import { Fragment as e, Teleport as t, Transition as n, computed as r, createBlock as i, createCommentVNode as a, createElementBlock as o, createElementVNode as s, createSlots as c, createTextVNode as l, createVNode as u, customRef as d, defineComponent as f, getCurrentInstance as p, getCurrentScope as m, guardReactiveProps as h, h as g, inject as _, isRef as v, markRaw as y, mergeModels as b, mergeProps as x, nextTick as S, normalizeClass as C, normalizeProps as w, normalizeStyle as T, onBeforeUnmount as E, onBeforeUpdate as D, onMounted as O, onScopeDispose as k, onUnmounted as ee, openBlock as A, provide as j, reactive as te, readonly as ne, ref as M, render as N, renderList as P, renderSlot as F, resolveDynamicComponent as re, shallowRef as ie, toDisplayString as I, toRef as ae, toValue as oe, unref as L, useAttrs as se, useCssVars as ce, useId as le, useModel as R, useSlots as ue, useTemplateRef as de, vModelCheckbox as fe, vModelDynamic as pe, vModelText as me, vShow as he, watch as z, watchEffect as ge, withCtx as B, withDirectives as V, withKeys as H, withModifiers as U } from "vue";
import { cn as _e, dayjs as ve, formatters as ye, resolveCarrierId as be, sorters as xe } from "@myparcel-frontend/utils";
import { computePosition as Se, flip as Ce, offset as we, shift as Te } from "@floating-ui/dom";
import { vOnClickOutside as Ee, vOnLongPress as De } from "@vueuse/components";
import { useClipboard as Oe, useCounter as ke, useDebounceFn as Ae, useElementSize as je, useFocusWithin as Me, useIntervalFn as Ne, useMediaQuery as Pe, useToggle as Fe, watchPausable as Ie } from "@vueuse/core";
import { Translation as Le, useI18n as Re } from "vue-i18n";
import { IconBase as ze, IconSize as Be } from "@myparcel-frontend/icons";
import { DrawerClose as Ve, DrawerContent as He, DrawerDescription as Ue, DrawerHandle as We, DrawerOverlay as Ge, DrawerPortal as Ke, DrawerRoot as qe, DrawerTitle as Je } from "@myparcel-frontend/drawer";
import { arrow as Ye, autoUpdate as Xe, flip as Ze, offset as Qe, shift as $e, size as et, useFloating as tt } from "@floating-ui/vue";
import { useResize as nt, useSortControl as rt } from "@myparcel-frontend/composables";
export * from "@myparcel-frontend/drawer";
//#endregion
//#region src/components/Accordion/AccordionGroup.vue
var it = /* @__PURE__ */ f({
	__name: "AccordionGroup",
	props: {
		multiple: { type: Boolean },
		border: { type: Boolean },
		background: { type: Boolean },
		openItems: {}
	},
	emits: ["openItems"],
	setup(e, { emit: t }) {
		let n = e, i = t, a = M([]), s = r(() => n.border), c = (e, t) => {
			if (t) {
				a.value = a.value.filter((t) => t !== e);
				return;
			}
			a.value = [...a.value, e];
		}, l = (e, t) => {
			if (t) {
				a.value = [];
				return;
			}
			a.value = [e];
		};
		return z(() => n.openItems, () => {
			n.multiple ? a.value = n.openItems ? [...a.value, ...n.openItems.filter((e) => !a.value.some((t) => t === e))] : a.value : a.value = n.openItems && n.openItems.length > 0 ? [n.openItems[0]] : [];
		}, { immediate: !0 }), j("openItems", a), j("border", s), j("setOpenItem", (e) => {
			let t = a.value.some((t) => t === e);
			n.multiple ? c(e, t) : l(e, t);
		}), z(a, (e) => {
			i("openItems", e);
		}, { deep: !0 }), (e, t) => (A(), o("div", { class: C(["group overflow-hidden", {
			border: s.value,
			"rounded-xl": s.value
		}]) }, [F(e.$slots, "default")], 2));
	}
}), at = {
	d: "M14.5982 5.85714H10.4464C10.0011 5.85714 9.64286 5.49888 9.64286 5.05357V0.901786C9.64286 0.680804 9.82366 0.5 10.0446 0.5H11.3839C11.6049 0.5 11.7857 0.680804 11.7857 0.901786V3.71429H14.5982C14.8192 3.71429 15 3.89509 15 4.11607V5.45536C15 5.67634 14.8192 5.85714 14.5982 5.85714ZM5.35714 5.05357V0.901786C5.35714 0.680804 5.17634 0.5 4.95536 0.5H3.61607C3.39509 0.5 3.21429 0.680804 3.21429 0.901786V3.71429H0.401786C0.180804 3.71429 0 3.89509 0 4.11607V5.45536C0 5.67634 0.180804 5.85714 0.401786 5.85714H4.55357C4.99888 5.85714 5.35714 5.49888 5.35714 5.05357ZM5.35714 15.0982V10.9464C5.35714 10.5011 4.99888 10.1429 4.55357 10.1429H0.401786C0.180804 10.1429 0 10.3237 0 10.5446V11.8839C0 12.1049 0.180804 12.2857 0.401786 12.2857H3.21429V15.0982C3.21429 15.3192 3.39509 15.5 3.61607 15.5H4.95536C5.17634 15.5 5.35714 15.3192 5.35714 15.0982ZM11.7857 15.0982V12.2857H14.5982C14.8192 12.2857 15 12.1049 15 11.8839V10.5446C15 10.3237 14.8192 10.1429 14.5982 10.1429H10.4464C10.0011 10.1429 9.64286 10.5011 9.64286 10.9464V15.0982C9.64286 15.3192 9.82366 15.5 10.0446 15.5H11.3839C11.6049 15.5 11.7857 15.3192 11.7857 15.0982Z",
	fill: "currentColor"
}, ot = /* @__PURE__ */ f({
	__name: "compress",
	setup(e) {
		return (e, t) => (A(), o("path", at));
	}
}), st = {
	fill: "none",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg"
}, ct = /* @__PURE__ */ f({
	__name: "reminder",
	setup(e) {
		return (e, t) => (A(), o("svg", st, [...t[0] ||= [
			s("path", {
				d: "m4.5 6.5-2 2-2-2",
				stroke: "#0F5C47",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			s("path", {
				d: "M2.5 7.5A6 6 0 1 1 4.531 12",
				stroke: "#0F5C47",
				"stroke-linecap": "round"
			}, null, -1),
			s("path", {
				d: "M8.5 3.5v4h3",
				stroke: "#0F5C47",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1)
		]]));
	}
}), lt = {
	"clip-rule": "evenodd",
	d: "M3 11C3 7.23771 6.91282 4 12 4C17.0872 4 21 7.23771 21 11C21 14.7623 17.0872 18 12 18C11.2331 18 10.4892 17.9252 9.77957 17.7848C9.54086 17.7375 9.30823 17.8687 9.21965 18.0859C9.14229 18.1381 9.07867 18.2126 9.03955 18.305C8.8997 18.6351 8.60951 18.9389 8.19648 19.2113C7.7866 19.4815 7.29127 19.6973 6.79969 19.8649C6.50173 19.9664 6.21121 20.0482 5.95098 20.1129C6.01845 19.9797 6.08886 19.8366 6.15986 19.6863C6.4887 18.9902 6.85809 18.0826 6.97182 17.2817C6.99746 17.209 7.00527 17.133 6.99683 17.0594C6.99743 17.052 6.99801 17.0445 6.99856 17.0371C7.01906 16.7617 6.81243 16.5219 6.53705 16.5014C6.5052 16.499 6.47383 16.4997 6.44322 16.5031C4.31462 15.2001 3 13.1975 3 11ZM5.94199 17.3687C3.57838 15.9285 2 13.6336 2 11C2 6.47802 6.59377 3 12 3C17.4062 3 22 6.47802 22 11C22 15.522 17.4062 19 12 19C11.2805 19 10.5783 18.9393 9.90108 18.8239C9.64449 19.3403 9.21199 19.7395 8.74699 20.0461C8.24088 20.3798 7.65937 20.6283 7.12228 20.8114C6.58265 20.9953 6.07112 21.1187 5.69574 21.1962C5.5075 21.235 5.35213 21.2626 5.24288 21.2805C5.18822 21.2895 5.14502 21.2961 5.11492 21.3006L5.07976 21.3056L5.06992 21.307L5.067 21.3074L5.06605 21.3075L5.0657 21.3076C5.06557 21.3076 5.06544 21.3076 4.99994 20.8119L5.06544 21.3076C4.87495 21.3328 4.68689 21.2465 4.58163 21.0858C4.4764 20.9251 4.47256 20.7183 4.57175 20.5537L4.57179 20.5537L4.57228 20.5528L4.57473 20.5488L4.58526 20.531C4.59471 20.5151 4.60889 20.491 4.62717 20.4594C4.66372 20.3963 4.71657 20.3037 4.78057 20.1876C4.90877 19.9549 5.0807 19.6296 5.25567 19.2592C5.54486 18.647 5.82026 17.9568 5.94199 17.3687Z",
	fill: "#FF8C00",
	"fill-rule": "evenodd"
}, ut = /* @__PURE__ */ f({
	__name: "chat-24",
	setup(e) {
		return (e, t) => (A(), o("path", lt));
	}
}), dt = { fill: "none" }, ft = /* @__PURE__ */ f({
	__name: "settings",
	setup(e) {
		return (e, t) => (A(), o("g", dt, [...t[0] ||= [s("path", {
			"clip-rule": "evenodd",
			d: "M22.0491 2.25C20.7492 2.25 19.6398 3.18976 19.4261 4.47194L18.8059 8.19359L16.9228 8.9736L13.8526 6.7806C12.7949 6.02507 11.346 6.14499 10.4268 7.06413L7.31421 10.1767C6.39507 11.0959 6.27515 12.5448 7.03068 13.6026L9.22367 16.6727L8.44359 18.5559L4.72194 19.1761C3.43976 19.3898 2.5 20.4992 2.5 21.7991V26.2009C2.5 27.5008 3.43976 28.6102 4.72194 28.8239L8.44363 29.4441L9.22386 31.3273L7.03089 34.3974C6.27536 35.4552 6.39528 36.9041 7.31442 37.8232L10.427 40.9358C11.3462 41.855 12.7951 41.9749 13.8528 41.2194L16.923 39.0264L18.8059 39.8064L19.4261 43.5281C19.6398 44.8102 20.7492 45.75 22.0491 45.75H26.4509C27.7508 45.75 28.8602 44.8102 29.0739 43.5281L29.6941 39.8064L31.577 39.0264L34.6472 41.2194C35.7049 41.9749 37.1538 41.855 38.073 40.9358L41.1856 37.8232C42.1047 36.9041 42.2246 35.4552 41.4691 34.3974L39.2761 31.3273L40.0564 29.4441L43.7781 28.8239C45.0602 28.6102 46 27.5008 46 26.2009V21.7991C46 20.4992 45.0602 19.3898 43.7781 19.1761L40.0564 18.5559L39.2763 16.6727L41.4693 13.6026C42.2249 12.5448 42.1049 11.0959 41.1858 10.1767L38.0732 7.06413C37.154 6.14499 35.7051 6.02507 34.6474 6.7806L31.5772 8.9736L29.6941 8.19359L29.0739 4.47194C28.8602 3.18976 27.7508 2.25 26.4509 2.25H22.0491ZM20.9057 4.71854C20.9989 4.15964 21.4825 3.75 22.0491 3.75H26.4509C27.0175 3.75 27.5011 4.15964 27.5943 4.71854L28.2829 8.85057C28.3255 9.10584 28.4966 9.32114 28.7357 9.42018L31.3875 10.5186C31.6266 10.6177 31.8999 10.5864 32.1105 10.436L35.5192 8.0012C35.9803 7.67187 36.6119 7.72414 37.0125 8.12479L40.1251 11.2374C40.5258 11.638 40.5781 12.2696 40.2487 12.7307L37.8139 16.1395C37.6635 16.35 37.6322 16.6233 37.7313 16.8624L38.8298 19.5143C38.9289 19.7534 39.1442 19.9245 39.3994 19.9671L43.5315 20.6557C44.0904 20.7489 44.5 21.2325 44.5 21.7991V26.2009C44.5 26.7675 44.0904 27.2511 43.5315 27.3443L39.3994 28.0329C39.1442 28.0755 38.9289 28.2466 38.8298 28.4856L37.7311 31.1375C37.632 31.3766 37.6632 31.6499 37.8137 31.8605L40.2485 35.2693C40.5778 35.7303 40.5256 36.3619 40.1249 36.7626L37.0123 39.8752C36.6117 40.2758 35.9801 40.3281 35.519 39.9988L32.1103 37.564C31.8997 37.4135 31.6264 37.3823 31.3873 37.4814L28.7357 38.5798C28.4966 38.6789 28.3255 38.8942 28.2829 39.1494L27.5943 43.2815C27.5011 43.8404 27.0175 44.25 26.4509 44.25H22.0491C21.4825 44.25 20.9989 43.8404 20.9057 43.2815L20.2171 39.1494C20.1745 38.8942 20.0034 38.6789 19.7643 38.5798L17.1127 37.4814C16.8736 37.3823 16.6003 37.4135 16.3897 37.564L12.981 39.9988C12.5199 40.3281 11.8883 40.2758 11.4877 39.8752L8.37508 36.7626C7.97443 36.3619 7.92216 35.7303 8.25149 35.2693L10.6863 31.8605C10.8368 31.6499 10.868 31.3766 10.7689 31.1375L9.67015 28.4856C9.57111 28.2466 9.35582 28.0755 9.10057 28.0329L4.96854 27.3443C4.40964 27.2511 4 26.7675 4 26.2009L4 21.7991C4 21.2325 4.40964 20.7489 4.96854 20.6557L9.10057 19.9671C9.35584 19.9245 9.57114 19.7534 9.67017 19.5143L10.7687 16.8624C10.8678 16.6233 10.8365 16.35 10.6861 16.1395L8.25128 12.7307C7.92195 12.2696 7.97422 11.638 8.37487 11.2374L11.4875 8.12479C11.8881 7.72414 12.5197 7.67187 12.9808 8.0012L16.3895 10.436C16.6001 10.5864 16.8734 10.6177 17.1125 10.5186L19.7643 9.42018C20.0034 9.32114 20.1745 9.10584 20.2171 8.85057L20.9057 4.71854ZM18 24C18 20.5482 20.7982 17.75 24.25 17.75C27.7018 17.75 30.5 20.5482 30.5 24C30.5 27.4518 27.7018 30.25 24.25 30.25C20.7982 30.25 18 27.4518 18 24ZM24.25 16.25C19.9698 16.25 16.5 19.7198 16.5 24C16.5 28.2802 19.9698 31.75 24.25 31.75C28.5302 31.75 32 28.2802 32 24C32 19.7198 28.5302 16.25 24.25 16.25Z",
			fill: "#FF8C00",
			"fill-rule": "evenodd"
		}, null, -1), s("path", {
			"clip-rule": "evenodd",
			d: "M22.0491 2.25C20.7492 2.25 19.6398 3.18976 19.4261 4.47194L18.8059 8.19359L16.9228 8.9736L13.8526 6.7806C12.7949 6.02507 11.346 6.14499 10.4268 7.06413L7.31421 10.1767C6.39507 11.0959 6.27515 12.5448 7.03068 13.6026L9.22367 16.6727L8.44359 18.5559L4.72194 19.1761C3.43976 19.3898 2.5 20.4992 2.5 21.7991V26.2009C2.5 27.5008 3.43976 28.6102 4.72194 28.8239L8.44363 29.4441L9.22386 31.3273L7.03089 34.3974C6.27536 35.4552 6.39528 36.9041 7.31442 37.8232L10.427 40.9358C11.3462 41.855 12.7951 41.9749 13.8528 41.2194L16.923 39.0264L18.8059 39.8064L19.4261 43.5281C19.6398 44.8102 20.7492 45.75 22.0491 45.75H26.4509C27.7508 45.75 28.8602 44.8102 29.0739 43.5281L29.6941 39.8064L31.577 39.0264L34.6472 41.2194C35.7049 41.9749 37.1538 41.855 38.073 40.9358L41.1856 37.8232C42.1047 36.9041 42.2246 35.4552 41.4691 34.3974L39.2761 31.3273L40.0564 29.4441L43.7781 28.8239C45.0602 28.6102 46 27.5008 46 26.2009V21.7991C46 20.4992 45.0602 19.3898 43.7781 19.1761L40.0564 18.5559L39.2763 16.6727L41.4693 13.6026C42.2249 12.5448 42.1049 11.0959 41.1858 10.1767L38.0732 7.06413C37.154 6.14499 35.7051 6.02507 34.6474 6.7806L31.5772 8.9736L29.6941 8.19359L29.0739 4.47194C28.8602 3.18976 27.7508 2.25 26.4509 2.25H22.0491ZM20.9057 4.71854C20.9989 4.15964 21.4825 3.75 22.0491 3.75H26.4509C27.0175 3.75 27.5011 4.15964 27.5943 4.71854L28.2829 8.85057C28.3255 9.10584 28.4966 9.32114 28.7357 9.42018L31.3875 10.5186C31.6266 10.6177 31.8999 10.5864 32.1105 10.436L35.5192 8.0012C35.9803 7.67187 36.6119 7.72414 37.0125 8.12479L40.1251 11.2374C40.5258 11.638 40.5781 12.2696 40.2487 12.7307L37.8139 16.1395C37.6635 16.35 37.6322 16.6233 37.7313 16.8624L38.8298 19.5143C38.9289 19.7534 39.1442 19.9245 39.3994 19.9671L43.5315 20.6557C44.0904 20.7489 44.5 21.2325 44.5 21.7991V26.2009C44.5 26.7675 44.0904 27.2511 43.5315 27.3443L39.3994 28.0329C39.1442 28.0755 38.9289 28.2466 38.8298 28.4856L37.7311 31.1375C37.632 31.3766 37.6632 31.6499 37.8137 31.8605L40.2485 35.2693C40.5778 35.7303 40.5256 36.3619 40.1249 36.7626L37.0123 39.8752C36.6117 40.2758 35.9801 40.3281 35.519 39.9988L32.1103 37.564C31.8997 37.4135 31.6264 37.3823 31.3873 37.4814L28.7357 38.5798C28.4966 38.6789 28.3255 38.8942 28.2829 39.1494L27.5943 43.2815C27.5011 43.8404 27.0175 44.25 26.4509 44.25H22.0491C21.4825 44.25 20.9989 43.8404 20.9057 43.2815L20.2171 39.1494C20.1745 38.8942 20.0034 38.6789 19.7643 38.5798L17.1127 37.4814C16.8736 37.3823 16.6003 37.4135 16.3897 37.564L12.981 39.9988C12.5199 40.3281 11.8883 40.2758 11.4877 39.8752L8.37508 36.7626C7.97443 36.3619 7.92216 35.7303 8.25149 35.2693L10.6863 31.8605C10.8368 31.6499 10.868 31.3766 10.7689 31.1375L9.67015 28.4856C9.57111 28.2466 9.35582 28.0755 9.10057 28.0329L4.96854 27.3443C4.40964 27.2511 4 26.7675 4 26.2009L4 21.7991C4 21.2325 4.40964 20.7489 4.96854 20.6557L9.10057 19.9671C9.35584 19.9245 9.57114 19.7534 9.67017 19.5143L10.7687 16.8624C10.8678 16.6233 10.8365 16.35 10.6861 16.1395L8.25128 12.7307C7.92195 12.2696 7.97422 11.638 8.37487 11.2374L11.4875 8.12479C11.8881 7.72414 12.5197 7.67187 12.9808 8.0012L16.3895 10.436C16.6001 10.5864 16.8734 10.6177 17.1125 10.5186L19.7643 9.42018C20.0034 9.32114 20.1745 9.10584 20.2171 8.85057L20.9057 4.71854ZM18 24C18 20.5482 20.7982 17.75 24.25 17.75C27.7018 17.75 30.5 20.5482 30.5 24C30.5 27.4518 27.7018 30.25 24.25 30.25C20.7982 30.25 18 27.4518 18 24ZM24.25 16.25C19.9698 16.25 16.5 19.7198 16.5 24C16.5 28.2802 19.9698 31.75 24.25 31.75C28.5302 31.75 32 28.2802 32 24C32 19.7198 28.5302 16.25 24.25 16.25Z",
			fill: "#FF8C00",
			"fill-rule": "evenodd"
		}, null, -1)]]));
	}
}), pt = /* @__PURE__ */ f({
	__name: "flag-finish-24",
	setup(t) {
		return (t, n) => (A(), o(e, null, [
			n[0] ||= s("path", {
				d: "M2.5 21.5V4.5C2.5 3.94772 2.94772 3.5 3.5 3.5H4.5V21.5C4.5 22.0523 4.05228 22.5 3.5 22.5C2.94772 22.5 2.5 22.0523 2.5 21.5Z",
				fill: "none",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[1] ||= s("path", {
				d: "M21.5 15.5V4.5C21.5 3.94772 21.0523 3.5 20.5 3.5H9.6H4.5V16.5H9.6H20.5C21.0523 16.5 21.5 16.0523 21.5 15.5Z",
				fill: "none",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[2] ||= s("path", {
				"clip-rule": "evenodd",
				d: "M9 4H7V6H5V8H7V10H5V12H7V14H5V16H7V14H9V16H11V14H13V16H15V14H17V16H19V14H21V12H19V10H21V8H19V6H21V4H19V6H17V4H15V6H13V4H11V6H9V4ZM9 8H7V6H9V8ZM11 8V6H13V8H11ZM11 10V8H9V10H7V12H9V14H11V12H13V14H15V12H17V14H19V12H17V10H19V8H17V6H15V8H13V10H11ZM15 10V8H17V10H15ZM15 10H13V12H15V10ZM11 10V12H9V10H11Z",
				fill: "currentColor",
				"fill-rule": "evenodd"
			}, null, -1)
		], 64));
	}
}), mt = {
	"clip-rule": "evenodd",
	d: "M4.5 3C3.11929 3 2 4.11929 2 5.5V14.5C2 15.8807 3.11929 17 4.5 17H9V18.2984C9 18.639 8.88408 18.9695 8.6713 19.2355L7.10957 21.1877C6.9895 21.3377 6.96609 21.5434 7.04935 21.7166C7.13261 21.8898 7.3078 22 7.5 22H16.5C16.6922 22 16.8674 21.8898 16.9507 21.7166C17.0339 21.5434 17.0105 21.3377 16.8904 21.1877L15.3287 19.2355C15.1159 18.9695 15 18.639 15 18.2984V17H19.5C20.8807 17 22 15.8807 22 14.5V5.5C22 4.11929 20.8807 3 19.5 3H4.5ZM14 17H10V18.2984C10 18.8661 9.8068 19.4169 9.45217 19.8602L8.54031 21H15.4597L14.5478 19.8602C14.1932 19.4169 14 18.8661 14 18.2984V17ZM14.5 16H19.5C20.3284 16 21 15.3284 21 14.5V5.5C21 4.67157 20.3284 4 19.5 4H4.5C3.67157 4 3 4.67157 3 5.5V14.5C3 15.3284 3.67157 16 4.5 16H9.5H14.5Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
}, ht = /* @__PURE__ */ f({
	__name: "desktop",
	setup(e) {
		return (e, t) => (A(), o("path", mt));
	}
}), gt = {
	"clip-rule": "evenodd",
	d: "M4.5 1.5a.5.5 0 0 0-.354.146l-3 3A.5.5 0 0 0 1 5v9a1.5 1.5 0 0 0 1.5 1.5h11A1.5 1.5 0 0 0 15 14V3a1.5 1.5 0 0 0-1.5-1.5h-9Zm.5 1h8.5a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-11A.5.5 0 0 1 2 14V5.5h2.5A.5.5 0 0 0 5 5V2.5Zm-1 2H2.707L4 3.207V4.5Zm.5 5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Zm0-2h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1Zm0 4a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z",
	fill: "#0F5C47",
	"fill-rule": "evenodd"
}, _t = /* @__PURE__ */ f({
	__name: "note",
	setup(e) {
		return (e, t) => (A(), o("path", gt));
	}
}), vt = {
	d: "M0 5.45536V1.30357C0 0.858259 0.358259 0.5 0.803571 0.5H4.95536C5.17634 0.5 5.35714 0.680804 5.35714 0.901786V2.24107C5.35714 2.46205 5.17634 2.64286 4.95536 2.64286H2.14286V5.45536C2.14286 5.67634 1.96205 5.85714 1.74107 5.85714H0.401786C0.180804 5.85714 0 5.67634 0 5.45536ZM9.64286 0.901786V2.24107C9.64286 2.46205 9.82366 2.64286 10.0446 2.64286H12.8571V5.45536C12.8571 5.67634 13.0379 5.85714 13.2589 5.85714H14.5982C14.8192 5.85714 15 5.67634 15 5.45536V1.30357C15 0.858259 14.6417 0.5 14.1964 0.5H10.0446C9.82366 0.5 9.64286 0.680804 9.64286 0.901786ZM14.5982 10.1429H13.2589C13.0379 10.1429 12.8571 10.3237 12.8571 10.5446V13.3571H10.0446C9.82366 13.3571 9.64286 13.5379 9.64286 13.7589V15.0982C9.64286 15.3192 9.82366 15.5 10.0446 15.5H14.1964C14.6417 15.5 15 15.1417 15 14.6964V10.5446C15 10.3237 14.8192 10.1429 14.5982 10.1429ZM5.35714 15.0982V13.7589C5.35714 13.5379 5.17634 13.3571 4.95536 13.3571H2.14286V10.5446C2.14286 10.3237 1.96205 10.1429 1.74107 10.1429H0.401786C0.180804 10.1429 0 10.3237 0 10.5446V14.6964C0 15.1417 0.358259 15.5 0.803571 15.5H4.95536C5.17634 15.5 5.35714 15.3192 5.35714 15.0982Z",
	fill: "currentColor"
}, yt = /* @__PURE__ */ f({
	__name: "expand",
	setup(e) {
		return (e, t) => (A(), o("path", vt));
	}
}), bt = {
	d: "M10 1a.5.5 0 0 0-.493.582l.117.702a10.015 10.015 0 0 0-7.34 7.34l-.702-.117A.5.5 0 0 0 1 10v4a.5.5 0 0 0 .582.493l.702-.117a10.015 10.015 0 0 0 7.34 7.34l-.117.702A.5.5 0 0 0 10 23h4a.5.5 0 0 0 .493-.582l-.117-.702a10.015 10.015 0 0 0 7.34-7.34l.702.117A.5.5 0 0 0 23 14v-4a.5.5 0 0 0-.582-.493l-.702.117a10.015 10.015 0 0 0-7.34-7.34l.117-.702A.5.5 0 0 0 14 1h-4ZM3.274 9.789a9.016 9.016 0 0 1 6.515-6.515l.33 1.982a7.013 7.013 0 0 0-4.863 4.863l-1.982-.33Zm2.975.495a6.014 6.014 0 0 1 4.036-4.035l.222 1.333A.5.5 0 0 0 11 8h2a.5.5 0 0 0 .493-.418l.223-1.333a6.014 6.014 0 0 1 4.035 4.035l-1.333.223A.5.5 0 0 0 16 11v2a.5.5 0 0 0 .418.493l1.333.223a6.014 6.014 0 0 1-4.036 4.035l-.222-1.333A.5.5 0 0 0 13 16h-2a.5.5 0 0 0-.493.418l-.223 1.333a6.014 6.014 0 0 1-4.035-4.036l1.333-.222A.5.5 0 0 0 8 13v-2a.5.5 0 0 0-.418-.493l-1.333-.223Zm7.632-5.028.33-1.982a9.016 9.016 0 0 1 6.516 6.515l-1.983.33a7.013 7.013 0 0 0-4.863-4.863Zm4.863 8.625 1.983.33a9.017 9.017 0 0 1-6.516 6.516l-.33-1.983a7.013 7.013 0 0 0 4.863-4.863Zm-8.625 4.863-.33 1.982a9.016 9.016 0 0 1-6.515-6.515l1.982-.33a7.013 7.013 0 0 0 4.863 4.863ZM11.424 7l-.834-5h2.82l-.834 5h-1.152ZM7 12.576l-5 .834v-2.82l5 .834v1.152ZM13.41 22h-2.82l.834-5h1.152l.834 5ZM17 11.424l5-.834v2.82l-5-.834v-1.152Z",
	fill: "currentColor"
}, xt = /* @__PURE__ */ f({
	__name: "crosshairs-24",
	setup(e) {
		return (e, t) => (A(), o("path", bt));
	}
}), St = {
	"clip-rule": "evenodd",
	d: "M5 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6Zm0 5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-2Zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H6Zm4-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6Zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2Zm-1 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2Zm6-11a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2Zm-1 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2Zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
}, Ct = /* @__PURE__ */ f({
	__name: "th-solid",
	setup(e) {
		return (e, t) => (A(), o("path", St));
	}
}), wt = {
	d: "M 0 1.8 C 0 0.805 0.805 0 1.8 0 L 19.795 0 C 20.79 0 21.595 0.805 21.595 1.8 L 21.595 2.999 C 21.595 3.783 21.094 4.449 20.395 4.696 L 20.395 11.397 C 20.395 11.728 20.126 11.997 19.795 11.997 C 19.464 11.997 19.195 11.728 19.195 11.397 L 19.195 4.799 L 2.399 4.799 L 2.399 16.196 C 2.399 16.527 2.667 16.796 2.999 16.796 L 5.399 16.796 C 5.73 16.796 5.999 17.065 5.999 17.396 C 5.999 17.728 5.731 17.997 5.399 17.997 L 2.999 17.997 C 2.005 17.997 1.199 17.191 1.199 16.197 L 1.199 4.698 C 0.5 4.45 0 3.785 0 3.001 L 0 1.801 L 0 1.8 Z M 1.8 1.199 C 1.468 1.199 1.199 1.468 1.199 1.8 L 1.199 2.999 C 1.199 3.33 1.468 3.599 1.8 3.599 L 19.795 3.599 C 20.126 3.599 20.395 3.331 20.395 2.999 L 20.395 1.8 C 20.395 1.468 20.126 1.199 19.795 1.199 L 1.8 1.199 Z M 8.998 8.398 C 8.667 8.398 8.398 8.666 8.398 8.998 C 8.398 9.33 8.666 9.598 8.998 9.598 L 12.597 9.598 C 12.928 9.598 13.197 9.33 13.197 8.998 C 13.197 8.666 12.928 8.398 12.597 8.398 L 8.998 8.398 Z M 7.198 8.998 C 7.198 8.004 8.004 7.198 8.998 7.198 L 12.597 7.198 C 13.591 7.198 14.397 8.004 14.397 8.998 C 14.397 9.992 13.591 10.797 12.597 10.797 L 8.998 10.797 C 8.004 10.797 7.198 9.992 7.198 8.998 Z M 8.398 14.996 C 8.398 14.002 9.203 13.196 10.197 13.196 L 22.194 13.196 C 23.188 13.196 23.994 14.002 23.994 14.996 L 23.994 22.194 C 23.994 23.188 23.188 23.994 22.194 23.994 L 10.197 23.994 C 9.203 23.994 8.398 23.188 8.398 22.194 L 8.398 14.996 Z M 10.545 14.397 L 15.816 18.709 C 16.037 18.89 16.355 18.89 16.575 18.709 L 21.846 14.397 L 10.544 14.397 L 10.545 14.397 Z M 22.794 15.171 L 17.335 19.638 C 16.672 20.18 15.719 20.18 15.056 19.638 L 9.597 15.171 L 9.597 22.194 C 9.597 22.525 9.866 22.794 10.197 22.794 L 22.194 22.794 C 22.525 22.794 22.794 22.525 22.794 22.194 L 22.794 15.171 Z",
	fill: "currentColor",
	style: { "transform-origin": "11.997px 11.997px" }
}, Tt = /* @__PURE__ */ f({
	__name: "packaging-24",
	setup(e) {
		return (e, t) => (A(), o("path", wt));
	}
}), Et = {
	d: "M49.285 7.462c-1.186.343-2.46 1.306-3.615 3.306-.841 1.457-1.1 3.54-1.05 5.662.05 2.034.38 3.956.614 5.092 1.102-.364 2.931-1.04 4.718-2.015 1.862-1.016 3.537-2.282 4.378-3.74 1.155-2 1.352-3.584 1.056-4.783C55.09 9.788 54.259 8.799 53 8.072c-1.259-.727-2.53-.952-3.715-.61ZM48.73 5.54c1.826-.527 3.66-.13 5.27.8 1.61.93 2.87 2.32 3.327 4.164.456 1.841.066 3.96-1.265 6.264-1.122 1.943-3.197 3.428-5.153 4.495-.49.267-.98.513-1.46.737H82a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-1v41a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V38H6a3 3 0 0 1-3-3V25a3 3 0 0 1 3-3h29.86c-.646-.314-1.252-.713-1.76-1.22-1.4-1.4-2.157-2.946-2.255-4.472-.099-1.537.48-2.946 1.548-4.014 1.069-1.068 2.478-1.647 4.014-1.548 1.526.098 3.072.856 4.471 2.255.315.315.588.667.824 1.043.15-1.511.51-3.018 1.236-4.276 1.33-2.305 2.97-3.701 4.792-4.228ZM9 38v41a1 1 0 0 0 1 1h68a1 1 0 0 0 1-1V38H52a1 1 0 1 1 0-2h30a1 1 0 0 0 1-1V25a1 1 0 0 0-1-1H45v45a1 1 0 1 1-2 0V38H9Zm-1-2h35V24H6a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2Zm27.514-16.635c.764.763 2 1.25 3.377 1.532 1.296.264 2.586.32 3.427.322-.001-.841-.058-2.131-.322-3.427-.282-1.377-.769-2.614-1.532-3.377-1.139-1.138-2.25-1.613-3.185-1.673-.926-.06-1.783.277-2.472.966-.689.69-1.026 1.546-.966 2.472.06.935.535 2.046 1.673 3.185Z",
	fill: "currentColor"
}, Dt = /* @__PURE__ */ f({
	__name: "droppedoff-88",
	setup(e) {
		return (e, t) => (A(), o("path", Et));
	}
}), Ot = /* @__PURE__ */ f({
	__name: "map-marker-alt",
	setup(e) {
		return (e, t) => (A(), o("g", null, [...t[0] ||= [s("path", {
			d: "M23.37 3.52c-9.07.01-16.41 7.36-16.41 16.42 0 8.82 15.14 25.9 15.78 26.62.31.35.85.38 1.19.07.02-.02.05-.04.07-.07.64-.73 15.78-17.8 15.78-26.62-.02-9.06-7.35-16.41-16.41-16.42zm0 41.19C20.48 41.33 8.65 27.15 8.65 19.93c0-8.13 6.59-14.72 14.72-14.72s14.72 6.59 14.72 14.72c0 7.22-11.83 21.42-14.72 24.78z",
			fill: "currentColor"
		}, null, -1), s("path", {
			d: "M23.35 10.45c-4.91 0-8.89 3.99-8.89 8.9s3.99 8.89 8.9 8.89 8.89-3.99 8.89-8.89c0-4.92-3.98-8.9-8.9-8.9zm0 16.1c-3.98 0-7.2-3.23-7.2-7.2s3.23-7.2 7.2-7.2 7.2 3.23 7.2 7.2c0 3.98-3.22 7.2-7.2 7.2z",
			fill: "currentColor"
		}, null, -1)]]));
	}
}), kt = {
	"clip-rule": "evenodd",
	d: "M10.847.5a1.5 1.5 0 0 0-1.48 1.253l-.315 1.891-.876.363-1.56-1.114a1.5 1.5 0 0 0-1.932.16l-1.63 1.63a1.5 1.5 0 0 0-.16 1.933l1.113 1.56-.363.876-1.89.316.082.493-.083-.493A1.5 1.5 0 0 0 .5 10.848v2.305a1.5 1.5 0 0 0 1.253 1.48l1.891.315.363.876-1.114 1.56a1.5 1.5 0 0 0 .16 1.933l1.63 1.63a1.5 1.5 0 0 0 1.933.16l1.56-1.114.876.363.316 1.89a1.5 1.5 0 0 0 1.48 1.254h2.305a1.5 1.5 0 0 0 1.48-1.253l.315-1.891.876-.363 1.56 1.114a1.5 1.5 0 0 0 1.932-.16l1.63-1.63a1.5 1.5 0 0 0 .16-1.933l-1.113-1.56.363-.876 1.89-.316a1.5 1.5 0 0 0 1.254-1.48v-2.305a1.5 1.5 0 0 0-1.253-1.48l-1.891-.315-.363-.876 1.114-1.56a1.5 1.5 0 0 0-.16-1.933l-1.63-1.63a1.5 1.5 0 0 0-1.933-.16l-1.56 1.114-.876-.363-.316-1.89A1.5 1.5 0 0 0 13.152.5h-2.305Zm-.493 1.418a.5.5 0 0 1 .493-.418h2.306a.5.5 0 0 1 .493.418l.36 2.164a.5.5 0 0 0 .303.38l1.389.575a.5.5 0 0 0 .482-.055l1.785-1.275a.5.5 0 0 1 .644.053l1.63 1.63a.5.5 0 0 1 .054.645L19.018 7.82a.5.5 0 0 0-.055.482l.575 1.39a.5.5 0 0 0 .38.301l2.164.36a.5.5 0 0 1 .418.494v2.306a.5.5 0 0 1-.418.493l-2.164.36a.5.5 0 0 0-.38.303l-.576 1.389a.5.5 0 0 0 .056.482l1.275 1.785a.5.5 0 0 1-.053.644l-1.63 1.63a.5.5 0 0 1-.645.054l-1.785-1.275a.5.5 0 0 0-.482-.055l-1.39.575a.5.5 0 0 0-.301.38l-.36 2.164a.5.5 0 0 1-.494.418h-2.306a.5.5 0 0 1-.493-.418l-.36-2.164a.5.5 0 0 0-.303-.38l-1.389-.575a.5.5 0 0 0-.482.055l-1.785 1.275a.5.5 0 0 1-.644-.053l-1.63-1.63a.5.5 0 0 1-.054-.645l1.275-1.785a.5.5 0 0 0 .055-.482l-.575-1.39a.5.5 0 0 0-.38-.301l-2.164-.36a.5.5 0 0 1-.418-.494v-2.306a.5.5 0 0 1 .418-.493l2.164-.36a.5.5 0 0 0 .38-.303l.575-1.389a.5.5 0 0 0-.055-.482L3.707 6.035a.5.5 0 0 1 .053-.644l1.63-1.63a.5.5 0 0 1 .645-.054L7.82 4.982a.5.5 0 0 0 .482.055l1.39-.575a.5.5 0 0 0 .301-.38l.36-2.164ZM9.5 12a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0ZM12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
}, At = /* @__PURE__ */ f({
	__name: "cog-24",
	setup(e) {
		return (e, t) => (A(), o("path", kt));
	}
}), jt = {
	"clip-rule": "evenodd",
	d: "M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM8 .5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM6 6.79v-.71h2.441v4.07H10v.707H6v-.706h1.625V6.79H6Zm1.638-1.633a.477.477 0 0 1-.12-.33c0-.071.011-.138.032-.2a.42.42 0 0 1 .25-.247.58.58 0 0 1 .208-.035c.076 0 .144.012.203.035a.38.38 0 0 1 .146.089.382.382 0 0 1 .106.154.58.58 0 0 1 .035.203.467.467 0 0 1-.124.331c-.082.089-.204.133-.366.133-.165 0-.289-.044-.371-.133Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
}, Mt = /* @__PURE__ */ f({
	__name: "info",
	setup(e) {
		return (e, t) => (A(), o("path", jt));
	}
}), Nt = /* @__PURE__ */ f({
	__name: "hand-giving-package",
	setup(t) {
		return (t, n) => (A(), o(e, null, [n[0] ||= s("path", {
			d: "M16.2347 18.7383C16.2347 18.7383 21.2379 17.4919 22 18C22.7621 18.5081 23.254 18.9919 23 19.5C22.746 20.0081 15.5405 23.5 13 23.5C10.4595 23.5 7.52428 22.5 6 22.5C5.09633 22.5 3.85827 22.5 2.99991 22.5C2.44763 22.5 2 22.0523 2 21.5V17.3015C2 16.8331 2.32352 16.428 2.78153 16.3298C4.11303 16.0443 6.75027 15.5 7.5 15.5C8.51619 15.5 11.4919 17.5 12 17.5C12.5081 17.5 13.9838 17.5 15 17.5C16.0162 17.5 16.2347 18.7383 16.2347 18.7383ZM16.2347 18.7383C16.2347 18.7383 14.0162 20.5 13 20.5C11.9838 20.5 10 19.5 10 19.5",
			fill: "none",
			stroke: "currentColor",
			"stroke-linecap": "round"
		}, null, -1), n[1] ||= s("path", {
			"clip-rule": "evenodd",
			d: "M16.1286 0.23944C15.7297 0.0553592 15.2703 0.055359 14.8714 0.23944L9.37141 2.7779C8.84019 3.02308 8.5 3.55476 8.5 4.13984V11.8602C8.5 12.4453 8.84019 12.9769 9.37141 13.2221L14.8714 15.7606C15.2703 15.9447 15.7297 15.9447 16.1286 15.7606L21.6286 13.2221C22.1598 12.9769 22.5 12.4453 22.5 11.8602V4.13984C22.5 3.55476 22.1598 3.02308 21.6286 2.7779L16.1286 0.23944ZM15.2905 1.1474C15.4234 1.08604 15.5766 1.08604 15.7095 1.1474L20.8069 3.50003L18.8493 4.40352C18.7802 4.35602 18.7064 4.31394 18.6286 4.27801L13.568 1.94237L15.2905 1.1474ZM12.3749 2.49306L10.1931 3.50003L15.2905 5.85267C15.4234 5.91403 15.5766 5.91403 15.7095 5.85267L17.6818 4.9424L12.3749 2.49306ZM18.5 5.66613L16.1286 6.76063C16.0864 6.78012 16.0434 6.79755 16 6.81291V14.7186L21.2095 12.3142C21.3866 12.2324 21.5 12.0552 21.5 11.8602V4.28151L19.4432 5.23081C19.4804 5.36196 19.5 5.49942 19.5 5.63995V7.50012C19.5 7.77626 19.2761 8.00012 19 8.00012C18.7239 8.00012 18.5 7.77626 18.5 7.50012V5.66613ZM9.5 4.28151V11.8602C9.5 12.0552 9.6134 12.2324 9.79047 12.3142L15 14.7186V6.81291C14.9566 6.79755 14.9136 6.78012 14.8714 6.76063L9.5 4.28151Z",
			fill: "currentColor",
			"fill-rule": "evenodd"
		}, null, -1)], 64));
	}
}), Pt = {
	d: "M12.5821 1.20263L21.0821 4.78152C21.6383 5.01572 22 5.56046 22 6.16398V17.836C22 18.4395 21.6383 18.9842 21.0821 19.2184L12.5821 22.7974C12.2099 22.9541 11.7901 22.9541 11.4179 22.7974L2.91791 19.2184C2.36169 18.9842 2 18.4395 2 17.836V6.16398C2 5.56046 2.3617 5.01572 2.91792 4.78152L11.4179 1.20263C11.7901 1.0459 12.2099 1.0459 12.5821 1.20263ZM11.806 2.12426L8.63748 3.45835L16.4999 6.95277L19.9841 5.40425L12.194 2.12426C12.07 2.07202 11.93 2.07202 11.806 2.12426ZM7.37309 3.99071L4.0159 5.40425L11.3908 8.68197C11.7786 8.85435 12.2214 8.85435 12.6092 8.68198L15.2688 7.49993L7.37309 3.99071ZM16 8.26927L13.0153 9.59579C12.8486 9.6699 12.6758 9.72489 12.5 9.76076V21.747L20.694 18.2968C20.8794 18.2187 21 18.0371 21 17.836V6.16398C21 6.12597 20.9957 6.08866 20.9875 6.05262L17 7.82483V11C17 11.2761 16.7761 11.5 16.5 11.5C16.2239 11.5 16 11.2761 16 11V8.26927ZM3.01253 6.05262C3.0043 6.08866 3 6.12597 3 6.16398V17.836C3 18.0371 3.12056 18.2187 3.30597 18.2968L11.5 21.747V9.76076C11.3242 9.72489 11.1514 9.6699 10.9847 9.59579L3.01253 6.05262Z",
	fill: "currentColor"
}, Ft = /* @__PURE__ */ f({
	__name: "shipment",
	setup(e) {
		return (e, t) => (A(), o("path", Pt));
	}
}), It = {
	d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM6.15273 10.0586C5.25963 12.3211 5.54262 14.8354 6.85364 16.1465C7.09708 16.3899 7.26628 16.5356 7.38752 16.6184C7.4315 16.6484 7.46298 16.6658 7.48369 16.6758L7.48841 16.6721C7.53868 16.6319 7.58804 16.5818 7.66807 16.5007C7.69775 16.4706 7.73166 16.4362 7.7714 16.3965C8.04498 16.1229 8.44174 15.7616 9.11841 15.4767C9.24686 15.4226 9.38427 15.3717 9.53165 15.3248C9.53778 15.3085 9.54482 15.2923 9.5528 15.2764L12.5531 9.27632C12.65 9.08262 12.8605 8.97329 13.0747 9.00551C13.2888 9.03772 13.4579 9.20415 13.4935 9.41777L14.4782 15.328C14.6219 15.374 14.756 15.4238 14.8816 15.4767C15.5583 15.7616 15.955 16.1229 16.2286 16.3965C16.2681 16.4359 16.3018 16.4701 16.3314 16.5001L16.3316 16.5003L16.3319 16.5006L16.3319 16.5007C16.412 16.5818 16.4613 16.6319 16.5116 16.6721L16.5164 16.6758C16.5371 16.6658 16.5686 16.6484 16.6126 16.6183C16.7339 16.5355 16.9031 16.3899 17.1465 16.1464C18.4576 14.8354 18.7406 12.3211 17.8474 10.0586C16.97 7.83596 15.0061 6 12 6C8.99394 6 7.03008 7.83596 6.15273 10.0586ZM13.4252 15.0925L12.7598 11.0988L10.7758 15.0665C11.1409 15.0237 11.547 15 12 15C12.5379 15 13.0096 15.0334 13.4252 15.0925ZM5.22257 9.69142C6.22022 7.16405 8.50628 5 12 5C15.4937 5 17.7799 7.16404 18.7776 9.69141C19.7596 12.1789 19.5427 15.1646 17.8536 16.8536C17.5971 17.1101 17.3756 17.3082 17.1766 17.4442C16.9804 17.5781 16.755 17.6875 16.5 17.6875C16.2307 17.6875 16.0285 17.5662 15.8869 17.4529C15.786 17.3722 15.6791 17.2635 15.5876 17.1704L15.5869 17.1697L15.5869 17.1697C15.564 17.1464 15.5421 17.1241 15.5215 17.1035C15.2951 16.8771 15.0044 16.6134 14.4935 16.3983C13.9754 16.1802 13.2008 16 12 16C10.7992 16 10.0246 16.1802 9.50647 16.3983C8.99564 16.6134 8.70491 16.8771 8.47853 17.1035C8.45773 17.1243 8.43559 17.1469 8.41246 17.1704C8.32096 17.2634 8.21402 17.3722 8.11314 17.4529C7.97159 17.5662 7.76938 17.6875 7.50003 17.6875C7.2451 17.6875 7.01969 17.5781 6.82353 17.4441C6.62448 17.3082 6.40307 17.1101 6.14652 16.8535C4.45762 15.1646 4.24068 12.1789 5.22257 9.69142Z",
	fill: "currentColor"
}, Lt = /* @__PURE__ */ f({
	__name: "dashboard",
	setup(e) {
		return (e, t) => (A(), o("path", It));
	}
}), Rt = /* @__PURE__ */ f({
	__name: "support",
	setup(e) {
		return (e, t) => (A(), o("g", null, [...t[0] ||= [s("path", {
			d: "M5.333 14c-1.473 0-2.667 1.194-2.667 2.667v1.333c0 1.473 1.194 2.667 2.667 2.667h0.667c0.368 0 0.667-0.299 0.667-0.667v-5.333c0-0.368-0.298-0.667-0.667-0.667h-0.667zM5.35 12.667c0.3-5.898 4.563-10.667 10.65-10.667s10.35 4.769 10.65 10.667h0.017c2.209 0 4 1.791 4 4v1.333c0 2.209-1.791 4-4 4 0 3.314-2.686 6-6 6h-1.4c-0.309 1.521-1.654 2.667-3.267 2.667-1.841 0-3.333-1.492-3.333-3.333s1.492-3.333 3.333-3.333c1.613 0 2.958 1.145 3.267 2.667h1.4c2.577 0 4.667-2.089 4.667-4.667v-0.114c-0.777-0.275-1.333-1.015-1.333-1.886v-5.333c0-0.866 0.551-1.604 1.321-1.882-0.244-5.319-4.034-9.452-9.321-9.452s-9.077 4.132-9.321 9.452c0.77 0.278 1.321 1.016 1.321 1.882v5.333c0 1.105-0.895 2-2 2h-0.667c-2.209 0-4-1.791-4-4v-1.333c0-2.209 1.791-4 4-4h0.017zM18 27.333c0-1.105-0.895-2-2-2s-2 0.895-2 2c0 1.105 0.895 2 2 2s2-0.895 2-2zM26.667 20.667c1.473 0 2.667-1.194 2.667-2.667v-1.333c0-1.473-1.194-2.667-2.667-2.667h-0.667c-0.368 0-0.667 0.299-0.667 0.667v5.333c0 0.368 0.299 0.667 0.667 0.667h0.667z",
			fill: "currentColor"
		}, null, -1)]]));
	}
}), zt = /* @__PURE__ */ f({
	__name: "shirt-24",
	setup(t) {
		return (t, n) => (A(), o(e, null, [n[0] ||= s("path", {
			d: "M6.49994 10.4997L6.5 20.4998C6.5 20.8145 6.64793 21.1099 6.92158 21.2654C7.68014 21.6963 9.43829 22.5 12 22.5C14.5617 22.5 16.3199 21.6963 17.0784 21.2654C17.3521 21.1099 17.5 20.8145 17.5 20.4998L17.4999 10.4997C17.4999 9.94744 17.9476 9.49972 18.4999 9.49972H21.7192C22.1781 9.49972 22.5781 9.18743 22.6894 8.74227L23.2934 6.32622C23.4125 5.85005 23.1684 5.35787 22.7172 5.16452L16.6998 2.58562C16.5922 2.53953 16.4665 2.59428 16.4191 2.70126C16.1213 3.37365 14.9466 5.5 12 5.5C9.05337 5.5 7.87871 3.37364 7.58092 2.70126C7.53354 2.59428 7.40776 2.53953 7.30021 2.58562L1.28279 5.16452C0.831651 5.35786 0.587522 5.85005 0.706577 6.32622L1.31065 8.74228C1.42196 9.18743 1.82193 9.49972 2.28079 9.49972H5.49994C6.05222 9.49972 6.49993 9.94743 6.49994 10.4997Z",
			fill: "none",
			stroke: "#FF8C00"
		}, null, -1), n[1] ||= s("path", {
			d: "M16.5 2.5C16.5 2.5 14.5 3 12 3C9.5 3 7.5 2.5 7.5 2.5",
			stroke: "#FF8C00",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1)], 64));
	}
}), Bt = {
	d: "M6.854 2.146a.5.5 0 0 1 0 .708L2.707 7H9.5a5.5 5.5 0 0 1 5.5 5.5v1a.5.5 0 0 1-1 0v-1A4.5 4.5 0 0 0 9.5 8H2.707l4.147 4.146a.5.5 0 0 1-.708.708l-5-5a.5.5 0 0 1 0-.708l5-5a.5.5 0 0 1 .708 0Z",
	fill: "currentColor"
}, Vt = /* @__PURE__ */ f({
	__name: "reply",
	setup(e) {
		return (e, t) => (A(), o("path", Bt));
	}
}), Ht = /* @__PURE__ */ f({
	__name: "assign-to-person",
	setup(t) {
		return (t, n) => (A(), o(e, null, [n[0] ||= s("g", {
			"clip-path": "url(#clip0_27568_7500)",
			fill: "none"
		}, [
			s("path", {
				d: "M11.5 4.5C11.5 6.433 9.933 8 8 8C6.067 8 4.5 6.433 4.5 4.5C4.5 2.567 6.067 1 8 1C9.933 1 11.5 2.567 11.5 4.5Z",
				stroke: "#0F5C47",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}),
			s("path", {
				d: "M14.5 15C14.5 12 13.5 9 10.5 7",
				stroke: "#0F5C47",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}),
			s("path", {
				d: "M5.5 7C4.61716 7.58856 3.90752 8.26372 3.3456 9",
				stroke: "#0F5C47",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}),
			s("path", {
				d: "M5 11L7.5 13.5M7.5 13.5L5 16M7.5 13.5H1.5",
				stroke: "#0F5C47",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			})
		], -1), n[1] ||= s("defs", null, [s("clipPath", { id: "clip0_27568_7500" }, [s("rect", {
			fill: "white",
			height: "16",
			transform: "translate(0 0.5)",
			width: "16"
		})])], -1)], 64));
	}
}), Ut = {
	d: "M3.5 19.5V9.01816C3.5 8.69323 3.65787 8.38857 3.92332 8.20119L11.4233 2.90707C11.769 2.66303 12.231 2.66303 12.5767 2.90707L20.0767 8.20119C20.3421 8.38857 20.5 8.69323 20.5 9.01816V19.5C20.5 20.0523 20.0523 20.5 19.5 20.5H15.5C14.9477 20.5 14.5 20.0523 14.5 19.5V14.5C14.5 13.9477 14.0523 13.5 13.5 13.5H10.5C9.94772 13.5 9.5 13.9477 9.5 14.5V19.5C9.5 20.0523 9.05228 20.5 8.5 20.5H4.5C3.94772 20.5 3.5 20.0523 3.5 19.5Z",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round"
}, Wt = /* @__PURE__ */ f({
	__name: "home",
	setup(e) {
		return (e, t) => (A(), o("path", Ut));
	}
}), Gt = /* @__PURE__ */ f({
	__name: "unassign-from-person",
	setup(t) {
		return (t, n) => (A(), o(e, null, [
			n[0] ||= s("path", {
				d: "M11.5 4C11.5 5.933 9.933 7.5 8 7.5C6.067 7.5 4.5 5.933 4.5 4C4.5 2.067 6.067 0.5 8 0.5C9.933 0.5 11.5 2.067 11.5 4Z",
				fill: "none",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[1] ||= s("path", {
				d: "M1.5 14.5C1.5 11.5 2.5 8.5 5.5 6.5",
				fill: "none",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[2] ||= s("path", {
				d: "M10.5 6.5C11.3828 7.08856 12.0925 7.76372 12.6544 8.5",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[3] ||= s("path", {
				d: "M10.5 10.5L12.5 12.5M12.5 12.5L10.5 14.5M12.5 12.5L14.5 10.5M12.5 12.5L14.5 14.5",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1)
		], 64));
	}
}), Kt = {
	d: "M1 6a5 5 0 1 1 10 0A5 5 0 0 1 1 6Zm5-6a6 6 0 1 0 3.874 10.582l4.272 4.272a.5.5 0 0 0 .708-.708l-4.272-4.272A6 6 0 0 0 6 0Z",
	fill: "currentColor"
}, qt = /* @__PURE__ */ f({
	__name: "search-24",
	setup(e) {
		return (e, t) => (A(), o("path", Kt));
	}
}), Jt = /* @__PURE__ */ f({
	__name: "fulfilment-48",
	setup(t) {
		return (t, n) => (A(), o(e, null, [
			n[0] ||= s("path", {
				"clip-rule": "evenodd",
				d: "M25.2572 2.47882C24.4595 2.11066 23.5405 2.11066 22.7429 2.47882L11.7429 7.55574C10.6804 8.0461 10 9.10947 10 10.2796V25.7203C10 26.8904 10.6804 27.9538 11.7429 28.4442L22.7429 33.5211C23.5405 33.8893 24.4595 33.8893 25.2572 33.5211L36.2572 28.4442C37.3197 27.9538 38 26.8904 38 25.7203V10.2796C38 9.10947 37.3197 8.0461 36.2572 7.55574L25.2572 2.47882ZM23.581 4.29474C23.8469 4.17202 24.1532 4.17202 24.4191 4.29474L34.6139 9.00002L30.6987 10.807C30.5604 10.712 30.4129 10.6278 30.2572 10.556L20.1361 5.88469L23.581 4.29474ZM17.7498 6.98606L13.3862 9.00002L23.581 13.7053C23.8469 13.828 24.1532 13.828 24.4191 13.7053L28.3636 11.8848L17.7498 6.98606ZM30 13.3322L25.2572 15.5212C25.1727 15.5602 25.0869 15.5951 25 15.6258V31.437L35.4191 26.6283C35.7732 26.4648 36 26.1103 36 25.7203V10.563L31.8864 12.4616C31.9608 12.7239 32 12.9988 32 13.2799V17.0002C32 17.5525 31.5523 18.0002 31 18.0002C30.4477 18.0002 30 17.5525 30 17.0002V13.3322ZM12 10.563V25.7203C12 26.1103 12.2268 26.4648 12.581 26.6283L23 31.437V15.6258C22.9131 15.5951 22.8273 15.5602 22.7429 15.5212L12 10.563Z",
				fill: "#FF8C00",
				"fill-rule": "evenodd"
			}, null, -1),
			n[1] ||= s("path", {
				d: "M1 16C0.447715 16 0 16.4477 0 17C0 17.5523 0.447715 18 1 18V16ZM9 18H10V16H9V18ZM1 18H9V16H1V18Z",
				fill: "#FF8C00"
			}, null, -1),
			n[2] ||= s("path", {
				d: "M39 16H38V18H39V16ZM45 18C45.5523 18 46 17.5523 46 17C46 16.4477 45.5523 16 45 16V18ZM39 18H45V16H39V18Z",
				fill: "#FF8C00"
			}, null, -1),
			n[3] ||= s("path", {
				d: "M1 37H45",
				fill: "none",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "2"
			}, null, -1),
			n[4] ||= s("path", {
				d: "M5 43C5 44.1046 4.10457 45 3 45C1.89543 45 1 44.1046 1 43C1 41.8954 1.89543 41 3 41C4.10457 41 5 41.8954 5 43Z",
				fill: "none",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "2"
			}, null, -1),
			n[5] ||= s("path", {
				d: "M13 43C13 44.1046 12.1046 45 11 45C9.89543 45 9 44.1046 9 43C9 41.8954 9.89543 41 11 41C12.1046 41 13 41.8954 13 43Z",
				fill: "none",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "2"
			}, null, -1),
			n[6] ||= s("path", {
				d: "M21 43C21 44.1046 20.1046 45 19 45C17.8954 45 17 44.1046 17 43C17 41.8954 17.8954 41 19 41C20.1046 41 21 41.8954 21 43Z",
				fill: "none",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "2"
			}, null, -1),
			n[7] ||= s("path", {
				d: "M29 43C29 44.1046 28.1046 45 27 45C25.8954 45 25 44.1046 25 43C25 41.8954 25.8954 41 27 41C28.1046 41 29 41.8954 29 43Z",
				fill: "none",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "2"
			}, null, -1),
			n[8] ||= s("path", {
				d: "M37 43C37 44.1046 36.1046 45 35 45C33.8954 45 33 44.1046 33 43C33 41.8954 33.8954 41 35 41C36.1046 41 37 41.8954 37 43Z",
				fill: "none",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "2"
			}, null, -1),
			n[9] ||= s("path", {
				d: "M45 43C45 44.1046 44.1046 45 43 45C41.8954 45 41 44.1046 41 43C41 41.8954 41.8954 41 43 41C44.1046 41 45 41.8954 45 43Z",
				fill: "none",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "2"
			}, null, -1)
		], 64));
	}
}), Yt = {
	d: "M10.5 6.5V16C10.5 16.8284 11.1716 17.5 12 17.5V17.5C12.8284 17.5 13.5 16.8284 13.5 16V6.5C13.5 4.84315 12.1569 3.5 10.5 3.5V3.5C8.84315 3.5 7.5 4.84315 7.5 6.5V16C7.5 18.4853 9.51472 20.5 12 20.5V20.5C14.4853 20.5 16.5 18.4853 16.5 16V6.5",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round"
}, Xt = /* @__PURE__ */ f({
	__name: "attachment-24",
	setup(e) {
		return (e, t) => (A(), o("path", Yt));
	}
}), Zt = {
	"clip-rule": "evenodd",
	d: "M0.169434 5.54443C0.169434 4.78504 0.785042 4.16943 1.54443 4.16943H12.6339C13.3491 4.16943 13.9368 4.71543 14.0028 5.41333C14.1918 5.3155 14.4064 5.26024 14.6339 5.26024H17.4309C17.9139 5.26024 18.3614 5.51365 18.6099 5.92781L21.4412 10.6466C21.5023 10.7485 21.5913 10.8309 21.6976 10.884L23.0659 11.5682C23.5318 11.8011 23.826 12.2772 23.826 12.798V16.634C23.826 17.3933 23.2104 18.009 22.451 18.009H21.6172C21.4358 19.2431 20.3725 20.1905 19.088 20.1905C17.7854 20.1905 16.7104 19.2164 16.5516 17.9569C16.4957 17.99 16.4305 18.009 16.3609 18.009H13.6339L13.6302 18.0089H8.52778C8.34637 19.2431 7.28308 20.1905 5.99851 20.1905C4.71395 20.1905 3.65065 19.2431 3.46924 18.0089L1.54443 18.0089C0.785042 18.0089 0.169434 17.3933 0.169434 16.6339V5.54443ZM16.5516 17.311C16.7103 16.0515 17.7854 15.0773 19.088 15.0773C20.3726 15.0773 21.4359 16.0248 21.6173 17.259H22.451C22.7962 17.259 23.076 16.9791 23.076 16.634V12.798C23.076 12.5613 22.9423 12.3449 22.7305 12.239L21.3622 11.5548C21.3083 11.5279 21.2565 11.4976 21.207 11.4641H16.8156C16.0562 11.4641 15.4406 10.8485 15.4406 10.0891V8.81673C15.4406 8.05734 16.0562 7.44173 16.8156 7.44173H18.6436L17.9668 6.31368C17.8539 6.12543 17.6504 6.01024 17.4309 6.01024H14.6339C14.2913 6.01024 14.013 6.28594 14.0089 6.6276V17.259H16.3609C16.4305 17.259 16.4957 17.2779 16.5516 17.311ZM20.8945 17.6254C20.89 16.6316 20.0829 15.8273 19.088 15.8273C18.0902 15.8273 17.2814 16.6362 17.2814 17.6339C17.2814 18.6317 18.0902 19.4405 19.088 19.4405C20.0829 19.4405 20.8899 18.6363 20.8945 17.6425C20.8945 17.6396 20.8944 17.6368 20.8944 17.634C20.8944 17.6311 20.8945 17.6283 20.8945 17.6254ZM7.80498 17.6339L7.80507 17.6254C7.80047 16.6316 6.99341 15.8273 5.99851 15.8273C5.00076 15.8273 4.19193 16.6362 4.19193 17.6339C4.19193 18.6317 5.00076 19.4405 5.99851 19.4405C6.9934 19.4405 7.80045 18.6363 7.80507 17.6425L7.80498 17.6339ZM13.2589 17.2589H8.52779C8.34639 16.0247 7.28309 15.0773 5.99851 15.0773C4.71393 15.0773 3.65063 16.0247 3.46923 17.2589L1.54443 17.2589C1.19926 17.2589 0.919434 16.9791 0.919434 16.6339V5.54443C0.919434 5.19926 1.19926 4.91943 1.54443 4.91943H12.6339C12.9791 4.91943 13.2589 5.19926 13.2589 5.54443V6.6239L13.2589 6.63524V17.2589ZM19.0936 8.19169L19.088 8.19173H16.8156C16.4705 8.19173 16.1906 8.47156 16.1906 8.81673V10.0891C16.1906 10.4343 16.4705 10.7141 16.8156 10.7141H20.6071L19.0936 8.19169Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
}, Qt = /* @__PURE__ */ f({
	__name: "carrier-truck",
	setup(e) {
		return (e, t) => (A(), o("path", Zt));
	}
}), $t = {
	d: "M21.782 7.447a3 3 0 0 1 2.436 0l16 7.111A3 3 0 0 1 42 17.3v11.383l11.782-5.236a3 3 0 0 1 2.436 0l25 11.111A3 3 0 0 1 83 37.3v30.443a3 3 0 0 1-1.698 2.703l-8.442 4.065a1 1 0 0 1-.997.48L56.3 82.483a3 3 0 0 1-2.602 0l-17.133-8.249a1 1 0 1 1 .868-1.802L54 80.41V49.64a2.984 2.984 0 0 1-.235-.094L29 38.54v29.204a1 1 0 0 0 .566.901l1.868.9a1 1 0 1 1-.868 1.802l-1.867-.9A3 3 0 0 1 27 67.743V46.118l-1.553.776-1.105.553a3 3 0 0 1-2.684 0l-16-8A3 3 0 0 1 4 36.764V17.3a3 3 0 0 1 1.782-2.742l16-7.11ZM56 49.627v30.782l15-7.223V42.695l-14.757 6.831c-.08.037-.16.07-.243.1Zm24.434 19.017a1 1 0 0 0 .566-.9v-29.68l-8.032 3.718c.021.117.032.236.032.356v30.084l7.434-3.579Zm-.303-32.38-24.725-10.99a1 1 0 0 0-.812 0l-7.786 3.461L71.6 40.213l8.53-3.95Zm-50.537.122a1 1 0 0 0-.217.132l25.2 11.2a1 1 0 0 0 .826-.007l13.817-6.396-24.64-11.407a1.006 1.006 0 0 1-.176-.104l-14.81 6.582ZM40 18.539l-15.782 7.014c-.072.032-.144.06-.218.087v19.742l.553-.276 2-1A.994.994 0 0 1 27 44v-6.7a3 3 0 0 1 1.782-2.742L40 29.572V18.54ZM22 45.382V25.64a3.063 3.063 0 0 1-.218-.087L6 18.539v18.225a1 1 0 0 0 .553.894L22 45.382Zm17.406-28.996-16-7.111a1 1 0 0 0-.812 0l-16 7.111a.99.99 0 0 0-.217.132l16.217 7.207a1 1 0 0 0 .812 0l16.217-7.207a1 1 0 0 0-.217-.132Z",
	fill: "currentColor"
}, en = /* @__PURE__ */ f({
	__name: "sorted",
	setup(e) {
		return (e, t) => (A(), o("path", $t));
	}
}), tn = {
	"clip-rule": "evenodd",
	d: "M8 6.25A1.75 1.75 0 0 0 6.25 8v19.878l-2.962 8.885A.75.75 0 0 0 3.25 37v3c0 .967.784 1.75 1.75 1.75h38A1.75 1.75 0 0 0 44.75 40v-3a.75.75 0 0 0-.038-.237l-2.962-8.885V8A1.75 1.75 0 0 0 40 6.25H8Zm-2.96 30 2.5-7.5h32.92l2.5 7.5H5.04ZM40.25 8v19.25H7.75V8A.25.25 0 0 1 8 7.75h32a.25.25 0 0 1 .25.25ZM4.75 37.75h38.5V40a.25.25 0 0 1-.25.25H5a.25.25 0 0 1-.25-.25v-2.25ZM12 12.25a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5h-7Zm13.25.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75ZM12 15.25a.75.75 0 0 0 0 1.5h9a.75.75 0 0 0 0-1.5h-9Zm13.25.75a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75ZM12 18.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-6Zm13.25.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75ZM12 21.25a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5h-7Zm13.25.75a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75ZM20 33.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5h-8ZM10.25 31a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75ZM12 33.25a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1Zm3.25.75a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75ZM31 33.25a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1ZM15.25 31a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm5.75-.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1Zm4.25.75a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75Zm5.75-.75a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1Zm4.25.75a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75ZM35 33.25a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
}, nn = /* @__PURE__ */ f({
	__name: "laptop-48",
	setup(e) {
		return (e, t) => (A(), o("path", tn));
	}
}), rn = /* @__PURE__ */ f({
	__name: "barcode-24",
	setup(t) {
		return (t, n) => (A(), o(e, null, [
			n[0] ||= s("path", {
				d: "M2.5 8.5V18.5C2.5 19.0523 2.94771 19.5 3.5 19.5H20.5C21.0523 19.5 21.5 19.0523 21.5 18.5V4.5C21.5 3.94772 21.0523 3.5 20.5 3.5H7.5M2.5 8.5L7.5 3.5M2.5 8.5H7.5V3.5",
				fill: "none",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[1] ||= s("path", {
				d: "M5.5 12.5V16.5",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[2] ||= s("path", {
				d: "M7.5 12.5V16.5",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[3] ||= s("path", {
				d: "M9.5 12.5V16.5",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[4] ||= s("path", {
				d: "M11.5 12.5V16.5",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[5] ||= s("path", {
				d: "M13.5 12.5V16.5",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[6] ||= s("path", {
				d: "M15.5 12.5V16.5",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[7] ||= s("path", {
				d: "M17.5 16.5V12.5H18.5V16.5H17.5Z",
				fill: "currentColor",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1)
		], 64));
	}
}), an = {
	d: "M21 4.75c10.098 0 18.006 6.338 18.245 13.9-2.022-.896-4.325-1.4-6.745-1.4-7.72 0-14.25 5.124-14.25 11.75 0 1.482.327 2.888.92 4.18a22.769 22.769 0 0 1-3.013-.438.747.747 0 0 0-.505.069.75.75 0 0 0-.525.439c-.314.742-.946 1.441-1.79 2.083-.84.636-1.839 1.178-2.815 1.619-.707.32-1.39.582-1.975.786a38.2 38.2 0 0 0 .54-1.097c.721-1.535 1.523-3.55 1.646-5.21a.75.75 0 0 0 .002-.051.75.75 0 0 0-.368-.802C5.7 27.957 2.75 23.711 2.75 19c0-7.714 7.996-14.25 18.25-14.25Zm19.743 14.665c.005-.138.007-.276.007-.415 0-8.854-9.017-15.75-19.75-15.75S1.25 10.146 1.25 19c0 5.23 3.177 9.8 7.954 12.638-.173 1.317-.813 2.958-1.474 4.364a34.358 34.358 0 0 1-1.345 2.565l-.022.036-.005.009-.001.002a.75.75 0 0 0 .825 1.113L7 39l.182.727h.002l.006-.002.018-.004.066-.017.245-.068a26.467 26.467 0 0 0 3.621-1.318c1.035-.467 2.144-1.063 3.103-1.79.813-.617 1.555-1.357 2.039-2.23 1.215.238 2.475.385 3.766.434 2.461 3.627 7.18 6.018 12.452 6.018.623 0 1.237-.033 1.84-.097.262.75.815 1.353 1.414 1.826.662.523 1.454.944 2.193 1.27a18.25 18.25 0 0 0 2.812.964l.05.012.014.004h.004l.001.001L41 44l-.171.73a.75.75 0 0 0 .803-1.134v-.001l-.004-.006-.015-.023a18.094 18.094 0 0 1-.277-.46 20.44 20.44 0 0 1-.663-1.234 12.92 12.92 0 0 1-.65-1.54c-.157-.466-.25-.88-.27-1.213C43.885 37.102 46.75 33.367 46.75 29c0-4.015-2.399-7.48-6.007-9.585ZM21.21 33.75a.752.752 0 0 0-.18-.289c-.822-1.36-1.279-2.878-1.279-4.462 0-5.525 5.558-10.25 12.75-10.25 7.193 0 12.75 4.725 12.75 10.25 0 3.788-2.582 7.176-6.557 8.959a.75.75 0 0 0-.422.863.75.75 0 0 0-.021.178c0 .587.153 1.222.352 1.812a14.394 14.394 0 0 0 .822 1.916c-.279-.103-.574-.22-.871-.352-.678-.299-1.344-.66-1.87-1.074-.533-.421-.85-.842-.958-1.245a.75.75 0 0 0-.115-.244.75.75 0 0 0-.856-.723c-.732.105-1.485.16-2.254.16-4.983 0-9.181-2.268-11.29-5.499Z",
	fill: "currentColor"
}, on = /* @__PURE__ */ f({
	__name: "comments-48",
	setup(e) {
		return (e, t) => (A(), o("path", an));
	}
}), sn = {
	"clip-rule": "evenodd",
	d: "M1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7ZM7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM9.85355 4.85355C10.0488 4.65829 10.0488 4.34171 9.85355 4.14645C9.65829 3.95118 9.34171 3.95118 9.14645 4.14645L7 6.29289L4.85355 4.14645C4.65829 3.95118 4.34171 3.95118 4.14645 4.14645C3.95118 4.34171 3.95118 4.65829 4.14645 4.85355L6.29289 7L4.14645 9.14645C3.95118 9.34171 3.95118 9.65829 4.14645 9.85355C4.34171 10.0488 4.65829 10.0488 4.85355 9.85355L7 7.70711L9.14645 9.85355C9.34171 10.0488 9.65829 10.0488 9.85355 9.85355C10.0488 9.65829 10.0488 9.34171 9.85355 9.14645L7.70711 7L9.85355 4.85355Z",
	"fill-rule": "evenodd"
}, cn = /* @__PURE__ */ f({
	__name: "clear",
	setup(e) {
		return (e, t) => (A(), o("path", sn));
	}
}), ln = { fill: "none" }, un = /* @__PURE__ */ f({
	__name: "image-empty",
	setup(e) {
		return (e, t) => (A(), o("g", ln, [...t[0] ||= [
			s("path", {
				d: "M25 38.5H3.5C2.94772 38.5 2.5 38.0523 2.5 37.5V6.5C2.5 5.94771 2.94772 5.5 3.5 5.5H40.5C41.0523 5.5 41.5 5.94772 41.5 6.5V22",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-width": "1.5"
			}, null, -1),
			s("path", {
				d: "M7.5 38L16.2842 27.5426C17.142 26.5214 18.74 26.61 19.4797 27.7196L22.3359 32.0038C23.1275 33.1913 24.8725 33.1913 25.6641 32.0038L32.4828 21.7758C33.2337 20.6495 34.863 20.5788 35.7086 21.6358L36 22",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-width": "1.5"
			}, null, -1),
			s("path", {
				d: "M16.5 15.5C16.5 17.7091 14.7091 19.5 12.5 19.5C10.2909 19.5 8.5 17.7091 8.5 15.5C8.5 13.2909 10.2909 11.5 12.5 11.5C14.7091 11.5 16.5 13.2909 16.5 15.5Z",
				stroke: "currentColor",
				"stroke-width": "1.5"
			}, null, -1),
			s("path", {
				d: "M34 41L45 30",
				stroke: "currentColor",
				"stroke-linejoin": "round",
				"stroke-width": "1.5"
			}, null, -1),
			s("path", {
				d: "M47 35.5C47 39.9183 43.4183 43.5 39 43.5C34.5817 43.5 31 39.9183 31 35.5C31 31.0817 34.5817 27.5 39 27.5C43.4183 27.5 47 31.0817 47 35.5Z",
				stroke: "currentColor",
				"stroke-width": "1.5"
			}, null, -1)
		]]));
	}
}), dn = /* @__PURE__ */ f({
	__name: "shipment-sorting",
	setup(t) {
		return (t, n) => (A(), o(e, null, [
			n[0] ||= s("path", {
				"clip-rule": "evenodd",
				d: "M13.1286 1.23944C12.7297 1.05536 12.2703 1.05536 11.8714 1.23944L6.37141 3.7779C5.84019 4.02308 5.5 4.55476 5.5 5.13984V12.8602C5.5 13.4453 5.84019 13.9769 6.37141 14.2221L11.8714 16.7606C12.2703 16.9447 12.7297 16.9447 13.1286 16.7606L18.6286 14.2221C19.1598 13.9769 19.5 13.4453 19.5 12.8602V5.13984C19.5 4.55476 19.1598 4.02308 18.6286 3.7779L13.1286 1.23944ZM12.2905 2.1474C12.4234 2.08604 12.5766 2.08604 12.7095 2.1474L17.8069 4.50003L15.8493 5.40352C15.7802 5.35602 15.7064 5.31394 15.6286 5.27801L10.568 2.94237L12.2905 2.1474ZM9.37488 3.49306L7.1931 4.50003L12.2905 6.85267C12.4234 6.91403 12.5766 6.91403 12.7095 6.85267L14.6818 5.9424L9.37488 3.49306ZM15.5 6.66613L13.1286 7.76063C13.0864 7.78012 13.0434 7.79755 13 7.81291V15.7186L18.2095 13.3142C18.3866 13.2324 18.5 13.0552 18.5 12.8602V5.28151L16.4432 6.23081C16.4804 6.36196 16.5 6.49942 16.5 6.63995V8.50012C16.5 8.77626 16.2761 9.00012 16 9.00012C15.7239 9.00012 15.5 8.77626 15.5 8.50012V6.66613ZM6.5 5.28151V12.8602C6.5 13.0552 6.6134 13.2324 6.79047 13.3142L12 15.7186V7.81291C11.9566 7.79755 11.9136 7.78012 11.8714 7.76063L6.5 5.28151Z",
				fill: "currentColor",
				"fill-rule": "evenodd"
			}, null, -1),
			n[1] ||= s("path", {
				d: "M1 8C0.723858 8 0.5 8.22386 0.5 8.5C0.5 8.77614 0.723858 9 1 9V8ZM5 9H5.5V8H5V9ZM1 9H5V8H1V9Z",
				fill: "currentColor"
			}, null, -1),
			n[2] ||= s("path", {
				d: "M20 8H19.5V9H20V8ZM23 9C23.2761 9 23.5 8.77614 23.5 8.5C23.5 8.22386 23.2761 8 23 8V9ZM20 9H23V8H20V9Z",
				fill: "currentColor"
			}, null, -1),
			n[3] ||= s("path", {
				d: "M1 18.5H23",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[4] ||= s("path", {
				d: "M3 21.5C3 22.0523 2.55228 22.5 2 22.5C1.44772 22.5 1 22.0523 1 21.5C1 20.9477 1.44772 20.5 2 20.5C2.55228 20.5 3 20.9477 3 21.5Z",
				fill: "none",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[5] ||= s("path", {
				d: "M7 21.5C7 22.0523 6.55228 22.5 6 22.5C5.44772 22.5 5 22.0523 5 21.5C5 20.9477 5.44772 20.5 6 20.5C6.55228 20.5 7 20.9477 7 21.5Z",
				fill: "none",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[6] ||= s("path", {
				d: "M11 21.5C11 22.0523 10.5523 22.5 10 22.5C9.44772 22.5 9 22.0523 9 21.5C9 20.9477 9.44772 20.5 10 20.5C10.5523 20.5 11 20.9477 11 21.5Z",
				fill: "none",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[7] ||= s("path", {
				d: "M15 21.5C15 22.0523 14.5523 22.5 14 22.5C13.4477 22.5 13 22.0523 13 21.5C13 20.9477 13.4477 20.5 14 20.5C14.5523 20.5 15 20.9477 15 21.5Z",
				fill: "none",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[8] ||= s("path", {
				d: "M19 21.5C19 22.0523 18.5523 22.5 18 22.5C17.4477 22.5 17 22.0523 17 21.5C17 20.9477 17.4477 20.5 18 20.5C18.5523 20.5 19 20.9477 19 21.5Z",
				fill: "none",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[9] ||= s("path", {
				d: "M23 21.5C23 22.0523 22.5523 22.5 22 22.5C21.4477 22.5 21 22.0523 21 21.5C21 20.9477 21.4477 20.5 22 20.5C22.5523 20.5 23 20.9477 23 21.5Z",
				fill: "none",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1)
		], 64));
	}
}), fn = /* @__PURE__ */ f({
	__name: "unstamped",
	setup(t) {
		return (t, n) => (A(), o(e, null, [n[0] ||= s("path", {
			d: "M19.5 19h-15c-.8 0-1.5-.7-1.5-1.5v-11C3 5.7 3.7 5 4.5 5h15c.8 0 1.5.7 1.5 1.5v11c0 .8-.7 1.5-1.5 1.5zM4.5 6c-.3 0-.5.2-.5.5v11c0 .3.2.5.5.5h15c.3 0 .5-.2.5-.5v-11c0-.3-.2-.5-.5-.5h-15z",
			fill: "currentColor"
		}, null, -1), n[1] ||= s("path", {
			d: "M17.5 9h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5zm-1 2h-4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4c.3 0 .5.2.5.5s-.2.5-.5.5zm1 2h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5z",
			fill: "currentColor"
		}, null, -1)], 64));
	}
}), pn = /* @__PURE__ */ f({
	__name: "shipment-unknown",
	setup(t) {
		return (t, n) => (A(), o(e, null, [
			n[0] ||= s("path", {
				"clip-rule": "evenodd",
				d: "M 11.853 1.527 C 11.948 1.491 12.054 1.491 12.15 1.527 L 13.377 1.992 C 13.587 2.072 13.692 2.303 13.61 2.508 C 13.528 2.714 13.291 2.815 13.08 2.736 L 12.001 2.327 L 10.922 2.736 C 10.712 2.815 10.475 2.714 10.393 2.508 C 10.311 2.303 10.415 2.072 10.626 1.992 L 11.853 1.527 Z M 15.302 3.15 C 15.384 2.945 15.621 2.843 15.831 2.923 L 18.286 3.853 C 18.496 3.933 18.601 4.164 18.519 4.369 C 18.437 4.574 18.2 4.676 17.989 4.596 L 15.535 3.666 C 15.324 3.586 15.22 3.355 15.302 3.15 Z M 8.701 3.15 C 8.783 3.355 8.678 3.586 8.468 3.666 L 6.013 4.596 C 5.803 4.676 5.566 4.574 5.484 4.369 C 5.402 4.164 5.506 3.933 5.717 3.853 L 8.171 2.923 C 8.382 2.843 8.619 2.945 8.701 3.15 Z M 20.211 5.011 C 20.293 4.805 20.53 4.704 20.74 4.783 L 21.968 5.249 C 22.125 5.308 22.228 5.456 22.228 5.62 L 22.228 6.949 C 22.228 7.17 22.045 7.348 21.819 7.348 C 21.593 7.348 21.41 7.17 21.41 6.949 L 21.41 5.893 L 20.444 5.527 C 20.233 5.447 20.129 5.216 20.211 5.011 Z M 3.792 5.011 C 3.874 5.216 3.769 5.447 3.559 5.527 L 2.592 5.893 L 2.592 6.639 C 2.592 6.86 2.409 7.038 2.183 7.038 C 1.957 7.038 1.774 6.86 1.774 6.639 L 1.774 5.62 C 1.774 5.456 1.878 5.308 2.035 5.249 L 3.262 4.783 C 3.473 4.704 3.71 4.805 3.792 5.011 Z M 2.183 8.279 C 2.409 8.279 2.592 8.457 2.592 8.677 L 2.592 10.715 C 2.592 10.935 2.409 11.114 2.183 11.114 C 1.957 11.114 1.774 10.935 1.774 10.715 L 1.774 8.677 C 1.774 8.457 1.957 8.279 2.183 8.279 Z M 21.819 9.209 C 22.045 9.209 22.228 9.387 22.228 9.607 L 22.228 10.937 C 22.228 11.157 22.045 11.335 21.819 11.335 C 21.593 11.335 21.41 11.157 21.41 10.937 L 21.41 9.607 C 21.41 9.387 21.593 9.209 21.819 9.209 Z M 2.183 12.354 C 2.409 12.354 2.592 12.533 2.592 12.753 L 2.592 14.791 C 2.592 15.011 2.409 15.19 2.183 15.19 C 1.957 15.19 1.774 15.011 1.774 14.791 L 1.774 12.753 C 1.774 12.533 1.957 12.354 2.183 12.354 Z M 2.183 16.43 C 2.409 16.43 2.592 16.609 2.592 16.829 L 2.592 17.589 L 3.577 18.015 C 3.783 18.105 3.876 18.34 3.784 18.542 C 3.692 18.743 3.451 18.834 3.244 18.744 L 2.017 18.213 C 1.869 18.149 1.774 18.006 1.774 17.848 L 1.774 16.829 C 1.774 16.609 1.957 16.43 2.183 16.43 Z M 5.491 19.281 C 5.583 19.08 5.825 18.989 6.031 19.079 L 8.486 20.142 C 8.692 20.231 8.785 20.467 8.693 20.668 C 8.602 20.869 8.36 20.96 8.153 20.871 L 5.699 19.807 C 5.492 19.718 5.399 19.482 5.491 19.281 Z M 17.146 19.809 C 17.24 20.009 17.15 20.246 16.944 20.337 L 15.751 20.869 C 15.545 20.96 15.303 20.872 15.209 20.672 C 15.115 20.472 15.205 20.235 15.411 20.144 L 16.604 19.612 C 16.809 19.52 17.052 19.609 17.146 19.809 Z M 13.567 21.404 C 13.66 21.604 13.57 21.841 13.365 21.932 L 12.171 22.464 C 12.065 22.511 11.942 22.512 11.835 22.466 L 10.608 21.934 C 10.401 21.845 10.308 21.609 10.4 21.408 C 10.492 21.206 10.734 21.116 10.94 21.205 L 11.999 21.664 L 13.024 21.207 C 13.23 21.115 13.473 21.204 13.567 21.404 Z",
				fill: "currentColor",
				"fill-rule": "evenodd",
				transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
			}, null, -1),
			n[1] ||= s("path", {
				"clip-rule": "evenodd",
				d: "M 1.808 5.458 C 1.9 5.257 2.142 5.166 2.348 5.256 L 3.576 5.787 C 3.782 5.877 3.875 6.112 3.783 6.314 C 3.691 6.515 3.45 6.606 3.243 6.516 L 2.016 5.984 C 1.809 5.895 1.717 5.659 1.808 5.458 Z M 22.192 5.458 C 22.284 5.659 22.191 5.895 21.985 5.984 L 20.757 6.516 C 20.551 6.606 20.309 6.515 20.217 6.314 C 20.126 6.112 20.219 5.877 20.425 5.787 L 21.652 5.256 C 21.859 5.166 22.1 5.257 22.192 5.458 Z M 18.51 7.053 C 18.602 7.254 18.509 7.49 18.303 7.579 L 15.848 8.643 C 15.642 8.732 15.4 8.642 15.308 8.44 C 15.216 8.239 15.309 8.003 15.516 7.914 L 17.97 6.851 C 18.177 6.761 18.419 6.852 18.51 7.053 Z M 5.49 7.053 C 5.582 6.852 5.824 6.761 6.03 6.851 L 8.485 7.914 C 8.691 8.003 8.784 8.239 8.692 8.44 C 8.6 8.642 8.359 8.732 8.152 8.643 L 5.698 7.579 C 5.491 7.49 5.398 7.254 5.49 7.053 Z M 10.399 9.18 C 10.491 8.979 10.733 8.888 10.939 8.977 L 12 9.437 L 13.061 8.977 C 13.268 8.888 13.51 8.979 13.601 9.18 C 13.693 9.381 13.6 9.617 13.394 9.706 L 12.166 10.238 C 12.061 10.284 11.94 10.284 11.834 10.238 L 10.607 9.706 C 10.4 9.617 10.307 9.381 10.399 9.18 Z",
				fill: "currentColor",
				"fill-rule": "evenodd",
				transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
			}, null, -1),
			n[2] ||= s("path", {
				"clip-rule": "evenodd",
				d: "M 12.001 11.07 C 12.227 11.07 12.41 11.248 12.41 11.468 L 12.41 12.532 C 12.41 12.752 12.227 12.93 12.001 12.93 C 11.775 12.93 11.592 12.752 11.592 12.532 L 11.592 11.468 C 11.592 11.248 11.775 11.07 12.001 11.07 Z M 12.001 14.259 C 12.227 14.259 12.41 14.438 12.41 14.658 L 12.41 16.785 C 12.41 17.005 12.227 17.183 12.001 17.183 C 11.775 17.183 11.592 17.005 11.592 16.785 L 11.592 14.658 C 11.592 14.438 11.775 14.259 12.001 14.259 Z M 12.001 18.513 C 12.227 18.513 12.41 18.691 12.41 18.911 L 12.41 19.975 C 12.41 20.195 12.227 20.373 12.001 20.373 C 11.775 20.373 11.592 20.195 11.592 19.975 L 11.592 18.911 C 11.592 18.691 11.775 18.513 12.001 18.513 Z",
				fill: "currentColor",
				"fill-rule": "evenodd",
				transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
			}, null, -1),
			n[3] ||= s("path", {
				"clip-rule": "evenodd",
				d: "M 20.183 15.057 C 19.806 15.057 19.501 15.354 19.501 15.721 L 19.501 16.253 C 19.501 16.473 19.318 16.652 19.092 16.652 C 18.866 16.652 18.683 16.473 18.683 16.253 L 18.683 15.721 C 18.683 14.914 19.355 14.259 20.183 14.259 L 21.274 14.259 C 22.102 14.259 22.774 14.914 22.774 15.721 L 22.774 16.216 C 22.774 16.705 22.523 17.161 22.106 17.432 L 21.441 17.864 C 21.252 17.987 21.138 18.195 21.138 18.417 L 21.138 18.911 C 21.138 19.132 20.954 19.31 20.729 19.31 C 20.503 19.31 20.319 19.132 20.319 18.911 L 20.319 18.417 C 20.319 17.928 20.57 17.472 20.987 17.201 L 21.652 16.769 C 21.842 16.645 21.956 16.438 21.956 16.216 L 21.956 15.721 C 21.956 15.354 21.651 15.057 21.274 15.057 L 20.183 15.057 Z",
				fill: "currentColor",
				"fill-rule": "evenodd",
				transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
			}, null, -1),
			n[4] ||= s("path", {
				d: "M 20.183 20.506 C 20.183 20.213 20.427 19.975 20.729 19.975 C 21.03 19.975 21.274 20.213 21.274 20.506 C 21.274 20.8 21.03 21.038 20.729 21.038 C 20.427 21.038 20.183 20.8 20.183 20.506 Z",
				fill: "currentColor",
				transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
			}, null, -1)
		], 64));
	}
}), mn = {
	"clip-rule": "evenodd",
	d: "M6 9C6 5.68629 8.68629 3 12 3C15.3137 3 18 5.68629 18 9C18 9.78139 17.636 10.9262 17.0292 12.2606C16.4314 13.5754 15.6301 15.0068 14.8226 16.3367C14.0162 17.6649 13.2089 18.883 12.6029 19.7695C12.3673 20.1141 12.1624 20.4082 12 20.6389C11.8376 20.4082 11.6327 20.1141 11.3971 19.7695C10.7911 18.883 9.98385 17.6649 9.17739 16.3367C8.3699 15.0068 7.56861 13.5754 6.97078 12.2606C6.36402 10.9262 6 9.78139 6 9ZM11.5959 21.7945C11.596 21.7946 11.5961 21.7947 12 21.5L11.5961 21.7947C11.6902 21.9237 11.8403 22 12 22C12.1597 22 12.3098 21.9237 12.4039 21.7947L12 21.5C12.4039 21.7947 12.404 21.7946 12.4041 21.7945L12.4043 21.7941L12.4053 21.7927L12.4091 21.7876L12.4235 21.7678L12.4788 21.6912C12.5271 21.6241 12.5976 21.5257 12.6872 21.3993C12.8663 21.1467 13.1219 20.7822 13.4284 20.3339C14.0411 19.4376 14.8588 18.2038 15.6774 16.8557C16.4949 15.5093 17.3186 14.0401 17.9395 12.6746C18.5515 11.3287 19 10.0135 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 10.0135 5.44848 11.3287 6.06047 12.6746C6.68139 14.0401 7.5051 15.5093 8.32261 16.8557C9.14115 18.2038 9.9589 19.4376 10.5716 20.3339C10.8781 20.7822 11.1337 21.1467 11.3128 21.3993C11.4024 21.5257 11.4729 21.6241 11.5212 21.6912L11.5765 21.7678L11.5909 21.7876L11.5947 21.7927L11.5957 21.7941L11.5959 21.7945ZM10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9C14 10.1046 13.1046 11 12 11C10.8954 11 10 10.1046 10 9ZM12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
}, hn = /* @__PURE__ */ f({
	__name: "location-pin",
	setup(e) {
		return (e, t) => (A(), o("path", mn));
	}
}), gn = /* @__PURE__ */ f({
	__name: "cancel",
	setup(e) {
		return (e, t) => (A(), o("g", null, [...t[0] ||= [s("path", {
			"clip-rule": "evenodd",
			d: "m13.354 3.354-10 10-.708-.708 10-10 .708.708Z",
			fill: "currentColor",
			"fill-rule": "evenodd"
		}, null, -1), s("path", {
			"clip-rule": "evenodd",
			d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-8 7A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z",
			fill: "currentColor",
			"fill-rule": "evenodd"
		}, null, -1)]]));
	}
}), _n = /* @__PURE__ */ f({
	__name: "filter",
	setup(t) {
		return (t, n) => (A(), o(e, null, [
			n[0] ||= s("path", {
				d: "M9.75 5.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM18.75 11.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
				fill: "none",
				stroke: "currentColor"
			}, null, -1),
			n[1] ||= s("path", {
				d: "M3.75 11.5h11M3.75 17.5h4M11.75 17.5h9M9.75 5.5h11M3.75 5.5h2M18.75 11.5h2",
				stroke: "currentColor",
				"stroke-linecap": "round"
			}, null, -1),
			n[2] ||= s("path", {
				d: "M11.75 17.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
				fill: "none",
				stroke: "currentColor"
			}, null, -1)
		], 64));
	}
}), vn = {
	d: "M8 2L4 6L2 4",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "square",
	"stroke-width": "2"
}, yn = /* @__PURE__ */ f({
	__name: "checkbox-check",
	setup(e) {
		return (e, t) => (A(), o("path", vn));
	}
}), bn = {
	d: "M3.66663 3.66663L12.3333 12.3333M12.3334 3.66661L3.66665 12.3332",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round"
}, xn = /* @__PURE__ */ f({
	__name: "cross",
	setup(e) {
		return (e, t) => (A(), o("path", bn));
	}
}), W = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, Sn = {}, Cn = {
	d: "M33.5303 5.46967C33.8232 5.76256 33.8232 6.23744 33.5303 6.53033L31.8107 8.25H38C38.4142 8.25 38.75 8.58579 38.75 9C38.75 9.41421 38.4142 9.75 38 9.75H31.8107L33.5303 11.4697C33.8232 11.7626 33.8232 12.2374 33.5303 12.5303C33.2374 12.8232 32.7626 12.8232 32.4697 12.5303L29.4697 9.53033C29.1768 9.23744 29.1768 8.76256 29.4697 8.46967L32.4697 5.46967C32.7626 5.17678 33.2374 5.17678 33.5303 5.46967ZM12 6.25C11.8011 6.25 11.6103 6.32902 11.4697 6.46967L9.46967 8.46967C9.32902 8.61032 9.25 8.80109 9.25 9V21V29.25H8C7.74924 29.25 7.51506 29.3753 7.37596 29.584L3.37596 35.584C3.29383 35.7072 3.25 35.8519 3.25 36V42C3.25 42.4142 3.58579 42.75 4 42.75H10C10.4142 42.75 10.75 42.4142 10.75 42V36.75H20.25V42C20.25 42.4142 20.5858 42.75 21 42.75H27C27.4142 42.75 27.75 42.4142 27.75 42V36.75H37.25V42C37.25 42.4142 37.5858 42.75 38 42.75H44C44.4142 42.75 44.75 42.4142 44.75 42V36C44.75 35.8519 44.7062 35.7072 44.624 35.584L40.624 29.584C40.4849 29.3753 40.2508 29.25 40 29.25H38.75V21C38.75 20.8011 38.671 20.6103 38.5303 20.4697L36.5303 18.4697C36.3897 18.329 36.1989 18.25 36 18.25H26.75V9C26.75 8.80109 26.671 8.61032 26.5303 8.46967L24.5303 6.46967C24.3897 6.32902 24.1989 6.25 24 6.25H12ZM38.75 30.75H39.5986L42.5986 35.25H38H27H21H10H5.40139L8.40139 30.75H9.25V33C9.25 33.4142 9.58579 33.75 10 33.75H38C38.4142 33.75 38.75 33.4142 38.75 33V30.75ZM26.75 20.25V19.75H35.6893L36.1893 20.25H26.75ZM26 21.75H37.25V32.25H10.75V21.75H26ZM25.25 20.25H10.75V9.75H25.25V19V20.25ZM24.1893 8.25H11.8107L12.3107 7.75H23.6893L24.1893 8.25ZM13 11.25C12.5858 11.25 12.25 11.5858 12.25 12V15C12.25 15.4142 12.5858 15.75 13 15.75H16C16.4142 15.75 16.75 15.4142 16.75 15V12C16.75 11.5858 16.4142 11.25 16 11.25H13ZM13.75 14.25V12.75H15.25V14.25H13.75ZM12.25 24C12.25 23.5858 12.5858 23.25 13 23.25H16C16.4142 23.25 16.75 23.5858 16.75 24V27C16.75 27.4142 16.4142 27.75 16 27.75H13C12.5858 27.75 12.25 27.4142 12.25 27V24ZM13.75 24.75V26.25H15.25V24.75H13.75ZM32 27.75H36V26.25H32V27.75ZM24 15.75H20V14.25H24V15.75ZM32 30.75H36V29.25H32V30.75ZM24 18.75H20V17.25H24V18.75ZM4.75 36.75H9.25V41.25H4.75V36.75ZM21.75 41.25V36.75H26.25V41.25H21.75ZM38.75 41.25V36.75H43.25V41.25H38.75ZM40.4697 11.5303C40.1768 11.2374 40.1768 10.7626 40.4697 10.4697C40.7626 10.1768 41.2374 10.1768 41.5303 10.4697L44.5303 13.4697C44.8232 13.7626 44.8232 14.2374 44.5303 14.5303L41.5303 17.5303C41.2374 17.8232 40.7626 17.8232 40.4697 17.5303C40.1768 17.2374 40.1768 16.7626 40.4697 16.4697L42.1893 14.75H36C35.5858 14.75 35.25 14.4142 35.25 14C35.25 13.5858 35.5858 13.25 36 13.25H42.1893L40.4697 11.5303Z",
	fill: "currentColor"
};
function wn(e, t) {
	return A(), o("path", Cn);
}
var Tn = /*#__PURE__*/ W(Sn, [["render", wn]]), En = {
	"clip-rule": "evenodd",
	d: "M10.8995 1C10.1885 1 9.58167 1.51406 9.46478 2.21542L9.16604 4.00785L8.35264 4.34478L6.87397 3.28858C6.29538 2.8753 5.5028 2.9409 5.00002 3.44368L3.44372 4.99998C2.94094 5.50276 2.87534 6.29534 3.28862 6.87393L4.34481 8.3526L4.00785 9.16604L2.21542 9.46478C1.51406 9.58167 1 10.1885 1 10.8995V13.1005C1 13.8115 1.51406 14.4183 2.21542 14.5352L4.00787 14.834L4.34491 15.6474L3.28873 17.1261C2.87545 17.7047 2.94104 18.4972 3.44382 19L5.00012 20.5563C5.5029 21.0591 6.29548 21.1247 6.87408 20.7114L8.35274 19.6552L9.16604 19.9921L9.46478 21.7846C9.58167 22.4859 10.1885 23 10.8995 23H13.1005C13.8115 23 14.4183 22.4859 14.5352 21.7846L14.834 19.9921L15.6473 19.6552L17.1259 20.7114C17.7045 21.1247 18.4971 21.0591 18.9999 20.5563L20.5562 19C21.059 18.4972 21.1246 17.7047 20.7113 17.1261L19.6551 15.6474L19.9921 14.834L21.7846 14.5352C22.4859 14.4183 23 13.8115 23 13.1005V10.8995C23 10.1885 22.4859 9.58167 21.7846 9.46478L19.9922 9.16604L19.6552 8.3526L20.7114 6.87393C21.1247 6.29534 21.0591 5.50276 20.5563 4.99998L19 3.44368C18.4972 2.9409 17.7046 2.8753 17.126 3.28858L15.6474 4.34478L14.834 4.00785L14.5352 2.21542L14.042 2.29762L14.5352 2.21542C14.4183 1.51406 13.8115 1 13.1005 1H10.8995ZM10.4512 2.37982C10.4877 2.16064 10.6773 2 10.8995 2H13.1005C13.3227 2 13.5123 2.16064 13.5488 2.37982L13.8932 4.44584C13.9215 4.61601 14.0356 4.75955 14.195 4.82557L15.5209 5.3748C15.6803 5.44083 15.8625 5.42001 16.0029 5.31973L17.7073 4.10232C17.8881 3.97317 18.1358 3.99366 18.2929 4.15078L19.8492 5.70708C20.0063 5.8642 20.0268 6.11188 19.8976 6.29269L18.6802 7.99707C18.5799 8.13747 18.5591 8.31965 18.6252 8.47904L19.1744 9.80499C19.2405 9.96438 19.384 10.0785 19.5542 10.1068L21.6202 10.4512C21.8394 10.4877 22 10.6773 22 10.8995V13.1005C22 13.3227 21.8394 13.5123 21.6202 13.5488L19.5542 13.8932C19.384 13.9215 19.2405 14.0356 19.1744 14.195L18.6251 15.5209C18.559 15.6803 18.5798 15.8625 18.6801 16.0029L19.8975 17.7073C20.0267 17.8881 20.0062 18.1358 19.8491 18.2929L18.2928 19.8492C18.1357 20.0063 17.888 20.0268 17.7072 19.8977L16.0028 18.6803C15.8624 18.58 15.6802 18.5592 15.5208 18.6252L14.195 19.1744C14.0356 19.2405 13.9215 19.384 13.8932 19.5542L13.5488 21.6202C13.5123 21.8394 13.3227 22 13.1005 22H10.8995C10.6773 22 10.4877 21.8394 10.4512 21.6202L10.1068 19.5542C10.0785 19.384 9.96438 19.2405 9.805 19.1744L8.4792 18.6252C8.3198 18.5592 8.13762 18.58 7.99722 18.6803L6.29284 19.8977C6.11203 20.0268 5.86435 20.0063 5.70723 19.8492L4.15093 18.2929C3.99381 18.1358 3.97331 17.8881 4.10246 17.7073L5.31987 16.0029C5.42017 15.8625 5.44098 15.6803 5.37493 15.5209L4.82556 14.195C4.75952 14.0356 4.616 13.9215 4.44584 13.8932L2.37982 13.5488C2.16064 13.5123 2 13.3227 2 13.1005L2 10.8995C2 10.6773 2.16064 10.4877 2.37982 10.4512L4.44584 10.1068C4.61601 10.0785 4.75954 9.96438 4.82557 9.80499L5.37484 8.47904C5.44087 8.31965 5.42005 8.13747 5.31977 7.99707L4.10236 6.29269C3.97321 6.11188 3.99371 5.8642 4.15082 5.70708L5.70712 4.15078C5.86424 3.99366 6.11192 3.97317 6.29273 4.10232L7.99711 5.31973C8.13751 5.42001 8.31968 5.44083 8.47908 5.3748L9.80498 4.82557C9.96438 4.75955 10.0785 4.61601 10.1068 4.44584L10.4512 2.37982ZM9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
}, Dn = /* @__PURE__ */ f({
	__name: "settings-24",
	setup(e) {
		return (e, t) => (A(), o("path", En));
	}
}), On = {
	"clip-rule": "evenodd",
	d: "M6 4.5C6 3.11929 7.11929 2 8.5 2H15.5C16.8807 2 18 3.11929 18 4.5V19.5C18 20.8807 16.8807 22 15.5 22H8.5C7.11929 22 6 20.8807 6 19.5V4.5ZM8.5 3C7.67157 3 7 3.67157 7 4.5V19.5C7 20.3284 7.67157 21 8.5 21H15.5C16.3284 21 17 20.3284 17 19.5V4.5C17 3.67157 16.3284 3 15.5 3H15L14.2929 3.70711C14.1054 3.89464 13.851 4 13.5858 4H10.4142C10.149 4 9.89464 3.89464 9.70711 3.70711L9 3H8.5ZM10.5 19C10.2239 19 10 19.2239 10 19.5C10 19.7761 10.2239 20 10.5 20H13.5C13.7761 20 14 19.7761 14 19.5C14 19.2239 13.7761 19 13.5 19H10.5Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
}, kn = /* @__PURE__ */ f({
	__name: "mobile-phone",
	setup(e) {
		return (e, t) => (A(), o("path", On));
	}
}), An = /* @__PURE__ */ f({
	__name: "myparcel-24",
	setup(t) {
		return (t, n) => (A(), o(e, null, [n[0] ||= s("path", {
			d: "M1.5 12C1.5 6.20101 6.20101 1.5 12 1.5V1.5C17.799 1.5 22.5 6.20101 22.5 12V12C22.5 17.799 17.799 22.5 12 22.5V22.5C6.20101 22.5 1.5 17.799 1.5 12V12Z",
			fill: "none",
			stroke: "currentColor"
		}, null, -1), n[1] ||= s("path", {
			"clip-rule": "evenodd",
			d: "M7.72074 10.8902C7.92181 11.0442 8.16795 11.1271 8.42085 11.1261C8.62301 11.1262 8.82153 11.0722 8.99593 10.9695L12.5648 8.88667C12.8167 8.72807 12.9974 8.47743 13.0687 8.18764C13.1401 7.89785 13.0965 7.59156 12.9472 7.33341C12.7979 7.07525 12.5545 6.88542 12.2685 6.80395C11.9824 6.72249 11.676 6.75576 11.4139 6.89676L7.84368 8.97754C7.62456 9.1043 7.45333 9.30024 7.35664 9.53484C7.25995 9.76945 7.24323 10.0296 7.30908 10.2747C7.37493 10.5198 7.51966 10.7362 7.72074 10.8902ZM8.43264 15.2682C8.18063 15.2682 7.93565 15.1848 7.73558 15.0309C7.53551 14.8771 7.39149 14.6614 7.3258 14.4171C7.2601 14.1729 7.27638 13.9137 7.37212 13.6797C7.46786 13.4456 7.63774 13.2498 7.85547 13.1224L14.996 8.95667C15.1261 8.88076 15.2699 8.83133 15.4191 8.8112C15.5682 8.79107 15.7199 8.80064 15.8654 8.83935C16.0109 8.87807 16.1474 8.94518 16.267 9.03684C16.3867 9.12851 16.4872 9.24293 16.5628 9.37359C16.6384 9.50425 16.6877 9.64858 16.7077 9.79835C16.7278 9.94811 16.7182 10.1004 16.6797 10.2464C16.6411 10.3925 16.5743 10.5295 16.4829 10.6496C16.3916 10.7698 16.2777 10.8707 16.1475 10.9466L9.00772 15.1151C8.83286 15.2162 8.63444 15.2691 8.43264 15.2682ZM12.0147 17.3337C11.7627 17.3336 11.5178 17.2502 11.3177 17.0964C11.1176 16.9426 10.9736 16.7268 10.9079 16.4826C10.8422 16.2383 10.8585 15.9792 10.9542 15.7451C11.05 15.5111 11.2198 15.3153 11.4376 15.1879L15.0078 13.1015C15.138 13.0256 15.2817 12.9762 15.4309 12.956C15.5801 12.9359 15.7318 12.9455 15.8772 12.9842C16.0227 13.0229 16.1592 13.09 16.2789 13.1817C16.3985 13.2733 16.4991 13.3878 16.5747 13.5184C16.6503 13.6491 16.6995 13.7934 16.7196 13.9432C16.7396 14.0929 16.7301 14.2452 16.6915 14.3913C16.653 14.5373 16.5861 14.6744 16.4948 14.7945C16.4035 14.9146 16.2895 15.0155 16.1594 15.0914L12.5898 17.1778C12.4152 17.2799 12.2168 17.3337 12.0147 17.3337Z",
			fill: "currentColor",
			"fill-rule": "evenodd"
		}, null, -1)], 64));
	}
}), jn = /* @__PURE__ */ f({
	__name: "insurance",
	setup(t) {
		return (t, n) => (A(), o(e, null, [n[0] ||= s("path", {
			d: "M3.5 5.5C3.5 5.5 10 3.5 12 1.5C14 3.5 20.5 5.5 20.5 5.5C20.5 20 12 21.5 12 21.5C12 21.5 3.5 20 3.5 5.5Z",
			fill: "none",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1), n[1] ||= s("path", {
			d: "M8.5 12.5L10.5 14.5L15.5 8.5",
			fill: "none",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1)], 64));
	}
}), Mn = /* @__PURE__ */ f({
	__name: "basket",
	setup(t) {
		return (t, n) => (A(), o(e, null, [n[0] ||= s("g", {
			"clip-path": "url(#clip0_16539_613)",
			fill: "none"
		}, [
			s("rect", {
				height: "8",
				rx: "2",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "1.5",
				width: "44",
				x: "2.5",
				y: "11"
			}),
			s("circle", {
				cx: "22",
				cy: "2.5",
				r: "1.5",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "1.5"
			}),
			s("path", {
				d: "M21 4L12.5 15",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "1.5"
			}),
			s("path", {
				d: "M29 4L36.5 15",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "1.5"
			}),
			s("circle", {
				cx: "28",
				cy: "2.5",
				r: "1.5",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "1.5"
			}),
			s("path", {
				d: "M32.5 42H9.25607C8.2515 42 7.4028 41.2548 7.27287 40.2587L4.5 19H44.5L42.7265 32.5968",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "1.5"
			}),
			s("path", {
				d: "M34.5208 45.3333L28.1569 27.6556L45.8345 34.0196L40.8848 37.5551L47.2487 43.9191L44.4203 46.7475L38.0563 40.3836L34.5208 45.3333Z",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "1.5"
			})
		], -1), n[1] ||= s("defs", null, [s("clipPath", { id: "clip0_16539_613" }, [s("rect", {
			fill: "white",
			height: "48",
			transform: "translate(0.5)",
			width: "48"
		})])], -1)], 64));
	}
}), Nn = /* @__PURE__ */ f({
	__name: "directDebitAuthorization",
	setup(t) {
		return (t, n) => (A(), o(e, null, [n[0] ||= s("rect", {
			fill: "url(#pattern0_26730_316821)",
			height: "38",
			width: "38"
		}, null, -1), n[1] ||= s("defs", null, [s("pattern", {
			id: "pattern0_26730_316821",
			height: "1",
			patternContentUnits: "objectBoundingBox",
			width: "1"
		}, [s("use", {
			transform: "scale(0.00666667)",
			"xlink:href": "#image0_26730_316821"
		})]), s("image", {
			id: "image0_26730_316821",
			height: "150",
			width: "150",
			"xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAlqADAAQAAAABAAAAlgAAAAAXS0ggAAAaN0lEQVR4Ae2dC5AcxXmA/5nZ3bvbO73F6QFEQgQJ0EnhkZAIcOqQKOzwTKp8gDBxkkr5MMG8klQlAYLPAmNjUwFXpWKhJI6xKYQ5uwrzqMLhJQwICBAcdBgJRFBARu/n6fb2NbP5/57p2Z7Z2efM7szudUt3szPT09P9z3d///P3370K1JCGhh7TKNvo6JU6bUdgRP1ghXpmoaCcWwDj9wDUUwAKCxVQFuA2TnlkaqUEFF1TY5ph5J56ZOzOy+jOQzCkjcIoe16trAm/l8I/eG8LysjgN7SRTSN5On/Vym8OaIb+ZwWAK1RFOyWmJthlRkEHo2DgD8vmXZQ82mwJ6F1aUsvoqac3jt15Kd0sTLjKgjU4OBLbZAF17cpvnqUX9K8roF6eULshb2QhX8gjX8D+IrAQKod+VPyRKTwJZBGuRBTg8gRr+Ozh+Ia3N+SGlo8k4or2gKKo12tqHHJ6BmFiaom6RglReABVunMk4CoBa/jsBxGq63JfWrFuhWHAE12x5GL8CzBQIZF2iiFYJdfYrSQdJlNrJeD9NEKHy1EtDtVVAyMXqaD+grSUbuSyCBUa5B5AEUiot9QYdpL0o2FxjhJbK+OpeLf8JNq2OXwQpXIPFS67Orz7u3bgrsGCor5YAHzfKxh5zIBaqjRpXSrEulXIpw1I7czC+J4sTEIeDLzObCXf0rXiZ/e++xydp1TuuHnW+VvMS58p8abxc3xrni1ffrl87uNUjtcxXr77fLW84nXiZ7qOErWHl1HAPQUN3AKcuHgadM+NQS6lg6LyNrML6FdocLGa8LeHq88YWQx5daumaF34pkeveA6oCtiuWJcCBNWB11LwGaTgOOiG077YD4sH+mHughkQj8eA8pUk3mZ+jvbdn3ke98WUj+fnefgxyusuh1/Pr+H7tOXX02d3GTy/eytex+9Fx3jiZYrl8XNifl4unfO6ptz1Yl5eLm61mAqbfroFPn7yAMz9g17IHs1HBi6qsl3ttQN3vRFXE+fkjEwOjzv8UehNgK4ZGhz+7zTsykzAF65fBoOXnwFLly+CucfNgq5u0/UgtFt+bIEE9u89BLdd86+w6/mjMGdVEjJHogGXwrvAqwfW3dStJb+HhjraVOCkBP+SEgjV9s2H4NxrF8GX//rzcPrvnAyq6nwxLKCq8tRWAQqY/gpEJRBg0Q0X5adOjV6r4IUGvl1pmgYH9h6Gf7hmA+xGuGZHBC5qF6BboS+mqB+h07Mfu0DUTYIrgaCarsG21w7CjQ+uhqG/uIh1d3QdNYz6evafWipTyyVg4ONSNTRN9iFcawmucYSrJ3TNxVROXFX/HB1rBBV1gbYaou6PNBVB9fePXALXDF/MoKLGUCKNRQajIqFi8gjjF0FFz2POcTPhWxuHYf6aacz+7ZqBtq5RotvJeUoG/SVrB9Y9RfWlYR+ysYOuuwlRAb6sm8MxNlR0o8Q0DT7dfBT+9J5z4Iq1F7B7U3dHjZEpOhJww7Vg9fTQ4VLWrhg5FQrq+6aYFETc9FcpyA5prPy4Aevfuhlmz52JXR9CVfpKGx0JT/Ga2N0i2VzYLe56ITyDHvWoen5C6yGDGN0LRSdovFeDHWNHYOgbqyyosC+XUEUaXVtz9WO3+OgwLFgzHQ6+Nolv863vFtHBXjiHpIWWUrFDRju8oBfw1VCF3z33dEuY0jiPNFVW5Wy4BJsrDLhUVFXLCtTnCdqKhmZSu3Nw+sXzYP7xc1mVpX3eDliZdfSCixzardRcCJYy3zCjX2yLnMb9xj/JwpIz+qEn2W2BJTVW+6CFb+yut8VWG/QqaiJ0MzD3gUkOdogKgkXjfjREQ4neBGVqPwmECZeKyMw0u0Jyc5qJuj0aTu5Jmg54yRWXTPttbbjqN+ifptY26ueyuz9vkdmseZ+WR9tCAjZcDoO+qs11sR8nahWw2kJuspI1SKAEriY7USVYNTyUTsnigAv9XPObCFdlsGRP2ClM2e0Q4fo2OVERrmb4uSqDZVdHfvArAYrIjUoS4SIPPQ1cBw2XBKsFT5vcNSy8KKpwNSEqQoLVZLDIlUNhRbpBkd7Rsi0cmgvhCtKJKsFqIljkeMY5mZDJp+Hbz1wHr277T3Y3yyHdxDvXXrQDLsvmCmL4R4JV+zOoKyfBoxJUuTQ88Nyt8NreH8C3Xv88vLH9RXY8snBt/EogURESrLpwqS2zCNX9z98Cr+xZD4t6z4CF3YvgjpdXRxuu/ll2JKofg16CVRsrNedyQ7V5z4NwYs8ATObfw3maaViSXBJ9uAQPfaPdogSrZmSqZ/SC6oSeFZA2PkRbqxffCSdBLxxDuE5uG7gaNeglWNV5qSmHJ1RJguoDfBfswTLIj6UIcP12e8DVoEEvwaoJm8qZPKEiTaWLUPEyKLYyhZprvH00F8FVZ5izBIs/7wa33lANuDSVu3ARrvayuWox6K8ZWPekBMv9zOvY94bKsqns7q9cgQRXuu1sLnve4vSyEzR0VY1fKsEq99yrHPeEqsSmqlJIBZsrSlG7DicqeeixW9z3+gTEkzjPtXQIVMM5qroEq9qz9zjvCVVZm8qjAMchsVs0Dfo3P3qJDQNFDS7dmnF9zyNfgSWXz4HJ/TlQ4x7DVIWCnNLseMY17HhDVc2mqlYwh+sILO07E659bhC2737PgovNR6hWQEvOa4iLruswF52on/vj5bBzxzGI9aBuKtVaxXUaWlKzNr9JeajQT1XVpqre+IQ6H7aOvwN3n7keTupfxi6gscYoJb7CUD6v4+JpqK08oKL6RqvWUZKgqy7eUNVqqLsKc+xSV6JDl3YSbD22BYaX/wsMnXMd4Lrt0ZwdZYFEERtlmGKtk2A5HrL3jidUdRvq3mUD5KBLXYKa6l24DqG66vevZxlZDBdNl2rT5FgKsk3b0NRqe0LVsKHuripqKvVk1FQE1fcRqq+yDO0OFTVCaiz3sxb2vaHya6jzGxjY/aGm6kCoqIUSLP6cXdvyUAVhqJOmQpvK7v46R1NxMUqwuCSErTdUQRnqedOmYprKn01lzWAXah6djxIs17PwhCpQQ53bVI1DxR2n5Irgn13NCH1XgiU8Ak+ommaoN/b2xydn5HG52A92bYmch56LU4JlScIbqgANdXIp2N1fYzaVCZX5yB77r+/DZU+sBD78Q/WPUpJg4dNwQPXcLUDhxHbkp2+PumWo21A1qqlwbqLlhX948wPwg603w4Wzz4TbfjkYzRj6KFEeRl0cUOHEh817EaqAbKoCLgbFnJ+BQGU6Swmq/9h6K44proSMvhODBaMZiTqlNVYJVFxTeUZ+1ou9Dt3o/NzGoCLnpx9NVYTqhwjVsmkE1Uc4pJKxIlGjB9eUBcsbqgBtKsv5OezDoy564ElTEVRLEaq0vh0pp0ETGq+LZpjzlASrPFRBOD/Jo+7f+emGinV/FlSK46uOeMgNxdBHJ8x5yoHlDVVQzk+3Rz2Y7o+gou4vjd2fCZU7roDgilaY85QCyxOqgAx1O0qhCYY6t6kU1v25oeK2X7Smlk0ZsDyhCtj52UxD3fWdpJwm11bsFsOdFDslwPKGqp0Mdcd3krpgcu+KcDltLnfOZu53PFjloQrCUHfbVI161Mn5WXQplBrq5bq/cmhwm2sCTkouhrteXW0vodSqlQU7GiwHVIF61AmC5jk/izYVrbNfL1QcNvz+LTgIcXUWjiwAvLrj57jFLySnOPWGy+RlV992LFgOqAL2qJuGejBRCm5NxaEybapGoTIN+W71VNgx8Q5cuPAWuPXC+3FdLs2KhjC1Y3U8Gs/RkWCVQBWwR70YTuwv9EWEinvUyaVQm6Fe7qETVGno1pbBJ6ktsHrhzXDjmnshriUQKnPZynJXBnm848DyhipAQ90RpRCMn0r0qCtQj6HuRoFDtRQ+mXgXLkCoblrzHQYVyYUPYruvasZ+R4FVHqoADfUm+Kn4MI2387PWx251f9opFlQ3OaCiZStbmVp7tya2zBMq5vz0D1UzoxS4TWVqKr82FWmqLZam+q6tqVoNFT3mjgDLE6oAnZ/FKAU/NlXRvuEDyhyqYGwqhAptKnf3FwZUHQGWN1TB21RmlIIfm8r8G+ZQ8e4vMKhsTVW0qcKCqu3BKg+V/+4P40qtae98hnKznJ/0GBpJbkM9XJvK3YK27Qq9oQoiSoFE5Pao+9FUTo86dX/loxTcj6fcvmWoq6KhHq5N5a5pW4LlCVVAUQqtMdQpSC8AQ922qaIFFUHWdms3eEIVsKHud9q7O0iPOz8pnNifyK3uT42WoU4guVNbaSxvqII31P0s0OEFVdFQD8j5aWuqaBjqbqhov23AKg9VEIa6e4pWswx1v92faFNFF6q2AYu0AL06Z/MZ+KdmRCnYq7748VOVhr5wP1UgHnVH9xc9m8qttSJvY/GuJZU5Bvc991fwPwd+DMf3LMd11LdjAEgPtqdRLUCioEXPMEqBrfrS+PpUvI5UIp/3x6EybapG68jf/qJvU1HbxRT9rtCK8CCN1RefA3l8RmZMkdiMRj5T98dDX4KDihvqQUcpMI/66mh3f+JTiDxYBBFphO5EEm658D5Yc8LfwY7UGIaFnMLCQxr71lJ0ftpRCn6gKh2m4YZ6U6IUYgl7OQDxIUbxc+TBIqFR3BIz3lUNbrjgbvjCiQgXhoV0a0sbgCtIQ90UH+/+ilD5ify0ur+IRCk0Cm1bgEWNo66Q4KLVhDlcHxNc6H2mwLbaNFcrwonJpRCATWWP/UXfUKfn405tAxZV3A3XH5HmQp9ObZrLtKn8T9Eq7f6chrpbxLXuW85P1MJRilKotfbufG0FFlXeDVdt3WLRpvK/lkKx+xMjPwPxqBNUtqZqH0PdDRV7Tl4Ho36sPrgIKlqcX0YptPK5Rktj1WGalIXLYXORTSVCJaMUWgVXJMDS87rZXvRZkWuh1uQF18dkcxFc+A2mXRr3UzXLo975UQq1Pgt3vlDB4hDt3rUfHn/kBVY3ci3w4+7Keu274SKDnuCanlgF79se9WA0FXd+Bhal0CGGuudz8TrYqmNcOeVzOvzJlx6Gp3/6S3Zrv3Bd+lu3w0N7X4EbBjY0/DUiBLd73h/3U0FgU7SiE6Me9DMPeayQuj0FJsZTsAb64e6hJ8D4iQGXXTnIHqr4cKs1XNRcf3n+bbB8wSoYPO0Sdlk95dAFYn7u/DQjP2l8MgjnJ04mZfP+ohVOXE3G9ZwPtSvkFT2GYB2GLKy8qB9uv+pxePKxTexUI5qLoKDhn6Chou4vEKgoSsGeTNqezk/+3CptIwHW+JEUq2P2mA5nnz8P7vABF4MRPd/kpafEuzO2U+VXOU1VtKlqf7Fw3soapnGEvrS3n8rZvtK9SIB15NAExkjj0juobTKH8/7hQt1CXWM9yQ0VN9SbEqUgTHuvt571tCnMvPVJP+Cacm1y5NAx6GJg4Q1QKaQRrrNQc/npFuupqhdU3FBvSpSC1j5RCvXIUcwbKli8Iof3E1i4xI6OVFnxV0xzndd8uNxQ+V/0jLeqM6IUeGvq3YYKFmksQzfg8L4JCyxn9TNH/HeLzhKde15Q8QHlTltLwdny5u+FBhY9VErZbA4O75mAxHzUWLT0nCsFYXO5imS7bqi4TVU01L2uquVYZ0Up1NJirzyhgcUrk80gWJ9OQnymN1iUj2wuv2+L/H58y94e8c1x4+v/bH43jeMbH3iuercCVB0SpVCvBHj+0MFKT2bg8JtpiPXgW2GFb0YL0qDnrogXfv0k3PDOjbBixucgncfv/nN84wMXUa1bESpa9KxznZ+1SCQ0sKyeEFKpNIyjc1SNW1Z7hVoHZdDzt9Hzll4Edy27HbaNvwzdsYE6IlHdlbQM9QivpeCucbP3QwOLh++mjk3CJK5ArGrVwSJhBGHQ2xM04j3w1cERYAPX2HXVF+bMHw2HSoz87FyPOm91tW2IYJlVo+GcHC4ZxN0M1SpM54Mw6NkbqRBDX1+YM6+l0P21wbR3XutWbEMH66g1nFNvY4OwucSBaz5Bo/bZPwJUU9xQ93p2IYJldn1HcTgnTktIlHoavOrrOBaEzdUYXLz7a5+1FByCa8FOaGBZ3/AB9nBOhTfCSnJgNpdPD31ZuBxhzrwWHCppU3GJeG1DBMvUWDSck6DhHA/nqFeFvY4FYdB7wcXCnB2TYr2g6uwoBS9513IsNLCoco7hnAY1Fm9kEAa9Gy5m0NszrjPYW2fsb3yIyurEvP1R24YSQcqHU7I5YTiHBqB9JtGgp6L8RqKSQQ8vAjzz6b2wOEl+LhCC9KSmqvS4QgGLVyibRrB24nDODH9dIS+PtqJBT/tBwfX8znsxxgumvEedZFpLChUsGs45gsM5fWdgfFLOv8biDRZtLjrmF66vXfBNyD2XgayegpvX3AcxLd42q75wmbR6GwpYNJxDb4VsOKeQhRnxLjCydDC45os2F5XqBy6VrXJzD4twlVDV9oxCAct0WilAwzkpHM5RcDiH9FWAXLHWc5uLYugpNQoX2YTdOPxDiT6TkS9TZQmEKiE+nMMHhStXtbGzpLn8hjmzEBtEn/41s66NtTCaV4UKFg3nkJZqhrYSxS0a9I1OLaOBa/onU20SCAks8wEdPWzOzsH+Jfh+0NV+0aBvFC5XkXK3ggRCAcsezjlozc7x6Ryt0D7HKdGgl3A5RBP4TkhgmRrLnp3jYzinLomgYuQGfaumltVVvw7K3Pq3QsugKg7nxCqGJDcsa2SXNKOCXk1668QvcAeVPJz0p4QactVFC+Geq57CYypc8sU/ZEZ5s229htvShhe2HCz2ZoVGMBvO2Y0hMwso1p0eqUfCw/wM03EIBb2VESQmMNaWTrIMmB+hofmJOvrF8ikdcgcNyB7QcZQvjz8G/uj4D9/u8JJZOOns0qGHcAklHa5YewEvwqMi8lC9Emg5WLyCNJxzCIdzEjg7hzQLxbwzWAge0jIWRJSffEcGfnNAKSwEjI4R8zpiY8JCsV29GOE1bXYCZp7eAzPP6oFZ83ph5tw+mDG3F2bM6oPpM3th+oxe6J3WA33TkqDFNNBxfqOmkTqTKQgJhAZWOp2FyV1Z6J4Xg9w4apWDCMh+E5J0GVimz03AjFMJliTCkoSZxyEsc4qwTENY+hCWZC/+JLuhqycBXV1xiMfjDNYgBCbLqE0CLQeLeRZQQ40fnYBNO/fBmt55kOxPwMIzvTULh6W3rwd6CJZugiWBsMTqgoW0HiVzU+xgWQ+Kv6TjszZgas3VcrC4q2Hegjnw5oe3Qd/0ZMCwUNOxK2XEmGJgdpl1wNwIJ2uVlMxXlwRCAAvHBVFtkG1DP+7ENQrfFs+LsJifuZaRsBSlFJVPLQeLGk5AEFwEj6VImDxMzcJyWMelZmGCacNfoYDF0EGiRKjaUHayyhUkIN+vKwhHnmpcAhKsxmUnr6wgAQlWBeHIU41LQILVuOzklRUkIMGqIBx5qnEJSLAal528soIEJFgVhCNPNS4BCVbjspNXlpdAToJVXjjyjJcErMGQyYmM9W0imKk4QGKoFCwHcEiC5SU8eaysBPj47L7PjkAS0TLENTcUpaCYcy4PSLDKilCecEuAhx5N4ETj/31nD/SdlIACBmDaCTOoFPutKLskWLZU5IdqEuBg7frNPvj1s/uhpx/XsBDAIsSYxioUtkqwqklTni+RwJsvv4eB4DQrHE8JCoubWgUF3pRglYhNHvCSgGEYbEbTvj2HYPRvX4dFK6dDDierFA13hRCLZfVJI2YYr0iwvKQojzkkQLOoaJocpUfWPwPjR7IQ63Z/k0jBiKn0tcbwxsPvjWyXYJEoZCorAZr/SbOmKP3sR8/CT0behuNXTYPssZLp68zVgN3jDylvaIF+dHOZoicBZqBjp0Y2FGkpFafE0Rdpbfy3Z2D9116CZatmQ+aozqbnCbUnqOJZY/KzfN+hH9PxCmAhpdZE0gLOAi0YpnJjlr9Qotc+Py3adrZhZ50Uz4n5+WexXP6Zb3ke2tIxSl7l03F+jTufeI5/pi0lXje+NY8Wf7uP83vzHOI9+TmvYzy/11bMT+f5PcUtHW8kH68TXU+JlYEHzdBw+kD/FdDzOoz96kN46Lu/gLce+w0sO3cOZPE7JD0if/NxtSuR1lN3jb52/+Tw2cM4h8orYcE6zhqOxZkXFSdymlvKiqccyc+++1qxYPEc/8y35fLRcXcevs+35a51n+f7fCte53Uf8Ty/hm/F/OIx8Rr3Z56Pb8uVwc/zbT35+D3Fa2n5TjLQt419DC8+/it49t+3wwmz+2DJqplsfVePNeeycY1B9eqjY3euR0yVDW8ruVKw8C75lAELsbC3X9oOOr4N5HOo+jww5RWT2/aXQC6bh327jsCOLXth68/3wSGcY348zik/fdUcyKdxaYLS7o8anccuMJHTMxOaalxNB4bgSnUU9ZKydmAdaUJnwiMKTnmf/L8s7DqUwuX9RaadWeVeZ0hAxWfcg5bRtOMTkFwQBy2hIlC4zkWGYPBqo5LDJTPjZCaheX/eo2N3bB4ZHImNbBrJU+5SjUVHsaACrmKcXJSAZad2FztyOidTR0qApuLRYiq0enU+g70UaimWSqAif1UhF1PjibyBak6BCx/d8o+bh89+MD6y6bocF443WHQWCyR3fRZVoExTRAIlEIntZg5QJKIQ69aSiYye+hAU4/KNW0a2ElQb3i5CRVeVB4uXWfFmPJPcdqYEmHZCDYXvclCIJ7TueM7IQkaf/F7+tFP/ZnT0Sp3eAN1QkSyqg9WZEpOtKpGADREZVehowggYoJWd4mpMiauoofALFNI/w35s3caxkXdhDA31oce0DaNX2t2fWKQES5TGFP6MEKGDPYYv/+gUVUz/Us7A1ceM3Pu4uNTjoBR+RN0eicg00r+uj44qZe0k77fCKSzgKdz0CWz7blRXuxGybegSf0uF2Ksbx25/l8tkEN/6jtv0XmEURssCxfP+PwnqBuzVZIEBAAAAAElFTkSuQmCC"
		})], -1)], 64));
	}
}), Pn = {
	"clip-rule": "evenodd",
	d: "M3.5 1C3.36739 1 3.24021 1.05268 3.14645 1.14645L0.146447 4.14645C0.0526784 4.24021 0 4.36739 0 4.5V12.5C0 13.3284 0.671573 14 1.5 14H14.5C15.3284 14 16 13.3284 16 12.5V2.5C16 1.67157 15.3284 1 14.5 1H3.5ZM4 2H14.5C14.7761 2 15 2.22386 15 2.5V12.5C15 12.7761 14.7761 13 14.5 13H1.5C1.22386 13 1 12.7761 1 12.5V5H3.5C3.77614 5 4 4.77614 4 4.5V2ZM3 4H1.70711L3 2.70711V4ZM4.5 5C4.22386 5 4 5.22386 4 5.5V8V10.5C4 10.7761 4.22386 11 4.5 11H8.5H12.5C12.7761 11 13 10.7761 13 10.5V8V5.5C13 5.22386 12.7761 5 12.5 5H8.5H4.5ZM5 7.5V6H8V7.5H5ZM9 7.5V6H12V7.5H9ZM9 8.5H12V10H9V8.5ZM8 8.5V10H5V8.5H8Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
}, Fn = /* @__PURE__ */ f({
	__name: "file-sheet",
	setup(e) {
		return (e, t) => (A(), o("path", Pn));
	}
}), In = {
	d: "M0 12a1 1 0 0 1 1-1h55a2 2 0 0 1 2 2v15h11.757a5 5 0 0 1 4.266 2.393l9.243 15.125A5 5 0 0 1 84 48.126V56h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-4a.97.97 0 0 1-.062-.002 8.001 8.001 0 0 1-15.876 0A.97.97 0 0 1 65 70H27a.97.97 0 0 1-.062-.002 8.001 8.001 0 0 1-15.876 0A.97.97 0 0 1 11 70H3a2 2 0 0 1-2-2V58a2 2 0 0 1 2-2V42a1 1 0 1 1 2 0v14h51V13H1a1 1 0 0 1-1-1Zm65.062 56.002a8.001 8.001 0 0 1 15.876 0A.97.97 0 0 1 81 68h4V58H3v10h8c.02 0 .041 0 .062.002a8.001 8.001 0 0 1 15.876 0l.017-.001A.767.767 0 0 1 27 68h38c.02 0 .041 0 .062.002ZM82 48.126a3 3 0 0 0-.44-1.565l-9.243-15.125A3 3 0 0 0 69.757 30H58v26h24v-7.874ZM0 17a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm13-1a1 1 0 1 0 0 2h30a1 1 0 1 0 0-2H13ZM0 22a1 1 0 0 1 1-1h34a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h26a1 1 0 1 0 0-2H1Zm-1 6a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H1Zm62-3a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-2.629a2 2 0 0 0-.33-1.1l-4.192-6.37a2 2 0 0 0-1.67-.901H63Zm0 2h4.807L72 41.371V44h-9v-9ZM19 63a6 6 0 1 0 0 12 6 6 0 0 0 0-12Zm0 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm56-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-8 0a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z",
	fill: "currentColor"
}, Ln = /* @__PURE__ */ f({
	__name: "distributed-88",
	setup(e) {
		return (e, t) => (A(), o("path", In));
	}
}), Rn = {
	d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14Zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM7.071 3.997a.931.931 0 1 1 1.858 0l-.393 5.504a.537.537 0 0 1-1.072 0l-.393-5.504ZM8 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
	fill: "currentColor"
}, zn = /* @__PURE__ */ f({
	__name: "error",
	setup(e) {
		return (e, t) => (A(), o("path", Rn));
	}
}), Bn = {
	d: "M47.28 11.42H2.72c-.4 0-.72-.35-.72-.78s.32-.78.72-.78h44.57c.4 0 .72.35.72.78s-.33.78-.73.78zM48 25c0-.43-.32-.78-.72-.78H2.72c-.4 0-.72.35-.72.78s.32.78.72.78h44.57c.39 0 .71-.35.71-.78zm0 14.36c0-.43-.32-.78-.72-.78H2.72c-.4 0-.72.35-.72.78s.32.78.72.78h44.57c.39-.01.71-.35.71-.78z",
	fill: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	"stroke-miterlimit": "10",
	"stroke-width": ".25"
}, Vn = /* @__PURE__ */ f({
	__name: "bars",
	setup(e) {
		return (e, t) => (A(), o("path", Bn));
	}
}), Hn = /* @__PURE__ */ f({
	__name: "packing-slip",
	setup(t) {
		return (t, n) => (A(), o(e, null, [n[0] ||= s("g", {
			"clip-path": "url(#clip0_27568_7480)",
			fill: "none"
		}, [
			s("path", {
				"clip-rule": "evenodd",
				d: "M0.686646 8.22045L3.22888 6.57983L3.77112 7.42006L1.48563 8.89499L8 12.3693L14.5144 8.89499L12.2289 7.42006L12.7711 6.57983L15.3134 8.22045C15.7414 8.4967 16 8.97133 16 9.48079V16.4999H15V14.809L12.3242 16.1468C11.7793 16.4193 11.1238 16.3351 10.6654 15.9338L8.5 14.0382V17.436H7.5V14.0382L5.33461 15.9338C4.87622 16.3351 4.22066 16.4193 3.67577 16.1468L1 14.809V16.4999H0V9.48079C0 8.97133 0.258586 8.4967 0.686646 8.22045ZM1 13.6909V9.76932L7.12604 13.0365L4.67593 15.1814C4.52313 15.3152 4.30461 15.3432 4.12298 15.2524L1 13.6909ZM8.87396 13.0365L15 9.76932V13.6909L11.877 15.2524C11.6954 15.3432 11.4769 15.3152 11.3241 15.1814L8.87396 13.0365Z",
				fill: "#0F5C47",
				"fill-rule": "evenodd"
			}),
			s("path", {
				d: "M5.5 2L3.5 4H5.5V2Z",
				fill: "#0F5C47"
			}),
			s("path", {
				d: "M5.5 2H12.5V10.5M5.5 2L3.5 4M5.5 2V4H3.5M3.5 10.5V4",
				stroke: "#0F5C47",
				"stroke-linejoin": "round"
			}),
			s("path", {
				d: "M5.5 8L7.5 9.5L10.5 5",
				stroke: "#0F5C47",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			})
		], -1), n[1] ||= s("defs", null, [s("clipPath", { id: "clip0_27568_7480" }, [s("rect", {
			fill: "white",
			height: "16",
			transform: "translate(0 0.5)",
			width: "16"
		})])], -1)], 64));
	}
}), Un = {
	"clip-rule": "evenodd",
	d: "M1 6.50003C1 4.37953 3.14017 2.49927 6 2.49927C8.26307 2.49927 10.107 3.68203 10.7516 5.50497C8.21628 5.60656 6 7.25425 6 9.5C6 9.73784 6.02486 9.96898 6.07232 10.1923C6.02717 10.2184 5.96296 10.2512 5.87692 10.2856C5.62991 10.3844 5.19386 10.4996 4.50024 10.4993C4.3546 10.4992 4.22347 10.5614 4.13203 10.6607C3.7137 11.072 3.06756 11.4064 2.47538 11.6462C2.58324 11.4054 2.69209 11.1451 2.78214 10.8939C2.88205 10.6152 2.97066 10.3157 2.99692 10.0558C3.01856 9.86477 2.92835 9.67006 2.75151 9.56713C2.11598 9.19724 1.68593 8.76191 1.4113 8.26855C1.13598 7.77393 1 7.19057 1 6.50003ZM6 1.49927C8.74769 1.49927 11.1402 3.0409 11.8134 5.55363C14.1041 5.85745 16 7.42292 16 9.5C16 10.9886 14.8697 12.1318 13.5547 12.7932C13.5561 12.7981 13.5575 12.803 13.5589 12.808C13.5994 12.9499 13.6554 13.1047 13.7142 13.2518C13.7727 13.3979 13.8315 13.5303 13.8759 13.6264C13.8979 13.6743 13.9162 13.7127 13.9288 13.7387L13.9431 13.768L13.9465 13.7749L13.9472 13.7764L13.9472 13.7764L13.9473 13.7765L13.9473 13.7765L13.9473 13.7765L13.9473 13.7765C14.0247 13.9315 14.0164 14.1155 13.9253 14.2629C13.8342 14.4103 13.6733 14.5 13.5 14.5V14C13.5 14.5 13.4999 14.5 13.4997 14.5H13.4994L13.4987 14.5L13.4966 14.5L13.4902 14.5L13.4692 14.4997C13.4515 14.4994 13.4267 14.4988 13.3956 14.4977C13.3334 14.4956 13.2458 14.4913 13.1398 14.4828C12.929 14.4659 12.6393 14.432 12.329 14.3631C12.0214 14.2947 11.6755 14.188 11.3621 14.0171C11.1322 13.8916 10.9031 13.7223 10.7242 13.4939C8.86844 13.4113 7.18767 12.5007 6.4278 11.1349C6.37357 11.1613 6.31376 11.1879 6.24808 11.2142C5.90247 11.3523 5.40141 11.4765 4.70173 11.4965C4.14014 11.9953 3.3974 12.3546 2.8107 12.5892C2.48272 12.7204 2.18814 12.8186 1.97517 12.8841C1.86847 12.917 1.78172 12.9418 1.72086 12.9586C1.69041 12.967 1.6664 12.9734 1.64956 12.9778L1.62977 12.9829L1.62407 12.9844L1.6223 12.9848L1.62169 12.985L1.62146 12.985C1.62136 12.985 1.62127 12.9851 1.5 12.5L1.62127 12.9851C1.429 13.0331 1.22649 12.9631 1.10498 12.8065C0.983482 12.65 0.965928 12.4364 1.06023 12.2621L1.06025 12.2621L1.0606 12.2614L1.06227 12.2583L1.06938 12.245L1.09744 12.1921C1.1219 12.1457 1.15719 12.078 1.1999 11.9941C1.28548 11.826 1.40005 11.5943 1.51657 11.3395C1.63352 11.0837 1.74993 10.8099 1.84079 10.5565C1.88255 10.44 1.91657 10.334 1.94262 10.2405C1.32892 9.82965 0.860796 9.33563 0.537546 8.75491C0.163251 8.08249 0 7.3241 0 6.50003C0 3.64912 2.7847 1.49927 6 1.49927ZM11.0612 12.5037C11.0375 12.5008 11.0136 12.4995 10.9896 12.5C8.66171 12.4957 7 11.0449 7 9.5C7 7.95281 8.66664 6.5 11 6.5C13.3334 6.5 15 7.95281 15 9.5C15 10.5193 14.1287 11.47 12.8134 12.036C12.7872 12.0465 12.762 12.0593 12.7382 12.074C12.6745 12.113 12.622 12.1649 12.5826 12.2246C12.5264 12.31 12.497 12.4115 12.5001 12.515C12.5024 12.7055 12.5476 12.9087 12.5974 13.0827C12.6297 13.1959 12.668 13.3102 12.7078 13.4196C12.6547 13.4099 12.6006 13.399 12.546 13.3869C12.2911 13.3303 12.0433 13.2495 11.841 13.1392C11.6417 13.0305 11.5162 12.9096 11.4508 12.7834C11.4407 12.7625 11.4293 12.7425 11.4165 12.7233C11.3376 12.6048 11.2094 12.5218 11.0612 12.5037Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
}, Wn = /* @__PURE__ */ f({
	__name: "DoubleChatBubble",
	setup(e) {
		return (e, t) => (A(), o("path", Un));
	}
}), Gn = {
	d: "M0 2.5C0 2.22386 0.223858 2 0.5 2H3.5C3.77614 2 4 2.22386 4 2.5V3H20.5C20.6412 3 20.7759 3.05976 20.8707 3.1645C20.9655 3.26924 21.0115 3.40919 20.9975 3.54975L19.9975 13.5498C19.9719 13.8054 19.7568 14 19.5 14H5.21486L5.44563 16H18.5C18.7761 16 19 16.2239 19 16.5C19 16.7761 18.7761 17 18.5 17H5C4.74603 17 4.53241 16.8096 4.5033 16.5573L3.00415 3.56472C3.00141 3.54353 3 3.52193 3 3.5V3H0.5C0.223858 3 0 2.77614 0 2.5ZM5.09947 13H19.0475L19.9475 4H4.06101L5.09947 13ZM16 19C15.4477 19 15 19.4477 15 20C15 20.5523 15.4477 21 16 21C16.5523 21 17 20.5523 17 20C17 19.4477 16.5523 19 16 19ZM14 20C14 18.8954 14.8954 18 16 18C17.1046 18 18 18.8954 18 20C18 21.1046 17.1046 22 16 22C14.8954 22 14 21.1046 14 20ZM6 20C6 19.4477 6.44772 19 7 19C7.55228 19 8 19.4477 8 20C8 20.5523 7.55228 21 7 21C6.44772 21 6 20.5523 6 20ZM7 18C5.89543 18 5 18.8954 5 20C5 21.1046 5.89543 22 7 22C8.10457 22 9 21.1046 9 20C9 18.8954 8.10457 18 7 18ZM14.9 6.8C15.0657 6.57909 15.0209 6.26569 14.8 6.1C14.5791 5.93431 14.2657 5.97909 14.1 6.2L11.4459 9.7388L9.85355 8.14645C9.65829 7.95118 9.34171 7.95118 9.14645 8.14645C8.95118 8.34171 8.95118 8.65829 9.14645 8.85355L11.1464 10.8536C11.2489 10.956 11.3909 11.009 11.5354 10.9987C11.68 10.9885 11.813 10.916 11.9 10.8L14.9 6.8Z",
	fill: "currentColor"
}, Kn = /* @__PURE__ */ f({
	__name: "shopping-cart",
	setup(e) {
		return (e, t) => (A(), o("path", Gn));
	}
}), qn = { fill: "none" }, Jn = /* @__PURE__ */ f({
	__name: "chrome",
	setup(e) {
		return (e, t) => (A(), o("g", qn, [...t[0] ||= [
			s("circle", {
				cx: "24",
				cy: "24",
				r: "21",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "1.5"
			}, null, -1),
			s("circle", {
				cx: "24",
				cy: "24",
				r: "7",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "1.5"
			}, null, -1),
			s("path", {
				d: "M30.0625 27.5L20.3125 44.3875",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "1.5"
			}, null, -1),
			s("path", {
				d: "M17.9375 27.5L8.18762 10.6127",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "1.5"
			}, null, -1),
			s("path", {
				d: "M24 17L43 17",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "1.5"
			}, null, -1)
		]]));
	}
}), Yn = { fill: "currentColor" }, Xn = /* @__PURE__ */ f({
	__name: "paper-plane",
	setup(e) {
		return (e, t) => (A(), o("g", Yn, [...t[0] ||= [s("path", { d: "M48.54 3.95c-.42-.41-1.04-.54-1.59-.35L3.58 19.04c-.81.31-1.39 1.04-1.49 1.9-.1.86.3 1.72 1.01 2.2l10.43 6.64 3.58 13.11c.21.67.83 1.1 1.52 1.09.53 0 1.01-.28 1.28-.73.04-.01.06-.02.1-.05l5.2-6.94 9.02 5.69c.37.23.8.36 1.23.36.26 0 .53-.05.77-.14.68-.25 1.2-.79 1.41-1.48L48.91 5.53c.21-.55.06-1.17-.37-1.58zM3.97 21.83a.735.735 0 0 1-.39-.73c.04-.3.23-.54.51-.64l40.5-14.37-30.6 22.13-10.02-6.39zm14.65 20.58L15.05 29.3 42.2 9.71 21.14 32.64c-.05.05-.07.11-.1.17-.02.04-.04.07-.05.11l-2.37 9.49zm2.32-3.09 1.25-4.99 1.72 1.14-2.97 3.85zm15.27.94a.778.778 0 0 1-1.15.42L22.9 33.01 46.87 6.94 36.21 40.26zm-24.32-3.61L.32 45.08a.781.781 0 0 0 .92 1.26l11.58-8.44c.35-.25.42-.73.17-1.09a.774.774 0 0 0-1.1-.16zm-9.56 2.92c.16 0 .32-.05.46-.15l3.86-2.81a.77.77 0 0 0 .17-1.09.764.764 0 0 0-1.09-.17l-3.85 2.81c-.27.2-.38.54-.28.86.1.33.41.55.73.55zm7.1-5 1.93-1.42c.35-.25.42-.73.17-1.09a.782.782 0 0 0-1.09-.17L8.51 33.3c-.35.25-.42.73-.17 1.09.26.35.74.42 1.09.17v.01z" }, null, -1), s("path", { d: "M.77 46.61c-.28 0-.56-.13-.73-.37-.29-.41-.2-.96.2-1.26l11.58-8.43c.2-.15.44-.21.67-.17.24.04.45.16.59.36.29.42.2.97-.2 1.26L1.3 46.44c-.16.11-.34.17-.53.17zm11.59-10c-.14 0-.28.05-.39.13L.39 45.18c-.29.22-.35.62-.14.91.2.29.62.35.91.14l11.58-8.44a.652.652 0 0 0-.28-1.17c-.04-.01-.07-.01-.1-.01zm-.47.04zm6.7 7.44c-.74 0-1.38-.47-1.61-1.17l-3.57-13.06-10.38-6.62a2.502 2.502 0 0 1-1.07-2.32c.1-.91.71-1.68 1.57-2L46.9 3.49c.6-.21 1.27-.07 1.72.37.47.44.63 1.11.4 1.71L37.75 40.72c-.22.73-.76 1.3-1.48 1.56a2.404 2.404 0 0 1-2.11-.24l-8.92-5.63-5.13 6.84-.03.03c-.03.02-.06.03-.08.05-.3.47-.81.75-1.37.75-.02.01-.03.01-.04.01zM47.46 3.65c-.16 0-.32.03-.47.08L3.62 19.15c-.78.29-1.32.98-1.41 1.8-.09.81.28 1.63.96 2.08l10.43 6.64c.03.02.04.04.05.07l3.58 13.11c.19.6.74.99 1.37.99h.03c.48 0 .92-.25 1.18-.67.01-.02.04-.04.07-.05.02-.01.04-.01.05-.02l5.18-6.92c.04-.05.11-.06.17-.03l9.02 5.69c.35.22.75.34 1.17.34a2.156 2.156 0 0 0 2.05-1.53L48.79 5.5c.19-.51.06-1.08-.34-1.45-.27-.26-.63-.4-.99-.4zM18.62 42.54c-.06 0-.11-.04-.12-.09l-3.57-13.11a.13.13 0 0 1 .05-.13L42.13 9.6c.05-.04.12-.03.17.02.04.05.04.12 0 .17L21.23 32.72a.4.4 0 0 0-.07.13c-.03.05-.04.07-.05.1l-2.37 9.48c-.01.07-.06.1-.12.11zM15.2 29.35l3.42 12.56 2.25-9.03c.02-.05.03-.1.07-.15.01-.04.05-.12.11-.19l20.23-22.02L15.2 29.35zm20.28 11.58c-.17 0-.34-.05-.49-.14l-12.16-7.68a.146.146 0 0 1-.06-.09c0-.04.01-.07.03-.1L46.78 6.86c.04-.04.1-.05.15-.02.05.03.07.09.06.15L36.33 40.3a.95.95 0 0 1-.54.57c-.1.04-.21.06-.31.06zM23.1 32.98l12.03 7.6c.17.11.39.13.57.06a.72.72 0 0 0 .4-.42L46.58 7.44 23.1 32.98zm13.11 7.28zM2.33 39.7c-.38 0-.74-.27-.85-.63-.12-.37.02-.77.33-1l3.85-2.81c.42-.3.96-.22 1.26.2.14.2.2.44.16.68-.04.24-.17.44-.36.58l-3.86 2.81c-.15.11-.34.17-.53.17zm3.87-4.38c-.13 0-.27.04-.39.13l-3.85 2.81a.66.66 0 0 0-.24.73c.08.26.34.45.61.45.14 0 .27-.04.38-.12l3.86-2.81c.14-.1.24-.25.26-.42a.62.62 0 0 0-.12-.49.611.611 0 0 0-.51-.28zm14.74 4.13c-.02 0-.04 0-.05-.01-.05-.03-.08-.08-.07-.14l1.25-4.99c.01-.04.04-.07.08-.09.04-.01.08-.01.11.01l1.72 1.14c.03.02.05.05.05.08s0 .07-.02.1l-2.96 3.85a.16.16 0 0 1-.11.05zm1.32-4.91-1.06 4.23 2.51-3.27-1.45-.96zm-13.29.29a.91.91 0 0 1-.73-.37c-.29-.42-.2-.98.2-1.26l1.92-1.41c.41-.29.96-.2 1.26.2.29.42.2.98-.2 1.26L9.5 34.67c-.02.01-.03.02-.05.02-.15.1-.32.14-.48.14zm1.92-2.96c-.13 0-.27.04-.38.12L8.59 33.4a.652.652 0 0 0 .77 1.05c.01-.01.03-.02.04-.02l1.88-1.39c.29-.21.35-.61.14-.91a.698.698 0 0 0-.53-.26zm3.1-3.53c-.02 0-.05-.01-.07-.02L3.91 21.93a.87.87 0 0 1-.46-.85c.04-.35.27-.63.59-.75l40.5-14.37c.06-.02.12.01.15.06.03.06.01.12-.04.16L14.07 28.32c-.03.01-.05.02-.08.02zM43.81 6.5 4.12 20.57c-.23.08-.39.29-.42.54-.02.25.11.49.33.6 0 0 .01 0 .01.01l9.95 6.35L43.81 6.5z" }, null, -1)]]));
	}
}), Zn = {
	"clip-rule": "evenodd",
	d: "M19.2071 3.75714C20.1834 2.78082 21.7663 2.78082 22.7426 3.75714C23.7189 4.73345 23.7189 6.31636 22.7426 7.29267L18.1464 11.8889C18.0661 11.9691 17.9609 12.0197 17.8481 12.0323L14.6661 12.3858C14.5151 12.4026 14.3647 12.3498 14.2573 12.2424C14.1499 12.135 14.0972 11.9846 14.114 11.8336L14.4675 8.65167C14.48 8.53883 14.5306 8.43361 14.6109 8.35333L19.2071 3.75714ZM22.0355 4.46424C21.4497 3.87846 20.5 3.87846 19.9142 4.46424L15.442 8.93642L15.1769 11.3229L17.5633 11.0577L22.0355 6.58556C22.6213 5.99978 22.6213 5.05003 22.0355 4.46424ZM6 10.5002C6 10.224 6.22386 10.0002 6.5 10.0002H12.5C12.7761 10.0002 13 10.224 13 10.5002C13 10.7763 12.7761 11.0002 12.5 11.0002H6.5C6.22386 11.0002 6 10.7763 6 10.5002ZM6.5 12.0002C6.22386 12.0002 6 12.224 6 12.5002C6 12.7763 6.22386 13.0002 6.5 13.0002H10.5C10.7761 13.0002 11 12.7763 11 12.5002C11 12.224 10.7761 12.0002 10.5 12.0002H6.5ZM6 14.5002C6 14.224 6.22386 14.0002 6.5 14.0002H14.5C14.7761 14.0002 15 14.224 15 14.5002C15 14.7763 14.7761 15.0002 14.5 15.0002H6.5C6.22386 15.0002 6 14.7763 6 14.5002ZM12 5C6.91282 5 3 8.23771 3 12C3 14.1975 4.31462 16.2001 6.44322 17.5031C6.47383 17.4997 6.5052 17.499 6.53705 17.5014C6.81243 17.5219 7.01906 17.7617 6.99856 18.0371L6.99683 18.0594C7.00527 18.133 6.99746 18.209 6.97182 18.2817C6.85809 19.0826 6.4887 19.9902 6.15986 20.6863C6.08886 20.8366 6.01845 20.9797 5.95098 21.1129C6.21121 21.0482 6.50173 20.9664 6.79969 20.8649C7.29127 20.6973 7.7866 20.4815 8.19648 20.2113C8.60951 19.9389 8.8997 19.6351 9.03955 19.305C9.07867 19.2126 9.14229 19.1381 9.21965 19.0859C9.30823 18.8687 9.54086 18.7375 9.77957 18.7848C10.4892 18.9252 11.2331 19 12 19C17.0872 19 21 15.7623 21 12C21 11.689 20.9739 11.3831 20.9233 11.0832C20.8773 10.8109 21.0608 10.5529 21.3331 10.507C21.6054 10.461 21.8634 10.6445 21.9093 10.9168C21.9691 11.2712 22 11.6328 22 12C22 16.522 17.4062 20 12 20C11.2806 20 10.5783 19.9393 9.90108 19.8239C9.64449 20.3403 9.21199 20.7395 8.74699 21.0461C8.24088 21.3798 7.65937 21.6283 7.12228 21.8114C6.58265 21.9953 6.07112 22.1187 5.69574 22.1962C5.5075 22.235 5.35213 22.2626 5.24288 22.2805C5.18822 22.2895 5.14502 22.2961 5.11492 22.3006L5.07976 22.3056L5.06992 22.307L5.067 22.3074L5.06605 22.3075L5.0657 22.3076C5.06557 22.3076 5.06544 22.3076 4.99994 21.8119L5.06544 22.3076C4.87495 22.3328 4.68689 22.2465 4.58163 22.0858C4.4764 21.9251 4.47256 21.7183 4.57175 21.5537L4.57179 21.5537L4.57228 21.5528L4.57473 21.5488L4.58526 21.531C4.59471 21.5151 4.60889 21.491 4.62717 21.4594C4.66372 21.3963 4.71657 21.3037 4.78057 21.1876C4.90877 20.9549 5.0807 20.6296 5.25567 20.2592C5.54486 19.647 5.82026 18.9568 5.94199 18.3687C3.57838 16.9285 2 14.6336 2 12C2 7.47802 6.59377 4 12 4C12.714 4 13.411 4.05975 14.0834 4.1735C14.4384 4.23356 14.7867 4.30868 15.127 4.39803C15.3941 4.46815 15.5537 4.74152 15.4836 5.00861C15.4135 5.2757 15.1401 5.43537 14.873 5.36525C14.5616 5.28349 14.2425 5.21462 13.9166 5.15949C13.2994 5.05508 12.6582 5 12 5Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
}, Qn = /* @__PURE__ */ f({
	__name: "feedback",
	setup(e) {
		return (e, t) => (A(), o("path", Zn));
	}
}), $n = {
	d: "M4.146 2.146A.5.5 0 0 1 4.5 2h9A1.5 1.5 0 0 1 15 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12.5v-7a.5.5 0 0 1 .146-.354l3-3ZM13.5 3H5v2.5a.5.5 0 0 1-.5.5H2v6.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5ZM2.707 5H4V3.707L2.707 5ZM3.5 7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5Zm2.5.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0v-4ZM7.5 7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5Zm3.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4Zm-1 0a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0v-4Z",
	fill: "currentColor"
}, er = /* @__PURE__ */ f({
	__name: "barcode",
	setup(e) {
		return (e, t) => (A(), o("path", $n));
	}
}), tr = {
	d: "M4.5 0a.5.5 0 0 0-.354.146l-3 3A.5.5 0 0 0 1 3.5v8A1.5 1.5 0 0 0 2.5 13H5v1.5A1.5 1.5 0 0 0 6.5 16h7a1.5 1.5 0 0 0 1.5-1.5v-10A1.5 1.5 0 0 0 13.5 3H11V1.5A1.5 1.5 0 0 0 9.5 0h-5ZM10 3H8.5a.5.5 0 0 0-.354.146l-3 3A.5.5 0 0 0 5 6.5V12H2.5a.5.5 0 0 1-.5-.5V4h2.5a.5.5 0 0 0 .5-.5V1h4.5a.5.5 0 0 1 .5.5V3Zm-4 9.5V7h2.5a.5.5 0 0 0 .5-.5V4h4.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-2ZM4 3H2.707L4 1.707V3Zm4 3H6.707L8 4.707V6Z",
	fill: "currentColor"
}, nr = /* @__PURE__ */ f({
	__name: "copy",
	setup(e) {
		return (e, t) => (A(), o("path", tr));
	}
}), rr = {
	"clip-rule": "evenodd",
	d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
	fill: "currentColor",
	"fill-rule": "evenodd"
}, ir = /* @__PURE__ */ f({
	__name: "close",
	setup(e) {
		return (e, t) => (A(), o("path", rr));
	}
}), ar = { transform: "matrix(0.81815, 0, 0, 0.81815, -1.091412, -1.6363)" }, or = /* @__PURE__ */ f({
	__name: "support-24",
	setup(e) {
		return (e, t) => (A(), o("g", ar, [...t[0] ||= [s("path", {
			d: "M5.333 14c-1.473 0-2.667 1.194-2.667 2.667v1.333c0 1.473 1.194 2.667 2.667 2.667h0.667c0.368 0 0.667-0.299 0.667-0.667v-5.333c0-0.368-0.298-0.667-0.667-0.667h-0.667zM5.35 12.667c0.3-5.898 4.563-10.667 10.65-10.667s10.35 4.769 10.65 10.667h0.017c2.209 0 4 1.791 4 4v1.333c0 2.209-1.791 4-4 4 0 3.314-2.686 6-6 6h-1.4c-0.309 1.521-1.654 2.667-3.267 2.667-1.841 0-3.333-1.492-3.333-3.333s1.492-3.333 3.333-3.333c1.613 0 2.958 1.145 3.267 2.667h1.4c2.577 0 4.667-2.089 4.667-4.667v-0.114c-0.777-0.275-1.333-1.015-1.333-1.886v-5.333c0-0.866 0.551-1.604 1.321-1.882-0.244-5.319-4.034-9.452-9.321-9.452s-9.077 4.132-9.321 9.452c0.77 0.278 1.321 1.016 1.321 1.882v5.333c0 1.105-0.895 2-2 2h-0.667c-2.209 0-4-1.791-4-4v-1.333c0-2.209 1.791-4 4-4h0.017zM18 27.333c0-1.105-0.895-2-2-2s-2 0.895-2 2c0 1.105 0.895 2 2 2s2-0.895 2-2zM26.667 20.667c1.473 0 2.667-1.194 2.667-2.667v-1.333c0-1.473-1.194-2.667-2.667-2.667h-0.667c-0.368 0-0.667 0.299-0.667 0.667v5.333c0 0.368 0.299 0.667 0.667 0.667h0.667z",
			fill: "currentColor"
		}, null, -1)]]));
	}
}), sr = {
	d: "M2.5 5A1.5 1.5 0 0 0 1 6.5V19a1.5 1.5 0 0 0 1.5 1.5h19A1.5 1.5 0 0 0 23 19V6.5A1.5 1.5 0 0 0 21.5 5h-19ZM2 6.625l9.1 6.825a1.5 1.5 0 0 0 1.8 0L22 6.625V18.76l-5.131-5.598a.5.5 0 0 0-.738.676l5.19 5.662H2.679l5.19-5.662a.5.5 0 0 0-.737-.676L2 18.76V6.625ZM21.167 6 12.3 12.65a.5.5 0 0 1-.6 0L2.833 6h18.334Z",
	fill: "currentColor"
}, cr = /* @__PURE__ */ f({
	__name: "envelope-24",
	setup(e) {
		return (e, t) => (A(), o("path", sr));
	}
}), lr = /* @__PURE__ */ f({
	__name: "refresh",
	setup(t) {
		return (t, n) => (A(), o(e, null, [n[0] ||= s("mask", {
			id: "mask0_36639_33301",
			height: "24",
			maskUnits: "userSpaceOnUse",
			style: { "mask-type": "alpha" },
			width: "24",
			x: "0",
			y: "0"
		}, [s("rect", {
			fill: "#D9D9D9",
			height: "24",
			width: "24"
		})], -1), n[1] ||= s("g", { mask: "url(#mask0_36639_33301)" }, [s("path", {
			d: "M12.0499 19.5C9.95755 19.5 8.17614 18.7698 6.70564 17.3095C5.23514 15.8493 4.49989 14.0795 4.49989 12V10.6135L2.39989 12.7135L1.69214 12.0058L4.99989 8.698L8.30764 12.0058L7.59989 12.7135L5.49989 10.6135V12C5.49989 13.8077 6.13547 15.3429 7.40664 16.6058C8.67781 17.8686 10.2256 18.5 12.0499 18.5C12.4447 18.5 12.8473 18.4596 13.2576 18.3788C13.6678 18.2981 14.0665 18.177 14.4536 18.0155L15.2036 18.7655C14.7115 19.0038 14.1993 19.1858 13.6671 19.3115C13.1351 19.4372 12.5961 19.5 12.0499 19.5ZM18.9999 15.302L15.6921 11.9942L16.3999 11.2865L18.4999 13.3865V12C18.4999 10.1923 17.8643 8.65708 16.5931 7.39425C15.322 6.13142 13.7742 5.5 11.9499 5.5C11.5551 5.5 11.1525 5.54042 10.7421 5.62125C10.332 5.70192 9.93331 5.823 9.54614 5.9845L8.79614 5.2345C9.28831 4.99617 9.80047 4.81417 10.3326 4.6885C10.8646 4.56283 11.4037 4.5 11.9499 4.5C14.0422 4.5 15.8236 5.23017 17.2941 6.6905C18.7646 8.15067 19.4999 9.9205 19.4999 12V13.3865L21.5999 11.2865L22.3076 11.9942L18.9999 15.302Z",
			fill: "#1C1B1F"
		})], -1)], 64));
	}
}), ur = /* @__PURE__ */ f({
	__name: "carrier-truck-48",
	setup(t) {
		return (t, n) => (A(), o(e, null, [
			n[0] ||= s("circle", {
				cx: "10",
				cy: "35",
				fill: "none",
				r: "4",
				stroke: "currentColor",
				"stroke-width": "1.5"
			}, null, -1),
			n[1] ||= s("circle", {
				cx: "37",
				cy: "35",
				fill: "none",
				r: "4",
				stroke: "currentColor",
				"stroke-width": "1.5"
			}, null, -1),
			n[2] ||= s("path", {
				d: "M6 35H3C1.89543 35 1 34.1046 1 33V11C1 9.89543 1.89543 9 3 9H28C29.1046 9 30 9.89543 30 11V35H14",
				fill: "none",
				stroke: "currentColor",
				"stroke-width": "1.5"
			}, null, -1),
			n[3] ||= s("path", {
				d: "M33 35H30V15C30 13.8954 30.8954 13 32 13H36.7639C37.5215 13 38.214 13.428 38.5528 14.1056L44 25L45.6325 25.5442C46.4491 25.8164 47 26.5807 47 27.4415V33C47 34.1046 46.1046 35 45 35H41",
				fill: "none",
				stroke: "currentColor",
				"stroke-width": "1.5"
			}, null, -1),
			n[4] ||= s("path", {
				d: "M40 18H35C34.4477 18 34 18.4477 34 19V24C34 24.5523 34.4477 25 35 25H44",
				fill: "none",
				stroke: "currentColor",
				"stroke-width": "1.5"
			}, null, -1),
			n[5] ||= s("path", {
				d: "M9.58094 26.2681L15.0809 28.8066C15.3468 28.9293 15.6532 28.9293 15.9191 28.8066L21.4191 26.2681C21.7732 26.1047 22 25.7502 22 25.3602V17.6398C22 17.2498 21.7732 16.8953 21.4191 16.7319L15.9191 14.1934C15.6532 14.0707 15.3468 14.0707 15.0809 14.1934L9.58094 16.7319C9.22679 16.8953 9 17.2498 9 17.6398V25.3602C9 25.7502 9.22679 26.1047 9.58094 26.2681Z",
				fill: "none",
				stroke: "currentColor",
				"stroke-width": "1.5"
			}, null, -1),
			n[6] ||= s("path", {
				d: "M9 17L15.0809 19.8066C15.3468 19.9293 15.6532 19.9293 15.9191 19.8066L22 17",
				fill: "none",
				stroke: "currentColor",
				"stroke-width": "1.5"
			}, null, -1),
			n[7] ||= s("path", {
				d: "M15.5 20V29",
				fill: "none",
				stroke: "currentColor",
				"stroke-width": "1.5"
			}, null, -1),
			n[8] ||= s("path", {
				d: "M12.5 15.5L18.4191 18.2319C18.7732 18.3953 19 18.7498 19 19.1398V21",
				fill: "none",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-width": "1.5"
			}, null, -1)
		], 64));
	}
}), dr = {
	d: "M14.217 1.282a3 3 0 0 0-4.242 0l-.06.06a1.5 1.5 0 0 0-1.708.294l-.707.707a1.5 1.5 0 0 0-.293 1.708L1.843 9.414a.5.5 0 0 0-.133.241L.649 14.252a.5.5 0 0 0 .6.6l4.596-1.062a.5.5 0 0 0 .24-.133l5.365-5.364A1.5 1.5 0 0 0 13.157 8l.707-.707a1.5 1.5 0 0 0 .293-1.708l.06-.06a3 3 0 0 0 0-4.243Zm-.707 3.536L10.682 1.99a2 2 0 0 1 2.828 2.828Zm-2.828 2.828-4.95 4.95-2.828-2.828 4.95-4.95 2.828 2.828Zm-8.879 6.05.678-2.937 2.26 2.26-2.938.678ZM8.914 2.344a.5.5 0 0 1 .707 0l3.536 3.536a.5.5 0 0 1 0 .707l-.707.707a.5.5 0 0 1-.707 0L8.207 3.757a.5.5 0 0 1 0-.707l.707-.707Z",
	fill: "currentColor"
}, fr = /* @__PURE__ */ f({
	__name: "edit",
	setup(e) {
		return (e, t) => (A(), o("path", dr));
	}
}), pr = {
	d: "M2.667 4.667c0-1.105 0.895-2 2-2h20c1.105 0 2 0.895 2 2v1.333c0 0.871-0.557 1.612-1.333 1.886v7.447c0 0.368-0.299 0.667-0.667 0.667s-0.667-0.299-0.667-0.667v-7.333h-18.667v12.667c0 0.368 0.298 0.667 0.667 0.667h2.667c0.368 0 0.667 0.299 0.667 0.667s-0.298 0.667-0.667 0.667h-2.667c-1.105 0-2-0.895-2-2v-12.78c-0.777-0.275-1.333-1.015-1.333-1.886v-1.333zM4.667 4c-0.368 0-0.667 0.298-0.667 0.667v1.333c0 0.368 0.298 0.667 0.667 0.667h20c0.368 0 0.667-0.298 0.667-0.667v-1.333c0-0.368-0.299-0.667-0.667-0.667h-20zM12.667 12c-0.368 0-0.667 0.298-0.667 0.667s0.298 0.667 0.667 0.667h4c0.368 0 0.667-0.298 0.667-0.667s-0.299-0.667-0.667-0.667h-4zM10.667 12.667c0-1.105 0.895-2 2-2h4c1.105 0 2 0.895 2 2s-0.895 2-2 2h-4c-1.105 0-2-0.895-2-2zM12 19.333c0-1.105 0.895-2 2-2h13.333c1.105 0 2 0.895 2 2v8c0 1.105-0.895 2-2 2h-13.333c-1.105 0-2-0.895-2-2v-8zM14.386 18.667l5.858 4.793c0.246 0.201 0.599 0.201 0.844 0l5.858-4.793h-12.561zM28 19.528l-6.067 4.964c-0.737 0.603-1.796 0.603-2.533 0l-6.067-4.964v7.805c0 0.368 0.299 0.667 0.667 0.667h13.333c0.368 0 0.667-0.299 0.667-0.667v-7.805z",
	fill: "currentColor"
}, mr = /* @__PURE__ */ f({
	__name: "packaging",
	setup(e) {
		return (e, t) => (A(), o("path", pr));
	}
}), hr = /* @__PURE__ */ f({
	__name: "refresh-plus",
	setup(t) {
		return (t, n) => (A(), o(e, null, [
			n[0] ||= s("path", {
				d: "M11.875 9.86356L13.5 8.5L14.8636 10.125",
				fill: "none",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[1] ||= s("path", {
				d: "M4.12503 7.13644L2.5 8.5L1.13644 6.87497",
				fill: "none",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[2] ||= s("path", {
				d: "M2.5 8.5C2.5 5.46243 4.96243 3 8 3C9.93078 3 11.6292 3.9949 12.6105 5.5",
				fill: "none",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[3] ||= s("path", {
				d: "M13.4999 8.5C13.4999 11.5376 11.0375 14 7.99994 14C6.06916 14 4.37075 13.0051 3.3894 11.5",
				fill: "none",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[4] ||= s("path", {
				d: "M5.5 8.5H10.5M8 6V11",
				fill: "none",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1)
		], 64));
	}
}), gr = {
	d: "M16.121 9.293 10.414 15H43.25V9H16.828a1 1 0 0 0-.707.293ZM44.75 15H64a1 1 0 1 1 0 2H9v24h70V17h-7a1 1 0 1 1 0-2h5.586l-5.707-5.707A1 1 0 0 0 71.172 9H44.75v6ZM34 43a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4Zm-2.83 0H9v31a1 1 0 0 0 1 1h68a1 1 0 0 0 1-1V43H40.83c.11.313.17.65.17 1v4a3 3 0 0 1-3 3h-4a3 3 0 0 1-3-3v-4c0-.35.06-.687.17-1ZM4 41h3V16a1 1 0 0 1 .293-.707l7.414-7.414A3 3 0 0 1 16.828 7h54.344a3 3 0 0 1 2.12.879l7.415 7.414A1 1 0 0 1 81 16v25h3a1 1 0 1 1 0 2h-3v31a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3V43H4a1 1 0 1 1 0-2Zm29-13a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v2a3 3 0 0 1-3 3H36a3 3 0 0 1-3-3v-2Zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H36ZM5 71a1 1 0 1 0-2 0v7a3 3 0 0 0 3 3h7a1 1 0 1 0 0-2H6a1 1 0 0 1-1-1v-7Zm78 0a1 1 0 1 1 2 0v7a3 3 0 0 1-3 3h-7a1 1 0 1 1 0-2h7a1 1 0 0 0 1-1v-7ZM31 60a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-4a3 3 0 0 1-3-3v-4Zm3-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4Zm13 1a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v4a3 3 0 0 1-3 3h-4a3 3 0 0 1-3-3v-4Zm3-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-4Zm-5-14a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0v-3Zm5 2a1 1 0 0 0-1 1v4h-5a1 1 0 0 0-1 1v9a1 1 0 1 0 2 0v-8h5a1 1 0 0 0 1-1v-4h4v2a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1h-6Zm-17 6a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z",
	fill: "currentColor"
}, _r = /* @__PURE__ */ f({
	__name: "signin",
	setup(e) {
		return (e, t) => (A(), o("path", gr));
	}
}), vr = /* @__PURE__ */ f({
	__name: "fulfilment-24",
	setup(t) {
		return (t, n) => (A(), o(e, null, [
			n[0] ||= s("path", {
				"clip-rule": "evenodd",
				d: "M12.6286 1.23962C12.2297 1.05554 11.7703 1.05554 11.3714 1.23962L5.87141 3.77808C5.34019 4.02327 5 4.55495 5 5.14002V12.8604C5 13.4454 5.34019 13.9771 5.87141 14.2223L11.3714 16.7608C11.7703 16.9448 12.2297 16.9448 12.6286 16.7608L18.1286 14.2223C18.6598 13.9771 19 13.4454 19 12.8604V5.14002C19 4.55495 18.6598 4.02327 18.1286 3.77808L12.6286 1.23962ZM11.7905 2.14758C11.9234 2.08622 12.0766 2.08622 12.2095 2.14758L17.3069 4.50022L15.3493 5.40371C15.2802 5.35621 15.2064 5.31413 15.1286 5.2782L10.068 2.94256L11.7905 2.14758ZM8.87488 3.49324L6.6931 4.50022L11.7905 6.85285C11.9234 6.91421 12.0766 6.91421 12.2095 6.85285L14.1818 5.94258L8.87488 3.49324ZM15 6.66631L12.6286 7.76081C12.5864 7.7803 12.5434 7.79773 12.5 7.81309V15.7187L17.7095 13.3143C17.8866 13.2326 18 13.0554 18 12.8604V5.2817L15.9432 6.231C15.9804 6.36214 16 6.4996 16 6.64014V8.5003C16 8.77645 15.7761 9.0003 15.5 9.0003C15.2239 9.0003 15 8.77645 15 8.5003V6.66631ZM6 5.2817V12.8604C6 13.0554 6.1134 13.2326 6.29047 13.3143L11.5 15.7187V7.81309C11.4566 7.79773 11.4136 7.7803 11.3714 7.76081L6 5.2817Z",
				fill: "#FF8C00",
				"fill-rule": "evenodd"
			}, null, -1),
			n[1] ||= s("path", {
				d: "M0.5 8C0.223858 8 0 8.22386 0 8.5C0 8.77614 0.223858 9 0.5 9V8ZM4.5 9H5V8H4.5V9ZM0.5 9H4.5V8H0.5V9Z",
				fill: "#FF8C00"
			}, null, -1),
			n[2] ||= s("path", {
				d: "M19.5 8H19V9H19.5V8ZM22.5 9C22.7761 9 23 8.77614 23 8.5C23 8.22386 22.7761 8 22.5 8V9ZM19.5 9H22.5V8H19.5V9Z",
				fill: "#FF8C00"
			}, null, -1),
			n[3] ||= s("path", {
				d: "M0.5 18.5H22.5",
				fill: "none",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[4] ||= s("path", {
				d: "M2.5 21.5C2.5 22.0523 2.05228 22.5 1.5 22.5C0.947715 22.5 0.5 22.0523 0.5 21.5C0.5 20.9477 0.947715 20.5 1.5 20.5C2.05228 20.5 2.5 20.9477 2.5 21.5Z",
				fill: "none",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[5] ||= s("path", {
				d: "M6.5 21.5C6.5 22.0523 6.05228 22.5 5.5 22.5C4.94772 22.5 4.5 22.0523 4.5 21.5C4.5 20.9477 4.94772 20.5 5.5 20.5C6.05228 20.5 6.5 20.9477 6.5 21.5Z",
				fill: "none",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[6] ||= s("path", {
				d: "M10.5 21.5C10.5 22.0523 10.0523 22.5 9.5 22.5C8.94772 22.5 8.5 22.0523 8.5 21.5C8.5 20.9477 8.94772 20.5 9.5 20.5C10.0523 20.5 10.5 20.9477 10.5 21.5Z",
				fill: "none",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[7] ||= s("path", {
				d: "M14.5 21.5C14.5 22.0523 14.0523 22.5 13.5 22.5C12.9477 22.5 12.5 22.0523 12.5 21.5C12.5 20.9477 12.9477 20.5 13.5 20.5C14.0523 20.5 14.5 20.9477 14.5 21.5Z",
				fill: "none",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[8] ||= s("path", {
				d: "M18.5 21.5C18.5 22.0523 18.0523 22.5 17.5 22.5C16.9477 22.5 16.5 22.0523 16.5 21.5C16.5 20.9477 16.9477 20.5 17.5 20.5C18.0523 20.5 18.5 20.9477 18.5 21.5Z",
				fill: "none",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1),
			n[9] ||= s("path", {
				d: "M22.5 21.5C22.5 22.0523 22.0523 22.5 21.5 22.5C20.9477 22.5 20.5 22.0523 20.5 21.5C20.5 20.9477 20.9477 20.5 21.5 20.5C22.0523 20.5 22.5 20.9477 22.5 21.5Z",
				fill: "none",
				stroke: "#FF8C00",
				"stroke-linecap": "round",
				"stroke-linejoin": "round"
			}, null, -1)
		], 64));
	}
}), yr = {
	fill: "none",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg"
}, br = /* @__PURE__ */ f({
	__name: "picklist",
	setup(e) {
		return (e, t) => (A(), o("svg", yr, [...t[0] ||= [s("path", {
			"clip-rule": "evenodd",
			d: "M4.14645 0.146447C4.24021 0.0526784 4.36739 0 4.5 0H12.5C13.3284 0 14 0.671573 14 1.5V14.5C14 15.3284 13.3284 16 12.5 16H2.5C1.67157 16 1 15.3284 1 14.5V3.5C1 3.36739 1.05268 3.24021 1.14645 3.14645L4.14645 0.146447ZM12.5 1H5V3.5C5 3.77614 4.77614 4 4.5 4H2V14.5C2 14.7761 2.22386 15 2.5 15H12.5C12.7761 15 13 14.7761 13 14.5V1.5C13 1.22386 12.7761 1 12.5 1ZM2.70711 3H4V1.70711L2.70711 3ZM6.85355 6.14645C7.04882 6.34171 7.04882 6.65829 6.85355 6.85355L4.85355 8.85355C4.65829 9.04882 4.34171 9.04882 4.14645 8.85355L3.14645 7.85355C2.95118 7.65829 2.95118 7.34171 3.14645 7.14645C3.34171 6.95118 3.65829 6.95118 3.85355 7.14645L4.5 7.79289L6.14645 6.14645C6.34171 5.95118 6.65829 5.95118 6.85355 6.14645ZM8 7.5C8 7.22386 8.22386 7 8.5 7H8.50686H8.51371H8.52054H8.52737H8.53418H8.54098H8.54777H8.55454H8.56131H8.56807H8.57481H8.58154H8.58826H8.59497H8.60167H8.60836H8.61504H8.6217H8.62836H8.635H8.64163H8.64825H8.65486H8.66147H8.66806H8.67463H8.6812H8.68776H8.69431H8.70085H8.70737H8.71389H8.7204H8.72689H8.73338H8.73985H8.74632H8.75277H8.75922H8.76565H8.77208H8.77849H8.7849H8.7913H8.79768H8.80406H8.81042H8.81678H8.82313H8.82947H8.8358H8.84211H8.84842H8.85472H8.86101H8.8673H8.87357H8.87983H8.88609H8.89233H8.89857H8.9048H8.91101H8.91722H8.92342H8.92962H8.9358H8.94197H8.94814H8.9543H8.96044H8.96658H8.97272H8.97884H8.98495H8.99106H8.99716H9.00325H9.00933H9.0154H9.02147H9.02753H9.03358H9.03962H9.04565H9.05168H9.05769H9.0637H9.06971H9.0757H9.08169H9.08767H9.09364H9.0996H9.10556H9.11151H9.11745H9.12339H9.12931H9.13523H9.14115H9.14705H9.15295H9.15884H9.16473H9.17061H9.17648H9.18234H9.1882H9.19405H9.19989H9.20573H9.21156H9.21738H9.2232H9.22901H9.23482H9.24062H9.24641H9.25219H9.25797H9.26375H9.26951H9.27527H9.28103H9.28678H9.29252H9.29825H9.30399H9.30971H9.31543H9.32114H9.32685H9.33255H9.33825H9.34394H9.34963H9.3553H9.36098H9.36665H9.37231H9.37797H9.38362H9.38927H9.39491H9.40055H9.40619H9.41181H9.41743H9.42305H9.42867H9.43427H9.43988H9.44548H9.45107H9.45666H9.46224H9.46782H9.4734H9.47897H9.48454H9.4901H9.49566H9.50121H9.50676H9.5123H9.51785H9.52338H9.52891H9.53444H9.53997H9.54549H9.55101H9.55652H9.56203H9.56754H9.57304H9.57854H9.58403H9.58952H9.59501H9.60049H9.60598H9.61145H9.61693H9.6224H9.62787H9.63333H9.63879H9.64425H9.64971H9.65516H9.66061H9.66606H9.6715H9.67694H9.68238H9.68781H9.69325H9.69868H9.7041H9.70953H9.71495H9.72037H9.72579H9.7312H9.73662H9.74203H9.74744H9.75284H9.75825H9.76365H9.76905H9.77445H9.77985H9.78524H9.79063H9.79602H9.80141H9.8068H9.81219H9.81757H9.82295H9.82833H9.83371H9.83909H9.84447H9.84984H9.85522H9.86059H9.86596H9.87133H9.8767H9.88207H9.88744H9.8928H9.89817H9.90353H9.9089H9.91426H9.91962H9.92498H9.93035H9.93571H9.94107H9.94643H9.95178H9.95714H9.9625H9.96786H9.97322H9.97857H9.98393H9.98929H9.99464H10H10.0054H10.0107H10.0161H10.0214H10.0268H10.0321H10.0375H10.0429H10.0482H10.0536H10.0589H10.0643H10.0697H10.075H10.0804H10.0857H10.0911H10.0965H10.1018H10.1072H10.1126H10.1179H10.1233H10.1287H10.134H10.1394H10.1448H10.1502H10.1555H10.1609H10.1663H10.1717H10.177H10.1824H10.1878H10.1932H10.1986H10.204H10.2094H10.2148H10.2202H10.2256H10.2309H10.2363H10.2418H10.2472H10.2526H10.258H10.2634H10.2688H10.2742H10.2796H10.285H10.2905H10.2959H10.3013H10.3068H10.3122H10.3176H10.3231H10.3285H10.3339H10.3394H10.3448H10.3503H10.3557H10.3612H10.3667H10.3721H10.3776H10.3831H10.3885H10.394H10.3995H10.405H10.4105H10.416H10.4215H10.427H10.4325H10.438H10.4435H10.449H10.4545H10.46H10.4656H10.4711H10.4766H10.4822H10.4877H10.4932H10.4988H10.5043H10.5099H10.5155H10.521H10.5266H10.5322H10.5378H10.5433H10.5489H10.5545H10.5601H10.5657H10.5713H10.5769H10.5826H10.5882H10.5938H10.5994H10.6051H10.6107H10.6164H10.622H10.6277H10.6334H10.639H10.6447H10.6504H10.6561H10.6618H10.6674H10.6731H10.6789H10.6846H10.6903H10.696H10.7017H10.7075H10.7132H10.719H10.7247H10.7305H10.7363H10.742H10.7478H10.7536H10.7594H10.7652H10.771H10.7768H10.7826H10.7884H10.7943H10.8001H10.806H10.8118H10.8177H10.8235H10.8294H10.8353H10.8412H10.847H10.8529H10.8589H10.8648H10.8707H10.8766H10.8825H10.8885H10.8944H10.9004H10.9064H10.9123H10.9183H10.9243H10.9303H10.9363H10.9423H10.9483H10.9544H10.9604H10.9664H10.9725H10.9785H10.9846H10.9907H10.9968H11.0028H11.0089H11.015H11.0212H11.0273H11.0334H11.0396H11.0457H11.0519H11.058H11.0642H11.0704H11.0766H11.0828H11.089H11.0952H11.1014H11.1077H11.1139H11.1202H11.1264H11.1327H11.139H11.1453H11.1516H11.1579H11.1642H11.1705H11.1769H11.1832H11.1896H11.1959H11.2023H11.2087H11.2151H11.2215H11.2279H11.2343H11.2408H11.2472H11.2537H11.2601H11.2666H11.2731H11.2796H11.2861H11.2926H11.2992H11.3057H11.3122H11.3188H11.3254H11.3319H11.3385H11.3451H11.3517H11.3584H11.365H11.3716H11.3783H11.385H11.3916H11.3983H11.405H11.4117H11.4185H11.4252H11.4319H11.4387H11.4455H11.4522H11.459H11.4658H11.4726H11.4795H11.4863H11.4931H11.5C11.7761 7 12 7.22386 12 7.5C12 7.77614 11.7761 8 11.5 8H11.4931H11.4863H11.4795H11.4726H11.4658H11.459H11.4522H11.4455H11.4387H11.4319H11.4252H11.4185H11.4117H11.405H11.3983H11.3916H11.385H11.3783H11.3716H11.365H11.3584H11.3517H11.3451H11.3385H11.3319H11.3254H11.3188H11.3122H11.3057H11.2992H11.2926H11.2861H11.2796H11.2731H11.2666H11.2601H11.2537H11.2472H11.2408H11.2343H11.2279H11.2215H11.2151H11.2087H11.2023H11.1959H11.1896H11.1832H11.1769H11.1705H11.1642H11.1579H11.1516H11.1453H11.139H11.1327H11.1264H11.1202H11.1139H11.1077H11.1014H11.0952H11.089H11.0828H11.0766H11.0704H11.0642H11.058H11.0519H11.0457H11.0396H11.0334H11.0273H11.0212H11.015H11.0089H11.0028H10.9968H10.9907H10.9846H10.9785H10.9725H10.9664H10.9604H10.9544H10.9483H10.9423H10.9363H10.9303H10.9243H10.9183H10.9123H10.9064H10.9004H10.8944H10.8885H10.8825H10.8766H10.8707H10.8648H10.8589H10.8529H10.847H10.8412H10.8353H10.8294H10.8235H10.8177H10.8118H10.806H10.8001H10.7943H10.7884H10.7826H10.7768H10.771H10.7652H10.7594H10.7536H10.7478H10.742H10.7363H10.7305H10.7247H10.719H10.7132H10.7075H10.7017H10.696H10.6903H10.6846H10.6789H10.6731H10.6674H10.6618H10.6561H10.6504H10.6447H10.639H10.6334H10.6277H10.622H10.6164H10.6107H10.6051H10.5994H10.5938H10.5882H10.5826H10.5769H10.5713H10.5657H10.5601H10.5545H10.5489H10.5433H10.5378H10.5322H10.5266H10.521H10.5155H10.5099H10.5043H10.4988H10.4932H10.4877H10.4822H10.4766H10.4711H10.4656H10.46H10.4545H10.449H10.4435H10.438H10.4325H10.427H10.4215H10.416H10.4105H10.405H10.3995H10.394H10.3885H10.3831H10.3776H10.3721H10.3667H10.3612H10.3557H10.3503H10.3448H10.3394H10.3339H10.3285H10.3231H10.3176H10.3122H10.3068H10.3013H10.2959H10.2905H10.285H10.2796H10.2742H10.2688H10.2634H10.258H10.2526H10.2472H10.2418H10.2363H10.2309H10.2256H10.2202H10.2148H10.2094H10.204H10.1986H10.1932H10.1878H10.1824H10.177H10.1717H10.1663H10.1609H10.1555H10.1502H10.1448H10.1394H10.134H10.1287H10.1233H10.1179H10.1126H10.1072H10.1018H10.0965H10.0911H10.0857H10.0804H10.075H10.0697H10.0643H10.0589H10.0536H10.0482H10.0429H10.0375H10.0321H10.0268H10.0214H10.0161H10.0107H10.0054H10H9.99464H9.98929H9.98393H9.97857H9.97322H9.96786H9.9625H9.95714H9.95178H9.94643H9.94107H9.93571H9.93035H9.92498H9.91962H9.91426H9.9089H9.90353H9.89817H9.8928H9.88744H9.88207H9.8767H9.87133H9.86596H9.86059H9.85522H9.84984H9.84447H9.83909H9.83371H9.82833H9.82295H9.81757H9.81219H9.8068H9.80141H9.79602H9.79063H9.78524H9.77985H9.77445H9.76905H9.76365H9.75825H9.75284H9.74744H9.74203H9.73662H9.7312H9.72579H9.72037H9.71495H9.70953H9.7041H9.69868H9.69325H9.68781H9.68238H9.67694H9.6715H9.66606H9.66061H9.65516H9.64971H9.64425H9.63879H9.63333H9.62787H9.6224H9.61693H9.61145H9.60598H9.60049H9.59501H9.58952H9.58403H9.57854H9.57304H9.56754H9.56203H9.55652H9.55101H9.54549H9.53997H9.53444H9.52891H9.52338H9.51785H9.5123H9.50676H9.50121H9.49566H9.4901H9.48454H9.47897H9.4734H9.46782H9.46224H9.45666H9.45107H9.44548H9.43988H9.43427H9.42867H9.42305H9.41743H9.41181H9.40619H9.40055H9.39491H9.38927H9.38362H9.37797H9.37231H9.36665H9.36098H9.3553H9.34963H9.34394H9.33825H9.33255H9.32685H9.32114H9.31543H9.30971H9.30399H9.29825H9.29252H9.28678H9.28103H9.27527H9.26951H9.26375H9.25797H9.25219H9.24641H9.24062H9.23482H9.22901H9.2232H9.21738H9.21156H9.20573H9.19989H9.19405H9.1882H9.18234H9.17648H9.17061H9.16473H9.15884H9.15295H9.14705H9.14115H9.13523H9.12931H9.12339H9.11745H9.11151H9.10556H9.0996H9.09364H9.08767H9.08169H9.0757H9.06971H9.0637H9.05769H9.05168H9.04565H9.03962H9.03358H9.02753H9.02147H9.0154H9.00933H9.00325H8.99716H8.99106H8.98495H8.97884H8.97272H8.96658H8.96044H8.9543H8.94814H8.94197H8.9358H8.92962H8.92342H8.91722H8.91101H8.9048H8.89857H8.89233H8.88609H8.87983H8.87357H8.8673H8.86101H8.85472H8.84842H8.84211H8.8358H8.82947H8.82313H8.81678H8.81042H8.80406H8.79768H8.7913H8.7849H8.77849H8.77208H8.76565H8.75922H8.75277H8.74632H8.73985H8.73338H8.72689H8.7204H8.71389H8.70737H8.70085H8.69431H8.68776H8.6812H8.67463H8.66806H8.66147H8.65486H8.64825H8.64163H8.635H8.62836H8.6217H8.61504H8.60836H8.60167H8.59497H8.58826H8.58154H8.57481H8.56807H8.56131H8.55454H8.54777H8.54098H8.53418H8.52737H8.52054H8.51371H8.50686H8.5C8.22386 8 8 7.77614 8 7.5ZM8.50686 11H8.5C8.22386 11 8 11.2239 8 11.5C8 11.7761 8.22386 12 8.5 12H8.50686H8.51371H8.52054H8.52737H8.53418H8.54098H8.54777H8.55454H8.56131H8.56807H8.57481H8.58154H8.58826H8.59497H8.60167H8.60836H8.61504H8.6217H8.62836H8.635H8.64163H8.64825H8.65486H8.66147H8.66806H8.67463H8.6812H8.68776H8.69431H8.70085H8.70737H8.71389H8.7204H8.72689H8.73338H8.73985H8.74632H8.75277H8.75922H8.76565H8.77208H8.77849H8.7849H8.7913H8.79768H8.80406H8.81042H8.81678H8.82313H8.82947H8.8358H8.84211H8.84842H8.85472H8.86101H8.8673H8.87357H8.87983H8.88609H8.89233H8.89857H8.9048H8.91101H8.91722H8.92342H8.92962H8.9358H8.94197H8.94814H8.9543H8.96044H8.96658H8.97272H8.97884H8.98495H8.99106H8.99716H9.00325H9.00933H9.0154H9.02147H9.02753H9.03358H9.03962H9.04565H9.05168H9.05769H9.0637H9.06971H9.0757H9.08169H9.08767H9.09364H9.0996H9.10556H9.11151H9.11745H9.12339H9.12931H9.13523H9.14115H9.14705H9.15295H9.15884H9.16473H9.17061H9.17648H9.18234H9.1882H9.19405H9.19989H9.20573H9.21156H9.21738H9.2232H9.22901H9.23482H9.24062H9.24641H9.25219H9.25797H9.26375H9.26951H9.27527H9.28103H9.28678H9.29252H9.29825H9.30399H9.30971H9.31543H9.32114H9.32685H9.33255H9.33825H9.34394H9.34963H9.3553H9.36098H9.36665H9.37231H9.37797H9.38362H9.38927H9.39491H9.40055H9.40619H9.41181H9.41743H9.42305H9.42867H9.43427H9.43988H9.44548H9.45107H9.45666H9.46224H9.46782H9.4734H9.47897H9.48454H9.4901H9.49566H9.50121H9.50676H9.5123H9.51785H9.52338H9.52891H9.53444H9.53997H9.54549H9.55101H9.55652H9.56203H9.56754H9.57304H9.57854H9.58403H9.58952H9.59501H9.60049H9.60598H9.61145H9.61693H9.6224H9.62787H9.63333H9.63879H9.64425H9.64971H9.65516H9.66061H9.66606H9.6715H9.67694H9.68238H9.68781H9.69325H9.69868H9.7041H9.70953H9.71495H9.72037H9.72579H9.7312H9.73662H9.74203H9.74744H9.75284H9.75825H9.76365H9.76905H9.77445H9.77985H9.78524H9.79063H9.79602H9.80141H9.8068H9.81219H9.81757H9.82295H9.82833H9.83371H9.83909H9.84447H9.84984H9.85522H9.86059H9.86596H9.87133H9.8767H9.88207H9.88744H9.8928H9.89817H9.90353H9.9089H9.91426H9.91962H9.92498H9.93035H9.93571H9.94107H9.94643H9.95178H9.95714H9.9625H9.96786H9.97322H9.97857H9.98393H9.98929H9.99464H10H10.0054H10.0107H10.0161H10.0214H10.0268H10.0321H10.0375H10.0429H10.0482H10.0536H10.0589H10.0643H10.0697H10.075H10.0804H10.0857H10.0911H10.0965H10.1018H10.1072H10.1126H10.1179H10.1233H10.1287H10.134H10.1394H10.1448H10.1502H10.1555H10.1609H10.1663H10.1717H10.177H10.1824H10.1878H10.1932H10.1986H10.204H10.2094H10.2148H10.2202H10.2256H10.2309H10.2363H10.2418H10.2472H10.2526H10.258H10.2634H10.2688H10.2742H10.2796H10.285H10.2905H10.2959H10.3013H10.3068H10.3122H10.3176H10.3231H10.3285H10.3339H10.3394H10.3448H10.3503H10.3557H10.3612H10.3667H10.3721H10.3776H10.3831H10.3885H10.394H10.3995H10.405H10.4105H10.416H10.4215H10.427H10.4325H10.438H10.4435H10.449H10.4545H10.46H10.4656H10.4711H10.4766H10.4822H10.4877H10.4932H10.4988H10.5043H10.5099H10.5155H10.521H10.5266H10.5322H10.5378H10.5433H10.5489H10.5545H10.5601H10.5657H10.5713H10.5769H10.5826H10.5882H10.5938H10.5994H10.6051H10.6107H10.6164H10.622H10.6277H10.6334H10.639H10.6447H10.6504H10.6561H10.6618H10.6674H10.6731H10.6789H10.6846H10.6903H10.696H10.7017H10.7075H10.7132H10.719H10.7247H10.7305H10.7363H10.742H10.7478H10.7536H10.7594H10.7652H10.771H10.7768H10.7826H10.7884H10.7943H10.8001H10.806H10.8118H10.8177H10.8235H10.8294H10.8353H10.8412H10.847H10.8529H10.8589H10.8648H10.8707H10.8766H10.8825H10.8885H10.8944H10.9004H10.9064H10.9123H10.9183H10.9243H10.9303H10.9363H10.9423H10.9483H10.9544H10.9604H10.9664H10.9725H10.9785H10.9846H10.9907H10.9968H11.0028H11.0089H11.015H11.0212H11.0273H11.0334H11.0396H11.0457H11.0519H11.058H11.0642H11.0704H11.0766H11.0828H11.089H11.0952H11.1014H11.1077H11.1139H11.1202H11.1264H11.1327H11.139H11.1453H11.1516H11.1579H11.1642H11.1705H11.1769H11.1832H11.1896H11.1959H11.2023H11.2087H11.2151H11.2215H11.2279H11.2343H11.2408H11.2472H11.2537H11.2601H11.2666H11.2731H11.2796H11.2861H11.2926H11.2992H11.3057H11.3122H11.3188H11.3254H11.3319H11.3385H11.3451H11.3517H11.3584H11.365H11.3716H11.3783H11.385H11.3916H11.3983H11.405H11.4117H11.4185H11.4252H11.4319H11.4387H11.4455H11.4522H11.459H11.4658H11.4726H11.4795H11.4863H11.4931H11.5C11.7761 12 12 11.7761 12 11.5C12 11.2239 11.7761 11 11.5 11H11.4931H11.4863H11.4795H11.4726H11.4658H11.459H11.4522H11.4455H11.4387H11.4319H11.4252H11.4185H11.4117H11.405H11.3983H11.3916H11.385H11.3783H11.3716H11.365H11.3584H11.3517H11.3451H11.3385H11.3319H11.3254H11.3188H11.3122H11.3057H11.2992H11.2926H11.2861H11.2796H11.2731H11.2666H11.2601H11.2537H11.2472H11.2408H11.2343H11.2279H11.2215H11.2151H11.2087H11.2023H11.1959H11.1896H11.1832H11.1769H11.1705H11.1642H11.1579H11.1516H11.1453H11.139H11.1327H11.1264H11.1202H11.1139H11.1077H11.1014H11.0952H11.089H11.0828H11.0766H11.0704H11.0642H11.058H11.0519H11.0457H11.0396H11.0334H11.0273H11.0212H11.015H11.0089H11.0028H10.9968H10.9907H10.9846H10.9785H10.9725H10.9664H10.9604H10.9544H10.9483H10.9423H10.9363H10.9303H10.9243H10.9183H10.9123H10.9064H10.9004H10.8944H10.8885H10.8825H10.8766H10.8707H10.8648H10.8589H10.8529H10.847H10.8412H10.8353H10.8294H10.8235H10.8177H10.8118H10.806H10.8001H10.7943H10.7884H10.7826H10.7768H10.771H10.7652H10.7594H10.7536H10.7478H10.742H10.7363H10.7305H10.7247H10.719H10.7132H10.7075H10.7017H10.696H10.6903H10.6846H10.6789H10.6731H10.6674H10.6618H10.6561H10.6504H10.6447H10.639H10.6334H10.6277H10.622H10.6164H10.6107H10.6051H10.5994H10.5938H10.5882H10.5826H10.5769H10.5713H10.5657H10.5601H10.5545H10.5489H10.5433H10.5378H10.5322H10.5266H10.521H10.5155H10.5099H10.5043H10.4988H10.4932H10.4877H10.4822H10.4766H10.4711H10.4656H10.46H10.4545H10.449H10.4435H10.438H10.4325H10.427H10.4215H10.416H10.4105H10.405H10.3995H10.394H10.3885H10.3831H10.3776H10.3721H10.3667H10.3612H10.3557H10.3503H10.3448H10.3394H10.3339H10.3285H10.3231H10.3176H10.3122H10.3068H10.3013H10.2959H10.2905H10.285H10.2796H10.2742H10.2688H10.2634H10.258H10.2526H10.2472H10.2418H10.2363H10.2309H10.2256H10.2202H10.2148H10.2094H10.204H10.1986H10.1932H10.1878H10.1824H10.177H10.1717H10.1663H10.1609H10.1555H10.1502H10.1448H10.1394H10.134H10.1287H10.1233H10.1179H10.1126H10.1072H10.1018H10.0965H10.0911H10.0857H10.0804H10.075H10.0697H10.0643H10.0589H10.0536H10.0482H10.0429H10.0375H10.0321H10.0268H10.0214H10.0161H10.0107H10.0054H10H9.99464H9.98929H9.98393H9.97857H9.97322H9.96786H9.9625H9.95714H9.95178H9.94643H9.94107H9.93571H9.93035H9.92498H9.91962H9.91426H9.9089H9.90353H9.89817H9.8928H9.88744H9.88207H9.8767H9.87133H9.86596H9.86059H9.85522H9.84984H9.84447H9.83909H9.83371H9.82833H9.82295H9.81757H9.81219H9.8068H9.80141H9.79602H9.79063H9.78524H9.77985H9.77445H9.76905H9.76365H9.75825H9.75284H9.74744H9.74203H9.73662H9.7312H9.72579H9.72037H9.71495H9.70953H9.7041H9.69868H9.69325H9.68781H9.68238H9.67694H9.6715H9.66606H9.66061H9.65516H9.64971H9.64425H9.63879H9.63333H9.62787H9.6224H9.61693H9.61145H9.60598H9.60049H9.59501H9.58952H9.58403H9.57854H9.57304H9.56754H9.56203H9.55652H9.55101H9.54549H9.53997H9.53444H9.52891H9.52338H9.51785H9.5123H9.50676H9.50121H9.49566H9.4901H9.48454H9.47897H9.4734H9.46782H9.46224H9.45666H9.45107H9.44548H9.43988H9.43427H9.42867H9.42305H9.41743H9.41181H9.40619H9.40055H9.39491H9.38927H9.38362H9.37797H9.37231H9.36665H9.36098H9.3553H9.34963H9.34394H9.33825H9.33255H9.32685H9.32114H9.31543H9.30971H9.30399H9.29825H9.29252H9.28678H9.28103H9.27527H9.26951H9.26375H9.25797H9.25219H9.24641H9.24062H9.23482H9.22901H9.2232H9.21738H9.21156H9.20573H9.19989H9.19405H9.1882H9.18234H9.17648H9.17061H9.16473H9.15884H9.15295H9.14705H9.14115H9.13523H9.12931H9.12339H9.11745H9.11151H9.10556H9.0996H9.09364H9.08767H9.08169H9.0757H9.06971H9.0637H9.05769H9.05168H9.04565H9.03962H9.03358H9.02753H9.02147H9.0154H9.00933H9.00325H8.99716H8.99106H8.98495H8.97884H8.97272H8.96658H8.96044H8.9543H8.94814H8.94197H8.9358H8.92962H8.92342H8.91722H8.91101H8.9048H8.89857H8.89233H8.88609H8.87983H8.87357H8.8673H8.86101H8.85472H8.84842H8.84211H8.8358H8.82947H8.82313H8.81678H8.81042H8.80406H8.79768H8.7913H8.7849H8.77849H8.77208H8.76565H8.75922H8.75277H8.74632H8.73985H8.73338H8.72689H8.7204H8.71389H8.70737H8.70085H8.69431H8.68776H8.6812H8.67463H8.66806H8.66147H8.65486H8.64825H8.64163H8.635H8.62836H8.6217H8.61504H8.60836H8.60167H8.59497H8.58826H8.58154H8.57481H8.56807H8.56131H8.55454H8.54777H8.54098H8.53418H8.52737H8.52054H8.51371H8.50686ZM6.85355 10.8536C7.04882 10.6583 7.04882 10.3417 6.85355 10.1464C6.65829 9.95118 6.34171 9.95118 6.14645 10.1464L4.5 11.7929L3.85355 11.1464C3.65829 10.9512 3.34171 10.9512 3.14645 11.1464C2.95118 11.3417 2.95118 11.6583 3.14645 11.8536L4.14645 12.8536C4.34171 13.0488 4.65829 13.0488 4.85355 12.8536L6.85355 10.8536Z",
			fill: "#0F5C47",
			"fill-rule": "evenodd"
		}, null, -1)]]));
	}
}), xr = {}, Sr = {
	d: "M24.65 2.24C12.1 2.24 1.89 12.45 1.89 25S12.1 47.76 24.65 47.76 47.41 37.55 47.41 25c.01-12.55-10.2-22.76-22.76-22.76zm-5.16 36.11c-3.26 0-6.43-.93-9.17-2.69a.765.765 0 0 1-.31-.9c.12-.33.45-.55.81-.5.41.05.84.07 1.27.07 1.8 0 3.53-.44 5.08-1.27a6.488 6.488 0 0 1-4.05-4.15.766.766 0 0 1 .36-.9 6.508 6.508 0 0 1-2.4-5.03v-.1c.01-.26.16-.5.39-.63.17-.1.37-.12.56-.08-.58-.98-.9-2.12-.9-3.3 0-1.15.3-2.28.88-3.26.13-.22.35-.36.6-.38.25-.03.49.09.65.28a15.55 15.55 0 0 0 10.29 5.62c-.01-.15-.02-.31-.02-.46 0-3.57 2.91-6.48 6.48-6.48 1.63 0 3.22.63 4.42 1.73 1.05-.25 2.06-.65 3-1.21.27-.16.62-.14.87.06s.35.53.25.83c-.17.54-.42 1.04-.71 1.51.15-.06.29-.12.44-.18.31-.14.68-.06.9.21.22.26.24.63.05.92-.74 1.12-1.65 2.09-2.71 2.91v.37c-.01 8.35-6.38 17.01-17.03 17.01zm-5.67-2.61c1.79.71 3.71 1.07 5.67 1.07 9.7 0 15.49-7.88 15.49-15.49 0-.24-.01-.47-.02-.71-.01-.26.11-.5.32-.65.35-.25.68-.52 1-.81-.3.06-.6.1-.9.14-.38.04-.7-.17-.81-.51-.12-.34.02-.72.33-.9.37-.22.7-.49 1-.79-.51.17-1.04.31-1.58.42a.763.763 0 0 1-.7-.23 4.902 4.902 0 0 0-3.61-1.56 4.955 4.955 0 0 0-4.82 6.08c.05.23 0 .48-.16.67-.15.19-.38.3-.63.27a17.08 17.08 0 0 1-11.53-5.33c-.15.47-.22.97-.22 1.47 0 1.66.82 3.2 2.2 4.12.28.19.41.54.3.87-.1.32-.41.51-.75.53-.56-.02-1.12-.11-1.66-.27.44 1.86 1.92 3.34 3.83 3.72.35.07.6.37.61.72.01.35-.22.67-.56.76-.5.14-1.02.21-1.55.22a4.96 4.96 0 0 0 4.12 2.34c.32.01.61.21.71.52.1.31 0 .65-.25.85-1.71 1.34-3.7 2.19-5.83 2.48z",
	fill: "currentColor"
};
function Cr(e, t) {
	return A(), o("path", Sr);
}
var wr = /*#__PURE__*/ W(xr, [["render", Cr]]), Tr = {}, Er = {
	d: "M25 1.46C12.02 1.46 1.46 12.02 1.46 25c0 12.98 10.56 23.54 23.54 23.54S48.54 37.98 48.54 25C48.54 12.02 37.98 1.46 25 1.46zm0 45.53C12.88 46.99 3.01 37.12 3.01 25S12.88 3.01 25 3.01 46.99 12.88 46.99 25 37.12 46.99 25 46.99zm13.61-30.06c-.15.07-.29.13-.44.18.3-.47.54-.98.71-1.51.1-.3 0-.63-.25-.83a.77.77 0 0 0-.87-.06c-.94.56-1.94.96-3 1.21a6.489 6.489 0 0 0-4.41-1.73c-3.57 0-6.48 2.91-6.48 6.48 0 .16.01.31.02.46-4.01-.45-7.72-2.46-10.29-5.62-.16-.19-.4-.3-.65-.28-.25.02-.47.16-.6.38-.57.98-.88 2.11-.88 3.26 0 1.18.32 2.31.9 3.3a.709.709 0 0 0-.55.08c-.23.13-.38.37-.39.63v.1c0 2 .92 3.83 2.4 5.03-.08.04-.14.1-.2.16-.18.2-.24.48-.16.74a6.488 6.488 0 0 0 4.05 4.15c-1.55.83-3.28 1.27-5.08 1.27-.43 0-.86-.03-1.27-.07-.35-.04-.69.17-.81.5s.01.71.31.9c2.74 1.76 5.91 2.69 9.17 2.69 10.66 0 17.02-8.65 17.02-17.02v-.37c1.05-.81 1.96-1.79 2.71-2.9.19-.28.17-.66-.05-.92a.801.801 0 0 0-.91-.21zm-2.98 3.03a.77.77 0 0 0-.32.65c.01.24.02.47.02.71 0 7.61-5.8 15.49-15.49 15.49-1.96 0-3.87-.37-5.67-1.07 2.13-.3 4.12-1.14 5.84-2.49.25-.2.36-.54.25-.85a.75.75 0 0 0-.71-.52 4.937 4.937 0 0 1-4.12-2.34c.53-.01 1.05-.09 1.55-.22.34-.09.58-.41.56-.76s-.27-.65-.61-.72c-1.91-.38-3.39-1.86-3.83-3.72.54.16 1.1.25 1.66.27.37 0 .65-.21.75-.53s-.02-.68-.3-.87a4.937 4.937 0 0 1-2.2-4.12c0-.5.08-1 .22-1.47 3 3.18 7.14 5.11 11.52 5.33.25.01.47-.09.63-.27.15-.18.21-.43.16-.67a4.955 4.955 0 0 1 4.82-6.08c1.38 0 2.67.56 3.61 1.56.18.19.44.28.7.23.54-.11 1.06-.25 1.57-.42-.3.3-.63.57-1 .79-.31.19-.45.56-.33.9.12.34.46.56.81.51.3-.04.6-.08.9-.14-.31.3-.64.57-.99.82z",
	fill: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	"stroke-miterlimit": "10",
	"stroke-width": ".25"
};
function Dr(e, t) {
	return A(), o("path", Er);
}
var Or = /*#__PURE__*/ W(Tr, [["render", Dr]]), kr = {}, Ar = {
	d: "M9.48891 6.77146L15.3142 3.05176e-05H13.9338L8.87569 5.87957L4.8358 3.05176e-05H0.17627L6.28537 8.89093L0.17627 15.9918H1.55676L6.89824 9.78283L11.1647 15.9918H15.8242L9.48857 6.77146H9.48891ZM7.59814 8.96926L6.97916 8.08393L2.05416 1.03924H4.17451L8.14904 6.72453L8.76802 7.60986L13.9344 14.9999H11.8141L7.59814 8.9696V8.96926Z",
	fill: "currentColor"
};
function jr(e, t) {
	return A(), o("path", Ar);
}
var Mr = /*#__PURE__*/ W(kr, [["render", jr]]), Nr = {}, Pr = {
	d: "m6 3 5 5-5 5",
	fill: "none",
	stroke: "currentColor"
};
function Fr(e, t) {
	return A(), o("path", Pr);
}
var Ir = /*#__PURE__*/ W(Nr, [["render", Fr]]), Lr = {}, Rr = {
	"clip-rule": "evenodd",
	d: "M16.354 11.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708-.708L15.293 12 8.646 5.354a.5.5 0 1 1 .708-.708l7 7Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function zr(e, t) {
	return A(), o("path", Rr);
}
var Br = /*#__PURE__*/ W(Lr, [["render", zr]]), Vr = {}, Hr = {
	"clip-rule": "evenodd",
	d: "M8.354 5.646a.5.5 0 0 0-.708 0l-5 5a.5.5 0 1 0 .708.707L8 6.707l4.646 4.646a.5.5 0 0 0 .708-.707l-5-5Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function Ur(e, t) {
	return A(), o("path", Hr);
}
var Wr = /*#__PURE__*/ W(Vr, [["render", Ur]]), Gr = {}, Kr = {
	"clip-rule": "evenodd",
	d: "M8.354 11.354a.5.5 0 0 1-.708 0l-5-5a.5.5 0 0 1 .708-.707L8 10.293l4.646-4.646a.5.5 0 0 1 .708.707l-5 5Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function qr(e, t) {
	return A(), o("path", Kr);
}
var Jr = /*#__PURE__*/ W(Gr, [["render", qr]]), Yr = {}, Xr = {
	"clip-rule": "evenodd",
	d: "M12.354 16.354a.5.5 0 0 1-.708 0l-7-7a.5.5 0 1 1 .708-.708L12 15.293l6.646-6.647a.5.5 0 0 1 .708.708l-7 7Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function Zr(e, t) {
	return A(), o("path", Xr);
}
var Qr = /*#__PURE__*/ W(Yr, [["render", Zr]]), $r = {}, ei = { fill: "currentColor" };
function ti(e, t) {
	return A(), o("g", ei, [...t[0] ||= [s("path", { d: "M35.03 47.54c-.21 0-.42-.09-.58-.25L14.39 25.54a.786.786 0 0 1 0-1.07L34.45 2.71c.3-.32.8-.34 1.12-.04.32.3.34.8.05 1.12L16.04 25l19.57 21.22a.783.783 0 0 1-.58 1.32z" }, null, -1), s("path", { d: "M35.03 47.67c-.25 0-.5-.11-.67-.29L14.3 25.62a.92.92 0 0 1 0-1.24L34.36 2.62a.93.93 0 0 1 1.3-.05c.18.17.28.39.29.64.01.24-.08.48-.24.66L16.21 25 35.7 46.13c.17.18.25.41.24.66a.93.93 0 0 1-.29.64c-.17.15-.39.24-.62.24zm0-45.09H35a.66.66 0 0 0-.46.21L14.48 24.55c-.23.25-.23.65 0 .9L34.54 47.2c.24.26.68.28.94.04.13-.12.21-.28.21-.46a.655.655 0 0 0-.18-.48L15.95 25.08a.135.135 0 0 1 0-.17L35.52 3.7c.12-.13.18-.3.18-.48a.667.667 0 0 0-.67-.64z" }, null, -1)]]);
}
var ni = /*#__PURE__*/ W($r, [["render", ti]]), ri = {}, ii = {
	"clip-rule": "evenodd",
	d: "M12.354 8.646a.5.5 0 0 0-.708 0l-7 7a.5.5 0 0 0 .708.708L12 9.707l6.646 6.647a.5.5 0 0 0 .708-.708l-7-7Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function ai(e, t) {
	return A(), o("path", ii);
}
var oi = /*#__PURE__*/ W(ri, [["render", ai]]), si = {}, ci = {
	"clip-rule": "evenodd",
	d: "M3.4937 12.7497C3.3093 12.4561 3.17264 12.2126 3.08285 12.0441C3.06788 12.0161 3.05423 11.9901 3.04187 11.9663C3.04936 11.9465 3.05752 11.9252 3.0664 11.9024C3.13083 11.7373 3.23215 11.4975 3.3769 11.208C3.66686 10.6281 4.12832 9.85414 4.812 9.08129C6.17106 7.54496 8.41634 6 12 6C15.5837 6 17.8289 7.54496 19.188 9.08129C19.8717 9.85414 20.3331 10.6281 20.6231 11.208C20.7679 11.4975 20.8692 11.7373 20.9336 11.9024C20.9425 11.9252 20.9506 11.9465 20.9581 11.9663C20.9458 11.9901 20.9321 12.0161 20.9172 12.0441C20.8274 12.2126 20.6907 12.4561 20.5063 12.7497C20.1369 13.3376 19.5792 14.1213 18.8271 14.9034C17.3214 16.4693 15.0681 18 12 18C8.93189 18 6.67856 16.4693 5.17292 14.9034C4.42081 14.1213 3.86306 13.3376 3.4937 12.7497ZM21.9538 12.21C21.9539 12.2097 21.954 12.2095 21.5 12L21.954 12.2095C22.0056 12.0977 22.0141 11.9707 21.9779 11.853L21.5 12C21.9779 11.853 21.9778 11.8527 21.9777 11.8524L21.9775 11.8517L21.9769 11.8498L21.9752 11.8443L21.9694 11.8263C21.9645 11.8112 21.9574 11.7901 21.9482 11.7634C21.9297 11.7101 21.9024 11.6342 21.8652 11.539C21.791 11.3487 21.6775 11.0806 21.5175 10.7608C21.1981 10.1219 20.6908 9.27086 19.937 8.41871C18.4211 6.70504 15.9163 5 12 5C8.08366 5 5.57894 6.70504 4.063 8.41871C3.30918 9.27086 2.80189 10.1219 2.48247 10.7608C2.32254 11.0806 2.20902 11.3487 2.13478 11.539C2.09764 11.6342 2.07027 11.7101 2.0518 11.7634C2.04256 11.7901 2.03554 11.8112 2.03063 11.8263L2.02483 11.8443L2.02309 11.8498L2.02251 11.8517L2.02229 11.8524C2.02219 11.8527 2.02211 11.853 2.5 12L2.02211 11.853C1.98588 11.9707 1.9944 12.0977 2.04602 12.2095L2.5 12C2.04602 12.2095 2.04612 12.2097 2.04622 12.21L2.0465 12.2106L2.04725 12.2122L2.0496 12.2172L2.05763 12.2342C2.06448 12.2485 2.07431 12.2688 2.08715 12.2948C2.11282 12.3466 2.15051 12.4209 2.20036 12.5145C2.30002 12.7015 2.44851 12.9658 2.64692 13.2816C3.04319 13.9124 3.64169 14.7537 4.45208 15.5966C6.07144 17.2807 8.56811 19 12 19C15.4319 19 17.9286 17.2807 19.5479 15.5966C20.3583 14.7537 20.9568 13.9124 21.3531 13.2816C21.5515 12.9658 21.7 12.7015 21.7996 12.5145C21.8495 12.4209 21.8872 12.3466 21.9129 12.2948C21.9257 12.2688 21.9355 12.2485 21.9424 12.2342L21.9504 12.2172L21.9527 12.2122L21.9535 12.2106L21.9538 12.21ZM9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function li(e, t) {
	return A(), o("path", ci);
}
var ui = /*#__PURE__*/ W(si, [["render", li]]), di = {}, fi = {
	d: "M14.854 1.146a.5.5 0 0 1 0 .708l-13 13a.5.5 0 0 1-.708-.708l1.985-1.984C2.19 11.388 1.468 10.5.964 9.77a12.752 12.752 0 0 1-.857-1.435 5.73 5.73 0 0 1-.045-.092L.05 8.218l-.003-.007-.002-.003L.5 8a42.876 42.876 0 0 1-.482-.132v-.002L.02 7.86l.004-.016a3.3 3.3 0 0 1 .08-.247 9.191 9.191 0 0 1 1.509-2.665C2.813 3.466 4.822 2 8 2c1.729 0 3.117.434 4.22 1.073l1.926-1.927a.5.5 0 0 1 .708 0ZM.5 8l-.455.207a.5.5 0 0 1-.027-.339L.5 8Zm5.055 1.738a3 3 0 0 1 4.184-4.184l1.745-1.745C10.567 3.326 9.424 3 8 3 5.178 3 3.436 4.284 2.387 5.567a8.192 8.192 0 0 0-1.339 2.362l-.01.031a11.752 11.752 0 0 0 .75 1.243c.483.702 1.17 1.539 2.054 2.248l1.713-1.713Zm.722-.722 2.74-2.74a2 2 0 0 0-2.74 2.74Zm7.998-3.435a.5.5 0 0 1 .691.147c.372.573.624 1.101.783 1.488a7.307 7.307 0 0 1 .229.636l.003.01v.004l.001.001v.001L15.5 8l.455.207v.002l-.003.005-.007.014a11.484 11.484 0 0 1-.486.89 12.883 12.883 0 0 1-1.464 1.968C12.697 12.514 10.698 14 8 14c-.37 0-.73-.028-1.075-.08a.5.5 0 0 1 .15-.99c.297.046.605.07.925.07 2.302 0 4.053-1.264 5.255-2.586a11.89 11.89 0 0 0 1.684-2.408l.024-.046a6.503 6.503 0 0 0-.138-.363 8.22 8.22 0 0 0-.698-1.325.5.5 0 0 1 .148-.691ZM15.5 8l.482-.132a.5.5 0 0 1-.027.339L15.5 8Z",
	fill: "currentColor"
};
function pi(e, t) {
	return A(), o("path", fi);
}
var mi = /*#__PURE__*/ W(di, [["render", pi]]), hi = {}, gi = {
	"clip-rule": "evenodd",
	d: "M1.934 8.486a13.149 13.149 0 0 1-.367-.527 9.368 9.368 0 0 1 1.43-2.124C4.06 4.651 5.686 3.5 8 3.5s3.939 1.152 5.003 2.334a9.368 9.368 0 0 1 1.43 2.125 14.539 14.539 0 0 1-1.787 2.188C11.424 11.368 9.796 12.5 8 12.5c-1.796 0-3.424-1.131-4.646-2.354a14.538 14.538 0 0 1-1.42-1.66Zm13.494-.228L15 8l.429.257.127-.212-.092-.23L15 8l.464-.186v-.002l-.003-.004-.005-.014-.021-.049a9.048 9.048 0 0 0-.39-.773 10.364 10.364 0 0 0-1.298-1.806C12.56 3.848 10.686 2.5 8 2.5S3.439 3.848 2.253 5.166a10.368 10.368 0 0 0-1.61 2.406 6.066 6.066 0 0 0-.099.222l-.006.014-.001.004v.001H.535L1 8l-.464-.186-.092.23.127.213L1 8l-.429.258.001.001.003.004.007.013a5.364 5.364 0 0 0 .137.213 15.54 15.54 0 0 0 1.928 2.364C3.923 12.132 5.796 13.5 8 13.5c2.204 0 4.076-1.369 5.354-2.646a15.54 15.54 0 0 0 2.035-2.532l.029-.046.007-.013.003-.004v-.001ZM6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function _i(e, t) {
	return A(), o("path", gi);
}
var vi = /*#__PURE__*/ W(hi, [["render", _i]]), yi = {}, bi = {
	d: "M30.47 26.56H19.53c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h10.94c1.73 0 3.12-1.4 3.12-3.12s-1.39-3.12-3.12-3.12zm0 4.69H19.53c-.86 0-1.56-.7-1.56-1.56s.7-1.56 1.56-1.56h10.94c.86 0 1.56.7 1.56 1.56s-.7 1.56-1.56 1.56zm15.39-14.61-6.24-6.24a.677.677 0 0 0-.26-.18c-.1-.04-.2-.06-.3-.06h-3.58l-6.8-6.8c-.3-.31-.8-.31-1.1 0l-3.36 3.36-1.79-1.79c-.3-.31-.8-.31-1.1 0l-5.24 5.24h-5.14a.765.765 0 0 0-.56.24l-6.24 6.24c-.23.23-.29.56-.18.84-.03.16-.06.33-.06.5v26.56c0 1.29 1.05 2.34 2.34 2.34h37.5c1.29 0 2.34-1.05 2.34-2.34V17.97c0-.17-.02-.34-.06-.5a.74.74 0 0 0-.17-.83zm-32.35-2.81c.3.31.8.31 1.1 0l2.34-2.34.01-.01 4.91-4.91 7.26 7.26c.15.15.35.23.55.23.2 0 .4-.08.55-.23.31-.3.31-.8 0-1.1l-4.92-4.92 2.8-2.8 6.47 6.47.01.01 2.34 2.34c.15.15.35.23.55.23s.4-.08.55-.23c.31-.3.31-.8 0-1.1l-1.01-1.01h1.7l3.91 3.91H7.35l3.91-3.91h3.27l-1.01 1.01c-.32.31-.32.8-.01 1.1zm31.02 30.7c0 .43-.35.78-.78.78H6.25c-.43 0-.78-.35-.78-.78V17.97c0-.43.35-.78.78-.78h37.5c.43 0 .78.35.78.78v26.56z",
	fill: "currentColor",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	"stroke-miterlimit": "10",
	"stroke-width": ".25"
};
function xi(e, t) {
	return A(), o("path", bi);
}
var Si = /*#__PURE__*/ W(yi, [["render", xi]]), Ci = {}, wi = {
	d: "M8.629.24a1.5 1.5 0 0 0-1.258 0l-5.5 2.538A1.5 1.5 0 0 0 1 4.14v7.72a1.5 1.5 0 0 0 .871 1.362l5.5 2.539a1.5 1.5 0 0 0 1.258 0l5.5-2.539A1.5 1.5 0 0 0 15 11.86V4.14a1.5 1.5 0 0 0-.871-1.362L8.629.239Zm-.839.907a.5.5 0 0 1 .42 0L13.307 3.5l-1.958.904a1.5 1.5 0 0 0-.22-.126L6.068 1.942l1.722-.795ZM4.875 2.493l5.307 2.45-1.972.91a.5.5 0 0 1-.42 0L2.693 3.5l2.182-1.007ZM11 5.666V7.5a.5.5 0 0 0 1 0V5.64c0-.14-.02-.278-.057-.41L14 4.282v7.58a.5.5 0 0 1-.29.453L8.5 14.72V6.813a1.5 1.5 0 0 0 .129-.052L11 5.666ZM2 4.281l5.371 2.48a1.5 1.5 0 0 0 .129.052v7.906l-5.21-2.405A.5.5 0 0 1 2 11.86V4.281Z",
	fill: "currentColor"
};
function Ti(e, t) {
	return A(), o("path", wi);
}
var Ei = /*#__PURE__*/ W(Ci, [["render", Ti]]), Di = {}, Oi = {
	d: "M12.5821 1.20263L21.0821 4.78152C21.6383 5.01572 22 5.56046 22 6.16398V17.836C22 18.4395 21.6383 18.9842 21.0821 19.2184L12.5821 22.7974C12.2099 22.9541 11.7901 22.9541 11.4179 22.7974L2.91791 19.2184C2.36169 18.9842 2 18.4395 2 17.836V6.16398C2 5.56046 2.3617 5.01572 2.91792 4.78152L11.4179 1.20263C11.7901 1.0459 12.2099 1.0459 12.5821 1.20263ZM11.806 2.12426L8.63748 3.45835L16.4999 6.95277L19.9841 5.40425L12.194 2.12426C12.07 2.07202 11.93 2.07202 11.806 2.12426ZM7.37309 3.99071L4.0159 5.40425L11.3908 8.68197C11.7786 8.85435 12.2214 8.85435 12.6092 8.68198L15.2688 7.49993L7.37309 3.99071ZM16 8.26927L13.0153 9.59579C12.8486 9.6699 12.6758 9.72489 12.5 9.76076V21.747L20.694 18.2968C20.8794 18.2187 21 18.0371 21 17.836V6.16398C21 6.12597 20.9957 6.08866 20.9875 6.05262L17 7.82483V11C17 11.2761 16.7761 11.5 16.5 11.5C16.2239 11.5 16 11.2761 16 11V8.26927ZM3.01253 6.05262C3.0043 6.08866 3 6.12597 3 6.16398V17.836C3 18.0371 3.12056 18.2187 3.30597 18.2968L11.5 21.747V9.76076C11.3242 9.72489 11.1514 9.6699 10.9847 9.59579L3.01253 6.05262Z",
	fill: "currentColor"
};
function ki(e, t) {
	return A(), o("path", Oi);
}
var Ai = /*#__PURE__*/ W(Di, [["render", ki]]), ji = {};
function Mi(t, n) {
	return A(), o(e, null, [
		n[0] ||= s("path", {
			d: "M 2.519 4.89 L 21.48 4.89 L 21.48 19.11 L 2.519 19.11 L 2.519 4.89 Z",
			fill: "#012169"
		}, null, -1),
		n[1] ||= s("path", {
			d: "M 4.741 4.89 L 11.97 10.253 L 19.169 4.89 L 21.48 4.89 L 21.48 6.727 L 14.37 12.029 L 21.48 17.303 L 21.48 19.11 L 19.109 19.11 L 11.999 13.809 L 4.918 19.11 L 2.519 19.11 L 2.519 17.333 L 9.598 12.061 L 2.519 6.787 L 2.519 4.89 L 4.741 4.89 Z",
			fill: "#FFF"
		}, null, -1),
		n[2] ||= s("path", {
			d: "M 15.08 13.215 L 21.48 17.927 L 21.48 19.11 L 13.451 13.215 L 15.08 13.215 Z M 9.629 13.809 L 9.806 14.845 L 4.118 19.11 L 2.519 19.11 L 9.629 13.809 Z M 21.48 4.89 L 21.48 4.98 L 14.103 10.548 L 14.163 9.246 L 19.998 4.89 L 21.48 4.89 Z M 2.519 4.89 L 9.598 10.104 L 7.822 10.104 L 2.519 6.135 L 2.519 4.89 Z",
			fill: "#C8102E"
		}, null, -1),
		n[3] ||= s("path", {
			d: "M 9.658 4.89 L 9.658 19.11 L 14.398 19.11 L 14.398 4.89 L 9.658 4.89 Z M 2.519 9.631 L 2.519 14.371 L 21.48 14.371 L 21.48 9.631 L 2.519 9.631 Z",
			fill: "#FFF"
		}, null, -1),
		n[4] ||= s("path", {
			d: "M 2.519 10.607 L 2.519 13.453 L 21.48 13.453 L 21.48 10.607 L 2.519 10.607 Z M 10.607 4.89 L 10.607 19.11 L 13.451 19.11 L 13.451 4.89 L 10.607 4.89 Z",
			fill: "#C8102E"
		}, null, -1)
	], 64);
}
var Ni = /*#__PURE__*/ W(ji, [["render", Mi]]), Pi = {};
function Fi(t, n) {
	return A(), o(e, null, [n[0] ||= s("g", { "clip-path": "url(#clip0_2900_4456)" }, [
		s("rect", {
			fill: "#002654",
			height: "12",
			width: "6",
			x: "3",
			y: "6"
		}),
		s("rect", {
			fill: "white",
			height: "12",
			width: "6",
			x: "9",
			y: "6"
		}),
		s("rect", {
			fill: "#ED2939",
			height: "12",
			width: "6",
			x: "15",
			y: "6"
		})
	], -1), n[1] ||= s("defs", null, [s("clipPath", { id: "clip0_2900_4456" }, [s("rect", {
		fill: "white",
		height: "12",
		transform: "translate(3 6)",
		width: "18"
	})])], -1)], 64);
}
var Ii = /*#__PURE__*/ W(Pi, [["render", Fi]]), Li = {};
function Ri(t, n) {
	return A(), o(e, null, [
		n[0] ||= s("rect", {
			fill: "#C8102E",
			height: "4",
			width: "18",
			x: "3",
			y: "6"
		}, null, -1),
		n[1] ||= s("rect", {
			fill: "white",
			height: "4",
			width: "18",
			x: "3",
			y: "10"
		}, null, -1),
		n[2] ||= s("rect", {
			fill: "#003DA5",
			height: "4",
			width: "18",
			x: "3",
			y: "14"
		}, null, -1)
	], 64);
}
var zi = /*#__PURE__*/ W(Li, [["render", Ri]]), Bi = {};
function Vi(t, n) {
	return A(), o(e, null, [n[0] ||= s("g", { "clip-path": "url(#clip0_2900_4456)" }, [
		s("rect", {
			fill: "black",
			height: "12",
			width: "6",
			x: "3",
			y: "6"
		}),
		s("rect", {
			fill: "#F8D952",
			height: "12",
			width: "6",
			x: "9",
			y: "6"
		}),
		s("rect", {
			fill: "#DD4547",
			height: "12",
			width: "6",
			x: "15",
			y: "6"
		})
	], -1), n[1] ||= s("defs", null, [s("clipPath", { id: "clip0_2900_4456" }, [s("rect", {
		fill: "white",
		height: "12",
		transform: "translate(3 6)",
		width: "18"
	})])], -1)], 64);
}
var Hi = /*#__PURE__*/ W(Bi, [["render", Vi]]), Ui = {};
function Wi(t, n) {
	return A(), o(e, null, [n[0] ||= s("rect", {
		fill: "#c60b1e",
		height: "12",
		style: {},
		width: "18",
		x: "3",
		y: "6"
	}, null, -1), n[1] ||= s("rect", {
		fill: "#ffc400",
		height: "6",
		style: {},
		width: "18",
		x: "3",
		y: "9.001"
	}, null, -1)], 64);
}
var Gi = /*#__PURE__*/ W(Ui, [["render", Wi]]), Ki = {};
function qi(t, n) {
	return A(), o(e, null, [
		n[0] ||= s("rect", {
			fill: "#139149",
			height: "12",
			width: "6",
			x: "3",
			y: "6"
		}, null, -1),
		n[1] ||= s("rect", {
			fill: "white",
			height: "12",
			width: "6",
			x: "9",
			y: "6"
		}, null, -1),
		n[2] ||= s("rect", {
			fill: "#CC2E3B",
			height: "12",
			width: "6",
			x: "15",
			y: "6"
		}, null, -1)
	], 64);
}
var Ji = /*#__PURE__*/ W(Ki, [["render", qi]]), Yi = {};
function Xi(t, n) {
	return A(), o(e, null, [
		n[0] ||= s("rect", {
			fill: "black",
			height: "4",
			width: "18",
			x: "3",
			y: "6"
		}, null, -1),
		n[1] ||= s("rect", {
			fill: "#DD4547",
			height: "4",
			width: "18",
			x: "3",
			y: "10"
		}, null, -1),
		n[2] ||= s("rect", {
			fill: "#F8D952",
			height: "4",
			width: "18",
			x: "3",
			y: "14"
		}, null, -1)
	], 64);
}
var Zi = /*#__PURE__*/ W(Yi, [["render", Xi]]), Qi = {}, $i = {
	d: "M5 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 5 12Z",
	fill: "currentColor"
};
function ea(e, t) {
	return A(), o("path", $i);
}
var ta = /*#__PURE__*/ W(Qi, [["render", ea]]), na = {}, ra = {
	d: "M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8Z",
	fill: "currentColor"
};
function ia(e, t) {
	return A(), o("path", ra);
}
var aa = /*#__PURE__*/ W(na, [["render", ia]]), oa = {}, sa = {
	"clip-path": "url(#a)",
	filter: "url(#b)"
};
function ca(e, t) {
	return A(), o("g", sa, [...t[0] ||= [
		s("rect", {
			fill: "#341B14",
			height: "72",
			rx: "36",
			width: "72",
			x: "6",
			y: "2"
		}, null, -1),
		s("path", {
			d: "M42 55.516c.305-.152 8.224-3.579 10.737-5.635 2.588-2.132 3.959-5.177 3.959-8.832V23.917l-.228-.076c-6.32-3.427-14.163-3.198-14.544-3.198-.304 0-8.147-.229-14.466 3.198l-.153.076v17.208c0 3.655 1.37 6.7 3.96 8.833C33.777 52.013 41.696 55.44 42 55.516Z",
			fill: "#341B14"
		}, null, -1),
		s("path", {
			d: "M42 55.897s-8.376-3.655-10.965-5.711C28.295 47.902 27 44.78 27 41.2V23.384c6.624-3.579 15-3.274 15-3.274s8.376-.305 15 3.274v17.74c0 3.58-1.294 6.701-4.035 8.986C50.374 52.242 42 55.897 42 55.897ZM28.218 41.2c0 3.35 1.218 6.091 3.579 7.995 2.132 1.751 8.452 4.569 10.203 5.33 1.751-.762 8.147-3.655 10.203-5.33 2.36-1.904 3.579-4.72 3.579-7.995V23.688c-8.833-.837-19.34-.38-27.564 7.234v10.28Z",
			fill: "#FFB406"
		}, null, -1),
		s("path", {
			d: "M50.452 38.688c1.142.686 1.6 1.142 1.675 1.98 0 .914-.609 1.447-1.599 1.447-.837 0-1.827-.457-2.512-1.066v2.436c.837.457 1.827.838 2.893.838 2.589 0 3.807-1.828 3.807-3.503.076-1.523-.38-2.74-2.589-4.035-.99-.61-1.751-.99-1.751-1.904 0-.913.838-1.294 1.523-1.294.914 0 1.827.533 2.36 1.066v-2.284c-.457-.381-1.446-.914-2.893-.838-1.751.076-3.579 1.294-3.579 3.426.076 1.447.533 2.513 2.665 3.731Zm-8.985 5.483c.229.076.61.152 1.219.152 2.97 0 4.644-2.665 4.644-6.472 0-3.883-1.75-6.244-4.873-6.244-1.447 0-2.589.305-3.578.914v17.208h2.588v-5.558Zm0-10.356c.229-.076.61-.228.914-.228 1.523 0 2.132 1.218 2.132 4.188 0 2.893-.761 4.264-2.284 4.264-.38 0-.685-.077-.838-.153v-8.07h.076Zm-7.995 10.508c1.6 0 2.97-.38 3.96-1.066V31.759h-2.665v9.975c-.305.228-.685.305-1.218.305-1.219 0-1.371-1.142-1.371-1.828V31.76h-2.665v8.3c0 2.817 1.37 4.264 3.96 4.264Z",
			fill: "#FFB406"
		}, null, -1),
		s("rect", {
			fill: "#341B14",
			height: "12",
			rx: "6",
			width: "12",
			x: "36",
			y: "78"
		}, null, -1)
	]]);
}
var la = /*#__PURE__*/ W(oa, [["render", ca]]), ua = {}, da = { "clip-path": "url(#a)" };
function fa(e, t) {
	return A(), o("g", da, [...t[0] ||= [s("rect", {
		fill: "#D90B37",
		height: "44",
		rx: "22",
		width: "44"
	}, null, -1), s("g", { "clip-path": "url(#b)" }, [s("path", {
		d: "M22.063 11.715h-.065a.832.832 0 0 0-.184.026l-.004-.005a.41.41 0 0 1-.024.011l-.04.01.005.005a.252.252 0 0 0-.067.037l-.072.036-.012-.015-.232.127-.19.105v.002l-.19.104h.001l-.191.105-.136.075-.01-.012-.182.115-.01-.01-.231.127.001.001-.19.104v.001l-.19.105v.002l-.189.103-.137.076-.011-.013-.253.127.006.007-.196.098.006.007-.196.098.006.008-.195.098.006.007-.197.098.006.007-.125.063-.006-.007-.253.127.006.007-.196.098.006.007-.154.078h-.002l-.04.02v.002l-.19.104.001.002-.19.103.001.002-.137.074-.01-.012-.233.126h.001l-.191.106v.001l-.19.104h.001l-.191.105v.002l-.189.103.001.002-.137.075-.011-.013-.232.126v.001l-.19.104v.002l-.19.104v.002l-.19.103.001.002-.19.104.001.002-.138.075-.012-.014-.232.126.002.002-.19.104h.001l-.192.105.002.002-.19.104-.19.105v.001l-.137.075-.01-.013-.254.126.009.01-.094.054.25.138.025.03.664.363.43.247.001.002.675.4-.022-.026.429.242.014.016.538.303.012.013.556.313.664.383.4.229.001.003.042.022.107.062-.005-.006.377.206.027.032.534.3.014.016.674.379-.016-.02.564.336-.016-.019.565.336-.021-.025.39.219.032.037.517.282.03.035.586.32.152.101c.073.036.146.12.165.21l-.019-.02c0 .01.006.02.011.031.005.01.01.021.01.032v.358l.002.002v.884h-.001v1.369l.001.002v.253l-.001-.002v.4l.001.003v.253l-.001-.003v.634-.001V26.828v-.002.738l.001.001v.232-.001.337h-.001v.4l.001.001V29.356a.16.16 0 0 1-.017.067l-.005-.004a.28.28 0 0 1-.008.025.119.119 0 0 1-.013.017l.005.005a.291.291 0 0 1-.103.129l-.007-.008v.012a.132.132 0 0 1-.021.01l-.145.086-.003-.002-.186.108-.003-.003-.148.084c-.042.021-.084.021-.127.021l.012.014a.123.123 0 0 1-.033.007H22a.304.304 0 0 1-.148-.042l-.039-.017-.003-.004-.464-.253a.293.293 0 0 1-.148-.253v-2.382h.001v-.97.001-.737l-.001-.001v-.233.002-.991h.001v-.4l-.001-.002v-.232l.002.002v-.4l-.002-.003v-.252l.002.002v-.232c0-.042-.043-.106-.085-.127l-.314-.185-.003-.005-.13-.074-.016-.01-.398-.229-.003-.002-.051-.029-.098-.056.005.006-.38-.207-.026-.03-.674-.38.015.017-.562-.333.017.02-.565-.336.02.024-.387-.218-.033-.038-.696-.38.001.001-.4-.23-.002-.002-.674-.4.02.023-.43-.242-.012-.014-.674-.379.016.019-.564-.335.015.018-.41-.244-.005-.006-.058-.031-.09-.053.008.008-.38-.207-.028-.033-.169-.085V26.826c0 .127.054.27.133.386l-.006-.006.006.006a.65.65 0 0 0 .183.183l.492.267.413.238.001.001.513.295.035.042.52.284.028.033.696.4-.016-.019.564.335-.02-.022.44.253h.001l.548.316.547.315.001.002.547.315.001.001.553.318.016.02.675.4-.016-.018.564.334-.02-.023.44.253.001.002.547.314.001.002.295.169a.449.449 0 0 0 .187.06l.003.003h.064-.001.063c.047 0 .094 0 .14-.009l.008.009.19-.063.063-.043h-.001l.19-.105v-.001l.19-.104-.008-.01.177-.096-.001-.001.19-.104-.003-.004.142-.09.009.01.181-.116.009.01.18-.115.01.01.231-.148-.008-.009.177-.096-.001-.001.19-.104v-.002l.19-.104v-.001l.19-.104-.001-.001.191-.105-.008-.01.176-.095-.001-.001.19-.104-.002-.004.142-.09.008.01.18-.116.01.01.168-.107.001.001.232-.147-.001-.002.19-.103v-.002l.19-.104h-.001l.191-.105-.001-.002.19-.103-.008-.009.178-.097-.002-.002.19-.103-.003-.003.143-.09.008.009.181-.116.009.01.167-.106.233-.147-.002-.001.192-.104-.001-.001.191-.104-.001-.002.19-.104v-.001l.19-.104-.008-.01.176-.096H28.7l.192-.105-.002-.002.19-.103-.002-.004.142-.09.009.01.167-.107h.001l.18-.114.01.01.23-.148v-.001l.19-.105.19-.105v-.001l.191-.104-.008-.01.163-.089.14-.07.02-.021h.001c.042-.028.084-.075.127-.122.02-.023.042-.047.063-.068l-.007-.008a.67.67 0 0 0 .09-.202l-.004-.006a.481.481 0 0 0 .026-.142v-.718.002V24.402l-.002-.002v-.252l.002.001v-.97.001-1.054h-.001v-.233l.002.002v-.4l-.001-.002v-1.621l-.001-.002v-.253l.001.002v-.634.001-.738l-.001-.001v-.232.002-.253l-.081.046-.004-.005-.18.116-.008-.01-.232.147.001.002-.19.104-.191.105.002.002-.19.104-.192.105.007.008-.195.098.008.009-.177.096.001.001-.191.105-.189.104.001.002-.191.104.001.002-.19.104-.191.105.008.01-.176.095.003.004-.142.09-.008-.01-.182.116-.008-.01-.181.115-.008-.01-.182.116-.009-.01-.168.107-.002-.002-.232.148.002.002-.19.103h.002l-.192.105.002.002-.191.104h.001l-.191.105.001.002-.19.104.008.008-.178.097.002.001-.19.104v.002l-.19.104.003.003-.13.081a.046.046 0 0 0-.017.004l-.004-.004a.365.365 0 0 1-.263.013l-.011-.013h-.02l-.106-.085.037.044-.417-.254c-.027-.014-.046-.036-.067-.062l-.038-.044c-.027-.04-.037-.07-.046-.1-.005-.016-.01-.031-.018-.047v-.149l.001.001v-.422c0-.051.027-.116.06-.172l.003.004a.164.164 0 0 1 .085-.084l.076-.051.008.009.167-.106.183-.116.009.011.18-.114.008.009.182-.116.008.01.232-.147-.001-.002.19-.104.191-.105-.009-.01.175-.095v-.001l.191-.105.19-.105v-.002l.19-.103-.001-.001.191-.105-.001-.001.19-.104-.006-.008.196-.098-.008-.01.176-.095.191-.105-.002-.002.19-.104-.002-.003.142-.09.008.01.168-.108.002.002.186-.11.003.004.18-.114.008.009.232-.148.191-.105-.001-.002.19-.104.19-.105-.006-.008.196-.097-.008-.01.176-.096h-.001l.191-.105.19-.105v-.002l.19-.104-.002-.001.148-.083-.396-.207-.004-.004-.497-.265-.007-.009-.525-.27-.003-.004-.5-.267-.007-.007-.497-.265-.008-.009-.523-.27-.003-.004-.5-.267-.007-.007-.498-.266-.007-.007-.526-.272-.002-.003-.497-.264-.007-.01-.486-.25-.02-.024-.526-.271-.002-.002-.497-.265-.008-.01-.653-.358.006.007-.513-.281.027.03-.401-.213-.006-.007-.108-.054-.017-.009.001.001h-.002a.583.583 0 0 0-.271-.083l-.002-.002Z",
		fill: "#fff"
	})], -1)]]);
}
var pa = /*#__PURE__*/ W(ua, [["render", fa]]), ma = {}, ha = {
	"clip-path": "url(#a)",
	filter: "url(#b)"
};
function ga(e, t) {
	return A(), o("g", ha, [...t[0] ||= [
		s("rect", {
			fill: "#D90B37",
			height: "72",
			rx: "36",
			width: "72",
			x: "6",
			y: "2"
		}, null, -1),
		s("g", { "clip-path": "url(#c)" }, [s("path", {
			d: "M42.105 20.858h-.107c-.103 0-.206.02-.308.043l-.007-.007a1.081 1.081 0 0 1-.04.018l-.065.016.007.01a.422.422 0 0 0-.112.06l-.12.06-.02-.024-.387.21.002.002-.32.174.003.003-.317.173.001.001-.319.174.002.002-.228.124-.018-.02-.303.192-.014-.017-.387.211.002.002-.317.174.001.002-.319.173.003.004-.316.172v.001l-.23.126-.017-.022-.422.211.01.013-.326.163.01.012-.327.164.01.012-.325.163.01.012-.328.163.01.012-.21.105-.009-.011-.421.21.01.013-.328.163.01.012-.256.129-.003.001-.067.034.002.002-.319.174.003.002-.318.174.002.002-.228.124-.018-.021-.386.21v.002l-.319.174.003.003-.318.173.002.002-.32.174.002.002-.316.173.002.002-.23.126-.018-.022-.386.21.001.002-.319.174.002.002-.318.173.002.003-.317.173.002.002-.319.174.003.003-.23.125-.02-.023-.386.21.003.004-.316.172v.002l-.32.174.004.003-.317.173.001.002-.319.174.002.002-.228.124-.019-.022-.421.211.014.017-.157.09.417.229.042.05 1.107.604.716.412.003.004 1.124.667-.037-.043.715.402.023.027.898.505.019.022.927.522 1.107.637.665.383.004.004.07.038.177.102-.008-.01.629.343.045.054.89.5.022.026 1.124.633-.027-.032.941.559-.027-.032.942.559-.036-.042.65.366.053.062.863.47.048.057.978.534.254.169c.121.06.243.2.273.35l-.03-.034c0 .017.01.035.018.053a.124.124 0 0 1 .018.052v.597l.002.003v.385-.001V39.582l-.002-.002v1.23l.001.001v1.053l.002.002v.422l-.003-.003v.668l.003.003v.422l-.003-.004v.668l.002.002v.386l-.001-.002V46.047l-.001-.003v1.229l.002.002v.386l-.001-.002v1.23l.001.002v.386l-.001-.002v.983c0 .04-.012.081-.028.115l-.007-.009a.493.493 0 0 1-.013.043.203.203 0 0 1-.022.027l.008.01a.484.484 0 0 1-.173.214l-.011-.013v.02a.21.21 0 0 1-.035.015l-.242.145-.004-.004-.311.181-.005-.005-.246.14c-.07.035-.14.035-.21.035l.019.023a.205.205 0 0 1-.055.013H42c-.105 0-.176-.035-.246-.07l-.064-.03-.006-.006-.773-.422a.487.487 0 0 1-.246-.421v-3.971l.002.002v-.668l-.002-.002v-.948l.002.001v-.702l-.002-.002v-.524l-.001-.002v-.388l.002.003v-1.23h-.001v-.422l.001.001v-.667l-.002-.002v-.388l.003.003v-.667l-.003-.003v-.422l.003.003v-.386c0-.07-.07-.176-.14-.21l-.524-.31-.006-.007-.217-.125-.026-.015-.663-.382-.005-.005-.086-.047-.162-.093.008.009-.633-.345-.043-.05-1.124-.633.025.03-.936-.557.028.033-.943-.56.035.042-.646-.364-.055-.065-1.16-.632.002.002-.667-.384-.003-.004-1.124-.667.034.04-.716-.403-.02-.024-1.124-.632.027.031-.94-.558.025.03-.685-.407-.008-.01-.095-.051-.15-.089.012.014-.633-.346-.047-.054-.281-.14V46.043c0 .212.09.449.222.642l-.01-.01.01.011c.088.128.194.236.305.305l.82.444.688.397.002.002.854.492.06.07.866.473.047.054 1.16.668-.027-.032.94.559-.032-.038.733.422v.002l.913.525.001.001.911.525.002.003.912.525.002.001.92.53.028.032 1.124.668-.026-.03.94.557-.033-.038.733.422.002.002.91.525.003.002.492.281a.745.745 0 0 0 .311.1l.005.005H42c.078 0 .156 0 .233-.014l.013.015.316-.106.105-.07-.001-.002.318-.173-.003-.003.319-.174-.013-.015.294-.16-.002-.002.318-.174-.005-.006.236-.15.015.016.302-.192.014.016.302-.192.014.017.386-.246-.013-.016.294-.16-.002-.002.319-.174-.003-.002.319-.173-.002-.003.318-.173-.002-.002.32-.173-.015-.017.293-.16-.001-.001.318-.174-.005-.006.237-.15.014.016.3-.192.015.017.28-.18.003.003.386-.246-.002-.002.318-.173-.002-.002.317-.173-.001-.002.319-.174-.003-.003.317-.173-.012-.014.296-.162-.003-.003.316-.172-.004-.005.237-.151.014.015.302-.192.014.017.279-.178.001.002.387-.246-.002-.002.318-.174v-.001l.318-.174-.002-.002.317-.173-.002-.003.319-.174-.013-.015.292-.16-.001-.001.32-.174-.003-.003.317-.173-.005-.006.238-.15.014.015.279-.177.002.002.3-.192.014.016.387-.246-.002-.002.318-.174-.001-.002.318-.173-.002-.002.32-.174-.015-.017.271-.148.233-.116.036-.036c.071-.046.141-.124.212-.202.035-.04.07-.078.105-.113l-.012-.014c.073-.113.123-.225.151-.337l-.008-.01a.803.803 0 0 0 .045-.236v-.808l-.002-.002v-.388l.003.004v-.703l-.003-.003v-.385l.001.001v-1.09l.001.001v-.667L56.995 42v-.42l.003.003v-.528.001-1.09.001-1.756l-.002-.002v-.388l.003.004v-.668l-.001-.001v-1.088l-.001-.002v-.386l.002.002v-1.229l-.003-.003v-.422l.003.003v-.667l-.002-.002v-.387l.002.002v-.668h-.001v-.562l-.002-.002v-.386l.002.002v-.422l-.137.078-.005-.008-.302.192-.013-.016-.386.246.002.003-.317.173v.001l-.318.174.003.003-.318.174h.001l-.32.175.012.013-.325.163.013.015-.294.16.001.002-.319.174.002.002-.316.173.001.002-.318.174.002.003-.317.173-.319.175.014.016-.293.16.005.006-.236.15-.014-.016-.303.193-.015-.017-.301.192-.014-.016-.302.192-.015-.017-.28.178-.003-.002-.387.246.003.003-.315.172.001.002-.319.174.003.002-.318.173.001.002-.319.174.003.004-.316.172.012.014-.296.162.002.002-.317.173.002.002-.317.174.004.005-.216.135a.078.078 0 0 0-.029.007l-.005-.007a.608.608 0 0 1-.44.022l-.018-.022h-.034l-.176-.14.062.071-.695-.423c-.046-.023-.076-.06-.111-.102-.02-.024-.04-.048-.065-.073-.044-.067-.06-.119-.075-.166-.009-.028-.017-.054-.03-.08v-.248l.001.002v-.703l-.001-.001c0-.085.046-.193.1-.286l.006.007a.274.274 0 0 1 .141-.14l.127-.086.013.015.278-.177.002.001.304-.193.015.018.3-.191.013.015.303-.193.014.017.387-.246-.002-.002.318-.173-.002-.002.319-.174-.014-.017.291-.159-.001-.001.32-.174-.002-.002.319-.174-.002-.002.317-.173-.002-.002.32-.174-.003-.002.318-.173-.01-.013.326-.163-.014-.016.293-.16.319-.175-.003-.003.318-.173-.006-.006.237-.15.014.016.28-.179.002.003.311-.182.006.007.3-.192.013.016.387-.246-.001-.001.32-.175-.004-.003.318-.173-.001-.001.319-.174-.011-.013.326-.163-.014-.016.293-.16v-.001l.318-.174-.001-.002.319-.174-.003-.003.316-.172-.002-.003.248-.138-.66-.344-.007-.007-.828-.442-.013-.015-.875-.451-.004-.006-.835-.445-.01-.012-.83-.442-.011-.014-.872-.45-.006-.006-.834-.445-.01-.012-.83-.443-.012-.013-.877-.453-.003-.004-.828-.442-.013-.015-.81-.417-.033-.04-.877-.452-.003-.004-.828-.442-.013-.015-1.09-.598.011.013-.854-.469.044.051-.668-.356-.01-.011-.18-.09-.028-.015.002.002-.004-.002a.973.973 0 0 0-.452-.137l-.003-.004Z",
			fill: "#fff"
		})], -1),
		s("rect", {
			fill: "#D90B37",
			height: "12",
			rx: "6",
			width: "12",
			x: "36",
			y: "78"
		}, null, -1)
	]]);
}
var _a = /*#__PURE__*/ W(ma, [["render", ga]]), va = {}, ya = { "clip-path": "url(#a)" };
function ba(e, t) {
	return A(), o("g", ya, [...t[0] ||= [s("rect", {
		fill: "#3544B3",
		height: "44",
		rx: "22",
		width: "44"
	}, null, -1), s("g", { "clip-path": "url(#b)" }, [s("path", {
		d: "M17.754 20.605c-1.035 0-1.867.574-1.867 1.866 0 1.264.832 1.867 1.867 1.867 1.032 0 1.866-.603 1.866-1.867 0-1.292-.834-1.866-1.866-1.866Zm0 2.845c-.462 0-.809-.351-.809-.979 0-.682.347-.98.81-.98.46 0 .806.298.806.98 0 .628-.347.979-.807.979Zm6.726-2.813c0 .02.015.035.034.035h.785c.063 0 .113.051.113.112v.68c0 .02-.015.035-.034.035h-.864a.034.034 0 0 0-.034.034v1.32c0 .506.191.656.511.656.15 0 .386-.092.42-.092.02 0 .036.015.036.034v.65a.11.11 0 0 1-.06.1c-.142.077-.381.13-.736.13-.619 0-1.194-.313-1.194-1.308V20.73a.8.8 0 0 1 .206-.534c.167-.185.704-.53.774-.53.03 0 .043.009.043.037v.935Zm-12.487.15c0-.064.051-.114.115-.114h1.361c1.337 0 2.03.802 2.03 1.84 0 1.04-.775 1.76-2.051 1.76h-.398a.035.035 0 0 0-.035.035v1.683c0 .029-.012.038-.043.038-.07 0-.607-.346-.774-.53a.804.804 0 0 1-.205-.534v-4.177Zm2.496 1.674c0-.442-.286-.856-1.04-.856h-.4a.034.034 0 0 0-.035.036v1.66c0 .02.015.036.034.036h.42c.9 0 1.021-.625 1.021-.876Zm8.442.702c0 .758-.545 1.175-1.608 1.175-.608 0-1.25-.214-1.256-.216a.12.12 0 0 1-.08-.11v-.707c0-.024.02-.042.045-.042l.014.003c.227.073.963.256 1.354.256.232 0 .353-.035.43-.113a.24.24 0 0 0 .078-.179c0-.23-.29-.295-.571-.357-.035-.007-.02-.003-.115-.026-.615-.145-1.264-.295-1.264-1.088 0-.352.147-.643.423-.846.275-.202.671-.308 1.147-.308.427 0 .934.14 1.104.195a.119.119 0 0 1 .084.112v.705c-.002.033-.036.048-.06.039a3.677 3.677 0 0 0-1.252-.247c-.254 0-.419.11-.419.281 0 .197.24.25.546.32.037.007.203.045.246.054.25.056.507.112.719.25.293.192.435.469.435.849Zm5.51 1.097a.022.022 0 0 1-.02-.022v-2.145c0-.476-.163-.68-.542-.68-.136 0-.3.051-.462.144-.162.094-.288.171-.334.198a.065.065 0 0 0-.026.047v2.437c0 .012-.01.022-.021.022h-.957c-.011 0-.022-.01-.022-.022v-3.45c0-.057.046-.103.103-.103h.876c.012 0 .023.01.023.022v.271c0 .016.014.03.03.03a.038.038 0 0 0 .017-.006l.029-.021c.107-.082.271-.176.381-.218.24-.091.498-.145.708-.145.782 0 1.195.45 1.195 1.298v2.32c0 .013-.01.022-.023.022h-.954Zm1.767 0a.022.022 0 0 1-.022-.022v-5.284c0-.02.004-.025.03-.025.06 0 .593.336.765.525a.789.789 0 0 1 .202.526v4.258c0 .012-.01.022-.022.022h-.953Zm-12.454-9.186a.104.104 0 0 0-.057.019 2.28 2.28 0 0 0-.425.418c-.036.04-.036.088.002.137.116.15.25.285.396.4a.13.13 0 0 0 .083.032.13.13 0 0 0 .082-.033c.146-.115.28-.25.397-.4.038-.048.038-.095 0-.139a2.219 2.219 0 0 0-.42-.414.103.103 0 0 0-.059-.02Zm0 1.296c-.077 0-.159.002-.243.005-.03 0-.057.01-.078.033a.165.165 0 0 0-.041.109l.02 1.594.007.47c0 .04.029.122.119.122h.432c.065 0 .109-.045.118-.117v-.006l.026-2.036v-.025a.161.161 0 0 0-.04-.11.105.105 0 0 0-.08-.032 4.392 4.392 0 0 0-.24-.007Zm1.098.118c-.1 0-.181.055-.224.15a5.68 5.68 0 0 0-.302.845c-.01.037-.007.068.01.09.012.016.036.034.083.034h.338c.076 0 .104-.04.115-.074.055-.188.095-.298.166-.453 0-.002.006-.012.027-.012.008 0 .016.001.024.004l.172.057c.02.007.033.024.039.038a.123.123 0 0 1 .005.087c-.002.006-.347.971-.45 1.293-.015.05-.013.088.007.117.02.027.052.04.097.04h.419c.068 0 .113-.027.133-.082l.063-.174.01-.027c.125-.35.316-.882.357-1.033.068-.256.087-.536-.288-.675a5.894 5.894 0 0 0-.336-.114c-.132-.04-.26-.07-.371-.096l-.014-.004a.305.305 0 0 0-.08-.01Zm-2.197 0a.297.297 0 0 0-.074.01l-.017.003a5.48 5.48 0 0 0-.707.21c-.376.14-.356.42-.287.675.039.146.216.644.366 1.06l.062.174c.02.055.065.082.134.082h.418c.057 0 .084-.021.097-.04.021-.027.023-.066.008-.116a71.587 71.587 0 0 0-.452-1.292.123.123 0 0 1 .006-.088.07.07 0 0 1 .04-.038l.172-.057a.086.086 0 0 1 .023-.003c.017 0 .025.008.027.012.071.16.112.27.165.453.01.034.038.074.115.074h.34c.036 0 .064-.01.081-.034.017-.022.021-.052.01-.089a5.786 5.786 0 0 0-.302-.846.243.243 0 0 0-.225-.15Zm2.638 2.536h-3.074a.201.201 0 0 0-.199.198v.387c0 .121.052.18.159.18h3.154c.107 0 .159-.059.159-.18v-.387a.201.201 0 0 0-.2-.198Zm14.802 2.99c-.003-2.157-4.058-5.896-8.378-8.277-4.984-2.749-10.655-4.368-12.523-3.339-2.13 1.175-3.296 7.04-3.297 11.617 0 4.614 1.1 10.404 3.297 11.615 1.99 1.098 7.415-.522 12.523-3.337 4.388-2.42 8.375-6.015 8.378-8.278ZM14.69 9.038c3.145 0 8.184 1.988 11.534 3.836 1.917 1.056 4.092 2.598 5.775 4.167 1.615 1.505 3.14 3.379 3.142 4.975-.003 1.503-1.223 3.266-3.187 5.066-1.668 1.528-3.833 3.03-5.73 4.076-3.236 1.784-8.169 3.868-11.42 3.868-.884 0-1.61-.153-2.157-.455-1.44-.793-2.363-2.931-2.908-5.026-.585-2.248-.886-4.951-.887-7.528 0-2.522.325-5.231.892-7.435.69-2.683 1.695-4.454 2.903-5.12.507-.282 1.195-.424 2.043-.424Z",
		fill: "#fff"
	})], -1)]]);
}
var xa = /*#__PURE__*/ W(va, [["render", ba]]), Sa = {}, Ca = { "clip-path": "url(#a)" };
function wa(e, t) {
	return A(), o("g", Ca, [...t[0] ||= [
		s("rect", {
			fill: "#F36920",
			height: "44",
			rx: "22",
			width: "44"
		}, null, -1),
		s("path", {
			d: "M6 6h32v32H6z",
			fill: "#F36920"
		}, null, -1),
		s("g", { "clip-path": "url(#b)" }, [s("path", {
			d: "M17.754 20.605c-1.035 0-1.867.574-1.867 1.866 0 1.264.832 1.867 1.867 1.867 1.032 0 1.866-.603 1.866-1.867 0-1.292-.834-1.866-1.866-1.866Zm0 2.845c-.462 0-.809-.351-.809-.979 0-.682.347-.98.81-.98.46 0 .806.298.806.98 0 .628-.347.979-.807.979Zm6.726-2.813c0 .02.015.035.034.035h.785c.063 0 .113.051.113.112v.68c0 .02-.015.035-.034.035h-.864a.034.034 0 0 0-.034.034v1.32c0 .506.191.656.511.656.15 0 .386-.092.42-.092.02 0 .036.015.036.034v.65a.11.11 0 0 1-.06.1c-.142.077-.381.13-.736.13-.619 0-1.194-.313-1.194-1.308V20.73a.8.8 0 0 1 .206-.534c.167-.185.704-.53.774-.53.03 0 .043.009.043.037v.935Zm-12.487.15c0-.064.051-.114.115-.114h1.361c1.337 0 2.03.802 2.03 1.84 0 1.04-.775 1.76-2.051 1.76h-.398a.035.035 0 0 0-.035.035v1.683c0 .029-.012.038-.043.038-.07 0-.607-.346-.774-.53a.804.804 0 0 1-.205-.534v-4.177Zm2.496 1.674c0-.442-.286-.856-1.04-.856h-.4a.034.034 0 0 0-.035.036v1.66c0 .02.015.036.034.036h.42c.9 0 1.021-.625 1.021-.876Zm8.442.702c0 .758-.545 1.175-1.608 1.175-.608 0-1.25-.214-1.256-.216a.12.12 0 0 1-.08-.11v-.707c0-.024.02-.042.045-.042l.014.003c.227.073.963.256 1.354.256.232 0 .353-.035.43-.113a.24.24 0 0 0 .078-.179c0-.23-.29-.295-.571-.357-.035-.007-.02-.003-.115-.026-.615-.145-1.264-.295-1.264-1.088 0-.352.147-.643.423-.846.275-.202.671-.308 1.147-.308.427 0 .934.14 1.104.195a.119.119 0 0 1 .084.112v.705c-.002.033-.036.048-.06.039a3.677 3.677 0 0 0-1.252-.247c-.254 0-.419.11-.419.281 0 .197.24.25.546.32.037.007.203.045.246.054.25.056.507.112.719.25.293.192.435.469.435.849Zm5.51 1.097a.022.022 0 0 1-.02-.022v-2.145c0-.476-.163-.68-.542-.68-.136 0-.3.051-.462.144-.162.094-.288.171-.334.198a.065.065 0 0 0-.026.047v2.437c0 .012-.01.022-.021.022h-.957c-.011 0-.022-.01-.022-.022v-3.45c0-.057.046-.103.103-.103h.876c.012 0 .023.01.023.022v.271c0 .016.014.03.03.03a.038.038 0 0 0 .017-.006l.029-.021c.107-.082.271-.176.381-.218.24-.091.498-.145.708-.145.782 0 1.195.45 1.195 1.298v2.32c0 .013-.01.022-.023.022h-.954Zm1.767 0a.022.022 0 0 1-.022-.022v-5.284c0-.02.004-.025.03-.025.06 0 .593.336.765.525a.789.789 0 0 1 .202.526v4.258c0 .012-.01.022-.022.022h-.953Zm-12.454-9.186a.104.104 0 0 0-.057.019 2.28 2.28 0 0 0-.425.418c-.036.04-.036.088.002.137.116.15.25.285.396.4a.13.13 0 0 0 .083.032.13.13 0 0 0 .082-.033c.146-.115.28-.25.397-.4.038-.048.038-.095 0-.139a2.219 2.219 0 0 0-.42-.414.103.103 0 0 0-.059-.02Zm0 1.296c-.077 0-.159.002-.243.005-.03 0-.057.01-.078.033a.165.165 0 0 0-.041.109l.02 1.594.007.47c0 .04.029.122.119.122h.432c.065 0 .109-.045.118-.117v-.006l.026-2.036v-.025a.161.161 0 0 0-.04-.11.105.105 0 0 0-.08-.032 4.392 4.392 0 0 0-.24-.007Zm1.098.118c-.1 0-.181.055-.224.15a5.68 5.68 0 0 0-.302.845c-.01.037-.007.068.01.09.012.016.036.034.083.034h.338c.076 0 .104-.04.115-.074.055-.188.095-.298.166-.453 0-.002.006-.012.027-.012.008 0 .016.001.024.004l.172.057c.02.007.033.024.039.038a.123.123 0 0 1 .005.087c-.002.006-.347.971-.45 1.293-.015.05-.013.088.007.117.02.027.052.04.097.04h.419c.068 0 .113-.027.133-.082l.063-.174.01-.027c.125-.35.316-.882.357-1.033.068-.256.087-.536-.288-.675a5.894 5.894 0 0 0-.336-.114c-.132-.04-.26-.07-.371-.096l-.014-.004a.305.305 0 0 0-.08-.01Zm-2.197 0a.297.297 0 0 0-.074.01l-.017.003a5.48 5.48 0 0 0-.707.21c-.376.14-.356.42-.287.675.039.146.216.644.366 1.06l.062.174c.02.055.065.082.134.082h.418c.057 0 .084-.021.097-.04.021-.027.023-.066.008-.116a71.587 71.587 0 0 0-.452-1.292.123.123 0 0 1 .006-.088.07.07 0 0 1 .04-.038l.172-.057a.086.086 0 0 1 .023-.003c.017 0 .025.008.027.012.071.16.112.27.165.453.01.034.038.074.115.074h.34c.036 0 .064-.01.081-.034.017-.022.021-.052.01-.089a5.786 5.786 0 0 0-.302-.846.243.243 0 0 0-.225-.15Zm2.638 2.536h-3.074a.201.201 0 0 0-.199.198v.387c0 .121.052.18.159.18h3.154c.107 0 .159-.059.159-.18v-.387a.201.201 0 0 0-.2-.198Zm14.802 2.99c-.003-2.157-4.058-5.896-8.378-8.277-4.984-2.749-10.655-4.368-12.523-3.339-2.13 1.175-3.296 7.04-3.297 11.617 0 4.614 1.1 10.404 3.297 11.615 1.99 1.098 7.415-.522 12.523-3.337 4.388-2.42 8.375-6.015 8.378-8.278ZM14.69 9.038c3.145 0 8.184 1.988 11.534 3.836 1.917 1.056 4.092 2.598 5.775 4.167 1.615 1.505 3.14 3.379 3.142 4.975-.003 1.503-1.223 3.266-3.187 5.066-1.668 1.528-3.833 3.03-5.73 4.076-3.236 1.784-8.169 3.868-11.42 3.868-.884 0-1.61-.153-2.157-.455-1.44-.793-2.363-2.931-2.908-5.026-.585-2.248-.886-4.951-.887-7.528 0-2.522.325-5.231.892-7.435.69-2.683 1.695-4.454 2.903-5.12.507-.282 1.195-.424 2.043-.424Z",
			fill: "#fff"
		})], -1)
	]]);
}
var Ta = /*#__PURE__*/ W(Sa, [["render", wa]]), Ea = {}, Da = { "clip-path": "url(#a)" };
function Oa(e, t) {
	return A(), o("g", Da, [...t[0] ||= [
		s("rect", {
			fill: "#341B14",
			height: "44",
			rx: "22",
			width: "44"
		}, null, -1),
		s("path", {
			d: "M21.535 33.736c.204-.102 5.501-2.394 7.182-3.77 1.732-1.426 2.65-3.463 2.65-5.909v-11.46l-.154-.052c-4.228-2.292-9.474-2.14-9.729-2.14-.204 0-5.45-.152-9.679 2.14l-.101.051v11.512c0 2.445.916 4.483 2.648 5.91 1.681 1.375 6.98 3.667 7.183 3.718Z",
			fill: "#341B14"
		}, null, -1),
		s("path", {
			d: "M21.535 33.99s-5.603-2.445-7.335-3.82c-1.834-1.528-2.7-3.617-2.7-6.01V12.24c4.432-2.395 10.035-2.191 10.035-2.191s5.603-.204 10.035 2.19v11.87c0 2.393-.866 4.482-2.7 6.01-1.732 1.427-7.335 3.872-7.335 3.872Zm-9.22-9.83c0 2.24.815 4.074 2.394 5.348 1.427 1.172 5.654 3.056 6.826 3.566 1.172-.51 5.45-2.445 6.826-3.566 1.58-1.274 2.394-3.158 2.394-5.349V12.443c-5.909-.56-12.938-.255-18.44 4.84v6.876Z",
			fill: "#FFB406"
		}, null, -1),
		s("path", {
			d: "M27.19 22.478c.763.459 1.069.764 1.12 1.325 0 .611-.408.968-1.07.968-.56 0-1.222-.306-1.68-.714v1.63c.56.306 1.222.56 1.935.56 1.732 0 2.547-1.222 2.547-2.342.05-1.02-.255-1.834-1.732-2.7-.662-.408-1.172-.662-1.172-1.274 0-.611.56-.866 1.02-.866.61 0 1.222.357 1.578.713V18.25c-.305-.254-.968-.611-1.935-.56-1.172.05-2.395.866-2.395 2.292.051.968.357 1.681 1.783 2.496Zm-6.012 3.668c.153.05.408.102.815.102 1.987 0 3.108-1.783 3.108-4.33 0-2.598-1.172-4.177-3.26-4.177-.968 0-1.732.204-2.395.611v11.512h1.732v-3.718Zm0-6.928c.153-.05.408-.153.612-.153 1.018 0 1.426.815 1.426 2.802 0 1.936-.51 2.853-1.528 2.853-.255 0-.459-.051-.56-.102v-5.4h.05Zm-5.348 7.03c1.07 0 1.986-.255 2.649-.713v-7.692h-1.783v6.673c-.204.153-.459.204-.815.204-.815 0-.917-.764-.917-1.223v-5.654H13.18v5.552c0 1.885.917 2.853 2.649 2.853Z",
			fill: "#FFB406"
		}, null, -1)
	]]);
}
var ka = /*#__PURE__*/ W(Ea, [["render", Oa]]), Aa = {};
function ja(t, n) {
	return A(), o(e, null, [n[0] ||= s("rect", {
		fill: "#FECC00",
		height: "44",
		rx: "22",
		width: "44"
	}, null, -1), n[1] ||= s("path", {
		d: "M13.93 20.816c-.19.256-.505.7-.697.96-.098.132-.274.372.31.372h3.076l.912-1.239c.565-.767.049-2.364-1.973-2.364h-7.96l-1.38 1.875h7.522c.38 0 .375.145.19.396Zm-2.26 1.794c-.585 0-.409-.24-.311-.372.192-.26.513-.7.702-.955.186-.252.19-.396-.19-.396h-3.44L5.66 24.654h6.76c2.233 0 3.476-1.518 3.86-2.044h-4.61Zm4.397 2.044h3.965l1.504-2.044H17.57c-.002 0-1.504 2.044-1.504 2.044Zm10.232-6.11-1.521 2.067h-1.77l1.52-2.066h-3.964l-2.653 3.603h9.7l2.651-3.603H26.3Zm-4.497 6.11h3.964l1.504-2.044h-3.964l-1.504 2.044ZM.001 23.416v.435h5.523l.319-.434H0Zm6.435-.806H.001v.434h6.115l.32-.434ZM.001 24.654h4.93l.319-.431H0v.431Zm37.38-.804h5.82v-.434h-5.5l-.32.434Zm-.591.804h6.41v-.431h-6.093l-.317.431Zm1.503-2.044-.319.434h5.227v-.434h-4.908Zm-5.192-.462 2.652-3.603h-4.199L28.9 22.148h4.2Zm-4.54.462-.431.587c-.498.672-.058 1.457 1.567 1.457h6.366l1.505-2.044H28.56Z",
		fill: "#D50029"
	}, null, -1)], 64);
}
var Ma = /*#__PURE__*/ W(Aa, [["render", ja]]), Na = {}, Pa = { filter: "url(#a)" };
function Fa(e, t) {
	return A(), o("g", Pa, [...t[0] ||= [
		s("rect", {
			fill: "#F36920",
			height: "72",
			rx: "36",
			width: "72",
			x: "8",
			y: "2"
		}, null, -1),
		s("g", { "clip-path": "url(#b)" }, [s("path", {
			d: "M38.693 36.256c-1.294 0-2.334.718-2.334 2.333 0 1.58 1.04 2.333 2.334 2.333 1.289 0 2.332-.754 2.332-2.333 0-1.615-1.043-2.333-2.332-2.333Zm0 3.556c-.579 0-1.011-.439-1.011-1.223 0-.853.432-1.226 1.01-1.226.576 0 1.01.373 1.01 1.226 0 .784-.434 1.224-1.01 1.224Zm8.406-3.515c0 .024.02.043.043.043h.982c.078 0 .141.064.141.14v.85c0 .024-.019.043-.043.043h-1.08a.043.043 0 0 0-.043.043v1.65c0 .632.24.82.64.82.187 0 .482-.115.525-.115.024 0 .044.019.044.043v.813a.139.139 0 0 1-.073.124c-.179.096-.478.162-.921.162-.774 0-1.492-.39-1.492-1.634v-2.868a1 1 0 0 1 .256-.668c.21-.23.881-.662.968-.662.038 0 .053.011.053.046v1.17Zm-15.608.187c0-.08.064-.143.144-.143h1.702c1.67 0 2.536 1.003 2.536 2.301 0 1.3-.968 2.199-2.563 2.199h-.498a.044.044 0 0 0-.044.044v2.104c0 .035-.014.047-.053.047-.087 0-.759-.432-.968-.662a1.005 1.005 0 0 1-.256-.668v-5.222Zm3.12 2.093c0-.553-.357-1.07-1.3-1.07h-.5a.043.043 0 0 0-.044.044v2.076c0 .024.02.044.043.044h.526c1.124 0 1.275-.78 1.275-1.094Zm10.553.876c0 .948-.681 1.469-2.01 1.469-.76 0-1.563-.267-1.57-.269a.15.15 0 0 1-.1-.139v-.883c0-.03.025-.052.056-.052l.018.003c.284.092 1.203.32 1.692.32.29 0 .44-.043.538-.14a.3.3 0 0 0 .097-.224c0-.29-.362-.37-.714-.446l-.143-.033c-.77-.182-1.58-.37-1.58-1.36 0-.44.183-.805.528-1.058.343-.253.84-.385 1.434-.385.534 0 1.168.176 1.38.244.067.022.105.08.105.14v.881c-.002.041-.045.06-.074.049a4.598 4.598 0 0 0-1.566-.308c-.318 0-.523.137-.523.35 0 .247.3.314.681.4l.308.069c.312.069.634.139.899.311.366.24.544.587.544 1.061Zm6.888 1.372a.027.027 0 0 1-.027-.027v-2.681c0-.596-.202-.85-.677-.85-.17 0-.374.063-.577.179-.202.117-.36.214-.417.248a.081.081 0 0 0-.033.059v3.046a.027.027 0 0 1-.027.027H49.1c-.015 0-.028-.013-.028-.027v-4.314c0-.07.057-.127.129-.127h1.095c.015 0 .029.012.029.027v.339c0 .02.017.037.037.037a.047.047 0 0 0 .021-.007l.037-.027a2.22 2.22 0 0 1 .476-.272c.3-.114.623-.18.885-.18.977 0 1.493.56 1.493 1.622v2.9c0 .015-.012.027-.028.027h-1.193Zm2.208 0a.027.027 0 0 1-.027-.027v-6.606c0-.024.004-.03.037-.03.074 0 .741.419.957.656.16.176.252.416.252.657v5.323a.027.027 0 0 1-.027.027H54.26ZM38.692 29.343a.13.13 0 0 0-.07.023 2.847 2.847 0 0 0-.532.523c-.046.05-.046.11.002.17.146.19.313.357.496.5.034.028.068.04.103.04a.163.163 0 0 0 .102-.04c.183-.144.35-.312.496-.5.048-.06.048-.12 0-.174a2.774 2.774 0 0 0-.524-.517.13.13 0 0 0-.073-.025Zm0 1.62a6.95 6.95 0 0 0-.303.006.131.131 0 0 0-.097.04.206.206 0 0 0-.052.137l.026 1.993.008.586c0 .05.036.154.148.154h.54c.081 0 .136-.056.148-.147v-.007l.032-2.545v-.032a.202.202 0 0 0-.05-.137.132.132 0 0 0-.1-.04 5.519 5.519 0 0 0-.3-.009Zm1.372.147a.299.299 0 0 0-.279.188 7.097 7.097 0 0 0-.378 1.056c-.012.046-.008.085.014.113.014.02.044.042.102.042h.423c.096 0 .13-.051.144-.093.07-.235.119-.372.207-.566.001-.002.008-.015.034-.015.01 0 .02.002.03.005l.215.071a.09.09 0 0 1 .049.047.154.154 0 0 1 .007.11c-.003.007-.434 1.213-.563 1.616-.02.062-.017.11.009.147.024.032.064.05.12.05h.524c.086 0 .142-.035.167-.104.02-.052.046-.127.078-.217l.013-.033c.157-.439.395-1.103.446-1.292.086-.32.11-.67-.36-.844a6.858 6.858 0 0 0-.885-.263l-.016-.004a.38.38 0 0 0-.1-.014Zm-2.745 0a.367.367 0 0 0-.093.011l-.021.005a6.721 6.721 0 0 0-.883.263c-.47.174-.446.524-.36.844.049.182.27.804.458 1.325l.078.217c.025.069.081.103.167.103h.523c.07 0 .104-.027.12-.05.027-.035.03-.083.01-.146a89.133 89.133 0 0 0-.564-1.615.154.154 0 0 1 .007-.11.086.086 0 0 1 .05-.047l.215-.071a.11.11 0 0 1 .029-.004c.021 0 .031.01.034.015.089.199.14.337.206.566.013.043.048.093.144.093h.423c.047 0 .082-.014.103-.042.022-.028.026-.066.013-.112a7.24 7.24 0 0 0-.379-1.057.304.304 0 0 0-.28-.188Zm3.297 3.17h-3.843a.251.251 0 0 0-.248.248v.483c0 .151.064.225.199.225h3.943c.133 0 .197-.073.197-.225v-.483a.251.251 0 0 0-.248-.248Zm18.503 3.739c-.005-2.698-5.073-7.371-10.473-10.348-6.23-3.436-13.319-5.46-15.654-4.173-2.661 1.468-4.12 8.8-4.121 14.52 0 5.768 1.375 13.005 4.121 14.52 2.489 1.372 9.27-.653 15.654-4.172 5.485-3.024 10.468-7.519 10.473-10.347ZM34.862 21.796c3.931 0 10.23 2.486 14.418 4.795 2.396 1.32 5.115 3.248 7.219 5.21 2.019 1.88 3.923 4.222 3.927 6.218-.004 1.878-1.529 4.082-3.984 6.333-2.084 1.91-4.79 3.787-7.161 5.094-4.046 2.23-10.212 4.835-14.277 4.835-1.105 0-2.01-.19-2.695-.568-1.8-.992-2.953-3.665-3.635-6.284-.732-2.81-1.108-6.188-1.11-9.41 0-3.151.407-6.538 1.116-9.293.863-3.354 2.118-5.567 3.629-6.4.633-.352 1.493-.53 2.553-.53Z",
			fill: "#fff"
		})], -1),
		s("rect", {
			fill: "#F36920",
			height: "12",
			rx: "6",
			width: "12",
			x: "38",
			y: "78"
		}, null, -1)
	]]);
}
var Ia = /*#__PURE__*/ W(Na, [["render", Fa]]), La = {}, Ra = {
	"clip-path": "url(#a)",
	filter: "url(#b)"
};
function za(e, t) {
	return A(), o("g", Ra, [...t[0] ||= [
		s("rect", {
			fill: "#3544B3",
			height: "72",
			rx: "36",
			width: "72",
			x: "6",
			y: "2"
		}, null, -1),
		s("g", { "clip-path": "url(#c)" }, [s("path", {
			d: "M36.693 36.256c-1.294 0-2.334.718-2.334 2.333 0 1.58 1.04 2.333 2.334 2.333 1.289 0 2.332-.754 2.332-2.333 0-1.615-1.043-2.333-2.332-2.333Zm0 3.556c-.579 0-1.011-.439-1.011-1.223 0-.853.432-1.226 1.01-1.226.576 0 1.01.373 1.01 1.226 0 .784-.434 1.224-1.01 1.224Zm8.406-3.515c0 .024.02.043.043.043h.982c.078 0 .141.064.141.14v.85c0 .024-.019.043-.043.043h-1.08a.043.043 0 0 0-.043.043v1.65c0 .632.24.82.64.82.187 0 .482-.115.525-.115.024 0 .044.019.044.043v.813a.139.139 0 0 1-.073.124c-.179.096-.478.162-.921.162-.774 0-1.492-.39-1.492-1.634v-2.868a1 1 0 0 1 .256-.668c.21-.23.881-.662.968-.662.038 0 .053.011.053.046v1.17Zm-15.608.187c0-.08.064-.143.144-.143h1.702c1.67 0 2.536 1.003 2.536 2.301 0 1.3-.968 2.199-2.563 2.199h-.497a.044.044 0 0 0-.045.044v2.104c0 .035-.014.047-.053.047-.087 0-.759-.432-.968-.662a1.005 1.005 0 0 1-.256-.668v-5.222Zm3.12 2.093c0-.553-.357-1.07-1.3-1.07h-.5a.043.043 0 0 0-.044.044v2.076c0 .024.02.044.043.044h.526c1.124 0 1.275-.78 1.275-1.094Zm10.553.876c0 .948-.681 1.469-2.01 1.469-.76 0-1.563-.267-1.57-.269a.15.15 0 0 1-.1-.139v-.883c0-.03.025-.052.056-.052l.018.003c.284.092 1.203.32 1.692.32.29 0 .44-.043.538-.14a.3.3 0 0 0 .097-.224c0-.29-.362-.37-.714-.446l-.143-.033c-.77-.182-1.58-.37-1.58-1.36 0-.44.183-.805.528-1.058.343-.253.84-.385 1.434-.385.534 0 1.168.176 1.38.244.067.022.105.08.105.14v.881c-.002.041-.045.06-.074.049a4.598 4.598 0 0 0-1.566-.308c-.318 0-.523.137-.523.35 0 .247.3.314.681.4l.308.069c.312.069.634.139.899.311.366.24.544.587.544 1.061Zm6.888 1.372a.027.027 0 0 1-.027-.027v-2.681c0-.596-.202-.85-.677-.85-.17 0-.374.063-.577.179-.202.117-.36.214-.417.248a.081.081 0 0 0-.033.059v3.046a.027.027 0 0 1-.027.027H47.1c-.015 0-.028-.013-.028-.027v-4.314c0-.07.057-.127.129-.127h1.095c.015 0 .029.012.029.027v.339c0 .02.017.037.037.037a.047.047 0 0 0 .021-.007l.037-.027a2.22 2.22 0 0 1 .476-.272c.3-.114.623-.18.885-.18.977 0 1.493.56 1.493 1.622v2.9c0 .015-.012.027-.028.027h-1.193Zm2.208 0a.027.027 0 0 1-.027-.027v-6.606c0-.024.004-.03.037-.03.074 0 .741.419.957.656.16.176.252.416.252.657v5.323a.027.027 0 0 1-.027.027H52.26ZM36.692 29.343a.13.13 0 0 0-.07.023 2.847 2.847 0 0 0-.532.523c-.046.05-.046.11.002.17.146.19.313.357.496.5.034.028.068.04.103.04a.163.163 0 0 0 .102-.04c.183-.144.35-.312.496-.5.048-.06.048-.12 0-.174a2.774 2.774 0 0 0-.524-.517.13.13 0 0 0-.073-.025Zm0 1.62a6.95 6.95 0 0 0-.303.006.131.131 0 0 0-.097.04.206.206 0 0 0-.052.137l.026 1.993.008.586c0 .05.036.154.148.154h.54c.081 0 .136-.056.148-.147v-.007l.032-2.545v-.032a.202.202 0 0 0-.05-.137.132.132 0 0 0-.1-.04 5.519 5.519 0 0 0-.3-.009Zm1.372.147a.299.299 0 0 0-.279.188 7.097 7.097 0 0 0-.378 1.056c-.012.046-.008.085.014.113.014.02.044.042.102.042h.423c.096 0 .13-.051.144-.093.07-.235.119-.372.207-.566.001-.002.008-.015.034-.015.01 0 .02.002.03.005l.215.071a.09.09 0 0 1 .049.047.154.154 0 0 1 .007.11c-.003.007-.434 1.213-.563 1.616-.02.062-.017.11.009.147.024.032.064.05.12.05h.524c.086 0 .142-.035.167-.104.02-.052.046-.127.078-.217l.013-.033c.157-.439.395-1.103.446-1.292.086-.32.11-.67-.36-.844a6.858 6.858 0 0 0-.885-.263l-.016-.004a.38.38 0 0 0-.1-.014Zm-2.745 0a.367.367 0 0 0-.093.011l-.021.005a6.721 6.721 0 0 0-.883.263c-.47.174-.446.524-.36.844.049.182.27.804.458 1.325l.078.217c.025.069.081.103.167.103h.523c.07 0 .104-.027.12-.05.027-.035.03-.083.01-.146a89.133 89.133 0 0 0-.564-1.615.154.154 0 0 1 .007-.11.086.086 0 0 1 .05-.047l.215-.071a.11.11 0 0 1 .029-.004c.021 0 .031.01.034.015.089.199.14.337.206.566.013.043.048.093.144.093h.423c.047 0 .082-.014.103-.042.022-.028.026-.066.013-.112a7.24 7.24 0 0 0-.379-1.057.304.304 0 0 0-.28-.188Zm3.297 3.17h-3.843a.251.251 0 0 0-.248.248v.483c0 .151.064.225.199.225h3.943c.133 0 .197-.073.197-.225v-.483a.251.251 0 0 0-.248-.248Zm18.503 3.739c-.005-2.698-5.073-7.371-10.473-10.348-6.23-3.436-13.319-5.46-15.654-4.173-2.662 1.468-4.12 8.8-4.121 14.52 0 5.768 1.375 13.005 4.121 14.52 2.489 1.372 9.27-.653 15.654-4.172 5.485-3.024 10.468-7.519 10.473-10.347ZM32.862 21.796c3.931 0 10.23 2.486 14.418 4.795 2.396 1.32 5.115 3.248 7.219 5.21 2.019 1.88 3.923 4.222 3.927 6.218-.004 1.878-1.529 4.082-3.984 6.333-2.084 1.91-4.79 3.787-7.161 5.094-4.046 2.23-10.212 4.835-14.277 4.835-1.105 0-2.01-.19-2.695-.568-1.8-.992-2.954-3.665-3.635-6.284-.732-2.81-1.108-6.188-1.11-9.41 0-3.151.407-6.538 1.116-9.293.863-3.354 2.118-5.567 3.629-6.4.633-.352 1.493-.53 2.553-.53Z",
			fill: "#fff"
		})], -1),
		s("rect", {
			fill: "#3544B3",
			height: "12",
			rx: "6",
			width: "12",
			x: "36",
			y: "78"
		}, null, -1)
	]]);
}
var Ba = /*#__PURE__*/ W(La, [["render", za]]), Va = {}, Ha = {
	"clip-path": "url(#a)",
	filter: "url(#b)"
};
function Ua(e, t) {
	return A(), o("g", Ha, [...t[0] ||= [
		s("rect", {
			fill: "#FECC00",
			height: "72",
			rx: "36",
			width: "72",
			x: "6",
			y: "2"
		}, null, -1),
		s("path", {
			d: "M30.413 37.217c-.285.386-.762 1.057-1.053 1.449-.147.2-.413.561.47.561h4.646l1.376-1.87c.854-1.16.074-3.571-2.979-3.571H20.85l-2.085 2.832h11.362c.574 0 .566.218.286.599ZM27 39.926c-.883 0-.617-.363-.47-.562.29-.392.776-1.056 1.06-1.442.282-.38.289-.599-.285-.599h-5.197l-4.186 5.69h10.21c3.372 0 5.25-2.294 5.828-3.087H27Zm6.641 3.087h5.99l2.27-3.087h-5.988c-.002 0-2.272 3.087-2.272 3.087Zm15.455-9.227-2.298 3.12h-2.673l2.296-3.12h-5.988l-4.006 5.441h14.65l4.006-5.441h-5.987Zm-6.792 9.227h5.988l2.271-3.087h-5.987c-.002 0-2.272 3.087-2.272 3.087Zm-32.929-1.87v.657h8.342l.482-.656H9.375Zm9.72-1.217h-9.72v.655h9.237l.483-.655Zm-9.72 3.087h7.448l.48-.652H9.375v.652Zm56.46-1.214h8.79v-.656h-8.308l-.482.656Zm-.893 1.214h9.683v-.652H65.42l-.48.652Zm2.27-3.087-.481.656h7.894v-.656h-7.413Zm-7.842-.699 4.005-5.441h-6.341c-.003 0-4.009 5.441-4.009 5.441h6.345Zm-6.858.699s-.438.598-.651.886c-.752 1.016-.087 2.201 2.367 2.201h9.616l2.272-3.087H52.511Z",
			fill: "#D50029"
		}, null, -1),
		s("rect", {
			fill: "#FECC00",
			height: "12",
			rx: "6",
			width: "12",
			x: "36",
			y: "78"
		}, null, -1)
	]]);
}
var Wa = /*#__PURE__*/ W(Va, [["render", Ua]]), Ga = {}, Ka = { "data-test": "icon-sort-desc" };
function qa(e, t) {
	return A(), o("g", Ka, [...t[0] ||= [s("path", {
		d: "M3.64645 11.6464L0.853553 8.85355C0.538571 8.53857 0.761654 8 1.20711 8L6.79289 8C7.23835 8 7.46143 8.53857 7.14645 8.85355L4.35355 11.6464C4.15829 11.8417 3.84171 11.8417 3.64645 11.6464Z",
		fill: "currentColor"
	}, null, -1)]]);
}
var Ja = /*#__PURE__*/ W(Ga, [["render", qa]]), Ya = {}, Xa = { "data-test": "icon-sort-asc" };
function Za(e, t) {
	return A(), o("g", Xa, [...t[0] ||= [s("path", {
		d: "M3.64645 0.353553L0.853553 3.14645C0.538571 3.46143 0.761654 4 1.20711 4L6.79289 4C7.23835 4 7.46143 3.46143 7.14645 3.14645L4.35355 0.353553C4.15829 0.158291 3.84171 0.158291 3.64645 0.353553Z",
		fill: "currentColor"
	}, null, -1)]]);
}
var Qa = /*#__PURE__*/ W(Ya, [["render", Za]]), $a = {}, eo = {
	"clip-rule": "evenodd",
	d: "M2.5 4a.5.5 0 0 1 .5-.5h18a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-4a.5.5 0 0 0 0 1h4a1.5 1.5 0 0 0 1.5-1.5V4A1.5 1.5 0 0 0 21 2.5H3A1.5 1.5 0 0 0 1.5 4v13A1.5 1.5 0 0 0 3 18.5h4a.5.5 0 0 0 0-1H3a.5.5 0 0 1-.5-.5V4Zm10 7a.5.5 0 1 0-1 0v10.793l-2.146-2.146a.5.5 0 1 0-.708.707l3 3a.5.5 0 0 0 .707 0l3-3a.5.5 0 0 0-.707-.708L12.5 21.793V11Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function to(e, t) {
	return A(), o("path", eo);
}
var no = /*#__PURE__*/ W($a, [["render", to]]), ro = {}, io = {
	d: "M4.146.146A.5.5 0 0 1 4.5 0h8A1.5 1.5 0 0 1 14 1.5v13a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 1 14.5v-11a.5.5 0 0 1 .146-.354l3-3ZM12.5 1H5v2.5a.5.5 0 0 1-.5.5H2v10.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5ZM2.707 3H4V1.707L2.707 3Z",
	fill: "currentColor"
};
function ao(e, t) {
	return A(), o("path", io);
}
var oo = /*#__PURE__*/ W(ro, [["render", ao]]), so = {}, co = {
	d: "M7 10.577L3.4615 7.0385L4.16925 6.31925L6.5 8.65V0H7.5V8.65L9.83075 6.31925L10.5385 7.0385L7 10.577ZM1.6155 14C1.15517 14 0.770833 13.8458 0.4625 13.5375C0.154167 13.2292 0 12.8448 0 12.3845V9.9615H1V12.3845C1 12.5385 1.06408 12.6796 1.19225 12.8077C1.32042 12.9359 1.4615 13 1.6155 13H12.3845C12.5385 13 12.6796 12.9359 12.8077 12.8077C12.9359 12.6796 13 12.5385 13 12.3845V9.9615H14V12.3845C14 12.8448 13.8458 13.2292 13.5375 13.5375C13.2292 13.8458 12.8448 14 12.3845 14H1.6155Z",
	fill: "currentColor"
};
function lo(e, t) {
	return A(), o("path", co);
}
var uo = /*#__PURE__*/ W(so, [["render", lo]]), fo = {}, po = {
	d: "M4.146.146A.5.5 0 0 1 4.5 0h8A1.5 1.5 0 0 1 14 1.5V6h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1v1.5a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 1 14.5v-11a.5.5 0 0 1 .146-.354l3-3ZM13 1.5a.5.5 0 0 0-.5-.5H5v2.5a.5.5 0 0 1-.5.5H2v10.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V13H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8V1.5ZM2.707 3H4V1.707L2.707 3ZM6 12h9V7H5v5h1Zm5.778-3.999a.25.25 0 0 0-.267.32l.75 2.5a.25.25 0 0 0 .479 0l.75-2.5a.25.25 0 0 0-.479-.142l-.51 1.701-.511-1.701A.25.25 0 0 0 11.777 8Zm-5.278.75a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 .75.75.25.25 0 0 1-.25.25.25.25 0 0 1-.25-.25.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25v1.5c0 .137.112.25.25.25h.5a.25.25 0 0 0 .25-.25.25.25 0 0 1 .25-.25.25.25 0 0 1 .25.25c0 .412-.337.75-.75.75h-.5a.752.752 0 0 1-.75-.75v-1.5Zm2.5 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 .75.75.25.25 0 0 1-.25.25.25.25 0 0 1-.25-.25.25.25 0 0 0-.25-.25h-.5a.25.25 0 0 0-.25.25V9c0 .137.112.25.25.25h.5A.75.75 0 0 1 11 10v.25c0 .412-.337.75-.75.75h-.5a.752.752 0 0 1-.75-.75.25.25 0 0 1 .25-.25.25.25 0 0 1 .25.25c0 .137.112.25.25.25h.5a.25.25 0 0 0 .25-.25V10a.25.25 0 0 0-.25-.25h-.5A.751.751 0 0 1 9 9v-.25Z",
	fill: "currentColor"
};
function mo(e, t) {
	return A(), o("path", po);
}
var ho = /*#__PURE__*/ W(fo, [["render", mo]]), go = {}, _o = {
	d: "M4.146.146A.5.5 0 0 1 4.5 0h8A1.5 1.5 0 0 1 14 1.5V6h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-1v1.5a1.5 1.5 0 0 1-1.5 1.5h-10A1.5 1.5 0 0 1 1 14.5v-11a.5.5 0 0 1 .146-.354l3-3ZM13 1.5a.5.5 0 0 0-.5-.5H5v2.5a.5.5 0 0 1-.5.5H2v10.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V13H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8V1.5ZM5 12h10V7H5v5ZM2.707 3H4V1.707L2.707 3Zm9.793 7.75a.25.25 0 1 1-.5 0v-2.5a.25.25 0 0 1 .25-.25h1.25a.25.25 0 1 1 0 .5h-1v1h.75a.25.25 0 1 1 0 .5h-.75v.75Zm-5 0a.25.25 0 1 1-.5 0v-2.5A.25.25 0 0 1 7.25 8h1a.75.75 0 0 1 .75.75v.5a.75.75 0 0 1-.75.75H7.5v.75Zm.75-2.25H7.5v1h.75a.25.25 0 0 0 .25-.25v-.5a.25.25 0 0 0-.25-.25ZM10.5 11h-.75a.25.25 0 0 1-.25-.25v-2.5A.25.25 0 0 1 9.75 8h.75a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1Zm0-2.5H10v2h.5a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5Z",
	fill: "currentColor"
};
function vo(e, t) {
	return A(), o("path", _o);
}
var yo = /*#__PURE__*/ W(go, [["render", vo]]), bo = {}, xo = {
	d: "M4.5 0a.5.5 0 0 0-.354.146l-3 3A.5.5 0 0 0 1 3.5v11A1.5 1.5 0 0 0 2.5 16h10a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 12.5 0h-8ZM5 1h7.5a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5V4h2.5a.5.5 0 0 0 .5-.5V1ZM4 3H2.707L4 1.707V3Zm1 4a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1H5Zm-.5 2.5A.5.5 0 0 1 5 9h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5ZM5 11a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1H5Z",
	fill: "currentColor"
};
function So(e, t) {
	return A(), o("path", xo);
}
var Co = /*#__PURE__*/ W(bo, [["render", So]]), wo = {};
function To(t, n) {
	return A(), o(e, null, [
		n[0] ||= s("path", {
			d: "M8 45V12.4142C8 12.149 8.10536 11.8946 8.29289 11.7071L17.7071 2.29289C17.8946 2.10536 18.149 2 18.4142 2H38C38.5523 2 39 2.44771 39 3V45C39 45.5523 38.5523 46 38 46H9C8.44772 46 8 45.5523 8 45Z",
			fill: "none",
			stroke: "currentColor",
			"stroke-width": "1.5"
		}, null, -1),
		n[1] ||= s("path", {
			d: "M28 24L31 24C31.5523 24 32 24.4477 32 25L32 34C32 34.5523 31.5523 35 31 35L16 35C15.4477 35 15 34.5523 15 34L15 25C15 24.4477 15.4477 24 16 24L19 24",
			fill: "none",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round",
			"stroke-width": "1.5"
		}, null, -1),
		n[2] ||= s("path", {
			d: "M23.5003 29L23.5001 18M23.5001 18L27 21M23.5001 18L20.0002 21",
			fill: "none",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round",
			"stroke-width": "1.5"
		}, null, -1),
		n[3] ||= s("path", {
			d: "M8 12H17C17.5523 12 18 11.5523 18 11V2",
			fill: "none",
			stroke: "currentColor",
			"stroke-width": "1.5"
		}, null, -1)
	], 64);
}
var Eo = /*#__PURE__*/ W(wo, [["render", To]]), Do = {}, Oo = {
	d: "M4.5 0a.5.5 0 0 0-.354.146l-3 3A.5.5 0 0 0 1 3.5v11A1.5 1.5 0 0 0 2.5 16h10a1.5 1.5 0 0 0 1.5-1.5v-13A1.5 1.5 0 0 0 12.5 0h-8ZM5 1h7.5a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5V4h2.5a.5.5 0 0 0 .5-.5V1ZM4 3H2.707L4 1.707V3Zm2.307 2.105A.5.5 0 0 0 5.5 5.5v7a.5.5 0 0 0 .807.395l4.5-3.5a.5.5 0 0 0 0-.79l-4.5-3.5ZM9.686 9 6.5 11.478V6.522L9.686 9Z",
	fill: "currentColor"
};
function ko(e, t) {
	return A(), o("path", Oo);
}
var Ao = /*#__PURE__*/ W(Do, [["render", ko]]), jo = {}, Mo = {
	"clip-rule": "evenodd",
	d: "M1.5 2a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 14 .5H2A1.5 1.5 0 0 0 .5 2v8A1.5 1.5 0 0 0 2 11.5h2a.5.5 0 1 0 0-1H2a.5.5 0 0 1-.5-.5V2Zm7 5a.5.5 0 0 0-1 0v6.793l-1.146-1.146a.5.5 0 1 0-.708.707l2 2a.5.5 0 0 0 .707 0l2-2a.5.5 0 1 0-.707-.707L8.5 13.793V7Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function No(e, t) {
	return A(), o("path", Mo);
}
var Po = /*#__PURE__*/ W(jo, [["render", No]]), Fo = {}, Io = {
	d: "M12 33H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h36a2 2 0 0 1 2 2v24a2 2 0 0 1-2 2h-6M24 23v21m0 0-8-8m8 8 8-8",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	"stroke-width": "1.5"
};
function Lo(e, t) {
	return A(), o("path", Io);
}
var Ro = /*#__PURE__*/ W(Fo, [["render", Lo]]), zo = {}, Bo = {
	d: "M15 4.5L22 12M22 12L15 19.5M22 12L3 12",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round"
};
function Vo(e, t) {
	return A(), o("path", Bo);
}
var Ho = /*#__PURE__*/ W(zo, [["render", Vo]]), Uo = {}, Wo = {
	d: "M3 9.5L8 14.5M8 14.5L13 9.5M8 14.5L8 1.5",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round"
};
function Go(e, t) {
	return A(), o("path", Wo);
}
var Ko = /*#__PURE__*/ W(Uo, [["render", Go]]), qo = {}, Jo = {
	d: "M3 6.33317L8 1.6665M8 1.6665L13 6.33317M8 1.6665L8 14.3332",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round"
};
function Yo(e, t) {
	return A(), o("path", Jo);
}
var Xo = /*#__PURE__*/ W(qo, [["render", Yo]]), Zo = {}, Qo = {
	"clip-rule": "evenodd",
	d: "M3.53 12a7.47 7.47 0 1 1 14.46 2.643l-1.505-2.606a.53.53 0 1 0-.917.53l2.121 3.674a.53.53 0 0 0 .724.194l3.674-2.121a.53.53 0 0 0-.53-.917l-2.515 1.452c.316-.892.487-1.85.487-2.849A8.53 8.53 0 1 0 11 20.53a.53.53 0 1 0 0-1.06A7.47 7.47 0 0 1 3.53 12Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function $o(e, t) {
	return A(), o("path", Qo);
}
var es = /*#__PURE__*/ W(Zo, [["render", $o]]), ts = {}, ns = {
	"clip-rule": "evenodd",
	d: "M2.5 7.5a5 5 0 1 1 9.853 1.208l-.802-1.39a.5.5 0 1 0-.866.5l1.414 2.45a.5.5 0 0 0 .683.183l2.45-1.415a.5.5 0 1 0-.5-.866l-1.418.819A6 6 0 1 0 7.5 13.5a.5.5 0 0 0 0-1 5 5 0 0 1-5-5Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function rs(e, t) {
	return A(), o("path", ns);
}
var is = /*#__PURE__*/ W(ts, [["render", rs]]), as = {}, ss = {
	d: "M18.854 5.147a.5.5 0 0 1 0 .707L12.707 12l6.147 6.146a.5.5 0 0 1-.708.708L12 12.707l-6.146 6.147a.5.5 0 1 1-.708-.707L11.293 12 5.146 5.854a.5.5 0 1 1 .707-.707L12 11.293l6.146-6.146a.5.5 0 0 1 .708 0Z",
	fill: "currentColor"
};
function cs(e, t) {
	return A(), o("path", ss);
}
var ls = /*#__PURE__*/ W(as, [["render", cs]]), us = {}, ds = {
	d: "M12.687 3.313a.5.5 0 0 1 0 .707L8.707 8l3.98 3.98a.5.5 0 0 1-.707.707L8 8.707l-3.98 3.98a.5.5 0 0 1-.707-.707L7.293 8l-3.98-3.98a.5.5 0 0 1 .707-.707L8 7.293l3.98-3.98a.5.5 0 0 1 .707 0Z",
	fill: "currentColor"
};
function fs(e, t) {
	return A(), o("path", ds);
}
var ps = /*#__PURE__*/ W(us, [["render", fs]]), ms = {}, hs = {
	"clip-rule": "evenodd",
	d: "M6.49939 7.5C6.49939 4.46243 8.96182 2 11.9994 2C15.037 2 17.4994 4.46243 17.4994 7.5C17.4994 10.5376 15.037 13 11.9994 13C8.96182 13 6.49939 10.5376 6.49939 7.5ZM11.9994 1C8.40954 1 5.49939 3.91015 5.49939 7.5C5.49939 9.28187 6.21638 10.8963 7.37759 12.0705C3.89823 13.7966 1.99951 17.4025 1.99951 21.5C1.99951 21.7761 2.22337 22 2.49951 22C2.77565 22 2.99951 21.7761 2.99951 21.5C2.99951 17.5588 4.88346 14.2392 8.1997 12.7902L8.21324 12.7841C9.27945 13.5494 10.5868 14 11.9994 14C13.412 14 14.7194 13.5494 15.7856 12.784L15.7993 12.7902C16.2161 12.9723 16.6092 13.1833 16.9782 13.4206C17.2104 13.5699 17.5198 13.5027 17.6691 13.2705C17.8185 13.0382 17.7513 12.7288 17.519 12.5795C17.2322 12.395 16.9328 12.225 16.6212 12.0704C17.7824 10.8962 18.4994 9.28184 18.4994 7.5C18.4994 3.91015 15.5892 1 11.9994 1ZM16.0535 15.351C16.2981 14.6795 16.9422 14.2 17.6983 14.2C18.4543 14.2 19.0984 14.6795 19.343 15.351C20.0469 15.2271 20.7841 15.5451 21.1622 16.1999C21.5402 16.8547 21.447 17.6523 20.9877 18.1999C21.447 18.7475 21.5402 19.5451 21.1622 20.1999C20.7842 20.8547 20.0469 21.1727 19.3431 21.0489C19.0986 21.7205 18.4544 22.2 17.6983 22.2C16.9421 22.2 16.2979 21.7204 16.0534 21.0488C15.3495 21.1728 14.6121 20.8548 14.234 20.1999C13.8559 19.5451 13.9491 18.7475 14.4084 18.1999C13.9491 17.6523 13.8559 16.8547 14.234 16.1999C14.6121 15.545 15.3495 15.227 16.0535 15.351ZM16.1245 19.9744C16.1913 19.9359 16.2747 19.9442 16.336 19.9909C16.4865 20.1056 16.6519 20.2017 16.8288 20.2759C16.8996 20.3056 16.9483 20.3733 16.9483 20.45C16.9483 20.8643 17.284 21.2 17.6983 21.2C18.1125 21.2 18.4483 20.8643 18.4483 20.45C18.4483 20.3733 18.4969 20.3056 18.5677 20.2759C18.7446 20.2017 18.91 20.1056 19.0606 19.9909C19.1218 19.9443 19.205 19.936 19.2716 19.9744C19.6303 20.1815 20.089 20.0586 20.2961 19.6999C20.5033 19.3412 20.3803 18.8825 20.0216 18.6754C19.9552 18.637 19.9208 18.561 19.9304 18.4849C19.9422 18.3916 19.9483 18.2965 19.9483 18.2C19.9483 18.1035 19.9422 18.0084 19.9304 17.915C19.9208 17.8388 19.9551 17.7628 20.0216 17.7244C20.3803 17.5173 20.5033 17.0586 20.2961 16.6999C20.089 16.3412 19.6303 16.2183 19.2716 16.4254C19.2049 16.4639 19.1215 16.4556 19.0602 16.4089C18.9098 16.2943 18.7445 16.1983 18.5677 16.1242C18.4969 16.0945 18.4483 16.0268 18.4483 15.95C18.4483 15.5358 18.1125 15.2 17.6983 15.2C17.284 15.2 16.9483 15.5358 16.9483 15.95C16.9483 16.0268 16.8996 16.0945 16.8288 16.1242C16.6521 16.1983 16.4868 16.2943 16.3364 16.4089C16.2749 16.4557 16.1914 16.464 16.1245 16.4254C15.7658 16.2183 15.3071 16.3412 15.1 16.6999C14.8929 17.0586 15.0158 17.5173 15.3745 17.7244C15.4412 17.7629 15.4757 17.8392 15.4661 17.9156C15.4543 18.0088 15.4483 18.1037 15.4483 18.2C15.4483 18.2963 15.4543 18.3912 15.466 18.4843C15.4757 18.5607 15.4412 18.6369 15.3745 18.6754C15.0158 18.8825 14.8929 19.3412 15.1 19.6999C15.3071 20.0586 15.7658 20.1815 16.1245 19.9744ZM18.45 18.2C18.45 18.6142 18.1142 18.95 17.7 18.95C17.2857 18.95 16.95 18.6142 16.95 18.2C16.95 17.7858 17.2857 17.45 17.7 17.45C18.1142 17.45 18.45 17.7858 18.45 18.2ZM19.2 18.2C19.2 19.0284 18.5284 19.7 17.7 19.7C16.8715 19.7 16.2 19.0284 16.2 18.2C16.2 17.3716 16.8715 16.7 17.7 16.7C18.5284 16.7 19.2 17.3716 19.2 18.2Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function gs(e, t) {
	return A(), o("path", hs);
}
var _s = /*#__PURE__*/ W(ms, [["render", gs]]), vs = {}, ys = { fill: "currentColor" };
function bs(e, t) {
	return A(), o("g", ys, [...t[0] ||= [s("path", { d: "M32.91 7.59a.764.764 0 0 1-.06-1.09c.28-.32.77-.35 1.09-.06.86.76 1.61 1.64 2.25 2.59.24.36.14.84-.22 1.07-.13.09-.28.13-.43.13-.25 0-.5-.12-.65-.35-.55-.84-1.22-1.61-1.98-2.29zm2.06 17.83a13.33 13.33 0 0 0 3.46-8.97c0-1.44-.23-2.86-.68-4.22a.764.764 0 0 0-.98-.49c-.41.13-.63.57-.49.98.4 1.2.6 2.45.6 3.73 0 6.55-5.33 11.88-11.88 11.88S13.13 23 13.13 16.45 18.46 4.58 25 4.58c1.79 0 3.51.39 5.11 1.15l.28.14c.38.19.85.04 1.04-.34s.04-.85-.34-1.04l-.32-.16c-1.8-.86-3.74-1.3-5.77-1.3-7.4 0-13.43 6.02-13.43 13.43 0 3.48 1.34 6.64 3.52 9.03C7.23 29.3 2.17 37.32 2.17 46.09c0 .43.35.77.77.77s.77-.35.77-.77c0-8.37 4.92-16 12.55-19.46 2.35 2.02 5.4 3.25 8.73 3.25 3.37 0 6.44-1.25 8.8-3.31.01 0 .01.01.02.02 7.67 3.44 12.63 11.1 12.63 19.5 0 .43.35.77.77.77s.77-.35.77-.77c.03-8.82-5.08-16.87-13.01-20.67z" }, null, -1), s("path", { d: "M47.23 46.99c-.5 0-.9-.4-.9-.9 0-8.34-4.91-15.94-12.51-19.37A13.503 13.503 0 0 1 25.01 30c-3.2 0-6.3-1.15-8.76-3.23-7.54 3.46-12.4 11.03-12.4 19.32 0 .5-.4.9-.9.9s-.9-.4-.9-.9c0-8.7 5.04-16.79 12.84-20.65a13.495 13.495 0 0 1-3.44-8.99C11.45 8.98 17.53 2.9 25 2.9c2.04 0 4.01.44 5.83 1.32l.32.16c.44.23.62.77.39 1.21-.11.21-.3.37-.52.45-.23.08-.47.06-.69-.05l-.28-.14A11.5 11.5 0 0 0 25 4.7c-6.48 0-11.75 5.27-11.75 11.75S18.53 28.21 25 28.21c6.48 0 11.75-5.27 11.75-11.75 0-1.26-.2-2.5-.59-3.69-.16-.47.1-.98.57-1.14a.85.85 0 0 1 .68.05c.22.11.38.29.45.52.45 1.37.68 2.8.68 4.26 0 3.28-1.2 6.45-3.39 8.93 7.88 3.84 12.96 11.95 12.96 20.71.02.49-.38.89-.88.89zM33.8 26.45c.02 0 .04 0 .06.01.01 0 .03.02.04.03 7.7 3.45 12.68 11.15 12.68 19.61 0 .36.29.65.65.65s.65-.29.65-.65c0-8.72-5.09-16.79-12.97-20.56-.04-.02-.06-.05-.07-.09s0-.08.03-.11c2.21-2.46 3.43-5.61 3.43-8.89 0-1.43-.23-2.83-.67-4.18a.62.62 0 0 0-.33-.38.641.641 0 0 0-.9.78c.4 1.21.6 2.48.6 3.77 0 6.62-5.38 12-12 12s-12-5.38-12-12 5.38-12 12-12c1.81 0 3.55.39 5.17 1.17l.28.14c.16.08.33.09.5.04a.645.645 0 0 0 .1-1.19l-.32-.16c-1.79-.85-3.72-1.29-5.73-1.29-7.33 0-13.3 5.97-13.3 13.3 0 3.3 1.24 6.48 3.48 8.94.03.03.04.07.03.11-.01.04-.03.07-.07.09-7.8 3.8-12.84 11.84-12.84 20.5 0 .36.29.65.65.65s.65-.29.65-.65c0-8.41 4.95-16.1 12.62-19.58.04-.02.1-.01.13.02 2.42 2.08 5.49 3.22 8.65 3.22 3.19 0 6.29-1.16 8.72-3.28.02-.01.05-.02.08-.02zm1.74-16.1c-.3 0-.58-.15-.75-.4-.56-.83-1.22-1.6-1.97-2.27a.877.877 0 0 1-.3-.62c-.01-.24.07-.47.23-.65.16-.18.38-.29.62-.3.23-.01.47.07.65.23.87.77 1.63 1.65 2.27 2.61.13.2.18.44.13.68a.89.89 0 0 1-.88.72zm-2.12-3.99h-.04c-.17.01-.33.09-.45.22s-.17.3-.16.47.09.33.22.45c.77.68 1.44 1.46 2.01 2.32.19.29.61.37.9.18.14-.1.24-.24.28-.41a.66.66 0 0 0-.1-.49 13.33 13.33 0 0 0-2.23-2.57.613.613 0 0 0-.43-.17z" }, null, -1)]]);
}
var xs = /*#__PURE__*/ W(vs, [["render", bs]]), Ss = {}, Cs = {
	"clip-rule": "evenodd",
	d: "M6.5 8a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0ZM12 1.5a6.5 6.5 0 0 0-4.623 11.07A10.5 10.5 0 0 0 1.5 22a.5.5 0 1 0 1 0 9.502 9.502 0 0 1 5.714-8.716A6.47 6.47 0 0 0 12 14.5a6.47 6.47 0 0 0 3.786-1.216l.014.006A9.502 9.502 0 0 1 21.5 22a.5.5 0 1 0 1 0 10.5 10.5 0 0 0-5.878-9.43A6.5 6.5 0 0 0 12 1.5Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function ws(e, t) {
	return A(), o("path", Cs);
}
var Ts = /*#__PURE__*/ W(Ss, [["render", ws]]), Es = {}, Ds = {
	d: "M6 8.5L7.3905 19.624C7.45306 20.1245 7.87846 20.5 8.38278 20.5H15.6172C16.1215 20.5 16.5469 20.1245 16.6095 19.624L18 8.5M6 8.5H5.5C4.94772 8.5 4.5 8.05228 4.5 7.5V5.5C4.5 4.94772 4.94772 4.5 5.5 4.5H8.5M6 8.5H18M18 8.5H18.5C19.0523 8.5 19.5 8.05228 19.5 7.5V5.5C19.5 4.94772 19.0523 4.5 18.5 4.5H15.5M8.5 4.5L9.7 2.9C9.88885 2.64819 10.1852 2.5 10.5 2.5H13.5C13.8148 2.5 14.1111 2.64819 14.3 2.9L15.5 4.5M8.5 4.5H15.5",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round"
};
function Os(e, t) {
	return A(), o("path", Ds);
}
var ks = /*#__PURE__*/ W(Es, [["render", Os]]), As = {}, js = {
	d: "M10.618 3H13.5a.5.5 0 0 1 .4.2l.6.8H9.809l.362-.724A.5.5 0 0 1 10.618 3Zm5.132 1L14.7 2.6a1.5 1.5 0 0 0-1.2-.6h-2.882a1.5 1.5 0 0 0-1.342.83L8.691 4H5.5A1.5 1.5 0 0 0 4 5.5v2A1.5 1.5 0 0 0 5.5 9h.059l1.335 10.686A1.5 1.5 0 0 0 8.383 21h7.234a1.5 1.5 0 0 0 1.489-1.314L18.44 9h.059A1.5 1.5 0 0 0 20 7.5v-2A1.5 1.5 0 0 0 18.5 4h-2.75Zm1.684 5-1.32 10.562a.5.5 0 0 1-.497.438H8.383a.5.5 0 0 1-.496-.438L6.567 9h10.867ZM5.5 5h13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5Z",
	fill: "currentColor"
};
function Ms(e, t) {
	return A(), o("path", js);
}
var Ns = /*#__PURE__*/ W(As, [["render", Ms]]), Ps = {}, Fs = {
	d: "M6.618 2h2.764a.5.5 0 0 1 .447.276l.362.724H5.809l.362-.724A.5.5 0 0 1 6.618 2Zm4.691 1-.585-1.17A1.5 1.5 0 0 0 9.382 1H6.618a1.5 1.5 0 0 0-1.342.83L4.691 3H3a1.5 1.5 0 0 0-1.5 1.5v1a1.5 1.5 0 0 0 1.05 1.431l.844 6.755A1.5 1.5 0 0 0 4.883 15h6.234a1.5 1.5 0 0 0 1.489-1.314l.844-6.755A1.5 1.5 0 0 0 14.5 5.5v-1A1.5 1.5 0 0 0 13 3h-1.691Zm1.125 4-.82 6.562a.5.5 0 0 1-.497.438H4.883a.5.5 0 0 1-.496-.438L3.567 7h8.867ZM3 4h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-1A.5.5 0 0 1 3 4Z",
	fill: "currentColor"
};
function Is(e, t) {
	return A(), o("path", Fs);
}
var Ls = /*#__PURE__*/ W(Ps, [["render", Is]]), Rs = {}, zs = {
	d: "M 14.234 2.731 C 14.922 2.916 15.466 3.461 15.651 4.149 C 15.99 5.402 16 8 16 8 C 16 8 16 10.608 15.661 11.851 C 15.476 12.539 14.932 13.083 14.244 13.268 C 13.001 13.607 8 13.607 8 13.607 C 8 13.607 2.999 13.607 1.756 13.268 C 1.068 13.083 0.524 12.539 0.339 11.851 C 0 10.598 0 8 0 8 C 0 8 0 5.402 0.329 4.159 C 0.513 3.471 1.058 2.927 1.746 2.742 C 2.988 2.403 7.99 2.393 7.99 2.393 C 7.99 2.393 12.991 2.393 14.234 2.731 Z M 10.547 8 L 6.398 5.597 L 6.398 10.403 L 10.547 8 Z",
	fill: "currentColor"
};
function Bs(e, t) {
	return A(), o("path", zs);
}
var Vs = /*#__PURE__*/ W(Rs, [["render", Bs]]), Hs = {}, Us = {
	d: "M20 2.62037V7.26328C20.0444 7.30152 20.095 7.34618 20.1504 7.39695C20.352 7.58178 20.6208 7.85047 20.8904 8.18756C21.4216 8.85152 22 9.83589 22 10.9999C22 12.1639 21.4216 13.1483 20.8904 13.8123C20.6208 14.1493 20.352 14.418 20.1504 14.6029C20.095 14.6536 20.0444 14.6983 20 14.7365V18.3794C20 19.1222 19.4909 19.64 18.9248 19.8397C18.3612 20.0386 17.6431 19.9594 17.1571 19.4199C16.2568 18.4206 15.1309 17.3024 13.9435 16.4378C12.7424 15.5631 11.5484 14.9999 10.5 14.9999H8.6099L9.63842 20.1425C9.88234 21.3621 8.94954 22.4999 7.70583 22.4999C6.76635 22.4999 5.95747 21.8368 5.77323 20.9156L4.58439 14.9713C3.12423 14.769 2 13.5157 2 11.9999V9.4999C2 7.56702 3.56635 5.9999 5.49946 5.9999H10.5C11.5484 5.9999 12.7424 5.4367 13.9435 4.56203C15.1309 3.69739 16.2568 2.57917 17.1571 1.57989C17.6431 1.04042 18.3612 0.961191 18.9248 1.1601C19.4909 1.35984 20 1.87757 20 2.62037ZM20 8.67943V13.3204C20.0364 13.2776 20.073 13.2333 20.1096 13.1876C20.5784 12.6015 21 11.8359 21 10.9999C21 10.1639 20.5784 9.39829 20.1096 8.81225C20.073 8.76653 20.0364 8.72224 20 8.67943ZM19 6.4999V2.62037C19 2.39033 18.849 2.19376 18.5921 2.10311C18.3328 2.01162 18.0652 2.06591 17.9 2.24922C16.9769 3.27391 15.7984 4.44837 14.5322 5.37041C13.4316 6.17185 12.2104 6.82308 11 6.9692V14.0306C12.2104 14.1767 13.4316 14.828 14.5322 15.6294C15.7984 16.5514 16.9769 17.7259 17.9 18.7506C18.0652 18.9339 18.3328 18.9882 18.5921 18.8967C18.849 18.8061 19 18.6095 19 18.3794V15.4999V6.4999ZM6.75381 20.7194C6.84457 21.1732 7.24303 21.4999 7.70583 21.4999C8.31849 21.4999 8.778 20.9394 8.65784 20.3386L7.5901 14.9999H5.6099L6.75381 20.7194ZM10 13.9999V6.9999H5.49946C4.11887 6.9999 3 8.11907 3 9.4999V11.9999C3 13.1045 3.89543 13.9999 5 13.9999H8.00003H10Z",
	fill: "currentColor"
};
function Ws(e, t) {
	return A(), o("path", Us);
}
var Gs = /*#__PURE__*/ W(Hs, [["render", Ws]]), Ks = {};
function qs(e, t) {
	return A(), o("g", null, [...t[0] ||= [
		s("path", {
			d: "M48.76,22.73h-2.64c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9h2.64c0.5,0,0.9-0.4,0.9-0.9S49.26,22.73,48.76,22.73z",
			fill: "currentColor"
		}, null, -1),
		s("path", {
			d: "M44.44,17.91c0.23,0,0.44-0.08,0.61-0.24l2.5-2.29c0.18-0.16,0.28-0.38,0.29-0.62c0.01-0.24-0.07-0.47-0.24-0.65 c-0.34-0.37-0.91-0.39-1.27-0.05l-2.5,2.29c-0.37,0.33-0.39,0.91-0.06,1.27C43.94,17.8,44.19,17.91,44.44,17.91z",
			fill: "currentColor"
		}, null, -1),
		s("path", {
			d: "M45.16,29.63c-0.19-0.15-0.42-0.22-0.66-0.2c-0.24,0.02-0.45,0.14-0.61,0.32c-0.15,0.18-0.22,0.42-0.2,0.66 c0.02,0.24,0.14,0.46,0.32,0.61l2.62,2.16c0.16,0.13,0.36,0.21,0.57,0.21c0.27,0,0.52-0.12,0.69-0.33 c0.32-0.38,0.26-0.95-0.12-1.27L45.16,29.63z",
			fill: "currentColor"
		}, null, -1)
	]]);
}
var Js = /*#__PURE__*/ W(Ks, [["render", qs]]), Ys = {}, Xs = {
	"clip-rule": "evenodd",
	d: "M5 8C5 9.10457 4.10457 10 3 10C1.89543 10 1 9.10457 1 8C1 6.89543 1.89543 6 3 6C4.10457 6 5 6.89543 5 8ZM3 9C3.55228 9 4 8.55228 4 8C4 7.44772 3.55228 7 3 7C2.44772 7 2 7.44772 2 8C2 8.55228 2.44772 9 3 9ZM10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8ZM8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9ZM13 10C14.1046 10 15 9.10457 15 8C15 6.89543 14.1046 6 13 6C11.8954 6 11 6.89543 11 8C11 9.10457 11.8954 10 13 10ZM14 8C14 8.55228 13.5523 9 13 9C12.4477 9 12 8.55228 12 8C12 7.44772 12.4477 7 13 7C13.5523 7 14 7.44772 14 8Z",
	fill: "black",
	"fill-opacity": "0.6",
	"fill-rule": "evenodd"
};
function Zs(e, t) {
	return A(), o("path", Xs);
}
var Qs = /*#__PURE__*/ W(Ys, [["render", Zs]]), $s = {}, ec = {
	"clip-rule": "evenodd",
	d: "M9 12C9 13.1046 8.10457 14 7 14C5.89543 14 5 13.1046 5 12C5 10.8954 5.89543 10 7 10C8.10457 10 9 10.8954 9 12ZM7 13C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13ZM14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12ZM12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13ZM17 14C18.1046 14 19 13.1046 19 12C19 10.8954 18.1046 10 17 10C15.8954 10 15 10.8954 15 12C15 13.1046 15.8954 14 17 14ZM18 12C18 12.5523 17.5523 13 17 13C16.4477 13 16 12.5523 16 12C16 11.4477 16.4477 11 17 11C17.5523 11 18 11.4477 18 12Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function tc(e, t) {
	return A(), o("path", ec);
}
var nc = /*#__PURE__*/ W($s, [["render", tc]]), rc = {}, ic = {
	"clip-rule": "evenodd",
	d: "M13.5321 1.70114C13.2721 1.77623 12.958 1.99634 12.6559 2.5195C12.5114 2.76986 12.4293 3.11722 12.4021 3.52334C12.3753 3.92342 12.4041 4.34214 12.4507 4.70676C12.4792 4.9289 12.6851 5.04779 12.8917 4.96135C13.2308 4.81947 13.6078 4.63504 13.9409 4.4118C14.279 4.18518 14.5388 3.9404 14.6834 3.69005C14.9854 3.16689 15.0189 2.78476 14.954 2.52206C14.8894 2.26081 14.7057 2.02982 14.3941 1.84993C14.0825 1.67004 13.7907 1.62647 13.5321 1.70114ZM13.2546 0.740411C13.8339 0.573095 14.4067 0.702488 14.8941 0.983906C15.3815 1.26532 15.78 1.69664 15.9247 2.282C16.0691 2.86591 15.9393 3.5147 15.5494 4.19005C15.2971 4.62707 14.8978 4.97429 14.4977 5.24247C14.4615 5.26674 14.425 5.29054 14.3883 5.31388H21.187C22.5396 5.31388 23.636 6.41032 23.636 7.76285C23.636 8.62276 23.1928 9.37915 22.5224 9.81607V19.9621C22.5224 21.3428 21.4031 22.4621 20.0224 22.4621H3.97582C2.59511 22.4621 1.47582 21.3428 1.47582 19.9621V9.81615C0.805317 9.37925 0.362061 8.62281 0.362061 7.76285C0.362061 6.41032 1.4585 5.31388 2.81103 5.31388H9.04803C8.65286 4.90466 8.42429 4.4405 8.39372 3.96522C8.36186 3.46972 8.54972 3.01624 8.88922 2.67675C9.22872 2.33725 9.68219 2.14939 10.1777 2.18125C10.6408 2.21103 11.0933 2.42881 11.4948 2.80552C11.5557 2.53192 11.6493 2.26294 11.7899 2.0195C12.1798 1.34415 12.6767 0.907314 13.2546 0.740411ZM2.47582 10.1891V19.9621C2.47582 20.7905 3.14739 21.4621 3.97582 21.4621H20.0224C20.8508 21.4621 21.5224 20.7905 21.5224 19.9621V10.189C21.4127 10.2041 21.3008 10.2118 21.187 10.2118H14.2264C13.9503 10.2118 13.7264 9.98796 13.7264 9.71181C13.7264 9.43567 13.9503 9.21181 14.2264 9.21181H21.187C21.9873 9.21181 22.636 8.56309 22.636 7.76285C22.636 6.9626 21.9873 6.31388 21.187 6.31388H12.4992V18.6214C12.4992 18.8975 12.2753 19.1214 11.9992 19.1214C11.723 19.1214 11.4992 18.8975 11.4992 18.6214V10.2118H2.81103C2.69732 10.2118 2.58542 10.2041 2.47582 10.1891ZM2.81103 6.31388H11.4992V9.21181H2.81103C2.01079 9.21181 1.36206 8.56309 1.36206 7.76285C1.36206 6.9626 2.01079 6.31388 2.81103 6.31388ZM9.7932 4.6455C9.50499 4.35729 9.4042 4.09606 9.39166 3.90104C9.37945 3.71117 9.44653 3.53365 9.59632 3.38385C9.74612 3.23406 9.92364 3.16698 10.1135 3.17919C10.3085 3.19173 10.5698 3.29252 10.858 3.58073C11.092 3.81477 11.2263 4.27694 11.2803 4.7761C11.2996 4.95419 11.1667 5.08709 10.9886 5.06783C10.4894 5.01383 10.0272 4.87955 9.7932 4.6455Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function ac(e, t) {
	return A(), o("path", ic);
}
var oc = /*#__PURE__*/ W(rc, [["render", ac]]), sc = {}, cc = {
	"clip-rule": "evenodd",
	d: "M7.5 7.5a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v1.469a2.5 2.5 0 0 1-1.572 2.321l-1.228.491a3.5 3.5 0 0 0-2.2 3.25V17a.5.5 0 0 0 1 0v-1.969a2.5 2.5 0 0 1 1.572-2.321l1.228-.491a3.5 3.5 0 0 0 2.2-3.25V7.5a4 4 0 0 0-4-4h-3a4 4 0 0 0-4 4V9a.5.5 0 0 0 1 0V7.5ZM12 19a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function lc(e, t) {
	return A(), o("path", cc);
}
var uc = /*#__PURE__*/ W(sc, [["render", lc]]), dc = {}, fc = {
	"clip-rule": "evenodd",
	d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0Zm1 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM7.5 4.5a1 1 0 0 0-1 1v.071a.5.5 0 0 1-1 0V5.5a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v.84a2.15 2.15 0 0 1-1.303 1.977A1.15 1.15 0 0 0 8.5 9.374V10a.5.5 0 0 1-1 0v-.626c0-.86.513-1.638 1.303-1.976A1.15 1.15 0 0 0 9.5 6.34V5.5a1 1 0 0 0-1-1h-1Zm-.25 7.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function pc(e, t) {
	return A(), o("path", fc);
}
var mc = /*#__PURE__*/ W(dc, [["render", pc]]), hc = {}, gc = {
	"clip-rule": "evenodd",
	d: "M5.5 4A1.5 1.5 0 0 1 7 2.5h2A1.5 1.5 0 0 1 10.5 4v.93c0 .501-.25.97-.668 1.248l-1.219.812A2.5 2.5 0 0 0 7.5 9.07V10a.5.5 0 0 0 1 0v-.93c0-.501.25-.97.668-1.248l1.219-.812A2.5 2.5 0 0 0 11.5 4.93V4A2.5 2.5 0 0 0 9 1.5H7A2.5 2.5 0 0 0 4.5 4v1a.5.5 0 0 0 1 0V4ZM8 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function _c(e, t) {
	return A(), o("path", gc);
}
var vc = /*#__PURE__*/ W(hc, [["render", _c]]), yc = {}, bc = {
	"clip-rule": "evenodd",
	d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Zm1 0c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12ZM11 6.5A1.5 1.5 0 0 0 9.5 8v1a.5.5 0 0 1-1 0V8A2.5 2.5 0 0 1 11 5.5h2A2.5 2.5 0 0 1 15.5 8v.93a2.5 2.5 0 0 1-1.113 2.08l-1.22.812a1.5 1.5 0 0 0-.667 1.248V14a.5.5 0 0 1-1 0v-.93a2.5 2.5 0 0 1 1.113-2.08l1.22-.812A1.5 1.5 0 0 0 14.5 8.93V8A1.5 1.5 0 0 0 13 6.5h-2ZM11 17a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function xc(e, t) {
	return A(), o("path", bc);
}
var Sc = /*#__PURE__*/ W(yc, [["render", xc]]), Cc = {}, wc = {
	"clip-rule": "evenodd",
	d: "M47 24C47 36.4264 36.9264 46.5 24.5 46.5C12.0736 46.5 2 36.4264 2 24C2 11.5736 12.0736 1.5 24.5 1.5C36.9264 1.5 47 11.5736 47 24ZM48.5 24C48.5 37.2548 37.7548 48 24.5 48C11.2452 48 0.5 37.2548 0.5 24C0.5 10.7452 11.2452 0 24.5 0C37.7548 0 48.5 10.7452 48.5 24ZM22.5 12.75C20.7051 12.75 19.25 14.2051 19.25 16V18C19.25 18.4142 18.9142 18.75 18.5 18.75C18.0858 18.75 17.75 18.4142 17.75 18V16C17.75 13.3766 19.8766 11.25 22.5 11.25H26.5C29.1234 11.25 31.25 13.3766 31.25 16V18.8593C31.25 20.4474 30.4563 21.9305 29.1348 22.8115L26.6972 24.4366C25.7931 25.0393 25.25 26.0541 25.25 27.1407V30C25.25 30.4142 24.9142 30.75 24.5 30.75C24.0858 30.75 23.75 30.4142 23.75 30V27.1407C23.75 25.5526 24.5437 24.0695 25.8652 23.1885L28.3028 21.5634C29.2069 20.9607 29.75 19.9459 29.75 18.8593V16C29.75 14.2051 28.2949 12.75 26.5 12.75H22.5ZM23 35.5C23 34.6716 23.6716 34 24.5 34C25.3284 34 26 34.6716 26 35.5C26 36.3284 25.3284 37 24.5 37C23.6716 37 23 36.3284 23 35.5Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function Tc(e, t) {
	return A(), o("path", wc);
}
var Ec = /*#__PURE__*/ W(Cc, [["render", Tc]]), Dc = {};
function Oc(t, n) {
	return A(), o(e, null, [
		n[0] ||= s("path", {
			d: "M8.53 7.47a.75.75 0 0 0-1.06 1.06l1.06-1.06ZM7.47 8.53l6 6 1.06-1.06-6-6-1.06 1.06Z",
			fill: "currentColor"
		}, null, -1),
		n[1] ||= s("path", {
			d: "m5 37.5 7.571-5.5M24 41v-3M39 34l-3-2M39 9l-5 5",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-width": "1.5"
		}, null, -1),
		n[2] ||= s("circle", {
			cx: "24",
			cy: "24",
			fill: "transparent",
			r: "14",
			stroke: "currentColor",
			"stroke-width": "1.5"
		}, null, -1),
		n[3] ||= s("path", {
			"clip-rule": "evenodd",
			d: "M17.849 22.337a1.644 1.644 0 0 0 1.833.114l5.13-2.994a1.655 1.655 0 0 0 .55-2.233 1.65 1.65 0 0 0-2.204-.628l-5.133 2.991a1.653 1.653 0 0 0-.768 1.865c.095.353.302.664.592.885Zm1.023 6.294a1.644 1.644 0 0 1-1.591-1.224 1.66 1.66 0 0 1 .762-1.861l10.265-5.989a1.643 1.643 0 0 1 2.252.6 1.658 1.658 0 0 1-.597 2.261l-10.264 5.993a1.637 1.637 0 0 1-.827.22Zm5.15 2.969a1.644 1.644 0 0 1-1.591-1.224 1.66 1.66 0 0 1 .76-1.86l5.134-3a1.643 1.643 0 0 1 2.252.6 1.66 1.66 0 0 1-.597 2.26l-5.132 3a1.637 1.637 0 0 1-.826.224Z",
			fill: "currentColor",
			"fill-rule": "evenodd"
		}, null, -1),
		n[4] ||= s("circle", {
			cx: "43",
			cy: "37",
			fill: "transparent",
			r: "4",
			stroke: "currentColor",
			"stroke-width": "1.5"
		}, null, -1),
		n[5] ||= s("circle", {
			cx: "24",
			cy: "44",
			fill: "transparent",
			r: "3",
			stroke: "currentColor",
			"stroke-width": "1.5"
		}, null, -1),
		n[6] ||= s("circle", {
			cx: "6",
			cy: "6",
			fill: "transparent",
			r: "3",
			stroke: "currentColor",
			"stroke-width": "1.5"
		}, null, -1),
		n[7] ||= s("circle", {
			cx: "3",
			cy: "39",
			fill: "transparent",
			r: "2",
			stroke: "currentColor",
			"stroke-width": "1.5"
		}, null, -1),
		n[8] ||= s("circle", {
			cx: "42",
			cy: "6",
			fill: "transparent",
			r: "4",
			stroke: "currentColor",
			"stroke-width": "1.5"
		}, null, -1)
	], 64);
}
var kc = /*#__PURE__*/ W(Dc, [["render", Oc]]), Ac = {};
function jc(t, n) {
	return A(), o(e, null, [n[0] ||= s("path", {
		"clip-rule": "evenodd",
		d: "M4.454 10h38.923a4.454 4.454 0 0 1 4.454 4.456v14.85a4.451 4.451 0 0 1-4.454 4.451h-13.96l1.911 4.697-8.433-4.697H4.448A4.453 4.453 0 0 1 0 29.305v-14.85A4.455 4.455 0 0 1 4.454 10Z",
		fill: "#7D57A4",
		"fill-rule": "evenodd"
	}, null, -1), n[1] ||= s("path", {
		d: "M2.408 14.034a1.611 1.611 0 0 1 1.223-.604c.993-.07 1.562.399 1.71 1.404.612 4.077 1.267 7.538 1.966 10.383l4.285-8.147c.387-.735.877-1.124 1.47-1.167.858-.06 1.395.486 1.61 1.64a36.454 36.454 0 0 0 1.85 6.68c.514-4.962 1.373-8.55 2.576-10.761a1.506 1.506 0 0 1 1.292-.866c.445-.037.887.101 1.233.386a1.505 1.505 0 0 1 .596 1.129c.032.325-.034.653-.188.941-.763 1.416-1.39 3.77-1.882 7.06-.486 3.178-.665 5.664-.539 7.457.045.44-.034.883-.227 1.28a1.23 1.23 0 0 1-1.041.706c-.516.037-1.03-.206-1.548-.725-1.817-1.864-3.26-4.636-4.329-8.318-1.255 2.51-2.196 4.387-2.824 5.632-1.148 2.209-2.132 3.341-2.951 3.398-.532.037-.985-.41-1.36-1.34-1.003-2.557-2.08-7.503-3.23-14.837a1.672 1.672 0 0 1 .308-1.331ZM44.424 17.106a4.535 4.535 0 0 0-3.125-2.259 5.225 5.225 0 0 0-1.061-.113c-1.873 0-3.402.975-4.59 2.924a10.386 10.386 0 0 0-1.519 5.505c0 1.506.314 2.797.942 3.872a4.527 4.527 0 0 0 3.126 2.26 5.07 5.07 0 0 0 1.06.114c1.891 0 3.42-.974 4.587-2.923a10.52 10.52 0 0 0 1.521-5.538c0-1.506-.314-2.787-.941-3.842Zm-2.466 5.423c-.267 1.28-.763 2.245-1.487 2.893-.573.516-1.1.726-1.577.631-.478-.095-.862-.517-1.15-1.265a5.047 5.047 0 0 1-.345-1.779 6.995 6.995 0 0 1 .143-1.434 6.449 6.449 0 0 1 1.032-2.323c.65-.955 1.329-1.356 2.036-1.203.478.097.861.517 1.148 1.261.22.567.337 1.17.343 1.777.003.485-.045.968-.143 1.442ZM32.173 17.106a4.537 4.537 0 0 0-3.125-2.259 5.226 5.226 0 0 0-1.061-.113c-1.874 0-3.403.975-4.588 2.924a10.371 10.371 0 0 0-1.52 5.505c0 1.506.313 2.797.94 3.872a4.516 4.516 0 0 0 3.127 2.26c.348.075.704.113 1.06.114 1.892 0 3.422-.974 4.59-2.923a10.54 10.54 0 0 0 1.533-5.538c0-1.506-.313-2.787-.941-3.842h-.015Zm-2.466 5.423c-.267 1.283-.764 2.248-1.49 2.897-.575.516-1.101.726-1.578.63-.477-.095-.86-.518-1.146-1.268a5.051 5.051 0 0 1-.345-1.779 6.995 6.995 0 0 1 .143-1.434 6.514 6.514 0 0 1 1.032-2.323c.647-.953 1.326-1.352 2.036-1.199.478.097.86.517 1.147 1.261.22.567.337 1.169.344 1.777.002.482-.046.962-.143 1.434v.004Z",
		fill: "#fff"
	}, null, -1)], 64);
}
var Mc = /*#__PURE__*/ W(Ac, [["render", jc]]), Nc = {}, Pc = {
	d: "M24 3L25.9244 6.36774C26.3093 7.06452 26.3093 7.91613 25.9244 8.6129L14.455 28.6258L19.8818 38.071C20.7285 39.5419 22.3065 40.471 24 40.471C25.6935 40.471 27.2715 39.5419 28.1182 38.071L33.545 28.6258L32.121 26.071L25.9629 36.7935C25.578 37.4903 24.8082 37.9161 24.0385 37.9161C23.2302 37.9161 22.499 37.4903 22.1141 36.7935L17.3801 28.6258L28.0412 10.0452L29.9656 13.4129C30.3505 14.1097 30.3505 14.9613 29.9656 15.6581L22.5375 28.6258L24 31.1806L32.0825 17.0903L37.3938 26.3419C38.2021 27.7742 38.2021 29.5161 37.3938 30.9484L32.0055 40.3548C31.1973 41.7871 28.6186 45 24 45C19.3814 45 16.8412 41.7871 15.9945 40.3548L10.6062 30.9484C9.79794 29.5161 9.79794 27.7742 10.6062 26.3419L24 3Z",
	fill: "#ED5153"
};
function Fc(e, t) {
	return A(), o("path", Pc);
}
var Ic = /*#__PURE__*/ W(Nc, [["render", Fc]]), Lc = {};
function Rc(t, n) {
	return A(), o(e, null, [n[0] ||= s("g", { "clip-path": "url(#clip0_cscart_48)" }, [s("path", {
		d: "M47.52 16.92934V41.7454C47.52 44.7248 45.1062 47.1384 42.1268 47.1384H17.31072C14.33134 47.1384 11.9176 44.7248 11.9176 41.7454V16.92934C11.9176 13.94986 14.33134 11.53612 17.31072 11.53612H42.1268C45.1062 11.53612 47.52 13.94986 47.52 16.92934ZM6.85018 1.075562C3.87074 1.075562 1.457032 3.48928 1.457032 6.4687C1.457032 9.44812 3.87074 11.86186 6.85018 11.86186C9.8296 11.86186 12.2433 9.44812 12.2433 6.4687C12.2433 3.48928 9.8296 1.075562 6.85018 1.075562Z",
		fill: "url(#paint0_linear_cscart_48)"
	})], -1), n[1] ||= s("defs", null, [s("linearGradient", {
		id: "paint0_linear_cscart_48",
		x1: "8.26776",
		y1: "40.329",
		x2: "40.711",
		y2: "7.88564",
		gradientUnits: "userSpaceOnUse"
	}, [s("stop", { "stop-color": "#7381FD" }), s("stop", {
		offset: "1",
		"stop-color": "#76C7FF"
	})]), s("clipPath", { id: "clip0_cscart_48" }, [s("rect", {
		width: "48",
		height: "48",
		fill: "white"
	})])], -1)], 64);
}
var zc = /*#__PURE__*/ W(Lc, [["render", Rc]]), Bc = {};
function Vc(t, n) {
	return A(), o(e, null, [n[0] ||= s("g", { "clip-path": "url(#clip0_presta_24)" }, [
		s("path", {
			d: "M5.40493 19.3791C5.40022 19.3599 5.40022 19.3311 5.40022 19.2926C5.40022 19.0477 5.4803 18.8555 5.64044 18.721C5.80059 18.5817 5.97487 18.5144 6.16799 18.5144C6.42234 18.5144 6.60133 18.6105 6.70025 18.8075L5.40493 19.3791ZM7.26076 19.0332C7.25605 18.745 7.15243 18.5096 6.94047 18.3271C6.72851 18.1446 6.46473 18.0581 6.14444 18.0581C5.9419 18.0581 5.74878 18.1013 5.56979 18.1926C5.38609 18.2839 5.23536 18.4232 5.1129 18.6201C4.99043 18.8123 4.9292 19.0332 4.9292 19.2878C4.9292 19.6529 5.04695 19.9507 5.28247 20.1717C5.51798 20.3975 5.8053 20.508 6.13502 20.508C6.51184 20.508 6.84155 20.3638 7.11946 20.0708L6.83213 19.7442C6.66256 19.9507 6.44589 20.0564 6.18683 20.0564C5.92306 20.0564 5.71581 19.9603 5.56508 19.7682L7.26547 19.038L7.26076 19.0332Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M4.3637 18.2022C4.2271 18.2983 4.11877 18.4184 4.0434 18.5673V18.0869H3.54883V20.4695H4.03869V19.4512C4.03869 19.1822 4.09992 18.9612 4.22239 18.8027C4.34486 18.6393 4.52856 18.5625 4.76878 18.5625H4.79704L4.79233 18.0581C4.64631 18.0581 4.50029 18.1061 4.3637 18.2022Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M9.01775 19.2589C8.93768 19.2061 8.86702 19.1629 8.79637 19.134C8.72572 19.1052 8.65506 19.0764 8.58441 19.0524C8.50905 19.0284 8.42897 19.0043 8.33006 18.9803C8.23585 18.9563 8.16049 18.9323 8.10868 18.9035C8.03331 18.8698 7.99563 18.8122 7.99563 18.7353C7.99563 18.6489 8.03331 18.5816 8.10397 18.5384C8.17933 18.4952 8.27353 18.4711 8.39129 18.4711C8.61267 18.4711 8.81992 18.5336 9.00833 18.6633L9.19203 18.2934C8.95181 18.1301 8.69745 18.0532 8.42897 18.0532C8.16049 18.0532 7.93911 18.1205 7.77425 18.2502C7.60468 18.3847 7.5199 18.5576 7.5199 18.7786C7.5199 19.0908 7.76483 19.3166 8.24998 19.4511C8.2594 19.4559 8.27824 19.4607 8.3018 19.4703C8.61267 19.5664 8.76811 19.672 8.76811 19.7921C8.76811 19.8738 8.73514 19.941 8.6739 19.9891C8.60796 20.0419 8.52318 20.0659 8.41013 20.0659C8.15578 20.0659 7.89201 19.9603 7.61881 19.7537L7.3833 20.1428C7.52461 20.2581 7.68476 20.3445 7.86845 20.407C8.05215 20.4694 8.22643 20.5031 8.396 20.5031C8.64564 20.5031 8.85289 20.4358 9.01304 20.3013C9.17319 20.1668 9.25326 19.9843 9.25326 19.7585C9.25797 19.5327 9.1779 19.3694 9.01775 19.2589Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M2.5176 18.9083C2.41398 19.0188 2.21615 19.0765 1.93353 19.0765H1.33063V17.8227H1.85817C2.14078 17.8227 2.34332 17.8659 2.47521 17.9572C2.6071 18.0485 2.67304 18.1974 2.67304 18.4136C2.67304 18.6345 2.62123 18.7978 2.5176 18.9083ZM2.885 17.6162C2.67304 17.4336 2.3339 17.3423 1.86759 17.3423H0.8125V20.4695H1.33063V19.552H1.87701C2.32919 19.552 2.66362 19.4655 2.88029 19.2878C3.09696 19.1101 3.2053 18.8363 3.2053 18.4568C3.2053 18.0821 3.09696 17.7987 2.885 17.6162Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M10.4068 20.0756C10.3032 20.0756 10.2184 20.042 10.1619 19.9747C10.1054 19.9075 10.0724 19.8162 10.0724 19.7057V18.4952H10.6847V18.0917H10.0724V17.3423H9.58252V19.6865C9.58252 19.9363 9.65788 20.1381 9.8039 20.2822C9.94992 20.4311 10.1289 20.5031 10.3409 20.5031C10.5481 20.5031 10.7412 20.4263 10.9155 20.2678L10.713 19.9123C10.6141 20.0228 10.5104 20.0756 10.4068 20.0756Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M12.6543 19.8499C12.5177 19.994 12.3576 20.066 12.1645 20.066C11.9713 20.066 11.8018 19.994 11.6605 19.8499C11.5192 19.7057 11.4438 19.5232 11.4438 19.2926C11.4438 19.0621 11.5144 18.8747 11.6558 18.721C11.7971 18.5673 11.9619 18.4904 12.1597 18.4904C12.3576 18.4904 12.5224 18.5673 12.6543 18.721C12.7909 18.8747 12.8569 19.0621 12.8569 19.2878C12.8569 19.5184 12.7909 19.7057 12.6543 19.8499ZM12.8474 18.5048C12.6496 18.207 12.3953 18.0581 12.0891 18.0581C11.7829 18.0581 11.5144 18.1686 11.2884 18.3896C11.0623 18.6105 10.9492 18.9035 10.9492 19.2734C10.9492 19.6433 11.0576 19.9411 11.2789 20.1669C11.5003 20.3927 11.7547 20.508 12.0514 20.508C12.1974 20.508 12.3434 20.4695 12.4895 20.3975C12.6355 20.3254 12.7532 20.2197 12.8474 20.0804V20.4695H13.3373V18.0869H12.8474V18.5048Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M20.6236 19.8451C20.4823 19.9892 20.308 20.0612 20.0961 20.0612C19.8841 20.0612 19.7051 19.9892 19.5685 19.8451C19.4272 19.7009 19.3613 19.5136 19.3613 19.283C19.3613 19.0525 19.4319 18.8651 19.5685 18.721C19.7051 18.5769 19.8841 18.5048 20.0961 18.5048C20.308 18.5048 20.487 18.5769 20.6236 18.721C20.7602 18.8651 20.8309 19.0525 20.8309 19.283C20.8309 19.5136 20.7649 19.7009 20.6236 19.8451ZM20.0961 18.0581C19.7428 18.0581 19.4508 18.1782 19.22 18.4136C18.9845 18.649 18.8667 18.942 18.8667 19.283C18.8667 19.6241 18.9845 19.9171 19.22 20.1525C19.4555 20.3879 19.7475 20.508 20.0961 20.508C20.4446 20.508 20.7414 20.3879 20.9722 20.1525C21.2077 19.9171 21.3254 19.6241 21.3254 19.283C21.3254 18.942 21.2077 18.649 20.9722 18.4136C20.7367 18.1734 20.4446 18.0581 20.0961 18.0581Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M23.2945 19.8451C23.1532 19.9892 22.9836 20.0612 22.7905 20.0612C22.5974 20.0612 22.4325 19.9892 22.3007 19.8451C22.1641 19.7009 22.0981 19.5136 22.0981 19.2878C22.0981 19.0621 22.1641 18.8747 22.3007 18.721C22.4373 18.5721 22.6021 18.4952 22.7952 18.4952C22.9931 18.4952 23.1579 18.5721 23.2992 18.721C23.4405 18.8699 23.5112 19.0621 23.5112 19.2878C23.5065 19.5184 23.4358 19.7009 23.2945 19.8451ZM23.6666 18.3896C23.4452 18.1686 23.1768 18.0581 22.8659 18.0581C22.555 18.0581 22.3007 18.207 22.1075 18.5096V18.0917H21.6177V21.339H22.1075V20.1141C22.3431 20.3783 22.6068 20.508 22.8989 20.508C23.1909 20.508 23.45 20.3927 23.6713 20.1621C23.8927 19.9315 24.0011 19.6337 24.0011 19.2686C24.0011 18.9035 23.888 18.6057 23.6666 18.3896Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M17.7221 18.058C17.5573 18.058 17.4065 18.1012 17.2652 18.1829C17.1239 18.2646 17.0156 18.3798 16.9449 18.5288V17.1597H16.4551V20.4742H16.9449V19.1869C16.9449 18.9659 17.0062 18.7978 17.1334 18.6825C17.2605 18.5672 17.4065 18.5095 17.5761 18.5095C17.9341 18.5095 18.1131 18.7305 18.1131 19.1676V20.4742H18.6029V19.0139C18.6029 18.7017 18.5229 18.4663 18.358 18.303C18.1979 18.1397 17.9859 18.058 17.7221 18.058Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M15.8665 18.9707C15.7063 18.8314 15.4708 18.721 15.1552 18.6441C14.8396 18.5672 14.6371 18.4952 14.5382 18.4279C14.444 18.3607 14.3922 18.2646 14.3922 18.1349C14.3922 18.01 14.4393 17.9139 14.5382 17.8515C14.6324 17.7891 14.7596 17.7554 14.9103 17.7554C15.061 17.7554 15.2117 17.7843 15.3672 17.8371C15.5226 17.8899 15.6451 17.9572 15.7346 18.0436L16.0125 17.6449C15.8712 17.5249 15.7063 17.4336 15.5132 17.3663C15.3201 17.2991 15.127 17.2703 14.9291 17.2703C14.623 17.2703 14.3686 17.3471 14.1614 17.5056C13.9541 17.6642 13.8505 17.8851 13.8505 18.1733C13.8505 18.4616 13.94 18.6777 14.1237 18.817C14.2132 18.8939 14.3168 18.9515 14.4346 18.9996C14.5523 19.0476 14.7219 19.0956 14.948 19.1533C15.1741 19.2061 15.3295 19.2686 15.4237 19.3358C15.5179 19.4031 15.5603 19.4991 15.5603 19.6192C15.5603 19.7393 15.5132 19.8354 15.4143 19.9123C15.3154 19.9843 15.1835 20.0227 15.0186 20.0227C14.6842 20.0227 14.3639 19.8834 14.053 19.6096L13.728 20.0083C14.1001 20.3446 14.5241 20.5127 15.0045 20.5127C15.3342 20.5127 15.598 20.4262 15.8005 20.2581C16.0031 20.09 16.102 19.869 16.102 19.5952C16.102 19.3214 16.0266 19.1101 15.8665 18.9707Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M9.91655 12.5723C10.0296 12.5195 10.1426 12.4763 10.2604 12.4282C10.3923 12.3802 10.5242 12.3322 10.6561 12.2889C10.8209 12.2361 10.9905 12.1929 11.16 12.1544C11.3908 12.1064 11.6217 12.068 11.8525 12.0439C11.7206 12.4619 11.5793 12.8798 11.4191 13.2929C11.4238 13.3746 11.4285 13.4514 11.4332 13.5331C11.7488 13.4706 12.0738 13.437 12.4083 13.437C12.7427 13.437 13.0677 13.4706 13.3833 13.5331C13.3833 13.4514 13.388 13.3697 13.3974 13.2929C13.242 12.8798 13.096 12.4619 12.9641 12.0439C13.1949 12.068 13.4304 12.1016 13.6565 12.1544C13.826 12.1929 13.9909 12.2361 14.1605 12.2889C14.2923 12.3322 14.4242 12.3754 14.5561 12.4282C14.6739 12.4715 14.7869 12.5195 14.9 12.5723C15.7007 12.9374 16.4308 13.4754 17.029 14.1768C18.5316 12.8558 19.483 10.9007 19.483 8.71504C19.483 4.73284 16.3177 1.5 12.4083 1.5C8.50348 1.5 5.3335 4.72803 5.3335 8.71504C5.3335 10.8959 6.28496 12.851 7.78752 14.1768C8.38572 13.4754 9.11581 12.9374 9.91655 12.5723Z",
			fill: "#A0DBE8"
		}),
		s("path", {
			d: "M10.3825 13.8789C10.7123 13.73 11.0655 13.6147 11.4282 13.5427C11.4282 13.461 11.4235 13.3793 11.4141 13.3025C11.5695 12.8894 11.7155 12.4714 11.8474 12.0535C11.6166 12.0775 11.3811 12.1112 11.155 12.164C10.9855 12.2024 10.8206 12.2457 10.651 12.2985C10.5191 12.3417 10.3873 12.385 10.2554 12.4378L10.7688 12.5675L10.3825 13.8789Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M9.16752 14.6523C9.18165 14.5178 9.18636 14.3833 9.18636 14.244C9.18636 14.1623 9.25231 14.0951 9.33238 14.0951H9.45956L9.91174 12.5675C9.111 12.9326 8.38091 13.4706 7.78271 14.1719C8.11243 14.4649 8.47041 14.7243 8.84723 14.9501C8.95556 14.8492 9.05919 14.7483 9.16752 14.6523Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M14.895 12.5723L15.3472 14.0999H15.4744C15.5545 14.0999 15.6204 14.1671 15.6204 14.2488C15.6204 14.3881 15.6298 14.5226 15.6392 14.6571C15.7476 14.7532 15.8559 14.8492 15.9548 14.9549C16.3363 14.7292 16.6896 14.4698 17.0193 14.1767C16.4258 13.4754 15.6958 12.9374 14.895 12.5723Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M14.0327 12.558L14.5462 12.4283C14.4143 12.3803 14.2824 12.3322 14.1505 12.289C13.9856 12.2362 13.8161 12.1929 13.6465 12.1545C13.4157 12.1065 13.1849 12.068 12.9541 12.044C13.086 12.4619 13.2273 12.8798 13.3874 13.2929C13.3827 13.3746 13.378 13.4515 13.3733 13.5331C13.7407 13.6052 14.0893 13.7205 14.419 13.8694L14.0327 12.558Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M12.4034 14.0999H13.4019C13.3831 13.9125 13.3737 13.7252 13.3784 13.5427C13.0628 13.4802 12.7378 13.4466 12.4034 13.4466C12.0689 13.4466 11.7439 13.4802 11.4283 13.5427C11.433 13.73 11.4236 13.9125 11.4048 14.0999H12.4034Z",
			fill: "black"
		}),
		s("path", {
			d: "M8.85205 14.9501C8.93212 14.9981 9.01691 15.0462 9.10169 15.0942C9.12995 14.9501 9.15351 14.8012 9.16764 14.6523C9.0593 14.7484 8.95568 14.8492 8.85205 14.9501Z",
			fill: "black"
		}),
		s("path", {
			d: "M10.3169 14.0999H11.4097C11.4285 13.9125 11.4379 13.7252 11.4332 13.5427C11.0658 13.6147 10.7173 13.73 10.3875 13.8789L10.3169 14.0999Z",
			fill: "black"
		}),
		s("path", {
			d: "M15.644 14.6523C15.6582 14.8012 15.6817 14.9501 15.71 15.0942C15.7948 15.051 15.8748 15.0029 15.9596 14.9501C15.856 14.8492 15.7524 14.7484 15.644 14.6523Z",
			fill: "black"
		}),
		s("path", {
			d: "M14.4946 14.0999L14.4287 13.8789C14.099 13.73 13.7457 13.6147 13.383 13.5427C13.3783 13.73 13.3877 13.9125 13.4066 14.0999H14.4946Z",
			fill: "black"
		}),
		s("path", {
			d: "M10.3164 14.0999L10.3824 13.8789L10.7733 12.5579L10.2599 12.4282C10.1421 12.4715 10.0291 12.5195 9.91605 12.5723L9.46387 14.0999H9.94902H10.3164Z",
			fill: "#AA9678"
		}),
		s("path", {
			d: "M14.429 13.8789L14.495 14.0999H14.8624H15.3475L14.8953 12.5723C14.7823 12.5195 14.6693 12.4763 14.5515 12.4282L14.0381 12.5579L14.429 13.8789Z",
			fill: "#AA9678"
		}),
		s("path", {
			d: "M9.47852 14.4074C9.48325 14.4025 9.48798 14.4025 9.49272 14.3977H9.47852C9.47852 14.3977 9.47852 14.4025 9.47852 14.4074Z",
			fill: "#C0B098"
		}),
		s("path", {
			d: "M12.4035 14.3977H11.3625H10.2274H9.49258C9.48787 14.4025 9.48316 14.4025 9.47845 14.4073C9.46903 14.6907 9.43135 14.9645 9.37012 15.2335C10.2886 15.6803 11.3154 15.9301 12.4035 15.9301V14.3977Z",
			fill: "#C0B098"
		}),
		s("path", {
			d: "M15.333 14.3977H15.3188C15.3236 14.4025 15.3283 14.4025 15.333 14.4074C15.333 14.4025 15.333 14.3977 15.333 14.3977Z",
			fill: "#AA9678"
		}),
		s("path", {
			d: "M15.319 14.3977H14.5842H13.4443H12.4033V15.9301C13.4867 15.9301 14.5182 15.6803 15.4367 15.2335C15.3755 14.9645 15.3378 14.6859 15.3284 14.4073C15.3284 14.4025 15.3237 14.3977 15.319 14.3977Z",
			fill: "#AA9678"
		}),
		s("path", {
			d: "M15.6439 14.6523C15.6298 14.5178 15.6251 14.3832 15.6251 14.2439C15.6251 14.1623 15.5591 14.095 15.479 14.095H15.3519H14.8573H14.4899H13.3971H12.3986H11.4H10.3072H9.93981H9.45466H9.32748C9.24741 14.095 9.18146 14.1623 9.18146 14.2439C9.18146 14.3832 9.17204 14.5178 9.16262 14.6523C9.14849 14.8012 9.12494 14.9501 9.09668 15.0942C9.18617 15.1422 9.27567 15.1903 9.36516 15.2335C9.4264 14.9645 9.46408 14.6859 9.4735 14.4073C9.4735 14.4025 9.4735 14.4025 9.4735 14.3977H9.48763H10.2224H11.3576H12.3986H13.4442H14.5794H15.3142H15.3283C15.3283 14.4025 15.3283 14.4025 15.3283 14.4073C15.3377 14.6907 15.3754 14.9645 15.4366 15.2335C15.5261 15.1903 15.6156 15.1422 15.7051 15.0942C15.6769 14.9501 15.658 14.8012 15.6439 14.6523Z",
			fill: "#8B7460"
		}),
		s("path", {
			d: "M14.4291 13.0674C14.4054 13.0433 14.3865 13.0143 14.3628 12.9854C14.3865 13.0191 14.4101 13.0433 14.4291 13.0674Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M17.1133 7.11055C17.0521 7.02409 16.9909 6.94723 16.9297 6.87998C16.9014 6.84635 16.8731 6.81753 16.8449 6.78871C16.8354 6.7791 16.8213 6.7695 16.8119 6.75989C16.7931 6.74067 16.7742 6.72626 16.7554 6.71185V7.38436L17.005 8.56125C17.0097 8.57085 17.0097 8.58046 17.0144 8.59007L17.1887 8.79182H17.3724C17.3724 8.77261 17.3724 8.7582 17.3724 8.73898C17.3724 8.18176 17.2829 7.64856 17.1228 7.14898C17.1181 7.12977 17.1181 7.12016 17.1133 7.11055Z",
			fill: "#BBBCBD"
		}),
		s("path", {
			d: "M17.0337 8.67176V8.67656C17.0337 8.67656 17.0337 8.67656 17.0337 8.68136C17.0384 8.71018 17.0384 8.73901 17.0384 8.76783C17.0384 8.77263 17.0384 8.77744 17.0384 8.78224C17.0384 8.78704 17.0384 8.79185 17.0384 8.79665C17.0384 8.82547 17.0384 8.85429 17.0337 8.87831V8.88312V8.88792C17.029 8.91674 17.0242 8.94556 17.0195 8.97438L17.1938 8.77744L17.0195 8.57568C17.0242 8.60931 17.029 8.63813 17.0337 8.67176Z",
			fill: "#676A6A"
		}),
		s("path", {
			d: "M17.0285 8.89747C17.0285 8.89267 17.0285 8.89267 17.0285 8.88787C17.0332 8.85905 17.0332 8.83022 17.0332 8.80621C17.0332 8.8014 17.0332 8.79179 17.0332 8.78699C17.0332 8.78219 17.0332 8.77738 17.0332 8.76778C17.0332 8.73895 17.0332 8.71013 17.0285 8.68131C17.0285 8.67651 17.0285 8.67651 17.0285 8.6717C17.0238 8.64288 17.019 8.61406 17.0143 8.58524C17.0096 8.57563 17.0096 8.56602 17.0049 8.55642C16.9861 8.49877 16.9672 8.45074 16.939 8.40751C16.9343 8.4027 16.9295 8.3979 16.9295 8.39309C16.9201 8.38349 16.9154 8.37388 16.906 8.36427C16.8966 8.34986 16.8824 8.34025 16.8683 8.33065C16.8636 8.32584 16.8589 8.32584 16.8542 8.32104C16.8448 8.31143 16.8306 8.30663 16.8212 8.30183C16.8165 8.30183 16.8118 8.29702 16.8071 8.29702C16.793 8.29222 16.7741 8.28741 16.7553 8.28741C16.7364 8.28741 16.7223 8.29222 16.7035 8.29702C16.6987 8.29702 16.694 8.30183 16.6893 8.30183C16.6799 8.30663 16.6658 8.31143 16.6564 8.32104C16.6516 8.32584 16.6469 8.32584 16.6422 8.33065C16.6281 8.34025 16.6187 8.35467 16.6045 8.36427C16.5951 8.37388 16.5904 8.38349 16.581 8.39309C16.5763 8.3979 16.5716 8.4027 16.5716 8.40751C16.5433 8.45074 16.5198 8.49877 16.5056 8.55642V8.56122C16.4962 8.58524 16.4915 8.61406 16.4868 8.64288C16.4868 8.65249 16.4821 8.65729 16.4821 8.6669C16.4774 8.70053 16.4774 8.72935 16.4727 8.76297C16.4727 8.76778 16.4727 8.77258 16.4727 8.77738C16.4727 9.05119 16.5998 9.27696 16.7553 9.27696C16.7835 9.27696 16.8071 9.26735 16.8353 9.25775C16.8401 9.25775 16.8448 9.25294 16.8495 9.25294C16.8589 9.24814 16.8683 9.23853 16.8777 9.23373C16.8824 9.22892 16.8872 9.22412 16.8919 9.21932C16.906 9.20971 16.9154 9.1953 16.9295 9.18089C16.939 9.17128 16.9437 9.16167 16.9531 9.14726C16.9578 9.13766 16.9625 9.13285 16.9672 9.12324C16.9767 9.10883 16.9814 9.09442 16.9908 9.07521C16.9955 9.0704 16.9955 9.0656 17.0002 9.05599C17.0096 9.03198 17.0143 9.00796 17.0238 8.98394C17.0238 8.95512 17.0285 8.9263 17.0285 8.89747ZM16.7647 8.71494C16.7035 8.71494 16.6564 8.63328 16.6564 8.5276C16.6564 8.42672 16.7035 8.34025 16.7647 8.34025C16.8259 8.34025 16.873 8.42192 16.873 8.5276C16.873 8.63328 16.8212 8.71494 16.7647 8.71494Z",
			fill: "black"
		}),
		s("path", {
			d: "M16.7646 8.71495C16.8244 8.71495 16.8729 8.63108 16.8729 8.52761C16.8729 8.42415 16.8244 8.34027 16.7646 8.34027C16.7048 8.34027 16.6562 8.42415 16.6562 8.52761C16.6562 8.63108 16.7048 8.71495 16.7646 8.71495Z",
			fill: "white"
		}),
		s("path", {
			d: "M16.501 8.5564C16.5198 8.49876 16.5387 8.45072 16.5669 8.40749C16.5716 8.40269 16.5763 8.39788 16.5763 8.39308C16.5858 8.38347 16.5905 8.37387 16.5999 8.36426C16.6093 8.34985 16.6234 8.34024 16.6376 8.33063C16.6423 8.32583 16.647 8.32583 16.6517 8.32103C16.6611 8.31142 16.6753 8.30662 16.6847 8.30181C16.6894 8.30181 16.6941 8.29701 16.6988 8.29701C16.7129 8.2922 16.7318 8.2874 16.7506 8.2874C16.7695 8.2874 16.7836 8.2922 16.8024 8.29701C16.8071 8.29701 16.8119 8.30181 16.8166 8.30181C16.826 8.30662 16.8401 8.31142 16.8495 8.32103C16.8542 8.32583 16.859 8.32583 16.8637 8.33063C16.8778 8.34024 16.8872 8.35465 16.9013 8.36426C16.9108 8.37387 16.9155 8.38347 16.9249 8.39308C16.9296 8.39788 16.9343 8.40269 16.9343 8.40749C16.9626 8.45072 16.9861 8.49876 17.0003 8.5564L16.7506 7.37952L16.501 8.5564Z",
			fill: "#909393"
		}),
		s("path", {
			d: "M13.4158 8.77268C13.4158 8.74867 13.4158 8.72465 13.4111 8.70063C13.4064 8.67661 13.4064 8.6574 13.4017 8.63338C13.397 8.60936 13.3923 8.59015 13.3829 8.57093C13.3781 8.55172 13.3687 8.5277 13.3593 8.50849C13.3499 8.48927 13.3405 8.47006 13.331 8.45084C13.2981 8.3932 13.2604 8.34036 13.2133 8.29713C13.1521 8.23948 13.0814 8.19145 13.006 8.15782C12.9684 8.14341 12.926 8.129 12.8883 8.11939C12.8883 8.11939 12.8883 8.11939 12.8836 8.11939C12.8412 8.10978 12.7988 8.10498 12.7564 8.10498C12.714 8.10498 12.6716 8.10978 12.6292 8.11939H12.6245C12.5821 8.129 12.5444 8.13861 12.5068 8.15302C12.5068 8.15302 12.5068 8.15302 12.502 8.15302C12.4644 8.16743 12.4267 8.18664 12.3937 8.21066C12.3607 8.23468 12.3278 8.2587 12.2995 8.28752H12.2948C12.2477 8.33555 12.2053 8.38839 12.1723 8.44604C12.1629 8.46525 12.1535 8.48447 12.1441 8.50368C12.1441 8.50368 12.1441 8.50849 12.1394 8.50849C12.1299 8.5277 12.1252 8.54211 12.1205 8.56132C12.1205 8.56613 12.1158 8.56613 12.1158 8.57093C12.1111 8.59015 12.1064 8.60456 12.1017 8.62377C12.1017 8.62858 12.097 8.63338 12.097 8.63818C12.0923 8.6574 12.0923 8.67181 12.0875 8.69102C12.0875 8.69583 12.0875 8.70063 12.0828 8.70543C12.0828 8.72945 12.0781 8.75347 12.0781 8.77749C12.0781 8.82072 12.0828 8.86395 12.0923 8.90718C12.0923 8.90718 12.0923 8.90719 12.0923 8.91199C12.1017 8.95522 12.1111 8.99365 12.1299 9.03688C12.1629 9.11374 12.21 9.1858 12.2665 9.24824C12.3136 9.29628 12.3654 9.33951 12.422 9.37314C12.4408 9.38274 12.4597 9.39235 12.4785 9.40196H12.4832C12.502 9.41157 12.5209 9.41637 12.535 9.42117C12.5397 9.42117 12.5397 9.42117 12.5444 9.42598C12.5633 9.43078 12.5774 9.43558 12.5963 9.44039C12.601 9.44039 12.6057 9.44519 12.6104 9.44519C12.6292 9.44999 12.6434 9.44999 12.6622 9.4548C12.6669 9.4548 12.6716 9.4548 12.6763 9.4596C12.6999 9.4596 12.7234 9.46441 12.747 9.46441C12.8412 9.46441 12.926 9.44519 13.006 9.41157C13.0437 9.39235 13.0814 9.37314 13.1191 9.34912C13.1897 9.30108 13.251 9.23864 13.2981 9.16658C13.3216 9.12815 13.3405 9.08972 13.3593 9.05129C13.3923 8.96963 13.4111 8.87836 13.4111 8.78709V8.78229C13.4158 8.77268 13.4158 8.77268 13.4158 8.77268ZM12.7517 8.69102C12.6151 8.69102 12.502 8.57574 12.502 8.43643C12.502 8.29713 12.6151 8.18184 12.7517 8.18184C12.8883 8.18184 13.0013 8.29713 13.0013 8.43643C13.0013 8.57574 12.8883 8.69102 12.7517 8.69102Z",
			fill: "black"
		}),
		s("path", {
			d: "M12.7521 8.69095C12.89 8.69095 13.0017 8.57696 13.0017 8.43635C13.0017 8.29575 12.89 8.18176 12.7521 8.18176C12.6142 8.18176 12.5024 8.29575 12.5024 8.43635C12.5024 8.57696 12.6142 8.69095 12.7521 8.69095Z",
			fill: "white"
		}),
		s("path", {
			d: "M12.2903 8.28749L12.7519 6.8512C12.7519 6.8512 12.7519 6.76474 12.7519 6.68308C12.7519 6.65906 12.7519 6.63504 12.7519 6.61583C12.7519 6.60622 12.7519 6.60142 12.7519 6.59661C12.7519 6.587 12.7519 6.5774 12.7519 6.56779C12.7519 6.56299 12.7519 6.55338 12.7519 6.54858C12.7519 6.54377 12.7519 6.53416 12.7519 6.52936C12.7519 6.52456 12.7519 6.51975 12.7519 6.51975C12.7519 6.51495 12.7519 6.51495 12.7519 6.51495C12.4975 6.46211 12.2338 6.43329 11.9653 6.43329C11.8758 6.43329 11.7863 6.43809 11.6968 6.4429C11.6827 6.4429 11.6732 6.4429 11.6591 6.4477C11.1975 6.48132 10.7453 6.60622 10.3261 6.80317C9.96814 6.97129 9.62901 7.19226 9.33226 7.45166C9.25219 7.52371 9.17211 7.59576 9.09675 7.67262C9.08262 7.68703 9.06849 7.70144 9.05436 7.71586C8.98371 7.78791 8.91305 7.86477 8.84711 7.94163C8.83298 7.96084 8.81885 7.97525 8.80472 7.99446C8.73877 8.07613 8.67283 8.15779 8.6116 8.23945C8.60689 8.24425 8.60218 8.25386 8.59747 8.25866C8.54094 8.34033 8.48442 8.42199 8.4279 8.50845C8.41848 8.52286 8.40435 8.54208 8.39493 8.55649C8.35254 8.62854 8.31014 8.7006 8.27246 8.77265H10.3591H10.3638L12.2903 8.28749Z",
			fill: "#BBBCBD"
		}),
		s("path", {
			d: "M14.0565 8.12889C14.0613 8.07125 14.066 8.01841 14.066 7.96076C14.0707 7.88391 14.0707 7.81185 14.0754 7.73499C14.0754 7.67735 14.0754 7.61971 14.0754 7.55726C14.0754 7.53805 14.0754 7.52363 14.0754 7.50442C14.0754 7.3507 14.066 7.20179 14.0613 7.04808C14.0613 7.04808 14.0565 7.04808 14.0565 7.04327C14.0565 7.04327 14.0518 7.04327 14.0518 7.03847C14.0236 7.02406 13.9576 6.98563 13.8964 6.9472H13.8917C13.8776 6.93759 13.8634 6.92799 13.8493 6.92318C13.8399 6.91838 13.8305 6.90877 13.821 6.90397L13.8163 6.89916C13.8069 6.89436 13.7975 6.88956 13.7928 6.88475C13.6986 6.83191 13.5997 6.78868 13.5007 6.74545C13.2652 6.64457 12.9449 6.5533 12.7612 6.51007V6.63977V6.66859V6.6782C12.7612 6.76466 12.7612 6.84632 12.7612 6.84632L13.2181 8.2778C13.2652 8.32104 13.3076 8.37388 13.3359 8.43152C13.3453 8.45073 13.3547 8.46995 13.3641 8.48916C13.3736 8.50838 13.383 8.52759 13.3877 8.55161C13.3924 8.57082 13.4018 8.59484 13.4065 8.61406C13.4112 8.63808 13.416 8.65729 13.416 8.68131C13.4207 8.70533 13.4207 8.72934 13.4207 8.75336V8.75817H13.9765C14.0142 8.55161 14.0424 8.34025 14.0565 8.12889C14.0565 8.1385 14.0565 8.13369 14.0565 8.12889Z",
			fill: "#E2DDDB"
		}),
		s("path", {
			d: "M13.421 10.819C13.5482 10.6893 13.6659 10.5692 13.779 10.4491C13.8449 10.3771 13.9109 10.305 13.9768 10.2378C14.4431 9.72379 14.7822 9.23863 14.9895 8.61896C14.9942 8.60455 14.9989 8.58533 15.0036 8.56132C15.0036 8.55651 15.0036 8.55651 15.0036 8.55171C15.0083 8.52769 15.0131 8.50367 15.0178 8.47485C15.0178 8.45564 15.0225 8.43642 15.0225 8.41721C14.9707 8.1482 14.8717 7.884 14.7823 7.62461C14.7823 7.62461 14.7823 7.62461 14.7823 7.62941C14.7823 7.62941 14.7822 7.62941 14.7775 7.62461C14.7587 7.6102 14.7446 7.59098 14.7257 7.57657C14.6739 7.52854 14.6221 7.4805 14.5656 7.43246C14.4007 7.29316 14.2312 7.16346 14.0522 7.05298C14.0616 7.20669 14.0663 7.35561 14.0663 7.50932C14.0663 7.52854 14.0663 7.54295 14.0663 7.56216C14.0663 7.61981 14.0663 7.67745 14.0663 7.7399C14.0663 7.81675 14.0616 7.89361 14.0569 7.96567C14.0522 8.02331 14.0522 8.07615 14.0475 8.13379C14.0475 8.1386 14.0475 8.1434 14.0475 8.15301C14.0286 8.36437 14.0051 8.57573 13.9674 8.78228L13.9014 9.09932C13.7648 9.66615 13.4869 10.1753 13.2608 10.7037C13.1996 10.843 13.1431 10.9871 13.0913 11.1313C13.0866 11.1457 13.0819 11.1601 13.0771 11.1745C13.1478 11.0976 13.2137 11.0304 13.2608 10.9823C13.3221 10.9199 13.3692 10.8671 13.421 10.819Z",
			fill: "#FBB040"
		}),
		s("path", {
			d: "M12.2954 8.28741C12.3237 8.25859 12.3566 8.23457 12.3896 8.21055C12.4226 8.18654 12.4603 8.16732 12.4979 8.15291C12.4979 8.15291 12.4979 8.15291 12.5027 8.15291C12.5403 8.1385 12.578 8.12409 12.6204 8.11928H12.6251C12.6675 8.10968 12.7099 8.10487 12.7523 8.10487C12.7947 8.10487 12.8371 8.10968 12.8795 8.11928C12.8795 8.11928 12.8795 8.11928 12.8842 8.11928C12.9266 8.12889 12.9643 8.1385 13.0019 8.15771C13.0773 8.19134 13.148 8.23457 13.2092 8.29702L12.7523 6.86554L12.2954 8.28741Z",
			fill: "#909393"
		}),
		s("path", {
			d: "M12.1353 9.03678C12.1212 8.99835 12.107 8.95512 12.0976 8.91189C12.0976 8.91189 12.0976 8.91188 12.0976 8.90708C12.0882 8.86385 12.0835 8.82062 12.0835 8.77738C12.0835 8.75337 12.0835 8.72935 12.0882 8.70533C12.0882 8.70053 12.0882 8.69572 12.0929 8.69092C12.0929 8.6717 12.0976 8.65729 12.1023 8.63808C12.1023 8.63328 12.107 8.62847 12.107 8.62367C12.1118 8.60445 12.1165 8.59004 12.1212 8.57083C12.1212 8.56602 12.1259 8.56602 12.1259 8.56122C12.1306 8.54201 12.14 8.52279 12.1447 8.50838C12.1447 8.50838 12.1447 8.50358 12.1494 8.50358C12.1589 8.48436 12.1683 8.46515 12.1777 8.44593C12.2107 8.38829 12.2531 8.33545 12.3002 8.28741L10.369 8.77258H10.3643L12.2766 9.24814C12.2154 9.1905 12.1683 9.11844 12.1353 9.03678Z",
			fill: "#676A6A"
		}),
		s("path", {
			d: "M16.4774 8.66697C16.4774 8.65736 16.4821 8.64776 16.4821 8.64295C16.4868 8.61413 16.4916 8.58531 16.501 8.56129C16.501 8.55649 16.501 8.55649 16.501 8.55169L16.7506 7.3748V6.70229C16.5434 6.52936 16.3267 6.43329 16.0959 6.43329C15.8039 6.43329 15.5354 6.59661 15.3328 6.79836C15.1115 7.01933 14.9419 7.29794 14.8006 7.57655C14.7959 7.59096 14.7864 7.60057 14.7817 7.61498C14.8241 7.65341 14.8665 7.69184 14.9089 7.73027C15.0031 7.81673 15.0973 7.908 15.1868 7.99927C15.2292 8.0425 15.2716 8.08573 15.314 8.12897C15.3564 8.177 15.4035 8.22024 15.4459 8.26827C15.5024 8.33072 15.5589 8.38836 15.6107 8.45081C15.6343 8.47483 15.6578 8.50365 15.6814 8.52767C15.7473 8.60453 15.8133 8.67658 15.8792 8.75344C15.8886 8.76304 15.8981 8.77265 15.9028 8.77746H16.4727C16.4727 8.77265 16.4727 8.76785 16.4727 8.76304C16.4727 8.73422 16.4727 8.7006 16.4774 8.66697Z",
			fill: "#E2DDDB"
		}),
		s("path", {
			d: "M7.92886 9.51719C7.92886 9.51239 7.93357 9.50758 7.93357 9.50278C7.97125 9.40671 8.00893 9.31064 8.05132 9.21456C8.06074 9.18574 8.07488 9.16172 8.08901 9.13771C8.12198 9.06085 8.15966 8.98879 8.19734 8.91674C8.21147 8.88792 8.2256 8.8591 8.24444 8.82547C8.25386 8.81106 8.26328 8.79184 8.2727 8.77743C8.3151 8.70538 8.35278 8.63333 8.39517 8.56127C8.40459 8.54686 8.41872 8.52765 8.42814 8.51323C8.47995 8.42677 8.53648 8.34511 8.59771 8.26345C8.60242 8.25864 8.60713 8.24904 8.61184 8.24423C8.67307 8.15777 8.73902 8.07611 8.80496 7.99925C8.81909 7.98003 8.83322 7.96562 8.84735 7.94641C8.9133 7.86955 8.98395 7.79269 9.0546 7.72064C9.06873 7.70623 9.08286 7.69182 9.09699 7.6774C9.17236 7.60055 9.24772 7.52849 9.33251 7.45644C9.64809 6.37082 10.6231 5.57822 11.7724 5.57822C12.234 5.57822 12.6956 5.71272 13.0913 5.96251C13.4963 6.2171 13.8261 6.58698 14.038 7.01451C14.038 7.01451 14.038 7.01931 14.0427 7.01931C14.0474 7.02892 14.0522 7.03852 14.0616 7.05293C14.2406 7.16342 14.4101 7.29312 14.575 7.43242C14.6315 7.48046 14.6833 7.52849 14.7351 7.57653C14.754 7.59094 14.7681 7.61015 14.787 7.62456C14.7917 7.61015 14.7964 7.60055 14.8058 7.58614C14.9659 6.54375 15.4181 5.78958 15.9504 5.78958C16.3507 5.78958 16.7087 6.2171 16.9254 6.8752V6.88C16.9866 6.94725 17.0479 7.02411 17.1091 7.10577C17.1091 7.10577 17.1091 7.11058 17.1138 7.11058C17.1185 7.12018 17.1185 7.12979 17.1232 7.1394L17.1138 7.10577C16.4497 5.10747 14.5985 3.66638 12.413 3.66638C9.67164 3.66638 7.45312 5.92889 7.45312 8.72459C7.45312 9.27701 7.53791 9.80541 7.69806 10.3002C7.69806 10.3002 7.69806 10.3002 7.69806 10.2954C7.73103 10.1465 7.76871 9.99755 7.8111 9.85345C7.84878 9.73816 7.88647 9.62768 7.92886 9.51719Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M17.1889 8.78217L17.0146 8.97912C17.0099 9.00314 17.0005 9.02716 16.991 9.05117C16.991 9.05598 16.9863 9.06078 16.9816 9.07039C16.9769 9.0848 16.9675 9.10401 16.9581 9.11843C16.9534 9.12803 16.9486 9.13284 16.9439 9.14244C16.9345 9.15205 16.9298 9.16646 16.9204 9.17607C16.911 9.19048 16.8968 9.20489 16.8827 9.2145C16.878 9.2193 16.8733 9.22411 16.8686 9.22891C16.8592 9.23852 16.8497 9.24332 16.8403 9.24812C16.8356 9.24812 16.8309 9.25293 16.8262 9.25293C16.8026 9.26734 16.7744 9.27214 16.7461 9.27214C16.5907 9.27214 16.4635 9.05118 16.4635 8.77257H15.8936C16.0019 8.89746 16.1055 9.02235 16.2044 9.15205L16.2091 9.15685C16.3081 9.28175 16.407 9.40664 16.5059 9.53154C16.5106 9.53634 16.5153 9.54595 16.52 9.55075C16.6142 9.67084 16.7037 9.79093 16.7932 9.91102C16.8026 9.92063 16.812 9.93504 16.8215 9.94465C16.9157 10.0743 17.0099 10.204 17.1041 10.3289C17.1041 10.3289 17.1041 10.3289 17.1041 10.3337C17.2689 9.83897 17.3584 9.31537 17.3631 8.76776L17.1889 8.78217Z",
			fill: "white"
		}),
		s("path", {
			d: "M11.659 6.44288C11.6732 6.44288 11.6826 6.44288 11.6967 6.43808C11.7862 6.43327 11.8757 6.42847 11.9652 6.42847C12.2337 6.42847 12.4974 6.45729 12.7518 6.51013C12.7518 6.51013 12.7518 6.51013 12.7518 6.51493C12.7518 6.51493 12.7518 6.51974 12.7518 6.52454C12.7518 6.52935 12.7518 6.53415 12.7518 6.54376C12.7518 6.54856 12.7518 6.55336 12.7518 6.56297C12.7518 6.57258 12.7518 6.58219 12.7518 6.59179C12.7518 6.5966 12.7518 6.6062 12.7518 6.61101C12.7518 6.62061 12.7518 6.63022 12.7518 6.63983V6.51013C12.9308 6.55336 13.2511 6.64463 13.4913 6.74551C13.5902 6.78874 13.6891 6.83678 13.7833 6.88481C13.7881 6.88481 13.7975 6.88962 13.8069 6.89922C13.8069 6.89922 13.8116 6.89922 13.8116 6.90403C13.821 6.90883 13.8304 6.91364 13.8399 6.92324C13.854 6.93285 13.8681 6.93765 13.8823 6.94726H13.887C13.9482 6.98089 14.0141 7.02412 14.0424 7.03853C14.0471 7.03853 14.0471 7.04333 14.0471 7.04333L14.0518 7.04814C14.0471 7.03853 14.0424 7.02892 14.033 7.01451C14.033 7.01451 14.033 7.00971 14.0283 7.00971C13.8163 6.57738 13.4819 6.2075 13.0815 5.95771C12.6859 5.71273 12.2243 5.57343 11.7627 5.57343C10.6134 5.57343 9.63834 6.36602 9.32275 7.45164C9.62421 7.18744 9.95863 6.96648 10.3166 6.80315C10.7452 6.6014 11.2021 6.48131 11.659 6.44288Z",
			fill: "black"
		}),
		s("path", {
			d: "M15.3381 6.80316C15.5406 6.60141 15.8091 6.43808 16.1011 6.43808C16.332 6.43808 16.5533 6.53415 16.7559 6.70709C16.7747 6.7215 16.7936 6.74071 16.8124 6.75512C16.8218 6.76473 16.8359 6.77434 16.8454 6.78394C16.8736 6.81276 16.9019 6.84159 16.9301 6.87521V6.87041C16.7088 6.21231 16.3555 5.78479 15.9551 5.78479C15.4229 5.78479 14.9707 6.53416 14.8105 7.58134C14.9424 7.30273 15.1167 7.02412 15.3381 6.80316Z",
			fill: "black"
		}),
		s("path", {
			d: "M10.6371 13.4466C10.6842 13.4658 10.7266 13.4802 10.7737 13.4946C11.2871 13.6772 11.8382 13.778 12.4129 13.778C13.0676 13.778 13.694 13.6483 14.264 13.413C14.2922 13.3986 14.3252 13.3889 14.3535 13.3745C14.4006 13.3553 14.4524 13.3313 14.4995 13.3073C14.5419 13.2881 14.5843 13.2689 14.6267 13.2448C14.6173 13.2448 14.6078 13.2496 14.5984 13.2496C14.4194 13.2689 14.2451 13.2737 14.0709 13.2448C13.0487 13.0959 12.8227 12.5915 12.8556 12.0728C12.7803 12.0295 12.7096 11.9815 12.6295 11.9238C11.8429 11.3426 11.3766 10.7229 11.3766 10.7229C11.3766 10.7229 11.9842 11.1985 12.8886 11.5588C12.9074 11.5684 12.9263 11.5732 12.9451 11.5828C12.9875 11.4339 13.0393 11.2898 13.0817 11.1649C13.0864 11.1505 13.0911 11.1361 13.0958 11.1216C13.1477 10.9775 13.2042 10.8334 13.2654 10.6941C13.4915 10.1657 13.7694 9.65173 13.906 9.08971L13.972 8.77267H13.4161V8.77747C13.4161 8.87354 13.3973 8.96001 13.3643 9.04167C13.3455 9.0801 13.3266 9.12333 13.3031 9.15696C13.256 9.22901 13.1948 9.29146 13.1241 9.3395C13.0864 9.36351 13.0487 9.38273 13.0111 9.40194C12.931 9.43557 12.8415 9.45478 12.752 9.45478C12.7284 9.45478 12.7049 9.45478 12.6813 9.44998C12.6766 9.44998 12.6719 9.44998 12.6672 9.44518C12.6484 9.44518 12.6342 9.44037 12.6154 9.43557C12.6107 9.43557 12.606 9.43077 12.6013 9.43077C12.5824 9.42596 12.5683 9.42116 12.5495 9.41635C12.5448 9.41635 12.5448 9.41635 12.54 9.41155C12.5212 9.40675 12.5024 9.39714 12.4882 9.39234H12.4835C12.4647 9.38273 12.4458 9.37312 12.427 9.36351C12.3705 9.32989 12.3187 9.29146 12.2716 9.23862L10.3592 8.76306H8.27257C8.26315 8.77747 8.25373 8.79669 8.24431 8.8111C8.23018 8.83992 8.21134 8.86874 8.19721 8.90237C8.15953 8.97442 8.12185 9.05128 8.08888 9.12333C8.07474 9.14735 8.06532 9.17617 8.05119 9.20019C8.0088 9.29626 7.97112 9.39234 7.93344 9.48841C7.93344 9.49321 7.92873 9.49802 7.92873 9.50282C7.88634 9.6133 7.84865 9.72859 7.81568 9.84388C7.77329 9.98798 7.73561 10.1369 7.70264 10.2858C8.03235 11.309 8.66823 12.188 9.50665 12.8029C9.5302 12.8221 9.55847 12.8365 9.58202 12.8557C9.72332 12.9566 9.86934 13.0527 10.0201 13.1344C10.2179 13.2593 10.4251 13.3601 10.6371 13.4466Z",
			fill: "white"
		}),
		s("path", {
			d: "M14.0613 11.871C14.0518 11.9238 14.0471 11.9766 14.0471 12.0295C14.0424 12.1208 14.0518 12.212 14.066 12.2937C14.0754 12.3513 14.0848 12.4042 14.0989 12.457C14.1225 12.5339 14.146 12.6059 14.179 12.6732C14.212 12.7404 14.245 12.8029 14.2779 12.8557C14.2873 12.8749 14.3015 12.8941 14.3109 12.9086C14.3297 12.9326 14.3439 12.9566 14.3627 12.9806C14.3863 13.0094 14.4098 13.0382 14.4287 13.0623C14.5181 13.1679 14.5935 13.2256 14.5935 13.2256C14.5935 13.2256 14.5935 13.2256 14.5935 13.2304C14.5935 13.2352 14.5935 13.24 14.5982 13.2448C14.6076 13.2448 14.6171 13.24 14.6265 13.24C14.8479 13.2112 15.0692 13.1487 15.2906 13.0719C15.4037 13.0286 15.5167 12.9854 15.6251 12.9374C15.658 12.923 15.691 12.9037 15.724 12.8893C16.8591 12.3273 17.8106 11.3378 17.8106 11.3378C16.3881 12.0535 14.9892 12.0247 14.0613 11.871Z",
			fill: "#9F2255"
		}),
		s("path", {
			d: "M16.803 9.92069C16.7136 9.80059 16.6193 9.6805 16.5299 9.56041C16.5251 9.55561 16.5204 9.546 16.5157 9.5412C16.4168 9.41631 16.3179 9.29141 16.219 9.16652L16.2143 9.16171C16.1106 9.03202 16.007 8.90712 15.9034 8.78223C15.8987 8.77262 15.8893 8.76782 15.8846 8.75821C15.8186 8.68135 15.7527 8.6093 15.6867 8.53244C15.6632 8.50842 15.6396 8.4796 15.6161 8.45558C15.5595 8.39313 15.5077 8.33549 15.4512 8.27304C15.4088 8.22501 15.3617 8.18177 15.3193 8.13374C15.2769 8.09051 15.2345 8.04727 15.1922 8.00404C15.1027 7.91277 15.0085 7.8215 14.9142 7.73504C14.8719 7.69661 14.8295 7.65818 14.7871 7.61975C14.8766 7.88395 14.9802 8.14815 15.032 8.42196C15.0461 8.49401 15.0556 8.56126 15.065 8.62851C15.1921 9.57482 14.8907 10.1945 14.4197 11.0111C14.3867 11.0688 14.349 11.1312 14.316 11.1888C14.2077 11.3714 14.1371 11.5491 14.0994 11.7124C14.0852 11.7653 14.0758 11.8181 14.0664 11.871C14.9943 12.0247 16.3885 12.0535 17.8157 11.3378C17.8157 11.3378 17.5378 10.9198 17.1139 10.3434C17.0197 10.2137 16.9255 10.084 16.8313 9.95911C16.8219 9.9447 16.8125 9.93029 16.803 9.92069Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M14.5936 13.2351C14.5936 13.2351 14.5229 13.1775 14.4287 13.0718C14.4051 13.0478 14.3863 13.019 14.3627 12.9902C14.3439 12.9661 14.3298 12.9421 14.3109 12.9181C14.3015 12.8989 14.2874 12.8845 14.278 12.8653C14.245 12.8076 14.212 12.75 14.1791 12.6827C14.1508 12.6155 14.1225 12.5434 14.099 12.4666C14.0848 12.4137 14.0707 12.3609 14.066 12.3032C14.0519 12.2216 14.0472 12.1303 14.0472 12.039C14.0472 11.9862 14.0519 11.9334 14.0613 11.8805C14.0707 11.8277 14.0801 11.7748 14.0943 11.722C14.1367 11.5587 14.2026 11.3857 14.3109 11.1984C14.3439 11.136 14.3816 11.0783 14.4146 11.0207C14.8856 10.2041 15.187 9.58919 15.0599 8.63807C15.0504 8.57082 15.041 8.49877 15.0269 8.43152C15.0222 8.47955 15.0128 8.52279 15.0033 8.55641C15.0033 8.56122 15.0033 8.56122 15.0033 8.56602C14.9986 8.59004 14.9939 8.60925 14.9892 8.62366C14.782 9.24333 14.4428 9.7285 13.9765 10.2425C13.9153 10.3145 13.8493 10.3818 13.7787 10.4538C13.6656 10.5739 13.5432 10.6988 13.4207 10.8237C13.3689 10.8766 13.3171 10.9246 13.2653 10.9774C13.2182 11.0255 13.1522 11.0927 13.0816 11.1696C13.0392 11.2945 12.9874 11.4386 12.945 11.5875C12.9261 11.5779 12.9073 11.5731 12.8884 11.5635C11.9841 11.208 11.3765 10.7276 11.3765 10.7276C11.3765 10.7276 11.8428 11.3473 12.6294 11.9286C12.7047 11.9862 12.7801 12.0342 12.8555 12.0775C12.8225 12.6011 13.0486 13.1006 14.0707 13.2496C14.245 13.2736 14.4193 13.2736 14.5983 13.2544C14.5983 13.2447 14.5936 13.2399 14.5936 13.2351Z",
			fill: "black"
		})
	], -1), n[1] ||= s("defs", null, [s("clipPath", { id: "clip0_presta_24" }, [s("rect", {
		width: "24",
		height: "24",
		fill: "white"
	})])], -1)], 64);
}
var Hc = /*#__PURE__*/ W(Bc, [["render", Vc]]), Uc = {};
function Wc(t, n) {
	return A(), o(e, null, [n[0] ||= s("path", {
		"clip-rule": "evenodd",
		d: "M19.6634 4.51915C19.7503 4.52646 19.8554 4.59288 19.8719 4.71287C19.8882 4.83287 22.4784 22.3444 22.4784 22.3444L15.1 23.9406L1.48267 21.3892C1.48267 21.3892 3.23023 7.87446 3.29623 7.398C3.38393 6.76866 3.40505 6.74761 4.07294 6.53811C4.18152 6.504 5.03154 6.24041 6.22809 5.86964C6.68935 3.91348 8.1605 0.0640259 11.2398 0.0640259C11.6421 0.0640259 12.1078 0.280026 12.4837 0.777204C12.5213 0.775067 12.5588 0.773587 12.5953 0.773587C13.9172 0.773587 14.6686 1.89945 15.0944 3.1246C15.5292 2.99005 15.792 2.90893 15.8076 2.90433C15.9137 2.87309 16.1871 2.83052 16.3271 2.97049C16.467 3.11055 17.7415 4.37589 17.7415 4.37589C17.7415 4.37589 19.5767 4.51192 19.6634 4.51915ZM13.1895 3.714L14.3417 3.35737C14.0498 2.46551 13.5962 1.69052 12.9151 1.60504C13.0846 2.09104 13.1903 2.70411 13.1903 3.46553C13.1903 3.55127 13.1899 3.62981 13.1895 3.70945L13.1895 3.714ZM12.3826 3.83038C12.3826 2.91148 12.2595 2.23052 12.0701 1.75603C11.3192 2.07822 10.4603 2.93235 10.0021 4.70079L12.3818 3.96386L12.3818 3.96225C12.3822 3.91932 12.3826 3.87682 12.3826 3.83038ZM11.5502 1.02329C11.422 0.935094 11.2881 0.889971 11.1552 0.889971C8.94346 0.889971 7.70097 3.79397 7.17774 5.57548L9.05878 4.9929C9.50549 2.65726 10.5633 1.48767 11.5502 1.02329ZM11.6855 11.3023L12.5953 8.59602C12.5953 8.59602 11.9803 8.23947 10.7355 8.23947C7.50488 8.23947 5.90444 10.3973 5.90444 12.627C5.90444 14.1153 6.73861 14.7902 7.46973 15.3818C8.04008 15.8432 8.54773 16.254 8.54773 16.9605C8.54773 17.3503 8.27214 17.8837 7.59463 17.8837C6.55778 17.8837 5.32902 16.8288 5.32902 16.8288L4.70312 18.8967C4.70312 18.8967 5.89852 20.3515 8.23606 20.3515C10.184 20.3515 11.6287 18.8848 11.6287 16.607C11.6287 14.856 10.4501 13.9908 9.51859 13.3069C8.90994 12.8601 8.40677 12.4907 8.40677 12.0023C8.40677 11.7758 8.47885 10.8768 9.91129 10.8768C10.8884 10.8768 11.6855 11.3023 11.6855 11.3023Z",
		fill: "#95BF46",
		"fill-rule": "evenodd"
	}, null, -1), n[1] ||= s("path", {
		d: "M19.6633 4.51914C19.5766 4.51191 17.7414 4.37588 17.7414 4.37588C17.7414 4.37588 16.4669 3.11054 16.327 2.97049C16.2746 2.91838 16.204 2.89166 16.1302 2.88016L15.1006 23.9404L22.4783 22.3444C22.4783 22.3444 19.8881 4.83287 19.8718 4.71287C19.8553 4.59287 19.7502 4.52646 19.6633 4.51914Z",
		fill: "#5E8E3E"
	}, null, -1)], 64);
}
var Gc = /*#__PURE__*/ W(Uc, [["render", Wc]]), Kc = {};
function qc(t, n) {
	return A(), o(e, null, [n[0] ||= s("g", { "clip-path": "url(#clip0_cscart_24)" }, [s("path", {
		d: "M23.76 8.46467V20.8727C23.76 22.3624 22.5531 23.5692 21.0634 23.5692H8.65536C7.16567 23.5692 5.9588 22.3624 5.9588 20.8727V8.46467C5.9588 6.97493 7.16567 5.76806 8.65536 5.76806H21.0634C22.5531 5.76806 23.76 6.97493 23.76 8.46467ZM3.42509 0.537781C1.93537 0.537781 0.728516 1.74464 0.728516 3.23435C0.728516 4.72406 1.93537 5.93093 3.42509 5.93093C4.9148 5.93093 6.12165 4.72406 6.12165 3.23435C6.12165 1.74464 4.9148 0.537781 3.42509 0.537781Z",
		fill: "url(#paint0_linear_cscart_24)"
	})], -1), n[1] ||= s("defs", null, [s("linearGradient", {
		id: "paint0_linear_cscart_24",
		x1: "4.13388",
		y1: "20.1645",
		x2: "20.3555",
		y2: "3.94282",
		gradientUnits: "userSpaceOnUse"
	}, [s("stop", { "stop-color": "#7381FD" }), s("stop", {
		offset: "1",
		"stop-color": "#76C7FF"
	})]), s("clipPath", { id: "clip0_cscart_24" }, [s("rect", {
		width: "24",
		height: "24",
		fill: "white"
	})])], -1)], 64);
}
var Jc = /*#__PURE__*/ W(Kc, [["render", qc]]), Yc = {}, Xc = {
	d: "M12 1.5L12.9622 3.18387C13.1546 3.53226 13.1546 3.95806 12.9622 4.30645L7.22749 14.3129L9.94089 19.0355C10.3643 19.771 11.1533 20.2355 12 20.2355C12.8467 20.2355 13.6357 19.771 14.0591 19.0355L16.7725 14.3129L16.0605 13.0355L12.9814 18.3968C12.789 18.7452 12.4041 18.9581 12.0192 18.9581C11.6151 18.9581 11.2495 18.7452 11.057 18.3968L8.69003 14.3129L14.0206 5.02258L14.9828 6.70645C15.1753 7.05484 15.1753 7.48064 14.9828 7.82903L11.2687 14.3129L12 15.5903L16.0412 8.54516L18.6969 13.171C19.101 13.8871 19.101 14.7581 18.6969 15.4742L16.0027 20.1774C15.5986 20.8935 14.3093 22.5 12 22.5C9.69072 22.5 8.42062 20.8935 7.99725 20.1774L5.30309 15.4742C4.89897 14.7581 4.89897 13.8871 5.30309 13.171L12 1.5Z",
	fill: "#ED5153"
};
function Zc(e, t) {
	return A(), o("path", Xc);
}
var Qc = /*#__PURE__*/ W(Yc, [["render", Zc]]), $c = {};
function el(t, n) {
	return A(), o(e, null, [n[0] ||= s("rect", {
		fill: "#00149D",
		height: "48",
		rx: "8",
		width: "48"
	}, null, -1), n[1] ||= s("path", {
		d: "M4 16h4.607v3.867a7.752 7.752 0 0 1 2.812-.51c3.618 0 6.241 2.686 6.241 6.368 0 2.779-1.877 6.067-6.151 6.067H4V16Zm4.607 11.736c.575.104 1.158.158 1.742.162 1.651 0 2.737-.903 2.737-2.316 0-1.388-1.063-2.338-2.602-2.338a6.121 6.121 0 0 0-1.877.278v4.214Zm16.797-8.382c5.088 0 7.033 3.358 7.033 6.322 0 3.241-2.24 6.32-6.99 6.32-5.088 0-7.079-3.334-7.079-6.32.005-3.15 2.108-6.322 7.039-6.322h-.003Zm0 8.683c1.438 0 2.428-.973 2.428-2.361 0-1.389-.987-2.363-2.425-2.363-1.439 0-2.428.973-2.428 2.363 0 1.39.99 2.361 2.428 2.361h-.003ZM33.373 16h4.6v15.789h-4.6V16ZM44 29.151C44 30.726 42.797 32 41.283 32s-2.74-1.274-2.74-2.849a2.826 2.826 0 0 1 .79-1.99 2.75 2.75 0 0 1 1.95-.834C42.797 26.323 44 27.573 44 29.148v.003Z",
		fill: "#fff"
	}, null, -1)], 64);
}
var tl = /*#__PURE__*/ W($c, [["render", el]]), nl = {};
function rl(t, n) {
	return A(), o(e, null, [n[0] ||= s("path", {
		"clip-rule": "evenodd",
		d: "M39.3266 9.0383C39.5003 9.05293 39.7106 9.18575 39.7436 9.42575C39.7762 9.66575 44.9565 44.6888 44.9565 44.6888L30.1998 47.8811L2.96509 42.7784C2.96509 42.7784 6.46021 15.7489 6.59221 14.796C6.76761 13.5373 6.80986 13.4952 8.14564 13.0762C8.36279 13.008 10.0628 12.4808 12.4559 11.7393C13.3785 7.82696 16.3208 0.128052 22.4794 0.128052C23.2839 0.128052 24.2153 0.560052 24.9672 1.55441C25.0423 1.55013 25.1174 1.54717 25.1904 1.54717C27.8342 1.54717 29.337 3.7989 30.1885 6.2492C31.0581 5.98011 31.5838 5.81786 31.615 5.80865C31.8272 5.74619 32.374 5.66104 32.6539 5.94098C32.9337 6.22109 35.4828 8.75178 35.4828 8.75178C35.4828 8.75178 39.1531 9.02383 39.3266 9.0383ZM26.3787 7.428L28.6832 6.71474C28.0993 4.93101 27.1921 3.38104 25.8299 3.21008C26.169 4.18208 26.3804 5.40822 26.3804 6.93107C26.3804 7.1029 26.3796 7.26026 26.3788 7.41989L26.3787 7.428ZM24.765 7.66076C24.765 5.82296 24.5187 4.46104 24.14 3.51205C22.6382 4.15644 20.9204 5.86471 20.0039 9.40159C20.903 9.12305 21.801 8.84502 22.6768 8.57385C23.3909 8.35276 24.0902 8.13623 24.7633 7.92772L24.7634 7.92451C24.7642 7.83864 24.765 7.75363 24.765 7.66076ZM23.1001 2.04657C22.8438 1.87019 22.576 1.77994 22.3102 1.77994C17.8867 1.77994 15.4017 7.58794 14.3552 11.151L18.1173 9.98581C19.0107 5.31452 21.1264 2.97534 23.1001 2.04657ZM23.371 22.6045L25.1905 17.192C25.1905 17.192 23.9606 16.4789 21.471 16.4789C15.0098 16.4789 11.8089 20.7945 11.8089 25.2541C11.8089 28.2306 13.4772 29.5804 14.9395 30.7635C16.0802 31.6865 17.0955 32.5079 17.0955 33.921C17.0955 34.7005 16.5443 35.7674 15.1893 35.7674C13.1156 35.7674 10.658 33.6575 10.658 33.6575L9.40625 37.7934C9.40625 37.7934 11.797 40.703 16.4721 40.703C20.368 40.703 23.2574 37.7696 23.2574 33.214C23.2574 29.712 20.9002 27.9816 19.0372 26.6139C17.8199 25.7202 16.8135 24.9815 16.8135 24.0046C16.8135 23.5515 16.9577 21.7537 19.8226 21.7537C21.7768 21.7537 23.371 22.6045 23.371 22.6045Z",
		fill: "#95BF46",
		"fill-rule": "evenodd"
	}, null, -1), n[1] ||= s("path", {
		d: "M39.3266 9.03829C39.1532 9.02382 35.4828 8.75177 35.4828 8.75177C35.4828 8.75177 32.9337 6.22108 32.6539 5.94097C32.5492 5.83675 32.408 5.78333 32.2604 5.76031L30.2012 47.8808L44.9566 44.6888C44.9566 44.6888 39.7762 9.66574 39.7436 9.42574C39.7106 9.18574 39.5004 9.05292 39.3266 9.03829Z",
		fill: "#5E8E3E"
	}, null, -1)], 64);
}
var il = /*#__PURE__*/ W(nl, [["render", rl]]), al = {};
function ol(t, n) {
	return A(), o(e, null, [n[0] ||= s("rect", {
		fill: "#00149D",
		height: "24",
		width: "24"
	}, null, -1), n[1] ||= s("path", {
		d: "M2 8H4.30357V9.9333C4.75282 9.76191 5.22928 9.67554 5.70928 9.6785C7.51854 9.6785 8.83012 11.0216 8.83012 12.8624C8.83012 14.2518 7.89167 15.896 5.75437 15.896H2V8ZM4.30357 13.8679C4.59105 13.9199 4.88237 13.9471 5.17439 13.949C6.00011 13.949 6.54289 13.4977 6.54289 12.791C6.54289 12.0968 6.01139 11.6221 5.24202 11.6221C4.92403 11.6193 4.60751 11.6661 4.30357 11.7609V13.8679ZM12.7017 9.67678C15.246 9.67678 16.2182 11.3559 16.2182 12.8378C16.2182 14.4586 15.0989 15.9983 12.7237 15.9983C10.1795 15.9983 9.18408 14.3312 9.18408 12.8378C9.18634 11.2627 10.2381 9.67678 12.7034 9.67678H12.7017ZM12.7017 14.0187C13.4209 14.0187 13.9158 13.532 13.9158 12.8378C13.9158 12.1437 13.4226 11.6564 12.7034 11.6564C11.9842 11.6564 11.4893 12.1431 11.4893 12.8378C11.4893 13.5325 11.9842 14.0187 12.7034 14.0187H12.7017ZM16.6872 8H18.9874V15.8943H16.6872V8ZM22 14.5757C22 15.363 21.3986 16 20.6416 16C19.8847 16 19.2714 15.363 19.2714 14.5757C19.2693 14.3916 19.3031 14.2089 19.3709 14.0381C19.4387 13.8673 19.5392 13.7118 19.6665 13.5805C19.7939 13.4493 19.9456 13.3448 20.113 13.2732C20.2803 13.2017 20.46 13.1644 20.6416 13.1635C21.3986 13.1618 22 13.7868 22 14.574V14.5757Z",
		fill: "white"
	}, null, -1)], 64);
}
var sl = /*#__PURE__*/ W(al, [["render", ol]]), cl = {};
function ll(t, n) {
	return A(), o(e, null, [n[0] ||= s("g", { "clip-path": "url(#clip0_presta_48)" }, [
		s("path", {
			d: "M10.8094 38.7581C10.8 38.7197 10.8 38.6621 10.8 38.5852C10.8 38.0952 10.9601 37.711 11.2804 37.442C11.6007 37.1633 11.9493 37.0288 12.3355 37.0288C12.8442 37.0288 13.2022 37.221 13.4 37.6149L10.8094 38.7581ZM14.521 38.0664C14.5116 37.49 14.3044 37.0192 13.8804 36.6542C13.4565 36.2891 12.929 36.1161 12.2884 36.1161C11.8833 36.1161 11.4971 36.2026 11.1391 36.3852C10.7717 36.5677 10.4702 36.8463 10.2253 37.2402C9.98038 37.6245 9.85791 38.0664 9.85791 38.5756C9.85791 39.3058 10.0934 39.9014 10.5644 40.3433C11.0355 40.7949 11.6101 41.0158 12.2695 41.0158C13.0232 41.0158 13.6826 40.7276 14.2384 40.1416L13.6638 39.4883C13.3246 39.9014 12.8913 40.1128 12.3732 40.1128C11.8456 40.1128 11.4311 39.9206 11.1297 39.5363L14.5305 38.076L14.521 38.0664Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M8.72691 36.4044C8.45371 36.5965 8.23704 36.8367 8.08632 37.1345V36.1738H7.09717V40.939H8.0769V38.9022C8.0769 38.3642 8.19936 37.9223 8.44429 37.6053C8.68922 37.2786 9.05662 37.1249 9.53707 37.1249H9.59359L9.58417 36.1161C9.29213 36.1161 9.0001 36.2122 8.72691 36.4044Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M18.0345 38.5179C17.8744 38.4122 17.7331 38.3258 17.5918 38.2681C17.4505 38.2105 17.3091 38.1529 17.1678 38.1048C17.0171 38.0568 16.857 38.0087 16.6591 37.9607C16.4707 37.9127 16.32 37.8646 16.2164 37.807C16.0656 37.7397 15.9903 37.6245 15.9903 37.4707C15.9903 37.2978 16.0656 37.1633 16.207 37.0768C16.3577 36.9904 16.5461 36.9423 16.7816 36.9423C17.2244 36.9423 17.6389 37.0672 18.0157 37.3266L18.3831 36.5869C17.9026 36.2602 17.3939 36.1065 16.857 36.1065C16.32 36.1065 15.8772 36.241 15.5475 36.5004C15.2084 36.7694 15.0388 37.1153 15.0388 37.5572C15.0388 38.1817 15.5287 38.6332 16.499 38.9022C16.5178 38.9118 16.5555 38.9214 16.6026 38.9406C17.2244 39.1328 17.5352 39.3441 17.5352 39.5843C17.5352 39.7477 17.4693 39.8822 17.3468 39.9782C17.2149 40.0839 17.0454 40.1319 16.8193 40.1319C16.3106 40.1319 15.783 39.9206 15.2366 39.5075L14.7656 40.2857C15.0482 40.5162 15.3685 40.6892 15.7359 40.8141C16.1033 40.9389 16.4519 41.0062 16.791 41.0062C17.2903 41.0062 17.7048 40.8717 18.0251 40.6027C18.3454 40.3337 18.5055 39.9686 18.5055 39.5171C18.515 39.0655 18.3548 38.7389 18.0345 38.5179Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M5.03423 37.8166C4.82698 38.0376 4.43132 38.1528 3.86609 38.1528H2.66027V35.6454H3.71536C4.28059 35.6454 4.68567 35.7318 4.94944 35.9144C5.21322 36.0969 5.3451 36.3947 5.3451 36.827C5.3451 37.269 5.24148 37.5956 5.03423 37.8166ZM5.76902 35.2322C5.3451 34.8672 4.66683 34.6846 3.73421 34.6846H1.62402V40.9389H2.66027V39.104H3.75305C4.65741 39.104 5.32626 38.931 5.7596 38.5756C6.19295 38.2201 6.40962 37.6725 6.40962 36.9135C6.40962 36.1641 6.19295 35.5973 5.76902 35.2322Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M20.8131 40.1512C20.6059 40.1512 20.4363 40.0839 20.3233 39.9494C20.2102 39.8149 20.1443 39.6324 20.1443 39.4114V36.9904H21.3689V36.1834H20.1443V34.6846H19.1646V39.373C19.1646 39.8725 19.3153 40.276 19.6073 40.5643C19.8993 40.8621 20.2573 41.0062 20.6812 41.0062C21.0957 41.0062 21.482 40.8525 21.8305 40.5354L21.4255 39.8245C21.2276 40.0455 21.0204 40.1512 20.8131 40.1512Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M25.3077 39.6997C25.0345 39.9879 24.7142 40.132 24.3279 40.132C23.9417 40.132 23.6026 39.9879 23.32 39.6997C23.0373 39.4114 22.8866 39.0464 22.8866 38.5852C22.8866 38.1241 23.0279 37.7494 23.3105 37.442C23.5931 37.1345 23.9229 36.9808 24.3185 36.9808C24.7142 36.9808 25.0439 37.1345 25.3077 37.442C25.5809 37.7494 25.7127 38.1241 25.7127 38.5756C25.7127 39.0368 25.5809 39.4114 25.3077 39.6997ZM25.6939 37.0096C25.2982 36.414 24.7895 36.1161 24.1772 36.1161C23.5649 36.1161 23.0279 36.3371 22.5757 36.779C22.1236 37.221 21.8975 37.807 21.8975 38.5468C21.8975 39.2865 22.1141 39.8822 22.5569 40.3337C22.9997 40.7853 23.5084 41.0158 24.1018 41.0158C24.3939 41.0158 24.6859 40.939 24.978 40.7949C25.27 40.6508 25.5055 40.4394 25.6939 40.1608V40.939H26.6736V36.1738H25.6939V37.0096Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M41.2463 39.69C40.9636 39.9783 40.6151 40.1224 40.1912 40.1224C39.7672 40.1224 39.4093 39.9783 39.1361 39.69C38.8535 39.4018 38.7216 39.0271 38.7216 38.566C38.7216 38.1048 38.8629 37.7302 39.1361 37.442C39.4093 37.1537 39.7672 37.0096 40.1912 37.0096C40.6151 37.0096 40.9731 37.1537 41.2463 37.442C41.5194 37.7302 41.6608 38.1048 41.6608 38.566C41.6608 39.0271 41.5289 39.4018 41.2463 39.69ZM40.1912 36.1161C39.4846 36.1161 38.9006 36.3563 38.439 36.8271C37.9679 37.2978 37.7324 37.8839 37.7324 38.566C37.7324 39.2481 37.9679 39.8342 38.439 40.3049C38.91 40.7757 39.494 41.0158 40.1912 41.0158C40.8883 41.0158 41.4818 40.7757 41.9434 40.3049C42.4144 39.8342 42.6499 39.2481 42.6499 38.566C42.6499 37.8839 42.4144 37.2978 41.9434 36.8271C41.4723 36.3467 40.8883 36.1161 40.1912 36.1161Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M46.5885 39.69C46.3059 39.9783 45.9668 40.1224 45.5806 40.1224C45.1943 40.1224 44.8646 39.9783 44.6008 39.69C44.3276 39.4018 44.1958 39.0271 44.1958 38.5756C44.1958 38.1241 44.3276 37.7494 44.6008 37.442C44.874 37.1441 45.2037 36.9904 45.59 36.9904C45.9856 36.9904 46.3154 37.1441 46.598 37.442C46.8806 37.7398 47.0219 38.1241 47.0219 38.5756C47.0125 39.0368 46.8712 39.4018 46.5885 39.69ZM47.3328 36.779C46.89 36.3371 46.353 36.1161 45.7313 36.1161C45.1095 36.1161 44.6008 36.414 44.2146 37.0192V36.1834H43.2349V42.6779H44.2146V40.2281C44.6856 40.7564 45.2132 41.0158 45.7972 41.0158C46.3813 41.0158 46.8994 40.7853 47.3422 40.3241C47.7849 39.863 48.0016 39.2673 48.0016 38.5372C48.0016 37.807 47.7755 37.2114 47.3328 36.779Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M35.4438 36.1161C35.1141 36.1161 34.8126 36.2025 34.53 36.3659C34.2474 36.5292 34.0307 36.7598 33.8894 37.0576V34.3195H32.9097V40.9485H33.8894V38.3738C33.8894 37.9318 34.0119 37.5956 34.2662 37.365C34.5206 37.1344 34.8126 37.0192 35.1517 37.0192C35.8677 37.0192 36.2257 37.4611 36.2257 38.3353V40.9485H37.2054V38.0279C37.2054 37.4034 37.0452 36.9327 36.7155 36.606C36.3952 36.2794 35.9713 36.1161 35.4438 36.1161Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M31.732 37.9415C31.4117 37.6629 30.9406 37.4419 30.3095 37.2882C29.6783 37.1345 29.2732 36.9904 29.0754 36.8559C28.887 36.7214 28.7834 36.5292 28.7834 36.2698C28.7834 36.02 28.8776 35.8279 29.0754 35.703C29.2638 35.5781 29.5182 35.5109 29.8196 35.5109C30.1211 35.5109 30.4225 35.5685 30.7334 35.6742C31.0443 35.7799 31.2892 35.9144 31.4682 36.0873L32.024 35.2899C31.7414 35.0497 31.4117 34.8672 31.0254 34.7327C30.6392 34.5982 30.253 34.5405 29.8573 34.5405C29.245 34.5405 28.7363 34.6942 28.3218 35.0113C27.9073 35.3283 27.7 35.7703 27.7 36.3467C27.7 36.9231 27.879 37.3555 28.2464 37.6341C28.4254 37.7878 28.6326 37.9031 28.8681 37.9991C29.1037 38.0952 29.4428 38.1913 29.895 38.3066C30.3472 38.4122 30.658 38.5371 30.8464 38.6716C31.0349 38.8061 31.1196 38.9983 31.1196 39.2385C31.1196 39.4786 31.0254 39.6708 30.8276 39.8245C30.6298 39.9686 30.366 40.0455 30.0363 40.0455C29.3674 40.0455 28.7268 39.7669 28.1051 39.2193L27.4551 40.0167C28.1993 40.6892 29.0471 41.0254 30.008 41.0254C30.6675 41.0254 31.195 40.8525 31.6001 40.5162C32.0052 40.18 32.203 39.738 32.203 39.1904C32.203 38.6428 32.0523 38.2201 31.732 37.9415Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M19.8326 25.1447C20.0587 25.039 20.2848 24.9525 20.5203 24.8565C20.7841 24.7604 21.0478 24.6643 21.3116 24.5779C21.6413 24.4722 21.9805 24.3857 22.3196 24.3089C22.7812 24.2128 23.2428 24.1359 23.7044 24.0879C23.4406 24.9237 23.158 25.7596 22.8377 26.5858C22.8472 26.7491 22.8566 26.9028 22.866 27.0661C23.4972 26.9412 24.1472 26.874 24.816 26.874C25.4849 26.874 26.1349 26.9412 26.7661 27.0661C26.7661 26.9028 26.7755 26.7395 26.7943 26.5858C26.4834 25.7596 26.1914 24.9237 25.9276 24.0879C26.3892 24.1359 26.8603 24.2032 27.3124 24.3089C27.6516 24.3857 27.9813 24.4722 28.3204 24.5779C28.5842 24.6643 28.848 24.7508 29.1118 24.8565C29.3473 24.9429 29.5734 25.039 29.7994 25.1447C31.4009 25.8748 32.8611 26.9509 34.0575 28.3535C37.0626 25.7115 38.9656 21.8014 38.9656 17.4301C38.9656 9.46567 32.635 3 24.816 3C17.0065 3 10.6665 9.45607 10.6665 17.4301C10.6665 21.7918 12.5694 25.7019 15.5746 28.3535C16.771 26.9509 18.2311 25.8748 19.8326 25.1447Z",
			fill: "#A0DBE8"
		}),
		s("path", {
			d: "M20.7651 27.7579C21.4245 27.46 22.1311 27.2295 22.8564 27.0854C22.8564 26.922 22.847 26.7587 22.8282 26.605C23.139 25.7788 23.4311 24.9429 23.6949 24.1071C23.2333 24.1552 22.7622 24.2224 22.31 24.3281C21.9709 24.4049 21.6412 24.4914 21.3021 24.5971C21.0383 24.6836 20.7745 24.77 20.5107 24.8757L21.5376 25.1351L20.7651 27.7579Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M18.335 29.3046C18.3633 29.0356 18.3727 28.7666 18.3727 28.488C18.3727 28.3247 18.5046 28.1902 18.6648 28.1902H18.9191L19.8235 25.1351C18.222 25.8652 16.7618 26.9412 15.5654 28.3439C16.2249 28.9299 16.9408 29.4487 17.6945 29.9003C17.9111 29.6985 18.1184 29.4968 18.335 29.3046Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M29.79 25.1447L30.6944 28.1998H30.9488C31.1089 28.1998 31.2408 28.3343 31.2408 28.4976C31.2408 28.7763 31.2596 29.0453 31.2785 29.3143C31.4951 29.5064 31.7118 29.6985 31.9096 29.9099C32.6727 29.4584 33.3792 28.9396 34.0387 28.3535C32.8517 26.9509 31.3915 25.8749 29.79 25.1447Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M28.0655 25.1159L29.0923 24.8565C28.8285 24.7605 28.5648 24.6644 28.301 24.5779C27.9713 24.4722 27.6321 24.3858 27.293 24.3089C26.8314 24.2128 26.3698 24.136 25.9082 24.088C26.172 24.9238 26.4546 25.7596 26.7749 26.5858C26.7655 26.7492 26.756 26.9029 26.7466 27.0662C27.4814 27.2103 28.1785 27.4409 28.838 27.7387L28.0655 25.1159Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M24.8067 28.1998H26.8038C26.7662 27.8252 26.7473 27.4505 26.7567 27.0854C26.1256 26.9605 25.4756 26.8932 24.8067 26.8932C24.1379 26.8932 23.4878 26.9605 22.8567 27.0854C22.8661 27.4601 22.8473 27.8252 22.8096 28.1998H24.8067Z",
			fill: "black"
		}),
		s("path", {
			d: "M17.7036 29.9003C17.8638 29.9963 18.0333 30.0924 18.2029 30.1885C18.2594 29.9003 18.3065 29.6025 18.3348 29.3046C18.1181 29.4968 17.9109 29.6985 17.7036 29.9003Z",
			fill: "black"
		}),
		s("path", {
			d: "M20.6333 28.1997H22.8188C22.8565 27.825 22.8754 27.4503 22.8659 27.0853C22.1312 27.2294 21.434 27.4599 20.7746 27.7578L20.6333 28.1997Z",
			fill: "black"
		}),
		s("path", {
			d: "M31.2881 29.3046C31.3163 29.6025 31.3634 29.9003 31.42 30.1885C31.5895 30.102 31.7497 30.006 31.9193 29.9003C31.712 29.6985 31.5048 29.4968 31.2881 29.3046Z",
			fill: "black"
		}),
		s("path", {
			d: "M28.9898 28.1997L28.8579 27.7578C28.1985 27.4599 27.4919 27.2294 26.7666 27.0853C26.7571 27.4599 26.776 27.825 26.8137 28.1997H28.9898Z",
			fill: "black"
		}),
		s("path", {
			d: "M20.6333 28.1998L20.7652 27.7578L21.5471 25.1158L20.5203 24.8564C20.2848 24.9429 20.0587 25.039 19.8326 25.1447L18.9282 28.1998H19.8985H20.6333Z",
			fill: "#AA9678"
		}),
		s("path", {
			d: "M28.8576 27.7578L28.9895 28.1998H29.7243H30.6946L29.7902 25.1447C29.5641 25.039 29.338 24.9525 29.1025 24.8564L28.0757 25.1158L28.8576 27.7578Z",
			fill: "#AA9678"
		}),
		s("path", {
			d: "M18.957 28.8147C18.9665 28.805 18.976 28.805 18.9854 28.7953H18.957C18.957 28.7953 18.957 28.805 18.957 28.8147Z",
			fill: "#C0B098"
		}),
		s("path", {
			d: "M24.807 28.7953H22.7251H20.4548H18.9852C18.9757 28.805 18.9663 28.805 18.9569 28.8146C18.9381 29.3814 18.8627 29.929 18.7402 30.467C20.5772 31.3605 22.6309 31.8601 24.807 31.8601V28.7953Z",
			fill: "#C0B098"
		}),
		s("path", {
			d: "M30.6666 28.7953H30.6382C30.6477 28.805 30.6571 28.805 30.6666 28.8147C30.6666 28.805 30.6666 28.7953 30.6666 28.7953Z",
			fill: "#AA9678"
		}),
		s("path", {
			d: "M30.6379 28.7953H29.1683H26.8886H24.8066V31.8601C26.9733 31.8601 29.0364 31.3605 30.8734 30.467C30.7509 29.929 30.6756 29.3718 30.6567 28.8146C30.6567 28.805 30.6473 28.7953 30.6379 28.7953Z",
			fill: "#AA9678"
		}),
		s("path", {
			d: "M31.2878 29.3046C31.2595 29.0356 31.2501 28.7666 31.2501 28.4879C31.2501 28.3246 31.1182 28.1901 30.9581 28.1901H30.7037H29.7146H28.9798H26.7942H24.7971H22.8H20.6144H19.8796H18.9093H18.655C18.4948 28.1901 18.3629 28.3246 18.3629 28.4879C18.3629 28.7666 18.3441 29.0356 18.3252 29.3046C18.297 29.6024 18.2499 29.9002 18.1934 30.1884C18.3723 30.2845 18.5513 30.3806 18.7303 30.467C18.8528 29.929 18.9282 29.3718 18.947 28.8146C18.947 28.805 18.947 28.805 18.947 28.7954H18.9753H20.4448H22.7152H24.7971H26.8884H29.1588H30.6284H30.6566C30.6566 28.805 30.6566 28.805 30.6566 28.8146C30.6755 29.3814 30.7508 29.929 30.8733 30.467C31.0523 30.3806 31.2313 30.2845 31.4103 30.1884C31.3537 29.9002 31.3161 29.6024 31.2878 29.3046Z",
			fill: "#8B7460"
		}),
		s("path", {
			d: "M28.8581 26.1348C28.8108 26.0866 28.7729 26.0286 28.7256 25.9707C28.7729 26.0383 28.8203 26.0866 28.8581 26.1348Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M34.2272 14.2212C34.1047 14.0482 33.9823 13.8945 33.8598 13.76C33.8033 13.6928 33.7467 13.6351 33.6902 13.5775C33.6714 13.5583 33.6431 13.5391 33.6243 13.5198C33.5866 13.4814 33.5489 13.4526 33.5112 13.4238V14.7688L34.0105 17.1226C34.0199 17.1418 34.0199 17.161 34.0294 17.1802L34.3779 17.5837H34.7453C34.7453 17.5453 34.7453 17.5165 34.7453 17.478C34.7453 16.3636 34.5663 15.2972 34.246 14.298C34.2366 14.2596 34.2366 14.2404 34.2272 14.2212Z",
			fill: "#BBBCBD"
		}),
		s("path", {
			d: "M34.0668 17.3435V17.3531C34.0668 17.3531 34.0668 17.3531 34.0668 17.3627C34.0763 17.4203 34.0763 17.478 34.0763 17.5356C34.0763 17.5452 34.0763 17.5548 34.0763 17.5644C34.0763 17.574 34.0763 17.5836 34.0763 17.5932C34.0763 17.6509 34.0763 17.7085 34.0668 17.7566V17.7662V17.7758C34.0574 17.8334 34.048 17.8911 34.0386 17.9487L34.3871 17.5548L34.0386 17.1513C34.048 17.2186 34.0574 17.2762 34.0668 17.3435Z",
			fill: "#676A6A"
		}),
		s("path", {
			d: "M34.0569 17.7949C34.0569 17.7853 34.0569 17.7853 34.0569 17.7757C34.0663 17.7181 34.0663 17.6604 34.0663 17.6124C34.0663 17.6028 34.0663 17.5836 34.0663 17.574C34.0663 17.5644 34.0663 17.5548 34.0663 17.5356C34.0663 17.4779 34.0663 17.4203 34.0569 17.3626C34.0569 17.353 34.0569 17.353 34.0569 17.3434C34.0475 17.2858 34.0381 17.2281 34.0287 17.1705C34.0192 17.1513 34.0192 17.132 34.0098 17.1128C33.9721 16.9975 33.9345 16.9015 33.8779 16.815C33.8685 16.8054 33.8591 16.7958 33.8591 16.7862C33.8403 16.767 33.8308 16.7478 33.812 16.7285C33.7932 16.6997 33.7649 16.6805 33.7366 16.6613C33.7272 16.6517 33.7178 16.6517 33.7084 16.6421C33.6895 16.6229 33.6613 16.6133 33.6424 16.6037C33.633 16.6037 33.6236 16.594 33.6142 16.594C33.5859 16.5844 33.5482 16.5748 33.5105 16.5748C33.4729 16.5748 33.4446 16.5844 33.4069 16.594C33.3975 16.594 33.3881 16.6037 33.3787 16.6037C33.3598 16.6133 33.3316 16.6229 33.3127 16.6421C33.3033 16.6517 33.2939 16.6517 33.2844 16.6613C33.2562 16.6805 33.2373 16.7093 33.2091 16.7285C33.1902 16.7478 33.1808 16.767 33.162 16.7862C33.1526 16.7958 33.1431 16.8054 33.1431 16.815C33.0866 16.9015 33.0395 16.9975 33.0113 17.1128V17.1224C32.9924 17.1705 32.983 17.2281 32.9736 17.2858C32.9736 17.305 32.9642 17.3146 32.9642 17.3338C32.9547 17.4011 32.9547 17.4587 32.9453 17.5259C32.9453 17.5356 32.9453 17.5452 32.9453 17.5548C32.9453 18.1024 33.1997 18.5539 33.5105 18.5539C33.5671 18.5539 33.6142 18.5347 33.6707 18.5155C33.6801 18.5155 33.6895 18.5059 33.6989 18.5059C33.7178 18.4963 33.7366 18.4771 33.7555 18.4675C33.7649 18.4578 33.7743 18.4482 33.7837 18.4386C33.812 18.4194 33.8308 18.3906 33.8591 18.3618C33.8779 18.3426 33.8874 18.3233 33.9062 18.2945C33.9156 18.2753 33.925 18.2657 33.9345 18.2465C33.9533 18.2177 33.9627 18.1888 33.9816 18.1504C33.991 18.1408 33.991 18.1312 34.0004 18.112C34.0192 18.064 34.0287 18.0159 34.0475 17.9679C34.0475 17.9102 34.0569 17.8526 34.0569 17.7949ZM33.5294 17.4299C33.4069 17.4299 33.3127 17.2666 33.3127 17.0552C33.3127 16.8534 33.4069 16.6805 33.5294 16.6805C33.6518 16.6805 33.7461 16.8438 33.7461 17.0552C33.7461 17.2666 33.6424 17.4299 33.5294 17.4299Z",
			fill: "black"
		}),
		s("path", {
			d: "M33.5297 17.4299C33.6493 17.4299 33.7463 17.2622 33.7463 17.0552C33.7463 16.8483 33.6493 16.6805 33.5297 16.6805C33.41 16.6805 33.313 16.8483 33.313 17.0552C33.313 17.2622 33.41 17.4299 33.5297 17.4299Z",
			fill: "white"
		}),
		s("path", {
			d: "M33.0024 17.1129C33.0401 16.9976 33.0778 16.9015 33.1343 16.815C33.1437 16.8054 33.1532 16.7958 33.1532 16.7862C33.172 16.767 33.1814 16.7478 33.2003 16.7286C33.2191 16.6998 33.2474 16.6805 33.2756 16.6613C33.2851 16.6517 33.2945 16.6517 33.3039 16.6421C33.3227 16.6229 33.351 16.6133 33.3698 16.6037C33.3793 16.6037 33.3887 16.5941 33.3981 16.5941C33.4264 16.5845 33.464 16.5749 33.5017 16.5749C33.5394 16.5749 33.5677 16.5845 33.6054 16.5941C33.6148 16.5941 33.6242 16.6037 33.6336 16.6037C33.6525 16.6133 33.6807 16.6229 33.6996 16.6421C33.709 16.6517 33.7184 16.6517 33.7278 16.6613C33.7561 16.6805 33.7749 16.7094 33.8032 16.7286C33.822 16.7478 33.8314 16.767 33.8503 16.7862C33.8597 16.7958 33.8691 16.8054 33.8691 16.815C33.9256 16.9015 33.9727 16.9976 34.001 17.1129L33.5017 14.7591L33.0024 17.1129Z",
			fill: "#909393"
		}),
		s("path", {
			d: "M26.8317 17.5453C26.8317 17.4973 26.8317 17.4492 26.8222 17.4012C26.8128 17.3532 26.8128 17.3147 26.8034 17.2667C26.794 17.2187 26.7846 17.1802 26.7657 17.1418C26.7563 17.1034 26.7375 17.0553 26.7186 17.0169C26.6998 16.9785 26.6809 16.94 26.6621 16.9016C26.5961 16.7863 26.5208 16.6807 26.4266 16.5942C26.3041 16.4789 26.1628 16.3828 26.0121 16.3156C25.9367 16.2868 25.8519 16.2579 25.7766 16.2387C25.7766 16.2387 25.7766 16.2387 25.7671 16.2387C25.6824 16.2195 25.5976 16.2099 25.5128 16.2099C25.428 16.2099 25.3432 16.2195 25.2584 16.2387H25.249C25.1642 16.2579 25.0889 16.2772 25.0135 16.306C25.0135 16.306 25.0135 16.306 25.0041 16.306C24.9287 16.3348 24.8534 16.3732 24.7874 16.4213C24.7215 16.4693 24.6555 16.5173 24.599 16.575H24.5896C24.4954 16.671 24.4106 16.7767 24.3447 16.892C24.3258 16.9304 24.307 16.9689 24.2881 17.0073C24.2881 17.0073 24.2881 17.0169 24.2787 17.0169C24.2599 17.0553 24.2505 17.0842 24.241 17.1226C24.241 17.1322 24.2316 17.1322 24.2316 17.1418C24.2222 17.1802 24.2128 17.2091 24.2034 17.2475C24.2034 17.2571 24.1939 17.2667 24.1939 17.2763C24.1845 17.3147 24.1845 17.3436 24.1751 17.382C24.1751 17.3916 24.1751 17.4012 24.1657 17.4108C24.1657 17.4588 24.1562 17.5069 24.1562 17.5549C24.1562 17.6414 24.1657 17.7278 24.1845 17.8143C24.1845 17.8143 24.1845 17.8143 24.1845 17.8239C24.2034 17.9104 24.2222 17.9872 24.2599 18.0737C24.3258 18.2274 24.42 18.3715 24.5331 18.4964C24.6273 18.5925 24.7309 18.679 24.8439 18.7462C24.8816 18.7654 24.9193 18.7846 24.957 18.8039H24.9664C25.0041 18.8231 25.0418 18.8327 25.07 18.8423C25.0795 18.8423 25.0795 18.8423 25.0889 18.8519C25.1266 18.8615 25.1548 18.8711 25.1925 18.8807C25.2019 18.8807 25.2113 18.8903 25.2208 18.8903C25.2584 18.8999 25.2867 18.8999 25.3244 18.9095C25.3338 18.9095 25.3432 18.9095 25.3526 18.9191C25.3998 18.9191 25.4469 18.9287 25.494 18.9287C25.6824 18.9287 25.8519 18.8903 26.0121 18.8231C26.0874 18.7846 26.1628 18.7462 26.2382 18.6982C26.3795 18.6021 26.5019 18.4772 26.5961 18.3331C26.6432 18.2562 26.6809 18.1794 26.7186 18.1025C26.7846 17.9392 26.8222 17.7567 26.8222 17.5741V17.5645C26.8317 17.5453 26.8317 17.5453 26.8317 17.5453ZM25.5034 17.382C25.2302 17.382 25.0041 17.1514 25.0041 16.8728C25.0041 16.5942 25.2302 16.3636 25.5034 16.3636C25.7766 16.3636 26.0027 16.5942 26.0027 16.8728C26.0027 17.1514 25.7766 17.382 25.5034 17.382Z",
			fill: "black"
		}),
		s("path", {
			d: "M25.5042 17.3819C25.7799 17.3819 26.0035 17.1539 26.0035 16.8727C26.0035 16.5915 25.7799 16.3635 25.5042 16.3635C25.2284 16.3635 25.0049 16.5915 25.0049 16.8727C25.0049 17.1539 25.2284 17.3819 25.5042 17.3819Z",
			fill: "white"
		}),
		s("path", {
			d: "M24.5806 16.575L25.5038 13.7024C25.5038 13.7024 25.5038 13.5295 25.5038 13.3662C25.5038 13.3181 25.5038 13.2701 25.5038 13.2317C25.5038 13.2124 25.5038 13.2028 25.5038 13.1932C25.5038 13.174 25.5038 13.1548 25.5038 13.1356C25.5038 13.126 25.5038 13.1068 25.5038 13.0972C25.5038 13.0875 25.5038 13.0683 25.5038 13.0587C25.5038 13.0491 25.5038 13.0395 25.5038 13.0395C25.5038 13.0299 25.5038 13.0299 25.5038 13.0299C24.9951 12.9242 24.4675 12.8666 23.9306 12.8666C23.7516 12.8666 23.5726 12.8762 23.3936 12.8858C23.3653 12.8858 23.3465 12.8858 23.3182 12.8954C22.395 12.9626 21.4907 13.2124 20.6522 13.6063C19.9363 13.9426 19.258 14.3845 18.6645 14.9033C18.5044 15.0474 18.3442 15.1915 18.1935 15.3452C18.1652 15.3741 18.137 15.4029 18.1087 15.4317C17.9674 15.5758 17.8261 15.7295 17.6942 15.8833C17.666 15.9217 17.6377 15.9505 17.6094 15.9889C17.4775 16.1523 17.3457 16.3156 17.2232 16.4789C17.2138 16.4885 17.2044 16.5077 17.1949 16.5173C17.0819 16.6807 16.9688 16.844 16.8558 17.0169C16.837 17.0457 16.8087 17.0842 16.7899 17.113C16.7051 17.2571 16.6203 17.4012 16.5449 17.5453H20.7182H20.7276L24.5806 16.575Z",
			fill: "#BBBCBD"
		}),
		s("path", {
			d: "M28.1126 16.2578C28.122 16.1426 28.1314 16.0369 28.1314 15.9216C28.1409 15.7679 28.1409 15.6238 28.1503 15.47C28.1503 15.3548 28.1503 15.2395 28.1503 15.1146C28.1503 15.0762 28.1503 15.0473 28.1503 15.0089C28.1503 14.7015 28.1314 14.4036 28.122 14.0962C28.122 14.0962 28.1126 14.0962 28.1126 14.0866C28.1126 14.0866 28.1032 14.0866 28.1032 14.077C28.0467 14.0482 27.9148 13.9713 27.7923 13.8945H27.7829C27.7546 13.8752 27.7264 13.856 27.6981 13.8464C27.6793 13.8368 27.6604 13.8176 27.6416 13.808L27.6322 13.7984C27.6133 13.7888 27.5945 13.7792 27.5851 13.7696C27.3966 13.6639 27.1988 13.5774 27.001 13.491C26.53 13.2892 25.8894 13.1067 25.522 13.0202V13.2796V13.3372V13.3565C25.522 13.5294 25.522 13.6927 25.522 13.6927L26.4358 16.5557C26.53 16.6421 26.6147 16.7478 26.6713 16.8631C26.6901 16.9015 26.7089 16.94 26.7278 16.9784C26.7466 17.0168 26.7655 17.0552 26.7749 17.1033C26.7843 17.1417 26.8032 17.1897 26.8126 17.2282C26.822 17.2762 26.8314 17.3146 26.8314 17.3627C26.8408 17.4107 26.8408 17.4587 26.8408 17.5068V17.5164H27.9524C28.0278 17.1033 28.0843 16.6806 28.1126 16.2578C28.1126 16.2771 28.1126 16.2675 28.1126 16.2578Z",
			fill: "#E2DDDB"
		}),
		s("path", {
			d: "M26.8425 21.638C27.0968 21.3786 27.3323 21.1384 27.5584 20.8982C27.6903 20.7541 27.8222 20.61 27.9541 20.4755C28.8867 19.4475 29.565 18.4772 29.9795 17.2379C29.9889 17.209 29.9983 17.1706 30.0078 17.1226C30.0078 17.113 30.0078 17.113 30.0078 17.1034C30.0172 17.0553 30.0266 17.0073 30.036 16.9496C30.036 16.9112 30.0454 16.8728 30.0454 16.8344C29.9418 16.2963 29.744 15.7679 29.565 15.2492C29.565 15.2492 29.565 15.2492 29.565 15.2588C29.565 15.2588 29.565 15.2588 29.5556 15.2492C29.5179 15.2203 29.4896 15.1819 29.4519 15.1531C29.3483 15.057 29.2447 14.9609 29.1316 14.8649C28.8019 14.5863 28.4628 14.3269 28.1048 14.1059C28.1237 14.4133 28.1331 14.7112 28.1331 15.0186C28.1331 15.057 28.1331 15.0858 28.1331 15.1243C28.1331 15.2395 28.1331 15.3548 28.1331 15.4797C28.1331 15.6334 28.1237 15.7872 28.1142 15.9313C28.1048 16.0466 28.1048 16.1522 28.0954 16.2675C28.0954 16.2771 28.0954 16.2867 28.0954 16.306C28.0577 16.7287 28.0106 17.1514 27.9353 17.5645L27.8034 18.1986C27.5302 19.3322 26.9744 20.3506 26.5222 21.4074C26.3997 21.686 26.2867 21.9742 26.183 22.2624C26.1736 22.2913 26.1642 22.3201 26.1548 22.3489C26.2961 22.1952 26.428 22.0607 26.5222 21.9646C26.6446 21.8397 26.7389 21.734 26.8425 21.638Z",
			fill: "#FBB040"
		}),
		s("path", {
			d: "M24.5908 16.5749C24.6473 16.5172 24.7133 16.4692 24.7792 16.4212C24.8452 16.3731 24.9205 16.3347 24.9959 16.3059C24.9959 16.3059 24.9959 16.3059 25.0053 16.3059C25.0807 16.2771 25.156 16.2482 25.2408 16.2386H25.2503C25.335 16.2194 25.4198 16.2098 25.5046 16.2098C25.5894 16.2098 25.6742 16.2194 25.759 16.2386C25.759 16.2386 25.759 16.2386 25.7684 16.2386C25.8532 16.2578 25.9285 16.2771 26.0039 16.3155C26.1546 16.3827 26.2959 16.4692 26.4184 16.5941L25.5046 13.7311L24.5908 16.5749Z",
			fill: "#909393"
		}),
		s("path", {
			d: "M24.2701 18.0736C24.2419 17.9967 24.2136 17.9102 24.1948 17.8238C24.1948 17.8238 24.1948 17.8238 24.1948 17.8142C24.1759 17.7277 24.1665 17.6412 24.1665 17.5548C24.1665 17.5067 24.1665 17.4587 24.1759 17.4107C24.1759 17.4011 24.1759 17.3914 24.1853 17.3818C24.1853 17.3434 24.1948 17.3146 24.2042 17.2762C24.2042 17.2666 24.2136 17.2569 24.2136 17.2473C24.223 17.2089 24.2324 17.1801 24.2419 17.1417C24.2419 17.132 24.2513 17.132 24.2513 17.1224C24.2607 17.084 24.2795 17.0456 24.289 17.0168C24.289 17.0168 24.289 17.0072 24.2984 17.0072C24.3172 16.9687 24.3361 16.9303 24.3549 16.8919C24.4208 16.7766 24.5056 16.6709 24.5998 16.5748L20.7374 17.5452H20.728L24.5527 18.4963C24.4303 18.381 24.3361 18.2369 24.2701 18.0736Z",
			fill: "#676A6A"
		}),
		s("path", {
			d: "M32.9553 17.3339C32.9553 17.3147 32.9648 17.2955 32.9648 17.2859C32.9742 17.2283 32.9836 17.1706 33.0024 17.1226C33.0024 17.113 33.0024 17.113 33.0024 17.1034L33.5017 14.7496V13.4046C33.0872 13.0587 32.6539 12.8666 32.1923 12.8666C31.6082 12.8666 31.0712 13.1932 30.6662 13.5967C30.2234 14.0387 29.8843 14.5959 29.6016 15.1531C29.5922 15.1819 29.5734 15.2011 29.564 15.23C29.6487 15.3068 29.7335 15.3837 29.8183 15.4605C30.0067 15.6335 30.1951 15.816 30.3741 15.9985C30.4589 16.085 30.5437 16.1715 30.6285 16.2579C30.7133 16.354 30.8075 16.4405 30.8922 16.5365C31.0053 16.6614 31.1183 16.7767 31.222 16.9016C31.2691 16.9497 31.3162 17.0073 31.3633 17.0553C31.4952 17.2091 31.627 17.3532 31.7589 17.5069C31.7778 17.5261 31.7966 17.5453 31.806 17.5549H32.9459C32.9459 17.5453 32.9459 17.5357 32.9459 17.5261C32.9459 17.4684 32.9459 17.4012 32.9553 17.3339Z",
			fill: "#E2DDDB"
		}),
		s("path", {
			d: "M15.8582 19.0344C15.8582 19.0248 15.8676 19.0152 15.8676 19.0056C15.943 18.8134 16.0184 18.6213 16.1031 18.4291C16.122 18.3715 16.1502 18.3234 16.1785 18.2754C16.2444 18.1217 16.3198 17.9776 16.3952 17.8335C16.4234 17.7758 16.4517 17.7182 16.4894 17.6509C16.5082 17.6221 16.5271 17.5837 16.5459 17.5549C16.6307 17.4108 16.706 17.2667 16.7908 17.1225C16.8097 17.0937 16.8379 17.0553 16.8568 17.0265C16.9604 16.8535 17.0734 16.6902 17.1959 16.5269C17.2053 16.5173 17.2147 16.4981 17.2242 16.4885C17.3466 16.3155 17.4785 16.1522 17.6104 15.9985C17.6387 15.9601 17.6669 15.9312 17.6952 15.8928C17.8271 15.7391 17.9684 15.5854 18.1097 15.4413C18.138 15.4125 18.1662 15.3836 18.1945 15.3548C18.3452 15.2011 18.4959 15.057 18.6655 14.9129C19.2967 12.7416 21.2467 11.1564 23.5453 11.1564C24.4685 11.1564 25.3917 11.4254 26.183 11.925C26.9932 12.4342 27.6526 13.174 28.0765 14.029C28.0765 14.029 28.0765 14.0386 28.086 14.0386C28.0954 14.0578 28.1048 14.077 28.1236 14.1059C28.4816 14.3268 28.8208 14.5862 29.1505 14.8648C29.2635 14.9609 29.3671 15.057 29.4708 15.1531C29.5084 15.1819 29.5367 15.2203 29.5744 15.2491C29.5838 15.2203 29.5932 15.2011 29.6121 15.1723C29.9324 13.0875 30.8367 11.5792 31.9012 11.5792C32.702 11.5792 33.4179 12.4342 33.8513 13.7504V13.76C33.9737 13.8945 34.0962 14.0482 34.2187 14.2115C34.2187 14.2115 34.2187 14.2212 34.2281 14.2212C34.2375 14.2404 34.2375 14.2596 34.2469 14.2788L34.2281 14.2115C32.8998 10.2149 29.1976 7.33276 24.8265 7.33276C19.3438 7.33276 14.9067 11.8578 14.9067 17.4492C14.9067 18.554 15.0763 19.6108 15.3966 20.6004C15.3966 20.6004 15.3966 20.6004 15.3966 20.5908C15.4625 20.2929 15.5379 19.9951 15.6227 19.7069C15.6981 19.4763 15.7734 19.2554 15.8582 19.0344Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M34.3772 17.5644L34.0287 17.9583C34.0193 18.0063 34.0004 18.0544 33.9816 18.1024C33.9816 18.112 33.9722 18.1216 33.9627 18.1408C33.9533 18.1697 33.9345 18.2081 33.9156 18.2369C33.9062 18.2561 33.8968 18.2657 33.8874 18.2849C33.8685 18.3042 33.8591 18.333 33.8403 18.3522C33.8214 18.381 33.7932 18.4098 33.7649 18.4291C33.7555 18.4387 33.7461 18.4483 33.7367 18.4579C33.7178 18.4771 33.699 18.4867 33.6801 18.4963C33.6707 18.4963 33.6613 18.5059 33.6519 18.5059C33.6048 18.5347 33.5482 18.5443 33.4917 18.5443C33.1808 18.5443 32.9265 18.1024 32.9265 17.5452H31.7866C32.0033 17.795 32.2105 18.0448 32.4084 18.3042L32.4178 18.3138C32.6156 18.5636 32.8135 18.8133 33.0113 19.0631C33.0207 19.0727 33.0301 19.092 33.0395 19.1016C33.2279 19.3417 33.4069 19.5819 33.5859 19.8221C33.6048 19.8413 33.6236 19.8701 33.6425 19.8894C33.8309 20.1488 34.0193 20.4081 34.2077 20.6579C34.2077 20.6579 34.2077 20.6579 34.2077 20.6675C34.5374 19.678 34.7164 18.6308 34.7258 17.5356L34.3772 17.5644Z",
			fill: "white"
		}),
		s("path", {
			d: "M23.3176 12.8858C23.3458 12.8858 23.3647 12.8858 23.3929 12.8762C23.5719 12.8665 23.7509 12.8569 23.9299 12.8569C24.4669 12.8569 24.9944 12.9146 25.5031 13.0203C25.5031 13.0203 25.5031 13.0203 25.5031 13.0299C25.5031 13.0299 25.5031 13.0395 25.5031 13.0491C25.5031 13.0587 25.5031 13.0683 25.5031 13.0875C25.5031 13.0971 25.5031 13.1067 25.5031 13.1259C25.5031 13.1452 25.5031 13.1644 25.5031 13.1836C25.5031 13.1932 25.5031 13.2124 25.5031 13.222C25.5031 13.2412 25.5031 13.2604 25.5031 13.2797V13.0203C25.8611 13.1067 26.5017 13.2893 26.9821 13.491C27.18 13.5775 27.3778 13.6736 27.5662 13.7696C27.5756 13.7696 27.5945 13.7792 27.6133 13.7984C27.6133 13.7984 27.6227 13.7984 27.6227 13.8081C27.6416 13.8177 27.6604 13.8273 27.6792 13.8465C27.7075 13.8657 27.7358 13.8753 27.764 13.8945H27.7734C27.8959 13.9618 28.0278 14.0482 28.0843 14.0771C28.0937 14.0771 28.0937 14.0867 28.0937 14.0867L28.1032 14.0963C28.0937 14.0771 28.0843 14.0578 28.0655 14.029C28.0655 14.029 28.0655 14.0194 28.0561 14.0194C27.6321 13.1548 26.9633 12.415 26.1625 11.9154C25.3712 11.4255 24.448 11.1469 23.5248 11.1469C21.2262 11.1469 19.2762 12.732 18.645 14.9033C19.2479 14.3749 19.9168 13.933 20.6327 13.6063C21.49 13.2028 22.4038 12.9626 23.3176 12.8858Z",
			fill: "black"
		}),
		s("path", {
			d: "M30.6757 13.6063C31.0808 13.2028 31.6177 12.8762 32.2018 12.8762C32.6634 12.8762 33.1062 13.0683 33.5113 13.4142C33.5489 13.443 33.5866 13.4814 33.6243 13.5102C33.6431 13.5295 33.6714 13.5487 33.6902 13.5679C33.7468 13.6255 33.8033 13.6832 33.8598 13.7504V13.7408C33.417 12.4246 32.7105 11.5696 31.9098 11.5696C30.8453 11.5696 29.9409 13.0683 29.6206 15.1627C29.8844 14.6055 30.2329 14.0482 30.6757 13.6063Z",
			fill: "black"
		}),
		s("path", {
			d: "M21.2742 26.8932C21.3684 26.9316 21.4532 26.9604 21.5474 26.9893C22.5742 27.3543 23.6764 27.5561 24.8257 27.5561C26.1352 27.5561 27.3881 27.2967 28.528 26.8259C28.5845 26.7971 28.6504 26.7779 28.707 26.7491C28.8012 26.7106 28.9048 26.6626 28.999 26.6146C29.0838 26.5761 29.1686 26.5377 29.2533 26.4897C29.2345 26.4897 29.2157 26.4993 29.1968 26.4993C28.8388 26.5377 28.4903 26.5473 28.1417 26.4897C26.0975 26.1919 25.6453 25.1831 25.7113 24.1455C25.5605 24.059 25.4192 23.963 25.2591 23.8477C23.6859 22.6852 22.7532 21.4459 22.7532 21.4459C22.7532 21.4459 23.9685 22.397 25.7772 23.1175C25.8149 23.1368 25.8526 23.1464 25.8902 23.1656C25.975 22.8678 26.0787 22.5795 26.1634 22.3297C26.1729 22.3009 26.1823 22.2721 26.1917 22.2433C26.2953 21.9551 26.4084 21.6668 26.5308 21.3882C26.983 20.3314 27.5388 19.3035 27.812 18.1794L27.9439 17.5453H26.8323V17.5549C26.8323 17.7471 26.7946 17.92 26.7287 18.0833C26.691 18.1602 26.6533 18.2467 26.6062 18.3139C26.512 18.458 26.3895 18.5829 26.2482 18.679C26.1729 18.727 26.0975 18.7655 26.0221 18.8039C25.862 18.8711 25.683 18.9096 25.504 18.9096C25.4569 18.9096 25.4098 18.9096 25.3627 18.9C25.3533 18.9 25.3439 18.9 25.3344 18.8904C25.2968 18.8904 25.2685 18.8807 25.2308 18.8711C25.2214 18.8711 25.212 18.8615 25.2025 18.8615C25.1649 18.8519 25.1366 18.8423 25.0989 18.8327C25.0895 18.8327 25.0895 18.8327 25.0801 18.8231C25.0424 18.8135 25.0047 18.7943 24.9765 18.7847H24.967C24.9294 18.7655 24.8917 18.7462 24.854 18.727C24.7409 18.6598 24.6373 18.5829 24.5431 18.4772L20.7184 17.5261H16.5451C16.5263 17.5549 16.5075 17.5934 16.4886 17.6222C16.4604 17.6798 16.4227 17.7375 16.3944 17.8047C16.3191 17.9488 16.2437 18.1026 16.1778 18.2467C16.1495 18.2947 16.1306 18.3523 16.1024 18.4004C16.0176 18.5925 15.9422 18.7847 15.8669 18.9768C15.8669 18.9864 15.8575 18.996 15.8575 19.0056C15.7727 19.2266 15.6973 19.4572 15.6314 19.6878C15.5466 19.976 15.4712 20.2738 15.4053 20.5716C16.0647 22.618 17.3365 24.3761 19.0133 25.6058C19.0604 25.6442 19.1169 25.6731 19.164 25.7115C19.4466 25.9132 19.7387 26.1054 20.0401 26.2687C20.4358 26.5185 20.8503 26.7203 21.2742 26.8932Z",
			fill: "white"
		}),
		s("path", {
			d: "M28.1225 23.7419C28.1037 23.8476 28.0942 23.9533 28.0942 24.059C28.0848 24.2415 28.1037 24.4241 28.1319 24.5874C28.1508 24.7027 28.1696 24.8083 28.1979 24.914C28.245 25.0677 28.2921 25.2118 28.358 25.3464C28.424 25.4809 28.4899 25.6057 28.5559 25.7114C28.5747 25.7499 28.603 25.7883 28.6218 25.8171C28.6595 25.8651 28.6877 25.9132 28.7254 25.9612C28.7725 26.0189 28.8196 26.0765 28.8573 26.1245C29.0363 26.3359 29.187 26.4512 29.187 26.4512C29.187 26.4512 29.187 26.4512 29.187 26.4608C29.187 26.4704 29.187 26.48 29.1964 26.4896C29.2153 26.4896 29.2341 26.48 29.253 26.48C29.6957 26.4224 30.1385 26.2975 30.5812 26.1438C30.8073 26.0573 31.0334 25.9708 31.2501 25.8747C31.316 25.8459 31.382 25.8075 31.4479 25.7787C33.7183 24.6546 35.6212 22.6755 35.6212 22.6755C32.7762 24.107 29.9783 24.0494 28.1225 23.7419Z",
			fill: "#9F2255"
		}),
		s("path", {
			d: "M33.6061 19.8414C33.4271 19.6013 33.2387 19.3611 33.0597 19.1209C33.0503 19.1113 33.0409 19.0921 33.0314 19.0825C32.8336 18.8327 32.6358 18.5829 32.438 18.3331L32.4285 18.3235C32.2213 18.0641 32.014 17.8143 31.8068 17.5645C31.7974 17.5453 31.7785 17.5357 31.7691 17.5165C31.6372 17.3628 31.5053 17.2187 31.3734 17.0649C31.3263 17.0169 31.2792 16.9593 31.2321 16.9112C31.1191 16.7863 31.0155 16.671 30.9024 16.5461C30.8176 16.4501 30.7234 16.3636 30.6387 16.2675C30.5539 16.1811 30.4691 16.0946 30.3843 16.0081C30.2053 15.8256 30.0169 15.6431 29.8285 15.4701C29.7437 15.3933 29.6589 15.3164 29.5741 15.2396C29.7531 15.768 29.9604 16.2964 30.064 16.844C30.0923 16.9881 30.1111 17.1226 30.1299 17.2571C30.3843 19.1497 29.7814 20.389 28.8393 22.0223C28.7734 22.1376 28.698 22.2625 28.6321 22.3777C28.4154 22.7428 28.2741 23.0983 28.1988 23.4249C28.1705 23.5306 28.1517 23.6363 28.1328 23.742C29.9886 24.0494 32.7771 24.107 35.6315 22.6756C35.6315 22.6756 35.0757 21.8397 34.2278 20.6869C34.0394 20.4275 33.851 20.1681 33.6626 19.9183C33.6438 19.8895 33.6249 19.8606 33.6061 19.8414Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M29.1871 26.4703C29.1871 26.4703 29.0458 26.3551 28.8574 26.1437C28.8103 26.0957 28.7726 26.038 28.7255 25.9804C28.6878 25.9323 28.6596 25.8843 28.6219 25.8363C28.603 25.7978 28.5748 25.769 28.5559 25.7306C28.49 25.6153 28.424 25.5 28.3581 25.3655C28.3016 25.231 28.2451 25.0869 28.198 24.9332C28.1697 24.8275 28.1414 24.7218 28.132 24.6065C28.1037 24.4432 28.0943 24.2607 28.0943 24.0781C28.0943 23.9725 28.1037 23.8668 28.1226 23.7611C28.1414 23.6554 28.1603 23.5497 28.1885 23.4441C28.2733 23.1174 28.4052 22.7716 28.6219 22.3969C28.6878 22.272 28.7632 22.1567 28.8291 22.0414C29.7712 20.4082 30.3741 19.1784 30.1197 17.2762C30.1009 17.1417 30.082 16.9976 30.0538 16.8631C30.0444 16.9592 30.0255 17.0456 30.0067 17.1129C30.0067 17.1225 30.0067 17.1225 30.0067 17.1321C29.9973 17.1801 29.9878 17.2186 29.9784 17.2474C29.5639 18.4867 28.8856 19.4571 27.953 20.485C27.8306 20.6291 27.6987 20.7636 27.5574 20.9077C27.3313 21.1479 27.0863 21.3977 26.8414 21.6475C26.7378 21.7532 26.6342 21.8493 26.5305 21.9549C26.4363 22.051 26.3044 22.1855 26.1631 22.3392C26.0783 22.589 25.9747 22.8772 25.8899 23.1751C25.8523 23.1558 25.8146 23.1462 25.7769 23.127C23.9682 22.4161 22.7529 21.4554 22.7529 21.4554C22.7529 21.4554 23.6856 22.6947 25.2588 23.8572C25.4095 23.9725 25.5602 24.0685 25.711 24.155C25.645 25.2022 26.0972 26.2013 28.1414 26.4992C28.49 26.5472 28.8385 26.5472 29.1965 26.5088C29.1965 26.4896 29.1871 26.4799 29.1871 26.4703Z",
			fill: "black"
		})
	], -1), n[1] ||= s("defs", null, [s("clipPath", { id: "clip0_presta_48" }, [s("rect", {
		width: "48",
		height: "48",
		fill: "white"
	})])], -1)], 64);
}
var ul = /*#__PURE__*/ W(cl, [["render", ll]]), dl = {};
function fl(t, n) {
	return A(), o(e, null, [n[0] ||= s("path", {
		"clip-rule": "evenodd",
		d: "M2.227 5h19.462a2.227 2.227 0 0 1 2.226 2.228v7.425a2.226 2.226 0 0 1-2.226 2.226h-6.98l.955 2.348-4.216-2.348H2.223A2.227 2.227 0 0 1 0 14.653V7.228A2.228 2.228 0 0 1 2.227 5Z",
		fill: "#7D57A4",
		"fill-rule": "evenodd"
	}, null, -1), n[1] ||= s("path", {
		d: "M1.204 7.017a.806.806 0 0 1 .612-.302c.496-.035.78.2.854.702.306 2.038.634 3.769.984 5.191l2.142-4.073c.194-.368.439-.562.735-.584.429-.03.697.244.805.82.201 1.14.51 2.259.925 3.34.257-2.48.686-4.274 1.288-5.38a.753.753 0 0 1 .646-.433.86.86 0 0 1 .616.193.752.752 0 0 1 .299.564.829.829 0 0 1-.094.471c-.382.708-.696 1.885-.942 3.53-.242 1.59-.332 2.832-.269 3.728.022.22-.017.442-.114.64a.615.615 0 0 1-.52.353c-.258.02-.515-.102-.774-.362-.908-.932-1.63-2.318-2.165-4.16-.627 1.256-1.098 2.194-1.411 2.817-.574 1.104-1.066 1.67-1.476 1.699-.266.019-.493-.205-.68-.67-.502-1.279-1.04-3.751-1.615-7.419a.836.836 0 0 1 .154-.665ZM22.212 8.553a2.268 2.268 0 0 0-1.562-1.13 2.612 2.612 0 0 0-.531-.056c-.936 0-1.701.487-2.295 1.462a5.193 5.193 0 0 0-.76 2.753c0 .753.157 1.398.471 1.936a2.264 2.264 0 0 0 1.564 1.13c.174.037.351.056.53.057.945 0 1.71-.488 2.293-1.462a5.259 5.259 0 0 0 .76-2.769c0-.753-.156-1.393-.47-1.92Zm-1.233 2.712c-.134.64-.381 1.122-.744 1.446-.286.258-.55.363-.788.316-.24-.048-.431-.259-.575-.633a2.526 2.526 0 0 1-.172-.89c-.001-.24.023-.48.071-.717.093-.417.268-.812.516-1.161.325-.477.664-.678 1.018-.601.24.048.43.258.574.63.11.284.168.585.172.889 0 .242-.023.483-.072.72ZM16.087 8.553a2.269 2.269 0 0 0-1.563-1.13 2.612 2.612 0 0 0-.53-.056c-.938 0-1.702.487-2.294 1.462a5.185 5.185 0 0 0-.76 2.753c0 .753.156 1.398.47 1.936a2.259 2.259 0 0 0 1.563 1.13c.174.037.352.056.53.057.946 0 1.711-.488 2.294-1.462a5.27 5.27 0 0 0 .768-2.769c0-.753-.157-1.393-.471-1.92h-.008Zm-1.233 2.712c-.134.64-.383 1.124-.746 1.448-.287.258-.55.363-.789.315-.238-.047-.43-.259-.573-.634a2.524 2.524 0 0 1-.172-.89c0-.24.023-.48.072-.717.093-.417.269-.811.515-1.161.324-.476.664-.676 1.019-.6.239.049.43.259.573.631.11.283.169.584.172.889.001.24-.023.48-.072.717v.002Z",
		fill: "#fff"
	}, null, -1)], 64);
}
var pl = /*#__PURE__*/ W(dl, [["render", fl]]), ml = {}, hl = {
	d: "M12 4C16.1686 4 19.5924 7.18828 19.9662 11.2593L18.8536 10.1465C18.6584 9.9512 18.3418 9.95117 18.1465 10.1464C17.9512 10.3416 17.9512 10.6582 18.1464 10.8535L20.1464 12.854C20.2402 12.9478 20.3674 13.0005 20.5 13.0005C20.6326 13.0005 20.7598 12.9478 20.8536 12.854L22.8536 10.8535C23.0488 10.6582 23.0488 10.3416 22.8535 10.1464C22.6582 9.95117 22.3416 9.9512 22.1464 10.1465L20.9746 11.3186C20.6263 6.66634 16.7413 3 12 3C8.56143 3 5.57406 4.92853 4.05911 7.76061C3.92886 8.0041 4.02067 8.30708 4.26416 8.43733C4.50765 8.56758 4.81063 8.47578 4.94088 8.23229C6.28879 5.71248 8.9448 4 12 4ZM3.02546 12.6814L1.8536 13.8535C1.65836 14.0488 1.34178 14.0488 1.14649 13.8536C0.951204 13.6584 0.951164 13.3418 1.1464 13.1465L3.1464 11.146C3.24018 11.0522 3.36737 10.9995 3.5 10.9995C3.63263 10.9995 3.75982 11.0522 3.8536 11.146L5.8536 13.1465C6.04884 13.3418 6.0488 13.6584 5.85351 13.8536C5.65822 14.0488 5.34164 14.0488 5.1464 13.8535L4.03389 12.7407C4.40765 16.8118 7.83152 20 12.0001 20C15.0566 20 17.7136 18.286 19.061 15.7644C19.1911 15.5208 19.494 15.4289 19.7376 15.559C19.9811 15.6891 20.0731 15.9921 19.943 16.2356C18.4286 19.0698 15.4401 21 12.0001 21C7.25871 21 3.3737 17.3336 3.02546 12.6814ZM11.5 8.5C11.5 8.22386 11.7239 8 12 8C12.2761 8 12.5 8.22386 12.5 8.5V11.5H15.5C15.7761 11.5 16 11.7239 16 12C16 12.2761 15.7761 12.5 15.5 12.5H12.5V15.5C12.5 15.7761 12.2761 16 12 16C11.7239 16 11.5 15.7761 11.5 15.5V12.5H8.5C8.22386 12.5 8 12.2761 8 12C8 11.7239 8.22386 11.5 8.5 11.5H11.5V8.5Z",
	fill: "currentColor"
};
function gl(e, t) {
	return A(), o("path", hl);
}
var _l = /*#__PURE__*/ W(ml, [["render", gl]]), vl = {}, yl = {
	"clip-rule": "evenodd",
	d: "M40.7316 23.2077L43.4697 20.4697C43.7626 20.1768 44.2374 20.1768 44.5303 20.4697C44.8232 20.7626 44.8232 21.2374 44.5303 21.5303L40.5303 25.5303C40.2374 25.8232 39.7626 25.8232 39.4697 25.5303L35.4697 21.5303C35.1768 21.2374 35.1768 20.7626 35.4697 20.4697C35.7626 20.1768 36.2374 20.1768 36.5303 20.4697L39.2276 23.167C38.7951 15.132 32.1428 8.75 24 8.75C18.1847 8.75 13.1284 12.0048 10.5555 16.7955C10.3596 17.1604 9.90487 17.2974 9.53995 17.1014C9.17504 16.9054 9.03808 16.4507 9.23406 16.0858C12.0579 10.8278 17.6105 7.25 24 7.25C32.9852 7.25 40.318 14.3248 40.7316 23.2077ZM7.26841 24.7923L4.53033 27.5303C4.23744 27.8232 3.76256 27.8232 3.46967 27.5303C3.17678 27.2374 3.17678 26.7626 3.46967 26.4697L7.46967 22.4697C7.76256 22.1768 8.23744 22.1768 8.53033 22.4697L12.5303 26.4697C12.8232 26.7626 12.8232 27.2374 12.5303 27.5303C12.2374 27.8232 11.7626 27.8232 11.4697 27.5303L8.77237 24.833C9.20491 32.868 15.8572 39.25 24 39.25C29.861 39.25 34.9509 35.9439 37.5046 31.0914C37.6975 30.7248 38.151 30.5841 38.5176 30.777C38.8841 30.9699 39.0249 31.4234 38.832 31.7899C36.0293 37.1158 30.4396 40.75 24 40.75C15.0148 40.75 7.68202 33.6752 7.26841 24.7923ZM24 16.25C23.5858 16.25 23.25 16.5858 23.25 17V23.25H17C16.5858 23.25 16.25 23.5858 16.25 24C16.25 24.4142 16.5858 24.75 17 24.75H23.25V31C23.25 31.4142 23.5858 31.75 24 31.75C24.4142 31.75 24.75 31.4142 24.75 31V24.75H31C31.4142 24.75 31.75 24.4142 31.75 24C31.75 23.5858 31.4142 23.25 31 23.25H24.75V17C24.75 16.5858 24.4142 16.25 24 16.25Z",
	fill: "#FF8C00",
	"fill-rule": "evenodd"
};
function bl(e, t) {
	return A(), o("path", yl);
}
var xl = /*#__PURE__*/ W(vl, [["render", bl]]), Sl = {}, Cl = {
	d: "M16.5622 16.3942H12.2951C10.258 16.3942 9.31148 15.6732 9.04964 13.8598H15.3481V13.8622H17.5601V13.2197C17.5616 13.1984 17.5629 13.1769 17.5629 13.1547V10.9577C17.5629 10.9356 17.5616 10.9141 17.5601 10.8927V10.2567H16.9384C16.9119 10.2544 16.8853 10.2532 16.8587 10.2532H9.03513C9.27563 8.37454 10.2196 7.60545 12.2951 7.60545H18.7177V4H16.7866L11.901 4.00032C6.9146 4.00032 5 6.47872 5 11.9998C5 17.5205 6.9146 20 11.901 20H18.0702L18.0771 19.9997H18.7744V16.3942H16.5622Z",
	fill: "#E1141D"
};
function wl(e, t) {
	return A(), o("path", Cl);
}
var Tl = /*#__PURE__*/ W(Sl, [["render", wl]]), El = {}, Dl = {
	"clip-rule": "evenodd",
	d: "M22.0002 8.27983L19.4002 12.1454L22.0002 16.0011C22.0002 16.0011 20.869 16.1454 20.3248 15.6503C20.0656 15.3951 19.8307 15.1163 19.6231 14.8175L18.6658 13.4405C18.6479 13.3998 18.6197 13.3646 18.5841 13.3381C18.5485 13.3117 18.5066 13.295 18.4625 13.2896C18.3641 13.2896 18.3051 13.3683 18.2559 13.4405L17.3018 14.8175C17.1011 15.1167 16.8716 15.3956 16.6166 15.6503C16.0723 16.1454 14.9314 16.0011 14.9314 16.0011L17.5248 12.1323L14.9248 8.2536C14.9248 8.2536 16.0199 8.06671 16.5641 8.55851C16.8381 8.83856 17.085 9.14372 17.3018 9.46999L18.2559 10.8536C18.3051 10.9257 18.3641 11.0044 18.4625 11.0044C18.5064 10.9985 18.548 10.9815 18.5835 10.9551C18.6191 10.9288 18.6474 10.8938 18.6658 10.8536L19.6264 9.44376C19.8429 9.12628 20.0888 8.82989 20.3608 8.55851C20.9018 8.09294 22.0002 8.27983 22.0002 8.27983ZM10.6754 9.35584C10.7403 9.07501 10.8849 8.81887 11.0918 8.61814V8.59519C11.4665 8.31096 11.9357 8.18076 12.4032 8.23126L10.3672 16.0017C10.0235 16.0274 9.67811 15.985 9.35079 15.8771C8.90817 15.6509 8.69506 15.4771 8.4262 14.4214C8.28267 13.8846 8.00349 12.7627 7.77845 11.8584L7.77844 11.8584L7.77843 11.8584L7.77831 11.8579C7.60759 11.1719 7.46806 10.6112 7.4426 10.5263C7.43785 10.5125 7.43295 10.4959 7.42754 10.4774C7.39564 10.3686 7.34575 10.1985 7.19998 10.1985C7.0494 10.1985 7.00112 10.3775 6.97157 10.4871C6.96766 10.5016 6.96408 10.5148 6.96064 10.5263C6.92271 10.6441 6.6588 11.712 6.40409 12.7426L6.40406 12.7427L6.40388 12.7435C6.24026 13.4056 6.08047 14.0521 5.98687 14.4214C5.71802 15.4771 5.50818 15.6509 5.06228 15.8771C4.73623 15.9856 4.3918 16.028 4.04917 16.0017L2 8.23126C2.4707 8.18621 2.94059 8.32483 3.31147 8.61814C3.51834 8.81887 3.66291 9.07501 3.72786 9.35584L4.79671 13.4771L5.69507 10.1067C5.77748 9.7068 5.94401 9.32904 6.18359 8.99847C6.46037 8.73772 6.82628 8.59251 7.20654 8.59251C7.5868 8.59251 7.9527 8.73772 8.22948 8.99847C8.46808 9.32922 8.63349 9.707 8.71473 10.1067L9.60325 13.4771L10.6754 9.35584ZM12.8978 9.91598C12.8978 8.94877 13.0454 8.59796 13.4421 8.38812C13.7126 8.28344 14.0014 8.23438 14.2913 8.24386C14.2913 8.77501 14.2322 9.09304 13.9044 9.33566C13.7485 9.4513 13.5775 9.54506 13.3962 9.61435C13.2119 9.68124 13.0426 9.78373 12.8978 9.91598ZM14.2917 9.51926C14.1788 9.6651 14.0356 9.78478 13.872 9.87007C13.7483 9.93835 13.6287 9.99273 13.5079 10.0477L13.5078 10.0477C13.443 10.0772 13.3778 10.1069 13.3114 10.1389C13.1858 10.177 13.0768 10.2563 13.0018 10.364C12.9269 10.4716 12.8904 10.6014 12.8983 10.7324V15.9782C13.1881 16.0131 13.482 15.976 13.754 15.87C14.1901 15.6471 14.2884 15.434 14.2917 14.4701V9.79794V9.51926Z",
	fill: "black",
	"fill-rule": "evenodd"
};
function Ol(e, t) {
	return A(), o("path", Dl);
}
var kl = /*#__PURE__*/ W(El, [["render", Ol]]), Al = {}, jl = {
	d: "M2.57294 7.87305V11.1009C2.57294 11.1009 3.71033 11.1009 4.31904 11.0547C4.79774 10.9709 4.88585 10.9247 4.97396 10.446L5.15019 9.74487H5.67079L5.58268 11.2771L5.62889 12.847H5.10398L4.97396 12.234C4.84395 11.7977 4.66773 11.7091 4.31904 11.6672C3.88279 11.621 2.57294 11.621 2.57294 11.621V14.3282C2.57294 14.8489 2.83728 15.0713 3.44599 15.0713H5.2802C5.84701 15.0713 6.41329 15.0251 6.76627 14.1982L7.24067 13.149H7.68122C7.63502 13.3671 7.41689 15.2894 7.37499 15.7219C7.37499 15.7219 5.717 15.68 5.02017 15.68H1.87612L0 15.7219V15.2475L0.608717 15.1132C1.04927 15.0251 1.17929 14.8951 1.17929 14.5464C1.17929 14.5464 1.22549 13.3671 1.22549 11.4023C1.22549 9.44239 1.17929 8.26256 1.17929 8.26256C1.17929 7.87198 1.04927 7.78386 0.608717 7.69575L0 7.56681V7.08811L1.83421 7.12572H5.32641C6.02324 7.12572 7.19823 7 7.19823 7C7.19823 7 7.15632 7.73873 7.11012 9.48483H6.63142L6.45519 8.87182C6.28327 8.08688 6.0227 7.69629 5.54024 7.69629H2.79537C2.57294 7.69683 2.57294 7.73873 2.57294 7.87305ZM9.64115 8.21743H10.1661V10.0516L11.9584 9.96353L11.8703 10.7947L10.1242 10.6604V13.8925C10.1242 14.8075 10.4304 15.1599 10.9553 15.1599C11.4297 15.1599 11.7821 14.8956 11.9122 14.6775L12.1722 14.9837C11.9122 15.5924 11.1734 15.8987 10.4723 15.8987C9.60355 15.8987 8.89812 15.3781 8.89812 14.375V10.706H7.85691V10.2698C8.7305 10.1817 9.38112 9.65676 9.64115 8.21743ZM13.3977 13.8458L13.7458 14.6769C13.8758 15.0251 14.1821 15.3781 14.8789 15.3781C15.6219 15.3781 15.9282 14.9837 15.9282 14.505C15.9282 13.0189 13.0028 13.4557 13.0028 11.4491C13.0028 10.316 13.9178 9.78677 15.097 9.78677C15.6219 9.78677 16.4069 9.87489 16.8012 10.0511C16.7131 10.4874 16.6669 11.0542 16.6669 11.491L16.2344 11.5329L15.9282 10.6598C15.8401 10.446 15.4876 10.2692 15.0551 10.2692C14.5302 10.2692 14.0059 10.4874 14.0059 11.0542C14.0059 12.4059 17.0194 12.1034 17.0194 14.1101C17.0194 15.2475 16.0163 15.8562 14.7908 15.8562C13.8758 15.8562 12.9566 15.5038 12.9566 15.5038C13.0447 14.9832 13.0028 14.4169 12.9566 13.8458H13.3977ZM16.8018 18.0348C16.9318 17.5561 17.0199 16.9479 17.108 16.3768L17.5867 16.3349L17.7629 17.2499C17.8048 17.468 17.9349 17.6442 18.2835 17.6442C18.8504 17.6442 19.5934 17.2961 20.294 16.0743C19.9834 15.3313 19.0685 12.9346 18.2373 11.1004C18.0192 10.6179 17.9773 10.5755 17.6748 10.4874L17.4524 10.4036V9.963L18.766 10.0092L20.3778 9.92109V10.3579L19.9834 10.446C19.6772 10.4879 19.5509 10.6598 19.5509 10.8366C19.5509 10.8828 19.5509 10.9247 19.5928 11.0128C19.6767 11.2771 20.3778 13.2376 20.9027 14.5469C21.3352 13.632 22.1663 11.5796 22.2963 11.2309C22.3425 11.0547 22.3845 11.0128 22.3845 10.8828C22.3845 10.6604 22.2544 10.5303 21.952 10.4465L21.6414 10.3579V9.92163L22.8669 9.96353L24 9.92163V10.3579L23.7819 10.5298C23.3456 10.706 23.2994 10.7479 23.127 11.1004L21.2089 15.5913C20.0715 18.1686 18.8923 18.3867 18.0649 18.3867C17.5405 18.3873 17.1462 18.2529 16.8018 18.0348Z",
	fill: "#F1641E"
};
function Ml(e, t) {
	return A(), o("path", jl);
}
var Nl = /*#__PURE__*/ W(Al, [["render", Ml]]), Pl = {};
function Fl(e, t) {
	return A(), o("g", null, [...t[0] ||= [s("path", {
		d: "M18.3208 17.8187C10.8914 21.3544 6.28063 18.3962 3.32914 16.5994C3.1465 16.4861 2.83608 16.6258 3.10541 16.9352C4.0887 18.1275 7.31115 21.0012 11.5174 21.0012C15.7265 21.0012 18.2305 18.7045 18.5438 18.3038C18.8549 17.9066 18.6351 17.6874 18.3207 17.8187H18.3208ZM20.4073 16.6664C20.2078 16.4066 19.1941 16.3581 18.5562 16.4365C17.9173 16.5126 16.9583 16.9031 17.0417 17.1375C17.0845 17.2254 17.1718 17.186 17.6107 17.1465C18.0508 17.1026 19.2837 16.947 19.5406 17.2828C19.7987 17.621 19.1474 19.2319 19.0284 19.4917C18.9135 19.7515 19.0724 19.8185 19.2882 19.6455C19.5012 19.4725 19.8866 19.0245 20.1453 18.3906C20.4022 17.7533 20.5589 16.8642 20.4072 16.6664H20.4073Z",
		fill: "#FF9900"
	}, null, -1), s("path", {
		"clip-rule": "evenodd",
		d: "M13.3253 10.6028C13.3253 11.5306 13.3488 12.3043 12.8799 13.1281C12.5014 13.798 11.9019 14.21 11.232 14.21C10.3176 14.21 9.78512 13.5133 9.78512 12.4851C9.78512 10.4554 11.6037 10.0871 13.3253 10.0871V10.6028ZM15.7267 16.4071C15.5693 16.5478 15.3415 16.5579 15.1641 16.464C14.3736 15.8076 14.2329 15.5028 13.7976 14.8765C12.4914 16.2095 11.5669 16.6081 9.87224 16.6081C7.86938 16.6081 6.30859 15.3722 6.30859 12.8971C6.30859 10.9646 7.35697 9.64829 8.8473 9.00528C10.1402 8.43584 11.9454 8.33538 13.3253 8.17801V7.86985C13.3253 7.3038 13.3688 6.63396 13.0373 6.145C12.7459 5.70623 12.1899 5.52536 11.7009 5.52536C10.7933 5.52536 9.98273 5.99089 9.78512 6.95547C9.74488 7.16987 9.58752 7.38089 9.37318 7.39092L7.06216 7.14312C6.86794 7.09949 6.65361 6.94212 6.70719 6.64399C7.23971 3.84407 9.76832 3 12.0324 3C13.1913 3 14.7051 3.30816 15.6195 4.18569C16.7784 5.26747 16.6678 6.71099 16.6678 8.28179V11.9928C16.6678 13.1081 17.13 13.597 17.5654 14.2C17.7194 14.4143 17.753 14.6723 17.5587 14.8329C17.073 15.2382 16.2089 15.9918 15.7334 16.4138L15.7267 16.4071",
		fill: "black",
		"fill-rule": "evenodd"
	}, null, -1)]]);
}
var Il = /*#__PURE__*/ W(Pl, [["render", Fl]]), Ll = {};
function Rl(t, n) {
	return A(), o(e, null, [
		n[0] ||= s("path", {
			"clip-rule": "evenodd",
			d: "M11.5205 5L10.9009 5.00004C5.9146 5.00004 4 7.47844 4 12.9996C4 18.5203 5.9146 20.9997 10.9009 20.9997H17.0702L17.0771 20.9994H17.7744V17.3939H15.5622H11.2951C9.258 17.3939 8.31148 16.6729 8.04964 14.8595H14.3481V14.8619H16.5601V14.2194C16.5616 14.1981 16.5629 14.1767 16.5629 14.1545V11.9574C16.5629 11.9353 16.5616 11.9138 16.5601 11.8925V11.4265C16.2978 11.3853 16.0411 11.327 15.7913 11.2529H8.03513C8.27563 9.37426 9.21959 8.60518 11.2951 8.60518H12.3651C11.8161 7.69925 11.5 6.6364 11.5 5.49972C11.5 5.33144 11.5069 5.16478 11.5205 5Z",
			fill: "#E1141D",
			"fill-rule": "evenodd"
		}, null, -1),
		n[1] ||= s("g", { "clip-path": "url(#clip_exact_de)" }, [
			s("path", {
				d: "M13 1H22V4H13V1Z",
				fill: "black"
			}),
			s("path", {
				d: "M13 4H22V7H13V4Z",
				fill: "#DD4547"
			}),
			s("path", {
				d: "M13 7H22V10H13V7Z",
				fill: "#F8D952"
			})
		], -1),
		n[2] ||= s("defs", null, [s("clipPath", { id: "clip_exact_de" }, [s("rect", {
			fill: "white",
			height: "9",
			rx: "4.5",
			width: "9",
			x: "13",
			y: "1"
		})])], -1)
	], 64);
}
var zl = /*#__PURE__*/ W(Ll, [["render", Rl]]), Bl = {}, Vl = {
	d: "M10.25 9.5L12.75 2.5L15.25 9.5L21.75 10L16.75 14.5L19.25 21L12.75 17.5L6.25 21L8.75 14.5L3.75 10L10.25 9.5Z",
	fill: "none",
	stroke: "currentColor",
	"stroke-linejoin": "round"
};
function Hl(e, t) {
	return A(), o("path", Vl);
}
var Ul = /*#__PURE__*/ W(Bl, [["render", Hl]]), Wl = {}, Gl = {
	d: "M49.24 19.48c-.1-.3-.36-.51-.67-.54l-16.7-1.52-6.15-15.06c-.11-.3-.4-.49-.72-.49s-.6.19-.72.48l-6.15 15.07-16.7 1.52a.786.786 0 0 0-.44 1.37l12.6 11.02-3.87 15.83c-.07.31.05.63.3.82.26.18.6.2.87.03L25 39.28l14.11 8.73c.12.08.27.12.41.12.16 0 .32-.05.46-.15.26-.19.38-.51.3-.82l-3.87-15.83 12.6-11.02c.24-.2.33-.53.23-.83z",
	fill: "currentColor"
};
function Kl(e, t) {
	return A(), o("path", Gl);
}
var ql = /*#__PURE__*/ W(Wl, [["render", Kl]]), Jl = {};
function Yl(e, t) {
	return A(), o("g", null, [...t[0] ||= [s("path", {
		d: "M49.24 19.48c-.1-.3-.36-.51-.67-.54l-16.7-1.52-6.15-15.06c-.11-.3-.4-.49-.72-.49s-.6.19-.72.48l-6.15 15.07-16.7 1.52a.786.786 0 0 0-.44 1.37l12.6 11.02-3.87 15.83c-.07.31.05.63.3.82.26.18.6.2.87.03L25 39.28l14.11 8.73c.12.08.27.12.41.12.16 0 .32-.05.46-.15.26-.19.38-.51.3-.82l-3.87-15.83 12.6-11.02c.24-.2.33-.53.23-.83zM35.02 30.47c-.22.2-.31.49-.25.77l3.53 14.44-12.9-7.98a.754.754 0 0 0-.82 0l-12.9 7.98 3.53-14.44a.756.756 0 0 0-.25-.77L3.39 20.34l15.35-1.4c.29-.02.54-.21.65-.48L25 4.72l5.61 13.74c.11.27.36.46.65.48l15.35 1.4-11.59 10.13z",
		fill: "currentColor"
	}, null, -1), s("path", {
		d: "M10.48 48.25a.902.902 0 0 1-.88-1.12l3.85-15.76L.91 20.41a.895.895 0 0 1-.26-.96c.11-.35.42-.59.78-.62l16.62-1.51 6.12-15c.13-.35.46-.57.83-.57.37 0 .7.23.84.56l6.12 15 16.62 1.51c.36.03.67.27.78.62.11.34.01.72-.26.96L36.55 31.37l3.85 15.76c.09.36-.05.73-.35.95-.3.21-.7.22-1.01.04L25 39.42l-14.04 8.69a.84.84 0 0 1-.48.14zM25 2c-.27 0-.5.16-.61.41l-6.15 15.07c-.02.04-.06.07-.1.08l-16.7 1.52c-.26.02-.48.2-.56.45-.08.25-.01.52.19.7l12.6 11.02c.04.03.05.08.04.12L9.84 47.19c-.06.26.04.53.25.69.22.16.5.17.73.03l14.11-8.73c.04-.03.09-.03.13 0l14.11 8.73c.22.14.51.13.73-.03.21-.16.31-.43.25-.69l-3.87-15.83c-.01-.04 0-.09.04-.12l12.6-11.02c.2-.17.27-.45.19-.7a.644.644 0 0 0-.56-.45l-16.7-1.52c-.05 0-.09-.03-.1-.08L25.61 2.4c-.1-.24-.34-.4-.61-.4zm13.31 43.8c-.02 0-.05-.01-.07-.02l-12.9-7.98a.66.66 0 0 0-.69 0l-12.9 7.98c-.04.03-.1.02-.14 0a.13.13 0 0 1-.05-.13l3.53-14.44a.642.642 0 0 0-.21-.65L3.31 20.43c-.04-.03-.05-.08-.04-.13.02-.05.06-.08.11-.08l15.35-1.4c.25-.02.46-.17.55-.4l5.61-13.74c.04-.1.19-.1.23 0l5.61 13.74c.09.23.3.38.55.4l15.35 1.4c.05 0 .09.04.11.08.02.05 0 .1-.04.13L35.11 30.56c-.18.16-.26.41-.21.65l3.53 14.44c.01.05-.01.1-.05.13-.02.02-.05.02-.07.02zM3.69 20.44l11.37 9.94c.26.23.37.57.29.9l-3.46 14.14 12.64-7.82c.28-.18.67-.18.95 0l12.64 7.82-3.46-14.14c-.08-.33.03-.67.28-.9l11.37-9.94-15.06-1.37a.897.897 0 0 1-.76-.56L25 5.05 19.51 18.5c-.13.32-.42.53-.76.56L3.69 20.44z",
		fill: "currentColor"
	}, null, -1)]]);
}
var Xl = /*#__PURE__*/ W(Jl, [["render", Yl]]), Zl = {}, Ql = {
	fill: "#0866ff",
	stroke: "none",
	transform: "translate(0,700) scale(0.1,-0.1)"
};
function $l(e, t) {
	return A(), o("g", Ql, [...t[0] ||= [s("path", { d: "M3245 5994 c-585 -62 -1145 -334 -1545 -751 -356 -370 -580 -812\n      -670 -1324 -28 -155 -39 -530 -21 -690 66 -578 312 -1091 721 -1499 289 -290\n      629 -498 1010 -618 52 -16 107 -32 123 -36 l27 -6 0 830 0 830 -255 0 -255 0\n      0 385 0 385 254 0 254 0 5 283 c3 191 10 315 22 385 90 562 403 845 999 903\n      185 18 496 -1 694 -42 l52 -10 0 -352 0 -352 -209 3 c-156 2 -227 -1 -281 -12\n      -180 -38 -278 -123 -333 -289 -17 -53 -21 -95 -25 -289 l-4 -228 406 0 406 0\n      -1 -22 c0 -13 -30 -185 -67 -383 l-67 -360 -338 -3 -337 -2 0 -859 0 -858 88\n      14 c518 82 995 326 1373 703 407 406 654 921 720 1499 18 160 7 535 -21 690\n      -95 537 -348 1018 -727 1381 -370 356 -811 579 -1324 670 -102 19 -169 23\n      -379 25 -140 2 -273 1 -295 -1z" }, null, -1)]]);
}
var eu = /*#__PURE__*/ W(Zl, [["render", $l]]), tu = {}, nu = {
	d: "M 9.632812 15.890625 C 9.554688 15.894531 9.507812 15.898438 9.457031 15.898438 C 8.386719 15.898438 7.320312 15.898438 6.253906 15.902344 C 6.101562 15.902344 6.0625 15.863281 6.0625 15.710938 C 6.066406 13.226562 6.066406 10.734375 6.066406 8.246094 C 6.066406 8.179688 6.066406 8.117188 6.066406 8.03125 C 5.484375 8.03125 4.917969 8.03125 4.34375 8.03125 C 4.34375 7.144531 4.34375 6.273438 4.34375 5.375 C 4.402344 5.375 4.460938 5.375 4.511719 5.375 C 4.980469 5.375 5.449219 5.371094 5.917969 5.378906 C 6.039062 5.378906 6.070312 5.34375 6.070312 5.226562 C 6.0625 4.53125 6.0625 3.832031 6.070312 3.132812 C 6.070312 2.648438 6.148438 2.171875 6.375 1.730469 C 6.695312 1.109375 7.207031 0.707031 7.851562 0.457031 C 8.375 0.25 8.929688 0.175781 9.484375 0.164062 C 10.390625 0.152344 11.296875 0.160156 12.203125 0.15625 C 12.289062 0.15625 12.355469 0.152344 12.355469 0.273438 C 12.351562 1.132812 12.351562 1.992188 12.351562 2.851562 C 12.351562 2.859375 12.351562 2.867188 12.335938 2.910156 C 12.285156 2.910156 12.226562 2.910156 12.164062 2.910156 C 11.601562 2.910156 11.039062 2.90625 10.476562 2.910156 C 10.152344 2.910156 9.890625 3.039062 9.726562 3.324219 C 9.675781 3.410156 9.644531 3.519531 9.644531 3.617188 C 9.632812 4.148438 9.644531 4.679688 9.636719 5.210938 C 9.636719 5.335938 9.675781 5.371094 9.796875 5.371094 C 10.578125 5.367188 11.359375 5.367188 12.140625 5.367188 C 12.203125 5.367188 12.261719 5.367188 12.367188 5.367188 C 12.257812 6.261719 12.152344 7.136719 12.042969 8.023438 C 11.230469 8.023438 10.441406 8.023438 9.632812 8.023438 C 9.632812 10.648438 9.632812 13.261719 9.632812 15.890625 Z M 9.632812 15.890625 ",
	fill: "currentColor"
};
function ru(e, t) {
	return A(), o("path", nu);
}
var iu = /*#__PURE__*/ W(tu, [["render", ru]]), au = {}, ou = {
	d: "M25 48.54C12.02 48.54 1.46 37.98 1.46 25S12.02 1.46 25 1.46 48.54 12.02 48.54 25 37.98 48.54 25 48.54zm0-45.53C12.88 3.01 3.01 12.88 3.01 25S12.88 46.99 25 46.99 46.99 37.12 46.99 25 37.12 3.01 25 3.01zm1.96 35.98h-5.49c-.43 0-.77-.35-.77-.78V25.79h-1.83c-.43 0-.77-.35-.77-.78v-4.67c0-.43.35-.78.77-.78h1.83v-2.24c0-2.91 1.65-6.31 6.31-6.31l4.07.02c.43 0 .77.35.77.78v4.53c0 .43-.35.78-.77.78h-2.95c-.25 0-.39.08-.39.5v1.97h3.41c.22 0 .43.09.58.26.15.16.22.38.2.6l-.48 4.67c-.04.4-.37.7-.77.7h-2.93v12.42c-.02.4-.37.75-.79.75zm-4.72-1.55h3.94V25.01c0-.43.35-.78.77-.78h3l.32-3.11h-3.32c-.43 0-.77-.35-.77-.78V17.6c0-1.41.97-2.05 1.94-2.05h2.18v-2.98l-3.3-.01c-4.3 0-4.76 3.33-4.76 4.76v3.02c0 .43-.35.78-.77.78h-1.83v3.12h1.83c.43 0 .77.35.77.78v12.42z",
	fill: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	"stroke-miterlimit": "10",
	"stroke-width": ".25"
};
function su(e, t) {
	return A(), o("path", ou);
}
var cu = /*#__PURE__*/ W(au, [["render", su]]), lu = {};
function uu(t, n) {
	return A(), o(e, null, [n[0] ||= s("g", { "clip-path": "url(#clip0_32686_39903)" }, [s("path", {
		d: "M28.6923 7.96066C27.7113 6.29863 25.541 5.73258 23.8489 6.70812L1.80244 19.2937C0.11033 20.2572 -0.465969 22.389 0.514964 24.051C1.17709 25.159 2.35421 25.7853 3.58038 25.7853C4.1812 25.7853 4.79429 25.6287 5.35832 25.3156L27.4048 12.7299C29.0969 11.7665 29.6732 9.63473 28.68 7.9727L28.6923 7.96066ZM23.8857 19.2215L12.8625 25.5203C11.1704 26.4838 10.5941 28.6155 11.575 30.2776C12.2371 31.3856 13.4142 32.0118 14.6404 32.0118C15.2412 32.0118 15.8543 31.8553 16.4183 31.5421L27.4416 25.2433C29.1337 24.2798 29.71 22.1481 28.7291 20.4861C27.7481 18.824 25.5778 18.258 23.8857 19.2215ZM3.5436 13.2478C4.14442 13.2478 4.7575 13.0913 5.32154 12.7781L16.3448 6.47929C18.0369 5.51579 18.6132 3.38407 17.6322 1.72204C16.6391 0.0720608 14.481 -0.493991 12.7889 0.469502L1.76565 6.76833C0.0735446 7.73183 -0.502754 9.86356 0.478179 11.5135C1.14031 12.6216 2.31743 13.2478 3.5436 13.2478ZM131.347 8.38218C130.525 7.57526 128.404 6.93695 127.031 6.93695C125.658 6.93695 124.664 7.16578 123.512 7.61139C122.359 8.05701 121.378 8.69532 120.569 9.50224C119.76 10.3092 119.122 11.2847 118.668 12.3927C118.215 13.5007 117.982 14.7292 117.982 16.066C117.982 17.3306 118.215 18.5109 118.693 19.6069C119.159 20.7028 119.809 21.6663 120.63 22.4974C121.452 23.3163 122.224 23.9667 123.377 24.4364C124.517 24.9061 125.363 25.147 127.129 25.147C129.557 25.147 131.359 23.6295 131.359 23.6295V24.7495H136.73V7.33439H131.359V8.38218H131.347ZM131.433 16.1142C131.433 18.812 129.618 20.5945 127.423 20.5945C125.228 20.5945 123.389 18.812 123.389 16.1142V16.054C123.389 13.3321 125.241 11.5738 127.423 11.5738C129.606 11.5738 131.433 13.3683 131.433 16.054V16.1142ZM183.054 6.91286C177.77 6.91286 173.821 10.7427 173.821 15.8372V15.8974C173.821 21.3652 177.855 25.1229 183.312 25.1229C186.598 25.1229 189.038 23.8583 190.742 21.7868L187.542 19.0047C186.439 20.3656 185.114 21.0642 183.385 21.0642C181.08 21.0642 179.449 19.8598 178.947 17.5715H191.601C191.638 17.1018 191.674 16.6441 191.674 16.2347C191.674 10.8511 188.106 6.91286 183.067 6.91286H183.054ZM178.873 14.404C179.204 12.3566 180.676 10.8511 182.809 10.8511C184.943 10.8511 186.328 12.2964 186.635 14.404H178.873ZM194.556 -0.000200971V24.7495H199.988V-0.000200971H194.556ZM63.3437 6.93695C62.2157 6.93695 61.1244 7.14169 60.0821 7.56322C59.0399 7.98474 58.1448 8.57488 57.4214 9.34568C57.2129 9.06867 56.9554 8.79167 56.6489 8.51467C56.3301 8.22562 55.9622 7.9727 55.5576 7.73183C55.1407 7.49095 54.6625 7.3103 54.0984 7.15373C53.5467 7.00921 52.9213 6.93695 52.2101 6.93695C51.0453 6.93695 50.0398 7.15373 49.1815 7.59935C48.3232 8.04496 47.6243 8.59897 47.0725 9.27342V7.34643H41.6774V24.7495H47.1093V15.4036C47.1093 14.2956 47.4281 13.3803 48.078 12.6577C48.7156 11.9471 49.5616 11.5858 50.5916 11.5858C51.5235 11.5858 52.2224 11.8748 52.6884 12.4409C53.1543 13.007 53.3873 13.8139 53.3873 14.8496V24.7495H58.6353V15.4036C58.6353 14.2956 58.9541 13.3803 59.5794 12.6577C60.2048 11.9471 61.0508 11.5858 62.1053 11.5858C63.0372 11.5858 63.7361 11.8748 64.2021 12.4409C64.668 13.007 64.901 13.8139 64.901 14.8496V24.7495H70.3451V13.9945C70.3451 11.8146 69.7443 10.1044 68.5549 8.83984C67.3656 7.5873 65.6244 6.94899 63.356 6.94899L63.3437 6.93695ZM151.517 7.0333C150.254 7.0333 149.224 7.3103 148.44 7.85226C147.643 8.39423 147.03 8.96028 146.576 9.56246V7.33439H141.181V24.7736H146.625V16.1624C146.625 14.7774 147.017 13.7055 147.814 12.9467C148.611 12.188 149.641 11.8146 150.929 11.8146C151.689 11.8146 152.339 11.8989 152.891 12.0796L153.761 7.37052C153.43 7.25008 153.099 7.15373 152.768 7.10556C152.425 7.05738 152.02 7.0333 151.542 7.0333H151.517ZM161.78 12.8383C162.136 12.4289 162.565 12.0916 163.08 11.8387C163.583 11.5858 164.159 11.4533 164.809 11.4533C165.741 11.4533 166.501 11.6219 167.065 11.9592C167.629 12.2964 168.107 12.6818 168.5 13.1274L171.725 9.70699C170.94 8.86393 169.959 8.17744 168.794 7.67161C167.641 7.16578 166.268 6.91286 164.686 6.91286C163.325 6.91286 162.075 7.15373 160.934 7.62343C159.782 8.09314 158.801 8.74349 157.967 9.56246C157.145 10.3935 156.496 11.357 156.03 12.4529C155.564 13.561 155.318 14.7412 155.318 15.9938C155.318 17.3306 155.551 18.547 156.005 19.6671C156.459 20.7872 157.096 21.7506 157.906 22.5576C158.715 23.3765 159.696 24.0028 160.848 24.4484C161.989 24.894 163.276 25.1229 164.674 25.1229C166.28 25.1229 167.666 24.8459 168.843 24.2798C170.008 23.7258 170.952 23.0514 171.676 22.2806L168.561 18.8602C168.193 19.2697 167.69 19.6551 167.077 20.0043C166.452 20.3536 165.692 20.5342 164.784 20.5342C164.135 20.5342 163.571 20.4018 163.056 20.1368C162.553 19.8718 162.111 19.5226 161.756 19.101C161.4 18.6795 161.131 18.1978 160.947 17.6438C160.763 17.1018 160.665 16.5478 160.665 15.9938C160.665 15.3916 160.75 14.8135 160.947 14.2715C161.131 13.7296 161.4 13.2478 161.756 12.8383H161.78ZM112.243 9.58655C111.422 8.76758 110.649 8.11722 109.497 7.64752C108.356 7.17782 107.51 6.93695 105.745 6.93695C103.317 6.93695 101.514 8.45445 101.514 8.45445V7.33439H96.1437V31.9998H101.514C101.514 31.9998 101.514 23.7138 101.514 23.7258C102.336 24.5327 104.457 25.171 105.83 25.171C107.204 25.171 108.197 24.9422 109.35 24.4966C110.502 24.051 111.483 23.4127 112.292 22.6057C113.102 21.7988 113.739 20.8353 114.193 19.7153C114.647 18.6073 114.88 17.3788 114.88 16.042C114.88 14.7774 114.647 13.5971 114.168 12.5011C113.702 11.4051 113.053 10.4296 112.231 9.61064L112.243 9.58655ZM109.497 16.042C109.497 18.7638 107.645 20.5222 105.463 20.5222C103.28 20.5222 101.453 18.7277 101.453 16.042V15.9817C101.453 13.284 103.268 11.5015 105.463 11.5015C107.657 11.5015 109.497 13.284 109.497 15.9817V16.042ZM82.7294 18.9806L78.0087 7.34643H72.1599L79.7008 24.7495L76.5496 31.9998H82.3371L93.3112 7.35847H87.7812L82.7294 18.9926V18.9806Z",
		fill: "#0F5C47"
	})], -1), n[1] ||= s("defs", null, [s("clipPath", { id: "clip0_32686_39903" }, [s("rect", {
		fill: "white",
		height: "32",
		width: "200"
	})])], -1)], 64);
}
var du = /*#__PURE__*/ W(lu, [["render", uu]]), fu = {}, pu = { transform: "translate(-135.827 -151.567)" };
function mu(e, t) {
	return A(), o("g", pu, [...t[0] ||= [s("g", { transform: "translate(135.827 151.567)" }, [
		s("g", { transform: "translate(0.032 5.52)" }, [s("path", {
			d: "M139.081,198.386a3.08,3.08,0,0,1-1.551-5.743l19.183-11.149a3.08,3.08,0,1,1,3.1,5.326l-19.183,11.149A3.07,3.07,0,0,1,139.081,198.386Z",
			fill: "#FFFFFF",
			transform: "translate(-135.997 -181.077)"
		})]),
		s("g", { transform: "translate(9.656 16.614)" }, [s("path", {
			d: "M190.531,252.122a3.08,3.08,0,0,1-1.551-5.743l9.592-5.574a3.08,3.08,0,0,1,3.1,5.326l-9.592,5.574A3.075,3.075,0,0,1,190.531,252.122Z",
			fill: "#FFFFFF",
			transform: "translate(-187.447 -240.387)"
		})]),
		s("g", { transform: "translate(0 0)" }, [s("path", {
			d: "M138.911,163.3a3.08,3.08,0,0,1-1.551-5.743l9.592-5.574a3.08,3.08,0,0,1,3.1,5.326l-9.592,5.574A3.07,3.07,0,0,1,138.911,163.3Z",
			fill: "#FFFFFF",
			transform: "translate(-135.827 -151.567)"
		})])
	], -1), s("g", { transform: "translate(172.082 151.577)" }, [
		s("path", {
			d: "M959.768,192.552c0-4.764-3.105-8.262-7.484-8.262a7.782,7.782,0,0,0-8.034,7.909v.056a8.352,8.352,0,0,0,14.721,5.223l-2.785-2.467a4.375,4.375,0,0,1-3.62,1.82,3.671,3.671,0,0,1-3.865-3.1h11C959.738,193.319,959.768,192.908,959.768,192.552Zm-11.124-1.624a3.45,3.45,0,0,1,3.423-3.144,3.3,3.3,0,0,1,3.333,3.144Z",
			fill: "#FFFFFF",
			transform: "translate(-829.282 -178.179)"
		}),
		s("rect", {
			fill: "#FFFFFF",
			height: "21.919",
			transform: "translate(133.015)",
			width: "4.731"
		}),
		s("path", {
			d: "M353.013,186.1a6.445,6.445,0,0,1,1.562,4.568V200.2h-4.733V191.43a3.35,3.35,0,0,0-.606-2.136,2.2,2.2,0,0,0-1.824-.754,2.754,2.754,0,0,0-2.2.952,3.59,3.59,0,0,0-.823,2.43V200.2h-4.568V191.43a3.338,3.338,0,0,0-.606-2.136,2.2,2.2,0,0,0-1.824-.754,2.776,2.776,0,0,0-2.185.952,3.545,3.545,0,0,0-.84,2.43V200.2H329.64v-15.41h4.7l0,1.71a5.909,5.909,0,0,1,1.839-1.48,5.52,5.52,0,0,1,2.632-.591,6.361,6.361,0,0,1,1.642.195,5.522,5.522,0,0,1,1.265.511,5.335,5.335,0,0,1,.954.69,5.168,5.168,0,0,1,.673.737,6.5,6.5,0,0,1,2.316-1.575,7.389,7.389,0,0,1,2.84-.559A5.877,5.877,0,0,1,353.013,186.1Z",
			fill: "#FFFFFF",
			transform: "translate(-329.64 -178.293)"
		}),
		s("path", {
			d: "M802.459,184.929a3.956,3.956,0,0,1,.87.23l-.754,4.173a5.587,5.587,0,0,0-1.708-.232,3.733,3.733,0,0,0-2.709,1,3.771,3.771,0,0,0-1.038,2.841v7.623H792.39V185.118h4.7V187.1a7.108,7.108,0,0,1,1.625-1.511,4.587,4.587,0,0,1,2.679-.724A7.763,7.763,0,0,1,802.459,184.929Z",
			fill: "#FFFFFF",
			transform: "translate(-705.829 -178.642)"
		}),
		s("path", {
			d: "M863.13,190.815a4.755,4.755,0,0,0-.241,1.528,4.545,4.545,0,0,0,.241,1.465,4.043,4.043,0,0,0,.707,1.291,3.72,3.72,0,0,0,1.128.917,3.123,3.123,0,0,0,1.5.354,3.937,3.937,0,0,0,2-.466,5.307,5.307,0,0,0,1.289-1.014l2.7,3.027a7.977,7.977,0,0,1-2.464,1.771,8.246,8.246,0,0,1-3.627.743,8.9,8.9,0,0,1-3.33-.6,7.3,7.3,0,0,1-2.563-1.674,7.668,7.668,0,0,1-1.657-2.561,8.605,8.605,0,0,1-.6-3.253,8.077,8.077,0,0,1,.614-3.141,7.99,7.99,0,0,1,1.689-2.561,7.841,7.841,0,0,1,2.579-1.723,8.352,8.352,0,0,1,3.266-.629,8.7,8.7,0,0,1,3.575.677,7.588,7.588,0,0,1,2.548,1.8l-2.806,3.03a5.389,5.389,0,0,0-1.253-1.033,3.786,3.786,0,0,0-1.966-.451,3.234,3.234,0,0,0-1.5.339,3.675,3.675,0,0,0-1.128.887A3.855,3.855,0,0,0,863.13,190.815Z",
			fill: "#FFFFFF",
			transform: "translate(-759.345 -178.179)"
		}),
		s("path", {
			d: "M598.738,189.34a7.99,7.99,0,0,0-1.689-2.561,7.014,7.014,0,0,0-2.385-1.721,7.211,7.211,0,0,0-3.264-.629,6.227,6.227,0,0,0-3.683,1.343v-1H583.05v21.846h4.667s0-7.335.006-7.335a6.429,6.429,0,0,0,3.754,1.278,7.514,7.514,0,0,0,3.057-.6A7.325,7.325,0,0,0,597.1,198.3a7.668,7.668,0,0,0,1.657-2.561,8.607,8.607,0,0,0,.6-3.253A8.08,8.08,0,0,0,598.738,189.34Zm-4.085,3.148a3.651,3.651,0,0,1-3.513,3.969c-1.9,0-3.487-1.584-3.487-3.969v-.056c0-2.389,1.583-3.969,3.487-3.969a3.665,3.665,0,0,1,3.513,3.969Z",
			fill: "#FFFFFF",
			transform: "translate(-535.648 -178.293)"
		}),
		s("path", {
			d: "M696.215,184.75s-.006.939-.006.937a6.429,6.429,0,0,0-3.754-1.278,7.552,7.552,0,0,0-3.057.6,7.325,7.325,0,0,0-2.565,1.674,7.668,7.668,0,0,0-1.657,2.561,8.605,8.605,0,0,0-.6,3.253,8.092,8.092,0,0,0,2.3,5.7,7.053,7.053,0,0,0,2.387,1.723,7.211,7.211,0,0,0,3.264.629,6.246,6.246,0,0,0,3.683-1.341v.993h4.667V184.76Zm.062,7.793c0,2.389-1.583,3.969-3.487,3.969a3.665,3.665,0,0,1-3.513-3.969v-.056a3.65,3.65,0,0,1,3.513-3.969c1.9,0,3.487,1.582,3.487,3.969Z",
			fill: "#FFFFFF",
			transform: "translate(-618.186 -178.276)"
		}),
		s("path", {
			d: "M485.035,186.36h4.807L480.3,208.192h-5.037L478,201.77l-6.564-15.41h5.092l4.106,10.307Z",
			fill: "#FFFFFF",
			transform: "translate(-444.915 -179.862)"
		}),
		s("path", {
			d: "M959.768,192.552c0-4.764-3.105-8.262-7.484-8.262a7.782,7.782,0,0,0-8.034,7.909v.056a8.352,8.352,0,0,0,14.721,5.223l-2.785-2.467a4.375,4.375,0,0,1-3.62,1.82,3.671,3.671,0,0,1-3.865-3.1h11C959.738,193.319,959.768,192.908,959.768,192.552Zm-11.124-1.624a3.45,3.45,0,0,1,3.423-3.144,3.3,3.3,0,0,1,3.333,3.144Z",
			fill: "#FFFFFF",
			transform: "translate(-829.282 -178.179)"
		}),
		s("rect", {
			fill: "#FFFFFF",
			height: "21.919",
			transform: "translate(133.015)",
			width: "4.731"
		}),
		s("path", {
			d: "M353.013,186.1a6.445,6.445,0,0,1,1.562,4.568V200.2h-4.733V191.43a3.35,3.35,0,0,0-.606-2.136,2.2,2.2,0,0,0-1.824-.754,2.754,2.754,0,0,0-2.2.952,3.59,3.59,0,0,0-.823,2.43V200.2h-4.568V191.43a3.338,3.338,0,0,0-.606-2.136,2.2,2.2,0,0,0-1.824-.754,2.776,2.776,0,0,0-2.185.952,3.545,3.545,0,0,0-.84,2.43V200.2H329.64v-15.41h4.7l0,1.71a5.909,5.909,0,0,1,1.839-1.48,5.52,5.52,0,0,1,2.632-.591,6.361,6.361,0,0,1,1.642.195,5.522,5.522,0,0,1,1.265.511,5.335,5.335,0,0,1,.954.69,5.168,5.168,0,0,1,.673.737,6.5,6.5,0,0,1,2.316-1.575,7.389,7.389,0,0,1,2.84-.559A5.877,5.877,0,0,1,353.013,186.1Z",
			fill: "#FFFFFF",
			transform: "translate(-329.64 -178.293)"
		}),
		s("path", {
			d: "M802.459,184.929a3.956,3.956,0,0,1,.87.23l-.754,4.173a5.587,5.587,0,0,0-1.708-.232,3.733,3.733,0,0,0-2.709,1,3.771,3.771,0,0,0-1.038,2.841v7.623H792.39V185.118h4.7V187.1a7.108,7.108,0,0,1,1.625-1.511,4.587,4.587,0,0,1,2.679-.724A7.763,7.763,0,0,1,802.459,184.929Z",
			fill: "#FFFFFF",
			transform: "translate(-705.829 -178.642)"
		}),
		s("path", {
			d: "M863.13,190.815a4.755,4.755,0,0,0-.241,1.528,4.545,4.545,0,0,0,.241,1.465,4.043,4.043,0,0,0,.707,1.291,3.72,3.72,0,0,0,1.128.917,3.123,3.123,0,0,0,1.5.354,3.937,3.937,0,0,0,2-.466,5.307,5.307,0,0,0,1.289-1.014l2.7,3.027a7.977,7.977,0,0,1-2.464,1.771,8.246,8.246,0,0,1-3.627.743,8.9,8.9,0,0,1-3.33-.6,7.3,7.3,0,0,1-2.563-1.674,7.668,7.668,0,0,1-1.657-2.561,8.605,8.605,0,0,1-.6-3.253,8.077,8.077,0,0,1,.614-3.141,7.99,7.99,0,0,1,1.689-2.561,7.841,7.841,0,0,1,2.579-1.723,8.352,8.352,0,0,1,3.266-.629,8.7,8.7,0,0,1,3.575.677,7.588,7.588,0,0,1,2.548,1.8l-2.806,3.03a5.389,5.389,0,0,0-1.253-1.033,3.786,3.786,0,0,0-1.966-.451,3.234,3.234,0,0,0-1.5.339,3.675,3.675,0,0,0-1.128.887A3.855,3.855,0,0,0,863.13,190.815Z",
			fill: "#FFFFFF",
			transform: "translate(-759.345 -178.179)"
		}),
		s("path", {
			d: "M598.738,189.34a7.99,7.99,0,0,0-1.689-2.561,7.014,7.014,0,0,0-2.385-1.721,7.211,7.211,0,0,0-3.264-.629,6.227,6.227,0,0,0-3.683,1.343v-1H583.05v21.846h4.667s0-7.335.006-7.335a6.429,6.429,0,0,0,3.754,1.278,7.514,7.514,0,0,0,3.057-.6A7.325,7.325,0,0,0,597.1,198.3a7.668,7.668,0,0,0,1.657-2.561,8.607,8.607,0,0,0,.6-3.253A8.08,8.08,0,0,0,598.738,189.34Zm-4.085,3.148a3.651,3.651,0,0,1-3.513,3.969c-1.9,0-3.487-1.584-3.487-3.969v-.056c0-2.389,1.583-3.969,3.487-3.969a3.665,3.665,0,0,1,3.513,3.969Z",
			fill: "#FFFFFF",
			transform: "translate(-535.648 -178.293)"
		}),
		s("path", {
			d: "M485.035,186.36h4.807L480.3,208.192h-5.037L478,201.77l-6.564-15.41h5.092l4.106,10.307Z",
			fill: "#FFFFFF",
			transform: "translate(-444.915 -179.862)"
		})
	], -1)]]);
}
var hu = /*#__PURE__*/ W(fu, [["render", mu]]), gu = {};
function _u(t, n) {
	return A(), o(e, null, [
		n[0] ||= s("path", {
			d: "M3.17621 23.4525C2.09698 23.4525 1.04186 22.8875 0.45703 21.879C-0.417207 20.3663 0.0952765 18.4344 1.59655 17.5535L21.1553 6.09548C22.6566 5.21457 24.5799 5.73097 25.4481 7.24371C26.3224 8.75645 25.8099 10.6884 24.3086 11.5693L4.74983 23.0273C4.25544 23.3128 3.71281 23.4525 3.17621 23.4525Z",
			fill: "#0F5C47"
		}, null, -1),
		n[1] ||= s("path", {
			d: "M12.9916 29.1269C11.9124 29.1269 10.8573 28.5619 10.2725 27.5534C9.39822 26.0407 9.91071 24.1088 11.412 23.2278L21.1914 17.4988C22.6927 16.624 24.616 17.1343 25.4842 18.6471C26.3584 20.1598 25.8459 22.0918 24.3447 22.9727L14.5653 28.7017C14.0709 28.9872 13.5282 29.1269 12.9916 29.1269Z",
			fill: "#0F5C47"
		}, null, -1),
		n[2] ||= s("path", {
			d: "M3.14594 12.0554C2.0667 12.0554 1.01159 11.4904 0.426756 10.4819C-0.447481 8.96915 0.0650039 7.03114 1.56628 6.1563L11.3457 0.427316C12.847 -0.447523 14.7703 0.0628004 15.6385 1.57554C16.5127 3.08829 16.0002 5.0263 14.499 5.90114L4.71956 11.624C4.22517 11.9157 3.68254 12.0554 3.14594 12.0554Z",
			fill: "#0F5C47"
		}, null, -1),
		n[3] ||= s("path", {
			d: "M116.532 6.66056L116.525 7.62653C115.802 6.89142 113.915 6.31427 112.697 6.31427C111.455 6.31427 110.599 6.52083 109.58 6.92787C108.561 7.33492 107.687 7.90599 106.963 8.64718C106.24 9.38836 105.673 10.2632 105.275 11.2778C104.871 12.2923 104.666 13.4041 104.666 14.6192C104.666 15.7674 104.877 16.8427 105.293 17.8451C105.703 18.8476 106.282 19.7224 107.011 20.4757C107.747 21.223 108.422 21.8123 109.447 22.2436C110.46 22.675 111.214 22.8876 112.775 22.8876C114.934 22.8876 116.525 21.5085 116.532 21.5085V22.5292H121.289V6.66664L116.532 6.66056ZM116.598 14.6678C116.598 17.1222 114.982 18.7443 113.041 18.7443C111.099 18.7443 109.459 17.1222 109.459 14.6678V14.6131C109.459 12.1344 111.099 10.5366 113.041 10.5366C114.982 10.5366 116.598 12.1648 116.598 14.6131V14.6678Z",
			fill: "#0F5C47"
		}, null, -1),
		n[4] ||= s("path", {
			d: "M170.016 14.7771C170.016 9.8804 166.851 6.28992 162.383 6.28992C157.692 6.28992 154.189 9.77713 154.189 14.4186V14.4794C154.189 19.449 157.771 22.8754 162.612 22.8754C165.53 22.8754 167.695 21.7272 169.202 19.8439L166.362 17.3105C165.386 18.5559 164.204 19.1816 162.673 19.1816C160.629 19.1816 159.188 18.0881 158.735 15.9982H169.956C169.986 15.5669 170.016 15.1416 170.016 14.7771ZM158.675 13.1064C158.965 11.2413 160.273 9.87433 162.166 9.87433C164.089 9.87433 165.289 11.1866 165.567 13.1064H158.675Z",
			fill: "#0F5C47"
		}, null, -1),
		n[5] ||= s("path", {
			d: "M200 8.10036C200 5.48192 198.306 3.56213 195.924 3.56213C193.416 3.56213 191.547 5.42724 191.547 7.90595V7.93633C191.547 10.5912 193.458 12.426 196.045 12.426C197.606 12.426 198.758 11.8124 199.566 10.8039L198.046 9.44907C197.528 10.1113 196.895 10.4454 196.075 10.4454C194.984 10.4454 194.212 9.86219 193.971 8.74434H199.964C199.988 8.52563 200 8.29477 200 8.10036ZM193.94 7.2073C194.097 6.21095 194.791 5.48192 195.804 5.48192C196.835 5.48192 197.474 6.18665 197.618 7.2073H193.94Z",
			fill: "#0F5C47"
		}, null, -1),
		n[6] ||= s("path", {
			d: "M177.42 0.00817871H172.597V22.5292H177.42V0.00817871Z",
			fill: "#0F5C47"
		}, null, -1),
		n[7] ||= s("path", {
			d: "M60.7964 8.03357C61.8575 9.1818 62.3881 10.7492 62.3881 12.7237V22.517H57.5647V13.5013C57.5647 12.5536 57.3597 11.8245 56.9437 11.3081C56.5337 10.7917 55.9127 10.5305 55.0807 10.5305C54.1462 10.5305 53.3925 10.8586 52.8378 11.5086C52.2771 12.1648 51.9998 12.9971 51.9998 14.0056V22.517H47.3452V13.5013C47.3452 12.5536 47.1402 11.8245 46.7242 11.3081C46.3142 10.7917 45.6932 10.5305 44.8672 10.5305C43.9508 10.5305 43.2092 10.8586 42.6424 11.5086C42.0757 12.1648 41.7863 12.9971 41.7863 14.0056V22.517H36.9629V6.68486H41.7501V8.44062C42.2385 7.83309 42.8655 7.32277 43.6252 6.9218C44.3849 6.51475 45.2772 6.31427 46.3082 6.31427C46.9352 6.31427 47.4899 6.3811 47.9843 6.51476C48.4727 6.65449 48.9068 6.82459 49.2746 7.03723C49.6423 7.24986 49.9679 7.4868 50.2453 7.74804C50.5226 8.0032 50.7517 8.25836 50.9326 8.50744C51.5777 7.81486 52.3675 7.26809 53.296 6.89142C54.2245 6.50868 55.1892 6.31427 56.1901 6.31427C58.2038 6.31427 59.7413 6.88535 60.7964 8.03357Z",
			fill: "#0F5C47"
		}, null, -1),
		n[8] ||= s("path", {
			d: "M135.499 6.46609C135.801 6.50862 136.096 6.5876 136.386 6.70303L135.614 10.9922C135.125 10.8342 134.541 10.7552 133.871 10.7552C132.732 10.7552 131.815 11.1015 131.11 11.788C130.405 12.4745 130.055 13.4466 130.055 14.7102V22.5413H125.231V6.6605H130.025V8.69572C130.429 8.15502 130.977 7.63862 131.683 7.14045C132.388 6.64835 133.299 6.39319 134.414 6.39319C134.836 6.39926 135.198 6.42356 135.499 6.46609Z",
			fill: "#0F5C47"
		}, null, -1),
		n[9] ||= s("path", {
			d: "M142.794 12.9909C142.632 13.4891 142.547 14.0116 142.547 14.5584C142.547 15.0687 142.625 15.5669 142.794 16.065C142.957 16.5632 143.198 17.0067 143.518 17.3894C143.831 17.7722 144.217 18.0881 144.669 18.3311C145.116 18.5741 145.628 18.6956 146.201 18.6956C147.009 18.6956 147.684 18.5377 148.239 18.2157C148.781 17.8937 149.221 17.5474 149.553 17.1707L152.314 20.2813C151.681 20.986 150.837 21.5935 149.8 22.1039C148.757 22.6081 147.527 22.8633 146.098 22.8633C144.85 22.8633 143.717 22.6567 142.704 22.2497C141.685 21.8426 140.811 21.2715 140.087 20.5304C139.364 19.7953 138.797 18.9143 138.399 17.8998C137.995 16.8852 137.79 15.7734 137.79 14.5584C137.79 13.4101 138.001 12.3348 138.417 11.3324C138.827 10.33 139.406 9.45514 140.141 8.7018C140.871 7.95454 141.751 7.36524 142.77 6.9339C143.783 6.50255 144.898 6.28992 146.098 6.28992C147.497 6.28992 148.715 6.52078 149.746 6.9825C150.777 7.44422 151.645 8.0639 152.345 8.83546L149.487 11.9521C149.137 11.5511 148.709 11.1987 148.209 10.8889C147.702 10.5791 147.033 10.4272 146.207 10.4272C145.634 10.4272 145.128 10.5426 144.675 10.7735C144.229 11.0043 143.843 11.3081 143.524 11.6848C143.198 12.0614 142.957 12.4928 142.794 12.9909Z",
			fill: "#0F5C47"
		}, null, -1),
		n[10] ||= s("path", {
			d: "M101.301 11.3567C100.891 10.3543 100.312 9.47949 99.5768 8.72615C98.8473 7.9789 98.166 7.38959 97.1471 6.95825C96.1341 6.52691 95.3805 6.31427 93.8189 6.31427C91.6605 6.31427 90.0687 7.68728 90.0627 7.69336V6.67271H85.3057V29.1148H90.0627C90.0627 29.1148 90.0687 21.5754 90.0687 21.5814C90.7923 22.3165 92.6794 22.8937 93.8973 22.8937C95.1454 22.8937 96.0015 22.6871 97.0144 22.2801C98.0333 21.873 98.9076 21.302 99.6311 20.5608C100.355 19.8196 100.921 18.9448 101.319 17.9302C101.723 16.9156 101.928 15.8038 101.928 14.5888C101.922 13.4345 101.717 12.3652 101.301 11.3567ZM97.135 14.5949C97.135 17.0736 95.495 18.6714 93.5536 18.6714C91.6122 18.6714 89.9964 17.0432 89.9964 14.5949V14.5341C89.9964 12.0797 91.6122 10.4576 93.5536 10.4576C95.495 10.4576 97.135 12.0797 97.135 14.5341V14.5949Z",
			fill: "#0F5C47"
		}, null, -1),
		n[11] ||= s("path", {
			d: "M190.244 7.98496C190.244 7.33491 190.135 6.73953 189.918 6.19883C189.701 5.65814 189.399 5.18426 189.014 4.79545C188.628 4.40055 188.163 4.09071 187.615 3.87808C187.072 3.65937 186.614 3.55001 185.951 3.55001C185.3 3.55001 184.293 3.85985 183.907 4.24867L183.901 0.220764H181.356V12.2134H183.901V11.6666C183.907 11.6666 184.757 12.4017 185.908 12.4017C186.741 12.4017 187.144 12.2863 187.687 12.0554C188.23 11.8245 188.598 11.5086 188.989 11.1077C189.381 10.7067 189.689 10.2389 189.912 9.70427C190.129 9.16964 190.244 8.59857 190.244 7.98496ZM187.681 8.00927C187.681 9.32153 186.807 10.1903 185.77 10.1903C184.733 10.1903 183.871 9.32153 183.871 8.00927V7.97889C183.871 6.66663 184.733 5.79787 185.77 5.79787C186.807 5.79787 187.681 6.65448 187.681 7.97889V8.00927Z",
			fill: "#0F5C47"
		}, null, -1),
		n[12] ||= s("path", {
			d: "M77.8778 6.68488H82.7795L73.0423 29.1148H67.9054L70.709 22.517L64.0166 6.68488H69.2017L73.392 17.2741L77.8778 6.68488Z",
			fill: "#0F5C47"
		}, null, -1)
	], 64);
}
var vu = /*#__PURE__*/ W(gu, [["render", _u]]), yu = {}, bu = {
	d: "M3.357 10.43c-1.182-2.408-1.304-5.483.593-7.38v0c.42-.42 1.063-.619 1.686-.705 1.126-.155 2.076.68 2.436 1.757l.698 2.095a3 3 0 0 1-.405 2.693l-.32.447c-.353.495-.464 1.127-.226 1.688.38.897 1.11 2.309 2.318 3.516 1.086 1.085 2.336 1.785 3.23 2.192.7.318 1.494.053 1.955-.562v0a2.782 2.782 0 0 1 3.403-.852l1.525.712c1.056.493 1.786 1.58 1.42 2.686-.158.474-.394.949-.75 1.304v0c-1.911 1.911-4.996 1.929-7.44.774a20.177 20.177 0 0 1-5.641-3.956c-2.075-2.075-3.526-4.461-4.482-6.41Z",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round"
};
function xu(e, t) {
	return A(), o("path", bu);
}
var Su = /*#__PURE__*/ W(yu, [["render", xu]]), Cu = {}, wu = {
	"clip-rule": "evenodd",
	d: "M8.43 6.63c-.507.508-1.036 1.218-1.546 2.013-1.803 2.81-1.96 6.35-.615 9.461 1.793 4.148 4.957 10.061 9.94 15.044 5.038 5.039 10.549 7.737 14.281 9.113 2.684.989 5.646.695 8.112-.773 1.059-.63 2.05-1.318 2.709-1.976.602-.603 1.02-1.43 1.307-2.29l-10.862-5.111-1.217 1.623c-.68.906-1.882 1.331-2.998.89-1.778-.703-5.037-2.252-7.797-5.012-2.98-2.98-4.549-6.542-5.166-8.197-.309-.827-.141-1.715.343-2.393l.503-.704-4.283-12.85a9.764 9.764 0 0 0-.59.117c-.872.206-1.618.543-2.121 1.046Zm24.264 24.265 10.301 4.847c.018-.096.035-.19.05-.284.123-.76-.322-1.53-1.131-1.908l-6.669-3.112a2.25 2.25 0 0 0-2.551.457ZM18.229 16.972l-1.14 1.596.007.023-.032.01-.922 1.293c-.225.314-.276.683-.159.997.584 1.563 2.06 4.898 4.821 7.66 2.557 2.557 5.606 4.012 7.288 4.678.426.169.932.025 1.247-.395l1.955-2.607a3.75 3.75 0 0 1 4.586-1.149l6.668 3.112c1.303.608 2.228 1.968 1.977 3.509-.233 1.436-.785 3.504-2.154 4.873-.791.792-1.91 1.554-3.002 2.204-2.846 1.695-6.28 2.04-9.398.892-3.871-1.427-9.589-4.225-14.823-9.46C9.982 29.043 6.726 22.943 4.892 18.7c-1.523-3.523-1.37-7.595.73-10.867.535-.834 1.13-1.645 1.747-2.262.778-.778 1.828-1.206 2.838-1.444 1.02-.24 2.068-.304 2.917-.303 1.51.003 2.7 1.053 3.144 2.385l2.467 7.399a3.75 3.75 0 0 1-.506 3.365ZM12.676 5.329l3.826 11.48.506-.709a2.25 2.25 0 0 0 .304-2.02l-2.467-7.397c-.274-.824-.961-1.358-1.724-1.36-.144 0-.293.002-.445.006Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function Tu(e, t) {
	return A(), o("path", wu);
}
var Eu = /*#__PURE__*/ W(Cu, [["render", Tu]]), Du = {}, Ou = { fill: "none" };
function ku(e, t) {
	return A(), o("g", Ou, [...t[0] ||= [
		s("path", {
			d: "M9.5 6.5H21.5",
			stroke: "black",
			"stroke-linecap": "round",
			"stroke-linejoin": "round",
			"stroke-opacity": "0.6"
		}, null, -1),
		s("path", {
			d: "M9.5 11.5H21.5",
			stroke: "black",
			"stroke-linecap": "round",
			"stroke-linejoin": "round",
			"stroke-opacity": "0.6"
		}, null, -1),
		s("path", {
			d: "M9.5 16.5H21.5",
			stroke: "black",
			"stroke-linecap": "round",
			"stroke-linejoin": "round",
			"stroke-opacity": "0.6"
		}, null, -1),
		s("path", {
			d: "M6.5 7.5L2.5 11.5L6.5 15.5",
			stroke: "black",
			"stroke-linecap": "round",
			"stroke-linejoin": "round",
			"stroke-opacity": "0.6"
		}, null, -1)
	]]);
}
var Au = /*#__PURE__*/ W(Du, [["render", ku]]), ju = {}, Mu = { fill: "none" };
function Nu(e, t) {
	return A(), o("g", Mu, [...t[0] ||= [
		s("path", {
			d: "M2.5 6.5H14.5",
			stroke: "black",
			"stroke-linecap": "round",
			"stroke-linejoin": "round",
			"stroke-opacity": "0.6"
		}, null, -1),
		s("path", {
			d: "M2.5 11.5H14.5",
			stroke: "black",
			"stroke-linecap": "round",
			"stroke-linejoin": "round",
			"stroke-opacity": "0.6"
		}, null, -1),
		s("path", {
			d: "M2.5 16.5H14.5",
			stroke: "black",
			"stroke-linecap": "round",
			"stroke-linejoin": "round",
			"stroke-opacity": "0.6"
		}, null, -1),
		s("path", {
			d: "M17.5 7.5L21.5 11.5L17.5 15.5",
			stroke: "black",
			"stroke-linecap": "round",
			"stroke-linejoin": "round",
			"stroke-opacity": "0.6"
		}, null, -1)
	]]);
}
var Pu = /*#__PURE__*/ W(ju, [["render", Nu]]), Fu = {}, Iu = {
	d: "M7.102 1.56a5.149 5.149 0 0 1 1.817.045 1 1 0 0 0-1.817-.046Zm2.897.396a2 2 0 0 0-3.994-.1 5.13 5.13 0 0 0-3.172 3.882l-.628 3.556a5.644 5.644 0 0 1-.718 1.923l-.219.364A1.267 1.267 0 0 0 2.355 13.5H5.04a3 3 0 0 0 5.917 0h2.768c.933 0 1.451-1.079.869-1.807l-.236-.294A4.918 4.918 0 0 1 13.315 8.9l-.338-2.871A5.129 5.129 0 0 0 10 1.956ZM8 15a2 2 0 0 1-1.936-1.5h3.874A2 2 0 0 1 8 15ZM7.885 2.5a4.13 4.13 0 0 1 4.1 3.647l.338 2.871c.13 1.1.565 2.14 1.256 3.005l.236.295a.112.112 0 0 1-.088.182H2.355a.267.267 0 0 1-.23-.405l.22-.364a6.643 6.643 0 0 0 .845-2.263l.627-3.557A4.129 4.129 0 0 1 7.884 2.5Z",
	fill: "currentColor"
};
function Lu(e, t) {
	return A(), o("path", Iu);
}
var Ru = /*#__PURE__*/ W(Fu, [["render", Lu]]), zu = {}, Bu = {
	"clip-rule": "evenodd",
	d: "M10.2859 2.64435C10.8067 2.5497 11.3764 2.5 11.9998 2.5C12.6231 2.5 13.1928 2.5497 13.7136 2.64435C13.5493 1.84838 12.8444 1.25 11.9998 1.25C11.1551 1.25 10.4502 1.84838 10.2859 2.64435ZM14.7484 2.91147C14.7016 1.43366 13.4889 0.25 11.9998 0.25C10.5106 0.25 9.29789 1.43366 9.25115 2.91148C8.59844 3.13578 8.04013 3.44611 7.56236 3.82831C6.52269 4.66002 5.91768 5.78975 5.52528 6.96688C5.16376 8.05138 4.9711 9.21518 4.7974 10.2644L4.7564 10.5116C4.56579 11.6554 4.38738 12.6065 4.05252 13.2764C3.20296 14.976 2.35315 16.6755 1.77605 17.8296C1.27708 18.8274 2.00334 20 3.11797 20H7.77886C8.02632 22.1116 9.8217 23.75 11.9998 23.75C14.1778 23.75 15.9732 22.1116 16.2207 20H20.8819C21.9964 20 22.7227 18.8277 22.2239 17.8299L19.9473 13.2764C19.6124 12.6065 19.4339 11.6553 19.2433 10.5115L19.2022 10.2641C19.0285 9.21492 18.8358 8.05125 18.4743 6.96687C18.0819 5.78975 17.4768 4.66002 16.4372 3.82831C15.9594 3.44611 15.4011 3.13578 14.7484 2.91147ZM5.7428 10.6759C5.55845 11.7821 5.36195 12.8935 4.94699 13.7236C4.0974 15.4232 3.24757 17.1228 2.67046 18.2769C2.50443 18.6089 2.74574 19 3.11797 19H20.8819C21.2541 19 21.4954 18.609 21.3294 18.277L19.0529 13.7236C18.6379 12.8935 18.4413 11.7822 18.2569 10.676L18.2181 10.4424C18.0415 9.37754 17.8609 8.28904 17.5256 7.28313C17.1679 6.21025 16.6479 5.27748 15.8125 4.60919C14.9827 3.94536 13.7883 3.5 11.9998 3.5C10.2112 3.5 9.01686 3.94536 8.18705 4.60919C7.35166 5.27748 6.8316 6.21025 6.47396 7.28312C6.1386 8.28912 5.95811 9.37773 5.78154 10.4427L5.7428 10.6759ZM11.9998 22.75C10.3749 22.75 9.02848 21.5575 8.78798 20H15.2115C14.971 21.5575 13.6246 22.75 11.9998 22.75Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function Vu(e, t) {
	return A(), o("path", Bu);
}
var Hu = /*#__PURE__*/ W(zu, [["render", Vu]]), Uu = {}, Wu = {
	d: "M0 7C0 6.44772 0.447715 6 1 6H17.0858C17.4836 6 17.8651 6.15804 18.1464 6.43934L24 12.2929V16C24 16.5523 23.5523 17 23 17L19.2929 17.0001L15.2929 13H11V16C11 16.5523 10.5523 17 9.99999 17L6.29289 17L0.43934 11.1464C0.158035 10.8651 0 10.4836 0 10.0858V7ZM10.7071 12H13.7929L8.79289 7H5.7071L10.7071 12ZM15.2071 12H18.2929L13.2929 7H10.2071L15.2071 12ZM14.7071 7L19.7071 12H22.2929L17.4393 7.14645C17.3456 7.05268 17.2184 7 17.0858 7H14.7071ZM23 13H20V16L23 16V13ZM19 15.2929V13H16.7071L19 15.2929ZM4.29289 7H1.7071L6.70711 12H9.2929L4.29289 7ZM6 12.7072L1 7.70711V10.0858C1 10.2184 1.05268 10.3456 1.14645 10.4393L6 15.2929V12.7072ZM7 16L10 16V13H7V16Z",
	fill: "currentColor"
};
function Gu(e, t) {
	return A(), o("path", Wu);
}
var Ku = /*#__PURE__*/ W(Uu, [["render", Gu]]), qu = {}, Ju = {
	d: "M12.5821 4.20251C12.2099 4.04578 11.7901 4.04578 11.4179 4.20251L2.91791 7.78147C2.36169 8.01567 2 8.56041 2 9.16392V14.8359C2 15.4394 2.36169 15.9842 2.91792 16.2184L11.4179 19.7973C11.7901 19.954 12.2099 19.954 12.5821 19.7973L21.0821 16.2183C21.6383 15.9842 22 15.4394 22 14.8359V9.16391C22 8.56039 21.6383 8.01565 21.0821 7.78146L12.5821 4.20251ZM11.806 5.12414C11.93 5.0719 12.07 5.0719 12.194 5.12414L19.984 8.40415L16.4999 9.95264L8.63751 6.45824L11.806 5.12414ZM7.37313 6.99061L15.2688 10.4998L12.6092 11.6819C12.2214 11.8542 11.7786 11.8542 11.3908 11.6819L4.01598 8.40415L7.37313 6.99061ZM16 11.2692V13.9998C16 14.276 16.2239 14.4998 16.5 14.4998C16.7761 14.4998 17 14.276 17 13.9998V10.8247L20.9875 9.0525C20.9957 9.08856 21 9.12588 21 9.16391V14.8359C21 15.0371 20.8794 15.2186 20.694 15.2967L12.5 18.7468V12.7606C12.6758 12.7248 12.8486 12.6698 13.0153 12.5957L16 11.2692ZM3.01255 9.0525L10.9847 12.5957C11.1514 12.6698 11.3242 12.7248 11.5 12.7606V18.7468L3.30597 15.2967C3.12056 15.2187 3 15.0371 3 14.8359V9.16392C3 9.12589 3.00431 9.08857 3.01255 9.0525Z",
	fill: "currentColor"
};
function Yu(e, t) {
	return A(), o("path", Ju);
}
var Xu = /*#__PURE__*/ W(qu, [["render", Yu]]), Zu = {};
function Qu(t, n) {
	return A(), o(e, null, [n[0] ||= s("path", {
		d: "M21 22h-3v-.5c0-.1-.1-.5-1-.5s-1 .4-1 .5v.5h-3v-.5c0-.1-.1-.5-1-.5s-1 .4-1 .5v.5H8v-.5c0-.1-.1-.5-1-.5s-1 .4-1 .5v.5H3v-4h.5c.1 0 .5-.1.5-1s-.4-1-.5-1H3v-3h.5c.1 0 .5-.1.5-1s-.4-1-.5-1H3V8h.5c.1 0 .5-.1.5-1s-.4-1-.5-1H3V2h3v.5c0 .1.1.5 1 .5s1-.4 1-.5V2h3v.5c0 .1.1.5 1 .5s1-.4 1-.5V2h3v.5c0 .1.1.5 1 .5s1-.4 1-.5V2h3v4h-.5c-.1 0-.5.1-.5 1s.4 1 .5 1h.5v3h-.5c-.1 0-.5.1-.5 1s.4 1 .5 1h.5v3h-.5c-.1 0-.5.1-.5 1s.4 1 .5 1h.5v4zm-2.1-1H20v-2.1c-.5-.2-1-.7-1-1.9s.5-1.7 1-1.9v-1.2c-.5-.2-1-.7-1-1.9s.5-1.7 1-1.9V8.9c-.5-.2-1-.7-1-1.9s.5-1.7 1-1.9V3h-1.1c-.2.5-.7 1-1.9 1s-1.7-.5-1.9-1h-1.2c-.2.5-.7 1-1.9 1s-1.7-.5-1.9-1H8.9c-.2.5-.8 1-1.9 1s-1.7-.5-1.9-1H4v2.1c.5.2 1 .8 1 1.9s-.5 1.7-1 1.9v1.2c.5.2 1 .7 1 1.9s-.5 1.7-1 1.9v1.2c.5.2 1 .7 1 1.9s-.5 1.7-1 1.9V21h1.1c.2-.5.7-1 1.9-1s1.7.5 1.9 1h1.2c.2-.5.7-1 1.9-1s1.7.5 1.9 1h1.2c.2-.5.7-1 1.9-1s1.7.5 1.9 1z",
		fill: "currentColor"
	}, null, -1), n[1] ||= s("path", {
		d: "M9.3 14.5c-.2 0-.4-.1-.5-.2-.2-.1-.3-.3-.3-.5-.1-.2 0-.4 0-.6.1-.2.2-.3.4-.4l5.5-3.2c.1-.1.2-.1.3-.1h.3c.1 0 .2.1.3.2.1.1.2.2.2.3.1.1.1.2.1.3v.3c0 .1-.1.2-.2.3-.1.1-.2.2-.3.2l-5.5 3.2c0 .2-.2.2-.3.2zm2.7 1.6c-.2 0-.4-.1-.5-.2-.2-.1-.3-.3-.3-.5-.1-.2 0-.4 0-.6.1-.2.2-.3.4-.4l2.7-1.6c.1-.1.2-.1.3-.1h.3c.1 0 .2.1.3.2.1.1.2.2.2.3.1.1.1.2.1.3v.3c0 .1-.1.2-.2.3-.1.1-.2.2-.3.2L12.5 16c-.2.1-.3.1-.5.1zm-2.8-4.7c-.2 0-.4-.1-.5-.2-.2-.1-.3-.3-.3-.5-.1-.2 0-.4 0-.6.1-.1.2-.3.4-.4l2.7-1.6c.3-.1.5-.1.7-.1.2.1.4.2.5.4.1.2.1.4.1.7-.1.2-.2.4-.4.5l-2.7 1.6c-.1.1-.3.2-.5.2z",
		fill: "currentColor"
	}, null, -1)], 64);
}
var $u = /*#__PURE__*/ W(Zu, [["render", Qu]]), ed = {}, td = {
	d: "M10.4116 5.20544C10.7894 5.04636 11.2158 5.04884 11.5918 5.21229L22.0981 9.78026C22.6458 10.0184 23 10.5587 23 11.1559V12.8362C23 13.4397 22.6383 13.9844 22.0821 14.2186L13.5884 17.7949C13.2106 17.954 12.7842 17.9515 12.4082 17.7881L1.90191 13.2201C1.35424 12.982 1 12.4417 1 11.8445V10.1642C1 9.56067 1.36169 9.01593 1.91792 8.78173L10.4116 5.20544ZM11.1931 6.12936C11.0677 6.07487 10.9256 6.07405 10.7997 6.12707L7.64807 7.45406L17.745 11.844L21.0046 10.3953L11.1931 6.12936ZM18.5 12.6028V13.5001C18.5 13.7763 18.2761 14.0001 18 14.0001C17.7239 14.0001 17.5 13.7763 17.5 13.5001V13.0472L14.0065 14.5999C13.8426 14.6727 13.6727 14.7271 13.5 14.763V16.7471L21.694 13.297C21.8794 13.2189 22 13.0374 22 12.8362V11.1559C22 11.1205 21.9963 11.0857 21.9891 11.052L18.5 12.6028ZM16.5048 12.3952L6.37396 7.99052L2.77115 9.5075L12.3931 13.6909C12.7784 13.8585 13.2164 13.8567 13.6004 13.6861L16.5048 12.3952ZM2.30064 12.303L12.5 16.7375V14.7666C12.3277 14.7321 12.1582 14.6792 11.9943 14.608L2 10.2626V11.8445C2 12.0436 2.11808 12.2237 2.30064 12.303Z",
	fill: "currentColor"
};
function nd(e, t) {
	return A(), o("path", td);
}
var rd = /*#__PURE__*/ W(ed, [["render", nd]]), id = {}, ad = {
	d: "M13 3h5.5a.5.5 0 0 1 0 1H13a4.5 4.5 0 0 0-4.5 4.5V10h9a.5.5 0 0 1 0 1h-9v2h7a.5.5 0 0 1 0 1h-7v1.5A4.5 4.5 0 0 0 13 20h5.5a.5.5 0 0 1 0 1H13a5.5 5.5 0 0 1-5.5-5.5V14h-4a.5.5 0 1 1 0-1h4v-2h-3a.5.5 0 1 1 0-1h3V8.5A5.5 5.5 0 0 1 13 3Z",
	fill: "currentColor"
};
function od(e, t) {
	return A(), o("path", ad);
}
var sd = /*#__PURE__*/ W(id, [["render", od]]), cd = {}, ld = {
	"clip-rule": "evenodd",
	d: "M4.5 4.833A3.833 3.833 0 0 1 8.333 1H12.5a.5.5 0 1 1 0 1H8.333A2.833 2.833 0 0 0 5.5 4.833V6h5a.5.5 0 0 1 0 1h-5v2h4a.5.5 0 0 1 0 1h-4v1.167A2.833 2.833 0 0 0 8.333 14H12.5a.5.5 0 0 1 0 1H8.333A3.833 3.833 0 0 1 4.5 11.167V10h-3a.5.5 0 1 1 0-1h3V7h-2a.5.5 0 1 1 0-1h2V4.833Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function ud(e, t) {
	return A(), o("path", ld);
}
var dd = /*#__PURE__*/ W(cd, [["render", ud]]), fd = {}, pd = {
	d: "M2.667 7.333c0-0.368 0.298-0.667 0.667-0.667h25.333c0.368 0 0.667 0.298 0.667 0.667s-0.299 0.667-0.667 0.667h-25.333c-0.368 0-0.667-0.298-0.667-0.667zM2.667 15.333c0-0.368 0.298-0.667 0.667-0.667h25.333c0.368 0 0.667 0.299 0.667 0.667s-0.299 0.667-0.667 0.667h-25.333c-0.368 0-0.667-0.299-0.667-0.667zM3.333 22.667c-0.368 0-0.667 0.299-0.667 0.667s0.298 0.667 0.667 0.667h25.333c0.368 0 0.667-0.299 0.667-0.667s-0.299-0.667-0.667-0.667h-25.333z",
	fill: "currentColor"
};
function md(e, t) {
	return A(), o("path", pd);
}
var hd = /*#__PURE__*/ W(fd, [["render", md]]), gd = {}, _d = {
	d: "M2.75 5.5h19M2.75 11.5h19M2.75 17.5h19",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round"
};
function vd(e, t) {
	return A(), o("path", _d);
}
var yd = /*#__PURE__*/ W(gd, [["render", vd]]), bd = {}, xd = {
	"clip-rule": "evenodd",
	d: "M5.5 6.5C5.5 5.67157 6.17157 5 7 5H10C10.2761 5 10.5 4.77614 10.5 4.5C10.5 4.22386 10.2761 4 10 4H7C5.61929 4 4.5 5.11929 4.5 6.5V17.5C4.5 18.8807 5.61929 20 7 20H18C19.3807 20 20.5 18.8807 20.5 17.5V14.5C20.5 14.2239 20.2761 14 20 14C19.7239 14 19.5 14.2239 19.5 14.5V17.5C19.5 18.3284 18.8284 19 18 19H7C6.17157 19 5.5 18.3284 5.5 17.5V6.5ZM15 4C14.7239 4 14.5 4.22386 14.5 4.5C14.5 4.77614 14.7239 5 15 5H18.7929L11.6464 12.1464C11.4512 12.3417 11.4512 12.6583 11.6464 12.8536C11.8417 13.0488 12.1583 13.0488 12.3536 12.8536L19.5 5.70711V9.5C19.5 9.77614 19.7239 10 20 10C20.2761 10 20.5 9.77614 20.5 9.5V4.5C20.5 4.22386 20.2761 4 20 4H15Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function Sd(e, t) {
	return A(), o("path", xd);
}
var Cd = /*#__PURE__*/ W(bd, [["render", Sd]]), wd = {}, Td = {
	d: "M10.5001 1C10.2239 1 10.0001 1.22386 10.0001 1.5C10.0001 1.77614 10.2239 2 10.5001 2H13.2929L7.14645 8.14645C6.95119 8.34171 6.95118 8.65829 7.14645 8.85356C7.34171 9.04882 7.65829 9.04882 7.85355 8.85356L14.0001 2.7071V5.5C14.0001 5.77614 14.2239 6 14.5001 6C14.7762 6 15.0001 5.77614 15.0001 5.5V1.5C15.0001 1.22386 14.7762 1 14.5001 1H10.5001ZM2 2.83334C2 2.3731 2.3731 2.00001 2.83333 2.00001H6.5C6.77614 2.00001 7 1.77615 7 1.50001C7 1.22387 6.77614 1.00001 6.5 1.00001H2.83333C1.82081 1.00001 1 1.82082 1 2.83334V13.1667C1 14.1792 1.82081 15 2.83333 15H13.1667C14.1792 15 15 14.1792 15 13.1667V9.5C15 9.22386 14.7761 9 14.5 9C14.2239 9 14 9.22386 14 9.5V13.1667C14 13.6269 13.6269 14 13.1667 14H2.83333C2.3731 14 2 13.6269 2 13.1667V2.83334Z",
	fill: "currentColor"
};
function Ed(e, t) {
	return A(), o("path", Td);
}
var Dd = /*#__PURE__*/ W(wd, [["render", Ed]]), Od = {}, kd = {
	d: "M9.16129 0.698078H11.2219C11.4205 1.74609 12.057 2.64537 12.9388 3.20722C12.9391 3.20758 12.9394 3.20794 12.9397 3.2083C13.5536 3.59927 14.2855 3.82737 15.0712 3.82737V4.4397L15.0713 6.57766C13.6118 6.57766 12.2594 6.12136 11.1555 5.34698V10.937C11.1555 13.7288 8.8315 16 5.97486 16C4.87105 16 3.84742 15.6598 3.006 15.0824C3.00555 15.0819 3.0051 15.0814 3.00456 15.0809C1.66941 14.1642 0.794434 12.6488 0.794434 10.9365C0.794434 8.14478 3.11839 5.87346 5.97504 5.87346C6.21205 5.87346 6.44438 5.89254 6.67312 5.92286V6.57451L6.67302 8.73155C6.45203 8.66397 6.21844 8.62465 5.97486 8.62465C4.6703 8.62465 3.60897 9.66205 3.60897 10.937C3.60897 11.8249 4.12438 12.5963 4.87744 12.9835C5.20578 13.1524 5.57876 13.2493 5.97477 13.2493C7.24927 13.2493 8.28892 12.2585 8.33625 11.024L8.34075 0H11.1554C11.1554 0.238451 11.1789 0.471504 11.2219 0.698078H9.16129Z",
	fill: "currentColor"
};
function Ad(e, t) {
	return A(), o("path", kd);
}
var jd = /*#__PURE__*/ W(Od, [["render", Ad]]), Md = {}, Nd = {
	d: "M12.83 4.124a.5.5 0 0 1 .046.705l-7 8a.5.5 0 0 1-.73.025l-3-3a.5.5 0 1 1 .708-.708l2.622 2.622 6.648-7.597a.5.5 0 0 1 .705-.047Z",
	fill: "currentColor"
};
function Pd(e, t) {
	return A(), o("path", Nd);
}
var Fd = /*#__PURE__*/ W(Md, [["render", Pd]]), Id = {}, Ld = {
	d: "M15 8A7 7 0 1 0 1 8a7 7 0 0 0 14 0Zm1 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-4.146-2.146a.5.5 0 0 0-.708-.708L6.5 9.793 4.854 8.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l5-5Z",
	fill: "currentColor"
};
function Rd(e, t) {
	return A(), o("path", Ld);
}
var zd = /*#__PURE__*/ W(Id, [["render", Rd]]), Bd = {}, Vd = {
	d: "M38.53 12.47a.75.75 0 0 0-1.06 0L18 31.94l-7.47-7.47a.75.75 0 1 0-1.06 1.06l8 8a.75.75 0 0 0 1.06 0l20-20a.75.75 0 0 0 0-1.06Z",
	fill: "currentColor"
};
function Hd(e, t) {
	return A(), o("path", Vd);
}
var Ud = /*#__PURE__*/ W(Bd, [["render", Hd]]), Wd = {}, Gd = {
	fill: "none",
	height: "24",
	width: "24",
	xmlns: "http://www.w3.org/2000/svg"
};
function Kd(e, t) {
	return A(), o("svg", Gd, [...t[0] ||= [s("mask", {
		id: "a",
		height: "24",
		maskUnits: "userSpaceOnUse",
		style: { "mask-type": "alpha" },
		width: "24",
		x: "0",
		y: "0"
	}, [s("path", {
		d: "M0 0h24v24H0z",
		fill: "#D9D9D9"
	})], -1), s("g", { mask: "url(#a)" }, [s("path", {
		d: "m10.562 15.908 6.396-6.396-.708-.708-5.688 5.688-2.85-2.85-.708.708 3.558 3.558ZM12.003 21a8.772 8.772 0 0 1-3.51-.709 9.095 9.095 0 0 1-2.859-1.922 9.081 9.081 0 0 1-1.925-2.857A8.752 8.752 0 0 1 3 12.003c0-1.244.236-2.414.708-3.51a9.096 9.096 0 0 1 1.923-2.859 9.081 9.081 0 0 1 2.857-1.925A8.752 8.752 0 0 1 11.997 3c1.244 0 2.414.236 3.51.708a9.096 9.096 0 0 1 2.859 1.923 9.082 9.082 0 0 1 1.925 2.857A8.752 8.752 0 0 1 21 11.997a8.772 8.772 0 0 1-.709 3.51 9.095 9.095 0 0 1-1.922 2.859 9.082 9.082 0 0 1-2.857 1.925 8.752 8.752 0 0 1-3.509.709ZM12 20c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z",
		fill: "#1C1B1F"
	})], -1)]]);
}
var qd = /*#__PURE__*/ W(Wd, [["render", Kd]]), Jd = {}, Yd = {
	d: "M19.354 6.146a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L9 15.793l9.646-9.647a.5.5 0 0 1 .708 0Z",
	fill: "currentColor"
};
function Xd(e, t) {
	return A(), o("path", Yd);
}
var Zd = /*#__PURE__*/ W(Jd, [["render", Xd]]), Qd = {}, $d = {
	d: "M25 48.54C12.02 48.54 1.46 37.98 1.46 25S12.02 1.46 25 1.46 48.54 12.02 48.54 25 37.98 48.54 25 48.54zm0-45.53C12.88 3.01 3.01 12.88 3.01 25S12.88 46.99 25 46.99 46.99 37.12 46.99 25 37.12 3.01 25 3.01zm0 29.41c-4.09 0-7.42-3.33-7.42-7.42s3.33-7.42 7.42-7.42 7.42 3.33 7.42 7.42-3.33 7.42-7.42 7.42zm0-13.29c-3.24 0-5.87 2.63-5.87 5.87s2.64 5.87 5.87 5.87 5.87-2.63 5.87-5.87-2.63-5.87-5.87-5.87zm8.43-.43c-1.18 0-2.14-.96-2.14-2.14s.96-2.14 2.14-2.14 2.14.96 2.14 2.14-.96 2.14-2.14 2.14zm0-2.97c-.46 0-.84.38-.84.84s.38.84.84.84.84-.38.84-.84-.37-.84-.84-.84zM25 40.08c-3.86 0-4.37-.02-5.93-.09-1.47-.07-2.61-.29-3.72-.72a7.812 7.812 0 0 1-2.81-1.83 7.795 7.795 0 0 1-1.82-2.8c-.43-1.09-.65-2.24-.71-3.71-.08-1.53-.09-2.04-.09-5.93s.02-4.4.09-5.94c.07-1.47.29-2.61.72-3.72a7.812 7.812 0 0 1 1.83-2.81 7.93 7.93 0 0 1 2.8-1.82c1.1-.43 2.24-.65 3.71-.71 1.56-.07 2.08-.09 5.93-.09s4.37.02 5.93.09c1.47.07 2.61.29 3.72.72 1.05.39 2.02 1.03 2.81 1.83.79.78 1.43 1.75 1.82 2.8.43 1.09.65 2.24.71 3.71.07 1.53.09 2.04.09 5.93s-.02 4.4-.09 5.93h0c-.07 1.47-.29 2.61-.72 3.72a8.118 8.118 0 0 1-4.63 4.63c-1.1.43-2.25.65-3.72.72-1.55.08-2.06.09-5.92.09zm0-28.61c-3.82 0-4.33.02-5.86.09-1.29.06-2.29.25-3.23.61-.86.33-1.62.82-2.26 1.47a6.38 6.38 0 0 0-1.48 2.26c-.37.95-.56 1.94-.62 3.24-.07 1.5-.09 2.01-.09 5.86s.02 4.36.09 5.86c.06 1.29.25 2.29.61 3.23.32.85.83 1.63 1.47 2.26.65.66 1.41 1.16 2.26 1.48.95.37 1.94.56 3.24.62 1.53.07 2.04.09 5.86.09 3.82 0 4.33-.02 5.86-.09 1.29-.06 2.29-.25 3.23-.61a6.53 6.53 0 0 0 3.74-3.74c.37-.94.55-1.94.61-3.23h0c.07-1.51.09-2.01.09-5.86s-.02-4.36-.09-5.86c-.06-1.29-.25-2.29-.61-3.23-.32-.85-.83-1.63-1.47-2.26a6.38 6.38 0 0 0-2.26-1.48c-.95-.37-1.95-.56-3.24-.62-1.52-.08-2.03-.09-5.85-.09z",
	fill: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	"stroke-miterlimit": "10",
	"stroke-width": ".25"
};
function ef(e, t) {
	return A(), o("path", $d);
}
var tf = /*#__PURE__*/ W(Qd, [["render", ef]]), nf = {}, rf = {
	d: "M 7.978 4.437 C 5.99 4.437 4.387 6.04 4.387 8.027 C 4.387 10.015 5.99 11.618 7.978 11.618 C 9.965 11.618 11.568 10.015 11.568 8.027 C 11.568 6.04 9.965 4.437 7.978 4.437 Z M 7.978 10.362 C 6.693 10.362 5.643 9.315 5.643 8.027 C 5.643 6.74 6.69 5.693 7.978 5.693 C 9.265 5.693 10.312 6.74 10.312 8.027 C 10.312 9.315 9.262 10.362 7.978 10.362 Z M 12.553 4.29 C 12.553 4.755 12.178 5.127 11.715 5.127 C 11.249 5.127 10.878 4.752 10.878 4.29 C 10.878 3.827 11.253 3.452 11.715 3.452 C 12.178 3.452 12.553 3.827 12.553 4.29 Z M 14.931 5.14 C 14.878 4.018 14.621 3.024 13.799 2.205 C 12.981 1.387 11.987 1.13 10.865 1.074 C 9.709 1.008 6.243 1.008 5.087 1.074 C 3.968 1.127 2.974 1.383 2.153 2.202 C 1.331 3.021 1.078 4.015 1.021 5.137 C 0.956 6.293 0.956 9.758 1.021 10.915 C 1.074 12.037 1.331 13.03 2.153 13.849 C 2.974 14.668 3.965 14.924 5.087 14.98 C 6.243 15.046 9.709 15.046 10.865 14.98 C 11.987 14.927 12.981 14.671 13.799 13.849 C 14.618 13.03 14.874 12.037 14.931 10.915 C 14.996 9.758 14.996 6.296 14.931 5.14 Z M 13.437 12.155 C 13.193 12.768 12.721 13.24 12.106 13.487 C 11.184 13.852 8.996 13.768 7.978 13.768 C 6.959 13.768 4.768 13.849 3.849 13.487 C 3.237 13.243 2.765 12.771 2.518 12.155 C 2.153 11.233 2.237 9.046 2.237 8.027 C 2.237 7.008 2.156 4.818 2.518 3.899 C 2.762 3.287 3.234 2.815 3.849 2.568 C 4.771 2.202 6.959 2.287 7.978 2.287 C 8.996 2.287 11.187 2.205 12.106 2.568 C 12.718 2.812 13.19 3.283 13.437 3.899 C 13.803 4.821 13.718 7.008 13.718 8.027 C 13.718 9.046 13.803 11.237 13.437 12.155 Z",
	style: { fill: "currentColor" }
};
function af(e, t) {
	return A(), o("path", rf);
}
var of = /*#__PURE__*/ W(nf, [["render", af]]), sf = {}, cf = {
	d: "M25 2.24C12.45 2.24 2.24 12.45 2.24 25S12.45 47.76 25 47.76 47.76 37.55 47.76 25 37.55 2.24 25 2.24zm0 30.18c-4.09 0-7.42-3.33-7.42-7.42s3.33-7.42 7.42-7.42 7.42 3.33 7.42 7.42-3.33 7.42-7.42 7.42zm0-13.29c-3.24 0-5.87 2.63-5.87 5.87s2.64 5.87 5.87 5.87 5.87-2.63 5.87-5.87-2.63-5.87-5.87-5.87zm8.43-.43c-1.18 0-2.14-.96-2.14-2.14 0-1.18.96-2.14 2.14-2.14s2.14.96 2.14 2.14c0 1.18-.96 2.14-2.14 2.14zm0-2.97c-.46 0-.84.38-.84.84 0 .46.38.84.84.84s.84-.38.84-.84c0-.47-.37-.84-.84-.84zM25 40.08c-3.88 0-4.39-.02-5.94-.09-1.47-.07-2.61-.29-3.72-.72a7.812 7.812 0 0 1-2.81-1.83 7.795 7.795 0 0 1-1.82-2.8c-.43-1.09-.65-2.24-.71-3.71-.07-1.53-.08-2.04-.08-5.93 0-3.89.02-4.4.09-5.93.07-1.47.29-2.61.72-3.72a7.899 7.899 0 0 1 1.83-2.81c.78-.79 1.75-1.43 2.8-1.82 1.1-.43 2.24-.65 3.71-.71 1.54-.07 2.06-.09 5.93-.09s4.39.02 5.93.09c1.47.07 2.61.29 3.72.72 1.05.39 2.02 1.03 2.81 1.83.79.78 1.43 1.75 1.82 2.8.43 1.09.65 2.24.71 3.71.07 1.53.09 2.04.09 5.93s-.02 4.4-.09 5.93c-.07 1.47-.29 2.61-.72 3.72a8.118 8.118 0 0 1-4.63 4.63c-1.1.43-2.25.65-3.72.72-1.53.07-2.04.08-5.92.08zm0-28.61c-3.84 0-4.35.02-5.86.08-1.29.06-2.29.25-3.23.61-.86.33-1.62.82-2.26 1.47-.66.65-1.16 1.41-1.48 2.26-.37.95-.56 1.94-.62 3.24-.07 1.5-.09 2-.09 5.86s.02 4.36.09 5.86c.06 1.29.25 2.29.61 3.23.32.85.83 1.63 1.47 2.26.65.66 1.41 1.16 2.26 1.48.95.37 1.94.56 3.24.62 1.51.07 2.02.09 5.86.09 3.85 0 4.35-.02 5.86-.09 1.29-.06 2.29-.25 3.23-.61a6.53 6.53 0 0 0 3.74-3.74c.37-.94.55-1.94.61-3.23.07-1.51.09-2.01.09-5.86s-.02-4.36-.09-5.86c-.06-1.29-.25-2.29-.61-3.23-.32-.85-.83-1.63-1.47-2.26a6.38 6.38 0 0 0-2.26-1.48c-.95-.37-1.95-.56-3.24-.62-1.5-.07-2.01-.08-5.85-.08z",
	fill: "currentColor"
};
function lf(e, t) {
	return A(), o("path", cf);
}
var uf = /*#__PURE__*/ W(sf, [["render", lf]]), df = {}, ff = {
	d: "M12 3a9 9 0 1 1 0 18 8.956 8.956 0 0 1-5.062-1.558.5.5 0 0 0-.68.112l-2.717.905.915-2.747a.5.5 0 0 0 .092-.663A8.956 8.956 0 0 1 3 12a9 9 0 0 1 9-9ZM2 12c0 1.955.562 3.78 1.533 5.323a.467.467 0 0 0-.007.019l-1.25 3.75a.5.5 0 0 0 .632.632l3.75-1.25a.422.422 0 0 0 .02-.007A9.955 9.955 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12Zm5.59-3.42c.11-.171.216-.31.31-.402.065-.065.187-.13.383-.171.188-.04.399-.05.585-.045.046 0 .12.035.157.142l.67 1.907a.282.282 0 0 1-.035.256l-.498.707a.975.975 0 0 0-.117.918c.174.446.611 1.401 1.425 2.215.751.751 1.623 1.181 2.101 1.38a.975.975 0 0 0 1.157-.332l.449-.606a.282.282 0 0 1 .35-.086l1.716.828a.24.24 0 0 1 .102.09.115.115 0 0 1 .018.078c-.047.337-.153.672-.332.85-.126.127-.328.27-.57.413a2.13 2.13 0 0 1-1.865.151 10.433 10.433 0 0 1-3.568-2.324c-1.255-1.256-2.074-2.736-2.546-3.785-.329-.73-.301-1.55.108-2.184Zm-.398-1.11a3.49 3.49 0 0 0-.441.567c-.619.957-.63 2.142-.18 3.138.5 1.11 1.378 2.709 2.75 4.081a11.433 11.433 0 0 0 3.912 2.55c.9.35 1.906.27 2.739-.224a4 4 0 0 0 .766-.566c.422-.421.562-1.04.616-1.418.076-.546-.253-1.003-.676-1.207l-1.717-.829a1.283 1.283 0 0 0-1.588.392l-.443.598c-.421-.177-1.143-.542-1.753-1.152-.665-.665-1.038-1.462-1.194-1.855l.494-.702c.24-.34.3-.773.162-1.164l-.67-1.906c-.152-.433-.549-.798-1.076-.811a3.575 3.575 0 0 0-.82.067c-.287.061-.623.184-.88.442Z",
	fill: "currentColor"
};
function pf(e, t) {
	return A(), o("path", ff);
}
var mf = /*#__PURE__*/ W(df, [["render", pf]]), hf = {}, gf = {
	d: "M25.21 2.24h-.01C12.65 2.24 2.44 12.45 2.44 25c0 4.98 1.6 9.59 4.33 13.34L3.94 46.8l8.75-2.8c3.6 2.38 7.89 3.76 12.52 3.76 12.55 0 22.76-10.21 22.76-22.76S37.76 2.24 25.21 2.24zm6.87 35.49c-1.28 0-3.15-.39-6.64-1.83-3.94-1.63-7.84-5.05-11-9.62l-.11-.16c-1.04-1.42-2.73-4.15-2.73-7.01 0-3.34 1.67-5.04 2.38-5.76.68-.7 1.69-1.07 2.83-1.07.26 0 .49.01.7.02 1.01.04 1.6.29 2.12 1.55l.66 1.59c.5 1.21 1.18 2.87 1.28 3.07.12.25.5 1.04.08 1.86-.22.48-.45.73-.75 1.09-.2.23-.34.38-.48.52-.17.18-.33.35-.5.56-.11.12-.24.28-.25.33 0 0 0 .04.06.14.55.93 1.73 2.73 3.36 4.18 2.12 1.89 3.84 2.58 4.67 2.92l.2.08c.26.11.54.09.67-.06.38-.41.87-1.09 1.38-1.81l.25-.35c.59-.84 1.5-1.11 2.46-.75.58.2 3.27 1.52 4.39 2.08l.36.18c.52.25.94.45 1.18.87.34.61.21 2.18-.31 3.65-.63 1.77-2.95 3.16-4.82 3.56-.45.1-.89.17-1.44.17zM16.8 13.82c-.7 0-1.33.21-1.66.54-.69.7-2 2.03-2 4.74 0 1.77.87 3.97 2.4 6.04.05.06.1.14.18.25 2.99 4.33 6.66 7.55 10.32 9.07 4.96 2.06 6.27 1.77 7.14 1.59 1.45-.31 3.28-1.42 3.69-2.56.4-1.14.44-2.05.41-2.36-.1-.07-.31-.17-.48-.25l-.38-.19c-1.82-.9-3.83-1.88-4.23-2.01-.33-.12-.48-.08-.67.19l-.25.35c-.54.76-1.06 1.49-1.51 1.97-.59.62-1.52.79-2.39.43l-.19-.08c-.83-.34-2.79-1.13-5.12-3.2-1.79-1.59-3.07-3.54-3.67-4.56-.64-1.1 0-1.86.31-2.23.2-.25.39-.45.59-.66l.38-.41c.33-.38.44-.51.59-.82.04-.08.06-.19-.09-.51-.11-.23-.59-1.39-1.31-3.15l-.65-1.58c-.24-.58-.24-.58-.69-.59-.29 0-.5-.01-.72-.01zm20.78 19.93z",
	fill: "currentColor"
};
function _f(e, t) {
	return A(), o("path", gf);
}
var vf = /*#__PURE__*/ W(hf, [["render", _f]]), yf = {}, bf = {
	d: "M24 4.75c10.632 0 19.25 8.618 19.25 19.25S34.632 43.25 24 43.25c-4.04 0-7.786-1.243-10.882-3.368l-.04-.028a.749.749 0 0 0-.64-.102.75.75 0 0 0-.175.036l-6.077 2.026 2.02-6.06a.75.75 0 0 0-.036-.798A19.158 19.158 0 0 1 4.75 24C4.75 13.368 13.368 4.75 24 4.75ZM3.25 24a20.66 20.66 0 0 0 3.465 11.484l-2.427 7.279a.75.75 0 0 0 .95.949l7.278-2.427A20.657 20.657 0 0 0 24 44.75c11.46 0 20.75-9.29 20.75-20.75S35.46 3.25 24 3.25 3.25 12.54 3.25 24Zm12.579-7.503c.225-.35.447-.642.651-.845.178-.179.477-.321.89-.41a5.418 5.418 0 0 1 1.23-.096c.212.006.44.156.545.452l1.34 3.814a.815.815 0 0 1-.103.74l-.995 1.413a1.7 1.7 0 0 0-.207 1.6c.343.877 1.202 2.753 2.795 4.345 1.47 1.47 3.18 2.315 4.121 2.705.757.314 1.57.022 2.017-.58l.897-1.212a.815.815 0 0 1 1.01-.249l3.433 1.657c.293.141.408.392.38.594-.097.685-.318 1.426-.736 1.844-.274.274-.7.574-1.19.864a4.51 4.51 0 0 1-3.948.32 21.118 21.118 0 0 1-7.221-4.705c-2.54-2.54-4.192-5.531-5.144-7.644-.688-1.527-.637-3.26.235-4.607Zm-.41-1.906c-.31.31-.597.7-.85 1.091-1.185 1.833-1.21 4.112-.342 6.038.993 2.206 2.735 5.373 5.45 8.089a22.617 22.617 0 0 0 7.738 5.042 6.01 6.01 0 0 0 5.259-.428c.525-.312 1.077-.687 1.484-1.094.782-.782 1.054-1.95 1.16-2.695.135-.964-.445-1.784-1.213-2.154l-3.434-1.657a2.315 2.315 0 0 0-2.866.707l-.898 1.211c-.078.106-.178.113-.236.089-.848-.352-2.36-1.104-3.636-2.38-1.384-1.385-2.15-3.045-2.459-3.832-.016-.042-.018-.112.037-.19l.995-1.413c.431-.612.54-1.395.292-2.1L20.56 15.1c-.276-.785-.988-1.431-1.922-1.454a6.889 6.889 0 0 0-1.58.129c-.552.118-1.171.348-1.639.815Z",
	fill: "currentColor"
};
function xf(e, t) {
	return A(), o("path", bf);
}
var Sf = /*#__PURE__*/ W(yf, [["render", xf]]), Cf = {}, wf = {
	d: "M25.01 48.54c-4.5 0-8.87-1.27-12.64-3.69l-8.4 2.68c-.28.09-.58.01-.79-.19-.2-.2-.27-.51-.18-.79l2.71-8.08A23.307 23.307 0 0 1 1.46 25c0-12.98 10.56-23.54 23.53-23.54H25c12.98 0 23.53 10.56 23.53 23.54.01 12.98-10.55 23.54-23.52 23.54zm-12.53-5.31c.15 0 .3.04.43.13 3.59 2.38 7.77 3.63 12.09 3.63 12.12 0 21.98-9.86 21.98-21.99 0-12.13-9.86-21.99-21.98-21.99h-.01C12.87 3.01 3.01 12.88 3.01 25c0 4.67 1.45 9.12 4.19 12.89.15.2.19.46.11.7L4.96 45.6l7.29-2.33c.07-.03.15-.04.23-.04zm19.39-5.5c-1.28 0-3.15-.39-6.64-1.83-3.94-1.63-7.85-5.05-11-9.62l-.11-.16c-1.04-1.42-2.73-4.15-2.73-7.01 0-3.34 1.67-5.04 2.38-5.76.68-.7 1.69-1.07 2.83-1.07.26 0 .49.01.7.02 1.01.04 1.6.29 2.12 1.55l.66 1.59c.5 1.21 1.18 2.87 1.28 3.07.12.25.5 1.04.08 1.86-.22.48-.45.73-.75 1.09-.2.23-.34.38-.48.52-.17.18-.33.35-.5.56-.11.12-.24.28-.25.33h0s0 .04.06.14c.55.93 1.73 2.73 3.36 4.18 2.12 1.89 3.84 2.58 4.67 2.92l.2.08c.26.11.53.09.67-.06.38-.41.87-1.09 1.38-1.81l.25-.35c.59-.84 1.5-1.11 2.46-.75.63.22 3.77 1.77 4.39 2.08l.36.18c.52.25.94.45 1.18.87.34.61.21 2.18-.31 3.65h0c-.63 1.77-2.95 3.16-4.82 3.56-.44.1-.89.17-1.44.17zM16.59 13.82c-.7 0-1.33.21-1.66.54-.69.7-2 2.03-2 4.74 0 1.77.87 3.97 2.4 6.04.05.06.1.14.17.25 2.99 4.33 6.65 7.55 10.32 9.07 4.96 2.06 6.27 1.77 7.14 1.59 1.45-.31 3.28-1.42 3.69-2.56.4-1.14.44-2.05.41-2.36-.1-.07-.31-.17-.48-.25l-.38-.19c-1.81-.9-3.84-1.88-4.23-2.01-.33-.12-.48-.08-.67.19l-.25.35c-.54.76-1.06 1.49-1.51 1.97-.59.62-1.52.79-2.39.43l-.19-.08c-.83-.34-2.79-1.13-5.12-3.2-1.79-1.59-3.07-3.54-3.67-4.56-.64-1.11.01-1.87.32-2.23.2-.25.39-.45.58-.66l.38-.41c.33-.38.44-.51.59-.82.04-.08.06-.19-.09-.51-.11-.23-.59-1.39-1.31-3.15l-.65-1.58c-.24-.58-.24-.58-.69-.59-.27 0-.48-.01-.71-.01zm20.79 19.93h0z",
	fill: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	"stroke-miterlimit": "10",
	"stroke-width": ".25"
};
function Tf(e, t) {
	return A(), o("path", wf);
}
var Ef = /*#__PURE__*/ W(Cf, [["render", Tf]]), Df = {}, Of = {
	d: "M21 19.5v-12a.5.5 0 0 0-.5-.5H17a.5.5 0 0 1 0-1h3.5A1.5 1.5 0 0 1 22 7.5v12a1.5 1.5 0 0 1-1.5 1.5h-17A1.5 1.5 0 0 1 2 19.5v-12A1.5 1.5 0 0 1 3.5 6H7a.5.5 0 0 1 0 1H3.5a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5Zm-9.5-6a.5.5 0 1 0 1 0V2.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.707 0l-3 3a.5.5 0 1 0 .707.708L11.5 2.707V13.5Z",
	fill: "currentColor"
};
function kf(e, t) {
	return A(), o("path", Of);
}
var Af = /*#__PURE__*/ W(Df, [["render", kf]]), jf = {}, Mf = {
	d: "M46.69 17.27v26.52c0 1.25-1.02 2.28-2.28 2.28H5.59c-1.25 0-2.28-1.02-2.28-2.28V17.27c0-1.25 1.02-2.28 2.28-2.28h6.49a.781.781 0 0 1 0 1.56H5.59c-.4 0-.72.33-.72.72v26.52c0 .4.33.72.72.72h38.82c.4 0 .72-.33.72-.72V17.27c0-.4-.33-.72-.72-.72h-6.34c-.43 0-.78-.35-.78-.78s.36-.77.78-.77h6.34c1.26 0 2.28 1.02 2.28 2.27zm-29.2-4.01c.19 0 .39-.07.54-.22l6.79-6.51v19.28a.781.781 0 0 0 1.56 0V6.58l6.45 6.45c.3.3.79.3 1.1 0s.3-.79 0-1.1l-7.77-7.77a.852.852 0 0 0-.25-.17.717.717 0 0 0-.29-.06h-.01c-.04 0-.07.02-.11.02-.06.01-.12.01-.18.04-.05.02-.1.06-.15.09-.03.02-.07.04-.1.07l-8.1 7.77c-.31.3-.32.79-.02 1.1a.7.7 0 0 0 .54.24z",
	fill: "currentColor"
};
function Nf(e, t) {
	return A(), o("path", Mf);
}
var Pf = /*#__PURE__*/ W(jf, [["render", Nf]]), Ff = {}, If = {
	d: "M14.8 0H1.2C0.88174 0 0.576516 0.126428 0.351472 0.351472C0.126428 0.576516 0 0.88174 0 1.2V14.8C0 15.1183 0.126428 15.4235 0.351472 15.6485C0.576516 15.8736 0.88174 16 1.2 16H14.8C15.1183 16 15.4235 15.8736 15.6485 15.6485C15.8736 15.4235 16 15.1183 16 14.8V1.2C16 0.88174 15.8736 0.576516 15.6485 0.351472C15.4235 0.126428 15.1183 0 14.8 0ZM4.8 13.6H2.4V6.4H4.8V13.6ZM3.6 5C3.32495 4.99214 3.05831 4.9034 2.8334 4.74486C2.60849 4.58633 2.43529 4.36503 2.33544 4.10862C2.23558 3.85221 2.2135 3.57206 2.27195 3.30318C2.3304 3.03429 2.4668 2.78859 2.66409 2.59678C2.86138 2.40497 3.11083 2.27555 3.38125 2.22469C3.65168 2.17383 3.93109 2.2038 4.18459 2.31083C4.43808 2.41787 4.65441 2.59724 4.80655 2.82652C4.95869 3.0558 5.03989 3.32483 5.04 3.6C5.03368 3.97628 4.87867 4.33476 4.60884 4.59709C4.33901 4.85943 3.97631 5.00428 3.6 5ZM13.6 13.6H11.2V9.808C11.2 8.672 10.72 8.264 10.096 8.264C9.91305 8.27618 9.73431 8.32439 9.57004 8.40585C9.40577 8.48731 9.25921 8.60042 9.13879 8.73869C9.01836 8.87695 8.92644 9.03765 8.8683 9.21154C8.81016 9.38544 8.78695 9.56911 8.8 9.752C8.79603 9.78923 8.79603 9.82677 8.8 9.864V13.6H6.4V6.4H8.72V7.44C8.95402 7.084 9.27554 6.79406 9.65375 6.59795C10.032 6.40184 10.4542 6.30613 10.88 6.32C12.12 6.32 13.568 7.008 13.568 9.248L13.6 13.6Z",
	fill: "currentColor"
};
function Lf(e, t) {
	return A(), o("path", If);
}
var Rf = /*#__PURE__*/ W(Ff, [["render", Lf]]), zf = {}, Bf = {
	d: "M19.55 36.99h-5.47c-.43 0-.77-.35-.77-.78V19.76c0-.43.35-.78.77-.78h5.47c.43 0 .77.35.77.78v16.45c0 .43-.35.78-.77.78zm-4.7-1.55h3.92v-14.9h-3.92v14.9zm1.96-17.15h-.04c-2.2 0-3.8-1.52-3.8-3.62s1.63-3.62 3.87-3.62c2.21 0 3.79 1.48 3.83 3.6.01 2.11-1.62 3.64-3.86 3.64zm.04-5.69c-1.39 0-2.32.83-2.32 2.07 0 1.22.92 2.07 2.25 2.07h.04c1.39 0 2.32-.83 2.32-2.07-.04-1.25-.93-2.07-2.29-2.07zm22.42 24.39H33.8c-.43 0-.77-.35-.77-.78v-8.8c0-2.95-1.45-2.95-2-2.95-1.33 0-1.9 1.06-2.09 1.51-.08.2-.12.55-.12 1.05v9.19c0 .43-.35.78-.77.78h-5.47c-.21 0-.4-.08-.55-.23a.764.764 0 0 1-.23-.55c0-.15.07-14.91 0-16.41-.01-.21.07-.42.21-.57.15-.15.35-.24.56-.24h5.47c.43 0 .77.35.77.78V20c.93-.78 2.24-1.4 4.15-1.4 4.36 0 7.07 3.14 7.07 8.18v9.43c.01.43-.34.78-.76.78zm-4.7-1.55h3.92v-8.66c0-4.21-2.01-6.63-5.52-6.63-2.44 0-3.57 1.26-4.28 2.36a.78.78 0 0 1-1.43-.42v-1.55h-3.9c.04 2.98 0 12.14-.01 14.9h3.92v-8.41c0-.73.07-1.23.24-1.63.62-1.55 1.94-2.48 3.52-2.48 1.07 0 3.55.44 3.55 4.5v8.02zM25 48.54C12.02 48.54 1.46 37.98 1.46 25S12.02 1.46 25 1.46c12.98 0 23.54 10.56 23.54 23.54S37.98 48.54 25 48.54zm0-45.53C12.88 3.01 3.01 12.88 3.01 25S12.88 46.99 25 46.99 46.99 37.12 46.99 25 37.12 3.01 25 3.01z",
	fill: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	"stroke-miterlimit": "10",
	"stroke-width": ".25"
};
function Vf(e, t) {
	return A(), o("path", Bf);
}
var Hf = /*#__PURE__*/ W(zf, [["render", Vf]]), Uf = {}, Wf = {
	d: "M25 2.24C12.45 2.24 2.24 12.45 2.24 25S12.45 47.76 25 47.76 47.76 37.55 47.76 25 37.55 2.24 25 2.24zm-6.96 34.71h-5.47c-.43 0-.77-.35-.77-.78V19.72c0-.43.35-.78.77-.78h5.47c.43 0 .77.35.77.78v16.45c0 .43-.35.78-.77.78zm-4.7-1.55h3.92V20.5h-3.92v14.9zm1.96-17.15h-.04c-2.2 0-3.8-1.52-3.8-3.62s1.63-3.62 3.87-3.62c2.21 0 3.79 1.48 3.83 3.6.01 2.12-1.62 3.64-3.86 3.64zm.04-5.69c-1.39 0-2.32.83-2.32 2.07 0 1.22.92 2.07 2.25 2.07h.04c1.39 0 2.32-.83 2.32-2.07-.04-1.25-.93-2.07-2.29-2.07zm22.42 24.39h-5.47c-.43 0-.77-.35-.77-.78v-8.8c0-2.95-1.45-2.95-2-2.95-1.33 0-1.9 1.06-2.09 1.51-.08.2-.12.55-.12 1.05v9.19c0 .43-.35.78-.77.78h-5.47c-.21 0-.4-.08-.55-.23a.764.764 0 0 1-.23-.55c0-.15.07-14.91 0-16.41-.01-.21.07-.42.21-.57.15-.15.35-.24.56-.24h5.47c.43 0 .77.35.77.78v.24c.93-.78 2.24-1.4 4.15-1.4 4.36 0 7.07 3.14 7.07 8.18v9.43c.01.42-.34.77-.76.77zm-4.7-1.55h3.92v-8.66c0-4.21-2.01-6.63-5.52-6.63-2.44 0-3.57 1.26-4.28 2.36a.78.78 0 0 1-1.43-.42V20.5h-3.9c.04 2.98 0 12.14-.01 14.9h3.92v-8.41c0-.73.07-1.23.24-1.63.62-1.55 1.94-2.48 3.52-2.48 1.07 0 3.55.44 3.55 4.5v8.02z",
	fill: "currentColor"
};
function Gf(e, t) {
	return A(), o("path", Wf);
}
var Kf = /*#__PURE__*/ W(Uf, [["render", Gf]]), qf = {}, Jf = {
	d: "M8 .5a.5.5 0 0 1 .5.5v6.5H15a.5.5 0 0 1 0 1H8.5V15a.5.5 0 0 1-1 0V8.5H1a.5.5 0 0 1 0-1h6.5V1A.5.5 0 0 1 8 .5Z",
	fill: "currentColor"
};
function Yf(e, t) {
	return A(), o("path", Jf);
}
var Xf = /*#__PURE__*/ W(qf, [["render", Yf]]), Zf = {}, Qf = {
	d: "M8 .5a.5.5 0 0 1 .5.5v6.5H15a.5.5 0 0 1 0 1H8.5V15a.5.5 0 0 1-1 0V8.5H1a.5.5 0 0 1 0-1h6.5V1A.5.5 0 0 1 8 .5Z",
	fill: "currentColor"
};
function $f(e, t) {
	return A(), o("path", Qf);
}
var ep = /*#__PURE__*/ W(Zf, [["render", $f]]), tp = {
	Normal: "0 0 16 16",
	Medium: "0 0 24 24",
	MediumLarge: "0 0 32 32",
	Large: "0 0 48 48",
	Social: "0 0 50 50",
	XLarge: "0 0 88 88",
	XXLarge: "0 0 200 200"
}, np = {
	Normal: 16,
	Medium: 24,
	MediumLarge: 32,
	Large: 48,
	Social: 50,
	XLarge: 88,
	XXLarge: 200
}, rp = {
	Rounded: "rounded",
	Active: "active",
	Disabled: "disabled"
}, ip = [
	"height",
	"viewBox",
	"width"
], ap = /* @__PURE__ */ f({
	__name: "IconBase",
	props: {
		width: { default: void 0 },
		height: { default: void 0 },
		viewbox: { default: void 0 },
		size: { default: np.Normal }
	},
	setup(e) {
		let t = se(), n = e, i = Object.entries(np).find(([, e]) => e === n.size)[0], a = r(() => String(n.height ?? np[i])), s = r(() => String(n.width ?? np[i])), c = r(() => String(n.viewbox ?? tp[i]));
		return (e, n) => (A(), o("svg", {
			class: C(L(_e)("align-baseline inline-block overflow-visible", L(t).class)),
			height: a.value,
			role: "presentation",
			viewBox: c.value,
			width: s.value,
			xmlns: "http://www.w3.org/2000/svg"
		}, [F(e.$slots, "default")], 10, ip));
	}
}), op = /* @__PURE__ */ f({
	__name: "ChevronIcon",
	props: { isOpen: { type: Boolean } },
	setup(e) {
		return (t, n) => (A(), i(L(ap), { size: L(np).Medium }, {
			default: B(() => [e.isOpen ? (A(), i(L(oi), { key: 0 })) : (A(), i(L(Qr), { key: 1 }))]),
			_: 1
		}, 8, ["size"]));
	}
}), sp = [
	"id",
	"aria-controls",
	"aria-expanded"
], cp = ["id", "aria-labelledby"], lp = /* @__PURE__ */ f({
	__name: "AccordionItem",
	props: {
		name: {},
		open: { type: Boolean },
		noPadding: {
			type: Boolean,
			default: !1
		}
	},
	setup(e) {
		let t = e, n = _("setOpenItem"), i = _("border"), a = _("openItems"), c = r(() => `accordion-header-${t.name}`), l = r(() => `accordion-content-${t.name}`), d = r(() => !!a?.value.includes(t.name));
		return t.open && n && n(t.name), (t, r) => (A(), o("div", { class: C(["group/item w-full", {
			"first:rounded-t-xl first:border-0 border-t": L(i),
			"border-b last:border-b-0": !L(i)
		}]) }, [s("div", { class: C({ "bg-gray-100": L(i) }) }, [s("button", {
			id: c.value,
			"aria-controls": l.value,
			"aria-expanded": d.value,
			class: C(["flex py-4 text-left w-full", {
				"group-first/item:rounded-t-xl px-4": L(i),
				"group-last/item:rounded-b-xl": !d.value && L(i),
				"pr-4 py-0": e.noPadding
			}]),
			type: "button",
			onClick: r[0] ||= () => L(n)?.(e.name)
		}, [F(t.$slots, "header"), u(L(op), {
			class: "ml-auto self-center",
			"is-open": d.value
		}, null, 8, ["is-open"])], 10, sp)], 2), V(s("div", {
			id: l.value,
			"aria-labelledby": c.value,
			class: C(["border-t", {
				"py-4": !e.noPadding,
				"px-4": L(i)
			}]),
			role: "region"
		}, [F(t.$slots, "default")], 10, cp), [[he, d.value]])], 2));
	}
}), up = "myparcel:top-layer-change", dp = Symbol("tooltip"), fp = [
	"top",
	"left",
	"right",
	"bottom"
], pp = 0, mp = (e) => {
	let [t] = Object.keys(e);
	return fp.find((e) => e === t) ?? "bottom";
}, hp = async (e, t, n) => {
	let { x: r, y: i } = await Se(e, t, {
		placement: n,
		middleware: [
			we(8),
			Ce(),
			Te({ padding: 8 })
		]
	});
	Object.assign(t.style, {
		left: `${r}px`,
		top: `${i}px`
	});
}, gp = async (e, t, n) => {
	t.showPopover?.(), await hp(e, t, n);
}, _p = (e) => {
	e.hidePopover?.();
}, vp = (e, t) => {
	let n = `tooltip-${++pp}`, r = mp(t.modifiers), i = document.createElement("div");
	i.id = n, i.setAttribute("popover", "manual"), i.setAttribute("role", "tooltip"), i.textContent = t.value, i.className = "fixed bg-gray-900 px-2 py-1 rounded-full text-white text-xs pointer-events-none z-10 w-max m-0", i.style.inset = "unset", document.body.appendChild(i), e.setAttribute("aria-describedby", n);
	let a = () => gp(e, i, r), o = () => _p(i), s = (e) => {
		if (e.target.matches(":focus-visible")) return a();
	};
	e.addEventListener("mouseenter", a), e.addEventListener("mouseleave", o), e.addEventListener("focusin", s), e.addEventListener("focusout", o), window.addEventListener(up, o), e[dp] = {
		tooltipElement: i,
		cleanup: () => {
			e.removeEventListener("mouseenter", a), e.removeEventListener("mouseleave", o), e.removeEventListener("focusin", s), e.removeEventListener("focusout", o), window.removeEventListener(up, o);
		}
	};
}, yp = (e) => {
	let t = e[dp];
	t && (t.cleanup(), t.tooltipElement.remove(), e.removeAttribute("aria-describedby"), delete e[dp]);
}, bp = {
	mounted(e, t) {
		t.value && vp(e, t);
	},
	updated(e, t) {
		if (!t.value) {
			yp(e);
			return;
		}
		let n = e[dp];
		if (!n) {
			vp(e, t);
			return;
		}
		n.tooltipElement.textContent = t.value;
	},
	unmounted(e) {
		yp(e);
	}
}, xp = {
	Small: "small",
	Medium: "medium",
	Large: "large",
	None: "none"
}, Sp = {
	Danger: "danger",
	DangerBasic: "danger-basic",
	DangerLight: "danger-light",
	DangerOutline: "danger-outline",
	GrayOutline: "gray",
	None: "none",
	Primary: "primary",
	PrimaryBasic: "primary-basic",
	PrimaryLight: "primary-light",
	PrimaryOutline: "primary-outline",
	Secondary: "secondary",
	SecondaryBasic: "secondary-basic",
	SecondaryLight: "secondary-light",
	SecondaryOutline: "secondary-outline"
}, Cp = {
	Button: "button",
	Submit: "submit"
}, wp = (e) => {
	let t = {
		[Sp.Primary]: {
			base: "bg-primary border-primary text-white",
			hover: "hover:bg-primary-200 hover:border-primary-200"
		},
		[Sp.Secondary]: {
			base: "bg-secondary border-secondary text-white",
			hover: "hover:bg-secondary-200 hover:border-secondary-200"
		},
		[Sp.Danger]: {
			base: "bg-red border-red text-white",
			hover: "hover:bg-red-900 hover:border-red-900"
		},
		[Sp.PrimaryOutline]: {
			base: "border-primary text-primary",
			hover: "hover:border-primary-200 hover:bg-primary-200 hover:text-white"
		},
		[Sp.SecondaryOutline]: {
			base: "border-secondary text-secondary",
			hover: "hover:border-secondary-200 hover:bg-secondary-200 hover:text-white"
		},
		[Sp.DangerOutline]: {
			base: "border-red text-red",
			hover: "hover:border-red-900 hover:bg-red-900 hover:text-white"
		},
		[Sp.PrimaryBasic]: {
			base: "border-transparent text-primary",
			hover: "hover:text-primary-200"
		},
		[Sp.SecondaryBasic]: {
			base: "border-transparent text-secondary",
			hover: "hover:text-secondary-200"
		},
		[Sp.DangerBasic]: {
			base: "border-transparent text-red",
			hover: "hover:text-red-900"
		},
		[Sp.PrimaryLight]: {
			base: "border-primary bg-primary-light text-primary",
			hover: "hover:bg-primary hover:text-white"
		},
		[Sp.SecondaryLight]: {
			base: "border-secondary bg-secondary-light text-secondary",
			hover: "hover:bg-secondary hover:text-white"
		},
		[Sp.DangerLight]: {
			base: "border-red bg-red-100 text-red",
			hover: "hover:bg-red hover:text-white"
		},
		[Sp.GrayOutline]: {
			base: "bg-white border-gray-400 text-gray-800",
			hover: "hover:bg-neutral-100"
		},
		[Sp.None]: {
			base: "",
			hover: ""
		}
	};
	return t[e] ? [t[e].base, t[e].hover].join(" ") : "";
}, Tp = (e) => ({
	[xp.Small]: "text-xs leading-0 px-[6px] py-[1px]",
	[xp.Medium]: "text-md leading-6 py-[6px] px-[12px]",
	[xp.Large]: "text-md leading-6 py-3 px-6",
	[xp.None]: ""
})[e] ?? "", Ep = [
	"aria-controls",
	"aria-expanded",
	"aria-haspopup",
	"aria-label",
	"data-test",
	"disabled",
	"title",
	"type"
], Dp = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "Button",
	props: {
		disabled: { type: Boolean },
		size: { default: xp.Medium },
		type: { default: Cp.Button },
		variant: { default: Sp.Secondary },
		title: { default: void 0 },
		dataTest: { default: void 0 },
		ariaControls: { default: void 0 },
		ariaExpanded: {
			type: [Boolean, String],
			default: void 0
		},
		ariaHaspopup: {
			type: [Boolean, String],
			default: void 0
		},
		ariaLabel: { default: void 0 }
	},
	emits: ["click", "keydown"],
	setup(e) {
		let t = se(), n = r(() => {
			let { class: e, ...n } = t;
			return n;
		}), i = e, a = r(() => {
			let e = Tp(i.size), n = wp(i.variant), r = i.disabled ? "cursor-not-allowed bg-gray-200 text-gray-800 border border-gray-200" : n, a = i.variant === Sp.None ? "" : "duration-200 ease-in-out rounded-xl select-none whitespace-nowrap border border-solid";
			return _e(a, e, r, t.class);
		});
		return (t, r) => (A(), o("button", x(n.value, {
			"aria-controls": e.ariaControls,
			"aria-expanded": e.ariaExpanded,
			"aria-haspopup": e.ariaHaspopup,
			"aria-label": e.ariaLabel,
			class: a.value,
			"data-test": e.dataTest,
			disabled: e.disabled,
			title: e.title,
			type: e.type,
			onClick: r[0] ||= (e) => t.$emit("click", e),
			onKeydown: r[1] ||= (e) => t.$emit("keydown", e)
		}), [F(t.$slots, "default")], 16, Ep));
	}
}), Op = /* @__PURE__ */ f({
	__name: "ActionButton",
	props: {
		title: { default: void 0 },
		withTooltip: {
			type: Boolean,
			default: !1
		},
		withText: {
			type: Boolean,
			default: !1
		},
		variant: { default: "none" }
	},
	setup(e) {
		let t = e, n = [
			"action-button",
			"flex justify-center items-center relative",
			"border-y border-r bg-white group/action-button first:rounded-s-full first:border last:rounded-r-full last:border-r",
			"disabled:bg-transparent disabled:text-gray-800 disabled:cursor-not-allowed",
			"hover:bg-gray-200",
			{
				"min-h-8 h-fit text-xs pl-2 first:pl-3 pr-2": t.withText,
				"action-button--icon only:w-8 h-8 min-w-8 w-8 first:w-9 last:w-9": !t.withText
			}
		];
		return (t, r) => V((A(), i(Dp, {
			"aria-label": e.withTooltip ? e.title : void 0,
			class: C(n),
			title: e.withTooltip ? void 0 : e.title,
			variant: e.variant
		}, {
			default: B(() => [F(t.$slots, "default")]),
			_: 3
		}, 8, [
			"aria-label",
			"title",
			"variant"
		])), [[L(bp), e.withTooltip && !e.withText ? e.title : void 0]]);
	}
}), kp = { "data-test": "spinner" }, Ap = /* @__PURE__ */ f({
	__name: "Spinner",
	props: { size: { default: "medium" } },
	setup(e) {
		let t = e, n = {
			"extra-small": "0.15rem",
			small: "0.2rem",
			medium: "0.3rem"
		}, i = {
			"extra-small": "1rem",
			small: "1.5rem",
			medium: "3rem"
		}, a = r(() => ({
			borderWidth: n[t.size],
			width: i[t.size]
		}));
		return (e, t) => (A(), o("div", kp, [s("div", {
			class: "animate-spin-border aspect-square border-gray-400 rounded-full text-primary",
			"data-test": "spinner-border",
			style: T([{ "border-right-color": "currentColor" }, a.value])
		}, null, 4)]));
	}
}), jp = { class: "ml-2" }, Mp = /* @__PURE__ */ f({
	__name: "ActionButtonWithSpinner",
	props: {
		isLoading: { type: Boolean },
		title: { default: void 0 },
		withTooltip: {
			type: Boolean,
			default: !1
		},
		withText: {
			type: Boolean,
			default: !1
		},
		variant: { default: "none" }
	},
	setup(e) {
		let { isLoading: t, ...n } = e;
		return (e, r) => (A(), i(Op, w(h(n)), {
			default: B(() => [L(t) ? (A(), i(Ap, {
				key: 1,
				size: "extra-small"
			})) : F(e.$slots, "icon", {}, void 0, void 0, 0), s("span", jp, [F(e.$slots, "default")])]),
			_: 3
		}, 16));
	}
}), Np = {}, Pp = { class: "absolute bg-white border px-2 py-1 right-0 rounded-[10px] shadow-lg" };
function Fp(e, t) {
	return A(), o("div", Pp, [F(e.$slots, "default")]);
}
var Ip = /*#__PURE__*/ W(Np, [["render", Fp]]), Lp = { class: "action-button-wrapper flex justify-self-end" }, Rp = { class: "flex relative" }, zp = ["id", "aria-labelledby"], Bp = /* @__PURE__ */ f({
	__name: "ActionButtonWrapper",
	props: { popupDirection: {} },
	setup(e) {
		let t = le(), [n, r] = Fe(!1), c = () => r(!n.value), { t: l } = Re();
		return (d, f) => (A(), o("div", Lp, [s("div", Rp, [
			F(d.$slots, "default"),
			d.$slots.actionMenu ? V((A(), i(Op, {
				key: 0,
				id: `action-button-${L(t)}`,
				"aria-controls": `action-button-menu-${L(t)}`,
				"aria-expanded": L(n),
				"aria-haspopup": "menu",
				class: C(["action-menu-toggle rounded-r-full", { "bg-gray-200 !rounded-s-none": L(n) }]),
				title: L(l)("ui.actionMenu"),
				"with-tooltip": "",
				onClick: U(c, ["stop"])
			}, {
				default: B(() => [u(ap, null, {
					default: B(() => [u(Qs)]),
					_: 1
				})]),
				_: 1
			}, 8, [
				"id",
				"aria-controls",
				"aria-expanded",
				"class",
				"title"
			])), [[L(Ee), () => L(r)(!1)]]) : a("", !0),
			d.$slots.actionMenu ? (A(), o("div", {
				key: 1,
				id: `action-button-menu-${L(t)}`,
				"aria-labelledby": `action-button-${L(t)}`
			}, [V(u(Ip, {
				class: C(["!right-[30px] min-w-[180px] z-30 action-menu", {
					"-bottom-2": e.popupDirection === "top",
					"-top-2": e.popupDirection === "bottom"
				}]),
				role: "menu"
			}, {
				default: B(() => [F(d.$slots, "actionMenu")]),
				_: 3
			}, 8, ["class"]), [[he, L(n)]])], 8, zp)) : a("", !0)
		])]));
	}
}), Vp = {
	Stacked: "stacked",
	Inline: "inline"
}, Hp = /* @__PURE__ */ f({
	__name: "BlockActionButton",
	props: {
		layout: { default: Vp.Stacked },
		destructive: {
			type: Boolean,
			default: !1
		},
		disabled: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["click"],
	setup(e) {
		let t = e;
		return (n, r) => (A(), i(Dp, {
			class: C([
				"flex items-center",
				"disabled:cursor-not-allowed disabled:bg-transparent disabled:text-gray-800",
				{
					"flex-col justify-center gap-1 rounded-regular px-2 py-3 text-xs": t.layout === L(Vp).Stacked,
					"text-sm w-full gap-3 px-4 py-3 text-left hover:bg-gray-200 disabled:border-0": t.layout === L(Vp).Inline,
					"text-red": t.destructive,
					"text-black": !t.destructive
				}
			]),
			disabled: e.disabled,
			size: L(xp).None,
			variant: L(Vp).Stacked === t.layout ? L(Sp).GrayOutline : L(Sp).None,
			onClick: r[0] ||= (e) => n.$emit("click", e)
		}, {
			default: B(() => [n.$slots.icon ? (A(), o("span", {
				key: 0,
				"aria-hidden": "true",
				class: C(["flex shrink-0", { "text-primary": t.layout === L(Vp).Inline && !t.destructive }])
			}, [F(n.$slots, "icon")], 2)) : a("", !0), F(n.$slots, "default")]),
			_: 3
		}, 8, [
			"class",
			"disabled",
			"size",
			"variant"
		]));
	}
}), Up = { class: "-translate-x-1/2 absolute left-1/2 mx-auto w-min" }, Wp = /* @__PURE__ */ f({
	__name: "ButtonWithSpinner",
	props: {
		disabled: { type: Boolean },
		size: {},
		type: {},
		variant: {},
		title: {},
		ariaControls: {},
		ariaExpanded: { type: [Boolean, String] },
		ariaHaspopup: { type: [Boolean, String] },
		ariaLabel: {},
		isLoading: { type: Boolean }
	},
	setup(e) {
		return (t, n) => (A(), i(Dp, x(t.$props, {
			class: ["box-content relative", { "text-transparent": e.isLoading }],
			disabled: e.disabled || e.isLoading
		}), {
			default: B(() => [V(s("div", Up, [u(Ap, { size: "small" })], 512), [[he, e.isLoading]]), F(t.$slots, "default")]),
			_: 3
		}, 16, ["class", "disabled"]));
	}
}), Gp = {
	Normal: "0 0 16 16",
	Medium: "0 0 24 24",
	MediumLarge: "0 0 32 32",
	Large: "0 0 48 48",
	Social: "0 0 50 50",
	XLarge: "0 0 88 88",
	XXLarge: "0 0 200 200"
}, Kp = {
	Normal: 16,
	Medium: 24,
	MediumLarge: 32,
	Large: 48,
	Social: 50,
	XLarge: 88,
	XXLarge: 200
}, qp = [
	"aria-label",
	"height",
	"role",
	"viewBox",
	"width"
], Jp = /* @__PURE__ */ f({
	__name: "IconBase",
	props: {
		width: { default: void 0 },
		height: { default: void 0 },
		viewbox: { default: void 0 },
		size: { default: Kp.Normal },
		ariaLabel: { default: void 0 }
	},
	setup(e) {
		let t = se(), n = e, i = Object.entries(Kp).find(([, e]) => e === n.size)[0], a = r(() => String(n.height ?? Kp[i])), s = r(() => String(n.width ?? Kp[i])), c = r(() => String(n.viewbox ?? Gp[i])), l = r(() => n.ariaLabel ? "img" : "presentation");
		return (n, r) => (A(), o("svg", {
			"aria-label": e.ariaLabel,
			class: C(L(_e)("align-baseline inline-block overflow-visible", L(t).class)),
			height: a.value,
			role: l.value,
			viewBox: c.value,
			width: s.value,
			xmlns: "http://www.w3.org/2000/svg"
		}, [F(n.$slots, "default")], 10, qp));
	}
}), G = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, Yp = {}, Xp = {
	d: "M6.2 12.3C6.39257 12.1556 6.63078 12.0855 6.87089 12.1025C7.111 12.1196 7.33689 12.2227 7.50711 12.3929C7.67732 12.5631 7.78042 12.789 7.79748 13.0291C7.81455 13.2692 7.74443 13.5074 7.6 13.7L5.5 15.7C5.23945 15.8533 5.01705 16.0637 4.84951 16.3153C4.68197 16.567 4.57366 16.8533 4.53272 17.1528C4.49177 17.4524 4.51926 17.7573 4.61312 18.0447C4.70697 18.332 4.86475 18.5944 5.0746 18.812C5.28444 19.0296 5.54089 19.1968 5.82466 19.3011C6.10843 19.4053 6.41214 19.4439 6.71295 19.4138C7.01376 19.3838 7.30386 19.286 7.56142 19.1277C7.81898 18.9694 8.03731 18.7548 8.2 18.5L13 13.7C13.1832 13.5131 13.2859 13.2618 13.2859 13C13.2859 12.7382 13.1832 12.4869 13 12.3C12.8642 12.2219 12.7487 12.113 12.6628 11.982C12.5768 11.8511 12.5228 11.7018 12.5051 11.5461C12.4874 11.3905 12.5066 11.2329 12.561 11.086C12.6153 10.9391 12.7035 10.807 12.8183 10.7004C12.9331 10.5939 13.0713 10.5157 13.2218 10.4723C13.3723 10.429 13.5309 10.4216 13.6848 10.4507C13.8387 10.4798 13.9836 10.5447 14.1078 10.6402C14.2321 10.7356 14.3321 10.8588 14.4 11C14.9136 11.5392 15.2 12.2553 15.2 13C15.2 13.7447 14.9136 14.4608 14.4 15L9.6 20C8.85423 20.6418 7.89347 20.9779 6.91028 20.9411C5.92709 20.9043 4.99414 20.4973 4.29844 19.8016C3.60273 19.1059 3.19569 18.1729 3.15888 17.1897C3.12208 16.2065 3.45825 15.2458 4.1 14.5L6.1 12.5L6.2 12.3ZM17.8 11.7C17.6074 11.8444 17.3692 11.9145 17.1291 11.8975C16.889 11.8804 16.6631 11.7773 16.4929 11.6071C16.3227 11.4369 16.2196 11.211 16.2025 10.9709C16.1855 10.7308 16.2556 10.4926 16.4 10.3L18.4 8.3C18.6824 8.16428 18.9289 7.96412 19.1197 7.71567C19.3105 7.46721 19.4403 7.1774 19.4986 6.86959C19.5569 6.56179 19.5421 6.24459 19.4553 5.94357C19.3685 5.64254 19.2123 5.36611 18.9991 5.13654C18.7859 4.90697 18.5218 4.73069 18.228 4.6219C17.9343 4.51311 17.619 4.47486 17.3078 4.51022C16.9965 4.54559 16.6979 4.65358 16.436 4.8255C16.1741 4.99742 15.9562 5.22846 15.8 5.5L11 10.3C10.8168 10.4869 10.7141 10.7382 10.7141 11C10.7141 11.2618 10.8168 11.5131 11 11.7C11.1358 11.7781 11.2513 11.887 11.3372 12.018C11.4232 12.1489 11.4772 12.2982 11.4949 12.4539C11.5126 12.6095 11.4934 12.7671 11.439 12.914C11.3847 13.0609 11.2965 13.193 11.1817 13.2996C11.0669 13.4061 10.9287 13.4843 10.7782 13.5277C10.6277 13.571 10.4691 13.5784 10.3152 13.5493C10.1613 13.5202 10.0164 13.4553 9.89217 13.3598C9.76794 13.2644 9.66786 13.1412 9.6 13C9.08645 12.4608 8.8 11.7447 8.8 11C8.8 10.2553 9.08645 9.53923 9.6 9L14.4 4C15.1458 3.35825 16.1065 3.02208 17.0897 3.05888C18.0729 3.09568 19.0059 3.50273 19.7016 4.19844C20.3973 4.89414 20.8043 5.82709 20.8411 6.81028C20.8779 7.79347 20.5417 8.75423 19.9 9.5L17.9 11.5L17.8 11.7Z",
	fill: "currentColor"
};
function Zp(e, t) {
	return A(), o("path", Xp);
}
var Qp = /*#__PURE__*/ G(Yp, [["render", Zp]]), $p = {}, em = {
	"clip-rule": "evenodd",
	d: "M7.8 19C7.5 19 7.3 19 7.2 18.8L7 18.3V5.7C7 5.5 7 5.3 7.2 5.2L7.8 5H12.8C14.3 5 15.5 5.3 16.3 6C17 6.6 17.4 7.4 17.4 8.5C17.4223 9.18319 17.2106 9.85352 16.8 10.4C16.4 11 15.8 11.4 15.2 11.6C15.6 11.7 16.1 11.9 16.5 12.2C16.9 12.5 17.3 12.9 17.5 13.4C17.9 13.8 18 14.4 18 15C18 16.3 17.6 17.3 16.7 18C15.9 18.7 14.6 19 12.9 19H7.8ZM12.8 10.7C13.4 10.7 14 10.6 14.4 10.2C14.8 9.9 15 9.5 15 8.9C15 7.8 14.2 7.2 12.7 7.2H9.3V10.7H12.7H12.8ZM13.3 16.7C14 16.7 14.6 16.6 15 16.3C15.4 15.9 15.6 15.4 15.6 14.8C15.6 14.2 15.4 13.8 14.9 13.4C14.5 13.1 13.9 13 12.9 13H9.4V16.8H13.4L13.3 16.7Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function tm(e, t) {
	return A(), o("path", em);
}
var nm = /*#__PURE__*/ G($p, [["render", tm]]), rm = {}, im = {
	"clip-rule": "evenodd",
	d: "M1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM8 .5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM6 6.79v-.71h2.441v4.07H10v.707H6v-.706h1.625V6.79H6Zm1.638-1.633a.477.477 0 0 1-.12-.33c0-.071.011-.138.032-.2a.42.42 0 0 1 .25-.247.58.58 0 0 1 .208-.035c.076 0 .144.012.203.035a.38.38 0 0 1 .146.089.382.382 0 0 1 .106.154.58.58 0 0 1 .035.203.467.467 0 0 1-.124.331c-.082.089-.204.133-.366.133-.165 0-.289-.044-.371-.133Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function am(e, t) {
	return A(), o("path", im);
}
var om = /*#__PURE__*/ G(rm, [["render", am]]), sm = {}, cm = {
	d: "M12.5821 1.20263L21.0821 4.78152C21.6383 5.01572 22 5.56046 22 6.16398V17.836C22 18.4395 21.6383 18.9842 21.0821 19.2184L12.5821 22.7974C12.2099 22.9541 11.7901 22.9541 11.4179 22.7974L2.91791 19.2184C2.36169 18.9842 2 18.4395 2 17.836V6.16398C2 5.56046 2.3617 5.01572 2.91792 4.78152L11.4179 1.20263C11.7901 1.0459 12.2099 1.0459 12.5821 1.20263ZM11.806 2.12426L8.63748 3.45835L16.4999 6.95277L19.9841 5.40425L12.194 2.12426C12.07 2.07202 11.93 2.07202 11.806 2.12426ZM7.37309 3.99071L4.0159 5.40425L11.3908 8.68197C11.7786 8.85435 12.2214 8.85435 12.6092 8.68198L15.2688 7.49993L7.37309 3.99071ZM16 8.26927L13.0153 9.59579C12.8486 9.6699 12.6758 9.72489 12.5 9.76076V21.747L20.694 18.2968C20.8794 18.2187 21 18.0371 21 17.836V6.16398C21 6.12597 20.9957 6.08866 20.9875 6.05262L17 7.82483V11C17 11.2761 16.7761 11.5 16.5 11.5C16.2239 11.5 16 11.2761 16 11V8.26927ZM3.01253 6.05262C3.0043 6.08866 3 6.12597 3 6.16398V17.836C3 18.0371 3.12056 18.2187 3.30597 18.2968L11.5 21.747V9.76076C11.3242 9.72489 11.1514 9.6699 10.9847 9.59579L3.01253 6.05262Z",
	fill: "currentColor"
};
function lm(e, t) {
	return A(), o("path", cm);
}
var um = /*#__PURE__*/ G(sm, [["render", lm]]), dm = {}, fm = {
	"clip-rule": "evenodd",
	d: "M10 17H18C18.6 17 19 17.4 19 18C19 18.6 18.6 19 18 19H10C9.73478 19 9.48043 18.8946 9.29289 18.7071C9.10535 18.5196 9 18.2652 9 18C9 17.7348 9.10535 17.4804 9.29289 17.2929C9.48043 17.1054 9.73478 17 10 17ZM10 11H18C18.6 11 19 11.4 19 12C19 12.6 18.6 13 18 13H10C9.73478 13 9.48043 12.8946 9.29289 12.7071C9.10535 12.5196 9 12.2652 9 12C9 11.7348 9.10535 11.4804 9.29289 11.2929C9.48043 11.1054 9.73478 11 10 11ZM10 5H18C18.6 5 19 5.4 19 6C19 6.6 18.6 7 18 7H10C9.73478 7 9.48043 6.89464 9.29289 6.70711C9.10535 6.51957 9 6.26522 9 6C9 5.73478 9.10535 5.48043 9.29289 5.29289C9.48043 5.10536 9.73478 5 10 5ZM6 4V7.5C6 7.8 5.8 8 5.5 8C5.36739 8 5.24021 7.94732 5.14644 7.85355C5.05268 7.75979 5 7.63261 5 7.5V5H4.5C4.36739 5 4.24021 4.94732 4.14644 4.85355C4.05268 4.75979 4 4.63261 4 4.5C4 4.36739 4.05268 4.24021 4.14644 4.14645C4.24021 4.05268 4.36739 4 4.5 4H6ZM5 12.8L5.2 13H6.5C6.8 13 7 13.2 7 13.5C7 13.8 6.8 14 6.5 14H4.9C4.65247 13.9751 4.42311 13.8589 4.25669 13.674C4.09027 13.4891 3.99875 13.2488 4 13C4 12.6 4.3 12.2 4.6 12L5.8 11.6L6 11.3C6 11.247 5.97893 11.1961 5.94142 11.1586C5.90391 11.1211 5.85304 11.1 5.8 11.1H4.5C4.36739 11.1 4.24021 11.0473 4.14644 10.9536C4.05268 10.8598 4 10.7326 4 10.6C4 10.3 4.2 10.1 4.5 10.1H6.1C6.6 10.1 7 10.5 7 11.1V11.2C7 11.6 6.7 12 6.4 12.2L5.2 12.6L5 12.9V12.8ZM7 17V19C7 19.6 6.6 20 6 20H4.5C4.36739 20 4.24021 19.9473 4.14644 19.8536C4.05268 19.7598 4 19.6326 4 19.5C4 19.3674 4.05268 19.2402 4.14644 19.1464C4.24021 19.0527 4.36739 19 4.5 19H5.7C5.9 19 6 18.9 6 18.7C6 18.5 5.9 18.4 5.7 18.4H4.4C4.29391 18.4 4.19217 18.3579 4.11715 18.2828C4.04214 18.2078 4 18.1061 4 18C4 17.8939 4.04214 17.7922 4.11715 17.7172C4.19217 17.6421 4.29391 17.6 4.4 17.6H5.7C5.9 17.6 6 17.5 6 17.3C6 17.1 5.9 17 5.7 17H4.5C4.36739 17 4.24021 16.9473 4.14644 16.8536C4.05268 16.7598 4 16.6326 4 16.5C4 16.3674 4.05268 16.2402 4.14644 16.1464C4.24021 16.0527 4.36739 16 4.5 16H6C6.6 16 7 16.4 7 17Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function pm(e, t) {
	return A(), o("path", fm);
}
var mm = /*#__PURE__*/ G(dm, [["render", pm]]), hm = {}, gm = {
	d: "M1 6a5 5 0 1 1 10 0A5 5 0 0 1 1 6Zm5-6a6 6 0 1 0 3.874 10.582l4.272 4.272a.5.5 0 0 0 .708-.708l-4.272-4.272A6 6 0 0 0 6 0Z",
	fill: "currentColor"
};
function _m(e, t) {
	return A(), o("path", gm);
}
var vm = /*#__PURE__*/ G(hm, [["render", _m]]), ym = {}, bm = {
	"clip-rule": "evenodd",
	d: "M11 5H19C19.6 5 20 5.4 20 6C20 6.6 19.6 7 19 7H11C10.7348 7 10.4804 6.89464 10.2929 6.70711C10.1054 6.51957 10 6.26522 10 6C10 5.73478 10.1054 5.48043 10.2929 5.29289C10.4804 5.10536 10.7348 5 11 5ZM11 11H19C19.6 11 20 11.4 20 12C20 12.6 19.6 13 19 13H11C10.7348 13 10.4804 12.8946 10.2929 12.7071C10.1054 12.5196 10 12.2652 10 12C10 11.7348 10.1054 11.4804 10.2929 11.2929C10.4804 11.1054 10.7348 11 11 11ZM11 17H19C19.6 17 20 17.4 20 18C20 18.6 19.6 19 19 19H11C10.7348 19 10.4804 18.8946 10.2929 18.7071C10.1054 18.5196 10 18.2652 10 18C10 17.7348 10.1054 17.4804 10.2929 17.2929C10.4804 17.1054 10.7348 17 11 17ZM4.5 6C4.5 5.6 4.6 5.2 4.9 5C5.2 4.6 5.6 4.5 6 4.5C6.4 4.5 6.8 4.6 7 4.9C7.4 5.2 7.5 5.6 7.5 6C7.5 6.4 7.4 6.8 7.1 7C6.8 7.4 6.4 7.5 6 7.5C5.6 7.5 5.2 7.4 5 7.1C4.6 6.8 4.5 6.4 4.5 6ZM4.5 12C4.5 11.6 4.6 11.2 4.9 11C5.2 10.6 5.6 10.5 6 10.5C6.4 10.5 6.8 10.6 7 10.9C7.4 11.2 7.5 11.6 7.5 12C7.5 12.4 7.4 12.8 7.1 13C6.8 13.4 6.4 13.5 6 13.5C5.6 13.5 5.2 13.4 5 13.1C4.6 12.8 4.5 12.4 4.5 12ZM4.5 18C4.5 17.6 4.6 17.2 4.9 17C5.2 16.6 5.6 16.5 6 16.5C6.4 16.5 6.8 16.6 7 16.9C7.4 17.2 7.5 17.6 7.5 18C7.5 18.4 7.4 18.8 7.1 19C6.8 19.4 6.4 19.5 6 19.5C5.6 19.5 5.2 19.4 5 19.1C4.6 18.8 4.5 18.4 4.5 18Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function xm(e, t) {
	return A(), o("path", bm);
}
var Sm = /*#__PURE__*/ G(ym, [["render", xm]]), Cm = {}, wm = {
	"clip-rule": "evenodd",
	d: "M5 5H19C19.6 5 20 5.4 20 6C20 6.6 19.6 7 19 7H5C4.73478 7 4.48043 6.89464 4.29289 6.70711C4.10536 6.51957 4 6.26522 4 6C4 5.73478 4.10536 5.48043 4.29289 5.29289C4.48043 5.10536 4.73478 5 5 5ZM5 9H19C19.6 9 20 9.4 20 10C20 10.6 19.6 11 19 11H5C4.73478 11 4.48043 10.8946 4.29289 10.7071C4.10536 10.5196 4 10.2652 4 10C4 9.73478 4.10536 9.48043 4.29289 9.29289C4.48043 9.10536 4.73478 9 5 9ZM5 13H19C19.6 13 20 13.4 20 14C20 14.6 19.6 15 19 15H5C4.73478 15 4.48043 14.8946 4.29289 14.7071C4.10536 14.5196 4 14.2652 4 14C4 13.7348 4.10536 13.4804 4.29289 13.2929C4.48043 13.1054 4.73478 13 5 13ZM5 17H19C19.6 17 20 17.4 20 18C20 18.6 19.6 19 19 19H5C4.73478 19 4.48043 18.8946 4.29289 18.7071C4.10536 18.5196 4 18.2652 4 18C4 17.7348 4.10536 17.4804 4.29289 17.2929C4.48043 17.1054 4.73478 17 5 17Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function Tm(e, t) {
	return A(), o("path", wm);
}
var Em = /*#__PURE__*/ G(Cm, [["render", Tm]]), Dm = {};
function Om(t, n) {
	return A(), o(e, null, [n[0] ||= s("path", {
		d: "M19.5 19h-15c-.8 0-1.5-.7-1.5-1.5v-11C3 5.7 3.7 5 4.5 5h15c.8 0 1.5.7 1.5 1.5v11c0 .8-.7 1.5-1.5 1.5zM4.5 6c-.3 0-.5.2-.5.5v11c0 .3.2.5.5.5h15c.3 0 .5-.2.5-.5v-11c0-.3-.2-.5-.5-.5h-15z",
		fill: "currentColor"
	}, null, -1), n[1] ||= s("path", {
		d: "M17.5 9h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5zm-1 2h-4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h4c.3 0 .5.2.5.5s-.2.5-.5.5zm1 2h-5c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5s-.2.5-.5.5z",
		fill: "currentColor"
	}, null, -1)], 64);
}
var km = /*#__PURE__*/ G(Dm, [["render", Om]]), Am = {};
function jm(t, n) {
	return A(), o(e, null, [
		n[0] ||= s("path", {
			"clip-rule": "evenodd",
			d: "M 11.853 1.527 C 11.948 1.491 12.054 1.491 12.15 1.527 L 13.377 1.992 C 13.587 2.072 13.692 2.303 13.61 2.508 C 13.528 2.714 13.291 2.815 13.08 2.736 L 12.001 2.327 L 10.922 2.736 C 10.712 2.815 10.475 2.714 10.393 2.508 C 10.311 2.303 10.415 2.072 10.626 1.992 L 11.853 1.527 Z M 15.302 3.15 C 15.384 2.945 15.621 2.843 15.831 2.923 L 18.286 3.853 C 18.496 3.933 18.601 4.164 18.519 4.369 C 18.437 4.574 18.2 4.676 17.989 4.596 L 15.535 3.666 C 15.324 3.586 15.22 3.355 15.302 3.15 Z M 8.701 3.15 C 8.783 3.355 8.678 3.586 8.468 3.666 L 6.013 4.596 C 5.803 4.676 5.566 4.574 5.484 4.369 C 5.402 4.164 5.506 3.933 5.717 3.853 L 8.171 2.923 C 8.382 2.843 8.619 2.945 8.701 3.15 Z M 20.211 5.011 C 20.293 4.805 20.53 4.704 20.74 4.783 L 21.968 5.249 C 22.125 5.308 22.228 5.456 22.228 5.62 L 22.228 6.949 C 22.228 7.17 22.045 7.348 21.819 7.348 C 21.593 7.348 21.41 7.17 21.41 6.949 L 21.41 5.893 L 20.444 5.527 C 20.233 5.447 20.129 5.216 20.211 5.011 Z M 3.792 5.011 C 3.874 5.216 3.769 5.447 3.559 5.527 L 2.592 5.893 L 2.592 6.639 C 2.592 6.86 2.409 7.038 2.183 7.038 C 1.957 7.038 1.774 6.86 1.774 6.639 L 1.774 5.62 C 1.774 5.456 1.878 5.308 2.035 5.249 L 3.262 4.783 C 3.473 4.704 3.71 4.805 3.792 5.011 Z M 2.183 8.279 C 2.409 8.279 2.592 8.457 2.592 8.677 L 2.592 10.715 C 2.592 10.935 2.409 11.114 2.183 11.114 C 1.957 11.114 1.774 10.935 1.774 10.715 L 1.774 8.677 C 1.774 8.457 1.957 8.279 2.183 8.279 Z M 21.819 9.209 C 22.045 9.209 22.228 9.387 22.228 9.607 L 22.228 10.937 C 22.228 11.157 22.045 11.335 21.819 11.335 C 21.593 11.335 21.41 11.157 21.41 10.937 L 21.41 9.607 C 21.41 9.387 21.593 9.209 21.819 9.209 Z M 2.183 12.354 C 2.409 12.354 2.592 12.533 2.592 12.753 L 2.592 14.791 C 2.592 15.011 2.409 15.19 2.183 15.19 C 1.957 15.19 1.774 15.011 1.774 14.791 L 1.774 12.753 C 1.774 12.533 1.957 12.354 2.183 12.354 Z M 2.183 16.43 C 2.409 16.43 2.592 16.609 2.592 16.829 L 2.592 17.589 L 3.577 18.015 C 3.783 18.105 3.876 18.34 3.784 18.542 C 3.692 18.743 3.451 18.834 3.244 18.744 L 2.017 18.213 C 1.869 18.149 1.774 18.006 1.774 17.848 L 1.774 16.829 C 1.774 16.609 1.957 16.43 2.183 16.43 Z M 5.491 19.281 C 5.583 19.08 5.825 18.989 6.031 19.079 L 8.486 20.142 C 8.692 20.231 8.785 20.467 8.693 20.668 C 8.602 20.869 8.36 20.96 8.153 20.871 L 5.699 19.807 C 5.492 19.718 5.399 19.482 5.491 19.281 Z M 17.146 19.809 C 17.24 20.009 17.15 20.246 16.944 20.337 L 15.751 20.869 C 15.545 20.96 15.303 20.872 15.209 20.672 C 15.115 20.472 15.205 20.235 15.411 20.144 L 16.604 19.612 C 16.809 19.52 17.052 19.609 17.146 19.809 Z M 13.567 21.404 C 13.66 21.604 13.57 21.841 13.365 21.932 L 12.171 22.464 C 12.065 22.511 11.942 22.512 11.835 22.466 L 10.608 21.934 C 10.401 21.845 10.308 21.609 10.4 21.408 C 10.492 21.206 10.734 21.116 10.94 21.205 L 11.999 21.664 L 13.024 21.207 C 13.23 21.115 13.473 21.204 13.567 21.404 Z",
			fill: "currentColor",
			"fill-rule": "evenodd",
			transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
		}, null, -1),
		n[1] ||= s("path", {
			"clip-rule": "evenodd",
			d: "M 1.808 5.458 C 1.9 5.257 2.142 5.166 2.348 5.256 L 3.576 5.787 C 3.782 5.877 3.875 6.112 3.783 6.314 C 3.691 6.515 3.45 6.606 3.243 6.516 L 2.016 5.984 C 1.809 5.895 1.717 5.659 1.808 5.458 Z M 22.192 5.458 C 22.284 5.659 22.191 5.895 21.985 5.984 L 20.757 6.516 C 20.551 6.606 20.309 6.515 20.217 6.314 C 20.126 6.112 20.219 5.877 20.425 5.787 L 21.652 5.256 C 21.859 5.166 22.1 5.257 22.192 5.458 Z M 18.51 7.053 C 18.602 7.254 18.509 7.49 18.303 7.579 L 15.848 8.643 C 15.642 8.732 15.4 8.642 15.308 8.44 C 15.216 8.239 15.309 8.003 15.516 7.914 L 17.97 6.851 C 18.177 6.761 18.419 6.852 18.51 7.053 Z M 5.49 7.053 C 5.582 6.852 5.824 6.761 6.03 6.851 L 8.485 7.914 C 8.691 8.003 8.784 8.239 8.692 8.44 C 8.6 8.642 8.359 8.732 8.152 8.643 L 5.698 7.579 C 5.491 7.49 5.398 7.254 5.49 7.053 Z M 10.399 9.18 C 10.491 8.979 10.733 8.888 10.939 8.977 L 12 9.437 L 13.061 8.977 C 13.268 8.888 13.51 8.979 13.601 9.18 C 13.693 9.381 13.6 9.617 13.394 9.706 L 12.166 10.238 C 12.061 10.284 11.94 10.284 11.834 10.238 L 10.607 9.706 C 10.4 9.617 10.307 9.381 10.399 9.18 Z",
			fill: "currentColor",
			"fill-rule": "evenodd",
			transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
		}, null, -1),
		n[2] ||= s("path", {
			"clip-rule": "evenodd",
			d: "M 12.001 11.07 C 12.227 11.07 12.41 11.248 12.41 11.468 L 12.41 12.532 C 12.41 12.752 12.227 12.93 12.001 12.93 C 11.775 12.93 11.592 12.752 11.592 12.532 L 11.592 11.468 C 11.592 11.248 11.775 11.07 12.001 11.07 Z M 12.001 14.259 C 12.227 14.259 12.41 14.438 12.41 14.658 L 12.41 16.785 C 12.41 17.005 12.227 17.183 12.001 17.183 C 11.775 17.183 11.592 17.005 11.592 16.785 L 11.592 14.658 C 11.592 14.438 11.775 14.259 12.001 14.259 Z M 12.001 18.513 C 12.227 18.513 12.41 18.691 12.41 18.911 L 12.41 19.975 C 12.41 20.195 12.227 20.373 12.001 20.373 C 11.775 20.373 11.592 20.195 11.592 19.975 L 11.592 18.911 C 11.592 18.691 11.775 18.513 12.001 18.513 Z",
			fill: "currentColor",
			"fill-rule": "evenodd",
			transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
		}, null, -1),
		n[3] ||= s("path", {
			"clip-rule": "evenodd",
			d: "M 20.183 15.057 C 19.806 15.057 19.501 15.354 19.501 15.721 L 19.501 16.253 C 19.501 16.473 19.318 16.652 19.092 16.652 C 18.866 16.652 18.683 16.473 18.683 16.253 L 18.683 15.721 C 18.683 14.914 19.355 14.259 20.183 14.259 L 21.274 14.259 C 22.102 14.259 22.774 14.914 22.774 15.721 L 22.774 16.216 C 22.774 16.705 22.523 17.161 22.106 17.432 L 21.441 17.864 C 21.252 17.987 21.138 18.195 21.138 18.417 L 21.138 18.911 C 21.138 19.132 20.954 19.31 20.729 19.31 C 20.503 19.31 20.319 19.132 20.319 18.911 L 20.319 18.417 C 20.319 17.928 20.57 17.472 20.987 17.201 L 21.652 16.769 C 21.842 16.645 21.956 16.438 21.956 16.216 L 21.956 15.721 C 21.956 15.354 21.651 15.057 21.274 15.057 L 20.183 15.057 Z",
			fill: "currentColor",
			"fill-rule": "evenodd",
			transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
		}, null, -1),
		n[4] ||= s("path", {
			d: "M 20.183 20.506 C 20.183 20.213 20.427 19.975 20.729 19.975 C 21.03 19.975 21.274 20.213 21.274 20.506 C 21.274 20.8 21.03 21.038 20.729 21.038 C 20.427 21.038 20.183 20.8 20.183 20.506 Z",
			fill: "currentColor",
			transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, -3.552713678800501e-15, -8.881784197001252e-16)"
		}, null, -1)
	], 64);
}
var Mm = /*#__PURE__*/ G(Am, [["render", jm]]), Nm = {};
function Pm(t, n) {
	return A(), o(e, null, [n[0] ||= s("path", {
		"clip-rule": "evenodd",
		d: "M15 5C15.3105 5 15.6167 5.07229 15.8944 5.21115C16.1721 5.35 16.4137 5.55161 16.6 5.8L21 12L16.6 18.2C16.4137 18.4484 16.1721 18.65 15.8944 18.7889C15.6167 18.9277 15.3105 19 15 19H12V17H15L18.5 12L15 7H5V10H3V7C3 5.9 3.9 5 5 5H15Z",
		fill: "currentColor",
		"fill-rule": "evenodd"
	}, null, -1), n[1] ||= s("path", {
		"clip-rule": "evenodd",
		d: "M6 12C5.73478 12 5.48043 12.1054 5.29289 12.2929C5.10536 12.4804 5 12.7348 5 13V15H3C2.73478 15 2.48043 15.1054 2.29289 15.2929C2.10536 15.4804 2 15.7348 2 16C2 16.2652 2.10536 16.5196 2.29289 16.7071C2.48043 16.8946 2.73478 17 3 17H5V19C5 19.2652 5.10536 19.5196 5.29289 19.7071C5.48043 19.8946 5.73478 20 6 20C6.26522 20 6.51957 19.8946 6.70711 19.7071C6.89464 19.5196 7 19.2652 7 19V17H9C9.26522 17 9.51957 16.8946 9.70711 16.7071C9.89464 16.5196 10 16.2652 10 16C10 15.7348 9.89464 15.4804 9.70711 15.2929C9.51957 15.1054 9.26522 15 9 15H7V13C7 12.4 6.6 12 6 12Z",
		fill: "currentColor",
		"fill-rule": "evenodd"
	}, null, -1)], 64);
}
var Fm = /*#__PURE__*/ G(Nm, [["render", Pm]]), Im = {}, Lm = {
	"clip-rule": "evenodd",
	d: "M16.7 4.69995L16.6 5.59995H16.3C15.7 5.59995 15.3 5.59995 14.9 5.89995C14.6 6.19995 14.5 6.49995 14.4 6.99995L12.3 16.8V17.4C12.3 17.9 12.7 18.2 13.7 18.2H13.9L13.7 19H8L8.2 18.2H8.4C9.5 18.2 10.2 17.7 10.4 16.7L12.4 6.89995L12.5 6.39995C12.5 5.79995 12.1 5.59995 11.1 5.59995H10.8L11 4.69995H16.8H16.7Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function Rm(e, t) {
	return A(), o("path", Lm);
}
var zm = /*#__PURE__*/ G(Im, [["render", Rm]]), Bm = {}, Vm = {
	d: "M6.4 10H12C14.8 10 16.4 11.4 16.9 13.5C17.3 15.5 16.6 17.5 15.5 18.1C15.2613 18.2326 15.0851 18.4546 15.0101 18.7172C14.935 18.9797 14.9674 19.2613 15.1 19.5C15.2326 19.7387 15.4546 19.915 15.7172 19.99C15.9797 20.065 16.2613 20.0326 16.5 19.9C18.5 18.7 19.4 15.8 18.8 13.1C18.2 10.1 15.8 8.00002 12 8.00002H6.4L9.7 4.70002C9.81462 4.61406 9.90943 4.50447 9.97801 4.37868C10.0466 4.25289 10.0873 4.11383 10.0975 3.97091C10.1076 3.828 10.087 3.68458 10.0369 3.55035C9.98677 3.41612 9.90842 3.29423 9.80711 3.19292C9.7058 3.09161 9.58391 3.01325 9.44968 2.96315C9.31545 2.91305 9.17202 2.89238 9.02911 2.90254C8.8862 2.9127 8.74714 2.95344 8.62135 3.02202C8.49555 3.0906 8.38597 3.18541 8.3 3.30002L3.3 8.30002C3.11677 8.48695 3.01414 8.73827 3.01414 9.00002C3.01414 9.26178 3.11677 9.5131 3.3 9.70002L8.3 14.7C8.49257 14.8445 8.73078 14.9146 8.97089 14.8975C9.211 14.8804 9.4369 14.7773 9.60711 14.6071C9.77732 14.4369 9.88042 14.211 9.89749 13.9709C9.91455 13.7308 9.84443 13.4926 9.7 13.3L6.4 10Z",
	fill: "currentColor"
};
function Hm(e, t) {
	return A(), o("path", Vm);
}
var Um = /*#__PURE__*/ G(Bm, [["render", Hm]]), Wm = {}, Gm = {
	"clip-rule": "evenodd",
	d: "M5 5H19C19.6 5 20 5.4 20 6C20 6.6 19.6 7 19 7H5C4.73478 7 4.48043 6.89464 4.29289 6.70711C4.10536 6.51957 4 6.26522 4 6C4 5.73478 4.10536 5.48043 4.29289 5.29289C4.48043 5.10536 4.73478 5 5 5ZM8 9H16C16.6 9 17 9.4 17 10C17 10.6 16.6 11 16 11H8C7.73478 11 7.48043 10.8946 7.29289 10.7071C7.10536 10.5196 7 10.2652 7 10C7 9.73478 7.10536 9.48043 7.29289 9.29289C7.48043 9.10536 7.73478 9 8 9ZM8 17H16C16.6 17 17 17.4 17 18C17 18.6 16.6 19 16 19H8C7.73478 19 7.48043 18.8946 7.29289 18.7071C7.10536 18.5196 7 18.2652 7 18C7 17.7348 7.10536 17.4804 7.29289 17.2929C7.48043 17.1054 7.73478 17 8 17ZM5 13H19C19.6 13 20 13.4 20 14C20 14.6 19.6 15 19 15H5C4.73478 15 4.48043 14.8946 4.29289 14.7071C4.10536 14.5196 4 14.2652 4 14C4 13.7348 4.10536 13.4804 4.29289 13.2929C4.48043 13.1054 4.73478 13 5 13Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function Km(e, t) {
	return A(), o("path", Gm);
}
var qm = /*#__PURE__*/ G(Wm, [["render", Km]]), Jm = {};
function Ym(e, t) {
	return A(), o("g", null, [...t[0] ||= [
		s("g", null, [s("path", {
			d: "M16.6,122c-5.7,0-11.2-2.9-14.2-8.2c-4.6-7.9-1.9-17.9,6-22.5l102.6-59.6c7.9-4.6,17.9-1.9,22.5,6\n			c4.6,7.9,1.9,17.9-6,22.5L24.9,119.8C22.3,121.3,19.5,122,16.6,122z",
			fill: "#0F5C47"
		})], -1),
		s("g", null, [s("path", {
			d: "M68.1,151.6c-5.7,0-11.2-2.9-14.2-8.2c-4.6-7.9-1.9-17.9,6-22.5l51.3-29.8c7.9-4.6,17.9-1.9,22.5,6\n			c4.6,7.9,1.9,17.9-6,22.5l-51.3,29.8C73.8,150.8,70.9,151.6,68.1,151.6z",
			fill: "#0F5C47"
		})], -1),
		s("g", null, [s("path", {
			d: "M16.5,62.7c-5.7,0-11.2-2.9-14.2-8.2c-4.6-7.9-1.9-17.9,6-22.5L59.5,2.2c7.9-4.6,17.9-1.9,22.5,6\n			s1.9,17.9-6,22.5L24.7,60.5C22.1,62,19.3,62.7,16.5,62.7z",
			fill: "#0F5C47"
		})], -1)
	]]);
}
var Xm = /*#__PURE__*/ G(Jm, [["render", Ym]]), Zm = {}, Qm = {
	"clip-rule": "evenodd",
	d: "M5 5H19C19.6 5 20 5.4 20 6C20 6.6 19.6 7 19 7H5C4.73478 7 4.48043 6.89464 4.29289 6.70711C4.10536 6.51957 4 6.26522 4 6C4 5.73478 4.10536 5.48043 4.29289 5.29289C4.48043 5.10536 4.73478 5 5 5ZM5 9H13C13.6 9 14 9.4 14 10C14 10.6 13.6 11 13 11H5C4.73478 11 4.48043 10.8946 4.29289 10.7071C4.10536 10.5196 4 10.2652 4 10C4 9.73478 4.10536 9.48043 4.29289 9.29289C4.48043 9.10536 4.73478 9 5 9ZM5 17H13C13.6 17 14 17.4 14 18C14 18.6 13.6 19 13 19H5C4.73478 19 4.48043 18.8946 4.29289 18.7071C4.10536 18.5196 4 18.2652 4 18C4 17.7348 4.10536 17.4804 4.29289 17.2929C4.48043 17.1054 4.73478 17 5 17ZM5 13H19C19.6 13 20 13.4 20 14C20 14.6 19.6 15 19 15H5C4.73478 15 4.48043 14.8946 4.29289 14.7071C4.10536 14.5196 4 14.2652 4 14C4 13.7348 4.10536 13.4804 4.29289 13.2929C4.48043 13.1054 4.73478 13 5 13Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function $m(e, t) {
	return A(), o("path", Qm);
}
var eh = /*#__PURE__*/ G(Zm, [["render", $m]]), th = {}, nh = {
	d: "M17.6 10H12C9.2 10 7.6 11.4 7.1 13.5C6.7 15.5 7.4 17.5 8.5 18.1C8.73869 18.2326 8.91493 18.4546 8.98995 18.7172C9.06496 18.9797 9.03261 19.2613 8.9 19.5C8.76739 19.7387 8.54539 19.915 8.28284 19.99C8.02029 20.065 7.73869 20.0326 7.5 19.9C5.5 18.7 4.6 15.8 5.2 13.1C5.8 10.1 8.2 8.00002 12 8.00002H17.6L14.3 4.70002C14.1854 4.61406 14.0906 4.50447 14.022 4.37868C13.9534 4.25289 13.9127 4.11383 13.9025 3.97091C13.8924 3.828 13.913 3.68458 13.9631 3.55035C14.0132 3.41612 14.0916 3.29423 14.1929 3.19292C14.2942 3.09161 14.4161 3.01325 14.5503 2.96315C14.6846 2.91305 14.828 2.89238 14.9709 2.90254C15.1138 2.9127 15.2529 2.95344 15.3787 3.02202C15.5044 3.0906 15.614 3.18541 15.7 3.30002L20.7 8.30002C20.8832 8.48695 20.9859 8.73827 20.9859 9.00002C20.9859 9.26178 20.8832 9.5131 20.7 9.70002L15.7 14.7C15.5074 14.8445 15.2692 14.9146 15.0291 14.8975C14.789 14.8804 14.5631 14.7773 14.3929 14.6071C14.2227 14.4369 14.1196 14.211 14.1025 13.9709C14.0855 13.7308 14.1556 13.4926 14.3 13.3L17.6 10Z",
	fill: "currentColor"
};
function rh(e, t) {
	return A(), o("path", nh);
}
var ih = /*#__PURE__*/ G(th, [["render", rh]]), ah = {}, oh = {
	"clip-rule": "evenodd",
	d: "M19 5H5C4.4 5 4 5.4 4 6C4 6.6 4.4 7 5 7H19C19.2652 7 19.5196 6.89464 19.7071 6.70711C19.8946 6.51957 20 6.26522 20 6C20 5.73478 19.8946 5.48043 19.7071 5.29289C19.5196 5.10536 19.2652 5 19 5ZM19 9H11C10.4 9 10 9.4 10 10C10 10.6 10.4 11 11 11H19C19.2652 11 19.5196 10.8946 19.7071 10.7071C19.8946 10.5196 20 10.2652 20 10C20 9.73478 19.8946 9.48043 19.7071 9.29289C19.5196 9.10536 19.2652 9 19 9ZM19 17H11C10.4 17 10 17.4 10 18C10 18.6 10.4 19 11 19H19C19.2652 19 19.5196 18.8946 19.7071 18.7071C19.8946 18.5196 20 18.2652 20 18C20 17.7348 19.8946 17.4804 19.7071 17.2929C19.5196 17.1054 19.2652 17 19 17ZM19 13H5C4.4 13 4 13.4 4 14C4 14.6 4.4 15 5 15H19C19.2652 15 19.5196 14.8946 19.7071 14.7071C19.8946 14.5196 20 14.2652 20 14C20 13.7348 19.8946 13.4804 19.7071 13.2929C19.5196 13.1054 19.2652 13 19 13Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function sh(e, t) {
	return A(), o("path", oh);
}
var ch = /*#__PURE__*/ G(ah, [["render", sh]]), lh = {}, uh = {
	d: "M9.48891 6.77146L15.3142 3.05176e-05H13.9338L8.87569 5.87957L4.8358 3.05176e-05H0.17627L6.28537 8.89093L0.17627 15.9918H1.55676L6.89824 9.78283L11.1647 15.9918H15.8242L9.48857 6.77146H9.48891ZM7.59814 8.96926L6.97916 8.08393L2.05416 1.03924H4.17451L8.14904 6.72453L8.76802 7.60986L13.9344 14.9999H11.8141L7.59814 8.9696V8.96926Z",
	fill: "currentColor"
};
function dh(e, t) {
	return A(), o("path", uh);
}
var fh = /*#__PURE__*/ G(lh, [["render", dh]]), ph = {}, mh = {
	"clip-rule": "evenodd",
	d: "M8.354 5.646a.5.5 0 0 0-.708 0l-5 5a.5.5 0 1 0 .708.707L8 6.707l4.646 4.646a.5.5 0 0 0 .708-.707l-5-5Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function hh(e, t) {
	return A(), o("path", mh);
}
var gh = /*#__PURE__*/ G(ph, [["render", hh]]), _h = {}, vh = {
	"clip-rule": "evenodd",
	d: "M8.354 11.354a.5.5 0 0 1-.708 0l-5-5a.5.5 0 0 1 .708-.707L8 10.293l4.646-4.646a.5.5 0 0 1 .708.707l-5 5Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function yh(e, t) {
	return A(), o("path", vh);
}
var bh = /*#__PURE__*/ G(_h, [["render", yh]]), xh = {}, Sh = {
	d: "M14.854 1.146a.5.5 0 0 1 0 .708l-13 13a.5.5 0 0 1-.708-.708l1.985-1.984C2.19 11.388 1.468 10.5.964 9.77a12.752 12.752 0 0 1-.857-1.435 5.73 5.73 0 0 1-.045-.092L.05 8.218l-.003-.007-.002-.003L.5 8a42.876 42.876 0 0 1-.482-.132v-.002L.02 7.86l.004-.016a3.3 3.3 0 0 1 .08-.247 9.191 9.191 0 0 1 1.509-2.665C2.813 3.466 4.822 2 8 2c1.729 0 3.117.434 4.22 1.073l1.926-1.927a.5.5 0 0 1 .708 0ZM.5 8l-.455.207a.5.5 0 0 1-.027-.339L.5 8Zm5.055 1.738a3 3 0 0 1 4.184-4.184l1.745-1.745C10.567 3.326 9.424 3 8 3 5.178 3 3.436 4.284 2.387 5.567a8.192 8.192 0 0 0-1.339 2.362l-.01.031a11.752 11.752 0 0 0 .75 1.243c.483.702 1.17 1.539 2.054 2.248l1.713-1.713Zm.722-.722 2.74-2.74a2 2 0 0 0-2.74 2.74Zm7.998-3.435a.5.5 0 0 1 .691.147c.372.573.624 1.101.783 1.488a7.307 7.307 0 0 1 .229.636l.003.01v.004l.001.001v.001L15.5 8l.455.207v.002l-.003.005-.007.014a11.484 11.484 0 0 1-.486.89 12.883 12.883 0 0 1-1.464 1.968C12.697 12.514 10.698 14 8 14c-.37 0-.73-.028-1.075-.08a.5.5 0 0 1 .15-.99c.297.046.605.07.925.07 2.302 0 4.053-1.264 5.255-2.586a11.89 11.89 0 0 0 1.684-2.408l.024-.046a6.503 6.503 0 0 0-.138-.363 8.22 8.22 0 0 0-.698-1.325.5.5 0 0 1 .148-.691ZM15.5 8l.482-.132a.5.5 0 0 1-.027.339L15.5 8Z",
	fill: "currentColor"
};
function Ch(e, t) {
	return A(), o("path", Sh);
}
var wh = /*#__PURE__*/ G(xh, [["render", Ch]]), Th = {}, Eh = {
	"clip-rule": "evenodd",
	d: "M1.934 8.486a13.149 13.149 0 0 1-.367-.527 9.368 9.368 0 0 1 1.43-2.124C4.06 4.651 5.686 3.5 8 3.5s3.939 1.152 5.003 2.334a9.368 9.368 0 0 1 1.43 2.125 14.539 14.539 0 0 1-1.787 2.188C11.424 11.368 9.796 12.5 8 12.5c-1.796 0-3.424-1.131-4.646-2.354a14.538 14.538 0 0 1-1.42-1.66Zm13.494-.228L15 8l.429.257.127-.212-.092-.23L15 8l.464-.186v-.002l-.003-.004-.005-.014-.021-.049a9.048 9.048 0 0 0-.39-.773 10.364 10.364 0 0 0-1.298-1.806C12.56 3.848 10.686 2.5 8 2.5S3.439 3.848 2.253 5.166a10.368 10.368 0 0 0-1.61 2.406 6.066 6.066 0 0 0-.099.222l-.006.014-.001.004v.001H.535L1 8l-.464-.186-.092.23.127.213L1 8l-.429.258.001.001.003.004.007.013a5.364 5.364 0 0 0 .137.213 15.54 15.54 0 0 0 1.928 2.364C3.923 12.132 5.796 13.5 8 13.5c2.204 0 4.076-1.369 5.354-2.646a15.54 15.54 0 0 0 2.035-2.532l.029-.046.007-.013.003-.004v-.001ZM6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function Dh(e, t) {
	return A(), o("path", Eh);
}
var Oh = /*#__PURE__*/ G(Th, [["render", Dh]]), kh = {};
function Ah(t, n) {
	return A(), o(e, null, [
		n[0] ||= s("path", {
			d: "M 2.519 4.89 L 21.48 4.89 L 21.48 19.11 L 2.519 19.11 L 2.519 4.89 Z",
			fill: "#012169"
		}, null, -1),
		n[1] ||= s("path", {
			d: "M 4.741 4.89 L 11.97 10.253 L 19.169 4.89 L 21.48 4.89 L 21.48 6.727 L 14.37 12.029 L 21.48 17.303 L 21.48 19.11 L 19.109 19.11 L 11.999 13.809 L 4.918 19.11 L 2.519 19.11 L 2.519 17.333 L 9.598 12.061 L 2.519 6.787 L 2.519 4.89 L 4.741 4.89 Z",
			fill: "#FFF"
		}, null, -1),
		n[2] ||= s("path", {
			d: "M 15.08 13.215 L 21.48 17.927 L 21.48 19.11 L 13.451 13.215 L 15.08 13.215 Z M 9.629 13.809 L 9.806 14.845 L 4.118 19.11 L 2.519 19.11 L 9.629 13.809 Z M 21.48 4.89 L 21.48 4.98 L 14.103 10.548 L 14.163 9.246 L 19.998 4.89 L 21.48 4.89 Z M 2.519 4.89 L 9.598 10.104 L 7.822 10.104 L 2.519 6.135 L 2.519 4.89 Z",
			fill: "#C8102E"
		}, null, -1),
		n[3] ||= s("path", {
			d: "M 9.658 4.89 L 9.658 19.11 L 14.398 19.11 L 14.398 4.89 L 9.658 4.89 Z M 2.519 9.631 L 2.519 14.371 L 21.48 14.371 L 21.48 9.631 L 2.519 9.631 Z",
			fill: "#FFF"
		}, null, -1),
		n[4] ||= s("path", {
			d: "M 2.519 10.607 L 2.519 13.453 L 21.48 13.453 L 21.48 10.607 L 2.519 10.607 Z M 10.607 4.89 L 10.607 19.11 L 13.451 19.11 L 13.451 4.89 L 10.607 4.89 Z",
			fill: "#C8102E"
		}, null, -1)
	], 64);
}
var jh = /*#__PURE__*/ G(kh, [["render", Ah]]), Mh = {};
function Nh(t, n) {
	return A(), o(e, null, [n[0] ||= s("g", { "clip-path": "url(#clip0_2900_4456)" }, [
		s("rect", {
			fill: "#002654",
			height: "12",
			width: "6",
			x: "3",
			y: "6"
		}),
		s("rect", {
			fill: "white",
			height: "12",
			width: "6",
			x: "9",
			y: "6"
		}),
		s("rect", {
			fill: "#ED2939",
			height: "12",
			width: "6",
			x: "15",
			y: "6"
		})
	], -1), n[1] ||= s("defs", null, [s("clipPath", { id: "clip0_2900_4456" }, [s("rect", {
		fill: "white",
		height: "12",
		transform: "translate(3 6)",
		width: "18"
	})])], -1)], 64);
}
var Ph = /*#__PURE__*/ G(Mh, [["render", Nh]]), Fh = {};
function Ih(t, n) {
	return A(), o(e, null, [
		n[0] ||= s("rect", {
			fill: "#C8102E",
			height: "4",
			width: "18",
			x: "3",
			y: "6"
		}, null, -1),
		n[1] ||= s("rect", {
			fill: "white",
			height: "4",
			width: "18",
			x: "3",
			y: "10"
		}, null, -1),
		n[2] ||= s("rect", {
			fill: "#003DA5",
			height: "4",
			width: "18",
			x: "3",
			y: "14"
		}, null, -1)
	], 64);
}
var Lh = /*#__PURE__*/ G(Fh, [["render", Ih]]), Rh = {};
function zh(t, n) {
	return A(), o(e, null, [n[0] ||= s("g", { "clip-path": "url(#clip0_2900_4456)" }, [
		s("rect", {
			fill: "black",
			height: "12",
			width: "6",
			x: "3",
			y: "6"
		}),
		s("rect", {
			fill: "#F8D952",
			height: "12",
			width: "6",
			x: "9",
			y: "6"
		}),
		s("rect", {
			fill: "#DD4547",
			height: "12",
			width: "6",
			x: "15",
			y: "6"
		})
	], -1), n[1] ||= s("defs", null, [s("clipPath", { id: "clip0_2900_4456" }, [s("rect", {
		fill: "white",
		height: "12",
		transform: "translate(3 6)",
		width: "18"
	})])], -1)], 64);
}
var Bh = /*#__PURE__*/ G(Rh, [["render", zh]]), Vh = {};
function Hh(t, n) {
	return A(), o(e, null, [n[0] ||= s("rect", {
		fill: "#c60b1e",
		height: "12",
		style: {},
		width: "18",
		x: "3",
		y: "6"
	}, null, -1), n[1] ||= s("rect", {
		fill: "#ffc400",
		height: "6",
		style: {},
		width: "18",
		x: "3",
		y: "9.001"
	}, null, -1)], 64);
}
var Uh = /*#__PURE__*/ G(Vh, [["render", Hh]]), Wh = {};
function Gh(t, n) {
	return A(), o(e, null, [
		n[0] ||= s("rect", {
			fill: "#139149",
			height: "12",
			width: "6",
			x: "3",
			y: "6"
		}, null, -1),
		n[1] ||= s("rect", {
			fill: "white",
			height: "12",
			width: "6",
			x: "9",
			y: "6"
		}, null, -1),
		n[2] ||= s("rect", {
			fill: "#CC2E3B",
			height: "12",
			width: "6",
			x: "15",
			y: "6"
		}, null, -1)
	], 64);
}
var Kh = /*#__PURE__*/ G(Wh, [["render", Gh]]), qh = {};
function Jh(t, n) {
	return A(), o(e, null, [
		n[0] ||= s("rect", {
			fill: "black",
			height: "4",
			width: "18",
			x: "3",
			y: "6"
		}, null, -1),
		n[1] ||= s("rect", {
			fill: "#DD4547",
			height: "4",
			width: "18",
			x: "3",
			y: "10"
		}, null, -1),
		n[2] ||= s("rect", {
			fill: "#F8D952",
			height: "4",
			width: "18",
			x: "3",
			y: "14"
		}, null, -1)
	], 64);
}
var Yh = /*#__PURE__*/ G(qh, [["render", Jh]]), Xh = {}, Zh = {
	d: "M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8Z",
	fill: "currentColor"
};
function Qh(e, t) {
	return A(), o("path", Zh);
}
var $h = /*#__PURE__*/ G(Xh, [["render", Qh]]), eg = {}, tg = {
	d: "M18.854 5.147a.5.5 0 0 1 0 .707L12.707 12l6.147 6.146a.5.5 0 0 1-.708.708L12 12.707l-6.146 6.147a.5.5 0 1 1-.708-.707L11.293 12 5.146 5.854a.5.5 0 1 1 .707-.707L12 11.293l6.146-6.146a.5.5 0 0 1 .708 0Z",
	fill: "currentColor"
};
function ng(e, t) {
	return A(), o("path", tg);
}
var rg = /*#__PURE__*/ G(eg, [["render", ng]]), ig = {}, ag = {
	d: "M12.687 3.313a.5.5 0 0 1 0 .707L8.707 8l3.98 3.98a.5.5 0 0 1-.707.707L8 8.707l-3.98 3.98a.5.5 0 0 1-.707-.707L7.293 8l-3.98-3.98a.5.5 0 0 1 .707-.707L8 7.293l3.98-3.98a.5.5 0 0 1 .707 0Z",
	fill: "currentColor"
};
function og(e, t) {
	return A(), o("path", ag);
}
var sg = /*#__PURE__*/ G(ig, [["render", og]]), cg = {}, lg = {
	d: "M 14.234 2.731 C 14.922 2.916 15.466 3.461 15.651 4.149 C 15.99 5.402 16 8 16 8 C 16 8 16 10.608 15.661 11.851 C 15.476 12.539 14.932 13.083 14.244 13.268 C 13.001 13.607 8 13.607 8 13.607 C 8 13.607 2.999 13.607 1.756 13.268 C 1.068 13.083 0.524 12.539 0.339 11.851 C 0 10.598 0 8 0 8 C 0 8 0 5.402 0.329 4.159 C 0.513 3.471 1.058 2.927 1.746 2.742 C 2.988 2.403 7.99 2.393 7.99 2.393 C 7.99 2.393 12.991 2.393 14.234 2.731 Z M 10.547 8 L 6.398 5.597 L 6.398 10.403 L 10.547 8 Z",
	fill: "currentColor"
};
function ug(e, t) {
	return A(), o("path", lg);
}
var dg = /*#__PURE__*/ G(cg, [["render", ug]]), fg = {};
function pg(t, n) {
	return A(), o(e, null, [
		n[0] ||= s("path", {
			d: "M8.53 7.47a.75.75 0 0 0-1.06 1.06l1.06-1.06ZM7.47 8.53l6 6 1.06-1.06-6-6-1.06 1.06Z",
			fill: "currentColor"
		}, null, -1),
		n[1] ||= s("path", {
			d: "m5 37.5 7.571-5.5M24 41v-3M39 34l-3-2M39 9l-5 5",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-width": "1.5"
		}, null, -1),
		n[2] ||= s("circle", {
			cx: "24",
			cy: "24",
			fill: "transparent",
			r: "14",
			stroke: "currentColor",
			"stroke-width": "1.5"
		}, null, -1),
		n[3] ||= s("path", {
			"clip-rule": "evenodd",
			d: "M17.849 22.337a1.644 1.644 0 0 0 1.833.114l5.13-2.994a1.655 1.655 0 0 0 .55-2.233 1.65 1.65 0 0 0-2.204-.628l-5.133 2.991a1.653 1.653 0 0 0-.768 1.865c.095.353.302.664.592.885Zm1.023 6.294a1.644 1.644 0 0 1-1.591-1.224 1.66 1.66 0 0 1 .762-1.861l10.265-5.989a1.643 1.643 0 0 1 2.252.6 1.658 1.658 0 0 1-.597 2.261l-10.264 5.993a1.637 1.637 0 0 1-.827.22Zm5.15 2.969a1.644 1.644 0 0 1-1.591-1.224 1.66 1.66 0 0 1 .76-1.86l5.134-3a1.643 1.643 0 0 1 2.252.6 1.66 1.66 0 0 1-.597 2.26l-5.132 3a1.637 1.637 0 0 1-.826.224Z",
			fill: "currentColor",
			"fill-rule": "evenodd"
		}, null, -1),
		n[4] ||= s("circle", {
			cx: "43",
			cy: "37",
			fill: "transparent",
			r: "4",
			stroke: "currentColor",
			"stroke-width": "1.5"
		}, null, -1),
		n[5] ||= s("circle", {
			cx: "24",
			cy: "44",
			fill: "transparent",
			r: "3",
			stroke: "currentColor",
			"stroke-width": "1.5"
		}, null, -1),
		n[6] ||= s("circle", {
			cx: "6",
			cy: "6",
			fill: "transparent",
			r: "3",
			stroke: "currentColor",
			"stroke-width": "1.5"
		}, null, -1),
		n[7] ||= s("circle", {
			cx: "3",
			cy: "39",
			fill: "transparent",
			r: "2",
			stroke: "currentColor",
			"stroke-width": "1.5"
		}, null, -1),
		n[8] ||= s("circle", {
			cx: "42",
			cy: "6",
			fill: "transparent",
			r: "4",
			stroke: "currentColor",
			"stroke-width": "1.5"
		}, null, -1)
	], 64);
}
var mg = /*#__PURE__*/ G(fg, [["render", pg]]), hg = {};
function gg(t, n) {
	return A(), o(e, null, [n[0] ||= s("path", {
		"clip-rule": "evenodd",
		d: "M4.454 10h38.923a4.454 4.454 0 0 1 4.454 4.456v14.85a4.451 4.451 0 0 1-4.454 4.451h-13.96l1.911 4.697-8.433-4.697H4.448A4.453 4.453 0 0 1 0 29.305v-14.85A4.455 4.455 0 0 1 4.454 10Z",
		fill: "#7D57A4",
		"fill-rule": "evenodd"
	}, null, -1), n[1] ||= s("path", {
		d: "M2.408 14.034a1.611 1.611 0 0 1 1.223-.604c.993-.07 1.562.399 1.71 1.404.612 4.077 1.267 7.538 1.966 10.383l4.285-8.147c.387-.735.877-1.124 1.47-1.167.858-.06 1.395.486 1.61 1.64a36.454 36.454 0 0 0 1.85 6.68c.514-4.962 1.373-8.55 2.576-10.761a1.506 1.506 0 0 1 1.292-.866c.445-.037.887.101 1.233.386a1.505 1.505 0 0 1 .596 1.129c.032.325-.034.653-.188.941-.763 1.416-1.39 3.77-1.882 7.06-.486 3.178-.665 5.664-.539 7.457.045.44-.034.883-.227 1.28a1.23 1.23 0 0 1-1.041.706c-.516.037-1.03-.206-1.548-.725-1.817-1.864-3.26-4.636-4.329-8.318-1.255 2.51-2.196 4.387-2.824 5.632-1.148 2.209-2.132 3.341-2.951 3.398-.532.037-.985-.41-1.36-1.34-1.003-2.557-2.08-7.503-3.23-14.837a1.672 1.672 0 0 1 .308-1.331ZM44.424 17.106a4.535 4.535 0 0 0-3.125-2.259 5.225 5.225 0 0 0-1.061-.113c-1.873 0-3.402.975-4.59 2.924a10.386 10.386 0 0 0-1.519 5.505c0 1.506.314 2.797.942 3.872a4.527 4.527 0 0 0 3.126 2.26 5.07 5.07 0 0 0 1.06.114c1.891 0 3.42-.974 4.587-2.923a10.52 10.52 0 0 0 1.521-5.538c0-1.506-.314-2.787-.941-3.842Zm-2.466 5.423c-.267 1.28-.763 2.245-1.487 2.893-.573.516-1.1.726-1.577.631-.478-.095-.862-.517-1.15-1.265a5.047 5.047 0 0 1-.345-1.779 6.995 6.995 0 0 1 .143-1.434 6.449 6.449 0 0 1 1.032-2.323c.65-.955 1.329-1.356 2.036-1.203.478.097.861.517 1.148 1.261.22.567.337 1.17.343 1.777.003.485-.045.968-.143 1.442ZM32.173 17.106a4.537 4.537 0 0 0-3.125-2.259 5.226 5.226 0 0 0-1.061-.113c-1.874 0-3.403.975-4.588 2.924a10.371 10.371 0 0 0-1.52 5.505c0 1.506.313 2.797.94 3.872a4.516 4.516 0 0 0 3.127 2.26c.348.075.704.113 1.06.114 1.892 0 3.422-.974 4.59-2.923a10.54 10.54 0 0 0 1.533-5.538c0-1.506-.313-2.787-.941-3.842h-.015Zm-2.466 5.423c-.267 1.283-.764 2.248-1.49 2.897-.575.516-1.101.726-1.578.63-.477-.095-.86-.518-1.146-1.268a5.051 5.051 0 0 1-.345-1.779 6.995 6.995 0 0 1 .143-1.434 6.514 6.514 0 0 1 1.032-2.323c.647-.953 1.326-1.352 2.036-1.199.478.097.86.517 1.147 1.261.22.567.337 1.169.344 1.777.002.482-.046.962-.143 1.434v.004Z",
		fill: "#fff"
	}, null, -1)], 64);
}
var _g = /*#__PURE__*/ G(hg, [["render", gg]]), vg = {}, yg = {
	d: "M24 3L25.9244 6.36774C26.3093 7.06452 26.3093 7.91613 25.9244 8.6129L14.455 28.6258L19.8818 38.071C20.7285 39.5419 22.3065 40.471 24 40.471C25.6935 40.471 27.2715 39.5419 28.1182 38.071L33.545 28.6258L32.121 26.071L25.9629 36.7935C25.578 37.4903 24.8082 37.9161 24.0385 37.9161C23.2302 37.9161 22.499 37.4903 22.1141 36.7935L17.3801 28.6258L28.0412 10.0452L29.9656 13.4129C30.3505 14.1097 30.3505 14.9613 29.9656 15.6581L22.5375 28.6258L24 31.1806L32.0825 17.0903L37.3938 26.3419C38.2021 27.7742 38.2021 29.5161 37.3938 30.9484L32.0055 40.3548C31.1973 41.7871 28.6186 45 24 45C19.3814 45 16.8412 41.7871 15.9945 40.3548L10.6062 30.9484C9.79794 29.5161 9.79794 27.7742 10.6062 26.3419L24 3Z",
	fill: "#ED5153"
};
function bg(e, t) {
	return A(), o("path", yg);
}
var xg = /*#__PURE__*/ G(vg, [["render", bg]]), Sg = {};
function Cg(t, n) {
	return A(), o(e, null, [n[0] ||= s("g", { "clip-path": "url(#clip0_cscart_48)" }, [s("path", {
		d: "M47.52 16.92934V41.7454C47.52 44.7248 45.1062 47.1384 42.1268 47.1384H17.31072C14.33134 47.1384 11.9176 44.7248 11.9176 41.7454V16.92934C11.9176 13.94986 14.33134 11.53612 17.31072 11.53612H42.1268C45.1062 11.53612 47.52 13.94986 47.52 16.92934ZM6.85018 1.075562C3.87074 1.075562 1.457032 3.48928 1.457032 6.4687C1.457032 9.44812 3.87074 11.86186 6.85018 11.86186C9.8296 11.86186 12.2433 9.44812 12.2433 6.4687C12.2433 3.48928 9.8296 1.075562 6.85018 1.075562Z",
		fill: "url(#paint0_linear_cscart_48)"
	})], -1), n[1] ||= s("defs", null, [s("linearGradient", {
		id: "paint0_linear_cscart_48",
		x1: "8.26776",
		y1: "40.329",
		x2: "40.711",
		y2: "7.88564",
		gradientUnits: "userSpaceOnUse"
	}, [s("stop", { "stop-color": "#7381FD" }), s("stop", {
		offset: "1",
		"stop-color": "#76C7FF"
	})]), s("clipPath", { id: "clip0_cscart_48" }, [s("rect", {
		width: "48",
		height: "48",
		fill: "white"
	})])], -1)], 64);
}
var wg = /*#__PURE__*/ G(Sg, [["render", Cg]]), Tg = {};
function Eg(t, n) {
	return A(), o(e, null, [n[0] ||= s("g", { "clip-path": "url(#clip0_presta_24)" }, [
		s("path", {
			d: "M5.40493 19.3791C5.40022 19.3599 5.40022 19.3311 5.40022 19.2926C5.40022 19.0477 5.4803 18.8555 5.64044 18.721C5.80059 18.5817 5.97487 18.5144 6.16799 18.5144C6.42234 18.5144 6.60133 18.6105 6.70025 18.8075L5.40493 19.3791ZM7.26076 19.0332C7.25605 18.745 7.15243 18.5096 6.94047 18.3271C6.72851 18.1446 6.46473 18.0581 6.14444 18.0581C5.9419 18.0581 5.74878 18.1013 5.56979 18.1926C5.38609 18.2839 5.23536 18.4232 5.1129 18.6201C4.99043 18.8123 4.9292 19.0332 4.9292 19.2878C4.9292 19.6529 5.04695 19.9507 5.28247 20.1717C5.51798 20.3975 5.8053 20.508 6.13502 20.508C6.51184 20.508 6.84155 20.3638 7.11946 20.0708L6.83213 19.7442C6.66256 19.9507 6.44589 20.0564 6.18683 20.0564C5.92306 20.0564 5.71581 19.9603 5.56508 19.7682L7.26547 19.038L7.26076 19.0332Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M4.3637 18.2022C4.2271 18.2983 4.11877 18.4184 4.0434 18.5673V18.0869H3.54883V20.4695H4.03869V19.4512C4.03869 19.1822 4.09992 18.9612 4.22239 18.8027C4.34486 18.6393 4.52856 18.5625 4.76878 18.5625H4.79704L4.79233 18.0581C4.64631 18.0581 4.50029 18.1061 4.3637 18.2022Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M9.01775 19.2589C8.93768 19.2061 8.86702 19.1629 8.79637 19.134C8.72572 19.1052 8.65506 19.0764 8.58441 19.0524C8.50905 19.0284 8.42897 19.0043 8.33006 18.9803C8.23585 18.9563 8.16049 18.9323 8.10868 18.9035C8.03331 18.8698 7.99563 18.8122 7.99563 18.7353C7.99563 18.6489 8.03331 18.5816 8.10397 18.5384C8.17933 18.4952 8.27353 18.4711 8.39129 18.4711C8.61267 18.4711 8.81992 18.5336 9.00833 18.6633L9.19203 18.2934C8.95181 18.1301 8.69745 18.0532 8.42897 18.0532C8.16049 18.0532 7.93911 18.1205 7.77425 18.2502C7.60468 18.3847 7.5199 18.5576 7.5199 18.7786C7.5199 19.0908 7.76483 19.3166 8.24998 19.4511C8.2594 19.4559 8.27824 19.4607 8.3018 19.4703C8.61267 19.5664 8.76811 19.672 8.76811 19.7921C8.76811 19.8738 8.73514 19.941 8.6739 19.9891C8.60796 20.0419 8.52318 20.0659 8.41013 20.0659C8.15578 20.0659 7.89201 19.9603 7.61881 19.7537L7.3833 20.1428C7.52461 20.2581 7.68476 20.3445 7.86845 20.407C8.05215 20.4694 8.22643 20.5031 8.396 20.5031C8.64564 20.5031 8.85289 20.4358 9.01304 20.3013C9.17319 20.1668 9.25326 19.9843 9.25326 19.7585C9.25797 19.5327 9.1779 19.3694 9.01775 19.2589Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M2.5176 18.9083C2.41398 19.0188 2.21615 19.0765 1.93353 19.0765H1.33063V17.8227H1.85817C2.14078 17.8227 2.34332 17.8659 2.47521 17.9572C2.6071 18.0485 2.67304 18.1974 2.67304 18.4136C2.67304 18.6345 2.62123 18.7978 2.5176 18.9083ZM2.885 17.6162C2.67304 17.4336 2.3339 17.3423 1.86759 17.3423H0.8125V20.4695H1.33063V19.552H1.87701C2.32919 19.552 2.66362 19.4655 2.88029 19.2878C3.09696 19.1101 3.2053 18.8363 3.2053 18.4568C3.2053 18.0821 3.09696 17.7987 2.885 17.6162Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M10.4068 20.0756C10.3032 20.0756 10.2184 20.042 10.1619 19.9747C10.1054 19.9075 10.0724 19.8162 10.0724 19.7057V18.4952H10.6847V18.0917H10.0724V17.3423H9.58252V19.6865C9.58252 19.9363 9.65788 20.1381 9.8039 20.2822C9.94992 20.4311 10.1289 20.5031 10.3409 20.5031C10.5481 20.5031 10.7412 20.4263 10.9155 20.2678L10.713 19.9123C10.6141 20.0228 10.5104 20.0756 10.4068 20.0756Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M12.6543 19.8499C12.5177 19.994 12.3576 20.066 12.1645 20.066C11.9713 20.066 11.8018 19.994 11.6605 19.8499C11.5192 19.7057 11.4438 19.5232 11.4438 19.2926C11.4438 19.0621 11.5144 18.8747 11.6558 18.721C11.7971 18.5673 11.9619 18.4904 12.1597 18.4904C12.3576 18.4904 12.5224 18.5673 12.6543 18.721C12.7909 18.8747 12.8569 19.0621 12.8569 19.2878C12.8569 19.5184 12.7909 19.7057 12.6543 19.8499ZM12.8474 18.5048C12.6496 18.207 12.3953 18.0581 12.0891 18.0581C11.7829 18.0581 11.5144 18.1686 11.2884 18.3896C11.0623 18.6105 10.9492 18.9035 10.9492 19.2734C10.9492 19.6433 11.0576 19.9411 11.2789 20.1669C11.5003 20.3927 11.7547 20.508 12.0514 20.508C12.1974 20.508 12.3434 20.4695 12.4895 20.3975C12.6355 20.3254 12.7532 20.2197 12.8474 20.0804V20.4695H13.3373V18.0869H12.8474V18.5048Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M20.6236 19.8451C20.4823 19.9892 20.308 20.0612 20.0961 20.0612C19.8841 20.0612 19.7051 19.9892 19.5685 19.8451C19.4272 19.7009 19.3613 19.5136 19.3613 19.283C19.3613 19.0525 19.4319 18.8651 19.5685 18.721C19.7051 18.5769 19.8841 18.5048 20.0961 18.5048C20.308 18.5048 20.487 18.5769 20.6236 18.721C20.7602 18.8651 20.8309 19.0525 20.8309 19.283C20.8309 19.5136 20.7649 19.7009 20.6236 19.8451ZM20.0961 18.0581C19.7428 18.0581 19.4508 18.1782 19.22 18.4136C18.9845 18.649 18.8667 18.942 18.8667 19.283C18.8667 19.6241 18.9845 19.9171 19.22 20.1525C19.4555 20.3879 19.7475 20.508 20.0961 20.508C20.4446 20.508 20.7414 20.3879 20.9722 20.1525C21.2077 19.9171 21.3254 19.6241 21.3254 19.283C21.3254 18.942 21.2077 18.649 20.9722 18.4136C20.7367 18.1734 20.4446 18.0581 20.0961 18.0581Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M23.2945 19.8451C23.1532 19.9892 22.9836 20.0612 22.7905 20.0612C22.5974 20.0612 22.4325 19.9892 22.3007 19.8451C22.1641 19.7009 22.0981 19.5136 22.0981 19.2878C22.0981 19.0621 22.1641 18.8747 22.3007 18.721C22.4373 18.5721 22.6021 18.4952 22.7952 18.4952C22.9931 18.4952 23.1579 18.5721 23.2992 18.721C23.4405 18.8699 23.5112 19.0621 23.5112 19.2878C23.5065 19.5184 23.4358 19.7009 23.2945 19.8451ZM23.6666 18.3896C23.4452 18.1686 23.1768 18.0581 22.8659 18.0581C22.555 18.0581 22.3007 18.207 22.1075 18.5096V18.0917H21.6177V21.339H22.1075V20.1141C22.3431 20.3783 22.6068 20.508 22.8989 20.508C23.1909 20.508 23.45 20.3927 23.6713 20.1621C23.8927 19.9315 24.0011 19.6337 24.0011 19.2686C24.0011 18.9035 23.888 18.6057 23.6666 18.3896Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M17.7221 18.058C17.5573 18.058 17.4065 18.1012 17.2652 18.1829C17.1239 18.2646 17.0156 18.3798 16.9449 18.5288V17.1597H16.4551V20.4742H16.9449V19.1869C16.9449 18.9659 17.0062 18.7978 17.1334 18.6825C17.2605 18.5672 17.4065 18.5095 17.5761 18.5095C17.9341 18.5095 18.1131 18.7305 18.1131 19.1676V20.4742H18.6029V19.0139C18.6029 18.7017 18.5229 18.4663 18.358 18.303C18.1979 18.1397 17.9859 18.058 17.7221 18.058Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M15.8665 18.9707C15.7063 18.8314 15.4708 18.721 15.1552 18.6441C14.8396 18.5672 14.6371 18.4952 14.5382 18.4279C14.444 18.3607 14.3922 18.2646 14.3922 18.1349C14.3922 18.01 14.4393 17.9139 14.5382 17.8515C14.6324 17.7891 14.7596 17.7554 14.9103 17.7554C15.061 17.7554 15.2117 17.7843 15.3672 17.8371C15.5226 17.8899 15.6451 17.9572 15.7346 18.0436L16.0125 17.6449C15.8712 17.5249 15.7063 17.4336 15.5132 17.3663C15.3201 17.2991 15.127 17.2703 14.9291 17.2703C14.623 17.2703 14.3686 17.3471 14.1614 17.5056C13.9541 17.6642 13.8505 17.8851 13.8505 18.1733C13.8505 18.4616 13.94 18.6777 14.1237 18.817C14.2132 18.8939 14.3168 18.9515 14.4346 18.9996C14.5523 19.0476 14.7219 19.0956 14.948 19.1533C15.1741 19.2061 15.3295 19.2686 15.4237 19.3358C15.5179 19.4031 15.5603 19.4991 15.5603 19.6192C15.5603 19.7393 15.5132 19.8354 15.4143 19.9123C15.3154 19.9843 15.1835 20.0227 15.0186 20.0227C14.6842 20.0227 14.3639 19.8834 14.053 19.6096L13.728 20.0083C14.1001 20.3446 14.5241 20.5127 15.0045 20.5127C15.3342 20.5127 15.598 20.4262 15.8005 20.2581C16.0031 20.09 16.102 19.869 16.102 19.5952C16.102 19.3214 16.0266 19.1101 15.8665 18.9707Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M9.91655 12.5723C10.0296 12.5195 10.1426 12.4763 10.2604 12.4282C10.3923 12.3802 10.5242 12.3322 10.6561 12.2889C10.8209 12.2361 10.9905 12.1929 11.16 12.1544C11.3908 12.1064 11.6217 12.068 11.8525 12.0439C11.7206 12.4619 11.5793 12.8798 11.4191 13.2929C11.4238 13.3746 11.4285 13.4514 11.4332 13.5331C11.7488 13.4706 12.0738 13.437 12.4083 13.437C12.7427 13.437 13.0677 13.4706 13.3833 13.5331C13.3833 13.4514 13.388 13.3697 13.3974 13.2929C13.242 12.8798 13.096 12.4619 12.9641 12.0439C13.1949 12.068 13.4304 12.1016 13.6565 12.1544C13.826 12.1929 13.9909 12.2361 14.1605 12.2889C14.2923 12.3322 14.4242 12.3754 14.5561 12.4282C14.6739 12.4715 14.7869 12.5195 14.9 12.5723C15.7007 12.9374 16.4308 13.4754 17.029 14.1768C18.5316 12.8558 19.483 10.9007 19.483 8.71504C19.483 4.73284 16.3177 1.5 12.4083 1.5C8.50348 1.5 5.3335 4.72803 5.3335 8.71504C5.3335 10.8959 6.28496 12.851 7.78752 14.1768C8.38572 13.4754 9.11581 12.9374 9.91655 12.5723Z",
			fill: "#A0DBE8"
		}),
		s("path", {
			d: "M10.3825 13.8789C10.7123 13.73 11.0655 13.6147 11.4282 13.5427C11.4282 13.461 11.4235 13.3793 11.4141 13.3025C11.5695 12.8894 11.7155 12.4714 11.8474 12.0535C11.6166 12.0775 11.3811 12.1112 11.155 12.164C10.9855 12.2024 10.8206 12.2457 10.651 12.2985C10.5191 12.3417 10.3873 12.385 10.2554 12.4378L10.7688 12.5675L10.3825 13.8789Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M9.16752 14.6523C9.18165 14.5178 9.18636 14.3833 9.18636 14.244C9.18636 14.1623 9.25231 14.0951 9.33238 14.0951H9.45956L9.91174 12.5675C9.111 12.9326 8.38091 13.4706 7.78271 14.1719C8.11243 14.4649 8.47041 14.7243 8.84723 14.9501C8.95556 14.8492 9.05919 14.7483 9.16752 14.6523Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M14.895 12.5723L15.3472 14.0999H15.4744C15.5545 14.0999 15.6204 14.1671 15.6204 14.2488C15.6204 14.3881 15.6298 14.5226 15.6392 14.6571C15.7476 14.7532 15.8559 14.8492 15.9548 14.9549C16.3363 14.7292 16.6896 14.4698 17.0193 14.1767C16.4258 13.4754 15.6958 12.9374 14.895 12.5723Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M14.0327 12.558L14.5462 12.4283C14.4143 12.3803 14.2824 12.3322 14.1505 12.289C13.9856 12.2362 13.8161 12.1929 13.6465 12.1545C13.4157 12.1065 13.1849 12.068 12.9541 12.044C13.086 12.4619 13.2273 12.8798 13.3874 13.2929C13.3827 13.3746 13.378 13.4515 13.3733 13.5331C13.7407 13.6052 14.0893 13.7205 14.419 13.8694L14.0327 12.558Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M12.4034 14.0999H13.4019C13.3831 13.9125 13.3737 13.7252 13.3784 13.5427C13.0628 13.4802 12.7378 13.4466 12.4034 13.4466C12.0689 13.4466 11.7439 13.4802 11.4283 13.5427C11.433 13.73 11.4236 13.9125 11.4048 14.0999H12.4034Z",
			fill: "black"
		}),
		s("path", {
			d: "M8.85205 14.9501C8.93212 14.9981 9.01691 15.0462 9.10169 15.0942C9.12995 14.9501 9.15351 14.8012 9.16764 14.6523C9.0593 14.7484 8.95568 14.8492 8.85205 14.9501Z",
			fill: "black"
		}),
		s("path", {
			d: "M10.3169 14.0999H11.4097C11.4285 13.9125 11.4379 13.7252 11.4332 13.5427C11.0658 13.6147 10.7173 13.73 10.3875 13.8789L10.3169 14.0999Z",
			fill: "black"
		}),
		s("path", {
			d: "M15.644 14.6523C15.6582 14.8012 15.6817 14.9501 15.71 15.0942C15.7948 15.051 15.8748 15.0029 15.9596 14.9501C15.856 14.8492 15.7524 14.7484 15.644 14.6523Z",
			fill: "black"
		}),
		s("path", {
			d: "M14.4946 14.0999L14.4287 13.8789C14.099 13.73 13.7457 13.6147 13.383 13.5427C13.3783 13.73 13.3877 13.9125 13.4066 14.0999H14.4946Z",
			fill: "black"
		}),
		s("path", {
			d: "M10.3164 14.0999L10.3824 13.8789L10.7733 12.5579L10.2599 12.4282C10.1421 12.4715 10.0291 12.5195 9.91605 12.5723L9.46387 14.0999H9.94902H10.3164Z",
			fill: "#AA9678"
		}),
		s("path", {
			d: "M14.429 13.8789L14.495 14.0999H14.8624H15.3475L14.8953 12.5723C14.7823 12.5195 14.6693 12.4763 14.5515 12.4282L14.0381 12.5579L14.429 13.8789Z",
			fill: "#AA9678"
		}),
		s("path", {
			d: "M9.47852 14.4074C9.48325 14.4025 9.48798 14.4025 9.49272 14.3977H9.47852C9.47852 14.3977 9.47852 14.4025 9.47852 14.4074Z",
			fill: "#C0B098"
		}),
		s("path", {
			d: "M12.4035 14.3977H11.3625H10.2274H9.49258C9.48787 14.4025 9.48316 14.4025 9.47845 14.4073C9.46903 14.6907 9.43135 14.9645 9.37012 15.2335C10.2886 15.6803 11.3154 15.9301 12.4035 15.9301V14.3977Z",
			fill: "#C0B098"
		}),
		s("path", {
			d: "M15.333 14.3977H15.3188C15.3236 14.4025 15.3283 14.4025 15.333 14.4074C15.333 14.4025 15.333 14.3977 15.333 14.3977Z",
			fill: "#AA9678"
		}),
		s("path", {
			d: "M15.319 14.3977H14.5842H13.4443H12.4033V15.9301C13.4867 15.9301 14.5182 15.6803 15.4367 15.2335C15.3755 14.9645 15.3378 14.6859 15.3284 14.4073C15.3284 14.4025 15.3237 14.3977 15.319 14.3977Z",
			fill: "#AA9678"
		}),
		s("path", {
			d: "M15.6439 14.6523C15.6298 14.5178 15.6251 14.3832 15.6251 14.2439C15.6251 14.1623 15.5591 14.095 15.479 14.095H15.3519H14.8573H14.4899H13.3971H12.3986H11.4H10.3072H9.93981H9.45466H9.32748C9.24741 14.095 9.18146 14.1623 9.18146 14.2439C9.18146 14.3832 9.17204 14.5178 9.16262 14.6523C9.14849 14.8012 9.12494 14.9501 9.09668 15.0942C9.18617 15.1422 9.27567 15.1903 9.36516 15.2335C9.4264 14.9645 9.46408 14.6859 9.4735 14.4073C9.4735 14.4025 9.4735 14.4025 9.4735 14.3977H9.48763H10.2224H11.3576H12.3986H13.4442H14.5794H15.3142H15.3283C15.3283 14.4025 15.3283 14.4025 15.3283 14.4073C15.3377 14.6907 15.3754 14.9645 15.4366 15.2335C15.5261 15.1903 15.6156 15.1422 15.7051 15.0942C15.6769 14.9501 15.658 14.8012 15.6439 14.6523Z",
			fill: "#8B7460"
		}),
		s("path", {
			d: "M14.4291 13.0674C14.4054 13.0433 14.3865 13.0143 14.3628 12.9854C14.3865 13.0191 14.4101 13.0433 14.4291 13.0674Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M17.1133 7.11055C17.0521 7.02409 16.9909 6.94723 16.9297 6.87998C16.9014 6.84635 16.8731 6.81753 16.8449 6.78871C16.8354 6.7791 16.8213 6.7695 16.8119 6.75989C16.7931 6.74067 16.7742 6.72626 16.7554 6.71185V7.38436L17.005 8.56125C17.0097 8.57085 17.0097 8.58046 17.0144 8.59007L17.1887 8.79182H17.3724C17.3724 8.77261 17.3724 8.7582 17.3724 8.73898C17.3724 8.18176 17.2829 7.64856 17.1228 7.14898C17.1181 7.12977 17.1181 7.12016 17.1133 7.11055Z",
			fill: "#BBBCBD"
		}),
		s("path", {
			d: "M17.0337 8.67176V8.67656C17.0337 8.67656 17.0337 8.67656 17.0337 8.68136C17.0384 8.71018 17.0384 8.73901 17.0384 8.76783C17.0384 8.77263 17.0384 8.77744 17.0384 8.78224C17.0384 8.78704 17.0384 8.79185 17.0384 8.79665C17.0384 8.82547 17.0384 8.85429 17.0337 8.87831V8.88312V8.88792C17.029 8.91674 17.0242 8.94556 17.0195 8.97438L17.1938 8.77744L17.0195 8.57568C17.0242 8.60931 17.029 8.63813 17.0337 8.67176Z",
			fill: "#676A6A"
		}),
		s("path", {
			d: "M17.0285 8.89747C17.0285 8.89267 17.0285 8.89267 17.0285 8.88787C17.0332 8.85905 17.0332 8.83022 17.0332 8.80621C17.0332 8.8014 17.0332 8.79179 17.0332 8.78699C17.0332 8.78219 17.0332 8.77738 17.0332 8.76778C17.0332 8.73895 17.0332 8.71013 17.0285 8.68131C17.0285 8.67651 17.0285 8.67651 17.0285 8.6717C17.0238 8.64288 17.019 8.61406 17.0143 8.58524C17.0096 8.57563 17.0096 8.56602 17.0049 8.55642C16.9861 8.49877 16.9672 8.45074 16.939 8.40751C16.9343 8.4027 16.9295 8.3979 16.9295 8.39309C16.9201 8.38349 16.9154 8.37388 16.906 8.36427C16.8966 8.34986 16.8824 8.34025 16.8683 8.33065C16.8636 8.32584 16.8589 8.32584 16.8542 8.32104C16.8448 8.31143 16.8306 8.30663 16.8212 8.30183C16.8165 8.30183 16.8118 8.29702 16.8071 8.29702C16.793 8.29222 16.7741 8.28741 16.7553 8.28741C16.7364 8.28741 16.7223 8.29222 16.7035 8.29702C16.6987 8.29702 16.694 8.30183 16.6893 8.30183C16.6799 8.30663 16.6658 8.31143 16.6564 8.32104C16.6516 8.32584 16.6469 8.32584 16.6422 8.33065C16.6281 8.34025 16.6187 8.35467 16.6045 8.36427C16.5951 8.37388 16.5904 8.38349 16.581 8.39309C16.5763 8.3979 16.5716 8.4027 16.5716 8.40751C16.5433 8.45074 16.5198 8.49877 16.5056 8.55642V8.56122C16.4962 8.58524 16.4915 8.61406 16.4868 8.64288C16.4868 8.65249 16.4821 8.65729 16.4821 8.6669C16.4774 8.70053 16.4774 8.72935 16.4727 8.76297C16.4727 8.76778 16.4727 8.77258 16.4727 8.77738C16.4727 9.05119 16.5998 9.27696 16.7553 9.27696C16.7835 9.27696 16.8071 9.26735 16.8353 9.25775C16.8401 9.25775 16.8448 9.25294 16.8495 9.25294C16.8589 9.24814 16.8683 9.23853 16.8777 9.23373C16.8824 9.22892 16.8872 9.22412 16.8919 9.21932C16.906 9.20971 16.9154 9.1953 16.9295 9.18089C16.939 9.17128 16.9437 9.16167 16.9531 9.14726C16.9578 9.13766 16.9625 9.13285 16.9672 9.12324C16.9767 9.10883 16.9814 9.09442 16.9908 9.07521C16.9955 9.0704 16.9955 9.0656 17.0002 9.05599C17.0096 9.03198 17.0143 9.00796 17.0238 8.98394C17.0238 8.95512 17.0285 8.9263 17.0285 8.89747ZM16.7647 8.71494C16.7035 8.71494 16.6564 8.63328 16.6564 8.5276C16.6564 8.42672 16.7035 8.34025 16.7647 8.34025C16.8259 8.34025 16.873 8.42192 16.873 8.5276C16.873 8.63328 16.8212 8.71494 16.7647 8.71494Z",
			fill: "black"
		}),
		s("path", {
			d: "M16.7646 8.71495C16.8244 8.71495 16.8729 8.63108 16.8729 8.52761C16.8729 8.42415 16.8244 8.34027 16.7646 8.34027C16.7048 8.34027 16.6562 8.42415 16.6562 8.52761C16.6562 8.63108 16.7048 8.71495 16.7646 8.71495Z",
			fill: "white"
		}),
		s("path", {
			d: "M16.501 8.5564C16.5198 8.49876 16.5387 8.45072 16.5669 8.40749C16.5716 8.40269 16.5763 8.39788 16.5763 8.39308C16.5858 8.38347 16.5905 8.37387 16.5999 8.36426C16.6093 8.34985 16.6234 8.34024 16.6376 8.33063C16.6423 8.32583 16.647 8.32583 16.6517 8.32103C16.6611 8.31142 16.6753 8.30662 16.6847 8.30181C16.6894 8.30181 16.6941 8.29701 16.6988 8.29701C16.7129 8.2922 16.7318 8.2874 16.7506 8.2874C16.7695 8.2874 16.7836 8.2922 16.8024 8.29701C16.8071 8.29701 16.8119 8.30181 16.8166 8.30181C16.826 8.30662 16.8401 8.31142 16.8495 8.32103C16.8542 8.32583 16.859 8.32583 16.8637 8.33063C16.8778 8.34024 16.8872 8.35465 16.9013 8.36426C16.9108 8.37387 16.9155 8.38347 16.9249 8.39308C16.9296 8.39788 16.9343 8.40269 16.9343 8.40749C16.9626 8.45072 16.9861 8.49876 17.0003 8.5564L16.7506 7.37952L16.501 8.5564Z",
			fill: "#909393"
		}),
		s("path", {
			d: "M13.4158 8.77268C13.4158 8.74867 13.4158 8.72465 13.4111 8.70063C13.4064 8.67661 13.4064 8.6574 13.4017 8.63338C13.397 8.60936 13.3923 8.59015 13.3829 8.57093C13.3781 8.55172 13.3687 8.5277 13.3593 8.50849C13.3499 8.48927 13.3405 8.47006 13.331 8.45084C13.2981 8.3932 13.2604 8.34036 13.2133 8.29713C13.1521 8.23948 13.0814 8.19145 13.006 8.15782C12.9684 8.14341 12.926 8.129 12.8883 8.11939C12.8883 8.11939 12.8883 8.11939 12.8836 8.11939C12.8412 8.10978 12.7988 8.10498 12.7564 8.10498C12.714 8.10498 12.6716 8.10978 12.6292 8.11939H12.6245C12.5821 8.129 12.5444 8.13861 12.5068 8.15302C12.5068 8.15302 12.5068 8.15302 12.502 8.15302C12.4644 8.16743 12.4267 8.18664 12.3937 8.21066C12.3607 8.23468 12.3278 8.2587 12.2995 8.28752H12.2948C12.2477 8.33555 12.2053 8.38839 12.1723 8.44604C12.1629 8.46525 12.1535 8.48447 12.1441 8.50368C12.1441 8.50368 12.1441 8.50849 12.1394 8.50849C12.1299 8.5277 12.1252 8.54211 12.1205 8.56132C12.1205 8.56613 12.1158 8.56613 12.1158 8.57093C12.1111 8.59015 12.1064 8.60456 12.1017 8.62377C12.1017 8.62858 12.097 8.63338 12.097 8.63818C12.0923 8.6574 12.0923 8.67181 12.0875 8.69102C12.0875 8.69583 12.0875 8.70063 12.0828 8.70543C12.0828 8.72945 12.0781 8.75347 12.0781 8.77749C12.0781 8.82072 12.0828 8.86395 12.0923 8.90718C12.0923 8.90718 12.0923 8.90719 12.0923 8.91199C12.1017 8.95522 12.1111 8.99365 12.1299 9.03688C12.1629 9.11374 12.21 9.1858 12.2665 9.24824C12.3136 9.29628 12.3654 9.33951 12.422 9.37314C12.4408 9.38274 12.4597 9.39235 12.4785 9.40196H12.4832C12.502 9.41157 12.5209 9.41637 12.535 9.42117C12.5397 9.42117 12.5397 9.42117 12.5444 9.42598C12.5633 9.43078 12.5774 9.43558 12.5963 9.44039C12.601 9.44039 12.6057 9.44519 12.6104 9.44519C12.6292 9.44999 12.6434 9.44999 12.6622 9.4548C12.6669 9.4548 12.6716 9.4548 12.6763 9.4596C12.6999 9.4596 12.7234 9.46441 12.747 9.46441C12.8412 9.46441 12.926 9.44519 13.006 9.41157C13.0437 9.39235 13.0814 9.37314 13.1191 9.34912C13.1897 9.30108 13.251 9.23864 13.2981 9.16658C13.3216 9.12815 13.3405 9.08972 13.3593 9.05129C13.3923 8.96963 13.4111 8.87836 13.4111 8.78709V8.78229C13.4158 8.77268 13.4158 8.77268 13.4158 8.77268ZM12.7517 8.69102C12.6151 8.69102 12.502 8.57574 12.502 8.43643C12.502 8.29713 12.6151 8.18184 12.7517 8.18184C12.8883 8.18184 13.0013 8.29713 13.0013 8.43643C13.0013 8.57574 12.8883 8.69102 12.7517 8.69102Z",
			fill: "black"
		}),
		s("path", {
			d: "M12.7521 8.69095C12.89 8.69095 13.0017 8.57696 13.0017 8.43635C13.0017 8.29575 12.89 8.18176 12.7521 8.18176C12.6142 8.18176 12.5024 8.29575 12.5024 8.43635C12.5024 8.57696 12.6142 8.69095 12.7521 8.69095Z",
			fill: "white"
		}),
		s("path", {
			d: "M12.2903 8.28749L12.7519 6.8512C12.7519 6.8512 12.7519 6.76474 12.7519 6.68308C12.7519 6.65906 12.7519 6.63504 12.7519 6.61583C12.7519 6.60622 12.7519 6.60142 12.7519 6.59661C12.7519 6.587 12.7519 6.5774 12.7519 6.56779C12.7519 6.56299 12.7519 6.55338 12.7519 6.54858C12.7519 6.54377 12.7519 6.53416 12.7519 6.52936C12.7519 6.52456 12.7519 6.51975 12.7519 6.51975C12.7519 6.51495 12.7519 6.51495 12.7519 6.51495C12.4975 6.46211 12.2338 6.43329 11.9653 6.43329C11.8758 6.43329 11.7863 6.43809 11.6968 6.4429C11.6827 6.4429 11.6732 6.4429 11.6591 6.4477C11.1975 6.48132 10.7453 6.60622 10.3261 6.80317C9.96814 6.97129 9.62901 7.19226 9.33226 7.45166C9.25219 7.52371 9.17211 7.59576 9.09675 7.67262C9.08262 7.68703 9.06849 7.70144 9.05436 7.71586C8.98371 7.78791 8.91305 7.86477 8.84711 7.94163C8.83298 7.96084 8.81885 7.97525 8.80472 7.99446C8.73877 8.07613 8.67283 8.15779 8.6116 8.23945C8.60689 8.24425 8.60218 8.25386 8.59747 8.25866C8.54094 8.34033 8.48442 8.42199 8.4279 8.50845C8.41848 8.52286 8.40435 8.54208 8.39493 8.55649C8.35254 8.62854 8.31014 8.7006 8.27246 8.77265H10.3591H10.3638L12.2903 8.28749Z",
			fill: "#BBBCBD"
		}),
		s("path", {
			d: "M14.0565 8.12889C14.0613 8.07125 14.066 8.01841 14.066 7.96076C14.0707 7.88391 14.0707 7.81185 14.0754 7.73499C14.0754 7.67735 14.0754 7.61971 14.0754 7.55726C14.0754 7.53805 14.0754 7.52363 14.0754 7.50442C14.0754 7.3507 14.066 7.20179 14.0613 7.04808C14.0613 7.04808 14.0565 7.04808 14.0565 7.04327C14.0565 7.04327 14.0518 7.04327 14.0518 7.03847C14.0236 7.02406 13.9576 6.98563 13.8964 6.9472H13.8917C13.8776 6.93759 13.8634 6.92799 13.8493 6.92318C13.8399 6.91838 13.8305 6.90877 13.821 6.90397L13.8163 6.89916C13.8069 6.89436 13.7975 6.88956 13.7928 6.88475C13.6986 6.83191 13.5997 6.78868 13.5007 6.74545C13.2652 6.64457 12.9449 6.5533 12.7612 6.51007V6.63977V6.66859V6.6782C12.7612 6.76466 12.7612 6.84632 12.7612 6.84632L13.2181 8.2778C13.2652 8.32104 13.3076 8.37388 13.3359 8.43152C13.3453 8.45073 13.3547 8.46995 13.3641 8.48916C13.3736 8.50838 13.383 8.52759 13.3877 8.55161C13.3924 8.57082 13.4018 8.59484 13.4065 8.61406C13.4112 8.63808 13.416 8.65729 13.416 8.68131C13.4207 8.70533 13.4207 8.72934 13.4207 8.75336V8.75817H13.9765C14.0142 8.55161 14.0424 8.34025 14.0565 8.12889C14.0565 8.1385 14.0565 8.13369 14.0565 8.12889Z",
			fill: "#E2DDDB"
		}),
		s("path", {
			d: "M13.421 10.819C13.5482 10.6893 13.6659 10.5692 13.779 10.4491C13.8449 10.3771 13.9109 10.305 13.9768 10.2378C14.4431 9.72379 14.7822 9.23863 14.9895 8.61896C14.9942 8.60455 14.9989 8.58533 15.0036 8.56132C15.0036 8.55651 15.0036 8.55651 15.0036 8.55171C15.0083 8.52769 15.0131 8.50367 15.0178 8.47485C15.0178 8.45564 15.0225 8.43642 15.0225 8.41721C14.9707 8.1482 14.8717 7.884 14.7823 7.62461C14.7823 7.62461 14.7823 7.62461 14.7823 7.62941C14.7823 7.62941 14.7822 7.62941 14.7775 7.62461C14.7587 7.6102 14.7446 7.59098 14.7257 7.57657C14.6739 7.52854 14.6221 7.4805 14.5656 7.43246C14.4007 7.29316 14.2312 7.16346 14.0522 7.05298C14.0616 7.20669 14.0663 7.35561 14.0663 7.50932C14.0663 7.52854 14.0663 7.54295 14.0663 7.56216C14.0663 7.61981 14.0663 7.67745 14.0663 7.7399C14.0663 7.81675 14.0616 7.89361 14.0569 7.96567C14.0522 8.02331 14.0522 8.07615 14.0475 8.13379C14.0475 8.1386 14.0475 8.1434 14.0475 8.15301C14.0286 8.36437 14.0051 8.57573 13.9674 8.78228L13.9014 9.09932C13.7648 9.66615 13.4869 10.1753 13.2608 10.7037C13.1996 10.843 13.1431 10.9871 13.0913 11.1313C13.0866 11.1457 13.0819 11.1601 13.0771 11.1745C13.1478 11.0976 13.2137 11.0304 13.2608 10.9823C13.3221 10.9199 13.3692 10.8671 13.421 10.819Z",
			fill: "#FBB040"
		}),
		s("path", {
			d: "M12.2954 8.28741C12.3237 8.25859 12.3566 8.23457 12.3896 8.21055C12.4226 8.18654 12.4603 8.16732 12.4979 8.15291C12.4979 8.15291 12.4979 8.15291 12.5027 8.15291C12.5403 8.1385 12.578 8.12409 12.6204 8.11928H12.6251C12.6675 8.10968 12.7099 8.10487 12.7523 8.10487C12.7947 8.10487 12.8371 8.10968 12.8795 8.11928C12.8795 8.11928 12.8795 8.11928 12.8842 8.11928C12.9266 8.12889 12.9643 8.1385 13.0019 8.15771C13.0773 8.19134 13.148 8.23457 13.2092 8.29702L12.7523 6.86554L12.2954 8.28741Z",
			fill: "#909393"
		}),
		s("path", {
			d: "M12.1353 9.03678C12.1212 8.99835 12.107 8.95512 12.0976 8.91189C12.0976 8.91189 12.0976 8.91188 12.0976 8.90708C12.0882 8.86385 12.0835 8.82062 12.0835 8.77738C12.0835 8.75337 12.0835 8.72935 12.0882 8.70533C12.0882 8.70053 12.0882 8.69572 12.0929 8.69092C12.0929 8.6717 12.0976 8.65729 12.1023 8.63808C12.1023 8.63328 12.107 8.62847 12.107 8.62367C12.1118 8.60445 12.1165 8.59004 12.1212 8.57083C12.1212 8.56602 12.1259 8.56602 12.1259 8.56122C12.1306 8.54201 12.14 8.52279 12.1447 8.50838C12.1447 8.50838 12.1447 8.50358 12.1494 8.50358C12.1589 8.48436 12.1683 8.46515 12.1777 8.44593C12.2107 8.38829 12.2531 8.33545 12.3002 8.28741L10.369 8.77258H10.3643L12.2766 9.24814C12.2154 9.1905 12.1683 9.11844 12.1353 9.03678Z",
			fill: "#676A6A"
		}),
		s("path", {
			d: "M16.4774 8.66697C16.4774 8.65736 16.4821 8.64776 16.4821 8.64295C16.4868 8.61413 16.4916 8.58531 16.501 8.56129C16.501 8.55649 16.501 8.55649 16.501 8.55169L16.7506 7.3748V6.70229C16.5434 6.52936 16.3267 6.43329 16.0959 6.43329C15.8039 6.43329 15.5354 6.59661 15.3328 6.79836C15.1115 7.01933 14.9419 7.29794 14.8006 7.57655C14.7959 7.59096 14.7864 7.60057 14.7817 7.61498C14.8241 7.65341 14.8665 7.69184 14.9089 7.73027C15.0031 7.81673 15.0973 7.908 15.1868 7.99927C15.2292 8.0425 15.2716 8.08573 15.314 8.12897C15.3564 8.177 15.4035 8.22024 15.4459 8.26827C15.5024 8.33072 15.5589 8.38836 15.6107 8.45081C15.6343 8.47483 15.6578 8.50365 15.6814 8.52767C15.7473 8.60453 15.8133 8.67658 15.8792 8.75344C15.8886 8.76304 15.8981 8.77265 15.9028 8.77746H16.4727C16.4727 8.77265 16.4727 8.76785 16.4727 8.76304C16.4727 8.73422 16.4727 8.7006 16.4774 8.66697Z",
			fill: "#E2DDDB"
		}),
		s("path", {
			d: "M7.92886 9.51719C7.92886 9.51239 7.93357 9.50758 7.93357 9.50278C7.97125 9.40671 8.00893 9.31064 8.05132 9.21456C8.06074 9.18574 8.07488 9.16172 8.08901 9.13771C8.12198 9.06085 8.15966 8.98879 8.19734 8.91674C8.21147 8.88792 8.2256 8.8591 8.24444 8.82547C8.25386 8.81106 8.26328 8.79184 8.2727 8.77743C8.3151 8.70538 8.35278 8.63333 8.39517 8.56127C8.40459 8.54686 8.41872 8.52765 8.42814 8.51323C8.47995 8.42677 8.53648 8.34511 8.59771 8.26345C8.60242 8.25864 8.60713 8.24904 8.61184 8.24423C8.67307 8.15777 8.73902 8.07611 8.80496 7.99925C8.81909 7.98003 8.83322 7.96562 8.84735 7.94641C8.9133 7.86955 8.98395 7.79269 9.0546 7.72064C9.06873 7.70623 9.08286 7.69182 9.09699 7.6774C9.17236 7.60055 9.24772 7.52849 9.33251 7.45644C9.64809 6.37082 10.6231 5.57822 11.7724 5.57822C12.234 5.57822 12.6956 5.71272 13.0913 5.96251C13.4963 6.2171 13.8261 6.58698 14.038 7.01451C14.038 7.01451 14.038 7.01931 14.0427 7.01931C14.0474 7.02892 14.0522 7.03852 14.0616 7.05293C14.2406 7.16342 14.4101 7.29312 14.575 7.43242C14.6315 7.48046 14.6833 7.52849 14.7351 7.57653C14.754 7.59094 14.7681 7.61015 14.787 7.62456C14.7917 7.61015 14.7964 7.60055 14.8058 7.58614C14.9659 6.54375 15.4181 5.78958 15.9504 5.78958C16.3507 5.78958 16.7087 6.2171 16.9254 6.8752V6.88C16.9866 6.94725 17.0479 7.02411 17.1091 7.10577C17.1091 7.10577 17.1091 7.11058 17.1138 7.11058C17.1185 7.12018 17.1185 7.12979 17.1232 7.1394L17.1138 7.10577C16.4497 5.10747 14.5985 3.66638 12.413 3.66638C9.67164 3.66638 7.45312 5.92889 7.45312 8.72459C7.45312 9.27701 7.53791 9.80541 7.69806 10.3002C7.69806 10.3002 7.69806 10.3002 7.69806 10.2954C7.73103 10.1465 7.76871 9.99755 7.8111 9.85345C7.84878 9.73816 7.88647 9.62768 7.92886 9.51719Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M17.1889 8.78217L17.0146 8.97912C17.0099 9.00314 17.0005 9.02716 16.991 9.05117C16.991 9.05598 16.9863 9.06078 16.9816 9.07039C16.9769 9.0848 16.9675 9.10401 16.9581 9.11843C16.9534 9.12803 16.9486 9.13284 16.9439 9.14244C16.9345 9.15205 16.9298 9.16646 16.9204 9.17607C16.911 9.19048 16.8968 9.20489 16.8827 9.2145C16.878 9.2193 16.8733 9.22411 16.8686 9.22891C16.8592 9.23852 16.8497 9.24332 16.8403 9.24812C16.8356 9.24812 16.8309 9.25293 16.8262 9.25293C16.8026 9.26734 16.7744 9.27214 16.7461 9.27214C16.5907 9.27214 16.4635 9.05118 16.4635 8.77257H15.8936C16.0019 8.89746 16.1055 9.02235 16.2044 9.15205L16.2091 9.15685C16.3081 9.28175 16.407 9.40664 16.5059 9.53154C16.5106 9.53634 16.5153 9.54595 16.52 9.55075C16.6142 9.67084 16.7037 9.79093 16.7932 9.91102C16.8026 9.92063 16.812 9.93504 16.8215 9.94465C16.9157 10.0743 17.0099 10.204 17.1041 10.3289C17.1041 10.3289 17.1041 10.3289 17.1041 10.3337C17.2689 9.83897 17.3584 9.31537 17.3631 8.76776L17.1889 8.78217Z",
			fill: "white"
		}),
		s("path", {
			d: "M11.659 6.44288C11.6732 6.44288 11.6826 6.44288 11.6967 6.43808C11.7862 6.43327 11.8757 6.42847 11.9652 6.42847C12.2337 6.42847 12.4974 6.45729 12.7518 6.51013C12.7518 6.51013 12.7518 6.51013 12.7518 6.51493C12.7518 6.51493 12.7518 6.51974 12.7518 6.52454C12.7518 6.52935 12.7518 6.53415 12.7518 6.54376C12.7518 6.54856 12.7518 6.55336 12.7518 6.56297C12.7518 6.57258 12.7518 6.58219 12.7518 6.59179C12.7518 6.5966 12.7518 6.6062 12.7518 6.61101C12.7518 6.62061 12.7518 6.63022 12.7518 6.63983V6.51013C12.9308 6.55336 13.2511 6.64463 13.4913 6.74551C13.5902 6.78874 13.6891 6.83678 13.7833 6.88481C13.7881 6.88481 13.7975 6.88962 13.8069 6.89922C13.8069 6.89922 13.8116 6.89922 13.8116 6.90403C13.821 6.90883 13.8304 6.91364 13.8399 6.92324C13.854 6.93285 13.8681 6.93765 13.8823 6.94726H13.887C13.9482 6.98089 14.0141 7.02412 14.0424 7.03853C14.0471 7.03853 14.0471 7.04333 14.0471 7.04333L14.0518 7.04814C14.0471 7.03853 14.0424 7.02892 14.033 7.01451C14.033 7.01451 14.033 7.00971 14.0283 7.00971C13.8163 6.57738 13.4819 6.2075 13.0815 5.95771C12.6859 5.71273 12.2243 5.57343 11.7627 5.57343C10.6134 5.57343 9.63834 6.36602 9.32275 7.45164C9.62421 7.18744 9.95863 6.96648 10.3166 6.80315C10.7452 6.6014 11.2021 6.48131 11.659 6.44288Z",
			fill: "black"
		}),
		s("path", {
			d: "M15.3381 6.80316C15.5406 6.60141 15.8091 6.43808 16.1011 6.43808C16.332 6.43808 16.5533 6.53415 16.7559 6.70709C16.7747 6.7215 16.7936 6.74071 16.8124 6.75512C16.8218 6.76473 16.8359 6.77434 16.8454 6.78394C16.8736 6.81276 16.9019 6.84159 16.9301 6.87521V6.87041C16.7088 6.21231 16.3555 5.78479 15.9551 5.78479C15.4229 5.78479 14.9707 6.53416 14.8105 7.58134C14.9424 7.30273 15.1167 7.02412 15.3381 6.80316Z",
			fill: "black"
		}),
		s("path", {
			d: "M10.6371 13.4466C10.6842 13.4658 10.7266 13.4802 10.7737 13.4946C11.2871 13.6772 11.8382 13.778 12.4129 13.778C13.0676 13.778 13.694 13.6483 14.264 13.413C14.2922 13.3986 14.3252 13.3889 14.3535 13.3745C14.4006 13.3553 14.4524 13.3313 14.4995 13.3073C14.5419 13.2881 14.5843 13.2689 14.6267 13.2448C14.6173 13.2448 14.6078 13.2496 14.5984 13.2496C14.4194 13.2689 14.2451 13.2737 14.0709 13.2448C13.0487 13.0959 12.8227 12.5915 12.8556 12.0728C12.7803 12.0295 12.7096 11.9815 12.6295 11.9238C11.8429 11.3426 11.3766 10.7229 11.3766 10.7229C11.3766 10.7229 11.9842 11.1985 12.8886 11.5588C12.9074 11.5684 12.9263 11.5732 12.9451 11.5828C12.9875 11.4339 13.0393 11.2898 13.0817 11.1649C13.0864 11.1505 13.0911 11.1361 13.0958 11.1216C13.1477 10.9775 13.2042 10.8334 13.2654 10.6941C13.4915 10.1657 13.7694 9.65173 13.906 9.08971L13.972 8.77267H13.4161V8.77747C13.4161 8.87354 13.3973 8.96001 13.3643 9.04167C13.3455 9.0801 13.3266 9.12333 13.3031 9.15696C13.256 9.22901 13.1948 9.29146 13.1241 9.3395C13.0864 9.36351 13.0487 9.38273 13.0111 9.40194C12.931 9.43557 12.8415 9.45478 12.752 9.45478C12.7284 9.45478 12.7049 9.45478 12.6813 9.44998C12.6766 9.44998 12.6719 9.44998 12.6672 9.44518C12.6484 9.44518 12.6342 9.44037 12.6154 9.43557C12.6107 9.43557 12.606 9.43077 12.6013 9.43077C12.5824 9.42596 12.5683 9.42116 12.5495 9.41635C12.5448 9.41635 12.5448 9.41635 12.54 9.41155C12.5212 9.40675 12.5024 9.39714 12.4882 9.39234H12.4835C12.4647 9.38273 12.4458 9.37312 12.427 9.36351C12.3705 9.32989 12.3187 9.29146 12.2716 9.23862L10.3592 8.76306H8.27257C8.26315 8.77747 8.25373 8.79669 8.24431 8.8111C8.23018 8.83992 8.21134 8.86874 8.19721 8.90237C8.15953 8.97442 8.12185 9.05128 8.08888 9.12333C8.07474 9.14735 8.06532 9.17617 8.05119 9.20019C8.0088 9.29626 7.97112 9.39234 7.93344 9.48841C7.93344 9.49321 7.92873 9.49802 7.92873 9.50282C7.88634 9.6133 7.84865 9.72859 7.81568 9.84388C7.77329 9.98798 7.73561 10.1369 7.70264 10.2858C8.03235 11.309 8.66823 12.188 9.50665 12.8029C9.5302 12.8221 9.55847 12.8365 9.58202 12.8557C9.72332 12.9566 9.86934 13.0527 10.0201 13.1344C10.2179 13.2593 10.4251 13.3601 10.6371 13.4466Z",
			fill: "white"
		}),
		s("path", {
			d: "M14.0613 11.871C14.0518 11.9238 14.0471 11.9766 14.0471 12.0295C14.0424 12.1208 14.0518 12.212 14.066 12.2937C14.0754 12.3513 14.0848 12.4042 14.0989 12.457C14.1225 12.5339 14.146 12.6059 14.179 12.6732C14.212 12.7404 14.245 12.8029 14.2779 12.8557C14.2873 12.8749 14.3015 12.8941 14.3109 12.9086C14.3297 12.9326 14.3439 12.9566 14.3627 12.9806C14.3863 13.0094 14.4098 13.0382 14.4287 13.0623C14.5181 13.1679 14.5935 13.2256 14.5935 13.2256C14.5935 13.2256 14.5935 13.2256 14.5935 13.2304C14.5935 13.2352 14.5935 13.24 14.5982 13.2448C14.6076 13.2448 14.6171 13.24 14.6265 13.24C14.8479 13.2112 15.0692 13.1487 15.2906 13.0719C15.4037 13.0286 15.5167 12.9854 15.6251 12.9374C15.658 12.923 15.691 12.9037 15.724 12.8893C16.8591 12.3273 17.8106 11.3378 17.8106 11.3378C16.3881 12.0535 14.9892 12.0247 14.0613 11.871Z",
			fill: "#9F2255"
		}),
		s("path", {
			d: "M16.803 9.92069C16.7136 9.80059 16.6193 9.6805 16.5299 9.56041C16.5251 9.55561 16.5204 9.546 16.5157 9.5412C16.4168 9.41631 16.3179 9.29141 16.219 9.16652L16.2143 9.16171C16.1106 9.03202 16.007 8.90712 15.9034 8.78223C15.8987 8.77262 15.8893 8.76782 15.8846 8.75821C15.8186 8.68135 15.7527 8.6093 15.6867 8.53244C15.6632 8.50842 15.6396 8.4796 15.6161 8.45558C15.5595 8.39313 15.5077 8.33549 15.4512 8.27304C15.4088 8.22501 15.3617 8.18177 15.3193 8.13374C15.2769 8.09051 15.2345 8.04727 15.1922 8.00404C15.1027 7.91277 15.0085 7.8215 14.9142 7.73504C14.8719 7.69661 14.8295 7.65818 14.7871 7.61975C14.8766 7.88395 14.9802 8.14815 15.032 8.42196C15.0461 8.49401 15.0556 8.56126 15.065 8.62851C15.1921 9.57482 14.8907 10.1945 14.4197 11.0111C14.3867 11.0688 14.349 11.1312 14.316 11.1888C14.2077 11.3714 14.1371 11.5491 14.0994 11.7124C14.0852 11.7653 14.0758 11.8181 14.0664 11.871C14.9943 12.0247 16.3885 12.0535 17.8157 11.3378C17.8157 11.3378 17.5378 10.9198 17.1139 10.3434C17.0197 10.2137 16.9255 10.084 16.8313 9.95911C16.8219 9.9447 16.8125 9.93029 16.803 9.92069Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M14.5936 13.2351C14.5936 13.2351 14.5229 13.1775 14.4287 13.0718C14.4051 13.0478 14.3863 13.019 14.3627 12.9902C14.3439 12.9661 14.3298 12.9421 14.3109 12.9181C14.3015 12.8989 14.2874 12.8845 14.278 12.8653C14.245 12.8076 14.212 12.75 14.1791 12.6827C14.1508 12.6155 14.1225 12.5434 14.099 12.4666C14.0848 12.4137 14.0707 12.3609 14.066 12.3032C14.0519 12.2216 14.0472 12.1303 14.0472 12.039C14.0472 11.9862 14.0519 11.9334 14.0613 11.8805C14.0707 11.8277 14.0801 11.7748 14.0943 11.722C14.1367 11.5587 14.2026 11.3857 14.3109 11.1984C14.3439 11.136 14.3816 11.0783 14.4146 11.0207C14.8856 10.2041 15.187 9.58919 15.0599 8.63807C15.0504 8.57082 15.041 8.49877 15.0269 8.43152C15.0222 8.47955 15.0128 8.52279 15.0033 8.55641C15.0033 8.56122 15.0033 8.56122 15.0033 8.56602C14.9986 8.59004 14.9939 8.60925 14.9892 8.62366C14.782 9.24333 14.4428 9.7285 13.9765 10.2425C13.9153 10.3145 13.8493 10.3818 13.7787 10.4538C13.6656 10.5739 13.5432 10.6988 13.4207 10.8237C13.3689 10.8766 13.3171 10.9246 13.2653 10.9774C13.2182 11.0255 13.1522 11.0927 13.0816 11.1696C13.0392 11.2945 12.9874 11.4386 12.945 11.5875C12.9261 11.5779 12.9073 11.5731 12.8884 11.5635C11.9841 11.208 11.3765 10.7276 11.3765 10.7276C11.3765 10.7276 11.8428 11.3473 12.6294 11.9286C12.7047 11.9862 12.7801 12.0342 12.8555 12.0775C12.8225 12.6011 13.0486 13.1006 14.0707 13.2496C14.245 13.2736 14.4193 13.2736 14.5983 13.2544C14.5983 13.2447 14.5936 13.2399 14.5936 13.2351Z",
			fill: "black"
		})
	], -1), n[1] ||= s("defs", null, [s("clipPath", { id: "clip0_presta_24" }, [s("rect", {
		width: "24",
		height: "24",
		fill: "white"
	})])], -1)], 64);
}
var Dg = /*#__PURE__*/ G(Tg, [["render", Eg]]), Og = {};
function kg(t, n) {
	return A(), o(e, null, [n[0] ||= s("path", {
		"clip-rule": "evenodd",
		d: "M19.6634 4.51915C19.7503 4.52646 19.8554 4.59288 19.8719 4.71287C19.8882 4.83287 22.4784 22.3444 22.4784 22.3444L15.1 23.9406L1.48267 21.3892C1.48267 21.3892 3.23023 7.87446 3.29623 7.398C3.38393 6.76866 3.40505 6.74761 4.07294 6.53811C4.18152 6.504 5.03154 6.24041 6.22809 5.86964C6.68935 3.91348 8.1605 0.0640259 11.2398 0.0640259C11.6421 0.0640259 12.1078 0.280026 12.4837 0.777204C12.5213 0.775067 12.5588 0.773587 12.5953 0.773587C13.9172 0.773587 14.6686 1.89945 15.0944 3.1246C15.5292 2.99005 15.792 2.90893 15.8076 2.90433C15.9137 2.87309 16.1871 2.83052 16.3271 2.97049C16.467 3.11055 17.7415 4.37589 17.7415 4.37589C17.7415 4.37589 19.5767 4.51192 19.6634 4.51915ZM13.1895 3.714L14.3417 3.35737C14.0498 2.46551 13.5962 1.69052 12.9151 1.60504C13.0846 2.09104 13.1903 2.70411 13.1903 3.46553C13.1903 3.55127 13.1899 3.62981 13.1895 3.70945L13.1895 3.714ZM12.3826 3.83038C12.3826 2.91148 12.2595 2.23052 12.0701 1.75603C11.3192 2.07822 10.4603 2.93235 10.0021 4.70079L12.3818 3.96386L12.3818 3.96225C12.3822 3.91932 12.3826 3.87682 12.3826 3.83038ZM11.5502 1.02329C11.422 0.935094 11.2881 0.889971 11.1552 0.889971C8.94346 0.889971 7.70097 3.79397 7.17774 5.57548L9.05878 4.9929C9.50549 2.65726 10.5633 1.48767 11.5502 1.02329ZM11.6855 11.3023L12.5953 8.59602C12.5953 8.59602 11.9803 8.23947 10.7355 8.23947C7.50488 8.23947 5.90444 10.3973 5.90444 12.627C5.90444 14.1153 6.73861 14.7902 7.46973 15.3818C8.04008 15.8432 8.54773 16.254 8.54773 16.9605C8.54773 17.3503 8.27214 17.8837 7.59463 17.8837C6.55778 17.8837 5.32902 16.8288 5.32902 16.8288L4.70312 18.8967C4.70312 18.8967 5.89852 20.3515 8.23606 20.3515C10.184 20.3515 11.6287 18.8848 11.6287 16.607C11.6287 14.856 10.4501 13.9908 9.51859 13.3069C8.90994 12.8601 8.40677 12.4907 8.40677 12.0023C8.40677 11.7758 8.47885 10.8768 9.91129 10.8768C10.8884 10.8768 11.6855 11.3023 11.6855 11.3023Z",
		fill: "#95BF46",
		"fill-rule": "evenodd"
	}, null, -1), n[1] ||= s("path", {
		d: "M19.6633 4.51914C19.5766 4.51191 17.7414 4.37588 17.7414 4.37588C17.7414 4.37588 16.4669 3.11054 16.327 2.97049C16.2746 2.91838 16.204 2.89166 16.1302 2.88016L15.1006 23.9404L22.4783 22.3444C22.4783 22.3444 19.8881 4.83287 19.8718 4.71287C19.8553 4.59287 19.7502 4.52646 19.6633 4.51914Z",
		fill: "#5E8E3E"
	}, null, -1)], 64);
}
var Ag = /*#__PURE__*/ G(Og, [["render", kg]]), jg = {};
function Mg(t, n) {
	return A(), o(e, null, [n[0] ||= s("g", { "clip-path": "url(#clip0_cscart_24)" }, [s("path", {
		d: "M23.76 8.46467V20.8727C23.76 22.3624 22.5531 23.5692 21.0634 23.5692H8.65536C7.16567 23.5692 5.9588 22.3624 5.9588 20.8727V8.46467C5.9588 6.97493 7.16567 5.76806 8.65536 5.76806H21.0634C22.5531 5.76806 23.76 6.97493 23.76 8.46467ZM3.42509 0.537781C1.93537 0.537781 0.728516 1.74464 0.728516 3.23435C0.728516 4.72406 1.93537 5.93093 3.42509 5.93093C4.9148 5.93093 6.12165 4.72406 6.12165 3.23435C6.12165 1.74464 4.9148 0.537781 3.42509 0.537781Z",
		fill: "url(#paint0_linear_cscart_24)"
	})], -1), n[1] ||= s("defs", null, [s("linearGradient", {
		id: "paint0_linear_cscart_24",
		x1: "4.13388",
		y1: "20.1645",
		x2: "20.3555",
		y2: "3.94282",
		gradientUnits: "userSpaceOnUse"
	}, [s("stop", { "stop-color": "#7381FD" }), s("stop", {
		offset: "1",
		"stop-color": "#76C7FF"
	})]), s("clipPath", { id: "clip0_cscart_24" }, [s("rect", {
		width: "24",
		height: "24",
		fill: "white"
	})])], -1)], 64);
}
var Ng = /*#__PURE__*/ G(jg, [["render", Mg]]), Pg = {}, Fg = {
	d: "M12 1.5L12.9622 3.18387C13.1546 3.53226 13.1546 3.95806 12.9622 4.30645L7.22749 14.3129L9.94089 19.0355C10.3643 19.771 11.1533 20.2355 12 20.2355C12.8467 20.2355 13.6357 19.771 14.0591 19.0355L16.7725 14.3129L16.0605 13.0355L12.9814 18.3968C12.789 18.7452 12.4041 18.9581 12.0192 18.9581C11.6151 18.9581 11.2495 18.7452 11.057 18.3968L8.69003 14.3129L14.0206 5.02258L14.9828 6.70645C15.1753 7.05484 15.1753 7.48064 14.9828 7.82903L11.2687 14.3129L12 15.5903L16.0412 8.54516L18.6969 13.171C19.101 13.8871 19.101 14.7581 18.6969 15.4742L16.0027 20.1774C15.5986 20.8935 14.3093 22.5 12 22.5C9.69072 22.5 8.42062 20.8935 7.99725 20.1774L5.30309 15.4742C4.89897 14.7581 4.89897 13.8871 5.30309 13.171L12 1.5Z",
	fill: "#ED5153"
};
function Ig(e, t) {
	return A(), o("path", Fg);
}
var Lg = /*#__PURE__*/ G(Pg, [["render", Ig]]), Rg = {};
function zg(t, n) {
	return A(), o(e, null, [n[0] ||= s("rect", {
		fill: "#00149D",
		height: "48",
		rx: "8",
		width: "48"
	}, null, -1), n[1] ||= s("path", {
		d: "M4 16h4.607v3.867a7.752 7.752 0 0 1 2.812-.51c3.618 0 6.241 2.686 6.241 6.368 0 2.779-1.877 6.067-6.151 6.067H4V16Zm4.607 11.736c.575.104 1.158.158 1.742.162 1.651 0 2.737-.903 2.737-2.316 0-1.388-1.063-2.338-2.602-2.338a6.121 6.121 0 0 0-1.877.278v4.214Zm16.797-8.382c5.088 0 7.033 3.358 7.033 6.322 0 3.241-2.24 6.32-6.99 6.32-5.088 0-7.079-3.334-7.079-6.32.005-3.15 2.108-6.322 7.039-6.322h-.003Zm0 8.683c1.438 0 2.428-.973 2.428-2.361 0-1.389-.987-2.363-2.425-2.363-1.439 0-2.428.973-2.428 2.363 0 1.39.99 2.361 2.428 2.361h-.003ZM33.373 16h4.6v15.789h-4.6V16ZM44 29.151C44 30.726 42.797 32 41.283 32s-2.74-1.274-2.74-2.849a2.826 2.826 0 0 1 .79-1.99 2.75 2.75 0 0 1 1.95-.834C42.797 26.323 44 27.573 44 29.148v.003Z",
		fill: "#fff"
	}, null, -1)], 64);
}
var Bg = /*#__PURE__*/ G(Rg, [["render", zg]]), Vg = {};
function Hg(t, n) {
	return A(), o(e, null, [n[0] ||= s("path", {
		"clip-rule": "evenodd",
		d: "M39.3266 9.0383C39.5003 9.05293 39.7106 9.18575 39.7436 9.42575C39.7762 9.66575 44.9565 44.6888 44.9565 44.6888L30.1998 47.8811L2.96509 42.7784C2.96509 42.7784 6.46021 15.7489 6.59221 14.796C6.76761 13.5373 6.80986 13.4952 8.14564 13.0762C8.36279 13.008 10.0628 12.4808 12.4559 11.7393C13.3785 7.82696 16.3208 0.128052 22.4794 0.128052C23.2839 0.128052 24.2153 0.560052 24.9672 1.55441C25.0423 1.55013 25.1174 1.54717 25.1904 1.54717C27.8342 1.54717 29.337 3.7989 30.1885 6.2492C31.0581 5.98011 31.5838 5.81786 31.615 5.80865C31.8272 5.74619 32.374 5.66104 32.6539 5.94098C32.9337 6.22109 35.4828 8.75178 35.4828 8.75178C35.4828 8.75178 39.1531 9.02383 39.3266 9.0383ZM26.3787 7.428L28.6832 6.71474C28.0993 4.93101 27.1921 3.38104 25.8299 3.21008C26.169 4.18208 26.3804 5.40822 26.3804 6.93107C26.3804 7.1029 26.3796 7.26026 26.3788 7.41989L26.3787 7.428ZM24.765 7.66076C24.765 5.82296 24.5187 4.46104 24.14 3.51205C22.6382 4.15644 20.9204 5.86471 20.0039 9.40159C20.903 9.12305 21.801 8.84502 22.6768 8.57385C23.3909 8.35276 24.0902 8.13623 24.7633 7.92772L24.7634 7.92451C24.7642 7.83864 24.765 7.75363 24.765 7.66076ZM23.1001 2.04657C22.8438 1.87019 22.576 1.77994 22.3102 1.77994C17.8867 1.77994 15.4017 7.58794 14.3552 11.151L18.1173 9.98581C19.0107 5.31452 21.1264 2.97534 23.1001 2.04657ZM23.371 22.6045L25.1905 17.192C25.1905 17.192 23.9606 16.4789 21.471 16.4789C15.0098 16.4789 11.8089 20.7945 11.8089 25.2541C11.8089 28.2306 13.4772 29.5804 14.9395 30.7635C16.0802 31.6865 17.0955 32.5079 17.0955 33.921C17.0955 34.7005 16.5443 35.7674 15.1893 35.7674C13.1156 35.7674 10.658 33.6575 10.658 33.6575L9.40625 37.7934C9.40625 37.7934 11.797 40.703 16.4721 40.703C20.368 40.703 23.2574 37.7696 23.2574 33.214C23.2574 29.712 20.9002 27.9816 19.0372 26.6139C17.8199 25.7202 16.8135 24.9815 16.8135 24.0046C16.8135 23.5515 16.9577 21.7537 19.8226 21.7537C21.7768 21.7537 23.371 22.6045 23.371 22.6045Z",
		fill: "#95BF46",
		"fill-rule": "evenodd"
	}, null, -1), n[1] ||= s("path", {
		d: "M39.3266 9.03829C39.1532 9.02382 35.4828 8.75177 35.4828 8.75177C35.4828 8.75177 32.9337 6.22108 32.6539 5.94097C32.5492 5.83675 32.408 5.78333 32.2604 5.76031L30.2012 47.8808L44.9566 44.6888C44.9566 44.6888 39.7762 9.66574 39.7436 9.42574C39.7106 9.18574 39.5004 9.05292 39.3266 9.03829Z",
		fill: "#5E8E3E"
	}, null, -1)], 64);
}
var Ug = /*#__PURE__*/ G(Vg, [["render", Hg]]), Wg = {};
function Gg(t, n) {
	return A(), o(e, null, [n[0] ||= s("rect", {
		fill: "#00149D",
		height: "24",
		width: "24"
	}, null, -1), n[1] ||= s("path", {
		d: "M2 8H4.30357V9.9333C4.75282 9.76191 5.22928 9.67554 5.70928 9.6785C7.51854 9.6785 8.83012 11.0216 8.83012 12.8624C8.83012 14.2518 7.89167 15.896 5.75437 15.896H2V8ZM4.30357 13.8679C4.59105 13.9199 4.88237 13.9471 5.17439 13.949C6.00011 13.949 6.54289 13.4977 6.54289 12.791C6.54289 12.0968 6.01139 11.6221 5.24202 11.6221C4.92403 11.6193 4.60751 11.6661 4.30357 11.7609V13.8679ZM12.7017 9.67678C15.246 9.67678 16.2182 11.3559 16.2182 12.8378C16.2182 14.4586 15.0989 15.9983 12.7237 15.9983C10.1795 15.9983 9.18408 14.3312 9.18408 12.8378C9.18634 11.2627 10.2381 9.67678 12.7034 9.67678H12.7017ZM12.7017 14.0187C13.4209 14.0187 13.9158 13.532 13.9158 12.8378C13.9158 12.1437 13.4226 11.6564 12.7034 11.6564C11.9842 11.6564 11.4893 12.1431 11.4893 12.8378C11.4893 13.5325 11.9842 14.0187 12.7034 14.0187H12.7017ZM16.6872 8H18.9874V15.8943H16.6872V8ZM22 14.5757C22 15.363 21.3986 16 20.6416 16C19.8847 16 19.2714 15.363 19.2714 14.5757C19.2693 14.3916 19.3031 14.2089 19.3709 14.0381C19.4387 13.8673 19.5392 13.7118 19.6665 13.5805C19.7939 13.4493 19.9456 13.3448 20.113 13.2732C20.2803 13.2017 20.46 13.1644 20.6416 13.1635C21.3986 13.1618 22 13.7868 22 14.574V14.5757Z",
		fill: "white"
	}, null, -1)], 64);
}
var Kg = /*#__PURE__*/ G(Wg, [["render", Gg]]), qg = {};
function Jg(t, n) {
	return A(), o(e, null, [n[0] ||= s("g", { "clip-path": "url(#clip0_presta_48)" }, [
		s("path", {
			d: "M10.8094 38.7581C10.8 38.7197 10.8 38.6621 10.8 38.5852C10.8 38.0952 10.9601 37.711 11.2804 37.442C11.6007 37.1633 11.9493 37.0288 12.3355 37.0288C12.8442 37.0288 13.2022 37.221 13.4 37.6149L10.8094 38.7581ZM14.521 38.0664C14.5116 37.49 14.3044 37.0192 13.8804 36.6542C13.4565 36.2891 12.929 36.1161 12.2884 36.1161C11.8833 36.1161 11.4971 36.2026 11.1391 36.3852C10.7717 36.5677 10.4702 36.8463 10.2253 37.2402C9.98038 37.6245 9.85791 38.0664 9.85791 38.5756C9.85791 39.3058 10.0934 39.9014 10.5644 40.3433C11.0355 40.7949 11.6101 41.0158 12.2695 41.0158C13.0232 41.0158 13.6826 40.7276 14.2384 40.1416L13.6638 39.4883C13.3246 39.9014 12.8913 40.1128 12.3732 40.1128C11.8456 40.1128 11.4311 39.9206 11.1297 39.5363L14.5305 38.076L14.521 38.0664Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M8.72691 36.4044C8.45371 36.5965 8.23704 36.8367 8.08632 37.1345V36.1738H7.09717V40.939H8.0769V38.9022C8.0769 38.3642 8.19936 37.9223 8.44429 37.6053C8.68922 37.2786 9.05662 37.1249 9.53707 37.1249H9.59359L9.58417 36.1161C9.29213 36.1161 9.0001 36.2122 8.72691 36.4044Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M18.0345 38.5179C17.8744 38.4122 17.7331 38.3258 17.5918 38.2681C17.4505 38.2105 17.3091 38.1529 17.1678 38.1048C17.0171 38.0568 16.857 38.0087 16.6591 37.9607C16.4707 37.9127 16.32 37.8646 16.2164 37.807C16.0656 37.7397 15.9903 37.6245 15.9903 37.4707C15.9903 37.2978 16.0656 37.1633 16.207 37.0768C16.3577 36.9904 16.5461 36.9423 16.7816 36.9423C17.2244 36.9423 17.6389 37.0672 18.0157 37.3266L18.3831 36.5869C17.9026 36.2602 17.3939 36.1065 16.857 36.1065C16.32 36.1065 15.8772 36.241 15.5475 36.5004C15.2084 36.7694 15.0388 37.1153 15.0388 37.5572C15.0388 38.1817 15.5287 38.6332 16.499 38.9022C16.5178 38.9118 16.5555 38.9214 16.6026 38.9406C17.2244 39.1328 17.5352 39.3441 17.5352 39.5843C17.5352 39.7477 17.4693 39.8822 17.3468 39.9782C17.2149 40.0839 17.0454 40.1319 16.8193 40.1319C16.3106 40.1319 15.783 39.9206 15.2366 39.5075L14.7656 40.2857C15.0482 40.5162 15.3685 40.6892 15.7359 40.8141C16.1033 40.9389 16.4519 41.0062 16.791 41.0062C17.2903 41.0062 17.7048 40.8717 18.0251 40.6027C18.3454 40.3337 18.5055 39.9686 18.5055 39.5171C18.515 39.0655 18.3548 38.7389 18.0345 38.5179Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M5.03423 37.8166C4.82698 38.0376 4.43132 38.1528 3.86609 38.1528H2.66027V35.6454H3.71536C4.28059 35.6454 4.68567 35.7318 4.94944 35.9144C5.21322 36.0969 5.3451 36.3947 5.3451 36.827C5.3451 37.269 5.24148 37.5956 5.03423 37.8166ZM5.76902 35.2322C5.3451 34.8672 4.66683 34.6846 3.73421 34.6846H1.62402V40.9389H2.66027V39.104H3.75305C4.65741 39.104 5.32626 38.931 5.7596 38.5756C6.19295 38.2201 6.40962 37.6725 6.40962 36.9135C6.40962 36.1641 6.19295 35.5973 5.76902 35.2322Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M20.8131 40.1512C20.6059 40.1512 20.4363 40.0839 20.3233 39.9494C20.2102 39.8149 20.1443 39.6324 20.1443 39.4114V36.9904H21.3689V36.1834H20.1443V34.6846H19.1646V39.373C19.1646 39.8725 19.3153 40.276 19.6073 40.5643C19.8993 40.8621 20.2573 41.0062 20.6812 41.0062C21.0957 41.0062 21.482 40.8525 21.8305 40.5354L21.4255 39.8245C21.2276 40.0455 21.0204 40.1512 20.8131 40.1512Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M25.3077 39.6997C25.0345 39.9879 24.7142 40.132 24.3279 40.132C23.9417 40.132 23.6026 39.9879 23.32 39.6997C23.0373 39.4114 22.8866 39.0464 22.8866 38.5852C22.8866 38.1241 23.0279 37.7494 23.3105 37.442C23.5931 37.1345 23.9229 36.9808 24.3185 36.9808C24.7142 36.9808 25.0439 37.1345 25.3077 37.442C25.5809 37.7494 25.7127 38.1241 25.7127 38.5756C25.7127 39.0368 25.5809 39.4114 25.3077 39.6997ZM25.6939 37.0096C25.2982 36.414 24.7895 36.1161 24.1772 36.1161C23.5649 36.1161 23.0279 36.3371 22.5757 36.779C22.1236 37.221 21.8975 37.807 21.8975 38.5468C21.8975 39.2865 22.1141 39.8822 22.5569 40.3337C22.9997 40.7853 23.5084 41.0158 24.1018 41.0158C24.3939 41.0158 24.6859 40.939 24.978 40.7949C25.27 40.6508 25.5055 40.4394 25.6939 40.1608V40.939H26.6736V36.1738H25.6939V37.0096Z",
			fill: "#27245D"
		}),
		s("path", {
			d: "M41.2463 39.69C40.9636 39.9783 40.6151 40.1224 40.1912 40.1224C39.7672 40.1224 39.4093 39.9783 39.1361 39.69C38.8535 39.4018 38.7216 39.0271 38.7216 38.566C38.7216 38.1048 38.8629 37.7302 39.1361 37.442C39.4093 37.1537 39.7672 37.0096 40.1912 37.0096C40.6151 37.0096 40.9731 37.1537 41.2463 37.442C41.5194 37.7302 41.6608 38.1048 41.6608 38.566C41.6608 39.0271 41.5289 39.4018 41.2463 39.69ZM40.1912 36.1161C39.4846 36.1161 38.9006 36.3563 38.439 36.8271C37.9679 37.2978 37.7324 37.8839 37.7324 38.566C37.7324 39.2481 37.9679 39.8342 38.439 40.3049C38.91 40.7757 39.494 41.0158 40.1912 41.0158C40.8883 41.0158 41.4818 40.7757 41.9434 40.3049C42.4144 39.8342 42.6499 39.2481 42.6499 38.566C42.6499 37.8839 42.4144 37.2978 41.9434 36.8271C41.4723 36.3467 40.8883 36.1161 40.1912 36.1161Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M46.5885 39.69C46.3059 39.9783 45.9668 40.1224 45.5806 40.1224C45.1943 40.1224 44.8646 39.9783 44.6008 39.69C44.3276 39.4018 44.1958 39.0271 44.1958 38.5756C44.1958 38.1241 44.3276 37.7494 44.6008 37.442C44.874 37.1441 45.2037 36.9904 45.59 36.9904C45.9856 36.9904 46.3154 37.1441 46.598 37.442C46.8806 37.7398 47.0219 38.1241 47.0219 38.5756C47.0125 39.0368 46.8712 39.4018 46.5885 39.69ZM47.3328 36.779C46.89 36.3371 46.353 36.1161 45.7313 36.1161C45.1095 36.1161 44.6008 36.414 44.2146 37.0192V36.1834H43.2349V42.6779H44.2146V40.2281C44.6856 40.7564 45.2132 41.0158 45.7972 41.0158C46.3813 41.0158 46.8994 40.7853 47.3422 40.3241C47.7849 39.863 48.0016 39.2673 48.0016 38.5372C48.0016 37.807 47.7755 37.2114 47.3328 36.779Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M35.4438 36.1161C35.1141 36.1161 34.8126 36.2025 34.53 36.3659C34.2474 36.5292 34.0307 36.7598 33.8894 37.0576V34.3195H32.9097V40.9485H33.8894V38.3738C33.8894 37.9318 34.0119 37.5956 34.2662 37.365C34.5206 37.1344 34.8126 37.0192 35.1517 37.0192C35.8677 37.0192 36.2257 37.4611 36.2257 38.3353V40.9485H37.2054V38.0279C37.2054 37.4034 37.0452 36.9327 36.7155 36.606C36.3952 36.2794 35.9713 36.1161 35.4438 36.1161Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M31.732 37.9415C31.4117 37.6629 30.9406 37.4419 30.3095 37.2882C29.6783 37.1345 29.2732 36.9904 29.0754 36.8559C28.887 36.7214 28.7834 36.5292 28.7834 36.2698C28.7834 36.02 28.8776 35.8279 29.0754 35.703C29.2638 35.5781 29.5182 35.5109 29.8196 35.5109C30.1211 35.5109 30.4225 35.5685 30.7334 35.6742C31.0443 35.7799 31.2892 35.9144 31.4682 36.0873L32.024 35.2899C31.7414 35.0497 31.4117 34.8672 31.0254 34.7327C30.6392 34.5982 30.253 34.5405 29.8573 34.5405C29.245 34.5405 28.7363 34.6942 28.3218 35.0113C27.9073 35.3283 27.7 35.7703 27.7 36.3467C27.7 36.9231 27.879 37.3555 28.2464 37.6341C28.4254 37.7878 28.6326 37.9031 28.8681 37.9991C29.1037 38.0952 29.4428 38.1913 29.895 38.3066C30.3472 38.4122 30.658 38.5371 30.8464 38.6716C31.0349 38.8061 31.1196 38.9983 31.1196 39.2385C31.1196 39.4786 31.0254 39.6708 30.8276 39.8245C30.6298 39.9686 30.366 40.0455 30.0363 40.0455C29.3674 40.0455 28.7268 39.7669 28.1051 39.2193L27.4551 40.0167C28.1993 40.6892 29.0471 41.0254 30.008 41.0254C30.6675 41.0254 31.195 40.8525 31.6001 40.5162C32.0052 40.18 32.203 39.738 32.203 39.1904C32.203 38.6428 32.0523 38.2201 31.732 37.9415Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M19.8326 25.1447C20.0587 25.039 20.2848 24.9525 20.5203 24.8565C20.7841 24.7604 21.0478 24.6643 21.3116 24.5779C21.6413 24.4722 21.9805 24.3857 22.3196 24.3089C22.7812 24.2128 23.2428 24.1359 23.7044 24.0879C23.4406 24.9237 23.158 25.7596 22.8377 26.5858C22.8472 26.7491 22.8566 26.9028 22.866 27.0661C23.4972 26.9412 24.1472 26.874 24.816 26.874C25.4849 26.874 26.1349 26.9412 26.7661 27.0661C26.7661 26.9028 26.7755 26.7395 26.7943 26.5858C26.4834 25.7596 26.1914 24.9237 25.9276 24.0879C26.3892 24.1359 26.8603 24.2032 27.3124 24.3089C27.6516 24.3857 27.9813 24.4722 28.3204 24.5779C28.5842 24.6643 28.848 24.7508 29.1118 24.8565C29.3473 24.9429 29.5734 25.039 29.7994 25.1447C31.4009 25.8748 32.8611 26.9509 34.0575 28.3535C37.0626 25.7115 38.9656 21.8014 38.9656 17.4301C38.9656 9.46567 32.635 3 24.816 3C17.0065 3 10.6665 9.45607 10.6665 17.4301C10.6665 21.7918 12.5694 25.7019 15.5746 28.3535C16.771 26.9509 18.2311 25.8748 19.8326 25.1447Z",
			fill: "#A0DBE8"
		}),
		s("path", {
			d: "M20.7651 27.7579C21.4245 27.46 22.1311 27.2295 22.8564 27.0854C22.8564 26.922 22.847 26.7587 22.8282 26.605C23.139 25.7788 23.4311 24.9429 23.6949 24.1071C23.2333 24.1552 22.7622 24.2224 22.31 24.3281C21.9709 24.4049 21.6412 24.4914 21.3021 24.5971C21.0383 24.6836 20.7745 24.77 20.5107 24.8757L21.5376 25.1351L20.7651 27.7579Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M18.335 29.3046C18.3633 29.0356 18.3727 28.7666 18.3727 28.488C18.3727 28.3247 18.5046 28.1902 18.6648 28.1902H18.9191L19.8235 25.1351C18.222 25.8652 16.7618 26.9412 15.5654 28.3439C16.2249 28.9299 16.9408 29.4487 17.6945 29.9003C17.9111 29.6985 18.1184 29.4968 18.335 29.3046Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M29.79 25.1447L30.6944 28.1998H30.9488C31.1089 28.1998 31.2408 28.3343 31.2408 28.4976C31.2408 28.7763 31.2596 29.0453 31.2785 29.3143C31.4951 29.5064 31.7118 29.6985 31.9096 29.9099C32.6727 29.4584 33.3792 28.9396 34.0387 28.3535C32.8517 26.9509 31.3915 25.8749 29.79 25.1447Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M28.0655 25.1159L29.0923 24.8565C28.8285 24.7605 28.5648 24.6644 28.301 24.5779C27.9713 24.4722 27.6321 24.3858 27.293 24.3089C26.8314 24.2128 26.3698 24.136 25.9082 24.088C26.172 24.9238 26.4546 25.7596 26.7749 26.5858C26.7655 26.7492 26.756 26.9029 26.7466 27.0662C27.4814 27.2103 28.1785 27.4409 28.838 27.7387L28.0655 25.1159Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M24.8067 28.1998H26.8038C26.7662 27.8252 26.7473 27.4505 26.7567 27.0854C26.1256 26.9605 25.4756 26.8932 24.8067 26.8932C24.1379 26.8932 23.4878 26.9605 22.8567 27.0854C22.8661 27.4601 22.8473 27.8252 22.8096 28.1998H24.8067Z",
			fill: "black"
		}),
		s("path", {
			d: "M17.7036 29.9003C17.8638 29.9963 18.0333 30.0924 18.2029 30.1885C18.2594 29.9003 18.3065 29.6025 18.3348 29.3046C18.1181 29.4968 17.9109 29.6985 17.7036 29.9003Z",
			fill: "black"
		}),
		s("path", {
			d: "M20.6333 28.1997H22.8188C22.8565 27.825 22.8754 27.4503 22.8659 27.0853C22.1312 27.2294 21.434 27.4599 20.7746 27.7578L20.6333 28.1997Z",
			fill: "black"
		}),
		s("path", {
			d: "M31.2881 29.3046C31.3163 29.6025 31.3634 29.9003 31.42 30.1885C31.5895 30.102 31.7497 30.006 31.9193 29.9003C31.712 29.6985 31.5048 29.4968 31.2881 29.3046Z",
			fill: "black"
		}),
		s("path", {
			d: "M28.9898 28.1997L28.8579 27.7578C28.1985 27.4599 27.4919 27.2294 26.7666 27.0853C26.7571 27.4599 26.776 27.825 26.8137 28.1997H28.9898Z",
			fill: "black"
		}),
		s("path", {
			d: "M20.6333 28.1998L20.7652 27.7578L21.5471 25.1158L20.5203 24.8564C20.2848 24.9429 20.0587 25.039 19.8326 25.1447L18.9282 28.1998H19.8985H20.6333Z",
			fill: "#AA9678"
		}),
		s("path", {
			d: "M28.8576 27.7578L28.9895 28.1998H29.7243H30.6946L29.7902 25.1447C29.5641 25.039 29.338 24.9525 29.1025 24.8564L28.0757 25.1158L28.8576 27.7578Z",
			fill: "#AA9678"
		}),
		s("path", {
			d: "M18.957 28.8147C18.9665 28.805 18.976 28.805 18.9854 28.7953H18.957C18.957 28.7953 18.957 28.805 18.957 28.8147Z",
			fill: "#C0B098"
		}),
		s("path", {
			d: "M24.807 28.7953H22.7251H20.4548H18.9852C18.9757 28.805 18.9663 28.805 18.9569 28.8146C18.9381 29.3814 18.8627 29.929 18.7402 30.467C20.5772 31.3605 22.6309 31.8601 24.807 31.8601V28.7953Z",
			fill: "#C0B098"
		}),
		s("path", {
			d: "M30.6666 28.7953H30.6382C30.6477 28.805 30.6571 28.805 30.6666 28.8147C30.6666 28.805 30.6666 28.7953 30.6666 28.7953Z",
			fill: "#AA9678"
		}),
		s("path", {
			d: "M30.6379 28.7953H29.1683H26.8886H24.8066V31.8601C26.9733 31.8601 29.0364 31.3605 30.8734 30.467C30.7509 29.929 30.6756 29.3718 30.6567 28.8146C30.6567 28.805 30.6473 28.7953 30.6379 28.7953Z",
			fill: "#AA9678"
		}),
		s("path", {
			d: "M31.2878 29.3046C31.2595 29.0356 31.2501 28.7666 31.2501 28.4879C31.2501 28.3246 31.1182 28.1901 30.9581 28.1901H30.7037H29.7146H28.9798H26.7942H24.7971H22.8H20.6144H19.8796H18.9093H18.655C18.4948 28.1901 18.3629 28.3246 18.3629 28.4879C18.3629 28.7666 18.3441 29.0356 18.3252 29.3046C18.297 29.6024 18.2499 29.9002 18.1934 30.1884C18.3723 30.2845 18.5513 30.3806 18.7303 30.467C18.8528 29.929 18.9282 29.3718 18.947 28.8146C18.947 28.805 18.947 28.805 18.947 28.7954H18.9753H20.4448H22.7152H24.7971H26.8884H29.1588H30.6284H30.6566C30.6566 28.805 30.6566 28.805 30.6566 28.8146C30.6755 29.3814 30.7508 29.929 30.8733 30.467C31.0523 30.3806 31.2313 30.2845 31.4103 30.1884C31.3537 29.9002 31.3161 29.6024 31.2878 29.3046Z",
			fill: "#8B7460"
		}),
		s("path", {
			d: "M28.8581 26.1348C28.8108 26.0866 28.7729 26.0286 28.7256 25.9707C28.7729 26.0383 28.8203 26.0866 28.8581 26.1348Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M34.2272 14.2212C34.1047 14.0482 33.9823 13.8945 33.8598 13.76C33.8033 13.6928 33.7467 13.6351 33.6902 13.5775C33.6714 13.5583 33.6431 13.5391 33.6243 13.5198C33.5866 13.4814 33.5489 13.4526 33.5112 13.4238V14.7688L34.0105 17.1226C34.0199 17.1418 34.0199 17.161 34.0294 17.1802L34.3779 17.5837H34.7453C34.7453 17.5453 34.7453 17.5165 34.7453 17.478C34.7453 16.3636 34.5663 15.2972 34.246 14.298C34.2366 14.2596 34.2366 14.2404 34.2272 14.2212Z",
			fill: "#BBBCBD"
		}),
		s("path", {
			d: "M34.0668 17.3435V17.3531C34.0668 17.3531 34.0668 17.3531 34.0668 17.3627C34.0763 17.4203 34.0763 17.478 34.0763 17.5356C34.0763 17.5452 34.0763 17.5548 34.0763 17.5644C34.0763 17.574 34.0763 17.5836 34.0763 17.5932C34.0763 17.6509 34.0763 17.7085 34.0668 17.7566V17.7662V17.7758C34.0574 17.8334 34.048 17.8911 34.0386 17.9487L34.3871 17.5548L34.0386 17.1513C34.048 17.2186 34.0574 17.2762 34.0668 17.3435Z",
			fill: "#676A6A"
		}),
		s("path", {
			d: "M34.0569 17.7949C34.0569 17.7853 34.0569 17.7853 34.0569 17.7757C34.0663 17.7181 34.0663 17.6604 34.0663 17.6124C34.0663 17.6028 34.0663 17.5836 34.0663 17.574C34.0663 17.5644 34.0663 17.5548 34.0663 17.5356C34.0663 17.4779 34.0663 17.4203 34.0569 17.3626C34.0569 17.353 34.0569 17.353 34.0569 17.3434C34.0475 17.2858 34.0381 17.2281 34.0287 17.1705C34.0192 17.1513 34.0192 17.132 34.0098 17.1128C33.9721 16.9975 33.9345 16.9015 33.8779 16.815C33.8685 16.8054 33.8591 16.7958 33.8591 16.7862C33.8403 16.767 33.8308 16.7478 33.812 16.7285C33.7932 16.6997 33.7649 16.6805 33.7366 16.6613C33.7272 16.6517 33.7178 16.6517 33.7084 16.6421C33.6895 16.6229 33.6613 16.6133 33.6424 16.6037C33.633 16.6037 33.6236 16.594 33.6142 16.594C33.5859 16.5844 33.5482 16.5748 33.5105 16.5748C33.4729 16.5748 33.4446 16.5844 33.4069 16.594C33.3975 16.594 33.3881 16.6037 33.3787 16.6037C33.3598 16.6133 33.3316 16.6229 33.3127 16.6421C33.3033 16.6517 33.2939 16.6517 33.2844 16.6613C33.2562 16.6805 33.2373 16.7093 33.2091 16.7285C33.1902 16.7478 33.1808 16.767 33.162 16.7862C33.1526 16.7958 33.1431 16.8054 33.1431 16.815C33.0866 16.9015 33.0395 16.9975 33.0113 17.1128V17.1224C32.9924 17.1705 32.983 17.2281 32.9736 17.2858C32.9736 17.305 32.9642 17.3146 32.9642 17.3338C32.9547 17.4011 32.9547 17.4587 32.9453 17.5259C32.9453 17.5356 32.9453 17.5452 32.9453 17.5548C32.9453 18.1024 33.1997 18.5539 33.5105 18.5539C33.5671 18.5539 33.6142 18.5347 33.6707 18.5155C33.6801 18.5155 33.6895 18.5059 33.6989 18.5059C33.7178 18.4963 33.7366 18.4771 33.7555 18.4675C33.7649 18.4578 33.7743 18.4482 33.7837 18.4386C33.812 18.4194 33.8308 18.3906 33.8591 18.3618C33.8779 18.3426 33.8874 18.3233 33.9062 18.2945C33.9156 18.2753 33.925 18.2657 33.9345 18.2465C33.9533 18.2177 33.9627 18.1888 33.9816 18.1504C33.991 18.1408 33.991 18.1312 34.0004 18.112C34.0192 18.064 34.0287 18.0159 34.0475 17.9679C34.0475 17.9102 34.0569 17.8526 34.0569 17.7949ZM33.5294 17.4299C33.4069 17.4299 33.3127 17.2666 33.3127 17.0552C33.3127 16.8534 33.4069 16.6805 33.5294 16.6805C33.6518 16.6805 33.7461 16.8438 33.7461 17.0552C33.7461 17.2666 33.6424 17.4299 33.5294 17.4299Z",
			fill: "black"
		}),
		s("path", {
			d: "M33.5297 17.4299C33.6493 17.4299 33.7463 17.2622 33.7463 17.0552C33.7463 16.8483 33.6493 16.6805 33.5297 16.6805C33.41 16.6805 33.313 16.8483 33.313 17.0552C33.313 17.2622 33.41 17.4299 33.5297 17.4299Z",
			fill: "white"
		}),
		s("path", {
			d: "M33.0024 17.1129C33.0401 16.9976 33.0778 16.9015 33.1343 16.815C33.1437 16.8054 33.1532 16.7958 33.1532 16.7862C33.172 16.767 33.1814 16.7478 33.2003 16.7286C33.2191 16.6998 33.2474 16.6805 33.2756 16.6613C33.2851 16.6517 33.2945 16.6517 33.3039 16.6421C33.3227 16.6229 33.351 16.6133 33.3698 16.6037C33.3793 16.6037 33.3887 16.5941 33.3981 16.5941C33.4264 16.5845 33.464 16.5749 33.5017 16.5749C33.5394 16.5749 33.5677 16.5845 33.6054 16.5941C33.6148 16.5941 33.6242 16.6037 33.6336 16.6037C33.6525 16.6133 33.6807 16.6229 33.6996 16.6421C33.709 16.6517 33.7184 16.6517 33.7278 16.6613C33.7561 16.6805 33.7749 16.7094 33.8032 16.7286C33.822 16.7478 33.8314 16.767 33.8503 16.7862C33.8597 16.7958 33.8691 16.8054 33.8691 16.815C33.9256 16.9015 33.9727 16.9976 34.001 17.1129L33.5017 14.7591L33.0024 17.1129Z",
			fill: "#909393"
		}),
		s("path", {
			d: "M26.8317 17.5453C26.8317 17.4973 26.8317 17.4492 26.8222 17.4012C26.8128 17.3532 26.8128 17.3147 26.8034 17.2667C26.794 17.2187 26.7846 17.1802 26.7657 17.1418C26.7563 17.1034 26.7375 17.0553 26.7186 17.0169C26.6998 16.9785 26.6809 16.94 26.6621 16.9016C26.5961 16.7863 26.5208 16.6807 26.4266 16.5942C26.3041 16.4789 26.1628 16.3828 26.0121 16.3156C25.9367 16.2868 25.8519 16.2579 25.7766 16.2387C25.7766 16.2387 25.7766 16.2387 25.7671 16.2387C25.6824 16.2195 25.5976 16.2099 25.5128 16.2099C25.428 16.2099 25.3432 16.2195 25.2584 16.2387H25.249C25.1642 16.2579 25.0889 16.2772 25.0135 16.306C25.0135 16.306 25.0135 16.306 25.0041 16.306C24.9287 16.3348 24.8534 16.3732 24.7874 16.4213C24.7215 16.4693 24.6555 16.5173 24.599 16.575H24.5896C24.4954 16.671 24.4106 16.7767 24.3447 16.892C24.3258 16.9304 24.307 16.9689 24.2881 17.0073C24.2881 17.0073 24.2881 17.0169 24.2787 17.0169C24.2599 17.0553 24.2505 17.0842 24.241 17.1226C24.241 17.1322 24.2316 17.1322 24.2316 17.1418C24.2222 17.1802 24.2128 17.2091 24.2034 17.2475C24.2034 17.2571 24.1939 17.2667 24.1939 17.2763C24.1845 17.3147 24.1845 17.3436 24.1751 17.382C24.1751 17.3916 24.1751 17.4012 24.1657 17.4108C24.1657 17.4588 24.1562 17.5069 24.1562 17.5549C24.1562 17.6414 24.1657 17.7278 24.1845 17.8143C24.1845 17.8143 24.1845 17.8143 24.1845 17.8239C24.2034 17.9104 24.2222 17.9872 24.2599 18.0737C24.3258 18.2274 24.42 18.3715 24.5331 18.4964C24.6273 18.5925 24.7309 18.679 24.8439 18.7462C24.8816 18.7654 24.9193 18.7846 24.957 18.8039H24.9664C25.0041 18.8231 25.0418 18.8327 25.07 18.8423C25.0795 18.8423 25.0795 18.8423 25.0889 18.8519C25.1266 18.8615 25.1548 18.8711 25.1925 18.8807C25.2019 18.8807 25.2113 18.8903 25.2208 18.8903C25.2584 18.8999 25.2867 18.8999 25.3244 18.9095C25.3338 18.9095 25.3432 18.9095 25.3526 18.9191C25.3998 18.9191 25.4469 18.9287 25.494 18.9287C25.6824 18.9287 25.8519 18.8903 26.0121 18.8231C26.0874 18.7846 26.1628 18.7462 26.2382 18.6982C26.3795 18.6021 26.5019 18.4772 26.5961 18.3331C26.6432 18.2562 26.6809 18.1794 26.7186 18.1025C26.7846 17.9392 26.8222 17.7567 26.8222 17.5741V17.5645C26.8317 17.5453 26.8317 17.5453 26.8317 17.5453ZM25.5034 17.382C25.2302 17.382 25.0041 17.1514 25.0041 16.8728C25.0041 16.5942 25.2302 16.3636 25.5034 16.3636C25.7766 16.3636 26.0027 16.5942 26.0027 16.8728C26.0027 17.1514 25.7766 17.382 25.5034 17.382Z",
			fill: "black"
		}),
		s("path", {
			d: "M25.5042 17.3819C25.7799 17.3819 26.0035 17.1539 26.0035 16.8727C26.0035 16.5915 25.7799 16.3635 25.5042 16.3635C25.2284 16.3635 25.0049 16.5915 25.0049 16.8727C25.0049 17.1539 25.2284 17.3819 25.5042 17.3819Z",
			fill: "white"
		}),
		s("path", {
			d: "M24.5806 16.575L25.5038 13.7024C25.5038 13.7024 25.5038 13.5295 25.5038 13.3662C25.5038 13.3181 25.5038 13.2701 25.5038 13.2317C25.5038 13.2124 25.5038 13.2028 25.5038 13.1932C25.5038 13.174 25.5038 13.1548 25.5038 13.1356C25.5038 13.126 25.5038 13.1068 25.5038 13.0972C25.5038 13.0875 25.5038 13.0683 25.5038 13.0587C25.5038 13.0491 25.5038 13.0395 25.5038 13.0395C25.5038 13.0299 25.5038 13.0299 25.5038 13.0299C24.9951 12.9242 24.4675 12.8666 23.9306 12.8666C23.7516 12.8666 23.5726 12.8762 23.3936 12.8858C23.3653 12.8858 23.3465 12.8858 23.3182 12.8954C22.395 12.9626 21.4907 13.2124 20.6522 13.6063C19.9363 13.9426 19.258 14.3845 18.6645 14.9033C18.5044 15.0474 18.3442 15.1915 18.1935 15.3452C18.1652 15.3741 18.137 15.4029 18.1087 15.4317C17.9674 15.5758 17.8261 15.7295 17.6942 15.8833C17.666 15.9217 17.6377 15.9505 17.6094 15.9889C17.4775 16.1523 17.3457 16.3156 17.2232 16.4789C17.2138 16.4885 17.2044 16.5077 17.1949 16.5173C17.0819 16.6807 16.9688 16.844 16.8558 17.0169C16.837 17.0457 16.8087 17.0842 16.7899 17.113C16.7051 17.2571 16.6203 17.4012 16.5449 17.5453H20.7182H20.7276L24.5806 16.575Z",
			fill: "#BBBCBD"
		}),
		s("path", {
			d: "M28.1126 16.2578C28.122 16.1426 28.1314 16.0369 28.1314 15.9216C28.1409 15.7679 28.1409 15.6238 28.1503 15.47C28.1503 15.3548 28.1503 15.2395 28.1503 15.1146C28.1503 15.0762 28.1503 15.0473 28.1503 15.0089C28.1503 14.7015 28.1314 14.4036 28.122 14.0962C28.122 14.0962 28.1126 14.0962 28.1126 14.0866C28.1126 14.0866 28.1032 14.0866 28.1032 14.077C28.0467 14.0482 27.9148 13.9713 27.7923 13.8945H27.7829C27.7546 13.8752 27.7264 13.856 27.6981 13.8464C27.6793 13.8368 27.6604 13.8176 27.6416 13.808L27.6322 13.7984C27.6133 13.7888 27.5945 13.7792 27.5851 13.7696C27.3966 13.6639 27.1988 13.5774 27.001 13.491C26.53 13.2892 25.8894 13.1067 25.522 13.0202V13.2796V13.3372V13.3565C25.522 13.5294 25.522 13.6927 25.522 13.6927L26.4358 16.5557C26.53 16.6421 26.6147 16.7478 26.6713 16.8631C26.6901 16.9015 26.7089 16.94 26.7278 16.9784C26.7466 17.0168 26.7655 17.0552 26.7749 17.1033C26.7843 17.1417 26.8032 17.1897 26.8126 17.2282C26.822 17.2762 26.8314 17.3146 26.8314 17.3627C26.8408 17.4107 26.8408 17.4587 26.8408 17.5068V17.5164H27.9524C28.0278 17.1033 28.0843 16.6806 28.1126 16.2578C28.1126 16.2771 28.1126 16.2675 28.1126 16.2578Z",
			fill: "#E2DDDB"
		}),
		s("path", {
			d: "M26.8425 21.638C27.0968 21.3786 27.3323 21.1384 27.5584 20.8982C27.6903 20.7541 27.8222 20.61 27.9541 20.4755C28.8867 19.4475 29.565 18.4772 29.9795 17.2379C29.9889 17.209 29.9983 17.1706 30.0078 17.1226C30.0078 17.113 30.0078 17.113 30.0078 17.1034C30.0172 17.0553 30.0266 17.0073 30.036 16.9496C30.036 16.9112 30.0454 16.8728 30.0454 16.8344C29.9418 16.2963 29.744 15.7679 29.565 15.2492C29.565 15.2492 29.565 15.2492 29.565 15.2588C29.565 15.2588 29.565 15.2588 29.5556 15.2492C29.5179 15.2203 29.4896 15.1819 29.4519 15.1531C29.3483 15.057 29.2447 14.9609 29.1316 14.8649C28.8019 14.5863 28.4628 14.3269 28.1048 14.1059C28.1237 14.4133 28.1331 14.7112 28.1331 15.0186C28.1331 15.057 28.1331 15.0858 28.1331 15.1243C28.1331 15.2395 28.1331 15.3548 28.1331 15.4797C28.1331 15.6334 28.1237 15.7872 28.1142 15.9313C28.1048 16.0466 28.1048 16.1522 28.0954 16.2675C28.0954 16.2771 28.0954 16.2867 28.0954 16.306C28.0577 16.7287 28.0106 17.1514 27.9353 17.5645L27.8034 18.1986C27.5302 19.3322 26.9744 20.3506 26.5222 21.4074C26.3997 21.686 26.2867 21.9742 26.183 22.2624C26.1736 22.2913 26.1642 22.3201 26.1548 22.3489C26.2961 22.1952 26.428 22.0607 26.5222 21.9646C26.6446 21.8397 26.7389 21.734 26.8425 21.638Z",
			fill: "#FBB040"
		}),
		s("path", {
			d: "M24.5908 16.5749C24.6473 16.5172 24.7133 16.4692 24.7792 16.4212C24.8452 16.3731 24.9205 16.3347 24.9959 16.3059C24.9959 16.3059 24.9959 16.3059 25.0053 16.3059C25.0807 16.2771 25.156 16.2482 25.2408 16.2386H25.2503C25.335 16.2194 25.4198 16.2098 25.5046 16.2098C25.5894 16.2098 25.6742 16.2194 25.759 16.2386C25.759 16.2386 25.759 16.2386 25.7684 16.2386C25.8532 16.2578 25.9285 16.2771 26.0039 16.3155C26.1546 16.3827 26.2959 16.4692 26.4184 16.5941L25.5046 13.7311L24.5908 16.5749Z",
			fill: "#909393"
		}),
		s("path", {
			d: "M24.2701 18.0736C24.2419 17.9967 24.2136 17.9102 24.1948 17.8238C24.1948 17.8238 24.1948 17.8238 24.1948 17.8142C24.1759 17.7277 24.1665 17.6412 24.1665 17.5548C24.1665 17.5067 24.1665 17.4587 24.1759 17.4107C24.1759 17.4011 24.1759 17.3914 24.1853 17.3818C24.1853 17.3434 24.1948 17.3146 24.2042 17.2762C24.2042 17.2666 24.2136 17.2569 24.2136 17.2473C24.223 17.2089 24.2324 17.1801 24.2419 17.1417C24.2419 17.132 24.2513 17.132 24.2513 17.1224C24.2607 17.084 24.2795 17.0456 24.289 17.0168C24.289 17.0168 24.289 17.0072 24.2984 17.0072C24.3172 16.9687 24.3361 16.9303 24.3549 16.8919C24.4208 16.7766 24.5056 16.6709 24.5998 16.5748L20.7374 17.5452H20.728L24.5527 18.4963C24.4303 18.381 24.3361 18.2369 24.2701 18.0736Z",
			fill: "#676A6A"
		}),
		s("path", {
			d: "M32.9553 17.3339C32.9553 17.3147 32.9648 17.2955 32.9648 17.2859C32.9742 17.2283 32.9836 17.1706 33.0024 17.1226C33.0024 17.113 33.0024 17.113 33.0024 17.1034L33.5017 14.7496V13.4046C33.0872 13.0587 32.6539 12.8666 32.1923 12.8666C31.6082 12.8666 31.0712 13.1932 30.6662 13.5967C30.2234 14.0387 29.8843 14.5959 29.6016 15.1531C29.5922 15.1819 29.5734 15.2011 29.564 15.23C29.6487 15.3068 29.7335 15.3837 29.8183 15.4605C30.0067 15.6335 30.1951 15.816 30.3741 15.9985C30.4589 16.085 30.5437 16.1715 30.6285 16.2579C30.7133 16.354 30.8075 16.4405 30.8922 16.5365C31.0053 16.6614 31.1183 16.7767 31.222 16.9016C31.2691 16.9497 31.3162 17.0073 31.3633 17.0553C31.4952 17.2091 31.627 17.3532 31.7589 17.5069C31.7778 17.5261 31.7966 17.5453 31.806 17.5549H32.9459C32.9459 17.5453 32.9459 17.5357 32.9459 17.5261C32.9459 17.4684 32.9459 17.4012 32.9553 17.3339Z",
			fill: "#E2DDDB"
		}),
		s("path", {
			d: "M15.8582 19.0344C15.8582 19.0248 15.8676 19.0152 15.8676 19.0056C15.943 18.8134 16.0184 18.6213 16.1031 18.4291C16.122 18.3715 16.1502 18.3234 16.1785 18.2754C16.2444 18.1217 16.3198 17.9776 16.3952 17.8335C16.4234 17.7758 16.4517 17.7182 16.4894 17.6509C16.5082 17.6221 16.5271 17.5837 16.5459 17.5549C16.6307 17.4108 16.706 17.2667 16.7908 17.1225C16.8097 17.0937 16.8379 17.0553 16.8568 17.0265C16.9604 16.8535 17.0734 16.6902 17.1959 16.5269C17.2053 16.5173 17.2147 16.4981 17.2242 16.4885C17.3466 16.3155 17.4785 16.1522 17.6104 15.9985C17.6387 15.9601 17.6669 15.9312 17.6952 15.8928C17.8271 15.7391 17.9684 15.5854 18.1097 15.4413C18.138 15.4125 18.1662 15.3836 18.1945 15.3548C18.3452 15.2011 18.4959 15.057 18.6655 14.9129C19.2967 12.7416 21.2467 11.1564 23.5453 11.1564C24.4685 11.1564 25.3917 11.4254 26.183 11.925C26.9932 12.4342 27.6526 13.174 28.0765 14.029C28.0765 14.029 28.0765 14.0386 28.086 14.0386C28.0954 14.0578 28.1048 14.077 28.1236 14.1059C28.4816 14.3268 28.8208 14.5862 29.1505 14.8648C29.2635 14.9609 29.3671 15.057 29.4708 15.1531C29.5084 15.1819 29.5367 15.2203 29.5744 15.2491C29.5838 15.2203 29.5932 15.2011 29.6121 15.1723C29.9324 13.0875 30.8367 11.5792 31.9012 11.5792C32.702 11.5792 33.4179 12.4342 33.8513 13.7504V13.76C33.9737 13.8945 34.0962 14.0482 34.2187 14.2115C34.2187 14.2115 34.2187 14.2212 34.2281 14.2212C34.2375 14.2404 34.2375 14.2596 34.2469 14.2788L34.2281 14.2115C32.8998 10.2149 29.1976 7.33276 24.8265 7.33276C19.3438 7.33276 14.9067 11.8578 14.9067 17.4492C14.9067 18.554 15.0763 19.6108 15.3966 20.6004C15.3966 20.6004 15.3966 20.6004 15.3966 20.5908C15.4625 20.2929 15.5379 19.9951 15.6227 19.7069C15.6981 19.4763 15.7734 19.2554 15.8582 19.0344Z",
			fill: "#525353"
		}),
		s("path", {
			d: "M34.3772 17.5644L34.0287 17.9583C34.0193 18.0063 34.0004 18.0544 33.9816 18.1024C33.9816 18.112 33.9722 18.1216 33.9627 18.1408C33.9533 18.1697 33.9345 18.2081 33.9156 18.2369C33.9062 18.2561 33.8968 18.2657 33.8874 18.2849C33.8685 18.3042 33.8591 18.333 33.8403 18.3522C33.8214 18.381 33.7932 18.4098 33.7649 18.4291C33.7555 18.4387 33.7461 18.4483 33.7367 18.4579C33.7178 18.4771 33.699 18.4867 33.6801 18.4963C33.6707 18.4963 33.6613 18.5059 33.6519 18.5059C33.6048 18.5347 33.5482 18.5443 33.4917 18.5443C33.1808 18.5443 32.9265 18.1024 32.9265 17.5452H31.7866C32.0033 17.795 32.2105 18.0448 32.4084 18.3042L32.4178 18.3138C32.6156 18.5636 32.8135 18.8133 33.0113 19.0631C33.0207 19.0727 33.0301 19.092 33.0395 19.1016C33.2279 19.3417 33.4069 19.5819 33.5859 19.8221C33.6048 19.8413 33.6236 19.8701 33.6425 19.8894C33.8309 20.1488 34.0193 20.4081 34.2077 20.6579C34.2077 20.6579 34.2077 20.6579 34.2077 20.6675C34.5374 19.678 34.7164 18.6308 34.7258 17.5356L34.3772 17.5644Z",
			fill: "white"
		}),
		s("path", {
			d: "M23.3176 12.8858C23.3458 12.8858 23.3647 12.8858 23.3929 12.8762C23.5719 12.8665 23.7509 12.8569 23.9299 12.8569C24.4669 12.8569 24.9944 12.9146 25.5031 13.0203C25.5031 13.0203 25.5031 13.0203 25.5031 13.0299C25.5031 13.0299 25.5031 13.0395 25.5031 13.0491C25.5031 13.0587 25.5031 13.0683 25.5031 13.0875C25.5031 13.0971 25.5031 13.1067 25.5031 13.1259C25.5031 13.1452 25.5031 13.1644 25.5031 13.1836C25.5031 13.1932 25.5031 13.2124 25.5031 13.222C25.5031 13.2412 25.5031 13.2604 25.5031 13.2797V13.0203C25.8611 13.1067 26.5017 13.2893 26.9821 13.491C27.18 13.5775 27.3778 13.6736 27.5662 13.7696C27.5756 13.7696 27.5945 13.7792 27.6133 13.7984C27.6133 13.7984 27.6227 13.7984 27.6227 13.8081C27.6416 13.8177 27.6604 13.8273 27.6792 13.8465C27.7075 13.8657 27.7358 13.8753 27.764 13.8945H27.7734C27.8959 13.9618 28.0278 14.0482 28.0843 14.0771C28.0937 14.0771 28.0937 14.0867 28.0937 14.0867L28.1032 14.0963C28.0937 14.0771 28.0843 14.0578 28.0655 14.029C28.0655 14.029 28.0655 14.0194 28.0561 14.0194C27.6321 13.1548 26.9633 12.415 26.1625 11.9154C25.3712 11.4255 24.448 11.1469 23.5248 11.1469C21.2262 11.1469 19.2762 12.732 18.645 14.9033C19.2479 14.3749 19.9168 13.933 20.6327 13.6063C21.49 13.2028 22.4038 12.9626 23.3176 12.8858Z",
			fill: "black"
		}),
		s("path", {
			d: "M30.6757 13.6063C31.0808 13.2028 31.6177 12.8762 32.2018 12.8762C32.6634 12.8762 33.1062 13.0683 33.5113 13.4142C33.5489 13.443 33.5866 13.4814 33.6243 13.5102C33.6431 13.5295 33.6714 13.5487 33.6902 13.5679C33.7468 13.6255 33.8033 13.6832 33.8598 13.7504V13.7408C33.417 12.4246 32.7105 11.5696 31.9098 11.5696C30.8453 11.5696 29.9409 13.0683 29.6206 15.1627C29.8844 14.6055 30.2329 14.0482 30.6757 13.6063Z",
			fill: "black"
		}),
		s("path", {
			d: "M21.2742 26.8932C21.3684 26.9316 21.4532 26.9604 21.5474 26.9893C22.5742 27.3543 23.6764 27.5561 24.8257 27.5561C26.1352 27.5561 27.3881 27.2967 28.528 26.8259C28.5845 26.7971 28.6504 26.7779 28.707 26.7491C28.8012 26.7106 28.9048 26.6626 28.999 26.6146C29.0838 26.5761 29.1686 26.5377 29.2533 26.4897C29.2345 26.4897 29.2157 26.4993 29.1968 26.4993C28.8388 26.5377 28.4903 26.5473 28.1417 26.4897C26.0975 26.1919 25.6453 25.1831 25.7113 24.1455C25.5605 24.059 25.4192 23.963 25.2591 23.8477C23.6859 22.6852 22.7532 21.4459 22.7532 21.4459C22.7532 21.4459 23.9685 22.397 25.7772 23.1175C25.8149 23.1368 25.8526 23.1464 25.8902 23.1656C25.975 22.8678 26.0787 22.5795 26.1634 22.3297C26.1729 22.3009 26.1823 22.2721 26.1917 22.2433C26.2953 21.9551 26.4084 21.6668 26.5308 21.3882C26.983 20.3314 27.5388 19.3035 27.812 18.1794L27.9439 17.5453H26.8323V17.5549C26.8323 17.7471 26.7946 17.92 26.7287 18.0833C26.691 18.1602 26.6533 18.2467 26.6062 18.3139C26.512 18.458 26.3895 18.5829 26.2482 18.679C26.1729 18.727 26.0975 18.7655 26.0221 18.8039C25.862 18.8711 25.683 18.9096 25.504 18.9096C25.4569 18.9096 25.4098 18.9096 25.3627 18.9C25.3533 18.9 25.3439 18.9 25.3344 18.8904C25.2968 18.8904 25.2685 18.8807 25.2308 18.8711C25.2214 18.8711 25.212 18.8615 25.2025 18.8615C25.1649 18.8519 25.1366 18.8423 25.0989 18.8327C25.0895 18.8327 25.0895 18.8327 25.0801 18.8231C25.0424 18.8135 25.0047 18.7943 24.9765 18.7847H24.967C24.9294 18.7655 24.8917 18.7462 24.854 18.727C24.7409 18.6598 24.6373 18.5829 24.5431 18.4772L20.7184 17.5261H16.5451C16.5263 17.5549 16.5075 17.5934 16.4886 17.6222C16.4604 17.6798 16.4227 17.7375 16.3944 17.8047C16.3191 17.9488 16.2437 18.1026 16.1778 18.2467C16.1495 18.2947 16.1306 18.3523 16.1024 18.4004C16.0176 18.5925 15.9422 18.7847 15.8669 18.9768C15.8669 18.9864 15.8575 18.996 15.8575 19.0056C15.7727 19.2266 15.6973 19.4572 15.6314 19.6878C15.5466 19.976 15.4712 20.2738 15.4053 20.5716C16.0647 22.618 17.3365 24.3761 19.0133 25.6058C19.0604 25.6442 19.1169 25.6731 19.164 25.7115C19.4466 25.9132 19.7387 26.1054 20.0401 26.2687C20.4358 26.5185 20.8503 26.7203 21.2742 26.8932Z",
			fill: "white"
		}),
		s("path", {
			d: "M28.1225 23.7419C28.1037 23.8476 28.0942 23.9533 28.0942 24.059C28.0848 24.2415 28.1037 24.4241 28.1319 24.5874C28.1508 24.7027 28.1696 24.8083 28.1979 24.914C28.245 25.0677 28.2921 25.2118 28.358 25.3464C28.424 25.4809 28.4899 25.6057 28.5559 25.7114C28.5747 25.7499 28.603 25.7883 28.6218 25.8171C28.6595 25.8651 28.6877 25.9132 28.7254 25.9612C28.7725 26.0189 28.8196 26.0765 28.8573 26.1245C29.0363 26.3359 29.187 26.4512 29.187 26.4512C29.187 26.4512 29.187 26.4512 29.187 26.4608C29.187 26.4704 29.187 26.48 29.1964 26.4896C29.2153 26.4896 29.2341 26.48 29.253 26.48C29.6957 26.4224 30.1385 26.2975 30.5812 26.1438C30.8073 26.0573 31.0334 25.9708 31.2501 25.8747C31.316 25.8459 31.382 25.8075 31.4479 25.7787C33.7183 24.6546 35.6212 22.6755 35.6212 22.6755C32.7762 24.107 29.9783 24.0494 28.1225 23.7419Z",
			fill: "#9F2255"
		}),
		s("path", {
			d: "M33.6061 19.8414C33.4271 19.6013 33.2387 19.3611 33.0597 19.1209C33.0503 19.1113 33.0409 19.0921 33.0314 19.0825C32.8336 18.8327 32.6358 18.5829 32.438 18.3331L32.4285 18.3235C32.2213 18.0641 32.014 17.8143 31.8068 17.5645C31.7974 17.5453 31.7785 17.5357 31.7691 17.5165C31.6372 17.3628 31.5053 17.2187 31.3734 17.0649C31.3263 17.0169 31.2792 16.9593 31.2321 16.9112C31.1191 16.7863 31.0155 16.671 30.9024 16.5461C30.8176 16.4501 30.7234 16.3636 30.6387 16.2675C30.5539 16.1811 30.4691 16.0946 30.3843 16.0081C30.2053 15.8256 30.0169 15.6431 29.8285 15.4701C29.7437 15.3933 29.6589 15.3164 29.5741 15.2396C29.7531 15.768 29.9604 16.2964 30.064 16.844C30.0923 16.9881 30.1111 17.1226 30.1299 17.2571C30.3843 19.1497 29.7814 20.389 28.8393 22.0223C28.7734 22.1376 28.698 22.2625 28.6321 22.3777C28.4154 22.7428 28.2741 23.0983 28.1988 23.4249C28.1705 23.5306 28.1517 23.6363 28.1328 23.742C29.9886 24.0494 32.7771 24.107 35.6315 22.6756C35.6315 22.6756 35.0757 21.8397 34.2278 20.6869C34.0394 20.4275 33.851 20.1681 33.6626 19.9183C33.6438 19.8895 33.6249 19.8606 33.6061 19.8414Z",
			fill: "#E2066F"
		}),
		s("path", {
			d: "M29.1871 26.4703C29.1871 26.4703 29.0458 26.3551 28.8574 26.1437C28.8103 26.0957 28.7726 26.038 28.7255 25.9804C28.6878 25.9323 28.6596 25.8843 28.6219 25.8363C28.603 25.7978 28.5748 25.769 28.5559 25.7306C28.49 25.6153 28.424 25.5 28.3581 25.3655C28.3016 25.231 28.2451 25.0869 28.198 24.9332C28.1697 24.8275 28.1414 24.7218 28.132 24.6065C28.1037 24.4432 28.0943 24.2607 28.0943 24.0781C28.0943 23.9725 28.1037 23.8668 28.1226 23.7611C28.1414 23.6554 28.1603 23.5497 28.1885 23.4441C28.2733 23.1174 28.4052 22.7716 28.6219 22.3969C28.6878 22.272 28.7632 22.1567 28.8291 22.0414C29.7712 20.4082 30.3741 19.1784 30.1197 17.2762C30.1009 17.1417 30.082 16.9976 30.0538 16.8631C30.0444 16.9592 30.0255 17.0456 30.0067 17.1129C30.0067 17.1225 30.0067 17.1225 30.0067 17.1321C29.9973 17.1801 29.9878 17.2186 29.9784 17.2474C29.5639 18.4867 28.8856 19.4571 27.953 20.485C27.8306 20.6291 27.6987 20.7636 27.5574 20.9077C27.3313 21.1479 27.0863 21.3977 26.8414 21.6475C26.7378 21.7532 26.6342 21.8493 26.5305 21.9549C26.4363 22.051 26.3044 22.1855 26.1631 22.3392C26.0783 22.589 25.9747 22.8772 25.8899 23.1751C25.8523 23.1558 25.8146 23.1462 25.7769 23.127C23.9682 22.4161 22.7529 21.4554 22.7529 21.4554C22.7529 21.4554 23.6856 22.6947 25.2588 23.8572C25.4095 23.9725 25.5602 24.0685 25.711 24.155C25.645 25.2022 26.0972 26.2013 28.1414 26.4992C28.49 26.5472 28.8385 26.5472 29.1965 26.5088C29.1965 26.4896 29.1871 26.4799 29.1871 26.4703Z",
			fill: "black"
		})
	], -1), n[1] ||= s("defs", null, [s("clipPath", { id: "clip0_presta_48" }, [s("rect", {
		width: "48",
		height: "48",
		fill: "white"
	})])], -1)], 64);
}
var Yg = /*#__PURE__*/ G(qg, [["render", Jg]]), Xg = {};
function Zg(t, n) {
	return A(), o(e, null, [n[0] ||= s("path", {
		"clip-rule": "evenodd",
		d: "M2.227 5h19.462a2.227 2.227 0 0 1 2.226 2.228v7.425a2.226 2.226 0 0 1-2.226 2.226h-6.98l.955 2.348-4.216-2.348H2.223A2.227 2.227 0 0 1 0 14.653V7.228A2.228 2.228 0 0 1 2.227 5Z",
		fill: "#7D57A4",
		"fill-rule": "evenodd"
	}, null, -1), n[1] ||= s("path", {
		d: "M1.204 7.017a.806.806 0 0 1 .612-.302c.496-.035.78.2.854.702.306 2.038.634 3.769.984 5.191l2.142-4.073c.194-.368.439-.562.735-.584.429-.03.697.244.805.82.201 1.14.51 2.259.925 3.34.257-2.48.686-4.274 1.288-5.38a.753.753 0 0 1 .646-.433.86.86 0 0 1 .616.193.752.752 0 0 1 .299.564.829.829 0 0 1-.094.471c-.382.708-.696 1.885-.942 3.53-.242 1.59-.332 2.832-.269 3.728.022.22-.017.442-.114.64a.615.615 0 0 1-.52.353c-.258.02-.515-.102-.774-.362-.908-.932-1.63-2.318-2.165-4.16-.627 1.256-1.098 2.194-1.411 2.817-.574 1.104-1.066 1.67-1.476 1.699-.266.019-.493-.205-.68-.67-.502-1.279-1.04-3.751-1.615-7.419a.836.836 0 0 1 .154-.665ZM22.212 8.553a2.268 2.268 0 0 0-1.562-1.13 2.612 2.612 0 0 0-.531-.056c-.936 0-1.701.487-2.295 1.462a5.193 5.193 0 0 0-.76 2.753c0 .753.157 1.398.471 1.936a2.264 2.264 0 0 0 1.564 1.13c.174.037.351.056.53.057.945 0 1.71-.488 2.293-1.462a5.259 5.259 0 0 0 .76-2.769c0-.753-.156-1.393-.47-1.92Zm-1.233 2.712c-.134.64-.381 1.122-.744 1.446-.286.258-.55.363-.788.316-.24-.048-.431-.259-.575-.633a2.526 2.526 0 0 1-.172-.89c-.001-.24.023-.48.071-.717.093-.417.268-.812.516-1.161.325-.477.664-.678 1.018-.601.24.048.43.258.574.63.11.284.168.585.172.889 0 .242-.023.483-.072.72ZM16.087 8.553a2.269 2.269 0 0 0-1.563-1.13 2.612 2.612 0 0 0-.53-.056c-.938 0-1.702.487-2.294 1.462a5.185 5.185 0 0 0-.76 2.753c0 .753.156 1.398.47 1.936a2.259 2.259 0 0 0 1.563 1.13c.174.037.352.056.53.057.946 0 1.711-.488 2.294-1.462a5.27 5.27 0 0 0 .768-2.769c0-.753-.157-1.393-.471-1.92h-.008Zm-1.233 2.712c-.134.64-.383 1.124-.746 1.448-.287.258-.55.363-.789.315-.238-.047-.43-.259-.573-.634a2.524 2.524 0 0 1-.172-.89c0-.24.023-.48.072-.717.093-.417.269-.811.515-1.161.324-.476.664-.676 1.019-.6.239.049.43.259.573.631.11.283.169.584.172.889.001.24-.023.48-.072.717v.002Z",
		fill: "#fff"
	}, null, -1)], 64);
}
var Qg = /*#__PURE__*/ G(Xg, [["render", Zg]]), $g = {}, e_ = {
	d: "M 9.632812 15.890625 C 9.554688 15.894531 9.507812 15.898438 9.457031 15.898438 C 8.386719 15.898438 7.320312 15.898438 6.253906 15.902344 C 6.101562 15.902344 6.0625 15.863281 6.0625 15.710938 C 6.066406 13.226562 6.066406 10.734375 6.066406 8.246094 C 6.066406 8.179688 6.066406 8.117188 6.066406 8.03125 C 5.484375 8.03125 4.917969 8.03125 4.34375 8.03125 C 4.34375 7.144531 4.34375 6.273438 4.34375 5.375 C 4.402344 5.375 4.460938 5.375 4.511719 5.375 C 4.980469 5.375 5.449219 5.371094 5.917969 5.378906 C 6.039062 5.378906 6.070312 5.34375 6.070312 5.226562 C 6.0625 4.53125 6.0625 3.832031 6.070312 3.132812 C 6.070312 2.648438 6.148438 2.171875 6.375 1.730469 C 6.695312 1.109375 7.207031 0.707031 7.851562 0.457031 C 8.375 0.25 8.929688 0.175781 9.484375 0.164062 C 10.390625 0.152344 11.296875 0.160156 12.203125 0.15625 C 12.289062 0.15625 12.355469 0.152344 12.355469 0.273438 C 12.351562 1.132812 12.351562 1.992188 12.351562 2.851562 C 12.351562 2.859375 12.351562 2.867188 12.335938 2.910156 C 12.285156 2.910156 12.226562 2.910156 12.164062 2.910156 C 11.601562 2.910156 11.039062 2.90625 10.476562 2.910156 C 10.152344 2.910156 9.890625 3.039062 9.726562 3.324219 C 9.675781 3.410156 9.644531 3.519531 9.644531 3.617188 C 9.632812 4.148438 9.644531 4.679688 9.636719 5.210938 C 9.636719 5.335938 9.675781 5.371094 9.796875 5.371094 C 10.578125 5.367188 11.359375 5.367188 12.140625 5.367188 C 12.203125 5.367188 12.261719 5.367188 12.367188 5.367188 C 12.257812 6.261719 12.152344 7.136719 12.042969 8.023438 C 11.230469 8.023438 10.441406 8.023438 9.632812 8.023438 C 9.632812 10.648438 9.632812 13.261719 9.632812 15.890625 Z M 9.632812 15.890625 ",
	fill: "currentColor"
};
function t_(e, t) {
	return A(), o("path", e_);
}
var n_ = /*#__PURE__*/ G($g, [["render", t_]]), r_ = {}, i_ = {
	"clip-rule": "evenodd",
	d: "M14.7624 2C15.8988 2.00005 16.9119 2.27211 17.8029 2.81393L14.1968 6.43425L11.0594 3.28458C12.0994 2.42868 13.3334 2 14.7624 2ZM17.7171 11.8052L17.5156 12.0001L17.5193 12.0038L9.91443 19.6385L6.52249 16.3649L19.0312 3.80693C19.936 4.73588 20.389 5.85632 20.389 7.16849C20.389 8.30138 20.0515 9.29149 19.377 10.1387L17.7171 11.8052ZM18.8567 20.3654C17.7388 21.4547 16.3739 22 14.7623 22C13.3334 22 12.0994 21.5708 11.0594 20.7154L18.6282 13.1168L18.8567 13.3462C19.8781 14.3077 20.3891 15.4773 20.3891 16.8558C20.3891 18.2335 19.8781 19.4039 18.8567 20.3654ZM9.91449 4.36151L2.00018 11.9997L2 11.9999L5.39192 15.2735L13.0878 7.54731L9.91449 4.36151Z",
	fill: "#FF3E3E",
	"fill-rule": "evenodd"
};
function a_(e, t) {
	return A(), o("path", i_);
}
var o_ = /*#__PURE__*/ G(r_, [["render", a_]]), s_ = {};
function c_(t, n) {
	return A(), o(e, null, [n[0] ||= s("rect", {
		fill: "#EEDC00",
		height: "24",
		rx: "4",
		width: "24"
	}, null, -1), n[1] ||= s("path", {
		d: "M21.6491 12.2133C21.6549 11.8733 21.5226 11.6067 21.2005 11.6067C20.9244 11.6067 20.7575 11.88 20.7575 12.2133H21.6491ZM20.7575 12.48C20.7345 12.8333 20.8611 13.2067 21.2005 13.2067C21.4593 13.2067 21.5858 13.0867 21.6261 12.7933H21.977C21.9252 13.2533 21.6146 13.4867 21.1947 13.4867C20.631 13.4867 20.4067 13.0267 20.4067 12.4267C20.4067 11.8333 20.6655 11.3333 21.2235 11.3333C21.7469 11.3467 21.9942 11.7333 21.9942 12.2933V12.4867H20.7575V12.48ZM18.9456 11.6933H18.9514C19.0607 11.44 19.308 11.3333 19.4806 11.3333C19.6014 11.3333 20.1421 11.3667 20.1421 12.02V13.4267H19.8085V12.1467C19.8085 11.8133 19.6877 11.6267 19.4058 11.6267C19.4058 11.6267 19.2217 11.6133 19.0837 11.7733C19.0377 11.8333 18.9456 11.92 18.9456 12.32V13.4267H18.612V11.3933H18.9399V11.6933H18.9456ZM17.6112 12.44C17.4098 12.4533 17.1395 12.54 17.1395 12.8333C17.1395 13.0867 17.289 13.2133 17.4846 13.2133C17.8758 13.2133 17.9505 12.82 17.9448 12.44H17.6112ZM17.9448 12.1667C17.9448 11.8133 17.9275 11.6067 17.5766 11.6067C17.4098 11.6067 17.2545 11.72 17.2488 11.9333H16.8979C16.9152 11.4867 17.2143 11.3267 17.5594 11.3267C17.9218 11.3267 18.2784 11.4533 18.2784 12.02V12.9933C18.2784 13.08 18.2842 13.2533 18.2899 13.42H18.0656C18.0368 13.42 17.9735 13.44 17.9735 13.3933C17.9678 13.3 17.962 13.2133 17.9563 13.12H17.9505C17.8412 13.3733 17.6457 13.4867 17.4041 13.4867C17.0992 13.4867 16.7944 13.3067 16.7944 12.9067C16.7944 12.3333 17.2315 12.1667 17.6457 12.1667H17.9448ZM16.1271 10.5H16.524V10.92H16.1271V10.5ZM16.1616 11.3933H16.4953V13.4267H16.1616V11.3933ZM15.4139 10.5H15.7475V13.4267H15.4139V10.5ZM14.4188 12.44C14.2174 12.4533 13.9471 12.54 13.9471 12.8333C13.9471 13.0867 14.0966 13.2133 14.2922 13.2133C14.6833 13.2133 14.7581 12.82 14.7524 12.44H14.4188ZM14.7524 12.1667C14.7524 11.8133 14.7351 11.6067 14.3842 11.6067C14.2174 11.6067 14.0564 11.72 14.0564 11.9333H13.7055C13.7227 11.4867 14.0219 11.3267 14.3727 11.3267C14.7351 11.3267 15.0917 11.4533 15.0917 12.02V12.9933C15.0917 13.08 15.0975 13.2533 15.1032 13.42H14.8789C14.8502 13.42 14.7869 13.44 14.7869 13.3933C14.7811 13.3 14.7754 13.2133 14.7696 13.12H14.7639C14.6546 13.3733 14.459 13.4867 14.2174 13.4867C13.9126 13.4867 13.6077 13.3067 13.6077 12.9067C13.6077 12.3333 14.0449 12.1667 14.459 12.1667H14.7524ZM12.7104 11.3933V10.96L13.044 10.8333V11.3867L13.4524 11.3733V11.66L13.044 11.6533V12.9667C13.044 13.1133 13.1418 13.18 13.2626 13.18C13.3144 13.18 13.3834 13.1733 13.4351 13.1533V13.4467C13.3604 13.4533 13.2856 13.4733 13.2051 13.4733C13.1245 13.4733 13.0613 13.4667 12.9807 13.4533C12.929 13.44 12.8427 13.4067 12.7852 13.32C12.7276 13.22 12.7104 13.2133 12.7104 12.94V11.66L12.4113 11.6667V11.38L12.7104 11.3933ZM11.8131 10.5H12.21V10.92H11.8131V10.5ZM11.8476 11.3933H12.1812V13.4267H11.8476V11.3933ZM8.4826 11.4133V11.1067L9.14409 10.8133V11.4133H9.52948V11.9H9.14409V12.7C9.14409 12.7533 9.11533 13.0133 9.27064 13.0133C9.35692 13.0133 9.44895 13.0133 9.52373 13V13.4533C9.37417 13.4867 9.26488 13.4933 9.1671 13.4933C8.71843 13.4933 8.44809 13.42 8.4826 12.8V11.8933H8.14323V11.4067H8.4826V11.4133ZM7.3897 12.04C7.3897 11.9733 7.3782 11.9133 7.34944 11.8733C7.31493 11.8267 7.25741 11.8 7.16537 11.8C7.06759 11.8 7.01007 11.8667 7.01007 11.98C7.01007 12.1267 7.28041 12.12 7.69456 12.2733C7.90164 12.3533 8.04544 12.5 8.04544 12.8333C8.04544 13.3733 7.60828 13.5067 7.21139 13.5067C6.77998 13.5067 6.36583 13.4067 6.36583 12.7867H6.99281C6.98131 12.8467 6.99856 12.9133 7.03883 12.9667C7.07909 13.02 7.13086 13.06 7.19413 13.06C7.32068 13.06 7.41846 13.0067 7.41846 12.8733C7.41846 12.5133 6.38309 12.7267 6.38309 11.9933C6.38309 11.4933 6.84326 11.3533 7.19413 11.3533C7.60828 11.3533 7.99367 11.48 8.02243 12.04H7.3897ZM5.22117 13.0533C5.50302 13.0533 5.56054 12.7133 5.56054 12.4267C5.56054 12.14 5.50302 11.8 5.22117 11.8C4.94507 11.8 4.88179 12.14 4.88179 12.4267C4.88179 12.7133 4.93932 13.0533 5.22117 13.0533ZM6.23929 12.4267C6.23929 13.1733 5.76762 13.5 5.22117 13.5C4.67472 13.5 4.20305 13.1733 4.20305 12.4267C4.20305 11.68 4.67472 11.3533 5.22117 11.3533C5.76762 11.3533 6.23929 11.68 6.23929 12.4267ZM3.05838 11.8333C3.33448 11.82 3.44953 11.6733 3.44953 11.46C3.44953 11.2467 3.33448 11.1 3.05838 11.0867H2.70175V11.8333H3.05838ZM2 13.44V10.52H3.15617C3.77164 10.52 4.18004 10.7533 4.18004 11.46C4.18004 12.1667 3.77739 12.4 3.15617 12.4H2.696V13.44H2ZM10.933 12.1667C10.933 12.06 10.9042 11.9467 10.8525 11.8667C10.8007 11.78 10.7259 11.7267 10.6224 11.74C10.3923 11.7533 10.3348 11.94 10.3175 12.1733H10.933V12.1667ZM10.306 12.58C10.3003 12.84 10.3635 13.0667 10.6109 13.0667C10.7949 13.0667 10.91 12.9667 10.933 12.7733H11.5485C11.5255 13.0333 11.3874 13.2267 11.2148 13.34C11.0595 13.4533 10.864 13.5 10.6626 13.5C9.96089 13.5 9.68479 13.1533 9.68479 12.36C9.68479 11.72 10.0989 11.3533 10.6281 11.3533C11.3414 11.3533 11.5657 11.8267 11.5657 12.58H10.306Z",
		fill: "#0047BB"
	}, null, -1)], 64);
}
var l_ = /*#__PURE__*/ G(s_, [["render", c_]]), u_ = {};
function d_(t, n) {
	return A(), o(e, null, [
		n[0] ||= s("rect", {
			fill: "#E3007B",
			height: "24",
			rx: "1.69",
			ry: "1.69",
			width: "24",
			x: "0",
			y: "0"
		}, null, -1),
		n[1] ||= s("polygon", {
			fill: "#FFFFFF",
			points: "2.12,5.72 3.96,5.72 7.58,16.40 11.16,5.72 13.05,5.72 8.47,18.26 6.67,18.26"
		}, null, -1),
		n[2] ||= s("polygon", {
			fill: "#FFFFFF",
			points: "15.42,5.72 17.35,5.72 21.88,18.26 20.05,18.26 16.31,7.61 12.43,18.26 10.71,18.26"
		}, null, -1)
	], 64);
}
var f_ = /*#__PURE__*/ G(u_, [["render", d_]]), p_ = {};
function m_(t, n) {
	return A(), o(e, null, [
		n[0] ||= s("path", {
			d: "M4.68225 11.0506C5.16775 10.2097 4.70996 9.03645 3.65975 8.43008C2.60953 7.82371 1.36458 8.01382 0.879081 8.85471C0.393578 9.69559 0.851369 10.8688 1.90158 11.4752C2.9518 12.0815 4.19675 11.8914 4.68225 11.0506Z",
			fill: "#F9B000"
		}, null, -1),
		n[1] ||= s("path", {
			d: "M12.5084 7.68253C13.5586 7.07616 14.0164 5.90294 13.5309 5.06205C13.0454 4.22117 11.8004 4.03106 10.7502 4.63743C9.7 5.24379 9.24221 6.41702 9.72771 7.2579C10.2132 8.09879 11.4582 8.2889 12.5084 7.68253Z",
			fill: "#F28B00"
		}, null, -1),
		n[2] ||= s("path", {
			d: "M7.6194 4.40699C8.10903 4.12429 8.32113 3.57501 8.09314 3.18014C7.86515 2.78526 7.2834 2.69432 6.79378 2.97702C6.30415 3.25972 6.09205 3.809 6.32004 4.20388C6.54803 4.59875 7.12977 4.68969 7.6194 4.40699Z",
			fill: "#FCBD00"
		}, null, -1),
		n[3] ||= s("path", {
			d: "M15.635 4.39202C16.122 4.68089 16.7085 4.60627 16.9393 4.21835C17.1789 3.83042 16.9725 3.27755 16.4855 2.98867C15.9981 2.6998 15.412 2.77398 15.1808 3.16191C14.9416 3.54984 15.148 4.10271 15.635 4.39202Z",
			fill: "#F28B00"
		}, null, -1),
		n[4] ||= s("path", {
			d: "M7.20646 8.48644C7.66243 8.48644 8.03206 8.02811 8.03206 7.46273C8.03206 6.89736 7.66243 6.43903 7.20646 6.43903C6.75049 6.43903 6.38086 6.89736 6.38086 7.46273C6.38086 8.02811 6.75049 8.48644 7.20646 8.48644Z",
			fill: "#F9B000"
		}, null, -1),
		n[5] ||= s("path", {
			d: "M3.45878 7.05969C4.26815 6.59238 4.62125 5.68872 4.24745 5.04131C3.87365 4.3939 2.91451 4.2479 2.10514 4.71521C1.29577 5.18251 0.942671 6.08617 1.31647 6.73358C1.69027 7.38099 2.64941 7.52699 3.45878 7.05969Z",
			fill: "#FCBD00"
		}, null, -1),
		n[6] ||= s("path", {
			d: "M21.9467 6.73487C22.3205 6.08746 21.9674 5.18381 21.158 4.7165C20.3486 4.24919 19.3895 4.39519 19.0157 5.0426C18.6419 5.69001 18.995 6.59367 19.8044 7.06098C20.6137 7.52829 21.5729 7.38228 21.9467 6.73487Z",
			fill: "#EE7100"
		}, null, -1),
		n[7] ||= s("path", {
			d: "M13.1 11.3564C13.4738 10.709 13.1207 9.80533 12.3113 9.33802C11.502 8.87071 10.5428 9.01671 10.169 9.66412C9.79521 10.3115 10.1483 11.2152 10.9577 11.6825C11.767 12.1498 12.7262 12.0038 13.1 11.3564Z",
			fill: "#EE7100"
		}, null, -1),
		n[8] ||= s("path", {
			d: "M16.7322 8.6358C17.5416 8.16849 17.8947 7.26483 17.5209 6.61742C17.1471 5.97001 16.1879 5.82401 15.3786 6.29132C14.5692 6.75862 14.2161 7.66228 14.5899 8.30969C14.9637 8.9571 15.9228 9.1031 16.7322 8.6358Z",
			fill: "#EE7100"
		}, null, -1),
		n[9] ||= s("path", {
			d: "M20.4799 10.6822C20.9359 10.6822 21.3055 10.2239 21.3055 9.65848C21.3055 9.0931 20.9359 8.63477 20.4799 8.63477C20.0239 8.63477 19.6543 9.0931 19.6543 9.65848C19.6543 10.2239 20.0239 10.6822 20.4799 10.6822Z",
			fill: "#E84C05"
		}, null, -1),
		n[10] ||= s("path", {
			d: "M7.88358 12.4086C8.69295 11.9413 9.04605 11.0377 8.67225 10.3902C8.29845 9.74284 7.33931 9.59684 6.52994 10.0641C5.72057 10.5315 5.36748 11.4351 5.74127 12.0825C6.11507 12.7299 7.07422 12.8759 7.88358 12.4086Z",
			fill: "#F28B00"
		}, null, -1),
		n[11] ||= s("path", {
			d: "M3.19655 14.345C3.68618 14.0623 3.89828 13.5131 3.67029 13.1182C3.4423 12.7233 2.86055 12.6324 2.37092 12.9151C1.8813 13.1978 1.6692 13.747 1.89719 14.1419C2.12518 14.5368 2.70692 14.6277 3.19655 14.345Z",
			fill: "#F9B000"
		}, null, -1),
		n[12] ||= s("path", {
			d: "M3.19486 16.485C2.70788 16.2044 2.12141 16.2869 1.89886 16.6831C1.67631 17.0793 1.88228 17.6243 2.37755 17.9049C2.86453 18.1855 3.45101 18.103 3.67355 17.7068C3.90482 17.3184 3.69013 16.7656 3.19486 16.485Z",
			fill: "#F28B00"
		}, null, -1),
		n[13] ||= s("path", {
			d: "M11.6311 14.8093C12.1965 14.8093 12.6548 14.4397 12.6548 13.9837C12.6548 13.5278 12.1965 13.1581 11.6311 13.1581C11.0658 13.1581 10.6074 13.5278 10.6074 13.9837C10.6074 14.4397 11.0658 14.8093 11.6311 14.8093Z",
			fill: "#EE7100"
		}, null, -1),
		n[14] ||= s("path", {
			d: "M16.9351 13.2699C17.9854 12.6636 18.4431 11.4903 17.9576 10.6495C17.4721 9.80858 16.2272 9.61846 15.177 10.2248C14.1268 10.8312 13.669 12.0044 14.1545 12.8453C14.64 13.6862 15.8849 13.8763 16.9351 13.2699Z",
			fill: "#E84C05"
		}, null, -1),
		n[15] ||= s("path", {
			d: "M21.156 14.6035C21.9654 14.1362 22.3185 13.2325 21.9447 12.5851C21.5709 11.9377 20.6118 11.7917 19.8024 12.259C18.993 12.7263 18.6399 13.63 19.0137 14.2774C19.3875 14.9248 20.3467 15.0708 21.156 14.6035Z",
			fill: "#E3000B"
		}, null, -1),
		n[16] ||= s("path", {
			d: "M15.6512 16.221C16.1382 16.5015 16.7246 16.4191 16.9472 16.0229C17.1697 15.6266 16.9638 15.0816 16.4685 14.801C15.9815 14.5205 15.395 14.6029 15.1725 14.9991C14.9495 15.3954 15.1559 15.9321 15.6512 16.221Z",
			fill: "#E84C05"
		}, null, -1),
		n[17] ||= s("path", {
			d: "M20.0676 16.4933C19.5807 16.7738 19.3664 17.3267 19.5889 17.7151C19.8119 18.103 20.398 18.1938 20.8849 17.9132C21.3719 17.6326 21.5866 17.0797 21.3636 16.6914C21.1411 16.303 20.5633 16.2127 20.0676 16.4933Z",
			fill: "#E3000B"
		}, null, -1),
		n[18] ||= s("path", {
			d: "M11.6309 19.4483C12.3785 19.4483 12.9845 18.6907 12.9845 17.7561C12.9845 16.8215 12.3785 16.0639 11.6309 16.0639C10.8834 16.0639 10.2773 16.8215 10.2773 17.7561C10.2773 18.6907 10.8834 19.4483 11.6309 19.4483Z",
			fill: "#E84C05"
		}, null, -1),
		n[19] ||= s("path", {
			d: "M7.88358 16.1805C8.69295 15.7132 9.04605 14.8096 8.67225 14.1622C8.29845 13.5148 7.33931 13.3687 6.52994 13.8361C5.72058 14.3034 5.36748 15.207 5.74127 15.8544C6.11507 16.5018 7.07422 16.6478 7.88358 16.1805Z",
			fill: "#F28B00"
		}, null, -1),
		n[20] ||= s("path", {
			d: "M11.6313 23.6666C12.844 23.6666 13.8271 22.8795 13.8271 21.9085C13.8271 20.9375 12.844 20.1504 11.6313 20.1504C10.4186 20.1504 9.43555 20.9375 9.43555 21.9085C9.43555 22.8795 10.4186 23.6666 11.6313 23.6666Z",
			fill: "#E84C05"
		}, null, -1),
		n[21] ||= s("path", {
			d: "M8.67128 19.9445C9.04507 19.2971 8.69197 18.3934 7.88261 17.9261C7.07324 17.4588 6.11409 17.6048 5.7403 18.2522C5.3665 18.8996 5.7196 19.8033 6.52897 20.2706C7.33833 20.7379 8.29748 20.5919 8.67128 19.9445Z",
			fill: "#EE7100"
		}, null, -1),
		n[22] ||= s("path", {
			d: "M16.7312 20.266C17.5406 19.7987 17.8937 18.895 17.5199 18.2476C17.1461 17.6002 16.187 17.4542 15.3776 17.9215C14.5682 18.3888 14.2151 19.2925 14.5889 19.9399C14.9627 20.5873 15.9219 20.7333 16.7312 20.266Z",
			fill: "#E3000B"
		}, null, -1),
		n[23] ||= s("path", {
			d: "M13.0971 2.86476C13.4709 2.21734 13.1178 1.31369 12.3084 0.846381C11.499 0.379073 10.5399 0.525076 10.1661 1.17249C9.79228 1.8199 10.1454 2.72355 10.9547 3.19086C11.7641 3.65817 12.7233 3.51217 13.0971 2.86476Z",
			fill: "#F9B000"
		}, null, -1)
	], 64);
}
var h_ = /*#__PURE__*/ G(p_, [["render", m_]]), g_ = {};
function __(e, t) {
	return A(), o("g", null, [...t[0] ||= [
		s("path", {
			"clip-rule": "evenodd",
			d: "M14.9392 10.3013C14.6869 10.0542 14.3255 9.92381 13.8549 9.92381H12.4024V14.0213H13.0843V12.7241H13.9095C14.3391 12.7241 14.6869 12.6005 14.9392 12.3397C15.1916 12.0858 15.3211 11.7495 15.3211 11.3308C15.3211 10.9121 15.1916 10.5484 14.9461 10.2944L14.9392 10.3013ZM14.4346 11.8593C14.305 11.9897 14.1277 12.0515 13.9027 12.0515H13.0775V10.569H13.9163C14.3869 10.569 14.6255 10.8161 14.6255 11.3171C14.6255 11.8181 14.5642 11.7289 14.4346 11.8593Z",
			fill: "#13100D",
			"fill-rule": "evenodd"
		}, null, -1),
		s("path", {
			d: "M8.48791 9.92381H7.80595V14.0213H8.48791V9.92381Z",
			fill: "#13100D"
		}, null, -1),
		s("path", {
			"clip-rule": "evenodd",
			d: "M22.6454 14.0693C22.7613 14.0693 22.8772 14.0556 22.9864 14.0281V13.4653C22.9318 13.4722 22.8704 13.4791 22.8159 13.4791C22.6454 13.4791 22.5363 13.4379 22.4817 13.3692C22.434 13.3143 22.4135 13.1977 22.4135 13.0123V11.3514H23V10.8023H22.4135V9.91695H21.752V13.0535C21.752 13.431 21.7998 13.685 21.8952 13.8154C22.018 13.987 22.2635 14.0693 22.6386 14.0693H22.6454Z",
			fill: "#13100D",
			"fill-rule": "evenodd"
		}, null, -1),
		s("path", {
			"clip-rule": "evenodd",
			d: "M11.0657 14.0213H11.734V11.9417C11.734 11.5916 11.6386 11.3239 11.4476 11.1318C11.2567 10.9396 11.0044 10.8229 10.6907 10.8229C9.96096 10.8229 9.14943 11.0082 9.14943 11.0082V14.0281H9.81775V11.4955C10.0496 11.4475 10.3701 11.3994 10.5679 11.4132C10.8884 11.4406 11.0657 11.6603 11.0657 12.0721V14.0281V14.0213Z",
			fill: "#13100D",
			"fill-rule": "evenodd"
		}, null, -1),
		s("path", {
			"clip-rule": "evenodd",
			d: "M18.0626 11.2073C17.7898 10.9121 17.442 10.7611 17.0056 10.7611C16.5691 10.7611 16.2282 10.9121 15.9554 11.2073C15.6826 11.5024 15.5462 11.9005 15.5462 12.3946C15.5462 12.8888 15.6826 13.2869 15.9554 13.582C16.2213 13.884 16.576 14.035 17.0056 14.035C17.4352 14.035 17.783 13.884 18.0558 13.582C18.3286 13.28 18.465 12.8819 18.465 12.3946C18.465 11.9073 18.3286 11.5093 18.0626 11.2073ZM17.5648 13.129C17.4216 13.3075 17.2375 13.3967 17.0056 13.3967C16.7737 13.3967 16.5896 13.3075 16.4464 13.129C16.31 12.9506 16.235 12.7035 16.235 12.3946C16.235 12.0858 16.3032 11.8456 16.4464 11.6671C16.5896 11.4818 16.7737 11.3926 17.0056 11.3926C17.2375 11.3926 17.4216 11.4818 17.5648 11.6603C17.7012 11.8387 17.7762 12.0858 17.7762 12.3946C17.7762 12.7035 17.708 12.9506 17.5648 13.129Z",
			fill: "#13100D",
			"fill-rule": "evenodd"
		}, null, -1),
		s("path", {
			"clip-rule": "evenodd",
			d: "M21.0087 13.7399C21.2405 13.5408 21.3633 13.2869 21.3633 12.978C21.3633 12.4976 21.07 12.2025 20.4836 12.0927C20.238 12.0446 19.9857 12.0034 19.7334 11.9622C19.5561 11.9142 19.4674 11.825 19.4674 11.6946C19.4674 11.4681 19.6584 11.3583 20.0539 11.3583C20.4495 11.3583 20.6336 11.4681 20.8723 11.6808L21.2678 11.2553C20.9405 10.9396 20.5381 10.7886 20.0744 10.7886C19.6106 10.7886 19.3788 10.8847 19.1469 11.07C18.915 11.2622 18.7991 11.4955 18.7991 11.7769C18.7991 12.0583 18.8946 12.2642 19.0855 12.4015C19.2492 12.5182 19.522 12.6005 19.9039 12.6555C20.2244 12.7035 20.4154 12.7447 20.4904 12.7721C20.6199 12.8202 20.6813 12.9094 20.6813 13.0398C20.6813 13.1702 20.6268 13.2457 20.5176 13.3212C20.4085 13.3967 20.2585 13.4379 20.0744 13.4379C19.7402 13.4379 19.447 13.3143 19.1947 13.0604L18.69 13.4928C19.0173 13.8566 19.4811 14.0419 20.088 14.0419C20.695 14.0419 20.7836 13.9458 21.0223 13.7467L21.0087 13.7399Z",
			fill: "#13100D",
			"fill-rule": "evenodd"
		}, null, -1),
		s("path", {
			"clip-rule": "evenodd",
			d: "M3.38685 12.0034C3.38685 12.0034 2.85493 12.2093 2.19343 12.2093C1.53193 12.2093 1 12.0034 1 12.0034C1 12.0034 1.53193 11.7975 2.19343 11.7975C2.85493 11.7975 3.38685 12.0034 3.38685 12.0034Z",
			fill: "#FFCB00",
			"fill-rule": "evenodd"
		}, null, -1),
		s("path", {
			"clip-rule": "evenodd",
			d: "M5.03037 8.94921C5.03037 8.94921 4.55982 8.62663 4.19156 8.09128C3.8233 7.54907 3.70055 7 3.70055 7C3.70055 7 4.1711 7.32258 4.53936 7.85793C4.90761 8.40014 5.03037 8.94921 5.03037 8.94921Z",
			fill: "#FFCB00",
			"fill-rule": "evenodd"
		}, null, -1),
		s("path", {
			"clip-rule": "evenodd",
			d: "M3.82332 10.267C3.82332 10.267 3.25047 10.2052 2.67081 9.89636C2.09114 9.59437 1.71607 9.16198 1.71607 9.16198C1.71607 9.16198 2.28891 9.22375 2.86858 9.5326C3.44824 9.83459 3.82332 10.267 3.82332 10.267Z",
			fill: "#FFCB00",
			"fill-rule": "evenodd"
		}, null, -1),
		s("path", {
			"clip-rule": "evenodd",
			d: "M5.03037 15.0508C5.03037 15.0508 4.55982 15.3734 4.19156 15.9087C3.8233 16.4509 3.70055 17 3.70055 17C3.70055 17 4.1711 16.6774 4.53936 16.1421C4.90761 15.5999 5.03037 15.0508 5.03037 15.0508Z",
			fill: "#FFCB00",
			"fill-rule": "evenodd"
		}, null, -1),
		s("path", {
			"clip-rule": "evenodd",
			d: "M3.82332 13.733C3.82332 13.733 3.25047 13.7948 2.67081 14.1036C2.09114 14.4056 1.71607 14.838 1.71607 14.838C1.71607 14.838 2.28891 14.7762 2.86858 14.4674C3.44824 14.1585 3.82332 13.733 3.82332 13.733Z",
			fill: "#FFCB00",
			"fill-rule": "evenodd"
		}, null, -1),
		s("path", {
			"clip-rule": "evenodd",
			d: "M5.20088 13.0055C5.63051 14.1105 6.31929 14.9066 7.55363 15.092C7.41042 15.1126 7.26721 15.1194 7.124 15.1263C5.37819 15.1331 3.95971 13.7399 3.94607 12.0172C3.93244 10.2944 5.34409 8.88743 7.0899 8.88057C7.24675 8.88057 7.39678 8.88743 7.54681 8.91489C6.13516 9.09333 5.19406 10.1915 5.00993 11.5985C4.94855 12.4564 5.93739 12.7447 5.93739 12.7447C5.93739 12.7447 5.53504 13.0123 5.19406 13.0192L5.20088 13.0055Z",
			fill: "#FFCB00",
			"fill-rule": "evenodd"
		}, null, -1)
	]]);
}
var v_ = /*#__PURE__*/ G(g_, [["render", __]]), y_ = ["fill"], b_ = ["id"], x_ = /* @__PURE__ */ f({
	__name: "dpd",
	setup(e) {
		let t = le();
		return (e, n) => (A(), o("g", null, [s("path", {
			"clip-rule": "evenodd",
			d: "M12.0627 1.71491H11.9995H11.9985C11.937 1.71503 11.8754 1.72634 11.8139 1.74064L11.81 1.73615C11.8027 1.73984 11.7947 1.74352 11.7863 1.74721L11.7466 1.75706L11.7466 1.75706L11.7512 1.76241C11.7226 1.77473 11.6959 1.78706 11.6836 1.79938L11.6122 1.8351L11.5995 1.82036L11.3677 1.94681L11.3686 1.94788L11.1772 2.05225L11.1786 2.05385L10.9883 2.15768L10.989 2.15849L10.7979 2.26274L10.7986 2.26364L10.6618 2.33825L10.6513 2.32592L10.4696 2.44154L10.4608 2.43136L10.229 2.55781L10.2302 2.55924L10.0396 2.66324L10.0405 2.66431L9.84912 2.76868L9.85081 2.77066L9.66113 2.87412L9.66174 2.87483L9.52369 2.95013L9.51268 2.93731L9.25977 3.06376L9.26621 3.07126L9.07031 3.16921L9.07644 3.17633L8.87988 3.27461L8.88624 3.28201L8.69092 3.37968L8.69704 3.38682L8.50049 3.48511L8.50649 3.4921L8.38071 3.55499L8.37498 3.5483L8.12207 3.67476L8.12822 3.68192L7.93164 3.7802L7.93791 3.7875L7.78363 3.86464L7.78359 3.86459L7.78226 3.86532L7.7417 3.8856L7.74278 3.88686L7.55176 3.99105L7.55315 3.99267L7.36279 4.0965L7.36402 4.09793L7.22725 4.17252L7.21621 4.15967L6.98438 4.28612L6.98513 4.287L6.79346 4.39155L6.79486 4.39319L6.60449 4.49702L6.60524 4.49789L6.41357 4.60243L6.41489 4.60397L6.2251 4.7075L6.22638 4.709L6.0887 4.78409L6.07754 4.77106L5.8457 4.89751L5.84639 4.89832L5.65527 5.00257L5.65634 5.00381L5.46533 5.108L5.46672 5.10962L5.27637 5.21345L5.27743 5.21469L5.08643 5.31888L5.08796 5.32067L4.95017 5.39583L4.93838 5.38205L4.70654 5.50851L4.70822 5.51048L4.51855 5.61394L4.51917 5.61466L4.32715 5.7194L4.32868 5.72119L4.13867 5.82484L4.13957 5.82588L3.94824 5.93024L3.94927 5.93144L3.81242 6.00609L3.80125 5.99306L3.54834 6.11951L3.55662 6.12963L3.46289 6.18319L3.71297 6.32073L3.73802 6.35135L4.40235 6.71371L4.83164 6.96088L4.83343 6.96297L5.50785 7.36341L5.48559 7.33726L5.9149 7.57874L5.9289 7.59513L6.46736 7.89802L6.4786 7.91119L7.03506 8.2242L7.69932 8.60665L7.69891 8.60617L8.09812 8.83602L8.10028 8.83854L8.14238 8.86151L8.24902 8.9229L8.24378 8.91682L8.62118 9.12268L8.64851 9.15463L9.18216 9.45482L9.19574 9.4707L9.87017 9.85007L9.85372 9.83087L10.4184 10.1662L10.4021 10.1471L10.9671 10.4826L10.9458 10.4576L11.3359 10.6771L11.3676 10.7141L11.8851 10.9964L11.9144 11.0306L12.5012 11.3506L12.6532 11.452C12.7263 11.4885 12.7993 11.5725 12.8175 11.6627L12.7995 11.6418C12.7995 11.6523 12.8048 11.6628 12.8101 11.6734C12.8153 11.6839 12.8206 11.6944 12.8206 11.705V12.0633L12.8218 12.0647V12.2955L12.8216 12.2952V12.7167L12.8218 12.717V12.949L12.821 12.9482V13.2647L12.8208 13.2643V13.6859L12.8215 13.6867V13.9181L12.8212 13.9178V14.3183L12.8224 14.3197V14.5731L12.8207 14.5711V14.9716L12.8224 14.9735V15.2266L12.8207 15.2246V15.625L12.8219 15.6264V15.8578L12.8212 15.8569V16.2574L12.8214 16.2577V16.5943L12.8217 16.5947V16.8278L12.8205 16.8265V17.248L12.8211 17.2487V17.5641L12.8222 17.5653V17.7967L12.8214 17.7957V18.1332L12.821 18.1328V18.5332L12.8221 18.5345V18.7663L12.8212 18.7653V19.1868L12.8213 19.1869V19.3552C12.8213 19.3793 12.8144 19.4034 12.8046 19.4236L12.8002 19.4185C12.7981 19.4272 12.7955 19.4358 12.7925 19.4444C12.7882 19.4506 12.7837 19.4561 12.7792 19.4606L12.784 19.4661C12.7604 19.5205 12.7218 19.5696 12.6805 19.595L12.6738 19.5871C12.6738 19.5922 12.6738 19.5961 12.6735 19.5991C12.6666 19.6028 12.6598 19.6059 12.6529 19.6082H12.6527L12.5075 19.6953L12.5052 19.6926L12.3186 19.8015L12.3155 19.798L12.168 19.8823C12.1258 19.9034 12.0837 19.9034 12.0415 19.9034L12.0534 19.9171C12.0408 19.9212 12.0289 19.9246 12.0205 19.9246H11.9994C11.9362 19.9246 11.894 19.9035 11.8519 19.8825L11.8519 19.8825L11.8133 19.8653L11.8097 19.8612L11.346 19.6082C11.2617 19.5661 11.1985 19.4607 11.1985 19.3553L11.1985 19.2291L11.1985 19.1446L11.1985 18.9128V18.8286V18.5756V18.5124L11.1985 18.2593V17.8589L11.1985 17.6059L11.1985 17.5428L11.1985 17.2055L11.1984 17.2054V16.9728L11.1993 16.9738V16.5734L11.1982 16.5721V16.32L11.1985 16.3204V16.0031L11.1994 16.0041V15.5825L11.1983 15.5813V15.2668L11.1977 15.2661V15.0332L11.1989 15.0346V14.6131L11.1986 14.6127V14.2971L11.1983 14.2968V14.0435L11.1991 14.0444V13.644L11.1979 13.6426V13.41L11.1996 13.412V13.0115L11.1979 13.0096V12.7567L11.1996 12.7587V12.5269C11.1996 12.4847 11.1575 12.4215 11.1153 12.4004L10.8009 12.2146L10.7975 12.2106L10.6673 12.1357L10.6517 12.1264L10.6521 12.1269L10.2538 11.8976L10.2512 11.8945L10.1996 11.8664L10.1019 11.8102L10.1068 11.8158L9.72749 11.6089L9.70148 11.5785L9.02705 11.1991L9.04199 11.2165L8.4803 10.883L8.49734 10.9029L7.93158 10.5669L7.95266 10.5915L7.56488 10.3734L7.53168 10.3347L6.83617 9.95531L6.83697 9.95624L6.43695 9.72593L6.43517 9.72385L5.76074 9.32341L5.78091 9.34693L5.35144 9.10536L5.33946 9.0914L4.66504 8.71203L4.68129 8.73095L4.1167 8.39572L4.1321 8.41364L3.72134 8.16975L3.7165 8.1641L3.6591 8.1328L3.56982 8.07979L3.57678 8.08789L3.19676 7.88061L3.16861 7.8478L3 7.7635V7.97436V8.05856V8.31152V8.39588V8.62782V8.71197V8.965V9.02826V9.28131V9.36544V9.59723V9.68175V9.93442V10.0187V10.2507V10.3349V10.5666V10.6512V10.9042V10.9882V11.2201V11.3046V11.5361V11.6206V11.8736V11.9576V12.1895V12.2741V12.5267V12.59V12.843V12.9271V13.159V13.2435V13.4961V13.5594V13.8124V13.8966V14.1284V14.2129V14.4659V14.5288V14.7822V14.8664V15.0981V15.1826V15.4353V15.5197V15.7512V15.8357V16.0676V16.1517V16.4047V16.4891V16.721V16.8052V16.8264C3 16.9534 3.05357 17.0957 3.13304 17.2118L3.12697 17.2057C3.12917 17.2079 3.13132 17.2102 3.13341 17.2124C3.18575 17.2887 3.24929 17.3537 3.31614 17.3954L3.80767 17.6617L4.22122 17.8998L4.2224 17.9012L4.73465 18.1961L4.77037 18.2382L5.29051 18.5219L5.31834 18.5545L6.01384 18.955L5.99788 18.9363L6.56181 19.2712L6.5428 19.2489L6.9825 19.5021L6.98333 19.503L7.5308 19.8182L7.53131 19.8188L8.07782 20.1335L8.07928 20.1352L8.62651 20.4503L8.62726 20.4511L9.17997 20.7694L9.19628 20.7884L9.87071 21.1888L9.85505 21.1705L10.4187 21.5052L10.399 21.4822L10.839 21.7355L10.8402 21.7369L11.3867 22.0516L11.3882 22.0533L11.6832 22.2219C11.7306 22.2535 11.8017 22.2732 11.8698 22.2811L11.8729 22.2848H11.9174C11.9237 22.285 11.93 22.2851 11.9362 22.2851L11.9359 22.2848H11.9994C12.0461 22.2848 12.0928 22.2848 12.1395 22.2763L12.1469 22.285L12.3366 22.2217L12.3998 22.1796L12.3988 22.1784L12.5895 22.0744L12.5882 22.0728L12.7792 21.9687L12.7715 21.9597L12.9478 21.8635L12.9466 21.8621L13.1375 21.758L13.1343 21.7543L13.2763 21.6639L13.285 21.6739L13.4662 21.5586L13.4747 21.5684L13.6558 21.4531L13.6644 21.463L13.8962 21.3155L13.8883 21.3062L14.0648 21.2099L14.0637 21.2087L14.2545 21.1046L14.2533 21.1032L14.4442 20.9991L14.4431 20.9979L14.6338 20.8939L14.6329 20.8929L14.8243 20.7885L14.816 20.7788L14.9918 20.6829L14.9909 20.6819L15.1819 20.5777L15.1789 20.5742L15.3209 20.4839L15.3292 20.4936L15.5099 20.3786L15.5183 20.3883L15.6868 20.281L15.688 20.2825L15.9199 20.1349L15.9187 20.1336L16.1092 20.0297L16.1082 20.0285L16.2987 19.9246L16.2978 19.9235L16.4891 19.8192L16.4876 19.8174L16.6776 19.7137L16.6702 19.7052L16.8479 19.6083L16.8462 19.6063L17.0359 19.5028L17.0334 19.4999L17.1759 19.4092L17.1839 19.4186L17.3653 19.3032L17.3739 19.3132L17.541 19.2068L17.5418 19.2077L17.7736 19.0602L17.7725 19.0589L17.9636 18.9548L17.9629 18.954L18.154 18.8497L18.1529 18.8484L18.3434 18.7444L18.3422 18.7429L18.5334 18.6386L18.5253 18.6293L18.7008 18.5336L18.7 18.5327L18.8917 18.4282L18.8903 18.4265L19.0807 18.3227L19.0779 18.3194L19.2204 18.2288L19.2287 18.2384L19.3961 18.1319L19.3971 18.133L19.5779 18.018L19.5861 18.0276L19.8179 17.88L19.8168 17.8788L20.0078 17.7746L20.0068 17.7734L20.1977 17.6692L20.1968 17.6681L20.3882 17.5637L20.3797 17.5539L20.5425 17.4651L20.6823 17.3952L20.7038 17.3737L20.7041 17.374C20.7463 17.3459 20.7884 17.2991 20.8306 17.2523L20.8306 17.2522C20.8517 17.2288 20.8727 17.2054 20.8938 17.1844L20.8866 17.1759C20.9303 17.1086 20.9606 17.0412 20.9774 16.9739L20.9726 16.9683C20.9874 16.921 20.9992 16.8737 20.9992 16.8263V16.6577L20.999 16.6575V16.3415L20.9982 16.3406V16.1077L20.9999 16.1097V15.6882L20.9982 15.6862V15.4554L20.999 15.4563V15.0558L20.9987 15.0555V14.802L20.9995 14.8028V14.4024L20.9973 14.3998V14.1481L20.9985 14.1495V13.8328L20.9993 13.8337V13.4332L20.9986 13.4324V13.1794L20.9993 13.1802V12.7798L20.9991 12.7795V12.4637L20.9989 12.4635V12.1264L20.9979 12.1252V11.8929L20.9995 11.8948V11.4944L20.9986 11.4933V11.2404L20.9992 11.241V10.8406L20.9981 10.8394V10.6078L20.9991 10.6089V10.2719L20.9992 10.272V9.87153L20.9977 9.86975V9.61695L20.9992 9.61869V9.21824L20.9982 9.2171V8.98489L20.9992 8.98608V8.58564L20.9987 8.5851V8.24829L20.9977 8.24704V8.01537L20.9987 8.01652V7.76361L20.9167 7.81048L20.9134 7.80554L20.7325 7.92065L20.7248 7.91108L20.4929 8.05861L20.4943 8.06017L20.3037 8.16412L20.3044 8.16491L20.113 8.26929L20.1147 8.27133L19.9243 8.3752L19.9248 8.37578L19.7331 8.48034L19.74 8.48837L19.545 8.58589L19.5527 8.59484L19.3763 8.69104L19.3772 8.69208L19.1856 8.79658L19.1868 8.79801L18.997 8.90158L18.998 8.90279L18.8068 9.00711L18.8083 9.00897L18.618 9.1128L18.6184 9.11331L18.4267 9.21791L18.4348 9.22739L18.259 9.32329L18.2623 9.32722L18.1204 9.41754L18.1119 9.40766L17.9302 9.5233L17.9215 9.5131L17.7408 9.62811L17.7325 9.61852L17.5511 9.73401L17.5421 9.72358L17.3737 9.83074L17.3723 9.82905L17.1404 9.97658L17.1422 9.97861L16.9529 10.0818L16.9538 10.0829L16.7625 10.1873L16.7637 10.1887L16.573 10.2927L16.574 10.2938L16.3826 10.3981L16.3843 10.4001L16.1947 10.5036L16.202 10.5121L16.0243 10.609L16.0256 10.6106L15.8354 10.7143L15.8367 10.7157L15.646 10.8197L15.6487 10.8229L15.5188 10.9041C15.5131 10.9041 15.5075 10.9056 15.5019 10.9078L15.4984 10.9038C15.4241 10.9409 15.3171 10.9453 15.235 10.917L15.2237 10.9038H15.2034L15.2033 10.9038L15.098 10.8195L15.1348 10.8626L14.7178 10.6088C14.6906 10.5951 14.6722 10.5727 14.6512 10.5472C14.6397 10.5332 14.6274 10.5183 14.6125 10.5034C14.586 10.4637 14.5762 10.4323 14.5673 10.404L14.5673 10.404C14.562 10.3872 14.5571 10.3715 14.5492 10.3558V10.2074L14.55 10.2083V9.78674L14.5493 9.78594C14.5497 9.73492 14.5772 9.67044 14.6098 9.6144L14.6133 9.61841C14.6343 9.57626 14.6554 9.55519 14.6976 9.53411L14.7741 9.4831L14.7816 9.49189L14.9486 9.38564L14.9495 9.38662L15.1318 9.27058L15.1409 9.28117L15.321 9.16654L15.3288 9.17573L15.5106 9.0601L15.5193 9.07029L15.7511 8.92276L15.7499 8.92134L15.9406 8.81733L15.9396 8.81626L16.131 8.71189L16.1225 8.70203L16.2974 8.60664L16.2966 8.60574L16.4883 8.50118L16.4876 8.50036L16.6787 8.39611L16.6774 8.39451L16.8677 8.29069L16.8668 8.28962L17.0581 8.18525L17.057 8.18392L17.2476 8.07997L17.2411 8.07239L17.437 7.97442L17.4289 7.96493L17.6047 7.86904L17.6043 7.86854L17.796 7.76394L17.7944 7.76208L17.9848 7.65824L17.9817 7.65464L18.1235 7.56444L18.1318 7.57417L18.3001 7.46708L18.3015 7.46863L18.488 7.35983L18.4912 7.36351L18.6715 7.24877L18.6793 7.25796L18.9112 7.11043L18.9107 7.10985L19.1024 7.00529L19.1006 7.00326L19.2911 6.89938L19.2904 6.89859L19.4818 6.79421L19.4752 6.7866L19.671 6.6887L19.6627 6.67909L19.8386 6.58317L19.8379 6.58238L20.0293 6.47801L20.0286 6.47722L20.2199 6.37283L20.2183 6.37085L20.4081 6.2673L20.4067 6.26564L20.5553 6.18307L20.5557 6.18287L20.1589 5.97652L20.1552 5.97223L19.6584 5.70725L19.6509 5.6984L19.1257 5.4273L19.123 5.42421L18.6223 5.15714L18.6162 5.15L18.1187 4.88468L18.1114 4.87616L17.5883 4.60618L17.5849 4.60231L17.0843 4.33529L17.0781 4.32812L16.5799 4.06243L16.5732 4.05467L16.0472 3.78316L16.0449 3.78044L15.5482 3.51556L15.5406 3.50662L15.055 3.25604L15.0347 3.2324L14.5089 2.96102L14.5068 2.95858L14.0102 2.69372L14.002 2.68421L13.3486 2.32592L13.3549 2.33317L12.8423 2.05209L12.8686 2.08281L12.4679 1.86909L12.4622 1.86244L12.3539 1.80827L12.3374 1.79949L12.3382 1.80045L12.3358 1.79922C12.2492 1.74731 12.1627 1.72381 12.0646 1.71706L12.0627 1.71491Z",
			fill: `url(#paint1_linear_${L(t)})`,
			"fill-rule": "evenodd"
		}, null, 8, y_), s("defs", null, [s("linearGradient", {
			id: `paint1_linear_${L(t)}`,
			gradientUnits: "userSpaceOnUse",
			x1: "21",
			x2: "3",
			y1: "2",
			y2: "22"
		}, [...n[0] ||= [s("stop", { "stop-color": "#DC0032" }, null, -1), s("stop", {
			offset: "1",
			"stop-color": "#C00033"
		}, null, -1)]], 8, b_)])]));
	}
}), S_ = {};
function C_(t, n) {
	return A(), o(e, null, [n[0] ||= s("g", { "clip-path": "url(#clip0_38757_17517)" }, [s("mask", {
		id: "mask0_38757_17517",
		height: "11",
		maskUnits: "userSpaceOnUse",
		style: { "mask-type": "luminance" },
		width: "24",
		x: "0",
		y: "6"
	}, [s("path", {
		d: "M0 6H24V17H0V6Z",
		fill: "white"
	})]), s("g", { mask: "url(#mask0_38757_17517)" }, [
		s("path", {
			d: "M20.7168 12.6136C21.3207 12.6136 21.8103 13.1027 21.8103 13.7061C21.8103 14.3094 21.3207 14.7986 20.7168 14.7986C20.1128 14.7986 19.6233 14.3094 19.6233 13.7061C19.6233 13.1027 20.1128 12.6136 20.7168 12.6136Z",
			fill: "#FFD100"
		}),
		s("path", {
			d: "M5.37905 11.2792V12.7086H6.56943C6.39556 12.9813 6.00347 13.1265 5.73747 13.1265C4.84144 13.1265 4.39339 12.6162 4.39339 11.5867C4.39339 10.4498 4.9848 9.86792 6.15861 9.86792C6.62458 9.86792 7.2339 9.98428 7.888 10.1902V8.48035C7.69984 8.3998 7.4131 8.33713 7.04572 8.27445C6.66935 8.21178 6.33784 8.18494 6.0511 8.18494C4.88622 8.18494 3.96329 8.49827 3.27333 9.1249C2.58336 9.75154 2.23389 10.593 2.23389 11.6583C2.23389 12.6341 2.50271 13.404 3.04034 13.968C3.57797 14.5409 4.30379 14.8274 5.21776 14.8274C6.13554 14.8274 6.97879 14.3515 7.25051 13.7474L7.24464 14.7199H8.57212V11.2792H5.37905Z",
			fill: "#061AB1"
		}),
		s("path", {
			d: "M9.22705 14.7199V8.29236H11.288V13.0459H13.537V14.7199H9.22705Z",
			fill: "#061AB1"
		}),
		s("path", {
			d: "M14.1914 14.5588V12.8042C14.4961 12.9027 14.8545 12.9833 15.2577 13.0549C15.6609 13.1265 16.0104 13.1623 16.3061 13.1623C16.8079 13.1623 17.0678 13.037 17.0678 12.8132C17.0678 12.6699 16.9871 12.5983 16.6197 12.5177L15.9029 12.3566C14.6753 12.0791 14.1018 11.4614 14.1018 10.414C14.1018 9.7247 14.3437 9.17861 14.8187 8.77578C15.2936 8.38189 15.9567 8.18494 16.79 8.18494C17.3635 8.18494 18.2416 8.30134 18.7792 8.43559V10.1096C18.5015 10.038 18.1699 9.96641 17.7667 9.90373C17.3635 9.84108 17.0499 9.81422 16.8168 9.81422C16.3778 9.81422 16.1269 9.93954 16.1269 10.1634C16.1269 10.2976 16.2434 10.3871 16.4853 10.4498L17.3187 10.6468C18.5373 10.9332 19.1018 11.5599 19.1018 12.6252C19.1018 13.3055 18.8509 13.8426 18.3581 14.2365C17.8653 14.6304 17.1842 14.8274 16.3151 14.8274C15.4907 14.8274 14.6574 14.711 14.1914 14.5588Z",
			fill: "#061AB1"
		})
	])], -1), n[1] ||= s("defs", null, [s("clipPath", { id: "clip0_38757_17517" }, [s("rect", {
		fill: "white",
		height: "11",
		transform: "translate(0 6)",
		width: "24"
	})])], -1)], 64);
}
var w_ = /*#__PURE__*/ G(S_, [["render", C_]]), T_ = {};
function E_(t, n) {
	return A(), o(e, null, [n[0] ||= s("g", { "clip-path": "url(#clip0_42355_61447)" }, [s("path", {
		d: "M13.0997 4.83683L7.8926 9.89285C7.74049 10.0409 7.53343 10.1241 7.31807 10.1244H0.405434C0.182482 10.123 0 9.94444 0 9.72796C0 9.62444 0.0419165 9.52479 0.116355 9.45077L4.97652 4.74561C5.12829 4.59298 5.33605 4.50456 5.55468 4.5H12.9587C13.0693 4.50035 13.1604 4.58912 13.1604 4.69649C13.1604 4.74912 13.1383 4.79999 13.0997 4.83683Z",
		fill: "#2CE27E"
	}), s("path", {
		d: "M23.5442 4.50035H15.2114C14.9949 4.50105 14.7872 4.58421 14.6332 4.73192L9.31778 9.89321C9.166 10.0416 9.08037 10.242 9.07928 10.4511V13.4791C9.07531 13.6938 8.89247 13.8686 8.67097 13.8686C8.66842 13.8686 8.66625 13.8686 8.66372 13.8686H5.55613C5.34076 13.8689 5.13371 13.9521 4.98157 14.1001L0.121414 18.8263C0.0437233 18.9004 0 19.0014 0 19.107C0 19.3225 0.182482 19.5 0.404712 19.5H0.406881H8.74322C8.95858 19.4996 9.16564 19.4165 9.31778 19.2684L14.6332 14.1071C14.7868 13.9601 14.8728 13.7587 14.8717 13.5493V10.5213C14.8717 10.3037 15.056 10.1248 15.2801 10.1248H18.3985C18.6139 10.1244 18.8209 10.0413 18.973 9.89321L23.8405 5.17402C23.9182 5.09999 23.9622 4.99894 23.9622 4.89297C23.9622 4.67754 23.7793 4.5 23.5576 4.5C23.5531 4.5 23.5485 4.50035 23.5442 4.50035Z",
		fill: "#220C4A"
	})], -1), n[1] ||= s("defs", null, [s("clipPath", { id: "clip0_42355_61447" }, [s("rect", {
		fill: "white",
		height: "24",
		width: "24"
	})])], -1)], 64);
}
var D_ = /*#__PURE__*/ G(T_, [["render", E_]]), O_ = {};
function k_(e, t) {
	return A(), o("g", null, [...t[0] ||= [s("rect", {
		fill: "#FECC00",
		height: "24",
		width: "24",
		y: "0.5"
	}, null, -1), s("path", {
		d: "M7.73844 12.0647C7.63356 12.2067 7.45808 12.4536 7.3513 12.5978C7.29708 12.6711 7.19917 12.8043 7.52377 12.8043C7.86721 12.8043 9.2328 12.8043 9.2328 12.8043C9.2328 12.8043 9.50823 12.4296 9.73915 12.1162C10.0532 11.6898 9.76633 10.8027 8.64341 10.8027C7.63834 10.8027 4.22111 10.8027 4.22111 10.8027L3.45433 11.8445C3.45433 11.8445 7.42941 11.8445 7.63343 11.8445C7.84441 11.8445 7.84154 11.9248 7.73844 12.0647ZM6.48292 13.0613C6.15832 13.0613 6.25624 12.9279 6.31045 12.8545C6.41724 12.7103 6.59558 12.466 6.70046 12.324C6.8037 12.1842 6.80643 12.1039 6.59517 12.1039C6.39129 12.1039 4.6839 12.1039 4.6839 12.1039L3.14394 14.1968C3.14394 14.1968 5.89436 14.1968 6.89942 14.1968C8.13978 14.1968 8.83036 13.3531 9.04325 13.0614C9.04325 13.0613 6.82623 13.0613 6.48292 13.0613ZM8.92595 14.1968H11.129L11.9642 13.0611L9.76141 13.0614C9.76073 13.0613 8.92595 14.1968 8.92595 14.1968ZM14.6102 10.8027L13.7652 11.9505H12.7819L13.6266 10.8027H11.4241L9.95068 12.8043H15.3393L16.8123 10.8027H14.6102ZM12.1123 14.1968H14.3145L15.1501 13.0614H12.9479C12.947 13.0613 12.1123 14.1968 12.1123 14.1968ZM0.000366211 13.5092V13.7503H3.06856L3.24581 13.5092H0.000366211ZM3.5756 13.0613H0.000366211V13.3022H3.39793L3.5756 13.0613ZM0.000366211 14.1968H2.73986L2.91629 13.957H0.000366211V14.1968ZM20.7671 13.7502H24.0002V13.509H20.9446L20.7671 13.7502ZM20.4386 14.1968H24.0002V13.957H20.6149L20.4386 14.1968ZM21.2738 13.0613L21.0967 13.3024H24.0002V13.0613H21.2738ZM18.3892 12.8043L19.8625 10.8027H17.5299C17.5291 10.8027 16.0555 12.8043 16.0555 12.8043H18.3892ZM15.8667 13.0613C15.8667 13.0613 15.7057 13.2813 15.6274 13.3872C15.3509 13.7609 15.5955 14.1968 16.4981 14.1968C17.5409 14.1968 20.0351 14.1968 20.0351 14.1968L20.8707 13.0614H15.8667V13.0613Z",
		fill: "#D50029"
	}, null, -1)]]);
}
var A_ = /*#__PURE__*/ G(O_, [["render", k_]]), j_ = ["fill"], M_ = ["fill"], N_ = ["id"], P_ = ["id"], F_ = /* @__PURE__ */ f({
	__name: "bpost",
	setup(e) {
		let t = le();
		return (e, n) => (A(), o("g", null, [
			s("path", {
				d: "M17.3502 6.34624C15.5409 10.2957 11.3191 14.3229 7.93385 15.354C4.52918 16.3852 3.24514 14.0116 5.07393 10.0622L3.26459 10.6069C2.42802 12.4357 2 14.0505 2 15.3735V15.4902C2.01946 18.4085 4.06226 19.7704 7.62257 18.6809C12.8171 17.1245 19.2568 10.9571 22 4.94547L17.3502 6.34624Z",
				fill: `url(#paint0_linear_${L(t)})`
			}, null, 8, j_),
			s("path", {
				d: "M5.89052 9.80931C4.95667 11.8327 5.61814 13.0389 7.34966 12.5136C9.08118 11.9883 11.2407 9.92604 12.1551 7.92215L5.89052 9.80931Z",
				fill: `url(#paint1_linear_${L(t)})`
			}, null, 8, M_),
			s("defs", null, [s("linearGradient", {
				id: `paint0_linear_${L(t)}`,
				gradientUnits: "userSpaceOnUse",
				x1: "2",
				x2: "22",
				y1: "12",
				y2: "12"
			}, [...n[0] ||= [
				s("stop", { "stop-color": "#A21007" }, null, -1),
				s("stop", {
					offset: "0.244",
					"stop-color": "#B90D11"
				}, null, -1),
				s("stop", {
					offset: "0.5555",
					"stop-color": "#D0091B"
				}, null, -1),
				s("stop", {
					offset: "0.75",
					"stop-color": "#D9081F"
				}, null, -1),
				s("stop", {
					offset: "1",
					"stop-color": "#D9081F"
				}, null, -1)
			]], 8, N_), s("linearGradient", {
				id: `paint1_linear_${L(t)}`,
				gradientUnits: "userSpaceOnUse",
				x1: "5.46632",
				x2: "12.1551",
				y1: "10.2793",
				y2: "10.2793"
			}, [...n[1] ||= [
				s("stop", { "stop-color": "#A21007" }, null, -1),
				s("stop", {
					offset: "0.244",
					"stop-color": "#B90D11"
				}, null, -1),
				s("stop", {
					offset: "0.5555",
					"stop-color": "#D0091B"
				}, null, -1),
				s("stop", {
					offset: "0.75",
					"stop-color": "#D9081F"
				}, null, -1),
				s("stop", {
					offset: "1",
					"stop-color": "#D9081F"
				}, null, -1)
			]], 8, P_)])
		]));
	}
}), I_ = {};
function L_(e, t) {
	return A(), o("g", null, [...t[0] ||= [
		s("path", {
			d: "M9.00037 22.0097C9.18311 21.9184 13.9344 19.8625 15.442 18.629C16.9953 17.3498 17.8176 15.5224 17.8176 13.3295V3.05035L17.6806 3.00466C13.8887 0.948826 9.18311 1.08588 8.95468 1.08588C8.77194 1.08588 4.06635 0.948826 0.274476 3.00466L0.183105 3.05035V13.3752C0.183105 15.5681 1.00544 17.3955 2.55874 18.6747C4.06635 19.9082 8.81763 21.9641 9.00037 22.0097Z",
			fill: "#341B14"
		}, null, -1),
		s("path", {
			d: "M9 22.2382C9 22.2382 3.97462 20.0453 2.42132 18.8118C0.77665 17.4412 0 15.5681 0 13.4209V2.73054C3.97462 0.583332 9 0.766073 9 0.766073C9 0.766073 14.0254 0.583332 18 2.73054V13.3752C18 15.5224 17.2233 17.3955 15.5787 18.7661C14.0254 20.0453 9 22.2382 9 22.2382ZM0.730964 13.4209C0.730964 15.431 1.46193 17.0757 2.87817 18.2178C4.15736 19.2686 7.94924 20.959 9 21.4158C10.0508 20.959 13.8883 19.2229 15.1218 18.2178C16.5381 17.0757 17.269 15.3854 17.269 13.4209V2.91328C11.9695 2.41074 5.66497 2.68485 0.730964 7.25338V13.4209Z",
			fill: "#FFB406"
		}, null, -1),
		s("path", {
			d: "M14.0713 11.9131C14.7565 12.3242 15.0307 12.5984 15.0763 13.1009C15.0763 13.6491 14.7109 13.9689 14.1169 13.9689C13.6144 13.9689 13.0205 13.6948 12.6093 13.3293V14.7912C13.1119 15.0654 13.7058 15.2938 14.3454 15.2938C15.8987 15.2938 16.6296 14.1973 16.6296 13.1923C16.6753 12.2786 16.4012 11.5476 15.0763 10.7709C14.4824 10.4055 14.0256 10.177 14.0256 9.62881C14.0256 9.08059 14.5281 8.85216 14.9393 8.85216C15.4875 8.85216 16.0357 9.17196 16.3555 9.49176V8.1212C16.0814 7.89277 15.4875 7.57297 14.6195 7.61866C13.5687 7.66434 12.4723 8.39531 12.4723 9.6745C12.518 10.5425 12.7921 11.1821 14.0713 11.9131ZM8.6804 15.2024C8.81746 15.2481 9.04588 15.2938 9.41137 15.2938C11.1931 15.2938 12.1982 13.6948 12.1982 11.4105C12.1982 9.08059 11.1474 7.66434 9.27431 7.66434C8.40629 7.66434 7.72101 7.84709 7.1271 8.21257V18.5374H8.6804V15.2024ZM8.6804 8.98922C8.81746 8.94353 9.04588 8.85216 9.22863 8.85216C10.1423 8.85216 10.5078 9.58313 10.5078 11.3649C10.5078 13.1009 10.051 13.9232 9.13725 13.9232C8.90883 13.9232 8.72609 13.8775 8.63472 13.8319V8.98922H8.6804ZM3.88345 15.2938C4.84284 15.2938 5.66517 15.0654 6.25908 14.6542V7.75572H4.6601V13.7405C4.47736 13.8775 4.24893 13.9232 3.92913 13.9232C3.19817 13.9232 3.1068 13.2379 3.1068 12.8268V7.75572H1.50781V12.7354C1.50781 14.4258 2.33015 15.2938 3.88345 15.2938Z",
			fill: "#FFB406"
		}, null, -1)
	]]);
}
var R_ = /*#__PURE__*/ G(I_, [["render", L_]]), z_ = {};
function B_(e, t) {
	return A(), o("g", null, [...t[0] ||= [s("path", {
		d: "M12.0858 24.2476C11.9829 24.2329 11.8965 24.2044 11.8205 24.1601C11.5274 23.9896 2.20552 18.4894 2.17743 18.4704C2.04288 18.3795 1.91937 18.1936 1.8666 18.0026L1.8484 17.9368L1.84667 12.5746C1.84572 9.62538 1.84623 7.2124 1.84784 7.2124C1.86004 7.2124 11.1854 12.6478 11.2044 12.666C11.2179 12.6789 11.2363 12.7038 11.2453 12.7214L11.2616 12.7534L11.265 16.8095L11.2684 20.8656L11.286 20.9107C11.3119 20.9773 11.3377 21.0179 11.3803 21.059C11.4113 21.0889 11.476 21.1275 11.7316 21.2686C11.9039 21.3637 12.0569 21.4447 12.0715 21.4487C12.1556 21.4714 12.2493 21.472 12.3229 21.4501C12.3423 21.4444 12.4973 21.3626 12.6674 21.2684C13.0004 21.084 13.0316 21.0626 13.0767 20.9876C13.0898 20.9659 13.1073 20.928 13.1157 20.9035L13.1309 20.8588L13.1311 16.3169L13.1313 11.775L13.1142 11.7238C13.0939 11.6634 13.0605 11.6088 13.0196 11.5695C12.9992 11.5497 11.3581 10.5911 7.68325 8.45205C4.7645 6.75315 2.3764 5.36138 2.37637 5.35923C2.37632 5.35625 11.3369 0.468989 11.7759 0.232537C11.9304 0.149309 12.0271 0.125217 12.205 0.125615C12.3307 0.125911 12.4028 0.136906 12.492 0.169475C12.5411 0.187399 22.0272 5.35129 22.0265 5.35973C22.0264 5.36161 20.5072 6.24741 18.6506 7.32819C14.894 9.51499 15.2213 9.31758 15.1683 9.42855C15.1264 9.51633 15.1261 9.52112 15.1336 9.86446C15.1426 10.2702 15.1432 10.2787 15.1629 10.3331C15.1846 10.3926 15.2337 10.4704 15.2747 10.5102C15.3117 10.5459 15.8793 10.8869 15.9437 10.912C15.9713 10.9227 16.0016 10.9276 16.0535 10.9298C16.1157 10.9324 16.1314 10.9306 16.1727 10.9167C16.2064 10.9053 17.1409 10.3642 19.3853 9.05652C21.126 8.04225 22.5521 7.2124 22.5542 7.2124C22.5617 7.2124 22.5586 17.8254 22.5511 17.8988C22.5381 18.0248 22.4901 18.1527 22.4103 18.2732C22.3602 18.3489 22.2563 18.4528 22.1903 18.4932C22.0971 18.5503 12.6387 24.1269 12.5728 24.1637C12.4626 24.2251 12.3796 24.2459 12.2254 24.2505C12.1711 24.2521 12.1082 24.2509 12.0858 24.2476Z",
		fill: "#DB0036"
	}, null, -1)]]);
}
var V_ = /*#__PURE__*/ G(z_, [["render", B_]]), H_ = {};
function U_(t, n) {
	return A(), o(e, null, [n[0] ||= s("g", { "clip-path": "url(#clip0_20324_27)" }, [s("path", {
		d: "M8.81575 10.9536C8.03961 10.9536 7.41532 11.384 7.41532 12.3533C7.41532 13.301 8.03961 13.7531 8.81575 13.7531C9.58918 13.7531 10.2148 13.301 10.2148 12.3533C10.2148 11.384 9.58918 10.9536 8.81575 10.9536ZM8.81575 13.0875C8.46868 13.0875 8.20907 12.8238 8.20907 12.3533C8.20907 11.8416 8.46868 11.6179 8.81575 11.6179C9.16077 11.6179 9.42107 11.8416 9.42107 12.3533C9.42107 12.8238 9.16077 13.0875 8.81575 13.0875ZM13.8596 10.978C13.8596 10.9922 13.8712 11.0038 13.8854 11.0038H14.4745C14.5212 11.0038 14.5592 11.0424 14.5592 11.0878V11.5975C14.5592 11.6125 14.5477 11.624 14.5334 11.624H13.8854C13.8712 11.624 13.8596 11.6355 13.8596 11.6498V12.6394C13.8596 13.019 14.0033 13.1315 14.2433 13.1315C14.3558 13.1315 14.5328 13.0624 14.5585 13.0624C14.5728 13.0624 14.585 13.0739 14.585 13.0881V13.5762C14.585 13.6128 14.5639 13.6386 14.5409 13.6508C14.4338 13.7084 14.2542 13.7477 13.9884 13.7477C13.5241 13.7477 13.093 13.5138 13.093 12.7675V11.0465C13.093 10.8939 13.1526 10.7489 13.2469 10.6458C13.3723 10.5076 13.7756 10.2486 13.8278 10.2486C13.8502 10.2486 13.8596 10.2554 13.8596 10.2764V10.978ZM4.49446 11.0905C4.49446 11.0424 4.53309 11.0044 4.5812 11.0044H5.60207C6.60459 11.0044 7.12384 11.6064 7.12384 12.3852C7.12384 13.1648 6.54291 13.7043 5.5858 13.7043H5.28755C5.2733 13.7043 5.26109 13.7158 5.26109 13.7308V14.9936C5.26109 15.0146 5.2523 15.0214 5.22925 15.0214C5.17705 15.0214 4.77373 14.7624 4.64832 14.6242C4.55409 14.5204 4.49446 14.3754 4.49446 14.2235V11.0905ZM6.36668 12.3459C6.36668 12.0144 6.15248 11.704 5.58648 11.704H5.28618C5.27196 11.704 5.26043 11.7155 5.26043 11.7304V12.9763C5.26043 12.9905 5.27196 13.0027 5.28618 13.0027H5.60139C6.27584 13.0027 6.36668 12.5343 6.36668 12.3459ZM12.6985 12.8719C12.6985 13.4406 12.2898 13.7531 11.4926 13.7531C11.0364 13.7531 10.5544 13.5931 10.5504 13.5918C10.5145 13.5782 10.4907 13.5457 10.4907 13.5084V12.9783C10.4907 12.9607 10.5056 12.9472 10.5239 12.9472C10.5267 12.9472 10.5341 12.9485 10.5348 12.9492C10.7049 13.0041 11.2567 13.141 11.5502 13.141C11.7237 13.141 11.8146 13.1153 11.8729 13.057C11.9129 13.017 11.9312 12.9743 11.9312 12.9228C11.9312 12.7492 11.7136 12.7011 11.5027 12.655C11.4763 12.6496 11.4878 12.6523 11.4167 12.6353C10.955 12.5262 10.4684 12.4137 10.4684 11.8192C10.4684 11.5555 10.5788 11.3366 10.7856 11.1847C10.9917 11.0329 11.2892 10.9536 11.6458 10.9536C11.9664 10.9536 12.3467 11.0593 12.4741 11.1C12.5141 11.1129 12.5372 11.1481 12.5372 11.1841V11.7128C12.5358 11.7372 12.51 11.7487 12.4924 11.7419C12.1271 11.605 11.7929 11.5569 11.5529 11.5569C11.3624 11.5569 11.2391 11.6396 11.2391 11.7677C11.2391 11.9155 11.4194 11.9555 11.6478 12.007C11.6756 12.0131 11.8003 12.0415 11.8329 12.0483C12.02 12.0897 12.2131 12.1317 12.3718 12.2354C12.5914 12.3791 12.6985 12.5872 12.6985 12.8719ZM16.8313 13.6948C16.8225 13.6948 16.8151 13.6874 16.8151 13.6785V12.07C16.8151 11.7128 16.6937 11.5603 16.409 11.5603C16.3074 11.5603 16.1847 11.5982 16.0627 11.6674C15.9413 11.7379 15.8464 11.7962 15.8125 11.8165C15.803 11.8226 15.7929 11.8389 15.7929 11.8518V13.6792C15.7929 13.688 15.7854 13.6955 15.7766 13.6955H15.0595C15.0506 13.6955 15.0425 13.688 15.0425 13.6792V11.0912C15.0425 11.0492 15.0771 11.0146 15.1198 11.0146H15.7773C15.7861 11.0146 15.7942 11.022 15.7942 11.0309V11.2342C15.7942 11.2464 15.8044 11.2566 15.8166 11.2566C15.8213 11.2566 15.8275 11.2539 15.8295 11.2525L15.8512 11.2363C15.9312 11.1746 16.0545 11.1048 16.1372 11.0729C16.3169 11.0044 16.5107 10.9644 16.668 10.9644C17.2543 10.9644 17.5641 11.3013 17.5641 11.9378V13.6779C17.5641 13.6874 17.5567 13.6941 17.5472 13.6941H16.8313V13.6948ZM18.1559 13.6948C18.147 13.6948 18.1396 13.6874 18.1396 13.6785V9.71516C18.1396 9.70091 18.1423 9.69685 18.162 9.69685C18.2067 9.69685 18.6066 9.94835 18.7361 10.0907C18.8324 10.1964 18.8873 10.3401 18.8873 10.4852V13.6785C18.8873 13.6874 18.8798 13.6948 18.871 13.6948H18.1559ZM8.81507 6.80582C8.80152 6.80582 8.78864 6.80989 8.77305 6.81937C8.65239 6.91021 8.54598 7.01528 8.45377 7.13323C8.42666 7.16373 8.42666 7.19898 8.45514 7.23557C8.54257 7.34878 8.64291 7.44978 8.7527 7.53587C8.77305 7.55214 8.79339 7.5596 8.81439 7.5596C8.83541 7.5596 8.85575 7.55146 8.87609 7.53519C8.98589 7.4491 9.0862 7.3481 9.17366 7.23557C9.20214 7.19898 9.20214 7.16373 9.17366 7.13119C9.0835 7.0146 8.97709 6.90953 8.85914 6.82073C8.84218 6.80989 8.82932 6.80582 8.81507 6.80582ZM8.81507 7.77719C8.75745 7.77719 8.69645 7.77853 8.63341 7.78125C8.61105 7.78125 8.5907 7.78939 8.57511 7.80564C8.55275 7.82803 8.54393 7.86394 8.54393 7.88766C8.54598 8.01171 8.55411 8.66653 8.55952 9.08339C8.56223 9.28473 8.56359 9.43046 8.56427 9.43521C8.56427 9.46503 8.58595 9.52739 8.65307 9.52739H8.97775C9.02589 9.52739 9.05909 9.4935 9.06589 9.43928C9.06589 9.43791 9.06589 9.43655 9.06589 9.43521C9.06589 9.42503 9.07266 8.86853 9.08555 7.908V7.88903C9.08621 7.87073 9.08011 7.83141 9.05505 7.80632C9.03945 7.79005 9.01911 7.7826 8.99539 7.7826C8.93439 7.77921 8.87336 7.77719 8.81507 7.77719ZM9.63866 7.86598C9.56409 7.86598 9.50309 7.90732 9.47123 7.97851C9.37768 8.1866 9.30991 8.37639 9.24416 8.6123C9.2367 8.6401 9.23941 8.66314 9.2523 8.68007C9.26109 8.6916 9.27873 8.70516 9.31398 8.70516H9.5675C9.62511 8.70516 9.64611 8.67466 9.65425 8.64957C9.69561 8.50857 9.72543 8.42655 9.7783 8.30998C9.77898 8.30862 9.78305 8.30116 9.79864 8.30116C9.80473 8.30116 9.81084 8.30185 9.81693 8.30387L9.94573 8.34657C9.96064 8.35201 9.97014 8.36487 9.97489 8.37505C9.98436 8.39471 9.98573 8.42114 9.97895 8.4408C9.97759 8.44487 9.71866 9.1688 9.64139 9.41012C9.62986 9.44741 9.6312 9.47655 9.6468 9.49825C9.66102 9.51791 9.68543 9.52807 9.71932 9.52807H10.0332C10.0847 9.52807 10.1186 9.50773 10.1335 9.46639C10.145 9.43521 10.1613 9.38978 10.1803 9.33623L10.1877 9.31591C10.282 9.05289 10.425 8.65432 10.4555 8.54112C10.507 8.34928 10.5212 8.13914 10.2399 8.03475C10.1504 8.00155 10.0657 7.97307 9.98775 7.94935C9.8888 7.91885 9.7932 7.89648 9.70916 7.87682L9.699 7.87412C9.67596 7.868 9.65698 7.86598 9.63866 7.86598ZM7.99148 7.86598C7.97318 7.86598 7.9542 7.868 7.93591 7.87275L7.92302 7.87546C7.83898 7.89512 7.74407 7.9175 7.64511 7.948C7.56782 7.97173 7.48309 8.00019 7.39293 8.03341C7.11095 8.1378 7.12586 8.34794 7.17739 8.53975C7.20652 8.64889 7.33939 9.02239 7.45191 9.33489C7.47157 9.38844 7.48716 9.43385 7.49868 9.46503C7.51359 9.50637 7.5475 9.52671 7.599 9.52671H7.91286C7.95489 9.52671 7.97523 9.51044 7.98539 9.49689C8.00098 9.47587 8.00234 9.44673 7.99082 9.40944C7.9142 9.17153 7.65527 8.44689 7.65257 8.44012C7.64577 8.42046 7.64714 8.39471 7.65664 8.37437C7.66136 8.36421 7.67018 8.35132 7.68645 8.34589L7.81593 8.30319C7.82066 8.30185 7.82677 8.30116 7.83286 8.30116C7.84575 8.30116 7.85184 8.30657 7.8532 8.30998C7.90675 8.42928 7.93725 8.51198 7.97725 8.64957C7.9847 8.67532 8.00573 8.70516 8.06334 8.70516H8.31752C8.34532 8.70516 8.36634 8.69703 8.37923 8.68007C8.39209 8.66314 8.39482 8.64075 8.38668 8.61296C8.32025 8.37573 8.25246 8.18591 8.15959 7.97851C8.144 7.94462 8.09723 7.86598 7.99148 7.86598ZM9.96945 9.76803H7.66409C7.58341 9.76803 7.51496 9.83582 7.51496 9.91648V10.2066C7.51496 10.2974 7.55359 10.3415 7.63425 10.3415H9.99996C10.08 10.3415 10.1186 10.2974 10.1186 10.2066V9.91648C10.1186 9.83582 10.0501 9.76803 9.96945 9.76803ZM21.0713 12.011C21.0686 10.3923 18.0278 7.58873 14.7876 5.8026C11.05 3.74125 6.79643 2.52654 5.39532 3.29861C3.7983 4.17982 2.92319 8.57839 2.92251 12.011C2.92319 15.4715 3.74746 19.8138 5.39532 20.7228C6.88861 21.5457 10.9571 20.331 14.7876 18.2195C18.0786 16.4049 21.0686 13.7084 21.0713 12.011ZM6.51716 2.27777C8.87609 2.27777 12.6551 3.76904 15.1679 5.15457C16.6056 5.94698 18.2372 7.10339 19.4994 8.28014C20.7107 9.40878 21.8535 10.814 21.8556 12.011C21.8535 13.1383 20.9385 14.4608 19.4655 15.8111C18.2148 16.9566 16.5907 18.0832 15.1686 18.8675C12.7412 20.2056 9.04148 21.7687 6.60257 21.7687C5.93964 21.7687 5.396 21.6542 4.9852 21.4278C3.9054 20.8326 3.21331 19.2288 2.80457 17.6576C2.36532 15.9717 2.13959 13.9443 2.13892 12.0117C2.13892 10.1205 2.38294 8.08832 2.80796 6.43571C3.32583 4.42316 4.07893 3.09526 4.9852 2.59501C5.36548 2.38419 5.88134 2.27777 6.51716 2.27777Z",
		fill: "#F56900"
	})], -1), n[1] ||= s("defs", null, [s("clipPath", { id: "clip0_20324_27" }, [s("rect", {
		fill: "white",
		height: "20",
		transform: "translate(2 2)",
		width: "20"
	})])], -1)], 64);
}
var W_ = /*#__PURE__*/ G(H_, [["render", U_]]), G_ = {};
function K_(e, t) {
	return A(), o("g", null, [...t[0] ||= [s("g", { "clip-path": "url(#clip0_4638_78157)" }, [s("rect", {
		fill: "#00149D",
		height: "24",
		width: "24"
	}), s("path", {
		d: "M3 8.21057H5.56604V10.3352C6.06647 10.1469 6.59721 10.052 7.13191 10.0552C9.14732 10.0552 10.6083 11.5313 10.6083 13.5542C10.6083 15.0812 9.56296 16.8881 7.18213 16.8881H3V8.21057ZM5.56604 14.6593C5.88626 14.7165 6.21078 14.7463 6.53607 14.7484C7.45588 14.7484 8.0605 14.2524 8.0605 13.4758C8.0605 12.7129 7.46844 12.1912 6.61142 12.1912C6.25719 12.1881 5.90461 12.2396 5.56604 12.3437V14.6593ZM14.9211 10.0533C17.7552 10.0533 18.8382 11.8986 18.8382 13.5272C18.8382 15.3085 17.5913 17.0005 14.9455 17.0005C12.1114 17.0005 11.0026 15.1684 11.0026 13.5272C11.0051 11.7962 12.1767 10.0533 14.9229 10.0533H14.9211ZM14.9211 14.825C15.7222 14.825 16.2735 14.2901 16.2735 13.5272C16.2735 12.7644 15.7241 12.2288 14.9229 12.2288C14.1218 12.2288 13.5705 12.7638 13.5705 13.5272C13.5705 14.2907 14.1218 14.825 14.9229 14.825H14.9211ZM19.3606 8.21057H21.9229V16.8863H19.3606V8.21057ZM25.2788 15.4372C25.2788 16.3024 24.6088 17.0024 23.7656 17.0024C22.9224 17.0024 22.2393 16.3024 22.2393 15.4372C22.2369 15.2348 22.2746 15.034 22.3501 14.8463C22.4256 14.6586 22.5376 14.4877 22.6794 14.3435C22.8213 14.1992 22.9903 14.0844 23.1767 14.0058C23.3632 13.9271 23.5633 13.8861 23.7656 13.8851C24.6088 13.8832 25.2788 14.5701 25.2788 15.4353V15.4372Z",
		fill: "white"
	})], -1), s("defs", null, [s("clipPath", { id: "clip0_4638_78157" }, [s("rect", {
		fill: "white",
		height: "24",
		width: "24"
	})])], -1)]]);
}
var q_ = /*#__PURE__*/ G(G_, [["render", K_]]), J_ = {}, Y_ = {
	d: "M15 18V20.2307C15 20.4372 14.9234 20.6171 14.7703 20.7703C14.6171 20.9234 14.4373 21 14.2308 21H3.76925C3.56275 21 3.38292 20.9234 3.22975 20.7703C3.07658 20.6171 3 20.4372 3 20.2307V13.7692C3 13.5627 3.07658 13.3829 3.22975 13.2298C3.38292 13.0766 3.56275 13 3.76925 13H7V8C7 6.61533 7.48717 5.43583 8.4615 4.4615C9.43583 3.48717 10.6153 3 12 3H16C17.3847 3 18.5642 3.48717 19.5385 4.4615C20.5128 5.43583 21 6.61533 21 8V21H20V18H15ZM15 17H20V8C20 6.9 19.6083 5.95833 18.825 5.175C18.0417 4.39167 17.1 4 16 4H12C10.9 4 9.95833 4.39167 9.175 5.175C8.39167 5.95833 8 6.9 8 8V13H14.2308C14.4373 13 14.6171 13.0766 14.7703 13.2298C14.9234 13.3829 15 13.5627 15 13.7692V17ZM10.5 9.5V8.5H17.5V9.5H10.5ZM9 16.85L14 14H4L9 16.85ZM9 17.8693L4 15.0192V20H14V15.0192L9 17.8693Z",
	fill: "currentColor"
};
function X_(e, t) {
	return A(), o("path", Y_);
}
var Z_ = /*#__PURE__*/ G(J_, [["render", X_]]), Q_ = {}, $_ = {
	d: "M0 7C0 6.44772 0.447715 6 1 6H17.0858C17.4836 6 17.8651 6.15804 18.1464 6.43934L24 12.2929V16C24 16.5523 23.5523 17 23 17L19.2929 17.0001L15.2929 13H11V16C11 16.5523 10.5523 17 9.99999 17L6.29289 17L0.43934 11.1464C0.158035 10.8651 0 10.4836 0 10.0858V7ZM10.7071 12H13.7929L8.79289 7H5.7071L10.7071 12ZM15.2071 12H18.2929L13.2929 7H10.2071L15.2071 12ZM14.7071 7L19.7071 12H22.2929L17.4393 7.14645C17.3456 7.05268 17.2184 7 17.0858 7H14.7071ZM23 13H20V16L23 16V13ZM19 15.2929V13H16.7071L19 15.2929ZM4.29289 7H1.7071L6.70711 12H9.2929L4.29289 7ZM6 12.7072L1 7.70711V10.0858C1 10.2184 1.05268 10.3456 1.14645 10.4393L6 15.2929V12.7072ZM7 16L10 16V13H7V16Z",
	fill: "currentColor"
};
function ev(e, t) {
	return A(), o("path", $_);
}
var tv = /*#__PURE__*/ G(Q_, [["render", ev]]), nv = {}, rv = {
	d: "M12.5821 4.20251C12.2099 4.04578 11.7901 4.04578 11.4179 4.20251L2.91791 7.78147C2.36169 8.01567 2 8.56041 2 9.16392V14.8359C2 15.4394 2.36169 15.9842 2.91792 16.2184L11.4179 19.7973C11.7901 19.954 12.2099 19.954 12.5821 19.7973L21.0821 16.2183C21.6383 15.9842 22 15.4394 22 14.8359V9.16391C22 8.56039 21.6383 8.01565 21.0821 7.78146L12.5821 4.20251ZM11.806 5.12414C11.93 5.0719 12.07 5.0719 12.194 5.12414L19.984 8.40415L16.4999 9.95264L8.63751 6.45824L11.806 5.12414ZM7.37313 6.99061L15.2688 10.4998L12.6092 11.6819C12.2214 11.8542 11.7786 11.8542 11.3908 11.6819L4.01598 8.40415L7.37313 6.99061ZM16 11.2692V13.9998C16 14.276 16.2239 14.4998 16.5 14.4998C16.7761 14.4998 17 14.276 17 13.9998V10.8247L20.9875 9.0525C20.9957 9.08856 21 9.12588 21 9.16391V14.8359C21 15.0371 20.8794 15.2186 20.694 15.2967L12.5 18.7468V12.7606C12.6758 12.7248 12.8486 12.6698 13.0153 12.5957L16 11.2692ZM3.01255 9.0525L10.9847 12.5957C11.1514 12.6698 11.3242 12.7248 11.5 12.7606V18.7468L3.30597 15.2967C3.12056 15.2187 3 15.0371 3 14.8359V9.16392C3 9.12589 3.00431 9.08857 3.01255 9.0525Z",
	fill: "currentColor"
};
function iv(e, t) {
	return A(), o("path", rv);
}
var av = /*#__PURE__*/ G(nv, [["render", iv]]), ov = {};
function sv(t, n) {
	return A(), o(e, null, [n[0] ||= s("path", {
		d: "M21 22h-3v-.5c0-.1-.1-.5-1-.5s-1 .4-1 .5v.5h-3v-.5c0-.1-.1-.5-1-.5s-1 .4-1 .5v.5H8v-.5c0-.1-.1-.5-1-.5s-1 .4-1 .5v.5H3v-4h.5c.1 0 .5-.1.5-1s-.4-1-.5-1H3v-3h.5c.1 0 .5-.1.5-1s-.4-1-.5-1H3V8h.5c.1 0 .5-.1.5-1s-.4-1-.5-1H3V2h3v.5c0 .1.1.5 1 .5s1-.4 1-.5V2h3v.5c0 .1.1.5 1 .5s1-.4 1-.5V2h3v.5c0 .1.1.5 1 .5s1-.4 1-.5V2h3v4h-.5c-.1 0-.5.1-.5 1s.4 1 .5 1h.5v3h-.5c-.1 0-.5.1-.5 1s.4 1 .5 1h.5v3h-.5c-.1 0-.5.1-.5 1s.4 1 .5 1h.5v4zm-2.1-1H20v-2.1c-.5-.2-1-.7-1-1.9s.5-1.7 1-1.9v-1.2c-.5-.2-1-.7-1-1.9s.5-1.7 1-1.9V8.9c-.5-.2-1-.7-1-1.9s.5-1.7 1-1.9V3h-1.1c-.2.5-.7 1-1.9 1s-1.7-.5-1.9-1h-1.2c-.2.5-.7 1-1.9 1s-1.7-.5-1.9-1H8.9c-.2.5-.8 1-1.9 1s-1.7-.5-1.9-1H4v2.1c.5.2 1 .8 1 1.9s-.5 1.7-1 1.9v1.2c.5.2 1 .7 1 1.9s-.5 1.7-1 1.9v1.2c.5.2 1 .7 1 1.9s-.5 1.7-1 1.9V21h1.1c.2-.5.7-1 1.9-1s1.7.5 1.9 1h1.2c.2-.5.7-1 1.9-1s1.7.5 1.9 1h1.2c.2-.5.7-1 1.9-1s1.7.5 1.9 1z",
		fill: "currentColor"
	}, null, -1), n[1] ||= s("path", {
		d: "M9.3 14.5c-.2 0-.4-.1-.5-.2-.2-.1-.3-.3-.3-.5-.1-.2 0-.4 0-.6.1-.2.2-.3.4-.4l5.5-3.2c.1-.1.2-.1.3-.1h.3c.1 0 .2.1.3.2.1.1.2.2.2.3.1.1.1.2.1.3v.3c0 .1-.1.2-.2.3-.1.1-.2.2-.3.2l-5.5 3.2c0 .2-.2.2-.3.2zm2.7 1.6c-.2 0-.4-.1-.5-.2-.2-.1-.3-.3-.3-.5-.1-.2 0-.4 0-.6.1-.2.2-.3.4-.4l2.7-1.6c.1-.1.2-.1.3-.1h.3c.1 0 .2.1.3.2.1.1.2.2.2.3.1.1.1.2.1.3v.3c0 .1-.1.2-.2.3-.1.1-.2.2-.3.2L12.5 16c-.2.1-.3.1-.5.1zm-2.8-4.7c-.2 0-.4-.1-.5-.2-.2-.1-.3-.3-.3-.5-.1-.2 0-.4 0-.6.1-.1.2-.3.4-.4l2.7-1.6c.3-.1.5-.1.7-.1.2.1.4.2.5.4.1.2.1.4.1.7-.1.2-.2.4-.4.5l-2.7 1.6c-.1.1-.3.2-.5.2z",
		fill: "currentColor"
	}, null, -1)], 64);
}
var cv = /*#__PURE__*/ G(ov, [["render", sv]]), lv = {}, uv = {
	d: "M10.4116 5.20544C10.7894 5.04636 11.2158 5.04884 11.5918 5.21229L22.0981 9.78026C22.6458 10.0184 23 10.5587 23 11.1559V12.8362C23 13.4397 22.6383 13.9844 22.0821 14.2186L13.5884 17.7949C13.2106 17.954 12.7842 17.9515 12.4082 17.7881L1.90191 13.2201C1.35424 12.982 1 12.4417 1 11.8445V10.1642C1 9.56067 1.36169 9.01593 1.91792 8.78173L10.4116 5.20544ZM11.1931 6.12936C11.0677 6.07487 10.9256 6.07405 10.7997 6.12707L7.64807 7.45406L17.745 11.844L21.0046 10.3953L11.1931 6.12936ZM18.5 12.6028V13.5001C18.5 13.7763 18.2761 14.0001 18 14.0001C17.7239 14.0001 17.5 13.7763 17.5 13.5001V13.0472L14.0065 14.5999C13.8426 14.6727 13.6727 14.7271 13.5 14.763V16.7471L21.694 13.297C21.8794 13.2189 22 13.0374 22 12.8362V11.1559C22 11.1205 21.9963 11.0857 21.9891 11.052L18.5 12.6028ZM16.5048 12.3952L6.37396 7.99052L2.77115 9.5075L12.3931 13.6909C12.7784 13.8585 13.2164 13.8567 13.6004 13.6861L16.5048 12.3952ZM2.30064 12.303L12.5 16.7375V14.7666C12.3277 14.7321 12.1582 14.6792 11.9943 14.608L2 10.2626V11.8445C2 12.0436 2.11808 12.2237 2.30064 12.303Z",
	fill: "currentColor"
};
function dv(e, t) {
	return A(), o("path", uv);
}
var fv = /*#__PURE__*/ G(lv, [["render", dv]]), pv = {}, mv = {
	"clip-rule": "evenodd",
	d: "M5.5 6.5C5.5 5.67157 6.17157 5 7 5H10C10.2761 5 10.5 4.77614 10.5 4.5C10.5 4.22386 10.2761 4 10 4H7C5.61929 4 4.5 5.11929 4.5 6.5V17.5C4.5 18.8807 5.61929 20 7 20H18C19.3807 20 20.5 18.8807 20.5 17.5V14.5C20.5 14.2239 20.2761 14 20 14C19.7239 14 19.5 14.2239 19.5 14.5V17.5C19.5 18.3284 18.8284 19 18 19H7C6.17157 19 5.5 18.3284 5.5 17.5V6.5ZM15 4C14.7239 4 14.5 4.22386 14.5 4.5C14.5 4.77614 14.7239 5 15 5H18.7929L11.6464 12.1464C11.4512 12.3417 11.4512 12.6583 11.6464 12.8536C11.8417 13.0488 12.1583 13.0488 12.3536 12.8536L19.5 5.70711V9.5C19.5 9.77614 19.7239 10 20 10C20.2761 10 20.5 9.77614 20.5 9.5V4.5C20.5 4.22386 20.2761 4 20 4H15Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function hv(e, t) {
	return A(), o("path", mv);
}
var gv = /*#__PURE__*/ G(pv, [["render", hv]]), _v = {}, vv = {
	d: "M9.16129 0.698078H11.2219C11.4205 1.74609 12.057 2.64537 12.9388 3.20722C12.9391 3.20758 12.9394 3.20794 12.9397 3.2083C13.5536 3.59927 14.2855 3.82737 15.0712 3.82737V4.4397L15.0713 6.57766C13.6118 6.57766 12.2594 6.12136 11.1555 5.34698V10.937C11.1555 13.7288 8.8315 16 5.97486 16C4.87105 16 3.84742 15.6598 3.006 15.0824C3.00555 15.0819 3.0051 15.0814 3.00456 15.0809C1.66941 14.1642 0.794434 12.6488 0.794434 10.9365C0.794434 8.14478 3.11839 5.87346 5.97504 5.87346C6.21205 5.87346 6.44438 5.89254 6.67312 5.92286V6.57451L6.67302 8.73155C6.45203 8.66397 6.21844 8.62465 5.97486 8.62465C4.6703 8.62465 3.60897 9.66205 3.60897 10.937C3.60897 11.8249 4.12438 12.5963 4.87744 12.9835C5.20578 13.1524 5.57876 13.2493 5.97477 13.2493C7.24927 13.2493 8.28892 12.2585 8.33625 11.024L8.34075 0H11.1554C11.1554 0.238451 11.1789 0.471504 11.2219 0.698078H9.16129Z",
	fill: "currentColor"
};
function yv(e, t) {
	return A(), o("path", vv);
}
var bv = /*#__PURE__*/ G(_v, [["render", yv]]), xv = {}, Sv = {
	d: "M12.83 4.124a.5.5 0 0 1 .046.705l-7 8a.5.5 0 0 1-.73.025l-3-3a.5.5 0 1 1 .708-.708l2.622 2.622 6.648-7.597a.5.5 0 0 1 .705-.047Z",
	fill: "currentColor"
};
function Cv(e, t) {
	return A(), o("path", Sv);
}
var wv = /*#__PURE__*/ G(xv, [["render", Cv]]), Tv = {}, Ev = {
	d: "M 7.978 4.437 C 5.99 4.437 4.387 6.04 4.387 8.027 C 4.387 10.015 5.99 11.618 7.978 11.618 C 9.965 11.618 11.568 10.015 11.568 8.027 C 11.568 6.04 9.965 4.437 7.978 4.437 Z M 7.978 10.362 C 6.693 10.362 5.643 9.315 5.643 8.027 C 5.643 6.74 6.69 5.693 7.978 5.693 C 9.265 5.693 10.312 6.74 10.312 8.027 C 10.312 9.315 9.262 10.362 7.978 10.362 Z M 12.553 4.29 C 12.553 4.755 12.178 5.127 11.715 5.127 C 11.249 5.127 10.878 4.752 10.878 4.29 C 10.878 3.827 11.253 3.452 11.715 3.452 C 12.178 3.452 12.553 3.827 12.553 4.29 Z M 14.931 5.14 C 14.878 4.018 14.621 3.024 13.799 2.205 C 12.981 1.387 11.987 1.13 10.865 1.074 C 9.709 1.008 6.243 1.008 5.087 1.074 C 3.968 1.127 2.974 1.383 2.153 2.202 C 1.331 3.021 1.078 4.015 1.021 5.137 C 0.956 6.293 0.956 9.758 1.021 10.915 C 1.074 12.037 1.331 13.03 2.153 13.849 C 2.974 14.668 3.965 14.924 5.087 14.98 C 6.243 15.046 9.709 15.046 10.865 14.98 C 11.987 14.927 12.981 14.671 13.799 13.849 C 14.618 13.03 14.874 12.037 14.931 10.915 C 14.996 9.758 14.996 6.296 14.931 5.14 Z M 13.437 12.155 C 13.193 12.768 12.721 13.24 12.106 13.487 C 11.184 13.852 8.996 13.768 7.978 13.768 C 6.959 13.768 4.768 13.849 3.849 13.487 C 3.237 13.243 2.765 12.771 2.518 12.155 C 2.153 11.233 2.237 9.046 2.237 8.027 C 2.237 7.008 2.156 4.818 2.518 3.899 C 2.762 3.287 3.234 2.815 3.849 2.568 C 4.771 2.202 6.959 2.287 7.978 2.287 C 8.996 2.287 11.187 2.205 12.106 2.568 C 12.718 2.812 13.19 3.283 13.437 3.899 C 13.803 4.821 13.718 7.008 13.718 8.027 C 13.718 9.046 13.803 11.237 13.437 12.155 Z",
	style: { fill: "currentColor" }
};
function Dv(e, t) {
	return A(), o("path", Ev);
}
var Ov = /*#__PURE__*/ G(Tv, [["render", Dv]]), kv = {}, Av = {
	d: "M14.8 0H1.2C0.88174 0 0.576516 0.126428 0.351472 0.351472C0.126428 0.576516 0 0.88174 0 1.2V14.8C0 15.1183 0.126428 15.4235 0.351472 15.6485C0.576516 15.8736 0.88174 16 1.2 16H14.8C15.1183 16 15.4235 15.8736 15.6485 15.6485C15.8736 15.4235 16 15.1183 16 14.8V1.2C16 0.88174 15.8736 0.576516 15.6485 0.351472C15.4235 0.126428 15.1183 0 14.8 0ZM4.8 13.6H2.4V6.4H4.8V13.6ZM3.6 5C3.32495 4.99214 3.05831 4.9034 2.8334 4.74486C2.60849 4.58633 2.43529 4.36503 2.33544 4.10862C2.23558 3.85221 2.2135 3.57206 2.27195 3.30318C2.3304 3.03429 2.4668 2.78859 2.66409 2.59678C2.86138 2.40497 3.11083 2.27555 3.38125 2.22469C3.65168 2.17383 3.93109 2.2038 4.18459 2.31083C4.43808 2.41787 4.65441 2.59724 4.80655 2.82652C4.95869 3.0558 5.03989 3.32483 5.04 3.6C5.03368 3.97628 4.87867 4.33476 4.60884 4.59709C4.33901 4.85943 3.97631 5.00428 3.6 5ZM13.6 13.6H11.2V9.808C11.2 8.672 10.72 8.264 10.096 8.264C9.91305 8.27618 9.73431 8.32439 9.57004 8.40585C9.40577 8.48731 9.25921 8.60042 9.13879 8.73869C9.01836 8.87695 8.92644 9.03765 8.8683 9.21154C8.81016 9.38544 8.78695 9.56911 8.8 9.752C8.79603 9.78923 8.79603 9.82677 8.8 9.864V13.6H6.4V6.4H8.72V7.44C8.95402 7.084 9.27554 6.79406 9.65375 6.59795C10.032 6.40184 10.4542 6.30613 10.88 6.32C12.12 6.32 13.568 7.008 13.568 9.248L13.6 13.6Z",
	fill: "currentColor"
};
function jv(e, t) {
	return A(), o("path", Av);
}
var Mv = /*#__PURE__*/ G(kv, [["render", jv]]), Nv = {}, Pv = {
	d: "M8 .5a.5.5 0 0 1 .5.5v6.5H15a.5.5 0 0 1 0 1H8.5V15a.5.5 0 0 1-1 0V8.5H1a.5.5 0 0 1 0-1h6.5V1A.5.5 0 0 1 8 .5Z",
	fill: "currentColor"
};
function Fv(e, t) {
	return A(), o("path", Pv);
}
var Iv = /*#__PURE__*/ G(Nv, [["render", Fv]]), Lv = /* @__PURE__ */ f({
	__name: "FlagIcon",
	props: { country: {} },
	setup(e) {
		let t = e, n = ie(), r = {
			nl: Lh,
			nl_nl: Lh,
			"nl-nl": Lh,
			be: Bh,
			nl_be: Bh,
			"nl-be": Bh,
			fr: Ph,
			fr_fr: Ph,
			"fr-fr": Ph,
			fr_be: Bh,
			"fr-be": Bh,
			de: Yh,
			de_de: Yh,
			"de-de": Yh,
			it: Kh,
			it_it: Kh,
			"it-it": Kh,
			en: jh,
			gb: jh,
			en_gb: jh,
			"en-gb": jh,
			es: Uh,
			es_es: Uh,
			"es-es": Uh
		}, o = () => {
			let e = t.country.toLowerCase();
			return r[e];
		};
		return z(() => t.country, () => {
			n.value = o();
		}, { immediate: !0 }), (e, t) => n.value ? (A(), i(Jp, {
			key: 0,
			size: L(Kp).Medium
		}, {
			default: B(() => [(A(), i(re(n.value)))]),
			_: 1
		}, 8, ["size"])) : a("", !0);
	}
}), Rv = M([]), zv = (e) => ({
	isTopModal: r(() => Rv.value[0] === e),
	isBottomModal: r(() => Rv.value[Rv.value.length - 1] === e),
	currentPosition: r(() => Rv.value.indexOf(e)),
	registerModal: () => {
		Rv.value.includes(e) || Rv.value.unshift(e);
	},
	unregisterModal: () => {
		Rv.value = Rv.value.filter((t) => t !== e);
	}
}), Bv = /* @__PURE__ */ f({
	__name: "Heading",
	props: {
		level: {},
		border: { type: Boolean }
	},
	setup(e) {
		return (t, n) => (A(), i(re(`h${e.level}`), { class: C(["leading-normal font-bold", {
			"text-xl": e.level === "1",
			"text-lg": e.level === "2",
			"text-base": e.level === "3",
			"text-xs": e.level === "4",
			"border-b pb-2 border-gray-400": e.border
		}]) }, {
			default: B(() => [F(t.$slots, "default")]),
			_: 3
		}, 8, ["class"]));
	}
}), Vv = ["aria-label", "closedby"], Hv = { class: "flex flex-col w-full gap-4" }, Uv = { class: "flex gap-4 ml-auto" }, Wv = /*#__PURE__*/ W(/* @__PURE__ */ f({
	__name: "Modal",
	props: {
		open: { type: Boolean },
		title: { default: "" },
		showCancel: { type: Boolean },
		hideConfirm: { type: Boolean },
		hideCloseButton: { type: Boolean },
		closedBy: { default: "any" },
		disableConfirm: { type: Boolean },
		fullWidthContent: { type: Boolean },
		bodyClass: { default: "" }
	},
	emits: [
		"close",
		"cancel",
		"confirm"
	],
	setup(e, { expose: t, emit: n }) {
		ce((e) => ({ v31ed5ad0: L(y) }));
		let c = e, d = n, f = ue(), p = le(), m = M(!1), h = de("dialog"), { t: g } = Re(), { isTopModal: _, isBottomModal: v, currentPosition: y, registerModal: b, unregisterModal: x } = zv(p), S = () => {
			window.dispatchEvent(new CustomEvent(up));
		};
		O(() => {
			c.open && w();
		}), E(() => {
			m.value && (T(), x(), S());
		}), z(() => c.open, (e) => {
			e !== m.value && (e ? w() : T());
		});
		let w = () => {
			b(), m.value = !0, h.value?.showModal(), S();
		}, T = () => {
			h.value?.close();
		}, D = () => {
			h.value?.open || (d("close"), m.value = !1, x());
		}, k = () => {
			d("cancel"), T();
		}, ee = () => {
			d("confirm"), T();
		}, j = r(() => !!f.footer || !!f.actionButtons || c.showCancel || !c.hideConfirm);
		return t({
			cancel: k,
			confirm: ee,
			show: w,
			isOpen: ne(m)
		}), (t, n) => (A(), o("dialog", {
			ref: "dialog",
			"aria-label": e.title || void 0,
			class: C([
				"mt-12 w-2xl max-w-full max-h-[calc(100vh-6rem)]",
				"left-0 right-0 mx-auto",
				"rounded-lg shadow-lg",
				"open:flex",
				{
					"backdrop:bg-black/50": L(v),
					"backdrop:transparent": !L(v),
					"h-8! w-2xl! overflow-hidden": !L(_),
					"p-4": !e.fullWidthContent
				}
			]),
			closedby: e.closedBy,
			onCancel: k,
			onClose: D
		}, [s("div", Hv, [
			s("div", { class: C(["flex justify-between items-center", { "p-4 pb-0": e.fullWidthContent }]) }, [F(t.$slots, "header", {}, () => [e.title ? (A(), i(Bv, {
				key: 0,
				level: "2"
			}, {
				default: B(() => [l(I(e.title), 1)]),
				_: 1
			})) : a("", !0)], !0), e.hideCloseButton ? a("", !0) : (A(), i(Dp, {
				key: 0,
				"aria-label": L(g)("close"),
				class: "p-0 ml-auto",
				variant: "none",
				onClick: n[0] ||= (e) => k()
			}, {
				default: B(() => [u(ap, {
					height: "22",
					viewBox: "0 0 16 16",
					width: "22"
				}, {
					default: B(() => [u(L(sg))]),
					_: 1
				})]),
				_: 1
			}, 8, ["aria-label"]))], 2),
			s("div", { class: C(e.bodyClass) }, [F(t.$slots, "default", {}, void 0, !0)], 2),
			j.value ? (A(), o("div", {
				key: 0,
				class: C(["flex justify-between gap-4 w-full", { "p-4 pt-0": e.fullWidthContent }])
			}, [F(t.$slots, "footer", {}, void 0, !0), s("div", Uv, [F(t.$slots, "actionButtons", {
				cancel: k,
				confirm: ee
			}, () => [e.showCancel ? (A(), i(Dp, {
				key: 0,
				variant: "secondary-basic",
				onClick: k
			}, {
				default: B(() => [l(I(L(g)("cancel", 2)), 1)]),
				_: 1
			})) : a("", !0), e.hideConfirm ? a("", !0) : (A(), i(Dp, {
				key: 1,
				autofocus: "",
				disabled: e.disableConfirm,
				onClick: ee
			}, {
				default: B(() => [l(I(L(g)("confirm")), 1)]),
				_: 1
			}, 8, ["disabled"]))], !0)])], 2)) : a("", !0)
		])], 42, Vv));
	}
}), [["__scopeId", "data-v-d9b0c433"]]), Gv = { class: "whitespace-pre-wrap" }, Kv = /* @__PURE__ */ f({
	__name: "AreYouSureModal",
	props: {
		open: { type: Boolean },
		isLoading: { type: Boolean },
		keepOpenOnConfirm: { type: Boolean },
		primaryButtonVariant: { default: Sp.Secondary },
		yesNo: { type: Boolean },
		title: {}
	},
	emits: ["closed", "agreed"],
	setup(e, { expose: t, emit: n }) {
		let a = e, o = n, { t: d } = Re(), f = de("modal"), p = r(() => a.yesNo ? d("yes") : d("confirm")), m = r(() => a.yesNo ? d("no") : d("cancel", 2)), h = () => {
			o("closed");
		}, g = () => {
			/* c8 ignore next -- modal ref is always defined when mounted. */
			f.value?.cancel();
		}, _ = async () => {
			o("agreed"), await S(), a.keepOpenOnConfirm || 
			/* c8 ignore next -- modal ref is always defined when mounted. */
			f.value?.confirm();
		}, v = () => {
			/* c8 ignore next -- modal ref is always defined when mounted. */
			f.value?.show();
		}, y = r(() => f.value?.isOpen.value ?? !1);
		return t({
			show: v,
			isOpen: ne(y)
		}), (t, n) => (A(), i(Wv, {
			ref: "modal",
			"closed-by": e.isLoading ? "none" : "any",
			"hide-close-button": e.isLoading,
			open: e.open,
			title: e.title ?? L(d)("modal.areYouSure"),
			onCancel: h
		}, c({
			actionButtons: B(() => [u(Dp, {
				class: C({ "bg-transparent! border-transparent! text-gray-400! hover:text-gray-400!": e.isLoading }),
				disabled: e.isLoading,
				variant: "secondary-basic",
				onClick: g
			}, {
				default: B(() => [F(t.$slots, "cancel", {}, () => [l(I(m.value), 1)])]),
				_: 3
			}, 8, ["class", "disabled"]), u(Wp, {
				disabled: e.isLoading,
				"is-loading": e.isLoading,
				variant: e.primaryButtonVariant,
				onClick: _
			}, {
				default: B(() => [F(t.$slots, "agree", {}, () => [l(I(p.value), 1)])]),
				_: 3
			}, 8, [
				"disabled",
				"is-loading",
				"variant"
			])]),
			default: B(() => [s("div", Gv, [F(t.$slots, "default")])]),
			_: 2
		}, [t.$slots.header ? {
			name: "header",
			fn: B(() => [F(t.$slots, "header")]),
			key: "0"
		} : void 0]), 1032, [
			"closed-by",
			"hide-close-button",
			"open",
			"title"
		]));
	}
}), qv = {
	Clear: "clear",
	Danger: "danger",
	DangerLight: "danger-light",
	Info: "info",
	InfoLight: "info-light",
	Muted: "muted",
	MutedLight: "muted-light",
	Primary: "primary",
	PrimaryLight: "primary-light",
	Secondary: "secondary",
	SecondaryLight: "secondary-light",
	Success: "success",
	SuccessLight: "success-light",
	Warning: "warning",
	WarningLight: "warning-light"
}, Jv = "border px-[6px] py-[2px] rounded-regular text-xs w-max min-w-3 min-h-3", Yv = "rounded-full! px-[9px] py-[3px]", Xv = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "Badge",
	props: {
		variant: {},
		newLight: {
			type: Boolean,
			default: !1
		}
	},
	setup(e) {
		let t = e, { class: n, ...i } = se(), a = {
			[qv.Clear]: "bg-white text-black border border-gray-400",
			[qv.Danger]: "bg-red text-white border-transparent",
			[qv.DangerLight]: "bg-red-100 text-danger-200 border border-transparent",
			[qv.Info]: "bg-blue text-white border-transparent",
			[qv.InfoLight]: "bg-blue-100 text-info-200 border border-transparent",
			[qv.Muted]: "bg-gray-200 text-black border-gray-400",
			[qv.MutedLight]: "bg-gray-200 text-gray-800 border border-gray-400",
			[qv.Primary]: "bg-primary text-white border-transparent",
			[qv.PrimaryLight]: "bg-primary-50 text-primary border-transparent",
			[qv.Secondary]: "bg-secondary text-black border-transparent",
			[qv.SecondaryLight]: "bg-secondary-50 text-secondary-200 border-transparent",
			[qv.Success]: "bg-green text-white border border-transparent",
			[qv.SuccessLight]: "bg-green-100 text-green border border-transparent",
			[qv.Warning]: "bg-yellow text-black border-transparent",
			[qv.WarningLight]: "bg-[#FEF5D9] text-[#A27900] border-transparent"
		}, s = {
			[qv.DangerLight]: "bg-red-200 text-red-900 border-red",
			[qv.InfoLight]: "bg-blue-100 text-blue border-blue",
			[qv.MutedLight]: "bg-gray-200 text-black-light border-gray-500",
			[qv.PrimaryLight]: "bg-primary-light text-primary border-primary",
			[qv.SecondaryLight]: "bg-secondary-light text-secondary-dark border-secondary",
			[qv.SuccessLight]: "bg-green-200 text-green border-green",
			[qv.WarningLight]: "bg-yellow-200 text-yellow-900 border-yellow"
		}, c = r(() => {
			let e = t.newLight ? s[t.variant] : void 0;
			return _e(Jv, e ? `${Yv} ${e}` : a[t.variant], n);
		});
		return (e, t) => (A(), o("div", x(i, { class: c.value }), [F(e.$slots, "default")], 16));
	}
}), Zv = {
	ExtraSmall: "extra-small",
	Small: "small",
	Medium: "medium"
}, Qv = {
	key: 0,
	class: "relative inline-flex"
}, $v = {
	key: 2,
	class: "sr-only",
	role: "status"
}, ey = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "BadgeOverlay",
	props: {
		variant: { default: qv.Primary },
		label: { default: void 0 },
		size: { default: Zv.Medium },
		showBadge: {
			type: Boolean,
			default: !0
		},
		announcement: { default: void 0 }
	},
	setup(t) {
		let i = t, s = {
			[Zv.ExtraSmall]: "text-[8px] px-0.5 py-px leading-none min-w-2 min-h-2 right-1 top-0.5",
			[Zv.Small]: "text-[10px] px-1 py-px leading-none",
			[Zv.Medium]: ""
		}, c = r(() => s[i.size]);
		return (r, i) => (A(), o(e, null, [t.showBadge ? (A(), o("div", Qv, [F(r.$slots, "default"), u(n, {
			appear: "",
			"enter-active-class": "transition duration-200 ease-out",
			"enter-from-class": "opacity-0 scale-0",
			"enter-to-class": "opacity-100 scale-100"
		}, {
			default: B(() => [u(Xv, x({
				class: ["absolute top-0 right-0.5 -translate-y-1/2 translate-x-1/2 rounded-full!", c.value],
				variant: t.variant
			}, r.$attrs), {
				default: B(() => [l(I(t.label), 1)]),
				_: 1
			}, 16, ["class", "variant"])]),
			_: 1
		})])) : F(r.$slots, "default", {}, void 0, void 0, 1), t.announcement ? (A(), o("span", $v, I(t.showBadge ? t.announcement : ""), 1)) : a("", !0)], 64));
	}
}), ty = [
	"alt",
	"src",
	"title"
], ny = /* @__PURE__ */ f({
	__name: "BaseImage",
	props: {
		src: {},
		alt: {},
		title: {},
		hideOnError: { type: Boolean }
	},
	emits: ["error"],
	setup(e, { emit: t }) {
		let n = e, i = t, s = M(!1), c = r(() => !n.hideOnError || !s.value), l = () => {
			s.value = !0, n.hideOnError && i("error");
		};
		return n.src || n.hideOnError && (s.value = !0, i("error")), z(() => n.src, (e) => {
			e ? s.value = !1 : (s.value = !!n.hideOnError, n.hideOnError && i("error"));
		}), (t, n) => c.value ? (A(), o("img", {
			key: 0,
			alt: e.alt,
			src: e.src,
			title: e.title,
			onError: l
		}, null, 40, ty)) : a("", !0);
	}
}), ry = {
	Default: "default",
	Elevated: "elevated"
}, iy = {
	key: 0,
	class: "p-4 border-b"
}, ay = {
	key: 1,
	class: "border-t divide-x grid auto-cols-[1fr] grid-flow-col"
}, oy = /* @__PURE__ */ f({
	__name: "Card",
	props: { variant: { default: ry.Default } },
	setup(e) {
		let t = e, n = r(() => t.variant === ry.Elevated);
		return (e, t) => (A(), o("div", { class: C(["border border-gray-400 card", n.value ? "bg-white rounded-[12px] shadow-sm" : "max-w-md rounded-regular"]) }, [
			e.$slots.header ? (A(), o("div", iy, [F(e.$slots, "header")])) : a("", !0),
			s("div", { class: C(n.value ? "p-4" : "py-4 px-6") }, [F(e.$slots, "default")], 2),
			e.$slots.footer ? (A(), o("div", ay, [F(e.$slots, "footer")])) : a("", !0)
		], 2));
	}
}), sy = {}, cy = {
	class: "font-normal text-xs grid grid-cols-2 gap-x-2 gap-y-3",
	role: "list"
};
function ly(e, t) {
	return A(), o("dl", cy, [F(e.$slots, "default")]);
}
var uy = /*#__PURE__*/ W(sy, [["render", ly]]), dy = { class: "flex flex-col w-full" }, fy = { class: "font-bold" }, py = { class: "break-all" }, my = /* @__PURE__ */ f({
	__name: "CardRow",
	props: { label: {} },
	setup(e) {
		return (t, n) => (A(), o("div", dy, [s("dt", fy, I(e.label), 1), s("dd", py, [F(t.$slots, "default")])]));
	}
}), hy = { class: "flex flex-col text-left gap-1" }, gy = { class: "text-md" }, _y = { class: "text-sm" }, vy = /* @__PURE__ */ f({
	__name: "DashboardButton",
	props: {
		disabled: { type: Boolean },
		variant: { default: "primary-light" },
		isExternal: { type: Boolean }
	},
	setup(e) {
		return (t, n) => (A(), i(Dp, {
			class: "group p-6 gap-4 flex items-center border-gray w-[375px] h-[97px] rounded-lg text-black",
			disabled: e.disabled,
			variant: e.variant
		}, {
			default: B(() => [
				s("div", { class: C(["flex w-8 h-8", {
					"text-primary group-hover:text-white": !e.disabled,
					"text-black group-hover:text-black": e.disabled
				}]) }, [F(t.$slots, "icon")], 2),
				s("div", hy, [s("div", gy, [F(t.$slots, "title")]), s("div", _y, [F(t.$slots, "subtitle")])]),
				e.isExternal ? (A(), i(L(ze), {
					key: 0,
					size: 24
				}, {
					default: B(() => [u(L(gv))]),
					_: 1
				})) : a("", !0)
			]),
			_: 3
		}, 8, ["disabled", "variant"]));
	}
}), yy = /* @__PURE__ */ f({
	__name: "Date",
	props: {
		date: {},
		format: { default: "D MMM. YYYY" }
	},
	setup(e) {
		let t = e, { locale: n } = Re(), i = (e, t) => ve(e).locale(n.value).format(t), a = r(() => i(t.date, t.format));
		return (e, t) => (A(), o("span", null, I(a.value), 1));
	}
}), K = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20,
	DhlFreight: 21
}, q = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM",
	DhlFreight: "dhlfreight",
	DHL_FREIGHT: "DHL_FREIGHT"
};
K.Dhl, K.Instabox, K.PostNl, q.PostNl, K.Bpost, q.Bpost, K.CheapCargo, q.CheapCargo, K.Dpd, q.Dpd, K.Instabox, q.Instabox, K.Dhl, q.Dhl, K.Bol, q.Bol, K.Ups, q.Ups, K.DhlForYou, q.DhlForYou, K.DhlParcelConnect, q.DhlParcelConnect, K.DhlEuroPlus, q.DhlEuroPlus, K.UpsStandard, q.UpsStandard, K.UpsExpressSaver, q.UpsExpressSaver, K.Gls, q.Gls, K.Brt, q.Brt, K.Trunkrs, q.Trunkrs, K.InPost, q.InPost, K.PosteItaliane, q.PosteItaliane, K.Spring, q.Spring, K.ViaTim, q.ViaTim, K.DhlFreight, q.DhlFreight, K.PostNl, q.POSTNL, K.Bpost, q.BPOST, K.CheapCargo, q.CHEAP_CARGO, K.Dpd, q.DPD, K.Instabox, q.INSTABOX, K.Dhl, q.DHL, K.Bol, q.BOL, K.Ups, q.UPS, K.DhlForYou, q.DHL_FOR_YOU, K.DhlParcelConnect, q.DHL_PARCEL_CONNECT, K.DhlEuroPlus, q.DHL_EUROPLUS, K.UpsStandard, q.UPS_STANDARD, K.UpsExpressSaver, q.UPS_EXPRESS_SAVER, K.Gls, q.GLS, K.Brt, q.BRT, K.Trunkrs, q.TRUNKRS, K.InPost, q.INPOST, K.PosteItaliane, q.POSTE_ITALIANE, K.Spring, q.SPRING, K.ViaTim, q.VIA_TIM, K.DhlFreight, q.DHL_FREIGHT, q.POSTNL, K.PostNl, q.BPOST, K.Bpost, q.CHEAP_CARGO, K.CheapCargo, q.DPD, K.Dpd, q.INSTABOX, K.Instabox, q.DHL, K.Dhl, q.BOL, K.Bol, q.UPS, K.Ups, q.DHL_FOR_YOU, K.DhlForYou, q.DHL_PARCEL_CONNECT, K.DhlParcelConnect, q.DHL_EUROPLUS, K.DhlEuroPlus, q.UPS_STANDARD, K.UpsStandard, q.UPS_EXPRESS_SAVER, K.UpsExpressSaver, q.GLS, K.Gls, q.BRT, K.Brt, q.TRUNKRS, K.Trunkrs, q.INPOST, K.InPost, q.POSTE_ITALIANE, K.PosteItaliane, q.SPRING, K.Spring, q.VIA_TIM, K.ViaTim, q.DHL_FREIGHT, K.DhlFreight, q.PostNl, K.PostNl, q.POSTNL, K.PostNl, q.Bpost, K.Bpost, q.BPOST, K.Bpost, q.CheapCargo, K.CheapCargo, q.CHEAP_CARGO, K.CheapCargo, q.Dpd, K.Dpd, q.DPD, K.Dpd, q.Instabox, K.Instabox, q.Dhl, K.Dhl, q.BolCom, K.Bol, q.Bol, K.Bol, q.BOL, K.Bol, q.Ups, K.Ups, q.DhlForYou, K.DhlForYou, q.DHL_FOR_YOU, K.DhlForYou, q.DhlParcelConnect, K.DhlParcelConnect, q.DHL_PARCEL_CONNECT, K.DhlParcelConnect, q.DhlEuroPlus, K.DhlEuroPlus, q.DHL_EUROPLUS, K.DhlEuroPlus, q.UpsStandard, K.UpsStandard, q.UPS_STANDARD, K.UpsStandard, q.UpsExpressSaver, K.UpsExpressSaver, q.UPS_EXPRESS_SAVER, K.UpsExpressSaver, q.Gls, K.Gls, q.GLS, K.Gls, q.Brt, K.Brt, q.BRT, K.Brt, q.Trunkrs, K.Trunkrs, q.TRUNKRS, K.Trunkrs, q.InPost, K.InPost, q.INPOST, K.InPost, q.PosteItaliane, K.PosteItaliane, q.POSTE_ITALIANE, K.PosteItaliane, q.Spring, K.Spring, q.SPRING, K.Spring, q.ViaTim, K.ViaTim, q.VIA_TIM, K.ViaTim, q.DhlFreight, K.DhlFreight, q.DHL_FREIGHT, K.DhlFreight, K.PostNl, K.Bpost, K.CheapCargo, K.Dpd, K.Instabox, K.Dhl, K.Bol, K.Ups, K.DhlForYou, K.DhlParcelConnect, K.DhlEuroPlus, K.UpsStandard, K.UpsExpressSaver, K.Gls, K.Brt, K.Trunkrs, K.InPost, K.PosteItaliane, K.Spring, K.ViaTim, K.DhlFreight;
var J = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
J.Austria, J.Belgium, J.Bulgaria, J.Croatia, J.Cyprus, J.CzechRepublic, J.Denmark, J.Estonia, J.Finland, J.France, J.Germany, J.Greece, J.Hungary, J.Ireland, J.Italy, J.Latvia, J.Lithuania, J.Luxembourg, J.Malta, J.Netherlands, J.Poland, J.Portugal, J.Romania, J.Slovakia, J.Slovenia, J.Spain, J.Sweden, Object.values(J), J.Angola, J.AntiguaAndBarbuda, J.Aruba, J.Bahamas, J.Belize, J.Benin, J.Bermuda, J.BonaireSintEustatiusAndSaba, J.Botswana, J.BurkinaFaso, J.Burundi, J.Cameroon, J.CanaryIslands, J.CentralAfricanRepublic, J.Comoros, J.CongoBrazzaville, J.CongoKinshasa, J.CoteDIvoire, J.Curacao, J.Djibouti, J.Dominica, J.DutchAntilles, J.EquatorialGuinea, J.Eritrea, J.Fiji, J.Gabon, J.Gambia, J.Ghana, J.Grenada, J.Guyana, J.HongKong, J.Kiribati, J.KoreaPeoplesDemocraticRepublic, J.Macao, J.Malawi, J.Mali, J.Mauritania, J.Nauru, J.Qatar, J.Rwanda, J.SaintKittsAndNevis, J.SaoTomeAndPrincipe, J.Seychelles, J.SierraLeone, J.SintMaarten, J.Suriname, J.SyrianArabRepublic, J.TimorLeste, J.Togo, J.Tonga, J.Tuvalu, J.Uganda, J.UnitedArabEmirates, J.Vanuatu, J.Yemen, J.Zimbabwe, J.Austria, J.Belgium, J.Bulgaria, J.Croatia, J.CzechRepublic, J.Estonia, J.Finland, J.France, J.Germany, J.Greece, J.Hungary, J.Ireland, J.Italy, J.Latvia, J.Lithuania, J.Luxembourg, J.Malta, J.Netherlands, J.Portugal, J.Romania, J.Slovakia, J.Slovenia, J.Spain, J.UnitedKingdom, J.Denmark, J.Germany, J.Sweden;
var by = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, xy = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, Sy = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
by.EarlyMorning, xy.EarlyMorning, by.Morning, xy.Morning, by.Standard, xy.Standard, by.Evening, xy.Evening, by.Pickup, xy.Pickup, by.PickupExpress, xy.PickupExpress, by.SameDayDelivery, xy.SameDayDelivery, by.Express, xy.Express, xy.EarlyMorning, by.EarlyMorning, xy.Morning, by.Morning, xy.Standard, by.Standard, xy.Evening, by.Evening, xy.Pickup, by.Pickup, xy.PickupExpress, by.PickupExpress, xy.SameDayDelivery, by.SameDayDelivery, xy.Express, by.Express, by.EarlyMorning, Sy.EarlyMorning, by.Morning, Sy.Morning, by.Standard, Sy.Standard, by.Evening, Sy.Evening, by.Pickup, Sy.Pickup, by.PickupExpress, Sy.PickupExpress, by.SameDayDelivery, Sy.SameDayDelivery, by.Express, Sy.Express, Sy.EarlyMorning, xy.EarlyMorning, Sy.Morning, xy.Morning, Sy.Standard, xy.Standard, Sy.Evening, xy.Evening, Sy.Pickup, xy.Pickup, Sy.PickupExpress, xy.PickupExpress, Sy.SameDayDelivery, xy.SameDayDelivery, Sy.Express, xy.Express, by.EarlyMorning, by.Morning, by.Standard, by.Evening, by.Pickup, by.PickupExpress, by.SameDayDelivery, by.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var Cy = {
	Registered: 0,
	HandedToCarrier: 3,
	Sorting: 4,
	Distribution: 5,
	Delivered: 7
}, wy = {
	Instagram: "instagram",
	Twitter: "twitter",
	Linkedin: "linkedin",
	Facebook: "facebook",
	Youtube: "youtube",
	Tiktok: "tiktok"
}, Ty = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, Ey = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
Ey.Sunday, Ty.Sunday, Ey.Monday, Ty.Monday, Ey.Tuesday, Ty.Tuesday, Ey.Wednesday, Ty.Wednesday, Ey.Thursday, Ty.Thursday, Ey.Friday, Ty.Friday, Ey.Saturday, Ty.Saturday, Ty.Sunday, Ey.Sunday, Ty.Monday, Ey.Monday, Ty.Tuesday, Ey.Tuesday, Ty.Wednesday, Ey.Wednesday, Ty.Thursday, Ey.Thursday, Ty.Friday, Ey.Friday, Ty.Saturday, Ey.Saturday;
var Dy = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
Dy.Bytes, Dy.Kilobytes, Dy.Megabytes, Dy.Gigabytes, Dy.Terabytes;
var Oy = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, ky = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
Oy.Bol, ky.Bol, Oy.Exact, ky.Exact, Oy.Amazon, ky.Amazon, Oy.Wix, ky.Wix, Oy.ExactDe, ky.ExactDe, Oy.Etsy, ky.Etsy, ky.Bol, Oy.Bol, ky.Exact, Oy.Exact, ky.Amazon, Oy.Amazon, ky.Wix, Oy.Wix, ky.ExactDe, Oy.ExactDe, ky.Etsy, Oy.Etsy;
var Ay = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, jy = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
Ay.Unpaid, jy.Unpaid, Ay.Due, jy.Due, Ay.DuePrepayment, jy.DuePrepayment, Ay.Reminder1, jy.Reminder1, Ay.Reminder2, jy.Reminder2, Ay.Dun, jy.Dun, Ay.Collection, jy.Collection, Ay.Instalments, jy.Instalments, Ay.PaymentArrangement, jy.PaymentArrangement, Ay.Dispute, jy.Dispute, Ay.LegalProcedure, jy.LegalProcedure, Ay.Insolvency, jy.Insolvency, Ay.WriteOff, jy.WriteOff, Ay.Pending, jy.Pending, Ay.Cancelled, jy.Cancelled, Ay.Paid, jy.Paid, Ay.PaidOnline, jy.PaidOnline, Ay.PaidAutomatic, jy.PaidAutomatic, Ay.PaidCredit, jy.PaidCredit, Ay.PaidZeroItems, jy.PaidZeroItems, Ay.InvoiceWith0InvoiceItemsPaidZeroBalance, jy.PaidZeroBalance, Ay.Due, Ay.Reminder1, Ay.Reminder2, Ay.Dun, Ay.Collection, Ay.Instalments, Ay.PaymentArrangement, Ay.Dispute, Ay.Paid, Ay.PaidOnline, Ay.PaidAutomatic, Ay.PaidCredit, Ay.PaidZeroItems;
var My = {
	Info: "info",
	Success: "success",
	Warning: "warning",
	Error: "alert"
}, Ny = {
	Full: "full",
	Half: "half"
}, Py = {
	Asc: "ASC",
	Desc: "DESC"
}, Fy = {
	Gram: "g",
	Kilogram: "kg"
}, Iy = {
	[Fy.Gram]: 1,
	[Fy.Kilogram]: 1e3
}, Ly = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
Ly.Millimeter, Ly.Centimeter, Ly.Meter;
var Ry = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, zy = {
	Amazon: "AMAZON",
	Bol: "BOL",
	Etsy: "ETSY",
	Exact: "EXACT",
	Cscart: "CSCART",
	Lightspeed: "LIGHTSPEED",
	Magento: "MAGENTO",
	Presta: "PRESTA",
	Shopify: "SHOPIFY",
	Wix: "WIX",
	Woocommerce: "WOOCOMMERCE"
}, By = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
By.PendingConcept, By.PendingRegistered, By.EnRouteHandedToCarrier, By.EnRouteSorting, By.EnRouteDistribution, By.EnRouteCustoms, By.DeliveredReadyForPickup, By.DeliveredAtRecipient, By.DeliveredPackagePickedUp;
var Vy = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, Hy = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
Hy.Light, Vy.Light, Hy.Start, Vy.Start, Hy.Plus, Vy.Plus, Hy.Premium, Vy.Premium, Hy.Max, Vy.Max, Vy.Light, Hy.Light, Vy.Start, Hy.Start, Vy.Plus, Hy.Plus, Vy.Premium, Hy.Premium, Vy.Max, Hy.Max;
var Uy = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, Wy = {
	Start: Vy.Start,
	Plus: Vy.Plus,
	Premium: Vy.Premium,
	Max: Vy.Max
};
Uy.Start, Wy.Start, Uy.Plus, Wy.Plus, Uy.Premium, Wy.Premium, Uy.Max, Wy.Max, Wy.Start, Uy.Start, Wy.Plus, Uy.Plus, Wy.Premium, Uy.Premium, Wy.Max, Uy.Max;
var Gy = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, Ky = {
	Start: Vy.Start,
	Plus: Vy.Plus,
	Premium: Vy.Premium,
	Max: Vy.Max
};
Gy.Start, Ky.Start, Gy.Plus, Ky.Plus, Gy.Premium, Ky.Premium, Gy.Max, Ky.Max, Ky.Start, Gy.Start, Ky.Plus, Gy.Plus, Ky.Premium, Gy.Premium, Ky.Max, Gy.Max;
var qy = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, Jy = {
	Light: Vy.Light,
	Start: Vy.Start,
	Plus: Vy.Plus,
	Premium: Vy.Premium,
	Max: Vy.Max
};
qy.Light, Jy.Light, qy.Start, Jy.Start, qy.Plus, Jy.Plus, qy.Premium, Jy.Premium, qy.Max, Jy.Max, Jy.Light, qy.Light, Jy.Start, qy.Start, Jy.Plus, qy.Plus, Jy.Premium, qy.Premium, Jy.Max, qy.Max;
var Yy = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, Xy = {
	Start: Vy.Start,
	Plus: Vy.Plus,
	Premium: Vy.Premium,
	Max: Vy.Max
};
Yy.Start, Xy.Start, Yy.Plus, Xy.Plus, Yy.Premium, Xy.Premium, Yy.Max, Xy.Max, Xy.Start, Yy.Start, Xy.Plus, Yy.Plus, Xy.Premium, Yy.Premium, Xy.Max, Yy.Max;
var Zy = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, Qy = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, $y = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
Zy.MyParcel, Qy.MyParcel, Zy.Flespakket, Qy.Flespakket, Zy.SendMyParcel, Qy.SendMyParcel, Zy.MyParcelIt, Qy.MyParcelIt, Zy.DeliverDutch, Qy.DeliverDutch, Zy.PostNlPlugin, Qy.PostNlPlugin, Zy.MyParcel, $y.MyParcelNl, Zy.Flespakket, $y.MyParcelNl, Zy.SendMyParcel, $y.MyParcelBe, Zy.MyParcelIt, $y.MyParcelIt, Zy.DeliverDutch, $y.DeliverDutch, Zy.PostNlPlugin, $y.PostNlPlugin, $y.MyParcelNl, Zy.MyParcel, $y.MyParcelBe, Zy.SendMyParcel, $y.MyParcelIt, Zy.MyParcelIt, $y.MyParcelNl, Ry.HomeCountry, J.Netherlands, Ry.Eu, Ry.Row, J.Belgium, $y.MyParcelBe, Ry.HomeCountry, J.Belgium, J.Netherlands, Ry.Eu, Ry.Row, $y.MyParcelBe, Ry.HomeCountry, J.Belgium, Ry.Eu, Ry.Row, $y.MyParcelNl, Ry.HomeCountry, J.Netherlands, Ry.Eu, Ry.Row, $y.MyParcelNl, Ry.HomeCountry, J.Netherlands, J.Belgium, J.Luxembourg, K.Bpost, K.PostNl, K.DhlForYou, K.DhlParcelConnect, K.DhlEuroPlus, K.Ups, K.UpsStandard, K.UpsExpressSaver;
var eb = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, tb = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
eb.Package, tb.Package, eb.Mailbox, tb.Mailbox, eb.Letter, tb.Letter, eb.DigitalStamp, tb.DigitalStamp, eb.Pallet, tb.Pallet, eb.PackageSmall, tb.PackageSmall, eb.Envelope, tb.Envelope, tb.Package, eb.Package, tb.Mailbox, eb.Mailbox, tb.Letter, eb.Letter, tb.DigitalStamp, eb.DigitalStamp, tb.Pallet, eb.Pallet, tb.PackageSmall, eb.PackageSmall, tb.Envelope, eb.Envelope;
var nb = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
eb.Package, nb.PACKAGE, eb.Mailbox, nb.MAILBOX, eb.Letter, nb.UNFRANKED, eb.DigitalStamp, nb.DIGITAL_STAMP, eb.Pallet, nb.PALLET, eb.PackageSmall, nb.SMALL_PACKAGE, eb.Envelope, nb.ENVELOPE, nb.PACKAGE, eb.Package, nb.MAILBOX, eb.Mailbox, nb.UNFRANKED, eb.Letter, nb.DIGITAL_STAMP, eb.DigitalStamp, nb.PALLET, eb.Pallet, nb.SMALL_PACKAGE, eb.PackageSmall, nb.ENVELOPE, eb.Envelope, eb.Package, eb.Mailbox, eb.Letter, eb.DigitalStamp, eb.Pallet, eb.PackageSmall, eb.Envelope;
var rb = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
rb.PendingConcept, rb.PendingRegistered, rb.EnrouteHandedToCarrier, rb.EnrouteSorting, rb.EnrouteDistribution, rb.DeliveredAtCustoms, rb.DeliveredAtRecipient, rb.DeliveredPackagePickedUp, rb.DeliveredReturnShipmentPackagePickedUp, rb.DeliveredAtAgreedLocation, rb.PrintedLetter, rb.PrintedDigitalStamp, rb.InactiveConcept, rb.InactiveRegistered, rb.InactiveEnrouteHandedToCarrier, rb.InactiveEnrouteSorting, rb.InactiveEnrouteDistribution, rb.InactiveEnrouteCustoms, rb.InactiveDeliveredAtRecipient, rb.InactiveDeliveredReadyForPickup, rb.InactiveDeliveredPackagePickedUp;
//#endregion
//#region src/components/CarrierLogo/CarrierLogo.vue
var ib = /* @__PURE__ */ f({
	__name: "CarrierLogo",
	props: {
		carrier: {},
		withTooltip: { type: Boolean },
		tooltip: {}
	},
	setup(e) {
		let t = e, n = ie(), r = {
			[K.PostNl]: W_,
			[K.Dhl]: A_,
			[K.DhlForYou]: A_,
			[K.DhlParcelConnect]: A_,
			[K.DhlEuroPlus]: A_,
			[K.DhlFreight]: A_,
			[K.Ups]: R_,
			[K.UpsStandard]: R_,
			[K.UpsExpressSaver]: R_,
			[K.CheapCargo]: A_,
			[K.Dpd]: x_,
			[K.Bpost]: F_,
			[K.Bol]: q_,
			[K.Instabox]: o_,
			[K.Gls]: w_,
			[K.Brt]: V_,
			[K.Trunkrs]: D_,
			[K.InPost]: v_,
			[K.PosteItaliane]: l_,
			[K.ViaTim]: f_,
			[K.Spring]: h_
		}, a = () => {
			let e = typeof t.carrier == "number" ? t.carrier : be(t.carrier);
			return e != null && r[e] || null;
		};
		return z(() => [t.carrier], () => {
			n.value = a();
		}, { immediate: !0 }), (t, r) => V((A(), i(L(Jp), { size: L(Kp).Medium }, {
			default: B(() => [(A(), i(re(n.value)))]),
			_: 1
		}, 8, ["size"])), [[L(bp), e.withTooltip && e.tooltip ? e.tooltip : void 0]]);
	}
}), ab = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "ClipboardText",
	props: {
		ariaLabel: { default: void 0 },
		copyContent: {},
		copyConfirmation: {}
	},
	setup(e) {
		let t = e, { copy: n, copied: r } = Oe(), a = async () => {
			r.value || await n(t.copyContent);
		};
		return (t, n) => (A(), i(L(Dp), x(t.$attrs, {
			"aria-label": e.ariaLabel,
			class: "flex gap-x-1 items-center relative text-center text-primary",
			variant: L(Sp).None,
			onClick: a,
			onKeydown: H(a, ["enter"])
		}), {
			default: B(() => [
				V(u(L(Ip), {
					class: "-top-8 -translate-x-1/2 absolute left-1/2 text-black text-sm transition-all w-fit whitespace-nowrap",
					role: "alert"
				}, {
					default: B(() => [l(I(e.copyConfirmation), 1)]),
					_: 1
				}, 512), [[he, L(r)]]),
				F(t.$slots, "default"),
				u(L(ap), null, {
					default: B(() => [u(L(nr))]),
					_: 1
				})
			]),
			_: 3
		}, 16, ["aria-label", "variant"]));
	}
}), ob = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "CountBadge",
	props: { count: {} },
	setup(e) {
		return (t, n) => (A(), o("p", { class: C(L(_e)("bg-primary-10 font-bold px-2 py-1 rounded-full text-primary text-xs", t.$attrs.class)) }, I(e.count), 3));
	}
}), sb = { class: "relative" }, cb = ["id"], lb = 16, ub = 8, db = /* @__PURE__ */ f({
	__name: "Dropdown",
	props: {
		label: {},
		value: {},
		hasDeleteButton: { type: Boolean },
		deleteButtonText: {}
	},
	emits: ["reset"],
	setup(e, { emit: t }) {
		let n = e, c = t, [d, f] = Fe(), p = le(), m = r(() => {
			let e = typeof n.value == "string" && n.value === "", t = Array.isArray(n.value) && n.value.length === 0, r = n.value === null, i = n.value === void 0;
			return e || t || r || i;
		}), h = r(() => m.value ? n.label : Array.isArray(n.value) ? `${n.label}: ` : `${n.label}: ${n.value}`), g = () => {
			c("reset");
		}, _ = de("reference"), v = de("floating"), { floatingStyles: y } = tt(_, v, {
			placement: "bottom-start",
			whileElementsMounted: Xe,
			middleware: [
				Qe(ub),
				Ze(),
				$e(),
				et({ padding: lb })
			]
		});
		return (t, r) => V((A(), o("div", sb, [u(Dp, {
			ref: "reference",
			"aria-controls": `listbox-${L(p)}`,
			"aria-haspopup": "listbox",
			class: "flex gap-2 justify-center",
			variant: m.value ? "gray" : "primary-outline",
			onClick: r[0] ||= () => L(f)()
		}, {
			default: B(() => [
				l(I(h.value) + " ", 1),
				Array.isArray(n.value) && !m.value ? (A(), i(ob, {
					key: 0,
					count: n.value.length
				}, null, 8, ["count"])) : a("", !0),
				u(op, { "is-open": L(d) }, null, 8, ["is-open"])
			]),
			_: 1
		}, 8, ["aria-controls", "variant"]), V(s("div", {
			id: `listbox-${L(p)}`,
			ref: "floating",
			class: "z-10 absolute bg-white min-w-max p-4 rounded-regular top-[calc(100%+8px)] shadow-[0px_4px_12px_rgba(0,0,0,0.15)] flex flex-col",
			style: T([L(y)]),
			tabindex: "-1"
		}, [F(t.$slots, "default"), e.hasDeleteButton ? (A(), i(Dp, {
			key: 0,
			class: "bg-transparent! border-none! mt-2 self-end",
			disabled: m.value,
			size: "none",
			variant: "danger-basic",
			onClick: g
		}, {
			default: B(() => [l(I(e.deleteButtonText), 1)]),
			_: 1
		}, 8, ["disabled"])) : a("", !0)], 12, cb), [[he, L(d)]])])), [[L(Ee), () => L(f)(!1)]]);
	}
}), fb = /* @__PURE__ */ f({
	__name: "EcommercePlatformLogo",
	props: {
		name: { default: void 0 },
		size: { default: Kp.Large }
	},
	setup(e) {
		let t = e, n = {
			[zy.Amazon]: {
				[Kp.Large]: y(Il),
				[Kp.Medium]: y(Il)
			},
			[zy.Bol]: {
				[Kp.Large]: y(Bg),
				[Kp.Medium]: y(Kg)
			},
			[zy.Etsy]: {
				[Kp.Large]: y(Nl),
				[Kp.Medium]: y(Nl)
			},
			[zy.Exact]: {
				[Kp.Large]: y(Tl),
				[Kp.Medium]: y(Tl)
			},
			[zy.Woocommerce]: {
				[Kp.Large]: y(_g),
				[Kp.Medium]: y(Qg)
			},
			[zy.Shopify]: {
				[Kp.Large]: y(Ug),
				[Kp.Medium]: y(Ag)
			},
			[zy.Lightspeed]: {
				[Kp.Large]: y(xg),
				[Kp.Medium]: y(Lg)
			},
			[zy.Wix]: {
				[Kp.Large]: y(kl),
				[Kp.Medium]: y(kl)
			},
			[zy.Presta]: {
				[Kp.Large]: y(Yg),
				[Kp.Medium]: y(Dg)
			},
			[zy.Cscart]: {
				[Kp.Large]: y(wg),
				[Kp.Medium]: y(Ng)
			}
		}, a = r(() => {
			switch (t.name) {
				case zy.Amazon: return "amazon";
				case zy.Bol: return "bol";
				case zy.Etsy: return "etsy";
				case zy.Exact: return "exact";
				case zy.Woocommerce: return "woocommerce";
				case zy.Shopify: return "shopify";
				case zy.Lightspeed: return "lightspeed";
				case zy.Wix: return "wix";
				case zy.Presta: return "presta";
				case zy.Cscart: return "cscart";
				default: return "default";
			}
		}), o = r(() => t.name && n[t.name]?.[t.size] || mg);
		return (t, n) => (A(), i(L(Jp), {
			class: C({ "text-gray-800": a.value === "default" }),
			"data-test": `logo-${a.value}`,
			size: e.size
		}, {
			default: B(() => [(A(), i(re(o.value)))]),
			_: 1
		}, 8, [
			"class",
			"data-test",
			"size"
		]));
	}
}), pb = {
	Self: "_self",
	Blank: "_blank",
	Parent: "_parent",
	Top: "_top"
}, mb = {
	Default: "default",
	Social: "social",
	Button: "button",
	FooterLegal: "footer legal",
	Outline: "outline",
	Clean: "clean"
}, hb = [
	"duration-300",
	"ease-in-out",
	"transition-colors"
], gb = {
	[mb.Default]: ["text-secondary", "hover:text-secondary-dark"],
	[mb.Social]: [
		"bg-primary",
		"hover:bg-primary-200",
		"text-onPrimary",
		"flex",
		"h-8",
		"items-center",
		"justify-center",
		"rounded-full",
		"w-8"
	],
	[mb.Button]: [
		"bg-primary",
		"hover:bg-primary-200",
		"rounded-xl",
		"px-4",
		"py-2",
		"text-white"
	],
	[mb.FooterLegal]: [
		"opacity-40",
		"text-sm",
		"hover:underline",
		"whitespace-nowrap",
		"font-extralight"
	],
	[mb.Outline]: [
		"text-secondary",
		"border",
		"py-2",
		"px-3",
		"rounded-[20px]",
		"border-secondary",
		"hover:text-white",
		"hover:border-secondary-dark",
		"hover:bg-secondary"
	],
	[mb.Clean]: []
}, _b = [
	"data-test",
	"href",
	"rel",
	"target",
	"title"
], vb = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "ExternalLink",
	props: {
		href: {},
		target: {},
		title: {},
		variant: {}
	},
	setup(e) {
		let t = e, n = se(), i = r(() => t.target === pb.Blank), a = r(() => {
			let e = t.variant ?? mb.Default;
			return [...hb, ...gb[e]].join(" ");
		}), s = r(() => _e(a.value, n.class));
		return (t, r) => (A(), o("a", {
			class: C(s.value),
			"data-test": L(n)["data-test"],
			href: e.href,
			rel: i.value ? "noopener noreferrer" : void 0,
			role: "link",
			target: e.target ?? L(pb).Self,
			title: e.title
		}, [F(t.$slots, "default")], 10, _b));
	}
}), yb = /* @__PURE__ */ f({
	__name: "Paragraph",
	props: { size: { default: "base" } },
	setup(e) {
		return (t, n) => (A(), o("p", { class: C(["leading-normal", {
			"text-xs": e.size === "extra-small",
			"text-sm": e.size === "small",
			"text-base": e.size === "base",
			"text-lg": e.size === "large",
			"text-[34px] font-bold": e.size === "extra-large"
		}]) }, [F(t.$slots, "default")], 2));
	}
}), bb = { class: "bg-gray-100 border-b border-grey-400 flex flex-row gap-x-4 items-center justify-between p-4" }, xb = ["title"], Sb = { class: "flex flex-row gap-x-2 items-center shrink-0" }, Cb = { class: "text-black/60 text-sm uppercase" }, wb = /* @__PURE__ */ f({
	__name: "FileBar",
	props: {
		file: {},
		deleteTitle: {},
		title: { default: void 0 }
	},
	emits: ["remove"],
	setup(e, { emit: t }) {
		let n = e, c = t, d = r(() => ye.fileSize.toBytes(n.file.size));
		return (t, n) => (A(), o("div", bb, [s("div", null, [e.title ? (A(), i(yb, {
			key: 0,
			class: "pb-1 text-black"
		}, {
			default: B(() => [l(I(e.title), 1)]),
			_: 1
		})) : a("", !0), s("p", {
			class: "first-letter:uppercase line-clamp-1 text-black text-sm",
			title: e.file.name
		}, I(e.file.name), 9, xb)]), s("div", Sb, [s("span", Cb, I(d.value), 1), u(L(ap), {
			"aria-label": e.deleteTitle,
			class: "cursor-pointer text-red",
			height: "24",
			title: e.deleteTitle,
			viewbox: "0 0 24 24",
			width: "24",
			onClick: n[0] ||= (e) => c("remove")
		}, {
			default: B(() => [u(L(ks))]),
			_: 1
		}, 8, ["aria-label", "title"])])]));
	}
}), Tb = {
	Secondary: "secondary",
	Gray: "gray",
	Custom: "custom"
}, Eb = (e) => ({
	[Tb.Secondary]: { base: "bg-secondary-10 border-secondary max-w-md rounded-xl" },
	[Tb.Gray]: { base: "bg-gray-100 border-gray-400 w-full" },
	[Tb.Custom]: { base: "" }
})[e].base, Db = {
	key: 1,
	class: "font-bold leading-snug"
}, Ob = {
	key: 2,
	class: "text-black-light"
}, kb = { class: "flex flex-wrap gap-2 justify-center" }, Ab = {
	key: 3,
	class: "text-black-light text-sm"
}, jb = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "FileUpload",
	props: {
		variant: { default: Tb.Secondary },
		title: { default: void 0 },
		hasDownload: { type: Boolean },
		orText: { default: void 0 },
		chooseFileText: { default: void 0 },
		downloadExampleText: { default: void 0 },
		helperText: { default: void 0 }
	},
	emits: ["click", "download"],
	setup(e) {
		let t = e, { class: n, ...c } = se(), u = r(() => {
			let e = Eb(t.variant);
			return _e("border border-dashed flex flex-col gap-y-2 items-center p-8 text-center", e, n);
		});
		return (t, n) => (A(), o("div", x({ class: u.value }, c), [
			e.variant === L(Tb).Custom ? a("", !0) : (A(), i(L(ap), {
				key: 0,
				class: C({
					"text-secondary": e.variant === L(Tb).Secondary,
					"rotate-180 text-primary": e.variant === L(Tb).Gray
				}),
				size: L(np).Large
			}, {
				default: B(() => [e.variant === L(Tb).Secondary ? (A(), i(L(Eo), { key: 0 })) : a("", !0), e.variant === L(Tb).Gray ? (A(), i(L(Ro), { key: 1 })) : a("", !0)]),
				_: 1
			}, 8, ["class", "size"])),
			e.title ? (A(), o("h3", Db, I(e.title), 1)) : a("", !0),
			e.orText ? (A(), o("span", Ob, I(e.orText), 1)) : a("", !0),
			s("div", kb, [e.chooseFileText ? (A(), i(Dp, {
				key: 0,
				variant: e.variant === L(Tb).Secondary ? "secondary-outline" : "secondary",
				onClick: n[0] ||= (e) => t.$emit("click")
			}, {
				default: B(() => [l(I(e.chooseFileText), 1)]),
				_: 1
			}, 8, ["variant"])) : a("", !0), e.hasDownload && e.downloadExampleText ? (A(), i(Dp, {
				key: 1,
				variant: "secondary-outline",
				onClick: n[1] ||= (e) => t.$emit("download")
			}, {
				default: B(() => [l(I(e.downloadExampleText), 1)]),
				_: 1
			})) : a("", !0)]),
			e.helperText ? (A(), o("span", Ab, I(e.helperText), 1)) : a("", !0)
		], 16));
	}
}), Mb = { class: "flex flex-row gap-x-4 items-center justify-between" }, Nb = ["title"], Pb = { class: "flex flex-row gap-x-2 items-center shrink-0" }, Fb = { class: "text-black/60 text-sm uppercase" }, Ib = /* @__PURE__ */ f({
	__name: "FilledFileCard",
	props: {
		file: {},
		deleteTitle: {}
	},
	emits: ["remove"],
	setup(e, { emit: t }) {
		let n = e, a = t, o = r(() => ye.fileSize.toBytes(n.file.size));
		return (t, n) => (A(), i(L(oy), {
			class: "p-3",
			"data-test": "filled-file-card"
		}, {
			default: B(() => [s("div", Mb, [s("p", {
				class: "first-letter:uppercase line-clamp-1 text-black text-sm",
				title: e.file.name
			}, I(e.file.name), 9, Nb), s("div", Pb, [s("span", Fb, I(o.value), 1), u(L(ap), {
				"aria-label": e.deleteTitle,
				class: "cursor-pointer text-red",
				height: "24",
				title: e.deleteTitle,
				viewbox: "0 0 24 24",
				width: "24",
				onClick: n[0] ||= (t) => a("remove", e.file)
			}, {
				default: B(() => [u(L(ks))]),
				_: 1
			}, 8, ["aria-label", "title"])])])]),
			_: 1
		}));
	}
}), Lb = /* @__PURE__ */ f({
	__name: "Flag",
	props: { country: {} },
	setup(e) {
		let t = e, n = ie(), r = {
			nl: zi,
			nl_nl: zi,
			"nl-nl": zi,
			be: Hi,
			nl_be: Hi,
			"nl-be": Hi,
			fr: Ii,
			fr_fr: Ii,
			"fr-fr": Ii,
			fr_be: Hi,
			"fr-be": Hi,
			de: Zi,
			de_de: Zi,
			"de-de": Zi,
			it: Ji,
			it_it: Ji,
			"it-it": Ji,
			en: Ni,
			gb: Ni,
			en_gb: Ni,
			"en-gb": Ni,
			es: Gi,
			es_es: Gi,
			"es-es": Gi
		}, o = () => {
			let e = t.country.toLowerCase();
			return r[e];
		};
		return z(() => t.country, () => {
			n.value = o();
		}, { immediate: !0 }), (e, t) => n.value ? (A(), i(ap, {
			key: 0,
			size: L(np).Medium
		}, {
			default: B(() => [(A(), i(re(n.value)))]),
			_: 1
		}, 8, ["size"])) : a("", !0);
	}
}), Rb = [
	"aria-checked",
	"aria-disabled",
	"aria-labelledby",
	"onKeydown"
], zb = { class: "flex flex-row items-center min-h-[24px]" }, Bb = /* @__PURE__ */ f({
	__name: "Checkbox",
	props: /*@__PURE__*/ b({
		name: {},
		isVisible: { type: Boolean },
		isDirty: { type: Boolean },
		isDisabled: { type: Boolean },
		isOptional: { type: Boolean },
		isReadOnly: { type: Boolean },
		isSuspended: { type: Boolean },
		isTouched: { type: Boolean },
		isValid: {
			type: Boolean,
			default: !0
		},
		disabled: { type: Boolean },
		labelledBy: { default: void 0 },
		disabledTitle: { default: void 0 }
	}, {
		modelValue: {
			type: Boolean,
			required: !1,
			default: void 0
		},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = e, n = R(e, "modelValue"), r = () => {
			t.disabled || (n.value = !n.value);
		}, c = (e) => {
			e.currentTarget.click();
		};
		return (t, l) => (A(), o("div", {
			"aria-checked": n.value,
			"aria-disabled": e.disabled ? !0 : void 0,
			"aria-labelledby": e.labelledBy,
			class: C([{
				"cursor-pointer": !e.disabled,
				"cursor-not-allowed": e.disabled
			}, "group focus-visible:outline-none"]),
			role: "checkbox",
			tabindex: "0",
			onClick: r,
			onKeydown: H(U(c, ["exact", "prevent"]), ["space"]),
			onMousedown: l[0] ||= U(() => {}, ["shift", "prevent"])
		}, [s("div", zb, [V((A(), o("div", { class: C(["aspect-square border h-4 inline-block mr-2 relative rounded-sm group-focus-visible:ring-2 group-focus-visible:ring-blue-600 group-focus-visible:ring-offset-1", {
			"bg-gray-300 border-gray-500": e.disabled,
			"bg-secondary-100 border-secondary-100": n.value && !e.disabled,
			"bg-white": !n.value && !e.disabled,
			"border-red": !e.isValid,
			"border-gray": e.isValid
		}]) }, [n.value ? (A(), i(ap, {
			key: 0,
			class: C(["absolute left-[2px] top-[3px]", {
				"text-gray-800": e.disabled,
				"text-white": !e.disabled
			}]),
			height: "8",
			viewbox: "0 0 10 8",
			width: "10"
		}, {
			default: B(() => [u(yn)]),
			_: 1
		}, 8, ["class"])) : a("", !0)], 2)), [[
			L(bp),
			e.disabled ? e.disabledTitle : void 0,
			void 0,
			{ right: !0 }
		]]), F(t.$slots, "default")])], 42, Rb));
	}
}), Vb = {
	Vertical: "vertical",
	Horizontal: "horizontal"
}, Hb = {
	class: "relative",
	role: "tooltip"
}, Ub = 16, Wb = 352, Gb = /* @__PURE__ */ f({
	__name: "PopOver",
	props: { alignment: { default: "right" } },
	setup(e) {
		let t = e, n = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), [r, i] = Fe(), a = M(null), c = M(null), l = null, d = () => {
			n || (l && clearTimeout(l), i(!0));
		}, f = () => {
			n || (l = setTimeout(() => {
				r.value && i(!1);
			}, 200));
		};
		O(() => {
			document.body.addEventListener("click", p);
		}), E(() => {
			document.body.removeEventListener("click", p);
		});
		let p = (e) => {
			n && (e.target === a.value || e.target === c.value || a.value?.contains(e.target) || c.value?.contains(e.target) || 
			/* c8 ignore end */
			i(!1));
		}, m = () => {
			if (n) return r.value ? i(!1) : i(!0);
		}, { floatingStyles: h } = tt(a, c, {
			placement: t.alignment,
			whileElementsMounted: Xe,
			middleware: [
				Qe(8),
				Ze(),
				$e(),
				et({
					padding: Ub,
					apply({ availableWidth: e, availableHeight: t, elements: n }) {
						if (Number.isNaN(e) || Number.isNaN(t) || e < 0 || t < 0) return;
						let r = e > Wb ? Wb : e;
						Object.assign(n.floating.style, {
							maxWidth: `${r}px`,
							maxHeight: `${t}px`
						});
					}
				})
			]
		});
		return (e, t) => (A(), o("div", Hb, [s("div", {
			ref_key: "reference",
			ref: a,
			class: "flex items-center w-max",
			"data-test": "popover-reference",
			onClick: m,
			onMouseenter: d,
			onMouseleave: f
		}, [F(e.$slots, "icon", {}, () => [u(L(Jp), { class: "text-secondary" }, {
			default: B(() => [u(L(om))]),
			_: 1
		})])], 544), s("div", {
			ref_key: "floating",
			ref: c,
			class: C(["absolute bg-white border border-secondary p-5 rounded-regular shadow-md w-max z-10 text-sm", { "invisible pointer-events-none": !L(r) }]),
			style: T([L(h)]),
			onMouseenter: d,
			onMouseleave: f
		}, [F(e.$slots, "default")], 38)]));
	}
}), Kb = { key: 0 }, qb = { class: "font-medium" }, Jb = { class: "list-disc ml-6" }, Yb = /* @__PURE__ */ f({
	__name: "NestedTranslation",
	props: { translation: {} },
	setup(t) {
		let { t: n, tm: r, te: c, locale: d } = Re(), f = t, p = M(), m = (e) => typeof e == "object" && !!e && "linkPath" in e;
		O(() => {
			p.value = h(r(f.translation.keypath));
		}), z(d, () => {
			p.value = h(r(f.translation.keypath));
		});
		let h = (e) => {
			if (!e) return;
			if (typeof e == "string") return n(f.translation.keypath);
			if (!Object.keys(e).length) return f.translation.keypath;
			let t = Object.keys(e);
			if (t.includes("description") && c(`${f.translation.keypath}.link.label`) && (f.translation.link !== void 0 || c(`${f.translation.keypath}.link.url`))) return { linkPath: `${f.translation.keypath}` };
			if (t.includes("list")) {
				let t = n(`${f.translation.keypath}.title`), r = e.list;
				return { [t]: Object.keys(r).map((e) => n(`${f.translation.keypath}.list.${e}`)) };
			}
		};
		return (r, c) => p.value ? (A(), o(e, { key: 0 }, [typeof p.value == "string" ? (A(), o("p", Kb, I(p.value), 1)) : m(p.value) ? (A(), i(L(Le), {
			key: 1,
			keypath: p.value.linkPath + ".description",
			tag: "p"
		}, {
			link: B(() => [u(L(vb), {
				href: t.translation.link ?? L(n)(p.value.linkPath + ".link.url"),
				target: "_blank"
			}, {
				default: B(() => [l(I(L(n)(p.value.linkPath + ".link.label")), 1)]),
				_: 1
			}, 8, ["href"])]),
			_: 1
		}, 8, ["keypath"])) : (A(!0), o(e, { key: 2 }, P(p.value, (t, n) => (A(), o("div", { key: n }, [s("p", qb, I(n), 1), s("ul", Jb, [(A(!0), o(e, null, P(t, (e, t) => (A(), o("li", {
			key: t,
			class: "ml-2"
		}, I(e), 1))), 128))])]))), 128))], 64)) : a("", !0);
	}
}), Xb = { class: "w-full" }, Zb = ["id"], Qb = ["aria-labelledby"], $b = {
	key: 0,
	class: "flex items-center"
}, ex = /* @__PURE__ */ f({
	__name: "CheckboxGroup",
	props: /*@__PURE__*/ b({
		name: {},
		options: {},
		disabled: { type: Boolean },
		isValid: {
			type: Boolean,
			default: !0
		},
		label: { default: void 0 },
		labelledBy: { default: void 0 },
		alignment: { default: Vb.Vertical }
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(t) {
		let { watchResize: n } = nt(), i = t, c = r(() => m.value === Vb.Horizontal), d = r(() => m.value === Vb.Vertical), f = R(t, "modelValue"), p = de("checkboxGroup"), m = M(i.alignment), h = (e) => f.value?.includes(e), g = (e) => i.disabled || e.disabled, _ = (e, t) => {
			let n = Array.isArray(f.value) ? f.value : [], r = t ? [...n, e] : n.filter((t) => t !== e);
			f.value = r;
		}, v = async () => {
			if (i.alignment === Vb.Vertical) {
				m.value = Vb.Vertical;
				return;
			}
			let e = p.value;
			if (e) {
				if (y(e)) {
					m.value = Vb.Vertical;
					return;
				}
				m.value = Vb.Horizontal, await S(), y(e) && (m.value = Vb.Vertical);
			}
		}, y = (e) => e.scrollWidth > e.clientWidth;
		/* c8 ignore stop */
		return z([
			() => i.alignment,
			() => i.options,
			() => f.value
		], () => {
			v();
		}, { deep: !0 }), O(() => {
			n(() => {
				v();
			});
		}), (n, r) => (A(), o("div", Xb, [t.label && !t.labelledBy ? (A(), o("label", {
			key: 0,
			id: `checkbox-group-${t.name}-aria-label`
		}, I(t.label), 9, Zb)) : a("", !0), s("ul", {
			ref_key: "checkboxGroup",
			ref: p,
			"aria-labelledby": t.labelledBy ? t.labelledBy : `checkbox-group-${t.name}-aria-label`,
			class: C(["flex border rounded-[10px] w-full", {
				"flex-row": c.value,
				"flex-col": d.value
			}]),
			role: "group"
		}, [(A(!0), o(e, null, P(t.options, (e) => (A(), o("li", {
			key: e.value,
			class: C(["flex gap-2 px-4 py-2 last:border-none", {
				"border-r flex-1 whitespace-nowrap": c.value,
				"border-b": d.value
			}])
		}, [
			u(Bb, {
				disabled: g(e),
				"is-valid": t.isValid,
				"model-value": h(e.value),
				"onUpdate:modelValue": (t) => _(e.value, t)
			}, {
				default: B(() => [
					e?.icon ? F(n.$slots, "icon", { option: e }, void 0, void 0, 0) : a("", !0),
					l(" " + I(e.label) + " ", 1),
					F(n.$slots, "default", { option: e })
				]),
				_: 2
			}, 1032, [
				"disabled",
				"is-valid",
				"model-value",
				"onUpdate:modelValue"
			]),
			e.note ? (A(), o("div", $b, [u(L(Gb), null, {
				default: B(() => [u(L(Yb), { translation: e.note }, null, 8, ["translation"])]),
				_: 2
			}, 1024)])) : a("", !0),
			F(n.$slots, "right", { option: e })
		], 2))), 128))], 10, Qb)]));
	}
}), tx = ["id", "placeholder"], nx = { class: "border-l flex items-center px-4" }, rx = ["id"], ix = /*#__PURE__*/ W(/* @__PURE__ */ f({
	__name: "ColorInput",
	props: /*@__PURE__*/ b({
		name: {},
		placeholder: { default: "0f5c47" }
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = (e) => {
			let t = e;
			return t && !t.startsWith("#") && (t = `#${t}`), t.split("").splice(0, 7).join("");
		}, n = R(e, "modelValue"), i = r({
			get() {
				return t(n.value);
			},
			set(e) {
				n.value = t(e);
			}
		}), a = r({
			get() {
				return n.value === "" ? "#0f5c47" : t(n.value);
			},
			set(e) {
				n.value = t(e);
			}
		}), [c, l] = Fe(!1);
		return (t, n) => (A(), o("div", { class: C(["border flex outline-hidden overflow-hidden ring-blue-600 rounded-full w-full", { "ring-2": L(c) }]) }, [V(s("input", {
			id: e.name,
			"onUpdate:modelValue": n[0] ||= (e) => i.value = e,
			class: "flex-1 outline-hidden px-3 py-2 rounded-l-full",
			placeholder: e.placeholder,
			type: "text",
			onBlur: n[1] ||= () => L(l)(!1),
			onFocus: n[2] ||= () => L(l)(!0)
		}, null, 40, tx), [[me, i.value]]), s("div", nx, [V(s("input", {
			id: `${e.name}-swatch`,
			"onUpdate:modelValue": n[3] ||= (e) => a.value = e,
			class: "appearance-none border-none h-6 p-0 rounded-full w-6",
			"data-test": "color-input-swatch",
			type: "color",
			onBlur: n[4] ||= () => L(l)(!1),
			onFocus: n[5] ||= () => L(l)(!0)
		}, null, 40, rx), [[me, a.value]])])], 2));
	}
}), [["__scopeId", "data-v-4a121730"]]), ax = { class: "flex items-center px-3 py-[.375rem]" }, ox = [
	"id",
	"name",
	"value"
], sx = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "CurrencyInput",
	props: {
		modelValue: {},
		name: {},
		isValid: {
			type: Boolean,
			default: !0
		},
		wrapperClass: { default: void 0 },
		emptyValue: { default: void 0 },
		currency: { default: void 0 }
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let { currency: { format: n, toNumberFromString: i } } = ye, a = e, c = /^\d{1,3}(?:\.\d{3})+$/, l = (e) => c.test(e) ? e.replace(/\./g, "") : e, d = t, f = M(!1), p = M(a.modelValue), m = M(), h = (e) => {
			m.value = e, d("update:modelValue", e);
		}, g = (e) => i(l(e?.toString().trim() ?? "")), _ = (e, t = !0) => {
			let r = g(e);
			return Number.isNaN(r) ? "" : n(r, {
				currencyDisplay: "code",
				currency: a.currency,
				useGrouping: t
			}).slice(4);
		}, v = (e) => {
			let t = e.target.value;
			if (p.value = t, f.value = !0, !t && a.emptyValue === void 0) {
				h(void 0);
				return;
			}
			t ||= a.emptyValue, t = l(t), !t.includes(",") && !t.includes(".") && (t += ".00");
			let n = a.currency ? _(t) : g(t);
			n !== m.value && (Number.isNaN(n) || h(n));
		}, y = () => {
			p.value = _(a.modelValue, !1), f.value = !0;
		}, b = () => {
			f.value = !1;
		}, S = r(() => f.value ? p.value : _(a.modelValue));
		return (t, n) => (A(), o("div", { class: C(["border flex outline-hidden overflow-hidden rounded-xl", [{
			"border-red": !e.isValid,
			"bg-gray-200 text-gray-800": t.$attrs.disabled
		}, e.wrapperClass]]) }, [s("span", ax, [u(L(ap), { class: "text-secondary" }, {
			default: B(() => [u(L(dd))]),
			_: 1
		})]), s("input", x(t.$attrs, {
			id: e.name,
			class: "outline-hidden placeholder-gray-800 py-[.375rem] w-full",
			name: e.name,
			type: "text",
			value: S.value,
			onBlur: b,
			onFocus: y,
			onInput: v
		}), null, 16, ox)], 2));
	}
}), cx = {
	Top: "top",
	Right: "right",
	Left: "left"
}, lx = {
	Right: "right",
	Left: "left"
}, ux = /* @__PURE__ */ f({
	__name: "FormRow",
	props: {
		labelPosition: { default: cx.Right },
		inputPosition: { default: lx.Left },
		inline: { type: Boolean },
		hideLabel: { type: Boolean },
		preserveLabelGap: {
			type: Boolean,
			default: !0
		}
	},
	setup(e) {
		let t = e, n = r(() => t.labelPosition === cx.Right), i = r(() => t.labelPosition === cx.Left), c = r(() => t.labelPosition === cx.Top), l = r(() => t.inputPosition === lx.Right);
		return (t, r) => (A(), o("div", null, [s("div", { class: C(["flex flex-col gap-2 w-full", {
			"lg:flex-row! lg:gap-4": n.value || i.value,
			"flex-row!": e.inline
		}]) }, [s("div", { class: C(["flex flex-1 justify-between", {
			"lg:h-[42px] lg:min-h-max": n.value || i.value,
			"grow-2!": e.inline,
			"lg:max-w-1/3": (n.value || i.value) && !e.inline,
			"lg:text-right flex-row-reverse lg:justify-normal": n.value,
			"gap-2": t.$slots.note,
			invisible: e.hideLabel && e.preserveLabelGap,
			hidden: e.hideLabel && !e.preserveLabelGap
		}]) }, [s("div", { class: C(["self-center", { "order-2 w-full": n.value }]) }, [F(t.$slots, "label")], 2), s("div", { class: C(["flex items-center text-left", {
			"w-[40px]": t.$slots.note || n.value || i.value,
			"order-1": n.value,
			"justify-end lg:justify-start! grow-2!": e.inline
		}]) }, [F(t.$slots, "note")], 2)], 2), s("div", { class: C(["flex flex-1 items-center w-full", {
			"lg:max-w-2/3": (n.value || i.value) && (!e.hideLabel || e.preserveLabelGap),
			"lg:justify-end": l.value,
			"justify-end": l.value && e.inline
		}]) }, [F(t.$slots, "default")], 2)], 2), t.$slots.errors ? (A(), o("div", {
			key: 0,
			class: C(["flex gap-2 text-left w-full", { "lg:flex-row lg:gap-4": n.value || i.value }])
		}, [s("div", { class: C(["flex-1", {
			"lg:max-w-1/3": (n.value || i.value) && (!e.hideLabel || e.preserveLabelGap),
			"max-lg:hidden": n.value || i.value,
			invisible: e.hideLabel && e.preserveLabelGap,
			hidden: e.hideLabel && !e.preserveLabelGap || c.value
		}]) }, null, 2), s("div", { class: C(["flex-1", { "lg:max-w-2/3": (n.value || i.value) && (!e.hideLabel || e.preserveLabelGap) }]) }, [F(t.$slots, "errors")], 2)], 2)) : a("", !0)]));
	}
}), dx = { class: "flex flex-col" }, fx = {
	key: 0,
	class: "text-gray-900 text-xs"
}, px = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "Label",
	setup(e) {
		return (e, t) => (A(), o("div", dx, [s("label", w(h(e.$attrs)), [F(e.$slots, "default")], 16), e.$slots.sublabel ? (A(), o("span", fx, [F(e.$slots, "sublabel")])) : a("", !0)]));
	}
}), mx = { class: "flex flex-row gap-4 w-full" }, hx = /* @__PURE__ */ f({
	__name: "CurrencyRangeInput",
	props: /*@__PURE__*/ b({
		minSubLabel: {},
		maxSubLabel: {},
		minPlaceholder: {},
		maxPlaceholder: {},
		minLabel: {},
		maxLabel: {},
		maxName: {},
		minName: {},
		currency: {}
	}, {
		min: {},
		minModifiers: {},
		max: {},
		maxModifiers: {}
	}),
	emits: ["update:min", "update:max"],
	setup(e) {
		let t = R(e, "min"), n = R(e, "max");
		return (r, i) => (A(), o("div", mx, [u(L(ux), {
			class: "w-full",
			"label-position": "top"
		}, {
			label: B(() => [u(L(px), { for: e.minName }, {
				sublabel: B(() => [l(I(e.minSubLabel), 1)]),
				default: B(() => [l(I(e.minLabel) + " ", 1)]),
				_: 1
			}, 8, ["for"])]),
			default: B(() => [u(L(sx), {
				modelValue: t.value,
				"onUpdate:modelValue": i[0] ||= (e) => t.value = e,
				name: e.minName,
				currency: e.currency,
				placeholder: e.minPlaceholder,
				"wrapper-class": "grow"
			}, null, 8, [
				"modelValue",
				"name",
				"currency",
				"placeholder"
			])]),
			_: 1
		}), u(L(ux), {
			class: "w-full",
			"label-position": "top"
		}, {
			label: B(() => [u(L(px), { for: e.maxName }, {
				sublabel: B(() => [l(I(e.maxSubLabel), 1)]),
				default: B(() => [l(I(e.maxLabel) + " ", 1)]),
				_: 1
			}, 8, ["for"])]),
			default: B(() => [u(L(sx), {
				modelValue: n.value,
				"onUpdate:modelValue": i[1] ||= (e) => n.value = e,
				name: e.maxName,
				placeholder: e.maxPlaceholder,
				currency: e.currency,
				"wrapper-class": "grow"
			}, null, 8, [
				"modelValue",
				"name",
				"placeholder",
				"currency"
			])]),
			_: 1
		})]));
	}
}), gx = 365.2425, _x = 6048e5, vx = 864e5, yx = 6e4, bx = 36e5, xx = 1e3, Sx = 86400;
Sx * 7, Sx * gx / 12 * 3;
var Cx = Symbol.for("constructDateFrom");
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/constructFrom.js
function wx(e, t) {
	return typeof e == "function" ? e(t) : e && typeof e == "object" && Cx in e ? e[Cx](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/toDate.js
function Tx(e, t) {
	return wx(t || e, e);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/addDays.js
function Ex(e, t, n) {
	let r = Tx(e, n?.in);
	return isNaN(t) ? wx(n?.in || e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/addMonths.js
function Dx(e, t, n) {
	let r = Tx(e, n?.in);
	if (isNaN(t)) return wx(n?.in || e, NaN);
	if (!t) return r;
	let i = r.getDate(), a = wx(n?.in || e, r.getTime());
	return a.setMonth(r.getMonth() + t + 1, 0), i >= a.getDate() ? a : (r.setFullYear(a.getFullYear(), a.getMonth(), i), r);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/add.js
function Ox(e, t, n) {
	let { years: r = 0, months: i = 0, weeks: a = 0, days: o = 0, hours: s = 0, minutes: c = 0, seconds: l = 0 } = t, u = Tx(e, n?.in), d = i || r ? Dx(u, i + r * 12) : u, f = o || a ? Ex(d, o + a * 7) : d, p = (l + (c + s * 60) * 60) * 1e3;
	return wx(n?.in || e, +f + p);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/addMilliseconds.js
function kx(e, t, n) {
	return wx(n?.in || e, +Tx(e) + t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/addHours.js
function Ax(e, t, n) {
	return kx(e, t * bx, n);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/_lib/defaultOptions.js
var jx = {};
function Mx() {
	return jx;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfWeek.js
function Nx(e, t) {
	let n = Mx(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, i = Tx(e, t?.in), a = i.getDay(), o = (a < r ? 7 : 0) + a - r;
	return i.setDate(i.getDate() - o), i.setHours(0, 0, 0, 0), i;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfISOWeek.js
function Px(e, t) {
	return Nx(e, {
		...t,
		weekStartsOn: 1
	});
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getISOWeekYear.js
function Fx(e, t) {
	let n = Tx(e, t?.in), r = n.getFullYear(), i = wx(n, 0);
	i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
	let a = Px(i), o = wx(n, 0);
	o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
	let s = Px(o);
	return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/_lib/getTimezoneOffsetInMilliseconds.js
function Ix(e) {
	let t = Tx(e), n = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
	return n.setUTCFullYear(t.getFullYear()), e - +n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/_lib/normalizeDates.js
function Lx(e, ...t) {
	let n = wx.bind(null, e || t.find((e) => typeof e == "object"));
	return t.map(n);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfDay.js
function Rx(e, t) {
	let n = Tx(e, t?.in);
	return n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/differenceInCalendarDays.js
function zx(e, t, n) {
	let [r, i] = Lx(n?.in, e, t), a = Rx(r), o = Rx(i), s = +a - Ix(a), c = +o - Ix(o);
	return Math.round((s - c) / vx);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfISOWeekYear.js
function Bx(e, t) {
	let n = Fx(e, t), r = wx(t?.in || e, 0);
	return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Px(r);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/addQuarters.js
function Vx(e, t, n) {
	return Dx(e, t * 3, n);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/addYears.js
function Hx(e, t, n) {
	return Dx(e, t * 12, n);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/compareAsc.js
function Ux(e, t) {
	let n = Tx(e) - +Tx(t);
	return n < 0 ? -1 : n > 0 ? 1 : n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/isDate.js
function Wx(e) {
	return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/isValid.js
function Gx(e) {
	return !(!Wx(e) && typeof e != "number" || isNaN(+Tx(e)));
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getQuarter.js
function Kx(e, t) {
	let n = Tx(e, t?.in);
	return Math.trunc(n.getMonth() / 3) + 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/differenceInCalendarYears.js
function qx(e, t, n) {
	let [r, i] = Lx(n?.in, e, t);
	return r.getFullYear() - i.getFullYear();
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/differenceInYears.js
function Jx(e, t, n) {
	let [r, i] = Lx(n?.in, e, t), a = Ux(r, i), o = Math.abs(qx(r, i));
	r.setFullYear(1584), i.setFullYear(1584);
	let s = a * (o - +(Ux(r, i) === -a));
	return s === 0 ? 0 : s;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/_lib/normalizeInterval.js
function Yx(e, t) {
	let [n, r] = Lx(e, t.start, t.end);
	return {
		start: n,
		end: r
	};
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/eachDayOfInterval.js
function Xx(e, t) {
	let { start: n, end: r } = Yx(t?.in, e), i = +n > +r, a = i ? +n : +r, o = i ? r : n;
	o.setHours(0, 0, 0, 0);
	let s = t?.step ?? 1;
	if (!s) return [];
	s < 0 && (s = -s, i = !i);
	let c = [];
	for (; +o <= a;) c.push(wx(n, o)), o.setDate(o.getDate() + s), o.setHours(0, 0, 0, 0);
	return i ? c.reverse() : c;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfQuarter.js
function Zx(e, t) {
	let n = Tx(e, t?.in), r = n.getMonth(), i = r - r % 3;
	return n.setMonth(i, 1), n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/eachQuarterOfInterval.js
function Qx(e, t) {
	let { start: n, end: r } = Yx(t?.in, e), i = +n > +r, a = i ? +Zx(n) : +Zx(r), o = Zx(i ? r : n), s = t?.step ?? 1;
	if (!s) return [];
	s < 0 && (s = -s, i = !i);
	let c = [];
	for (; +o <= a;) c.push(wx(n, o)), o = Vx(o, s);
	return i ? c.reverse() : c;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfMonth.js
function $x(e, t) {
	let n = Tx(e, t?.in);
	return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/endOfYear.js
function eS(e, t) {
	let n = Tx(e, t?.in), r = n.getFullYear();
	return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfYear.js
function tS(e, t) {
	let n = Tx(e, t?.in);
	return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/endOfWeek.js
function nS(e, t) {
	let n = Mx(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, i = Tx(e, t?.in), a = i.getDay(), o = (a < r ? -7 : 0) + 6 - (a - r);
	return i.setDate(i.getDate() + o), i.setHours(23, 59, 59, 999), i;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/endOfQuarter.js
function rS(e, t) {
	let n = Tx(e, t?.in), r = n.getMonth(), i = r - r % 3 + 3;
	return n.setMonth(i, 0), n.setHours(23, 59, 59, 999), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/locale/en-US/_lib/formatDistance.js
var iS = {
	lessThanXSeconds: {
		one: "less than a second",
		other: "less than {{count}} seconds"
	},
	xSeconds: {
		one: "1 second",
		other: "{{count}} seconds"
	},
	halfAMinute: "half a minute",
	lessThanXMinutes: {
		one: "less than a minute",
		other: "less than {{count}} minutes"
	},
	xMinutes: {
		one: "1 minute",
		other: "{{count}} minutes"
	},
	aboutXHours: {
		one: "about 1 hour",
		other: "about {{count}} hours"
	},
	xHours: {
		one: "1 hour",
		other: "{{count}} hours"
	},
	xDays: {
		one: "1 day",
		other: "{{count}} days"
	},
	aboutXWeeks: {
		one: "about 1 week",
		other: "about {{count}} weeks"
	},
	xWeeks: {
		one: "1 week",
		other: "{{count}} weeks"
	},
	aboutXMonths: {
		one: "about 1 month",
		other: "about {{count}} months"
	},
	xMonths: {
		one: "1 month",
		other: "{{count}} months"
	},
	aboutXYears: {
		one: "about 1 year",
		other: "about {{count}} years"
	},
	xYears: {
		one: "1 year",
		other: "{{count}} years"
	},
	overXYears: {
		one: "over 1 year",
		other: "over {{count}} years"
	},
	almostXYears: {
		one: "almost 1 year",
		other: "almost {{count}} years"
	}
}, aS = (e, t, n) => {
	let r, i = iS[e];
	return r = typeof i == "string" ? i : t === 1 ? i.one : i.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/locale/_lib/buildFormatLongFn.js
function oS(e) {
	return (t = {}) => {
		let n = t.width ? String(t.width) : e.defaultWidth;
		return e.formats[n] || e.formats[e.defaultWidth];
	};
}
var sS = {
	date: oS({
		formats: {
			full: "EEEE, MMMM do, y",
			long: "MMMM do, y",
			medium: "MMM d, y",
			short: "MM/dd/yyyy"
		},
		defaultWidth: "full"
	}),
	time: oS({
		formats: {
			full: "h:mm:ss a zzzz",
			long: "h:mm:ss a z",
			medium: "h:mm:ss a",
			short: "h:mm a"
		},
		defaultWidth: "full"
	}),
	dateTime: oS({
		formats: {
			full: "{{date}} 'at' {{time}}",
			long: "{{date}} 'at' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
}, cS = {
	lastWeek: "'last' eeee 'at' p",
	yesterday: "'yesterday at' p",
	today: "'today at' p",
	tomorrow: "'tomorrow at' p",
	nextWeek: "eeee 'at' p",
	other: "P"
}, lS = (e, t, n, r) => cS[e];
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/locale/_lib/buildLocalizeFn.js
function uS(e) {
	return (t, n) => {
		let r = n?.context ? String(n.context) : "standalone", i;
		if (r === "formatting" && e.formattingValues) {
			let t = e.defaultFormattingWidth || e.defaultWidth, r = n?.width ? String(n.width) : t;
			i = e.formattingValues[r] || e.formattingValues[t];
		} else {
			let t = e.defaultWidth, r = n?.width ? String(n.width) : e.defaultWidth;
			i = e.values[r] || e.values[t];
		}
		let a = e.argumentCallback ? e.argumentCallback(t) : t;
		return i[a];
	};
}
var dS = {
	ordinalNumber: (e, t) => {
		let n = Number(e), r = n % 100;
		if (r > 20 || r < 10) switch (r % 10) {
			case 1: return n + "st";
			case 2: return n + "nd";
			case 3: return n + "rd";
		}
		return n + "th";
	},
	era: uS({
		values: {
			narrow: ["B", "A"],
			abbreviated: ["BC", "AD"],
			wide: ["Before Christ", "Anno Domini"]
		},
		defaultWidth: "wide"
	}),
	quarter: uS({
		values: {
			narrow: [
				"1",
				"2",
				"3",
				"4"
			],
			abbreviated: [
				"Q1",
				"Q2",
				"Q3",
				"Q4"
			],
			wide: [
				"1st quarter",
				"2nd quarter",
				"3rd quarter",
				"4th quarter"
			]
		},
		defaultWidth: "wide",
		argumentCallback: (e) => e - 1
	}),
	month: uS({
		values: {
			narrow: [
				"J",
				"F",
				"M",
				"A",
				"M",
				"J",
				"J",
				"A",
				"S",
				"O",
				"N",
				"D"
			],
			abbreviated: [
				"Jan",
				"Feb",
				"Mar",
				"Apr",
				"May",
				"Jun",
				"Jul",
				"Aug",
				"Sep",
				"Oct",
				"Nov",
				"Dec"
			],
			wide: [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December"
			]
		},
		defaultWidth: "wide"
	}),
	day: uS({
		values: {
			narrow: [
				"S",
				"M",
				"T",
				"W",
				"T",
				"F",
				"S"
			],
			short: [
				"Su",
				"Mo",
				"Tu",
				"We",
				"Th",
				"Fr",
				"Sa"
			],
			abbreviated: [
				"Sun",
				"Mon",
				"Tue",
				"Wed",
				"Thu",
				"Fri",
				"Sat"
			],
			wide: [
				"Sunday",
				"Monday",
				"Tuesday",
				"Wednesday",
				"Thursday",
				"Friday",
				"Saturday"
			]
		},
		defaultWidth: "wide"
	}),
	dayPeriod: uS({
		values: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			}
		},
		defaultWidth: "wide",
		formattingValues: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			}
		},
		defaultFormattingWidth: "wide"
	})
};
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/locale/_lib/buildMatchFn.js
function fS(e) {
	return (t, n = {}) => {
		let r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
		if (!a) return null;
		let o = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? mS(s, (e) => e.test(o)) : pS(s, (e) => e.test(o)), l;
		l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? n.valueCallback(l) : l;
		let u = t.slice(o.length);
		return {
			value: l,
			rest: u
		};
	};
}
function pS(e, t) {
	for (let n in e) if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n])) return n;
}
function mS(e, t) {
	for (let n = 0; n < e.length; n++) if (t(e[n])) return n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/locale/_lib/buildMatchPatternFn.js
function hS(e) {
	return (t, n = {}) => {
		let r = t.match(e.matchPattern);
		if (!r) return null;
		let i = r[0], a = t.match(e.parsePattern);
		if (!a) return null;
		let o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
		o = n.valueCallback ? n.valueCallback(o) : o;
		let s = t.slice(i.length);
		return {
			value: o,
			rest: s
		};
	};
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/locale/en-US.js
var gS = {
	code: "en-US",
	formatDistance: aS,
	formatLong: sS,
	formatRelative: lS,
	localize: dS,
	match: {
		ordinalNumber: hS({
			matchPattern: /^(\d+)(th|st|nd|rd)?/i,
			parsePattern: /\d+/i,
			valueCallback: (e) => parseInt(e, 10)
		}),
		era: fS({
			matchPatterns: {
				narrow: /^(b|a)/i,
				abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
				wide: /^(before christ|before common era|anno domini|common era)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^b/i, /^(a|c)/i] },
			defaultParseWidth: "any"
		}),
		quarter: fS({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^q[1234]/i,
				wide: /^[1234](th|st|nd|rd)? quarter/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: (e) => e + 1
		}),
		month: fS({
			matchPatterns: {
				narrow: /^[jfmasond]/i,
				abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
				wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^j/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^ja/i,
					/^f/i,
					/^mar/i,
					/^ap/i,
					/^may/i,
					/^jun/i,
					/^jul/i,
					/^au/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: fS({
			matchPatterns: {
				narrow: /^[smtwf]/i,
				short: /^(su|mo|tu|we|th|fr|sa)/i,
				abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
				wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^s/i,
					/^m/i,
					/^t/i,
					/^w/i,
					/^t/i,
					/^f/i,
					/^s/i
				],
				any: [
					/^su/i,
					/^m/i,
					/^tu/i,
					/^w/i,
					/^th/i,
					/^f/i,
					/^sa/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: fS({
			matchPatterns: {
				narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
				any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
			},
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^a/i,
				pm: /^p/i,
				midnight: /^mi/i,
				noon: /^no/i,
				morning: /morning/i,
				afternoon: /afternoon/i,
				evening: /evening/i,
				night: /night/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 0,
		firstWeekContainsDate: 1
	}
};
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getDayOfYear.js
function _S(e, t) {
	let n = Tx(e, t?.in);
	return zx(n, tS(n)) + 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getISOWeek.js
function vS(e, t) {
	let n = Tx(e, t?.in), r = Px(n) - +Bx(n);
	return Math.round(r / _x) + 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getWeekYear.js
function yS(e, t) {
	let n = Tx(e, t?.in), r = n.getFullYear(), i = Mx(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, o = wx(t?.in || e, 0);
	o.setFullYear(r + 1, 0, a), o.setHours(0, 0, 0, 0);
	let s = Nx(o, t), c = wx(t?.in || e, 0);
	c.setFullYear(r, 0, a), c.setHours(0, 0, 0, 0);
	let l = Nx(c, t);
	return +n >= +s ? r + 1 : +n >= +l ? r : r - 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfWeekYear.js
function bS(e, t) {
	let n = Mx(), r = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, i = yS(e, t), a = wx(t?.in || e, 0);
	return a.setFullYear(i, 0, r), a.setHours(0, 0, 0, 0), Nx(a, t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getWeek.js
function xS(e, t) {
	let n = Tx(e, t?.in), r = Nx(n, t) - +bS(n, t);
	return Math.round(r / _x) + 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/_lib/addLeadingZeros.js
function SS(e, t) {
	return (e < 0 ? "-" : "") + Math.abs(e).toString().padStart(t, "0");
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/_lib/format/lightFormatters.js
var CS = {
	y(e, t) {
		let n = e.getFullYear(), r = n > 0 ? n : 1 - n;
		return SS(t === "yy" ? r % 100 : r, t.length);
	},
	M(e, t) {
		let n = e.getMonth();
		return t === "M" ? String(n + 1) : SS(n + 1, 2);
	},
	d(e, t) {
		return SS(e.getDate(), t.length);
	},
	a(e, t) {
		let n = e.getHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.toUpperCase();
			case "aaa": return n;
			case "aaaaa": return n[0];
			default: return n === "am" ? "a.m." : "p.m.";
		}
	},
	h(e, t) {
		return SS(e.getHours() % 12 || 12, t.length);
	},
	H(e, t) {
		return SS(e.getHours(), t.length);
	},
	m(e, t) {
		return SS(e.getMinutes(), t.length);
	},
	s(e, t) {
		return SS(e.getSeconds(), t.length);
	},
	S(e, t) {
		let n = t.length, r = e.getMilliseconds();
		return SS(Math.trunc(r * 10 ** (n - 3)), t.length);
	}
}, wS = {
	am: "am",
	pm: "pm",
	midnight: "midnight",
	noon: "noon",
	morning: "morning",
	afternoon: "afternoon",
	evening: "evening",
	night: "night"
}, TS = {
	G: function(e, t, n) {
		let r = +(e.getFullYear() > 0);
		switch (t) {
			case "G":
			case "GG":
			case "GGG": return n.era(r, { width: "abbreviated" });
			case "GGGGG": return n.era(r, { width: "narrow" });
			default: return n.era(r, { width: "wide" });
		}
	},
	y: function(e, t, n) {
		if (t === "yo") {
			let t = e.getFullYear(), r = t > 0 ? t : 1 - t;
			return n.ordinalNumber(r, { unit: "year" });
		}
		return CS.y(e, t);
	},
	Y: function(e, t, n, r) {
		let i = yS(e, r), a = i > 0 ? i : 1 - i;
		return t === "YY" ? SS(a % 100, 2) : t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : SS(a, t.length);
	},
	R: function(e, t) {
		return SS(Fx(e), t.length);
	},
	u: function(e, t) {
		return SS(e.getFullYear(), t.length);
	},
	Q: function(e, t, n) {
		let r = Math.ceil((e.getMonth() + 1) / 3);
		switch (t) {
			case "Q": return String(r);
			case "QQ": return SS(r, 2);
			case "Qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "QQQ": return n.quarter(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "QQQQQ": return n.quarter(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	q: function(e, t, n) {
		let r = Math.ceil((e.getMonth() + 1) / 3);
		switch (t) {
			case "q": return String(r);
			case "qq": return SS(r, 2);
			case "qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "qqq": return n.quarter(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "qqqqq": return n.quarter(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	M: function(e, t, n) {
		let r = e.getMonth();
		switch (t) {
			case "M":
			case "MM": return CS.M(e, t);
			case "Mo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "MMM": return n.month(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "MMMMM": return n.month(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.month(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	L: function(e, t, n) {
		let r = e.getMonth();
		switch (t) {
			case "L": return String(r + 1);
			case "LL": return SS(r + 1, 2);
			case "Lo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "LLL": return n.month(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "LLLLL": return n.month(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.month(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	w: function(e, t, n, r) {
		let i = xS(e, r);
		return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : SS(i, t.length);
	},
	I: function(e, t, n) {
		let r = vS(e);
		return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : SS(r, t.length);
	},
	d: function(e, t, n) {
		return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : CS.d(e, t);
	},
	D: function(e, t, n) {
		let r = _S(e);
		return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : SS(r, t.length);
	},
	E: function(e, t, n) {
		let r = e.getDay();
		switch (t) {
			case "E":
			case "EE":
			case "EEE": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "EEEEE": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "EEEEEE": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	e: function(e, t, n, r) {
		let i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "e": return String(a);
			case "ee": return SS(a, 2);
			case "eo": return n.ordinalNumber(a, { unit: "day" });
			case "eee": return n.day(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "eeeee": return n.day(i, {
				width: "narrow",
				context: "formatting"
			});
			case "eeeeee": return n.day(i, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	c: function(e, t, n, r) {
		let i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "c": return String(a);
			case "cc": return SS(a, t.length);
			case "co": return n.ordinalNumber(a, { unit: "day" });
			case "ccc": return n.day(i, {
				width: "abbreviated",
				context: "standalone"
			});
			case "ccccc": return n.day(i, {
				width: "narrow",
				context: "standalone"
			});
			case "cccccc": return n.day(i, {
				width: "short",
				context: "standalone"
			});
			default: return n.day(i, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	i: function(e, t, n) {
		let r = e.getDay(), i = r === 0 ? 7 : r;
		switch (t) {
			case "i": return String(i);
			case "ii": return SS(i, t.length);
			case "io": return n.ordinalNumber(i, { unit: "day" });
			case "iii": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "iiiii": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "iiiiii": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	a: function(e, t, n) {
		let r = e.getHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "aaa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "aaaaa": return n.dayPeriod(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	b: function(e, t, n) {
		let r = e.getHours(), i;
		switch (i = r === 12 ? wS.noon : r === 0 ? wS.midnight : r / 12 >= 1 ? "pm" : "am", t) {
			case "b":
			case "bb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "bbb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "bbbbb": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	B: function(e, t, n) {
		let r = e.getHours(), i;
		switch (i = r >= 17 ? wS.evening : r >= 12 ? wS.afternoon : r >= 4 ? wS.morning : wS.night, t) {
			case "B":
			case "BB":
			case "BBB": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "BBBBB": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	h: function(e, t, n) {
		if (t === "ho") {
			let t = e.getHours() % 12;
			return t === 0 && (t = 12), n.ordinalNumber(t, { unit: "hour" });
		}
		return CS.h(e, t);
	},
	H: function(e, t, n) {
		return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : CS.H(e, t);
	},
	K: function(e, t, n) {
		let r = e.getHours() % 12;
		return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : SS(r, t.length);
	},
	k: function(e, t, n) {
		let r = e.getHours();
		return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : SS(r, t.length);
	},
	m: function(e, t, n) {
		return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : CS.m(e, t);
	},
	s: function(e, t, n) {
		return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : CS.s(e, t);
	},
	S: function(e, t) {
		return CS.S(e, t);
	},
	X: function(e, t, n) {
		let r = e.getTimezoneOffset();
		if (r === 0) return "Z";
		switch (t) {
			case "X": return DS(r);
			case "XXXX":
			case "XX": return OS(r);
			default: return OS(r, ":");
		}
	},
	x: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "x": return DS(r);
			case "xxxx":
			case "xx": return OS(r);
			default: return OS(r, ":");
		}
	},
	O: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "O":
			case "OO":
			case "OOO": return "GMT" + ES(r, ":");
			default: return "GMT" + OS(r, ":");
		}
	},
	z: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "z":
			case "zz":
			case "zzz": return "GMT" + ES(r, ":");
			default: return "GMT" + OS(r, ":");
		}
	},
	t: function(e, t, n) {
		return SS(Math.trunc(e / 1e3), t.length);
	},
	T: function(e, t, n) {
		return SS(+e, t.length);
	}
};
function ES(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.trunc(r / 60), a = r % 60;
	return a === 0 ? n + String(i) : n + String(i) + t + SS(a, 2);
}
function DS(e, t) {
	return e % 60 == 0 ? (e > 0 ? "-" : "+") + SS(Math.abs(e) / 60, 2) : OS(e, t);
}
function OS(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = SS(Math.trunc(r / 60), 2), a = SS(r % 60, 2);
	return n + i + t + a;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/_lib/format/longFormatters.js
var kS = (e, t) => {
	switch (e) {
		case "P": return t.date({ width: "short" });
		case "PP": return t.date({ width: "medium" });
		case "PPP": return t.date({ width: "long" });
		default: return t.date({ width: "full" });
	}
}, AS = (e, t) => {
	switch (e) {
		case "p": return t.time({ width: "short" });
		case "pp": return t.time({ width: "medium" });
		case "ppp": return t.time({ width: "long" });
		default: return t.time({ width: "full" });
	}
}, jS = {
	p: AS,
	P: (e, t) => {
		let n = e.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
		if (!i) return kS(e, t);
		let a;
		switch (r) {
			case "P":
				a = t.dateTime({ width: "short" });
				break;
			case "PP":
				a = t.dateTime({ width: "medium" });
				break;
			case "PPP":
				a = t.dateTime({ width: "long" });
				break;
			default: a = t.dateTime({ width: "full" });
		}
		return a.replace("{{date}}", kS(r, t)).replace("{{time}}", AS(i, t));
	}
}, MS = /^D+$/, NS = /^Y+$/, PS = [
	"D",
	"DD",
	"YY",
	"YYYY"
];
function FS(e) {
	return MS.test(e);
}
function IS(e) {
	return NS.test(e);
}
function LS(e, t, n) {
	let r = RS(e, t, n);
	if (console.warn(r), PS.includes(e)) throw RangeError(r);
}
function RS(e, t, n) {
	let r = e[0] === "Y" ? "years" : "days of the month";
	return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/format.js
var zS = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, BS = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, VS = /^'([^]*?)'?$/, HS = /''/g, US = /[a-zA-Z]/;
function WS(e, t, n) {
	let r = Mx(), i = n?.locale ?? r.locale ?? gS, a = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, o = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, s = Tx(e, n?.in);
	if (!Gx(s)) throw RangeError("Invalid time value");
	let c = t.match(BS).map((e) => {
		let t = e[0];
		if (t === "p" || t === "P") {
			let n = jS[t];
			return n(e, i.formatLong);
		}
		return e;
	}).join("").match(zS).map((e) => {
		if (e === "''") return {
			isToken: !1,
			value: "'"
		};
		let t = e[0];
		if (t === "'") return {
			isToken: !1,
			value: GS(e)
		};
		if (TS[t]) return {
			isToken: !0,
			value: e
		};
		if (t.match(US)) throw RangeError("Format string contains an unescaped latin alphabet character `" + t + "`");
		return {
			isToken: !1,
			value: e
		};
	});
	i.localize.preprocessor && (c = i.localize.preprocessor(s, c));
	let l = {
		firstWeekContainsDate: a,
		weekStartsOn: o,
		locale: i
	};
	return c.map((r) => {
		if (!r.isToken) return r.value;
		let a = r.value;
		(!n?.useAdditionalWeekYearTokens && IS(a) || !n?.useAdditionalDayOfYearTokens && FS(a)) && LS(a, t, String(e));
		let o = TS[a[0]];
		return o(s, a, i.localize, l);
	}).join("");
}
function GS(e) {
	let t = e.match(VS);
	return t ? t[1].replace(HS, "'") : e;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getDay.js
function KS(e, t) {
	return Tx(e, t?.in).getDay();
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getDaysInMonth.js
function qS(e, t) {
	let n = Tx(e, t?.in), r = n.getFullYear(), i = n.getMonth(), a = wx(n, 0);
	return a.setFullYear(r, i + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getDefaultOptions.js
function JS() {
	return Object.assign({}, Mx());
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getHours.js
function YS(e, t) {
	return Tx(e, t?.in).getHours();
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getISODay.js
function XS(e, t) {
	let n = Tx(e, t?.in).getDay();
	return n === 0 ? 7 : n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getMinutes.js
function ZS(e, t) {
	return Tx(e, t?.in).getMinutes();
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getMonth.js
function QS(e, t) {
	return Tx(e, t?.in).getMonth();
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getSeconds.js
function $S(e) {
	return Tx(e).getSeconds();
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getYear.js
function eC(e, t) {
	return Tx(e, t?.in).getFullYear();
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/isAfter.js
function tC(e, t) {
	return +Tx(e) > +Tx(t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/isBefore.js
function nC(e, t) {
	return +Tx(e) < +Tx(t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/isEqual.js
function rC(e, t) {
	return +Tx(e) == +Tx(t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/transpose.js
function iC(e, t) {
	let n = aC(t) ? new t(0) : wx(t, 0);
	return n.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), n.setHours(e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()), n;
}
function aC(e) {
	return typeof e == "function" && e.prototype?.constructor === e;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/parse/_lib/Setter.js
var oC = 10, sC = class {
	subPriority = 0;
	validate(e, t) {
		return !0;
	}
}, cC = class extends sC {
	constructor(e, t, n, r, i) {
		super(), this.value = e, this.validateValue = t, this.setValue = n, this.priority = r, i && (this.subPriority = i);
	}
	validate(e, t) {
		return this.validateValue(e, this.value, t);
	}
	set(e, t, n) {
		return this.setValue(e, t, this.value, n);
	}
}, lC = class extends sC {
	priority = oC;
	subPriority = -1;
	constructor(e, t) {
		super(), this.context = e || ((e) => wx(t, e));
	}
	set(e, t) {
		return t.timestampIsSet ? e : wx(e, iC(e, this.context));
	}
}, uC = class {
	run(e, t, n, r) {
		let i = this.parse(e, t, n, r);
		return i ? {
			setter: new cC(i.value, this.validate, this.set, this.priority, this.subPriority),
			rest: i.rest
		} : null;
	}
	validate(e, t, n) {
		return !0;
	}
}, dC = class extends uC {
	priority = 140;
	parse(e, t, n) {
		switch (t) {
			case "G":
			case "GG":
			case "GGG": return n.era(e, { width: "abbreviated" }) || n.era(e, { width: "narrow" });
			case "GGGGG": return n.era(e, { width: "narrow" });
			default: return n.era(e, { width: "wide" }) || n.era(e, { width: "abbreviated" }) || n.era(e, { width: "narrow" });
		}
	}
	set(e, t, n) {
		return t.era = n, e.setFullYear(n, 0, 1), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"R",
		"u",
		"t",
		"T"
	];
}, fC = {
	month: /^(1[0-2]|0?\d)/,
	date: /^(3[0-1]|[0-2]?\d)/,
	dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
	week: /^(5[0-3]|[0-4]?\d)/,
	hour23h: /^(2[0-3]|[0-1]?\d)/,
	hour24h: /^(2[0-4]|[0-1]?\d)/,
	hour11h: /^(1[0-1]|0?\d)/,
	hour12h: /^(1[0-2]|0?\d)/,
	minute: /^[0-5]?\d/,
	second: /^[0-5]?\d/,
	singleDigit: /^\d/,
	twoDigits: /^\d{1,2}/,
	threeDigits: /^\d{1,3}/,
	fourDigits: /^\d{1,4}/,
	anyDigitsSigned: /^-?\d+/,
	singleDigitSigned: /^-?\d/,
	twoDigitsSigned: /^-?\d{1,2}/,
	threeDigitsSigned: /^-?\d{1,3}/,
	fourDigitsSigned: /^-?\d{1,4}/
}, pC = {
	basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
	basic: /^([+-])(\d{2})(\d{2})|Z/,
	basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
	extended: /^([+-])(\d{2}):(\d{2})|Z/,
	extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/parse/_lib/utils.js
function mC(e, t) {
	return e && {
		value: t(e.value),
		rest: e.rest
	};
}
function hC(e, t) {
	let n = t.match(e);
	return n ? {
		value: parseInt(n[0], 10),
		rest: t.slice(n[0].length)
	} : null;
}
function gC(e, t) {
	let n = t.match(e);
	if (!n) return null;
	if (n[0] === "Z") return {
		value: 0,
		rest: t.slice(1)
	};
	let r = n[1] === "+" ? 1 : -1, i = n[2] ? parseInt(n[2], 10) : 0, a = n[3] ? parseInt(n[3], 10) : 0, o = n[5] ? parseInt(n[5], 10) : 0;
	return {
		value: r * (i * bx + a * yx + o * xx),
		rest: t.slice(n[0].length)
	};
}
function _C(e) {
	return hC(fC.anyDigitsSigned, e);
}
function vC(e, t) {
	switch (e) {
		case 1: return hC(fC.singleDigit, t);
		case 2: return hC(fC.twoDigits, t);
		case 3: return hC(fC.threeDigits, t);
		case 4: return hC(fC.fourDigits, t);
		default: return hC(RegExp("^\\d{1," + e + "}"), t);
	}
}
function yC(e, t) {
	switch (e) {
		case 1: return hC(fC.singleDigitSigned, t);
		case 2: return hC(fC.twoDigitsSigned, t);
		case 3: return hC(fC.threeDigitsSigned, t);
		case 4: return hC(fC.fourDigitsSigned, t);
		default: return hC(RegExp("^-?\\d{1," + e + "}"), t);
	}
}
function bC(e) {
	switch (e) {
		case "morning": return 4;
		case "evening": return 17;
		case "pm":
		case "noon":
		case "afternoon": return 12;
		default: return 0;
	}
}
function xC(e, t) {
	let n = t > 0, r = n ? t : 1 - t, i;
	if (r <= 50) i = e || 100;
	else {
		let t = r + 50, n = Math.trunc(t / 100) * 100, a = e >= t % 100;
		i = e + n - (a ? 100 : 0);
	}
	return n ? i : 1 - i;
}
function SC(e) {
	return e % 400 == 0 || e % 4 == 0 && e % 100 != 0;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/parse/_lib/parsers/YearParser.js
var CC = class extends uC {
	priority = 130;
	incompatibleTokens = [
		"Y",
		"R",
		"u",
		"w",
		"I",
		"i",
		"e",
		"c",
		"t",
		"T"
	];
	parse(e, t, n) {
		let r = (e) => ({
			year: e,
			isTwoDigitYear: t === "yy"
		});
		switch (t) {
			case "y": return mC(vC(4, e), r);
			case "yo": return mC(n.ordinalNumber(e, { unit: "year" }), r);
			default: return mC(vC(t.length, e), r);
		}
	}
	validate(e, t) {
		return t.isTwoDigitYear || t.year > 0;
	}
	set(e, t, n) {
		let r = e.getFullYear();
		if (n.isTwoDigitYear) {
			let t = xC(n.year, r);
			return e.setFullYear(t, 0, 1), e.setHours(0, 0, 0, 0), e;
		}
		let i = !("era" in t) || t.era === 1 ? n.year : 1 - n.year;
		return e.setFullYear(i, 0, 1), e.setHours(0, 0, 0, 0), e;
	}
}, wC = class extends uC {
	priority = 130;
	parse(e, t, n) {
		let r = (e) => ({
			year: e,
			isTwoDigitYear: t === "YY"
		});
		switch (t) {
			case "Y": return mC(vC(4, e), r);
			case "Yo": return mC(n.ordinalNumber(e, { unit: "year" }), r);
			default: return mC(vC(t.length, e), r);
		}
	}
	validate(e, t) {
		return t.isTwoDigitYear || t.year > 0;
	}
	set(e, t, n, r) {
		let i = yS(e, r);
		if (n.isTwoDigitYear) {
			let t = xC(n.year, i);
			return e.setFullYear(t, 0, r.firstWeekContainsDate), e.setHours(0, 0, 0, 0), Nx(e, r);
		}
		let a = !("era" in t) || t.era === 1 ? n.year : 1 - n.year;
		return e.setFullYear(a, 0, r.firstWeekContainsDate), e.setHours(0, 0, 0, 0), Nx(e, r);
	}
	incompatibleTokens = [
		"y",
		"R",
		"u",
		"Q",
		"q",
		"M",
		"L",
		"I",
		"d",
		"D",
		"i",
		"t",
		"T"
	];
}, TC = class extends uC {
	priority = 130;
	parse(e, t) {
		return yC(t === "R" ? 4 : t.length, e);
	}
	set(e, t, n) {
		let r = wx(e, 0);
		return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Px(r);
	}
	incompatibleTokens = [
		"G",
		"y",
		"Y",
		"u",
		"Q",
		"q",
		"M",
		"L",
		"w",
		"d",
		"D",
		"e",
		"c",
		"t",
		"T"
	];
}, EC = class extends uC {
	priority = 130;
	parse(e, t) {
		return yC(t === "u" ? 4 : t.length, e);
	}
	set(e, t, n) {
		return e.setFullYear(n, 0, 1), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"G",
		"y",
		"Y",
		"R",
		"w",
		"I",
		"i",
		"e",
		"c",
		"t",
		"T"
	];
}, DC = class extends uC {
	priority = 120;
	parse(e, t, n) {
		switch (t) {
			case "Q":
			case "QQ": return vC(t.length, e);
			case "Qo": return n.ordinalNumber(e, { unit: "quarter" });
			case "QQQ": return n.quarter(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.quarter(e, {
				width: "narrow",
				context: "formatting"
			});
			case "QQQQQ": return n.quarter(e, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.quarter(e, {
				width: "wide",
				context: "formatting"
			}) || n.quarter(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.quarter(e, {
				width: "narrow",
				context: "formatting"
			});
		}
	}
	validate(e, t) {
		return t >= 1 && t <= 4;
	}
	set(e, t, n) {
		return e.setMonth((n - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"Y",
		"R",
		"q",
		"M",
		"L",
		"w",
		"I",
		"d",
		"D",
		"i",
		"e",
		"c",
		"t",
		"T"
	];
}, OC = class extends uC {
	priority = 120;
	parse(e, t, n) {
		switch (t) {
			case "q":
			case "qq": return vC(t.length, e);
			case "qo": return n.ordinalNumber(e, { unit: "quarter" });
			case "qqq": return n.quarter(e, {
				width: "abbreviated",
				context: "standalone"
			}) || n.quarter(e, {
				width: "narrow",
				context: "standalone"
			});
			case "qqqqq": return n.quarter(e, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.quarter(e, {
				width: "wide",
				context: "standalone"
			}) || n.quarter(e, {
				width: "abbreviated",
				context: "standalone"
			}) || n.quarter(e, {
				width: "narrow",
				context: "standalone"
			});
		}
	}
	validate(e, t) {
		return t >= 1 && t <= 4;
	}
	set(e, t, n) {
		return e.setMonth((n - 1) * 3, 1), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"Y",
		"R",
		"Q",
		"M",
		"L",
		"w",
		"I",
		"d",
		"D",
		"i",
		"e",
		"c",
		"t",
		"T"
	];
}, kC = class extends uC {
	incompatibleTokens = [
		"Y",
		"R",
		"q",
		"Q",
		"L",
		"w",
		"I",
		"D",
		"i",
		"e",
		"c",
		"t",
		"T"
	];
	priority = 110;
	parse(e, t, n) {
		let r = (e) => e - 1;
		switch (t) {
			case "M": return mC(hC(fC.month, e), r);
			case "MM": return mC(vC(2, e), r);
			case "Mo": return mC(n.ordinalNumber(e, { unit: "month" }), r);
			case "MMM": return n.month(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.month(e, {
				width: "narrow",
				context: "formatting"
			});
			case "MMMMM": return n.month(e, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.month(e, {
				width: "wide",
				context: "formatting"
			}) || n.month(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.month(e, {
				width: "narrow",
				context: "formatting"
			});
		}
	}
	validate(e, t) {
		return t >= 0 && t <= 11;
	}
	set(e, t, n) {
		return e.setMonth(n, 1), e.setHours(0, 0, 0, 0), e;
	}
}, AC = class extends uC {
	priority = 110;
	parse(e, t, n) {
		let r = (e) => e - 1;
		switch (t) {
			case "L": return mC(hC(fC.month, e), r);
			case "LL": return mC(vC(2, e), r);
			case "Lo": return mC(n.ordinalNumber(e, { unit: "month" }), r);
			case "LLL": return n.month(e, {
				width: "abbreviated",
				context: "standalone"
			}) || n.month(e, {
				width: "narrow",
				context: "standalone"
			});
			case "LLLLL": return n.month(e, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.month(e, {
				width: "wide",
				context: "standalone"
			}) || n.month(e, {
				width: "abbreviated",
				context: "standalone"
			}) || n.month(e, {
				width: "narrow",
				context: "standalone"
			});
		}
	}
	validate(e, t) {
		return t >= 0 && t <= 11;
	}
	set(e, t, n) {
		return e.setMonth(n, 1), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"Y",
		"R",
		"q",
		"Q",
		"M",
		"w",
		"I",
		"D",
		"i",
		"e",
		"c",
		"t",
		"T"
	];
};
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/setWeek.js
function jC(e, t, n) {
	let r = Tx(e, n?.in), i = xS(r, n) - t;
	return r.setDate(r.getDate() - i * 7), Tx(r, n?.in);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/parse/_lib/parsers/LocalWeekParser.js
var MC = class extends uC {
	priority = 100;
	parse(e, t, n) {
		switch (t) {
			case "w": return hC(fC.week, e);
			case "wo": return n.ordinalNumber(e, { unit: "week" });
			default: return vC(t.length, e);
		}
	}
	validate(e, t) {
		return t >= 1 && t <= 53;
	}
	set(e, t, n, r) {
		return Nx(jC(e, n, r), r);
	}
	incompatibleTokens = [
		"y",
		"R",
		"u",
		"q",
		"Q",
		"M",
		"L",
		"I",
		"d",
		"D",
		"i",
		"t",
		"T"
	];
};
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/setISOWeek.js
function NC(e, t, n) {
	let r = Tx(e, n?.in), i = vS(r, n) - t;
	return r.setDate(r.getDate() - i * 7), r;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/parse/_lib/parsers/ISOWeekParser.js
var PC = class extends uC {
	priority = 100;
	parse(e, t, n) {
		switch (t) {
			case "I": return hC(fC.week, e);
			case "Io": return n.ordinalNumber(e, { unit: "week" });
			default: return vC(t.length, e);
		}
	}
	validate(e, t) {
		return t >= 1 && t <= 53;
	}
	set(e, t, n) {
		return Px(NC(e, n));
	}
	incompatibleTokens = [
		"y",
		"Y",
		"u",
		"q",
		"Q",
		"M",
		"L",
		"w",
		"d",
		"D",
		"e",
		"c",
		"t",
		"T"
	];
}, FC = [
	31,
	28,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
], IC = [
	31,
	29,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
], LC = class extends uC {
	priority = 90;
	subPriority = 1;
	parse(e, t, n) {
		switch (t) {
			case "d": return hC(fC.date, e);
			case "do": return n.ordinalNumber(e, { unit: "date" });
			default: return vC(t.length, e);
		}
	}
	validate(e, t) {
		let n = SC(e.getFullYear()), r = e.getMonth();
		return n ? t >= 1 && t <= IC[r] : t >= 1 && t <= FC[r];
	}
	set(e, t, n) {
		return e.setDate(n), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"Y",
		"R",
		"q",
		"Q",
		"w",
		"I",
		"D",
		"i",
		"e",
		"c",
		"t",
		"T"
	];
}, RC = class extends uC {
	priority = 90;
	subpriority = 1;
	parse(e, t, n) {
		switch (t) {
			case "D":
			case "DD": return hC(fC.dayOfYear, e);
			case "Do": return n.ordinalNumber(e, { unit: "date" });
			default: return vC(t.length, e);
		}
	}
	validate(e, t) {
		return SC(e.getFullYear()) ? t >= 1 && t <= 366 : t >= 1 && t <= 365;
	}
	set(e, t, n) {
		return e.setMonth(0, n), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"Y",
		"R",
		"q",
		"Q",
		"M",
		"L",
		"w",
		"I",
		"d",
		"E",
		"i",
		"e",
		"c",
		"t",
		"T"
	];
};
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/setDay.js
function zC(e, t, n) {
	let r = Mx(), i = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, a = Tx(e, n?.in), o = a.getDay(), s = (t % 7 + 7) % 7, c = 7 - i;
	return Ex(a, t < 0 || t > 6 ? t - (o + c) % 7 : (s + c) % 7 - (o + c) % 7, n);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/parse/_lib/parsers/DayParser.js
var BC = class extends uC {
	priority = 90;
	parse(e, t, n) {
		switch (t) {
			case "E":
			case "EE":
			case "EEE": return n.day(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.day(e, {
				width: "short",
				context: "formatting"
			}) || n.day(e, {
				width: "narrow",
				context: "formatting"
			});
			case "EEEEE": return n.day(e, {
				width: "narrow",
				context: "formatting"
			});
			case "EEEEEE": return n.day(e, {
				width: "short",
				context: "formatting"
			}) || n.day(e, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.day(e, {
				width: "wide",
				context: "formatting"
			}) || n.day(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.day(e, {
				width: "short",
				context: "formatting"
			}) || n.day(e, {
				width: "narrow",
				context: "formatting"
			});
		}
	}
	validate(e, t) {
		return t >= 0 && t <= 6;
	}
	set(e, t, n, r) {
		return e = zC(e, n, r), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"D",
		"i",
		"e",
		"c",
		"t",
		"T"
	];
}, VC = class extends uC {
	priority = 90;
	parse(e, t, n, r) {
		let i = (e) => {
			let t = Math.floor((e - 1) / 7) * 7;
			return (e + r.weekStartsOn + 6) % 7 + t;
		};
		switch (t) {
			case "e":
			case "ee": return mC(vC(t.length, e), i);
			case "eo": return mC(n.ordinalNumber(e, { unit: "day" }), i);
			case "eee": return n.day(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.day(e, {
				width: "short",
				context: "formatting"
			}) || n.day(e, {
				width: "narrow",
				context: "formatting"
			});
			case "eeeee": return n.day(e, {
				width: "narrow",
				context: "formatting"
			});
			case "eeeeee": return n.day(e, {
				width: "short",
				context: "formatting"
			}) || n.day(e, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.day(e, {
				width: "wide",
				context: "formatting"
			}) || n.day(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.day(e, {
				width: "short",
				context: "formatting"
			}) || n.day(e, {
				width: "narrow",
				context: "formatting"
			});
		}
	}
	validate(e, t) {
		return t >= 0 && t <= 6;
	}
	set(e, t, n, r) {
		return e = zC(e, n, r), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"y",
		"R",
		"u",
		"q",
		"Q",
		"M",
		"L",
		"I",
		"d",
		"D",
		"E",
		"i",
		"c",
		"t",
		"T"
	];
}, HC = class extends uC {
	priority = 90;
	parse(e, t, n, r) {
		let i = (e) => {
			let t = Math.floor((e - 1) / 7) * 7;
			return (e + r.weekStartsOn + 6) % 7 + t;
		};
		switch (t) {
			case "c":
			case "cc": return mC(vC(t.length, e), i);
			case "co": return mC(n.ordinalNumber(e, { unit: "day" }), i);
			case "ccc": return n.day(e, {
				width: "abbreviated",
				context: "standalone"
			}) || n.day(e, {
				width: "short",
				context: "standalone"
			}) || n.day(e, {
				width: "narrow",
				context: "standalone"
			});
			case "ccccc": return n.day(e, {
				width: "narrow",
				context: "standalone"
			});
			case "cccccc": return n.day(e, {
				width: "short",
				context: "standalone"
			}) || n.day(e, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.day(e, {
				width: "wide",
				context: "standalone"
			}) || n.day(e, {
				width: "abbreviated",
				context: "standalone"
			}) || n.day(e, {
				width: "short",
				context: "standalone"
			}) || n.day(e, {
				width: "narrow",
				context: "standalone"
			});
		}
	}
	validate(e, t) {
		return t >= 0 && t <= 6;
	}
	set(e, t, n, r) {
		return e = zC(e, n, r), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"y",
		"R",
		"u",
		"q",
		"Q",
		"M",
		"L",
		"I",
		"d",
		"D",
		"E",
		"i",
		"e",
		"t",
		"T"
	];
};
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/setISODay.js
function UC(e, t, n) {
	let r = Tx(e, n?.in);
	return Ex(r, t - XS(r, n), n);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/parse/_lib/parsers/ISODayParser.js
var WC = class extends uC {
	priority = 90;
	parse(e, t, n) {
		let r = (e) => e === 0 ? 7 : e;
		switch (t) {
			case "i":
			case "ii": return vC(t.length, e);
			case "io": return n.ordinalNumber(e, { unit: "day" });
			case "iii": return mC(n.day(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.day(e, {
				width: "short",
				context: "formatting"
			}) || n.day(e, {
				width: "narrow",
				context: "formatting"
			}), r);
			case "iiiii": return mC(n.day(e, {
				width: "narrow",
				context: "formatting"
			}), r);
			case "iiiiii": return mC(n.day(e, {
				width: "short",
				context: "formatting"
			}) || n.day(e, {
				width: "narrow",
				context: "formatting"
			}), r);
			default: return mC(n.day(e, {
				width: "wide",
				context: "formatting"
			}) || n.day(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.day(e, {
				width: "short",
				context: "formatting"
			}) || n.day(e, {
				width: "narrow",
				context: "formatting"
			}), r);
		}
	}
	validate(e, t) {
		return t >= 1 && t <= 7;
	}
	set(e, t, n) {
		return e = UC(e, n), e.setHours(0, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"y",
		"Y",
		"u",
		"q",
		"Q",
		"M",
		"L",
		"w",
		"d",
		"D",
		"E",
		"e",
		"c",
		"t",
		"T"
	];
}, GC = class extends uC {
	priority = 80;
	parse(e, t, n) {
		switch (t) {
			case "a":
			case "aa":
			case "aaa": return n.dayPeriod(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.dayPeriod(e, {
				width: "narrow",
				context: "formatting"
			});
			case "aaaaa": return n.dayPeriod(e, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(e, {
				width: "wide",
				context: "formatting"
			}) || n.dayPeriod(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.dayPeriod(e, {
				width: "narrow",
				context: "formatting"
			});
		}
	}
	set(e, t, n) {
		return e.setHours(bC(n), 0, 0, 0), e;
	}
	incompatibleTokens = [
		"b",
		"B",
		"H",
		"k",
		"t",
		"T"
	];
}, KC = class extends uC {
	priority = 80;
	parse(e, t, n) {
		switch (t) {
			case "b":
			case "bb":
			case "bbb": return n.dayPeriod(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.dayPeriod(e, {
				width: "narrow",
				context: "formatting"
			});
			case "bbbbb": return n.dayPeriod(e, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(e, {
				width: "wide",
				context: "formatting"
			}) || n.dayPeriod(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.dayPeriod(e, {
				width: "narrow",
				context: "formatting"
			});
		}
	}
	set(e, t, n) {
		return e.setHours(bC(n), 0, 0, 0), e;
	}
	incompatibleTokens = [
		"a",
		"B",
		"H",
		"k",
		"t",
		"T"
	];
}, qC = class extends uC {
	priority = 80;
	parse(e, t, n) {
		switch (t) {
			case "B":
			case "BB":
			case "BBB": return n.dayPeriod(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.dayPeriod(e, {
				width: "narrow",
				context: "formatting"
			});
			case "BBBBB": return n.dayPeriod(e, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(e, {
				width: "wide",
				context: "formatting"
			}) || n.dayPeriod(e, {
				width: "abbreviated",
				context: "formatting"
			}) || n.dayPeriod(e, {
				width: "narrow",
				context: "formatting"
			});
		}
	}
	set(e, t, n) {
		return e.setHours(bC(n), 0, 0, 0), e;
	}
	incompatibleTokens = [
		"a",
		"b",
		"t",
		"T"
	];
}, JC = class extends uC {
	priority = 70;
	parse(e, t, n) {
		switch (t) {
			case "h": return hC(fC.hour12h, e);
			case "ho": return n.ordinalNumber(e, { unit: "hour" });
			default: return vC(t.length, e);
		}
	}
	validate(e, t) {
		return t >= 1 && t <= 12;
	}
	set(e, t, n) {
		let r = e.getHours() >= 12;
		return r && n < 12 ? e.setHours(n + 12, 0, 0, 0) : !r && n === 12 ? e.setHours(0, 0, 0, 0) : e.setHours(n, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"H",
		"K",
		"k",
		"t",
		"T"
	];
}, YC = class extends uC {
	priority = 70;
	parse(e, t, n) {
		switch (t) {
			case "H": return hC(fC.hour23h, e);
			case "Ho": return n.ordinalNumber(e, { unit: "hour" });
			default: return vC(t.length, e);
		}
	}
	validate(e, t) {
		return t >= 0 && t <= 23;
	}
	set(e, t, n) {
		return e.setHours(n, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"a",
		"b",
		"h",
		"K",
		"k",
		"t",
		"T"
	];
}, XC = class extends uC {
	priority = 70;
	parse(e, t, n) {
		switch (t) {
			case "K": return hC(fC.hour11h, e);
			case "Ko": return n.ordinalNumber(e, { unit: "hour" });
			default: return vC(t.length, e);
		}
	}
	validate(e, t) {
		return t >= 0 && t <= 11;
	}
	set(e, t, n) {
		return e.getHours() >= 12 && n < 12 ? e.setHours(n + 12, 0, 0, 0) : e.setHours(n, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"h",
		"H",
		"k",
		"t",
		"T"
	];
}, ZC = class extends uC {
	priority = 70;
	parse(e, t, n) {
		switch (t) {
			case "k": return hC(fC.hour24h, e);
			case "ko": return n.ordinalNumber(e, { unit: "hour" });
			default: return vC(t.length, e);
		}
	}
	validate(e, t) {
		return t >= 1 && t <= 24;
	}
	set(e, t, n) {
		let r = n <= 24 ? n % 24 : n;
		return e.setHours(r, 0, 0, 0), e;
	}
	incompatibleTokens = [
		"a",
		"b",
		"h",
		"H",
		"K",
		"t",
		"T"
	];
}, QC = class extends uC {
	priority = 60;
	parse(e, t, n) {
		switch (t) {
			case "m": return hC(fC.minute, e);
			case "mo": return n.ordinalNumber(e, { unit: "minute" });
			default: return vC(t.length, e);
		}
	}
	validate(e, t) {
		return t >= 0 && t <= 59;
	}
	set(e, t, n) {
		return e.setMinutes(n, 0, 0), e;
	}
	incompatibleTokens = ["t", "T"];
}, $C = class extends uC {
	priority = 50;
	parse(e, t, n) {
		switch (t) {
			case "s": return hC(fC.second, e);
			case "so": return n.ordinalNumber(e, { unit: "second" });
			default: return vC(t.length, e);
		}
	}
	validate(e, t) {
		return t >= 0 && t <= 59;
	}
	set(e, t, n) {
		return e.setSeconds(n, 0), e;
	}
	incompatibleTokens = ["t", "T"];
}, ew = class extends uC {
	priority = 30;
	parse(e, t) {
		return mC(vC(t.length, e), (e) => Math.trunc(e * 10 ** (-t.length + 3)));
	}
	set(e, t, n) {
		return e.setMilliseconds(n), e;
	}
	incompatibleTokens = ["t", "T"];
}, tw = class extends uC {
	priority = 10;
	parse(e, t) {
		switch (t) {
			case "X": return gC(pC.basicOptionalMinutes, e);
			case "XX": return gC(pC.basic, e);
			case "XXXX": return gC(pC.basicOptionalSeconds, e);
			case "XXXXX": return gC(pC.extendedOptionalSeconds, e);
			default: return gC(pC.extended, e);
		}
	}
	set(e, t, n) {
		return t.timestampIsSet ? e : wx(e, e.getTime() - Ix(e) - n);
	}
	incompatibleTokens = [
		"t",
		"T",
		"x"
	];
}, nw = class extends uC {
	priority = 10;
	parse(e, t) {
		switch (t) {
			case "x": return gC(pC.basicOptionalMinutes, e);
			case "xx": return gC(pC.basic, e);
			case "xxxx": return gC(pC.basicOptionalSeconds, e);
			case "xxxxx": return gC(pC.extendedOptionalSeconds, e);
			default: return gC(pC.extended, e);
		}
	}
	set(e, t, n) {
		return t.timestampIsSet ? e : wx(e, e.getTime() - Ix(e) - n);
	}
	incompatibleTokens = [
		"t",
		"T",
		"X"
	];
}, rw = class extends uC {
	priority = 40;
	parse(e) {
		return _C(e);
	}
	set(e, t, n) {
		return [wx(e, n * 1e3), { timestampIsSet: !0 }];
	}
	incompatibleTokens = "*";
}, iw = class extends uC {
	priority = 20;
	parse(e) {
		return _C(e);
	}
	set(e, t, n) {
		return [wx(e, n), { timestampIsSet: !0 }];
	}
	incompatibleTokens = "*";
}, aw = {
	G: new dC(),
	y: new CC(),
	Y: new wC(),
	R: new TC(),
	u: new EC(),
	Q: new DC(),
	q: new OC(),
	M: new kC(),
	L: new AC(),
	w: new MC(),
	I: new PC(),
	d: new LC(),
	D: new RC(),
	E: new BC(),
	e: new VC(),
	c: new HC(),
	i: new WC(),
	a: new GC(),
	b: new KC(),
	B: new qC(),
	h: new JC(),
	H: new YC(),
	K: new XC(),
	k: new ZC(),
	m: new QC(),
	s: new $C(),
	S: new ew(),
	X: new tw(),
	x: new nw(),
	t: new rw(),
	T: new iw()
}, ow = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, sw = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, cw = /^'([^]*?)'?$/, lw = /''/g, uw = /\S/, dw = /[a-zA-Z]/;
function fw(e, t, n, r) {
	let i = () => wx(r?.in || n, NaN), a = JS(), o = r?.locale ?? a.locale ?? gS, s = r?.firstWeekContainsDate ?? r?.locale?.options?.firstWeekContainsDate ?? a.firstWeekContainsDate ?? a.locale?.options?.firstWeekContainsDate ?? 1, c = r?.weekStartsOn ?? r?.locale?.options?.weekStartsOn ?? a.weekStartsOn ?? a.locale?.options?.weekStartsOn ?? 0;
	if (!t) return e ? i() : Tx(n, r?.in);
	let l = {
		firstWeekContainsDate: s,
		weekStartsOn: c,
		locale: o
	}, u = [new lC(r?.in, n)], d = t.match(sw).map((e) => {
		let t = e[0];
		if (t in jS) {
			let n = jS[t];
			return n(e, o.formatLong);
		}
		return e;
	}).join("").match(ow), f = [];
	for (let n of d) {
		!r?.useAdditionalWeekYearTokens && IS(n) && LS(n, t, e), !r?.useAdditionalDayOfYearTokens && FS(n) && LS(n, t, e);
		let a = n[0], s = aw[a];
		if (s) {
			let { incompatibleTokens: t } = s;
			if (Array.isArray(t)) {
				let e = f.find((e) => t.includes(e.token) || e.token === a);
				if (e) throw RangeError(`The format string mustn't contain \`${e.fullToken}\` and \`${n}\` at the same time`);
			} else if (s.incompatibleTokens === "*" && f.length > 0) throw RangeError(`The format string mustn't contain \`${n}\` and any other token at the same time`);
			f.push({
				token: a,
				fullToken: n
			});
			let r = s.run(e, n, o.match, l);
			if (!r) return i();
			u.push(r.setter), e = r.rest;
		} else {
			if (a.match(dw)) throw RangeError("Format string contains an unescaped latin alphabet character `" + a + "`");
			if (n === "''" ? n = "'" : a === "'" && (n = pw(n)), e.indexOf(n) === 0) e = e.slice(n.length);
			else return i();
		}
	}
	if (e.length > 0 && uw.test(e)) return i();
	let p = u.map((e) => e.priority).sort((e, t) => t - e).filter((e, t, n) => n.indexOf(e) === t).map((e) => u.filter((t) => t.priority === e).sort((e, t) => t.subPriority - e.subPriority)).map((e) => e[0]), m = Tx(n, r?.in);
	if (isNaN(+m)) return i();
	let h = {};
	for (let e of p) {
		if (!e.validate(m, l)) return i();
		let t = e.set(m, h, l);
		Array.isArray(t) ? (m = t[0], Object.assign(h, t[1])) : m = t;
	}
	return m;
}
function pw(e) {
	return e.match(cw)[1].replace(lw, "'");
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/isSameQuarter.js
function mw(e, t, n) {
	let [r, i] = Lx(n?.in, e, t);
	return +Zx(r) == +Zx(i);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/subDays.js
function hw(e, t, n) {
	return Ex(e, -t, n);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/setMonth.js
function gw(e, t, n) {
	let r = Tx(e, n?.in), i = r.getFullYear(), a = r.getDate(), o = wx(n?.in || e, 0);
	o.setFullYear(i, t, 15), o.setHours(0, 0, 0, 0);
	let s = qS(o);
	return r.setMonth(t, Math.min(a, s)), r;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/set.js
function _w(e, t, n) {
	let r = Tx(e, n?.in);
	return isNaN(+r) ? wx(n?.in || e, NaN) : (t.year != null && r.setFullYear(t.year), t.month != null && (r = gw(r, t.month)), t.date != null && r.setDate(t.date), t.hours != null && r.setHours(t.hours), t.minutes != null && r.setMinutes(t.minutes), t.seconds != null && r.setSeconds(t.seconds), t.milliseconds != null && r.setMilliseconds(t.milliseconds), r);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/setHours.js
function vw(e, t, n) {
	let r = Tx(e, n?.in);
	return r.setHours(t), r;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/setMilliseconds.js
function yw(e, t, n) {
	let r = Tx(e, n?.in);
	return r.setMilliseconds(t), r;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/setMinutes.js
function bw(e, t, n) {
	let r = Tx(e, n?.in);
	return r.setMinutes(t), r;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/setSeconds.js
function xw(e, t, n) {
	let r = Tx(e, n?.in);
	return r.setSeconds(t), r;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/setYear.js
function Sw(e, t, n) {
	let r = Tx(e, n?.in);
	return isNaN(+r) ? wx(n?.in || e, NaN) : (r.setFullYear(t), r);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/subMonths.js
function Cw(e, t, n) {
	return Dx(e, -t, n);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/sub.js
function ww(e, t, n) {
	let { years: r = 0, months: i = 0, weeks: a = 0, days: o = 0, hours: s = 0, minutes: c = 0, seconds: l = 0 } = t, u = hw(Cw(e, i + r * 12, n), o + a * 7, n), d = (l + (c + s * 60) * 60) * 1e3;
	return wx(n?.in || e, +u - d);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/subYears.js
function Tw(e, t, n) {
	return Hx(e, -t, n);
}
//#endregion
//#region ../../node_modules/.pnpm/@vuepic+vue-datepicker@11.0.1_vue@3.5.41_typescript@6.0.3_/node_modules/@vuepic/vue-datepicker/dist/vue-datepicker.js
function Ew() {
	let e = se();
	return A(), o("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32",
		fill: "currentColor",
		"aria-hidden": "true",
		class: "dp__icon",
		role: "img",
		...e
	}, [
		s("path", { d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z" }),
		s("path", { d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z" }),
		s("path", { d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z" }),
		s("path", { d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z" })
	]);
}
Ew.compatConfig = { MODE: 3 };
function Dw() {
	return A(), o("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32",
		fill: "currentColor",
		"aria-hidden": "true",
		class: "dp__icon",
		role: "img"
	}, [s("path", { d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z" }), s("path", { d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z" })]);
}
Dw.compatConfig = { MODE: 3 };
function Ow() {
	return A(), o("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32",
		fill: "currentColor",
		"aria-hidden": "true",
		class: "dp__icon",
		role: "img"
	}, [s("path", { d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z" })]);
}
Ow.compatConfig = { MODE: 3 };
function kw() {
	return A(), o("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32",
		fill: "currentColor",
		"aria-hidden": "true",
		class: "dp__icon",
		role: "img"
	}, [s("path", { d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z" })]);
}
kw.compatConfig = { MODE: 3 };
function Aw() {
	return A(), o("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32",
		fill: "currentColor",
		"aria-hidden": "true",
		class: "dp__icon",
		role: "img"
	}, [s("path", { d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z" }), s("path", { d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z" })]);
}
Aw.compatConfig = { MODE: 3 };
function jw() {
	return A(), o("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32",
		fill: "currentColor",
		"aria-hidden": "true",
		class: "dp__icon",
		role: "img"
	}, [s("path", { d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z" })]);
}
jw.compatConfig = { MODE: 3 };
function Mw() {
	return A(), o("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 32 32",
		fill: "currentColor",
		"aria-hidden": "true",
		class: "dp__icon",
		role: "img"
	}, [s("path", { d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z" })]);
}
Mw.compatConfig = { MODE: 3 };
var Nw = (e, t) => t ? new Date(e.toLocaleString("en-US", { timeZone: t })) : new Date(e), Pw = (e, t, n) => Iw(e, t, n) || Y(), Fw = (e, t, n) => {
	let r = t.dateInTz ? Nw(new Date(e), t.dateInTz) : Y(e);
	return n ? ET(r, !0) : r;
}, Iw = (e, t, n) => {
	if (!e) return null;
	let r = n ? ET(Y(e), !0) : Y(e);
	return t ? t.exactMatch ? Fw(e, t, n) : Nw(r, t.timezone) : r;
}, Lw = (e) => {
	let t = new Date(e.getFullYear(), 0, 1).getTimezoneOffset();
	return e.getTimezoneOffset() < t;
}, Rw = (e, t) => {
	if (!e) return 0;
	let n = /* @__PURE__ */ new Date(), r = new Date(n.toLocaleString("en-US", { timeZone: "UTC" })), i = new Date(n.toLocaleString("en-US", { timeZone: e })), a = (Lw(t ?? i) ? i : t ?? i).getTimezoneOffset() / 60;
	return (r - +i) / 36e5 - a;
}, zw = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(zw || {}), Bw = /* @__PURE__ */ ((e) => (e.top = "top", e.bottom = "bottom", e))(Bw || {}), Vw = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(Vw || {}), Hw = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(Hw || {}), Uw = [
	"timestamp",
	"date",
	"iso"
], Ww = /* @__PURE__ */ ((e) => (e.up = "up", e.down = "down", e.left = "left", e.right = "right", e))(Ww || {}), Gw = /* @__PURE__ */ ((e) => (e.arrowUp = "ArrowUp", e.arrowDown = "ArrowDown", e.arrowLeft = "ArrowLeft", e.arrowRight = "ArrowRight", e.enter = "Enter", e.space = " ", e.esc = "Escape", e.tab = "Tab", e.home = "Home", e.end = "End", e.pageUp = "PageUp", e.pageDown = "PageDown", e))(Gw || {}), Kw = /* @__PURE__ */ ((e) => (e.MONTH_AND_YEAR = "MM-yyyy", e.YEAR = "yyyy", e.DATE = "dd-MM-yyyy", e))(Kw || {});
function qw(e) {
	return (t) => new Intl.DateTimeFormat(e, {
		weekday: "short",
		timeZone: "UTC"
	}).format(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`)).slice(0, 2);
}
function Jw(e) {
	return (t) => WS(Nw(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`), "UTC"), "EEEEEE", { locale: e });
}
var Yw = (e, t, n) => {
	let r = [
		1,
		2,
		3,
		4,
		5,
		6,
		7
	], i;
	if (e !== null) try {
		i = r.map(Jw(e));
	} catch {
		i = r.map(qw(t));
	}
	else i = r.map(qw(t));
	let a = i.slice(0, n), o = i.slice(n + 1, i.length);
	return [i[n]].concat(...o, ...a);
}, Xw = (e, t, n) => {
	let r = [];
	for (let n = +e[0]; n <= +e[1]; n++) r.push({
		value: +n,
		text: mT(n, t)
	});
	return n ? r.reverse() : r;
}, Zw = (e, t, n) => {
	let r = [
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11,
		12
	].map((e) => {
		let t = e < 10 ? `0${e}` : e;
		return /* @__PURE__ */ new Date(`2017-${t}-01T00:00:00+00:00`);
	});
	if (e !== null) try {
		let t = n === "long" ? "LLLL" : "LLL";
		return r.map((n, r) => {
			let i = WS(Nw(n, "UTC"), t, { locale: e });
			return {
				text: i.charAt(0).toUpperCase() + i.substring(1),
				value: r
			};
		});
	} catch {}
	let i = new Intl.DateTimeFormat(t, {
		month: n,
		timeZone: "UTC"
	});
	return r.map((e, t) => {
		let n = i.format(e);
		return {
			text: n.charAt(0).toUpperCase() + n.substring(1),
			value: t
		};
	});
}, Qw = (e) => [
	12,
	1,
	2,
	3,
	4,
	5,
	6,
	7,
	8,
	9,
	10,
	11,
	12,
	1,
	2,
	3,
	4,
	5,
	6,
	7,
	8,
	9,
	10,
	11
][e], $w = (e) => {
	let t = L(e);
	return t != null && t.$el ? t?.$el : t;
}, eT = (e) => ({
	type: "dot",
	...e ?? {}
}), tT = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : !1, nT = {
	prop: (e) => `"${e}" prop must be enabled!`,
	dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, rT = (e) => e, iT = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, aT = (e) => e === null, oT = (e) => {
	if (e) return [...e.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, sT = (e) => {
	let t = [], n = (e) => e.filter((e) => e);
	for (let r = 0; r < e.length; r += 3) {
		let i = [
			e[r],
			e[r + 1],
			e[r + 2]
		];
		t.push(n(i));
	}
	return t;
}, cT = (e, t, n) => {
	let r = n != null, i = t != null;
	if (!r && !i) return !1;
	let a = +n, o = +t;
	return r && i ? +e > a || +e < o : r ? +e > a : i ? +e < o : !1;
}, lT = (e, t) => sT(e).map((e) => e.map((e) => {
	let { active: n, disabled: r, isBetween: i, highlighted: a } = t(e);
	return {
		...e,
		active: n,
		disabled: r,
		className: {
			dp__overlay_cell_active: n,
			dp__overlay_cell: !n,
			dp__overlay_cell_disabled: r,
			dp__overlay_cell_pad: !0,
			dp__overlay_cell_active_disabled: r && n,
			dp__cell_in_between: i,
			"dp--highlighted": a
		}
	};
})), uT = (e, t, n = !1) => {
	e && t.allowStopPropagation && (n && e.stopImmediatePropagation(), e.stopPropagation());
}, dT = () => [
	"a[href]",
	"area[href]",
	"input:not([disabled]):not([type='hidden'])",
	"select:not([disabled])",
	"textarea:not([disabled])",
	"button:not([disabled])",
	"[tabindex]:not([tabindex='-1'])",
	"[data-datepicker-instance]"
].join(", ");
function fT(e, t) {
	let n = [...document.querySelectorAll(dT())];
	n = n.filter((t) => !e.contains(t) || t.hasAttribute("data-datepicker-instance"));
	let r = n.indexOf(e);
	if (r >= 0 && (t ? r - 1 >= 0 : r + 1 <= n.length)) return n[r + (t ? -1 : 1)];
}
var pT = (e, t) => e?.querySelector(`[data-dp-element="${t}"]`), mT = (e, t) => new Intl.NumberFormat(t, {
	useGrouping: !1,
	style: "decimal"
}).format(e), hT = (e, t) => WS(e, t ?? Kw.DATE), gT = (e) => Array.isArray(e), _T = (e, t, n) => t.get(hT(e, n)), vT = (e, t) => e ? t ? t instanceof Map ? !!_T(e, t) : t(Y(e)) : !1 : !0, yT = (e, t, n = !1, r) => {
	if (e.key === Gw.enter || e.key === Gw.space) return n && e.preventDefault(), t();
	if (r) return r(e);
}, bT = () => "ontouchstart" in window || navigator.maxTouchPoints > 0, xT = (e, t) => e ? Kw.MONTH_AND_YEAR : t ? Kw.YEAR : Kw.DATE, ST = (e) => e < 10 ? `0${e}` : e, CT = (e, t, n, r, i, a) => {
	let o = fw(e, t.slice(0, e.length), /* @__PURE__ */ new Date(), { locale: a });
	return Gx(o) && Wx(o) ? r || i ? o : _w(o, {
		hours: +n.hours,
		minutes: +n?.minutes,
		seconds: +n?.seconds,
		milliseconds: 0
	}) : null;
}, wT = (e, t, n, r, i, a) => {
	let o = Array.isArray(n) ? n[0] : n;
	if (typeof t == "string") return CT(e, t, o, r, i, a);
	if (Array.isArray(t)) {
		let n = null;
		for (let s of t) if (n = CT(e, s, o, r, i, a), n) break;
		return n;
	}
	return typeof t == "function" ? t(e) : null;
}, Y = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), TT = (e, t, n) => {
	if (t) {
		let t = (e.getMonth() + 1).toString().padStart(2, "0"), r = e.getDate().toString().padStart(2, "0"), i = e.getHours().toString().padStart(2, "0"), a = e.getMinutes().toString().padStart(2, "0"), o = n ? e.getSeconds().toString().padStart(2, "0") : "00";
		return `${e.getFullYear()}-${t}-${r}T${i}:${a}:${o}.000Z`;
	}
	let r = Date.UTC(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate(), e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds());
	return new Date(r).toISOString();
}, ET = (e, t) => {
	let n = _w(Y(JSON.parse(JSON.stringify(e))), {
		hours: 0,
		minutes: 0,
		seconds: 0,
		milliseconds: 0
	});
	return t ? $x(n) : n;
}, DT = (e, t, n, r) => {
	let i = e ? Y(e) : Y();
	return (t || t === 0) && (i = vw(i, +t)), (n || n === 0) && (i = bw(i, +n)), (r || r === 0) && (i = xw(i, +r)), yw(i, 0);
}, OT = (e, t) => !e || !t ? !1 : nC(ET(e), ET(t)), kT = (e, t) => !e || !t ? !1 : rC(ET(e), ET(t)), AT = (e, t) => !e || !t ? !1 : tC(ET(e), ET(t)), jT = (e, t, n) => e != null && e[0] && e != null && e[1] ? AT(n, e[0]) && OT(n, e[1]) : e != null && e[0] && t ? AT(n, e[0]) && OT(n, t) || OT(n, e[0]) && AT(n, t) : !1, MT = (e) => ET(_w(new Date(e), { date: 1 })), NT = (e, t, n) => t && (n || n === 0) ? Object.fromEntries([
	"hours",
	"minutes",
	"seconds"
].map((r) => r === t ? [r, n] : [r, isNaN(+e[r]) ? void 0 : +e[r]])) : {
	hours: isNaN(+e.hours) ? void 0 : +e.hours,
	minutes: isNaN(+e.minutes) ? void 0 : +e.minutes,
	seconds: isNaN(+e.seconds) ? void 0 : +e.seconds
}, PT = (e) => ({
	hours: YS(e),
	minutes: ZS(e),
	seconds: $S(e)
}), FT = (e, t) => {
	if (t) {
		let n = eC(Y(t));
		if (n > e) return 12;
		if (n === e) return QS(Y(t));
	}
}, IT = (e, t) => {
	if (t) {
		let n = eC(Y(t));
		return n < e ? -1 : n === e ? QS(Y(t)) : void 0;
	}
}, LT = (e) => {
	if (e) return eC(Y(e));
}, RT = (e, t) => Xx({
	start: AT(e, t) ? t : e,
	end: AT(t, e) ? t : e
}), zT = (e) => {
	let t = Dx(e, 1);
	return {
		month: QS(t),
		year: eC(t)
	};
}, BT = (e, t) => [Nx(e, { weekStartsOn: +t }), nS(e, { weekStartsOn: +t })], VT = (e, t) => {
	let n = {
		hours: YS(Y()),
		minutes: ZS(Y()),
		seconds: t ? $S(Y()) : 0
	};
	return Object.assign(n, e);
}, HT = (e, t, n) => [_w(Y(e), { date: 1 }), _w(Y(), {
	month: t,
	year: n,
	date: 1
})], UT = (e, t, n) => {
	let r = e ? Y(e) : Y();
	return (t || t === 0) && (r = gw(r, t)), n && (r = Sw(r, n)), r;
}, WT = (e, t, n, r, i) => {
	if (!r || i && !t || !i && !n) return !1;
	let a = i ? Dx(e, 1) : Cw(e, 1), o = [QS(a), eC(a)];
	return i ? !KT(...o, t) : !GT(...o, n);
}, GT = (e, t, n) => OT(...HT(n, e, t)) || kT(...HT(n, e, t)), KT = (e, t, n) => AT(...HT(n, e, t)) || kT(...HT(n, e, t)), qT = (e, t, n, r, i, a, o) => {
	if (typeof t == "function" && !o) return t(e);
	let s = n ? { locale: n } : void 0;
	return Array.isArray(e) ? `${WS(e[0], a, s)}${i && !e[1] ? "" : r}${e[1] ? WS(e[1], a, s) : ""}` : WS(e, a, s);
}, JT = (e) => {
	if (e) return null;
	throw Error(nT.prop("partial-range"));
}, YT = (e, t) => {
	if (t) return e();
	throw Error(nT.prop("range"));
}, XT = (e) => Array.isArray(e) ? Gx(e[0]) && (!e[1] || Gx(e[1])) : e ? Gx(e) : !1, ZT = (e, t) => _w(t ?? Y(), {
	hours: +e.hours || 0,
	minutes: +e.minutes || 0,
	seconds: +e.seconds || 0
}), QT = (e, t, n, r) => {
	if (!e) return !0;
	if (r) {
		let r = n === "max" ? nC(e, t) : tC(e, t), i = {
			seconds: 0,
			milliseconds: 0
		};
		return r || rC(_w(e, i), _w(t, i));
	}
	return n === "max" ? e.getTime() <= t.getTime() : e.getTime() >= t.getTime();
}, $T = (e, t, n) => e ? ZT(e, t) : Y(n ?? t), eE = (e, t, n, r, i) => {
	if (Array.isArray(r)) {
		let a = $T(e, r[0], t), o = $T(e, r[1], t);
		return QT(r[0], a, n, !!t) && QT(r[1], o, n, !!t) && i;
	}
	return QT(r, $T(e, r, t), n, !!t) && i;
}, tE = (e) => _w(Y(), PT(e)), nE = (e, t, n) => {
	if (e instanceof Map) {
		let r = `${ST(n + 1)}-${t}`;
		return e.size ? e.has(r) : !1;
	}
	return !1;
}, rE = (e, t, n) => {
	if (e instanceof Map) {
		let r = `${ST(n + 1)}-${t}`;
		return !e.size || e.has(r);
	}
	return !0;
}, iE = (e, t, n) => typeof e == "function" ? e({
	month: t,
	year: n
}) : !!e.months.find((e) => e.month === t && e.year === n), aE = (e, t) => typeof e == "function" ? e(t) : e.years.includes(t), oE = (e) => `dp-${WS(e, "yyyy-MM-dd")}`, sE = (e, t) => ({
	before: hw(ET(t), e),
	after: Ex(ET(t), e)
}), cE = te({
	menuFocused: !1,
	shiftKeyInMenu: !1
}), lE = () => ({
	control: r(() => ({
		shiftKeyInMenu: cE.shiftKeyInMenu,
		menuFocused: cE.menuFocused
	})),
	setMenuFocused: (e) => {
		cE.menuFocused = e;
	},
	setShiftKey: (e) => {
		cE.shiftKeyInMenu !== e && (cE.shiftKeyInMenu = e);
	}
}), uE = te({
	monthYear: [],
	calendar: [],
	time: [],
	actionRow: [],
	selectionGrid: [],
	timePicker: {
		0: [],
		1: []
	},
	monthPicker: []
}), dE = M(null), fE = M(!1), pE = M(!1), mE = M(!1), hE = M(!1), gE = M(0), _E = M(0), vE = () => {
	let e = r(() => fE.value ? [...uE.selectionGrid, uE.actionRow].filter((e) => e.length) : pE.value ? [
		...uE.timePicker[0],
		...uE.timePicker[1],
		hE.value ? [] : [dE.value],
		uE.actionRow
	].filter((e) => e.length) : mE.value ? [...uE.monthPicker, uE.actionRow] : [
		uE.monthYear,
		...uE.calendar,
		uE.time,
		uE.actionRow
	].filter((e) => e.length)), t = (t) => {
		gE.value = t ? gE.value + 1 : gE.value - 1;
		let n = null;
		e.value[_E.value] && (n = e.value[_E.value][gE.value]), !n && e.value[_E.value + (t ? 1 : -1)] ? (_E.value += t ? 1 : -1, gE.value = t ? 0 : e.value[_E.value].length - 1) : n || (gE.value = t ? gE.value - 1 : gE.value + 1);
	}, n = (t) => {
		_E.value === 0 && !t || _E.value === e.value.length && t || (_E.value = t ? _E.value + 1 : _E.value - 1, e.value[_E.value] ? e.value[_E.value] && !e.value[_E.value][gE.value] && gE.value !== 0 && (gE.value = e.value[_E.value].length - 1) : _E.value = t ? _E.value - 1 : _E.value + 1);
	}, i = (t) => {
		let n = null;
		e.value[_E.value] && (n = e.value[_E.value][gE.value]), n ? n.focus({ preventScroll: !fE.value }) : gE.value = t ? gE.value - 1 : gE.value + 1;
	}, a = () => {
		t(!0), i(!0);
	}, o = () => {
		t(!1), i(!1);
	}, s = () => {
		n(!1), i(!0);
	}, c = () => {
		n(!0), i(!0);
	}, l = (e, t) => {
		uE[t] = e;
	}, u = (e, t) => {
		uE[t] = e;
	}, d = () => {
		gE.value = 0, _E.value = 0;
	};
	return {
		buildMatrix: l,
		buildMultiLevelMatrix: u,
		setTimePickerBackRef: (e) => {
			dE.value = e;
		},
		setSelectionGrid: (e) => {
			fE.value = e, d(), e || (uE.selectionGrid = []);
		},
		setTimePicker: (e, t = !1) => {
			pE.value = e, hE.value = t, d(), e || (uE.timePicker[0] = [], uE.timePicker[1] = []);
		},
		setTimePickerElements: (e, t = 0) => {
			uE.timePicker[t] = e;
		},
		arrowRight: a,
		arrowLeft: o,
		arrowUp: s,
		arrowDown: c,
		clearArrowNav: () => {
			uE.monthYear = [], uE.calendar = [], uE.time = [], uE.actionRow = [], uE.selectionGrid = [], uE.timePicker[0] = [], uE.timePicker[1] = [], fE.value = !1, pE.value = !1, hE.value = !1, mE.value = !1, d(), dE.value = null;
		},
		setMonthPicker: (e) => {
			mE.value = e, d();
		},
		refSets: uE
	};
}, yE = (e) => ({
	menuAppearTop: "dp-menu-appear-top",
	menuAppearBottom: "dp-menu-appear-bottom",
	open: "dp-slide-down",
	close: "dp-slide-up",
	next: "calendar-next",
	previous: "calendar-prev",
	vNext: "dp-slide-up",
	vPrevious: "dp-slide-down",
	...e ?? {}
}), bE = (e) => ({
	toggleOverlay: "Toggle overlay",
	menu: "Datepicker menu",
	input: "Datepicker input",
	openTimePicker: "Open time picker",
	closeTimePicker: "Close time Picker",
	incrementValue: (e) => `Increment ${e}`,
	decrementValue: (e) => `Decrement ${e}`,
	openTpOverlay: (e) => `Open ${e} overlay`,
	amPmButton: "Switch AM/PM mode",
	openYearsOverlay: "Open years overlay",
	openMonthsOverlay: "Open months overlay",
	nextMonth: "Next month",
	prevMonth: "Previous month",
	nextYear: "Next year",
	prevYear: "Previous year",
	day: void 0,
	weekDay: void 0,
	clearInput: "Clear value",
	calendarIcon: "Calendar icon",
	timePicker: "Time picker",
	monthPicker: (e) => `Month picker${e ? " overlay" : ""}`,
	yearPicker: (e) => `Year picker${e ? " overlay" : ""}`,
	timeOverlay: (e) => `${e} overlay`,
	...e ?? {}
}), xE = (e) => e ? typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2 : 0, SE = (e) => {
	let t = typeof e == "object" && e, n = {
		static: !0,
		solo: !1
	};
	if (!e) return {
		...n,
		count: xE(!1)
	};
	let r = t ? e : {}, i = xE(t ? r.count ?? !0 : e);
	return Object.assign(n, r, { count: i });
}, CE = (e, t, n) => e || (typeof n == "string" ? n : t), wE = (e) => typeof e == "boolean" ? e ? yE({}) : !1 : yE(e), TE = (e) => {
	let t = {
		enterSubmit: !0,
		tabSubmit: !0,
		openMenu: "open",
		selectOnFocus: !1,
		rangeSeparator: " - ",
		escClose: !0
	};
	return typeof e == "object" ? {
		...t,
		...e ?? {},
		enabled: !0
	} : {
		...t,
		enabled: e
	};
}, EE = (e) => ({
	months: [],
	years: [],
	times: {
		hours: [],
		minutes: [],
		seconds: []
	},
	...e ?? {}
}), DE = (e) => ({
	showSelect: !0,
	showCancel: !0,
	showNow: !1,
	showPreview: !0,
	...e ?? {}
}), OE = (e) => {
	let t = { input: !1 };
	return typeof e == "object" ? {
		...t,
		...e ?? {},
		enabled: !0
	} : {
		enabled: e,
		...t
	};
}, kE = (e) => ({
	allowStopPropagation: !0,
	closeOnScroll: !1,
	modeHeight: 255,
	allowPreventDefault: !1,
	closeOnClearValue: !0,
	closeOnAutoApply: !0,
	noSwipe: !1,
	keepActionRow: !1,
	onClickOutside: void 0,
	tabOutClosesMenu: !0,
	arrowLeft: void 0,
	keepViewOnOffsetClick: !1,
	timeArrowHoldThreshold: 0,
	shadowDom: !1,
	mobileBreakpoint: 600,
	setDateOnMenuClose: !1,
	...e ?? {}
}), AE = (e) => {
	let t = {
		dates: Array.isArray(e) ? e.map((e) => Y(e)) : [],
		years: [],
		months: [],
		quarters: [],
		weeks: [],
		weekdays: [],
		options: { highlightDisabled: !1 }
	};
	return typeof e == "function" ? e : {
		...t,
		...e ?? {}
	};
}, jE = (e) => typeof e == "object" ? {
	type: e?.type ?? "local",
	hideOnOffsetDates: e?.hideOnOffsetDates ?? !1
} : {
	type: e,
	hideOnOffsetDates: !1
}, ME = (e) => {
	let t = {
		noDisabledRange: !1,
		showLastInRange: !0,
		minMaxRawRange: !1,
		partialRange: !0,
		disableTimeRangeValidation: !1,
		maxRange: void 0,
		minRange: void 0,
		autoRange: void 0,
		fixedStart: !1,
		fixedEnd: !1
	};
	return typeof e == "object" ? {
		enabled: !0,
		...t,
		...e
	} : {
		enabled: e,
		...t
	};
}, NE = (e) => e ? typeof e == "string" ? {
	timezone: e,
	exactMatch: !1,
	dateInTz: void 0,
	emitTimezone: void 0,
	convertModel: !0
} : {
	timezone: e.timezone,
	exactMatch: e.exactMatch ?? !1,
	dateInTz: e.dateInTz ?? void 0,
	emitTimezone: e.emitTimezone ?? void 0,
	convertModel: e.convertModel ?? !0
} : {
	timezone: void 0,
	exactMatch: !1,
	emitTimezone: void 0
}, PE = (e, t, n, r) => new Map(e.map((e) => {
	let i = Pw(e, t, r);
	return [hT(i, n), i];
})), FE = (e, t) => e.length ? new Map(e.map((e) => [hT(Pw(e.date, t), Kw.DATE), e])) : null, IE = (e) => {
	let t = xT(e.isMonthPicker, e.isYearPicker);
	return {
		minDate: Iw(e.minDate, e.timezone, e.isSpecific),
		maxDate: Iw(e.maxDate, e.timezone, e.isSpecific),
		disabledDates: gT(e.disabledDates) ? PE(e.disabledDates, e.timezone, t, e.isSpecific) : e.disabledDates,
		allowedDates: gT(e.allowedDates) ? PE(e.allowedDates, e.timezone, t, e.isSpecific) : null,
		highlight: typeof e.highlight == "object" && gT(e.highlight?.dates) ? PE(e.highlight.dates, e.timezone, t) : e.highlight,
		markers: FE(e.markers, e.timezone)
	};
}, LE = (e) => typeof e == "boolean" ? {
	enabled: e,
	dragSelect: !0,
	limit: null
} : {
	enabled: !!e,
	limit: e.limit ? +e.limit : null,
	dragSelect: e.dragSelect ?? !0
}, RE = (e) => ({ ...Object.fromEntries(Object.keys(e).map((t) => {
	let n = t, r = e[n];
	return [t, typeof e[n] == "string" ? { [r]: !0 } : Object.fromEntries(r.map((e) => [e, !0]))];
})) }), zE = (e) => {
	let t = () => {
		let t = e.enableSeconds ? ":ss" : "", n = e.enableMinutes ? ":mm" : "";
		return e.is24 ? `HH${n}${t}` : `hh${n}${t} aa`;
	}, n = () => e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? t() : e.weekPicker ? `${_.value?.type === "iso" ? "II" : "ww"}-RR` : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${t()}` : "MM/dd/yyyy", i = (t) => VT(t, e.enableSeconds), a = () => x.value.enabled ? e.startTime && Array.isArray(e.startTime) ? [i(e.startTime[0]), i(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? i(e.startTime) : null, o = r(() => SE(e.multiCalendars)), s = r(() => a()), c = r(() => bE(e.ariaLabels)), l = r(() => EE(e.filters)), u = r(() => wE(e.transitions)), d = r(() => DE(e.actionRow)), f = r(() => CE(e.previewFormat, e.format, n())), p = r(() => TE(e.textInput)), m = r(() => OE(e.inline)), h = r(() => kE(e.config)), g = r(() => AE(e.highlight)), _ = r(() => jE(e.weekNumbers)), v = r(() => NE(e.timezone)), y = r(() => LE(e.multiDates)), b = r(() => IE({
		minDate: e.minDate,
		maxDate: e.maxDate,
		disabledDates: e.disabledDates,
		allowedDates: e.allowedDates,
		highlight: g.value,
		markers: e.markers,
		timezone: v.value,
		isSpecific: e.monthPicker || e.yearPicker || e.quarterPicker,
		isMonthPicker: e.monthPicker,
		isYearPicker: e.yearPicker
	})), x = r(() => ME(e.range));
	return {
		defaultedTransitions: u,
		defaultedMultiCalendars: o,
		defaultedStartTime: s,
		defaultedAriaLabels: c,
		defaultedFilters: l,
		defaultedActionRow: d,
		defaultedPreviewFormat: f,
		defaultedTextInput: p,
		defaultedInline: m,
		defaultedConfig: h,
		defaultedHighlight: g,
		defaultedWeekNumbers: _,
		defaultedRange: x,
		propDates: b,
		defaultedTz: v,
		defaultedMultiDates: y,
		defaultedUI: r(() => RE(e.ui)),
		getDefaultPattern: n,
		getDefaultStartTime: a
	};
}, BE = (e, t, n) => {
	let r = M(), { defaultedTextInput: i, defaultedRange: a, defaultedTz: o, defaultedMultiDates: s, getDefaultPattern: c } = zE(t), l = M(""), u = ae(t, "format"), d = ae(t, "formatLocale");
	z(r, () => {
		typeof t.onInternalModelChange == "function" && e("internal-model-change", r.value, L(!0));
	}, { deep: !0 }), z(a, (e, t) => {
		e.enabled !== t.enabled && (r.value = null);
	}), z(u, () => {
		ne();
	});
	let f = (e) => o.value.timezone && o.value.convertModel ? Nw(e, o.value.timezone) : e, p = (e) => o.value.timezone && o.value.convertModel ? Ax(e, Rw(o.value.timezone, e)) : e, m = (e, n, r = !1) => qT(e, t.format, t.formatLocale, i.value.rangeSeparator, t.modelAuto, n ?? c(), r), h = (e) => e ? t.modelType ? P(e) : {
		hours: YS(e),
		minutes: ZS(e),
		seconds: t.enableSeconds ? $S(e) : 0
	} : null, g = (e) => t.modelType ? P(e) : {
		month: QS(e),
		year: eC(e)
	}, _ = (e) => Array.isArray(e) ? s.value.enabled ? e.map((e) => v(e, Sw(Y(), e))) : YT(() => [Sw(Y(), e[0]), e[1] ? Sw(Y(), e[1]) : JT(a.value.partialRange)], a.value.enabled) : Sw(Y(), +e), v = (e, n) => (typeof e == "string" || typeof e == "number") && t.modelType ? N(e) : n, y = (e) => Array.isArray(e) ? [v(e[0], DT(null, +e[0].hours, +e[0].minutes, e[0].seconds)), v(e[1], DT(null, +e[1].hours, +e[1].minutes, e[1].seconds))] : v(e, DT(null, e.hours, e.minutes, e.seconds)), b = (e) => {
		let t = _w(Y(), { date: 1 });
		return Array.isArray(e) ? s.value.enabled ? e.map((e) => v(e, UT(t, +e.month, +e.year))) : YT(() => [v(e[0], UT(t, +e[0].month, +e[0].year)), v(e[1], e[1] ? UT(t, +e[1].month, +e[1].year) : JT(a.value.partialRange))], a.value.enabled) : v(e, UT(t, +e.month, +e.year));
	}, x = (e) => {
		if (Array.isArray(e)) return e.map((e) => N(e));
		throw Error(nT.dateArr("multi-dates"));
	}, S = (e) => {
		if (Array.isArray(e) && a.value.enabled) {
			let t = e[0], n = e[1];
			return [Y(Array.isArray(t) ? t[0] : null), Array.isArray(n) && n.length ? Y(n[0]) : null];
		}
		return Y(e[0]);
	}, C = (e) => t.modelAuto ? Array.isArray(e) ? [N(e[0]), N(e[1])] : t.autoApply ? [N(e)] : [N(e), null] : Array.isArray(e) ? YT(() => e[1] ? [N(e[0]), e[1] ? N(e[1]) : JT(a.value.partialRange)] : [N(e[0])], a.value.enabled) : N(e), w = () => {
		Array.isArray(r.value) && a.value.enabled && r.value.length === 1 && r.value.push(JT(a.value.partialRange));
	}, T = () => {
		let e = r.value;
		return [P(e[0]), e[1] ? P(e[1]) : JT(a.value.partialRange)];
	}, E = () => r.value[1] ? T() : P(rT(r.value[0])), D = () => (r.value || []).map((e) => P(e)), O = (e = !1) => (e || w(), t.modelAuto ? E() : s.value.enabled ? D() : Array.isArray(r.value) ? YT(() => T(), a.value.enabled) : P(rT(r.value))), k = (e) => !e || Array.isArray(e) && !e.length ? null : t.timePicker ? y(rT(e)) : t.monthPicker ? b(rT(e)) : t.yearPicker ? _(rT(e)) : s.value.enabled ? x(rT(e)) : t.weekPicker ? S(rT(e)) : C(rT(e)), ee = (e) => {
		let t = k(e);
		XT(rT(t)) ? (r.value = rT(t), ne()) : (r.value = null, l.value = "");
	}, A = () => {
		let e = (e) => WS(e, i.value.format);
		return `${e(r.value[0])} ${i.value.rangeSeparator} ${r.value[1] ? e(r.value[1]) : ""}`;
	}, j = () => n.value && r.value ? Array.isArray(r.value) ? A() : WS(r.value, i.value.format) : m(r.value), te = () => r.value ? s.value.enabled ? r.value.map((e) => m(e)).join("; ") : i.value.enabled && typeof i.value.format == "string" ? j() : m(r.value) : "", ne = () => {
		!t.format || typeof t.format == "string" || i.value.enabled && typeof i.value.format == "string" ? l.value = te() : l.value = t.format(r.value);
	}, N = (e) => {
		if (t.utc) {
			let n = new Date(e);
			return t.utc === "preserve" ? new Date(n.getTime() + n.getTimezoneOffset() * 6e4) : n;
		}
		return t.modelType ? Uw.includes(t.modelType) ? f(new Date(e)) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? f(fw(e, c(), /* @__PURE__ */ new Date(), { locale: d.value })) : f(fw(e, t.modelType, /* @__PURE__ */ new Date(), { locale: d.value })) : f(new Date(e));
	}, P = (e) => e ? t.utc ? TT(e, t.utc === "preserve", t.enableSeconds) : t.modelType ? t.modelType === "timestamp" ? +p(e) : t.modelType === "iso" ? p(e).toISOString() : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? m(p(e)) : m(p(e), t.modelType, !0) : p(e) : "", F = (t, n = !1, r = !1) => {
		if (r) return t;
		e("update:model-value", t), o.value.emitTimezone && n && e("update:model-timezone-value", Array.isArray(t) ? t.map((e) => Nw(rT(e), o.value.emitTimezone)) : Nw(rT(t), o.value.emitTimezone));
	}, re = (e) => Array.isArray(r.value) ? s.value.enabled ? r.value.map((t) => e(t)) : [e(r.value[0]), r.value[1] ? e(r.value[1]) : JT(a.value.partialRange)] : e(rT(r.value)), ie = () => {
		if (Array.isArray(r.value)) {
			let e = BT(r.value[0], t.weekStart), n = r.value[1] ? BT(r.value[1], t.weekStart) : [];
			return [e.map((e) => Y(e)), n.map((e) => Y(e))];
		}
		return BT(r.value, t.weekStart).map((e) => Y(e));
	}, I = (e, t) => F(rT(re(e)), !1, t), oe = (t) => {
		let n = ie();
		return t ? n : e("update:model-value", ie());
	}, L = (e = !1) => (e || ne(), t.monthPicker ? I(g, e) : t.timePicker ? I(h, e) : t.yearPicker ? I(eC, e) : t.weekPicker ? oe(e) : F(O(e), !0, e));
	return {
		inputValue: l,
		internalModelValue: r,
		checkBeforeEmit: () => r.value ? a.value.enabled ? a.value.partialRange ? r.value.length >= 1 : r.value.length === 2 : !!r.value : !1,
		parseExternalModelValue: ee,
		formatInputValue: ne,
		emitModelValue: L
	};
}, VE = (e, t) => {
	let { defaultedFilters: n, propDates: i } = zE(e), { validateMonthYearInRange: a } = _O(e), o = (e, t) => {
		let r = e;
		return n.value.months.includes(QS(r)) ? (r = t ? Dx(e, 1) : Cw(e, 1), o(r, t)) : r;
	}, s = (e, t) => {
		let r = e;
		return n.value.years.includes(eC(r)) ? (r = t ? Hx(e, 1) : Tw(e, 1), s(r, t)) : r;
	}, c = (t, r = !1) => {
		let i = _w(Y(), {
			month: e.month,
			year: e.year
		}), c = t ? Dx(i, 1) : Cw(i, 1);
		e.disableYearSelect && (c = Sw(c, e.year));
		let u = QS(c), d = eC(c);
		n.value.months.includes(u) && (c = o(c, t), u = QS(c), d = eC(c)), n.value.years.includes(d) && (c = s(c, t), d = eC(c)), a(u, d, t, e.preventMinMaxNavigation) && l(u, d, r);
	}, l = (e, n, r) => {
		t("update-month-year", {
			month: e,
			year: n,
			fromNav: r
		});
	};
	return {
		handleMonthYearChange: c,
		isDisabled: r(() => (t) => WT(_w(Y(), {
			month: e.month,
			year: e.year
		}), i.value.maxDate, i.value.minDate, e.preventMinMaxNavigation, t)),
		updateMonthYear: l
	};
}, HE = {
	multiCalendars: {
		type: [
			Boolean,
			Number,
			String,
			Object
		],
		default: void 0
	},
	modelValue: {
		type: [
			String,
			Date,
			Array,
			Object,
			Number
		],
		default: null
	},
	modelType: {
		type: String,
		default: null
	},
	position: {
		type: String,
		default: "center"
	},
	dark: {
		type: Boolean,
		default: !1
	},
	format: {
		type: [String, Function],
		default: () => null
	},
	autoPosition: {
		type: [Boolean, String],
		default: !0
	},
	altPosition: {
		type: Function,
		default: null
	},
	transitions: {
		type: [Boolean, Object],
		default: !0
	},
	formatLocale: {
		type: Object,
		default: null
	},
	utc: {
		type: [Boolean, String],
		default: !1
	},
	ariaLabels: {
		type: Object,
		default: () => ({})
	},
	offset: {
		type: [Number, String],
		default: 10
	},
	hideNavigation: {
		type: Array,
		default: () => []
	},
	timezone: {
		type: [String, Object],
		default: null
	},
	vertical: {
		type: Boolean,
		default: !1
	},
	disableMonthYearSelect: {
		type: Boolean,
		default: !1
	},
	disableYearSelect: {
		type: Boolean,
		default: !1
	},
	dayClass: {
		type: Function,
		default: null
	},
	yearRange: {
		type: Array,
		default: () => [1900, 2100]
	},
	enableTimePicker: {
		type: Boolean,
		default: !0
	},
	autoApply: {
		type: Boolean,
		default: !1
	},
	disabledDates: {
		type: [Array, Function],
		default: () => []
	},
	monthNameFormat: {
		type: String,
		default: "short"
	},
	startDate: {
		type: [Date, String],
		default: null
	},
	startTime: {
		type: [Object, Array],
		default: null
	},
	hideOffsetDates: {
		type: Boolean,
		default: !1
	},
	noToday: {
		type: Boolean,
		default: !1
	},
	disabledWeekDays: {
		type: Array,
		default: () => []
	},
	allowedDates: {
		type: Array,
		default: null
	},
	nowButtonLabel: {
		type: String,
		default: "Now"
	},
	markers: {
		type: Array,
		default: () => []
	},
	escClose: {
		type: Boolean,
		default: !0
	},
	spaceConfirm: {
		type: Boolean,
		default: !0
	},
	monthChangeOnArrows: {
		type: Boolean,
		default: !0
	},
	presetDates: {
		type: Array,
		default: () => []
	},
	flow: {
		type: Array,
		default: () => []
	},
	partialFlow: {
		type: Boolean,
		default: !1
	},
	preventMinMaxNavigation: {
		type: Boolean,
		default: !1
	},
	reverseYears: {
		type: Boolean,
		default: !1
	},
	weekPicker: {
		type: Boolean,
		default: !1
	},
	filters: {
		type: Object,
		default: () => ({})
	},
	arrowNavigation: {
		type: Boolean,
		default: !1
	},
	highlight: {
		type: [Function, Object],
		default: null
	},
	teleport: {
		type: [
			Boolean,
			String,
			Object
		],
		default: null
	},
	teleportCenter: {
		type: Boolean,
		default: !1
	},
	locale: {
		type: String,
		default: "en-Us"
	},
	weekNumName: {
		type: String,
		default: "W"
	},
	weekStart: {
		type: [Number, String],
		default: 1
	},
	weekNumbers: {
		type: [
			String,
			Function,
			Object
		],
		default: null
	},
	monthChangeOnScroll: {
		type: [Boolean, String],
		default: !0
	},
	dayNames: {
		type: [Function, Array],
		default: null
	},
	monthPicker: {
		type: Boolean,
		default: !1
	},
	customProps: {
		type: Object,
		default: null
	},
	yearPicker: {
		type: Boolean,
		default: !1
	},
	modelAuto: {
		type: Boolean,
		default: !1
	},
	selectText: {
		type: String,
		default: "Select"
	},
	cancelText: {
		type: String,
		default: "Cancel"
	},
	previewFormat: {
		type: [String, Function],
		default: () => ""
	},
	multiDates: {
		type: [Object, Boolean],
		default: !1
	},
	ignoreTimeValidation: {
		type: Boolean,
		default: !1
	},
	minDate: {
		type: [Date, String],
		default: null
	},
	maxDate: {
		type: [Date, String],
		default: null
	},
	minTime: {
		type: Object,
		default: null
	},
	maxTime: {
		type: Object,
		default: null
	},
	name: {
		type: String,
		default: null
	},
	placeholder: {
		type: String,
		default: ""
	},
	hideInputIcon: {
		type: Boolean,
		default: !1
	},
	clearable: {
		type: Boolean,
		default: !0
	},
	alwaysClearable: {
		type: Boolean,
		default: !1
	},
	state: {
		type: Boolean,
		default: null
	},
	required: {
		type: Boolean,
		default: !1
	},
	autocomplete: {
		type: String,
		default: "off"
	},
	timePicker: {
		type: Boolean,
		default: !1
	},
	enableSeconds: {
		type: Boolean,
		default: !1
	},
	is24: {
		type: Boolean,
		default: !0
	},
	noHoursOverlay: {
		type: Boolean,
		default: !1
	},
	noMinutesOverlay: {
		type: Boolean,
		default: !1
	},
	noSecondsOverlay: {
		type: Boolean,
		default: !1
	},
	hoursGridIncrement: {
		type: [String, Number],
		default: 1
	},
	minutesGridIncrement: {
		type: [String, Number],
		default: 5
	},
	secondsGridIncrement: {
		type: [String, Number],
		default: 5
	},
	hoursIncrement: {
		type: [Number, String],
		default: 1
	},
	minutesIncrement: {
		type: [Number, String],
		default: 1
	},
	secondsIncrement: {
		type: [Number, String],
		default: 1
	},
	range: {
		type: [Boolean, Object],
		default: !1
	},
	uid: {
		type: String,
		default: null
	},
	disabled: {
		type: Boolean,
		default: !1
	},
	readonly: {
		type: Boolean,
		default: !1
	},
	inline: {
		type: [Boolean, Object],
		default: !1
	},
	textInput: {
		type: [Boolean, Object],
		default: !1
	},
	sixWeeks: {
		type: [Boolean, String],
		default: !1
	},
	actionRow: {
		type: Object,
		default: () => ({})
	},
	focusStartDate: {
		type: Boolean,
		default: !1
	},
	disabledTimes: {
		type: [Function, Array],
		default: void 0
	},
	timePickerInline: {
		type: Boolean,
		default: !1
	},
	calendar: {
		type: Function,
		default: null
	},
	config: {
		type: Object,
		default: void 0
	},
	quarterPicker: {
		type: Boolean,
		default: !1
	},
	yearFirst: {
		type: Boolean,
		default: !1
	},
	loading: {
		type: Boolean,
		default: !1
	},
	onInternalModelChange: {
		type: [Function, Object],
		default: null
	},
	enableMinutes: {
		type: Boolean,
		default: !0
	},
	ui: {
		type: Object,
		default: () => ({})
	}
}, UE = {
	...HE,
	shadow: {
		type: Boolean,
		default: !1
	},
	flowStep: {
		type: Number,
		default: 0
	},
	internalModelValue: {
		type: [Date, Array],
		default: null
	},
	noOverlayFocus: {
		type: Boolean,
		default: !1
	},
	collapse: {
		type: Boolean,
		default: !1
	},
	menuWrapRef: {
		type: Object,
		default: null
	},
	getInputRect: {
		type: Function,
		default: () => ({})
	},
	isTextInputDate: {
		type: Boolean,
		default: !1
	},
	isMobile: {
		type: Boolean,
		default: void 0
	}
}, WE = ["title"], GE = ["disabled"], KE = /* @__PURE__ */ f({
	compatConfig: { MODE: 3 },
	__name: "ActionRow",
	props: {
		menuMount: {
			type: Boolean,
			default: !1
		},
		calendarWidth: {
			type: Number,
			default: 0
		},
		...UE
	},
	emits: [
		"close-picker",
		"select-date",
		"select-now",
		"invalid-select"
	],
	setup(t, { emit: n }) {
		let i = n, c = t, { defaultedActionRow: u, defaultedPreviewFormat: d, defaultedMultiCalendars: f, defaultedTextInput: p, defaultedInline: m, defaultedRange: h, defaultedMultiDates: g } = zE(c), { isTimeValid: _, isMonthValid: v } = _O(c), { buildMatrix: y } = vE(), b = M(null), S = M(null), C = M(!1), E = M({}), D = M(null), k = M(null);
		O(() => {
			c.arrowNavigation && y([$w(b), $w(S)], "actionRow"), j(), window.addEventListener("resize", j);
		}), ee(() => {
			window.removeEventListener("resize", j);
		});
		let j = () => {
			C.value = !1, setTimeout(() => {
				let e = D.value?.getBoundingClientRect(), t = k.value?.getBoundingClientRect();
				e && t && (E.value.maxWidth = `${t.width - e.width - 20}px`), C.value = !0;
			}, 0);
		}, te = r(() => h.value.enabled && !h.value.partialRange && c.internalModelValue ? c.internalModelValue.length === 2 : !0), ne = r(() => !_.value(c.internalModelValue) || !v.value(c.internalModelValue) || !te.value), N = () => {
			let e = d.value;
			return c.timePicker || c.monthPicker, e(rT(c.internalModelValue));
		}, P = () => {
			let e = c.internalModelValue;
			return f.value.count > 0 ? `${re(e[0])} - ${re(e[1])}` : [re(e[0]), re(e[1])];
		}, re = (e) => qT(e, d.value, c.formatLocale, p.value.rangeSeparator, c.modelAuto, d.value), ie = r(() => !c.internalModelValue || !c.menuMount ? "" : typeof d.value == "string" ? Array.isArray(c.internalModelValue) ? c.internalModelValue.length === 2 && c.internalModelValue[1] ? P() : g.value.enabled ? c.internalModelValue.map((e) => `${re(e)}`) : c.modelAuto ? `${re(c.internalModelValue[0])}` : `${re(c.internalModelValue[0])} -` : re(c.internalModelValue) : N()), ae = () => g.value.enabled ? "; " : " - ", oe = r(() => Array.isArray(ie.value) ? ie.value.join(ae()) : ie.value), se = () => {
			_.value(c.internalModelValue) && v.value(c.internalModelValue) && te.value ? i("select-date") : i("invalid-select");
		};
		return (t, n) => (A(), o("div", {
			ref_key: "actionRowRef",
			ref: k,
			class: "dp__action_row"
		}, [t.$slots["action-row"] ? F(t.$slots, "action-row", w(x({ key: 0 }, {
			internalModelValue: t.internalModelValue,
			disabled: ne.value,
			selectDate: () => t.$emit("select-date"),
			closePicker: () => t.$emit("close-picker")
		}))) : (A(), o(e, { key: 1 }, [L(u).showPreview ? (A(), o("div", {
			key: 0,
			class: "dp__selection_preview",
			title: oe.value,
			style: T(E.value)
		}, [t.$slots["action-preview"] && C.value ? F(t.$slots, "action-preview", {
			key: 0,
			value: t.internalModelValue
		}) : a("", !0), !t.$slots["action-preview"] && C.value ? (A(), o(e, { key: 1 }, [l(I(oe.value), 1)], 64)) : a("", !0)], 12, WE)) : a("", !0), s("div", {
			ref_key: "actionBtnContainer",
			ref: D,
			class: "dp__action_buttons",
			"data-dp-element": "action-row"
		}, [t.$slots["action-buttons"] ? F(t.$slots, "action-buttons", {
			key: 0,
			value: t.internalModelValue
		}) : a("", !0), t.$slots["action-buttons"] ? a("", !0) : (A(), o(e, { key: 1 }, [
			!L(m).enabled && L(u).showCancel ? (A(), o("button", {
				key: 0,
				ref_key: "cancelButtonRef",
				ref: b,
				type: "button",
				class: "dp__action_button dp__action_cancel",
				onClick: n[0] ||= (e) => t.$emit("close-picker"),
				onKeydown: n[1] ||= (e) => L(yT)(e, () => t.$emit("close-picker"))
			}, I(t.cancelText), 545)) : a("", !0),
			L(u).showNow ? (A(), o("button", {
				key: 1,
				type: "button",
				class: "dp__action_button dp__action_cancel",
				onClick: n[2] ||= (e) => t.$emit("select-now"),
				onKeydown: n[3] ||= (e) => L(yT)(e, () => t.$emit("select-now"))
			}, I(t.nowButtonLabel), 33)) : a("", !0),
			L(u).showSelect ? (A(), o("button", {
				key: 2,
				ref_key: "selectButtonRef",
				ref: S,
				type: "button",
				class: "dp__action_button dp__action_select",
				disabled: ne.value,
				"data-test-id": "select-button",
				onKeydown: n[4] ||= (e) => L(yT)(e, () => se()),
				onClick: se
			}, I(t.selectText), 41, GE)) : a("", !0)
		], 64))], 512)], 64))], 512));
	}
}), qE = [
	"role",
	"aria-label",
	"tabindex"
], JE = { class: "dp__selection_grid_header" }, YE = [
	"aria-selected",
	"aria-disabled",
	"data-test-id",
	"onClick",
	"onKeydown",
	"onMouseover"
], XE = ["aria-label"], ZE = /* @__PURE__ */ f({
	__name: "SelectionOverlay",
	props: {
		items: {},
		type: {},
		isLast: { type: Boolean },
		arrowNavigation: { type: Boolean },
		skipButtonRef: { type: Boolean },
		headerRefs: {},
		hideNavigation: {},
		escClose: { type: Boolean },
		useRelative: { type: Boolean },
		height: {},
		textInput: { type: [Boolean, Object] },
		config: {},
		noOverlayFocus: { type: Boolean },
		focusValue: {},
		menuWrapRef: {},
		ariaLabels: {},
		overlayLabel: {}
	},
	emits: [
		"selected",
		"toggle",
		"reset-flow",
		"hover-value"
	],
	setup(t, { expose: n, emit: i }) {
		let { setSelectionGrid: c, buildMultiLevelMatrix: u, setMonthPicker: d } = vE(), f = i, p = t, { defaultedAriaLabels: m, defaultedTextInput: h, defaultedConfig: g } = zE(p), { hideNavigationButtons: _ } = vO(), v = M(!1), y = M(null), b = M(null), x = M([]), w = M(), E = M(null), k = M(0), j = M(null);
		D(() => {
			y.value = null;
		}), O(() => {
			S().then(() => se()), p.noOverlayFocus || ne(), te(!0);
		}), ee(() => te(!1));
		let te = (e) => {
			var t;
			p.arrowNavigation && ((t = p.headerRefs) != null && t.length ? d(e) : c(e));
		}, ne = () => {
			var e;
			let t = $w(b);
			t && (h.value.enabled || (y.value ? (e = y.value) == null || e.focus({ preventScroll: !0 }) : t.focus({ preventScroll: !0 })), v.value = t.clientHeight < t.scrollHeight);
		}, N = r(() => ({
			dp__overlay: !0,
			"dp--overlay-absolute": !p.useRelative,
			"dp--overlay-relative": p.useRelative
		})), re = r(() => p.useRelative ? {
			height: `${p.height}px`,
			width: "var(--dp-menu-min-width)"
		} : void 0), ie = r(() => ({ dp__overlay_col: !0 })), ae = r(() => ({
			dp__btn: !0,
			dp__button: !0,
			dp__overlay_action: !0,
			dp__over_action_scroll: v.value,
			dp__button_bottom: p.isLast
		})), oe = r(() => ({
			dp__overlay_container: !0,
			dp__container_flex: p.items?.length <= 6,
			dp__container_block: p.items?.length > 6
		}));
		z(() => p.items, () => se(!1), { deep: !0 });
		let se = (e = !0) => {
			S().then(() => {
				let t = $w(y), n = $w(b), r = $w(E), i = $w(j), a = r ? r.getBoundingClientRect().height : 0;
				n && (n.getBoundingClientRect().height ? k.value = n.getBoundingClientRect().height - a : k.value = g.value.modeHeight - a), t && i && e && (i.scrollTop = t.offsetTop - i.offsetTop - (k.value / 2 - t.getBoundingClientRect().height) - a);
			});
		}, ce = (e) => {
			e.disabled || f("selected", e.value);
		}, le = () => {
			f("toggle"), f("reset-flow");
		}, R = () => {
			p.escClose && le();
		}, ue = (e, t, n, r) => {
			e && ((t.active || t.value === p.focusValue) && (y.value = e), p.arrowNavigation && (Array.isArray(x.value[n]) ? x.value[n][r] = e : x.value[n] = [e], de()));
		}, de = () => {
			var e, t;
			let n = (e = p.headerRefs) != null && e.length ? [p.headerRefs].concat(x.value) : x.value.concat([p.skipButtonRef ? [] : [E.value]]);
			u(rT(n), (t = p.headerRefs) != null && t.length ? "monthPicker" : "selectionGrid");
		}, fe = (e) => {
			p.arrowNavigation || uT(e, g.value, !0);
		}, pe = (e) => {
			w.value = e, f("hover-value", e);
		}, me = () => {
			if (le(), !p.isLast) {
				let e = pT(p.menuWrapRef ?? null, "action-row");
				e && oT(e)?.focus();
			}
		}, ge = (e) => {
			switch (e.key) {
				case Gw.esc: return R();
				case Gw.arrowLeft: return fe(e);
				case Gw.arrowRight: return fe(e);
				case Gw.arrowUp: return fe(e);
				case Gw.arrowDown: return fe(e);
				default: return;
			}
		}, B = (e) => {
			if (e.key === Gw.enter) return le();
			if (e.key === Gw.tab) return me();
		};
		return n({ focusGrid: ne }), (t, n) => (A(), o("div", {
			ref_key: "gridWrapRef",
			ref: b,
			class: C(N.value),
			style: T(re.value),
			role: t.useRelative ? void 0 : "dialog",
			"aria-label": t.overlayLabel,
			tabindex: t.useRelative ? void 0 : "0",
			onKeydown: ge,
			onClick: n[0] ||= U(() => {}, ["prevent"])
		}, [s("div", {
			ref_key: "containerRef",
			ref: j,
			class: C(oe.value),
			style: T({ "--dp-overlay-height": `${k.value}px` }),
			role: "grid"
		}, [s("div", JE, [F(t.$slots, "header")]), t.$slots.overlay ? F(t.$slots, "overlay", { key: 0 }) : (A(!0), o(e, { key: 1 }, P(t.items, (n, r) => (A(), o("div", {
			key: r,
			class: C(["dp__overlay_row", { dp__flex_row: t.items.length >= 3 }]),
			role: "row"
		}, [(A(!0), o(e, null, P(n, (n, i) => (A(), o("div", {
			key: n.value,
			ref_for: !0,
			ref: (e) => ue(e, n, r, i),
			role: "gridcell",
			class: C(ie.value),
			"aria-selected": n.active || void 0,
			"aria-disabled": n.disabled || void 0,
			tabindex: "0",
			"data-test-id": n.text,
			onClick: U((e) => ce(n), ["prevent"]),
			onKeydown: (e) => L(yT)(e, () => ce(n), !0),
			onMouseover: (e) => pe(n.value)
		}, [s("div", { class: C(n.className) }, [t.$slots.item ? F(t.$slots, "item", {
			key: 0,
			item: n
		}) : a("", !0), t.$slots.item ? a("", !0) : (A(), o(e, { key: 1 }, [l(I(n.text), 1)], 64))], 2)], 42, YE))), 128))], 2))), 128))], 6), t.$slots["button-icon"] ? V((A(), o("button", {
			key: 0,
			ref_key: "toggleButton",
			ref: E,
			type: "button",
			"aria-label": L(m)?.toggleOverlay,
			class: C(ae.value),
			tabindex: "0",
			onClick: le,
			onKeydown: B
		}, [F(t.$slots, "button-icon")], 42, XE)), [[he, !L(_)(t.hideNavigation, t.type)]]) : a("", !0)], 46, qE));
	}
}), QE = ["data-dp-mobile"], $E = /* @__PURE__ */ f({
	__name: "InstanceWrap",
	props: {
		multiCalendars: {},
		stretch: { type: Boolean },
		collapse: { type: Boolean },
		isMobile: { type: Boolean }
	},
	setup(t) {
		let n = t, i = r(() => n.multiCalendars > 0 ? [...Array(n.multiCalendars).keys()] : [0]), a = r(() => ({ dp__instance_calendar: n.multiCalendars > 0 }));
		return (t, n) => (A(), o("div", {
			class: C({
				dp__menu_inner: !t.stretch,
				"dp--menu--inner-stretched": t.stretch,
				dp__flex_display: t.multiCalendars > 0,
				"dp--flex-display-collapsed": t.collapse
			}),
			"data-dp-mobile": t.isMobile
		}, [(A(!0), o(e, null, P(i.value, (e, n) => (A(), o("div", {
			key: e,
			class: C(a.value)
		}, [F(t.$slots, "default", {
			instance: e,
			index: n
		})], 2))), 128))], 10, QE));
	}
}), eD = [
	"data-dp-element",
	"aria-label",
	"aria-disabled"
], tD = /* @__PURE__ */ f({
	compatConfig: { MODE: 3 },
	__name: "ArrowBtn",
	props: {
		ariaLabel: {},
		elName: {},
		disabled: { type: Boolean }
	},
	emits: ["activate", "set-ref"],
	setup(e, { emit: t }) {
		let n = t, r = M(null);
		return O(() => n("set-ref", r)), (e, t) => (A(), o("button", {
			ref_key: "elRef",
			ref: r,
			type: "button",
			"data-dp-element": e.elName,
			class: "dp__btn dp--arrow-btn-nav",
			tabindex: "0",
			"aria-label": e.ariaLabel,
			"aria-disabled": e.disabled || void 0,
			onClick: t[0] ||= (t) => e.$emit("activate"),
			onKeydown: t[1] ||= (t) => L(yT)(t, () => e.$emit("activate"), !0)
		}, [s("span", { class: C(["dp__inner_nav", { dp__inner_nav_disabled: e.disabled }]) }, [F(e.$slots, "default")], 2)], 40, eD));
	}
}), nD = ["aria-label", "data-test-id"], rD = /* @__PURE__ */ f({
	__name: "YearModePicker",
	props: {
		...UE,
		showYearPicker: {
			type: Boolean,
			default: !1
		},
		items: {
			type: Array,
			default: () => []
		},
		instance: {
			type: Number,
			default: 0
		},
		year: {
			type: Number,
			default: 0
		},
		isDisabled: {
			type: Function,
			default: () => !1
		}
	},
	emits: [
		"toggle-year-picker",
		"year-select",
		"handle-year"
	],
	setup(t, { emit: r }) {
		let d = r, f = t, { showRightIcon: p, showLeftIcon: m } = vO(), { defaultedConfig: h, defaultedMultiCalendars: g, defaultedAriaLabels: _, defaultedTransitions: v, defaultedUI: y } = zE(f), { showTransition: b, transitionName: x } = mO(v), S = M(!1), w = (e = !1, t) => {
			S.value = !S.value, d("toggle-year-picker", {
				flow: e,
				show: t
			});
		}, T = (e) => {
			S.value = !1, d("year-select", e);
		}, E = (e = !1) => {
			d("handle-year", e);
		};
		return (r, d) => (A(), o(e, null, [s("div", { class: C(["dp--year-mode-picker", { "dp--hidden-el": S.value }]) }, [
			L(m)(L(g), t.instance) ? (A(), i(tD, {
				key: 0,
				ref: "mpPrevIconRef",
				"aria-label": L(_)?.prevYear,
				disabled: t.isDisabled(!1),
				class: C(L(y)?.navBtnPrev),
				onActivate: d[0] ||= (e) => E(!1)
			}, {
				default: B(() => [r.$slots["arrow-left"] ? F(r.$slots, "arrow-left", { key: 0 }) : a("", !0), r.$slots["arrow-left"] ? a("", !0) : (A(), i(L(Ow), { key: 1 }))]),
				_: 3
			}, 8, [
				"aria-label",
				"disabled",
				"class"
			])) : a("", !0),
			s("button", {
				ref: "mpYearButtonRef",
				class: "dp__btn dp--year-select",
				type: "button",
				"aria-label": `${t.year}-${L(_)?.openYearsOverlay}`,
				"data-test-id": `year-mode-btn-${t.instance}`,
				onClick: d[1] ||= () => w(!1),
				onKeydown: d[2] ||= H(() => w(!1), ["enter"])
			}, [r.$slots.year ? F(r.$slots, "year", {
				key: 0,
				year: t.year
			}) : a("", !0), r.$slots.year ? a("", !0) : (A(), o(e, { key: 1 }, [l(I(t.year), 1)], 64))], 40, nD),
			L(p)(L(g), t.instance) ? (A(), i(tD, {
				key: 1,
				ref: "mpNextIconRef",
				"aria-label": L(_)?.nextYear,
				disabled: t.isDisabled(!0),
				class: C(L(y)?.navBtnNext),
				onActivate: d[3] ||= (e) => E(!0)
			}, {
				default: B(() => [r.$slots["arrow-right"] ? F(r.$slots, "arrow-right", { key: 0 }) : a("", !0), r.$slots["arrow-right"] ? a("", !0) : (A(), i(L(kw), { key: 1 }))]),
				_: 3
			}, 8, [
				"aria-label",
				"disabled",
				"class"
			])) : a("", !0)
		], 2), u(n, {
			name: L(x)(t.showYearPicker),
			css: L(b)
		}, {
			default: B(() => {
				var e;
				return [t.showYearPicker ? (A(), i(ZE, {
					key: 0,
					items: t.items,
					"text-input": r.textInput,
					"esc-close": r.escClose,
					config: r.config,
					"is-last": r.autoApply && !L(h).keepActionRow,
					"hide-navigation": r.hideNavigation,
					"aria-labels": r.ariaLabels,
					"overlay-label": ((e = L(_))?.yearPicker)?.call(e, !0),
					type: "year",
					onToggle: w,
					onSelected: d[4] ||= (e) => T(e)
				}, c({
					"button-icon": B(() => [r.$slots["calendar-icon"] ? F(r.$slots, "calendar-icon", { key: 0 }) : a("", !0), r.$slots["calendar-icon"] ? a("", !0) : (A(), i(L(Ew), { key: 1 }))]),
					_: 2
				}, [r.$slots["year-overlay-value"] ? {
					name: "item",
					fn: B(({ item: e }) => [F(r.$slots, "year-overlay-value", {
						text: e.text,
						value: e.value
					})]),
					key: "0"
				} : void 0]), 1032, [
					"items",
					"text-input",
					"esc-close",
					"config",
					"is-last",
					"hide-navigation",
					"aria-labels",
					"overlay-label"
				])) : a("", !0)];
			}),
			_: 3
		}, 8, ["name", "css"])], 64));
	}
}), iD = (e, t, n) => {
	if (t.value && Array.isArray(t.value)) {
		if (t.value.some((t) => kT(e, t))) {
			let n = t.value.filter((t) => !kT(t, e));
			t.value = n.length ? n : null;
		} else (n && +n > t.value.length || !n) && t.value.push(e);
	} else t.value = [e];
}, aD = (e, t, n) => {
	let r = e.value ? e.value.slice() : [];
	return r.length === 2 && r[1] !== null && (r = []), r.length ? (OT(t, r[0]) ? r.unshift(t) : r[1] = t, n("range-end", t)) : (r = [t], n("range-start", t)), r;
}, oD = (e, t, n, r) => {
	e && (e[0] && e[1] && n && t("auto-apply"), e[0] && !e[1] && r && n && t("auto-apply"));
}, sD = (e) => {
	Array.isArray(e.value) && e.value.length <= 2 && e.range ? e.modelValue.value = e.value.map((t) => Nw(Y(t), e.timezone)) : Array.isArray(e.value) || (e.modelValue.value = Nw(Y(e.value), e.timezone));
}, cD = (e, t, n, r) => Array.isArray(t.value) && (t.value.length === 2 || t.value.length === 1 && r.value.partialRange) ? r.value.fixedStart && (AT(e, t.value[0]) || kT(e, t.value[0])) ? [t.value[0], e] : r.value.fixedEnd && (OT(e, t.value[1]) || kT(e, t.value[1])) ? [e, t.value[1]] : (n("invalid-fixed-range", e), t.value) : [], lD = ({ multiCalendars: e, range: t, highlight: n, propDates: i, calendars: a, modelValue: o, props: s, filters: c, year: l, month: u, emit: d }) => {
	let f = r(() => Xw(s.yearRange, s.locale, s.reverseYears)), p = M([!1]), m = r(() => (e, t) => {
		let n = _w(MT(/* @__PURE__ */ new Date()), {
			month: u.value(e),
			year: l.value(e)
		});
		return WT(t ? eS(n) : tS(n), i.value.maxDate, i.value.minDate, s.preventMinMaxNavigation, t);
	}), h = () => Array.isArray(o.value) && e.value.solo && o.value[1], g = () => {
		for (let t = 0; t < e.value.count; t++) if (t === 0) a.value[t] = a.value[0];
		else if (t === e.value.count - 1 && h()) a.value[t] = {
			month: QS(o.value[1]),
			year: eC(o.value[1])
		};
		else {
			let e = _w(Y(), a.value[t - 1]);
			a.value[t] = {
				month: QS(e),
				year: eC(Hx(e, 1))
			};
		}
	}, _ = (t) => {
		if (!t) return g();
		let n = _w(Y(), a.value[t]);
		return a.value[0].year = eC(Tw(n, e.value.count - 1)), g();
	}, v = (e, n) => {
		let r = Jx(n, e);
		return t.value.showLastInRange && r > 1 ? n : e;
	}, y = (t) => s.focusStartDate || e.value.solo ? t[0] : t[1] ? v(t[0], t[1]) : t[0], b = () => {
		if (o.value) {
			let e = Array.isArray(o.value) ? y(o.value) : o.value;
			a.value[0] = {
				month: QS(e),
				year: eC(e)
			};
		}
	}, x = () => {
		b(), e.value.count && g();
	};
	z(o, (e, t) => {
		s.isTextInputDate && JSON.stringify(e ?? {}) !== JSON.stringify(t ?? {}) && x();
	}), O(() => {
		x();
	});
	let S = (t, n) => {
		a.value[n].year = t, d("update-month-year", {
			instance: n,
			year: t,
			month: a.value[n].month
		}), e.value.count && !e.value.solo && _(n);
	}, C = r(() => (e) => lT(f.value, (t) => ({
		active: l.value(e) === t.value,
		disabled: cT(t.value, LT(i.value.minDate), LT(i.value.maxDate)) || c.value.years?.includes(l.value(e)),
		highlighted: aE(n.value, t.value)
	}))), w = (e, t) => {
		S(e, t), E(t);
	}, T = (e, t = !1) => {
		if (!m.value(e, t)) {
			let n = t ? l.value(e) + 1 : l.value(e) - 1;
			S(n, e);
		}
	}, E = (e, t = !1, n) => {
		t || d("reset-flow"), n === void 0 ? p.value[e] = !p.value[e] : p.value[e] = n, p.value[e] ? d("overlay-toggle", {
			open: !0,
			overlay: Hw.year
		}) : (d("overlay-closed"), d("overlay-toggle", {
			open: !1,
			overlay: Hw.year
		}));
	};
	return {
		isDisabled: m,
		groupedYears: C,
		showYearPicker: p,
		selectYear: S,
		toggleYearPicker: E,
		handleYearSelect: w,
		handleYear: T
	};
}, uD = (e, t) => {
	let { defaultedMultiCalendars: n, defaultedAriaLabels: i, defaultedTransitions: a, defaultedConfig: o, defaultedRange: s, defaultedHighlight: c, propDates: l, defaultedTz: u, defaultedFilters: d, defaultedMultiDates: f } = zE(e), { modelValue: p, year: m, month: h, calendars: g } = hO(e, t, () => {
		e.isTextInputDate && b(eC(Y(e.startDate)), 0);
	}), _ = r(() => Zw(e.formatLocale, e.locale, e.monthNameFormat)), v = M(null), { checkMinMaxRange: y } = _O(e), { selectYear: b, groupedYears: x, showYearPicker: C, toggleYearPicker: w, handleYearSelect: T, handleYear: E, isDisabled: D } = lD({
		modelValue: p,
		multiCalendars: n,
		range: s,
		highlight: c,
		calendars: g,
		year: m,
		propDates: l,
		month: h,
		filters: d,
		props: e,
		emit: t
	});
	O(() => {
		e.startDate && (p.value && e.focusStartDate || !p.value) && b(eC(Y(e.startDate)), 0);
	});
	let k = (e) => e ? {
		month: QS(e),
		year: eC(e)
	} : {
		month: null,
		year: null
	}, ee = () => p.value ? Array.isArray(p.value) ? p.value.map((e) => k(e)) : k(p.value) : k(), A = (e, t) => {
		let n = g.value[e], r = ee();
		return Array.isArray(r) ? r.some((e) => e.year === n?.year && e.month === t) : n?.year === r.year && t === r.month;
	}, j = (e, t, n) => {
		let r = ee();
		return Array.isArray(r) ? m.value(t) === r[n]?.year && e === r[n]?.month : !1;
	}, te = (e, t) => {
		if (s.value.enabled) {
			let n = ee();
			if (Array.isArray(p.value) && Array.isArray(n)) {
				let n = j(e, t, 0) || j(e, t, 1), r = UT(MT(Y()), e, m.value(t));
				return jT(p.value, v.value, r) && !n;
			}
			return !1;
		}
		return !1;
	}, ne = r(() => (e) => lT(_.value, (t) => ({
		active: A(e, t.value),
		disabled: cT(t.value, FT(m.value(e), l.value.minDate), IT(m.value(e), l.value.maxDate)) || nE(l.value.disabledDates, m.value(e), t.value) || d.value.months?.includes(t.value) || !rE(l.value.allowedDates, m.value(e), t.value),
		isBetween: te(t.value, e),
		highlighted: iE(c.value, t.value, m.value(e))
	}))), N = (e, t) => UT(MT(Y()), e, m.value(t)), P = (e, n) => {
		let r = p.value ? p.value : MT(/* @__PURE__ */ new Date());
		p.value = UT(r, e, m.value(n)), t("auto-apply"), t("update-flow-step");
	}, F = (n, r) => {
		let i = N(n, r);
		s.value.fixedEnd || s.value.fixedStart ? p.value = cD(i, p, t, s) : p.value ? y(i, p.value) && (p.value = aD(p, N(n, r), t)) : p.value = [N(n, r)], S().then(() => {
			oD(p.value, t, e.autoApply, e.modelAuto);
		});
	}, re = (e, n) => {
		iD(N(e, n), p, f.value.limit), t("auto-apply", !0);
	}, ie = (e, t) => (g.value[t].month = e, ae(t, g.value[t].year, e), f.value.enabled ? re(e, t) : s.value.enabled ? F(e, t) : P(e, t)), I = (e, t) => {
		b(e, t), ae(t, e, null);
	}, ae = (e, n, r) => {
		let i = r;
		if (!i && i !== 0) {
			let t = ee();
			i = Array.isArray(t) ? t[e].month : t.month;
		}
		t("update-month-year", {
			instance: e,
			year: n,
			month: i
		});
	};
	return {
		groupedMonths: ne,
		groupedYears: x,
		year: m,
		isDisabled: D,
		defaultedMultiCalendars: n,
		defaultedAriaLabels: i,
		defaultedTransitions: a,
		defaultedConfig: o,
		showYearPicker: C,
		modelValue: p,
		presetDate: (e, n) => {
			sD({
				value: e,
				modelValue: p,
				range: s.value.enabled,
				timezone: n ? void 0 : u.value.timezone
			}), t("auto-apply");
		},
		setHoverDate: (e, t) => {
			v.value = N(e, t);
		},
		selectMonth: ie,
		selectYear: I,
		toggleYearPicker: w,
		handleYearSelect: T,
		handleYear: E,
		getModelMonthYear: ee
	};
}, dD = /* @__PURE__ */ f({
	compatConfig: { MODE: 3 },
	__name: "MonthPicker",
	props: { ...UE },
	emits: [
		"update:internal-model-value",
		"overlay-closed",
		"reset-flow",
		"range-start",
		"range-end",
		"auto-apply",
		"update-month-year",
		"update-flow-step",
		"mount",
		"invalid-fixed-range",
		"overlay-toggle"
	],
	setup(e, { expose: t, emit: n }) {
		let r = n, o = pO(ue(), "yearMode"), s = e;
		O(() => {
			s.shadow || r("mount", null);
		});
		let { groupedMonths: l, groupedYears: d, year: f, isDisabled: p, defaultedMultiCalendars: m, defaultedConfig: g, showYearPicker: _, modelValue: v, presetDate: y, setHoverDate: b, selectMonth: S, selectYear: C, toggleYearPicker: T, handleYearSelect: E, handleYear: D, getModelMonthYear: k } = uD(s, r);
		return t({
			getSidebarProps: () => ({
				modelValue: v,
				year: f,
				getModelMonthYear: k,
				selectMonth: S,
				selectYear: C,
				handleYear: D
			}),
			presetDate: y,
			toggleYearPicker: (e) => T(0, e)
		}), (e, t) => (A(), i($E, {
			"multi-calendars": L(m).count,
			collapse: e.collapse,
			stretch: "",
			"is-mobile": e.isMobile
		}, {
			default: B(({ instance: t }) => [e.$slots["top-extra"] ? F(e.$slots, "top-extra", {
				key: 0,
				value: e.internalModelValue
			}) : a("", !0), e.$slots["month-year"] ? F(e.$slots, "month-year", w(x({ key: 1 }, {
				year: L(f),
				months: L(l)(t),
				years: L(d)(t),
				selectMonth: L(S),
				selectYear: L(C),
				instance: t
			}))) : (A(), i(ZE, {
				key: 2,
				items: L(l)(t),
				"arrow-navigation": e.arrowNavigation,
				"is-last": e.autoApply && !L(g).keepActionRow,
				"esc-close": e.escClose,
				height: L(g).modeHeight,
				config: e.config,
				"no-overlay-focus": !!(e.noOverlayFocus || e.textInput),
				"use-relative": "",
				type: "month",
				onSelected: (e) => L(S)(e, t),
				onHoverValue: (e) => L(b)(e, t)
			}, c({
				header: B(() => [u(rD, x(e.$props, {
					items: L(d)(t),
					instance: t,
					"show-year-picker": L(_)[t],
					year: L(f)(t),
					"is-disabled": (e) => L(p)(t, e),
					onHandleYear: (e) => L(D)(t, e),
					onYearSelect: (e) => L(E)(e, t),
					onToggleYearPicker: (e) => L(T)(t, e?.flow, e?.show)
				}), c({ _: 2 }, [P(L(o), (t, n) => ({
					name: t,
					fn: B((n) => [F(e.$slots, t, w(h(n)))])
				}))]), 1040, [
					"items",
					"instance",
					"show-year-picker",
					"year",
					"is-disabled",
					"onHandleYear",
					"onYearSelect",
					"onToggleYearPicker"
				])]),
				_: 2
			}, [e.$slots["month-overlay-value"] ? {
				name: "item",
				fn: B(({ item: t }) => [F(e.$slots, "month-overlay-value", {
					text: t.text,
					value: t.value
				})]),
				key: "0"
			} : void 0]), 1032, [
				"items",
				"arrow-navigation",
				"is-last",
				"esc-close",
				"height",
				"config",
				"no-overlay-focus",
				"onSelected",
				"onHoverValue"
			]))]),
			_: 3
		}, 8, [
			"multi-calendars",
			"collapse",
			"is-mobile"
		]));
	}
}), fD = (e, t) => {
	let { modelValue: n } = hO(e, t, () => {
		e.isTextInputDate && (u.value = eC(Y(e.startDate)));
	}), i = M(null), { defaultedHighlight: a, defaultedMultiDates: o, defaultedFilters: s, defaultedRange: c, propDates: l } = zE(e), u = M();
	O(() => {
		e.startDate && (n.value && e.focusStartDate || !n.value) && (u.value = eC(Y(e.startDate)));
	});
	let d = (e) => Array.isArray(n.value) ? n.value.some((t) => eC(t) === e) : n.value ? eC(n.value) === e : !1, f = (e) => c.value.enabled && Array.isArray(n.value) ? jT(n.value, i.value, g(e)) : !1, p = (e) => l.value.allowedDates instanceof Map ? l.value.allowedDates.size ? l.value.allowedDates.has(`${e}`) : !1 : !0, m = (e) => l.value.disabledDates instanceof Map ? l.value.disabledDates.size ? l.value.disabledDates.has(`${e}`) : !1 : !0, h = r(() => lT(Xw(e.yearRange, e.locale, e.reverseYears), (e) => {
		let t = d(e.value);
		return {
			active: t,
			disabled: cT(e.value, LT(l.value.minDate), LT(l.value.maxDate)) || s.value.years.includes(e.value) || !p(e.value) || m(e.value),
			isBetween: f(e.value) && !t,
			highlighted: aE(a.value, e.value)
		};
	})), g = (e) => Sw(MT(tS(/* @__PURE__ */ new Date())), e);
	return {
		groupedYears: h,
		modelValue: n,
		focusYear: u,
		setHoverValue: (e) => {
			i.value = Sw(MT(/* @__PURE__ */ new Date()), e);
		},
		selectYear: (r) => {
			if (t("update-month-year", {
				instance: 0,
				year: r
			}), o.value.enabled) return n.value ? Array.isArray(n.value) && ((n.value?.map((e) => eC(e))).includes(r) ? n.value = n.value.filter((e) => eC(e) !== r) : n.value.push(Sw(ET(Y()), r))) : n.value = [Sw(ET(tS(Y())), r)], t("auto-apply", !0);
			c.value.enabled ? (n.value = aD(n, g(r), t), S().then(() => {
				oD(n.value, t, e.autoApply, e.modelAuto);
			})) : (n.value = g(r), t("auto-apply"));
		}
	};
}, pD = /* @__PURE__ */ f({
	compatConfig: { MODE: 3 },
	__name: "YearPicker",
	props: { ...UE },
	emits: [
		"update:internal-model-value",
		"reset-flow",
		"range-start",
		"range-end",
		"auto-apply",
		"update-month-year"
	],
	setup(e, { expose: t, emit: n }) {
		let r = n, s = e, { groupedYears: l, modelValue: u, focusYear: d, selectYear: f, setHoverValue: p } = fD(s, r), { defaultedConfig: m } = zE(s);
		return t({ getSidebarProps: () => ({
			modelValue: u,
			selectYear: f
		}) }), (e, t) => (A(), o("div", null, [e.$slots["top-extra"] ? F(e.$slots, "top-extra", {
			key: 0,
			value: e.internalModelValue
		}) : a("", !0), e.$slots["month-year"] ? F(e.$slots, "month-year", w(x({ key: 1 }, {
			years: L(l),
			selectYear: L(f)
		}))) : (A(), i(ZE, {
			key: 2,
			items: L(l),
			"is-last": e.autoApply && !L(m).keepActionRow,
			height: L(m).modeHeight,
			config: e.config,
			"no-overlay-focus": !!(e.noOverlayFocus || e.textInput),
			"focus-value": L(d),
			type: "year",
			"use-relative": "",
			onSelected: L(f),
			onHoverValue: L(p)
		}, c({ _: 2 }, [e.$slots["year-overlay-value"] ? {
			name: "item",
			fn: B(({ item: t }) => [F(e.$slots, "year-overlay-value", {
				text: t.text,
				value: t.value
			})]),
			key: "0"
		} : void 0]), 1032, [
			"items",
			"is-last",
			"height",
			"config",
			"no-overlay-focus",
			"focus-value",
			"onSelected",
			"onHoverValue"
		]))]));
	}
}), mD = {
	key: 0,
	class: "dp__time_input"
}, hD = ["data-compact", "data-collapsed"], gD = [
	"data-test-id",
	"aria-label",
	"onKeydown",
	"onClick",
	"onMousedown"
], _D = [
	"aria-label",
	"disabled",
	"data-test-id",
	"onKeydown",
	"onClick"
], vD = [
	"data-test-id",
	"aria-label",
	"onKeydown",
	"onClick",
	"onMousedown"
], yD = { key: 0 }, bD = ["aria-label", "data-compact"], xD = /* @__PURE__ */ f({
	compatConfig: { MODE: 3 },
	__name: "TimeInput",
	props: {
		hours: {
			type: Number,
			default: 0
		},
		minutes: {
			type: Number,
			default: 0
		},
		seconds: {
			type: Number,
			default: 0
		},
		closeTimePickerBtn: {
			type: Object,
			default: null
		},
		order: {
			type: Number,
			default: 0
		},
		disabledTimesConfig: {
			type: Function,
			default: null
		},
		validateTime: {
			type: Function,
			default: () => !1
		},
		...UE
	},
	emits: [
		"set-hours",
		"set-minutes",
		"update:hours",
		"update:minutes",
		"update:seconds",
		"reset-flow",
		"mounted",
		"overlay-closed",
		"overlay-opened",
		"am-pm-change"
	],
	setup(t, { expose: u, emit: d }) {
		let f = d, p = t, { setTimePickerElements: m, setTimePickerBackRef: h } = vE(), { defaultedAriaLabels: g, defaultedTransitions: _, defaultedFilters: v, defaultedConfig: y, defaultedRange: b, defaultedMultiCalendars: x } = zE(p), { transitionName: S, showTransition: w } = mO(_), T = te({
			hours: !1,
			minutes: !1,
			seconds: !1
		}), E = M("AM"), D = M(null), k = M([]), ee = M(), j = M(!1);
		O(() => {
			f("mounted");
		});
		let ne = (e) => _w(/* @__PURE__ */ new Date(), {
			hours: e.hours,
			minutes: e.minutes,
			seconds: p.enableSeconds ? e.seconds : 0,
			milliseconds: 0
		}), N = r(() => (e) => he(e, p[e]) || ae(e, p[e])), ie = r(() => ({
			hours: p.hours,
			minutes: p.minutes,
			seconds: p.seconds
		})), ae = (e, t) => b.value.enabled && !b.value.disableTimeRangeValidation ? !p.validateTime(e, t) : !1, oe = (e, t) => {
			if (b.value.enabled && !b.value.disableTimeRangeValidation) {
				let n = t ? +p[`${e}Increment`] : -+p[`${e}Increment`], r = p[e] + n;
				return !p.validateTime(e, r);
			}
			return !1;
		}, se = r(() => (e) => !U(+p[e] + +p[`${e}Increment`], e) || oe(e, !0)), ce = r(() => (e) => !U(p[e] - +p[`${e}Increment`], e) || oe(e, !1)), le = (e, t) => Ox(_w(Y(), e), t), R = (e, t) => ww(_w(Y(), e), t), ue = r(() => ({
			dp__time_col: !0,
			dp__time_col_block: !p.timePickerInline,
			dp__time_col_reg_block: !p.enableSeconds && p.is24 && !p.timePickerInline,
			dp__time_col_reg_inline: !p.enableSeconds && p.is24 && p.timePickerInline,
			dp__time_col_reg_with_button: !p.enableSeconds && !p.is24,
			dp__time_col_sec: p.enableSeconds && p.is24,
			dp__time_col_sec_with_button: p.enableSeconds && !p.is24
		})), de = r(() => p.timePickerInline && b.value.enabled && !x.value.count), fe = r(() => {
			let e = [{ type: "hours" }];
			return p.enableMinutes && e.push({
				type: "",
				separator: !0
			}, { type: "minutes" }), p.enableSeconds && e.push({
				type: "",
				separator: !0
			}, { type: "seconds" }), e;
		}), pe = r(() => fe.value.filter((e) => !e.separator)), me = r(() => (e) => {
			if (e === "hours") {
				let e = Se(+p.hours);
				return {
					text: e < 10 ? `0${e}` : `${e}`,
					value: e
				};
			}
			return {
				text: p[e] < 10 ? `0${p[e]}` : `${p[e]}`,
				value: p[e]
			};
		}), he = (e, t) => {
			var n;
			if (!p.disabledTimesConfig) return !1;
			let r = p.disabledTimesConfig(p.order, e === "hours" ? t : void 0);
			return !r[e] || !!((n = r[e]) != null && n.includes(t));
		}, z = (e, t) => t !== "hours" || E.value === "AM" ? e : e + 12, ge = (e) => {
			let t = p.is24 ? 24 : 12, n = e === "hours" ? t : 60, r = +p[`${e}GridIncrement`], i = e === "hours" && !p.is24 ? r : 0, a = [];
			for (let t = i; t < n; t += r) a.push({
				value: p.is24 ? t : z(t, e),
				text: t < 10 ? `0${t}` : `${t}`
			});
			return e === "hours" && !p.is24 && a.unshift({
				value: E.value === "PM" ? 12 : 0,
				text: "12"
			}), lT(a, (t) => ({
				active: !1,
				disabled: v.value.times[e].includes(t.value) || !U(t.value, e) || he(e, t.value) || ae(e, t.value)
			}));
		}, V = (e) => e >= 0 ? e : 59, H = (e) => e >= 0 ? e : 23, U = (e, t) => {
			let n = p.minTime ? ne(NT(p.minTime)) : null, r = p.maxTime ? ne(NT(p.maxTime)) : null, i = ne(NT(ie.value, t, t === "minutes" || t === "seconds" ? V(e) : H(e)));
			return n && r ? (nC(i, r) || rC(i, r)) && (tC(i, n) || rC(i, n)) : n ? tC(i, n) || rC(i, n) : !r || nC(i, r) || rC(i, r);
		}, _e = (e) => p[`no${e[0].toUpperCase() + e.slice(1)}Overlay`], ve = (e) => {
			_e(e) || (T[e] = !T[e], T[e] ? (j.value = !0, f("overlay-opened", e)) : (j.value = !1, f("overlay-closed", e)));
		}, ye = (e) => e === "hours" ? YS : e === "minutes" ? ZS : $S, be = () => {
			ee.value && clearTimeout(ee.value);
		}, xe = (e, t = !0, n) => {
			let r = t ? le : R, i = t ? +p[`${e}Increment`] : -+p[`${e}Increment`];
			U(+p[e] + i, e) && f(`update:${e}`, ye(e)(r({ [e]: +p[e] }, { [e]: +p[`${e}Increment`] }))), !(n != null && n.keyboard) && y.value.timeArrowHoldThreshold && (ee.value = setTimeout(() => {
				xe(e, t);
			}, y.value.timeArrowHoldThreshold));
		}, Se = (e) => p.is24 ? e : (e >= 12 ? E.value = "PM" : E.value = "AM", Qw(e)), Ce = () => {
			E.value === "PM" ? (E.value = "AM", f("update:hours", p.hours - 12)) : (E.value = "PM", f("update:hours", p.hours + 12)), f("am-pm-change", E.value);
		}, we = (e) => {
			T[e] = !0;
		}, Te = (e, t, n) => {
			if (e && p.arrowNavigation) {
				Array.isArray(k.value[t]) ? k.value[t][n] = e : k.value[t] = [e];
				let r = k.value.reduce((e, t) => t.map((n, r) => [...e[r] || [], t[r]]), []);
				h(p.closeTimePickerBtn), D.value && (r[1] = r[1].concat(D.value)), m(r, p.order);
			}
		}, Ee = (e, t) => (ve(e), f(`update:${e}`, t));
		return u({ openChildCmp: we }), (t, r) => t.disabled ? a("", !0) : (A(), o("div", mD, [
			(A(!0), o(e, null, P(fe.value, (n, c) => (A(), o("div", {
				key: c,
				class: C(ue.value),
				"data-compact": de.value && !t.enableSeconds,
				"data-collapsed": de.value && t.enableSeconds
			}, [n.separator ? (A(), o(e, { key: 0 }, [j.value ? a("", !0) : (A(), o(e, { key: 0 }, [l(":")], 64))], 64)) : (A(), o(e, { key: 1 }, [
				s("button", {
					ref_for: !0,
					ref: (e) => Te(e, c, 0),
					type: "button",
					class: C({
						dp__btn: !0,
						dp__inc_dec_button: !t.timePickerInline,
						dp__inc_dec_button_inline: t.timePickerInline,
						dp__tp_inline_btn_top: t.timePickerInline,
						dp__inc_dec_button_disabled: se.value(n.type),
						"dp--hidden-el": j.value
					}),
					"data-test-id": `${n.type}-time-inc-btn-${p.order}`,
					"aria-label": L(g)?.incrementValue(n.type),
					tabindex: "0",
					onKeydown: (e) => L(yT)(e, () => xe(n.type, !0, { keyboard: !0 }), !0),
					onClick: (e) => L(y).timeArrowHoldThreshold ? void 0 : xe(n.type, !0),
					onMousedown: (e) => L(y).timeArrowHoldThreshold ? xe(n.type, !0) : void 0,
					onMouseup: be
				}, [p.timePickerInline ? (A(), o(e, { key: 1 }, [t.$slots["tp-inline-arrow-up"] ? F(t.$slots, "tp-inline-arrow-up", { key: 0 }) : (A(), o(e, { key: 1 }, [r[2] ||= s("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), r[3] ||= s("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1)], 64))], 64)) : (A(), o(e, { key: 0 }, [t.$slots["arrow-up"] ? F(t.$slots, "arrow-up", { key: 0 }) : a("", !0), t.$slots["arrow-up"] ? a("", !0) : (A(), i(L(jw), { key: 1 }))], 64))], 42, gD),
				s("button", {
					ref_for: !0,
					ref: (e) => Te(e, c, 1),
					type: "button",
					"aria-label": `${me.value(n.type).text}-${L(g)?.openTpOverlay(n.type)}`,
					class: C({
						dp__time_display: !0,
						dp__time_display_block: !t.timePickerInline,
						dp__time_display_inline: t.timePickerInline,
						"dp--time-invalid": N.value(n.type),
						"dp--time-overlay-btn": !N.value(n.type),
						"dp--hidden-el": j.value
					}),
					disabled: _e(n.type),
					tabindex: "0",
					"data-test-id": `${n.type}-toggle-overlay-btn-${p.order}`,
					onKeydown: (e) => L(yT)(e, () => ve(n.type), !0),
					onClick: (e) => ve(n.type)
				}, [t.$slots[n.type] ? F(t.$slots, n.type, {
					key: 0,
					text: me.value(n.type).text,
					value: me.value(n.type).value
				}) : a("", !0), t.$slots[n.type] ? a("", !0) : (A(), o(e, { key: 1 }, [l(I(me.value(n.type).text), 1)], 64))], 42, _D),
				s("button", {
					ref_for: !0,
					ref: (e) => Te(e, c, 2),
					type: "button",
					class: C({
						dp__btn: !0,
						dp__inc_dec_button: !t.timePickerInline,
						dp__inc_dec_button_inline: t.timePickerInline,
						dp__tp_inline_btn_bottom: t.timePickerInline,
						dp__inc_dec_button_disabled: ce.value(n.type),
						"dp--hidden-el": j.value
					}),
					"data-test-id": `${n.type}-time-dec-btn-${p.order}`,
					"aria-label": L(g)?.decrementValue(n.type),
					tabindex: "0",
					onKeydown: (e) => L(yT)(e, () => xe(n.type, !1, { keyboard: !0 }), !0),
					onClick: (e) => L(y).timeArrowHoldThreshold ? void 0 : xe(n.type, !1),
					onMousedown: (e) => L(y).timeArrowHoldThreshold ? xe(n.type, !1) : void 0,
					onMouseup: be
				}, [p.timePickerInline ? (A(), o(e, { key: 1 }, [t.$slots["tp-inline-arrow-down"] ? F(t.$slots, "tp-inline-arrow-down", { key: 0 }) : (A(), o(e, { key: 1 }, [r[4] ||= s("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), r[5] ||= s("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1)], 64))], 64)) : (A(), o(e, { key: 0 }, [t.$slots["arrow-down"] ? F(t.$slots, "arrow-down", { key: 0 }) : a("", !0), t.$slots["arrow-down"] ? a("", !0) : (A(), i(L(Mw), { key: 1 }))], 64))], 42, vD)
			], 64))], 10, hD))), 128)),
			t.is24 ? a("", !0) : (A(), o("div", yD, [t.$slots["am-pm-button"] ? F(t.$slots, "am-pm-button", {
				key: 0,
				toggle: Ce,
				value: E.value
			}) : a("", !0), t.$slots["am-pm-button"] ? a("", !0) : (A(), o("button", {
				key: 1,
				ref_key: "amPmButton",
				ref: D,
				type: "button",
				class: "dp__pm_am_button",
				role: "button",
				"aria-label": L(g)?.amPmButton,
				tabindex: "0",
				"data-compact": de.value,
				onClick: Ce,
				onKeydown: r[0] ||= (e) => L(yT)(e, () => Ce(), !0)
			}, I(E.value), 41, bD))])),
			(A(!0), o(e, null, P(pe.value, (e, o) => (A(), i(n, {
				key: o,
				name: L(S)(T[e.type]),
				css: L(w)
			}, {
				default: B(() => {
					var n;
					return [T[e.type] ? (A(), i(ZE, {
						key: 0,
						items: ge(e.type),
						"is-last": t.autoApply && !L(y).keepActionRow,
						"esc-close": t.escClose,
						type: e.type,
						"text-input": t.textInput,
						config: t.config,
						"arrow-navigation": t.arrowNavigation,
						"aria-labels": t.ariaLabels,
						"overlay-label": (n = L(g)).timeOverlay?.call(n, e.type),
						onSelected: (t) => Ee(e.type, t),
						onToggle: (t) => ve(e.type),
						onResetFlow: r[1] ||= (e) => t.$emit("reset-flow")
					}, c({
						"button-icon": B(() => [t.$slots["clock-icon"] ? F(t.$slots, "clock-icon", { key: 0 }) : a("", !0), t.$slots["clock-icon"] ? a("", !0) : (A(), i(re(t.timePickerInline ? L(Ew) : L(Aw)), { key: 1 }))]),
						_: 2
					}, [t.$slots[`${e.type}-overlay-value`] ? {
						name: "item",
						fn: B(({ item: n }) => [F(t.$slots, `${e.type}-overlay-value`, {
							text: n.text,
							value: n.value
						})]),
						key: "0"
					} : void 0, t.$slots[`${e.type}-overlay-header`] ? {
						name: "header",
						fn: B(() => [F(t.$slots, `${e.type}-overlay-header`, { toggle: () => ve(e.type) })]),
						key: "1"
					} : void 0]), 1032, [
						"items",
						"is-last",
						"esc-close",
						"type",
						"text-input",
						"config",
						"arrow-navigation",
						"aria-labels",
						"overlay-label",
						"onSelected",
						"onToggle"
					])) : a("", !0)];
				}),
				_: 2
			}, 1032, ["name", "css"]))), 128))
		]));
	}
}), SD = ["data-dp-mobile"], CD = ["aria-label", "tabindex"], wD = [
	"role",
	"aria-label",
	"tabindex"
], TD = ["aria-label"], ED = /* @__PURE__ */ f({
	compatConfig: { MODE: 3 },
	__name: "TimePicker",
	props: {
		hours: {
			type: [Number, Array],
			default: 0
		},
		minutes: {
			type: [Number, Array],
			default: 0
		},
		seconds: {
			type: [Number, Array],
			default: 0
		},
		disabledTimesConfig: {
			type: Function,
			default: null
		},
		validateTime: {
			type: Function,
			default: () => !1
		},
		...UE
	},
	emits: [
		"update:hours",
		"update:minutes",
		"update:seconds",
		"mount",
		"reset-flow",
		"overlay-opened",
		"overlay-closed",
		"am-pm-change"
	],
	setup(t, { expose: l, emit: d }) {
		let f = d, p = t, { buildMatrix: m, setTimePicker: h } = vE(), g = ue(), { defaultedTransitions: _, defaultedAriaLabels: v, defaultedTextInput: y, defaultedConfig: b, defaultedRange: w } = zE(p), { transitionName: E, showTransition: D } = mO(_), { hideNavigationButtons: k } = vO(), ee = M(null), j = M(null), te = M([]), ne = M(null), N = M(!1);
		O(() => {
			f("mount"), !p.timePicker && p.arrowNavigation ? m([$w(ee.value)], "time") : h(!0, p.timePicker);
		});
		let re = r(() => w.value.enabled && p.modelAuto ? tT(p.internalModelValue) : !0), ie = M(!1), I = (e) => ({
			hours: Array.isArray(p.hours) ? p.hours[e] : p.hours,
			minutes: Array.isArray(p.minutes) ? p.minutes[e] : p.minutes,
			seconds: Array.isArray(p.seconds) ? p.seconds[e] : p.seconds
		}), ae = r(() => {
			let e = [];
			if (w.value.enabled) for (let t = 0; t < 2; t++) e.push(I(t));
			else e.push(I(0));
			return e;
		}), oe = (e, t = !1, n = "") => {
			t || f("reset-flow"), ie.value = e, f(e ? "overlay-opened" : "overlay-closed", Hw.time), p.arrowNavigation && h(e), S(() => {
				n !== "" && te.value[0] && te.value[0].openChildCmp(n);
			});
		}, se = r(() => ({
			dp__btn: !0,
			dp__button: !0,
			dp__button_bottom: p.autoApply && !b.value.keepActionRow
		})), ce = pO(g, "timePicker"), le = (e, t, n) => w.value.enabled ? t === 0 ? [e, ae.value[1][n]] : [ae.value[0][n], e] : e, R = (e) => {
			f("update:hours", e);
		}, de = (e) => {
			f("update:minutes", e);
		}, fe = (e) => {
			f("update:seconds", e);
		}, pe = () => {
			if (ne.value && !y.value.enabled && !p.noOverlayFocus) {
				let e = oT(ne.value);
				e && e.focus({ preventScroll: !0 });
			}
		}, me = (e) => {
			N.value = !1, f("overlay-closed", e);
		}, z = (e) => {
			N.value = !0, f("overlay-opened", e);
		};
		return l({ toggleTimePicker: oe }), (r, l) => (A(), o("div", {
			class: "dp--tp-wrap",
			"data-dp-mobile": r.isMobile
		}, [!r.timePicker && !r.timePickerInline ? V((A(), o("button", {
			key: 0,
			ref_key: "openTimePickerBtn",
			ref: ee,
			type: "button",
			class: C({
				...se.value,
				"dp--hidden-el": ie.value
			}),
			"aria-label": L(v)?.openTimePicker,
			tabindex: r.noOverlayFocus ? void 0 : 0,
			"data-test-id": "open-time-picker-btn",
			onKeydown: l[0] ||= (e) => L(yT)(e, () => oe(!0)),
			onClick: l[1] ||= (e) => oe(!0)
		}, [r.$slots["clock-icon"] ? F(r.$slots, "clock-icon", { key: 0 }) : a("", !0), r.$slots["clock-icon"] ? a("", !0) : (A(), i(L(Aw), { key: 1 }))], 42, CD)), [[he, !L(k)(r.hideNavigation, "time")]]) : a("", !0), u(n, {
			name: L(E)(ie.value),
			css: L(D) && !r.timePickerInline
		}, {
			default: B(() => [ie.value || r.timePicker || r.timePickerInline ? (A(), o("div", {
				key: 0,
				ref_key: "overlayRef",
				ref: ne,
				role: r.timePickerInline ? void 0 : "dialog",
				class: C({
					dp__overlay: !r.timePickerInline,
					"dp--overlay-absolute": !p.timePicker && !r.timePickerInline,
					"dp--overlay-relative": p.timePicker
				}),
				style: T(r.timePicker ? { height: `${L(b).modeHeight}px` } : void 0),
				"aria-label": L(v)?.timePicker,
				tabindex: r.timePickerInline ? void 0 : 0
			}, [s("div", {
				class: C(r.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"),
				style: { display: "flex" }
			}, [
				r.$slots["time-picker-overlay"] ? F(r.$slots, "time-picker-overlay", {
					key: 0,
					hours: t.hours,
					minutes: t.minutes,
					seconds: t.seconds,
					setHours: R,
					setMinutes: de,
					setSeconds: fe
				}) : a("", !0),
				r.$slots["time-picker-overlay"] ? a("", !0) : (A(), o("div", {
					key: 1,
					class: C(r.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
				}, [(A(!0), o(e, null, P(ae.value, (e, n) => V((A(), i(xD, x({
					key: n,
					ref_for: !0
				}, {
					...r.$props,
					order: n,
					hours: e.hours,
					minutes: e.minutes,
					seconds: e.seconds,
					closeTimePickerBtn: j.value,
					disabledTimesConfig: t.disabledTimesConfig,
					disabled: n === 0 ? L(w).fixedStart : L(w).fixedEnd
				}, {
					ref_for: !0,
					ref_key: "timeInputRefs",
					ref: te,
					"validate-time": (e, r) => t.validateTime(e, le(r, n, e)),
					"onUpdate:hours": (e) => R(le(e, n, "hours")),
					"onUpdate:minutes": (e) => de(le(e, n, "minutes")),
					"onUpdate:seconds": (e) => fe(le(e, n, "seconds")),
					onMounted: pe,
					onOverlayClosed: me,
					onOverlayOpened: z,
					onAmPmChange: l[2] ||= (e) => r.$emit("am-pm-change", e)
				}), c({ _: 2 }, [P(L(ce), (e, t) => ({
					name: e,
					fn: B((t) => [F(r.$slots, e, x({ ref_for: !0 }, t))])
				}))]), 1040, [
					"validate-time",
					"onUpdate:hours",
					"onUpdate:minutes",
					"onUpdate:seconds"
				])), [[he, n === 0 || re.value]])), 128))], 2)),
				!r.timePicker && !r.timePickerInline ? V((A(), o("button", {
					key: 2,
					ref_key: "closeTimePickerBtn",
					ref: j,
					type: "button",
					class: C({
						...se.value,
						"dp--hidden-el": N.value
					}),
					"aria-label": L(v)?.closeTimePicker,
					tabindex: "0",
					onKeydown: l[3] ||= (e) => L(yT)(e, () => oe(!1)),
					onClick: l[4] ||= (e) => oe(!1)
				}, [r.$slots["calendar-icon"] ? F(r.$slots, "calendar-icon", { key: 0 }) : a("", !0), r.$slots["calendar-icon"] ? a("", !0) : (A(), i(L(Ew), { key: 1 }))], 42, TD)), [[he, !L(k)(r.hideNavigation, "time")]]) : a("", !0)
			], 2)], 14, wD)) : a("", !0)]),
			_: 3
		}, 8, ["name", "css"])], 8, SD));
	}
}), DD = (e, t, n, i) => {
	let { defaultedRange: a } = zE(e), o = (e, n) => Array.isArray(t[e]) ? t[e][n] : t[e], s = (n) => e.enableSeconds ? Array.isArray(t.seconds) ? t.seconds[n] : t.seconds : 0, c = (e, n) => e ? n === void 0 ? DT(e, t.hours, t.minutes, s()) : DT(e, o("hours", n), o("minutes", n), s(n)) : xw(Y(), s(n)), l = (e, n) => {
		t[e] = n;
	}, u = r(() => e.modelAuto && a.value.enabled ? Array.isArray(n.value) ? n.value.length > 1 : !1 : a.value.enabled), d = (e, r) => {
		let i = Object.fromEntries(Object.keys(t).map((n) => n === e ? [n, r] : [n, t[n]].slice()));
		if (u.value && !a.value.disableTimeRangeValidation) {
			let e = (e) => n.value ? DT(n.value[e], i.hours[e], i.minutes[e], i.seconds[e]) : null, t = (e) => yw(n.value[e], 0);
			return !(kT(e(0), e(1)) && (tC(e(0), t(1)) || nC(e(1), t(0))));
		}
		return !0;
	}, f = (e, t) => {
		d(e, t) && (l(e, t), i && i());
	}, p = (e) => {
		f("hours", e);
	}, m = (e) => {
		f("minutes", e);
	}, h = (e) => {
		f("seconds", e);
	}, g = (e, t, r, i) => {
		t && p(e), !t && !r && m(e), r && h(e), n.value && i(n.value);
	}, _ = (t) => {
		if (t) {
			let n = Array.isArray(t), r = n ? [+t[0].hours, +t[1].hours] : +t.hours, i = n ? [+t[0].minutes, +t[1].minutes] : +t.minutes, a = n ? [+t[0].seconds, +t[1].seconds] : +t.seconds;
			l("hours", r), l("minutes", i), e.enableSeconds && l("seconds", a);
		}
	}, v = (n, r) => {
		let i = {
			hours: Array.isArray(t.hours) ? t.hours[n] : t.hours,
			disabledArr: []
		};
		return (r || r === 0) && (i.hours = r), Array.isArray(e.disabledTimes) && (i.disabledArr = a.value.enabled && Array.isArray(e.disabledTimes[n]) ? e.disabledTimes[n] : e.disabledTimes), i;
	};
	return {
		setTime: l,
		updateHours: p,
		updateMinutes: m,
		updateSeconds: h,
		getSetDateTime: c,
		updateTimeValues: g,
		getSecondsValue: s,
		assignStartTime: _,
		validateTime: d,
		disabledTimesConfig: r(() => (t, n) => {
			if (Array.isArray(e.disabledTimes)) {
				let { disabledArr: e, hours: r } = v(t, n), i = e.filter((e) => +e.hours === r);
				return i[0]?.minutes === "*" ? {
					hours: [r],
					minutes: void 0,
					seconds: void 0
				} : {
					hours: [],
					minutes: i?.map((e) => +e.minutes) ?? [],
					seconds: i?.map((e) => e.seconds ? +e.seconds : void 0) ?? []
				};
			}
			return {
				hours: [],
				minutes: [],
				seconds: []
			};
		})
	};
}, OD = (e, t) => {
	let { modelValue: n, time: r } = hO(e, t, () => {
		e.isTextInputDate && y();
	}), { defaultedStartTime: i, defaultedRange: a, defaultedTz: o } = zE(e), { updateTimeValues: s, getSetDateTime: c, setTime: l, assignStartTime: u, disabledTimesConfig: d, validateTime: f } = DD(e, r, n, p);
	function p() {
		t("update-flow-step");
	}
	let m = (e) => {
		let { hours: t, minutes: n, seconds: r } = e;
		return {
			hours: +t,
			minutes: +n,
			seconds: r ? +r : 0
		};
	}, h = () => {
		if (e.startTime) {
			if (Array.isArray(e.startTime)) {
				let t = m(e.startTime[0]), n = m(e.startTime[1]);
				return [_w(Y(), t), _w(Y(), n)];
			}
			let t = m(e.startTime);
			return _w(Y(), t);
		}
		return a.value.enabled ? [null, null] : null;
	}, g = () => {
		if (a.value.enabled) {
			let [e, t] = h();
			n.value = [Nw(c(e, 0), o.value.timezone), Nw(c(t, 1), o.value.timezone)];
		} else n.value = Nw(c(h()), o.value.timezone);
	}, _ = (e) => Array.isArray(e) ? [PT(Y(e[0])), PT(Y(e[1]))] : [PT(e ?? Y())], v = (t, n, r) => {
		l("hours", t), l("minutes", n), l("seconds", e.enableSeconds ? r : 0);
	}, y = () => {
		let [e, t] = _(n.value);
		return a.value.enabled ? v([e.hours, t.hours], [e.minutes, t.minutes], [e.seconds, t.seconds]) : v(e.hours, e.minutes, e.seconds);
	};
	O(() => {
		if (!e.shadow) return u(i.value), n.value ? y() : g();
	});
	let b = () => {
		Array.isArray(n.value) ? n.value = n.value.map((e, t) => e && c(e, t)) : n.value = c(n.value), t("time-update");
	};
	return {
		modelValue: n,
		time: r,
		disabledTimesConfig: d,
		updateTime: (e, t = !0, n = !1) => {
			s(e, t, n, b);
		},
		validateTime: f
	};
}, kD = /* @__PURE__ */ f({
	compatConfig: { MODE: 3 },
	__name: "TimePickerSolo",
	props: { ...UE },
	emits: [
		"update:internal-model-value",
		"time-update",
		"am-pm-change",
		"mount",
		"reset-flow",
		"update-flow-step",
		"overlay-toggle"
	],
	setup(e, { expose: t, emit: n }) {
		let r = n, a = e, o = pO(ue(), "timePicker"), s = M(null), { time: l, modelValue: d, disabledTimesConfig: f, updateTime: p, validateTime: m } = OD(a, r);
		return O(() => {
			a.shadow || r("mount", null);
		}), t({
			getSidebarProps: () => ({
				modelValue: d,
				time: l,
				updateTime: p
			}),
			toggleTimePicker: (e, t = !1, n = "") => {
				var r;
				(r = s.value) == null || r.toggleTimePicker(e, t, n);
			}
		}), (e, t) => (A(), i($E, {
			"multi-calendars": 0,
			stretch: "",
			"is-mobile": e.isMobile
		}, {
			default: B(() => [u(ED, x({
				ref_key: "tpRef",
				ref: s
			}, e.$props, {
				hours: L(l).hours,
				minutes: L(l).minutes,
				seconds: L(l).seconds,
				"internal-model-value": e.internalModelValue,
				"disabled-times-config": L(f),
				"validate-time": L(m),
				"onUpdate:hours": t[0] ||= (e) => L(p)(e),
				"onUpdate:minutes": t[1] ||= (e) => L(p)(e, !1),
				"onUpdate:seconds": t[2] ||= (e) => L(p)(e, !1, !0),
				onAmPmChange: t[3] ||= (t) => e.$emit("am-pm-change", t),
				onResetFlow: t[4] ||= (t) => e.$emit("reset-flow"),
				onOverlayClosed: t[5] ||= (t) => e.$emit("overlay-toggle", {
					open: !1,
					overlay: t
				}),
				onOverlayOpened: t[6] ||= (t) => e.$emit("overlay-toggle", {
					open: !0,
					overlay: t
				})
			}), c({ _: 2 }, [P(L(o), (t, n) => ({
				name: t,
				fn: B((n) => [F(e.$slots, t, w(h(n)))])
			}))]), 1040, [
				"hours",
				"minutes",
				"seconds",
				"internal-model-value",
				"disabled-times-config",
				"validate-time"
			])]),
			_: 3
		}, 8, ["is-mobile"]));
	}
}), AD = { class: "dp--header-wrap" }, jD = {
	key: 0,
	class: "dp__month_year_wrap"
}, MD = { key: 0 }, ND = { class: "dp__month_year_wrap" }, PD = [
	"data-dp-element",
	"aria-label",
	"data-test-id",
	"onClick",
	"onKeydown"
], FD = /* @__PURE__ */ f({
	compatConfig: { MODE: 3 },
	__name: "DpHeader",
	props: {
		month: {
			type: Number,
			default: 0
		},
		year: {
			type: Number,
			default: 0
		},
		instance: {
			type: Number,
			default: 0
		},
		years: {
			type: Array,
			default: () => []
		},
		months: {
			type: Array,
			default: () => []
		},
		...UE
	},
	emits: [
		"update-month-year",
		"mount",
		"reset-flow",
		"overlay-closed",
		"overlay-opened"
	],
	setup(t, { expose: d, emit: f }) {
		let p = f, m = t, { defaultedTransitions: g, defaultedAriaLabels: _, defaultedMultiCalendars: v, defaultedFilters: y, defaultedConfig: b, defaultedHighlight: S, propDates: T, defaultedUI: E } = zE(m), { transitionName: D, showTransition: k } = mO(g), { buildMatrix: ee } = vE(), { handleMonthYearChange: j, isDisabled: te, updateMonthYear: ne } = VE(m, p), { showLeftIcon: N, showRightIcon: ie } = vO(), ae = M(!1), oe = M(!1), se = M(!1), ce = M([
			null,
			null,
			null,
			null
		]);
		O(() => {
			p("mount");
		});
		let le = (e) => ({
			get: () => m[e],
			set: (t) => {
				let n = e === zw.month ? zw.year : zw.month;
				p("update-month-year", {
					[e]: t,
					[n]: m[n]
				}), e === zw.month ? z(!0) : ge(!0);
			}
		}), R = r(le(zw.month)), ue = r(le(zw.year)), de = r(() => (e) => ({
			month: m.month,
			year: m.year,
			items: e === zw.month ? m.months : m.years,
			instance: m.instance,
			updateMonthYear: ne,
			toggle: e === zw.month ? z : ge
		})), fe = r(() => m.months.find((e) => e.value === m.month) || {
			text: "",
			value: 0
		}), pe = r(() => lT(m.months, (e) => ({
			active: m.month === e.value,
			disabled: cT(e.value, FT(m.year, T.value.minDate), IT(m.year, T.value.maxDate)) || y.value.months.includes(e.value),
			highlighted: iE(S.value, e.value, m.year)
		}))), me = r(() => lT(m.years, (e) => ({
			active: m.year === e.value,
			disabled: cT(e.value, LT(T.value.minDate), LT(T.value.maxDate)) || y.value.years.includes(e.value),
			highlighted: aE(S.value, e.value)
		}))), he = (e, t, n) => {
			e.value = n === void 0 ? !e.value : n, e.value ? (se.value = !0, p("overlay-opened", t)) : (se.value = !1, p("overlay-closed", t));
		}, z = (e = !1, t) => {
			V(e), he(ae, Hw.month, t);
		}, ge = (e = !1, t) => {
			V(e), he(oe, Hw.year, t);
		}, V = (e) => {
			e || p("reset-flow");
		}, H = (e, t) => {
			m.arrowNavigation && (ce.value[t] = $w(e), ee(ce.value, "monthYear"));
		}, U = r(() => {
			var e, t;
			return [{
				type: zw.month,
				index: 1,
				toggle: z,
				modelValue: R.value,
				updateModelValue: (e) => R.value = e,
				text: fe.value.text,
				showSelectionGrid: ae.value,
				items: pe.value,
				ariaLabel: _.value?.openMonthsOverlay,
				overlayLabel: (e = _.value).monthPicker?.call(e, !0) ?? void 0
			}, {
				type: zw.year,
				index: 2,
				toggle: ge,
				modelValue: ue.value,
				updateModelValue: (e) => ue.value = e,
				text: mT(m.year, m.locale),
				showSelectionGrid: oe.value,
				items: me.value,
				ariaLabel: _.value?.openYearsOverlay,
				overlayLabel: (t = _.value).yearPicker?.call(t, !0) ?? void 0
			}];
		}), _e = r(() => m.disableYearSelect ? [U.value[0]] : m.yearFirst ? [...U.value].reverse() : U.value);
		return d({
			toggleMonthPicker: z,
			toggleYearPicker: ge,
			handleMonthYearChange: j
		}), (r, d) => (A(), o("div", AD, [r.$slots["month-year"] ? (A(), o("div", jD, [F(r.$slots, "month-year", w(h({
			month: t.month,
			year: t.year,
			months: t.months,
			years: t.years,
			updateMonthYear: L(ne),
			handleMonthYearChange: L(j),
			instance: t.instance,
			isDisabled: L(te)
		})))])) : (A(), o(e, { key: 1 }, [r.$slots["top-extra"] ? (A(), o("div", MD, [F(r.$slots, "top-extra", { value: r.internalModelValue })])) : a("", !0), s("div", ND, [
			L(N)(L(v), t.instance) && !r.vertical ? (A(), i(tD, {
				key: 0,
				"aria-label": L(_)?.prevMonth,
				disabled: L(te)(!1),
				class: C(L(E)?.navBtnPrev),
				"el-name": "action-prev",
				onActivate: d[0] ||= (e) => L(j)(!1, !0),
				onSetRef: d[1] ||= (e) => H(e, 0)
			}, {
				default: B(() => [r.$slots["arrow-left"] ? F(r.$slots, "arrow-left", { key: 0 }) : a("", !0), r.$slots["arrow-left"] ? a("", !0) : (A(), i(L(Ow), { key: 1 }))]),
				_: 3
			}, 8, [
				"aria-label",
				"disabled",
				"class"
			])) : a("", !0),
			s("div", { class: C(["dp__month_year_wrap", { dp__year_disable_select: r.disableYearSelect }]) }, [(A(!0), o(e, null, P(_e.value, (d, f) => (A(), o(e, { key: d.type }, [s("button", {
				ref_for: !0,
				ref: (e) => H(e, f + 1),
				type: "button",
				"data-dp-element": `overlay-${d.type}`,
				class: C(["dp__btn dp__month_year_select", { "dp--hidden-el": se.value }]),
				"aria-label": `${d.text}-${d.ariaLabel}`,
				"data-test-id": `${d.type}-toggle-overlay-${t.instance}`,
				onClick: d.toggle,
				onKeydown: (e) => L(yT)(e, () => d.toggle(), !0)
			}, [r.$slots[d.type] ? F(r.$slots, d.type, {
				key: 0,
				text: d.text,
				value: m[d.type]
			}) : a("", !0), r.$slots[d.type] ? a("", !0) : (A(), o(e, { key: 1 }, [l(I(d.text), 1)], 64))], 42, PD), u(n, {
				name: L(D)(d.showSelectionGrid),
				css: L(k)
			}, {
				default: B(() => [d.showSelectionGrid ? (A(), i(ZE, {
					key: 0,
					items: d.items,
					"arrow-navigation": r.arrowNavigation,
					"hide-navigation": r.hideNavigation,
					"is-last": r.autoApply && !L(b).keepActionRow,
					"skip-button-ref": !1,
					config: r.config,
					type: d.type,
					"header-refs": [],
					"esc-close": r.escClose,
					"menu-wrap-ref": r.menuWrapRef,
					"text-input": r.textInput,
					"aria-labels": r.ariaLabels,
					"overlay-label": d.overlayLabel,
					onSelected: d.updateModelValue,
					onToggle: d.toggle
				}, c({
					"button-icon": B(() => [r.$slots["calendar-icon"] ? F(r.$slots, "calendar-icon", { key: 0 }) : a("", !0), r.$slots["calendar-icon"] ? a("", !0) : (A(), i(L(Ew), { key: 1 }))]),
					_: 2
				}, [
					r.$slots[`${d.type}-overlay-value`] ? {
						name: "item",
						fn: B(({ item: e }) => [F(r.$slots, `${d.type}-overlay-value`, {
							text: e.text,
							value: e.value
						})]),
						key: "0"
					} : void 0,
					r.$slots[`${d.type}-overlay`] ? {
						name: "overlay",
						fn: B(() => [F(r.$slots, `${d.type}-overlay`, x({ ref_for: !0 }, de.value(d.type)))]),
						key: "1"
					} : void 0,
					r.$slots[`${d.type}-overlay-header`] ? {
						name: "header",
						fn: B(() => [F(r.$slots, `${d.type}-overlay-header`, { toggle: d.toggle })]),
						key: "2"
					} : void 0
				]), 1032, [
					"items",
					"arrow-navigation",
					"hide-navigation",
					"is-last",
					"config",
					"type",
					"esc-close",
					"menu-wrap-ref",
					"text-input",
					"aria-labels",
					"overlay-label",
					"onSelected",
					"onToggle"
				])) : a("", !0)]),
				_: 2
			}, 1032, ["name", "css"])], 64))), 128))], 2),
			L(N)(L(v), t.instance) && r.vertical ? (A(), i(tD, {
				key: 1,
				"aria-label": L(_)?.prevMonth,
				"el-name": "action-prev",
				disabled: L(te)(!1),
				class: C(L(E)?.navBtnPrev),
				onActivate: d[2] ||= (e) => L(j)(!1, !0)
			}, {
				default: B(() => [r.$slots["arrow-up"] ? F(r.$slots, "arrow-up", { key: 0 }) : a("", !0), r.$slots["arrow-up"] ? a("", !0) : (A(), i(L(jw), { key: 1 }))]),
				_: 3
			}, 8, [
				"aria-label",
				"disabled",
				"class"
			])) : a("", !0),
			L(ie)(L(v), t.instance) ? (A(), i(tD, {
				key: 2,
				ref: "rightIcon",
				"el-name": "action-next",
				disabled: L(te)(!0),
				"aria-label": L(_)?.nextMonth,
				class: C(L(E)?.navBtnNext),
				onActivate: d[3] ||= (e) => L(j)(!0, !0),
				onSetRef: d[4] ||= (e) => H(e, r.disableYearSelect ? 2 : 3)
			}, {
				default: B(() => [r.$slots[r.vertical ? "arrow-down" : "arrow-right"] ? F(r.$slots, r.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : a("", !0), r.$slots[r.vertical ? "arrow-down" : "arrow-right"] ? a("", !0) : (A(), i(re(r.vertical ? L(Mw) : L(kw)), { key: 1 }))]),
				_: 3
			}, 8, [
				"disabled",
				"aria-label",
				"class"
			])) : a("", !0)
		])], 64))]));
	}
}), ID = {
	class: "dp__calendar_header",
	role: "row"
}, LD = {
	key: 0,
	class: "dp__calendar_header_item",
	role: "gridcell"
}, RD = ["aria-label"], zD = {
	key: 0,
	class: "dp__calendar_item dp__week_num",
	role: "gridcell"
}, BD = { class: "dp__cell_inner" }, VD = [
	"id",
	"aria-pressed",
	"aria-disabled",
	"aria-label",
	"tabindex",
	"data-test-id",
	"onClick",
	"onTouchend",
	"onKeydown",
	"onMouseenter",
	"onMouseleave",
	"onMousedown"
], HD = /* @__PURE__ */ f({
	compatConfig: { MODE: 3 },
	__name: "DpCalendar",
	props: {
		mappedDates: {
			type: Array,
			default: () => []
		},
		instance: {
			type: Number,
			default: 0
		},
		month: {
			type: Number,
			default: 0
		},
		year: {
			type: Number,
			default: 0
		},
		...UE
	},
	emits: [
		"select-date",
		"set-hover-date",
		"handle-scroll",
		"mount",
		"handle-swipe",
		"handle-space",
		"tooltip-open",
		"tooltip-close"
	],
	setup(t, { expose: i, emit: c }) {
		let d = c, f = t, { buildMultiLevelMatrix: p } = vE(), { defaultedTransitions: m, defaultedConfig: h, defaultedAriaLabels: g, defaultedMultiCalendars: _, defaultedWeekNumbers: v, defaultedMultiDates: y, defaultedUI: b } = zE(f), x = M(null), w = M({
			bottom: "",
			left: "",
			transform: ""
		}), E = M([]), D = M(null), k = M(!0), ee = M(""), j = M({
			startX: 0,
			endX: 0,
			startY: 0,
			endY: 0
		}), te = M([]), ne = M({ left: "50%" }), N = M(!1), re = r(() => f.calendar ? f.calendar(f.mappedDates) : f.mappedDates), ie = r(() => f.dayNames ? Array.isArray(f.dayNames) ? f.dayNames : f.dayNames(f.locale, +f.weekStart) : Yw(f.formatLocale, f.locale, +f.weekStart));
		O(() => {
			d("mount", {
				cmp: "calendar",
				refs: E
			}), h.value.noSwipe || D.value && (D.value.addEventListener("touchstart", he, { passive: !1 }), D.value.addEventListener("touchend", z, { passive: !1 }), D.value.addEventListener("touchmove", ge, { passive: !1 })), f.monthChangeOnScroll && D.value && D.value.addEventListener("wheel", _e, { passive: !1 });
		});
		let ae = (e) => e ? f.vertical ? "vNext" : "next" : f.vertical ? "vPrevious" : "previous", oe = (e, t) => {
			if (f.transitions) {
				let n = ET(UT(Y(), f.month, f.year));
				ee.value = AT(ET(UT(Y(), e, t)), n) ? m.value[ae(!0)] : m.value[ae(!1)], k.value = !1, S(() => {
					k.value = !0;
				});
			}
		}, se = r(() => ({ ...b.value.calendar ?? {} })), ce = r(() => (e) => {
			let t = eT(e);
			return {
				dp__marker_dot: t.type === "dot",
				dp__marker_line: t.type === "line"
			};
		}), le = r(() => (e) => kT(e, x.value)), R = r(() => ({
			dp__calendar: !0,
			dp__calendar_next: _.value.count > 0 && f.instance !== 0
		})), ue = r(() => (e) => !f.hideOffsetDates || e.current), de = async (e, t) => {
			let { width: n, height: r } = e.getBoundingClientRect();
			x.value = t.value;
			let i = { left: `${n / 2}px` }, a = -50;
			if (await S(), te.value[0]) {
				let { left: e, width: t } = te.value[0].getBoundingClientRect();
				e < 0 && (i = { left: "0" }, a = 0, ne.value.left = `${n / 2}px`), window.innerWidth < e + t && (i = { right: "0" }, a = 0, ne.value.left = `${t - n / 2}px`);
			}
			w.value = {
				bottom: `${r}px`,
				...i,
				transform: `translateX(${a}%)`
			};
		}, fe = async (e, t, n) => {
			var r, i;
			let a = $w(E.value[t][n]);
			a && ((r = e.marker) != null && r.customPosition && (i = e.marker?.tooltip) != null && i.length ? w.value = e.marker.customPosition(a) : await de(a, e), d("tooltip-open", e.marker));
		}, pe = async (e, t, n) => {
			var r;
			if (N.value && y.value.enabled && y.value.dragSelect) return d("select-date", e);
			if (d("set-hover-date", e), (r = e.marker?.tooltip) != null && r.length) {
				if (f.hideOffsetDates && !e.current) return;
				await fe(e, t, n);
			}
		}, me = (e) => {
			x.value && (x.value = null, w.value = JSON.parse(JSON.stringify({
				bottom: "",
				left: "",
				transform: ""
			})), d("tooltip-close", e.marker));
		}, he = (e) => {
			j.value.startX = e.changedTouches[0].screenX, j.value.startY = e.changedTouches[0].screenY;
		}, z = (e) => {
			j.value.endX = e.changedTouches[0].screenX, j.value.endY = e.changedTouches[0].screenY, V();
		}, ge = (e) => {
			f.vertical && !f.inline && e.preventDefault();
		}, V = () => {
			let e = f.vertical ? "Y" : "X";
			Math.abs(j.value[`start${e}`] - j.value[`end${e}`]) > 10 && d("handle-swipe", j.value[`start${e}`] > j.value[`end${e}`] ? "right" : "left");
		}, H = (e, t, n) => {
			e && (Array.isArray(E.value[t]) ? E.value[t][n] = e : E.value[t] = [e]), f.arrowNavigation && p(E.value, "calendar");
		}, _e = (e) => {
			f.monthChangeOnScroll && (e.preventDefault(), d("handle-scroll", e));
		}, ve = (e) => v.value.type === "local" ? xS(e.value, { weekStartsOn: +f.weekStart }) : v.value.type === "iso" ? vS(e.value) : typeof v.value.type == "function" ? v.value.type(e.value) : "", ye = (e) => {
			let t = e[0];
			return v.value.hideOnOffsetDates ? e.some((e) => e.current) ? ve(t) : "" : ve(t);
		}, be = (e, t, n = !0) => {
			!n && bT() || (!y.value.enabled || h.value.allowPreventDefault) && (uT(e, h.value), d("select-date", t));
		}, xe = (e) => {
			uT(e, h.value);
		}, Se = (e) => {
			y.value.enabled && y.value.dragSelect ? (N.value = !0, d("select-date", e)) : y.value.enabled && d("select-date", e);
		};
		return i({ triggerTransition: oe }), (t, r) => (A(), o("div", { class: C(R.value) }, [s("div", {
			ref_key: "calendarWrapRef",
			ref: D,
			class: C(se.value),
			role: "grid"
		}, [
			s("div", ID, [t.weekNumbers ? (A(), o("div", LD, I(t.weekNumName), 1)) : a("", !0), (A(!0), o(e, null, P(ie.value, (n, r) => {
				var i;
				return A(), o("div", {
					key: r,
					class: "dp__calendar_header_item",
					role: "gridcell",
					"data-test-id": "calendar-header",
					"aria-label": ((i = L(g))?.weekDay)?.call(i, r)
				}, [t.$slots["calendar-header"] ? F(t.$slots, "calendar-header", {
					key: 0,
					day: n,
					index: r
				}) : a("", !0), t.$slots["calendar-header"] ? a("", !0) : (A(), o(e, { key: 1 }, [l(I(n), 1)], 64))], 8, RD);
			}), 128))]),
			r[2] ||= s("div", { class: "dp__calendar_header_separator" }, null, -1),
			u(n, {
				name: ee.value,
				css: !!t.transitions
			}, {
				default: B(() => [k.value ? (A(), o("div", {
					key: 0,
					class: "dp__calendar",
					role: "rowgroup",
					onMouseleave: r[1] ||= (e) => N.value = !1
				}, [(A(!0), o(e, null, P(re.value, (n, i) => (A(), o("div", {
					key: i,
					class: "dp__calendar_row",
					role: "row"
				}, [t.weekNumbers ? (A(), o("div", zD, [s("div", BD, I(ye(n.days)), 1)])) : a("", !0), (A(!0), o(e, null, P(n.days, (n, c) => {
					var u, d;
					return A(), o("div", {
						id: L(oE)(n.value),
						ref_for: !0,
						ref: (e) => H(e, i, c),
						key: c + i,
						role: "gridcell",
						class: "dp__calendar_item",
						"aria-pressed": (n.classData.dp__active_date || n.classData.dp__range_start || n.classData.dp__range_start) ?? void 0,
						"aria-disabled": n.classData.dp__cell_disabled || void 0,
						"aria-label": ((u = L(g))?.day)?.call(u, n),
						tabindex: !n.current && t.hideOffsetDates ? void 0 : 0,
						"data-test-id": L(oE)(n.value),
						onClick: U((e) => be(e, n), ["prevent"]),
						onTouchend: (e) => be(e, n, !1),
						onKeydown: (e) => L(yT)(e, () => t.$emit("select-date", n)),
						onMouseenter: (e) => pe(n, i, c),
						onMouseleave: (e) => me(n),
						onMousedown: (e) => Se(n),
						onMouseup: r[0] ||= (e) => N.value = !1
					}, [s("div", { class: C(["dp__cell_inner", n.classData]) }, [
						t.$slots.day && ue.value(n) ? F(t.$slots, "day", {
							key: 0,
							day: +n.text,
							date: n.value
						}) : a("", !0),
						t.$slots.day ? a("", !0) : (A(), o(e, { key: 1 }, [l(I(n.text), 1)], 64)),
						n.marker && ue.value(n) ? (A(), o(e, { key: 2 }, [t.$slots.marker ? F(t.$slots, "marker", {
							key: 0,
							marker: n.marker,
							day: +n.text,
							date: n.value
						}) : (A(), o("div", {
							key: 1,
							class: C(ce.value(n.marker)),
							style: T(n.marker.color ? { backgroundColor: n.marker.color } : {})
						}, null, 6))], 64)) : a("", !0),
						le.value(n.value) ? (A(), o("div", {
							key: 3,
							ref_for: !0,
							ref_key: "activeTooltip",
							ref: te,
							class: "dp__marker_tooltip",
							style: T(w.value)
						}, [(d = n.marker) != null && d.tooltip ? (A(), o("div", {
							key: 0,
							class: "dp__tooltip_content",
							onClick: xe
						}, [(A(!0), o(e, null, P(n.marker.tooltip, (r, i) => (A(), o("div", {
							key: i,
							class: "dp__tooltip_text"
						}, [t.$slots["marker-tooltip"] ? F(t.$slots, "marker-tooltip", {
							key: 0,
							tooltip: r,
							day: n.value
						}) : a("", !0), t.$slots["marker-tooltip"] ? a("", !0) : (A(), o(e, { key: 1 }, [s("div", {
							class: "dp__tooltip_mark",
							style: T(r.color ? { backgroundColor: r.color } : {})
						}, null, 4), s("div", null, I(r.text), 1)], 64))]))), 128)), s("div", {
							class: "dp__arrow_bottom_tp",
							style: T(ne.value)
						}, null, 4)])) : a("", !0)], 4)) : a("", !0)
					], 2)], 40, VD);
				}), 128))]))), 128))], 32)) : a("", !0)]),
				_: 3
			}, 8, ["name", "css"])
		], 2)], 2));
	}
}), UD = (e) => Array.isArray(e), WD = (e, t, n, i) => {
	let a = M([]), o = M(/* @__PURE__ */ new Date()), s = M(), { modelValue: c, calendars: l, time: u, today: d } = hO(e, t, () => ie(e.isTextInputDate)), { defaultedMultiCalendars: f, defaultedStartTime: p, defaultedRange: m, defaultedConfig: h, defaultedTz: g, propDates: _, defaultedMultiDates: v } = zE(e), { validateMonthYearInRange: y, isDisabled: b, isDateRangeAllowed: x, checkMinMaxRange: C } = _O(e), { updateTimeValues: w, getSetDateTime: T, setTime: E, assignStartTime: D, validateTime: k, disabledTimesConfig: ee } = DD(e, u, c, i), A = r(() => (e) => l.value[e] ? l.value[e].month : 0), j = r(() => (e) => l.value[e] ? l.value[e].year : 0), te = (e) => !h.value.keepViewOnOffsetClick || e ? !0 : !s.value, ne = (e, t, n, r = !1) => {
		te(r) && (l.value[e] || (l.value[e] = {
			month: 0,
			year: 0
		}), l.value[e].month = aT(t) ? l.value[e]?.month : t, l.value[e].year = aT(n) ? l.value[e]?.year : n);
	}, N = () => {
		e.autoApply && t("select-date");
	}, P = () => {
		p.value && D(p.value);
	};
	O(() => {
		e.shadow || (c.value || (fe(), P()), ie(!0), e.focusStartDate && e.startDate && fe());
	});
	let F = r(() => {
		var t;
		return (t = e.flow) != null && t.length && !e.partialFlow ? e.flowStep === e.flow.length : !0;
	}), re = () => {
		e.autoApply && F.value && t("auto-apply", e.partialFlow ? e.flowStep !== e.flow.length : !1);
	}, ie = (t = !1) => {
		if (c.value) return Array.isArray(c.value) ? (a.value = c.value, le(t)) : oe(c.value, t);
		if (f.value.count && t && !e.startDate) return ae(Y(), t);
	}, I = () => Array.isArray(c.value) && m.value.enabled ? QS(c.value[0]) === QS(c.value[1] ?? c.value[0]) : !1, ae = (e = /* @__PURE__ */ new Date(), t = !1) => {
		if ((!f.value.count || !f.value.static || t) && ne(0, QS(e), eC(e)), f.value.count && (!c.value || I() || !f.value.solo) && (!f.value.solo || t)) for (let e = 1; e < f.value.count; e++) {
			let t = Ox(_w(Y(), {
				month: A.value(e - 1),
				year: j.value(e - 1)
			}), { months: 1 });
			l.value[e] = {
				month: QS(t),
				year: eC(t)
			};
		}
	}, oe = (e, t) => {
		ae(e), E("hours", YS(e)), E("minutes", ZS(e)), E("seconds", $S(e)), f.value.count && t && de();
	}, L = (e) => {
		if (f.value.count) {
			if (f.value.solo) return 0;
			let t = QS(e[0]), n = QS(e[1]);
			return Math.abs(n - t) < f.value.count ? 0 : 1;
		}
		return 1;
	}, se = (e, t) => {
		e[1] && m.value.showLastInRange ? ae(e[L(e)], t) : ae(e[0], t);
		let n = (t, n) => [t(e[0]), e[1] ? t(e[1]) : u[n][1]];
		E("hours", n(YS, "hours")), E("minutes", n(ZS, "minutes")), E("seconds", n($S, "seconds"));
	}, ce = (t, n) => {
		if ((m.value.enabled || e.weekPicker) && !v.value.enabled) return se(t, n);
		if (v.value.enabled && n) {
			let e = t[t.length - 1];
			return oe(e, n);
		}
	}, le = (e) => {
		let t = c.value;
		ce(t, e), f.value.count && f.value.solo && de();
	}, R = (r, i) => {
		let a = _w(Y(), {
			month: A.value(i),
			year: j.value(i)
		}), o = r < 0 ? Dx(a, 1) : Cw(a, 1);
		y(QS(o), eC(o), r < 0, e.preventMinMaxNavigation) && (ne(i, QS(o), eC(o)), t("update-month-year", {
			instance: i,
			month: QS(o),
			year: eC(o)
		}), f.value.count && !f.value.solo && ue(i), n());
	}, ue = (e) => {
		for (let t = e - 1; t >= 0; t--) {
			let e = Cw(_w(Y(), {
				month: A.value(t + 1),
				year: j.value(t + 1)
			}), 1);
			ne(t, QS(e), eC(e));
		}
		for (let t = e + 1; t <= f.value.count - 1; t++) {
			let e = Dx(_w(Y(), {
				month: A.value(t - 1),
				year: j.value(t - 1)
			}), 1);
			ne(t, QS(e), eC(e));
		}
	}, de = () => {
		if (Array.isArray(c.value) && c.value.length === 2) {
			let e = Y(Y(c.value[1] ? c.value[1] : Dx(c.value[0], 1))), [t, n] = [QS(c.value[0]), eC(c.value[0])], [r, i] = [QS(c.value[1]), eC(c.value[1])];
			(t !== r || t === r && n !== i) && f.value.solo && ne(1, QS(e), eC(e));
		} else c.value && !Array.isArray(c.value) && (ne(0, QS(c.value), eC(c.value)), ae(Y()));
	}, fe = () => {
		e.startDate && (ne(0, QS(Y(e.startDate)), eC(Y(e.startDate))), f.value.count && ue(0));
	}, pe = (t, n) => {
		if (e.monthChangeOnScroll) {
			let r = (/* @__PURE__ */ new Date()).getTime() - o.value.getTime(), i = Math.abs(t.deltaY), a = 500;
			i > 1 && (a = 100), i > 100 && (a = 0), r > a && (o.value = /* @__PURE__ */ new Date(), R(e.monthChangeOnScroll === "inverse" ? t.deltaY : -t.deltaY, n));
		}
	}, me = (t, n, r = !1) => {
		e.monthChangeOnArrows && e.vertical === r && he(t, n);
	}, he = (e, t) => {
		R(e === "right" ? -1 : 1, t);
	}, z = (e) => {
		if (_.value.markers) return _T(e.value, _.value.markers);
	}, ge = (t, n) => {
		switch (e.sixWeeks === !0 ? "append" : e.sixWeeks) {
			case "prepend": return [!0, !1];
			case "center": return [t == 0, !0];
			case "fair": return [t == 0 || n > t, !0];
			case "append": return [!1, !1];
			default: return [!1, !1];
		}
	}, B = (t, n, r, i) => {
		if (e.sixWeeks && t.length < 6) {
			let e = 6 - t.length, a = (n.getDay() + 7 - i) % 7, o = 6 - (r.getDay() + 7 - i) % 7, [s, c] = ge(a, o);
			for (let r = 1; r <= e; r++) if (c ? !!(r % 2) == s : s) {
				let e = t[0].days[0], r = V(Ex(e.value, -7), QS(n));
				t.unshift({ days: r });
			} else {
				let e = t[t.length - 1], r = e.days[e.days.length - 1], i = V(Ex(r.value, 1), QS(n));
				t.push({ days: i });
			}
		}
		return t;
	}, V = (t, n) => {
		let r = Y(t), i = [];
		for (let t = 0; t < 7; t++) {
			let a = Ex(r, t), o = QS(a) !== n;
			i.push({
				text: e.hideOffsetDates && o ? "" : a.getDate(),
				value: a,
				current: !o,
				classData: {}
			});
		}
		return i;
	}, H = (t, n) => {
		let r = [], i = new Date(n, t), a = new Date(n, t + 1, 0), o = e.weekStart, s = Nx(i, { weekStartsOn: o }), c = (e) => {
			let n = V(e, t);
			if (r.push({ days: n }), !r[r.length - 1].days.some((e) => kT(ET(e.value), ET(a)))) {
				let t = Ex(e, 7);
				c(t);
			}
		};
		return c(s), B(r, i, a, o);
	}, U = (e) => {
		let n = DT(Y(e.value), u.hours, u.minutes, Ce());
		t("date-update", n), v.value.enabled ? iD(n, c, v.value.limit) : c.value = n, i(), S().then(() => {
			re();
		});
	}, _e = (e) => m.value.noDisabledRange ? RT(a.value[0], e).some((e) => b(e)) : !1, ve = () => {
		a.value = c.value ? c.value.slice() : [], a.value.length === 2 && !(m.value.fixedStart || m.value.fixedEnd) && (a.value = []);
	}, ye = (e, n) => {
		let r = [Y(e.value), Ex(Y(e.value), +m.value.autoRange)];
		x(r) ? (n && be(e.value), a.value = r) : t("invalid-date", e.value);
	}, be = (e) => {
		let t = QS(Y(e)), n = eC(Y(e));
		if (ne(0, t, n), f.value.count > 0) for (let t = 1; t < f.value.count; t++) {
			let n = zT(_w(Y(e), {
				year: j.value(t - 1),
				month: A.value(t - 1)
			}));
			ne(t, n.month, n.year);
		}
	}, xe = (e) => {
		if (_e(e.value) || !C(e.value, c.value, +!m.value.fixedStart)) return t("invalid-date", e.value);
		a.value = cD(Y(e.value), c, t, m);
	}, Se = (n, r) => {
		if (ve(), m.value.autoRange) return ye(n, r);
		if (m.value.fixedStart || m.value.fixedEnd) return xe(n);
		a.value[0] ? C(Y(n.value), c.value) && !_e(n.value) ? OT(Y(n.value), Y(a.value[0])) ? (a.value.unshift(Y(n.value)), t("range-end", a.value[0])) : (a.value[1] = Y(n.value), t("range-end", a.value[1])) : (e.autoApply && t("auto-apply-invalid", n.value), t("invalid-date", n.value)) : (a.value[0] = Y(n.value), t("range-start", a.value[0]));
	}, Ce = (t = !0) => e.enableSeconds ? Array.isArray(u.seconds) ? t ? u.seconds[0] : u.seconds[1] : u.seconds : 0, we = (e) => {
		a.value[e] = DT(a.value[e], u.hours[e], u.minutes[e], Ce(e !== 1));
	}, Te = () => {
		a.value[0] && a.value[1] && +a.value?.[0] > +a.value?.[1] && (a.value.reverse(), t("range-start", a.value[0]), t("range-end", a.value[1]));
	}, Ee = () => {
		a.value.length && (a.value[0] && !a.value[1] ? we(0) : (we(0), we(1), i()), Te(), c.value = a.value.slice(), oD(a.value, t, e.autoApply, e.modelAuto));
	}, De = (n, r = !1) => {
		if (b(n.value) || !n.current && e.hideOffsetDates) return t("invalid-date", n.value);
		if (s.value = JSON.parse(JSON.stringify(n)), !m.value.enabled) return U(n);
		UD(u.hours) && UD(u.minutes) && !v.value.enabled && (Se(n, r), Ee());
	}, Oe = (r, a) => {
		var o;
		ne(r, a.month, a.year, !0), f.value.count && !f.value.solo && ue(r), t("update-month-year", {
			instance: r,
			month: a.month,
			year: a.year
		}), n(f.value.solo ? r : void 0);
		let s = (o = e.flow) != null && o.length ? e.flow[e.flowStep] : void 0;
		!a.fromNav && (s === Hw.month || s === Hw.year) && i();
	}, ke = (t, n) => {
		sD({
			value: t,
			modelValue: c,
			range: m.value.enabled,
			timezone: n ? void 0 : g.value.timezone
		}), N(), e.multiCalendars && S().then(() => ie(!0));
	}, Ae = () => {
		let e = Pw(Y(), g.value);
		!m.value.enabled && !v.value.enabled ? c.value = e : c.value && Array.isArray(c.value) && c.value[0] ? v.value.enabled ? c.value = [...c.value, e] : c.value = OT(e, c.value[0]) ? [e, c.value[0]] : [c.value[0], e] : c.value = [e], N();
	}, je = () => {
		if (Array.isArray(c.value)) {
			if (v.value.enabled) {
				let e = Me();
				c.value[c.value.length - 1] = T(e);
			} else c.value = c.value.map((e, t) => e && T(e, t));
		} else c.value = T(c.value);
		t("time-update");
	}, Me = () => Array.isArray(c.value) && c.value.length ? c.value[c.value.length - 1] : null;
	return {
		calendars: l,
		modelValue: c,
		month: A,
		year: j,
		time: u,
		disabledTimesConfig: ee,
		today: d,
		validateTime: k,
		getCalendarDays: H,
		getMarker: z,
		handleScroll: pe,
		handleSwipe: he,
		handleArrow: me,
		selectDate: De,
		updateMonthYear: Oe,
		presetDate: ke,
		selectCurrentDate: Ae,
		updateTime: (e, t = !0, n = !1) => {
			w(e, t, n, je);
		},
		assignMonthAndYear: ae,
		setStartTime: P
	};
}, GD = { key: 0 }, KD = /* @__PURE__ */ f({
	__name: "DatePicker",
	props: { ...UE },
	emits: [
		"tooltip-open",
		"tooltip-close",
		"mount",
		"update:internal-model-value",
		"update-flow-step",
		"reset-flow",
		"auto-apply",
		"focus-menu",
		"select-date",
		"range-start",
		"range-end",
		"invalid-fixed-range",
		"time-update",
		"am-pm-change",
		"time-picker-open",
		"time-picker-close",
		"recalculate-position",
		"update-month-year",
		"auto-apply-invalid",
		"date-update",
		"invalid-date",
		"overlay-toggle"
	],
	setup(t, { expose: n, emit: s }) {
		let l = s, d = t, { calendars: f, month: p, year: m, modelValue: g, time: _, disabledTimesConfig: v, today: y, validateTime: b, getCalendarDays: S, getMarker: C, handleArrow: T, handleScroll: E, handleSwipe: D, selectDate: O, updateMonthYear: k, presetDate: ee, selectCurrentDate: j, updateTime: te, assignMonthAndYear: ne, setStartTime: N } = WD(d, l, he, ge), re = ue(), { setHoverDate: ie, getDayClassData: I, clearHoverDate: ae } = gO(g, d), { defaultedMultiCalendars: oe } = zE(d), se = M([]), ce = M([]), le = M(null), R = pO(re, "calendar"), de = pO(re, "monthYear"), fe = pO(re, "timePicker"), pe = (e) => {
			d.shadow || l("mount", e);
		};
		z(f, () => {
			d.shadow || setTimeout(() => {
				l("recalculate-position");
			}, 0);
		}, { deep: !0 }), z(oe, (e, t) => {
			e.count - t.count > 0 && ne();
		}, { deep: !0 });
		let me = r(() => (e) => S(p.value(e), m.value(e)).map((e) => ({
			...e,
			days: e.days.map((e) => (e.marker = C(e), e.classData = I(e), e))
		})));
		function he(e) {
			var t;
			e || e === 0 ? (t = ce.value[e]) == null || t.triggerTransition(p.value(e), m.value(e)) : ce.value.forEach((e, t) => e.triggerTransition(p.value(t), m.value(t)));
		}
		function ge() {
			l("update-flow-step");
		}
		let V = (e, t = !1) => {
			O(e, t), d.spaceConfirm && l("select-date");
		}, H = (e, t, n = 0) => {
			var r;
			(r = se.value[n]) == null || r.toggleMonthPicker(e, t);
		}, U = (e, t, n = 0) => {
			var r;
			(r = se.value[n]) == null || r.toggleYearPicker(e, t);
		}, _e = (e, t, n) => {
			var r;
			(r = le.value) == null || r.toggleTimePicker(e, t, n);
		}, ve = (e, t) => {
			var n;
			if (!d.range) {
				let r = g.value ? g.value : y, i = t ? new Date(t) : r, a = e ? Nx(i, { weekStartsOn: 1 }) : nS(i, { weekStartsOn: 1 });
				O({
					value: a,
					current: QS(i) === p.value(0),
					text: "",
					classData: {}
				}), (n = document.getElementById(oE(a))) == null || n.focus();
			}
		}, ye = (e) => {
			var t;
			(t = se.value[0]) == null || t.handleMonthYearChange(e, !0);
		}, be = (e) => {
			k(0, {
				month: p.value(0),
				year: m.value(0) + (e ? 1 : -1),
				fromNav: !0
			});
		}, xe = (e, t) => {
			e === Hw.time && l(`time-picker-${t ? "open" : "close"}`), l("overlay-toggle", {
				open: t,
				overlay: e
			});
		}, Se = (e) => {
			l("overlay-toggle", {
				open: !1,
				overlay: e
			}), l("focus-menu");
		};
		return n({
			clearHoverDate: ae,
			presetDate: ee,
			selectCurrentDate: j,
			toggleMonthPicker: H,
			toggleYearPicker: U,
			toggleTimePicker: _e,
			handleArrow: T,
			updateMonthYear: k,
			getSidebarProps: () => ({
				modelValue: g,
				month: p,
				year: m,
				time: _,
				updateTime: te,
				updateMonthYear: k,
				selectDate: O,
				presetDate: ee
			}),
			changeMonth: ye,
			changeYear: be,
			selectWeekDate: ve,
			setStartTime: N
		}), (t, n) => (A(), o(e, null, [u($E, {
			"multi-calendars": L(oe).count,
			collapse: t.collapse,
			"is-mobile": t.isMobile
		}, {
			default: B(({ instance: e, index: r }) => [t.disableMonthYearSelect ? a("", !0) : (A(), i(FD, x({
				key: 0,
				ref: (e) => {
					e && (se.value[r] = e);
				},
				months: L(Zw)(t.formatLocale, t.locale, t.monthNameFormat),
				years: L(Xw)(t.yearRange, t.locale, t.reverseYears),
				month: L(p)(e),
				year: L(m)(e),
				instance: e
			}, t.$props, {
				onMount: n[0] ||= (e) => pe(L(Vw).header),
				onResetFlow: n[1] ||= (e) => t.$emit("reset-flow"),
				onUpdateMonthYear: (t) => L(k)(e, t),
				onOverlayClosed: Se,
				onOverlayOpened: n[2] ||= (e) => t.$emit("overlay-toggle", {
					open: !0,
					overlay: e
				})
			}), c({ _: 2 }, [P(L(de), (e, n) => ({
				name: e,
				fn: B((n) => [F(t.$slots, e, w(h(n)))])
			}))]), 1040, [
				"months",
				"years",
				"month",
				"year",
				"instance",
				"onUpdateMonthYear"
			])), u(HD, x({
				ref: (e) => {
					e && (ce.value[r] = e);
				},
				"mapped-dates": me.value(e),
				month: L(p)(e),
				year: L(m)(e),
				instance: e
			}, t.$props, {
				onSelectDate: (t) => L(O)(t, e !== 1),
				onHandleSpace: (t) => V(t, e !== 1),
				onSetHoverDate: n[3] ||= (e) => L(ie)(e),
				onHandleScroll: (t) => L(E)(t, e),
				onHandleSwipe: (t) => L(D)(t, e),
				onMount: n[4] ||= (e) => pe(L(Vw).calendar),
				onResetFlow: n[5] ||= (e) => t.$emit("reset-flow"),
				onTooltipOpen: n[6] ||= (e) => t.$emit("tooltip-open", e),
				onTooltipClose: n[7] ||= (e) => t.$emit("tooltip-close", e)
			}), c({ _: 2 }, [P(L(R), (e, n) => ({
				name: e,
				fn: B((n) => [F(t.$slots, e, w(h({ ...n })))])
			}))]), 1040, [
				"mapped-dates",
				"month",
				"year",
				"instance",
				"onSelectDate",
				"onHandleSpace",
				"onHandleScroll",
				"onHandleSwipe"
			])]),
			_: 3
		}, 8, [
			"multi-calendars",
			"collapse",
			"is-mobile"
		]), t.enableTimePicker ? (A(), o("div", GD, [t.$slots["time-picker"] ? F(t.$slots, "time-picker", w(x({ key: 0 }, {
			time: L(_),
			updateTime: L(te)
		}))) : (A(), i(ED, x({
			key: 1,
			ref_key: "timePickerRef",
			ref: le
		}, t.$props, {
			hours: L(_).hours,
			minutes: L(_).minutes,
			seconds: L(_).seconds,
			"internal-model-value": t.internalModelValue,
			"disabled-times-config": L(v),
			"validate-time": L(b),
			onMount: n[8] ||= (e) => pe(L(Vw).timePicker),
			"onUpdate:hours": n[9] ||= (e) => L(te)(e),
			"onUpdate:minutes": n[10] ||= (e) => L(te)(e, !1),
			"onUpdate:seconds": n[11] ||= (e) => L(te)(e, !1, !0),
			onResetFlow: n[12] ||= (e) => t.$emit("reset-flow"),
			onOverlayClosed: n[13] ||= (e) => xe(e, !1),
			onOverlayOpened: n[14] ||= (e) => xe(e, !0),
			onAmPmChange: n[15] ||= (e) => t.$emit("am-pm-change", e)
		}), c({ _: 2 }, [P(L(fe), (e, n) => ({
			name: e,
			fn: B((n) => [F(t.$slots, e, w(h(n)))])
		}))]), 1040, [
			"hours",
			"minutes",
			"seconds",
			"internal-model-value",
			"disabled-times-config",
			"validate-time"
		]))])) : a("", !0)], 64));
	}
}), qD = (e, t) => {
	let n = M(), { defaultedMultiCalendars: i, defaultedConfig: a, defaultedHighlight: o, defaultedRange: s, propDates: c, defaultedFilters: l, defaultedMultiDates: u } = zE(e), { modelValue: d, year: f, month: p, calendars: m } = hO(e, t), { isDisabled: h } = _O(e), { selectYear: g, groupedYears: _, showYearPicker: v, isDisabled: y, toggleYearPicker: b, handleYearSelect: x, handleYear: S } = lD({
		modelValue: d,
		multiCalendars: i,
		range: s,
		highlight: o,
		calendars: m,
		propDates: c,
		month: p,
		year: f,
		filters: l,
		props: e,
		emit: t
	}), C = (t, n) => [t, n].map((t) => WS(t, "MMMM", { locale: e.formatLocale })).join("-"), w = r(() => (e) => d.value ? Array.isArray(d.value) ? d.value.some((t) => mw(e, t)) : mw(d.value, e) : !1), T = (e) => {
		if (s.value.enabled) {
			if (Array.isArray(d.value)) {
				let t = kT(e, d.value[0]) || kT(e, d.value[1]);
				return jT(d.value, n.value, e) && !t;
			}
			return !1;
		}
		return !1;
	}, E = (e, t) => e.quarter === Kx(t) && e.year === eC(t), D = (e) => typeof o.value == "function" ? o.value({
		quarter: Kx(e),
		year: eC(e)
	}) : !!o.value.quarters.find((t) => E(t, e)), O = r(() => (e) => {
		let t = _w(/* @__PURE__ */ new Date(), { year: f.value(e) });
		return Qx({
			start: tS(t),
			end: eS(t)
		}).map((e) => {
			let t = Zx(e), n = rS(e), r = h(e), i = T(t), a = D(t);
			return {
				text: C(t, n),
				value: t,
				active: w.value(t),
				highlighted: a,
				disabled: r,
				isBetween: i
			};
		});
	}), k = (e) => {
		iD(e, d, u.value.limit), t("auto-apply", !0);
	}, ee = (n) => {
		d.value = aD(d, n, t), oD(d.value, t, e.autoApply, e.modelAuto);
	}, A = (e) => {
		d.value = e, t("auto-apply");
	};
	return {
		defaultedConfig: a,
		defaultedMultiCalendars: i,
		groupedYears: _,
		year: f,
		isDisabled: y,
		quarters: O,
		showYearPicker: v,
		modelValue: d,
		setHoverDate: (e) => {
			n.value = e;
		},
		selectYear: g,
		selectQuarter: (e, t, n) => {
			if (!n) return m.value[t].month = QS(rS(e)), u.value.enabled ? k(e) : s.value.enabled ? ee(e) : A(e);
		},
		toggleYearPicker: b,
		handleYearSelect: x,
		handleYear: S
	};
}, JD = { class: "dp--quarter-items" }, YD = [
	"data-test-id",
	"disabled",
	"onClick",
	"onMouseover"
], XD = /* @__PURE__ */ f({
	compatConfig: { MODE: 3 },
	__name: "QuarterPicker",
	props: { ...UE },
	emits: [
		"update:internal-model-value",
		"reset-flow",
		"overlay-closed",
		"auto-apply",
		"range-start",
		"range-end",
		"overlay-toggle",
		"update-month-year"
	],
	setup(t, { expose: n, emit: r }) {
		let d = r, f = t, p = pO(ue(), "yearMode"), { defaultedMultiCalendars: m, defaultedConfig: g, groupedYears: _, year: v, isDisabled: y, quarters: b, modelValue: S, showYearPicker: E, setHoverDate: D, selectQuarter: O, toggleYearPicker: k, handleYearSelect: ee, handleYear: j } = qD(f, d);
		return n({ getSidebarProps: () => ({
			modelValue: S,
			year: v,
			selectQuarter: O,
			handleYearSelect: ee,
			handleYear: j
		}) }), (t, n) => (A(), i($E, {
			"multi-calendars": L(m).count,
			collapse: t.collapse,
			stretch: "",
			"is-mobile": t.isMobile
		}, {
			default: B(({ instance: n }) => [s("div", {
				class: "dp-quarter-picker-wrap",
				style: T({ minHeight: `${L(g).modeHeight}px` })
			}, [
				t.$slots["top-extra"] ? F(t.$slots, "top-extra", {
					key: 0,
					value: t.internalModelValue
				}) : a("", !0),
				s("div", null, [u(rD, x(t.$props, {
					items: L(_)(n),
					instance: n,
					"show-year-picker": L(E)[n],
					year: L(v)(n),
					"is-disabled": (e) => L(y)(n, e),
					onHandleYear: (e) => L(j)(n, e),
					onYearSelect: (e) => L(ee)(e, n),
					onToggleYearPicker: (e) => L(k)(n, e?.flow, e?.show)
				}), c({ _: 2 }, [P(L(p), (e, n) => ({
					name: e,
					fn: B((n) => [F(t.$slots, e, w(h(n)))])
				}))]), 1040, [
					"items",
					"instance",
					"show-year-picker",
					"year",
					"is-disabled",
					"onHandleYear",
					"onYearSelect",
					"onToggleYearPicker"
				])]),
				s("div", JD, [(A(!0), o(e, null, P(L(b)(n), (r, i) => (A(), o("div", { key: i }, [s("button", {
					type: "button",
					class: C(["dp--qr-btn", {
						"dp--qr-btn-active": r.active,
						"dp--qr-btn-between": r.isBetween,
						"dp--qr-btn-disabled": r.disabled,
						"dp--highlighted": r.highlighted
					}]),
					"data-test-id": r.value,
					disabled: r.disabled,
					onClick: (e) => L(O)(r.value, n, r.disabled),
					onMouseover: (e) => L(D)(r.value)
				}, [t.$slots.quarter ? F(t.$slots, "quarter", {
					key: 0,
					value: r.value,
					text: r.text
				}) : (A(), o(e, { key: 1 }, [l(I(r.text), 1)], 64))], 42, YD)]))), 128))])
			], 4)]),
			_: 3
		}, 8, [
			"multi-calendars",
			"collapse",
			"is-mobile"
		]));
	}
}), ZD = (e, t) => {
	let n = M(0);
	O(() => {
		i(), window.addEventListener("resize", i, { passive: !0 });
	}), ee(() => {
		window.removeEventListener("resize", i);
	});
	let i = () => {
		n.value = window.document.documentElement.clientWidth;
	};
	return { isMobile: r(() => n.value <= e.value.mobileBreakpoint && !t || void 0) };
}, QD = [
	"id",
	"tabindex",
	"role",
	"aria-label"
], $D = {
	key: 0,
	class: "dp--menu-load-container"
}, eO = {
	key: 1,
	class: "dp--menu-header"
}, tO = ["data-dp-mobile"], nO = {
	key: 0,
	class: "dp__sidebar_left"
}, rO = ["data-dp-mobile"], iO = [
	"data-test-id",
	"data-dp-mobile",
	"onClick",
	"onKeydown"
], aO = {
	key: 2,
	class: "dp__sidebar_right"
}, oO = {
	key: 3,
	class: "dp__action_extra"
}, sO = /* @__PURE__ */ f({
	compatConfig: { MODE: 3 },
	__name: "DatepickerMenu",
	props: {
		...HE,
		shadow: {
			type: Boolean,
			default: !1
		},
		openOnTop: {
			type: Boolean,
			default: !1
		},
		internalModelValue: {
			type: [Date, Array],
			default: null
		},
		noOverlayFocus: {
			type: Boolean,
			default: !1
		},
		collapse: {
			type: Boolean,
			default: !1
		},
		getInputRect: {
			type: Function,
			default: () => ({})
		},
		isTextInputDate: {
			type: Boolean,
			default: !1
		}
	},
	emits: [
		"close-picker",
		"select-date",
		"auto-apply",
		"time-update",
		"flow-step",
		"update-month-year",
		"invalid-select",
		"update:internal-model-value",
		"recalculate-position",
		"invalid-fixed-range",
		"tooltip-open",
		"tooltip-close",
		"time-picker-open",
		"time-picker-close",
		"am-pm-change",
		"range-start",
		"range-end",
		"auto-apply-invalid",
		"date-update",
		"invalid-date",
		"overlay-toggle",
		"menu-blur"
	],
	setup(t, { expose: n, emit: l }) {
		let u = l, d = t, f = M(null), p = r(() => {
			let { openOnTop: e, ...t } = d;
			return {
				...t,
				isMobile: D.value,
				flowStep: de.value,
				menuWrapRef: f.value
			};
		}), { setMenuFocused: m, setShiftKey: g, control: _ } = lE(), v = ue(), { defaultedTextInput: y, defaultedInline: b, defaultedConfig: S, defaultedUI: E } = zE(d), { isMobile: D } = ZD(S, d.shadow), k = M(null), j = M(0), te = M(null), ne = M(!1), N = M(null), ie = M(!1);
		O(() => {
			if (!d.shadow) {
				ne.value = !0, ae(), window.addEventListener("resize", ae);
				let e = $w(f);
				if (e && !y.value.enabled && !b.value.enabled && (m(!0), V()), e) {
					let t = (e) => {
						ie.value = !0, S.value.allowPreventDefault && e.preventDefault(), uT(e, S.value, !0);
					};
					e.addEventListener("pointerdown", t), e.addEventListener("mousedown", t);
				}
			}
			document.addEventListener("mousedown", Le);
		}), ee(() => {
			window.removeEventListener("resize", ae), document.addEventListener("mousedown", Le);
		});
		let ae = () => {
			let e = $w(te);
			e && (j.value = e.getBoundingClientRect().width);
		}, { arrowRight: se, arrowLeft: ce, arrowDown: le, arrowUp: R } = vE(), { flowStep: de, updateFlowStep: fe, childMount: pe, resetFlow: me, handleFlow: he } = yO(d, u, N), z = r(() => d.monthPicker ? dD : d.yearPicker ? pD : d.timePicker ? kD : d.quarterPicker ? XD : KD), ge = r(() => {
			if (S.value.arrowLeft) return S.value.arrowLeft;
			let e = f.value?.getBoundingClientRect(), t = d.getInputRect();
			return t?.width < j?.value && t?.left <= (e?.left ?? 0) ? `${t?.width / 2}px` : t?.right >= (e?.right ?? 0) && t?.width < j?.value ? `${j?.value - t?.width / 2}px` : "50%";
		}), V = () => {
			let e = $w(f);
			e && e.focus({ preventScroll: !0 });
		}, H = r(() => N.value?.getSidebarProps() || {}), _e = () => {
			d.openOnTop && u("recalculate-position");
		}, ve = pO(v, "action"), ye = r(() => d.monthPicker || d.yearPicker ? pO(v, "monthYear") : d.timePicker ? pO(v, "timePicker") : pO(v, "shared")), be = r(() => d.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), xe = r(() => ({
			dp__menu_disabled: d.disabled,
			dp__menu_readonly: d.readonly,
			"dp-menu-loading": d.loading
		})), Se = r(() => ({
			dp__menu: !0,
			dp__menu_index: !b.value.enabled,
			dp__relative: b.value.enabled,
			...E.value.menu ?? {}
		})), Ce = (e) => {
			uT(e, S.value, !0);
		}, we = () => {
			d.escClose && u("close-picker");
		}, Te = (e) => {
			if (d.arrowNavigation) {
				if (e === Ww.up) return R();
				if (e === Ww.down) return le();
				if (e === Ww.left) return ce();
				if (e === Ww.right) return se();
			} else e === Ww.left || e === Ww.up ? Ae("handleArrow", Ww.left, 0, e === Ww.up) : Ae("handleArrow", Ww.right, 0, e === Ww.down);
		}, Ee = (e) => {
			g(e.shiftKey), !d.disableMonthYearSelect && e.code === Gw.tab && e.target.classList.contains("dp__menu") && _.value.shiftKeyInMenu && (e.preventDefault(), uT(e, S.value, !0), u("close-picker"));
		}, De = () => {
			V(), u("time-picker-close");
		}, Oe = (e) => {
			var t, n, r;
			(t = N.value) == null || t.toggleTimePicker(!1, !1), (n = N.value) == null || n.toggleMonthPicker(!1, !1, e), (r = N.value) == null || r.toggleYearPicker(!1, !1, e);
		}, ke = (e, t = 0) => e === "month" ? N.value?.toggleMonthPicker(!1, !0, t) : e === "year" ? N.value?.toggleYearPicker(!1, !0, t) : e === "time" ? N.value?.toggleTimePicker(!0, !1) : Oe(t), Ae = (e, ...t) => {
			var n, r;
			(n = N.value) != null && n[e] && ((r = N.value) == null || r[e](...t));
		}, je = () => {
			Ae("selectCurrentDate");
		}, Me = (e, t) => {
			Ae("presetDate", oe(e), t);
		}, Ne = () => {
			Ae("clearHoverDate");
		}, Pe = (e, t) => {
			Ae("updateMonthYear", e, t);
		}, Fe = (e, t) => {
			e.preventDefault(), Te(t);
		}, Ie = (e) => {
			var t, n, r;
			if (Ee(e), e.key === Gw.home || e.key === Gw.end) return Ae("selectWeekDate", e.key === Gw.home, e.target.getAttribute("id"));
			switch ((e.key === Gw.pageUp || e.key === Gw.pageDown) && (e.shiftKey ? (Ae("changeYear", e.key === Gw.pageUp), (t = pT(f.value, "overlay-year")) == null || t.focus()) : (Ae("changeMonth", e.key === Gw.pageUp), (n = pT(f.value, e.key === Gw.pageUp ? "action-prev" : "action-next")) == null || n.focus()), e.target.getAttribute("id") && ((r = f.value) == null || r.focus({ preventScroll: !0 }))), e.key) {
				case Gw.esc: return we();
				case Gw.arrowLeft: return Fe(e, Ww.left);
				case Gw.arrowRight: return Fe(e, Ww.right);
				case Gw.arrowUp: return Fe(e, Ww.up);
				case Gw.arrowDown: return Fe(e, Ww.down);
				default: return;
			}
		}, Le = (e) => {
			var t;
			b.value.enabled && !b.value.input && !((t = f.value) != null && t.contains(e.target)) && ie.value && (ie.value = !1, u("menu-blur"));
		};
		return n({
			updateMonthYear: Pe,
			switchView: ke,
			handleFlow: he,
			onValueCleared: () => {
				var e, t;
				(t = (e = N.value)?.setStartTime) == null || t.call(e);
			}
		}), (n, r) => (A(), o("div", {
			id: n.uid ? `dp-menu-${n.uid}` : void 0,
			ref_key: "dpMenuRef",
			ref: f,
			tabindex: L(b).enabled ? void 0 : "0",
			role: L(b).enabled ? void 0 : "dialog",
			"aria-label": n.ariaLabels?.menu,
			class: C(Se.value),
			style: T({ "--dp-arrow-left": ge.value }),
			onMouseleave: Ne,
			onClick: Ce,
			onKeydown: Ie
		}, [
			(n.disabled || n.readonly) && L(b).enabled || n.loading ? (A(), o("div", {
				key: 0,
				class: C(xe.value)
			}, [n.loading ? (A(), o("div", $D, r[19] ||= [s("span", { class: "dp--menu-loader" }, null, -1)])) : a("", !0)], 2)) : a("", !0),
			n.$slots["menu-header"] ? (A(), o("div", eO, [F(n.$slots, "menu-header")])) : a("", !0),
			!L(b).enabled && !n.teleportCenter ? (A(), o("div", {
				key: 2,
				class: C(be.value)
			}, null, 2)) : a("", !0),
			s("div", {
				ref_key: "innerMenuRef",
				ref: te,
				class: C({
					dp__menu_content_wrapper: n.presetDates?.length || !!n.$slots["left-sidebar"] || !!n.$slots["right-sidebar"],
					"dp--menu-content-wrapper-collapsed": t.collapse && (n.presetDates?.length || !!n.$slots["left-sidebar"] || !!n.$slots["right-sidebar"])
				}),
				"data-dp-mobile": L(D),
				style: T({ "--dp-menu-width": `${j.value}px` })
			}, [
				n.$slots["left-sidebar"] ? (A(), o("div", nO, [F(n.$slots, "left-sidebar", w(h(H.value)))])) : a("", !0),
				n.presetDates.length ? (A(), o("div", {
					key: 1,
					class: C({
						"dp--preset-dates-collapsed": t.collapse,
						"dp--preset-dates": !0
					}),
					"data-dp-mobile": L(D)
				}, [(A(!0), o(e, null, P(n.presetDates, (r, i) => (A(), o(e, { key: i }, [r.slot ? F(n.$slots, r.slot, {
					key: 0,
					presetDate: Me,
					label: r.label,
					value: r.value
				}) : (A(), o("button", {
					key: 1,
					type: "button",
					style: T(r.style || {}),
					class: C(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": t.collapse }]),
					"data-test-id": r.testId ?? void 0,
					"data-dp-mobile": L(D),
					onClick: U((e) => Me(r.value, r.noTz), ["prevent"]),
					onKeydown: (e) => L(yT)(e, () => Me(r.value, r.noTz), !0)
				}, I(r.label), 47, iO))], 64))), 128))], 10, rO)) : a("", !0),
				s("div", {
					ref_key: "calendarWrapperRef",
					ref: k,
					class: "dp__instance_calendar",
					role: "document"
				}, [(A(), i(re(z.value), x({
					ref_key: "dynCmpRef",
					ref: N
				}, p.value, {
					"flow-step": L(de),
					onMount: L(pe),
					onUpdateFlowStep: L(fe),
					onResetFlow: L(me),
					onFocusMenu: V,
					onSelectDate: r[0] ||= (e) => n.$emit("select-date"),
					onDateUpdate: r[1] ||= (e) => n.$emit("date-update", e),
					onTooltipOpen: r[2] ||= (e) => n.$emit("tooltip-open", e),
					onTooltipClose: r[3] ||= (e) => n.$emit("tooltip-close", e),
					onAutoApply: r[4] ||= (e) => n.$emit("auto-apply", e),
					onRangeStart: r[5] ||= (e) => n.$emit("range-start", e),
					onRangeEnd: r[6] ||= (e) => n.$emit("range-end", e),
					onInvalidFixedRange: r[7] ||= (e) => n.$emit("invalid-fixed-range", e),
					onTimeUpdate: r[8] ||= (e) => n.$emit("time-update"),
					onAmPmChange: r[9] ||= (e) => n.$emit("am-pm-change", e),
					onTimePickerOpen: r[10] ||= (e) => n.$emit("time-picker-open", e),
					onTimePickerClose: De,
					onRecalculatePosition: _e,
					onUpdateMonthYear: r[11] ||= (e) => n.$emit("update-month-year", e),
					onAutoApplyInvalid: r[12] ||= (e) => n.$emit("auto-apply-invalid", e),
					onInvalidDate: r[13] ||= (e) => n.$emit("invalid-date", e),
					onOverlayToggle: r[14] ||= (e) => n.$emit("overlay-toggle", e),
					"onUpdate:internalModelValue": r[15] ||= (e) => n.$emit("update:internal-model-value", e)
				}), c({ _: 2 }, [P(ye.value, (e, t) => ({
					name: e,
					fn: B((t) => [F(n.$slots, e, w(h({ ...t })))])
				}))]), 1040, [
					"flow-step",
					"onMount",
					"onUpdateFlowStep",
					"onResetFlow"
				]))], 512),
				n.$slots["right-sidebar"] ? (A(), o("div", aO, [F(n.$slots, "right-sidebar", w(h(H.value)))])) : a("", !0),
				n.$slots["action-extra"] ? (A(), o("div", oO, [n.$slots["action-extra"] ? F(n.$slots, "action-extra", {
					key: 0,
					selectCurrentDate: je
				}) : a("", !0)])) : a("", !0)
			], 14, tO),
			!n.autoApply || L(S).keepActionRow ? (A(), i(KE, x({
				key: 3,
				"menu-mount": ne.value
			}, p.value, {
				"calendar-width": j.value,
				onClosePicker: r[16] ||= (e) => n.$emit("close-picker"),
				onSelectDate: r[17] ||= (e) => n.$emit("select-date"),
				onInvalidSelect: r[18] ||= (e) => n.$emit("invalid-select"),
				onSelectNow: je
			}), c({ _: 2 }, [P(L(ve), (e, t) => ({
				name: e,
				fn: B((t) => [F(n.$slots, e, w(h({ ...t })))])
			}))]), 1040, ["menu-mount", "calendar-width"])) : a("", !0)
		], 46, QD));
	}
}), cO = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(cO || {}), lO = ({ menuRef: e, menuRefInner: t, inputRef: n, pickerWrapperRef: r, inline: i, emit: a, props: o, slots: s }) => {
	let { defaultedConfig: c } = zE(o), l = M({}), u = M(!1), d = M({
		top: "0",
		left: "0"
	}), f = M(!1), p = ae(o, "teleportCenter");
	z(p, () => {
		d.value = JSON.parse(JSON.stringify({})), S();
	});
	let m = (e) => {
		if (o.teleport) {
			let t = e.getBoundingClientRect();
			return {
				left: t.left + window.scrollX,
				top: t.top + window.scrollY
			};
		}
		return {
			top: 0,
			left: 0
		};
	}, h = (e, t) => {
		d.value.left = `${e + t - l.value.width}px`;
	}, _ = (e) => {
		d.value.left = `${e}px`;
	}, v = (e, t) => {
		o.position === cO.left && _(e), o.position === cO.right && h(e, t), o.position === cO.center && (d.value.left = `${e + t / 2 - l.value.width / 2}px`);
	}, y = (e) => {
		let { width: t, height: n } = e.getBoundingClientRect(), { top: r, left: i } = m(e);
		return {
			top: +r,
			left: +i,
			width: t,
			height: n
		};
	}, b = () => {
		d.value.left = "50%", d.value.top = "50%", d.value.transform = "translate(-50%, -50%)", d.value.position = "fixed", delete d.value.opacity;
	}, x = () => {
		let e = $w(n);
		d.value = o.altPosition(e);
	}, S = (n = !0) => {
		if (!i.value.enabled) {
			if (p.value) return b();
			if (o.altPosition !== null) return x();
			if (n) {
				let n = o.teleport ? t.value?.$el : e.value;
				n && (l.value = n.getBoundingClientRect()), a("recalculate-position");
			}
			return k();
		}
	}, C = ({ inputEl: e, left: t, width: n }) => {
		window.screen.width > 768 && !u.value && v(t, n), E(e);
	}, w = (e) => {
		let { top: t, left: n, height: r, width: i } = y(e);
		d.value.top = `${r + t + +o.offset}px`, f.value = !1, u.value || (d.value.left = `${n + i / 2 - l.value.width / 2}px`), C({
			inputEl: e,
			left: n,
			width: i
		});
	}, T = (e) => {
		let { top: t, left: n, width: r } = y(e);
		d.value.top = `${t - +o.offset - l.value.height}px`, f.value = !0, C({
			inputEl: e,
			left: n,
			width: r
		});
	}, E = (e) => {
		if (o.autoPosition) {
			let { left: t, width: n } = y(e), { left: r, right: i } = l.value;
			if (!u.value) {
				if (Math.abs(r) !== Math.abs(i)) {
					if (r <= 0) return u.value = !0, _(t);
					if (i >= document.documentElement.clientWidth) return u.value = !0, h(t, n);
				}
				return v(t, n);
			}
		}
	}, D = () => {
		let e = $w(n);
		if (e) {
			if (o.autoPosition === Bw.top) return Bw.top;
			if (o.autoPosition === Bw.bottom) return Bw.bottom;
			let { height: t } = l.value, { top: n, height: r } = e.getBoundingClientRect(), i = window.innerHeight - n - r, a = n;
			return t <= i ? Bw.bottom : t > i && t <= a ? Bw.top : i >= a ? Bw.bottom : Bw.top;
		}
		return Bw.bottom;
	}, O = (e) => D() === Bw.bottom ? w(e) : T(e), k = () => {
		let e = $w(n);
		if (e) return o.autoPosition ? O(e) : w(e);
	}, ee = function(e) {
		if (e) {
			let t = e.scrollHeight > e.clientHeight, n = window.getComputedStyle(e).overflowY.indexOf("hidden") !== -1;
			return t && !n;
		}
		return !0;
	}, A = function(e) {
		return !e || e === document.body || e.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : ee(e) ? e : A(e.assignedSlot && c.value.shadowDom ? e.assignedSlot.parentNode : e.parentNode);
	}, j = (e) => {
		if (e) switch (o.position) {
			case cO.left: return {
				left: 0,
				transform: "translateX(0)"
			};
			case cO.right: return {
				left: `${e.width}px`,
				transform: "translateX(-100%)"
			};
			default: return {
				left: `${e.width / 2}px`,
				transform: "translateX(-50%)"
			};
		}
		return {};
	};
	return {
		openOnTop: f,
		menuStyle: d,
		xCorrect: u,
		setMenuPosition: S,
		getScrollableParent: A,
		shadowRender: (e, t) => {
			var i;
			let a = document.createElement("div"), o = $w(n)?.getBoundingClientRect();
			a.setAttribute("id", "dp--temp-container");
			let u = (i = r.value) != null && i.clientWidth ? r.value : document.body;
			u.append(a);
			let d = j(o), f = c.value.shadowDom ? Object.keys(s).filter((e) => [
				"right-sidebar",
				"left-sidebar",
				"top-extra",
				"action-extra"
			].includes(e)) : Object.keys(s), p = g(e, {
				...t,
				shadow: !0,
				style: {
					opacity: 0,
					position: "absolute",
					...d
				}
			}, Object.fromEntries(f.map((e) => [e, s[e]])));
			N(p, a), l.value = p.el?.getBoundingClientRect(), N(null, a), u.removeChild(a);
		}
	};
}, uO = [
	{
		name: "clock-icon",
		use: [
			"time",
			"calendar",
			"shared"
		]
	},
	{
		name: "arrow-left",
		use: [
			"month-year",
			"calendar",
			"shared",
			"year-mode"
		]
	},
	{
		name: "arrow-right",
		use: [
			"month-year",
			"calendar",
			"shared",
			"year-mode"
		]
	},
	{
		name: "arrow-up",
		use: [
			"time",
			"calendar",
			"month-year",
			"shared"
		]
	},
	{
		name: "arrow-down",
		use: [
			"time",
			"calendar",
			"month-year",
			"shared"
		]
	},
	{
		name: "calendar-icon",
		use: [
			"month-year",
			"time",
			"calendar",
			"shared",
			"year-mode"
		]
	},
	{
		name: "day",
		use: ["calendar", "shared"]
	},
	{
		name: "month-overlay-value",
		use: [
			"calendar",
			"month-year",
			"shared"
		]
	},
	{
		name: "year-overlay-value",
		use: [
			"calendar",
			"month-year",
			"shared",
			"year-mode"
		]
	},
	{
		name: "year-overlay",
		use: ["month-year", "shared"]
	},
	{
		name: "month-overlay",
		use: ["month-year", "shared"]
	},
	{
		name: "month-overlay-header",
		use: ["month-year", "shared"]
	},
	{
		name: "year-overlay-header",
		use: ["month-year", "shared"]
	},
	{
		name: "hours-overlay-value",
		use: [
			"calendar",
			"time",
			"shared"
		]
	},
	{
		name: "hours-overlay-header",
		use: [
			"calendar",
			"time",
			"shared"
		]
	},
	{
		name: "minutes-overlay-value",
		use: [
			"calendar",
			"time",
			"shared"
		]
	},
	{
		name: "minutes-overlay-header",
		use: [
			"calendar",
			"time",
			"shared"
		]
	},
	{
		name: "seconds-overlay-value",
		use: [
			"calendar",
			"time",
			"shared"
		]
	},
	{
		name: "seconds-overlay-header",
		use: [
			"calendar",
			"time",
			"shared"
		]
	},
	{
		name: "hours",
		use: [
			"calendar",
			"time",
			"shared"
		]
	},
	{
		name: "minutes",
		use: [
			"calendar",
			"time",
			"shared"
		]
	},
	{
		name: "month",
		use: [
			"calendar",
			"month-year",
			"shared"
		]
	},
	{
		name: "year",
		use: [
			"calendar",
			"month-year",
			"shared",
			"year-mode"
		]
	},
	{
		name: "action-buttons",
		use: ["action"]
	},
	{
		name: "action-preview",
		use: ["action"]
	},
	{
		name: "calendar-header",
		use: ["calendar", "shared"]
	},
	{
		name: "marker-tooltip",
		use: ["calendar", "shared"]
	},
	{
		name: "action-extra",
		use: ["menu"]
	},
	{
		name: "time-picker-overlay",
		use: [
			"calendar",
			"time",
			"shared"
		]
	},
	{
		name: "am-pm-button",
		use: [
			"calendar",
			"time",
			"shared"
		]
	},
	{
		name: "left-sidebar",
		use: ["menu"]
	},
	{
		name: "right-sidebar",
		use: ["menu"]
	},
	{
		name: "month-year",
		use: ["month-year", "shared"]
	},
	{
		name: "time-picker",
		use: ["menu", "shared"]
	},
	{
		name: "action-row",
		use: ["action"]
	},
	{
		name: "marker",
		use: ["calendar", "shared"]
	},
	{
		name: "quarter",
		use: ["shared"]
	},
	{
		name: "top-extra",
		use: ["shared", "month-year"]
	},
	{
		name: "tp-inline-arrow-up",
		use: ["shared", "time"]
	},
	{
		name: "tp-inline-arrow-down",
		use: ["shared", "time"]
	},
	{
		name: "menu-header",
		use: ["menu"]
	}
], dO = [
	{ name: "trigger" },
	{ name: "input-icon" },
	{ name: "clear-icon" },
	{ name: "dp-input" }
], fO = {
	all: () => uO,
	monthYear: () => uO.filter((e) => e.use.includes("month-year")),
	input: () => dO,
	timePicker: () => uO.filter((e) => e.use.includes("time")),
	action: () => uO.filter((e) => e.use.includes("action")),
	calendar: () => uO.filter((e) => e.use.includes("calendar")),
	menu: () => uO.filter((e) => e.use.includes("menu")),
	shared: () => uO.filter((e) => e.use.includes("shared")),
	yearMode: () => uO.filter((e) => e.use.includes("year-mode"))
}, pO = (e, t, n) => {
	let r = [];
	return fO[t]().forEach((t) => {
		e[t.name] && r.push(t.name);
	}), n != null && n.length && n.forEach((e) => {
		e.slot && r.push(e.slot);
	}), r;
}, mO = (e) => {
	let t = r(() => (t) => e.value ? t ? e.value.open : e.value.close : ""), n = r(() => (t) => e.value ? t ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
	return {
		transitionName: t,
		showTransition: !!e.value,
		menuTransition: n
	};
}, hO = (e, t, n) => {
	let { defaultedRange: i, defaultedTz: a } = zE(e), o = Y(Nw(Y(), a.value.timezone)), s = M([{
		month: QS(o),
		year: eC(o)
	}]), c = (e) => {
		let t = {
			hours: YS(o),
			minutes: ZS(o),
			seconds: 0
		};
		return i.value.enabled ? [t[e], t[e]] : t[e];
	}, l = te({
		hours: c("hours"),
		minutes: c("minutes"),
		seconds: c("seconds")
	});
	z(i, (e, t) => {
		e.enabled !== t.enabled && (l.hours = c("hours"), l.minutes = c("minutes"), l.seconds = c("seconds"));
	}, { deep: !0 });
	let u = r({
		get: () => e.internalModelValue,
		set: (n) => {
			!e.readonly && !e.disabled && t("update:internal-model-value", n);
		}
	}), d = r(() => (e) => s.value[e] ? s.value[e].month : 0), f = r(() => (e) => s.value[e] ? s.value[e].year : 0);
	return z(u, (e, t) => {
		n && JSON.stringify(e ?? {}) !== JSON.stringify(t ?? {}) && n();
	}, { deep: !0 }), {
		calendars: s,
		time: l,
		modelValue: u,
		month: d,
		year: f,
		today: o
	};
}, gO = (e, t) => {
	let { defaultedMultiCalendars: n, defaultedMultiDates: r, defaultedUI: i, defaultedHighlight: a, defaultedTz: o, propDates: s, defaultedRange: c } = zE(t), { isDisabled: l } = _O(t), u = M(null), d = M(Nw(/* @__PURE__ */ new Date(), o.value.timezone)), f = (e) => {
		!e.current && t.hideOffsetDates || (u.value = e.value);
	}, p = () => {
		u.value = null;
	}, m = (t) => Array.isArray(e.value) && c.value.enabled && e.value[0] && u.value ? t ? AT(u.value, e.value[0]) : OT(u.value, e.value[0]) : !0, h = (t, n) => {
		let r = e.value && Array.isArray(e.value) && e.value ? n ? e.value[0] || null : e.value[1] : null;
		return kT(Y(t.value), r);
	}, g = (t) => {
		let n = Array.isArray(e.value) ? e.value[0] : null;
		return !t || !OT(u.value ?? null, n);
	}, _ = (n, r = !0) => (c.value.enabled || t.weekPicker) && Array.isArray(e.value) && e.value.length === 2 ? t.hideOffsetDates && !n.current ? !1 : kT(Y(n.value), e.value[+!r]) : c.value.enabled ? h(n, r) && g(r) || kT(n.value, Array.isArray(e.value) ? e.value[0] : null) && m(r) : !1, v = (t, n) => {
		if (Array.isArray(e.value) && e.value[0] && e.value.length === 1) {
			let r = kT(t.value, u.value);
			return n ? AT(e.value[0], t.value) && r : OT(e.value[0], t.value) && r;
		}
		return !1;
	}, y = (n) => !e.value || t.hideOffsetDates && !n.current ? !1 : c.value.enabled ? t.modelAuto && Array.isArray(e.value) ? kT(n.value, e.value[0] ? e.value[0] : d.value) : !1 : r.value.enabled && Array.isArray(e.value) ? e.value.some((e) => kT(e, n.value)) : kT(n.value, e.value ? e.value : d.value), b = (e) => {
		if (c.value.autoRange || t.weekPicker) {
			if (u.value) {
				if (t.hideOffsetDates && !e.current) return !1;
				let n = Ex(u.value, +c.value.autoRange), r = BT(Y(u.value), t.weekStart);
				return t.weekPicker ? kT(r[1], Y(e.value)) : kT(n, Y(e.value));
			}
			return !1;
		}
		return !1;
	}, x = (e) => {
		if (c.value.autoRange || t.weekPicker) {
			if (u.value) {
				let n = Ex(u.value, +c.value.autoRange);
				if (t.hideOffsetDates && !e.current) return !1;
				let r = BT(Y(u.value), t.weekStart);
				return t.weekPicker ? AT(e.value, r[0]) && OT(e.value, r[1]) : AT(e.value, u.value) && OT(e.value, n);
			}
			return !1;
		}
		return !1;
	}, S = (e) => {
		if (c.value.autoRange || t.weekPicker) {
			if (u.value) {
				if (t.hideOffsetDates && !e.current) return !1;
				let n = BT(Y(u.value), t.weekStart);
				return t.weekPicker ? kT(n[0], e.value) : kT(u.value, e.value);
			}
			return !1;
		}
		return !1;
	}, C = (t) => jT(e.value, u.value, t.value), w = () => t.modelAuto && Array.isArray(t.internalModelValue) ? !!t.internalModelValue[0] : !1, T = () => !t.modelAuto || tT(t.internalModelValue), E = (e) => {
		if (t.weekPicker) return !1;
		let n = !c.value.enabled || !_(e) && !_(e, !1);
		return !l(e.value) && !y(e) && !(!e.current && t.hideOffsetDates) && n;
	}, D = (e) => c.value.enabled ? t.modelAuto ? w() && y(e) : !1 : y(e), O = (e) => a.value ? vT(e.value, s.value.highlight) : !1, k = (e) => {
		let t = l(e.value);
		return t && (typeof a.value == "function" ? !a.value(e.value, t) : !a.value.options.highlightDisabled);
	}, ee = (e) => typeof a.value == "function" ? a.value(e.value) : a.value.weekdays?.includes(e.value.getDay()), A = (e) => (c.value.enabled || t.weekPicker) && (!(n.value.count > 0) || e.current) && T() && !(!e.current && t.hideOffsetDates) && !y(e) ? C(e) : !1, j = (t) => {
		if (Array.isArray(e.value) && e.value.length === 1) {
			let { before: n, after: r } = sE(+c.value.maxRange, e.value[0]);
			return nC(t.value, n) || tC(t.value, r);
		}
		return !1;
	}, te = (t) => {
		if (Array.isArray(e.value) && e.value.length === 1) {
			let { before: n, after: r } = sE(+c.value.minRange, e.value[0]);
			return jT([n, r], e.value[0], t.value);
		}
		return !1;
	}, ne = (e) => c.value.enabled && (c.value.maxRange || c.value.minRange) ? c.value.maxRange && c.value.minRange ? j(e) || te(e) : c.value.maxRange ? j(e) : te(e) : !1, N = (e) => {
		let { isRangeStart: n, isRangeEnd: r } = ie(e), i = c.value.enabled ? n || r : !1;
		return {
			dp__cell_offset: !e.current,
			dp__pointer: !t.disabled && !(!e.current && t.hideOffsetDates) && !l(e.value) && !ne(e),
			dp__cell_disabled: l(e.value) || ne(e),
			dp__cell_highlight: !k(e) && (O(e) || ee(e)) && !D(e) && !i && !S(e) && !(A(e) && t.weekPicker) && !r,
			dp__cell_highlight_active: !k(e) && (O(e) || ee(e)) && D(e),
			dp__today: !t.noToday && kT(e.value, d.value) && e.current,
			"dp--past": OT(e.value, d.value),
			"dp--future": AT(e.value, d.value)
		};
	}, P = (e) => ({
		dp__active_date: D(e),
		dp__date_hover: E(e)
	}), F = (n) => {
		if (e.value && !Array.isArray(e.value)) {
			let r = BT(e.value, t.weekStart);
			return {
				...ae(n),
				dp__range_start: kT(r[0], n.value),
				dp__range_end: kT(r[1], n.value),
				dp__range_between_week: AT(n.value, r[0]) && OT(n.value, r[1])
			};
		}
		return { ...ae(n) };
	}, re = (n) => {
		if (e.value && Array.isArray(e.value)) {
			let r = BT(e.value[0], t.weekStart), i = e.value[1] ? BT(e.value[1], t.weekStart) : [];
			return {
				...ae(n),
				dp__range_start: kT(r[0], n.value) || kT(i[0], n.value),
				dp__range_end: kT(r[1], n.value) || kT(i[1], n.value),
				dp__range_between_week: AT(n.value, r[0]) && OT(n.value, r[1]) || AT(n.value, i[0]) && OT(n.value, i[1]),
				dp__range_between: AT(n.value, r[1]) && OT(n.value, i[0])
			};
		}
		return { ...ae(n) };
	}, ie = (e) => ({
		isRangeStart: n.value.count > 0 ? e.current && _(e) && T() : _(e) && T(),
		isRangeEnd: n.value.count > 0 ? e.current && _(e, !1) && T() : _(e, !1) && T()
	}), I = (e) => {
		let { isRangeStart: n, isRangeEnd: r } = ie(e);
		return {
			dp__range_start: n,
			dp__range_end: r,
			dp__range_between: A(e),
			dp__date_hover: kT(e.value, u.value) && !n && !r && !t.weekPicker,
			dp__date_hover_start: v(e, !0),
			dp__date_hover_end: v(e, !1)
		};
	}, ae = (e) => ({
		...I(e),
		dp__cell_auto_range: x(e),
		dp__cell_auto_range_start: S(e),
		dp__cell_auto_range_end: b(e)
	}), oe = (e) => c.value.enabled ? c.value.autoRange ? ae(e) : t.modelAuto ? {
		...P(e),
		...I(e)
	} : t.weekPicker ? re(e) : I(e) : t.weekPicker ? F(e) : P(e);
	return {
		setHoverDate: f,
		clearHoverDate: p,
		getDayClassData: (e) => t.hideOffsetDates && !e.current ? {} : {
			...N(e),
			...oe(e),
			[t.dayClass ? t.dayClass(e.value, t.internalModelValue) : ""]: !0,
			...i.value.calendarCell ?? {}
		}
	};
}, _O = (e) => {
	let { defaultedFilters: t, defaultedRange: n, propDates: i, defaultedMultiDates: a } = zE(e), o = (e) => i.value.disabledDates ? typeof i.value.disabledDates == "function" ? i.value.disabledDates(Y(e)) : !!_T(e, i.value.disabledDates) : !1, s = (t) => i.value.maxDate ? e.yearPicker ? eC(t) > eC(i.value.maxDate) : AT(t, i.value.maxDate) : !1, c = (t) => i.value.minDate ? e.yearPicker ? eC(t) < eC(i.value.minDate) : OT(t, i.value.minDate) : !1, l = (n) => {
		let r = s(n), i = c(n), a = o(n), l = t.value.months.map((e) => +e).includes(QS(n)), u = e.disabledWeekDays.length ? e.disabledWeekDays.some((e) => +e === KS(n)) : !1, d = m(n), f = eC(n), p = f < +e.yearRange[0] || f > +e.yearRange[1];
		return !(r || i || a || l || p || u || d);
	}, u = (e, t) => OT(...HT(i.value.minDate, e, t)) || kT(...HT(i.value.minDate, e, t)), d = (e, t) => AT(...HT(i.value.maxDate, e, t)) || kT(...HT(i.value.maxDate, e, t)), f = (e, t, n) => {
		let r = !1;
		return i.value.maxDate && n && d(e, t) && (r = !0), i.value.minDate && !n && u(e, t) && (r = !0), r;
	}, p = (e, t, n, r) => {
		let a = !1;
		return r && (i.value.minDate || i.value.maxDate) ? i.value.minDate && i.value.maxDate ? a = f(e, t, n) : (i.value.minDate && u(e, t) || i.value.maxDate && d(e, t)) && (a = !0) : a = !0, a;
	}, m = (e) => Array.isArray(i.value.allowedDates) && !i.value.allowedDates.length ? !0 : i.value.allowedDates ? !_T(e, i.value.allowedDates) : !1, h = (e) => !l(e), g = (e) => !n.value.noDisabledRange || !Xx({
		start: e[0],
		end: e[1]
	}).some((e) => h(e)), _ = (t) => {
		if (t) {
			let n = eC(t);
			return n >= +e.yearRange[0] && n <= e.yearRange[1];
		}
		return !0;
	}, v = (e, t) => !!(Array.isArray(e) && e[t] && (n.value.maxRange || n.value.minRange) && _(e[t])), y = (e, t, r = 0) => {
		if (v(t, r) && _(e)) {
			let i = zx(e, t[r]), a = RT(t[r], e), o = a.length === 1 ? 0 : a.filter((e) => h(e)).length, s = Math.abs(i) - (n.value.minMaxRawRange ? 0 : o);
			if (n.value.minRange && n.value.maxRange) return s >= +n.value.minRange && s <= +n.value.maxRange;
			if (n.value.minRange) return s >= +n.value.minRange;
			if (n.value.maxRange) return s <= +n.value.maxRange;
		}
		return !0;
	}, b = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, x = (e) => Array.isArray(e) ? [e[0] ? tE(e[0]) : null, e[1] ? tE(e[1]) : null] : tE(e), S = (e, t, n) => e.find((e) => +e.hours === YS(t) && e.minutes === "*" || +e.minutes === ZS(t) && +e.hours === YS(t)) && n, C = (e, t, n) => {
		let [r, i] = e, [a, o] = t;
		return !S(r, a, n) && !S(i, o, n) && n;
	}, w = (t, n) => {
		let r = Array.isArray(n) ? n : [n];
		return Array.isArray(e.disabledTimes) ? Array.isArray(e.disabledTimes[0]) ? C(e.disabledTimes, r, t) : !r.some((n) => S(e.disabledTimes, n, t)) : t;
	}, T = (t, n) => {
		let r = Array.isArray(n) ? [PT(n[0]), n[1] ? PT(n[1]) : void 0] : PT(n), i = !e.disabledTimes(r);
		return t && i;
	}, E = (t, n) => e.disabledTimes ? Array.isArray(e.disabledTimes) ? w(n, t) : T(n, t) : n, D = (t) => {
		let n = !0;
		if (!t || b()) return !0;
		let r = !i.value.minDate && !i.value.maxDate ? x(t) : t;
		return (e.maxTime || i.value.maxDate) && (n = eE(e.maxTime, i.value.maxDate, "max", rT(r), n)), (e.minTime || i.value.minDate) && (n = eE(e.minTime, i.value.minDate, "min", rT(r), n)), E(t, n);
	}, O = (t) => {
		if (!e.monthPicker) return !0;
		let n = !0, r = Y(MT(t));
		if (i.value.minDate && i.value.maxDate) {
			let e = Y(MT(i.value.minDate)), t = Y(MT(i.value.maxDate));
			return AT(r, e) && OT(r, t) || kT(r, e) || kT(r, t);
		}
		if (i.value.minDate) {
			let e = Y(MT(i.value.minDate));
			n = AT(r, e) || kT(r, e);
		}
		if (i.value.maxDate) {
			let e = Y(MT(i.value.maxDate));
			n = OT(r, e) || kT(r, e);
		}
		return n;
	};
	return {
		isDisabled: h,
		validateDate: l,
		validateMonthYearInRange: p,
		isDateRangeAllowed: g,
		checkMinMaxRange: y,
		isValidTime: D,
		isTimeValid: r(() => (t) => !e.enableTimePicker || e.ignoreTimeValidation ? !0 : D(t)),
		isMonthValid: r(() => (t) => e.monthPicker ? Array.isArray(t) && (n.value.enabled || a.value.enabled) ? !t.filter((e) => !O(e)).length : O(t) : !0)
	};
}, vO = () => ({
	hideNavigationButtons: r(() => (e, t) => e?.includes(t)),
	showLeftIcon: r(() => (e, t) => e.count ? e.solo ? !0 : t === 0 : !0),
	showRightIcon: r(() => (e, t) => e.count ? e.solo ? !0 : t === e.count - 1 : !0)
}), yO = (e, t, n) => {
	let i = M(0), a = te({
		[Vw.timePicker]: !e.enableTimePicker || e.timePicker || e.monthPicker,
		[Vw.calendar]: !1,
		[Vw.header]: !1
	}), o = r(() => e.monthPicker || e.timePicker), s = (t) => {
		var n;
		if ((n = e.flow) != null && n.length) {
			if (!t && o.value) return d();
			a[t] = !0, Object.keys(a).filter((e) => !a[e]).length || d();
		}
	}, c = () => {
		var n;
		(n = e.flow) != null && n.length && i.value !== -1 && (i.value += 1, t("flow-step", i.value), d()), e.flow?.length === i.value && S().then(() => l());
	}, l = () => {
		i.value = -1;
	}, u = (t, r, ...a) => {
		var o, s;
		e.flow[i.value] === t && n.value && ((s = (o = n.value)[r]) == null || s.call(o, ...a));
	}, d = (t = 0) => {
		t && (i.value += t), u(Hw.month, "toggleMonthPicker", !0), u(Hw.year, "toggleYearPicker", !0), u(Hw.calendar, "toggleTimePicker", !1, !0), u(Hw.time, "toggleTimePicker", !0, !0);
		let n = e.flow[i.value];
		(n === Hw.hours || n === Hw.minutes || n === Hw.seconds) && u(n, "toggleTimePicker", !0, !0, n);
	};
	return {
		childMount: s,
		updateFlowStep: c,
		resetFlow: l,
		handleFlow: d,
		flowStep: i
	};
}, bO = {
	key: 1,
	class: "dp__input_wrap"
}, xO = [
	"id",
	"name",
	"inputmode",
	"placeholder",
	"disabled",
	"readonly",
	"required",
	"value",
	"autocomplete",
	"aria-label",
	"aria-disabled",
	"aria-invalid"
], SO = {
	key: 2,
	class: "dp--clear-btn"
}, CO = ["aria-label"], wO = /* @__PURE__ */ f({
	compatConfig: { MODE: 3 },
	__name: "DatepickerInput",
	props: {
		isMenuOpen: {
			type: Boolean,
			default: !1
		},
		inputValue: {
			type: String,
			default: ""
		},
		...HE
	},
	emits: [
		"clear",
		"open",
		"update:input-value",
		"set-input-date",
		"close",
		"select-date",
		"set-empty-date",
		"toggle",
		"focus-prev",
		"focus",
		"blur",
		"real-blur",
		"text-input"
	],
	setup(e, { expose: t, emit: n }) {
		let c = n, l = e, { defaultedTextInput: d, defaultedAriaLabels: f, defaultedInline: p, defaultedConfig: m, defaultedRange: h, defaultedMultiDates: g, defaultedUI: _, getDefaultPattern: v, getDefaultStartTime: y } = zE(l), { checkMinMaxRange: b } = _O(l), x = M(), w = M(null), T = M(!1), E = M(!1), D = r(() => ({
			dp__pointer: !l.disabled && !l.readonly && !d.value.enabled,
			dp__disabled: l.disabled,
			dp__input_readonly: !d.value.enabled,
			dp__input: !0,
			dp__input_icon_pad: !l.hideInputIcon,
			dp__input_valid: typeof l.state == "boolean" && l.state,
			dp__input_invalid: typeof l.state == "boolean" && !l.state,
			dp__input_focus: T.value || l.isMenuOpen,
			dp__input_reg: !d.value.enabled,
			..._.value.input ?? {}
		})), O = () => {
			c("set-input-date", null), l.clearable && l.autoApply && (c("set-empty-date"), x.value = null);
		}, k = (e) => {
			let t = y();
			return wT(e, d.value.format ?? v(), t ?? VT({}, l.enableSeconds), l.inputValue, E.value, l.formatLocale);
		}, ee = (e) => {
			let { rangeSeparator: t } = d.value, [n, r] = e.split(`${t}`);
			if (n) {
				let e = k(n.trim()), t = r ? k(r.trim()) : null;
				if (tC(e, t)) return;
				let i = e && t ? [e, t] : [e];
				b(t, i, 0) && (x.value = e ? i : null);
			}
		}, j = () => {
			E.value = !0;
		}, te = (e) => {
			if (h.value.enabled) ee(e);
			else if (g.value.enabled) {
				let t = e.split(";");
				x.value = t.map((e) => k(e.trim())).filter((e) => e);
			} else x.value = k(e);
		}, ne = (e) => {
			let t = typeof e == "string" ? e : e.target?.value;
			t === "" ? O() : (d.value.openMenu && !l.isMenuOpen && c("open"), te(t), c("set-input-date", x.value)), E.value = !1, c("update:input-value", t), c("text-input", e, x.value);
		}, N = (e) => {
			d.value.enabled ? (te(e.target.value), d.value.enterSubmit && XT(x.value) && l.inputValue !== "" ? (c("set-input-date", x.value, !0), x.value = null) : d.value.enterSubmit && l.inputValue === "" && (x.value = null, c("clear"))) : ie(e);
		}, P = (e, t) => {
			d.value.enabled && d.value.tabSubmit && !t && te(e.target.value), d.value.tabSubmit && XT(x.value) && l.inputValue !== "" ? (c("set-input-date", x.value, !0, !0), x.value = null) : d.value.tabSubmit && l.inputValue === "" && (x.value = null, c("clear", !0));
		}, re = () => {
			T.value = !0, c("focus"), S().then(() => {
				var e;
				d.value.enabled && d.value.selectOnFocus && ((e = w.value) == null || e.select());
			});
		}, ie = (e) => {
			if (uT(e, m.value, !0), d.value.enabled && d.value.openMenu && !p.value.input) {
				if (d.value.openMenu === "open" && !l.isMenuOpen) return c("open");
				if (d.value.openMenu === "toggle") return c("toggle");
			} else d.value.enabled || c("toggle");
		}, I = () => {
			c("real-blur"), T.value = !1, (!l.isMenuOpen || p.value.enabled && p.value.input) && c("blur"), l.autoApply && d.value.enabled && x.value && !l.isMenuOpen && (c("set-input-date", x.value), c("select-date"), x.value = null);
		}, ae = (e) => {
			uT(e, m.value, !0), c("clear");
		}, oe = () => {
			c("close");
		}, se = (e) => {
			if (e.key === "Tab" && P(e), e.key === "Enter" && N(e), e.key === "Escape" && d.value.escClose && oe(), !d.value.enabled) {
				if (e.code === "Tab") return;
				e.preventDefault();
			}
		}, ce = () => {
			var e;
			(e = w.value) == null || e.focus({ preventScroll: !0 });
		}, le = (e) => {
			x.value = e;
		}, R = (e) => {
			e.key === Gw.tab && P(e, !0);
		};
		return t({
			focusInput: ce,
			setParsedDate: le
		}), (t, n) => (A(), o("div", { onClick: ie }, [t.$slots.trigger && !t.$slots["dp-input"] && !L(p).enabled ? F(t.$slots, "trigger", { key: 0 }) : a("", !0), !t.$slots.trigger && (!L(p).enabled || L(p).input) ? (A(), o("div", bO, [
			t.$slots["dp-input"] && !t.$slots.trigger && (!L(p).enabled || L(p).enabled && L(p).input) ? F(t.$slots, "dp-input", {
				key: 0,
				value: e.inputValue,
				isMenuOpen: e.isMenuOpen,
				onInput: ne,
				onEnter: N,
				onTab: P,
				onClear: ae,
				onBlur: I,
				onKeypress: se,
				onPaste: j,
				onFocus: re,
				openMenu: () => t.$emit("open"),
				closeMenu: () => t.$emit("close"),
				toggleMenu: () => t.$emit("toggle")
			}) : a("", !0),
			t.$slots["dp-input"] ? a("", !0) : (A(), o("input", {
				key: 1,
				id: t.uid ? `dp-input-${t.uid}` : void 0,
				ref_key: "inputRef",
				ref: w,
				"data-test-id": "dp-input",
				name: t.name,
				class: C(D.value),
				inputmode: L(d).enabled ? "text" : "none",
				placeholder: t.placeholder,
				disabled: t.disabled,
				readonly: t.readonly,
				required: t.required,
				value: e.inputValue,
				autocomplete: t.autocomplete,
				"aria-label": L(f)?.input,
				"aria-disabled": t.disabled || void 0,
				"aria-invalid": t.state === !1 || void 0,
				onInput: ne,
				onBlur: I,
				onFocus: re,
				onKeypress: se,
				onKeydown: n[0] ||= (e) => se(e),
				onPaste: j
			}, null, 42, xO)),
			s("div", { onClick: n[3] ||= (e) => c("toggle") }, [t.$slots["input-icon"] && !t.hideInputIcon ? (A(), o("span", {
				key: 0,
				class: "dp__input_icon",
				onClick: n[1] ||= (e) => c("toggle")
			}, [F(t.$slots, "input-icon")])) : a("", !0), !t.$slots["input-icon"] && !t.hideInputIcon && !t.$slots["dp-input"] ? (A(), i(L(Ew), {
				key: 1,
				"aria-label": L(f)?.calendarIcon,
				class: "dp__input_icon dp__input_icons",
				onClick: n[2] ||= (e) => c("toggle")
			}, null, 8, ["aria-label"])) : a("", !0)]),
			t.$slots["clear-icon"] && (t.alwaysClearable || e.inputValue && t.clearable && !t.disabled && !t.readonly) ? (A(), o("span", SO, [F(t.$slots, "clear-icon", { clear: ae })])) : a("", !0),
			!t.$slots["clear-icon"] && (t.alwaysClearable || t.clearable && e.inputValue && !t.disabled && !t.readonly) ? (A(), o("button", {
				key: 3,
				"aria-label": L(f)?.clearInput,
				class: "dp--clear-btn",
				type: "button",
				onKeydown: n[4] ||= (e) => L(yT)(e, () => ae(e), !0, R),
				onClick: n[5] ||= U((e) => ae(e), ["prevent"])
			}, [u(L(Dw), {
				class: "dp__input_icons",
				"data-test-id": "clear-icon"
			})], 40, CO)) : a("", !0)
		])) : a("", !0)]));
	}
}), TO = typeof window < "u" ? window : void 0, EO = () => {}, DO = (e) => m() ? (k(e), !0) : !1, OO = (e, t, n, r) => {
	if (!e) return EO;
	let i = EO, a = z(() => L(e), (e) => {
		i(), e && (e.addEventListener(t, n, r), i = () => {
			e.removeEventListener(t, n, r), i = EO;
		});
	}, {
		immediate: !0,
		flush: "post"
	}), o = () => {
		a(), i();
	};
	return DO(o), o;
}, kO = (e, t, n, r = {}) => {
	let { window: i = TO, event: a = "pointerdown" } = r;
	return i ? OO(i, a, (r) => {
		let i = $w(e), a = $w(t);
		!i || !a || i === r.target || r.composedPath().includes(i) || r.composedPath().includes(a) || n(r);
	}, { passive: !0 }) : void 0;
}, AO = ["data-dp-mobile"], jO = /* @__PURE__ */ f({
	compatConfig: { MODE: 3 },
	__name: "VueDatePicker",
	props: { ...HE },
	emits: [
		"update:model-value",
		"update:model-timezone-value",
		"text-submit",
		"closed",
		"cleared",
		"open",
		"focus",
		"blur",
		"internal-model-change",
		"recalculate-position",
		"flow-step",
		"update-month-year",
		"invalid-select",
		"invalid-fixed-range",
		"tooltip-open",
		"tooltip-close",
		"time-picker-open",
		"time-picker-close",
		"am-pm-change",
		"range-start",
		"range-end",
		"date-update",
		"invalid-date",
		"overlay-toggle",
		"text-input"
	],
	setup(e, { expose: s, emit: l }) {
		let d = l, f = e, p = ue(), m = M(!1), g = ae(f, "modelValue"), _ = ae(f, "timezone"), y = M(null), b = M(null), T = M(null), E = M(!1), D = M(null), k = M(!1), j = M(!1), te = M(!1), ne = M(!1), { setMenuFocused: N, setShiftKey: ie } = lE(), { clearArrowNav: I } = vE(), { validateDate: oe, isValidTime: se } = _O(f), { defaultedTransitions: ce, defaultedTextInput: le, defaultedInline: R, defaultedConfig: de, defaultedRange: fe, defaultedMultiDates: pe } = zE(f), { menuTransition: me, showTransition: he } = mO(ce), { isMobile: ge } = ZD(de);
		O(() => {
			we(f.modelValue), S().then(() => {
				R.value.enabled || (be(D.value)?.addEventListener("scroll", Pe), window == null || window.addEventListener("resize", Fe));
			}), R.value.enabled && (m.value = !0), window == null || window.addEventListener("keyup", Ie), window == null || window.addEventListener("keydown", Le);
		}), ee(() => {
			R.value.enabled || (be(D.value)?.removeEventListener("scroll", Pe), window == null || window.removeEventListener("resize", Fe)), window == null || window.removeEventListener("keyup", Ie), window == null || window.removeEventListener("keydown", Le);
		});
		let V = pO(p, "all", f.presetDates), H = pO(p, "input");
		z([g, _], () => {
			we(g.value);
		}, { deep: !0 });
		let { openOnTop: U, menuStyle: _e, xCorrect: ve, setMenuPosition: ye, getScrollableParent: be, shadowRender: xe } = lO({
			menuRef: y,
			menuRefInner: b,
			inputRef: T,
			pickerWrapperRef: D,
			inline: R,
			emit: d,
			props: f,
			slots: p
		}), { inputValue: Se, internalModelValue: Ce, parseExternalModelValue: we, emitModelValue: Te, formatInputValue: Ee, checkBeforeEmit: De } = BE(d, f, E), Oe = r(() => ({
			dp__main: !0,
			dp__theme_dark: f.dark,
			dp__theme_light: !f.dark,
			dp__flex_display: R.value.enabled,
			"dp--flex-display-collapsed": te.value,
			dp__flex_display_with_input: R.value.input
		})), ke = r(() => f.dark ? "dp__theme_dark" : "dp__theme_light"), Ae = r(() => f.teleport ? {
			to: typeof f.teleport == "boolean" ? "body" : f.teleport,
			disabled: !f.teleport || R.value.enabled
		} : {}), je = r(() => ({ class: "dp__outer_menu_wrap" })), Me = r(() => R.value.enabled && (f.timePicker || f.monthPicker || f.yearPicker || f.quarterPicker)), Ne = () => (T.value?.$el)?.getBoundingClientRect() ?? {
			width: 0,
			left: 0,
			right: 0
		}, Pe = () => {
			m.value && (de.value.closeOnScroll ? Ke() : ye());
		}, Fe = () => {
			m.value && ye();
			let e = b.value?.$el.getBoundingClientRect().width ?? 0;
			te.value = document.body.offsetWidth <= e;
		}, Ie = (e) => {
			e.key === "Tab" && !R.value.enabled && !f.teleport && de.value.tabOutClosesMenu && (D.value.contains(document.activeElement) || Ke()), j.value = e.shiftKey;
		}, Le = (e) => {
			j.value = e.shiftKey;
		}, Re = () => {
			!f.disabled && !f.readonly && (xe(sO, f), ye(!1), m.value = !0, m.value && d("open"), m.value || Ge(), we(f.modelValue));
		}, ze = () => {
			var e, t;
			Se.value = "", Ge(), (e = b.value) == null || e.onValueCleared(), (t = T.value) == null || t.setParsedDate(null), d("update:model-value", null), d("update:model-timezone-value", null), d("cleared"), de.value.closeOnClearValue && Ke();
		}, Be = () => {
			let e = Ce.value;
			return !e || !Array.isArray(e) && oe(e) ? !0 : Array.isArray(e) ? pe.value.enabled || e.length === 2 && oe(e[0]) && oe(e[1]) ? !0 : fe.value.partialRange && !f.timePicker ? oe(e[0]) : !1 : !1;
		}, Ve = () => {
			De() && Be() ? (Te(), Ke()) : d("invalid-select", Ce.value);
		}, He = (e) => {
			Ue(), Te(), de.value.closeOnAutoApply && !e && Ke();
		}, Ue = () => {
			T.value && le.value.enabled && T.value.setParsedDate(Ce.value);
		}, We = (e = !1) => {
			f.autoApply && se(Ce.value) && Be() && (fe.value.enabled && Array.isArray(Ce.value) ? (fe.value.partialRange || Ce.value.length === 2) && He(e) : He(e));
		}, Ge = () => {
			le.value.enabled || (Ce.value = null);
		}, Ke = (e = !1) => {
			e && Ce.value && de.value.setDateOnMenuClose && Ve(), R.value.enabled || (m.value && (m.value = !1, ve.value = !1, N(!1), ie(!1), I(), d("closed"), Se.value && we(g.value)), Ge(), d("blur"));
		}, qe = (e, t, n = !1) => {
			if (!e) {
				Ce.value = null;
				return;
			}
			let r = Array.isArray(e) ? !e.some((e) => !oe(e)) : oe(e), i = se(e);
			r && i ? (ne.value = !0, Ce.value = e, t && (k.value = n, Ve(), d("text-submit")), S().then(() => {
				ne.value = !1;
			})) : d("invalid-date", e);
		}, Je = () => {
			f.autoApply && se(Ce.value) && Te(), Ue();
		}, Ye = () => m.value ? Ke() : Re(), Xe = (e) => {
			Ce.value = e;
		}, Ze = () => {
			le.value.enabled && (E.value = !0, Ee()), d("focus");
		}, Qe = () => {
			le.value.enabled && (E.value = !1, we(f.modelValue), k.value) && fT(D.value, j.value)?.focus(), d("blur");
		}, $e = (e) => {
			b.value && b.value.updateMonthYear(0, {
				month: iT(e.month),
				year: iT(e.year)
			});
		}, et = (e) => {
			we(e ?? f.modelValue);
		}, tt = (e, t) => {
			var n;
			(n = b.value) == null || n.switchView(e, t);
		}, nt = (e, t) => de.value.onClickOutside ? de.value.onClickOutside(e, t) : Ke(!0);
		return kO(y, T, (e) => nt(Be, e)), s({
			closeMenu: Ke,
			selectDate: Ve,
			clearValue: ze,
			openMenu: Re,
			onScroll: Pe,
			formatInputValue: Ee,
			updateInternalModelValue: Xe,
			setMonthYear: $e,
			parseModel: et,
			switchView: tt,
			toggleMenu: Ye,
			handleFlow: (e = 0) => {
				var t;
				(t = b.value) == null || t.handleFlow(e);
			},
			getDpWrapMenuRef: () => y
		}), (e, r) => (A(), o("div", {
			ref_key: "pickerWrapperRef",
			ref: D,
			class: C(Oe.value),
			"data-datepicker-instance": "",
			"data-dp-mobile": L(ge)
		}, [u(wO, x({
			ref_key: "inputRef",
			ref: T,
			"input-value": L(Se),
			"onUpdate:inputValue": r[0] ||= (e) => v(Se) ? Se.value = e : null,
			"is-menu-open": m.value
		}, e.$props, {
			onClear: ze,
			onOpen: Re,
			onSetInputDate: qe,
			onSetEmptyDate: L(Te),
			onSelectDate: Ve,
			onToggle: Ye,
			onClose: Ke,
			onFocus: Ze,
			onBlur: Qe,
			onRealBlur: r[1] ||= (e) => E.value = !1,
			onTextInput: r[2] ||= (t) => e.$emit("text-input", t)
		}), c({ _: 2 }, [P(L(H), (t, n) => ({
			name: t,
			fn: B((n) => [F(e.$slots, t, w(h(n)))])
		}))]), 1040, [
			"input-value",
			"is-menu-open",
			"onSetEmptyDate"
		]), (A(), i(re(e.teleport ? t : "div"), w(h(Ae.value)), {
			default: B(() => [u(n, {
				name: L(me)(L(U)),
				css: L(he) && !L(R).enabled
			}, {
				default: B(() => [m.value ? (A(), o("div", x({
					key: 0,
					ref_key: "dpWrapMenuRef",
					ref: y
				}, je.value, {
					class: { "dp--menu-wrapper": !L(R).enabled },
					style: L(R).enabled ? void 0 : L(_e)
				}), [u(sO, x({
					ref_key: "dpMenuRef",
					ref: b
				}, e.$props, {
					"internal-model-value": L(Ce),
					"onUpdate:internalModelValue": r[3] ||= (e) => v(Ce) ? Ce.value = e : null,
					class: {
						[ke.value]: !0,
						"dp--menu-wrapper": e.teleport
					},
					"open-on-top": L(U),
					"no-overlay-focus": Me.value,
					collapse: te.value,
					"get-input-rect": Ne,
					"is-text-input-date": ne.value,
					onClosePicker: Ke,
					onSelectDate: Ve,
					onAutoApply: We,
					onTimeUpdate: Je,
					onFlowStep: r[4] ||= (t) => e.$emit("flow-step", t),
					onUpdateMonthYear: r[5] ||= (t) => e.$emit("update-month-year", t),
					onInvalidSelect: r[6] ||= (t) => e.$emit("invalid-select", L(Ce)),
					onAutoApplyInvalid: r[7] ||= (t) => e.$emit("invalid-select", t),
					onInvalidFixedRange: r[8] ||= (t) => e.$emit("invalid-fixed-range", t),
					onRecalculatePosition: L(ye),
					onTooltipOpen: r[9] ||= (t) => e.$emit("tooltip-open", t),
					onTooltipClose: r[10] ||= (t) => e.$emit("tooltip-close", t),
					onTimePickerOpen: r[11] ||= (t) => e.$emit("time-picker-open", t),
					onTimePickerClose: r[12] ||= (t) => e.$emit("time-picker-close", t),
					onAmPmChange: r[13] ||= (t) => e.$emit("am-pm-change", t),
					onRangeStart: r[14] ||= (t) => e.$emit("range-start", t),
					onRangeEnd: r[15] ||= (t) => e.$emit("range-end", t),
					onDateUpdate: r[16] ||= (t) => e.$emit("date-update", t),
					onInvalidDate: r[17] ||= (t) => e.$emit("invalid-date", t),
					onOverlayToggle: r[18] ||= (t) => e.$emit("overlay-toggle", t),
					onMenuBlur: r[19] ||= (t) => e.$emit("blur")
				}), c({ _: 2 }, [P(L(V), (t, n) => ({
					name: t,
					fn: B((n) => [F(e.$slots, t, w(h({ ...n })))])
				}))]), 1040, [
					"internal-model-value",
					"class",
					"open-on-top",
					"no-overlay-focus",
					"collapse",
					"is-text-input-date",
					"onRecalculatePosition"
				])], 16)) : a("", !0)]),
				_: 3
			}, 8, ["name", "css"])]),
			_: 3
		}, 16))], 10, AO));
	}
}), MO = /* @__PURE__ */ (() => {
	let e = jO;
	return e.install = (t) => {
		t.component("Vue3DatePicker", e);
	}, e;
})();
Object.entries(/* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
	__proto__: null,
	default: MO
}, Symbol.toStringTag, { value: "Module" }))).forEach(([e, t]) => {
	e !== "default" && (MO[e] = t);
});
//#endregion
//#region src/components/Form/DatePicker/DatePicker.vue
var NO = /* @__PURE__ */ f({
	__name: "DatePicker",
	props: /*@__PURE__*/ b({
		name: {},
		isVisible: { type: Boolean },
		isDirty: { type: Boolean },
		isDisabled: { type: Boolean },
		isOptional: { type: Boolean },
		isReadOnly: { type: Boolean },
		isSuspended: { type: Boolean },
		isTouched: { type: Boolean },
		isValid: {
			type: Boolean,
			default: !0
		},
		uid: {},
		is24: { type: Boolean },
		enableTimePicker: { type: Boolean },
		range: { type: [Boolean, Object] },
		multiCalendars: { type: [
			Boolean,
			Number,
			String,
			Object
		] },
		modelValue: {},
		locale: {},
		position: {},
		dark: { type: Boolean },
		placeholder: { default: "dd/mm/yyyy" },
		weekNumbers: {},
		hoursIncrement: {},
		hoursGridIncrement: {},
		secondsGridIncrement: {},
		minutesGridIncrement: {},
		minutesIncrement: {},
		secondsIncrement: {},
		minDate: { default: void 0 },
		maxDate: { default: void 0 },
		minTime: {},
		maxTime: {},
		weekStart: {},
		disabled: {
			type: Boolean,
			default: !1
		},
		readonly: { type: Boolean },
		required: { type: Boolean },
		format: {},
		previewFormat: {},
		hideInputIcon: { type: Boolean },
		state: { type: Boolean },
		clearable: {
			type: Boolean,
			default: !0
		},
		alwaysClearable: { type: Boolean },
		autoApply: { type: Boolean },
		filters: {},
		disableMonthYearSelect: { type: Boolean },
		yearRange: {},
		disabledDates: {},
		inline: { type: [Boolean, Object] },
		selectText: {},
		cancelText: {},
		weekNumName: {},
		autoPosition: { type: [Boolean, String] },
		monthPicker: { type: Boolean },
		timePicker: { type: Boolean },
		textInput: { type: [Boolean, Object] },
		monthNameFormat: {},
		startDate: {},
		startTime: {},
		hideOffsetDates: { type: Boolean },
		noToday: { type: Boolean },
		noHoursOverlay: { type: Boolean },
		noMinutesOverlay: { type: Boolean },
		noSecondsOverlay: { type: Boolean },
		altPosition: {},
		disabledWeekDays: {},
		allowedDates: {},
		nowButtonLabel: {},
		monthChangeOnScroll: { type: [Boolean, String] },
		markers: {},
		transitions: { type: [Boolean, Object] },
		enableSeconds: { type: Boolean },
		escClose: { type: Boolean },
		spaceConfirm: { type: Boolean },
		monthChangeOnArrows: { type: Boolean },
		formatLocale: {},
		autocomplete: {},
		multiDates: { type: [Boolean, Object] },
		presetDates: {},
		flow: {},
		partialFlow: { type: Boolean },
		preventMinMaxNavigation: { type: Boolean },
		utc: { type: [Boolean, String] },
		reverseYears: { type: Boolean },
		weekPicker: { type: Boolean },
		vertical: { type: Boolean },
		ariaLabels: {},
		arrowNavigation: { type: Boolean },
		yearPicker: { type: Boolean },
		dayNames: {},
		modelType: {},
		modelAuto: { type: Boolean },
		highlight: {},
		offset: {},
		teleportCenter: { type: Boolean },
		teleport: { type: [Boolean, String] },
		ignoreTimeValidation: { type: Boolean },
		dayClass: {},
		hideNavigation: {},
		sixWeeks: { type: [Boolean, String] },
		timezone: {},
		disableYearSelect: { type: Boolean },
		focusStartDate: { type: Boolean },
		disabledTimes: {},
		timePickerInline: { type: Boolean },
		calendar: {},
		config: {},
		quarterPicker: { type: Boolean },
		yearFirst: { type: Boolean },
		loading: { type: Boolean },
		onInternalModelChange: {},
		enableMinutes: { type: Boolean },
		ui: {},
		date: { default: void 0 }
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = e, n = r(() => ({ input: ["date-input", t.isValid ? "" : "!border-red"].join(" ") })), a = r(() => {
			if (t.date) return ve(t.date).startOf("day").toISOString();
		}), o = (e) => ve(e).format("DD-MM-YYYY"), s = R(e, "modelValue", {
			get(e) {
				return ve(e).toDate();
			},
			set(e) {
				return e ? ve(e).startOf("day").toISOString() : "";
			}
		});
		return (t, r) => (A(), i(L(MO), {
			modelValue: s.value,
			"onUpdate:modelValue": r[0] ||= (e) => s.value = e,
			"aria-labels": e.ariaLabels,
			"auto-apply": !0,
			clearable: e.clearable,
			date: a.value,
			disabled: e.disabled,
			"enable-time-picker": !1,
			format: o,
			"max-date": e.maxDate,
			"min-date": e.minDate,
			name: e.name,
			placeholder: e.placeholder,
			"prevent-min-max-navigation": !0,
			"text-input": !1,
			ui: n.value
		}, null, 8, [
			"modelValue",
			"aria-labels",
			"clearable",
			"date",
			"disabled",
			"max-date",
			"min-date",
			"name",
			"placeholder",
			"ui"
		]));
	}
}), PO = { class: "flex" }, FO = /* @__PURE__ */ f({
	__name: "DatePickerRange",
	props: {
		name: {},
		isVisible: { type: Boolean },
		isDirty: { type: Boolean },
		isDisabled: { type: Boolean },
		isOptional: { type: Boolean },
		isReadOnly: { type: Boolean },
		isSuspended: { type: Boolean },
		isTouched: { type: Boolean },
		isValid: { type: Boolean },
		uid: {},
		is24: { type: Boolean },
		enableTimePicker: { type: Boolean },
		range: { type: [Boolean, Object] },
		multiCalendars: { type: [
			Boolean,
			Number,
			String,
			Object
		] },
		modelValue: {},
		locale: {},
		position: {},
		dark: { type: Boolean },
		placeholder: { default: "dd/mm/yyyy" },
		weekNumbers: {},
		hoursIncrement: {},
		hoursGridIncrement: {},
		secondsGridIncrement: {},
		minutesGridIncrement: {},
		minutesIncrement: {},
		secondsIncrement: {},
		minDate: {},
		maxDate: {},
		minTime: {},
		maxTime: {},
		weekStart: {},
		disabled: {
			type: Boolean,
			default: !1
		},
		readonly: { type: Boolean },
		required: { type: Boolean },
		format: {},
		previewFormat: {},
		hideInputIcon: { type: Boolean },
		state: { type: Boolean },
		clearable: {
			type: Boolean,
			default: !1
		},
		alwaysClearable: { type: Boolean },
		autoApply: { type: Boolean },
		filters: {},
		disableMonthYearSelect: { type: Boolean },
		yearRange: {},
		disabledDates: {},
		inline: { type: [Boolean, Object] },
		selectText: {},
		cancelText: {},
		weekNumName: {},
		autoPosition: { type: [Boolean, String] },
		monthPicker: { type: Boolean },
		timePicker: { type: Boolean },
		textInput: { type: [Boolean, Object] },
		monthNameFormat: {},
		startDate: {},
		startTime: {},
		hideOffsetDates: { type: Boolean },
		noToday: { type: Boolean },
		noHoursOverlay: { type: Boolean },
		noMinutesOverlay: { type: Boolean },
		noSecondsOverlay: { type: Boolean },
		altPosition: {},
		disabledWeekDays: {},
		allowedDates: {},
		nowButtonLabel: {},
		monthChangeOnScroll: { type: [Boolean, String] },
		markers: {},
		transitions: { type: [Boolean, Object] },
		enableSeconds: { type: Boolean },
		escClose: { type: Boolean },
		spaceConfirm: { type: Boolean },
		monthChangeOnArrows: { type: Boolean },
		formatLocale: {},
		autocomplete: {},
		multiDates: { type: [Boolean, Object] },
		presetDates: {},
		flow: {},
		partialFlow: { type: Boolean },
		preventMinMaxNavigation: { type: Boolean },
		utc: { type: [Boolean, String] },
		reverseYears: { type: Boolean },
		weekPicker: { type: Boolean },
		vertical: { type: Boolean },
		ariaLabels: {},
		arrowNavigation: { type: Boolean },
		yearPicker: { type: Boolean },
		dayNames: {},
		modelType: {},
		modelAuto: { type: Boolean },
		highlight: {},
		offset: {},
		teleportCenter: { type: Boolean },
		teleport: { type: [Boolean, String] },
		ignoreTimeValidation: { type: Boolean },
		dayClass: {},
		hideNavigation: {},
		sixWeeks: { type: [Boolean, String] },
		timezone: {},
		disableYearSelect: { type: Boolean },
		focusStartDate: { type: Boolean },
		disabledTimes: {},
		timePickerInline: { type: Boolean },
		calendar: {},
		config: {},
		quarterPicker: { type: Boolean },
		yearFirst: { type: Boolean },
		loading: { type: Boolean },
		onInternalModelChange: {},
		enableMinutes: { type: Boolean },
		ui: {},
		fromDate: {},
		endDate: {},
		placeholderEndDate: { default: "dd/mm/yyyy" },
		startDateInputProps: { default: () => ({}) },
		endDateInputProps: { default: () => ({}) },
		startDateIsValid: {
			type: Boolean,
			default: !0
		},
		endDateIsValid: {
			type: Boolean,
			default: !0
		}
	},
	emits: ["update:fromDate", "update:endDate"],
	setup(e, { emit: t }) {
		let n = (e) => ve(e).format("DD-MM-YYYY"), i = e, a = t, s = (e) => {
			if (e instanceof Date) return e;
			if (e) return ve(e).toDate();
		}, c = r({
			get: () => s(i.fromDate),
			set: (e) => {
				a("update:fromDate", ve(e).toDate());
			}
		}), l = r({
			get: () => s(i.endDate),
			set: (e) => {
				a("update:endDate", ve(e).toDate());
			}
		}), d = {
			"auto-apply": !0,
			"enable-time-picker": !1,
			"text-input": !1,
			"prevent-min-max-navigation": !0,
			clearable: i.clearable,
			disabled: i.disabled,
			timezone: "UTC"
		}, f = r(() => ({ input: ["date-input", i.startDateIsValid ? i.endDateIsValid ? "" : "border-r-red!" : "border-red!"].join(" ") })), p = r(() => ({ input: ["date-input", i.endDateIsValid ? "" : "border-red!"].join(" ") }));
		return (t, r) => (A(), o("div", PO, [u(L(MO), x({
			modelValue: c.value,
			"onUpdate:modelValue": r[0] ||= (e) => c.value = e
		}, {
			...d,
			...e.startDateInputProps
		}, {
			format: n,
			"max-date": l.value ?? e.maxDate,
			placeholder: e.placeholder,
			ui: f.value
		}), null, 16, [
			"modelValue",
			"max-date",
			"placeholder",
			"ui"
		]), u(L(MO), x({
			modelValue: l.value,
			"onUpdate:modelValue": r[1] ||= (e) => l.value = e
		}, {
			...d,
			...e.endDateInputProps
		}, {
			format: n,
			"max-date": e.maxDate,
			"min-date": c.value ?? void 0,
			placeholder: e.placeholderEndDate,
			ui: p.value
		}), null, 16, [
			"modelValue",
			"max-date",
			"min-date",
			"placeholder",
			"ui"
		])]));
	}
}), IO = { class: "border h-[144px] p- p-4 relative rounded-regular w-[144px]" }, LO = { class: "flex h-full items-center overflow-hidden rounded-regular w-full" }, RO = ["src"], zO = { key: 0 }, BO = /* @__PURE__ */ f({
	__name: "ImageUpload",
	props: {
		emptyText: {},
		deleteButtonText: {},
		editButtonText: {},
		src: {}
	},
	emits: [
		"edit",
		"delete",
		"upload"
	],
	setup(e, { emit: t }) {
		let n = e, c = t, l = M(!1), d = () => {
			l.value = !0;
		}, f = r(() => l.value ? void 0 : n.src);
		/* c8 ignore end */
		return (t, n) => (A(), o("div", IO, [f.value ? (A(), i(Bp, {
			key: 0,
			class: "absolute right-2 top-2"
		}, {
			default: B(() => [u(Op, {
				class: "text-primary",
				title: e.editButtonText,
				onClick: n[0] ||= (e) => c("edit")
			}, {
				default: B(() => [u(ap, null, {
					default: B(() => [u(fr)]),
					_: 1
				})]),
				_: 1
			}, 8, ["title"]), u(Op, {
				class: "text-red",
				title: e.deleteButtonText,
				onClick: n[1] ||= (e) => c("delete")
			}, {
				default: B(() => [u(ap, null, {
					default: B(() => [u(Ls)]),
					_: 1
				})]),
				_: 1
			}, 8, ["title"])]),
			_: 1
		})) : a("", !0), s("div", LO, [f.value ? (A(), o("img", {
			key: 0,
			class: "h-auto w-full",
			src: f.value,
			onError: d
		}, null, 40, RO)) : (A(), o("button", {
			key: 1,
			class: "flex flex-col gap-2 h-full hover:bg-gray-200 items-center justify-center text-secondary w-full",
			type: "button",
			onClick: n[2] ||= (e) => c("upload")
		}, [u(ap, null, {
			default: B(() => [u(ep)]),
			_: 1
		}), e.emptyText ? (A(), o("p", zO, I(e.emptyText), 1)) : a("", !0)]))])]));
	}
}), VO = [
	"id",
	"aria-invalid",
	"aria-labelledby",
	"disabled",
	"name"
], HO = /* @__PURE__ */ f({
	__name: "NumberInput",
	props: /*@__PURE__*/ b({
		name: {},
		isValid: {
			type: Boolean,
			default: !0
		},
		hideSpinButtons: { type: Boolean },
		labelledBy: { default: void 0 },
		disabled: {
			type: Boolean,
			default: !1
		}
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = R(e, "modelValue");
		return (n, r) => V((A(), o("input", {
			id: e.name,
			"onUpdate:modelValue": r[0] ||= (e) => t.value = e,
			"aria-invalid": e.isValid ? void 0 : "true",
			"aria-labelledby": e.labelledBy,
			class: C(["border focus:ring-2 outline-hidden px-3 py-2 ring-blue-600 rounded-full text-black w-full", {
				"text-gray-800 bg-gray-200 pr-5": e.disabled,
				"border-red": !e.isValid,
				"[&::-webkit-inner-spin-button]:appearance-none": e.hideSpinButtons
			}]),
			disabled: e.disabled,
			name: e.name,
			type: "number"
		}, null, 10, VO)), [[me, t.value]]);
	}
}), UO = { class: "flex w-full" }, WO = ["disabled"], GO = [
	"id",
	"max",
	"min",
	"name"
], KO = ["disabled"], qO = 300, JO = 100, YO = 20, XO = /* @__PURE__ */ f({
	__name: "NumberInputStepper",
	props: /*@__PURE__*/ b({
		modelValue: {},
		name: {},
		minimum: {},
		maximum: {}
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e, { expose: t }) {
		let n = e, i = R(e, "modelValue", { set(e) {
			return e || n.minimum || 0;
		} }), a = de("input"), { count: c, inc: l, reset: d } = ke(0, {
			min: n.minimum,
			max: n.maximum
		}), f = r(() => c.value < YO ? JO : JO / 2), p = () => {
			l(), i.value = (i.value || 0) - 1;
		}, m = () => {
			l(), i.value = (i.value || 0) + 1;
		}, { resume: h, pause: g } = Ne(p, f, { immediate: !1 }), { resume: _, pause: v } = Ne(m, f, { immediate: !1 });
		ee(() => {
			d();
		});
		let y = () => {
			let e = i.value;
			e && (n.minimum !== void 0 && e < n.minimum && (i.value = n.minimum), n.maximum !== void 0 && e > n.maximum && (i.value = n.maximum));
		};
		return z(i, () => {
			y();
		}), t({ element: a }), (t, n) => (A(), o("div", UO, [
			V((A(), o("button", {
				"aria-label": "decrease",
				class: C(["border border-r-0 font-thin px-4 rounded-l-full text-secondary hover:bg-gray-100", { "text-gray bg-gray-100": i.value === e.minimum }]),
				disabled: i.value === e.minimum,
				type: "button",
				onClick: p
			}, [u(ap, { class: "mt-1.5" }, {
				default: B(() => [u(L(aa))]),
				_: 1
			})], 10, WO)), [[
				L(De),
				[L(h), {
					onMouseUp: () => {
						L(g)(), L(d)();
					},
					delay: qO
				}],
				void 0,
				{ prevent: !0 }
			]]),
			V(s("input", {
				id: e.name,
				ref: "input",
				"onUpdate:modelValue": n[0] ||= (e) => i.value = e,
				class: "rounded-l-none! rounded-r-none! [&::-webkit-inner-spin-button]:appearance-none border focus:ring-2 outline-hidden py-2 ring-blue-600 text-black text-center w-full",
				max: e.maximum,
				min: e.minimum,
				name: e.name,
				type: "number",
				onBlur: y
			}, null, 40, GO), [[me, i.value]]),
			V((A(), o("button", {
				"aria-label": "increase",
				class: C(["border border-l-0 px-4 rounded-r-full text-secondary hover:bg-gray-100", { "text-gray bg-gray-100": i.value === e.maximum }]),
				disabled: i.value === e.maximum,
				type: "button",
				onClick: m
			}, [u(ap, { class: "mt-1.5" }, {
				default: B(() => [u(L(ep))]),
				_: 1
			})], 10, KO)), [[
				L(De),
				[L(_), {
					onMouseUp: () => {
						L(v)(), L(d)();
					},
					delay: qO
				}],
				void 0,
				{ prevent: !0 }
			]])
		]));
	}
}), ZO = [
	"id",
	"aria-invalid",
	"aria-labelledby",
	"disabled",
	"name",
	"type"
], QO = /* @__PURE__ */ f({
	__name: "TextInput",
	props: /*@__PURE__*/ b({
		name: {},
		isVisible: { type: Boolean },
		isDirty: { type: Boolean },
		isDisabled: { type: Boolean },
		isOptional: { type: Boolean },
		isReadOnly: { type: Boolean },
		isSuspended: { type: Boolean },
		isTouched: { type: Boolean },
		isValid: {
			type: Boolean,
			default: !0
		},
		disabled: { type: Boolean },
		modelValue: {},
		autoFocus: { type: Boolean },
		labelledBy: { default: void 0 },
		type: { default: "text" }
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: /*@__PURE__*/ b(["blur"], ["update:modelValue"]),
	setup(e, { expose: t }) {
		let n = e, r = R(e, "modelValue"), i = de("component");
		/* c8 ignore start - this cant be tested https://github.com/capricorn86/happy-dom/issues/1592 */
		O(() => {
			n.autoFocus && a();
		});
		/* c8 ignore stop */
		function a() {
			i.value?.focus();
		}
		return t({ focus: a }), (t, n) => V((A(), o("input", {
			id: e.name,
			ref: "component",
			"onUpdate:modelValue": n[0] ||= (e) => r.value = e,
			"aria-invalid": e.isValid ? void 0 : "true",
			"aria-labelledby": e.labelledBy,
			class: C(["border focus:ring-2 outline-hidden px-3 py-2 ring-blue-600 rounded-full w-full", {
				"text-gray-800 bg-gray-200 pr-5": e.disabled,
				"border-red": !e.isValid
			}]),
			disabled: e.disabled,
			name: e.name,
			type: e.type,
			onBlur: n[1] ||= (e) => t.$emit("blur", e)
		}, null, 42, ZO)), [[pe, r.value]]);
	}
}), $O = { class: "flex w-full" }, ek = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "TextInputWithButton",
	props: /*@__PURE__*/ b({
		type: { default: "text" },
		name: {},
		placeholder: { default: void 0 },
		disabled: { type: Boolean },
		labelledBy: { default: void 0 },
		buttonVariant: { default: "secondary-outline" },
		buttonDisabled: { type: Boolean },
		buttonAriaLabel: { default: void 0 },
		buttonClass: { default: void 0 }
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: /*@__PURE__*/ b(["blur", "click"], ["update:modelValue"]),
	setup(e) {
		let t = R(e, "modelValue");
		return (n, r) => (A(), o("div", $O, [u(QO, x(n.$attrs, {
			modelValue: t.value,
			"onUpdate:modelValue": r[0] ||= (e) => t.value = e,
			class: L(_e)("border-r-0! rounded-r-none!", n.$attrs.class),
			disabled: e.disabled,
			"labelled-by": e.labelledBy,
			name: e.name,
			placeholder: e.placeholder,
			type: e.type,
			onBlur: r[1] ||= (e) => n.$emit("blur", e)
		}), null, 16, [
			"modelValue",
			"class",
			"disabled",
			"labelled-by",
			"name",
			"placeholder",
			"type"
		]), u(Dp, {
			"aria-label": e.buttonAriaLabel,
			class: C(L(_e)("rounded-l-none! flex items-center rounded-r-full", e.buttonClass)),
			disabled: e.buttonDisabled,
			variant: e.buttonVariant,
			onClick: r[2] ||= (e) => n.$emit("click", e)
		}, {
			default: B(() => [F(n.$slots, "button")]),
			_: 3
		}, 8, [
			"aria-label",
			"class",
			"disabled",
			"variant"
		])]));
	}
}), tk = /* @__PURE__ */ f({
	__name: "PasswordInput",
	props: /*@__PURE__*/ b({
		name: {},
		placeholder: { default: void 0 },
		disabled: { type: Boolean },
		labelledBy: { default: void 0 },
		buttonVariant: { default: "secondary-outline" },
		buttonDisabled: { type: Boolean }
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let [t, n] = Fe(!1), r = R(e, "modelValue");
		return (e, a) => (A(), i(ek, x(e.$props, {
			modelValue: r.value,
			"onUpdate:modelValue": a[0] ||= (e) => r.value = e,
			type: L(t) ? "text" : "password",
			onClick: a[1] ||= () => L(n)()
		}), {
			button: B(() => [u(L(Jp), null, {
				default: B(() => [L(t) ? (A(), i(L(wh), { key: 0 })) : (A(), i(L(Oh), { key: 1 }))]),
				_: 1
			})]),
			_: 1
		}, 16, ["modelValue", "type"]));
	}
}), nk = [
	"aria-disabled",
	"aria-labelledby",
	"name"
], rk = { key: 0 }, ik = [
	"aria-checked",
	"aria-disabled",
	"aria-label",
	"data-test",
	"tabindex",
	"onClick",
	"onKeydown"
], ak = {
	key: 1,
	class: "flex items-center"
}, ok = /* @__PURE__ */ f({
	__name: "RadioGroup",
	props: /*@__PURE__*/ b({
		name: { default: void 0 },
		isVisible: { type: Boolean },
		isDirty: { type: Boolean },
		isDisabled: { type: Boolean },
		isOptional: { type: Boolean },
		isReadOnly: { type: Boolean },
		isSuspended: { type: Boolean },
		isTouched: { type: Boolean },
		isValid: {
			type: Boolean,
			default: !0
		},
		options: {},
		labelledBy: { default: void 0 },
		alignment: { default: "vertical" },
		disabled: { type: Boolean },
		radioClass: { default: void 0 },
		activeClass: { default: void 0 },
		optionIdentifier: { default: "label" }
	}, {
		modelValue: {},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(t) {
		let n = t, i = de("radioGroup"), c = R(t, "modelValue"), d = r(() => n.options.length - 1), { t: f } = Re(), { count: p, inc: m, dec: h, reset: g, set: _ } = ke(0, {
			min: 0,
			max: d.value
		}), v = (e) => e[n.optionIdentifier], y = (e) => {
			n.disabled || e.disabled || e.value !== c.value && (c.value = e.value);
		}, b = () => {
			i.value && i.value.children[p.value].focus();
		}, x = () => {
			p.value === d.value ? g() : m(), b();
		}, w = () => {
			p.value === 0 ? _(d.value) : h(), b();
		}, T = (e) => typeof e.value == "object" ? JSON.stringify(e.value) === JSON.stringify(c.value) : c.value === e.value, E = M(n.alignment), D = async () => {
			if (n.alignment === "vertical") {
				E.value = "vertical";
				return;
			}
			if (!i.value) {
				E.value = "horizontal";
				return;
			}
			let e = i.value, { clientWidth: t, scrollWidth: r } = e;
			if (t < r) {
				E.value = "vertical";
				return;
			}
			E.value = "horizontal", await S();
			let { clientWidth: a, scrollWidth: o } = e;
			a < o && (E.value = "vertical");
		};
		z([
			() => n.alignment,
			() => n.options,
			() => c.value
		], () => {
			D();
		}, { deep: !0 });
		let { watchResize: k, unwatchResize: j } = nt();
		/* c8 ignore stop */
		return O(() => {
			D(), k(() => {
				D();
			});
		}), ee(() => {
			j(() => {
				D();
			});
		}), (n, r) => (A(), o("div", {
			ref: "radioGroup",
			"aria-disabled": t.disabled,
			"aria-labelledby": t.labelledBy,
			class: C(["flex border rounded-[10px] w-full", {
				"flex-row": E.value === "horizontal",
				"flex-col": E.value === "vertical",
				"border-red": !t.isValid
			}]),
			name: t.name,
			role: "radiogroup"
		}, [(A(!0), o(e, null, P(t.options, (r, i) => (A(), o(e, { key: v(r) }, [r.isGroupLabel ? (A(), o("div", rk, [F(n.$slots, "groupLabel", { option: r }, () => [l(I(r.label), 1)])])) : (A(), o("div", {
			key: 1,
			"aria-checked": T(r),
			"aria-disabled": t.disabled || r.disabled,
			"aria-label": r.label ? r.label : void 0,
			class: C(["cursor-pointer flex focus:ring-2 gap-2 items-center outline-hidden ring-blue-600 px-4 py-2 last:border-none", [t.radioClass, {
				[`${t.activeClass}`]: T(r),
				"border-b": E.value === "vertical",
				"border-r flex-1 whitespace-nowrap": E.value === "horizontal"
			}]]),
			"data-test": `radio ${t.name} ${r.value}`,
			role: "radio",
			tabindex: i === L(p) ? "0" : "-1",
			onClick: (e) => y(r),
			onKeydown: [
				H(U(x, ["exact", "prevent"]), ["down"]),
				H(U(w, ["exact", "prevent"]), ["left"]),
				H(U(x, ["exact", "prevent"]), ["right"]),
				H(U((e) => y(r), ["exact", "prevent"]), ["space"]),
				H(U(w, ["exact", "prevent"]), ["up"])
			]
		}, [
			s("span", { class: C(["border border-gray-400 h-4 inline-block relative rounded-full w-4", {
				"bg-secondary border-secondary": T(r) && !(t.disabled || r.disabled),
				"bg-gray-300 border-gray-500": t.disabled || r.disabled
			}]) }, [T(r) ? (A(), o("span", {
				key: 0,
				class: C(["absolute h-[6px] left-[4px] rounded-full top-[4px] w-[6px]", {
					"bg-white": !(t.disabled || r.disabled),
					"bg-gray-800": t.disabled || r.disabled
				}])
			}, null, 2)) : a("", !0)], 2),
			r.icon ? F(n.$slots, "icon", { option: r }, void 0, void 0, 0) : a("", !0),
			F(n.$slots, "label", { option: r }, () => [l(I(r.label), 1)]),
			F(n.$slots, "default", { option: r }),
			r.note ? (A(), o("div", ak, [u(L(Gb), null, {
				default: B(() => [u(L(Yb), { translation: r.note }, null, 8, ["translation"])]),
				_: 2
			}, 1024)])) : a("", !0)
		], 42, ik))], 64))), 128))], 10, nk));
	}
}), sk = [
	"aria-activedescendant",
	"aria-controls",
	"aria-disabled",
	"aria-expanded",
	"aria-labelledby",
	"name",
	"tabindex",
	"onKeydown"
], ck = { class: "flex gap-2 p-2 px-3 w-full" }, lk = ["id"], uk = [
	"id",
	"aria-disabled",
	"aria-selected",
	"onClick"
], dk = 500, fk = 10, pk = /* @__PURE__ */ f({
	__name: "Select",
	props: /*@__PURE__*/ b({
		name: {},
		isVisible: { type: Boolean },
		isDirty: { type: Boolean },
		isDisabled: { type: Boolean },
		isOptional: { type: Boolean },
		isReadOnly: { type: Boolean },
		isSuspended: { type: Boolean },
		isTouched: { type: Boolean },
		isValid: {
			type: Boolean,
			default: !0
		},
		modelValue: {},
		options: {},
		disabled: { type: Boolean },
		placeholder: { default: void 0 },
		labelledBy: { default: void 0 },
		listBoxClass: { default: "" }
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: /*@__PURE__*/ b(["blur"], ["update:modelValue"]),
	setup(t, { emit: n }) {
		let c = t, d = n, f = R(t, "modelValue"), p = M(!1), { count: m, ...h } = ke(0, {
			min: 0,
			max: c.options.length - 1
		}), g = r(() => c.options.map((e) => e.value)), _ = r(() => c.options.find((e) => e.value === f.value)), v = r(() => c.options.some(({ isGroupLabel: e }) => e)), y = () => {
			c.disabled || (f.value && h.set(g.value.indexOf(f.value)), p.value = !0, S(O));
		}, b = () => {
			p.value = !1, h.reset(0);
		}, x = (e) => {
			e.disabled || (f.value = e.value, b());
		}, w = M(), T = M(), { placement: E } = tt(T, w, {
			middleware: [Ze({
				fallbackPlacements: ["bottom-start", "top-start"],
				padding: 100
			})],
			whileElementsMounted: Xe,
			placement: "bottom-start"
		}), D = r(() => E.value === "bottom-start"), O = () => {
			/* c8 ignore start - this will only fire when no props are set which is required */
			if (!w.value) return;
			let e = w.value.children[m.value];
			e && 
			/* c8 ignore end */
			(w.value.scrollTop = e.offsetTop);
		};
		z(m, O);
		let k = () => {
			if (!p.value) {
				y();
				return;
			}
			h.inc(1);
		}, ee = () => {
			if (!p.value) {
				y();
				return;
			}
			h.dec(1);
		}, j = () => {
			p.value && x(c.options[m.value]);
		}, te = () => {
			if (!p.value) {
				y();
				return;
			}
			x(c.options[m.value]);
		}, ne = () => {
			p.value && x(c.options[m.value]);
		}, N = () => {
			h.set(0), p.value || y();
		}, re = () => {
			h.set(c.options.length - 1), p.value || y();
		}, ie = M([]), ae = M(""), oe = null, se = () => {
			oe = setTimeout(() => {
				ie.value = [];
			}, dk);
		}, ce = (e) => {
			if (!(e.key.length === 1 && e.key.match(/[a-z]|[0-9]/i))) return;
			if (oe && clearTimeout(oe), se(), ie.value.push(e.key), p.value || y(), ae.value === e.key) {
				let e = c.options.filter((e) => e.label.toLowerCase().startsWith(ae.value.toLowerCase()));
				if (e.length === 1 || e.length === 0) return;
				let t = g.value.indexOf(c.options[m.value].value), n = g.value.indexOf(e[0].value);
				t >= g.value.indexOf(e[e.length - 1].value) ? h.set(n) : h.inc(1);
				return;
			}
			let t = ie.value.join("").toLowerCase(), n = c.options.find((e) => e.label.toLowerCase().startsWith(t));
			if (!n) return;
			let r = g.value.indexOf(n.value);
			h.set(r), ae.value = e.key;
		}, le = () => {
			p.value && h.inc(fk);
		}, ue = () => {
			p.value && h.dec(fk);
		};
		return (n, r) => V((A(), o("div", {
			ref_key: "inputRef",
			ref: T,
			"aria-activedescendant": p.value ? `option-${g.value[L(m)]}` : void 0,
			"aria-controls": `listbox-${t.name}`,
			"aria-disabled": t.disabled,
			"aria-expanded": p.value,
			"aria-haspopup": "listbox",
			"aria-labelledby": t.labelledBy,
			class: C(["border border-t group outline-hidden relative ring-blue-600 rounded-b-[25px] rounded-t-[25px] w-full", {
				"rounded-b-none! border-b-transparent!": p.value && D.value,
				"rounded-t-none! border-t-transparent!": p.value && !D.value,
				"bg-gray-200 text-gray-800 cursor-not-allowed": t.disabled,
				"border-red": !t.isValid,
				"focus:ring-2 cursor-pointer": !t.disabled
			}]),
			name: t.name,
			role: "combobox",
			tabindex: t.disabled ? -1 : 0,
			onBlur: r[0] ||= (e) => d("blur", e),
			onClick: r[1] ||= (e) => p.value ? b() : y(),
			onKeydown: [
				U(ce, ["exact"]),
				H(U(j, ["exact", "alt"]), ["up"]),
				H(U(te, ["exact"]), ["enter"]),
				H(U(b, ["exact"]), ["escape"]),
				H(U(k, ["exact", "prevent"]), ["down"]),
				H(U(re, ["exact", "prevent"]), ["end"]),
				H(U(N, ["exact", "prevent"]), ["home"]),
				H(U(le, ["exact", "prevent"]), ["page-down"]),
				H(U(ue, ["exact", "prevent"]), ["page-up"]),
				H(U(ee, ["exact", "prevent"]), ["up"]),
				H(U(te, ["exact"]), ["space"]),
				H(U(ne, ["exact"]), ["tab"])
			]
		}, [s("div", ck, [_.value?.label ? (A(), o("span", {
			key: 0,
			class: C(_.value?.class)
		}, [F(n.$slots, "value", { option: _.value }, () => [l(I(_.value?.label), 1)])], 2)) : (A(), o("span", {
			key: 1,
			class: C(["text-gray-400", { "text-gray-800": t.disabled }])
		}, I(t.placeholder), 3)), u(op, {
			class: C(["ml-auto self-center", { "text-gray-800": t.disabled }]),
			"is-open": p.value
		}, null, 8, ["class", "is-open"])]), V(s("div", {
			id: `listbox-${t.name}`,
			ref_key: "selectBodyRef",
			ref: w,
			class: C(L(_e)("-left-[1px] absolute bg-white border border-gray-400 group-focus:ring-2 hide-scrollbar max-h-52 overflow-auto py-2 ring-blue-600 shadow-card w-[calc(100%+2px)] z-20", D.value ? "top-[calc(100%+1px)] rounded-b-[20px]" : "bottom-[calc(100%+1px)] rounded-t-[20px]", t.listBoxClass)),
			role: "listbox",
			tabindex: "-1"
		}, [(A(!0), o(e, null, P(t.options, (e, t) => (A(), o("div", {
			id: `option-${e.value}`,
			key: String(e.value),
			"aria-disabled": e.disabled,
			"aria-selected": e.value === f.value,
			class: C(L(_e)([
				"border-y flex p-2",
				e.isGroupLabel ? "text-primary font-bold border-b-gray-400" : "hover:bg-gray-200 cursor-pointer",
				L(m) === t ? "border-gray-400" : "border-transparent",
				{ "bg-gray-200 text-gray-800 cursor-not-allowed": e.disabled },
				e.class,
				{ "pl-5": v.value && !e.isGroupLabel }
			])),
			role: "option",
			onClick: U((t) => x(e), ["stop", "prevent"])
		}, [s("span", null, [F(n.$slots, "option", { option: e }, () => [l(I(e.label), 1)])]), e.value === f.value ? (A(), i(ap, {
			key: 0,
			class: "ml-auto self-center"
		}, {
			default: B(() => [u(Fd)]),
			_: 1
		})) : a("", !0)], 10, uk))), 128))], 10, lk), [[he, p.value]])], 42, sk)), [[L(Ee), b]]);
	}
}), mk = { class: "flex relative w-full" }, hk = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "Search",
	props: /*@__PURE__*/ b({
		name: {},
		placeholder: { default: void 0 },
		disabled: { type: Boolean },
		labelledBy: { default: void 0 },
		buttonVariant: { default: "secondary-outline" },
		buttonDisabled: { type: Boolean },
		buttonAriaLabel: { default: void 0 },
		hasIconToTheLeft: {
			type: Boolean,
			default: !1
		},
		hasSubmitButton: {
			type: Boolean,
			default: !0
		},
		options: { default: () => [] }
	}, {
		modelValue: { required: !0 },
		modelModifiers: {},
		queryAttribute: {
			required: !1,
			default: ""
		},
		queryAttributeModifiers: {},
		search: {
			required: !1,
			default: null
		},
		searchModifiers: {}
	}),
	emits: /*@__PURE__*/ b([
		"blur",
		"click",
		"inputClick"
	], [
		"update:modelValue",
		"update:queryAttribute",
		"update:search"
	]),
	setup(e) {
		let t = e, n = le(), s = r(() => t.hasSubmitButton || t.options.length > 0), c = R(e, "modelValue"), l = R(e, "queryAttribute"), d = R(e, "search");
		return t.options.length && z([c, l], () => {
			d.value = { [l.value]: c.value };
		}, { immediate: !0 }), (t, r) => (A(), o("div", mk, [
			e.hasIconToTheLeft ? (A(), i(L(Jp), {
				key: 0,
				"aria-hidden": "true",
				class: "-translate-y-1/2 absolute left-3 pointer-events-none text-gray-500 top-1/2"
			}, {
				default: B(() => [u(L(vm))]),
				_: 1
			})) : a("", !0),
			u(QO, x(t.$attrs, {
				modelValue: c.value,
				"onUpdate:modelValue": r[0] ||= (e) => c.value = e,
				class: L(_e)(e.hasIconToTheLeft && "pl-9!", s.value && "border-r-0! rounded-r-none!", t.$attrs.class),
				disabled: e.disabled,
				"labelled-by": e.labelledBy,
				name: e.name,
				placeholder: e.placeholder,
				type: "search",
				onBlur: r[1] ||= (e) => t.$emit("blur", e),
				onClick: r[2] ||= (e) => t.$emit("inputClick", e)
			}), null, 16, [
				"modelValue",
				"class",
				"disabled",
				"labelled-by",
				"name",
				"placeholder"
			]),
			e.options.length > 0 ? (A(), i(pk, {
				key: 1,
				modelValue: l.value,
				"onUpdate:modelValue": r[3] ||= (e) => l.value = e,
				class: C(L(_e)("rounded-none! flex items-center max-w-max", !e.hasSubmitButton && "rounded-r-full!")),
				name: L(n),
				options: e.options
			}, null, 8, [
				"modelValue",
				"class",
				"name",
				"options"
			])) : a("", !0),
			e.hasSubmitButton ? (A(), i(Dp, {
				key: 2,
				"aria-label": e.buttonAriaLabel,
				class: "rounded-l-none! flex items-center rounded-r-full",
				disabled: e.buttonDisabled,
				variant: e.buttonVariant,
				onClick: r[4] ||= (e) => t.$emit("click", e)
			}, {
				default: B(() => [F(t.$slots, "button", {}, () => [u(L(Jp), null, {
					default: B(() => [u(L(vm))]),
					_: 1
				})])]),
				_: 3
			}, 8, [
				"aria-label",
				"disabled",
				"variant"
			])) : a("", !0)
		]));
	}
}), gk = {
	ref: "containerRef",
	class: "flex flex-col relative w-full"
}, _k = { class: "flex w-full" }, vk = {
	key: 0,
	class: "absolute bg-white border border-gray mt-2 overflow-hidden rounded-xl top top-full w-full z-30",
	role: "listbox"
}, yk = ["aria-label"], bk = ["onClick"], xk = {
	key: 0,
	class: "text-black-light"
}, Sk = {
	key: 3,
	class: "border-t flex flex-row justify-end py-0.5 w-full"
}, Ck = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "SearchSuggestTextInput",
	props: /*@__PURE__*/ b({
		name: {},
		cancelLabel: { default: void 0 },
		placeholder: {},
		disabled: { type: Boolean },
		maxLength: { default: void 0 },
		suggestions: {},
		buttonVariant: { default: "secondary" },
		isValid: {
			type: Boolean,
			default: !0
		},
		debounceTime: { default: 750 },
		loading: {
			type: Boolean,
			default: !1
		},
		noResultsLabel: { default: void 0 }
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: /*@__PURE__*/ b([
		"blur",
		"search",
		"selected"
	], ["update:modelValue"]),
	setup(t, { emit: n }) {
		let c = ue(), d = t, { t: f } = Re(), p = r(() => d.noResultsLabel ?? f("common.noResults")), m = n, h = M(!1), g = M(!1), _ = de("containerRef"), v = de("textInputRef"), { focused: y } = Me(_), b = se(), w = r(() => "button" in c);
		z(y, async (e) => {
			await S(), e ? ee() : j();
		});
		let T = R(t, "modelValue", { set(e) {
			return e.trimStart();
		} }), { count: E, dec: D, inc: O } = ke(0, { min: 0 }), k = r(() => d.suggestions.map((e) => e.value)), ee = () => {
			!d.loading && !g.value && d.suggestions.length === 0 || (h.value = !0);
		}, j = () => {
			h.value = !1;
		}, te = async (e) => {
			N(), T.value = e.value, await S(), T.value = e.label, j(), await S(), re(), m("selected", e);
		}, ne = Ae(() => {
			y.value && m("search", T.value);
		}, () => d.debounceTime), { pause: N, resume: re } = Ie(T, () => {
			ne();
		});
		z(() => d.suggestions, (e) => {
			e.length && (g.value = !1), y.value && ee();
		}), z(T, () => {
			g.value = !1;
		}), z(() => d.loading, (e) => {
			e ? g.value = !1 : g.value = d.suggestions.length === 0 && (T.value ?? "").trim().length > 0, y.value && ee();
		});
		let ie = M();
		z(E, () => {
			/* c8 ignore start - this will only fire when no props are set which is required */
			if (!ie.value) return;
			let e = ie.value.children[E.value];
			e && 
			/* c8 ignore end */
			(ie.value.scrollTop = e.offsetTop);
		});
		let ae = async () => {
			if (!h.value) {
				h.value = !0;
				return;
			}
			let e = d.suggestions[E.value];
			if (e) {
				await te(e);
				return;
			}
			ne();
		}, oe = () => {
			h.value && E.value !== d.suggestions.length - 1 && O();
		}, ce = () => {
			h.value && D();
		}, le = () => {
			v.value?.focus();
		};
		return (n, r) => (A(), o("div", gk, [
			s("div", _k, [u(QO, x({
				ref: "textInputRef",
				modelValue: T.value,
				"onUpdate:modelValue": r[0] ||= (e) => T.value = e
			}, L(b), {
				"aria-activedescendant": h.value ? `option-${k.value[L(E)]}` : void 0,
				class: { "border-r-0! rounded-r-none!": w.value },
				disabled: t.disabled,
				"is-valid": t.isValid,
				maxlength: t.maxLength,
				name: t.name,
				placeholder: t.placeholder,
				role: "combobox",
				onBlur: r[1] ||= (e) => m("blur", T.value),
				onKeydown: [
					H(U(oe, ["exact"]), ["down"]),
					H(U(ae, ["exact", "prevent"]), ["enter"]),
					H(U(j, ["exact"]), ["escape"]),
					H(U(ce, ["exact"]), ["up"])
				]
			}), null, 16, [
				"modelValue",
				"aria-activedescendant",
				"class",
				"disabled",
				"is-valid",
				"maxlength",
				"name",
				"placeholder",
				"onKeydown"
			]), w.value ? (A(), i(Dp, {
				key: 0,
				class: "flex items-center rounded-r-full",
				disabled: t.disabled,
				tabindex: "-1",
				variant: t.buttonVariant,
				onClick: le
			}, {
				default: B(() => [F(n.$slots, "button")]),
				_: 3
			}, 8, ["disabled", "variant"])) : a("", !0)]),
			F(n.$slots, "sublabel"),
			h.value && (t.loading || t.suggestions.length || g.value) ? (A(), o("div", vk, [t.loading && !t.suggestions.length ? (A(), o("div", {
				key: 0,
				"aria-disabled": "true",
				"aria-label": L(f)("common.loading"),
				class: "flex items-center justify-center px-3 py-4",
				role: "option"
			}, [u(Ap, { size: "small" })], 8, yk)) : g.value ? (A(), i(yb, {
				key: 1,
				"aria-disabled": "true",
				class: "px-3 py-3 text-black-light",
				role: "option",
				size: "small"
			}, {
				default: B(() => [l(I(p.value), 1)]),
				_: 1
			})) : (A(), o("ul", {
				key: 2,
				ref_key: "selectBodyRef",
				ref: ie,
				class: "max-h-64 overflow-auto",
				tabindex: "-1"
			}, [(A(!0), o(e, null, P(t.suggestions, (e, r) => (A(), o("li", {
				key: e.label,
				class: C(["border-gray cursor-pointer flex flex-col hover:bg-gray-100 px-3 py-3", {
					"bg-gray-100": L(E) === r,
					"border-b": t.suggestions.length > 1
				}]),
				role: "option",
				onClick: U((t) => te(e), ["stop"])
			}, [F(n.$slots, "listitem", { suggestion: e }, () => [s("strong", null, I(e.label), 1), e.sublabel ? (A(), o("span", xk, I(e.sublabel), 1)) : a("", !0)])], 10, bk))), 128))], 512)), t.cancelLabel && t.suggestions.length ? (A(), o("div", Sk, [u(Dp, {
				tabindex: "-1",
				type: "button",
				variant: "primary-basic",
				onClick: U(j, ["stop"])
			}, {
				default: B(() => [l(I(t.cancelLabel), 1)]),
				_: 1
			})])) : a("", !0)])) : a("", !0)
		], 512));
	}
}), wk = [
	"id",
	"aria-activedescendant",
	"aria-controls",
	"aria-disabled",
	"aria-expanded",
	"aria-label",
	"aria-labelledby",
	"name",
	"tabindex",
	"onKeydown"
], Tk = { class: "flex gap-2 px-3 py-2 w-full" }, Ek = { key: 0 }, Dk = { key: 0 }, Ok = ["id"], kk = [
	"id",
	"aria-disabled",
	"aria-selected",
	"onClick"
], Ak = 500, jk = 10, Mk = /* @__PURE__ */ f({
	__name: "MultiSelect",
	props: /*@__PURE__*/ b({
		name: {},
		isVisible: { type: Boolean },
		isDirty: { type: Boolean },
		isDisabled: { type: Boolean },
		isOptional: { type: Boolean },
		isReadOnly: { type: Boolean },
		isSuspended: { type: Boolean },
		isTouched: { type: Boolean },
		isValid: { type: Boolean },
		options: {},
		disabled: { type: Boolean },
		placeholder: {},
		max: {},
		labelledBy: {},
		ariaLabel: {}
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(t) {
		let n = t, c = R(t, "modelValue"), d = M(!1), { count: f, ...p } = ke(0, {
			min: 0,
			max: n.options.length - 1
		}), m = r(() => n.options.map((e) => e.value)), h = r(() => n.options.map((e) => c.value.includes(e.value) && e).filter(Boolean)), g = r(() => n.max ? c.value.length === n.max : !1), _ = r(() => h.value.length ? h.value.map((e) => e.label).join(", ") : ""), v = () => {
			n.disabled || (d.value = !0, S(O));
		}, y = () => {
			d.value = !1, p.reset(0);
		}, b = (e) => {
			if (c.value.includes(e.value)) {
				x(e);
				return;
			}
			g.value || (c.value = [...c.value, e.value]);
		}, x = (e) => {
			c.value = c.value.filter((t) => t !== e.value);
		}, w = M(), T = M(), { placement: E } = tt(T, w, {
			middleware: [Ze({
				fallbackPlacements: ["bottom-start", "top-start"],
				padding: 100
			})],
			whileElementsMounted: Xe,
			placement: "bottom-start"
		}), D = r(() => E.value === "bottom-start"), O = () => {
			/* c8 ignore start - this will only fire when no props are set which is required */
			if (!w.value) return;
			let e = w.value.children[f.value];
			e && 
			/* c8 ignore end */
			(w.value.scrollTop = e.offsetTop);
		};
		z(f, O);
		let k = () => {
			if (!d.value) {
				v();
				return;
			}
			p.inc(1);
		}, ee = () => {
			if (!d.value) {
				v();
				return;
			}
			p.dec(1);
		}, j = () => {
			d.value && b(n.options[f.value]);
		}, te = () => {
			if (!d.value) {
				v();
				return;
			}
			b(n.options[f.value]);
		}, ne = () => {
			d.value && b(n.options[f.value]);
		}, N = () => {
			p.set(0), d.value || v();
		}, re = () => {
			p.set(n.options.length - 1), d.value || v();
		}, ie = M([]), ae = M(""), oe = null, se = () => {
			oe = setTimeout(() => {
				ie.value = [];
			}, Ak);
		}, ce = (e) => {
			if (!(e.key.length === 1 && e.key.match(/[a-z]|[0-9]/i))) return;
			if (oe && clearTimeout(oe), se(), ie.value.push(e.key), d.value || v(), ae.value === e.key) {
				let e = n.options.filter((e) => e.label.toLowerCase().startsWith(ae.value.toLowerCase()));
				if (e.length === 1 || e.length === 0) return;
				let t = m.value.indexOf(n.options[f.value].value), r = m.value.indexOf(e[0].value);
				t >= m.value.indexOf(e[e.length - 1].value) ? p.set(r) : p.inc(1);
				return;
			}
			let t = ie.value.join("").toLowerCase(), r = n.options.find((e) => e.label.toLowerCase().startsWith(t));
			if (!r) return;
			let i = m.value.indexOf(r.value);
			p.set(i), ae.value = e.key;
		}, le = () => {
			d.value && p.inc(jk);
		}, ue = () => {
			d.value && p.dec(jk);
		};
		return (n, r) => (A(), o(e, null, [V((A(), o("div", {
			id: t.name,
			ref_key: "inputRef",
			ref: T,
			"aria-activedescendant": d.value ? `option-${m.value[L(f)]}` : void 0,
			"aria-controls": `listbox-${t.name}`,
			"aria-disabled": t.disabled,
			"aria-expanded": d.value,
			"aria-haspopup": "listbox",
			"aria-label": t.ariaLabel,
			"aria-labelledby": t.labelledBy,
			"aria-multiselectable": "true",
			class: C(["border border-t group outline-hidden relative ring-blue-600 rounded-b-[25px] rounded-t-[25px] w-full", {
				"rounded-b-none! border-b-transparent!": d.value && D.value,
				"rounded-t-none! border-t-transparent!": d.value && !D.value,
				"bg-gray-200 text-gray-800 cursor-not-allowed": t.disabled,
				"focus:ring-2 cursor-pointer": !t.disabled
			}]),
			name: t.name,
			role: "combobox",
			tabindex: t.disabled ? -1 : 0,
			onClick: r[0] ||= (e) => d.value ? y() : v(),
			onKeydown: [
				U(ce, ["exact"]),
				H(U(j, ["exact", "alt"]), ["up"]),
				H(U(te, ["exact"]), ["enter"]),
				H(U(y, ["exact"]), ["escape"]),
				H(U(k, ["exact", "prevent"]), ["down"]),
				H(U(re, ["exact", "prevent"]), ["end"]),
				H(U(N, ["exact", "prevent"]), ["home"]),
				H(U(le, ["exact", "prevent"]), ["page-down"]),
				H(U(ue, ["exact", "prevent"]), ["page-up"]),
				H(U(ee, ["exact", "prevent"]), ["up"]),
				H(U(te, ["exact"]), ["space"]),
				H(U(ne, ["exact"]), ["tab"])
			]
		}, [s("div", Tk, [_.value ? (A(), o("span", Ek, [F(n.$slots, "value", {
			deselectItem: x,
			options: h.value,
			selectItem: b
		}, () => [n.$slots.outsideBadges ? a("", !0) : (A(), o("span", Dk, I(_.value), 1))])])) : (A(), o("span", {
			key: 1,
			class: C(["text-gray-400", { "text-gray-800": t.disabled }])
		}, I(t.placeholder), 3)), u(op, {
			class: C(["ml-auto self-center", { "text-gray-800": t.disabled }]),
			"is-open": d.value
		}, null, 8, ["class", "is-open"])]), V(s("div", {
			id: `listbox-${t.name}`,
			ref_key: "selectBodyRef",
			ref: w,
			class: C(["-left-[1px] absolute border border-gray-400 group-focus:ring-2 hide-scrollbar max-h-52 overflow-auto py-2 ring-blue-600 shadow-card w-[calc(100%+2px)] z-20", {
				"top-[calc(100%+1px)] rounded-b-[20px]": D.value,
				"bottom-[calc(100%+1px)] rounded-t-[20px]": !D.value,
				"bg-white": !g.value,
				"bg-gray-200": g.value
			}]),
			role: "listbox",
			tabindex: "-1"
		}, [(A(!0), o(e, null, P(t.options, (e, t) => (A(), o("div", {
			id: `option-${e.value}`,
			key: String(e.value),
			"aria-disabled": g.value && !c.value.includes(e.value),
			"aria-selected": c.value.includes(e.value),
			class: C(["bg-white border-y cursor-pointer flex hover:bg-gray-200 p-2", {
				"border-transparent": L(f) !== t,
				"border-gray-400": L(f) === t,
				"bg-gray-200! text-gray-800 cursor-not-allowed!": g.value && !c.value.includes(e.value)
			}]),
			role: "option",
			onClick: U((t) => b(e), ["stop", "prevent"])
		}, [s("span", null, [F(n.$slots, "option", { option: e }, () => [l(I(e.label), 1)])]), c.value.includes(e.value) ? (A(), i(ap, {
			key: 0,
			class: "ml-auto self-center"
		}, {
			default: B(() => [u(Fd)]),
			_: 1
		})) : a("", !0)], 10, kk))), 128))], 10, Ok), [[he, d.value]])], 42, wk)), [[L(Ee), y]]), n.$slots.outsideBadges ? F(n.$slots, "outsideBadges", {
			deselectItem: x,
			options: h.value
		}, void 0, void 0, 0) : a("", !0)], 64));
	}
}), Nk = { "data-test": "selectedOptions" }, Pk = { class: "flex flex-wrap gap-2" }, Fk = { class: "bg-secondary flex px-2 py-0.5 rounded-full text-sm text-white" }, Ik = ["onClick"], Lk = /* @__PURE__ */ f({
	__name: "MultiSelectWithBadges",
	props: /*@__PURE__*/ b({
		options: {},
		disabled: { type: Boolean },
		name: {},
		placeholder: {},
		labelledBy: {},
		label: {}
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(t) {
		let n = R(t, "modelValue");
		return (r, a) => (A(), i(Mk, {
			modelValue: n.value,
			"onUpdate:modelValue": a[0] ||= (e) => n.value = e,
			"aria-label": t.label,
			disabled: t.disabled,
			"labelled-by": t.labelledBy,
			name: t.name,
			options: t.options,
			placeholder: t.placeholder
		}, {
			value: B(({ options: t, deselectItem: n }) => [s("div", Nk, [s("div", Pk, [(A(!0), o(e, null, P(t, (e) => (A(), o("div", {
				key: e.label,
				class: ""
			}, [s("p", Fk, [l(I(e.label) + " ", 1), s("button", {
				class: "hover:text-white text-[#ffe3bf]",
				type: "button",
				onClick: U((t) => n(e), ["stop", "prevent"])
			}, [u(ap, { class: "flex ml-1 p-0.5" }, {
				default: B(() => [u(L(xn))]),
				_: 1
			})], 8, Ik)])]))), 128))])])]),
			_: 1
		}, 8, [
			"modelValue",
			"aria-label",
			"disabled",
			"labelled-by",
			"name",
			"options",
			"placeholder"
		]));
	}
}), Rk = { class: "flex flex-col w-full" }, zk = {
	key: 0,
	class: "mt-2",
	"data-test": "selectedOptions"
}, Bk = { class: "flex flex-wrap gap-2" }, Vk = { class: "bg-secondary flex px-2 py-0.5 rounded-full text-sm text-white" }, Hk = ["onClick"], Uk = /* @__PURE__ */ f({
	__name: "MultiSelectWithBadgesOutside",
	props: /*@__PURE__*/ b({
		options: {},
		disabled: { type: Boolean },
		name: {},
		placeholder: {},
		labelledBy: {}
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(t) {
		let n = R(t, "modelValue");
		return (r, i) => (A(), o("div", Rk, [u(Mk, {
			modelValue: n.value,
			"onUpdate:modelValue": i[0] ||= (e) => n.value = e,
			disabled: t.disabled,
			"labelled-by": t.labelledBy,
			name: t.name,
			options: t.options,
			placeholder: t.placeholder
		}, {
			outsideBadges: B(({ options: t, deselectItem: n }) => [t?.length ? (A(), o("div", zk, [s("div", Bk, [(A(!0), o(e, null, P(t, (e) => (A(), o("div", { key: e.label }, [s("p", Vk, [l(I(e.label) + " ", 1), s("button", {
				class: "hover:text-white text-(--color-secondary-light)",
				type: "button",
				onClick: (t) => n(e)
			}, [u(ap, { class: "flex ml-1 p-0.5" }, {
				default: B(() => [u(L(xn))]),
				_: 1
			})], 8, Hk)])]))), 128))])])) : a("", !0)]),
			_: 1
		}, 8, [
			"modelValue",
			"disabled",
			"labelled-by",
			"name",
			"options",
			"placeholder"
		])]));
	}
}), Wk = /* @__PURE__ */ new Map([
	["Æ", "Ae"],
	["Ð", "D"],
	["Ø", "O"],
	["Þ", "Th"],
	["ß", "ss"],
	["æ", "ae"],
	["ð", "d"],
	["ø", "o"],
	["þ", "th"],
	["Đ", "D"],
	["đ", "d"],
	["Ħ", "H"],
	["ħ", "h"],
	["ı", "i"],
	["Ĳ", "IJ"],
	["ĳ", "ij"],
	["ĸ", "k"],
	["Ŀ", "L"],
	["ŀ", "l"],
	["Ł", "L"],
	["ł", "l"],
	["ŉ", "'n"],
	["Ŋ", "N"],
	["ŋ", "n"],
	["Œ", "Oe"],
	["œ", "oe"],
	["Ŧ", "T"],
	["ŧ", "t"],
	["ſ", "s"]
]);
function Gk(e) {
	e = e.normalize("NFD");
	let t = "";
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		r >= "̀" && r <= "ͯ" || r >= "⃐" && r <= "⃿" || r >= "︠" && r <= "︯" || (t += Wk.get(r) ?? r);
	}
	return t;
}
//#endregion
//#region src/components/Form/Selects/SelectAutocomplete/SelectAutocomplete.vue?vue&type=script&setup=true&lang.ts
var Kk = { class: "flex group" }, qk = [
	"aria-activedescendant",
	"aria-controls",
	"aria-expanded",
	"aria-invalid",
	"aria-labelledby",
	"disabled",
	"name",
	"placeholder",
	"onKeydown"
], Jk = [
	"aria-controls",
	"aria-expanded",
	"disabled"
], Yk = ["id"], Xk = {
	key: 0,
	class: "border-b font-bold option-group-header px-4 py-2 text-primary",
	role: "presentation"
}, Zk = ["aria-selected", "onClick"], Qk = /* @__PURE__ */ f({
	__name: "SelectAutocomplete",
	props: /*@__PURE__*/ b({
		modelValue: {},
		options: {},
		disabled: {
			type: Boolean,
			default: !1
		},
		name: {},
		placeholder: { default: "" },
		labelledBy: { default: void 0 },
		isValid: {
			type: Boolean,
			default: !0
		},
		relativeListbox: {
			type: Boolean,
			default: !1
		}
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(t) {
		let n = t, c = M(!1), d = () => {
			c.value = !0;
		}, f = () => {
			c.value = !1;
		}, p = M(), m = M(!1);
		z(p, () => {
			x.value && (m.value = !0);
		});
		let h = r(() => !p.value || !m.value ? n.options : n.options.filter((e) => {
			/* c8 ignore next */
			if (!p.value) return !0;
			let t = Gk(p.value.toLocaleLowerCase());
			return Gk(e.label.toLocaleLowerCase()).includes(t);
		})), g = R(t, "modelValue"), _ = r(() => h.value.find((e) => e.value === g.value)), { count: v, ...y } = ke(0, {
			min: 0,
			max: h.value.length
		}), b = r(() => v.value - 1), x = M(!1);
		z(_, () => {
			x.value || (p.value = _.value?.label);
		}, { immediate: !0 });
		let w = () => {
			p.value = "", x.value = !0;
		}, T = () => {
			x.value = !1, y.reset(0), S(() => {
				_.value && (p.value = _.value.label), m.value = !1;
			});
		}, E = (e) => {
			g.value = e.value, T();
		}, D = M();
		z(v, () => {
			/* c8 ignore start - this will only fire when no props are set which is required */
			if (!D.value) return;
			let e = D.value.children[b.value];
			e && 
			/* c8 ignore end */
			(D.value.scrollTop = e.offsetTop);
		});
		let O = () => {
			if (!x.value) {
				y.set(1), w();
				return;
			}
			if (v.value === h.value.length) {
				y.set(1), h.value[b.value]?.isGroupLabel && O();
				return;
			}
			y.inc(1), h.value[b.value]?.isGroupLabel && O();
		}, k = () => {
			if (!x.value) {
				y.set(h.value.length), w();
				return;
			}
			if (v.value === 0 || v.value === 1) {
				y.set(h.value.length), h.value[b.value]?.isGroupLabel && k();
				return;
			}
			y.dec(1), h.value[b.value]?.isGroupLabel && k();
		}, ee = () => {
			if (!x.value) {
				w();
				return;
			}
			v.value && E(h.value[b.value]);
		}, j = () => {
			if (x.value) {
				T();
				return;
			}
			p.value = "";
		}, te = (e) => {
			let t = e.key.length === 1 && e.key.match(/[a-z]|[0-9]/i);
			!x.value && t && w();
		};
		return (n, r) => V((A(), o("div", { class: C(["border outline-hidden relative rounded-[20px] w-full", {
			"rounded-b-none! border-b-transparent! rounded-tl-[17px]! rounded-tr-[17px]!": x.value,
			"bg-gray-200 text-gray-800 cursor-not-allowed": t.disabled,
			"cursor-pointer": !t.disabled,
			"border-red": !t.isValid,
			"ring-2 ring-blue-600": c.value
		}]) }, [s("div", Kk, [V(s("input", {
			"onUpdate:modelValue": r[0] ||= (e) => p.value = e,
			"aria-activedescendant": x.value && L(v) !== 0 && h.value.length ? `option-${h.value[b.value].value}` : void 0,
			"aria-autocomplete": "list",
			"aria-controls": `listbox-${t.name}`,
			"aria-expanded": x.value,
			"aria-haspopup": "listbox",
			"aria-invalid": t.isValid ? void 0 : "true",
			"aria-labelledby": t.labelledBy,
			class: C(["outline-none pl-3 py-2 rounded-l-[20px] w-full", {
				"rounded-bl-none! rounded-l-[17px]": x.value,
				"cursor-not-allowed": t.disabled
			}]),
			disabled: t.disabled,
			name: t.name,
			placeholder: t.placeholder,
			role: "combobox",
			type: "text",
			onBlur: f,
			onClick: r[1] ||= (e) => x.value ? T() : w(),
			onFocus: d,
			onKeydown: [
				te,
				H(U(O, ["exact", "prevent"]), ["down"]),
				H(U(ee, ["exact", "prevent"]), ["enter"]),
				H(U(j, ["exact", "prevent"]), ["escape"]),
				H(U(k, ["exact", "prevent"]), ["up"]),
				H(U(T, ["exact"]), ["tab"])
			]
		}, null, 42, qk), [[me, p.value]]), s("button", {
			id: "cb1-button",
			"aria-controls": `listbox-${t.name}`,
			"aria-expanded": x.value,
			class: "flex items-center px-3",
			disabled: t.disabled,
			tabindex: "-1",
			type: "button",
			onClick: r[2] ||= (e) => x.value ? T() : w()
		}, [u(op, {
			class: C({ "text-gray-800": t.disabled }),
			"is-open": x.value
		}, null, 8, ["class", "is-open"])], 8, Jk)]), V(s("ul", {
			id: `listbox-${t.name}`,
			ref_key: "selectBodyRef",
			ref: D,
			class: C(["-left-[1px] bg-white border border-gray-400 hide-scrollbar max-h-52 overflow-auto py-2 rounded-b-[20px] shadow-card top-[calc(100%+1px)] w-[calc(100%+2px)] z-20", {
				"ring-2 ring-blue-600": c.value,
				absolute: !t.relativeListbox,
				relative: t.relativeListbox
			}]),
			role: "listbox",
			tabindex: "-1"
		}, [(A(!0), o(e, null, P(h.value, (t, n) => (A(), o(e, { key: t.label }, [t.isGroupLabel ? (A(), o("li", Xk, I(t.label), 1)) : (A(), o("li", {
			key: 1,
			"aria-selected": t.value === g.value,
			class: C(["border-y cursor-pointer flex hover:bg-gray-200 p-2", {
				"border-transparent": L(v) !== n + 1,
				"border-gray-400": L(v) === n + 1
			}]),
			role: "option",
			onClick: U((e) => E(t), ["stop", "prevent"])
		}, [l(I(t.label), 1), t.value === g.value ? (A(), i(ap, {
			key: 0,
			class: "ml-auto self-center"
		}, {
			default: B(() => [u(Fd)]),
			_: 1
		})) : a("", !0)], 10, Zk))], 64))), 128))], 10, Yk), [[he, x.value]])], 2)), [[L(Ee), T]]);
	}
}), $k = [
	"id",
	"aria-checked",
	"disabled",
	"name"
], eA = [
	"aria-labelledby",
	"for",
	"onKeydown"
], tA = /* @__PURE__ */ f({
	__name: "Switch",
	props: /*@__PURE__*/ b({
		name: {},
		isVisible: { type: Boolean },
		isDirty: { type: Boolean },
		isDisabled: { type: Boolean },
		isOptional: { type: Boolean },
		isReadOnly: { type: Boolean },
		isSuspended: { type: Boolean },
		isTouched: { type: Boolean },
		isValid: { type: Boolean },
		modelValue: { type: Boolean },
		labelledBy: {},
		disabled: { type: Boolean }
	}, {
		modelValue: {
			type: Boolean,
			required: !0
		},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = R(e, "modelValue"), n = () => {
			t.value = !t.value;
		};
		return (r, i) => (A(), o("div", null, [V(s("input", {
			id: e.name,
			"onUpdate:modelValue": i[0] ||= (e) => t.value = e,
			"aria-checked": t.value ? "true" : "false",
			class: "appearance-none h-0 hidden w-0",
			disabled: e.disabled,
			name: e.name,
			role: "switch",
			type: "checkbox"
		}, null, 8, $k), [[fe, t.value]]), s("label", {
			"aria-labelledby": e.labelledBy,
			class: C(["block border cursor-pointer focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 h-[20px] outline-hidden relative rounded-full w-[40px]", {
				"bg-gray-500 border-gray-800": e.disabled || !t.value,
				"bg-primary border-primary": t.value && !e.disabled
			}]),
			for: e.name,
			tabindex: "0",
			onKeydown: H(U(n, ["exact"]), ["space"])
		}, [s("span", { class: C(["absolute block h-[18px] rounded-full transition-all w-[18px]", {
			"bg-white": !e.disabled,
			"bg-gray-800": e.disabled,
			"left-5": t.value,
			"left-0": !t.value
		}]) }, null, 2)], 42, eA)]));
	}
}), nA = ["id", "name"], rA = /* @__PURE__ */ f({
	__name: "TextArea",
	props: /*@__PURE__*/ b({
		name: {},
		isVisible: { type: Boolean },
		isDirty: { type: Boolean },
		isDisabled: { type: Boolean },
		isOptional: { type: Boolean },
		isReadOnly: { type: Boolean },
		isSuspended: { type: Boolean },
		isTouched: { type: Boolean },
		isValid: {
			type: Boolean,
			default: !0
		},
		modelValue: {}
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = R(e, "modelValue");
		return (n, r) => V((A(), o("textarea", {
			id: e.name,
			"onUpdate:modelValue": r[0] ||= (e) => t.value = e,
			class: C(["border focus:ring-2 outline-hidden px-3 py-2 ring-blue-600 rounded-lg w-full", { "border-red": !e.isValid }]),
			name: e.name,
			type: "text"
		}, null, 10, nA)), [[me, t.value]]);
	}
}), iA = { class: "flex w-full" }, aA = {
	key: 0,
	class: "border border-r-0 font-thin px-3 py-2 rounded-l-full text-secondary"
}, oA = {
	key: 1,
	class: "border border-l-0 font-thin px-3 py-2 rounded-r-full text-secondary"
}, sA = /* @__PURE__ */ f({
	__name: "TextInputWithInfo",
	props: /*@__PURE__*/ b({
		suffix: {},
		prefix: {},
		name: {},
		labelledBy: {}
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: /*@__PURE__*/ b(["blur"], ["update:modelValue"]),
	setup(e) {
		let t = e, n = (e) => {
			let n = e;
			return t.prefix && (n = n.split(t.prefix)?.pop() || n), t.suffix && (n = n.split(t.suffix)?.splice(0, 1).join("") || n), n;
		}, r = R(e, "modelValue", {
			set(e) {
				return n(e);
			},
			get(e) {
				return n(e);
			}
		});
		return (t, n) => (A(), o("div", iA, [
			e.prefix ? (A(), o("div", aA, I(e.prefix), 1)) : a("", !0),
			u(QO, {
				modelValue: r.value,
				"onUpdate:modelValue": n[0] ||= (e) => r.value = e,
				class: C({
					"rounded-r-none!": !!e.suffix,
					"rounded-l-none!": !!e.prefix
				}),
				"labelled-by": e.labelledBy,
				name: e.name,
				onBlur: n[1] ||= (e) => t.$emit("blur", e)
			}, null, 8, [
				"modelValue",
				"class",
				"labelled-by",
				"name"
			]),
			e.suffix ? (A(), o("div", oA, I(e.suffix), 1)) : a("", !0)
		]));
	}
}), cA = /* @__PURE__ */ f({
	__name: "TimeInput",
	props: /*@__PURE__*/ b({
		name: {},
		isVisible: { type: Boolean },
		isDirty: { type: Boolean },
		isDisabled: { type: Boolean },
		isOptional: { type: Boolean },
		isReadOnly: { type: Boolean },
		isSuspended: { type: Boolean },
		isTouched: { type: Boolean },
		isValid: {
			type: Boolean,
			default: !0
		},
		disabled: { type: Boolean },
		modelValue: {},
		autoFocus: { type: Boolean },
		labelledBy: { default: void 0 }
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = R(e, "modelValue");
		return (e, n) => (A(), i(QO, x(e.$props, {
			modelValue: t.value,
			"onUpdate:modelValue": n[0] ||= (e) => t.value = e,
			class: "md:w-32 relative sm:w-full",
			type: "time"
		}), null, 16, ["modelValue"]));
	}
}), lA = { class: "flex flex-row w-full" }, uA = /* @__PURE__ */ f({
	__name: "WeightSelector",
	props: /*@__PURE__*/ b({
		name: { default: "weight" },
		unit: { default: Fy.Kilogram },
		units: { default: () => [{
			value: Fy.Gram,
			label: "Gram",
			factor: Iy[Fy.Gram]
		}, {
			value: Fy.Kilogram,
			label: "Kilogram",
			factor: Iy[Fy.Kilogram]
		}] },
		placeholder: { default: void 0 },
		isValid: {
			type: Boolean,
			default: !0
		},
		emptyValue: { default: 0 },
		unitFieldLabel: {}
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: /*@__PURE__*/ b(["unit-changed", "blur"], ["update:modelValue"]),
	setup(e, { emit: t }) {
		let n = e, i = t, a = {
			value: Fy.Gram,
			label: "Gram",
			factor: Iy[Fy.Gram]
		}, s = (e, t, n) => e * t.factor / n.factor, c = M(n.unit), l = r(() => n.units), d = r(() => !n.units || n.units.length === 1), f = n.emptyValue, p = R(e, "modelValue", {
			set(e) {
				return e?.toString() === "" ? null : s(e, m(c.value), a);
			},
			get(e) {
				return e == null ? f : s(e, a, m(c.value));
			}
		}), m = (e) => n.units.find((t) => t.value === e), h = (e) => {
			c.value = e, i("unit-changed", e);
		};
		return z(() => n.unit, (e) => {
			e !== void 0 && e !== c.value && (c.value = e);
		}), (t, n) => (A(), o("div", lA, [u(HO, {
			id: e.name,
			modelValue: p.value,
			"onUpdate:modelValue": n[0] ||= (e) => p.value = e,
			modelModifiers: { number: !0 },
			class: "border-r-0! rounded-r-none! textinput-weight",
			"input-classes": "border-r-0",
			"is-valid": e.isValid,
			name: e.name,
			placeholder: e.placeholder,
			step: "any",
			onBlur: n[1] ||= (e) => i("blur", e)
		}, null, 8, [
			"id",
			"modelValue",
			"is-valid",
			"name",
			"placeholder"
		]), u(pk, {
			modelValue: c.value,
			"onUpdate:modelValue": [n[2] ||= (e) => c.value = e, h],
			"aria-label": e.unitFieldLabel,
			class: "rounded-l-none!",
			disabled: d.value,
			"is-valid": e.isValid,
			name: "weight-unit",
			options: l.value,
			onBlur: n[3] ||= (e) => i("blur", e)
		}, null, 8, [
			"modelValue",
			"aria-label",
			"disabled",
			"is-valid",
			"options"
		])]));
	}
}), dA = { class: "flex flex-row gap-4 w-full" }, fA = /* @__PURE__ */ f({
	__name: "WeightRangeSelector",
	props: /*@__PURE__*/ b({
		minPlaceholder: {},
		maxPlaceholder: {},
		minSubLabel: {},
		maxSubLabel: {},
		minLabel: {},
		maxLabel: {},
		maxName: {},
		minName: {},
		unit: {},
		units: {},
		minUnitFieldLabel: {},
		maxUnitFieldLabel: {}
	}, {
		min: {},
		minModifiers: {},
		max: {},
		maxModifiers: {}
	}),
	emits: ["update:min", "update:max"],
	setup(e) {
		let t = R(e, "min"), n = R(e, "max");
		return (r, i) => (A(), o("div", dA, [u(L(ux), {
			class: "w-full",
			"label-position": "top"
		}, {
			label: B(() => [u(L(px), { for: e.minName }, {
				sublabel: B(() => [l(I(e.minSubLabel), 1)]),
				default: B(() => [l(I(e.minLabel) + " ", 1)]),
				_: 1
			}, 8, ["for"])]),
			default: B(() => [u(L(uA), {
				modelValue: t.value,
				"onUpdate:modelValue": i[0] ||= (e) => t.value = e,
				class: "grow",
				"empty-value": null,
				label: e.minLabel,
				"label-position": "top",
				name: e.minName,
				placeholder: e.minPlaceholder,
				unit: e.unit,
				"unit-field-label": e.minUnitFieldLabel,
				units: e.units
			}, null, 8, [
				"modelValue",
				"label",
				"name",
				"placeholder",
				"unit",
				"unit-field-label",
				"units"
			])]),
			_: 1
		}), u(L(ux), {
			class: "w-full",
			"label-position": "top"
		}, {
			label: B(() => [u(L(px), { for: e.maxName }, {
				sublabel: B(() => [l(I(e.maxSubLabel), 1)]),
				default: B(() => [l(I(e.maxLabel) + " ", 1)]),
				_: 1
			}, 8, ["for"])]),
			default: B(() => [u(L(uA), {
				modelValue: n.value,
				"onUpdate:modelValue": i[1] ||= (e) => n.value = e,
				class: "grow",
				"empty-value": null,
				label: e.maxLabel,
				"label-position": "top",
				name: e.maxName,
				placeholder: e.maxPlaceholder,
				unit: e.unit,
				"unit-field-label": e.maxUnitFieldLabel,
				units: e.units
			}, null, 8, [
				"modelValue",
				"label",
				"name",
				"placeholder",
				"unit",
				"unit-field-label",
				"units"
			])]),
			_: 1
		})]));
	}
}), pA = { class: "relative" }, mA = [
	"aria-controls",
	"aria-expanded",
	"aria-label"
], hA = { class: "pr-2 flex justify-between w-full" }, gA = { class: "whitespace-nowrap" }, _A = ["aria-label"], vA = { key: 1 }, yA = { class: "text-primary whitespace-nowrap ml-2" }, bA = ["id"], xA = { class: "mt-2" }, SA = /* @__PURE__ */ f({
	__name: "FilterDropdown",
	props: {
		label: {},
		amount: {},
		activeLabel: {},
		hasValue: { type: Boolean }
	},
	emits: ["deleteFilters"],
	setup(e, { emit: t }) {
		let n = t, c = e, { t: d } = Re(), f = () => {
			p.value = !1;
		}, p = M(!1), m = r(() => c.activeLabel ?? c.label), h = () => {
			p.value = !p.value;
		}, g = le(), _ = () => {
			p.value = !1, n("deleteFilters");
		};
		return (t, n) => V((A(), o("div", pA, [s("button", {
			"aria-controls": `listbox-${L(g)}`,
			"aria-expanded": p.value,
			"aria-haspopup": "listbox",
			"aria-label": e.label,
			class: C(["min-w-max bg-white border cursor-pointer flex h-10 items-center justify-between px-3 py-2 rounded-full text-black text-left transition-color w-full", p.value ? "border-black" : "border-gray-400"]),
			role: "combobox",
			tabindex: "0",
			type: "button",
			onClick: h
		}, [s("span", hA, [s("span", gA, I(e.label), 1), e.amount ? (A(), o("span", {
			key: 0,
			"aria-label": L(d)("ui.amountSelected"),
			class: "ml-2 rounded-full text-primary border border-primary text-sm flex text-center justify-center min-w-6 px-0.5 bg-primary/5"
		}, I(e.amount), 9, _A)) : e.hasValue ? (A(), o("span", vA, [s("span", yA, I(m.value), 1)])) : a("", !0)]), u(L(Jp), null, {
			default: B(() => [p.value ? (A(), i(L(gh), { key: 0 })) : a("", !0), p.value ? a("", !0) : (A(), i(L(bh), { key: 1 }))]),
			_: 1
		})], 10, mA), V(s("div", {
			id: `listbox-${L(g)}`,
			class: "absolute bg-white min-w-max px-4 py-3 rounded-regular shadow-[0px_4px_12px_rgba(0,0,0,0.15)] top-[calc(100%+8px)] z-20",
			tabindex: "-1"
		}, [F(t.$slots, "default"), s("div", xA, [u(Dp, {
			class: C({ "text-gray-800 hover:text-gray-800 cursor-default disabled:bg-white disabled:border-none": !e.hasValue }),
			disabled: !e.hasValue,
			size: "none",
			variant: "danger-basic",
			onClick: _
		}, {
			default: B(() => [l(I(L(d)("ui.deleteFilter")), 1)]),
			_: 1
		}, 8, ["class", "disabled"])])], 8, bA), [[he, p.value]])])), [[L(Ee), () => f()]]);
	}
}), CA = /* @__PURE__ */ f({
	__name: "CheckboxFilter",
	props: /*@__PURE__*/ b({ item: {} }, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = e, n = R(e, "modelValue"), a = r(() => t.item.options.map((e) => ({
			...e,
			value: String(e.value)
		}))), o = () => {
			n.value = [];
		};
		return (t, r) => (A(), i(SA, {
			amount: n.value.length,
			"has-value": n.value.length > 0,
			label: e.item.label,
			onDeleteFilters: o
		}, {
			default: B(() => [u(ex, {
				modelValue: n.value,
				"onUpdate:modelValue": r[0] ||= (e) => n.value = e,
				name: e.item.name,
				options: a.value
			}, null, 8, [
				"modelValue",
				"name",
				"options"
			])]),
			_: 1
		}, 8, [
			"amount",
			"has-value",
			"label"
		]));
	}
}), wA = /* @__PURE__ */ f({
	__name: "DateRangeFilter",
	props: /*@__PURE__*/ b({ item: {} }, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let { t } = Re(), n = R(e, "modelValue"), a = (e) => ve(e).format("DD-MM-YYYY"), o = (e) => {
			n.value = {
				from: e,
				to: n.value.to
			};
		}, s = (e) => {
			n.value = {
				from: n.value.from,
				to: e
			};
		}, c = () => {
			n.value = {
				from: null,
				to: null
			};
		}, l = r(() => {
			let e = n.value?.from ? a(n.value.from) : "", r = n.value?.to ? a(n.value.to) : "";
			return e && r ? t("ui.dates.between", {
				from: e,
				to: r
			}) : e ? t("ui.dates.from", { from: e }) : r ? t("ui.dates.to", { to: r }) : "";
		});
		return (r, a) => (A(), i(SA, {
			"active-label": l.value,
			"has-value": !!n.value.from || !!n.value.to,
			label: e.item.label,
			onDeleteFilters: c
		}, {
			default: B(() => [u(FO, {
				"end-date": n.value?.to,
				"from-date": n.value?.from,
				placeholder: L(t)("from"),
				"placeholder-end-date": L(t)("to"),
				"onUpdate:endDate": s,
				"onUpdate:fromDate": o
			}, null, 8, [
				"end-date",
				"from-date",
				"placeholder",
				"placeholder-end-date"
			])]),
			_: 1
		}, 8, [
			"active-label",
			"has-value",
			"label"
		]));
	}
}), TA = /* @__PURE__ */ f({
	__name: "NumberFilter",
	props: /*@__PURE__*/ b({ item: {} }, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = R(e, "modelValue"), n = () => {
			t.value = null;
		};
		return (r, a) => (A(), i(SA, {
			"active-label": String(t.value),
			"has-value": t.value !== null,
			label: e.item.label,
			onDeleteFilters: n
		}, {
			default: B(() => [u(HO, {
				modelValue: t.value,
				"onUpdate:modelValue": a[0] ||= (e) => t.value = e,
				name: e.item.name
			}, null, 8, ["modelValue", "name"])]),
			_: 1
		}, 8, [
			"active-label",
			"has-value",
			"label"
		]));
	}
}), EA = /* @__PURE__ */ f({
	__name: "RadioFilter",
	props: /*@__PURE__*/ b({ item: {} }, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let t = R(e, "modelValue"), n = () => {
			t.value = null;
		};
		return (r, a) => (A(), i(SA, {
			"active-label": e.item.options.find((e) => e.value === t.value)?.label,
			"has-value": !!t.value,
			label: e.item.label,
			onDeleteFilters: n
		}, {
			default: B(() => [u(ok, {
				modelValue: t.value,
				"onUpdate:modelValue": a[0] ||= (e) => t.value = e,
				name: e.item.name,
				options: e.item.options
			}, null, 8, [
				"modelValue",
				"name",
				"options"
			])]),
			_: 1
		}, 8, [
			"active-label",
			"has-value",
			"label"
		]));
	}
}), DA = { class: "flex gap-4 flex-wrap w-max" }, OA = { class: "ml-2 px-1.5 py-.5 rounded-full duration-[inherit] ease-[inherit] text-red border border-red text-sm bg-red/5 group-hover:border-white group-hover:text-white" }, kA = /* @__PURE__ */ f({
	__name: "FilterBar",
	props: /*@__PURE__*/ b({ config: {} }, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(t) {
		let n = t, c = R(t, "modelValue"), { t: u } = Re(), d = r(() => Object.values(c.value).filter((e) => Array.isArray(e) ? e.length > 0 : e && typeof e == "object" && "from" in e && "to" in e ? e.from !== null || e.to !== null : e !== void 0 && e !== "" && e !== null).length), f = () => {
			let e = {}, t = {
				checkbox: [],
				dateRange: {
					from: null,
					to: null
				},
				number: null,
				radio: null
			};
			return n.config.forEach((n) => {
				e[n.name] = t[n.type];
			}), e;
		}, p = () => {
			let e = c.value, t = f();
			Object.keys(e).forEach((n) => {
				n in t || delete e[n], Array.isArray(c.value[n]) && (c.value[n] = c.value[n].map((e) => String(e)));
			}), c.value = {
				...t,
				...e
			};
		}, m = () => {
			c.value = { ...f() };
		};
		return z(() => n.config, () => {
			p();
		}, { immediate: !0 }), (n, r) => (A(), o("div", DA, [(A(!0), o(e, null, P(t.config, (e) => (A(), o("div", {
			key: e.name,
			class: "flex-1 min-w-max md:max-w-1/3"
		}, [
			e.type === "radio" && c.value[e.name] !== void 0 ? (A(), i(EA, {
				key: 0,
				modelValue: c.value[e.name],
				"onUpdate:modelValue": (t) => c.value[e.name] = t,
				item: e
			}, null, 8, [
				"modelValue",
				"onUpdate:modelValue",
				"item"
			])) : a("", !0),
			e.type === "checkbox" && c.value[e.name] !== void 0 ? (A(), i(CA, {
				key: 1,
				modelValue: c.value[e.name],
				"onUpdate:modelValue": (t) => c.value[e.name] = t,
				item: e
			}, null, 8, [
				"modelValue",
				"onUpdate:modelValue",
				"item"
			])) : a("", !0),
			e.type === "number" && c.value[e.name] !== void 0 ? (A(), i(TA, {
				key: 2,
				modelValue: c.value[e.name],
				"onUpdate:modelValue": (t) => c.value[e.name] = t,
				item: e
			}, null, 8, [
				"modelValue",
				"onUpdate:modelValue",
				"item"
			])) : a("", !0),
			e.type === "dateRange" && c.value[e.name] !== void 0 ? (A(), i(wA, {
				key: 3,
				modelValue: c.value[e.name],
				"onUpdate:modelValue": (t) => c.value[e.name] = t,
				item: e
			}, null, 8, [
				"modelValue",
				"onUpdate:modelValue",
				"item"
			])) : a("", !0)
		]))), 128)), d.value > 0 ? (A(), i(Dp, {
			key: 0,
			class: "flex-1 md:max-w-1/3 group",
			variant: "danger-outline",
			onClick: m
		}, {
			default: B(() => [l(I(L(u)("ui.deleteFilters")) + " ", 1), s("span", OA, I(d.value), 1)]),
			_: 1
		})) : a("", !0)]));
	}
}), AA = { class: "flex gap-x-4 mb-4" }, jA = ["textContent"], MA = { class: "text-sm" }, NA = /* @__PURE__ */ f({
	__name: "InfoCard",
	props: { title: {} },
	setup(e) {
		return (t, n) => (A(), i(L(oy), { class: "bg-white gap-y-4 shadow-card" }, {
			default: B(() => [s("div", AA, [u(ap, null, {
				default: B(() => [u(L(An))]),
				_: 1
			}), s("h3", {
				class: "font-bold font-heading",
				textContent: I(e.title)
			}, null, 8, jA)]), s("div", MA, [F(t.$slots, "default")])]),
			_: 3
		}));
	}
}), PA = {
	id: "language-toggle",
	class: "flex flex-col items-center",
	"data-test": "language-toggle"
}, FA = ["aria-hidden", "aria-label"], IA = ["aria-label", "onMouseup"], LA = { class: "flex-1 text" }, RA = ["aria-label"], zA = /* @__PURE__ */ f({
	__name: "LanguageToggle",
	props: {
		direction: {},
		isSidebarCollapsed: { type: Boolean },
		languages: {}
	},
	emits: ["changeLanguage"],
	setup(t, { emit: n }) {
		let { t: r } = Re(), c = de("menuRef"), d = M(!1), f = n, p = (e, t) => {
			d.value = t === void 0 ? !d.value : t, d.value && c.value && c.value.focus();
		}, m = (e) => {
			f("changeLanguage", e), p();
		}, h = () => {
			p(void 0, !1);
		}, g = (e) => {
			e.preventDefault();
		};
		return (n, c) => (A(), o("div", PA, [s("div", {
			ref: "menuRef",
			class: "flex justify-center language-toggle-wrapper w-full z-40",
			tabindex: "-1",
			onBlur: h
		}, [V(s("div", {
			"aria-hidden": !d.value,
			"aria-label": L(r)("ui.languageToggle.label"),
			class: C({
				"absolute bg-white border drop-shadow-lg language-toggle--menu py-4 rounded-lg": !t.isSidebarCollapsed,
				"bottom-16 mb-4": !t.isSidebarCollapsed && t.direction !== "down",
				"top-10 language-toggle--menu--direction-down": !t.isSidebarCollapsed && t.direction === "down"
			})
		}, [s("ul", null, [(A(!0), o(e, null, P(t.languages, (e) => (A(), o("li", {
			key: e.code,
			class: "hover:bg-gray-200 language-toggle--menu--item"
		}, [s("a", {
			"aria-label": L(r)(`locale.${e.code}`),
			class: "flex gap-3 pl-5 pr-4 py-2.5",
			href: "#",
			onMousedown: g,
			onMouseup: (t) => m(e.code)
		}, [u(L(Lv), {
			class: C({ "mt-0.5": t.isSidebarCollapsed }),
			country: e.code
		}, null, 8, ["class", "country"]), s("span", LA, I(L(r)(`locale.${e.code}`)), 1)], 40, IA)]))), 128))])], 10, FA), [[he, d.value || t.isSidebarCollapsed]])], 544), t.isSidebarCollapsed ? a("", !0) : (A(), o("button", {
			key: 0,
			"aria-label": L(r)("ui.languageToggle.open"),
			class: "border duration-150 flex gap-2 hover:bg-gray-200 items-center language-toggle--button pr-3 px-3.5 py-1.5 rounded-full transition-all",
			type: "button",
			onMousedown: g,
			onMouseup: p
		}, [(A(), i(L(Lv), {
			key: L(r)("meta.flag"),
			country: L(r)("meta.flag")
		}, null, 8, ["country"])), l(" " + I(L(r)("meta.shortName")), 1)], 40, RA))]));
	}
}), BA = /* @__PURE__ */ f({
	__name: "Backdrop",
	props: { show: { type: Boolean } },
	emits: ["click"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = (e) => {
			n.show && r("click", e);
		};
		return (t, n) => (A(), o("div", {
			class: C(["absolute bg-black duration-200 ease-in-out h-full left-0 top-0 transition-opacity w-full z-30", {
				"opacity-0 pointer-events-none": !e.show,
				"opacity-50": e.show
			}]),
			"data-test": "backdrop",
			onClick: n[0] ||= (e) => i(e)
		}, null, 2));
	}
}), VA = /* @__PURE__ */ f({
	__name: "CollapseMenuButton",
	props: {
		isCollapsed: { type: Boolean },
		classes: {}
	},
	setup(e) {
		return (t, n) => (A(), o("button", {
			class: C(L(_e)("flex gap-2 hover:bg-gray-200 items-center px-4 py-2", e.classes)),
			type: "button"
		}, [u(ap, { size: 24 }, {
			default: B(() => [e.isCollapsed ? (A(), i(L(Pu), { key: 0 })) : (A(), i(L(Au), { key: 1 }))]),
			_: 1
		})], 2));
	}
}), HA = {};
function UA(e, t) {
	return A(), o("li", null, [...t[0] ||= [s("hr", { class: "my-0.5" }, null, -1)]]);
}
var WA = /*#__PURE__*/ W(HA, [["render", UA]]), GA = { class: "border-l-2 border-transparent flex flex-col hover:bg-gray-200" }, KA = ["href"], qA = {
	key: 1,
	class: "mr-1 w-[24px]"
}, JA = { class: "flex-1" }, YA = /* @__PURE__ */ f({
	__name: "ExternalMenuItem",
	props: {
		item: {},
		hideIcon: { type: Boolean },
		linkClass: {}
	},
	setup(e) {
		return (t, n) => (A(), o("li", GA, [s("a", {
			class: C(["flex gap-2 grow items-center pl-[14px] pr-4 py-2", e.linkClass]),
			href: e.item.href,
			rel: "noopener noreferrer",
			target: "_blank"
		}, [
			e.item.icon && !e.hideIcon ? (A(), i(ap, {
				key: 0,
				class: "mr-1 text-secondary",
				size: 24
			}, {
				default: B(() => [(A(), i(re(e.item.icon)))]),
				_: 1
			})) : e.hideIcon ? a("", !0) : (A(), o("div", qA)),
			s("span", JA, [F(t.$slots, "default")]),
			u(ap, {
				class: "ml-auto text-black-light",
				size: 24
			}, {
				default: B(() => [u(L(Cd))]),
				_: 1
			})
		], 10, KA)]));
	}
}), XA = {
	key: 1,
	class: "mr-1 w-[24px]"
}, ZA = {
	key: 2,
	class: "flex-1 text-left"
}, QA = /* @__PURE__ */ f({
	__name: "InternalMenuItem",
	props: {
		linkComponent: {},
		linkClass: {},
		item: {},
		isActive: { type: Boolean },
		hideIcon: { type: Boolean },
		hideLabel: { type: Boolean }
	},
	setup(e) {
		return (t, n) => (A(), o("li", { class: C(["active-bar flex flex-col hover:bg-gray-200 relative", { "font-bold before:bg-secondary": e.isActive }]) }, [(A(), i(re(e.linkComponent), {
			class: C(["flex gap-2 items-center px-4 py-2 text-left", e.linkClass]),
			to: e.item.to
		}, {
			default: B(() => [e.item.icon && !e.hideIcon ? (A(), i(ap, {
				key: 0,
				class: "mr-1 text-secondary",
				size: 24
			}, {
				default: B(() => [(A(), i(re(e.item.icon)))]),
				_: 1
			})) : e.hideIcon ? a("", !0) : (A(), o("div", XA)), e.hideLabel ? a("", !0) : (A(), o("div", ZA, [F(t.$slots, "default")]))]),
			_: 3
		}, 8, ["class", "to"]))], 2));
	}
}), $A = {
	Internal: "internal",
	External: "external",
	Parent: "parent",
	Divider: "divider"
}, ej = {
	key: 1,
	class: "w-[24px]"
}, tj = /*#__PURE__*/ W(/* @__PURE__ */ f({
	__name: "ParentMenuItemCollapsed",
	props: {
		item: {},
		activeRouteName: {},
		hideIcon: { type: Boolean },
		iconClass: {}
	},
	setup(t) {
		let n = t, [c, l] = Fe(!1), u = r(() => n.item.children.some((e) => e.type === "internal" ? e.to.name === n.activeRouteName || e.activeRouteNameAliases?.includes(n.activeRouteName) : !1)), d = M(), f = M(), { floatingStyles: p } = tt(d, f, {
			placement: "right-start",
			whileElementsMounted: Xe,
			middleware: [
				Ze(),
				$e(),
				et({ padding: 8 })
			]
		});
		return (n, r) => V((A(), o("li", {
			ref_key: "reference",
			ref: d,
			class: "flex flex-col group",
			onMouseleave: r[1] ||= () => L(l)(!1)
		}, [s("button", {
			class: C(["active-bar flex gap-2 hover:bg-gray-200 items-center px-4 py-2 relative", { "before:bg-secondary font-bold": u.value }]),
			type: "button",
			onClick: r[0] ||= () => L(l)()
		}, [t.item.icon && !t.hideIcon ? (A(), i(ap, {
			key: 0,
			class: C(["text-secondary", t.iconClass]),
			size: 24
		}, {
			default: B(() => [(A(), i(re(t.item.icon)))]),
			_: 1
		}, 8, ["class"])) : t.hideIcon ? a("", !0) : (A(), o("div", ej)), F(n.$slots, "label", {}, void 0, !0)], 2), s("ul", {
			ref_key: "floating",
			ref: f,
			class: C([
				"absolute bg-white flex-col group-hover:flex left-full margin-l-4 shadow-[0px_0px_7px_-3px_rgba(0,0,0,0.5)] translate-x-2 w-max z-20",
				"hover-fix",
				"rounded-regular py-2",
				{
					flex: L(c),
					hidden: !L(c)
				}
			]),
			style: T([L(p)])
		}, [(A(!0), o(e, null, P(t.item.children, (t) => (A(), o(e, { key: t.label }, [t.type === "external" ? F(n.$slots, "external-menu-item", { child: t }, void 0, !0, 0) : t.type === "internal" ? F(n.$slots, "internal-menu-item", { child: t }, void 0, !0, 1) : a("", !0)], 64))), 128)), F(n.$slots, "default", {}, void 0, !0)], 6)], 32)), [[L(Ee), () => L(l)(!1)]]);
	}
}), [["__scopeId", "data-v-4984730d"]]), nj = { class: /*@__PURE__*/ C([
	"hide-scrollbar z-10 shadow-[inset_0px_0px_7px_-3px_rgba(0,0,0,0.5)]",
	"bg-gray-100 border-r flex flex-col h-full",
	"justify-between pt-3"
]) }, rj = { class: "flex flex-col gap-2" }, ij = { class: "flex justify-end lg:hidden pr-1" }, aj = {
	key: 0,
	class: "d-flex flex-column"
}, oj = /* @__PURE__ */ f({
	__name: "SideMenuCollapsed",
	props: { menu: {} },
	emits: ["close"],
	setup(t) {
		return (n, r) => (A(), o("nav", nj, [s("ul", rj, [s("li", ij, [u(L(Dp), {
			variant: "none",
			onClick: r[0] ||= (e) => n.$emit("close")
		}, {
			default: B(() => [u(ap, {
				class: "text-black-light",
				size: 24
			}, {
				default: B(() => [u(L(ls))]),
				_: 1
			})]),
			_: 1
		})]), (A(!0), o(e, null, P(t.menu, (t) => (A(), o(e, { key: t.label }, [
			t.type === "parent" ? F(n.$slots, "parent-menu-item", { item: t }, void 0, void 0, 0) : a("", !0),
			t.type === "external" ? F(n.$slots, "external-menu-item", { item: t }, void 0, void 0, 1) : a("", !0),
			t.type === "internal" ? F(n.$slots, "internal-menu-item", { item: t }, void 0, void 0, 2) : a("", !0),
			t.type === "divider" ? F(n.$slots, "divider-menu-item", { item: t }, void 0, void 0, 3) : a("", !0)
		], 64))), 128))]), n.$slots.default ? (A(), o("div", aj, [F(n.$slots, "default")])) : a("", !0)]));
	}
}), sj = {
	key: 1,
	class: "mr-1 w-[24px]"
}, cj = { class: "flex flex-col" }, lj = /* @__PURE__ */ f({
	__name: "ParentMenuItemExpanded",
	props: {
		item: {},
		activeRouteName: {}
	},
	setup(t) {
		let n = t, [c, l] = Fe(!1), d = r(() => n.item.children.some((e) => e.type === "internal" ? e.to.name === n.activeRouteName || e.activeRouteNameAliases?.includes(n.activeRouteName) : !1));
		return z(() => n.activeRouteName, () => {
			d.value && !c.value && l();
		}, { immediate: !0 }), (n, r) => (A(), o(e, null, [s("li", { class: C(["active-bar flex flex-col relative", { "before:bg-secondary font-bold": d.value && !L(c) }]) }, [s("button", {
			class: "flex gap-2 hover:bg-gray-200 items-center px-4 py-2 text-left",
			type: "button",
			onClick: r[0] ||= () => L(l)()
		}, [
			t.item.icon ? (A(), i(ap, {
				key: 0,
				class: "mr-1 text-secondary",
				size: 24
			}, {
				default: B(() => [(A(), i(re(t.item.icon)))]),
				_: 1
			})) : (A(), o("div", sj)),
			F(n.$slots, "default", { item: t.item }),
			u(ap, { class: "ml-auto text-black-light" }, {
				default: B(() => [(A(), i(re(L(c) ? L(Wr) : L(Jr))))]),
				_: 1
			})
		])], 2), V(s("ul", cj, [(A(!0), o(e, null, P(t.item.children, (t) => (A(), o(e, { key: t.label }, [t.type === "external" ? F(n.$slots, "external-menu-item", { child: t }, void 0, void 0, 0) : t.type === "internal" ? F(n.$slots, "internal-menu-item", { child: t }, void 0, void 0, 1) : a("", !0)], 64))), 128))], 512), [[he, L(c)]])], 64));
	}
}), uj = { class: /*@__PURE__*/ C([
	"hide-scrollbar overflow-y-auto shadow-[inset_0px_0px_7px_-3px_rgba(0,0,0,0.5)]",
	"bg-gray-100 border-r flex flex-col h-full",
	"justify-between pt-3"
]) }, dj = { class: "flex flex-col gap-2" }, fj = { class: "flex justify-end lg:hidden pr-1" }, pj = {
	key: 0,
	class: "d-flex flex-column"
}, mj = /* @__PURE__ */ f({
	__name: "SideMenuExpanded",
	props: { menu: {} },
	emits: ["close"],
	setup(t) {
		return (n, r) => (A(), o("nav", uj, [s("ul", dj, [s("li", fj, [u(L(Dp), {
			title: "Close",
			variant: "none",
			onClick: r[0] ||= (e) => n.$emit("close")
		}, {
			default: B(() => [u(ap, {
				class: "text-black-light",
				size: 24
			}, {
				default: B(() => [u(L(ls))]),
				_: 1
			})]),
			_: 1
		})]), (A(!0), o(e, null, P(t.menu, (t) => (A(), o(e, { key: t.label }, [t.type === "parent" ? F(n.$slots, "parent-menu-item", { item: t }, void 0, void 0, 0) : t.type === "internal" ? F(n.$slots, "internal-menu-item", { item: t }, void 0, void 0, 1) : t.type === "external" ? F(n.$slots, "external-menu-item", { item: t }, void 0, void 0, 2) : t.type === "divider" ? F(n.$slots, "divider-menu-item", { item: t }, void 0, void 0, 3) : a("", !0)], 64))), 128))]), n.$slots.default ? (A(), o("div", pj, [F(n.$slots, "default")])) : a("", !0)]));
	}
}), hj = Symbol("stackedBottomSheet"), gj = Symbol("bottomSheetContainer"), _j = {
	ref: "header",
	class: "shrink-0 pt-2"
}, vj = { class: "flex items-center justify-between gap-3 border-b border-gray-400 px-6 pb-3" }, yj = {
	key: 0,
	class: "shrink-0 bg-white px-6 pt-4"
}, bj = {
	key: 1,
	class: "w-full shrink-0 bg-white px-6"
}, xj = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "BottomSheet",
	props: {
		title: {},
		closeButtonText: {},
		bodyClass: {}
	},
	emits: ["close"],
	setup(e, { expose: t, emit: n }) {
		let c = ue(), d = n, f = de("header"), { height: p } = je(f), m = _(gj, null), h = r(() => !!m?.value), g = r(() => m?.value ?? void 0), v = _(hj, null), y = (v?.depth ?? -1) + 1, b = r(() => v?.nextSheetTop.value ?? 16), S = r(() => b.value + p.value);
		j(hj, {
			nextSheetTop: S,
			depth: y
		});
		let w = 40 + y * 20, E = 50 + y * 20, D = M(!1), O = M(0);
		z(D, (e) => {
			e || (d("close"), document.body.style.pointerEvents = "");
		});
		let k = () => {
			O.value += 1, D.value = !0;
		}, te = () => {
			D.value = !1;
		}, N = (e) => {
			h.value && (e.preventDefault(), te());
		};
		return ee(() => {
			D.value && (document.body.style.pointerEvents = "");
		}), t({
			openBottomSheet: k,
			closeBottomSheet: te,
			isOpen: ne(D)
		}), (t, n) => (A(), i(L(qe), {
			key: O.value,
			open: D.value,
			"onUpdate:open": n[0] ||= (e) => D.value = e
		}, {
			default: B(() => [u(L(Ke), { to: g.value }, {
				default: B(() => [u(L(Ge), {
					class: C(["bottom-sheet-overlay inset-0 bg-black/50", h.value ? "absolute" : "fixed"]),
					"data-test": "bottom-sheet-overlay",
					style: T({ zIndex: w })
				}, null, 8, ["class", "style"]), u(L(He), x({
					class: ["bottom-sheet-panel inset-x-0 bottom-0 flex flex-col overflow-clip rounded-t-xl bg-white shadow-lg", h.value ? "absolute bottom-sheet-panel--no-bleed" : "fixed"],
					"data-test": "bottom-sheet-panel",
					style: {
						top: `${b.value}px`,
						zIndex: E
					}
				}, t.$attrs, { onEscapeKeyDown: N }), {
					default: B(() => [
						s("div", _j, [
							u(L(We), {
								class: "mx-auto mb-2 h-1.5 w-11 rounded-full bg-gray-500 md:hidden",
								"data-test": "bottom-sheet-drag-handle"
							}),
							c.title ? (A(), i(L(Je), {
								key: 0,
								class: "sr-only"
							}, {
								default: B(() => [l(I(e.title), 1)]),
								_: 1
							})) : a("", !0),
							s("div", vj, [
								F(t.$slots, "title", {}, () => [u(L(Je), { "as-child": "" }, {
									default: B(() => [u(Bv, {
										class: "flex-1",
										level: "3"
									}, {
										default: B(() => [l(I(e.title), 1)]),
										_: 1
									})]),
									_: 1
								})]),
								u(L(Ue), { class: "sr-only" }, {
									default: B(() => [l(I(e.title), 1)]),
									_: 1
								}),
								u(L(Ve), { "as-child": "" }, {
									default: B(() => [u(Dp, {
										"aria-label": e.closeButtonText,
										class: "flex items-center",
										title: e.closeButtonText,
										variant: "none"
									}, {
										default: B(() => [u(L(Jp), {
											class: "hover:text-secondary stroke-3",
											size: L(Kp).Medium
										}, {
											default: B(() => [u(L(rg))]),
											_: 1
										}, 8, ["size"])]),
										_: 1
									}, 8, ["aria-label", "title"])]),
									_: 1
								})
							])
						], 512),
						c.subheader ? (A(), o("div", yj, [F(t.$slots, "subheader")])) : a("", !0),
						s("div", {
							class: C(L(_e)(["min-h-0 w-full flex-1 overflow-y-auto px-6 py-4", e.bodyClass])),
							"data-test": "bottom-sheet-body"
						}, [F(t.$slots, "default")], 2),
						c.footer ? (A(), o("div", bj, [F(t.$slots, "footer", { closeBottomSheet: te })])) : a("", !0)
					]),
					_: 3
				}, 16, ["class", "style"])]),
				_: 3
			}, 8, ["to"])]),
			_: 3
		}, 8, ["open"]));
	}
}), Sj = {
	key: 0,
	class: "sticky top-0 bg-white px-6 mb-6"
}, Cj = {
	key: 1,
	class: "sticky bottom-0 left-0 w-full bg-white px-6"
}, wj = /* @__PURE__ */ f({
	__name: "SidePanel",
	props: {
		title: {},
		closeButtonText: {},
		bodyClass: {}
	},
	emits: ["close"],
	setup(e, { expose: t, emit: n }) {
		let d = ue(), f = n, p = Pe("(width < 720px)"), m = de("side-panel"), h = de("bottom-sheet"), g = M(!1);
		j(gj, r(() => p.value ? null : m.value));
		let _ = () => {
			if (g.value = !0, p.value) {
				h.value?.openBottomSheet();
				return;
			}
			m.value?.showModal(), window.dispatchEvent(new CustomEvent(up));
		}, v = () => {
			if (p.value) {
				h.value?.closeBottomSheet();
				return;
			}
			m.value?.close();
		};
		z(p, async () => {
			g.value && (await S(), _());
		});
		let y = () => {
			f("close"), g.value = !1;
		};
		return t({
			openSidePanel: _,
			closeSidePanel: v,
			isOpen: ne(g)
		}), (t, n) => L(p) ? (A(), i(xj, {
			key: 0,
			ref: "bottom-sheet",
			"body-class": e.bodyClass,
			"close-button-text": e.closeButtonText,
			title: e.title,
			onClose: y
		}, c({
			default: B(() => [F(t.$slots, "default")]),
			_: 2
		}, [
			d.title ? {
				name: "title",
				fn: B(() => [F(t.$slots, "title")]),
				key: "0"
			} : void 0,
			d.subheader ? {
				name: "subheader",
				fn: B(() => [F(t.$slots, "subheader")]),
				key: "1"
			} : void 0,
			d.footer ? {
				name: "footer",
				fn: B(() => [F(t.$slots, "footer", { closeSidePanel: v })]),
				key: "2"
			} : void 0
		]), 1032, [
			"body-class",
			"close-button-text",
			"title"
		])) : (A(), o("dialog", {
			key: 1,
			ref: "side-panel",
			class: C([
				"right-0 top-0 ml-auto h-full max-h-full",
				"shadow-[inset_1px_0_0_var(--color-gray-200)] pt-6 bg-white",
				"open:flex flex-col overflow-clip",
				"side-panel-transition"
			]),
			closedby: "any",
			"data-test": "side-panel",
			onClose: y
		}, [
			s("div", { class: C(["flex items-center gap-2 px-6", {
				"mb-2": d.subheader,
				"mb-6": !d.subheader
			}]) }, [F(t.$slots, "title", {}, () => [u(Bv, {
				class: "flex-1",
				level: "2"
			}, {
				default: B(() => [l(I(e.title), 1)]),
				_: 1
			})]), u(Dp, {
				"aria-label": e.closeButtonText,
				class: "flex items-center",
				title: e.closeButtonText,
				variant: "none",
				onClick: v
			}, {
				default: B(() => [u(L(Jp), {
					class: "hover:text-secondary stroke-3",
					size: L(Kp).Medium
				}, {
					default: B(() => [u(L(rg))]),
					_: 1
				}, 8, ["size"])]),
				_: 1
			}, 8, ["aria-label", "title"])], 2),
			d.subheader ? (A(), o("div", Sj, [F(t.$slots, "subheader")])) : a("", !0),
			s("div", { class: C(L(_e)(["w-full h-full px-6 overflow-y-auto", e.bodyClass])) }, [F(t.$slots, "default")], 2),
			d.footer ? (A(), o("div", Cj, [F(t.$slots, "footer", { closeSidePanel: v })])) : a("", !0)
		], 544));
	}
}), Tj = { class: "container flex flex-row flex-wrap gap-1" }, Ej = {
	key: 0,
	class: "border-r flex items-center justify-center p-4"
}, Dj = { class: "auto-cols-max divide-x grid grid-flow-col items-center justify-center" }, Oj = /* @__PURE__ */ f({
	__name: "BulkActionBar",
	props: { count: {} },
	setup(t) {
		return (n, r) => (A(), o(e, null, [s("div", x(n.$attrs, { class: "bg-white border-gray-400 border-t bottom-0 fixed z-5 w-full drop-shadow-sm" }), [s("div", Tj, [t.count ? (A(), o("div", Ej, [u(ob, {
			class: "bg-secondary-10 flex font-medium h-6 items-center justify-center px-1.5 py-0.5 text-secondary w-6",
			count: t.count
		}, null, 8, ["count"])])) : a("", !0), s("div", Dj, [F(n.$slots, "default")])])], 16), r[0] ||= s("div", { class: "h-16 w-full" }, null, -1)], 64));
	}
}), kj = ["id"], Aj = { class: "absolute bg-gradient-to-b from-40% from-transparent to-white top-0 w-full h-full" }, jj = /* @__PURE__ */ f({
	__name: "LoadMoreSection",
	props: {
		openText: {},
		closeText: {},
		initialHeight: {}
	},
	setup(t) {
		let [n, r] = Fe(), i = le();
		return (a, c) => (A(), o("div", null, [s("div", {
			id: L(i),
			class: "overflow-hidden relative",
			style: T({ maxHeight: L(n) ? "100%" : t.initialHeight + "px" })
		}, [F(a.$slots, "default"), V(s("div", Aj, null, 512), [[he, !L(n)]])], 12, kj), u(Dp, {
			"aria-controls": L(i),
			"aria-expanded": L(n),
			class: "mt-4 w-full flex gap-2 items-center justify-center",
			variant: "primary-basic",
			onClick: c[0] ||= () => L(r)()
		}, {
			default: B(() => [L(n) ? (A(), o(e, { key: 0 }, [u(L(ze), null, {
				default: B(() => [u(L($h))]),
				_: 1
			}), l(" " + I(t.closeText), 1)], 64)) : (A(), o(e, { key: 1 }, [u(L(ze), null, {
				default: B(() => [u(L(Iv))]),
				_: 1
			}), l(" " + I(t.openText), 1)], 64))]),
			_: 1
		}, 8, ["aria-controls", "aria-expanded"])]));
	}
}), Mj = { class: "flex h-full flex-row" }, Nj = ["aria-label"], Pj = ["aria-label"], Fj = /* @__PURE__ */ f({
	__name: "MasterDetailView",
	props: {
		items: {},
		masterViewAriaLabel: {},
		detailViewAriaLabel: {},
		masterWrapperClass: { default: void 0 },
		detailWrapperClass: { default: void 0 },
		defaultActiveItem: { default: void 0 }
	},
	setup(e) {
		let t = e, n = M();
		z(() => t.defaultActiveItem, () => {
			n.value = t.defaultActiveItem;
		}, { immediate: !0 });
		let r = (e) => {
			n.value = e;
		};
		return (t, i) => (A(), o("div", Mj, [s("nav", {
			"aria-label": e.masterViewAriaLabel,
			class: C(L(_e)(["border-gray-400 overflow-y-auto w-1/4 border-r"], e.masterWrapperClass))
		}, [F(t.$slots, "master", {
			activeItem: n.value,
			items: e.items,
			setActiveDetail: r
		})], 10, Nj), s("section", {
			"aria-label": e.detailViewAriaLabel,
			class: C(L(_e)("flex flex-1 overflow-y-auto w-full flex-col", e.detailWrapperClass))
		}, [F(t.$slots, "detail", {
			item: n.value,
			setActiveDetail: r
		})], 10, Pj)]));
	}
}), Ij = { class: "bg-gray-100 border-b w-full" }, Lj = { class: "flex items-center" }, Rj = { class: "flex flex-col justify-center min-h-[60px] p-4 pt-3" }, zj = { class: "flex flex-row items-center gap-x-2" }, Bj = { class: "font-bold" }, Vj = /* @__PURE__ */ f({
	__name: "PanelHeader",
	props: { label: {} },
	setup(e) {
		return (t, n) => (A(), o("div", Ij, [s("div", Lj, [s("div", Rj, [s("div", zj, [F(t.$slots, "icon"), s("h3", Bj, I(e.label), 1)])]), F(t.$slots, "right")])]));
	}
}), Hj = ["aria-checked"], Uj = {
	key: 0,
	class: "flex items-stretch -my-1"
}, Wj = ["aria-label", "onKeydown"], Gj = {
	key: 0,
	class: "shrink-0 w-6 h-6 mx-1 flex items-center justify-center"
}, Kj = { class: "flex flex-1 flex-col min-w-0" }, qj = { class: "font-bold leading-tight text-left truncate" }, Jj = {
	key: 0,
	class: "text-xs text-gray-600"
}, Yj = {
	key: 1,
	class: "flex items-center px-3"
}, Xj = /* @__PURE__ */ f({
	__name: "PanelItem",
	props: {
		label: {},
		description: { default: void 0 },
		icon: { default: void 0 },
		active: {
			type: Boolean,
			default: !1
		},
		item: { default: void 0 }
	},
	emits: ["select"],
	setup(e, { emit: t }) {
		let n = e, c = t, l = ue(), u = r(() => !!l.indicator), d = r(() => !!l.icon), f = r(() => !!l.action), p = r(() => n.icon ? y(n.icon) : void 0), m = r(() => n.active ? u.value ? "bg-gray-200 active:bg-gray-300" : "active-bar relative bg-gray-200 active:bg-gray-300 before:bg-secondary" : "hover:bg-gray-100 active:bg-gray-200"), h = () => {
			if (n.item) {
				c("select", n.item);
				return;
			}
			c("select");
		};
		return (t, n) => (A(), o("li", {
			"aria-checked": e.active,
			class: C(["border-b border-gray-200 last:border-b-0 flex py-1", m.value]),
			role: "menuitemradio"
		}, [
			u.value ? (A(), o("div", Uj, [F(t.$slots, "indicator")])) : a("", !0),
			s("button", {
				"aria-label": e.description ? `${e.label} ${e.description}` : e.label,
				class: "flex w-full cursor-pointer text-left items-center gap-3 py-6 px-3 min-w-0",
				onClick: h,
				onKeydown: [H(U(h, ["prevent"]), ["enter"]), H(U(h, ["prevent"]), ["space"])]
			}, [d.value ? (A(), o("span", Gj, [F(t.$slots, "icon")])) : p.value ? (A(), i(L(ze), {
				key: 1,
				class: "w-6 h-6 mx-1 shrink-0 flex items-center justify-center",
				size: L(Be).Medium
			}, {
				default: B(() => [(A(), i(re(p.value)))]),
				_: 1
			}, 8, ["size"])) : a("", !0), s("span", Kj, [s("span", qj, I(e.label), 1), e.description ? (A(), o("span", Jj, I(e.description), 1)) : a("", !0)])], 40, Wj),
			f.value ? (A(), o("div", Yj, [F(t.$slots, "action")])) : a("", !0)
		], 10, Hj));
	}
}), Zj = { class: "flex-1 min-h-0 overflow-y-auto" }, Qj = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "MasterDetailPanel",
	setup(e) {
		let { class: t, ...n } = se(), i = r(() => _e("flex h-full flex-col", t));
		return (e, t) => (A(), o("div", x(n, { class: i.value }), [
			F(e.$slots, "header"),
			s("div", Zj, [F(e.$slots, "body")]),
			F(e.$slots, "footer")
		], 16));
	}
}), $j = { class: "relative w-fit" }, eM = { class: "min-w-0 overflow-hidden text-ellipsis whitespace-nowrap" }, tM = [
	"id",
	"aria-activedescendant",
	"aria-labelledby"
], nM = ["id", "onClick"], rM = 500, iM = 16, aM = /* @__PURE__ */ f({
	__name: "MenuButton",
	props: {
		name: {},
		buttonText: {},
		options: {},
		buttonVariant: { default: Sp.None }
	},
	setup(t) {
		let n = t, i = r(() => n.options.map((e) => e.key)), a = r(() => i.value.find((e) => e === n.options[d.value].key)), [c, l] = Fe(), { count: d, ...f } = ke(0, {
			min: 0,
			max: i.value.length - 1
		}), p = (e) => {
			l(!1), e.onClick();
		};
		z(c, (e) => {
			e || f.reset(0);
		});
		let m = () => {
			c.value = !0;
		}, h = () => {
			c.value = !1;
		}, g = () => {
			if (!c.value) {
				m();
				return;
			}
			if (d.value === i.value.length - 1) {
				f.set(0);
				return;
			}
			f.inc(1);
		}, _ = () => {
			if (!c.value) {
				m(), f.set(i.value.length - 1);
				return;
			}
			if (d.value === 0) {
				f.set(i.value.length - 1);
				return;
			}
			f.dec(1);
		}, v = () => {
			if (!c.value) {
				m();
				return;
			}
			p(n.options[d.value]);
		}, y = () => {
			c.value && h();
		}, b = () => {
			c.value && f.set(0);
		}, x = () => {
			c.value && f.set(i.value.length - 1);
		}, S = M([]), w = M(""), E = null, D = () => {
			E = setTimeout(() => {
				S.value = [];
			}, rM);
		}, O = (e, t) => {
			let n = t.find((n) => n.key === t[e].key);
			/* c8 ignore next 3 - should not be possible to be undefined but for safety return */
			if (!n) return;
			let r = i.value.findIndex((e) => e === n.key);
			f.set(r);
		}, k = (e) => {
			if (!c.value || !(e.key.length === 1 && e.key.match(/[a-z]|[0-9]/i))) return;
			if (E && clearTimeout(E), D(), S.value.push(e.key), w.value === e.key) {
				let e = n.options.filter((e) => e.label.toLowerCase().startsWith(w.value.toLowerCase()));
				if (e.length === 1 || e.length === 0) return;
				let t = e.find((e) => e.key === a.value);
				/* c8 ignore next 3 - should not be possible to be undefined but for safety return */
				if (!t) return;
				let r = e.findIndex((e) => e.key === t.key);
				if (r === e.length - 1) {
					O(0, e);
					return;
				}
				O(r + 1, e);
			}
			let t = S.value.join("").toLowerCase(), r = n.options.find((e) => e.label.toLowerCase().startsWith(t));
			if (!r) return;
			let o = i.value.indexOf(r.key);
			f.set(o), w.value = e.key;
		}, ee = M(), j = M(), te = M(), { floatingStyles: ne, middlewareData: N } = tt(ee, j, {
			placement: "bottom-start",
			whileElementsMounted: Xe,
			middleware: [
				Ye({ element: te }),
				Qe(8),
				Ze(),
				$e(),
				et({ padding: iM })
			]
		}), F = r(() => ({
			left: N.value.arrow?.x == null ? "" : `${N.value.arrow.x}px`,
			top: N.value.arrow?.y == null ? "-6.75px" : `${N.value.arrow.y}px`
		}));
		/* c8 ignore stop */
		return (n, r) => V((A(), o("div", $j, [u(L(Dp), {
			id: `${t.name}-menu-button-button`,
			ref_key: "reference",
			ref: ee,
			"aria-controls": `${t.name}-menu-button-menu`,
			"aria-expanded": L(c),
			"aria-haspopup": "true",
			class: "flex focus-within:ring-2 gap-2 items-center max-w-full ring-blue-600",
			type: "button",
			variant: t.buttonVariant,
			onClick: r[0] ||= () => L(l)(),
			onKeydown: [
				H(U(g, ["exact", "prevent"]), ["down"]),
				H(U(x, ["exact", "prevent"]), ["end"]),
				H(U(v, ["exact", "prevent"]), ["enter"]),
				H(U(y, ["exact", "prevent"]), ["escape"]),
				H(U(b, ["exact", "prevent"]), ["home"]),
				H(U(_, ["exact", "prevent"]), ["up"]),
				U(k, ["stop"])
			]
		}, {
			default: B(() => [s("span", eM, I(t.buttonText), 1), u(L(op), {
				"aria-hidden": "true",
				"is-open": L(c)
			}, null, 8, ["is-open"])]),
			_: 1
		}, 8, [
			"id",
			"aria-controls",
			"aria-expanded",
			"variant",
			"onKeydown"
		]), V(s("ul", {
			id: `${t.name}-menu-button-menu`,
			ref_key: "floating",
			ref: j,
			"aria-activedescendant": L(c) ? `option-${i.value[L(d)]}` : void 0,
			"aria-labelledby": `${t.name}-menu-button-button`,
			class: "absolute bg-white border drop-shadow-lg py-2 rounded-regular w-max z-20",
			role: "menu",
			style: T([L(ne)]),
			tabindex: "-1"
		}, [s("div", {
			ref_key: "floatingArrow",
			ref: te,
			class: "absolute bg-white border-l border-t border-gray h-3 rotate-45 transform w-3 z-30",
			style: T(F.value)
		}, null, 4), (A(!0), o(e, null, P(t.options, (e, n) => (A(), o("li", {
			id: `${t.name}-option-${e.key}`,
			key: e.key,
			class: C(["active-bar active:bg-primary active:text-white border-y cursor-pointer hover:bg-gray-200 px-5 py-2 relative text-black text-center", {
				"border-transparent": L(d) !== n,
				"border-gray": L(d) === n,
				"before:bg-secondary": e.active
			}]),
			role: "menuitem",
			onClick: () => p(e)
		}, I(e.label), 11, nM))), 128))], 12, tM), [[he, L(c)]])])), [[L(Ee), () => L(l)(!1)]]);
	}
}), oM = /* @__PURE__ */ f({
	__name: "MyParcelShopLogo",
	setup(e) {
		return (e, t) => (A(), i(L(ze), {
			"data-test": "myparcel-shop-logo",
			size: L(Be).Medium,
			viewbox: "0 0 152 152"
		}, {
			default: B(() => [u(L(Xm))]),
			_: 1
		}, 8, ["size"]));
	}
}), sM = { key: 0 }, cM = { class: "content flex flex-col grow" }, lM = { class: "empty:hidden font-bold" }, uM = { class: "body" }, dM = /*#__PURE__*/ W(/* @__PURE__ */ f({
	__name: "Toast",
	props: {
		id: {},
		variant: {},
		timeout: { default: 6e3 },
		size: { default: Ny.Full },
		canClose: { type: Boolean },
		withShadow: { type: Boolean }
	},
	emits: ["remove"],
	setup(e, { emit: t }) {
		ce((e) => ({ v2545d458: l.value }));
		let n = e, c = t;
		n.timeout && setTimeout(() => {
			c("remove", n.id);
		}, n.timeout);
		/* c8 ignore next - computed inner fn invoked via Vue's useCssVars, which happy-dom does not trigger in tests */
		let l = r(() => `${n.timeout}ms`), d = r(() => n.variant === My.Info), f = r(() => n.variant === My.Error), p = r(() => n.variant === My.Warning), m = r(() => n.variant === My.Success);
		return (t, n) => (A(), o("div", {
			"aria-atomic": "true",
			"aria-live": "polite",
			class: C(["border border-gray-400 flex items-center mb-4 md:text-base overflow-hidden p-4 pointer-events-auto relative rounded-lg transform-gpu", {
				"drop-shadow-md": e.withShadow,
				"pb-5!": !!e.timeout,
				"md:min-w-[400px] md:max-w-3xl md:min-h-[56px]": e.size === L(Ny).Half,
				"bg-green-100": m.value,
				"bg-blue-100": d.value,
				"bg-yellow-100": p.value,
				"bg-red-100": f.value
			}]),
			"data-test": "toast",
			role: "status"
		}, [
			e.timeout ? (A(), o("div", sM, [s("div", { class: C(["absolute bottom-0 h-1 left-0 origin-left toast__timer w-full", {
				"bg-blue": d.value,
				"bg-green": m.value,
				"bg-yellow": p.value,
				"bg-red": f.value
			}]) }, null, 2), s("div", { class: C(["absolute bottom-0 h-1 left-0 opacity-20 w-full", {
				"bg-blue": d.value,
				"bg-green": m.value,
				"bg-yellow": p.value,
				"bg-red": f.value
			}]) }, null, 2)])) : (A(), o("div", {
				key: 1,
				class: C(["absolute h-full left-0 top-0 w-1", {
					"bg-blue": d.value,
					"bg-green": m.value,
					"bg-yellow": p.value,
					"bg-red": f.value
				}])
			}, null, 2)),
			s("div", { class: C(["flex-none pr-4", {
				"text-blue": d.value,
				"text-green": m.value,
				"text-yellow": p.value,
				"text-red": f.value
			}]) }, [u(ap, { size: L(np).Normal }, {
				default: B(() => [
					d.value ? (A(), i(Mt, { key: 0 })) : a("", !0),
					f.value ? (A(), i(zn, { key: 1 })) : a("", !0),
					p.value ? (A(), i(zn, { key: 2 })) : a("", !0),
					m.value ? (A(), i(zd, { key: 3 })) : a("", !0)
				]),
				_: 1
			}, 8, ["size"])], 2),
			s("div", cM, [s("div", lM, [F(t.$slots, "title", {}, void 0, !0)]), s("div", uM, [F(t.$slots, "default", {}, void 0, !0)])]),
			e.canClose ? (A(), o("button", {
				key: 2,
				class: "button close flex-none pl-4",
				type: "button",
				onClick: n[0] ||= (n) => t.$emit("remove", e.id)
			}, [u(ap, {
				class: "cursor-pointer",
				size: L(np).Normal
			}, {
				default: B(() => [u(ps)]),
				_: 1
			}, 8, ["size"])])) : a("", !0)
		], 2));
	}
}), [["__scopeId", "data-v-c315e04e"]]), fM = /* @__PURE__ */ f({
	__name: "Notification",
	props: {
		id: {},
		variant: {},
		canClose: { type: Boolean },
		withShadow: { type: Boolean }
	},
	emits: ["remove"],
	setup(e, { emit: t }) {
		let n = t, r = M(!0), o = () => {
			r.value = !1, n("remove");
		};
		return (t, n) => r.value ? (A(), i(dM, {
			key: 0,
			id: e.id,
			"can-close": e.canClose,
			class: "relative",
			"data-test": "notification",
			timeout: 0,
			variant: e.variant,
			"with-shadow": e.withShadow,
			onRemove: o
		}, {
			title: B(() => [F(t.$slots, "title")]),
			default: B(() => [F(t.$slots, "default")]),
			_: 3
		}, 8, [
			"id",
			"can-close",
			"variant",
			"with-shadow"
		])) : a("", !0);
	}
}), pM = /* @__PURE__ */ f({
	__name: "PackageTypeIcon",
	props: { packageTypeId: {} },
	setup(e) {
		let t = e, n = ie(), r = () => {
			switch (t.packageTypeId) {
				case eb.Package:
				case nb.PACKAGE: return um;
				case eb.Mailbox:
				case nb.MAILBOX: return fv;
				case eb.DigitalStamp:
				case nb.DIGITAL_STAMP: return cv;
				case eb.Letter:
				case nb.UNFRANKED: return km;
				case eb.Envelope:
				case nb.ENVELOPE: return Z_;
				case eb.Pallet:
				case nb.PALLET: return tv;
				case eb.PackageSmall:
				case nb.SMALL_PACKAGE: return av;
				default: return Mm;
			}
		};
		return z(() => t.packageTypeId, () => {
			n.value = r();
		}, { immediate: !0 }), (e, t) => (A(), i(L(Jp), { size: L(Kp).Medium }, {
			default: B(() => [(A(), i(re(n.value)))]),
			_: 1
		}, 8, ["size"]));
	}
}), mM = ["aria-label"], hM = [
	"aria-label",
	"disabled",
	"tabindex"
], gM = [
	"aria-current",
	"aria-hidden",
	"aria-label",
	"tabindex",
	"onClick",
	"onKeyup"
], _M = [
	"aria-label",
	"disabled",
	"tabindex"
], vM = /* @__PURE__ */ f({
	__name: "Pagination",
	props: {
		page: {},
		size: {},
		results: {},
		pageText: {},
		previousText: {},
		nextText: {},
		title: {}
	},
	emits: ["page"],
	setup(t, { emit: n }) {
		let i = t, c = M(), l = M(), d = n, f = r(() => i.page > 1), p = r(() => c.value && i.page < c.value), m = (e) => e === "-", h = (e) => {
			e !== "-" && d("page", e);
		};
		return ge(() => {
			c.value = Math.ceil(i.results / i.size), c.value < 9 ? l.value = Array.from({ length: c.value }, (e, t) => t + 1) : i.page < 5 ? l.value = [
				1,
				2,
				3,
				4,
				5,
				6,
				"-",
				c.value
			] : i.page > c.value - 4 ? l.value = [
				1,
				"-",
				c.value - 5,
				c.value - 4,
				c.value - 3,
				c.value - 2,
				c.value - 1,
				c.value
			] : l.value = [
				1,
				"-",
				i.page - 1,
				i.page,
				i.page + 1,
				"-",
				c.value
			];
		}), (n, r) => c.value ? (A(), o("nav", {
			key: 0,
			"aria-label": t.title,
			class: "flex font-body"
		}, [
			s("div", {
				"aria-label": t.previousText,
				class: C(["bg-white border px-3 py-1.5 rounded-l-lg", {
					"text-secondary cursor-pointer hover:bg-gray-200": f.value,
					"text-gray-800 cursor-not-allowed": t.page <= 1
				}]),
				disabled: !f.value || void 0,
				role: "button",
				tabindex: f.value ? 0 : -1,
				onClick: r[0] ||= (e) => f.value ? h(t.page - 1) : void 0,
				onKeyup: r[1] ||= H(U((e) => h(t.page - 1), ["exact"]), ["enter"])
			}, [u(ap, { class: "-scale-x-100" }, {
				default: B(() => [s("title", null, I(t.previousText), 1), u(Ir)]),
				_: 1
			})], 42, hM),
			(A(!0), o(e, null, P(l.value, (e) => (A(), o("div", {
				key: e,
				"aria-current": e === t.page ? "page" : void 0,
				"aria-hidden": m(e) ? !0 : void 0,
				"aria-label": `${t.pageText} ${e}`,
				class: C(["border-r border-y min-w-[30px] px-1 py-1.5 text-center", {
					"bg-primary-200 text-white active": e === t.page,
					"text-secondary": e !== t.page,
					"cursor-text": m(e),
					"cursor-pointer hover:bg-gray-200": !m(e) && e !== t.page
				}]),
				role: "button",
				tabindex: m(e) ? -1 : 0,
				onClick: (t) => h(e),
				onKeyup: H(U((t) => h(e), ["exact"]), ["enter"])
			}, I(e), 43, gM))), 128)),
			s("div", {
				"aria-label": t.nextText,
				class: C(["bg-white border-r border-y px-3 py-1.5 rounded-r-lg", {
					"text-secondary cursor-pointer hover:bg-gray-200": p.value,
					"text-gray-800 cursor-not-allowed": t.page >= c.value
				}]),
				disabled: !p.value || void 0,
				role: "button",
				tabindex: p.value ? 0 : -1,
				onClick: r[2] ||= (e) => p.value ? h(t.page + 1) : void 0,
				onKeyup: r[3] ||= H(U((e) => h(t.page + 1), ["exact"]), ["enter"])
			}, [u(ap, null, {
				default: B(() => [s("title", null, I(t.nextText), 1), u(Ir)]),
				_: 1
			})], 42, _M)
		], 8, mM)) : a("", !0);
	}
}), yM = /* @__PURE__ */ f({
	__name: "LoadMore",
	props: { label: {} },
	emits: ["loadMore"],
	setup(e) {
		let { t } = Re();
		return (n, r) => (A(), i(L(Dp), {
			class: "block mx-auto mt-2",
			size: "medium",
			variant: "secondary-outline",
			onClick: r[0] ||= (e) => n.$emit("loadMore", e)
		}, {
			default: B(() => [l(I(e.label ? L(t)("ui.loadMoreWithLabel", { label: e.label }) : L(t)("ui.loadMore")), 1)]),
			_: 1
		}));
	}
}), bM = { class: "flex flex-col h-full" }, xM = {
	key: 0,
	class: "flex justify-center items-center h-full"
}, SM = /* @__PURE__ */ f({
	__name: "PrefetchWrapper",
	props: { callables: {} },
	emits: ["finished"],
	setup(e, { emit: t }) {
		let n = e, r = t, i = M(!0), a = async (e) => Promise.all(e.map((e) => Array.isArray(e) ? a(e) : e()));
		return O(async () => {
			try {
				await a(n.callables);
			} finally {
				i.value = !1, r("finished");
			}
		}), (e, t) => (A(), o("div", bM, [F(e.$slots, "default", { isLoading: i.value }), i.value ? (A(), o("div", xM, [u(Ap)])) : F(e.$slots, "loaded", {}, void 0, void 0, 1)]));
	}
}), CM = {
	Primary: "primary",
	Secondary: "secondary",
	Success: "success",
	Warning: "warning",
	Info: "info",
	Danger: "danger"
}, wM = { class: "relative h-1 w-full overflow-hidden rounded-full" }, TM = ["max", "value"], EM = /*#__PURE__*/ W(/* @__PURE__ */ f({
	__name: "ProgressBar",
	props: {
		value: {},
		max: {},
		strokes: { default: 0 },
		variant: { default: CM.Primary }
	},
	setup(e) {
		let t = e, n = {
			[CM.Primary]: "var(--color-primary)",
			[CM.Secondary]: "var(--color-secondary)",
			[CM.Success]: "var(--color-green)",
			[CM.Warning]: "var(--color-yellow)",
			[CM.Info]: "var(--color-blue)",
			[CM.Danger]: "var(--color-red)"
		}, i = r(() => n[t.variant]);
		return (t, n) => (A(), o("div", wM, [s("progress", {
			class: "block h-full w-full",
			max: Math.max(1, e.max),
			style: T({ "--progress-color": i.value }),
			value: Math.max(0, e.value)
		}, null, 12, TM), e.strokes > 0 ? (A(), o("div", {
			key: 0,
			class: "progress-bar__strokes pointer-events-none absolute inset-0",
			"data-test": "progress-bar-strokes",
			style: T({ "--strokes": e.strokes })
		}, null, 4)) : a("", !0)]));
	}
}), [["__scopeId", "data-v-92a1982b"]]), DM = /* @__PURE__ */ f({
	__name: "Skeleton",
	setup(e) {
		let t = se();
		return (e, n) => (A(), o("div", {
			"aria-busy": "true",
			"aria-live": "off",
			class: C(L(_e)("animate-pulse transform-gpu rounded-full bg-gray-200", L(t).class)),
			role: "status"
		}, null, 2));
	}
}), OM = { class: "text-gray-900" }, kM = /* @__PURE__ */ f({
	__name: "SkeletonField",
	props: {
		type: {},
		name: {},
		label: {},
		hideLabel: { type: Boolean },
		sublabel: {},
		note: {},
		skeletonStyle: {},
		preserveLabelGap: { type: Boolean }
	},
	setup(e) {
		let t = e, n = r(() => {
			switch (t.type) {
				case "text":
				case "checkbox":
				case "radio": return "h-6";
				case "input": return "h-[42px]";
				default: return "h-6";
			}
		});
		return (t, r) => (A(), i(ux, {
			class: "w-full",
			"hide-label": e.hideLabel,
			"preserve-label-gap": e.preserveLabelGap
		}, c({
			default: B(() => [u(DM, { class: C(["w-full", [n.value, e.skeletonStyle]]) }, null, 8, ["class"])]),
			_: 2
		}, [e.hideLabel ? void 0 : {
			name: "label",
			fn: B(() => [u(px, { id: e.name }, c({
				default: B(() => [l(I(e.label) + " ", 1)]),
				_: 2
			}, [e.sublabel ? {
				name: "sublabel",
				fn: B(() => [s("span", OM, I(e.sublabel), 1)]),
				key: "0"
			} : void 0]), 1032, ["id"])]),
			key: "0"
		}]), 1032, ["hide-label", "preserve-label-gap"]));
	}
}), AM = /* @__PURE__ */ f({
	__name: "SkeletonRectangle",
	props: {
		height: { default: void 0 },
		width: { default: "w-full" }
	},
	setup(e) {
		let t = se();
		return (n, r) => (A(), i(DM, { class: C([L(_e)(e.width, e.height, L(t).class)]) }, null, 8, ["class"]));
	}
}), jM = /* @__PURE__ */ f({
	__name: "SocialIcon",
	props: { name: {} },
	setup(e) {
		let t = (e) => {
			switch (e) {
				case wy.Facebook: return y(n_);
				case wy.Instagram: return y(Ov);
				case wy.Twitter: return y(fh);
				case wy.Linkedin: return y(Mv);
				case wy.Youtube: return y(dg);
				case wy.Tiktok: return y(bv);
			}
		};
		return (n, r) => t(e.name) ? (A(), i(L(Jp), {
			key: 0,
			"aria-label": e.name
		}, {
			default: B(() => [(A(), i(re(t(e.name))))]),
			_: 1
		}, 8, ["aria-label"])) : a("", !0);
	}
}), MM = { class: "flex gap-2 justify-center text-white" }, NM = /* @__PURE__ */ f({
	__name: "SocialLinks",
	props: { socialLinks: {} },
	setup(t) {
		let n = t, a = {
			facebook: "https://facebook.com/",
			twitter: "https://x.com/",
			linkedin: "https://linkedin.com/company/",
			instagram: "https://www.instagram.com/",
			youtube: "https://www.youtube.com/@",
			tiktok: "https://www.tiktok.com/@"
		}, s = r(() => Object.entries(n.socialLinks).filter(([, e]) => e).map(([e, t]) => ({
			social: e,
			url: a[e] + t
		})));
		return (t, n) => (A(), o("div", MM, [(A(!0), o(e, null, P(s.value, (e) => (A(), i(L(vb), {
			key: e.social,
			href: e.url,
			variant: L(mb).Social
		}, {
			default: B(() => [u(L(jM), { name: e.social }, null, 8, ["name"])]),
			_: 2
		}, 1032, ["href", "variant"]))), 128))]));
	}
}), PM = {
	Clear: "clear",
	Danger: "danger",
	DangerLight: "danger-light",
	Info: "info",
	InfoLight: "info-light",
	Muted: "muted",
	MutedLight: "muted-light",
	Primary: "primary",
	PrimaryLight: "primary-light",
	Secondary: "secondary",
	SecondaryLight: "secondary-light",
	Success: "success",
	SuccessLight: "success-light",
	Warning: "warning",
	WarningLight: "warning-light"
}, FM = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "StatusIndicator",
	props: { variant: {} },
	setup(e) {
		let t = e, { class: n, ...i } = se(), a = {
			[PM.Clear]: "bg-transparent",
			[PM.Danger]: "bg-red",
			[PM.DangerLight]: "bg-red-100",
			[PM.Info]: "bg-blue",
			[PM.InfoLight]: "bg-blue-100",
			[PM.Muted]: "bg-gray-300",
			[PM.MutedLight]: "bg-gray-200",
			[PM.Primary]: "bg-primary",
			[PM.PrimaryLight]: "bg-primary-100",
			[PM.Secondary]: "bg-secondary",
			[PM.SecondaryLight]: "bg-secondary-100",
			[PM.Success]: "bg-green",
			[PM.SuccessLight]: "bg-green-100",
			[PM.Warning]: "bg-yellow",
			[PM.WarningLight]: "bg-[#FEF5D9]"
		}, s = r(() => _e(a[t.variant], n));
		return (e, t) => (A(), o("div", x({
			"aria-hidden": "true",
			class: "w-1 h-full"
		}, i, { class: s.value }), null, 16));
	}
}), IM = /* @__PURE__ */ f({
	__name: "Body",
	props: { borderless: { type: Boolean } },
	setup(e) {
		return (t, n) => (A(), o("div", {
			class: C(["col-span-full grid grid-cols-subgrid", { "divide-solid divide-y": !e.borderless }]),
			role: "rowgroup"
		}, [F(t.$slots, "default")], 2));
	}
}), LM = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "Cell",
	setup(e) {
		return (e, t) => (A(), o("div", {
			class: C(["break-words", L(_e)("p-2.5 w-full rounded-b", e.$attrs.class)]),
			role: "cell"
		}, [F(e.$slots, "default")], 2));
	}
}), RM = /* @__PURE__ */ f({
	__name: "Sort",
	props: { order: {} },
	setup(e) {
		return (t, n) => (A(), i(ap, {
			class: "align-middle inline-block overflow-visible",
			height: "12",
			viewbox: "0 0 8 12",
			width: "8"
		}, {
			default: B(() => [u(L(Qa), { class: C({ "text-icon-sort": e.order === L(Py).Asc }) }, null, 8, ["class"]), u(L(Ja), { class: C({ "text-icon-sort": e.order === L(Py).Desc }) }, null, 8, ["class"])]),
			_: 1
		}));
	}
}), zM = ["aria-sort"], BM = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "ColumnHeader",
	props: {
		withSorting: { type: Boolean },
		sort: {},
		sortOrder: {}
	},
	emits: ["click"],
	setup(e, { emit: t }) {
		let n = e, s = t, c = {
			[Py.Asc]: "ascending",
			[Py.Desc]: "descending"
		}, l = (e) => e ? c[e] : "none", u = r(() => n.sort ? n.sort === "ascending" ? Py.Asc : n.sort === "descending" ? Py.Desc : void 0 : n.sortOrder === null ? void 0 : n.sortOrder);
		return (t, n) => (A(), o("div", {
			"aria-sort": e.sort ? e.sort : l(e.sortOrder),
			class: C(L(_e)("lg:text-base p-2.5 text-black text-sm w-full whitespace-nowrap flex items-center", t.$attrs.class, { "cursor-pointer": e.withSorting })),
			role: "columnheader",
			onClick: n[0] ||= (e) => s("click", e)
		}, [F(t.$slots, "default"), e.withSorting ? (A(), i(RM, {
			key: 0,
			class: "ml-1.5",
			order: u.value
		}, null, 8, ["order"])) : a("", !0)], 10, zM));
	}
}), VM = {
	key: 0,
	class: "font-normal text-black"
}, HM = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "Header",
	props: {
		hasTabs: { type: Boolean },
		useTableSorting: {},
		columns: {}
	},
	setup(t) {
		let n = t, r = se(), { t: s } = Re(), c = (e) => e.sortable ? e.sortKey : e.name, l = (e) => {
			e.sortable && u && u(e.sortKey);
		}, { sortByColumn: u, sorters: d } = n.useTableSorting && n.columns ? rt(n.useTableSorting.name, ((e) => e.reduce((e, t) => (t.sortable && (e[t.sortKey] = t.defaultSortOrder ?? null), e), {}))(n.columns), n.useTableSorting.sortOptions) : {
			sortByColumn: void 0,
			sorters: M({})
		};
		return (n, u) => (A(), o("div", {
			class: C(L(_e)("col-span-full grid grid-cols-subgrid bg-gray-100 border-b grid-flow-col h-11 rounded-tr-lg w-full rounded-tl-lg", { "rounded-tl-none": t.hasTabs }, L(r).class)),
			role: "rowgroup"
		}, [t.columns ? (A(!0), o(e, { key: 0 }, P(t.columns, (e) => (A(), i(BM, {
			key: c(e),
			class: C(e.colSpan ? `col-span-${e.colSpan}` : ""),
			"sort-order": e.sortable ? L(d)[e.sortKey] : null,
			"with-sorting": e.sortable && !!t.useTableSorting,
			onClick: (t) => l(e)
		}, {
			default: B(() => [F(n.$slots, `header:${c(e)}`, x({ ref_for: !0 }, e), () => [e.header ? (A(), o("span", VM, I(L(s)(e.header.translationKey)), 1)) : a("", !0)])]),
			_: 2
		}, 1032, [
			"class",
			"sort-order",
			"with-sorting",
			"onClick"
		]))), 128)) : a("", !0), F(n.$slots, "default")], 2));
	}
}), UM = ["aria-rowindex"], WM = /* @__PURE__ */ f({
	__name: "Row",
	props: {
		index: {},
		border: { type: Boolean },
		highlight: { type: Boolean }
	},
	setup(e) {
		return (t, n) => (A(), o("div", {
			"aria-rowindex": e.index,
			class: C(["col-span-full grid grid-cols-subgrid", {
				"border-b border-gray-400 last:border-b-0": e.border,
				"animate-blink": e.highlight
			}]),
			role: "row"
		}, [F(t.$slots, "default")], 10, UM));
	}
}), GM = /* @__PURE__ */ f({
	__name: "ColoredRow",
	props: {
		color: {},
		index: {},
		highlight: { type: Boolean }
	},
	setup(e) {
		let t = {
			Yellow: "yellow",
			Red: "red",
			Gray: "gray",
			Green: "green",
			White: "white"
		}, n = e, a = r(() => n.color === t.Gray), o = r(() => n.color === t.Green), s = r(() => n.color === t.Red), c = r(() => n.color === t.Yellow);
		return (t, n) => (A(), i(WM, {
			class: C({
				"border-l-[5px] border-x-transparent ": e.highlight,
				"bg-green-100! border-x-green!": o.value,
				"bg-gray-100! border-x-gray!": a.value,
				"bg-red-100! border-x-red!": s.value,
				"bg-yellow-100! border-x-yellow!": c.value
			}),
			index: e.index
		}, {
			default: B(() => [F(t.$slots, "default")]),
			_: 3
		}, 8, ["class", "index"]));
	}
}), KM = [
	"aria-controls",
	"aria-expanded",
	"name"
], qM = /* @__PURE__ */ f({
	__name: "RowToggle",
	props: {
		name: {},
		expanded: { type: Boolean },
		openLabel: {},
		closeLabel: {}
	},
	emits: ["click"],
	setup(e) {
		return (t, n) => (A(), o("button", {
			"aria-controls": `row-toggle-control-${e.name}`,
			"aria-expanded": e.expanded ? "true" : "false",
			class: "cursor-pointer flex items-center text-left w-min",
			name: `row-toggle-${e.name}`,
			type: "button",
			onClick: n[0] ||= (e) => t.$emit("click")
		}, [u(op, {
			"aria-label": e.expanded ? e.closeLabel : e.openLabel,
			"is-open": e.expanded
		}, null, 8, ["aria-label", "is-open"])], 8, KM));
	}
}), JM = /* @__PURE__ */ f({
	__name: "TabCount",
	props: { isActive: { type: Boolean } },
	setup(e) {
		return (t, n) => (A(), o("span", { class: C(["bg-gray-200 rounded-full min-w-6 h-6 px-1.5 flex items-center justify-center text-xs ml-2 border border-gray-300", { "text-primary opacity-100": e.isActive }]) }, [F(t.$slots, "default")], 2));
	}
}), YM = ["aria-selected"], XM = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "Tab",
	props: {
		isActive: { type: Boolean },
		withCount: { type: Boolean },
		amount: {},
		alwaysShowCount: { type: Boolean }
	},
	setup(e) {
		let t = e, n = r(() => t.amount === void 0 ? void 0 : ye.number.formatCompactNumber(t.amount)), s = se(), c = r(() => {
			let { class: e, ...t } = s;
			return t;
		});
		return (t, r) => (A(), o("button", x(c.value, {
			"aria-selected": e.isActive,
			class: L(_e)({
				"bg-white border-x text-primary font-semibold": e.isActive,
				"bg-gray-100 text-black-light": !e.isActive
			}, "flex items-center border-y first:border-l first:rounded-l-md last:border-r last:rounded-r-md lg:border-b-0 lg:first:rounded-bl-none lg:last:rounded-br-none px-4 h-10 text-sm", L(s).class),
			role: "tab",
			type: "button"
		}), [F(t.$slots, "default"), e.withCount && (e.isActive || e.alwaysShowCount) ? (A(), i(JM, {
			key: 0,
			"is-active": !!e.isActive
		}, {
			default: B(() => [l(I(n.value), 1)]),
			_: 1
		}, 8, ["is-active"])) : a("", !0)], 16, YM));
	}
}), ZM = ["aria-rowcount"], QM = /* @__PURE__ */ f({
	inheritAttrs: !1,
	__name: "Table",
	props: {
		hasTabs: { type: Boolean },
		useTableSorting: {},
		columns: {},
		rowCount: {}
	},
	setup(e) {
		let t = (e) => e.sortable ? e.sortKey : e.name, n = se(), s = r(() => {
			let { class: e, ...t } = n;
			return t;
		});
		return (n, r) => (A(), o("div", x(s.value, {
			"aria-rowcount": e.rowCount,
			class: L(_e)("border rounded-lg w-full grid", { "rounded-tl-none!": e.hasTabs }, n.$attrs.class),
			role: "table"
		}), [
			e.columns?.length ? (A(), i(HM, {
				key: 0,
				columns: e.columns,
				"has-tabs": e.hasTabs,
				"use-table-sorting": e.useTableSorting
			}, c({ _: 2 }, [P(e.columns, (e) => ({
				name: `header:${t(e)}`,
				fn: B((r) => [F(n.$slots, `header:${t(e)}`, w(h(r)))])
			}))]), 1032, [
				"columns",
				"has-tabs",
				"use-table-sorting"
			])) : a("", !0),
			F(n.$slots, "default"),
			F(n.$slots, "empty")
		], 16, ZM));
	}
}), $M = {}, eN = { class: "flex" };
function tN(e, t) {
	return A(), o("div", eN, [F(e.$slots, "default")]);
}
var nN = /*#__PURE__*/ W($M, [["render", tN]]), rN = /* @__PURE__ */ f({
	__name: "RowExpandable",
	props: {
		openLabel: {},
		closeLabel: {},
		expanded: { type: Boolean }
	},
	setup(t) {
		let [n, r] = Fe(t.expanded), i = le();
		return (a, s) => (A(), o(e, null, [u(WM, { class: C(a.$attrs.class) }, {
			default: B(() => [F(a.$slots, "default"), u(LM, null, {
				default: B(() => [u(qM, {
					"close-label": t.closeLabel,
					expanded: L(n),
					name: L(i),
					"open-label": t.openLabel,
					onClick: L(r)
				}, null, 8, [
					"close-label",
					"expanded",
					"name",
					"open-label",
					"onClick"
				])]),
				_: 1
			})]),
			_: 3
		}, 8, ["class"]), V(u(WM, {
			id: `row-toggle-control-${L(i)}`,
			class: C(a.$attrs.class)
		}, {
			default: B(() => [F(a.$slots, "expandable-content")]),
			_: 3
		}, 8, ["id", "class"]), [[he, L(n)]])], 64));
	}
}), iN = { key: 0 }, aN = /* @__PURE__ */ f({
	__name: "EmptyBody",
	props: {
		message: { default: void 0 },
		button: { default: void 0 },
		columnCount: {}
	},
	setup(e) {
		return (t, n) => (A(), i(L(WM), null, {
			default: B(() => [u(L(LM), {
				"aria-colspan": e.columnCount,
				class: "col-span-full my-2 text-center text-gray-900 flex align-center justify-center flex-col gap-2"
			}, {
				default: B(() => [e.message ? (A(), o("span", iN, I(e.message), 1)) : a("", !0), e.button ? (A(), i(L(Dp), {
					key: 1,
					class: C(["mx-auto flex gap-2 items-center text-sm", { "text-black": !e.button.variant }]),
					variant: e.button.variant ?? L(Sp).GrayOutline,
					onClick: e.button.click
				}, {
					default: B(() => [e.button.icon ? (A(), i(L(Jp), {
						key: 0,
						size: e.button.size
					}, {
						default: B(() => [(A(), i(re(e.button.icon)))]),
						_: 1
					}, 8, ["size"])) : a("", !0), l(" " + I(e.button.label), 1)]),
					_: 1
				}, 8, [
					"class",
					"variant",
					"onClick"
				])) : a("", !0)]),
				_: 1
			}, 8, ["aria-colspan"])]),
			_: 1
		}));
	}
}), oN = (e) => ({
	sortable: !0,
	name: e.name ?? String(e.sortKey),
	sortKey: e.sortKey,
	colSpan: e.colSpan,
	header: { translationKey: e.translationKey },
	defaultSortOrder: e.defaultSortOrder
}), sN = (e) => ({
	sortable: !1,
	name: e.name,
	colSpan: e.colSpan,
	header: e.translationKey ? { translationKey: e.translationKey } : void 0
}), cN = (e) => sN({
	name: "actions",
	colSpan: e?.colSpan ?? 2
}), lN = { class: "flex gap-2 items-center" }, uN = /* @__PURE__ */ f({
	__name: "TableRowSkeleton",
	props: {
		amountOfColumns: { default: 1 },
		hasMultiSelect: {
			type: Boolean,
			default: !1
		},
		hasActionButtons: {
			type: Boolean,
			default: !1
		},
		isExpandableRow: {
			type: Boolean,
			default: !1
		}
	},
	setup(t) {
		return (n, r) => (A(), i(WM, { class: "last:rounded-b-lg" }, {
			default: B(() => [(A(!0), o(e, null, P(t.amountOfColumns, (n) => (A(), i(LM, { key: n }, {
				default: B(() => [t.hasMultiSelect && n === 1 ? (A(), i(AM, {
					key: 0,
					height: "h-4",
					width: "w-4"
				})) : (A(), o(e, { key: 1 }, [u(AM, {
					class: "mb-1.5",
					height: "h-4",
					width: "w-3/4"
				}), u(AM, {
					height: "h-3",
					width: "w-1/2"
				})], 64))]),
				_: 2
			}, 1024))), 128)), t.hasActionButtons || t.isExpandableRow ? (A(), i(LM, {
				key: 0,
				class: "flex! flex-row-reverse h-full items-center"
			}, {
				default: B(() => [s("div", lN, [t.hasActionButtons ? (A(), i(AM, {
					key: 0,
					class: "rounded-full",
					height: "h-8",
					width: "w-30"
				})) : a("", !0), t.isExpandableRow ? (A(), i(AM, {
					key: 1,
					height: "h-4",
					width: "w-4"
				})) : a("", !0)])]),
				_: 1
			})) : a("", !0)]),
			_: 1
		}));
	}
}), dN = {}, fN = { class: "overflow-x-auto px-4" }, pN = { class: "flex gap-4" };
function mN(e, t) {
	return A(), o("nav", fN, [s("ul", pN, [F(e.$slots, "default")])]);
}
var hN = /*#__PURE__*/ W(dN, [["render", mN]]), gN = ["aria-selected"], _N = /* @__PURE__ */ f({
	__name: "TabLink",
	props: { active: { type: Boolean } },
	setup(e) {
		return (t, n) => (A(), o("li", {
			"aria-selected": e.active,
			class: C(["border-b-2 cursor-pointer min-w-max", {
				"border-secondary": e.active,
				"border-white hover:border-gray": !e.active
			}])
		}, [s("div", { class: C(["block pb-[10px]", { "text-secondary": e.active }]) }, [F(t.$slots, "default")], 2)], 10, gN));
	}
}), vN = /* @__PURE__ */ f({
	__name: "StatusIcon",
	props: { status: {} },
	setup(e) {
		let t = e, n = ie();
		function r(e) {
			switch (e) {
				case Cy.Registered: return y(rn);
				case Cy.HandedToCarrier: return y(Nt);
				case Cy.Sorting: return y(dn);
				case Cy.Distribution: return y(Qt);
				case Cy.Delivered: return y(oc);
			}
		}
		return z(() => t.status, (e) => {
			n.value = r(e);
		}, { immediate: !0 }), (e, t) => (A(), i(L(ap), { size: L(np).Medium }, {
			default: B(() => [(A(), i(re(n.value)))]),
			_: 1
		}, 8, ["size"]));
	}
}), yN = { class: "flex gap-4" }, bN = { class: "flex items-center justify-center" }, xN = /* @__PURE__ */ f({
	__name: "Header",
	props: { item: {} },
	setup(e) {
		return (t, n) => (A(), o("div", yN, [s("div", bN, [u(vN, {
			class: C({
				"text-primary": !e.item.disabled,
				"text-gray-400": e.item.disabled
			}),
			status: e.item.status
		}, null, 8, ["class", "status"])]), s("div", { class: C(["font-bold py-2", {
			"text-primary": !e.item.disabled,
			"text-gray-800": e.item.disabled
		}]) }, I(e.item.description), 3)]));
	}
}), SN = { class: "flex gap-4" }, CN = { class: "flex w-6" }, wN = { class: "flex flex-1 items-center justify-center relative" }, TN = { class: "flex flex-1 flex-col py-2" }, EN = {
	class: "text-slate-500 text-sm",
	"data-test": "tnt-time"
}, DN = /* @__PURE__ */ f({
	__name: "InBetweenStatus",
	props: {
		item: {},
		nextIsDisabled: { type: Boolean }
	},
	setup(e) {
		let t = e, n = r(() => ve(t.item.date).format("D MMMM HH:mm"));
		return (t, r) => (A(), o("div", SN, [s("div", CN, [s("div", wN, [
			s("div", {
				class: C(["absolute border-l h-1/2 top-0 w-0", e.nextIsDisabled ? "border-gray-300" : "border-primary"]),
				"data-test": "tnt-top-line"
			}, null, 2),
			r[0] ||= s("div", {
				class: "absolute border-l h-1/2 top-1/2 w-0 border-primary",
				"data-test": "tnt-bottom-line"
			}, null, -1),
			r[1] ||= s("div", {
				class: "h-2 relative rounded-full w-2 z-10 bg-primary",
				"data-test": "tnt-middle-circle"
			}, null, -1)
		])]), s("div", TN, [s("p", EN, I(n.value), 1), s("p", null, I(e.item.description), 1)])]));
	}
}), ON = { class: "flex flex-col pl-1" }, kN = /* @__PURE__ */ f({
	__name: "TrackAndTraceTimeline",
	props: { items: {} },
	setup(t) {
		let n = t, s = r(() => [...n.items].reverse());
		return (t, n) => (A(), o("div", ON, [(A(!0), o(e, null, P(s.value, (t, n) => (A(), o(e, null, [t.type === "header" ? (A(), i(xN, {
			key: `${t.type}-${t.status}`,
			item: t
		}, null, 8, ["item"])) : a("", !0), t.type === "item" ? (A(), i(DN, {
			key: `${t.type}-${t.status}-${n}`,
			item: t,
			"next-is-disabled": s.value[n - 1]?.disabled
		}, null, 8, ["item", "next-is-disabled"])) : a("", !0)], 64))), 256))]));
	}
}), AN = {
	"aria-hidden": "true",
	class: "flex flex-col"
}, jN = { class: "flex w-6" }, MN = { class: "flex flex-1 items-center justify-center relative" }, NN = { class: "flex flex-1 flex-col gap-2 py-2" }, PN = /* @__PURE__ */ f({
	__name: "TrackAndTraceTimelineSkeleton",
	props: { rows: { default: 2 } },
	setup(t) {
		return (n, r) => (A(), o("div", AN, [(A(!0), o(e, null, P(t.rows, (e) => (A(), o("div", {
			key: e,
			class: "flex gap-4"
		}, [s("div", jN, [s("div", MN, [
			r[0] ||= s("div", { class: "absolute border-gray-200 border-l h-1/2 top-0 w-0" }, null, -1),
			r[1] ||= s("div", { class: "absolute border-gray-200 border-l h-1/2 top-1/2 w-0" }, null, -1),
			u(DM, { class: "h-2 relative w-2 z-10" })
		])]), s("div", NN, [u(AM, {
			height: "h-3",
			width: "w-24"
		}), u(AM, {
			height: "h-4",
			width: "w-3/5"
		})])]))), 128))]));
	}
}), FN = { class: "flex gap-4" }, IN = { class: "flex w-6" }, LN = { class: "flex flex-1 items-center justify-center relative" }, RN = {
	key: 0,
	class: "absolute border-l h-1/2 top-0 w-0 border-primary",
	"data-test": "tnt-top-line"
}, zN = {
	key: 1,
	class: "absolute border-l h-1/2 top-1/2 w-0 border-primary",
	"data-test": "tnt-bottom-line"
}, BN = { class: "flex flex-1 flex-col py-2" }, VN = {
	class: "text-slate-500 text-sm",
	"data-test": "tnt-time"
}, HN = /* @__PURE__ */ f({
	__name: "TrackAndTraceListItem",
	props: {
		item: {},
		hasNext: { type: Boolean },
		hasPrevious: { type: Boolean }
	},
	setup(e) {
		let t = e, n = r(() => ve(t.item.date).format("D MMMM HH:mm"));
		return (t, r) => (A(), o("div", FN, [s("div", IN, [s("div", LN, [
			e.hasPrevious ? (A(), o("div", RN)) : a("", !0),
			e.hasNext ? (A(), o("div", zN)) : a("", !0),
			r[0] ||= s("div", {
				class: "h-2 relative rounded-full w-2 z-10 bg-primary",
				"data-test": "tnt-middle-circle"
			}, null, -1)
		])]), s("div", BN, [s("p", VN, I(n.value), 1), s("p", null, I(e.item.description), 1)])]));
	}
}), UN = { class: "flex flex-col pl-1" }, WN = /* @__PURE__ */ f({
	__name: "TrackAndTraceList",
	props: { items: {} },
	setup(t) {
		let n = t, a = r(() => xe.date.sortByDate(n.items, "date", { order: Py.Desc }));
		return (t, n) => (A(), o("div", UN, [(A(!0), o(e, null, P(a.value, (e, t) => (A(), i(HN, {
			key: `${e.type}-${e.status}-${t}`,
			"has-next": t !== a.value.length - 1,
			"has-previous": t !== 0,
			item: e
		}, null, 8, [
			"has-next",
			"has-previous",
			"item"
		]))), 128))]));
	}
}), GN = { class: "hidden items-center gap-2 md:flex!" }, KN = ["aria-current"], qN = { class: "md:hidden" }, JN = { class: "mb-2 flex items-baseline gap-1.5 text-sm" }, YN = { class: "font-bold whitespace-nowrap" }, XN = { class: "font-medium text-black whitespace-nowrap" }, ZN = { class: "flex gap-1.5" }, QN = ["aria-current"], $N = { class: "sr-only" }, eP = /* @__PURE__ */ f({
	__name: "WizardStepper",
	props: {
		steps: {},
		currentStepIndex: {},
		progressLabel: {},
		completedSteps: { default: () => [] }
	},
	setup(t) {
		let n = t, { t: c } = Re(), d = r(() => Object.entries(n.steps)), f = r(() => d.value[n.currentStepIndex][1]), p = (e, t) => e < n.currentStepIndex || n.completedSteps.includes(t) && e !== n.currentStepIndex, m = (e, t) => e === n.currentStepIndex ? "border-secondary bg-secondary text-white" : p(e, t) ? "border-green bg-green text-white" : "border-gray-400 text-black-light", h = (e, t) => p(e, t) ? "bg-green" : e === n.currentStepIndex ? "bg-secondary" : "bg-gray-400";
		return (n, r) => (A(), o(e, null, [s("ol", GN, [(A(!0), o(e, null, P(d.value, ([n, r], f) => (A(), o(e, { key: n }, [s("li", {
			"aria-current": f === t.currentStepIndex ? "step" : void 0,
			class: "flex shrink-0 items-center gap-2"
		}, [s("span", { class: C(["flex h-7 w-7 shrink-0 items-center justify-center rounded-full border text-sm font-medium", m(f, n)]) }, [p(f, n) ? (A(), i(L(Jp), {
			key: 0,
			size: L(Kp).Normal
		}, {
			default: B(() => [u(L(wv))]),
			_: 1
		}, 8, ["size"])) : (A(), o(e, { key: 1 }, [l(I(f + 1), 1)], 64))], 2), s("span", { class: C(["text-sm whitespace-nowrap", f === t.currentStepIndex ? "font-bold text-black" : "font-medium text-black-light"]) }, I(L(c)(r.title)), 3)], 8, KN), f < d.value.length - 1 ? (A(), o("span", {
			key: 0,
			"aria-hidden": "true",
			class: C(["h-px flex-1", f < t.currentStepIndex ? "bg-green" : "bg-gray-400"])
		}, null, 2)) : a("", !0)], 64))), 128))]), s("div", qN, [s("p", JN, [s("span", YN, I(L(c)(t.progressLabel, {
			current: t.currentStepIndex + 1,
			total: d.value.length
		})), 1), s("span", XN, "· " + I(L(c)(f.value.title)), 1)]), s("ol", ZN, [(A(!0), o(e, null, P(d.value, ([e, n], r) => (A(), o("li", {
			key: e,
			"aria-current": r === t.currentStepIndex ? "step" : void 0,
			class: C(["h-1.5 flex-1 rounded-full", h(r, e)])
		}, [s("span", $N, I(L(c)(n.title)), 1)], 10, QN))), 128))])])], 64));
	}
}), tP = { class: "sticky bottom-0 left-0 z-10 flex items-center justify-end gap-2 border-t bg-white px-4 py-2.5 shadow-[0px_4px_12px_0px_rgba(0,0,0,0.15)]" }, nP = /* @__PURE__ */ f({
	__name: "WizardFooter",
	props: {
		isFirstStep: { type: Boolean },
		isLastStep: { type: Boolean },
		canProceed: { type: Boolean },
		isLoading: {
			type: Boolean,
			default: !1
		},
		prevLabel: {},
		nextLabel: {},
		submitLabel: {}
	},
	emits: [
		"back",
		"next",
		"submit"
	],
	setup(e, { emit: t }) {
		let n = t;
		return (t, r) => (A(), o("div", tP, [e.isFirstStep ? a("", !0) : (A(), i(L(Dp), {
			key: 0,
			variant: L(Sp).SecondaryOutline,
			onClick: r[0] ||= (e) => n("back")
		}, {
			default: B(() => [l(I(e.prevLabel), 1)]),
			_: 1
		}, 8, ["variant"])), e.isLastStep ? (A(), i(L(Dp), {
			key: 2,
			disabled: !e.canProceed || e.isLoading,
			variant: L(Sp).Secondary,
			onClick: r[2] ||= (e) => n("submit")
		}, {
			default: B(() => [l(I(e.submitLabel), 1)]),
			_: 1
		}, 8, ["disabled", "variant"])) : (A(), i(L(Dp), {
			key: 1,
			disabled: !e.canProceed,
			variant: L(Sp).Secondary,
			onClick: r[1] ||= (e) => n("next")
		}, {
			default: B(() => [l(I(e.nextLabel), 1)]),
			_: 1
		}, 8, ["disabled", "variant"]))]));
	}
});
//#endregion
//#region ../../node_modules/.pnpm/orderedmap@2.1.1/node_modules/orderedmap/dist/index.js
function rP(e) {
	this.content = e;
}
rP.prototype = {
	constructor: rP,
	find: function(e) {
		for (var t = 0; t < this.content.length; t += 2) if (this.content[t] === e) return t;
		return -1;
	},
	get: function(e) {
		var t = this.find(e);
		return t == -1 ? void 0 : this.content[t + 1];
	},
	update: function(e, t, n) {
		var r = n && n != e ? this.remove(n) : this, i = r.find(e), a = r.content.slice();
		return i == -1 ? a.push(n || e, t) : (a[i + 1] = t, n && (a[i] = n)), new rP(a);
	},
	remove: function(e) {
		var t = this.find(e);
		if (t == -1) return this;
		var n = this.content.slice();
		return n.splice(t, 2), new rP(n);
	},
	addToStart: function(e, t) {
		return new rP([e, t].concat(this.remove(e).content));
	},
	addToEnd: function(e, t) {
		var n = this.remove(e).content.slice();
		return n.push(e, t), new rP(n);
	},
	addBefore: function(e, t, n) {
		var r = this.remove(t), i = r.content.slice(), a = r.find(e);
		return i.splice(a == -1 ? i.length : a, 0, t, n), new rP(i);
	},
	forEach: function(e) {
		for (var t = 0; t < this.content.length; t += 2) e(this.content[t], this.content[t + 1]);
	},
	prepend: function(e) {
		return e = rP.from(e), e.size ? new rP(e.content.concat(this.subtract(e).content)) : this;
	},
	append: function(e) {
		return e = rP.from(e), e.size ? new rP(this.subtract(e).content.concat(e.content)) : this;
	},
	subtract: function(e) {
		var t = this;
		e = rP.from(e);
		for (var n = 0; n < e.content.length; n += 2) t = t.remove(e.content[n]);
		return t;
	},
	toObject: function() {
		var e = {};
		return this.forEach(function(t, n) {
			e[t] = n;
		}), e;
	},
	get size() {
		return this.content.length >> 1;
	}
}, rP.from = function(e) {
	if (e instanceof rP) return e;
	var t = [];
	if (e) for (var n in e) t.push(n, e[n]);
	return new rP(t);
};
//#endregion
//#region ../../node_modules/.pnpm/prosemirror-model@1.25.9/node_modules/prosemirror-model/dist/index.js
function iP(e, t, n) {
	for (let r = 0;; r++) {
		if (r == e.childCount || r == t.childCount) return e.childCount == t.childCount ? null : n;
		let i = e.child(r), a = t.child(r);
		if (i == a) {
			n += i.nodeSize;
			continue;
		}
		if (!i.sameMarkup(a)) return n;
		if (i.isText && i.text != a.text) {
			let e = i.text, t = a.text, r = 0;
			for (; e[r] == t[r]; r++) n++;
			return r && r < e.length && r < t.length && sP(e.charCodeAt(r - 1)) && oP(e.charCodeAt(r)) && n--, n;
		}
		if (i.content.size || a.content.size) {
			let e = iP(i.content, a.content, n + 1);
			if (e != null) return e;
		}
		n += i.nodeSize;
	}
}
function aP(e, t, n, r) {
	for (let i = e.childCount, a = t.childCount;;) {
		if (i == 0 || a == 0) return i == a ? null : {
			a: n,
			b: r
		};
		let o = e.child(--i), s = t.child(--a), c = o.nodeSize;
		if (o == s) {
			n -= c, r -= c;
			continue;
		}
		if (!o.sameMarkup(s)) return {
			a: n,
			b: r
		};
		if (o.isText && o.text != s.text) {
			let e = o.text, t = s.text, i = e.length, a = t.length;
			for (; i > 0 && a > 0 && e[i - 1] == t[a - 1];) i--, a--, n--, r--;
			return i && a && i < e.length && sP(e.charCodeAt(i - 1)) && oP(e.charCodeAt(i)) && (n++, r++), {
				a: n,
				b: r
			};
		}
		if (o.content.size || s.content.size) {
			let e = aP(o.content, s.content, n - 1, r - 1);
			if (e) return e;
		}
		n -= c, r -= c;
	}
}
function oP(e) {
	return e >= 56320 && e < 57344;
}
function sP(e) {
	return e >= 55296 && e < 56320;
}
var X = class e {
	constructor(e, t) {
		if (this.content = e, this.size = t || 0, t == null) for (let t = 0; t < e.length; t++) this.size += e[t].nodeSize;
	}
	nodesBetween(e, t, n, r = 0, i) {
		for (let a = 0, o = 0; o < t; a++) {
			let s = this.content[a], c = o + s.nodeSize;
			if (c > e && n(s, r + o, i || null, a) !== !1 && s.content.size) {
				let i = o + 1;
				s.nodesBetween(Math.max(0, e - i), Math.min(s.content.size, t - i), n, r + i);
			}
			o = c;
		}
	}
	descendants(e) {
		this.nodesBetween(0, this.size, e);
	}
	textBetween(e, t, n, r) {
		let i = "", a = !0;
		return this.nodesBetween(e, t, (o, s) => {
			let c = o.isText ? o.text.slice(Math.max(e, s) - s, t - s) : o.isLeaf ? r ? typeof r == "function" ? r(o) : r : o.type.spec.leafText ? o.type.spec.leafText(o) : "" : "";
			o.isBlock && (o.isLeaf && c || o.isTextblock) && n && (a ? a = !1 : i += n), i += c;
		}, 0), i;
	}
	append(t) {
		if (!t.size) return this;
		if (!this.size) return t;
		let n = this.lastChild, r = t.firstChild, i = this.content.slice(), a = 0;
		for (n.isText && n.sameMarkup(r) && (i[i.length - 1] = n.withText(n.text + r.text), a = 1); a < t.content.length; a++) i.push(t.content[a]);
		return new e(i, this.size + t.size);
	}
	cut(t, n = this.size) {
		if (t == 0 && n == this.size) return this;
		let r = [], i = 0;
		if (n > t) for (let e = 0, a = 0; a < n; e++) {
			let o = this.content[e], s = a + o.nodeSize;
			s > t && ((a < t || s > n) && (o = o.isText ? o.cut(Math.max(0, t - a), Math.min(o.text.length, n - a)) : o.cut(Math.max(0, t - a - 1), Math.min(o.content.size, n - a - 1))), r.push(o), i += o.nodeSize), a = s;
		}
		return new e(r, i);
	}
	cutByIndex(t, n) {
		return t == n ? e.empty : t == 0 && n == this.content.length ? this : new e(this.content.slice(t, n));
	}
	replaceChild(t, n) {
		let r = this.content[t];
		if (r == n) return this;
		let i = this.content.slice(), a = this.size + n.nodeSize - r.nodeSize;
		return i[t] = n, new e(i, a);
	}
	addToStart(t) {
		return new e([t].concat(this.content), this.size + t.nodeSize);
	}
	addToEnd(t) {
		return new e(this.content.concat(t), this.size + t.nodeSize);
	}
	eq(e) {
		if (this.content.length != e.content.length) return !1;
		for (let t = 0; t < this.content.length; t++) if (!this.content[t].eq(e.content[t])) return !1;
		return !0;
	}
	get firstChild() {
		return this.content.length ? this.content[0] : null;
	}
	get lastChild() {
		return this.content.length ? this.content[this.content.length - 1] : null;
	}
	get childCount() {
		return this.content.length;
	}
	child(e) {
		let t = this.content[e];
		if (!t) throw RangeError("Index " + e + " out of range for " + this);
		return t;
	}
	maybeChild(e) {
		return this.content[e] || null;
	}
	forEach(e) {
		for (let t = 0, n = 0; t < this.content.length; t++) {
			let r = this.content[t];
			e(r, n, t), n += r.nodeSize;
		}
	}
	findDiffStart(e, t = 0) {
		return iP(this, e, t);
	}
	findDiffEnd(e, t = this.size, n = e.size) {
		return aP(this, e, t, n);
	}
	findIndex(e) {
		if (e == 0) return lP(0, e);
		if (e == this.size) return lP(this.content.length, e);
		if (e > this.size || e < 0) throw RangeError(`Position ${e} outside of fragment (${this})`);
		for (let t = 0, n = 0;; t++) {
			let r = this.child(t), i = n + r.nodeSize;
			if (i >= e) return i == e ? lP(t + 1, i) : lP(t, n);
			n = i;
		}
	}
	toString() {
		return "<" + this.toStringInner() + ">";
	}
	toStringInner() {
		return this.content.join(", ");
	}
	toJSON() {
		return this.content.length ? this.content.map((e) => e.toJSON()) : null;
	}
	static fromJSON(t, n) {
		if (!n) return e.empty;
		if (!Array.isArray(n)) throw RangeError("Invalid input for Fragment.fromJSON");
		return e.fromArray(n.map(t.nodeFromJSON));
	}
	static fromArray(t) {
		if (!t.length) return e.empty;
		let n, r = 0;
		for (let e = 0; e < t.length; e++) {
			let i = t[e];
			r += i.nodeSize, e && i.isText && t[e - 1].sameMarkup(i) ? (n ||= t.slice(0, e), n[n.length - 1] = i.withText(n[n.length - 1].text + i.text)) : n && n.push(i);
		}
		return new e(n || t, r);
	}
	static from(t) {
		if (!t) return e.empty;
		if (t instanceof e) return t;
		if (Array.isArray(t)) return this.fromArray(t);
		if (t.attrs) return new e([t], t.nodeSize);
		throw RangeError("Can not convert " + t + " to a Fragment" + (t.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
	}
};
X.empty = new X([], 0);
var cP = {
	index: 0,
	offset: 0
};
function lP(e, t) {
	return cP.index = e, cP.offset = t, cP;
}
function uP(e, t) {
	if (e === t) return !0;
	if (!(e && typeof e == "object") || !(t && typeof t == "object")) return !1;
	let n = Array.isArray(e);
	if (Array.isArray(t) != n) return !1;
	if (n) {
		if (e.length != t.length) return !1;
		for (let n = 0; n < e.length; n++) if (!uP(e[n], t[n])) return !1;
	} else {
		for (let n in e) if (!(n in t) || !uP(e[n], t[n])) return !1;
		for (let n in t) if (!(n in e)) return !1;
	}
	return !0;
}
var dP = class e {
	constructor(e, t) {
		this.type = e, this.attrs = t;
	}
	addToSet(e) {
		let t, n = !1;
		for (let r = 0; r < e.length; r++) {
			let i = e[r];
			if (this.eq(i)) return e;
			if (this.type.excludes(i.type)) t ||= e.slice(0, r);
			else if (i.type.excludes(this.type)) return e;
			else !n && i.type.rank > this.type.rank && (t ||= e.slice(0, r), t.push(this), n = !0), t && t.push(i);
		}
		return t ||= e.slice(), n || t.push(this), t;
	}
	removeFromSet(e) {
		for (let t = 0; t < e.length; t++) if (this.eq(e[t])) return e.slice(0, t).concat(e.slice(t + 1));
		return e;
	}
	isInSet(e) {
		for (let t = 0; t < e.length; t++) if (this.eq(e[t])) return !0;
		return !1;
	}
	eq(e) {
		return this == e || this.type == e.type && uP(this.attrs, e.attrs);
	}
	toJSON() {
		let e = { type: this.type.name };
		for (let t in this.attrs) {
			e.attrs = this.attrs;
			break;
		}
		return e;
	}
	static fromJSON(e, t) {
		if (!t) throw RangeError("Invalid input for Mark.fromJSON");
		let n = e.marks[t.type];
		if (!n) throw RangeError(`There is no mark type ${t.type} in this schema`);
		let r = n.create(t.attrs);
		return n.checkAttrs(r.attrs), r;
	}
	static sameSet(e, t) {
		if (e == t) return !0;
		if (e.length != t.length) return !1;
		for (let n = 0; n < e.length; n++) if (!e[n].eq(t[n])) return !1;
		return !0;
	}
	static setFrom(t) {
		if (!t || Array.isArray(t) && t.length == 0) return e.none;
		if (t instanceof e) return [t];
		let n = t.slice();
		return n.sort((e, t) => e.type.rank - t.type.rank), n;
	}
};
dP.none = [];
var fP = class extends Error {}, Z = class e {
	constructor(e, t, n) {
		this.content = e, this.openStart = t, this.openEnd = n;
	}
	get size() {
		return this.content.size - this.openStart - this.openEnd;
	}
	insertAt(t, n) {
		let r = mP(this.content, t + this.openStart, n, this.openStart + 1, this.openEnd + 1);
		return r && new e(r, this.openStart, this.openEnd);
	}
	removeBetween(t, n) {
		return new e(pP(this.content, t + this.openStart, n + this.openStart), this.openStart, this.openEnd);
	}
	eq(e) {
		return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
	}
	toString() {
		return this.content + "(" + this.openStart + "," + this.openEnd + ")";
	}
	toJSON() {
		if (!this.content.size) return null;
		let e = { content: this.content.toJSON() };
		return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
	}
	static fromJSON(t, n) {
		if (!n) return e.empty;
		let r = n.openStart || 0, i = n.openEnd || 0;
		if (typeof r != "number" || typeof i != "number") throw RangeError("Invalid input for Slice.fromJSON");
		return new e(X.fromJSON(t, n.content), r, i);
	}
	static maxOpen(t, n = !0) {
		let r = 0, i = 0;
		for (let e = t.firstChild; e && !e.isLeaf && (n || !e.type.spec.isolating); e = e.firstChild) r++;
		for (let e = t.lastChild; e && !e.isLeaf && (n || !e.type.spec.isolating); e = e.lastChild) i++;
		return new e(t, r, i);
	}
};
Z.empty = new Z(X.empty, 0, 0);
function pP(e, t, n) {
	let { index: r, offset: i } = e.findIndex(t), a = e.maybeChild(r), { index: o, offset: s } = e.findIndex(n);
	if (i == t || a.isText) {
		if (s != n && !e.child(o).isText) throw RangeError("Removing non-flat range");
		return e.cut(0, t).append(e.cut(n));
	}
	if (r != o) throw RangeError("Removing non-flat range");
	return e.replaceChild(r, a.copy(pP(a.content, t - i - 1, n - i - 1)));
}
function mP(e, t, n, r, i, a) {
	let { index: o, offset: s } = e.findIndex(t), c = e.maybeChild(o);
	if (s == t || c.isText) return a && r <= 0 && i <= 0 && !a.canReplace(o, o, n) ? null : e.cut(0, t).append(n).append(e.cut(t));
	let l = mP(c.content, t - s - 1, n, o == 0 ? r - 1 : 0, o == e.childCount - 1 ? i - 1 : 0, c);
	return l && e.replaceChild(o, c.copy(l));
}
function hP(e, t, n) {
	if (n.openStart > e.depth) throw new fP("Inserted content deeper than insertion position");
	if (e.depth - n.openStart != t.depth - n.openEnd) throw new fP("Inconsistent open depths");
	return gP(e, t, n, 0);
}
function gP(e, t, n, r) {
	let i = e.index(r), a = e.node(r);
	if (i == t.index(r) && r < e.depth - n.openStart) {
		let o = gP(e, t, n, r + 1);
		return a.copy(a.content.replaceChild(i, o));
	}
	if (!n.content.size) return xP(a, CP(e, t, r));
	if (!n.openStart && !n.openEnd && e.depth == r && t.depth == r) {
		let r = e.parent, i = r.content;
		return xP(r, i.cut(0, e.parentOffset).append(n.content).append(i.cut(t.parentOffset)));
	}
	{
		let { start: i, end: o } = wP(n, e);
		return xP(a, SP(e, i, o, t, r));
	}
}
function _P(e, t) {
	if (!t.type.compatibleContent(e.type)) throw new fP("Cannot join " + t.type.name + " onto " + e.type.name);
}
function vP(e, t, n) {
	let r = e.node(n);
	return _P(r, t.node(n)), r;
}
function yP(e, t) {
	let n = t.length - 1;
	n >= 0 && e.isText && e.sameMarkup(t[n]) ? t[n] = e.withText(t[n].text + e.text) : t.push(e);
}
function bP(e, t, n, r) {
	let i = (t || e).node(n), a = 0, o = t ? t.index(n) : i.childCount;
	e && (a = e.index(n), e.depth > n ? a++ : e.textOffset && (yP(e.nodeAfter, r), a++));
	for (let e = a; e < o; e++) yP(i.child(e), r);
	t && t.depth == n && t.textOffset && yP(t.nodeBefore, r);
}
function xP(e, t) {
	if (!e.type.validContent(t)) throw new fP("Invalid content for node " + e.type.name);
	return e.copy(t);
}
function SP(e, t, n, r, i) {
	let a = e.depth > i && vP(e, t, i + 1), o = r.depth > i && vP(n, r, i + 1), s = [];
	return bP(null, e, i, s), a && o && t.index(i) == n.index(i) ? (_P(a, o), yP(xP(a, SP(e, t, n, r, i + 1)), s)) : (a && yP(xP(a, CP(e, t, i + 1)), s), bP(t, n, i, s), o && yP(xP(o, CP(n, r, i + 1)), s)), bP(r, null, i, s), new X(s);
}
function CP(e, t, n) {
	let r = [];
	return bP(null, e, n, r), e.depth > n && yP(xP(vP(e, t, n + 1), CP(e, t, n + 1)), r), bP(t, null, n, r), new X(r);
}
function wP(e, t) {
	let n = t.depth - e.openStart, r = t.node(n).copy(e.content);
	for (let e = n - 1; e >= 0; e--) r = t.node(e).copy(X.from(r));
	return {
		start: r.resolveNoCache(e.openStart + n),
		end: r.resolveNoCache(r.content.size - e.openEnd - n)
	};
}
var TP = class e {
	constructor(e, t, n) {
		this.pos = e, this.path = t, this.parentOffset = n, this.depth = t.length / 3 - 1;
	}
	resolveDepth(e) {
		return e == null ? this.depth : e < 0 ? this.depth + e : e;
	}
	get parent() {
		return this.node(this.depth);
	}
	get doc() {
		return this.node(0);
	}
	node(e) {
		return this.path[this.resolveDepth(e) * 3];
	}
	index(e) {
		return this.path[this.resolveDepth(e) * 3 + 1];
	}
	indexAfter(e) {
		return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
	}
	start(e) {
		return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
	}
	end(e) {
		return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
	}
	before(e) {
		if (e = this.resolveDepth(e), !e) throw RangeError("There is no position before the top-level node");
		return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
	}
	after(e) {
		if (e = this.resolveDepth(e), !e) throw RangeError("There is no position after the top-level node");
		return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
	}
	get textOffset() {
		return this.pos - this.path[this.path.length - 1];
	}
	get nodeAfter() {
		let e = this.parent, t = this.index(this.depth);
		if (t == e.childCount) return null;
		let n = this.pos - this.path[this.path.length - 1], r = e.child(t);
		return n ? e.child(t).cut(n) : r;
	}
	get nodeBefore() {
		let e = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
		return t ? this.parent.child(e).cut(0, t) : e == 0 ? null : this.parent.child(e - 1);
	}
	posAtIndex(e, t) {
		t = this.resolveDepth(t);
		let n = this.path[t * 3], r = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
		for (let t = 0; t < e; t++) r += n.child(t).nodeSize;
		return r;
	}
	marks() {
		let e = this.parent, t = this.index();
		if (e.content.size == 0) return dP.none;
		if (this.textOffset) return e.child(t).marks;
		let n = e.maybeChild(t - 1), r = e.maybeChild(t);
		if (!n) {
			let e = n;
			n = r, r = e;
		}
		let i = n.marks;
		for (var a = 0; a < i.length; a++) i[a].type.spec.inclusive === !1 && (!r || !i[a].isInSet(r.marks)) && (i = i[a--].removeFromSet(i));
		return i;
	}
	marksAcross(e) {
		let t = this.parent.maybeChild(this.index());
		if (!t || !t.isInline) return null;
		let n = t.marks, r = e.parent.maybeChild(e.index());
		for (var i = 0; i < n.length; i++) n[i].type.spec.inclusive === !1 && (!r || !n[i].isInSet(r.marks)) && (n = n[i--].removeFromSet(n));
		return n;
	}
	sharedDepth(e) {
		for (let t = this.depth; t > 0; t--) if (this.start(t) <= e && this.end(t) >= e) return t;
		return 0;
	}
	blockRange(e = this, t) {
		if (e.pos < this.pos) return e.blockRange(this);
		for (let n = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); n >= 0; n--) if (e.pos <= this.end(n) && (!t || t(this.node(n)))) return new kP(this, e, n);
		return null;
	}
	sameParent(e) {
		return this.pos - this.parentOffset == e.pos - e.parentOffset;
	}
	max(e) {
		return e.pos > this.pos ? e : this;
	}
	min(e) {
		return e.pos < this.pos ? e : this;
	}
	toString() {
		let e = "";
		for (let t = 1; t <= this.depth; t++) e += (e ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
		return e + ":" + this.parentOffset;
	}
	static resolve(t, n) {
		if (!(n >= 0 && n <= t.content.size)) throw RangeError("Position " + n + " out of range");
		let r = [], i = 0, a = n;
		for (let e = t;;) {
			let { index: t, offset: n } = e.content.findIndex(a), o = a - n;
			if (r.push(e, t, i + n), !o || (e = e.child(t), e.isText)) break;
			a = o - 1, i += n + 1;
		}
		return new e(n, r, a);
	}
	static resolveCached(t, n) {
		let r = OP.get(t);
		if (r) for (let e = 0; e < r.elts.length; e++) {
			let t = r.elts[e];
			if (t.pos == n) return t;
		}
		else OP.set(t, r = new EP());
		let i = r.elts[r.i] = e.resolve(t, n);
		return r.i = (r.i + 1) % DP, i;
	}
}, EP = class {
	constructor() {
		this.elts = [], this.i = 0;
	}
}, DP = 12, OP = /* @__PURE__ */ new WeakMap(), kP = class {
	constructor(e, t, n) {
		this.$from = e, this.$to = t, this.depth = n;
	}
	get start() {
		return this.$from.before(this.depth + 1);
	}
	get end() {
		return this.$to.after(this.depth + 1);
	}
	get parent() {
		return this.$from.node(this.depth);
	}
	get startIndex() {
		return this.$from.index(this.depth);
	}
	get endIndex() {
		return this.$to.indexAfter(this.depth);
	}
}, AP = Object.create(null), jP = class e {
	constructor(e, t, n, r = dP.none) {
		this.type = e, this.attrs = t, this.marks = r, this.content = n || X.empty;
	}
	get children() {
		return this.content.content;
	}
	get nodeSize() {
		return this.isLeaf ? 1 : 2 + this.content.size;
	}
	get childCount() {
		return this.content.childCount;
	}
	child(e) {
		return this.content.child(e);
	}
	maybeChild(e) {
		return this.content.maybeChild(e);
	}
	forEach(e) {
		this.content.forEach(e);
	}
	nodesBetween(e, t, n, r = 0) {
		this.content.nodesBetween(e, t, n, r, this);
	}
	descendants(e) {
		this.nodesBetween(0, this.content.size, e);
	}
	get textContent() {
		return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
	}
	textBetween(e, t, n, r) {
		return this.content.textBetween(e, t, n, r);
	}
	get firstChild() {
		return this.content.firstChild;
	}
	get lastChild() {
		return this.content.lastChild;
	}
	eq(e) {
		return this == e || this.sameMarkup(e) && this.content.eq(e.content);
	}
	sameMarkup(e) {
		return this.hasMarkup(e.type, e.attrs, e.marks);
	}
	hasMarkup(e, t, n) {
		return this.type == e && uP(this.attrs, t || e.defaultAttrs || AP) && dP.sameSet(this.marks, n || dP.none);
	}
	copy(t = null) {
		return t == this.content ? this : new e(this.type, this.attrs, t, this.marks);
	}
	mark(t) {
		return t == this.marks ? this : new e(this.type, this.attrs, this.content, t);
	}
	cut(e, t = this.content.size) {
		return e == 0 && t == this.content.size ? this : this.copy(this.content.cut(e, t));
	}
	slice(e, t = this.content.size, n = !1) {
		if (e == t) return Z.empty;
		let r = this.resolve(e), i = this.resolve(t), a = n ? 0 : r.sharedDepth(t), o = r.start(a);
		return new Z(r.node(a).content.cut(r.pos - o, i.pos - o), r.depth - a, i.depth - a);
	}
	replace(e, t, n) {
		return hP(this.resolve(e), this.resolve(t), n);
	}
	nodeAt(e) {
		for (let t = this;;) {
			let { index: n, offset: r } = t.content.findIndex(e);
			if (t = t.maybeChild(n), !t) return null;
			if (r == e || t.isText) return t;
			e -= r + 1;
		}
	}
	childAfter(e) {
		let { index: t, offset: n } = this.content.findIndex(e);
		return {
			node: this.content.maybeChild(t),
			index: t,
			offset: n
		};
	}
	childBefore(e) {
		if (e == 0) return {
			node: null,
			index: 0,
			offset: 0
		};
		let { index: t, offset: n } = this.content.findIndex(e);
		if (n < e) return {
			node: this.content.child(t),
			index: t,
			offset: n
		};
		let r = this.content.child(t - 1);
		return {
			node: r,
			index: t - 1,
			offset: n - r.nodeSize
		};
	}
	resolve(e) {
		return TP.resolveCached(this, e);
	}
	resolveNoCache(e) {
		return TP.resolve(this, e);
	}
	rangeHasMark(e, t, n) {
		let r = !1;
		return t > e && this.nodesBetween(e, t, (e) => (n.isInSet(e.marks) && (r = !0), !r)), r;
	}
	get isBlock() {
		return this.type.isBlock;
	}
	get isTextblock() {
		return this.type.isTextblock;
	}
	get inlineContent() {
		return this.type.inlineContent;
	}
	get isInline() {
		return this.type.isInline;
	}
	get isText() {
		return this.type.isText;
	}
	get isLeaf() {
		return this.type.isLeaf;
	}
	get isAtom() {
		return this.type.isAtom;
	}
	toString() {
		if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
		let e = this.type.name;
		return this.content.size && (e += "(" + this.content.toStringInner() + ")"), NP(this.marks, e);
	}
	contentMatchAt(e) {
		let t = this.type.contentMatch.matchFragment(this.content, 0, e);
		if (!t) throw Error("Called contentMatchAt on a node with invalid content");
		return t;
	}
	canReplace(e, t, n = X.empty, r = 0, i = n.childCount) {
		let a = this.contentMatchAt(e).matchFragment(n, r, i), o = a && a.matchFragment(this.content, t);
		if (!o || !o.validEnd) return !1;
		for (let e = r; e < i; e++) if (!this.type.allowsMarks(n.child(e).marks)) return !1;
		return !0;
	}
	canReplaceWith(e, t, n, r) {
		if (r && !this.type.allowsMarks(r)) return !1;
		let i = this.contentMatchAt(e).matchType(n), a = i && i.matchFragment(this.content, t);
		return a ? a.validEnd : !1;
	}
	canAppend(e) {
		return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
	}
	check() {
		this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
		let e = dP.none;
		for (let t = 0; t < this.marks.length; t++) {
			let n = this.marks[t];
			n.type.checkAttrs(n.attrs), e = n.addToSet(e);
		}
		if (!dP.sameSet(e, this.marks)) throw RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((e) => e.type.name)}`);
		this.content.forEach((e) => e.check());
	}
	toJSON() {
		let e = { type: this.type.name };
		for (let t in this.attrs) {
			e.attrs = this.attrs;
			break;
		}
		return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((e) => e.toJSON())), e;
	}
	static fromJSON(e, t) {
		if (!t) throw RangeError("Invalid input for Node.fromJSON");
		let n;
		if (t.marks) {
			if (!Array.isArray(t.marks)) throw RangeError("Invalid mark data for Node.fromJSON");
			n = t.marks.map(e.markFromJSON);
		}
		if (t.type == "text") {
			if (typeof t.text != "string") throw RangeError("Invalid text node in JSON");
			return e.text(t.text, n);
		}
		let r = X.fromJSON(e, t.content), i = e.nodeType(t.type).create(t.attrs, r, n);
		return i.type.checkAttrs(i.attrs), i;
	}
};
jP.prototype.text = void 0;
var MP = class e extends jP {
	constructor(e, t, n, r) {
		if (super(e, t, null, r), !n) throw RangeError("Empty text nodes are not allowed");
		this.text = n;
	}
	toString() {
		return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : NP(this.marks, JSON.stringify(this.text));
	}
	get textContent() {
		return this.text;
	}
	textBetween(e, t) {
		return this.text.slice(e, t);
	}
	get nodeSize() {
		return this.text.length;
	}
	mark(t) {
		return t == this.marks ? this : new e(this.type, this.attrs, this.text, t);
	}
	withText(t) {
		return t == this.text ? this : new e(this.type, this.attrs, t, this.marks);
	}
	cut(e = 0, t = this.text.length) {
		return e == 0 && t == this.text.length ? this : this.withText(this.text.slice(e, t));
	}
	eq(e) {
		return this.sameMarkup(e) && this.text == e.text;
	}
	toJSON() {
		let e = super.toJSON();
		return e.text = this.text, e;
	}
};
function NP(e, t) {
	for (let n = e.length - 1; n >= 0; n--) t = e[n].type.name + "(" + t + ")";
	return t;
}
var PP = class e {
	constructor(e) {
		this.validEnd = e, this.next = [], this.wrapCache = [];
	}
	static parse(t, n) {
		let r = new FP(t, n);
		if (r.next == null) return e.empty;
		let i = IP(r);
		r.next && r.err("Unexpected trailing text");
		let a = KP(UP(i));
		return qP(a, r), a;
	}
	matchType(e) {
		for (let t = 0; t < this.next.length; t++) if (this.next[t].type == e) return this.next[t].next;
		return null;
	}
	matchFragment(e, t = 0, n = e.childCount) {
		let r = this;
		for (let i = t; r && i < n; i++) r = r.matchType(e.child(i).type);
		return r;
	}
	get inlineContent() {
		return this.next.length != 0 && this.next[0].type.isInline;
	}
	get defaultType() {
		for (let e = 0; e < this.next.length; e++) {
			let { type: t } = this.next[e];
			if (!(t.isText || t.hasRequiredAttrs())) return t;
		}
		return null;
	}
	compatible(e) {
		for (let t = 0; t < this.next.length; t++) for (let n = 0; n < e.next.length; n++) if (this.next[t].type == e.next[n].type) return !0;
		return !1;
	}
	fillBefore(e, t = !1, n = 0) {
		let r = [this];
		function i(a, o) {
			let s = a.matchFragment(e, n);
			if (s && (!t || s.validEnd)) return X.from(o.map((e) => e.createAndFill()));
			for (let e = 0; e < a.next.length; e++) {
				let { type: t, next: n } = a.next[e];
				if (!(t.isText || t.hasRequiredAttrs()) && r.indexOf(n) == -1) {
					r.push(n);
					let e = i(n, o.concat(t));
					if (e) return e;
				}
			}
			return null;
		}
		return i(this, []);
	}
	findWrapping(e) {
		for (let t = 0; t < this.wrapCache.length; t += 2) if (this.wrapCache[t] == e) return this.wrapCache[t + 1];
		let t = this.computeWrapping(e);
		return this.wrapCache.push(e, t), t;
	}
	computeWrapping(e) {
		let t = Object.create(null), n = [{
			match: this,
			type: null,
			via: null
		}];
		for (; n.length;) {
			let r = n.shift(), i = r.match;
			if (i.matchType(e)) {
				let e = [];
				for (let t = r; t.type; t = t.via) e.push(t.type);
				return e.reverse();
			}
			for (let e = 0; e < i.next.length; e++) {
				let { type: a, next: o } = i.next[e];
				!a.isLeaf && !a.hasRequiredAttrs() && !(a.name in t) && (!r.type || o.validEnd) && (n.push({
					match: a.contentMatch,
					type: a,
					via: r
				}), t[a.name] = !0);
			}
		}
		return null;
	}
	get edgeCount() {
		return this.next.length;
	}
	edge(e) {
		if (e >= this.next.length) throw RangeError(`There's no ${e}th edge in this content match`);
		return this.next[e];
	}
	toString() {
		let e = [];
		function t(n) {
			e.push(n);
			for (let r = 0; r < n.next.length; r++) e.indexOf(n.next[r].next) == -1 && t(n.next[r].next);
		}
		return t(this), e.map((t, n) => {
			let r = n + (t.validEnd ? "*" : " ") + " ";
			for (let n = 0; n < t.next.length; n++) r += (n ? ", " : "") + t.next[n].type.name + "->" + e.indexOf(t.next[n].next);
			return r;
		}).join("\n");
	}
};
PP.empty = new PP(!0);
var FP = class {
	constructor(e, t) {
		this.string = e, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
	}
	get next() {
		return this.tokens[this.pos];
	}
	eat(e) {
		return this.next == e && (this.pos++ || !0);
	}
	err(e) {
		throw SyntaxError(e + " (in content expression '" + this.string + "')");
	}
};
function IP(e) {
	let t = [];
	do
		t.push(LP(e));
	while (e.eat("|"));
	return t.length == 1 ? t[0] : {
		type: "choice",
		exprs: t
	};
}
function LP(e) {
	let t = [];
	do
		t.push(RP(e));
	while (e.next && e.next != ")" && e.next != "|");
	return t.length == 1 ? t[0] : {
		type: "seq",
		exprs: t
	};
}
function RP(e) {
	let t = HP(e);
	for (;;) if (e.eat("+")) t = {
		type: "plus",
		expr: t
	};
	else if (e.eat("*")) t = {
		type: "star",
		expr: t
	};
	else if (e.eat("?")) t = {
		type: "opt",
		expr: t
	};
	else if (e.eat("{")) t = BP(e, t);
	else break;
	return t;
}
function zP(e) {
	/\D/.test(e.next) && e.err("Expected number, got '" + e.next + "'");
	let t = Number(e.next);
	return e.pos++, t;
}
function BP(e, t) {
	let n = zP(e), r = n;
	return e.eat(",") && (r = e.next == "}" ? -1 : zP(e)), e.eat("}") || e.err("Unclosed braced range"), {
		type: "range",
		min: n,
		max: r,
		expr: t
	};
}
function VP(e, t) {
	let n = e.nodeTypes, r = n[t];
	if (r) return [r];
	let i = [];
	for (let e in n) {
		let r = n[e];
		r.isInGroup(t) && i.push(r);
	}
	return i.length == 0 && e.err("No node type or group '" + t + "' found"), i;
}
function HP(e) {
	if (e.eat("(")) {
		let t = IP(e);
		return e.eat(")") || e.err("Missing closing paren"), t;
	}
	if (/\W/.test(e.next)) e.err("Unexpected token '" + e.next + "'");
	else {
		let t = VP(e, e.next).map((t) => (e.inline == null ? e.inline = t.isInline : e.inline != t.isInline && e.err("Mixing inline and block content"), {
			type: "name",
			value: t
		}));
		return e.pos++, t.length == 1 ? t[0] : {
			type: "choice",
			exprs: t
		};
	}
}
function UP(e) {
	let t = [[]];
	return i(a(e, 0), n()), t;
	function n() {
		return t.push([]) - 1;
	}
	function r(e, n, r) {
		let i = {
			term: r,
			to: n
		};
		return t[e].push(i), i;
	}
	function i(e, t) {
		e.forEach((e) => e.to = t);
	}
	function a(e, t) {
		if (e.type == "choice") return e.exprs.reduce((e, n) => e.concat(a(n, t)), []);
		if (e.type == "seq") for (let r = 0;; r++) {
			let o = a(e.exprs[r], t);
			if (r == e.exprs.length - 1) return o;
			i(o, t = n());
		}
		else if (e.type == "star") {
			let o = n();
			return r(t, o), i(a(e.expr, o), o), [r(o)];
		} else if (e.type == "plus") {
			let o = n();
			return i(a(e.expr, t), o), i(a(e.expr, o), o), [r(o)];
		} else if (e.type == "opt") return [r(t)].concat(a(e.expr, t));
		else if (e.type == "range") {
			let o = t;
			for (let t = 0; t < e.min; t++) {
				let t = n();
				i(a(e.expr, o), t), o = t;
			}
			if (e.max == -1) i(a(e.expr, o), o);
			else for (let t = e.min; t < e.max; t++) {
				let t = n();
				r(o, t), i(a(e.expr, o), t), o = t;
			}
			return [r(o)];
		} else if (e.type == "name") return [r(t, void 0, e.value)];
		else throw Error("Unknown expr type");
	}
}
function WP(e, t) {
	return t - e;
}
function GP(e, t) {
	let n = [];
	return r(t), n.sort(WP);
	function r(t) {
		let i = e[t];
		if (i.length == 1 && !i[0].term) return r(i[0].to);
		n.push(t);
		for (let e = 0; e < i.length; e++) {
			let { term: t, to: a } = i[e];
			!t && n.indexOf(a) == -1 && r(a);
		}
	}
}
function KP(e) {
	let t = Object.create(null);
	return n(GP(e, 0));
	function n(r) {
		let i = [];
		r.forEach((t) => {
			e[t].forEach(({ term: t, to: n }) => {
				if (!t) return;
				let r;
				for (let e = 0; e < i.length; e++) i[e][0] == t && (r = i[e][1]);
				GP(e, n).forEach((e) => {
					r || i.push([t, r = []]), r.indexOf(e) == -1 && r.push(e);
				});
			});
		});
		let a = t[r.join(",")] = new PP(r.indexOf(e.length - 1) > -1);
		for (let e = 0; e < i.length; e++) {
			let r = i[e][1].sort(WP);
			a.next.push({
				type: i[e][0],
				next: t[r.join(",")] || n(r)
			});
		}
		return a;
	}
}
function qP(e, t) {
	for (let n = 0, r = [e]; n < r.length; n++) {
		let e = r[n], i = !e.validEnd, a = [];
		for (let t = 0; t < e.next.length; t++) {
			let { type: n, next: o } = e.next[t];
			a.push(n.name), i && !(n.isText || n.hasRequiredAttrs()) && (i = !1), r.indexOf(o) == -1 && r.push(o);
		}
		i && t.err("Only non-generatable nodes (" + a.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
	}
}
function JP(e) {
	let t = Object.create(null);
	for (let n in e) {
		let r = e[n];
		if (!r.hasDefault) return null;
		t[n] = r.default;
	}
	return t;
}
function YP(e, t) {
	let n = Object.create(null);
	for (let r in e) {
		let i = t && t[r];
		if (i === void 0) {
			let t = e[r];
			if (t.hasDefault) i = t.default;
			else throw RangeError("No value supplied for attribute " + r);
		}
		n[r] = i;
	}
	return n;
}
function XP(e, t, n, r) {
	for (let i in t) if (!(i in e)) throw RangeError(`Unsupported attribute ${i} for ${n} of type ${r}`);
	for (let n in e) e[n].validate && e[n].validate(t[n]);
}
function ZP(e, t) {
	let n = Object.create(null);
	if (t) for (let r in t) n[r] = new eF(e, r, t[r]);
	return n;
}
var QP = class e {
	constructor(e, t, n) {
		this.name = e, this.schema = t, this.spec = n, this.markSet = null, this.groups = n.group ? n.group.split(" ") : [], this.attrs = ZP(e, n.attrs), this.defaultAttrs = JP(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(n.inline || e == "text"), this.isText = e == "text";
	}
	get isInline() {
		return !this.isBlock;
	}
	get isTextblock() {
		return this.isBlock && this.inlineContent;
	}
	get isLeaf() {
		return this.contentMatch == PP.empty;
	}
	get isAtom() {
		return this.isLeaf || !!this.spec.atom;
	}
	isInGroup(e) {
		return this.groups.indexOf(e) > -1;
	}
	get whitespace() {
		return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
	}
	hasRequiredAttrs() {
		for (let e in this.attrs) if (this.attrs[e].isRequired) return !0;
		return !1;
	}
	compatibleContent(e) {
		return this == e || this.contentMatch.compatible(e.contentMatch);
	}
	computeAttrs(e) {
		return !e && this.defaultAttrs ? this.defaultAttrs : YP(this.attrs, e);
	}
	create(e = null, t, n) {
		if (this.isText) throw Error("NodeType.create can't construct text nodes");
		return new jP(this, this.computeAttrs(e), X.from(t), dP.setFrom(n));
	}
	createChecked(e = null, t, n) {
		return t = X.from(t), this.checkContent(t), new jP(this, this.computeAttrs(e), t, dP.setFrom(n));
	}
	createAndFill(e = null, t, n) {
		if (e = this.computeAttrs(e), t = X.from(t), t.size) {
			let e = this.contentMatch.fillBefore(t);
			if (!e) return null;
			t = e.append(t);
		}
		let r = this.contentMatch.matchFragment(t), i = r && r.fillBefore(X.empty, !0);
		return i ? new jP(this, e, t.append(i), dP.setFrom(n)) : null;
	}
	validContent(e) {
		let t = this.contentMatch.matchFragment(e);
		if (!t || !t.validEnd) return !1;
		for (let t = 0; t < e.childCount; t++) if (!this.allowsMarks(e.child(t).marks)) return !1;
		return !0;
	}
	checkContent(e) {
		if (!this.validContent(e)) throw RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
	}
	checkAttrs(e) {
		XP(this.attrs, e, "node", this.name);
	}
	allowsMarkType(e) {
		return this.markSet == null || this.markSet.indexOf(e) > -1;
	}
	allowsMarks(e) {
		if (this.markSet == null) return !0;
		for (let t = 0; t < e.length; t++) if (!this.allowsMarkType(e[t].type)) return !1;
		return !0;
	}
	allowedMarks(e) {
		if (this.markSet == null) return e;
		let t;
		for (let n = 0; n < e.length; n++) this.allowsMarkType(e[n].type) ? t && t.push(e[n]) : t ||= e.slice(0, n);
		return t ? t.length ? t : dP.none : e;
	}
	static compile(t, n) {
		let r = Object.create(null);
		t.forEach((t, i) => r[t] = new e(t, n, i));
		let i = n.spec.topNode || "doc";
		if (!r[i]) throw RangeError("Schema is missing its top node type ('" + i + "')");
		if (!r.text) throw RangeError("Every schema needs a 'text' type");
		for (let e in r.text.attrs) throw RangeError("The text node type should not have attributes");
		return r;
	}
};
function $P(e, t, n) {
	let r = n.split("|");
	return (n) => {
		let i = n === null ? "null" : typeof n;
		if (r.indexOf(i) < 0) throw RangeError(`Expected value of type ${r} for attribute ${t} on type ${e}, got ${i}`);
	};
}
var eF = class {
	constructor(e, t, n) {
		this.hasDefault = Object.prototype.hasOwnProperty.call(n, "default"), this.default = n.default, this.validate = typeof n.validate == "string" ? $P(e, t, n.validate) : n.validate;
	}
	get isRequired() {
		return !this.hasDefault;
	}
}, tF = class e {
	constructor(e, t, n, r) {
		this.name = e, this.rank = t, this.schema = n, this.spec = r, this.attrs = ZP(e, r.attrs), this.excluded = null;
		let i = JP(this.attrs);
		this.instance = i ? new dP(this, i) : null;
	}
	create(e = null) {
		return !e && this.instance ? this.instance : new dP(this, YP(this.attrs, e));
	}
	static compile(t, n) {
		let r = Object.create(null), i = 0;
		return t.forEach((t, a) => r[t] = new e(t, i++, n, a)), r;
	}
	removeFromSet(e) {
		for (var t = 0; t < e.length; t++) e[t].type == this && (e = e.slice(0, t).concat(e.slice(t + 1)), t--);
		return e;
	}
	isInSet(e) {
		for (let t = 0; t < e.length; t++) if (e[t].type == this) return e[t];
	}
	checkAttrs(e) {
		XP(this.attrs, e, "mark", this.name);
	}
	excludes(e) {
		return this.excluded.indexOf(e) > -1;
	}
}, nF = class {
	constructor(e) {
		this.linebreakReplacement = null, this.cached = Object.create(null);
		let t = this.spec = {};
		for (let n in e) t[n] = e[n];
		t.nodes = rP.from(e.nodes), t.marks = rP.from(e.marks || {}), this.nodes = QP.compile(this.spec.nodes, this), this.marks = tF.compile(this.spec.marks, this);
		let n = Object.create(null);
		for (let e in this.nodes) {
			if (e in this.marks) throw RangeError(e + " can not be both a node and a mark");
			let t = this.nodes[e], r = t.spec.content || "", i = t.spec.marks;
			if (t.contentMatch = n[r] || (n[r] = PP.parse(r, this.nodes)), t.inlineContent = t.contentMatch.inlineContent, t.spec.linebreakReplacement) {
				if (this.linebreakReplacement) throw RangeError("Multiple linebreak nodes defined");
				if (!t.isInline || !t.isLeaf) throw RangeError("Linebreak replacement nodes must be inline leaf nodes");
				this.linebreakReplacement = t;
			}
			t.markSet = i == "_" ? null : i ? rF(this, i.split(" ")) : i == "" || !t.inlineContent ? [] : null;
		}
		for (let e in this.marks) {
			let t = this.marks[e], n = t.spec.excludes;
			t.excluded = n == null ? [t] : n == "" ? [] : rF(this, n.split(" "));
		}
		this.nodeFromJSON = (e) => jP.fromJSON(this, e), this.markFromJSON = (e) => dP.fromJSON(this, e), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = Object.create(null);
	}
	node(e, t = null, n, r) {
		if (typeof e == "string") e = this.nodeType(e);
		else if (!(e instanceof QP)) throw RangeError("Invalid node type: " + e);
		else if (e.schema != this) throw RangeError("Node type from different schema used (" + e.name + ")");
		return e.createChecked(t, n, r);
	}
	text(e, t) {
		let n = this.nodes.text;
		return new MP(n, n.defaultAttrs, e, dP.setFrom(t));
	}
	mark(e, t) {
		return typeof e == "string" && (e = this.marks[e]), e.create(t);
	}
	nodeType(e) {
		let t = this.nodes[e];
		if (!t) throw RangeError("Unknown node type: " + e);
		return t;
	}
};
function rF(e, t) {
	let n = [];
	for (let r = 0; r < t.length; r++) {
		let i = t[r], a = e.marks[i], o = a;
		if (a) n.push(a);
		else for (let t in e.marks) {
			let r = e.marks[t];
			(i == "_" || r.spec.group && r.spec.group.split(" ").indexOf(i) > -1) && n.push(o = r);
		}
		if (!o) throw SyntaxError("Unknown mark type: '" + t[r] + "'");
	}
	return n;
}
function iF(e) {
	return e.tag != null;
}
function aF(e) {
	return e.style != null;
}
var oF = class e {
	constructor(e, t) {
		this.schema = e, this.rules = t, this.tags = [], this.styles = [];
		let n = this.matchedStyles = [];
		t.forEach((e) => {
			if (iF(e)) this.tags.push(e);
			else if (aF(e)) {
				let t = /[^=]*/.exec(e.style)[0];
				n.indexOf(t) < 0 && n.push(t), this.styles.push(e);
			}
		}), this.normalizeLists = !this.tags.some((t) => {
			if (!/^(ul|ol)\b/.test(t.tag) || !t.node) return !1;
			let n = e.nodes[t.node];
			return n.contentMatch.matchType(n);
		});
	}
	parse(e, t = {}) {
		let n = new hF(this, t, !1);
		return n.addAll(e, dP.none, t.from, t.to), n.finish();
	}
	parseSlice(e, t = {}) {
		let n = new hF(this, t, !0);
		return n.addAll(e, dP.none, t.from, t.to), Z.maxOpen(n.finish());
	}
	matchTag(e, t, n) {
		for (let r = n ? this.tags.indexOf(n) + 1 : 0; r < this.tags.length; r++) {
			let n = this.tags[r];
			if (_F(e, n.tag) && (n.namespace === void 0 || e.namespaceURI == n.namespace) && (!n.context || t.matchesContext(n.context))) {
				if (n.getAttrs) {
					let t = n.getAttrs(e);
					if (t === !1) continue;
					n.attrs = t || void 0;
				}
				return n;
			}
		}
	}
	matchStyle(e, t, n, r) {
		for (let i = r ? this.styles.indexOf(r) + 1 : 0; i < this.styles.length; i++) {
			let r = this.styles[i], a = r.style;
			if (!(a.indexOf(e) != 0 || r.context && !n.matchesContext(r.context) || a.length > e.length && (a.charCodeAt(e.length) != 61 || a.slice(e.length + 1) != t))) {
				if (r.getAttrs) {
					let e = r.getAttrs(t);
					if (e === !1) continue;
					r.attrs = e || void 0;
				}
				return r;
			}
		}
	}
	static schemaRules(e) {
		let t = [];
		function n(e) {
			let n = e.priority == null ? 50 : e.priority, r = 0;
			for (; r < t.length; r++) {
				let e = t[r];
				if ((e.priority == null ? 50 : e.priority) < n) break;
			}
			t.splice(r, 0, e);
		}
		for (let t in e.marks) {
			let r = e.marks[t].spec.parseDOM;
			r && r.forEach((e) => {
				n(e = vF(e)), e.mark || e.ignore || e.clearMark || (e.mark = t);
			});
		}
		for (let t in e.nodes) {
			let r = e.nodes[t].spec.parseDOM;
			r && r.forEach((e) => {
				n(e = vF(e)), e.node || e.ignore || e.mark || (e.node = t);
			});
		}
		return t;
	}
	static fromSchema(t) {
		return t.cached.domParser || (t.cached.domParser = new e(t, e.schemaRules(t)));
	}
}, sF = {
	address: !0,
	article: !0,
	aside: !0,
	blockquote: !0,
	canvas: !0,
	dd: !0,
	div: !0,
	dl: !0,
	fieldset: !0,
	figcaption: !0,
	figure: !0,
	footer: !0,
	form: !0,
	h1: !0,
	h2: !0,
	h3: !0,
	h4: !0,
	h5: !0,
	h6: !0,
	header: !0,
	hgroup: !0,
	hr: !0,
	li: !0,
	noscript: !0,
	ol: !0,
	output: !0,
	p: !0,
	pre: !0,
	section: !0,
	table: !0,
	tfoot: !0,
	ul: !0
}, cF = {
	head: !0,
	noscript: !0,
	object: !0,
	script: !0,
	style: !0,
	title: !0
}, lF = {
	ol: !0,
	ul: !0
}, uF = 1, dF = 2, fF = 4;
function pF(e, t, n) {
	return t == null ? e && e.whitespace == "pre" ? 3 : n & -5 : (t ? uF : 0) | (t === "full" ? dF : 0);
}
var mF = class {
	constructor(e, t, n, r, i, a) {
		this.type = e, this.attrs = t, this.marks = n, this.solid = r, this.options = a, this.content = [], this.activeMarks = dP.none, this.match = i || (a & fF ? null : e.contentMatch);
	}
	findWrapping(e) {
		if (!this.match) {
			if (!this.type) return [];
			let t = this.type.contentMatch.fillBefore(X.from(e));
			if (t) this.match = this.type.contentMatch.matchFragment(t);
			else {
				let t = this.type.contentMatch, n;
				return (n = t.findWrapping(e.type)) ? (this.match = t, n) : null;
			}
		}
		return this.match.findWrapping(e.type);
	}
	finish(e) {
		if (!(this.options & uF)) {
			let e = this.content[this.content.length - 1], t;
			if (e && e.isText && (t = /[ \t\r\n\u000c]+$/.exec(e.text))) {
				let n = e;
				e.text.length == t[0].length ? this.content.pop() : this.content[this.content.length - 1] = n.withText(n.text.slice(0, n.text.length - t[0].length));
			}
		}
		let t = X.from(this.content);
		return !e && this.match && (t = t.append(this.match.fillBefore(X.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
	}
	inlineContext(e) {
		return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !sF.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
	}
}, hF = class {
	constructor(e, t, n) {
		this.parser = e, this.options = t, this.isOpen = n, this.open = 0, this.localPreserveWS = !1;
		let r = t.topNode, i, a = pF(null, t.preserveWhitespace, 0) | (n ? fF : 0);
		i = r ? new mF(r.type, r.attrs, dP.none, !0, t.topMatch || r.type.contentMatch, a) : n ? new mF(null, null, dP.none, !0, null, a) : new mF(e.schema.topNodeType, null, dP.none, !0, null, a), this.nodes = [i], this.find = t.findPositions, this.needsBlock = !1;
	}
	get top() {
		return this.nodes[this.open];
	}
	addDOM(e, t) {
		e.nodeType == 3 ? this.addTextNode(e, t) : e.nodeType == 1 && this.addElement(e, t);
	}
	addTextNode(e, t) {
		let n = e.nodeValue, r = this.top, i = r.options & dF ? "full" : this.localPreserveWS || (r.options & uF) > 0, { schema: a } = this.parser;
		if (i === "full" || r.inlineContext(e) || /[^ \t\r\n\u000c]/.test(n)) {
			if (!i) {
				if (n = n.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(n) && this.open == this.nodes.length - 1) {
					let t = r.content[r.content.length - 1], i = e.previousSibling;
					(!t || i && i.nodeName == "BR" || t.isText && /[ \t\r\n\u000c]$/.test(t.text)) && (n = n.slice(1));
				}
			} else if (i === "full") n = n.replace(/\r\n?/g, "\n");
			else if (a.linebreakReplacement && /[\r\n]/.test(n) && this.top.findWrapping(a.linebreakReplacement.create())) {
				let e = n.split(/\r?\n|\r/);
				for (let n = 0; n < e.length; n++) n && this.insertNode(a.linebreakReplacement.create(), t, !0), e[n] && this.insertNode(a.text(e[n]), t, !/\S/.test(e[n]));
				n = "";
			} else n = n.replace(/\r?\n|\r/g, " ");
			n && this.insertNode(a.text(n), t, !/\S/.test(n)), this.findInText(e);
		} else this.findInside(e);
	}
	addElement(e, t, n) {
		let r = this.localPreserveWS, i = this.top;
		(e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
		let a = e.nodeName.toLowerCase(), o;
		lF.hasOwnProperty(a) && this.parser.normalizeLists && gF(e);
		let s = this.options.ruleFromNode && this.options.ruleFromNode(e) || (o = this.parser.matchTag(e, this, n));
		out: if (s ? s.ignore : cF.hasOwnProperty(a)) this.findInside(e), this.ignoreFallback(e, t);
		else if (!s || s.skip || s.closeParent) {
			s && s.closeParent ? this.open = Math.max(0, this.open - 1) : s && s.skip.nodeType && (e = s.skip);
			let n, r = this.needsBlock;
			if (sF.hasOwnProperty(a)) i.content.length && i.content[0].isInline && this.open && (this.open--, i = this.top), n = !0, i.type || (this.needsBlock = !0);
			else if (!e.firstChild) {
				this.leafFallback(e, t);
				break out;
			}
			let o = s && s.skip ? t : this.readStyles(e, t);
			o && this.addAll(e, o), n && this.sync(i), this.needsBlock = r;
		} else {
			let n = this.readStyles(e, t);
			n && this.addElementByRule(e, s, n, s.consuming === !1 ? o : void 0);
		}
		this.localPreserveWS = r;
	}
	leafFallback(e, t) {
		e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode("\n"), t);
	}
	ignoreFallback(e, t) {
		e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), t, !0);
	}
	readStyles(e, t) {
		let n = e.style;
		if (n && n.length) for (let e = 0; e < this.parser.matchedStyles.length; e++) {
			let r = this.parser.matchedStyles[e], i = n.getPropertyValue(r);
			if (i) for (let e;;) {
				let n = this.parser.matchStyle(r, i, this, e);
				if (!n) break;
				if (n.ignore) return null;
				if (t = n.clearMark ? t.filter((e) => !n.clearMark(e)) : t.concat(this.parser.schema.marks[n.mark].create(n.attrs)), n.consuming === !1) e = n;
				else break;
			}
		}
		return t;
	}
	addElementByRule(e, t, n, r) {
		let i, a;
		if (t.node) {
			if (a = this.parser.schema.nodes[t.node], a.isLeaf) this.insertNode(a.create(t.attrs), n, e.nodeName == "BR") || this.leafFallback(e, n);
			else {
				let e = this.enter(a, t.attrs || null, n, t.preserveWhitespace);
				e && (i = !0, n = e);
			}
		} else {
			let e = this.parser.schema.marks[t.mark];
			n = n.concat(e.create(t.attrs));
		}
		let o = this.top;
		if (a && a.isLeaf) this.findInside(e);
		else if (r) this.addElement(e, n, r);
		else if (t.getContent) this.findInside(e), t.getContent(e, this.parser.schema).forEach((e) => this.insertNode(e, n, !1));
		else {
			let r = e;
			typeof t.contentElement == "string" ? r = e.querySelector(t.contentElement) : typeof t.contentElement == "function" ? r = t.contentElement(e) : t.contentElement && (r = t.contentElement), this.findAround(e, r, !0), this.addAll(r, n), this.findAround(e, r, !1);
		}
		i && this.sync(o) && this.open--;
	}
	addAll(e, t, n, r) {
		let i = n || 0;
		for (let a = n ? e.childNodes[n] : e.firstChild, o = r == null ? null : e.childNodes[r]; a != o; a = a.nextSibling, ++i) this.findAtPoint(e, i), this.addDOM(a, t);
		this.findAtPoint(e, i);
	}
	findPlace(e, t, n) {
		let r, i;
		for (let t = this.open, a = 0; t >= 0; t--) {
			let o = this.nodes[t], s = o.findWrapping(e);
			if (s && (!r || r.length > s.length + a) && (r = s, i = o, !s.length)) break;
			if (o.solid) {
				if (n) break;
				a += 2;
			}
		}
		if (!r) return null;
		this.sync(i);
		for (let e = 0; e < r.length; e++) t = this.enterInner(r[e], null, t, !1);
		return t;
	}
	insertNode(e, t, n) {
		if (e.isInline && this.needsBlock && !this.top.type) {
			let e = this.textblockFromContext();
			e && (t = this.enterInner(e, null, t));
		}
		let r = this.findPlace(e, t, n);
		if (r) {
			this.closeExtra();
			let t = this.top;
			t.match &&= t.match.matchType(e.type);
			let n = dP.none;
			for (let i of r.concat(e.marks)) (t.type ? t.type.allowsMarkType(i.type) : yF(i.type, e.type)) && (n = i.addToSet(n));
			return t.content.push(e.mark(n)), !0;
		}
		return !1;
	}
	enter(e, t, n, r) {
		let i = this.findPlace(e.create(t), n, !1);
		return i &&= this.enterInner(e, t, n, !0, r), i;
	}
	enterInner(e, t, n, r = !1, i) {
		this.closeExtra();
		let a = this.top;
		a.match = a.match && a.match.matchType(e);
		let o = pF(e, i, a.options);
		a.options & fF && a.content.length == 0 && (o |= fF);
		let s = dP.none;
		return n = n.filter((t) => !(a.type ? a.type.allowsMarkType(t.type) : yF(t.type, e)) || (s = t.addToSet(s), !1)), this.nodes.push(new mF(e, t, s, r, null, o)), this.open++, n;
	}
	closeExtra(e = !1) {
		let t = this.nodes.length - 1;
		if (t > this.open) {
			for (; t > this.open; t--) this.nodes[t - 1].content.push(this.nodes[t].finish(e));
			this.nodes.length = this.open + 1;
		}
	}
	finish() {
		return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
	}
	sync(e) {
		for (let t = this.open; t >= 0; t--) if (this.nodes[t] == e) return this.open = t, !0;
		else this.localPreserveWS && (this.nodes[t].options |= uF);
		return !1;
	}
	get currentPos() {
		this.closeExtra();
		let e = 0;
		for (let t = this.open; t >= 0; t--) {
			let n = this.nodes[t].content;
			for (let t = n.length - 1; t >= 0; t--) e += n[t].nodeSize;
			t && e++;
		}
		return e;
	}
	findAtPoint(e, t) {
		if (this.find) for (let n = 0; n < this.find.length; n++) this.find[n].node == e && this.find[n].offset == t && (this.find[n].pos = this.currentPos);
	}
	findInside(e) {
		if (this.find) for (let t = 0; t < this.find.length; t++) this.find[t].pos == null && e.nodeType == 1 && e.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
	}
	findAround(e, t, n) {
		if (e != t && this.find) for (let r = 0; r < this.find.length; r++) this.find[r].pos == null && e.nodeType == 1 && e.contains(this.find[r].node) && t.compareDocumentPosition(this.find[r].node) & (n ? 2 : 4) && (this.find[r].pos = this.currentPos);
	}
	findInText(e) {
		if (this.find) for (let t = 0; t < this.find.length; t++) this.find[t].node == e && (this.find[t].pos = this.currentPos - (e.nodeValue.length - this.find[t].offset));
	}
	matchesContext(e) {
		if (e.indexOf("|") > -1) return e.split(/\s*\|\s*/).some(this.matchesContext, this);
		let t = e.split("/"), n = this.options.context, r = !this.isOpen && (!n || n.parent.type == this.nodes[0].type), i = -(n ? n.depth + 1 : 0) + +!r, a = (e, o) => {
			for (; e >= 0; e--) {
				let s = t[e];
				if (s == "") {
					if (e == t.length - 1 || e == 0) continue;
					for (; o >= i; o--) if (a(e - 1, o)) return !0;
					return !1;
				}
				{
					let e = o > 0 || o == 0 && r ? this.nodes[o].type : n && o >= i ? n.node(o - i).type : null;
					if (!e || e.name != s && !e.isInGroup(s)) return !1;
					o--;
				}
			}
			return !0;
		};
		return a(t.length - 1, this.open);
	}
	textblockFromContext() {
		let e = this.options.context;
		if (e) for (let t = e.depth; t >= 0; t--) {
			let n = e.node(t).contentMatchAt(e.indexAfter(t)).defaultType;
			if (n && n.isTextblock && n.defaultAttrs) return n;
		}
		for (let e in this.parser.schema.nodes) {
			let t = this.parser.schema.nodes[e];
			if (t.isTextblock && t.defaultAttrs) return t;
		}
	}
};
function gF(e) {
	for (let t = e.firstChild, n = null; t; t = t.nextSibling) {
		let e = t.nodeType == 1 ? t.nodeName.toLowerCase() : null;
		e && lF.hasOwnProperty(e) && n ? (n.appendChild(t), t = n) : e == "li" ? n = t : e && (n = null);
	}
}
function _F(e, t) {
	return (e.matches || e.msMatchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector).call(e, t);
}
function vF(e) {
	let t = {};
	for (let n in e) t[n] = e[n];
	return t;
}
function yF(e, t) {
	let n = t.schema.nodes;
	for (let r in n) {
		let i = n[r];
		if (!i.allowsMarkType(e)) continue;
		let a = [], o = (e) => {
			a.push(e);
			for (let n = 0; n < e.edgeCount; n++) {
				let { type: r, next: i } = e.edge(n);
				if (r == t || a.indexOf(i) < 0 && o(i)) return !0;
			}
		};
		if (o(i.contentMatch)) return !0;
	}
}
var bF = class e {
	constructor(e, t) {
		this.nodes = e, this.marks = t;
	}
	serializeFragment(e, t = {}, n) {
		n ||= SF(t).createDocumentFragment();
		let r = n, i = [];
		return e.forEach((e) => {
			if (i.length || e.marks.length) {
				let n = 0, a = 0;
				for (; n < i.length && a < e.marks.length;) {
					let t = e.marks[a];
					if (!this.marks[t.type.name]) {
						a++;
						continue;
					}
					if (!t.eq(i[n][0]) || t.type.spec.spanning === !1) break;
					n++, a++;
				}
				for (; n < i.length;) r = i.pop()[1];
				for (; a < e.marks.length;) {
					let n = e.marks[a++], o = this.serializeMark(n, e.isInline, t);
					o && (i.push([n, r]), r.appendChild(o.dom), r = o.contentDOM || o.dom);
				}
			}
			r.appendChild(this.serializeNodeInner(e, t));
		}), n;
	}
	serializeNodeInner(e, t) {
		if (e.isText) return SF(t).createTextNode(e.text);
		let { dom: n, contentDOM: r } = EF(SF(t), this.nodes[e.type.name](e), null, e.attrs);
		if (r) {
			if (e.isLeaf) throw RangeError("Content hole not allowed in a leaf node spec");
			this.serializeFragment(e.content, t, r);
		}
		return n;
	}
	serializeNode(e, t = {}) {
		let n = this.serializeNodeInner(e, t);
		for (let r = e.marks.length - 1; r >= 0; r--) {
			let i = this.serializeMark(e.marks[r], e.isInline, t);
			i && ((i.contentDOM || i.dom).appendChild(n), n = i.dom);
		}
		return n;
	}
	serializeMark(e, t, n = {}) {
		let r = this.marks[e.type.name];
		return r && EF(SF(n), r(e, t), null, e.attrs);
	}
	static renderSpec(e, t, n = null, r) {
		return typeof t == "string" ? { dom: e.createTextNode(t) } : EF(e, t, n, r);
	}
	static fromSchema(t) {
		return t.cached.domSerializer || (t.cached.domSerializer = new e(this.nodesFromSchema(t), this.marksFromSchema(t)));
	}
	static nodesFromSchema(e) {
		let t = xF(e.nodes);
		return t.text ||= (e) => e.text, t;
	}
	static marksFromSchema(e) {
		return xF(e.marks);
	}
};
function xF(e) {
	let t = {};
	for (let n in e) {
		let r = e[n].spec.toDOM;
		r && (t[n] = r);
	}
	return t;
}
function SF(e) {
	return e.document || window.document;
}
var CF = /* @__PURE__ */ new WeakMap();
function wF(e) {
	let t = CF.get(e);
	return t === void 0 && CF.set(e, t = TF(e)), t;
}
function TF(e) {
	let t = null;
	function n(e) {
		if (e && typeof e == "object") {
			if (Array.isArray(e)) {
				if (typeof e[0] == "string") t ||= [], t.push(e);
				else for (let t = 0; t < e.length; t++) n(e[t]);
			} else for (let t in e) n(e[t]);
		}
	}
	return n(e), t;
}
function EF(e, t, n, r) {
	if (t.nodeType == 1) return { dom: t };
	if (t.dom && t.dom.nodeType == 1) return t;
	let i = t[0], a;
	if (typeof i != "string") throw RangeError("Invalid array passed to renderSpec");
	if (r && (a = wF(r)) && a.indexOf(t) > -1) throw RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
	let o = i.indexOf(" ");
	o > 0 && (n = i.slice(0, o), i = i.slice(o + 1));
	let s, c = n ? e.createElementNS(n, i) : e.createElement(i), l = t[1], u = 1;
	if (l && typeof l == "object" && l.nodeType == null && !Array.isArray(l)) {
		u = 2;
		for (let e in l) if (l[e] != null) {
			let t = e.indexOf(" ");
			t > 0 ? c.setAttributeNS(e.slice(0, t), e.slice(t + 1), l[e]) : e == "style" && c.style ? c.style.cssText = l[e] : c.setAttribute(e, l[e]);
		}
	}
	for (let i = u; i < t.length; i++) {
		let a = t[i];
		if (a === 0) {
			if (i < t.length - 1 || i > u) throw RangeError("Content hole must be the only child of its parent node");
			return {
				dom: c,
				contentDOM: c
			};
		}
		if (typeof a == "string") c.appendChild(e.createTextNode(a));
		else {
			let { dom: t, contentDOM: i } = EF(e, a, n, r);
			if (c.appendChild(t), i) {
				if (s) throw RangeError("Multiple content holes");
				s = i;
			}
		}
	}
	return {
		dom: c,
		contentDOM: s
	};
}
//#endregion
//#region ../../node_modules/.pnpm/prosemirror-transform@1.12.0/node_modules/prosemirror-transform/dist/index.js
var DF = 65535, OF = 2 ** 16;
function kF(e, t) {
	return e + t * OF;
}
function AF(e) {
	return e & DF;
}
function jF(e) {
	return (e - (e & DF)) / OF;
}
var MF = 1, NF = 2, PF = 4, FF = 8, IF = class {
	constructor(e, t, n) {
		this.pos = e, this.delInfo = t, this.recover = n;
	}
	get deleted() {
		return (this.delInfo & FF) > 0;
	}
	get deletedBefore() {
		return (this.delInfo & 5) > 0;
	}
	get deletedAfter() {
		return (this.delInfo & 6) > 0;
	}
	get deletedAcross() {
		return (this.delInfo & PF) > 0;
	}
}, LF = class e {
	constructor(t, n = !1) {
		if (this.ranges = t, this.inverted = n, !t.length && e.empty) return e.empty;
	}
	recover(e) {
		let t = 0, n = AF(e);
		if (!this.inverted) for (let e = 0; e < n; e++) t += this.ranges[e * 3 + 2] - this.ranges[e * 3 + 1];
		return this.ranges[n * 3] + t + jF(e);
	}
	mapResult(e, t = 1) {
		return this._map(e, t, !1);
	}
	map(e, t = 1) {
		return this._map(e, t, !0);
	}
	_map(e, t, n) {
		let r = 0, i = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
		for (let o = 0; o < this.ranges.length; o += 3) {
			let s = this.ranges[o] - (this.inverted ? r : 0);
			if (s > e) break;
			let c = this.ranges[o + i], l = this.ranges[o + a], u = s + c;
			if (e <= u) {
				let i = c ? e == s ? -1 : e == u ? 1 : t : t, a = s + r + (i < 0 ? 0 : l);
				if (n) return a;
				let d = e == (t < 0 ? s : u) ? null : kF(o / 3, e - s), f = e == s ? NF : e == u ? MF : PF;
				return (t < 0 ? e != s : e != u) && (f |= FF), new IF(a, f, d);
			}
			r += l - c;
		}
		return n ? e + r : new IF(e + r, 0, null);
	}
	touches(e, t) {
		let n = 0, r = AF(t), i = this.inverted ? 2 : 1, a = this.inverted ? 1 : 2;
		for (let t = 0; t < this.ranges.length; t += 3) {
			let o = this.ranges[t] - (this.inverted ? n : 0);
			if (o > e) break;
			let s = this.ranges[t + i];
			if (e <= o + s && t == r * 3) return !0;
			n += this.ranges[t + a] - s;
		}
		return !1;
	}
	forEach(e) {
		let t = this.inverted ? 2 : 1, n = this.inverted ? 1 : 2;
		for (let r = 0, i = 0; r < this.ranges.length; r += 3) {
			let a = this.ranges[r], o = a - (this.inverted ? i : 0), s = a + (this.inverted ? 0 : i), c = this.ranges[r + t], l = this.ranges[r + n];
			e(o, o + c, s, s + l), i += l - c;
		}
	}
	invert() {
		return new e(this.ranges, !this.inverted);
	}
	toString() {
		return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
	}
	static offset(t) {
		return t == 0 ? e.empty : new e(t < 0 ? [
			0,
			-t,
			0
		] : [
			0,
			0,
			t
		]);
	}
};
LF.empty = new LF([]);
var RF = class e {
	constructor(e, t, n = 0, r = e ? e.length : 0) {
		this.mirror = t, this.from = n, this.to = r, this._maps = e || [], this.ownData = !(e || t);
	}
	get maps() {
		return this._maps;
	}
	slice(t = 0, n = this.maps.length) {
		return new e(this._maps, this.mirror, t, n);
	}
	appendMap(e, t) {
		this.ownData ||= (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), !0), this.to = this._maps.push(e), t != null && this.setMirror(this._maps.length - 1, t);
	}
	appendMapping(e) {
		for (let t = 0, n = this._maps.length; t < e._maps.length; t++) {
			let r = e.getMirror(t);
			this.appendMap(e._maps[t], r != null && r < t ? n + r : void 0);
		}
	}
	getMirror(e) {
		if (this.mirror) {
			for (let t = 0; t < this.mirror.length; t++) if (this.mirror[t] == e) return this.mirror[t + (t % 2 ? -1 : 1)];
		}
	}
	setMirror(e, t) {
		this.mirror ||= [], this.mirror.push(e, t);
	}
	appendMappingInverted(e) {
		for (let t = e.maps.length - 1, n = this._maps.length + e._maps.length; t >= 0; t--) {
			let r = e.getMirror(t);
			this.appendMap(e._maps[t].invert(), r != null && r > t ? n - r - 1 : void 0);
		}
	}
	invert() {
		let t = new e();
		return t.appendMappingInverted(this), t;
	}
	map(e, t = 1) {
		if (this.mirror) return this._map(e, t, !0);
		for (let n = this.from; n < this.to; n++) e = this._maps[n].map(e, t);
		return e;
	}
	mapResult(e, t = 1) {
		return this._map(e, t, !1);
	}
	_map(e, t, n) {
		let r = 0;
		for (let n = this.from; n < this.to; n++) {
			let i = this._maps[n].mapResult(e, t);
			if (i.recover != null) {
				let t = this.getMirror(n);
				if (t != null && t > n && t < this.to) {
					n = t, e = this._maps[t].recover(i.recover);
					continue;
				}
			}
			r |= i.delInfo, e = i.pos;
		}
		return n ? e : new IF(e, r, null);
	}
}, zF = Object.create(null), BF = class {
	getMap() {
		return LF.empty;
	}
	merge(e) {
		return null;
	}
	static fromJSON(e, t) {
		if (!t || !t.stepType) throw RangeError("Invalid input for Step.fromJSON");
		let n = zF[t.stepType];
		if (!n) throw RangeError(`No step type ${t.stepType} defined`);
		return n.fromJSON(e, t);
	}
	static jsonID(e, t) {
		if (e in zF) throw RangeError("Duplicate use of step JSON ID " + e);
		return zF[e] = t, t.prototype.jsonID = e, t;
	}
}, VF = class e {
	constructor(e, t) {
		this.doc = e, this.failed = t;
	}
	static ok(t) {
		return new e(t, null);
	}
	static fail(t) {
		return new e(null, t);
	}
	static fromReplace(t, n, r, i) {
		try {
			return e.ok(t.replace(n, r, i));
		} catch (t) {
			if (t instanceof fP) return e.fail(t.message);
			throw t;
		}
	}
};
function HF(e, t, n) {
	let r = [];
	for (let i = 0; i < e.childCount; i++) {
		let a = e.child(i);
		a.content.size && (a = a.copy(HF(a.content, t, a))), a.isInline && (a = t(a, n, i)), r.push(a);
	}
	return X.fromArray(r);
}
var UF = class e extends BF {
	constructor(e, t, n) {
		super(), this.from = e, this.to = t, this.mark = n;
	}
	apply(e) {
		let t = e.slice(this.from, this.to), n = e.resolve(this.from), r = n.node(n.sharedDepth(this.to)), i = new Z(HF(t.content, (e, t) => !e.isAtom || !t.type.allowsMarkType(this.mark.type) ? e : e.mark(this.mark.addToSet(e.marks)), r), t.openStart, t.openEnd);
		return VF.fromReplace(e, this.from, this.to, i);
	}
	invert() {
		return new WF(this.from, this.to, this.mark);
	}
	map(t) {
		let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1);
		return n.deleted && r.deleted || n.pos >= r.pos ? null : new e(n.pos, r.pos, this.mark);
	}
	merge(t) {
		return t instanceof e && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new e(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
	}
	toJSON() {
		return {
			stepType: "addMark",
			mark: this.mark.toJSON(),
			from: this.from,
			to: this.to
		};
	}
	static fromJSON(t, n) {
		if (typeof n.from != "number" || typeof n.to != "number") throw RangeError("Invalid input for AddMarkStep.fromJSON");
		return new e(n.from, n.to, t.markFromJSON(n.mark));
	}
};
BF.jsonID("addMark", UF);
var WF = class e extends BF {
	constructor(e, t, n) {
		super(), this.from = e, this.to = t, this.mark = n;
	}
	apply(e) {
		let t = e.slice(this.from, this.to), n = new Z(HF(t.content, (e) => e.mark(this.mark.removeFromSet(e.marks)), e), t.openStart, t.openEnd);
		return VF.fromReplace(e, this.from, this.to, n);
	}
	invert() {
		return new UF(this.from, this.to, this.mark);
	}
	map(t) {
		let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1);
		return n.deleted && r.deleted || n.pos >= r.pos ? null : new e(n.pos, r.pos, this.mark);
	}
	merge(t) {
		return t instanceof e && t.mark.eq(this.mark) && this.from <= t.to && this.to >= t.from ? new e(Math.min(this.from, t.from), Math.max(this.to, t.to), this.mark) : null;
	}
	toJSON() {
		return {
			stepType: "removeMark",
			mark: this.mark.toJSON(),
			from: this.from,
			to: this.to
		};
	}
	static fromJSON(t, n) {
		if (typeof n.from != "number" || typeof n.to != "number") throw RangeError("Invalid input for RemoveMarkStep.fromJSON");
		return new e(n.from, n.to, t.markFromJSON(n.mark));
	}
};
BF.jsonID("removeMark", WF);
var GF = class e extends BF {
	constructor(e, t) {
		super(), this.pos = e, this.mark = t;
	}
	apply(e) {
		let t = e.nodeAt(this.pos);
		if (!t) return VF.fail("No node at mark step's position");
		let n = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
		return VF.fromReplace(e, this.pos, this.pos + 1, new Z(X.from(n), 0, +!t.isLeaf));
	}
	invert(t) {
		let n = t.nodeAt(this.pos);
		if (n) {
			let t = this.mark.addToSet(n.marks);
			if (t.length == n.marks.length) {
				for (let r = 0; r < n.marks.length; r++) if (!n.marks[r].isInSet(t)) return new e(this.pos, n.marks[r]);
				return new e(this.pos, this.mark);
			}
		}
		return new KF(this.pos, this.mark);
	}
	map(t) {
		let n = t.mapResult(this.pos, 1);
		return n.deletedAfter ? null : new e(n.pos, this.mark);
	}
	toJSON() {
		return {
			stepType: "addNodeMark",
			pos: this.pos,
			mark: this.mark.toJSON()
		};
	}
	static fromJSON(t, n) {
		if (typeof n.pos != "number") throw RangeError("Invalid input for AddNodeMarkStep.fromJSON");
		return new e(n.pos, t.markFromJSON(n.mark));
	}
};
BF.jsonID("addNodeMark", GF);
var KF = class e extends BF {
	constructor(e, t) {
		super(), this.pos = e, this.mark = t;
	}
	apply(e) {
		let t = e.nodeAt(this.pos);
		if (!t) return VF.fail("No node at mark step's position");
		let n = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
		return VF.fromReplace(e, this.pos, this.pos + 1, new Z(X.from(n), 0, +!t.isLeaf));
	}
	invert(e) {
		let t = e.nodeAt(this.pos);
		return !t || !this.mark.isInSet(t.marks) ? this : new GF(this.pos, this.mark);
	}
	map(t) {
		let n = t.mapResult(this.pos, 1);
		return n.deletedAfter ? null : new e(n.pos, this.mark);
	}
	toJSON() {
		return {
			stepType: "removeNodeMark",
			pos: this.pos,
			mark: this.mark.toJSON()
		};
	}
	static fromJSON(t, n) {
		if (typeof n.pos != "number") throw RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
		return new e(n.pos, t.markFromJSON(n.mark));
	}
};
BF.jsonID("removeNodeMark", KF);
var qF = class e extends BF {
	constructor(e, t, n, r = !1) {
		super(), this.from = e, this.to = t, this.slice = n, this.structure = r;
	}
	apply(e) {
		return this.structure && YF(e, this.from, this.to) ? VF.fail("Structure replace would overwrite content") : VF.fromReplace(e, this.from, this.to, this.slice);
	}
	getMap() {
		return new LF([
			this.from,
			this.to - this.from,
			this.slice.size
		]);
	}
	invert(t) {
		return new e(this.from, this.from + this.slice.size, t.slice(this.from, this.to));
	}
	map(t) {
		let n = t.mapResult(this.to, -1), r = this.from == this.to && e.MAP_BIAS < 0 ? n : t.mapResult(this.from, 1);
		return r.deletedAcross && n.deletedAcross ? null : new e(r.pos, Math.max(r.pos, n.pos), this.slice, this.structure);
	}
	merge(t) {
		if (!(t instanceof e) || t.structure || this.structure) return null;
		if (this.from + this.slice.size == t.from && !this.slice.openEnd && !t.slice.openStart) {
			let n = this.slice.size + t.slice.size == 0 ? Z.empty : new Z(this.slice.content.append(t.slice.content), this.slice.openStart, t.slice.openEnd);
			return new e(this.from, this.to + (t.to - t.from), n, this.structure);
		}
		if (t.to == this.from && !this.slice.openStart && !t.slice.openEnd) {
			let n = this.slice.size + t.slice.size == 0 ? Z.empty : new Z(t.slice.content.append(this.slice.content), t.slice.openStart, this.slice.openEnd);
			return new e(t.from, this.to, n, this.structure);
		}
		return null;
	}
	toJSON() {
		let e = {
			stepType: "replace",
			from: this.from,
			to: this.to
		};
		return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
	}
	static fromJSON(t, n) {
		if (typeof n.from != "number" || typeof n.to != "number") throw RangeError("Invalid input for ReplaceStep.fromJSON");
		return new e(n.from, n.to, Z.fromJSON(t, n.slice), !!n.structure);
	}
};
qF.MAP_BIAS = 1, BF.jsonID("replace", qF);
var JF = class e extends BF {
	constructor(e, t, n, r, i, a, o = !1) {
		super(), this.from = e, this.to = t, this.gapFrom = n, this.gapTo = r, this.slice = i, this.insert = a, this.structure = o;
	}
	apply(e) {
		if (this.structure && (YF(e, this.from, this.gapFrom) || YF(e, this.gapTo, this.to))) return VF.fail("Structure gap-replace would overwrite content");
		let t = e.slice(this.gapFrom, this.gapTo);
		if (t.openStart || t.openEnd) return VF.fail("Gap is not a flat range");
		let n = this.slice.insertAt(this.insert, t.content);
		return n ? VF.fromReplace(e, this.from, this.to, n) : VF.fail("Content does not fit in gap");
	}
	getMap() {
		return new LF([
			this.from,
			this.gapFrom - this.from,
			this.insert,
			this.gapTo,
			this.to - this.gapTo,
			this.slice.size - this.insert
		]);
	}
	invert(t) {
		let n = this.gapTo - this.gapFrom;
		return new e(this.from, this.from + this.slice.size + n, this.from + this.insert, this.from + this.insert + n, t.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
	}
	map(t) {
		let n = t.mapResult(this.from, 1), r = t.mapResult(this.to, -1), i = this.from == this.gapFrom ? n.pos : t.map(this.gapFrom, -1), a = this.to == this.gapTo ? r.pos : t.map(this.gapTo, 1);
		return n.deletedAcross && r.deletedAcross || i < n.pos || a > r.pos ? null : new e(n.pos, r.pos, i, a, this.slice, this.insert, this.structure);
	}
	toJSON() {
		let e = {
			stepType: "replaceAround",
			from: this.from,
			to: this.to,
			gapFrom: this.gapFrom,
			gapTo: this.gapTo,
			insert: this.insert
		};
		return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
	}
	static fromJSON(t, n) {
		if (typeof n.from != "number" || typeof n.to != "number" || typeof n.gapFrom != "number" || typeof n.gapTo != "number" || typeof n.insert != "number") throw RangeError("Invalid input for ReplaceAroundStep.fromJSON");
		return new e(n.from, n.to, n.gapFrom, n.gapTo, Z.fromJSON(t, n.slice), n.insert, !!n.structure);
	}
};
BF.jsonID("replaceAround", JF);
function YF(e, t, n) {
	let r = e.resolve(t), i = n - t, a = r.depth;
	for (; i > 0 && a > 0 && r.indexAfter(a) == r.node(a).childCount;) a--, i--;
	if (i > 0) {
		let e = r.node(a).maybeChild(r.indexAfter(a));
		for (; i > 0;) {
			if (!e || e.isLeaf) return !0;
			e = e.firstChild, i--;
		}
	}
	return !1;
}
function XF(e, t, n, r) {
	let i = [], a = [], o, s;
	e.doc.nodesBetween(t, n, (e, c, l) => {
		if (!e.isInline) return;
		let u = e.marks;
		if (!r.isInSet(u) && l.type.allowsMarkType(r.type)) {
			let l = Math.max(c, t), d = Math.min(c + e.nodeSize, n), f = r.addToSet(u);
			for (let e = 0; e < u.length; e++) u[e].isInSet(f) || (o && o.to == l && o.mark.eq(u[e]) ? o.to = d : i.push(o = new WF(l, d, u[e])));
			s && s.to == l ? s.to = d : a.push(s = new UF(l, d, r));
		}
	}), i.forEach((t) => e.step(t)), a.forEach((t) => e.step(t));
}
function ZF(e, t, n, r) {
	let i = [], a = 0;
	e.doc.nodesBetween(t, n, (e, o) => {
		if (!e.isInline) return;
		a++;
		let s = null;
		if (r instanceof tF) {
			let t = e.marks, n;
			for (; n = r.isInSet(t);) (s ||= []).push(n), t = n.removeFromSet(t);
		} else r ? r.isInSet(e.marks) && (s = [r]) : s = e.marks;
		if (s && s.length) {
			let r = Math.min(o + e.nodeSize, n);
			for (let e = 0; e < s.length; e++) {
				let n = s[e], c;
				for (let e = 0; e < i.length; e++) {
					let t = i[e];
					t.step == a - 1 && n.eq(i[e].style) && (c = t);
				}
				c ? (c.to = r, c.step = a) : i.push({
					style: n,
					from: Math.max(o, t),
					to: r,
					step: a
				});
			}
		}
	}), i.forEach((t) => e.step(new WF(t.from, t.to, t.style)));
}
function QF(e, t, n, r = n.contentMatch, i = !0) {
	let a = e.doc.nodeAt(t), o = [], s = t + 1;
	for (let t = 0; t < a.childCount; t++) {
		let c = a.child(t), l = s + c.nodeSize, u = r.matchType(c.type);
		if (!u) o.push(new qF(s, l, Z.empty));
		else {
			r = u;
			for (let t = 0; t < c.marks.length; t++) n.allowsMarkType(c.marks[t].type) || e.step(new WF(s, l, c.marks[t]));
			if (i && c.isText && n.whitespace != "pre") {
				let e, t = /\r?\n|\r/g, r;
				for (; e = t.exec(c.text);) r ||= new Z(X.from(n.schema.text(" ", n.allowedMarks(c.marks))), 0, 0), o.push(new qF(s + e.index, s + e.index + e[0].length, r));
			}
		}
		s = l;
	}
	if (!r.validEnd) {
		let t = r.fillBefore(X.empty, !0);
		e.replace(s, s, new Z(t, 0, 0));
	}
	for (let t = o.length - 1; t >= 0; t--) e.step(o[t]);
}
function $F(e, t, n) {
	return (t == 0 || e.canReplace(t, e.childCount)) && (n == e.childCount || e.canReplace(0, n));
}
function eI(e) {
	let t = e.parent.content.cutByIndex(e.startIndex, e.endIndex);
	for (let n = e.depth, r = 0, i = 0;; --n) {
		let a = e.$from.node(n), o = e.$from.index(n) + r, s = e.$to.indexAfter(n) - i;
		if (n < e.depth && a.canReplace(o, s, t)) return n;
		if (n == 0 || a.type.spec.isolating || !$F(a, o, s)) break;
		o && (r = 1), s < a.childCount && (i = 1);
	}
	return null;
}
function tI(e, t, n) {
	let { $from: r, $to: i, depth: a } = t, o = r.before(a + 1), s = i.after(a + 1), c = o, l = s, u = X.empty, d = 0;
	for (let e = a, t = !1; e > n; e--) t || r.index(e) > 0 ? (t = !0, u = X.from(r.node(e).copy(u)), d++) : c--;
	let f = X.empty, p = 0;
	for (let e = a, t = !1; e > n; e--) t || i.after(e + 1) < i.end(e) ? (t = !0, f = X.from(i.node(e).copy(f)), p++) : l++;
	e.step(new JF(c, l, o, s, new Z(u.append(f), d, p), u.size - d, !0));
}
function nI(e, t, n = null, r = e) {
	let i = iI(e, t), a = i && aI(r, t);
	return a ? i.map(rI).concat({
		type: t,
		attrs: n
	}).concat(a.map(rI)) : null;
}
function rI(e) {
	return {
		type: e,
		attrs: null
	};
}
function iI(e, t) {
	let { parent: n, startIndex: r, endIndex: i } = e, a = n.contentMatchAt(r).findWrapping(t);
	if (!a) return null;
	let o = a.length ? a[0] : t;
	return n.canReplaceWith(r, i, o) ? a : null;
}
function aI(e, t) {
	let { parent: n, startIndex: r, endIndex: i } = e, a = n.child(r), o = t.contentMatch.findWrapping(a.type);
	if (!o) return null;
	let s = (o.length ? o[o.length - 1] : t).contentMatch;
	for (let e = r; s && e < i; e++) s = s.matchType(n.child(e).type);
	return !s || !s.validEnd ? null : o;
}
function oI(e, t, n) {
	let r = X.empty;
	for (let e = n.length - 1; e >= 0; e--) {
		if (r.size) {
			let t = n[e].type.contentMatch.matchFragment(r);
			if (!t || !t.validEnd) throw RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
		}
		r = X.from(n[e].type.create(n[e].attrs, r));
	}
	let i = t.start, a = t.end;
	e.step(new JF(i, a, i, a, new Z(r, 0, 0), n.length, !0));
}
function sI(e, t, n, r, i) {
	if (!r.isTextblock) throw RangeError("Type given to setBlockType should be a textblock");
	let a = e.steps.length;
	e.doc.nodesBetween(t, n, (t, n) => {
		let o = typeof i == "function" ? i(t) : i;
		if (t.isTextblock && !t.hasMarkup(r, o) && uI(e.doc, e.mapping.slice(a).map(n), r)) {
			let i = null;
			if (r.schema.linebreakReplacement) {
				let e = r.whitespace == "pre", t = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
				e && !t ? i = !1 : !e && t && (i = !0);
			}
			i === !1 && lI(e, t, n, a), QF(e, e.mapping.slice(a).map(n, 1), r, void 0, i === null);
			let s = e.mapping.slice(a), c = s.map(n, 1), l = s.map(n + t.nodeSize, 1);
			return e.step(new JF(c, l, c + 1, l - 1, new Z(X.from(r.create(o, null, t.marks)), 0, 0), 1, !0)), i === !0 && cI(e, t, n, a), !1;
		}
	});
}
function cI(e, t, n, r) {
	t.forEach((i, a) => {
		if (i.isText) {
			let o, s = /\r?\n|\r/g;
			for (; o = s.exec(i.text);) {
				let i = e.mapping.slice(r).map(n + 1 + a + o.index);
				e.replaceWith(i, i + 1, t.type.schema.linebreakReplacement.create());
			}
		}
	});
}
function lI(e, t, n, r) {
	t.forEach((i, a) => {
		if (i.type == i.type.schema.linebreakReplacement) {
			let i = e.mapping.slice(r).map(n + 1 + a);
			e.replaceWith(i, i + 1, t.type.schema.text("\n"));
		}
	});
}
function uI(e, t, n) {
	let r = e.resolve(t), i = r.index();
	return r.parent.canReplaceWith(i, i + 1, n);
}
function dI(e, t, n, r, i) {
	let a = e.doc.nodeAt(t);
	if (!a) throw RangeError("No node at given position");
	n ||= a.type;
	let o = n.create(r, null, i || a.marks);
	if (a.isLeaf) return e.replaceWith(t, t + a.nodeSize, o);
	if (!n.validContent(a.content)) throw RangeError("Invalid content for node type " + n.name);
	e.step(new JF(t, t + a.nodeSize, t + 1, t + a.nodeSize - 1, new Z(X.from(o), 0, 0), 1, !0));
}
function fI(e, t, n = 1, r) {
	let i = e.resolve(t), a = i.depth - n, o = r && r[r.length - 1] || i.parent;
	if (a < 0 || i.parent.type.spec.isolating || !i.parent.canReplace(i.index(), i.parent.childCount) || !o.type.validContent(i.parent.content.cutByIndex(i.index(), i.parent.childCount))) return !1;
	for (let e = i.depth - 1, t = n - 2; e > a; e--, t--) {
		let n = i.node(e), a = i.index(e);
		if (n.type.spec.isolating) return !1;
		let o = n.content.cutByIndex(a, n.childCount), s = r && r[t + 1];
		s && (o = o.replaceChild(0, s.type.create(s.attrs)));
		let c = r && r[t] || n;
		if (!n.canReplace(a + 1, n.childCount) || !c.type.validContent(o)) return !1;
	}
	let s = i.indexAfter(a), c = r && r[0];
	return i.node(a).canReplaceWith(s, s, c ? c.type : i.node(a + 1).type);
}
function pI(e, t, n = 1, r) {
	let i = e.doc.resolve(t), a = X.empty, o = X.empty;
	for (let e = i.depth, t = i.depth - n, s = n - 1; e > t; e--, s--) {
		a = X.from(i.node(e).copy(a));
		let t = r && r[s];
		o = X.from(t ? t.type.create(t.attrs, o) : i.node(e).copy(o));
	}
	e.step(new qF(t, t, new Z(a.append(o), n, n), !0));
}
function mI(e, t) {
	let n = e.resolve(t), r = n.index();
	return gI(n.nodeBefore, n.nodeAfter) && n.parent.canReplace(r, r + 1);
}
function hI(e, t) {
	t.content.size || e.type.compatibleContent(t.type);
	let n = e.contentMatchAt(e.childCount), { linebreakReplacement: r } = e.type.schema;
	for (let i = 0; i < t.childCount; i++) {
		let a = t.child(i), o = a.type == r ? e.type.schema.nodes.text : a.type;
		if (n = n.matchType(o), !n || !e.type.allowsMarks(a.marks)) return !1;
	}
	return n.validEnd;
}
function gI(e, t) {
	return !!(e && t && !e.isLeaf && hI(e, t));
}
function _I(e, t, n = -1) {
	let r = e.resolve(t);
	for (let e = r.depth;; e--) {
		let i, a, o = r.index(e);
		if (e == r.depth ? (i = r.nodeBefore, a = r.nodeAfter) : n > 0 ? (i = r.node(e + 1), o++, a = r.node(e).maybeChild(o)) : (i = r.node(e).maybeChild(o - 1), a = r.node(e + 1)), i && !i.isTextblock && gI(i, a) && r.node(e).canReplace(o, o + 1)) return t;
		if (e == 0) break;
		t = n < 0 ? r.before(e) : r.after(e);
	}
}
function vI(e, t, n) {
	let r = null, { linebreakReplacement: i } = e.doc.type.schema, a = e.doc.resolve(t - n), o = a.node().type;
	if (i && o.inlineContent) {
		let e = o.whitespace == "pre", t = !!o.contentMatch.matchType(i);
		e && !t ? r = !1 : !e && t && (r = !0);
	}
	let s = e.steps.length;
	if (r === !1) {
		let r = e.doc.resolve(t + n);
		lI(e, r.node(), r.before(), s);
	}
	o.inlineContent && QF(e, t + n - 1, o, a.node().contentMatchAt(a.index()), r == null);
	let c = e.mapping.slice(s), l = c.map(t - n);
	if (e.step(new qF(l, c.map(t + n, -1), Z.empty, !0)), r === !0) {
		let t = e.doc.resolve(l);
		cI(e, t.node(), t.before(), e.steps.length);
	}
	return e;
}
function yI(e, t, n) {
	let r = e.resolve(t);
	if (r.parent.canReplaceWith(r.index(), r.index(), n)) return t;
	if (r.parentOffset == 0) for (let e = r.depth - 1; e >= 0; e--) {
		let t = r.index(e);
		if (r.node(e).canReplaceWith(t, t, n)) return r.before(e + 1);
		if (t > 0) return null;
	}
	if (r.parentOffset == r.parent.content.size) for (let e = r.depth - 1; e >= 0; e--) {
		let t = r.indexAfter(e);
		if (r.node(e).canReplaceWith(t, t, n)) return r.after(e + 1);
		if (t < r.node(e).childCount) return null;
	}
	return null;
}
function bI(e, t, n) {
	let r = e.resolve(t);
	if (!n.content.size) return t;
	let i = n.content;
	for (let e = 0; e < n.openStart; e++) i = i.firstChild.content;
	for (let e = 1; e <= (n.openStart == 0 && n.size ? 2 : 1); e++) for (let t = r.depth; t >= 0; t--) {
		let n = t == r.depth ? 0 : r.pos <= (r.start(t + 1) + r.end(t + 1)) / 2 ? -1 : 1, a = r.index(t) + +(n > 0), o = r.node(t), s = !1;
		if (e == 1) s = o.canReplace(a, a, i);
		else {
			let e = o.contentMatchAt(a).findWrapping(i.firstChild.type);
			s = e && o.canReplaceWith(a, a, e[0]);
		}
		if (s) return n == 0 ? r.pos : n < 0 ? r.before(t + 1) : r.after(t + 1);
	}
	return null;
}
function xI(e, t, n = t, r = Z.empty) {
	if (t == n && !r.size) return null;
	let i = e.resolve(t), a = e.resolve(n);
	return SI(i, a, r) ? new qF(t, n, r) : new CI(i, a, r).fit();
}
function SI(e, t, n) {
	return !n.openStart && !n.openEnd && e.start() == t.start() && e.parent.canReplace(e.index(), t.index(), n.content);
}
var CI = class {
	constructor(e, t, n) {
		this.$from = e, this.$to = t, this.unplaced = n, this.frontier = [], this.placed = X.empty;
		for (let t = 0; t <= e.depth; t++) {
			let n = e.node(t);
			this.frontier.push({
				type: n.type,
				match: n.contentMatchAt(e.indexAfter(t))
			});
		}
		for (let t = e.depth; t > 0; t--) this.placed = X.from(e.node(t).copy(this.placed));
	}
	get depth() {
		return this.frontier.length - 1;
	}
	fit() {
		for (; this.unplaced.size;) {
			let e = this.findFittable();
			e ? this.placeNodes(e) : this.openMore() || this.dropNode();
		}
		let e = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, n = this.$from, r = this.close(e < 0 ? this.$to : n.doc.resolve(e));
		if (!r) return null;
		let i = this.placed, a = n.depth, o = r.depth;
		for (; a && o && i.childCount == 1;) i = i.firstChild.content, a--, o--;
		let s = new Z(i, a, o);
		return e > -1 ? new JF(n.pos, e, this.$to.pos, this.$to.end(), s, t) : s.size || n.pos != this.$to.pos ? new qF(n.pos, r.pos, s) : null;
	}
	findFittable() {
		let e = this.unplaced.openStart;
		for (let t = this.unplaced.content, n = 0, r = this.unplaced.openEnd; n < e; n++) {
			let i = t.firstChild;
			if (t.childCount > 1 && (r = 0), i.type.spec.isolating && r <= n) {
				e = n;
				break;
			}
			t = i.content;
		}
		for (let t = 1; t <= 2; t++) for (let n = t == 1 ? e : this.unplaced.openStart; n >= 0; n--) {
			let e, r = null;
			n ? (r = EI(this.unplaced.content, n - 1).firstChild, e = r.content) : e = this.unplaced.content;
			let i = e.firstChild;
			for (let e = this.depth; e >= 0; e--) {
				let { type: a, match: o } = this.frontier[e], s, c = null;
				if (t == 1 && (i ? o.matchType(i.type) || (c = o.fillBefore(X.from(i), !1)) : r && a.compatibleContent(r.type))) return {
					sliceDepth: n,
					frontierDepth: e,
					parent: r,
					inject: c
				};
				if (t == 2 && i && (s = o.findWrapping(i.type))) return {
					sliceDepth: n,
					frontierDepth: e,
					parent: r,
					wrap: s
				};
				if (r && o.matchType(r.type)) break;
			}
		}
	}
	openMore() {
		let { content: e, openStart: t, openEnd: n } = this.unplaced, r = EI(e, t);
		return !r.childCount || r.firstChild.isLeaf ? !1 : (this.unplaced = new Z(e, t + 1, Math.max(n, r.size + t >= e.size - n ? t + 1 : 0)), !0);
	}
	dropNode() {
		let { content: e, openStart: t, openEnd: n } = this.unplaced, r = EI(e, t);
		if (r.childCount <= 1 && t > 0) {
			let i = e.size - t <= t + r.size;
			this.unplaced = new Z(wI(e, t - 1, 1), t - 1, i ? t - 1 : n);
		} else this.unplaced = new Z(wI(e, t, 1), t, n);
	}
	placeNodes({ sliceDepth: e, frontierDepth: t, parent: n, inject: r, wrap: i }) {
		for (; this.depth > t;) this.closeFrontierNode();
		if (i) for (let e = 0; e < i.length; e++) this.openFrontierNode(i[e]);
		let a = this.unplaced, o = n ? n.content : a.content, s = a.openStart - e, c = 0, l = [], { match: u, type: d } = this.frontier[t];
		if (r) {
			for (let e = 0; e < r.childCount; e++) l.push(r.child(e));
			u = u.matchFragment(r);
		}
		let f = o.size + e - (a.content.size - a.openEnd);
		for (; c < o.childCount;) {
			let e = o.child(c), t = u.matchType(e.type);
			if (!t) break;
			c++, (c > 1 || s == 0 || e.content.size) && (u = t, l.push(DI(e.mark(d.allowedMarks(e.marks)), c == 1 ? s : 0, c == o.childCount ? f : -1)));
		}
		let p = c == o.childCount;
		p || (f = -1), this.placed = TI(this.placed, t, X.from(l)), this.frontier[t].match = u, p && f < 0 && n && n.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
		for (let e = 0, t = o; e < f; e++) {
			let e = t.lastChild;
			this.frontier.push({
				type: e.type,
				match: e.contentMatchAt(e.childCount)
			}), t = e.content;
		}
		this.unplaced = p ? e == 0 ? Z.empty : new Z(wI(a.content, e - 1, 1), e - 1, f < 0 ? a.openEnd : e - 1) : new Z(wI(a.content, e, c), a.openStart, a.openEnd);
	}
	mustMoveInline() {
		if (!this.$to.parent.isTextblock) return -1;
		let e = this.frontier[this.depth], t;
		if (!e.type.isTextblock || !OI(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth) return -1;
		let { depth: n } = this.$to, r = this.$to.after(n);
		for (; n > 1 && r == this.$to.end(--n);) ++r;
		return r;
	}
	findCloseLevel(e) {
		scan: for (let t = Math.min(this.depth, e.depth); t >= 0; t--) {
			let { match: n, type: r } = this.frontier[t], i = t < e.depth && e.end(t + 1) == e.pos + (e.depth - (t + 1)), a = OI(e, t, r, n, i);
			if (a) {
				for (let n = t - 1; n >= 0; n--) {
					let { match: t, type: r } = this.frontier[n], i = OI(e, n, r, t, !0);
					if (!i || i.childCount) continue scan;
				}
				return {
					depth: t,
					fit: a,
					move: i ? e.doc.resolve(e.after(t + 1)) : e
				};
			}
		}
	}
	close(e) {
		let t = this.findCloseLevel(e);
		if (!t) return null;
		for (; this.depth > t.depth;) this.closeFrontierNode();
		t.fit.childCount && (this.placed = TI(this.placed, t.depth, t.fit)), e = t.move;
		for (let n = t.depth + 1; n <= e.depth; n++) {
			let t = e.node(n), r = t.type.contentMatch.fillBefore(t.content, !0, e.index(n));
			this.openFrontierNode(t.type, t.attrs, r);
		}
		return e;
	}
	openFrontierNode(e, t = null, n) {
		let r = this.frontier[this.depth];
		r.match = r.match.matchType(e), this.placed = TI(this.placed, this.depth, X.from(e.create(t, n))), this.frontier.push({
			type: e,
			match: e.contentMatch
		});
	}
	closeFrontierNode() {
		let e = this.frontier.pop().match.fillBefore(X.empty, !0);
		e.childCount && (this.placed = TI(this.placed, this.frontier.length, e));
	}
};
function wI(e, t, n) {
	return t == 0 ? e.cutByIndex(n, e.childCount) : e.replaceChild(0, e.firstChild.copy(wI(e.firstChild.content, t - 1, n)));
}
function TI(e, t, n) {
	return t == 0 ? e.append(n) : e.replaceChild(e.childCount - 1, e.lastChild.copy(TI(e.lastChild.content, t - 1, n)));
}
function EI(e, t) {
	for (let n = 0; n < t; n++) e = e.firstChild.content;
	return e;
}
function DI(e, t, n) {
	if (t <= 0) return e;
	let r = e.content;
	return t > 1 && (r = r.replaceChild(0, DI(r.firstChild, t - 1, r.childCount == 1 ? n - 1 : 0))), t > 0 && (r = e.type.contentMatch.fillBefore(r).append(r), n <= 0 && (r = r.append(e.type.contentMatch.matchFragment(r).fillBefore(X.empty, !0)))), e.copy(r);
}
function OI(e, t, n, r, i) {
	let a = e.node(t), o = i ? e.indexAfter(t) : e.index(t);
	if (o == a.childCount && !n.compatibleContent(a.type)) return null;
	let s = r.fillBefore(a.content, !0, o);
	return s && !kI(n, a.content, o) ? s : null;
}
function kI(e, t, n) {
	for (let r = n; r < t.childCount; r++) if (!e.allowsMarks(t.child(r).marks)) return !0;
	return !1;
}
function AI(e) {
	return e.spec.defining || e.spec.definingForContent;
}
function jI(e, t, n, r) {
	if (!r.size) return e.deleteRange(t, n);
	let i = e.doc.resolve(t), a = e.doc.resolve(n);
	if (SI(i, a, r)) return e.step(new qF(t, n, r));
	let o = FI(i, a);
	o[o.length - 1] == 0 && o.pop();
	let s = -(i.depth + 1);
	o.unshift(s);
	for (let e = i.depth, t = i.pos - 1; e > 0; e--, t--) {
		let n = i.node(e).type.spec;
		if (n.defining || n.definingAsContext || n.isolating) break;
		o.indexOf(e) > -1 ? s = e : i.before(e) == t && o.splice(1, 0, -e);
	}
	let c = o.indexOf(s), l = [], u = r.openStart;
	for (let e = r.content, t = 0;; t++) {
		let n = e.firstChild;
		if (l.push(n), t == r.openStart) break;
		e = n.content;
	}
	for (let e = u - 1; e >= 0; e--) {
		let t = l[e], n = AI(t.type);
		if (n && !t.sameMarkup(i.node(Math.abs(s) - 1))) u = e;
		else if (n || !t.type.isTextblock) break;
	}
	for (let t = r.openStart; t >= 0; t--) {
		let s = (t + u + 1) % (r.openStart + 1), d = l[s];
		if (d) for (let t = 0; t < o.length; t++) {
			let l = o[(t + c) % o.length], u = !0;
			l < 0 && (u = !1, l = -l);
			let f = i.node(l - 1), p = i.index(l - 1);
			if (f.canReplaceWith(p, p, d.type, d.marks)) return e.replace(i.before(l), u ? a.after(l) : n, new Z(MI(r.content, 0, r.openStart, s), s, r.openEnd));
		}
	}
	let d = e.steps.length;
	for (let s = o.length - 1; s >= 0 && (e.replace(t, n, r), !(e.steps.length > d)); s--) {
		let e = o[s];
		e < 0 || (t = i.before(e), n = a.after(e));
	}
}
function MI(e, t, n, r, i) {
	if (t < n) {
		let i = e.firstChild;
		e = e.replaceChild(0, i.copy(MI(i.content, t + 1, n, r, i)));
	}
	if (t > r) {
		let t = i.contentMatchAt(0), n = t.fillBefore(e).append(e);
		e = n.append(t.matchFragment(n).fillBefore(X.empty, !0));
	}
	return e;
}
function NI(e, t, n, r) {
	if (!r.isInline && t == n && e.doc.resolve(t).parent.content.size) {
		let i = yI(e.doc, t, r.type);
		i != null && (t = n = i);
	}
	e.replaceRange(t, n, new Z(X.from(r), 0, 0));
}
function PI(e, t, n) {
	let r = e.doc.resolve(t), i = e.doc.resolve(n);
	if (r.parent.isTextblock && i.parent.isTextblock && r.start() != i.start() && r.parentOffset == 0 && i.parentOffset == 0) {
		let a = r.sharedDepth(n), o = !1;
		for (let e = r.depth; e > a; e--) r.node(e).type.spec.isolating && (o = !0);
		for (let e = i.depth; e > a; e--) i.node(e).type.spec.isolating && (o = !0);
		if (!o) {
			for (let e = r.depth; e > 0 && t == r.start(e); e--) t = r.before(e);
			for (let e = i.depth; e > 0 && n == i.start(e); e--) n = i.before(e);
			r = e.doc.resolve(t), i = e.doc.resolve(n);
		}
	}
	let a = FI(r, i);
	for (let t = 0; t < a.length; t++) {
		let n = a[t], o = t == a.length - 1;
		if (o && n == 0 || r.node(n).type.contentMatch.validEnd) return e.delete(r.start(n), i.end(n));
		if (n > 0 && (o || r.node(n - 1).canReplace(r.index(n - 1), i.indexAfter(n - 1)))) return e.delete(r.before(n), i.after(n));
	}
	for (let a = 1; a <= r.depth && a <= i.depth; a++) if (t - r.start(a) == r.depth - a && n > r.end(a) && i.end(a) - n != i.depth - a && r.start(a - 1) == i.start(a - 1) && r.node(a - 1).canReplace(r.index(a - 1), i.index(a - 1))) return e.delete(r.before(a), n);
	e.delete(t, n);
}
function FI(e, t) {
	let n = [], r = Math.min(e.depth, t.depth);
	for (let i = r; i >= 0; i--) {
		let r = e.start(i);
		if (r < e.pos - (e.depth - i) || t.end(i) > t.pos + (t.depth - i) || e.node(i).type.spec.isolating || t.node(i).type.spec.isolating) break;
		(r == t.start(i) || i == e.depth && i == t.depth && e.parent.inlineContent && t.parent.inlineContent && i && t.start(i - 1) == r - 1) && n.push(i);
	}
	return n;
}
var II = class e extends BF {
	constructor(e, t, n) {
		super(), this.pos = e, this.attr = t, this.value = n;
	}
	apply(e) {
		let t = e.nodeAt(this.pos);
		if (!t) return VF.fail("No node at attribute step's position");
		let n = Object.create(null);
		for (let e in t.attrs) n[e] = t.attrs[e];
		n[this.attr] = this.value;
		let r = t.type.create(n, null, t.marks);
		return VF.fromReplace(e, this.pos, this.pos + 1, new Z(X.from(r), 0, +!t.isLeaf));
	}
	getMap() {
		return LF.empty;
	}
	invert(t) {
		return new e(this.pos, this.attr, t.nodeAt(this.pos).attrs[this.attr]);
	}
	map(t) {
		let n = t.mapResult(this.pos, 1);
		return n.deletedAfter ? null : new e(n.pos, this.attr, this.value);
	}
	toJSON() {
		return {
			stepType: "attr",
			pos: this.pos,
			attr: this.attr,
			value: this.value
		};
	}
	static fromJSON(t, n) {
		if (typeof n.pos != "number" || typeof n.attr != "string") throw RangeError("Invalid input for AttrStep.fromJSON");
		return new e(n.pos, n.attr, n.value);
	}
};
BF.jsonID("attr", II);
var LI = class e extends BF {
	constructor(e, t) {
		super(), this.attr = e, this.value = t;
	}
	apply(e) {
		let t = Object.create(null);
		for (let n in e.attrs) t[n] = e.attrs[n];
		t[this.attr] = this.value;
		let n = e.type.create(t, e.content, e.marks);
		return VF.ok(n);
	}
	getMap() {
		return LF.empty;
	}
	invert(t) {
		return new e(this.attr, t.attrs[this.attr]);
	}
	map(e) {
		return this;
	}
	toJSON() {
		return {
			stepType: "docAttr",
			attr: this.attr,
			value: this.value
		};
	}
	static fromJSON(t, n) {
		if (typeof n.attr != "string") throw RangeError("Invalid input for DocAttrStep.fromJSON");
		return new e(n.attr, n.value);
	}
};
BF.jsonID("docAttr", LI);
var RI = class extends Error {};
RI = function e(t) {
	let n = Error.call(this, t);
	return n.__proto__ = e.prototype, n;
}, RI.prototype = Object.create(Error.prototype), RI.prototype.constructor = RI, RI.prototype.name = "TransformError";
var zI = class {
	constructor(e) {
		this.doc = e, this.steps = [], this.docs = [], this.mapping = new RF();
	}
	get before() {
		return this.docs.length ? this.docs[0] : this.doc;
	}
	step(e) {
		let t = this.maybeStep(e);
		if (t.failed) throw new RI(t.failed);
		return this;
	}
	maybeStep(e) {
		let t = e.apply(this.doc);
		return t.failed || this.addStep(e, t.doc), t;
	}
	get docChanged() {
		return this.steps.length > 0;
	}
	changedRange() {
		let e = 1e9, t = -1e9;
		for (let n = 0; n < this.mapping.maps.length; n++) {
			let r = this.mapping.maps[n];
			n && (e = r.map(e, 1), t = r.map(t, -1)), r.forEach((n, r, i, a) => {
				e = Math.min(e, i), t = Math.max(t, a);
			});
		}
		return e == 1e9 ? null : {
			from: e,
			to: t
		};
	}
	addStep(e, t) {
		this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = t;
	}
	replace(e, t = e, n = Z.empty) {
		let r = xI(this.doc, e, t, n);
		return r && this.step(r), this;
	}
	replaceWith(e, t, n) {
		return this.replace(e, t, new Z(X.from(n), 0, 0));
	}
	delete(e, t) {
		return this.replace(e, t, Z.empty);
	}
	insert(e, t) {
		return this.replaceWith(e, e, t);
	}
	replaceRange(e, t, n) {
		return jI(this, e, t, n), this;
	}
	replaceRangeWith(e, t, n) {
		return NI(this, e, t, n), this;
	}
	deleteRange(e, t) {
		return PI(this, e, t), this;
	}
	lift(e, t) {
		return tI(this, e, t), this;
	}
	join(e, t = 1) {
		return vI(this, e, t), this;
	}
	wrap(e, t) {
		return oI(this, e, t), this;
	}
	setBlockType(e, t = e, n, r = null) {
		return sI(this, e, t, n, r), this;
	}
	setNodeMarkup(e, t, n = null, r) {
		return dI(this, e, t, n, r), this;
	}
	setNodeAttribute(e, t, n) {
		return this.step(new II(e, t, n)), this;
	}
	setDocAttribute(e, t) {
		return this.step(new LI(e, t)), this;
	}
	addNodeMark(e, t) {
		return this.step(new GF(e, t)), this;
	}
	removeNodeMark(e, t) {
		let n = this.doc.nodeAt(e);
		if (!n) throw RangeError("No node at position " + e);
		if (t instanceof dP) t.isInSet(n.marks) && this.step(new KF(e, t));
		else {
			let r = n.marks, i, a = [];
			for (; i = t.isInSet(r);) a.push(new KF(e, i)), r = i.removeFromSet(r);
			for (let e = a.length - 1; e >= 0; e--) this.step(a[e]);
		}
		return this;
	}
	split(e, t = 1, n) {
		return pI(this, e, t, n), this;
	}
	addMark(e, t, n) {
		return XF(this, e, t, n), this;
	}
	removeMark(e, t, n) {
		return ZF(this, e, t, n), this;
	}
	clearIncompatible(e, t, n) {
		return QF(this, e, t, n), this;
	}
}, BI = Object.create(null), VI = class {
	constructor(e, t, n) {
		this.$anchor = e, this.$head = t, this.ranges = n || [new HI(e.min(t), e.max(t))];
	}
	get anchor() {
		return this.$anchor.pos;
	}
	get head() {
		return this.$head.pos;
	}
	get from() {
		return this.$from.pos;
	}
	get to() {
		return this.$to.pos;
	}
	get $from() {
		return this.ranges[0].$from;
	}
	get $to() {
		return this.ranges[0].$to;
	}
	get empty() {
		let e = this.ranges;
		for (let t = 0; t < e.length; t++) if (e[t].$from.pos != e[t].$to.pos) return !1;
		return !0;
	}
	content() {
		return this.$from.doc.slice(this.from, this.to, !0);
	}
	replace(e, t = Z.empty) {
		let n = t.content.lastChild, r = null;
		for (let e = 0; e < t.openEnd; e++) r = n, n = n.lastChild;
		let i = e.steps.length, a = this.ranges;
		for (let o = 0; o < a.length; o++) {
			let { $from: s, $to: c } = a[o], l = e.mapping.slice(i);
			e.replaceRange(l.map(s.pos), l.map(c.pos), o ? Z.empty : t), o == 0 && QI(e, i, (n ? n.isInline : r && r.isTextblock) ? -1 : 1);
		}
	}
	replaceWith(e, t) {
		let n = e.steps.length, r = this.ranges;
		for (let i = 0; i < r.length; i++) {
			let { $from: a, $to: o } = r[i], s = e.mapping.slice(n), c = s.map(a.pos), l = s.map(o.pos);
			i ? e.deleteRange(c, l) : (e.replaceRangeWith(c, l, t), QI(e, n, t.isInline ? -1 : 1));
		}
	}
	static findFrom(e, t, n = !1) {
		let r = e.parent.inlineContent ? new GI(e) : ZI(e.node(0), e.parent, e.pos, e.index(), t, n);
		if (r) return r;
		for (let r = e.depth - 1; r >= 0; r--) {
			let i = t < 0 ? ZI(e.node(0), e.node(r), e.before(r + 1), e.index(r), t, n) : ZI(e.node(0), e.node(r), e.after(r + 1), e.index(r) + 1, t, n);
			if (i) return i;
		}
		return null;
	}
	static near(e, t = 1) {
		return this.findFrom(e, t) || this.findFrom(e, -t) || new YI(e.node(0));
	}
	static atStart(e) {
		return ZI(e, e, 0, 0, 1) || new YI(e);
	}
	static atEnd(e) {
		return ZI(e, e, e.content.size, e.childCount, -1) || new YI(e);
	}
	static fromJSON(e, t) {
		if (!t || !t.type) throw RangeError("Invalid input for Selection.fromJSON");
		let n = BI[t.type];
		if (!n) throw RangeError(`No selection type ${t.type} defined`);
		return n.fromJSON(e, t);
	}
	static jsonID(e, t) {
		if (e in BI) throw RangeError("Duplicate use of selection JSON ID " + e);
		return BI[e] = t, t.prototype.jsonID = e, t;
	}
	getBookmark() {
		return GI.between(this.$anchor, this.$head).getBookmark();
	}
};
VI.prototype.visible = !0;
var HI = class {
	constructor(e, t) {
		this.$from = e, this.$to = t;
	}
}, UI = !1;
function WI(e) {
	!UI && !e.parent.inlineContent && (UI = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + e.parent.type.name + ")"));
}
var GI = class e extends VI {
	constructor(e, t = e) {
		WI(e), WI(t), super(e, t);
	}
	get $cursor() {
		return this.$anchor.pos == this.$head.pos ? this.$head : null;
	}
	map(t, n) {
		let r = t.resolve(n.map(this.head));
		if (!r.parent.inlineContent) return VI.near(r);
		let i = t.resolve(n.map(this.anchor));
		return new e(i.parent.inlineContent ? i : r, r);
	}
	replace(e, t = Z.empty) {
		if (super.replace(e, t), t == Z.empty) {
			let t = this.$from.marksAcross(this.$to);
			t && e.ensureMarks(t);
		}
	}
	eq(t) {
		return t instanceof e && t.anchor == this.anchor && t.head == this.head;
	}
	getBookmark() {
		return new KI(this.anchor, this.head);
	}
	toJSON() {
		return {
			type: "text",
			anchor: this.anchor,
			head: this.head
		};
	}
	static fromJSON(t, n) {
		if (typeof n.anchor != "number" || typeof n.head != "number") throw RangeError("Invalid input for TextSelection.fromJSON");
		return new e(t.resolve(n.anchor), t.resolve(n.head));
	}
	static create(e, t, n = t) {
		let r = e.resolve(t);
		return new this(r, n == t ? r : e.resolve(n));
	}
	static between(t, n, r) {
		let i = t.pos - n.pos;
		if ((!r || i) && (r = i >= 0 ? 1 : -1), !n.parent.inlineContent) {
			let e = VI.findFrom(n, r, !0) || VI.findFrom(n, -r, !0);
			if (e) n = e.$head;
			else return VI.near(n, r);
		}
		return t.parent.inlineContent || (i == 0 ? t = n : (t = (VI.findFrom(t, -r, !0) || VI.findFrom(t, r, !0)).$anchor, t.pos < n.pos != i < 0 && (t = n))), new e(t, n);
	}
};
VI.jsonID("text", GI);
var KI = class e {
	constructor(e, t) {
		this.anchor = e, this.head = t;
	}
	map(t) {
		return new e(t.map(this.anchor), t.map(this.head));
	}
	resolve(e) {
		return GI.between(e.resolve(this.anchor), e.resolve(this.head));
	}
}, qI = class e extends VI {
	constructor(e) {
		let t = e.nodeAfter, n = e.node(0).resolve(e.pos + t.nodeSize);
		super(e, n), this.node = t;
	}
	map(t, n) {
		let { deleted: r, pos: i } = n.mapResult(this.anchor), a = t.resolve(i);
		return r ? VI.near(a) : new e(a);
	}
	content() {
		return new Z(X.from(this.node), 0, 0);
	}
	eq(t) {
		return t instanceof e && t.anchor == this.anchor;
	}
	toJSON() {
		return {
			type: "node",
			anchor: this.anchor
		};
	}
	getBookmark() {
		return new JI(this.anchor);
	}
	static fromJSON(t, n) {
		if (typeof n.anchor != "number") throw RangeError("Invalid input for NodeSelection.fromJSON");
		return new e(t.resolve(n.anchor));
	}
	static create(t, n) {
		return new e(t.resolve(n));
	}
	static isSelectable(e) {
		return !e.isText && e.type.spec.selectable !== !1;
	}
};
qI.prototype.visible = !1, VI.jsonID("node", qI);
var JI = class e {
	constructor(e) {
		this.anchor = e;
	}
	map(t) {
		let { deleted: n, pos: r } = t.mapResult(this.anchor);
		return n ? new KI(r, r) : new e(r);
	}
	resolve(e) {
		let t = e.resolve(this.anchor), n = t.nodeAfter;
		return n && qI.isSelectable(n) ? new qI(t) : VI.near(t);
	}
}, YI = class e extends VI {
	constructor(e) {
		super(e.resolve(0), e.resolve(e.content.size));
	}
	replace(e, t = Z.empty) {
		if (t == Z.empty) {
			e.delete(0, e.doc.content.size);
			let t = VI.atStart(e.doc);
			t.eq(e.selection) || e.setSelection(t);
		} else super.replace(e, t);
	}
	toJSON() {
		return { type: "all" };
	}
	static fromJSON(t) {
		return new e(t);
	}
	map(t) {
		return new e(t);
	}
	eq(t) {
		return t instanceof e;
	}
	getBookmark() {
		return XI;
	}
};
VI.jsonID("all", YI);
var XI = {
	map() {
		return this;
	},
	resolve(e) {
		return new YI(e);
	}
};
function ZI(e, t, n, r, i, a = !1) {
	if (t.inlineContent) return GI.create(e, n);
	for (let o = r - (i > 0 ? 0 : 1); i > 0 ? o < t.childCount : o >= 0; o += i) {
		let r = t.child(o);
		if (!r.isAtom) {
			let t = ZI(e, r, n + i, i < 0 ? r.childCount : 0, i, a);
			if (t) return t;
		} else if (!a && qI.isSelectable(r)) return qI.create(e, n - (i < 0 ? r.nodeSize : 0));
		n += r.nodeSize * i;
	}
	return null;
}
function QI(e, t, n) {
	let r = e.steps.length - 1;
	if (r < t) return;
	let i = e.steps[r];
	if (!(i instanceof qF || i instanceof JF)) return;
	let a = e.mapping.maps[r], o;
	a.forEach((e, t, n, r) => {
		o ??= r;
	}), e.setSelection(VI.near(e.doc.resolve(o), n));
}
var $I = 1, eL = 2, tL = 4, nL = class extends zI {
	constructor(e) {
		super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
	}
	get selection() {
		return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
	}
	setSelection(e) {
		if (e.$from.doc != this.doc) throw RangeError("Selection passed to setSelection must point at the current document");
		return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | $I) & -3, this.storedMarks = null, this;
	}
	get selectionSet() {
		return (this.updated & $I) > 0;
	}
	setStoredMarks(e) {
		return this.storedMarks = e, this.updated |= eL, this;
	}
	ensureMarks(e) {
		return dP.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
	}
	addStoredMark(e) {
		return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
	}
	removeStoredMark(e) {
		return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
	}
	get storedMarksSet() {
		return (this.updated & eL) > 0;
	}
	addStep(e, t) {
		super.addStep(e, t), this.updated &= -3, this.storedMarks = null;
	}
	setTime(e) {
		return this.time = e, this;
	}
	replaceSelection(e) {
		return this.selection.replace(this, e), this;
	}
	replaceSelectionWith(e, t = !0) {
		let n = this.selection;
		return t && (e = e.mark(this.storedMarks || (n.empty ? n.$from.marks() : n.$from.marksAcross(n.$to) || dP.none))), n.replaceWith(this, e), this;
	}
	deleteSelection() {
		return this.selection.replace(this), this;
	}
	insertText(e, t, n) {
		let r = this.doc.type.schema;
		if (t == null) return e ? this.replaceSelectionWith(r.text(e), !0) : this.deleteSelection();
		{
			if (n ??= t, !e) return this.deleteRange(t, n);
			let i = this.storedMarks;
			if (!i) {
				let e = this.doc.resolve(t);
				i = n == t ? e.marks() : e.marksAcross(this.doc.resolve(n));
			}
			return this.replaceRangeWith(t, n, r.text(e, i)), !this.selection.empty && this.selection.to == t + e.length && this.setSelection(VI.near(this.selection.$to)), this;
		}
	}
	setMeta(e, t) {
		return this.meta[typeof e == "string" ? e : e.key] = t, this;
	}
	getMeta(e) {
		return this.meta[typeof e == "string" ? e : e.key];
	}
	get isGeneric() {
		for (let e in this.meta) return !1;
		return !0;
	}
	scrollIntoView() {
		return this.updated |= tL, this;
	}
	get scrolledIntoView() {
		return (this.updated & tL) > 0;
	}
};
function rL(e, t) {
	return !t || !e ? e : e.bind(t);
}
var iL = class {
	constructor(e, t, n) {
		this.name = e, this.init = rL(t.init, n), this.apply = rL(t.apply, n);
	}
}, aL = [
	new iL("doc", {
		init(e) {
			return e.doc || e.schema.topNodeType.createAndFill();
		},
		apply(e) {
			return e.doc;
		}
	}),
	new iL("selection", {
		init(e, t) {
			return e.selection || VI.atStart(t.doc);
		},
		apply(e) {
			return e.selection;
		}
	}),
	new iL("storedMarks", {
		init(e) {
			return e.storedMarks || null;
		},
		apply(e, t, n, r) {
			return r.selection.$cursor ? e.storedMarks : null;
		}
	}),
	new iL("scrollToSelection", {
		init() {
			return 0;
		},
		apply(e, t) {
			return e.scrolledIntoView ? t + 1 : t;
		}
	})
], oL = class {
	constructor(e, t) {
		this.schema = e, this.plugins = [], this.pluginsByKey = Object.create(null), this.fields = aL.slice(), t && t.forEach((e) => {
			if (this.pluginsByKey[e.key]) throw RangeError("Adding different instances of a keyed plugin (" + e.key + ")");
			this.plugins.push(e), this.pluginsByKey[e.key] = e, e.spec.state && this.fields.push(new iL(e.key, e.spec.state, e));
		});
	}
}, sL = class e {
	constructor(e) {
		this.config = e;
	}
	get schema() {
		return this.config.schema;
	}
	get plugins() {
		return this.config.plugins;
	}
	apply(e) {
		return this.applyTransaction(e).state;
	}
	filterTransaction(e, t = -1) {
		for (let n = 0; n < this.config.plugins.length; n++) if (n != t) {
			let t = this.config.plugins[n];
			if (t.spec.filterTransaction && !t.spec.filterTransaction.call(t, e, this)) return !1;
		}
		return !0;
	}
	applyTransaction(e) {
		if (!this.filterTransaction(e)) return {
			state: this,
			transactions: []
		};
		let t = [e], n = this.applyInner(e), r = null;
		for (;;) {
			let i = !1;
			for (let a = 0; a < this.config.plugins.length; a++) {
				let o = this.config.plugins[a];
				if (o.spec.appendTransaction) {
					let s = r ? r[a].n : 0, c = r ? r[a].state : this, l = s < t.length && o.spec.appendTransaction.call(o, s ? t.slice(s) : t, c, n);
					if (l && n.filterTransaction(l, a)) {
						if (l.setMeta("appendedTransaction", e), !r) {
							r = [];
							for (let e = 0; e < this.config.plugins.length; e++) r.push(e < a ? {
								state: n,
								n: t.length
							} : {
								state: this,
								n: 0
							});
						}
						t.push(l), n = n.applyInner(l), i = !0;
					}
					r && (r[a] = {
						state: n,
						n: t.length
					});
				}
			}
			if (!i) return {
				state: n,
				transactions: t
			};
		}
	}
	applyInner(t) {
		if (!t.before.eq(this.doc)) throw RangeError("Applying a mismatched transaction");
		let n = new e(this.config), r = this.config.fields;
		for (let e = 0; e < r.length; e++) {
			let i = r[e];
			n[i.name] = i.apply(t, this[i.name], this, n);
		}
		return n;
	}
	get tr() {
		return new nL(this);
	}
	static create(t) {
		let n = new oL(t.doc ? t.doc.type.schema : t.schema, t.plugins), r = new e(n);
		for (let e = 0; e < n.fields.length; e++) r[n.fields[e].name] = n.fields[e].init(t, r);
		return r;
	}
	reconfigure(t) {
		let n = new oL(this.schema, t.plugins), r = n.fields, i = new e(n);
		for (let e = 0; e < r.length; e++) {
			let n = r[e].name;
			i[n] = this.hasOwnProperty(n) ? this[n] : r[e].init(t, i);
		}
		return i;
	}
	toJSON(e) {
		let t = {
			doc: this.doc.toJSON(),
			selection: this.selection.toJSON()
		};
		if (this.storedMarks && (t.storedMarks = this.storedMarks.map((e) => e.toJSON())), e && typeof e == "object") for (let n in e) {
			if (n == "doc" || n == "selection") throw RangeError("The JSON fields `doc` and `selection` are reserved");
			let r = e[n], i = r.spec.state;
			i && i.toJSON && (t[n] = i.toJSON.call(r, this[r.key]));
		}
		return t;
	}
	static fromJSON(t, n, r) {
		if (!n) throw RangeError("Invalid input for EditorState.fromJSON");
		if (!t.schema) throw RangeError("Required config field 'schema' missing");
		let i = new oL(t.schema, t.plugins), a = new e(i);
		return i.fields.forEach((e) => {
			if (e.name == "doc") a.doc = jP.fromJSON(t.schema, n.doc);
			else if (e.name == "selection") a.selection = VI.fromJSON(a.doc, n.selection);
			else if (e.name == "storedMarks") n.storedMarks && (a.storedMarks = n.storedMarks.map(t.schema.markFromJSON));
			else {
				if (r) for (let i in r) {
					let o = r[i], s = o.spec.state;
					if (o.key == e.name && s && s.fromJSON && Object.prototype.hasOwnProperty.call(n, i)) {
						a[e.name] = s.fromJSON.call(o, t, n[i], a);
						return;
					}
				}
				a[e.name] = e.init(t, a);
			}
		}), a;
	}
};
function cL(e, t, n) {
	for (let r in e) {
		let i = e[r];
		i instanceof Function ? i = i.bind(t) : r == "handleDOMEvents" && (i = cL(i, t, {})), n[r] = i;
	}
	return n;
}
var lL = class {
	constructor(e) {
		this.spec = e, this.props = {}, e.props && cL(e.props, this, this.props), this.key = e.key ? e.key.key : dL("plugin");
	}
	getState(e) {
		return e[this.key];
	}
}, uL = Object.create(null);
function dL(e) {
	return e in uL ? e + "$" + ++uL[e] : (uL[e] = 0, e + "$");
}
var fL = class {
	constructor(e = "key") {
		this.key = dL(e);
	}
	get(e) {
		return e.config.pluginsByKey[this.key];
	}
	getState(e) {
		return e[this.key];
	}
}, pL = (e, t) => !e.selection.empty && (t && t(e.tr.deleteSelection().scrollIntoView()), !0);
function mL(e, t) {
	let { $cursor: n } = e.selection;
	return !n || (t ? !t.endOfTextblock("backward", e) : n.parentOffset > 0) ? null : n;
}
var hL = (e, t, n) => {
	let r = mL(e, n);
	if (!r) return !1;
	let i = xL(r);
	if (!i) {
		let n = r.blockRange(), i = n && eI(n);
		return i != null && (t && t(e.tr.lift(n, i).scrollIntoView()), !0);
	}
	let a = i.nodeBefore;
	if (zL(e, i, t, -1)) return !0;
	if (r.parent.content.size == 0 && (yL(a, "end") || qI.isSelectable(a))) for (let n = r.depth;; n--) {
		let o = xI(e.doc, r.before(n), r.after(n), Z.empty);
		if (o && o.slice.size < o.to - o.from) {
			if (t) {
				let n = e.tr.step(o);
				n.setSelection(yL(a, "end") ? VI.findFrom(n.doc.resolve(n.mapping.map(i.pos, -1)), -1) : qI.create(n.doc, i.pos - a.nodeSize)), t(n.scrollIntoView());
			}
			return !0;
		}
		if (n == 1 || r.node(n - 1).childCount > 1) break;
	}
	return a.isAtom && i.depth == r.depth - 1 ? (t && t(e.tr.delete(i.pos - a.nodeSize, i.pos).scrollIntoView()), !0) : !1;
}, gL = (e, t, n) => {
	let r = mL(e, n);
	if (!r) return !1;
	let i = xL(r);
	return i ? vL(e, i, t) : !1;
}, _L = (e, t, n) => {
	let r = SL(e, n);
	if (!r) return !1;
	let i = TL(r);
	return i ? vL(e, i, t) : !1;
};
function vL(e, t, n) {
	let r = t.nodeBefore, i = t.pos - 1;
	for (; !r.isTextblock; i--) {
		if (r.type.spec.isolating) return !1;
		let e = r.lastChild;
		if (!e) return !1;
		r = e;
	}
	let a = t.nodeAfter, o = t.pos + 1;
	for (; !a.isTextblock; o++) {
		if (a.type.spec.isolating) return !1;
		let e = a.firstChild;
		if (!e) return !1;
		a = e;
	}
	let s = xI(e.doc, i, o, Z.empty);
	if (!s || s.from != i || s instanceof qF && s.slice.size >= o - i) return !1;
	if (n) {
		let t = e.tr.step(s);
		t.setSelection(GI.create(t.doc, i)), n(t.scrollIntoView());
	}
	return !0;
}
function yL(e, t, n = !1) {
	for (let r = e; r; r = t == "start" ? r.firstChild : r.lastChild) {
		if (r.isTextblock) return !0;
		if (n && r.childCount != 1) return !1;
	}
	return !1;
}
var bL = (e, t, n) => {
	let { $head: r, empty: i } = e.selection, a = r;
	if (!i) return !1;
	if (r.parent.isTextblock) {
		if (n ? !n.endOfTextblock("backward", e) : r.parentOffset > 0) return !1;
		a = xL(r);
	}
	let o = a && a.nodeBefore;
	return !o || !qI.isSelectable(o) ? !1 : (t && t(e.tr.setSelection(qI.create(e.doc, a.pos - o.nodeSize)).scrollIntoView()), !0);
};
function xL(e) {
	if (!e.parent.type.spec.isolating) for (let t = e.depth - 1; t >= 0; t--) {
		if (e.index(t) > 0) return e.doc.resolve(e.before(t + 1));
		if (e.node(t).type.spec.isolating) break;
	}
	return null;
}
function SL(e, t) {
	let { $cursor: n } = e.selection;
	return !n || (t ? !t.endOfTextblock("forward", e) : n.parentOffset < n.parent.content.size) ? null : n;
}
var CL = (e, t, n) => {
	let r = SL(e, n);
	if (!r) return !1;
	let i = TL(r);
	if (!i) return !1;
	let a = i.nodeAfter;
	if (zL(e, i, t, 1)) return !0;
	if (r.parent.content.size == 0 && (yL(a, "start") || qI.isSelectable(a))) {
		let n = xI(e.doc, r.before(), r.after(), Z.empty);
		if (n && n.slice.size < n.to - n.from) {
			if (t) {
				let r = e.tr.step(n);
				r.setSelection(yL(a, "start") ? VI.findFrom(r.doc.resolve(r.mapping.map(i.pos)), 1) : qI.create(r.doc, r.mapping.map(i.pos))), t(r.scrollIntoView());
			}
			return !0;
		}
	}
	return a.isAtom && i.depth == r.depth - 1 ? (t && t(e.tr.delete(i.pos, i.pos + a.nodeSize).scrollIntoView()), !0) : !1;
}, wL = (e, t, n) => {
	let { $head: r, empty: i } = e.selection, a = r;
	if (!i) return !1;
	if (r.parent.isTextblock) {
		if (n ? !n.endOfTextblock("forward", e) : r.parentOffset < r.parent.content.size) return !1;
		a = TL(r);
	}
	let o = a && a.nodeAfter;
	return !o || !qI.isSelectable(o) ? !1 : (t && t(e.tr.setSelection(qI.create(e.doc, a.pos)).scrollIntoView()), !0);
};
function TL(e) {
	if (!e.parent.type.spec.isolating) for (let t = e.depth - 1; t >= 0; t--) {
		let n = e.node(t);
		if (e.index(t) + 1 < n.childCount) return e.doc.resolve(e.after(t + 1));
		if (n.type.spec.isolating) break;
	}
	return null;
}
var EL = (e, t) => {
	let n = e.selection, r = n instanceof qI, i;
	if (r) {
		if (n.node.isTextblock || !mI(e.doc, n.from)) return !1;
		i = n.from;
	} else if (i = _I(e.doc, n.from, -1), i == null) return !1;
	if (t) {
		let n = e.tr.join(i);
		r && n.setSelection(qI.create(n.doc, i - e.doc.resolve(i).nodeBefore.nodeSize)), t(n.scrollIntoView());
	}
	return !0;
}, DL = (e, t) => {
	let n = e.selection, r;
	if (n instanceof qI) {
		if (n.node.isTextblock || !mI(e.doc, n.to)) return !1;
		r = n.to;
	} else if (r = _I(e.doc, n.to, 1), r == null) return !1;
	return t && t(e.tr.join(r).scrollIntoView()), !0;
}, OL = (e, t) => {
	let { $from: n, $to: r } = e.selection, i = n.blockRange(r), a = i && eI(i);
	return a != null && (t && t(e.tr.lift(i, a).scrollIntoView()), !0);
}, kL = (e, t) => {
	let { $head: n, $anchor: r } = e.selection;
	return !n.parent.type.spec.code || !n.sameParent(r) ? !1 : (t && t(e.tr.insertText("\n").scrollIntoView()), !0);
};
function AL(e) {
	for (let t = 0; t < e.edgeCount; t++) {
		let { type: n } = e.edge(t);
		if (n.isTextblock && !n.hasRequiredAttrs()) return n;
	}
	return null;
}
var jL = (e, t) => {
	let { $head: n, $anchor: r } = e.selection;
	if (!n.parent.type.spec.code || !n.sameParent(r)) return !1;
	let i = n.node(-1), a = n.indexAfter(-1), o = AL(i.contentMatchAt(a));
	if (!o || !i.canReplaceWith(a, a, o)) return !1;
	if (t) {
		let r = n.after(), i = e.tr.replaceWith(r, r, o.createAndFill());
		i.setSelection(VI.near(i.doc.resolve(r), 1)), t(i.scrollIntoView());
	}
	return !0;
}, ML = (e, t) => {
	let n = e.selection, { $from: r, $to: i } = n;
	if (n instanceof YI || r.parent.inlineContent || i.parent.inlineContent) return !1;
	let a = AL(i.parent.contentMatchAt(i.indexAfter()));
	if (!a || !a.isTextblock) return !1;
	if (t) {
		let n = (!r.parentOffset && i.index() < i.parent.childCount ? r : i).pos, o = e.tr.insert(n, a.createAndFill());
		o.setSelection(GI.create(o.doc, n + 1)), t(o.scrollIntoView());
	}
	return !0;
}, NL = (e, t) => {
	let { $cursor: n } = e.selection;
	if (!n || n.parent.content.size) return !1;
	if (n.depth > 1 && n.after() != n.end(-1)) {
		let r = n.before();
		if (fI(e.doc, r)) return t && t(e.tr.split(r).scrollIntoView()), !0;
	}
	let r = n.blockRange(), i = r && eI(r);
	return i != null && (t && t(e.tr.lift(r, i).scrollIntoView()), !0);
};
function PL(e) {
	return (t, n) => {
		let { $from: r, $to: i } = t.selection;
		if (t.selection instanceof qI && t.selection.node.isBlock) return !r.parentOffset || !fI(t.doc, r.pos) ? !1 : (n && n(t.tr.split(r.pos).scrollIntoView()), !0);
		if (!r.depth) return !1;
		let a = [], o, s, c = !1, l = !1;
		for (let t = r.depth;; t--) if (r.node(t).isBlock) {
			c = r.end(t) == r.pos + (r.depth - t), l = r.start(t) == r.pos - (r.depth - t), s = AL(r.node(t - 1).contentMatchAt(r.indexAfter(t - 1)));
			let n = e && e(i.parent, c, r);
			a.unshift(n || (c && s ? { type: s } : null)), o = t;
			break;
		} else {
			if (t == 1) return !1;
			a.unshift(null);
		}
		let u = t.tr;
		(t.selection instanceof GI || t.selection instanceof YI) && u.deleteSelection();
		let d = u.mapping.map(r.pos), f = fI(u.doc, d, a.length, a);
		if (f ||= (a[0] = s ? { type: s } : null, fI(u.doc, d, a.length, a)), !f) return !1;
		if (u.split(d, a.length, a), !c && l && r.node(o).type != s) {
			let e = u.mapping.map(r.before(o)), t = u.doc.resolve(e);
			s && r.node(o - 1).canReplaceWith(t.index(), t.index() + 1, s) && u.setNodeMarkup(u.mapping.map(r.before(o)), s);
		}
		return n && n(u.scrollIntoView()), !0;
	};
}
var FL = PL(), IL = (e, t) => {
	let { $from: n, to: r } = e.selection, i, a = n.sharedDepth(r);
	return a != 0 && (i = n.before(a), t && t(e.tr.setSelection(qI.create(e.doc, i))), !0);
}, LL = (e, t) => (t && t(e.tr.setSelection(new YI(e.doc))), !0);
function RL(e, t, n) {
	let r = t.nodeBefore, i = t.nodeAfter, a = t.index();
	return !r || !i || !r.type.compatibleContent(i.type) ? !1 : !r.content.size && t.parent.canReplace(a - 1, a) ? (n && n(e.tr.delete(t.pos - r.nodeSize, t.pos).scrollIntoView()), !0) : !t.parent.canReplace(a, a + 1) || !(i.isTextblock || mI(e.doc, t.pos)) ? !1 : (n && n(e.tr.join(t.pos).scrollIntoView()), !0);
}
function zL(e, t, n, r) {
	let i = t.nodeBefore, a = t.nodeAfter, o, s, c = i.type.spec.isolating || a.type.spec.isolating;
	if (!c && RL(e, t, n)) return !0;
	let l = !c && t.parent.canReplace(t.index(), t.index() + 1);
	if (l && (o = (s = i.contentMatchAt(i.childCount)).findWrapping(a.type)) && s.matchType(o[0] || a.type).validEnd) {
		if (n) {
			let r = t.pos + a.nodeSize, s = X.empty;
			for (let e = o.length - 1; e >= 0; e--) s = X.from(o[e].create(null, s));
			s = X.from(i.copy(s));
			let c = e.tr.step(new JF(t.pos - 1, r, t.pos, r, new Z(s, 1, 0), o.length, !0)), l = c.doc.resolve(r + 2 * o.length);
			l.nodeAfter && l.nodeAfter.type == i.type && mI(c.doc, l.pos) && c.join(l.pos), n(c.scrollIntoView());
		}
		return !0;
	}
	let u = a.type.spec.isolating || r > 0 && c ? null : VI.findFrom(t, 1), d = u && u.$from.blockRange(u.$to), f = d && eI(d);
	if (f != null && f >= t.depth) return n && n(e.tr.lift(d, f).scrollIntoView()), !0;
	if (l && yL(a, "start", !0) && yL(i, "end")) {
		let r = i, o = [];
		for (; o.push(r), !r.isTextblock;) r = r.lastChild;
		let s = a, c = 1;
		for (; !s.isTextblock; s = s.firstChild) c++;
		if (r.canReplace(r.childCount, r.childCount, s.content)) {
			if (n) {
				let r = X.empty;
				for (let e = o.length - 1; e >= 0; e--) r = X.from(o[e].copy(r));
				n(e.tr.step(new JF(t.pos - o.length, t.pos + a.nodeSize, t.pos + c, t.pos + a.nodeSize - c, new Z(r, o.length, 0), 0, !0)).scrollIntoView());
			}
			return !0;
		}
	}
	return !1;
}
function BL(e) {
	return function(t, n) {
		let r = t.selection, i = e < 0 ? r.$from : r.$to, a = i.depth;
		for (; i.node(a).isInline;) {
			if (!a) return !1;
			a--;
		}
		return i.node(a).isTextblock ? (n && n(t.tr.setSelection(GI.create(t.doc, e < 0 ? i.start(a) : i.end(a)))), !0) : !1;
	};
}
var VL = BL(-1), HL = BL(1);
function UL(e, t = null) {
	return function(n, r) {
		let { $from: i, $to: a } = n.selection, o = i.blockRange(a), s = o && nI(o, e, t);
		return s ? (r && r(n.tr.wrap(o, s).scrollIntoView()), !0) : !1;
	};
}
function WL(e, t = null) {
	return function(n, r) {
		let i = !1;
		for (let r = 0; r < n.selection.ranges.length && !i; r++) {
			let { $from: { pos: a }, $to: { pos: o } } = n.selection.ranges[r];
			n.doc.nodesBetween(a, o, (r, a) => {
				if (i) return !1;
				if (!(!r.isTextblock || r.hasMarkup(e, t))) {
					if (r.type == e) i = !0;
					else {
						let t = n.doc.resolve(a), r = t.index();
						i = t.parent.canReplaceWith(r, r + 1, e);
					}
				}
			});
		}
		if (!i) return !1;
		if (r) {
			let i = n.tr;
			for (let r = 0; r < n.selection.ranges.length; r++) {
				let { $from: { pos: a }, $to: { pos: o } } = n.selection.ranges[r];
				i.setBlockType(a, o, e, t);
			}
			r(i.scrollIntoView());
		}
		return !0;
	};
}
function GL(...e) {
	return function(t, n, r) {
		for (let i = 0; i < e.length; i++) if (e[i](t, n, r)) return !0;
		return !1;
	};
}
var KL = GL(pL, hL, bL), qL = GL(pL, CL, wL), JL = {
	Enter: GL(kL, ML, NL, FL),
	"Mod-Enter": jL,
	Backspace: KL,
	"Mod-Backspace": KL,
	"Shift-Backspace": KL,
	Delete: qL,
	"Mod-Delete": qL,
	"Mod-a": LL
}, YL = {
	"Ctrl-h": JL.Backspace,
	"Alt-Backspace": JL["Mod-Backspace"],
	"Ctrl-d": JL.Delete,
	"Ctrl-Alt-Backspace": JL["Mod-Delete"],
	"Alt-Delete": JL["Mod-Delete"],
	"Alt-d": JL["Mod-Delete"],
	"Ctrl-a": VL,
	"Ctrl-e": HL
};
for (let e in JL) YL[e] = JL[e];
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform();
//#endregion
//#region ../../node_modules/.pnpm/prosemirror-schema-list@1.5.1/node_modules/prosemirror-schema-list/dist/index.js
function XL(e, t = null) {
	return function(n, r) {
		let { $from: i, $to: a } = n.selection, o = i.blockRange(a);
		if (!o) return !1;
		let s = r ? n.tr : null;
		return ZL(s, o, e, t) ? (r && r(s.scrollIntoView()), !0) : !1;
	};
}
function ZL(e, t, n, r = null) {
	let i = !1, a = t, o = t.$from.doc;
	if (t.depth >= 2 && t.$from.node(t.depth - 1).type.compatibleContent(n) && t.startIndex == 0) {
		if (t.$from.index(t.depth - 1) == 0) return !1;
		let e = o.resolve(t.start - 2);
		a = new kP(e, e, t.depth), t.endIndex < t.parent.childCount && (t = new kP(t.$from, o.resolve(t.$to.end(t.depth)), t.depth)), i = !0;
	}
	let s = nI(a, n, r, t);
	return s ? (e && QL(e, t, s, i, n), !0) : !1;
}
function QL(e, t, n, r, i) {
	let a = X.empty;
	for (let e = n.length - 1; e >= 0; e--) a = X.from(n[e].type.create(n[e].attrs, a));
	e.step(new JF(t.start - (r ? 2 : 0), t.end, t.start, t.end, new Z(a, 0, 0), n.length, !0));
	let o = 0;
	for (let e = 0; e < n.length; e++) n[e].type == i && (o = e + 1);
	let s = n.length - o, c = t.start + n.length - (r ? 2 : 0), l = t.parent;
	for (let n = t.startIndex, r = t.endIndex, i = !0; n < r; n++, i = !1) !i && fI(e.doc, c, s) && (e.split(c, s), c += 2 * s), c += l.child(n).nodeSize;
	return e;
}
function $L(e) {
	return function(t, n) {
		let { $from: r, $to: i } = t.selection, a = r.blockRange(i, (t) => t.childCount > 0 && t.firstChild.type == e);
		return a ? n ? r.node(a.depth - 1).type == e ? eR(t, n, e, a) : tR(t, n, a) : !0 : !1;
	};
}
function eR(e, t, n, r) {
	let i = e.tr, a = r.end, o = r.$to.end(r.depth);
	a < o && (i.step(new JF(a - 1, o, a, o, new Z(X.from(n.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new kP(i.doc.resolve(r.$from.pos), i.doc.resolve(o), r.depth));
	let s = eI(r);
	if (s == null) return !1;
	i.lift(r, s);
	let c = i.doc.resolve(i.mapping.map(a, -1) - 1);
	return mI(i.doc, c.pos) && c.nodeBefore.type == c.nodeAfter.type && i.join(c.pos), t(i.scrollIntoView()), !0;
}
function tR(e, t, n) {
	let r = e.tr, i = n.parent;
	for (let e = n.end, t = n.endIndex - 1, a = n.startIndex; t > a; t--) e -= i.child(t).nodeSize, r.delete(e - 1, e + 1);
	let a = r.doc.resolve(n.start), o = a.nodeAfter;
	if (r.mapping.map(n.end) != n.start + a.nodeAfter.nodeSize) return !1;
	let s = n.startIndex == 0, c = n.endIndex == i.childCount, l = a.node(-1), u = a.index(-1);
	if (!l.canReplace(u + +!s, u + 1, o.content.append(c ? X.empty : X.from(i)))) return !1;
	let d = a.pos, f = d + o.nodeSize;
	return r.step(new JF(d - +!!s, f + +!!c, d + 1, f - 1, new Z((s ? X.empty : X.from(i.copy(X.empty))).append(c ? X.empty : X.from(i.copy(X.empty))), +!s, +!c), +!s)), t(r.scrollIntoView()), !0;
}
function nR(e) {
	return function(t, n) {
		let { $from: r, $to: i } = t.selection, a = r.blockRange(i, (t) => t.childCount > 0 && t.firstChild.type == e);
		if (!a) return !1;
		let o = a.startIndex;
		if (o == 0) return !1;
		let s = a.parent, c = s.child(o - 1);
		if (c.type != e) return !1;
		if (n) {
			let r = c.lastChild && c.lastChild.type == s.type, i = X.from(r ? e.create() : null), o = new Z(X.from(e.create(null, X.from(s.type.create(null, i)))), r ? 3 : 1, 0), l = a.start, u = a.end;
			n(t.tr.step(new JF(l - (r ? 3 : 1), u, l, u, o, 1, !0)).scrollIntoView());
		}
		return !0;
	};
}
//#endregion
//#region ../../node_modules/.pnpm/prosemirror-view@1.41.9/node_modules/prosemirror-view/dist/index.js
var rR = function(e) {
	for (var t = 0;; t++) if (e = e.previousSibling, !e) return t;
}, iR = function(e) {
	let t = e.assignedSlot || e.parentNode;
	return t && t.nodeType == 11 ? t.host : t;
}, aR = null, oR = function(e, t, n) {
	let r = aR ||= document.createRange();
	return r.setEnd(e, n ?? e.nodeValue.length), r.setStart(e, t || 0), r;
}, sR = function() {
	aR = null;
}, cR = function(e, t, n, r) {
	return n && (uR(e, t, n, r, -1) || uR(e, t, n, r, 1));
}, lR = /^(img|br|input|textarea|hr)$/i;
function uR(e, t, n, r, i) {
	for (;;) {
		if (e == n && t == r) return !0;
		if (t == (i < 0 ? 0 : dR(e))) {
			let n = e.parentNode;
			if (!n || n.nodeType != 1 || hR(e) || lR.test(e.nodeName) || e.contentEditable == "false") return !1;
			t = rR(e) + (i < 0 ? 0 : 1), e = n;
		} else if (e.nodeType == 1) {
			let n = e.childNodes[t + (i < 0 ? -1 : 0)];
			if (n.nodeType == 1 && n.contentEditable == "false") {
				if (n.pmViewDesc?.ignoreForSelection) t += i;
				else return !1;
			} else e = n, t = i < 0 ? dR(e) : 0;
		} else return !1;
	}
}
function dR(e) {
	return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function fR(e, t) {
	for (;;) {
		if (e.nodeType == 3 && t) return e;
		if (e.nodeType == 1 && t > 0) {
			if (e.contentEditable == "false") return null;
			e = e.childNodes[t - 1], t = dR(e);
		} else if (e.parentNode && !hR(e)) t = rR(e), e = e.parentNode;
		else return null;
	}
}
function pR(e, t) {
	for (;;) {
		if (e.nodeType == 3 && t < e.nodeValue.length) return e;
		if (e.nodeType == 1 && t < e.childNodes.length) {
			if (e.contentEditable == "false") return null;
			e = e.childNodes[t], t = 0;
		} else if (e.parentNode && !hR(e)) t = rR(e) + 1, e = e.parentNode;
		else return null;
	}
}
function mR(e, t, n) {
	for (let r = t == 0, i = t == dR(e); r || i;) {
		if (e == n) return !0;
		let t = rR(e);
		if (e = e.parentNode, !e) return !1;
		r &&= t == 0, i &&= t == dR(e);
	}
}
function hR(e) {
	let t;
	for (let n = e; n && !(t = n.pmViewDesc); n = n.parentNode);
	return t && t.node && t.node.isBlock && (t.dom == e || t.contentDOM == e);
}
var gR = function(e) {
	return e.focusNode && cR(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset);
};
function _R(e, t) {
	let n = document.createEvent("Event");
	return n.initEvent("keydown", !0, !0), n.keyCode = e, n.key = n.code = t, n;
}
function vR(e) {
	let t = e.activeElement;
	for (; t && t.shadowRoot;) t = t.shadowRoot.activeElement;
	return t;
}
function yR(e, t, n) {
	if (e.caretPositionFromPoint) try {
		let r = e.caretPositionFromPoint(t, n);
		if (r) return {
			node: r.offsetNode,
			offset: Math.min(dR(r.offsetNode), r.offset)
		};
	} catch {}
	if (e.caretRangeFromPoint) {
		let r = e.caretRangeFromPoint(t, n);
		if (r) return {
			node: r.startContainer,
			offset: Math.min(dR(r.startContainer), r.startOffset)
		};
	}
}
var bR = typeof navigator < "u" ? navigator : null, xR = typeof document < "u" ? document : null, SR = bR && bR.userAgent || "", CR = /Edge\/(\d+)/.exec(SR), wR = /MSIE \d/.exec(SR), TR = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(SR), ER = !!(wR || TR || CR), DR = wR ? document.documentMode : TR ? +TR[1] : CR ? +CR[1] : 0, OR = !ER && /gecko\/(\d+)/i.test(SR);
OR && +(/Firefox\/(\d+)/.exec(SR) || [0, 0])[1];
var kR = !ER && /Chrome\/(\d+)/.exec(SR), AR = !!kR, jR = kR ? +kR[1] : 0, MR = !ER && !!bR && /Apple Computer/.test(bR.vendor), NR = MR && (/Mobile\/\w+/.test(SR) || !!bR && bR.maxTouchPoints > 2), PR = NR || (bR ? /Mac/.test(bR.platform) : !1), FR = bR ? /Win/.test(bR.platform) : !1, IR = /Android \d/.test(SR), LR = !!xR && "webkitFontSmoothing" in xR.documentElement.style, RR = LR ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function zR(e) {
	let t = e.defaultView && e.defaultView.visualViewport;
	return t ? {
		left: 0,
		right: t.width,
		top: 0,
		bottom: t.height
	} : {
		left: 0,
		right: e.documentElement.clientWidth,
		top: 0,
		bottom: e.documentElement.clientHeight
	};
}
function BR(e, t) {
	return typeof e == "number" ? e : e[t];
}
function VR(e) {
	let t = e.getBoundingClientRect(), n = t.width / e.offsetWidth || 1, r = t.height / e.offsetHeight || 1;
	return {
		left: t.left,
		right: t.left + e.clientWidth * n,
		top: t.top,
		bottom: t.top + e.clientHeight * r
	};
}
function HR(e, t, n) {
	let r = e.someProp("scrollThreshold") || 0, i = e.someProp("scrollMargin") || 5, a = e.dom.ownerDocument;
	for (let o = n || e.dom; o;) {
		if (o.nodeType != 1) {
			o = iR(o);
			continue;
		}
		let e = o, n = e == a.body, s = n ? zR(a) : VR(e), c = 0, l = 0;
		if (t.top < s.top + BR(r, "top") ? l = -(s.top - t.top + BR(i, "top")) : t.bottom > s.bottom - BR(r, "bottom") && (l = t.bottom - t.top > s.bottom - s.top ? t.top + BR(i, "top") - s.top : t.bottom - s.bottom + BR(i, "bottom")), t.left < s.left + BR(r, "left") ? c = -(s.left - t.left + BR(i, "left")) : t.right > s.right - BR(r, "right") && (c = t.right - s.right + BR(i, "right")), c || l) {
			if (n) a.defaultView.scrollBy(c, l);
			else {
				let n = e.scrollLeft, r = e.scrollTop;
				l && (e.scrollTop += l), c && (e.scrollLeft += c);
				let i = e.scrollLeft - n, a = e.scrollTop - r;
				t = {
					left: t.left - i,
					top: t.top - a,
					right: t.right - i,
					bottom: t.bottom - a
				};
			}
		}
		let u = n ? "fixed" : getComputedStyle(o).position;
		if (/^(fixed|sticky)$/.test(u)) break;
		o = u == "absolute" ? o.offsetParent : iR(o);
	}
}
function UR(e) {
	let t = e.dom.getBoundingClientRect(), n = Math.max(0, t.top), r, i;
	for (let a = (t.left + t.right) / 2, o = n + 1; o < Math.min(innerHeight, t.bottom); o += 5) {
		let t = e.root.elementFromPoint(a, o);
		if (!t || t == e.dom || !e.dom.contains(t)) continue;
		let s = t.getBoundingClientRect();
		if (s.top >= n - 20) {
			r = t, i = s.top;
			break;
		}
	}
	return {
		refDOM: r,
		refTop: i,
		stack: WR(e.dom)
	};
}
function WR(e) {
	let t = [], n = e.ownerDocument;
	for (let r = e; r && (t.push({
		dom: r,
		top: r.scrollTop,
		left: r.scrollLeft
	}), e != n); r = iR(r));
	return t;
}
function GR({ refDOM: e, refTop: t, stack: n }) {
	let r = e ? e.getBoundingClientRect().top : 0;
	KR(n, r == 0 ? 0 : r - t);
}
function KR(e, t) {
	for (let n = 0; n < e.length; n++) {
		let { dom: r, top: i, left: a } = e[n];
		r.scrollTop != i + t && (r.scrollTop = i + t), r.scrollLeft != a && (r.scrollLeft = a);
	}
}
var qR = null;
function JR(e) {
	if (e.setActive) return e.setActive();
	if (qR) return e.focus(qR);
	let t = WR(e);
	e.focus(qR == null ? { get preventScroll() {
		return qR = { preventScroll: !0 }, !0;
	} } : void 0), qR || (qR = !1, KR(t, 0));
}
function YR(e, t) {
	let n, r = 2e8, i, a = 0, o = t.top, s = t.top, c, l;
	for (let u = e.firstChild, d = 0; u; u = u.nextSibling, d++) {
		let e;
		if (u.nodeType == 1) e = u.getClientRects();
		else if (u.nodeType == 3) e = oR(u).getClientRects();
		else continue;
		for (let f = 0; f < e.length; f++) {
			let p = e[f];
			if (p.top <= o && p.bottom >= s) {
				o = Math.max(p.bottom, o), s = Math.min(p.top, s);
				let e = p.left > t.left ? p.left - t.left : p.right < t.left ? t.left - p.right : 0;
				if (e < r) {
					n = u, r = e, i = e && n.nodeType == 3 ? {
						left: p.right < t.left ? p.right : p.left,
						top: t.top
					} : t, u.nodeType == 1 && e && (a = d + +(t.left >= (p.left + p.right) / 2));
					continue;
				}
			} else p.top > t.top && !c && p.left <= t.left && p.right >= t.left && (c = u, l = {
				left: Math.max(p.left, Math.min(p.right, t.left)),
				top: p.top
			});
			!n && (t.left >= p.right && t.top >= p.top || t.left >= p.left && t.top >= p.bottom) && (a = d + 1);
		}
	}
	return !n && c && (n = c, i = l, r = 0), n && n.nodeType == 3 ? XR(n, i) : !n || r && n.nodeType == 1 ? {
		node: e,
		offset: a
	} : YR(n, i);
}
function XR(e, t) {
	let n = e.nodeValue.length, r = document.createRange(), i;
	for (let a = 0; a < n; a++) {
		r.setEnd(e, a + 1), r.setStart(e, a);
		let n = iz(r, 1);
		if (n.top != n.bottom && ZR(t, n)) {
			i = {
				node: e,
				offset: a + +(t.left >= (n.left + n.right) / 2)
			};
			break;
		}
	}
	return r.detach(), i || {
		node: e,
		offset: 0
	};
}
function ZR(e, t) {
	return e.left >= t.left - 1 && e.left <= t.right + 1 && e.top >= t.top - 1 && e.top <= t.bottom + 1;
}
function QR(e, t) {
	let n = e.parentNode;
	return n && /^li$/i.test(n.nodeName) && t.left < e.getBoundingClientRect().left ? n : e;
}
function $R(e, t, n) {
	let { node: r, offset: i } = YR(t, n), a = -1;
	if (r.nodeType == 1 && !r.firstChild) {
		let e = r.getBoundingClientRect();
		a = e.left != e.right && n.left > (e.left + e.right) / 2 ? 1 : -1;
	}
	return e.docView.posFromDOM(r, i, a);
}
function ez(e, t, n, r) {
	let i = -1;
	for (let n = t, a = !1; n != e.dom;) {
		let t = e.docView.nearestDesc(n, !0), o;
		if (!t) return null;
		if (t.dom.nodeType == 1 && (t.node.isBlock && t.parent || !t.contentDOM) && ((o = t.dom.getBoundingClientRect()).width || o.height) && (t.node.isBlock && t.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(t.dom.nodeName) && (!a && o.left > r.left || o.top > r.top ? i = t.posBefore : (!a && o.right < r.left || o.bottom < r.top) && (i = t.posAfter), a = !0), !t.contentDOM && i < 0 && !t.node.isText)) return (t.node.isBlock ? r.top < (o.top + o.bottom) / 2 : r.left < (o.left + o.right) / 2) ? t.posBefore : t.posAfter;
		n = t.dom.parentNode;
	}
	return i > -1 ? i : e.docView.posFromDOM(t, n, -1);
}
function tz(e, t, n) {
	let r = e.childNodes.length;
	if (r && n.top < n.bottom) for (let i = Math.max(0, Math.min(r - 1, Math.floor(r * (t.top - n.top) / (n.bottom - n.top)) - 2)), a = i;;) {
		let n = e.childNodes[a];
		if (n.nodeType == 1) {
			let e = n.getClientRects();
			for (let r = 0; r < e.length; r++) {
				let i = e[r];
				if (ZR(t, i)) return tz(n, t, i);
			}
		}
		if ((a = (a + 1) % r) == i) break;
	}
	return e;
}
function nz(e, t) {
	let n = e.dom.ownerDocument, r, i = 0, a = yR(n, t.left, t.top);
	a && ({node: r, offset: i} = a);
	let o = (e.root.elementFromPoint ? e.root : n).elementFromPoint(t.left, t.top), s;
	if (!o || !e.dom.contains(o.nodeType == 1 ? o : o.parentNode)) {
		let n = e.dom.getBoundingClientRect();
		if (!ZR(t, n) || (o = tz(e.dom, t, n), !o)) return null;
	}
	if (MR) for (let e = o; r && e; e = iR(e)) e.draggable && (r = void 0);
	if (o = QR(o, t), r) {
		if (OR && r.nodeType == 1 && (i = Math.min(i, r.childNodes.length), i < r.childNodes.length)) {
			let e = r.childNodes[i], n;
			e.nodeName == "IMG" && (n = e.getBoundingClientRect()).right <= t.left && n.bottom > t.top && i++;
		}
		let n;
		LR && i && r.nodeType == 1 && (n = r.childNodes[i - 1]).nodeType == 1 && n.contentEditable == "false" && n.getBoundingClientRect().top >= t.top && i--, r == e.dom && i == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && t.top > r.lastChild.getBoundingClientRect().bottom ? s = e.state.doc.content.size : (i == 0 || r.nodeType != 1 || r.childNodes[i - 1].nodeName != "BR") && (s = ez(e, r, i, t));
	}
	s ??= $R(e, o, t);
	let c = e.docView.nearestDesc(o, !0);
	return {
		pos: s,
		inside: c ? c.posAtStart - c.border : -1
	};
}
function rz(e) {
	return e.top < e.bottom || e.left < e.right;
}
function iz(e, t) {
	let n = e.getClientRects();
	if (n.length) {
		let e = n[t < 0 ? 0 : n.length - 1];
		if (rz(e)) return e;
	}
	return Array.prototype.find.call(n, rz) || e.getBoundingClientRect();
}
var az = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function oz(e, t, n) {
	let { node: r, offset: i, atom: a } = e.docView.domFromPos(t, n < 0 ? -1 : 1), o = LR || OR;
	if (r.nodeType == 3) {
		if (o && (az.test(r.nodeValue) || (n < 0 ? !i : i == r.nodeValue.length))) {
			let e = iz(oR(r, i, i), n);
			if (OR && i && /\s/.test(r.nodeValue[i - 1]) && i < r.nodeValue.length) {
				let t = iz(oR(r, i - 1, i - 1), -1);
				if (t.top == e.top) {
					let n = iz(oR(r, i, i + 1), -1);
					if (n.top != e.top) return sz(n, n.left < t.left);
				}
			}
			return e;
		}
		{
			let e = i, t = i, a = n < 0 ? 1 : -1;
			return n < 0 && !i ? (t++, a = -1) : n >= 0 && i == r.nodeValue.length ? (e--, a = 1) : n < 0 ? e-- : t++, sz(iz(oR(r, e, t), a), a < 0);
		}
	}
	if (!e.state.doc.resolve(t - (a || 0)).parent.inlineContent) {
		if (a == null && i && (n < 0 || i == dR(r))) {
			let e = r.childNodes[i - 1];
			if (e.nodeType == 1) return cz(e.getBoundingClientRect(), !1);
		}
		if (a == null && i < dR(r)) {
			let e = r.childNodes[i];
			if (e.nodeType == 1) return cz(e.getBoundingClientRect(), !0);
		}
		return cz(r.getBoundingClientRect(), n >= 0);
	}
	if (a == null && i && (n < 0 || i == dR(r))) {
		let e = r.childNodes[i - 1], t = e.nodeType == 3 ? oR(e, dR(e) - +!o) : e.nodeType == 1 && (e.nodeName != "BR" || !e.nextSibling) ? e : null;
		if (t) return sz(iz(t, 1), !1);
	}
	if (a == null && i < dR(r)) {
		let e = r.childNodes[i];
		for (; e.pmViewDesc && e.pmViewDesc.ignoreForCoords;) e = e.nextSibling;
		let t = e ? e.nodeType == 3 ? oR(e, 0, +!o) : e.nodeType == 1 ? e : null : null;
		if (t) return sz(iz(t, -1), !0);
	}
	return sz(iz(r.nodeType == 3 ? oR(r) : r, -n), n >= 0);
}
function sz(e, t) {
	if (e.width == 0) return e;
	let n = t ? e.left : e.right;
	return {
		top: e.top,
		bottom: e.bottom,
		left: n,
		right: n
	};
}
function cz(e, t) {
	if (e.height == 0) return e;
	let n = t ? e.top : e.bottom;
	return {
		top: n,
		bottom: n,
		left: e.left,
		right: e.right
	};
}
function lz(e, t, n) {
	let r = e.state, i = e.root.activeElement;
	r != t && e.updateState(t), i != e.dom && e.focus();
	try {
		return n();
	} finally {
		r != t && e.updateState(r), i != e.dom && i && i.focus();
	}
}
function uz(e, t, n) {
	let r = t.selection, i = n == "up" ? r.$from : r.$to;
	return lz(e, t, () => {
		let { node: t } = e.docView.domFromPos(i.pos, n == "up" ? -1 : 1);
		for (;;) {
			let n = e.docView.nearestDesc(t, !0);
			if (!n) break;
			if (n.node.isBlock) {
				t = n.contentDOM || n.dom;
				break;
			}
			t = n.dom.parentNode;
		}
		let r = oz(e, i.pos, 1);
		for (let e = t.firstChild; e; e = e.nextSibling) {
			let t;
			if (e.nodeType == 1) t = e.getClientRects();
			else if (e.nodeType == 3) t = oR(e, 0, e.nodeValue.length).getClientRects();
			else continue;
			for (let e = 0; e < t.length; e++) {
				let i = t[e];
				if (i.bottom > i.top + 1 && (n == "up" ? r.top - i.top > (i.bottom - r.top) * 2 : i.bottom - r.bottom > (r.bottom - i.top) * 2)) return !1;
			}
		}
		return !0;
	});
}
var dz = /[\u0590-\u08ac]/;
function fz(e, t, n) {
	let { $head: r } = t.selection;
	if (!r.parent.isTextblock) return !1;
	let i = r.parentOffset, a = !i, o = i == r.parent.content.size, s = e.domSelection();
	return s ? !dz.test(r.parent.textContent) || !s.modify ? n == "left" || n == "backward" ? a : o : lz(e, t, () => {
		let { focusNode: t, focusOffset: i, anchorNode: a, anchorOffset: o } = e.domSelectionRange(), c = s.caretBidiLevel;
		s.modify("move", n, "character");
		let l = r.depth ? e.docView.domAfterPos(r.before()) : e.dom, { focusNode: u, focusOffset: d } = e.domSelectionRange(), f = u && !l.contains(u.nodeType == 1 ? u : u.parentNode) || t == u && i == d;
		try {
			s.collapse(a, o), t && (t != a || i != o) && s.extend && s.extend(t, i);
		} catch {}
		return c != null && (s.caretBidiLevel = c), f;
	}) : r.pos == r.start() || r.pos == r.end();
}
var pz = null, mz = null, hz = !1;
function gz(e, t, n) {
	return pz == t && mz == n ? hz : (pz = t, mz = n, hz = n == "up" || n == "down" ? uz(e, t, n) : fz(e, t, n));
}
var _z = 0, vz = 1, yz = 2, bz = 3, xz = class {
	constructor(e, t, n, r) {
		this.parent = e, this.children = t, this.dom = n, this.contentDOM = r, this.dirty = _z, n.pmViewDesc = this;
	}
	matchesWidget(e) {
		return !1;
	}
	matchesMark(e) {
		return !1;
	}
	matchesNode(e, t, n) {
		return !1;
	}
	matchesHack(e) {
		return !1;
	}
	parseRule() {
		return null;
	}
	stopEvent(e) {
		return !1;
	}
	get size() {
		let e = 0;
		for (let t = 0; t < this.children.length; t++) e += this.children[t].size;
		return e;
	}
	get border() {
		return 0;
	}
	destroy() {
		this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
		for (let e = 0; e < this.children.length; e++) this.children[e].destroy();
	}
	posBeforeChild(e) {
		for (let t = 0, n = this.posAtStart;; t++) {
			let r = this.children[t];
			if (r == e) return n;
			n += r.size;
		}
	}
	get posBefore() {
		return this.parent.posBeforeChild(this);
	}
	get posAtStart() {
		return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
	}
	get posAfter() {
		return this.posBefore + this.size;
	}
	get posAtEnd() {
		return this.posAtStart + this.size - 2 * this.border;
	}
	localPosFromDOM(e, t, n) {
		if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode)) {
			if (n < 0) {
				let n, r;
				if (e == this.contentDOM) n = e.childNodes[t - 1];
				else {
					for (; e.parentNode != this.contentDOM;) e = e.parentNode;
					n = e.previousSibling;
				}
				for (; n && !((r = n.pmViewDesc) && r.parent == this);) n = n.previousSibling;
				return n ? this.posBeforeChild(r) + r.size : this.posAtStart;
			}
			{
				let n, r;
				if (e == this.contentDOM) n = e.childNodes[t];
				else {
					for (; e.parentNode != this.contentDOM;) e = e.parentNode;
					n = e.nextSibling;
				}
				for (; n && !((r = n.pmViewDesc) && r.parent == this);) n = n.nextSibling;
				return n ? this.posBeforeChild(r) : this.posAtEnd;
			}
		}
		let r;
		if (e == this.dom && this.contentDOM) r = t > rR(this.contentDOM);
		else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) r = e.compareDocumentPosition(this.contentDOM) & 2;
		else if (this.dom.firstChild) {
			if (t == 0) for (let t = e;; t = t.parentNode) {
				if (t == this.dom) {
					r = !1;
					break;
				}
				if (t.previousSibling) break;
			}
			if (r == null && t == e.childNodes.length) for (let t = e;; t = t.parentNode) {
				if (t == this.dom) {
					r = !0;
					break;
				}
				if (t.nextSibling) break;
			}
		}
		return r ?? n > 0 ? this.posAtEnd : this.posAtStart;
	}
	nearestDesc(e, t = !1) {
		for (let n = !0, r = e; r; r = r.parentNode) {
			let i = this.getDesc(r), a;
			if (i && (!t || i.node)) {
				if (n && (a = i.nodeDOM) && !(a.nodeType == 1 ? a.contains(e.nodeType == 1 ? e : e.parentNode) : a == e)) n = !1;
				else return i;
			}
		}
	}
	getDesc(e) {
		let t = e.pmViewDesc;
		for (let e = t; e; e = e.parent) if (e == this) return t;
	}
	posFromDOM(e, t, n) {
		for (let r = e; r; r = r.parentNode) {
			let i = this.getDesc(r);
			if (i) return i.localPosFromDOM(e, t, n);
		}
		return -1;
	}
	descAt(e) {
		for (let t = 0, n = 0; t < this.children.length; t++) {
			let r = this.children[t], i = n + r.size;
			if (n == e && i != n) {
				for (; !r.border && r.children.length;) for (let e = 0; e < r.children.length; e++) {
					let t = r.children[e];
					if (t.size) {
						r = t;
						break;
					}
				}
				return r;
			}
			if (e < i) return r.descAt(e - n - r.border);
			n = i;
		}
	}
	domFromPos(e, t) {
		if (!this.contentDOM) return {
			node: this.dom,
			offset: 0,
			atom: e + 1
		};
		let n = 0, r = 0;
		for (let t = 0; n < this.children.length; n++) {
			let i = this.children[n], a = t + i.size;
			if (a > e || i instanceof Oz) {
				r = e - t;
				break;
			}
			t = a;
		}
		if (r) return this.children[n].domFromPos(r - this.children[n].border, t);
		for (let e; n && !(e = this.children[n - 1]).size && e instanceof Sz && e.side >= 0; n--);
		if (t <= 0) {
			let e, r = !0;
			for (; e = n ? this.children[n - 1] : null, !(!e || e.dom.parentNode == this.contentDOM); n--, r = !1);
			return e && t && r && !e.border && !e.domAtom ? e.domFromPos(e.size, t) : {
				node: this.contentDOM,
				offset: e ? rR(e.dom) + 1 : 0
			};
		}
		{
			let e, r = !0;
			for (; e = n < this.children.length ? this.children[n] : null, !(!e || e.dom.parentNode == this.contentDOM); n++, r = !1);
			return e && r && !e.border && !e.domAtom ? e.domFromPos(0, t) : {
				node: this.contentDOM,
				offset: e ? rR(e.dom) : this.contentDOM.childNodes.length
			};
		}
	}
	parseRange(e, t, n = 0) {
		if (this.children.length == 0) return {
			node: this.contentDOM,
			from: e,
			to: t,
			fromOffset: 0,
			toOffset: this.contentDOM.childNodes.length
		};
		let r = -1, i = -1;
		for (let a = n, o = 0;; o++) {
			let n = this.children[o], s = a + n.size;
			if (r == -1 && e <= s) {
				let i = a + n.border;
				if (e >= i && t <= s - n.border && n.node && n.contentDOM && this.contentDOM.contains(n.contentDOM)) return n.parseRange(e, t, i);
				e = a;
				for (let t = o; t > 0; t--) {
					let n = this.children[t - 1];
					if (n.size && n.dom.parentNode == this.contentDOM && !n.emptyChildAt(1)) {
						r = rR(n.dom) + 1;
						break;
					}
					e -= n.size;
				}
				r == -1 && (r = 0);
			}
			if (r > -1 && (s > t || o == this.children.length - 1)) {
				t = s;
				for (let e = o + 1; e < this.children.length; e++) {
					let n = this.children[e];
					if (n.size && n.dom.parentNode == this.contentDOM && !n.emptyChildAt(-1)) {
						i = rR(n.dom);
						break;
					}
					t += n.size;
				}
				i == -1 && (i = this.contentDOM.childNodes.length);
				break;
			}
			a = s;
		}
		return {
			node: this.contentDOM,
			from: e,
			to: t,
			fromOffset: r,
			toOffset: i
		};
	}
	emptyChildAt(e) {
		if (this.border || !this.contentDOM || !this.children.length) return !1;
		let t = this.children[e < 0 ? 0 : this.children.length - 1];
		return t.size == 0 || t.emptyChildAt(e);
	}
	domAfterPos(e) {
		let { node: t, offset: n } = this.domFromPos(e, 0);
		if (t.nodeType != 1 || n == t.childNodes.length) throw RangeError("No node after pos " + e);
		return t.childNodes[n];
	}
	setSelection(e, t, n, r = !1) {
		let i = Math.min(e, t), a = Math.max(e, t);
		for (let o = 0, s = 0; o < this.children.length; o++) {
			let c = this.children[o], l = s + c.size;
			if (i > s && a < l) return c.setSelection(e - s - c.border, t - s - c.border, n, r);
			s = l;
		}
		let o = this.domFromPos(e, e ? -1 : 1), s = t == e ? o : this.domFromPos(t, t ? -1 : 1), c = n.root.getSelection(), l = n.domSelectionRange(), u = !1;
		if ((OR || MR) && e == t) {
			let { node: e, offset: t } = o;
			if (e.nodeType == 3) {
				if (u = !!(t && e.nodeValue[t - 1] == "\n"), u && t == e.nodeValue.length) for (let t = e, n; t; t = t.parentNode) {
					if (n = t.nextSibling) {
						n.nodeName == "BR" && (o = s = {
							node: n.parentNode,
							offset: rR(n) + 1
						});
						break;
					}
					let e = t.pmViewDesc;
					if (e && e.node && e.node.isBlock) break;
				}
			} else {
				let n = e.childNodes[t - 1];
				u = n && (n.nodeName == "BR" || n.contentEditable == "false");
			}
		}
		if (OR && l.focusNode && l.focusNode != s.node && l.focusNode.nodeType == 1) {
			let e = l.focusNode.childNodes[l.focusOffset];
			e && e.contentEditable == "false" && (r = !0);
		}
		if (!(r || u && MR) && cR(o.node, o.offset, l.anchorNode, l.anchorOffset) && cR(s.node, s.offset, l.focusNode, l.focusOffset)) return;
		let d = !1;
		if ((c.extend || e == t) && !(u && OR)) {
			c.collapse(o.node, o.offset);
			try {
				e != t && c.extend(s.node, s.offset), d = !0;
			} catch {}
		}
		if (!d) {
			if (e > t) {
				let e = o;
				o = s, s = e;
			}
			let n = document.createRange();
			n.setEnd(s.node, s.offset), n.setStart(o.node, o.offset), c.removeAllRanges(), c.addRange(n);
		}
	}
	ignoreMutation(e) {
		return !this.contentDOM && e.type != "selection";
	}
	get contentLost() {
		return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
	}
	markDirty(e, t) {
		for (let n = 0, r = 0; r < this.children.length; r++) {
			let i = this.children[r], a = n + i.size;
			if (n == a ? e <= a && t >= n : e < a && t > n) {
				let r = n + i.border, o = a - i.border;
				if (e >= r && t <= o) {
					this.dirty = e == n || t == a ? yz : vz, e == r && t == o && (i.contentLost || i.dom.parentNode != this.contentDOM) ? i.dirty = bz : i.markDirty(e - r, t - r);
					return;
				}
				i.dirty = i.dom == i.contentDOM && i.dom.parentNode == this.contentDOM && !i.children.length ? yz : bz;
			}
			n = a;
		}
		this.dirty = yz;
	}
	markParentsDirty() {
		let e = 1;
		for (let t = this.parent; t; t = t.parent, e++) {
			let n = e == 1 ? yz : vz;
			t.dirty < n && (t.dirty = n);
		}
	}
	get domAtom() {
		return !1;
	}
	get ignoreForCoords() {
		return !1;
	}
	get ignoreForSelection() {
		return !1;
	}
	isText(e) {
		return !1;
	}
}, Sz = class extends xz {
	constructor(e, t, n, r) {
		let i, a = t.type.toDOM;
		if (typeof a == "function" && (a = a(n, () => {
			if (!i) return r;
			if (i.parent) return i.parent.posBeforeChild(i);
		})), !t.type.spec.raw) {
			if (a.nodeType != 1) {
				let e = document.createElement("span");
				e.appendChild(a), a = e;
			}
			a.contentEditable = "false", a.classList.add("ProseMirror-widget");
		}
		super(e, [], a, null), this.widget = t, this.widget = t, i = this;
	}
	matchesWidget(e) {
		return this.dirty == _z && e.type.eq(this.widget.type);
	}
	parseRule() {
		return { ignore: !0 };
	}
	stopEvent(e) {
		let t = this.widget.spec.stopEvent;
		return t ? t(e) : !1;
	}
	ignoreMutation(e) {
		return e.type != "selection" || this.widget.spec.ignoreSelection;
	}
	destroy() {
		this.widget.type.destroy(this.dom), super.destroy();
	}
	get domAtom() {
		return !0;
	}
	get ignoreForSelection() {
		return !!this.widget.type.spec.relaxedSide;
	}
	get side() {
		return this.widget.type.side;
	}
}, Cz = class extends xz {
	constructor(e, t, n, r) {
		super(e, [], t, null), this.textDOM = n, this.text = r;
	}
	get size() {
		return this.text.length;
	}
	localPosFromDOM(e, t) {
		return e == this.textDOM ? this.posAtStart + t : this.posAtStart + (t ? this.size : 0);
	}
	domFromPos(e) {
		return {
			node: this.textDOM,
			offset: e
		};
	}
	ignoreMutation(e) {
		return e.type === "characterData" && e.target.nodeValue == e.oldValue;
	}
}, wz = class e extends xz {
	constructor(e, t, n, r, i) {
		super(e, [], n, r), this.mark = t, this.spec = i;
	}
	static create(t, n, r, i) {
		let a = i.nodeViews[n.type.name], o = a && a(n, i, r);
		return (!o || !o.dom) && (o = bF.renderSpec(document, n.type.spec.toDOM(n, r), null, n.attrs)), new e(t, n, o.dom, o.contentDOM || o.dom, o);
	}
	parseRule() {
		return this.dirty & bz || this.mark.type.spec.reparseInView ? null : {
			mark: this.mark.type.name,
			attrs: this.mark.attrs,
			contentElement: this.contentDOM
		};
	}
	matchesMark(e) {
		return this.dirty != bz && this.mark.eq(e);
	}
	markDirty(e, t) {
		if (super.markDirty(e, t), this.dirty != _z) {
			let e = this.parent;
			for (; !e.node;) e = e.parent;
			e.dirty < this.dirty && (e.dirty = this.dirty), this.dirty = _z;
		}
	}
	slice(t, n, r) {
		let i = e.create(this.parent, this.mark, !0, r), a = this.children, o = this.size;
		n < o && (a = Gz(a, n, o, r)), t > 0 && (a = Gz(a, 0, t, r));
		for (let e = 0; e < a.length; e++) a[e].parent = i;
		return i.children = a, i;
	}
	ignoreMutation(e) {
		return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
	}
	destroy() {
		this.spec.destroy && this.spec.destroy(), super.destroy();
	}
}, Tz = class e extends xz {
	constructor(e, t, n, r, i, a, o, s, c) {
		super(e, [], i, a), this.node = t, this.outerDeco = n, this.innerDeco = r, this.nodeDOM = o;
	}
	static create(t, n, r, i, a, o) {
		let s = a.nodeViews[n.type.name], c, l = s && s(n, a, () => {
			if (!c) return o;
			if (c.parent) return c.parent.posBeforeChild(c);
		}, r, i), u = l && l.dom, d = l && l.contentDOM;
		if (n.isText) {
			if (!u) u = document.createTextNode(n.text);
			else if (u.nodeType != 3) throw RangeError("Text must be rendered as a DOM text node");
		} else if (!u) {
			let e = bF.renderSpec(document, n.type.spec.toDOM(n), null, n.attrs);
			({dom: u, contentDOM: d} = e);
		}
		!d && !n.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), n.type.spec.draggable && (u.draggable = !0));
		let f = u;
		return u = Iz(u, r, n), l ? c = new kz(t, n, r, i, u, d || null, f, l, a, o + 1) : n.isText ? new Dz(t, n, r, i, u, f, a) : new e(t, n, r, i, u, d || null, f, a, o + 1);
	}
	parseRule() {
		if (this.node.type.spec.reparseInView) return null;
		let e = {
			node: this.node.type.name,
			attrs: this.node.attrs
		};
		if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM) e.getContent = () => this.node.content;
		else if (!this.contentLost) e.contentElement = this.contentDOM;
		else {
			for (let t = this.children.length - 1; t >= 0; t--) {
				let n = this.children[t];
				if (this.dom.contains(n.dom.parentNode)) {
					e.contentElement = n.dom.parentNode;
					break;
				}
			}
			e.contentElement || (e.getContent = () => X.empty);
		}
		return e;
	}
	matchesNode(e, t, n) {
		return this.dirty == _z && e.eq(this.node) && Lz(t, this.outerDeco) && n.eq(this.innerDeco);
	}
	get size() {
		return this.node.nodeSize;
	}
	get border() {
		return +!this.node.isLeaf;
	}
	updateChildren(e, t) {
		let n = this.node.inlineContent, r = t, i = e.composing ? this.localCompositionInfo(e, t) : null, a = i && i.pos > -1 ? i : null, o = i && i.pos < 0, s = new zz(this, a && a.node, e);
		Hz(this.node, this.innerDeco, (t, i, a) => {
			t.spec.marks ? s.syncToMarks(t.spec.marks, n, e, i) : t.type.side >= 0 && !a && s.syncToMarks(i == this.node.childCount ? dP.none : this.node.child(i).marks, n, e, i), s.placeWidget(t, e, r);
		}, (t, a, c, l) => {
			s.syncToMarks(t.marks, n, e, l);
			let u;
			s.findNodeMatch(t, a, c, l) || o && e.state.selection.from > r && e.state.selection.to < r + t.nodeSize && (u = s.findIndexWithChild(i.node)) > -1 && s.updateNodeAt(t, a, c, u, e) || s.updateNextNode(t, a, c, e, l, r) || s.addNode(t, a, c, e, r), r += t.nodeSize;
		}), s.syncToMarks([], n, e, 0), this.node.isTextblock && s.addTextblockHacks(), s.destroyRest(), (s.changed || this.dirty == yz) && (a && this.protectLocalComposition(e, a), Az(this.contentDOM, this.children, e), NR && Uz(this.dom));
	}
	localCompositionInfo(e, t) {
		let { from: n, to: r } = e.state.selection;
		if (!(e.state.selection instanceof GI) || n < t || r > t + this.node.content.size) return null;
		let i = e.input.compositionNode;
		if (!i || !this.dom.contains(i.parentNode)) return null;
		if (this.node.inlineContent) {
			let e = i.nodeValue, a = Wz(this.node.content, e, n - t, r - t);
			return a < 0 ? null : {
				node: i,
				pos: a,
				text: e
			};
		}
		return {
			node: i,
			pos: -1,
			text: ""
		};
	}
	protectLocalComposition(e, { node: t, pos: n, text: r }) {
		if (this.getDesc(t)) return;
		let i = t;
		for (; i.parentNode != this.contentDOM; i = i.parentNode) {
			for (; i.previousSibling;) i.parentNode.removeChild(i.previousSibling);
			for (; i.nextSibling;) i.parentNode.removeChild(i.nextSibling);
			i.pmViewDesc && (i.pmViewDesc = void 0);
		}
		let a = new Cz(this, i, t, r);
		e.input.compositionNodes.push(a), this.children = Gz(this.children, n, n + r.length, e, a);
	}
	update(e, t, n, r) {
		return this.dirty == bz || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, t, n, r), !0);
	}
	updateInner(e, t, n, r) {
		this.updateOuterDeco(t), this.node = e, this.innerDeco = n, this.contentDOM && this.updateChildren(r, this.posAtStart), this.dirty = _z;
	}
	updateOuterDeco(e) {
		if (Lz(e, this.outerDeco)) return;
		let t = this.nodeDOM.nodeType != 1, n = this.dom;
		this.dom = Pz(this.dom, this.nodeDOM, Nz(this.outerDeco, this.node, t), Nz(e, this.node, t)), this.dom != n && (n.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
	}
	selectNode() {
		this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.nodeDOM.draggable = !0));
	}
	deselectNode() {
		this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.nodeDOM.removeAttribute("draggable"));
	}
	get domAtom() {
		return this.node.isAtom;
	}
};
function Ez(e, t, n, r, i) {
	Iz(r, t, e);
	let a = new Tz(void 0, e, t, n, r, r, r, i, 0);
	return a.contentDOM && a.updateChildren(i, 0), a;
}
var Dz = class e extends Tz {
	constructor(e, t, n, r, i, a, o) {
		super(e, t, n, r, i, null, a, o, 0);
	}
	parseRule() {
		let e = this.nodeDOM.parentNode;
		for (; e && e != this.dom && !e.pmIsDeco;) e = e.parentNode;
		return { skip: e || !0 };
	}
	update(e, t, n, r) {
		return this.dirty == bz || this.dirty != _z && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != _z || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, r.trackWrites == this.nodeDOM && (r.trackWrites = null)), this.node = e, this.dirty = _z, !0);
	}
	inParent() {
		let e = this.parent.contentDOM;
		for (let t = this.nodeDOM; t; t = t.parentNode) if (t == e) return !0;
		return !1;
	}
	domFromPos(e) {
		return {
			node: this.nodeDOM,
			offset: e
		};
	}
	localPosFromDOM(e, t, n) {
		return e == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(e, t, n);
	}
	ignoreMutation(e) {
		return e.type != "characterData" && e.type != "selection";
	}
	slice(t, n, r) {
		let i = this.node.cut(t, n), a = document.createTextNode(i.text);
		return new e(this.parent, i, this.outerDeco, this.innerDeco, a, a, r);
	}
	markDirty(e, t) {
		super.markDirty(e, t), this.dom != this.nodeDOM && (e == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = bz);
	}
	get domAtom() {
		return !1;
	}
	isText(e) {
		return this.node.text == e;
	}
}, Oz = class extends xz {
	parseRule() {
		return { ignore: !0 };
	}
	matchesHack(e) {
		return this.dirty == _z && this.dom.nodeName == e;
	}
	get domAtom() {
		return !0;
	}
	get ignoreForCoords() {
		return this.dom.nodeName == "IMG";
	}
}, kz = class extends Tz {
	constructor(e, t, n, r, i, a, o, s, c, l) {
		super(e, t, n, r, i, a, o, c, l), this.spec = s;
	}
	update(e, t, n, r) {
		if (this.dirty == bz) return !1;
		if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
			let i = this.spec.update(e, t, n);
			return i && this.updateInner(e, t, n, r), i;
		}
		return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, t, n, r);
	}
	selectNode() {
		this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
	}
	deselectNode() {
		this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
	}
	setSelection(e, t, n, r) {
		this.spec.setSelection ? this.spec.setSelection(e, t, n.root) : super.setSelection(e, t, n, r);
	}
	destroy() {
		this.spec.destroy && this.spec.destroy(), super.destroy();
	}
	stopEvent(e) {
		return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
	}
	ignoreMutation(e) {
		return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
	}
};
function Az(e, t, n) {
	let r = e.firstChild, i = !1;
	for (let a = 0; a < t.length; a++) {
		let o = t[a], s = o.dom;
		if (s.parentNode == e) {
			for (; s != r;) r = Rz(r), i = !0;
			r = r.nextSibling;
		} else i = !0, e.insertBefore(s, r);
		if (o instanceof wz) {
			let t = r ? r.previousSibling : e.lastChild;
			Az(o.contentDOM, o.children, n), r = t ? t.nextSibling : e.firstChild;
		}
	}
	for (; r;) r = Rz(r), i = !0;
	i && n.trackWrites == e && (n.trackWrites = null);
}
var jz = function(e) {
	e && (this.nodeName = e);
};
jz.prototype = Object.create(null);
var Mz = [new jz()];
function Nz(e, t, n) {
	if (e.length == 0) return Mz;
	let r = n ? Mz[0] : new jz(), i = [r];
	for (let a = 0; a < e.length; a++) {
		let o = e[a].type.attrs;
		if (o) {
			o.nodeName && i.push(r = new jz(o.nodeName));
			for (let e in o) {
				let a = o[e];
				a != null && (n && i.length == 1 && i.push(r = new jz(t.isInline ? "span" : "div")), e == "class" ? r.class = (r.class ? r.class + " " : "") + a : e == "style" ? r.style = (r.style ? r.style + ";" : "") + a : e != "nodeName" && (r[e] = a));
			}
		}
	}
	return i;
}
function Pz(e, t, n, r) {
	if (n == Mz && r == Mz) return t;
	let i = t;
	for (let t = 0; t < r.length; t++) {
		let a = r[t], o = n[t];
		if (t) {
			let t;
			o && o.nodeName == a.nodeName && i != e && (t = i.parentNode) && t.nodeName.toLowerCase() == a.nodeName ? i = t : (t = document.createElement(a.nodeName), t.pmIsDeco = !0, t.appendChild(i), o = Mz[0], i = t);
		}
		Fz(i, o || Mz[0], a);
	}
	return i;
}
function Fz(e, t, n) {
	for (let r in t) r != "class" && r != "style" && r != "nodeName" && !(r in n) && e.removeAttribute(r);
	for (let r in n) r != "class" && r != "style" && r != "nodeName" && n[r] != t[r] && e.setAttribute(r, n[r]);
	if (t.class != n.class) {
		let r = t.class ? t.class.split(" ").filter(Boolean) : [], i = n.class ? n.class.split(" ").filter(Boolean) : [];
		for (let t = 0; t < r.length; t++) i.indexOf(r[t]) == -1 && e.classList.remove(r[t]);
		for (let t = 0; t < i.length; t++) r.indexOf(i[t]) == -1 && e.classList.add(i[t]);
		e.classList.length == 0 && e.removeAttribute("class");
	}
	if (t.style != n.style) {
		if (t.style) {
			let n = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, r;
			for (; r = n.exec(t.style);) e.style.removeProperty(r[1]);
		}
		n.style && (e.style.cssText += n.style);
	}
}
function Iz(e, t, n) {
	return Pz(e, e, Mz, Nz(t, n, e.nodeType != 1));
}
function Lz(e, t) {
	if (e.length != t.length) return !1;
	for (let n = 0; n < e.length; n++) if (!e[n].type.eq(t[n].type)) return !1;
	return !0;
}
function Rz(e) {
	let t = e.nextSibling;
	return e.parentNode.removeChild(e), t;
}
var zz = class {
	constructor(e, t, n) {
		this.lock = t, this.view = n, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = Bz(e.node.content, e);
	}
	destroyBetween(e, t) {
		if (e != t) {
			for (let n = e; n < t; n++) this.top.children[n].destroy();
			this.top.children.splice(e, t - e), this.changed = !0;
		}
	}
	destroyRest() {
		this.destroyBetween(this.index, this.top.children.length);
	}
	syncToMarks(e, t, n, r) {
		let i = 0, a = this.stack.length >> 1, o = Math.min(a, e.length);
		for (; i < o && (i == a - 1 ? this.top : this.stack[i + 1 << 1]).matchesMark(e[i]) && e[i].type.spec.spanning !== !1;) i++;
		for (; i < a;) this.destroyRest(), this.top.dirty = _z, this.index = this.stack.pop(), this.top = this.stack.pop(), a--;
		for (; a < e.length;) {
			this.stack.push(this.top, this.index + 1);
			let i = -1, o = this.top.children.length;
			r < this.preMatch.index && (o = Math.min(this.index + 3, o));
			for (let t = this.index; t < o; t++) {
				let n = this.top.children[t];
				if (n.matchesMark(e[a]) && !this.isLocked(n.dom)) {
					i = t;
					break;
				}
			}
			if (i > -1) i > this.index && (this.changed = !0, this.destroyBetween(this.index, i)), this.top = this.top.children[this.index];
			else {
				let r = wz.create(this.top, e[a], t, n);
				this.top.children.splice(this.index, 0, r), this.top = r, this.changed = !0;
			}
			this.index = 0, a++;
		}
	}
	findNodeMatch(e, t, n, r) {
		let i = -1, a;
		if (r >= this.preMatch.index && (a = this.preMatch.matches[r - this.preMatch.index]).parent == this.top && a.matchesNode(e, t, n)) i = this.top.children.indexOf(a, this.index);
		else for (let r = this.index, a = Math.min(this.top.children.length, r + 5); r < a; r++) {
			let a = this.top.children[r];
			if (a.matchesNode(e, t, n) && !this.preMatch.matched.has(a)) {
				i = r;
				break;
			}
		}
		return i < 0 ? !1 : (this.destroyBetween(this.index, i), this.index++, !0);
	}
	updateNodeAt(e, t, n, r, i) {
		let a = this.top.children[r];
		return a.dirty == bz && a.dom == a.contentDOM && (a.dirty = yz), a.update(e, t, n, i) ? (this.destroyBetween(this.index, r), this.index++, !0) : !1;
	}
	findIndexWithChild(e) {
		for (;;) {
			let t = e.parentNode;
			if (!t) return -1;
			if (t == this.top.contentDOM) {
				let t = e.pmViewDesc;
				if (t) {
					for (let e = this.index; e < this.top.children.length; e++) if (this.top.children[e] == t) return e;
				}
				return -1;
			}
			e = t;
		}
	}
	updateNextNode(e, t, n, r, i, a) {
		for (let o = this.index; o < this.top.children.length; o++) {
			let s = this.top.children[o];
			if (s instanceof Tz) {
				let c = this.preMatch.matched.get(s);
				if (c != null && c != i) return !1;
				let l = s.dom, u, d = this.isLocked(l) && !(e.isText && s.node && s.node.isText && s.nodeDOM.nodeValue == e.text && s.dirty != bz && Lz(t, s.outerDeco));
				if (!d && s.update(e, t, n, r)) return this.destroyBetween(this.index, o), s.dom != l && (this.changed = !0), this.index++, !0;
				if (!d && (u = this.recreateWrapper(s, e, t, n, r, a))) return this.destroyBetween(this.index, o), this.top.children[this.index] = u, u.contentDOM && (u.dirty = yz, u.updateChildren(r, a + 1), u.dirty = _z), this.changed = !0, this.index++, !0;
				break;
			}
		}
		return !1;
	}
	recreateWrapper(e, t, n, r, i, a) {
		if (e.dirty || t.isAtom || !e.children.length || !e.node.content.eq(t.content) || !Lz(n, e.outerDeco) || !r.eq(e.innerDeco)) return null;
		let o = Tz.create(this.top, t, n, r, i, a);
		if (o.contentDOM) {
			o.children = e.children, e.children = [];
			for (let e of o.children) e.parent = o;
		}
		return e.destroy(), o;
	}
	addNode(e, t, n, r, i) {
		let a = Tz.create(this.top, e, t, n, r, i);
		a.contentDOM && a.updateChildren(r, i + 1), this.top.children.splice(this.index++, 0, a), this.changed = !0;
	}
	placeWidget(e, t, n) {
		let r = this.index < this.top.children.length ? this.top.children[this.index] : null;
		if (r && r.matchesWidget(e) && (e == r.widget || !r.widget.type.toDOM.parentNode)) this.index++;
		else {
			let r = new Sz(this.top, e, t, n);
			this.top.children.splice(this.index++, 0, r), this.changed = !0;
		}
	}
	addTextblockHacks() {
		let e = this.top.children[this.index - 1], t = this.top;
		for (; e instanceof wz;) t = e, e = t.children[t.children.length - 1];
		(!e || !(e instanceof Dz) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((MR || AR) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
	}
	addHackNode(e, t) {
		if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(e)) this.index++;
		else {
			let n = document.createElement(e);
			e == "IMG" && (n.className = "ProseMirror-separator", n.alt = ""), e == "BR" && (n.className = "ProseMirror-trailingBreak");
			let r = new Oz(this.top, [], n, null);
			t == this.top ? t.children.splice(this.index++, 0, r) : t.children.push(r), this.changed = !0;
		}
	}
	isLocked(e) {
		return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
	}
};
function Bz(e, t) {
	let n = t, r = n.children.length, i = e.childCount, a = /* @__PURE__ */ new Map(), o = [];
	outer: for (; i > 0;) {
		let s;
		for (;;) if (r) {
			let e = n.children[r - 1];
			if (e instanceof wz) n = e, r = e.children.length;
			else {
				s = e, r--;
				break;
			}
		} else if (n == t) break outer;
		else r = n.parent.children.indexOf(n), n = n.parent;
		let c = s.node;
		if (c) {
			if (c != e.child(i - 1)) break;
			--i, a.set(s, i), o.push(s);
		}
	}
	return {
		index: i,
		matched: a,
		matches: o.reverse()
	};
}
function Vz(e, t) {
	return e.type.side - t.type.side;
}
function Hz(e, t, n, r) {
	let i = t.locals(e), a = 0;
	if (i.length == 0) {
		for (let n = 0; n < e.childCount; n++) {
			let o = e.child(n);
			r(o, i, t.forChild(a, o), n), a += o.nodeSize;
		}
		return;
	}
	let o = 0, s = [], c = null;
	for (let l = 0;;) {
		let u, d;
		for (; o < i.length && i[o].to == a;) {
			let e = i[o++];
			e.widget && (u ? (d ||= [u]).push(e) : u = e);
		}
		if (u) {
			if (d) {
				d.sort(Vz);
				for (let e = 0; e < d.length; e++) n(d[e], l, !!c);
			} else n(u, l, !!c);
		}
		let f, p;
		if (c) p = -1, f = c, c = null;
		else if (l < e.childCount) p = l, f = e.child(l++);
		else break;
		for (let e = 0; e < s.length; e++) s[e].to <= a && s.splice(e--, 1);
		for (; o < i.length && i[o].from <= a && i[o].to > a;) s.push(i[o++]);
		let m = a + f.nodeSize;
		if (f.isText) {
			let e = m;
			o < i.length && i[o].from < e && (e = i[o].from);
			for (let t = 0; t < s.length; t++) s[t].to < e && (e = s[t].to);
			e < m && (c = f.cut(e - a), f = f.cut(0, e - a), m = e, p = -1);
		} else for (; o < i.length && i[o].to < m;) o++;
		let h = f.isInline && !f.isLeaf ? s.filter((e) => !e.inline) : s.slice();
		r(f, h, t.forChild(a, f), p), a = m;
	}
}
function Uz(e) {
	if (e.nodeName == "UL" || e.nodeName == "OL") {
		let t = e.style.cssText;
		e.style.cssText = t + "; list-style: square !important", window.getComputedStyle(e).listStyle, e.style.cssText = t;
	}
}
function Wz(e, t, n, r) {
	for (let i = 0, a = 0; i < e.childCount && a <= r;) {
		let o = e.child(i++), s = a;
		if (a += o.nodeSize, !o.isText) continue;
		let c = o.text;
		for (; i < e.childCount;) {
			let t = e.child(i++);
			if (a += t.nodeSize, !t.isText) break;
			c += t.text;
		}
		if (a >= n) {
			if (a >= r && c.slice(r - t.length - s, r - s) == t) return r - t.length;
			let e = s < r ? c.lastIndexOf(t, r - s - 1) : -1;
			if (e >= 0 && e + t.length + s >= n) return s + e;
			if (n == r && c.length >= r + t.length - s && c.slice(r - s, r - s + t.length) == t) return r;
		}
	}
	return -1;
}
function Gz(e, t, n, r, i) {
	let a = [];
	for (let o = 0, s = 0; o < e.length; o++) {
		let c = e[o], l = s, u = s += c.size;
		l >= n || u <= t ? a.push(c) : (l < t && a.push(c.slice(0, t - l, r)), i &&= (a.push(i), void 0), u > n && a.push(c.slice(n - l, c.size, r)));
	}
	return a;
}
function Kz(e, t = null) {
	let n = e.domSelectionRange(), r = e.state.doc;
	if (!n.focusNode) return null;
	let i = e.docView.nearestDesc(n.focusNode), a = i && i.size == 0, o = e.docView.posFromDOM(n.focusNode, n.focusOffset, 1);
	if (o < 0) return null;
	let s = r.resolve(o), c, l;
	if (gR(n)) {
		for (c = o; i && !i.node;) i = i.parent;
		let e = i.node;
		if (i && e.isAtom && qI.isSelectable(e) && i.parent && !(e.isInline && mR(n.focusNode, n.focusOffset, i.dom))) {
			let e = i.posBefore;
			l = new qI(o == e ? s : r.resolve(e));
		}
	} else {
		if (n instanceof e.dom.ownerDocument.defaultView.Selection && n.rangeCount > 1) {
			let t = o, i = o;
			for (let r = 0; r < n.rangeCount; r++) {
				let a = n.getRangeAt(r);
				t = Math.min(t, e.docView.posFromDOM(a.startContainer, a.startOffset, 1)), i = Math.max(i, e.docView.posFromDOM(a.endContainer, a.endOffset, -1));
			}
			if (t < 0) return null;
			[c, o] = i == e.state.selection.anchor ? [i, t] : [t, i], s = r.resolve(o);
		} else c = e.docView.posFromDOM(n.anchorNode, n.anchorOffset, 1);
		if (c < 0) return null;
	}
	let u = r.resolve(c);
	if (!l) {
		let n = t == "pointer" || e.state.selection.head < s.pos && !a ? 1 : -1;
		l = rB(e, u, s, n);
	}
	return l;
}
function qz(e) {
	return e.editable ? e.hasFocus() : aB(e) && document.activeElement && document.activeElement.contains(e.dom);
}
function Jz(e, t = !1) {
	let n = e.state.selection;
	if (tB(e, n), !qz(e)) return;
	let r = e.input.mouseDown;
	if (!t && AR && r) {
		let t = e.domSelectionRange(), n = e.domObserver.currentSelection;
		if (t.anchorNode && n.anchorNode && cR(t.anchorNode, t.anchorOffset, n.anchorNode, n.anchorOffset) && r.delaySelUpdate()) {
			e.domObserver.setCurSelection();
			return;
		}
	}
	if (e.domObserver.disconnectSelection(), e.cursorWrapper) eB(e);
	else {
		let { anchor: r, head: i } = n, a, o;
		Yz && !(n instanceof GI) && (n.$from.parent.inlineContent || (a = Xz(e, n.from)), !n.empty && !n.$from.parent.inlineContent && (o = Xz(e, n.to))), e.docView.setSelection(r, i, e, t), Yz && (a && Qz(a), o && Qz(o)), n.visible ? e.dom.classList.remove("ProseMirror-hideselection") : (e.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && $z(e));
	}
	e.domObserver.setCurSelection(), e.domObserver.connectSelection();
}
var Yz = MR || AR && jR < 63;
function Xz(e, t) {
	let { node: n, offset: r } = e.docView.domFromPos(t, 0), i = r < n.childNodes.length ? n.childNodes[r] : null, a = r ? n.childNodes[r - 1] : null;
	if (MR && i && i.contentEditable == "false") return Zz(i);
	if ((!i || i.contentEditable == "false") && (!a || a.contentEditable == "false")) {
		if (i) return Zz(i);
		if (a) return Zz(a);
	}
}
function Zz(e) {
	return e.contentEditable = "true", MR && e.draggable && (e.draggable = !1, e.wasDraggable = !0), e;
}
function Qz(e) {
	e.contentEditable = "false", e.wasDraggable &&= (e.draggable = !0, null);
}
function $z(e) {
	let t = e.dom.ownerDocument;
	t.removeEventListener("selectionchange", e.input.hideSelectionGuard);
	let n = e.domSelectionRange(), r = n.anchorNode, i = n.anchorOffset;
	t.addEventListener("selectionchange", e.input.hideSelectionGuard = () => {
		(n.anchorNode != r || n.anchorOffset != i) && (t.removeEventListener("selectionchange", e.input.hideSelectionGuard), setTimeout(() => {
			(!qz(e) || e.state.selection.visible) && e.dom.classList.remove("ProseMirror-hideselection");
		}, 20));
	});
}
function eB(e) {
	let t = e.domSelection();
	if (!t) return;
	let n = e.cursorWrapper.dom, r = n.nodeName == "IMG";
	r ? t.collapse(n.parentNode, rR(n) + 1) : t.collapse(n, 0), !r && !e.state.selection.visible && ER && DR <= 11 && (n.disabled = !0, n.disabled = !1);
}
function tB(e, t) {
	if (t instanceof qI) {
		let n = e.docView.descAt(t.from);
		n != e.lastSelectedViewDesc && (nB(e), n && n.selectNode(), e.lastSelectedViewDesc = n);
	} else nB(e);
}
function nB(e) {
	e.lastSelectedViewDesc &&= (e.lastSelectedViewDesc.parent && e.lastSelectedViewDesc.deselectNode(), void 0);
}
function rB(e, t, n, r) {
	return e.someProp("createSelectionBetween", (r) => r(e, t, n)) || GI.between(t, n, r);
}
function iB(e) {
	return e.editable && !e.hasFocus() ? !1 : aB(e);
}
function aB(e) {
	let t = e.domSelectionRange();
	if (!t.anchorNode) return !1;
	try {
		return e.dom.contains(t.anchorNode.nodeType == 3 ? t.anchorNode.parentNode : t.anchorNode) && (e.editable || e.dom.contains(t.focusNode.nodeType == 3 ? t.focusNode.parentNode : t.focusNode));
	} catch {
		return !1;
	}
}
function oB(e) {
	let t = e.docView.domFromPos(e.state.selection.anchor, 0), n = e.domSelectionRange();
	return cR(t.node, t.offset, n.anchorNode, n.anchorOffset);
}
function sB(e, t) {
	let { $anchor: n, $head: r } = e.selection, i = t > 0 ? n.max(r) : n.min(r), a = i.parent.inlineContent ? i.depth ? e.doc.resolve(t > 0 ? i.after() : i.before()) : null : i;
	return a && VI.findFrom(a, t);
}
function cB(e, t) {
	return e.dispatch(e.state.tr.setSelection(t).scrollIntoView()), !0;
}
function lB(e, t, n) {
	let r = e.state.selection;
	if (r instanceof GI) {
		if (n.indexOf("s") > -1) {
			let { $head: n } = r, i = n.textOffset ? null : t < 0 ? n.nodeBefore : n.nodeAfter;
			if (!i || i.isText || !i.isLeaf) return !1;
			let a = e.state.doc.resolve(n.pos + i.nodeSize * (t < 0 ? -1 : 1));
			return cB(e, new GI(r.$anchor, a));
		}
		if (!r.empty) return !1;
		if (e.endOfTextblock(t > 0 ? "forward" : "backward")) {
			let n = sB(e.state, t);
			return n && n instanceof qI ? cB(e, n) : !1;
		}
		if (!(PR && n.indexOf("m") > -1)) {
			let n = r.$head, i = n.textOffset ? null : t < 0 ? n.nodeBefore : n.nodeAfter, a;
			if (!i || i.isText) return !1;
			let o = t < 0 ? n.pos - i.nodeSize : n.pos;
			return i.isAtom || (a = e.docView.descAt(o)) && !a.contentDOM ? qI.isSelectable(i) ? cB(e, new qI(t < 0 ? e.state.doc.resolve(n.pos - i.nodeSize) : n)) : LR ? cB(e, new GI(e.state.doc.resolve(t < 0 ? o : o + i.nodeSize))) : !1 : !1;
		}
	} else if (r instanceof qI && r.node.isInline) return cB(e, new GI(t > 0 ? r.$to : r.$from));
	else {
		let n = sB(e.state, t);
		return n ? cB(e, n) : !1;
	}
}
function uB(e) {
	return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function dB(e, t) {
	let n = e.pmViewDesc;
	return n && n.size == 0 && (t < 0 || e.nextSibling || e.nodeName != "BR");
}
function fB(e, t) {
	return t < 0 ? pB(e) : mB(e);
}
function pB(e) {
	let t = e.domSelectionRange(), n = t.focusNode, r = t.focusOffset;
	if (!n) return;
	let i, a, o = !1;
	for (OR && n.nodeType == 1 && r < uB(n) && dB(n.childNodes[r], -1) && (o = !0);;) if (r > 0) {
		if (n.nodeType != 1) break;
		{
			let e = n.childNodes[r - 1];
			if (dB(e, -1)) i = n, a = --r;
			else if (e.nodeType == 3) n = e, r = n.nodeValue.length;
			else break;
		}
	} else if (hB(n)) break;
	else {
		let t = n.previousSibling;
		for (; t && dB(t, -1);) i = n.parentNode, a = rR(t), t = t.previousSibling;
		if (t) n = t, r = uB(n);
		else {
			if (n = n.parentNode, n == e.dom) break;
			r = 0;
		}
	}
	o ? vB(e, n, r) : i && vB(e, i, a);
}
function mB(e) {
	let t = e.domSelectionRange(), n = t.focusNode, r = t.focusOffset;
	if (!n) return;
	let i = uB(n), a, o;
	for (;;) if (r < i) {
		if (n.nodeType != 1) break;
		let e = n.childNodes[r];
		if (dB(e, 1)) a = n, o = ++r;
		else break;
	} else if (hB(n)) break;
	else {
		let t = n.nextSibling;
		for (; t && dB(t, 1);) a = t.parentNode, o = rR(t) + 1, t = t.nextSibling;
		if (t) n = t, r = 0, i = uB(n);
		else {
			if (n = n.parentNode, n == e.dom) break;
			r = i = 0;
		}
	}
	a && vB(e, a, o);
}
function hB(e) {
	let t = e.pmViewDesc;
	return t && t.node && t.node.isBlock;
}
function gB(e, t) {
	for (; e && t == e.childNodes.length && !hR(e);) t = rR(e) + 1, e = e.parentNode;
	for (; e && t < e.childNodes.length;) {
		let n = e.childNodes[t];
		if (n.nodeType == 3) return n;
		if (n.nodeType == 1 && n.contentEditable == "false") break;
		e = n, t = 0;
	}
}
function _B(e, t) {
	for (; e && !t && !hR(e);) t = rR(e), e = e.parentNode;
	for (; e && t;) {
		let n = e.childNodes[t - 1];
		if (n.nodeType == 3) return n;
		if (n.nodeType == 1 && n.contentEditable == "false") break;
		e = n, t = e.childNodes.length;
	}
}
function vB(e, t, n) {
	if (t.nodeType != 3) {
		let e, r;
		(r = gB(t, n)) ? (t = r, n = 0) : (e = _B(t, n)) && (t = e, n = e.nodeValue.length);
	}
	let r = e.domSelection();
	if (!r) return;
	if (gR(r)) {
		let e = document.createRange();
		e.setEnd(t, n), e.setStart(t, n), r.removeAllRanges(), r.addRange(e);
	} else r.extend && r.extend(t, n);
	e.domObserver.setCurSelection();
	let { state: i } = e;
	setTimeout(() => {
		e.state == i && Jz(e);
	}, 50);
}
function yB(e, t) {
	let n = e.state.doc.resolve(t);
	if (!(AR || FR) && n.parent.inlineContent) {
		let r = e.coordsAtPos(t);
		if (t > n.start()) {
			let n = e.coordsAtPos(t - 1), i = (n.top + n.bottom) / 2;
			if (i > r.top && i < r.bottom && Math.abs(n.left - r.left) > 1) return n.left < r.left ? "ltr" : "rtl";
		}
		if (t < n.end()) {
			let n = e.coordsAtPos(t + 1), i = (n.top + n.bottom) / 2;
			if (i > r.top && i < r.bottom && Math.abs(n.left - r.left) > 1) return n.left > r.left ? "ltr" : "rtl";
		}
	}
	return getComputedStyle(e.dom).direction == "rtl" ? "rtl" : "ltr";
}
function bB(e, t, n) {
	let r = e.state.selection;
	if (r instanceof GI && !r.empty || n.indexOf("s") > -1 || PR && n.indexOf("m") > -1) return !1;
	let { $from: i, $to: a } = r;
	if (!i.parent.inlineContent || e.endOfTextblock(t < 0 ? "up" : "down")) {
		let n = sB(e.state, t);
		if (n && n instanceof qI) return cB(e, n);
	}
	if (!i.parent.inlineContent) {
		let n = t < 0 ? i : a, o = r instanceof YI ? VI.near(n, t) : VI.findFrom(n, t);
		return o ? cB(e, o) : !1;
	}
	return !1;
}
function xB(e, t) {
	if (!(e.state.selection instanceof GI)) return !0;
	let { $head: n, $anchor: r, empty: i } = e.state.selection;
	if (!n.sameParent(r)) return !0;
	if (!i) return !1;
	if (e.endOfTextblock(t > 0 ? "forward" : "backward")) return !0;
	let a = !n.textOffset && (t < 0 ? n.nodeBefore : n.nodeAfter);
	if (a && !a.isText) {
		let r = e.state.tr;
		return t < 0 ? r.delete(n.pos - a.nodeSize, n.pos) : r.delete(n.pos, n.pos + a.nodeSize), e.dispatch(r), !0;
	}
	return !1;
}
function SB(e, t, n) {
	e.domObserver.stop(), t.contentEditable = n, e.domObserver.start();
}
function CB(e) {
	if (!MR || e.state.selection.$head.parentOffset > 0) return !1;
	let { focusNode: t, focusOffset: n } = e.domSelectionRange();
	if (t && t.nodeType == 1 && n == 0 && t.firstChild && t.firstChild.contentEditable == "false") {
		let n = t.firstChild;
		SB(e, n, "true"), setTimeout(() => SB(e, n, "false"), 20);
	}
	return !1;
}
function wB(e) {
	let t = "";
	return e.ctrlKey && (t += "c"), e.metaKey && (t += "m"), e.altKey && (t += "a"), e.shiftKey && (t += "s"), t;
}
function TB(e, t) {
	let n = t.keyCode, r = wB(t);
	if (n == 8 || PR && n == 72 && r == "c") return xB(e, -1) || fB(e, -1);
	if (n == 46 && !t.shiftKey || PR && n == 68 && r == "c") return xB(e, 1) || fB(e, 1);
	if (n == 13 || n == 27) return !0;
	if (n == 37 || PR && n == 66 && r == "c") {
		let t = n == 37 ? yB(e, e.state.selection.from) == "ltr" ? -1 : 1 : -1;
		return lB(e, t, r) || fB(e, t);
	}
	if (n == 39 || PR && n == 70 && r == "c") {
		let t = n == 39 ? yB(e, e.state.selection.from) == "ltr" ? 1 : -1 : 1;
		return lB(e, t, r) || fB(e, t);
	}
	return n == 38 || PR && n == 80 && r == "c" ? bB(e, -1, r) || fB(e, -1) : n == 40 || PR && n == 78 && r == "c" ? CB(e) || bB(e, 1, r) || fB(e, 1) : !(r != (PR ? "m" : "c") || n != 66 && n != 73 && n != 89 && n != 90);
}
function EB(e, t) {
	e.someProp("transformCopied", (n) => {
		t = n(t, e);
	});
	let n = [], { content: r, openStart: i, openEnd: a } = t;
	for (; i > 1 && a > 1 && r.childCount == 1 && r.firstChild.childCount == 1;) {
		i--, a--;
		let e = r.firstChild;
		n.push(e.type.name, e.attrs == e.type.defaultAttrs ? null : e.attrs), r = e.content;
	}
	let o = e.someProp("clipboardSerializer") || bF.fromSchema(e.state.schema), s = LB(), c = s.createElement("div");
	c.appendChild(o.serializeFragment(r, { document: s }));
	let l = c.firstChild, u, d = 0;
	for (; l && l.nodeType == 1 && (u = FB[l.nodeName.toLowerCase()]);) {
		for (let e = u.length - 1; e >= 0; e--) {
			let t = s.createElement(u[e]);
			for (; c.firstChild;) t.appendChild(c.firstChild);
			c.appendChild(t), d++;
		}
		l = c.firstChild;
	}
	return l && l.nodeType == 1 && l.setAttribute("data-pm-slice", `${i} ${a}${d ? ` -${d}` : ""} ${JSON.stringify(n)}`), {
		dom: c,
		text: e.someProp("clipboardTextSerializer", (n) => n(t, e)) || t.content.textBetween(0, t.content.size, "\n\n"),
		slice: t
	};
}
function DB(e, t, n, r, i) {
	let a = i.parent.type.spec.code, o, s;
	if (!n && !t) return null;
	let c = !!t && (r || a || !n);
	if (c) {
		if (e.someProp("transformPastedText", (n) => {
			t = n(t, a || r, e);
		}), a) return s = new Z(X.from(e.state.schema.text(t.replace(/\r\n?/g, "\n"))), 0, 0), e.someProp("transformPasted", (t) => {
			s = t(s, e, !0);
		}), s;
		let n = e.someProp("clipboardTextParser", (n) => n(t, i, r, e));
		if (n) s = n;
		else {
			let n = i.marks(), { schema: r } = e.state, a = bF.fromSchema(r);
			o = document.createElement("div"), t.split(/(?:\r\n?|\n)+/).forEach((e) => {
				let t = o.appendChild(document.createElement("p"));
				e && t.appendChild(a.serializeNode(r.text(e, n)));
			});
		}
	} else e.someProp("transformPastedHTML", (t) => {
		n = t(n, e);
	}), o = BB(n), LR && VB(o);
	let l = o && o.querySelector("[data-pm-slice]"), u = l && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(l.getAttribute("data-pm-slice") || "");
	if (u && u[3]) for (let e = +u[3]; e > 0; e--) {
		let e = o.firstChild;
		for (; e && e.nodeType != 1;) e = e.nextSibling;
		if (!e) break;
		o = e;
	}
	if (s ||= (e.someProp("clipboardParser") || e.someProp("domParser") || oF.fromSchema(e.state.schema)).parseSlice(o, {
		preserveWhitespace: !!(c || u),
		context: i,
		ruleFromNode(e) {
			return e.nodeName == "BR" && !e.nextSibling && e.parentNode && !OB.test(e.parentNode.nodeName) ? { ignore: !0 } : null;
		}
	}), u) s = HB(PB(s, +u[1], +u[2]), u[4]);
	else if (s = Z.maxOpen(kB(s.content, i), !0), s.openStart || s.openEnd) {
		let e = 0, t = 0;
		for (let t = s.content.firstChild; e < s.openStart && !t.type.spec.isolating; e++, t = t.firstChild);
		for (let e = s.content.lastChild; t < s.openEnd && !e.type.spec.isolating; t++, e = e.lastChild);
		s = PB(s, e, t);
	}
	return e.someProp("transformPasted", (t) => {
		s = t(s, e, c);
	}), s;
}
var OB = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function kB(e, t) {
	if (e.childCount < 2) return e;
	for (let n = t.depth; n >= 0; n--) {
		let r = t.node(n).contentMatchAt(t.index(n)), i, a = [];
		if (e.forEach((e) => {
			if (!a) return;
			let t = r.findWrapping(e.type), n;
			if (!t) return a = null;
			if (n = a.length && i.length && jB(t, i, e, a[a.length - 1], 0)) a[a.length - 1] = n;
			else {
				a.length && (a[a.length - 1] = MB(a[a.length - 1], i.length));
				let n = AB(e, t);
				a.push(n), r = r.matchType(n.type), i = t;
			}
		}), a) return X.from(a);
	}
	return e;
}
function AB(e, t, n = 0) {
	for (let r = t.length - 1; r >= n; r--) e = t[r].create(null, X.from(e));
	return e;
}
function jB(e, t, n, r, i) {
	if (i < e.length && i < t.length && e[i] == t[i]) {
		let a = jB(e, t, n, r.lastChild, i + 1);
		if (a) return r.copy(r.content.replaceChild(r.childCount - 1, a));
		if (r.contentMatchAt(r.childCount).matchType(i == e.length - 1 ? n.type : e[i + 1])) return r.copy(r.content.append(X.from(AB(n, e, i + 1))));
	}
}
function MB(e, t) {
	if (t == 0) return e;
	let n = e.content.replaceChild(e.childCount - 1, MB(e.lastChild, t - 1)), r = e.contentMatchAt(e.childCount).fillBefore(X.empty, !0);
	return e.copy(n.append(r));
}
function NB(e, t, n, r, i, a) {
	let o = t < 0 ? e.firstChild : e.lastChild, s = o.content;
	return e.childCount > 1 && (a = 0), i < r - 1 && (s = NB(s, t, n, r, i + 1, a)), i >= n && (s = t < 0 ? o.contentMatchAt(0).fillBefore(s, a <= i).append(s) : s.append(o.contentMatchAt(o.childCount).fillBefore(X.empty, !0))), e.replaceChild(t < 0 ? 0 : e.childCount - 1, o.copy(s));
}
function PB(e, t, n) {
	return t < e.openStart && (e = new Z(NB(e.content, -1, t, e.openStart, 0, e.openEnd), t, e.openEnd)), n < e.openEnd && (e = new Z(NB(e.content, 1, n, e.openEnd, 0, 0), e.openStart, n)), e;
}
var FB = {
	thead: ["table"],
	tbody: ["table"],
	tfoot: ["table"],
	caption: ["table"],
	colgroup: ["table"],
	col: ["table", "colgroup"],
	tr: ["table", "tbody"],
	td: [
		"table",
		"tbody",
		"tr"
	],
	th: [
		"table",
		"tbody",
		"tr"
	]
}, IB = null;
function LB() {
	return IB ||= document.implementation.createHTMLDocument("title");
}
var RB = null;
function zB(e) {
	let t = window.trustedTypes;
	return t ? (RB ||= t.defaultPolicy || t.createPolicy("ProseMirrorClipboard", { createHTML: (e) => e }), RB.createHTML(e)) : e;
}
function BB(e) {
	let t = /^(\s*<meta [^>]*>)*/.exec(e);
	t && (e = e.slice(t[0].length));
	let n = LB().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(e), i;
	if ((i = r && FB[r[1].toLowerCase()]) && (e = i.map((e) => "<" + e + ">").join("") + e + i.map((e) => "</" + e + ">").reverse().join("")), n.innerHTML = zB(e), i) for (let e = 0; e < i.length; e++) n = n.querySelector(i[e]) || n;
	return n;
}
function VB(e) {
	let t = e.querySelectorAll(AR ? "span:not([class]):not([style])" : "span.Apple-converted-space");
	for (let n = 0; n < t.length; n++) {
		let r = t[n];
		r.childNodes.length == 1 && r.textContent == "\xA0" && r.parentNode && r.parentNode.replaceChild(e.ownerDocument.createTextNode(" "), r);
	}
}
function HB(e, t) {
	if (!e.size) return e;
	let n = e.content.firstChild.type.schema, r;
	try {
		r = JSON.parse(t);
	} catch {
		return e;
	}
	let { content: i, openStart: a, openEnd: o } = e;
	for (let e = r.length - 2; e >= 0; e -= 2) {
		let t = n.nodes[r[e]];
		if (!t || t.hasRequiredAttrs()) break;
		i = X.from(t.create(r[e + 1], i)), a++, o++;
	}
	return new Z(i, a, o);
}
var UB = {}, WB = {}, GB = {
	touchstart: !0,
	touchmove: !0
}, KB = class {
	constructor() {
		this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = {
			time: 0,
			x: 0,
			y: 0,
			type: "",
			button: 0
		}, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.badSafariComposition = !1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = Object.create(null), this.hideSelectionGuard = null;
	}
};
function qB(e) {
	for (let t in UB) {
		let n = UB[t];
		e.dom.addEventListener(t, e.input.eventHandlers[t] = (t) => {
			QB(e, t) && !ZB(e, t) && (e.editable || !(t.type in WB)) && n(e, t);
		}, GB[t] ? { passive: !0 } : void 0);
	}
	MR && e.dom.addEventListener("input", () => null), XB(e);
}
function JB(e, t) {
	e.input.lastSelectionOrigin = t, e.input.lastSelectionTime = Date.now();
}
function YB(e) {
	e.input.mouseDown && e.input.mouseDown.done(), e.domObserver.stop();
	for (let t in e.input.eventHandlers) e.dom.removeEventListener(t, e.input.eventHandlers[t]);
	clearTimeout(e.input.composingTimeout), clearTimeout(e.input.lastIOSEnterFallbackTimeout);
}
function XB(e) {
	e.someProp("handleDOMEvents", (t) => {
		for (let n in t) e.input.eventHandlers[n] || e.dom.addEventListener(n, e.input.eventHandlers[n] = (t) => ZB(e, t));
	});
}
function ZB(e, t) {
	return e.someProp("handleDOMEvents", (n) => {
		let r = n[t.type];
		return r ? r(e, t) || t.defaultPrevented : !1;
	});
}
function QB(e, t) {
	if (!t.bubbles) return !0;
	if (t.defaultPrevented) return !1;
	for (let n = t.target; n != e.dom; n = n.parentNode) if (!n || n.nodeType == 11 || n.pmViewDesc && n.pmViewDesc.stopEvent(t)) return !1;
	return !0;
}
function $B(e, t) {
	!ZB(e, t) && UB[t.type] && (e.editable || !(t.type in WB)) && UB[t.type](e, t);
}
WB.keydown = (e, t) => {
	let n = t;
	if (e.input.shiftKey = n.keyCode == 16 || n.shiftKey, !gV(e) && (e.input.lastKeyCode = n.keyCode, e.input.lastKeyCodeTime = Date.now(), !(IR && AR && n.keyCode == 13))) {
		if (n.keyCode != 229 && e.domObserver.forceFlush(), NR && n.keyCode == 13 && !n.ctrlKey && !n.altKey && !n.metaKey) {
			let t = Date.now();
			e.input.lastIOSEnter = t, e.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
				e.input.lastIOSEnter == t && (e.someProp("handleKeyDown", (t) => t(e, _R(13, "Enter"))), e.input.lastIOSEnter = 0);
			}, 200);
		} else e.someProp("handleKeyDown", (t) => t(e, n)) || TB(e, n) ? n.preventDefault() : JB(e, "key");
	}
}, WB.keyup = (e, t) => {
	t.keyCode == 16 && (e.input.shiftKey = !1);
}, WB.keypress = (e, t) => {
	let n = t;
	if (gV(e) || !n.charCode || n.ctrlKey && !n.altKey || PR && n.metaKey) return;
	if (e.someProp("handleKeyPress", (t) => t(e, n))) {
		n.preventDefault();
		return;
	}
	let r = e.state.selection;
	if (!(r instanceof GI) || !r.$from.sameParent(r.$to)) {
		let t = String.fromCharCode(n.charCode), i = () => e.state.tr.insertText(t).scrollIntoView();
		!/[\r\n]/.test(t) && !e.someProp("handleTextInput", (n) => n(e, r.$from.pos, r.$to.pos, t, i)) && e.dispatch(i()), n.preventDefault();
	}
};
function eV(e) {
	return {
		left: e.clientX,
		top: e.clientY
	};
}
function tV(e, t) {
	let n = t.x - e.clientX, r = t.y - e.clientY;
	return n * n + r * r < 100;
}
function nV(e, t, n, r, i) {
	if (r == -1) return !1;
	let a = e.state.doc.resolve(r);
	for (let r = a.depth + 1; r > 0; r--) if (e.someProp(t, (t) => r > a.depth ? t(e, n, a.nodeAfter, a.before(r), i, !0) : t(e, n, a.node(r), a.before(r), i, !1))) return !0;
	return !1;
}
function rV(e, t, n) {
	if (e.focused || e.focus(), e.state.selection.eq(t)) return;
	let r = e.state.tr.setSelection(t);
	n == "pointer" && r.setMeta("pointer", !0), e.dispatch(r);
}
function iV(e, t) {
	if (t == -1) return !1;
	let n = e.state.doc.resolve(t), r = n.nodeAfter;
	return r && r.isAtom && qI.isSelectable(r) ? (rV(e, new qI(n), "pointer"), !0) : !1;
}
function aV(e, t) {
	if (t == -1) return !1;
	let n = e.state.selection, r, i;
	n instanceof qI && (r = n.node);
	let a = e.state.doc.resolve(t);
	for (let e = a.depth + 1; e > 0; e--) {
		let t = e > a.depth ? a.nodeAfter : a.node(e);
		if (qI.isSelectable(t)) {
			i = r && n.$from.depth > 0 && e >= n.$from.depth && a.before(n.$from.depth + 1) == n.$from.pos ? a.before(n.$from.depth) : a.before(e);
			break;
		}
	}
	return i != null && (rV(e, qI.create(e.state.doc, i), "pointer"), !0);
}
function oV(e, t, n, r, i) {
	return nV(e, "handleClickOn", t, n, r) || e.someProp("handleClick", (n) => n(e, t, r)) || (i ? aV(e, n) : iV(e, n));
}
function sV(e, t, n, r) {
	return nV(e, "handleDoubleClickOn", t, n, r) || e.someProp("handleDoubleClick", (n) => n(e, t, r));
}
function cV(e, t, n, r) {
	return nV(e, "handleTripleClickOn", t, n, r) || e.someProp("handleTripleClick", (n) => n(e, t, r)) || lV(e, n, r);
}
function lV(e, t, n) {
	if (n.button != 0) return !1;
	let r = uV(e, t, !0), i = e.state.doc;
	return r ? (rV(e, r, "pointer"), r instanceof GI && i.eq(e.state.doc) && (e.input.mouseDown = new hV(e, r)), !0) : !1;
}
function uV(e, t, n) {
	let r = e.state.doc;
	if (t == -1) return r.inlineContent ? GI.create(r, 0, r.content.size) : null;
	let i = r.resolve(t);
	for (let e = i.depth + 1; e > 0; e--) {
		let t = e > i.depth ? i.nodeAfter : i.node(e), a = i.before(e);
		if (t.inlineContent) return GI.create(r, a + 1, a + 1 + t.content.size);
		if (n && qI.isSelectable(t)) return qI.create(r, a);
	}
	return null;
}
function dV(e) {
	return SV(e);
}
var fV = PR ? "metaKey" : "ctrlKey";
UB.mousedown = (e, t) => {
	let n = t;
	e.input.shiftKey = n.shiftKey;
	let r = dV(e), i = Date.now(), a = "singleClick";
	i - e.input.lastClick.time < 500 && tV(n, e.input.lastClick) && !n[fV] && e.input.lastClick.button == n.button && (e.input.lastClick.type == "singleClick" ? a = "doubleClick" : e.input.lastClick.type == "doubleClick" && (a = "tripleClick")), e.input.lastClick = {
		time: i,
		x: n.clientX,
		y: n.clientY,
		type: a,
		button: n.button
	}, e.input.mouseDown && e.input.mouseDown.done();
	let o = e.posAtCoords(eV(n));
	o && (a == "singleClick" ? e.input.mouseDown = new mV(e, o, n, !!r) : (a == "doubleClick" ? sV : cV)(e, o.pos, o.inside, n) ? n.preventDefault() : JB(e, "pointer"));
};
var pV = class {
	constructor(e) {
		this.view = e, this.mightDrag = null, e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this));
	}
	up(e) {
		this.done();
	}
	move(e) {
		e.buttons == 0 && this.done();
	}
	done() {
		this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.view.input.mouseDown == this && (this.view.input.mouseDown = null);
	}
	delaySelUpdate() {
		return !1;
	}
}, mV = class extends pV {
	constructor(e, t, n, r) {
		super(e), this.pos = t, this.event = n, this.flushed = r, this.delayedSelectionSync = !1, this.startDoc = e.state.doc, this.selectNode = !!n[fV], this.allowDefault = n.shiftKey;
		let i, a;
		if (t.inside > -1) i = e.state.doc.nodeAt(t.inside), a = t.inside;
		else {
			let n = e.state.doc.resolve(t.pos);
			i = n.parent, a = n.depth ? n.before() : 0;
		}
		let o = r ? null : n.target, s = o ? e.docView.nearestDesc(o, !0) : null;
		this.target = s && s.nodeDOM.nodeType == 1 ? s.nodeDOM : null;
		let { selection: c } = e.state;
		n.button == 0 && (i.type.spec.draggable && i.type.spec.selectable !== !1 || c instanceof qI && c.from <= a && c.to > a) && (this.mightDrag = {
			node: i,
			pos: a,
			addAttr: !!(this.target && !this.target.draggable),
			setUneditable: !!(this.target && OR && !this.target.hasAttribute("contentEditable"))
		}), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
			this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
		}, 20), this.view.domObserver.start()), JB(e, "pointer");
	}
	done() {
		super.done(), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => {
			this.view.isDestroyed || Jz(this.view);
		});
	}
	up(e) {
		if (this.done(), !this.view.dom.contains(e.target)) return;
		let t = this.pos;
		this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(eV(e))), this.updateAllowDefault(e), this.allowDefault || !t ? JB(this.view, "pointer") : oV(this.view, t.pos, t.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || MR && this.mightDrag && !this.mightDrag.node.isAtom || AR && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (rV(this.view, VI.near(this.view.state.doc.resolve(t.pos)), "pointer"), e.preventDefault()) : JB(this.view, "pointer");
	}
	move(e) {
		this.updateAllowDefault(e), JB(this.view, "pointer"), super.move(e);
	}
	updateAllowDefault(e) {
		!this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
	}
	delaySelUpdate() {
		return this.allowDefault ? (this.delayedSelectionSync = !0, !0) : !1;
	}
}, hV = class extends pV {
	constructor(e, t) {
		super(e), this.startSelection = t, this.startDoc = e.state.doc;
	}
	move(e) {
		if (e.buttons == 0 || this.view.isDestroyed || !this.view.state.doc.eq(this.startDoc)) {
			this.done();
			return;
		}
		e.preventDefault(), JB(this.view, "pointer");
		let t = this.view.posAtCoords(eV(e)), n = t && uV(this.view, t.inside, !1);
		if (!n) return;
		let { doc: r } = this.view.state, i = this.startSelection, [a, o] = n.from < i.from ? [i.to, n.from] : [i.from, n.to];
		rV(this.view, GI.create(r, a, o), "pointer");
	}
};
UB.touchstart = (e) => {
	e.input.lastTouch = Date.now(), dV(e), JB(e, "pointer");
}, UB.touchmove = (e) => {
	e.input.lastTouch = Date.now(), JB(e, "pointer");
}, UB.contextmenu = (e) => dV(e);
function gV(e, t) {
	return e.composing ? !0 : MR && Math.abs(Date.now() - e.input.compositionEndedAt) < 500 ? (e.input.compositionEndedAt = -2e8, !0) : !1;
}
var _V = IR ? 5e3 : -1;
WB.compositionstart = WB.compositionupdate = (e) => {
	if (!e.composing) {
		e.domObserver.flush();
		let { state: t } = e, n = t.selection.$to;
		if (t.selection instanceof GI && (t.storedMarks || !n.textOffset && n.parentOffset && n.nodeBefore.marks.some((e) => e.type.spec.inclusive === !1) || AR && FR && vV(e))) e.markCursor = e.state.storedMarks || n.marks(), SV(e, !0), e.markCursor = null;
		else if (SV(e, !t.selection.empty), OR && t.selection.empty && n.parentOffset && !n.textOffset && n.nodeBefore.marks.length) {
			let t = e.domSelectionRange();
			for (let n = t.focusNode, r = t.focusOffset; n && n.nodeType == 1 && r != 0;) {
				let t = r < 0 ? n.lastChild : n.childNodes[r - 1];
				if (!t) break;
				if (t.nodeType == 3) {
					let n = e.domSelection();
					n && n.collapse(t, t.nodeValue.length);
					break;
				}
				n = t, r = -1;
			}
		}
		e.input.composing = !0;
	}
	yV(e, _V);
};
function vV(e) {
	let { focusNode: t, focusOffset: n } = e.domSelectionRange();
	if (!t || t.nodeType != 1 || n >= t.childNodes.length) return !1;
	let r = t.childNodes[n];
	return r.nodeType == 1 && r.contentEditable == "false";
}
WB.compositionend = (e, t) => {
	e.composing && (e.input.composing = !1, e.input.compositionEndedAt = Date.now(), e.input.compositionPendingChanges = e.domObserver.pendingRecords().length ? e.input.compositionID : 0, e.input.compositionNode = null, e.input.badSafariComposition ? e.domObserver.forceFlush() : e.input.compositionPendingChanges && Promise.resolve().then(() => e.domObserver.flush()), e.input.compositionID++, yV(e, 20));
};
function yV(e, t) {
	clearTimeout(e.input.composingTimeout), t > -1 && (e.input.composingTimeout = setTimeout(() => SV(e), t));
}
function bV(e) {
	for (e.composing && (e.input.composing = !1, e.input.compositionEndedAt = Date.now()); e.input.compositionNodes.length > 0;) e.input.compositionNodes.pop().markParentsDirty();
}
function xV(e) {
	let t = e.domSelectionRange();
	if (!t.focusNode) return null;
	let n = fR(t.focusNode, t.focusOffset), r = pR(t.focusNode, t.focusOffset);
	if (n && r && n != r) {
		let t = r.pmViewDesc, i = e.domObserver.lastChangedTextNode;
		if (n == i || r == i) return i;
		if (!t || !t.isText(r.nodeValue)) return r;
		if (e.input.compositionNode == r) {
			let e = n.pmViewDesc;
			if (!(!e || !e.isText(n.nodeValue))) return r;
		}
	}
	return n || r;
}
function SV(e, t = !1) {
	if (!(IR && e.domObserver.flushingSoon >= 0)) {
		if (e.domObserver.forceFlush(), bV(e), t || e.docView && e.docView.dirty) {
			let n = Kz(e), r = e.state.selection;
			return n && !n.eq(r) ? e.dispatch(e.state.tr.setSelection(n)) : (e.markCursor || t) && !r.$from.node(r.$from.sharedDepth(r.to)).inlineContent ? e.dispatch(e.state.tr.deleteSelection()) : e.updateState(e.state), !0;
		}
		return !1;
	}
}
function CV(e, t) {
	if (!e.dom.parentNode) return;
	let n = e.dom.parentNode.appendChild(document.createElement("div"));
	n.appendChild(t), n.style.cssText = "position: fixed; left: -10000px; top: 10px";
	let r = getSelection(), i = document.createRange();
	i.selectNodeContents(t), e.dom.blur(), r.removeAllRanges(), r.addRange(i), setTimeout(() => {
		n.parentNode && n.parentNode.removeChild(n), e.focus();
	}, 50);
}
var wV = ER && DR < 15 || NR && RR < 604;
UB.copy = WB.cut = (e, t) => {
	let n = t, r = e.state.selection, i = n.type == "cut";
	if (r.empty) return;
	let a = wV ? null : n.clipboardData, { dom: o, text: s } = EB(e, r.content());
	a ? (n.preventDefault(), a.clearData(), a.setData("text/html", o.innerHTML), a.setData("text/plain", s)) : CV(e, o), i && e.dispatch(e.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function TV(e) {
	return e.openStart == 0 && e.openEnd == 0 && e.content.childCount == 1 ? e.content.firstChild : null;
}
function EV(e, t) {
	if (!e.dom.parentNode) return;
	let n = e.input.shiftKey || e.state.selection.$from.parent.type.spec.code, r = e.dom.parentNode.appendChild(document.createElement(n ? "textarea" : "div"));
	n || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
	let i = e.input.shiftKey && e.input.lastKeyCode != 45;
	setTimeout(() => {
		e.focus(), r.parentNode && r.parentNode.removeChild(r), n ? DV(e, r.value, null, i, t) : DV(e, r.textContent, r.innerHTML, i, t);
	}, 50);
}
function DV(e, t, n, r, i) {
	let a = DB(e, t, n, r, e.state.selection.$from);
	if (e.someProp("handlePaste", (t) => t(e, i, a || Z.empty))) return !0;
	if (!a) return !1;
	let o = TV(a), s = o ? e.state.tr.replaceSelectionWith(o, r) : e.state.tr.replaceSelection(a);
	return e.dispatch(s.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function OV(e) {
	let t = e.getData("text/plain") || e.getData("Text");
	if (t) return t;
	let n = e.getData("text/uri-list");
	return n ? n.replace(/\r?\n/g, " ") : "";
}
WB.paste = (e, t) => {
	let n = t;
	if (e.composing && !IR) return;
	let r = wV ? null : n.clipboardData, i = e.input.shiftKey && e.input.lastKeyCode != 45;
	r && DV(e, OV(r), r.getData("text/html"), i, n) ? n.preventDefault() : EV(e, n);
};
var kV = class {
	constructor(e, t, n) {
		this.slice = e, this.move = t, this.node = n;
	}
}, AV = PR ? "altKey" : "ctrlKey";
function jV(e, t) {
	let n;
	return e.someProp("dragCopies", (e) => {
		n ||= e(t);
	}), n == null ? !t[AV] : !n;
}
UB.dragstart = (e, t) => {
	let n = t, r = e.input.mouseDown;
	if (r && r.done(), !n.dataTransfer) return;
	let i = e.state.selection, a = i.empty ? null : e.posAtCoords(eV(n)), o;
	if (!(a && a.pos >= i.from && a.pos <= (i instanceof qI ? i.to - 1 : i.to))) {
		if (r && r.mightDrag) o = qI.create(e.state.doc, r.mightDrag.pos);
		else if (n.target && n.target.nodeType == 1) {
			let t = e.docView.nearestDesc(n.target, !0);
			t && t.node.type.spec.draggable && t != e.docView && (o = qI.create(e.state.doc, t.posBefore));
		}
	}
	let { dom: s, text: c, slice: l } = EB(e, (o || e.state.selection).content());
	(!n.dataTransfer.files.length || !AR || jR > 120) && n.dataTransfer.clearData(), n.dataTransfer.setData(wV ? "Text" : "text/html", s.innerHTML), n.dataTransfer.effectAllowed = "copyMove", wV || n.dataTransfer.setData("text/plain", c), e.dragging = new kV(l, jV(e, n), o);
}, UB.dragend = (e) => {
	let t = e.dragging;
	window.setTimeout(() => {
		e.dragging == t && (e.dragging = null);
	}, 50);
}, WB.dragover = WB.dragenter = (e, t) => t.preventDefault(), WB.drop = (e, t) => {
	try {
		MV(e, t, e.dragging);
	} finally {
		e.dragging = null;
	}
};
function MV(e, t, n) {
	if (!t.dataTransfer) return;
	let r = e.posAtCoords(eV(t));
	if (!r) return;
	let i = e.state.doc.resolve(r.pos), a = n && n.slice;
	a ? e.someProp("transformPasted", (t) => {
		a = t(a, e, !1);
	}) : a = DB(e, OV(t.dataTransfer), wV ? null : t.dataTransfer.getData("text/html"), !1, i);
	let o = !!(n && jV(e, t));
	if (e.someProp("handleDrop", (n) => n(e, t, a || Z.empty, o))) {
		t.preventDefault();
		return;
	}
	if (!a) return;
	t.preventDefault();
	let s = a ? bI(e.state.doc, i.pos, a) : i.pos;
	s ??= i.pos;
	let c = e.state.tr;
	if (o) {
		let { node: e } = n;
		e ? e.replace(c) : c.deleteSelection();
	}
	let l = c.mapping.map(s), u = a.openStart == 0 && a.openEnd == 0 && a.content.childCount == 1, d = c.doc;
	if (u ? c.replaceRangeWith(l, l, a.content.firstChild) : c.replaceRange(l, l, a), c.doc.eq(d)) return;
	let f = c.doc.resolve(l);
	if (u && qI.isSelectable(a.content.firstChild) && f.nodeAfter && f.nodeAfter.sameMarkup(a.content.firstChild)) c.setSelection(new qI(f));
	else {
		let t = c.mapping.map(s);
		c.mapping.maps[c.mapping.maps.length - 1].forEach((e, n, r, i) => t = i), c.setSelection(rB(e, f, c.doc.resolve(t)));
	}
	e.focus(), e.dispatch(c.setMeta("uiEvent", "drop"));
}
UB.focus = (e) => {
	e.input.lastFocus = Date.now(), e.focused || (e.domObserver.stop(), e.dom.classList.add("ProseMirror-focused"), e.domObserver.start(), e.focused = !0, setTimeout(() => {
		e.docView && e.hasFocus() && !e.domObserver.currentSelection.eq(e.domSelectionRange()) && Jz(e);
	}, 20));
}, UB.blur = (e, t) => {
	let n = t;
	e.focused &&= (e.domObserver.stop(), e.dom.classList.remove("ProseMirror-focused"), e.domObserver.start(), n.relatedTarget && e.dom.contains(n.relatedTarget) && e.domObserver.currentSelection.clear(), !1);
}, UB.beforeinput = (e, t) => {
	if (AR && IR && t.inputType == "deleteContentBackward") {
		e.domObserver.flushSoon();
		let { domChangeCount: t } = e.input;
		setTimeout(() => {
			if (e.input.domChangeCount != t || (e.dom.blur(), e.focus(), e.someProp("handleKeyDown", (t) => t(e, _R(8, "Backspace"))))) return;
			let { $cursor: n } = e.state.selection;
			n && n.pos > 0 && e.dispatch(e.state.tr.delete(n.pos - 1, n.pos).scrollIntoView());
		}, 50);
	}
};
for (let e in WB) UB[e] = WB[e];
function NV(e, t) {
	if (e == t) return !0;
	for (let n in e) if (e[n] !== t[n]) return !1;
	for (let n in t) if (!(n in e)) return !1;
	return !0;
}
var PV = class e {
	constructor(e, t) {
		this.toDOM = e, this.spec = t || zV, this.side = this.spec.side || 0;
	}
	map(e, t, n, r) {
		let { pos: i, deleted: a } = e.mapResult(t.from + r, this.side < 0 ? -1 : 1);
		return a ? null : new LV(i - n, i - n, this);
	}
	valid() {
		return !0;
	}
	eq(t) {
		return this == t || t instanceof e && (this.spec.key && this.spec.key == t.spec.key || this.toDOM == t.toDOM && NV(this.spec, t.spec));
	}
	destroy(e) {
		this.spec.destroy && this.spec.destroy(e);
	}
}, FV = class e {
	constructor(e, t) {
		this.attrs = e, this.spec = t || zV;
	}
	map(e, t, n, r) {
		let i = e.map(t.from + r, this.spec.inclusiveStart ? -1 : 1) - n, a = e.map(t.to + r, this.spec.inclusiveEnd ? 1 : -1) - n;
		return i >= a ? null : new LV(i, a, this);
	}
	valid(e, t) {
		return t.from < t.to;
	}
	eq(t) {
		return this == t || t instanceof e && NV(this.attrs, t.attrs) && NV(this.spec, t.spec);
	}
	static is(t) {
		return t.type instanceof e;
	}
	destroy() {}
}, IV = class e {
	constructor(e, t) {
		this.attrs = e, this.spec = t || zV;
	}
	map(e, t, n, r) {
		let i = e.mapResult(t.from + r, 1);
		if (i.deleted) return null;
		let a = e.mapResult(t.to + r, -1);
		return a.deleted || a.pos <= i.pos ? null : new LV(i.pos - n, a.pos - n, this);
	}
	valid(e, t) {
		let { index: n, offset: r } = e.content.findIndex(t.from), i;
		return r == t.from && !(i = e.child(n)).isText && r + i.nodeSize == t.to;
	}
	eq(t) {
		return this == t || t instanceof e && NV(this.attrs, t.attrs) && NV(this.spec, t.spec);
	}
	destroy() {}
}, LV = class e {
	constructor(e, t, n) {
		this.from = e, this.to = t, this.type = n;
	}
	copy(t, n) {
		return new e(t, n, this.type);
	}
	eq(e, t = 0) {
		return this.type.eq(e.type) && this.from + t == e.from && this.to + t == e.to;
	}
	map(e, t, n) {
		return this.type.map(e, this, t, n);
	}
	static widget(t, n, r) {
		return new e(t, t, new PV(n, r));
	}
	static inline(t, n, r, i) {
		return new e(t, n, new FV(r, i));
	}
	static node(t, n, r, i) {
		return new e(t, n, new IV(r, i));
	}
	get spec() {
		return this.type.spec;
	}
	get inline() {
		return this.type instanceof FV;
	}
	get widget() {
		return this.type instanceof PV;
	}
}, RV = [], zV = {}, BV = class e {
	constructor(e, t) {
		this.local = e.length ? e : RV, this.children = t.length ? t : RV;
	}
	static create(e, t) {
		return t.length ? JV(t, e, 0, zV) : VV;
	}
	find(e, t, n) {
		let r = [];
		return this.findInner(e ?? 0, t ?? 1e9, r, 0, n), r;
	}
	findInner(e, t, n, r, i) {
		for (let a = 0; a < this.local.length; a++) {
			let o = this.local[a];
			o.from <= t && o.to >= e && (!i || i(o.spec)) && n.push(o.copy(o.from + r, o.to + r));
		}
		for (let a = 0; a < this.children.length; a += 3) if (this.children[a] < t && this.children[a + 1] > e) {
			let o = this.children[a] + 1;
			this.children[a + 2].findInner(e - o, t - o, n, r + o, i);
		}
	}
	map(e, t, n) {
		return this == VV || e.maps.length == 0 ? this : this.mapInner(e, t, 0, 0, n || zV);
	}
	mapInner(t, n, r, i, a) {
		let o;
		for (let e = 0; e < this.local.length; e++) {
			let s = this.local[e].map(t, r, i);
			s && s.type.valid(n, s) ? (o ||= []).push(s) : a.onRemove && a.onRemove(this.local[e].spec);
		}
		return this.children.length ? UV(this.children, o || [], t, n, r, i, a) : o ? new e(o.sort(YV), RV) : VV;
	}
	add(t, n) {
		return n.length ? this == VV ? e.create(t, n) : this.addInner(t, n, 0) : this;
	}
	addInner(t, n, r) {
		let i, a = 0;
		t.forEach((e, t) => {
			let o = t + r, s;
			if (s = KV(n, e, o)) {
				for (i ||= this.children.slice(); a < i.length && i[a] < t;) a += 3;
				i[a] == t ? i[a + 2] = i[a + 2].addInner(e, s, o + 1) : i.splice(a, 0, t, t + e.nodeSize, JV(s, e, o + 1, zV)), a += 3;
			}
		});
		let o = WV(a ? qV(n) : n, -r);
		for (let e = 0; e < o.length; e++) o[e].type.valid(t, o[e]) || o.splice(e--, 1);
		return new e(o.length ? this.local.concat(o).sort(YV) : this.local, i || this.children);
	}
	remove(e) {
		return e.length == 0 || this == VV ? this : this.removeInner(e, 0);
	}
	removeInner(t, n) {
		let r = this.children, i = this.local;
		for (let e = 0; e < r.length; e += 3) {
			let i, a = r[e] + n, o = r[e + 1] + n;
			for (let e = 0, n; e < t.length; e++) (n = t[e]) && n.from > a && n.to < o && (t[e] = null, (i ||= []).push(n));
			if (!i) continue;
			r == this.children && (r = this.children.slice());
			let s = r[e + 2].removeInner(i, a + 1);
			s == VV ? (r.splice(e, 3), e -= 3) : r[e + 2] = s;
		}
		if (i.length) {
			for (let e = 0, r; e < t.length; e++) if (r = t[e]) for (let e = 0; e < i.length; e++) i[e].eq(r, n) && (i == this.local && (i = this.local.slice()), i.splice(e--, 1));
		}
		return r == this.children && i == this.local ? this : i.length || r.length ? new e(i, r) : VV;
	}
	forChild(t, n) {
		if (this == VV) return this;
		if (n.isLeaf) return e.empty;
		let r, i;
		for (let e = 0; e < this.children.length; e += 3) if (this.children[e] >= t) {
			this.children[e] == t && (r = this.children[e + 2]);
			break;
		}
		let a = t + 1, o = a + n.content.size;
		for (let e = 0; e < this.local.length; e++) {
			let t = this.local[e];
			if (t.from < o && t.to > a && t.type instanceof FV) {
				let e = Math.max(a, t.from) - a, n = Math.min(o, t.to) - a;
				e < n && (i ||= []).push(t.copy(e, n));
			}
		}
		if (i) {
			let t = new e(i.sort(YV), RV);
			return r ? new HV([t, r]) : t;
		}
		return r || VV;
	}
	eq(t) {
		if (this == t) return !0;
		if (!(t instanceof e) || this.local.length != t.local.length || this.children.length != t.children.length) return !1;
		for (let e = 0; e < this.local.length; e++) if (!this.local[e].eq(t.local[e])) return !1;
		for (let e = 0; e < this.children.length; e += 3) if (this.children[e] != t.children[e] || this.children[e + 1] != t.children[e + 1] || !this.children[e + 2].eq(t.children[e + 2])) return !1;
		return !0;
	}
	locals(e) {
		return XV(this.localsInner(e));
	}
	localsInner(e) {
		if (this == VV) return RV;
		if (e.inlineContent || !this.local.some(FV.is)) return this.local;
		let t = [];
		for (let e = 0; e < this.local.length; e++) this.local[e].type instanceof FV || t.push(this.local[e]);
		return t;
	}
	forEachSet(e) {
		e(this);
	}
};
BV.empty = new BV([], []), BV.removeOverlap = XV;
var VV = BV.empty, HV = class e {
	constructor(e) {
		this.members = e;
	}
	map(t, n) {
		let r = this.members.map((e) => e.map(t, n, zV));
		return e.from(r);
	}
	forChild(t, n) {
		if (n.isLeaf) return BV.empty;
		let r = [];
		for (let i = 0; i < this.members.length; i++) {
			let a = this.members[i].forChild(t, n);
			a != VV && (a instanceof e ? r = r.concat(a.members) : r.push(a));
		}
		return e.from(r);
	}
	eq(t) {
		if (!(t instanceof e) || t.members.length != this.members.length) return !1;
		for (let e = 0; e < this.members.length; e++) if (!this.members[e].eq(t.members[e])) return !1;
		return !0;
	}
	locals(e) {
		let t, n = !0;
		for (let r = 0; r < this.members.length; r++) {
			let i = this.members[r].localsInner(e);
			if (i.length) {
				if (!t) t = i;
				else {
					n &&= (t = t.slice(), !1);
					for (let e = 0; e < i.length; e++) t.push(i[e]);
				}
			}
		}
		return t ? XV(n ? t : t.sort(YV)) : RV;
	}
	static from(t) {
		switch (t.length) {
			case 0: return VV;
			case 1: return t[0];
			default: return new e(t.every((e) => e instanceof BV) ? t : t.reduce((e, t) => e.concat(t instanceof BV ? t : t.members), []));
		}
	}
	forEachSet(e) {
		for (let t = 0; t < this.members.length; t++) this.members[t].forEachSet(e);
	}
};
function UV(e, t, n, r, i, a, o) {
	let s = e.slice();
	for (let e = 0, t = a; e < n.maps.length; e++) {
		let r = 0;
		n.maps[e].forEach((e, n, i, a) => {
			let o = a - i - (n - e);
			for (let i = 0; i < s.length; i += 3) {
				let a = s[i + 1];
				if (a < 0 || e > a + t - r) continue;
				let c = s[i] + t - r;
				n >= c ? s[i + 1] = e <= c ? -2 : -1 : e >= t && o && (s[i] += o, s[i + 1] += o);
			}
			r += o;
		}), t = n.maps[e].map(t, -1);
	}
	let c = !1;
	for (let t = 0; t < s.length; t += 3) if (s[t + 1] < 0) {
		if (s[t + 1] == -2) {
			c = !0, s[t + 1] = -1;
			continue;
		}
		let l = n.map(e[t] + a), u = l - i;
		if (u < 0 || u >= r.content.size) {
			c = !0;
			continue;
		}
		let d = n.map(e[t + 1] + a, -1) - i, { index: f, offset: p } = r.content.findIndex(u), m = r.maybeChild(f);
		if (m && p == u && p + m.nodeSize == d) {
			let r = s[t + 2].mapInner(n, m, l + 1, e[t] + a + 1, o);
			r == VV ? (s[t + 1] = -2, c = !0) : (s[t] = u, s[t + 1] = d, s[t + 2] = r);
		} else c = !0;
	}
	if (c) {
		let c = JV(GV(s, e, t, n, i, a, o), r, 0, o);
		t = c.local;
		for (let e = 0; e < s.length; e += 3) s[e + 1] < 0 && (s.splice(e, 3), e -= 3);
		for (let e = 0, t = 0; e < c.children.length; e += 3) {
			let n = c.children[e];
			for (; t < s.length && s[t] < n;) t += 3;
			s.splice(t, 0, c.children[e], c.children[e + 1], c.children[e + 2]);
		}
	}
	return new BV(t.sort(YV), s);
}
function WV(e, t) {
	if (!t || !e.length) return e;
	let n = [];
	for (let r = 0; r < e.length; r++) {
		let i = e[r];
		n.push(new LV(i.from + t, i.to + t, i.type));
	}
	return n;
}
function GV(e, t, n, r, i, a, o) {
	function s(e, t) {
		for (let a = 0; a < e.local.length; a++) {
			let s = e.local[a].map(r, i, t);
			s ? n.push(s) : o.onRemove && o.onRemove(e.local[a].spec);
		}
		for (let n = 0; n < e.children.length; n += 3) s(e.children[n + 2], e.children[n] + t + 1);
	}
	for (let n = 0; n < e.length; n += 3) e[n + 1] == -1 && s(e[n + 2], t[n] + a + 1);
	return n;
}
function KV(e, t, n) {
	if (t.isLeaf) return null;
	let r = n + t.nodeSize, i = null;
	for (let t = 0, a; t < e.length; t++) (a = e[t]) && a.from > n && a.to < r && ((i ||= []).push(a), e[t] = null);
	return i;
}
function qV(e) {
	let t = [];
	for (let n = 0; n < e.length; n++) e[n] != null && t.push(e[n]);
	return t;
}
function JV(e, t, n, r) {
	let i = [], a = !1;
	t.forEach((t, o) => {
		let s = KV(e, t, o + n);
		if (s) {
			a = !0;
			let e = JV(s, t, n + o + 1, r);
			e != VV && i.push(o, o + t.nodeSize, e);
		}
	});
	let o = WV(a ? qV(e) : e, -n).sort(YV);
	for (let e = 0; e < o.length; e++) o[e].type.valid(t, o[e]) || (r.onRemove && r.onRemove(o[e].spec), o.splice(e--, 1));
	return o.length || i.length ? new BV(o, i) : VV;
}
function YV(e, t) {
	return e.from - t.from || e.to - t.to;
}
function XV(e) {
	let t = e;
	for (let n = 0; n < t.length - 1; n++) {
		let r = t[n];
		if (r.from != r.to) for (let i = n + 1; i < t.length; i++) {
			let a = t[i];
			if (a.from == r.from) {
				a.to != r.to && (t == e && (t = e.slice()), t[i] = a.copy(a.from, r.to), ZV(t, i + 1, a.copy(r.to, a.to)));
				continue;
			}
			a.from < r.to && (t == e && (t = e.slice()), t[n] = r.copy(r.from, a.from), ZV(t, i, r.copy(a.from, r.to)));
			break;
		}
	}
	return t;
}
function ZV(e, t, n) {
	for (; t < e.length && YV(n, e[t]) > 0;) t++;
	e.splice(t, 0, n);
}
function QV(e) {
	let t = [];
	return e.someProp("decorations", (n) => {
		let r = n(e.state);
		r && r != VV && t.push(r);
	}), e.cursorWrapper && t.push(BV.create(e.state.doc, [e.cursorWrapper.deco])), HV.from(t);
}
var $V = {
	childList: !0,
	characterData: !0,
	characterDataOldValue: !0,
	attributes: !0,
	attributeOldValue: !0,
	subtree: !0
}, eH = ER && DR <= 11, tH = class {
	constructor() {
		this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
	}
	set(e) {
		this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
	}
	clear() {
		this.anchorNode = this.focusNode = null;
	}
	eq(e) {
		return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
	}
}, nH = class {
	constructor(e, t) {
		this.view = e, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new tH(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((t) => {
			for (let e = 0; e < t.length; e++) this.queue.push(t[e]);
			ER && DR <= 11 && t.some((e) => e.type == "childList" && e.removedNodes.length || e.type == "characterData" && e.oldValue.length > e.target.nodeValue.length) ? this.flushSoon() : MR && e.composing && t.some((e) => e.type == "childList" && e.target.nodeName == "TR") ? (e.input.badSafariComposition = !0, this.flushSoon()) : this.flush();
		}), eH && (this.onCharData = (e) => {
			this.queue.push({
				target: e.target,
				type: "characterData",
				oldValue: e.prevValue
			}), this.flushSoon();
		}), this.onSelectionChange = this.onSelectionChange.bind(this);
	}
	flushSoon() {
		this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
			this.flushingSoon = -1, this.flush();
		}, 20));
	}
	forceFlush() {
		this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
	}
	start() {
		this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, $V)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
	}
	stop() {
		if (this.observer) {
			let e = this.observer.takeRecords();
			if (e.length) {
				for (let t = 0; t < e.length; t++) this.queue.push(e[t]);
				window.setTimeout(() => this.flush(), 20);
			}
			this.observer.disconnect();
		}
		this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
	}
	connectSelection() {
		this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
	}
	disconnectSelection() {
		this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
	}
	suppressSelectionUpdates() {
		this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
	}
	onSelectionChange() {
		if (iB(this.view)) {
			if (this.suppressingSelectionUpdates) return Jz(this.view);
			if (ER && DR <= 11 && !this.view.state.selection.empty) {
				let e = this.view.domSelectionRange();
				if (e.focusNode && cR(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset)) return this.flushSoon();
			}
			this.flush();
		}
	}
	setCurSelection() {
		this.currentSelection.set(this.view.domSelectionRange());
	}
	ignoreSelectionChange(e) {
		if (!e.focusNode) return !0;
		let t = /* @__PURE__ */ new Set(), n;
		for (let n = e.focusNode; n; n = iR(n)) t.add(n);
		for (let r = e.anchorNode; r; r = iR(r)) if (t.has(r)) {
			n = r;
			break;
		}
		let r = n && this.view.docView.nearestDesc(n);
		if (r && r.ignoreMutation({
			type: "selection",
			target: n.nodeType == 3 ? n.parentNode : n
		})) return this.setCurSelection(), !0;
	}
	pendingRecords() {
		if (this.observer) for (let e of this.observer.takeRecords()) this.queue.push(e);
		return this.queue;
	}
	flush() {
		let { view: e } = this;
		if (!e.docView || this.flushingSoon > -1) return;
		let t = this.pendingRecords();
		t.length && (this.queue = []);
		let n = e.domSelectionRange(), r = !this.suppressingSelectionUpdates && !this.currentSelection.eq(n) && iB(e) && !this.ignoreSelectionChange(n), i = -1, a = -1, o = !1, s = [];
		if (e.editable) for (let e = 0; e < t.length; e++) {
			let n = this.registerMutation(t[e], s);
			n && (i = i < 0 ? n.from : Math.min(n.from, i), a = a < 0 ? n.to : Math.max(n.to, a), n.typeOver && (o = !0));
		}
		if (s.some((e) => e.nodeName == "BR") && (e.input.lastKeyCode == 8 || e.input.lastKeyCode == 46 || AR && (e.composing || e.input.compositionEndedAt > Date.now() - 50) && t.some((e) => e.type == "childList" && e.removedNodes.length))) {
			for (let e of s) if (e.nodeName == "BR" && e.parentNode) {
				let t = e.nextSibling;
				for (; t && t.nodeType == 1;) {
					if (t.contentEditable == "false") {
						e.parentNode.removeChild(e);
						break;
					}
					t = t.firstChild;
				}
			}
		} else if (OR && s.length) {
			let t = s.filter((e) => e.nodeName == "BR");
			if (t.length == 2) {
				let [e, n] = t;
				e.parentNode && e.parentNode.parentNode == n.parentNode ? n.remove() : e.remove();
			} else {
				let { focusNode: n } = this.currentSelection;
				for (let r of t) {
					let t = r.parentNode;
					t && t.nodeName == "LI" && (!n || cH(e, n) != t) && r.remove();
				}
			}
		}
		let c = null;
		i < 0 && r && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && gR(n) && (c = Kz(e)) && c.eq(VI.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, Jz(e), this.currentSelection.set(n), e.scrollToSelection()) : (i > -1 || r) && (i > -1 && (e.docView.markDirty(i, a), aH(e)), e.input.badSafariComposition && (e.input.badSafariComposition = !1, lH(e, s)), this.handleDOMChange(i, a, o, s), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(n) || Jz(e), this.currentSelection.set(n));
	}
	registerMutation(e, t) {
		if (t.indexOf(e.target) > -1) return null;
		let n = this.view.docView.nearestDesc(e.target);
		if (e.type == "attributes" && (n == this.view.docView || e.attributeName == "contenteditable" || e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !n || n.ignoreMutation(e)) return null;
		if (e.type == "childList") {
			for (let n = 0; n < e.addedNodes.length; n++) {
				let r = e.addedNodes[n];
				t.push(r), r.nodeType == 3 && (this.lastChangedTextNode = r);
			}
			if (n.contentDOM && n.contentDOM != n.dom && !n.contentDOM.contains(e.target)) return {
				from: n.posBefore,
				to: n.posAfter
			};
			let r = e.previousSibling, i = e.nextSibling;
			if (ER && DR <= 11 && e.addedNodes.length) for (let t = 0; t < e.addedNodes.length; t++) {
				let { previousSibling: n, nextSibling: a } = e.addedNodes[t];
				(!n || Array.prototype.indexOf.call(e.addedNodes, n) < 0) && (r = n), (!a || Array.prototype.indexOf.call(e.addedNodes, a) < 0) && (i = a);
			}
			let a = r && r.parentNode == e.target ? rR(r) + 1 : 0, o = n.localPosFromDOM(e.target, a, -1), s = i && i.parentNode == e.target ? rR(i) : e.target.childNodes.length;
			return {
				from: o,
				to: n.localPosFromDOM(e.target, s, 1)
			};
		}
		return e.type == "attributes" ? {
			from: n.posAtStart - n.border,
			to: n.posAtEnd + n.border
		} : (this.lastChangedTextNode = e.target, {
			from: n.posAtStart,
			to: n.posAtEnd,
			typeOver: e.target.nodeValue == e.oldValue
		});
	}
}, rH = /* @__PURE__ */ new WeakMap(), iH = !1;
function aH(e) {
	if (!rH.has(e) && (rH.set(e, null), [
		"normal",
		"nowrap",
		"pre-line"
	].indexOf(getComputedStyle(e.dom).whiteSpace) !== -1)) {
		if (e.requiresGeckoHackNode = OR, iH) return;
		console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), iH = !0;
	}
}
function oH(e, t) {
	let n = t.startContainer, r = t.startOffset, i = t.endContainer, a = t.endOffset, o = e.domAtPos(e.state.selection.anchor);
	return cR(o.node, o.offset, i, a) && ([n, r, i, a] = [
		i,
		a,
		n,
		r
	]), {
		anchorNode: n,
		anchorOffset: r,
		focusNode: i,
		focusOffset: a
	};
}
function sH(e, t) {
	if (t.getComposedRanges) {
		let n = t.getComposedRanges(e.root)[0];
		if (n) return oH(e, n);
	}
	let n;
	function r(e) {
		e.preventDefault(), e.stopImmediatePropagation(), n = e.getTargetRanges()[0];
	}
	return e.dom.addEventListener("beforeinput", r, !0), document.execCommand("indent"), e.dom.removeEventListener("beforeinput", r, !0), n ? oH(e, n) : null;
}
function cH(e, t) {
	for (let n = t.parentNode; n && n != e.dom; n = n.parentNode) {
		let t = e.docView.nearestDesc(n, !0);
		if (t && t.node.isBlock) return n;
	}
	return null;
}
function lH(e, t) {
	let { focusNode: n, focusOffset: r } = e.domSelectionRange();
	for (let i of t) if (i.parentNode?.nodeName == "TR") {
		let t = i.nextSibling;
		for (; t && t.nodeName != "TD" && t.nodeName != "TH";) t = t.nextSibling;
		if (t) {
			let a = t;
			for (;;) {
				let e = a.firstChild;
				if (!e || e.nodeType != 1 || e.contentEditable == "false" || /^(BR|IMG)$/.test(e.nodeName)) break;
				a = e;
			}
			a.insertBefore(i, a.firstChild), n == i && e.domSelection().collapse(i, r);
		} else i.parentNode.removeChild(i);
	}
}
function uH(e, t, n) {
	let { node: r, fromOffset: i, toOffset: a, from: o, to: s } = e.docView.parseRange(t, n), c = e.domSelectionRange(), l, u = c.anchorNode;
	if (u && e.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (l = [{
		node: u,
		offset: c.anchorOffset
	}], gR(c) || l.push({
		node: c.focusNode,
		offset: c.focusOffset
	})), AR && e.input.lastKeyCode === 8) for (let e = a; e > i; e--) {
		let t = r.childNodes[e - 1], n = t.pmViewDesc;
		if (t.nodeName == "BR" && !n) {
			a = e;
			break;
		}
		if (!n || n.size) break;
	}
	let d = e.state.doc, f = e.someProp("domParser") || oF.fromSchema(e.state.schema), p = d.resolve(o), m = null, h = f.parse(r, {
		topNode: p.parent,
		topMatch: p.parent.contentMatchAt(p.index()),
		topOpen: !0,
		from: i,
		to: a,
		preserveWhitespace: p.parent.type.whitespace != "pre" || "full",
		findPositions: l,
		ruleFromNode: dH,
		context: p
	});
	if (l && l[0].pos != null) {
		let e = l[0].pos, t = l[1] && l[1].pos;
		t ??= e, m = {
			anchor: e + o,
			head: t + o
		};
	}
	return {
		doc: h,
		sel: m,
		from: o,
		to: s
	};
}
function dH(e) {
	let t = e.pmViewDesc;
	if (t) return t.parseRule();
	if (e.nodeName == "BR" && e.parentNode) {
		if (MR && /^(ul|ol)$/i.test(e.parentNode.nodeName)) {
			let e = document.createElement("div");
			return e.appendChild(document.createElement("li")), { skip: e };
		}
		if (e.parentNode.lastChild == e || MR && /^(tr|table)$/i.test(e.parentNode.nodeName)) return { ignore: !0 };
	} else if (e.nodeName == "IMG" && e.getAttribute("mark-placeholder")) return { ignore: !0 };
	return null;
}
var fH = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function pH(e, t, n, r, i) {
	let a = e.input.compositionPendingChanges || (e.composing ? e.input.compositionID : 0);
	if (e.input.compositionPendingChanges = 0, t < 0) {
		let t = e.input.lastSelectionTime > Date.now() - 50 ? e.input.lastSelectionOrigin : null, n = Kz(e, t);
		if (n && !e.state.selection.eq(n)) {
			if (AR && IR && e.input.lastKeyCode === 13 && Date.now() - 100 < e.input.lastKeyCodeTime && e.someProp("handleKeyDown", (t) => t(e, _R(13, "Enter")))) return;
			let r = e.state.tr.setSelection(n);
			t == "pointer" ? r.setMeta("pointer", !0) : t == "key" && r.scrollIntoView(), a && r.setMeta("composition", a), e.dispatch(r);
		}
		return;
	}
	let o = e.state.doc.resolve(t), s = o.sharedDepth(n);
	t = o.before(s + 1), n = e.state.doc.resolve(n).after(s + 1);
	let c = e.state.selection, l = uH(e, t, n), u = e.state.doc, d = u.slice(l.from, l.to), f, p;
	e.input.lastKeyCode === 8 && Date.now() - 100 < e.input.lastKeyCodeTime ? (f = e.state.selection.to, p = "end") : (f = e.state.selection.from, p = "start"), e.input.lastKeyCode = null;
	let m = vH(d.content, l.doc.content, l.from, f, p);
	if (m && e.input.domChangeCount++, (NR && e.input.lastIOSEnter > Date.now() - 225 || IR) && i.some((e) => e.nodeType == 1 && !fH.test(e.nodeName)) && (!m || m.endA >= m.endB) && e.someProp("handleKeyDown", (t) => t(e, _R(13, "Enter")))) {
		e.input.lastIOSEnter = 0;
		return;
	}
	if (!m) {
		if (r && c instanceof GI && !c.empty && c.$head.sameParent(c.$anchor) && !e.composing && !(l.sel && l.sel.anchor != l.sel.head)) m = {
			start: c.from,
			endA: c.to,
			endB: c.to
		};
		else {
			if (l.sel) {
				let t = mH(e, e.state.doc, l.sel);
				if (t && !t.eq(e.state.selection)) {
					let n = e.state.tr.setSelection(t);
					a && n.setMeta("composition", a), e.dispatch(n);
				}
			}
			return;
		}
	}
	e.state.selection.from < e.state.selection.to && m.start == m.endB && e.state.selection instanceof GI && (m.start > e.state.selection.from && m.start <= e.state.selection.from + 2 && e.state.selection.from >= l.from ? m.start = e.state.selection.from : m.endA < e.state.selection.to && m.endA >= e.state.selection.to - 2 && e.state.selection.to <= l.to && (m.endB += e.state.selection.to - m.endA, m.endA = e.state.selection.to)), ER && DR <= 11 && m.endB == m.start + 1 && m.endA == m.start && m.start > l.from && l.doc.textBetween(m.start - l.from - 1, m.start - l.from + 1) == " \xA0" && (m.start--, m.endA--, m.endB--);
	let h = l.doc.resolveNoCache(m.start - l.from), g = l.doc.resolveNoCache(m.endB - l.from), _ = u.resolve(m.start), v = h.sameParent(g) && h.parent.inlineContent && _.end() >= m.endA;
	if ((NR && e.input.lastIOSEnter > Date.now() - 225 && (!v || i.some((e) => e.nodeName == "DIV" || e.nodeName == "P")) || !v && h.pos < l.doc.content.size && (!h.sameParent(g) || !h.parent.inlineContent) && h.pos < g.pos && !/\S/.test(l.doc.textBetween(h.pos, g.pos, "", ""))) && e.someProp("handleKeyDown", (t) => t(e, _R(13, "Enter")))) {
		e.input.lastIOSEnter = 0;
		return;
	}
	if (e.state.selection.anchor > m.start && gH(u, m.start, m.endA, h, g) && e.someProp("handleKeyDown", (t) => t(e, _R(8, "Backspace")))) {
		IR && AR && e.domObserver.suppressSelectionUpdates();
		return;
	}
	AR && m.endB == m.start && (e.input.lastChromeDelete = Date.now()), IR && !v && h.start() != g.start() && g.parentOffset == 0 && h.depth == g.depth && l.sel && l.sel.anchor == l.sel.head && l.sel.head == m.endA && (m.endB -= 2, g = l.doc.resolveNoCache(m.endB - l.from), setTimeout(() => {
		e.someProp("handleKeyDown", function(t) {
			return t(e, _R(13, "Enter"));
		});
	}, 20));
	let y = m.start, b = m.endA, x = (t) => {
		let n = t || e.state.tr.replace(y, b, l.doc.slice(m.start - l.from, m.endB - l.from));
		if (l.sel) {
			let t = mH(e, n.doc, l.sel);
			t && !(AR && e.composing && t.empty && (m.start != m.endB || e.input.lastChromeDelete < Date.now() - 100) && (t.head == y || t.head == n.mapping.map(b) - 1) || ER && t.empty && t.head == y) && n.setSelection(t);
		}
		return a && n.setMeta("composition", a), n.scrollIntoView();
	}, S;
	if (v) {
		if (h.pos == g.pos) {
			ER && DR <= 11 && h.parentOffset == 0 && (e.domObserver.suppressSelectionUpdates(), setTimeout(() => Jz(e), 20));
			let t = x(e.state.tr.delete(y, b)), n = u.resolve(m.start).marksAcross(u.resolve(m.endA));
			n && t.ensureMarks(n), e.dispatch(t);
		} else if (m.endA == m.endB && (S = hH(h.parent.content.cut(h.parentOffset, g.parentOffset), _.parent.content.cut(_.parentOffset, m.endA - _.start())))) {
			let t = x(e.state.tr);
			S.type == "add" ? t.addMark(y, b, S.mark) : t.removeMark(y, b, S.mark), e.dispatch(t);
		} else if (h.parent.child(h.index()).isText && h.index() == g.index() - +!g.textOffset) {
			let t = h.parent.textBetween(h.parentOffset, g.parentOffset), n = () => x(e.state.tr.insertText(t, y, b));
			e.someProp("handleTextInput", (r) => r(e, y, b, t, n)) || e.dispatch(n());
		} else e.dispatch(x());
	} else e.dispatch(x());
}
function mH(e, t, n) {
	return Math.max(n.anchor, n.head) > t.content.size ? null : rB(e, t.resolve(n.anchor), t.resolve(n.head));
}
function hH(e, t) {
	let n = e.firstChild.marks, r = t.firstChild.marks, i = n, a = r, o, s, c;
	for (let e = 0; e < r.length; e++) i = r[e].removeFromSet(i);
	for (let e = 0; e < n.length; e++) a = n[e].removeFromSet(a);
	if (i.length == 1 && a.length == 0) s = i[0], o = "add", c = (e) => e.mark(s.addToSet(e.marks));
	else if (i.length == 0 && a.length == 1) s = a[0], o = "remove", c = (e) => e.mark(s.removeFromSet(e.marks));
	else return null;
	let l = [];
	for (let e = 0; e < t.childCount; e++) l.push(c(t.child(e)));
	if (X.from(l).eq(e)) return {
		mark: s,
		type: o
	};
}
function gH(e, t, n, r, i) {
	if (n - t <= i.pos - r.pos || _H(r, !0, !1) < i.pos) return !1;
	let a = e.resolve(t);
	if (!r.parent.isTextblock) {
		let e = a.nodeAfter;
		return e != null && n == t + e.nodeSize;
	}
	if (a.parentOffset < a.parent.content.size || !a.parent.isTextblock) return !1;
	let o = e.resolve(_H(a, !0, !0));
	return !o.parent.isTextblock || o.pos > n || _H(o, !0, !1) < n ? !1 : r.parent.content.cut(r.parentOffset).eq(o.parent.content);
}
function _H(e, t, n) {
	let r = e.depth, i = t ? e.end() : e.pos;
	for (; r > 0 && (t || e.indexAfter(r) == e.node(r).childCount);) r--, i++, t = !1;
	if (n) {
		let t = e.node(r).maybeChild(e.indexAfter(r));
		for (; t && !t.isLeaf;) t = t.firstChild, i++;
	}
	return i;
}
function vH(e, t, n, r, i) {
	let a = e.findDiffStart(t, n), o = n + e.size, s = n + t.size;
	if (a == null) return null;
	let { a: c, b: l } = e.findDiffEnd(t, o, s);
	if (i == "end") {
		let e = Math.max(0, a - Math.min(c, l));
		r -= c + e - a;
	}
	if (c < a && o < s) {
		let e = r <= a && r >= c ? a - r : 0;
		a -= e, l = a + (l - c), c = a;
	} else if (l < a) {
		let e = r <= a && r >= l ? a - r : 0;
		a -= e, c = a + (c - l), l = a;
	}
	return {
		start: a,
		endA: c,
		endB: l
	};
}
var yH = class {
	constructor(e, t) {
		this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new KB(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(EH), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = SH(this), xH(this), this.nodeViews = wH(this), this.docView = Ez(this.state.doc, bH(this), QV(this), this.dom, this), this.domObserver = new nH(this, (e, t, n, r) => pH(this, e, t, n, r)), this.domObserver.start(), qB(this), this.updatePluginViews();
	}
	get composing() {
		return this.input.composing;
	}
	get props() {
		if (this._props.state != this.state) {
			let e = this._props;
			this._props = {};
			for (let t in e) this._props[t] = e[t];
			this._props.state = this.state;
		}
		return this._props;
	}
	update(e) {
		e.handleDOMEvents != this._props.handleDOMEvents && XB(this);
		let t = this._props;
		this._props = e, e.plugins && (e.plugins.forEach(EH), this.directPlugins = e.plugins), this.updateStateInner(e.state, t);
	}
	setProps(e) {
		let t = {};
		for (let e in this._props) t[e] = this._props[e];
		t.state = this.state;
		for (let n in e) t[n] = e[n];
		this.update(t);
	}
	updateState(e) {
		this.updateStateInner(e, this._props);
	}
	updateStateInner(e, t) {
		let n = this.state, r = !1, i = !1;
		e.storedMarks && this.composing && (bV(this), i = !0), this.state = e;
		let a = n.plugins != e.plugins || this._props.plugins != t.plugins;
		if (a || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
			let e = wH(this);
			TH(e, this.nodeViews) && (this.nodeViews = e, r = !0);
		}
		(a || t.handleDOMEvents != this._props.handleDOMEvents) && XB(this), this.editable = SH(this), xH(this);
		let o = QV(this), s = bH(this), c = n.plugins != e.plugins && !n.doc.eq(e.doc) ? "reset" : e.scrollToSelection > n.scrollToSelection ? "to selection" : "preserve", l = r || !this.docView.matchesNode(e.doc, s, o);
		(l || !e.selection.eq(n.selection)) && (i = !0);
		let u = c == "preserve" && i && this.dom.style.overflowAnchor == null && UR(this);
		if (i) {
			this.domObserver.stop();
			let t = l && (ER || AR) && !this.composing && !n.selection.empty && !e.selection.empty && CH(n.selection, e.selection);
			if (l) {
				let n = AR ? this.trackWrites = this.domSelectionRange().focusNode : null;
				this.composing && (this.input.compositionNode = xV(this)), (r || !this.docView.update(e.doc, s, o, this)) && (this.docView.updateOuterDeco(s), this.docView.destroy(), this.docView = Ez(e.doc, s, o, this.dom, this)), n && (!this.trackWrites || !this.dom.contains(this.trackWrites)) && (t = !0);
			}
			let i = this.input.mouseDown;
			t || !(i && this.domObserver.currentSelection.eq(this.domSelectionRange()) && oB(this) && i.delaySelUpdate()) ? Jz(this, t) : (tB(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
		}
		this.updatePluginViews(n), this.dragging?.node && !n.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, n), c == "reset" ? this.dom.scrollTop = 0 : c == "to selection" ? this.scrollToSelection() : u && GR(u);
	}
	scrollToSelection() {
		let e = this.domSelectionRange().focusNode;
		if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode)) && !this.someProp("handleScrollToSelection", (e) => e(this))) {
			if (this.state.selection instanceof qI) {
				let t = this.docView.domAfterPos(this.state.selection.from);
				t.nodeType == 1 && HR(this, t.getBoundingClientRect(), e);
			} else HR(this, this.coordsAtPos(this.state.selection.head, 1), e);
		}
	}
	destroyPluginViews() {
		let e;
		for (; e = this.pluginViews.pop();) e.destroy && e.destroy();
	}
	updatePluginViews(e) {
		if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
			this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
			for (let e = 0; e < this.directPlugins.length; e++) {
				let t = this.directPlugins[e];
				t.spec.view && this.pluginViews.push(t.spec.view(this));
			}
			for (let e = 0; e < this.state.plugins.length; e++) {
				let t = this.state.plugins[e];
				t.spec.view && this.pluginViews.push(t.spec.view(this));
			}
		} else for (let t = 0; t < this.pluginViews.length; t++) {
			let n = this.pluginViews[t];
			n.update && n.update(this, e);
		}
	}
	updateDraggedNode(e, t) {
		let n = e.node, r = -1;
		if (n.from < this.state.doc.content.size && this.state.doc.nodeAt(n.from) == n.node) r = n.from;
		else {
			let e = n.from + (this.state.doc.content.size - t.doc.content.size);
			(e > 0 && e < this.state.doc.content.size && this.state.doc.nodeAt(e)) == n.node && (r = e);
		}
		this.dragging = new kV(e.slice, e.move, r < 0 ? void 0 : qI.create(this.state.doc, r));
	}
	someProp(e, t) {
		let n = this._props && this._props[e], r;
		if (n != null && (r = t ? t(n) : n)) return r;
		for (let n = 0; n < this.directPlugins.length; n++) {
			let i = this.directPlugins[n].props[e];
			if (i != null && (r = t ? t(i) : i)) return r;
		}
		let i = this.state.plugins;
		if (i) for (let n = 0; n < i.length; n++) {
			let a = i[n].props[e];
			if (a != null && (r = t ? t(a) : a)) return r;
		}
	}
	hasFocus() {
		if (ER) {
			let e = this.root.activeElement;
			if (e == this.dom) return !0;
			if (!e || !this.dom.contains(e)) return !1;
			for (; e && this.dom != e && this.dom.contains(e);) {
				if (e.contentEditable == "false") return !1;
				e = e.parentElement;
			}
			return !0;
		}
		return this.root.activeElement == this.dom;
	}
	focus() {
		this.domObserver.stop(), this.editable && JR(this.dom), Jz(this), this.domObserver.start();
	}
	get root() {
		let e = this._root;
		if (e == null) {
			for (let e = this.dom.parentNode; e; e = e.parentNode) if (e.nodeType == 9 || e.nodeType == 11 && e.host) return e.getSelection || (Object.getPrototypeOf(e).getSelection = () => e.ownerDocument.getSelection()), this._root = e;
		}
		return e || document;
	}
	updateRoot() {
		this._root = null;
	}
	posAtCoords(e) {
		return nz(this, e);
	}
	coordsAtPos(e, t = 1) {
		return oz(this, e, t);
	}
	domAtPos(e, t = 0) {
		return this.docView.domFromPos(e, t);
	}
	nodeDOM(e) {
		let t = this.docView.descAt(e);
		return t ? t.nodeDOM : null;
	}
	posAtDOM(e, t, n = -1) {
		let r = this.docView.posFromDOM(e, t, n);
		if (r == null) throw RangeError("DOM position not inside the editor");
		return r;
	}
	endOfTextblock(e, t) {
		return gz(this, t || this.state, e);
	}
	pasteHTML(e, t) {
		return DV(this, "", e, !1, t || new ClipboardEvent("paste"));
	}
	pasteText(e, t) {
		return DV(this, e, null, !0, t || new ClipboardEvent("paste"));
	}
	serializeForClipboard(e) {
		return EB(this, e);
	}
	destroy() {
		this.docView && (YB(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], QV(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, sR());
	}
	get isDestroyed() {
		return this.docView == null;
	}
	dispatchEvent(e) {
		return $B(this, e);
	}
	domSelectionRange() {
		let e = this.domSelection();
		return e ? MR && this.root.nodeType === 11 && vR(this.dom.ownerDocument) == this.dom && sH(this, e) || e : {
			focusNode: null,
			focusOffset: 0,
			anchorNode: null,
			anchorOffset: 0
		};
	}
	domSelection() {
		return this.root.getSelection();
	}
};
yH.prototype.dispatch = function(e) {
	let t = this._props.dispatchTransaction;
	t ? t.call(this, e) : this.updateState(this.state.apply(e));
};
function bH(e) {
	let t = Object.create(null);
	return t.class = "ProseMirror", t.contenteditable = String(e.editable), e.someProp("attributes", (n) => {
		if (typeof n == "function" && (n = n(e.state)), n) for (let e in n) e == "class" ? t.class += " " + n[e] : e == "style" ? t.style = (t.style ? t.style + ";" : "") + n[e] : !t[e] && e != "contenteditable" && e != "nodeName" && (t[e] = String(n[e]));
	}), t.translate ||= "no", [LV.node(0, e.state.doc.content.size, t)];
}
function xH(e) {
	if (e.markCursor) {
		let t = document.createElement("img");
		t.className = "ProseMirror-separator", t.setAttribute("mark-placeholder", "true"), t.setAttribute("alt", ""), e.cursorWrapper = {
			dom: t,
			deco: LV.widget(e.state.selection.from, t, {
				raw: !0,
				marks: e.markCursor
			})
		};
	} else e.cursorWrapper = null;
}
function SH(e) {
	return !e.someProp("editable", (t) => t(e.state) === !1);
}
function CH(e, t) {
	let n = Math.min(e.$anchor.sharedDepth(e.head), t.$anchor.sharedDepth(t.head));
	return e.$anchor.start(n) != t.$anchor.start(n);
}
function wH(e) {
	let t = Object.create(null);
	function n(e) {
		for (let n in e) Object.prototype.hasOwnProperty.call(t, n) || (t[n] = e[n]);
	}
	return e.someProp("nodeViews", n), e.someProp("markViews", n), t;
}
function TH(e, t) {
	let n = 0, r = 0;
	for (let r in e) {
		if (e[r] != t[r]) return !0;
		n++;
	}
	for (let e in t) r++;
	return n != r;
}
function EH(e) {
	if (e.spec.state || e.spec.filterTransaction || e.spec.appendTransaction) throw RangeError("Plugins passed directly to the view must not have a state component");
}
for (var DH = {
	8: "Backspace",
	9: "Tab",
	10: "Enter",
	12: "NumLock",
	13: "Enter",
	16: "Shift",
	17: "Control",
	18: "Alt",
	20: "CapsLock",
	27: "Escape",
	32: " ",
	33: "PageUp",
	34: "PageDown",
	35: "End",
	36: "Home",
	37: "ArrowLeft",
	38: "ArrowUp",
	39: "ArrowRight",
	40: "ArrowDown",
	44: "PrintScreen",
	45: "Insert",
	46: "Delete",
	59: ";",
	61: "=",
	91: "Meta",
	92: "Meta",
	106: "*",
	107: "+",
	108: ",",
	109: "-",
	110: ".",
	111: "/",
	144: "NumLock",
	145: "ScrollLock",
	160: "Shift",
	161: "Shift",
	162: "Control",
	163: "Control",
	164: "Alt",
	165: "Alt",
	173: "-",
	186: ";",
	187: "=",
	188: ",",
	189: "-",
	190: ".",
	191: "/",
	192: "`",
	219: "[",
	220: "\\",
	221: "]",
	222: "'"
}, OH = {
	48: ")",
	49: "!",
	50: "@",
	51: "#",
	52: "$",
	53: "%",
	54: "^",
	55: "&",
	56: "*",
	57: "(",
	59: ":",
	61: "+",
	173: "_",
	186: ":",
	187: "+",
	188: "<",
	189: "_",
	190: ">",
	191: "?",
	192: "~",
	219: "{",
	220: "|",
	221: "}",
	222: "\""
}, kH = typeof navigator < "u" && /Mac/.test(navigator.platform), AH = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent), jH = 0; jH < 10; jH++) DH[48 + jH] = DH[96 + jH] = String(jH);
for (var jH = 1; jH <= 24; jH++) DH[jH + 111] = "F" + jH;
for (var jH = 65; jH <= 90; jH++) DH[jH] = String.fromCharCode(jH + 32), OH[jH] = String.fromCharCode(jH);
for (var MH in DH) OH.hasOwnProperty(MH) || (OH[MH] = DH[MH]);
function NH(e) {
	var t = !(kH && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || AH && e.shiftKey && e.key && e.key.length == 1 || e.key == "Unidentified") && e.key || (e.shiftKey ? OH : DH)[e.keyCode] || e.key || "Unidentified";
	return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
//#endregion
//#region ../../node_modules/.pnpm/prosemirror-keymap@1.2.3/node_modules/prosemirror-keymap/dist/index.js
var PH = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), FH = typeof navigator < "u" && /Win/.test(navigator.platform);
function IH(e) {
	let t = e.split(/-(?!$)/), n = t[t.length - 1];
	n == "Space" && (n = " ");
	let r, i, a, o;
	for (let e = 0; e < t.length - 1; e++) {
		let n = t[e];
		if (/^(cmd|meta|m)$/i.test(n)) o = !0;
		else if (/^a(lt)?$/i.test(n)) r = !0;
		else if (/^(c|ctrl|control)$/i.test(n)) i = !0;
		else if (/^s(hift)?$/i.test(n)) a = !0;
		else if (/^mod$/i.test(n)) PH ? o = !0 : i = !0;
		else throw Error("Unrecognized modifier name: " + n);
	}
	return r && (n = "Alt-" + n), i && (n = "Ctrl-" + n), o && (n = "Meta-" + n), a && (n = "Shift-" + n), n;
}
function LH(e) {
	let t = Object.create(null);
	for (let n in e) t[IH(n)] = e[n];
	return t;
}
function RH(e, t, n = !0) {
	return t.altKey && (e = "Alt-" + e), t.ctrlKey && (e = "Ctrl-" + e), t.metaKey && (e = "Meta-" + e), n && t.shiftKey && (e = "Shift-" + e), e;
}
function zH(e) {
	return new lL({ props: { handleKeyDown: BH(e) } });
}
function BH(e) {
	let t = LH(e);
	return function(e, n) {
		let r = NH(n), i, a = t[RH(r, n)];
		if (a && a(e.state, e.dispatch, e)) return !0;
		if (r.length == 1 && r != " ") {
			if (n.shiftKey) {
				let i = t[RH(r, n, !1)];
				if (i && i(e.state, e.dispatch, e)) return !0;
			}
			if ((n.altKey || n.metaKey || n.ctrlKey) && !(FH && n.ctrlKey && n.altKey) && (i = DH[n.keyCode]) && i != r) {
				let r = t[RH(i, n)];
				if (r && r(e.state, e.dispatch, e)) return !0;
			}
		}
		return !1;
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@tiptap+core@3.27.1_@tiptap+pm@3.27.1/node_modules/@tiptap/core/dist/index.js
var VH = Object.defineProperty, HH = (e, t) => {
	for (var n in t) VH(e, n, {
		get: t[n],
		enumerable: !0
	});
};
function UH(e) {
	let { state: t, transaction: n } = e, { selection: r } = n, { doc: i } = n, { storedMarks: a } = n;
	return {
		...t,
		apply: t.apply.bind(t),
		applyTransaction: t.applyTransaction.bind(t),
		plugins: t.plugins,
		schema: t.schema,
		reconfigure: t.reconfigure.bind(t),
		toJSON: t.toJSON.bind(t),
		get storedMarks() {
			return a;
		},
		get selection() {
			return r;
		},
		get doc() {
			return i;
		},
		get tr() {
			return r = n.selection, i = n.doc, a = n.storedMarks, n;
		}
	};
}
var WH = class {
	constructor(e) {
		this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
	}
	get hasCustomState() {
		return !!this.customState;
	}
	get state() {
		return this.customState || this.editor.state;
	}
	get commands() {
		let { rawCommands: e, editor: t, state: n } = this, { view: r } = t, { tr: i } = n, a = this.buildProps(i);
		return Object.fromEntries(Object.entries(e).map(([e, t]) => [e, (...e) => {
			let n = t(...e)(a);
			return !i.getMeta("preventDispatch") && !this.hasCustomState && r.dispatch(i), n;
		}]));
	}
	get chain() {
		return () => this.createChain();
	}
	get can() {
		return () => this.createCan();
	}
	createChain(e, t = !0) {
		let { rawCommands: n, editor: r, state: i } = this, { view: a } = r, o = [], s = !!e, c = e || i.tr, l = () => (!s && t && !c.getMeta("preventDispatch") && !this.hasCustomState && a.dispatch(c), o.every((e) => e === !0)), u = {
			...Object.fromEntries(Object.entries(n).map(([e, n]) => [e, (...e) => {
				let r = this.buildProps(c, t), i = n(...e)(r);
				return o.push(i), u;
			}])),
			run: l
		};
		return u;
	}
	createCan(e) {
		let { rawCommands: t, state: n } = this, r = e || n.tr, i = this.buildProps(r, !1);
		return {
			...Object.fromEntries(Object.entries(t).map(([e, t]) => [e, (...e) => t(...e)({
				...i,
				dispatch: void 0
			})])),
			chain: () => this.createChain(r, !1)
		};
	}
	buildProps(e, t = !0) {
		let { rawCommands: n, editor: r, state: i } = this, { view: a } = r, o = {
			tr: e,
			editor: r,
			view: a,
			state: UH({
				state: i,
				transaction: e
			}),
			dispatch: t ? () => void 0 : void 0,
			chain: () => this.createChain(e, t),
			can: () => this.createCan(e),
			get commands() {
				return Object.fromEntries(Object.entries(n).map(([e, t]) => [e, (...e) => t(...e)(o)]));
			}
		};
		return o;
	}
}, GH = {};
HH(GH, {
	blur: () => KH,
	clearContent: () => qH,
	clearNodes: () => JH,
	command: () => YH,
	createParagraphNear: () => XH,
	cut: () => ZH,
	deleteCurrentNode: () => QH,
	deleteNode: () => eU,
	deleteRange: () => tU,
	deleteSelection: () => aU,
	enter: () => oU,
	exitCode: () => sU,
	extendMarkRange: () => mU,
	first: () => hU,
	focus: () => SU,
	forEach: () => CU,
	insertContent: () => wU,
	insertContentAt: () => AU,
	joinBackward: () => NU,
	joinDown: () => MU,
	joinForward: () => PU,
	joinItemBackward: () => FU,
	joinItemForward: () => IU,
	joinTextblockBackward: () => LU,
	joinTextblockForward: () => RU,
	joinUp: () => jU,
	keyboardShortcut: () => VU,
	lift: () => UU,
	liftEmptyBlock: () => WU,
	liftListItem: () => GU,
	newlineInCode: () => KU,
	resetAttributes: () => YU,
	scrollIntoView: () => XU,
	selectAll: () => ZU,
	selectNodeBackward: () => QU,
	selectNodeForward: () => $U,
	selectParentNode: () => eW,
	selectTextblockEnd: () => tW,
	selectTextblockStart: () => nW,
	setContent: () => iW,
	setMark: () => tG,
	setMeta: () => nG,
	setNode: () => rG,
	setNodeSelection: () => iG,
	setTextDirection: () => aG,
	setTextSelection: () => oG,
	sinkListItem: () => sG,
	splitBlock: () => lG,
	splitListItem: () => uG,
	toggleList: () => gG,
	toggleMark: () => _G,
	toggleNode: () => vG,
	toggleWrap: () => yG,
	undoInputRule: () => bG,
	unsetAllMarks: () => xG,
	unsetMark: () => SG,
	unsetTextDirection: () => CG,
	updateAttributes: () => wG,
	wrapIn: () => TG,
	wrapInList: () => EG
});
var KH = () => ({ editor: e, view: t }) => (requestAnimationFrame(() => {
	var n;
	e.isDestroyed || (t.dom.blur(), (n = window == null ? void 0 : window.getSelection()) == null || n.removeAllRanges());
}), !0), qH = (e = !0) => ({ commands: t }) => t.setContent("", { emitUpdate: e }), JH = () => ({ state: e, tr: t, dispatch: n }) => {
	let { selection: r } = t, { ranges: i } = r;
	return n && i.forEach(({ $from: n, $to: r }) => {
		e.doc.nodesBetween(n.pos, r.pos, (e, n) => {
			if (e.type.isText) return;
			let { doc: r, mapping: i } = t, a = r.resolve(i.map(n)), o = r.resolve(i.map(n + e.nodeSize)), s = a.blockRange(o);
			if (!s) return;
			let c = eI(s);
			if (e.type.isTextblock) {
				let { defaultType: e } = a.parent.contentMatchAt(a.index());
				t.setNodeMarkup(s.start, e);
			}
			(c || c === 0) && t.lift(s, c);
		});
	}), !0;
}, YH = (e) => (t) => e(t), XH = () => ({ state: e, dispatch: t }) => ML(e, t), ZH = (e, t) => ({ editor: n, tr: r }) => {
	let { state: i } = n, a = i.doc.slice(e.from, e.to);
	r.deleteRange(e.from, e.to);
	let o = r.mapping.map(t);
	return r.insert(o, a.content), r.setSelection(new GI(r.doc.resolve(Math.max(o - 1, 0)))), !0;
}, QH = () => ({ tr: e, dispatch: t }) => {
	let { selection: n } = e, r = n.$anchor.node();
	if (r.content.size > 0) return !1;
	let i = e.selection.$anchor;
	for (let n = i.depth; n > 0; --n) if (i.node(n).type === r.type) {
		if (t) {
			let t = i.before(n), r = i.after(n);
			e.delete(t, r).scrollIntoView();
		}
		return !0;
	}
	return !1;
};
function $H(e, t) {
	if (typeof e == "string") {
		if (!t.nodes[e]) throw Error(`There is no node type named '${e}'. Maybe you forgot to add the extension?`);
		return t.nodes[e];
	}
	return e;
}
var eU = (e) => ({ tr: t, state: n, dispatch: r }) => {
	let i = $H(e, n.schema), a = t.selection.$anchor;
	for (let e = a.depth; e > 0; --e) if (a.node(e).type === i) {
		if (r) {
			let n = a.before(e), r = a.after(e);
			t.delete(n, r).scrollIntoView();
		}
		return !0;
	}
	return !1;
}, tU = (e) => ({ tr: t, dispatch: n }) => {
	let { from: r, to: i } = e;
	return n && t.delete(r, i), !0;
}, nU = (e) => e.content ? /^text(\*|\+)/.test(e.content) : !1, rU = (e, t, n) => {
	if (!e.parent.isInline || n === "left" && e.pos > e.start() || n === "right" && e.pos < e.end()) return e.pos;
	let r = t.nodes[e.parent.type.name].spec;
	return nU(r) ? n === "left" ? e.start() - 1 : e.end() + 1 : e.pos;
}, iU = (e, t, n) => ({
	from: rU(e, n, "left"),
	to: rU(t, n, "right")
}), aU = () => ({ state: e, dispatch: t }) => {
	let { $from: n, $to: r } = e.selection;
	if (e.selection.empty) return !1;
	let { from: i, to: a } = iU(n, r, e.schema);
	return t && (e.tr.deleteRange(i, a).scrollIntoView(), t(e.tr)), !0;
}, oU = () => ({ commands: e }) => e.keyboardShortcut("Enter"), sU = () => ({ state: e, dispatch: t }) => jL(e, t);
function cU(e) {
	return Object.prototype.toString.call(e) === "[object RegExp]";
}
function lU(e, t, n = { strict: !0 }) {
	let r = Object.keys(t);
	return !r.length || r.every((r) => n.strict ? t[r] === e[r] : cU(t[r]) ? t[r].test(e[r]) : t[r] === e[r]);
}
function uU(e, t, n = {}) {
	return e.find((e) => e.type === t && lU(Object.fromEntries(Object.keys(n).map((t) => [t, e.attrs[t]])), n));
}
function dU(e, t, n = {}) {
	return !!uU(e, t, n);
}
function fU(e, t, n) {
	if (!e || !t) return;
	let r = e.parent.childAfter(e.parentOffset);
	if ((!r.node || !r.node.marks.some((e) => e.type === t)) && (r = e.parent.childBefore(e.parentOffset)), !r.node || !r.node.marks.some((e) => e.type === t)) return;
	if (!n) {
		let e = r.node.marks.find((e) => e.type === t);
		e && (n = e.attrs);
	}
	if (!uU([...r.node.marks], t, n)) return;
	let i = r.index, a = e.start() + r.offset, o = i + 1, s = a + r.node.nodeSize;
	for (; i > 0 && dU([...e.parent.child(i - 1).marks], t, n);) --i, a -= e.parent.child(i).nodeSize;
	for (; o < e.parent.childCount && dU([...e.parent.child(o).marks], t, n);) s += e.parent.child(o).nodeSize, o += 1;
	return {
		from: a,
		to: s
	};
}
function pU(e, t) {
	if (typeof e == "string") {
		if (!t.marks[e]) throw Error(`There is no mark type named '${e}'. Maybe you forgot to add the extension?`);
		return t.marks[e];
	}
	return e;
}
var mU = (e, t) => ({ tr: n, state: r, dispatch: i }) => {
	let a = pU(e, r.schema), { doc: o, selection: s } = n, { $from: c, from: l, to: u } = s;
	if (i) {
		let e = fU(c, a, t);
		if (e && e.from <= l && e.to >= u) {
			let t = GI.create(o, e.from, e.to);
			n.setSelection(t);
		}
	}
	return !0;
}, hU = (e) => (t) => {
	let n = typeof e == "function" ? e(t) : e;
	for (let e = 0; e < n.length; e += 1) if (n[e](t)) return !0;
	return !1;
};
function gU(e) {
	return e instanceof GI;
}
function _U(e = 0, t = 0, n = 0) {
	return Math.min(Math.max(e, t), n);
}
function vU(e, t = null) {
	if (!t) return null;
	let n = VI.atStart(e), r = VI.atEnd(e);
	if (t === "start" || t === !0) return n;
	if (t === "end") return r;
	let i = n.from, a = r.to;
	return t === "all" ? GI.create(e, _U(0, i, a), _U(e.content.size, i, a)) : GI.create(e, _U(t, i, a), _U(t, i, a));
}
function yU() {
	return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function bU() {
	return [
		"iPad Simulator",
		"iPhone Simulator",
		"iPod Simulator",
		"iPad",
		"iPhone",
		"iPod"
	].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function xU() {
	return typeof navigator < "u" && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
var SU = (e = null, t = {}) => ({ editor: n, view: r, tr: i, dispatch: a }) => {
	t = {
		scrollIntoView: !0,
		...t
	};
	let o = () => {
		(bU() || yU()) && r.dom.focus(), xU() && !bU() && !yU() && r.dom.focus({ preventScroll: !0 }), requestAnimationFrame(() => {
			n.isDestroyed || (r.focus(), t?.scrollIntoView && n.commands.scrollIntoView());
		});
	};
	try {
		if (r.hasFocus() && e === null || e === !1) return !0;
	} catch {
		return !1;
	}
	if (a && e === null && !gU(n.state.selection)) return o(), !0;
	let s = vU(i.doc, e) || n.state.selection, c = n.state.selection.eq(s);
	return a && (c || i.setSelection(s), c && i.storedMarks && i.setStoredMarks(i.storedMarks), o()), !0;
}, CU = (e, t) => (n) => e.every((e, r) => t(e, {
	...n,
	index: r
})), wU = (e, t) => ({ tr: n, commands: r }) => r.insertContentAt({
	from: n.selection.from,
	to: n.selection.to
}, e, t), TU = (e) => {
	let t = e.childNodes;
	for (let n = t.length - 1; n >= 0; --n) {
		let r = t[n];
		r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? e.removeChild(r) : r.nodeType === 1 && TU(r);
	}
	return e;
};
function EU(e) {
	if (typeof window > "u") throw Error("[tiptap error]: there is no window object available, so this function cannot be used");
	let t = `<body>${e}</body>`, n = new window.DOMParser().parseFromString(t, "text/html").body;
	return TU(n);
}
function DU(e, t, n) {
	if (e instanceof jP || e instanceof X) return e;
	n = {
		slice: !0,
		parseOptions: {},
		...n
	};
	let r = typeof e == "object" && !!e, i = typeof e == "string";
	if (r) try {
		if (Array.isArray(e) && e.length > 0) return X.fromArray(e.map((e) => t.nodeFromJSON(e)));
		let r = t.nodeFromJSON(e);
		return n.errorOnInvalidContent && r.check(), r;
	} catch (r) {
		if (n.errorOnInvalidContent) throw Error("[tiptap error]: Invalid JSON content", { cause: r });
		return console.warn("[tiptap warn]: Invalid content.", "Passed value:", e, "Error:", r), DU("", t, n);
	}
	if (i) {
		if (n.errorOnInvalidContent) {
			let r = !1, i = "", a = new nF({
				topNode: t.spec.topNode,
				marks: t.spec.marks,
				nodes: t.spec.nodes.append({ __tiptap__private__unknown__catch__all__node: {
					content: "inline*",
					group: "block",
					parseDOM: [{
						tag: "*",
						getAttrs: (e) => (r = !0, i = typeof e == "string" ? e : e.outerHTML, null)
					}]
				} })
			});
			if (n.slice ? oF.fromSchema(a).parseSlice(EU(e), n.parseOptions) : oF.fromSchema(a).parse(EU(e), n.parseOptions), n.errorOnInvalidContent && r) throw Error("[tiptap error]: Invalid HTML content", { cause: /* @__PURE__ */ Error(`Invalid element found: ${i}`) });
		}
		let r = oF.fromSchema(t);
		return n.slice ? r.parseSlice(EU(e), n.parseOptions).content : r.parse(EU(e), n.parseOptions);
	}
	return DU("", t, n);
}
function OU(e, t, n) {
	let r = e.steps.length - 1;
	if (r < t) return;
	let i = e.steps[r];
	if (!(i instanceof qF || i instanceof JF)) return;
	let a = e.mapping.maps[r], o = 0;
	a.forEach((e, t, n, r) => {
		o === 0 && (o = r);
	}), e.setSelection(VI.near(e.doc.resolve(o), n));
}
var kU = (e) => !("type" in e), AU = (e, t, n) => ({ tr: r, dispatch: i, editor: a }) => {
	if (i) {
		n = {
			parseOptions: a.options.parseOptions,
			updateSelection: !0,
			applyInputRules: !1,
			applyPasteRules: !1,
			...n
		};
		let i, o = (e) => {
			a.emit("contentError", {
				editor: a,
				error: e,
				disableCollaboration: () => {
					"collaboration" in a.storage && typeof a.storage.collaboration == "object" && a.storage.collaboration && (a.storage.collaboration.isDisabled = !0);
				}
			});
		}, s = {
			preserveWhitespace: "full",
			...n.parseOptions
		};
		if (!n.errorOnInvalidContent && !a.options.enableContentCheck && a.options.emitContentError) try {
			DU(t, a.schema, {
				parseOptions: s,
				errorOnInvalidContent: !0
			});
		} catch (e) {
			o(e);
		}
		try {
			i = DU(t, a.schema, {
				parseOptions: s,
				errorOnInvalidContent: n.errorOnInvalidContent ?? a.options.enableContentCheck
			});
		} catch (e) {
			return o(e), !1;
		}
		let { from: c, to: l } = typeof e == "number" ? {
			from: e,
			to: e
		} : {
			from: e.from,
			to: e.to
		}, u = !0, d = !0;
		if ((kU(i) ? i : [i]).forEach((e) => {
			e.check(), u = u ? e.isText && e.marks.length === 0 : !1, d = d ? e.isBlock : !1;
		}), c === l && d) {
			let { parent: e } = r.doc.resolve(c);
			e.isTextblock && !e.type.spec.code && !e.childCount && (--c, l += 1);
		}
		let f;
		if (u) {
			if (Array.isArray(t)) f = t.map((e) => e.text || "").join("");
			else if (t instanceof X) {
				let e = "";
				t.forEach((t) => {
					t.text && (e += t.text);
				}), f = e;
			} else f = typeof t == "object" && t && t.text ? t.text : t;
			r.insertText(f, c, l);
		} else {
			f = i;
			let e = r.doc.resolve(c), t = e.node(), n = e.parentOffset === 0, a = t.isText || t.isTextblock, o = t.content.size > 0;
			n && a && o && d && (c = Math.max(0, c - 1)), r.replaceWith(c, l, f);
		}
		n.updateSelection && OU(r, r.steps.length - 1, -1), n.applyInputRules && r.setMeta("applyInputRules", {
			from: c,
			text: f
		}), n.applyPasteRules && r.setMeta("applyPasteRules", {
			from: c,
			text: f
		});
	}
	return !0;
}, jU = () => ({ state: e, dispatch: t }) => EL(e, t), MU = () => ({ state: e, dispatch: t }) => DL(e, t), NU = () => ({ state: e, dispatch: t }) => hL(e, t), PU = () => ({ state: e, dispatch: t }) => CL(e, t), FU = () => ({ state: e, dispatch: t, tr: n }) => {
	try {
		let r = _I(e.doc, e.selection.$from.pos, -1);
		return r != null && (n.join(r, 2), t && t(n), !0);
	} catch {
		return !1;
	}
}, IU = () => ({ state: e, dispatch: t, tr: n }) => {
	try {
		let r = _I(e.doc, e.selection.$from.pos, 1);
		return r != null && (n.join(r, 2), t && t(n), !0);
	} catch {
		return !1;
	}
}, LU = () => ({ state: e, dispatch: t }) => gL(e, t), RU = () => ({ state: e, dispatch: t }) => _L(e, t);
function zU() {
	return typeof navigator < "u" && /Mac/.test(navigator.platform);
}
function BU(e) {
	let t = e.split(/-(?!$)/), n = t[t.length - 1];
	n === "Space" && (n = " ");
	let r, i, a, o;
	for (let e = 0; e < t.length - 1; e += 1) {
		let n = t[e];
		if (/^(cmd|meta|m)$/i.test(n)) o = !0;
		else if (/^a(lt)?$/i.test(n)) r = !0;
		else if (/^(c|ctrl|control)$/i.test(n)) i = !0;
		else if (/^s(hift)?$/i.test(n)) a = !0;
		else if (/^mod$/i.test(n)) bU() || zU() ? o = !0 : i = !0;
		else throw Error(`Unrecognized modifier name: ${n}`);
	}
	return r && (n = `Alt-${n}`), i && (n = `Ctrl-${n}`), o && (n = `Meta-${n}`), a && (n = `Shift-${n}`), n;
}
var VU = (e) => ({ editor: t, view: n, tr: r, dispatch: i }) => {
	let a = BU(e).split(/-(?!$)/), o = a.find((e) => ![
		"Alt",
		"Ctrl",
		"Meta",
		"Shift"
	].includes(e)), s = new KeyboardEvent("keydown", {
		key: o === "Space" ? " " : o,
		altKey: a.includes("Alt"),
		ctrlKey: a.includes("Ctrl"),
		metaKey: a.includes("Meta"),
		shiftKey: a.includes("Shift"),
		bubbles: !0,
		cancelable: !0
	});
	return t.captureTransaction(() => {
		n.someProp("handleKeyDown", (e) => e(n, s));
	})?.steps.forEach((e) => {
		let t = e.map(r.mapping);
		t && i && r.maybeStep(t);
	}), !0;
};
function HU(e, t, n = {}) {
	let { from: r, to: i, empty: a } = e.selection, o = t ? $H(t, e.schema) : null, s = [];
	e.doc.nodesBetween(r, i, (e, t) => {
		if (e.isText) return;
		let n = Math.max(r, t), a = Math.min(i, t + e.nodeSize);
		s.push({
			node: e,
			from: n,
			to: a
		});
	});
	let c = i - r, l = s.filter((e) => !o || o.name === e.node.type.name).filter((e) => lU(e.node.attrs, n, { strict: !1 }));
	return a ? !!l.length : l.reduce((e, t) => e + t.to - t.from, 0) >= c;
}
var UU = (e, t = {}) => ({ state: n, dispatch: r }) => HU(n, $H(e, n.schema), t) ? OL(n, r) : !1, WU = () => ({ state: e, dispatch: t }) => NL(e, t), GU = (e) => ({ state: t, dispatch: n }) => $L($H(e, t.schema))(t, n), KU = () => ({ state: e, dispatch: t }) => kL(e, t);
function qU(e, t) {
	return t.nodes[e] ? "node" : t.marks[e] ? "mark" : null;
}
function JU(e, t) {
	let n = typeof t == "string" ? [t] : t;
	return Object.keys(e).reduce((t, r) => (n.includes(r) || (t[r] = e[r]), t), {});
}
var YU = (e, t) => ({ tr: n, state: r, dispatch: i }) => {
	let a = null, o = null, s = qU(typeof e == "string" ? e : e.name, r.schema);
	if (!s) return !1;
	s === "node" && (a = $H(e, r.schema)), s === "mark" && (o = pU(e, r.schema));
	let c = !1;
	return n.selection.ranges.forEach((e) => {
		r.doc.nodesBetween(e.$from.pos, e.$to.pos, (e, r) => {
			a && a === e.type && (c = !0, i && n.setNodeMarkup(r, void 0, JU(e.attrs, t))), o && e.marks.length && e.marks.forEach((a) => {
				o === a.type && (c = !0, i && n.addMark(r, r + e.nodeSize, o.create(JU(a.attrs, t))));
			});
		});
	}), c;
}, XU = () => ({ tr: e, dispatch: t }) => (t && e.scrollIntoView(), !0), ZU = () => ({ tr: e, dispatch: t }) => {
	if (t) {
		let t = new YI(e.doc);
		e.setSelection(t);
	}
	return !0;
}, QU = () => ({ state: e, dispatch: t }) => bL(e, t), $U = () => ({ state: e, dispatch: t }) => wL(e, t), eW = () => ({ state: e, dispatch: t }) => IL(e, t), tW = () => ({ state: e, dispatch: t }) => HL(e, t), nW = () => ({ state: e, dispatch: t }) => VL(e, t);
function rW(e, t, n = {}, r = {}) {
	return DU(e, t, {
		slice: !1,
		parseOptions: n,
		errorOnInvalidContent: r.errorOnInvalidContent
	});
}
var iW = (e, { errorOnInvalidContent: t, emitUpdate: n = !0, parseOptions: r = {} } = {}) => ({ editor: i, tr: a, dispatch: o, commands: s }) => {
	let { doc: c } = a;
	if (r.preserveWhitespace !== "full") {
		let s = rW(e, i.schema, r, { errorOnInvalidContent: t ?? i.options.enableContentCheck });
		return o && a.replaceWith(0, c.content.size, s).setMeta("preventUpdate", !n), !0;
	}
	return o && a.setMeta("preventUpdate", !n), s.insertContentAt({
		from: 0,
		to: c.content.size
	}, e, {
		parseOptions: r,
		errorOnInvalidContent: t ?? i.options.enableContentCheck
	});
};
function aW(e, t) {
	let n = pU(t, e.schema), { from: r, to: i, empty: a } = e.selection, o = [];
	a ? (e.storedMarks && o.push(...e.storedMarks), o.push(...e.selection.$head.marks())) : e.doc.nodesBetween(r, i, (e) => {
		o.push(...e.marks);
	});
	let s = o.find((e) => e.type.name === n.name);
	return s ? { ...s.attrs } : {};
}
function oW(e, t) {
	let n = new zI(e);
	return t.forEach((e) => {
		e.steps.forEach((e) => {
			n.step(e);
		});
	}), n;
}
function sW(e) {
	for (let t = 0; t < e.edgeCount; t += 1) {
		let { type: n } = e.edge(t);
		if (n.isTextblock && !n.hasRequiredAttrs()) return n;
	}
	return null;
}
function cW(e, t, n) {
	let r = [];
	return e.nodesBetween(t.from, t.to, (e, t) => {
		n(e) && r.push({
			node: e,
			pos: t
		});
	}), r;
}
function lW(e, t) {
	for (let n = e.depth; n > 0; --n) {
		let r = e.node(n);
		if (t(r)) return {
			pos: n > 0 ? e.before(n) : 0,
			start: e.start(n),
			depth: n,
			node: r
		};
	}
}
function uW(e) {
	return (t) => lW(t.$from, e);
}
function Q(e, t, n) {
	return e.config[t] === void 0 && e.parent ? Q(e.parent, t, n) : typeof e.config[t] == "function" ? e.config[t].bind({
		...n,
		parent: e.parent ? Q(e.parent, t, n) : null
	}) : e.config[t];
}
function dW(e) {
	return e.map((e) => {
		let t = Q(e, "addExtensions", {
			name: e.name,
			options: e.options,
			storage: e.storage
		});
		return t ? [e, ...dW(t())] : e;
	}).flat(10);
}
function fW(e, t) {
	let n = bF.fromSchema(t).serializeFragment(e), r = document.implementation.createHTMLDocument().createElement("div");
	return r.appendChild(n), r.innerHTML;
}
function pW(e) {
	return typeof e == "function";
}
function mW(e, t = void 0, ...n) {
	return pW(e) ? t ? e.bind(t)(...n) : e(...n) : e;
}
function hW(e = {}) {
	return Object.keys(e).length === 0 && e.constructor === Object;
}
function gW(e) {
	return {
		baseExtensions: e.filter((e) => e.type === "extension"),
		nodeExtensions: e.filter((e) => e.type === "node"),
		markExtensions: e.filter((e) => e.type === "mark")
	};
}
function _W(e) {
	let t = [], { nodeExtensions: n, markExtensions: r } = gW(e), i = [...n, ...r], a = {
		default: null,
		validate: void 0,
		rendered: !0,
		renderHTML: null,
		parseHTML: null,
		keepOnSplit: !0,
		isRequired: !1
	}, o = n.filter((e) => e.name !== "text").map((e) => e.name), s = r.map((e) => e.name), c = [...o, ...s];
	return e.forEach((e) => {
		let n = Q(e, "addGlobalAttributes", {
			name: e.name,
			options: e.options,
			storage: e.storage,
			extensions: i
		});
		n && n().forEach((e) => {
			let n;
			n = Array.isArray(e.types) ? e.types : e.types === "*" ? c : e.types === "nodes" ? o : e.types === "marks" ? s : [], n.forEach((n) => {
				Object.entries(e.attributes).forEach(([e, r]) => {
					t.push({
						type: n,
						name: e,
						attribute: {
							...a,
							...r
						}
					});
				});
			});
		});
	}), i.forEach((e) => {
		let n = Q(e, "addAttributes", {
			name: e.name,
			options: e.options,
			storage: e.storage
		});
		if (!n) return;
		let r = n();
		Object.entries(r).forEach(([n, r]) => {
			let i = {
				...a,
				...r
			};
			typeof i?.default == "function" && (i.default = i.default()), i?.isRequired && i?.default === void 0 && delete i.default, t.push({
				type: e.name,
				name: n,
				attribute: i
			});
		});
	}), t;
}
function vW(e) {
	let t = [], n = "", r = !1, i = !1, a = 0, o = e.length;
	for (let s = 0; s < o; s += 1) {
		let o = e[s];
		if (o === "'" && !i) {
			r = !r, n += o;
			continue;
		}
		if (o === "\"" && !r) {
			i = !i, n += o;
			continue;
		}
		if (!r && !i) {
			if (o === "(") {
				a += 1, n += o;
				continue;
			}
			if (o === ")" && a > 0) {
				--a, n += o;
				continue;
			}
			if (o === ";" && a === 0) {
				t.push(n), n = "";
				continue;
			}
		}
		n += o;
	}
	return n && t.push(n), t;
}
function yW(e) {
	let t = [], n = vW(e || ""), r = n.length;
	for (let e = 0; e < r; e += 1) {
		let r = n[e], i = r.indexOf(":");
		if (i === -1) continue;
		let a = r.slice(0, i).trim(), o = r.slice(i + 1).trim();
		a && o && t.push([a, o]);
	}
	return t;
}
function bW(...e) {
	return e.filter((e) => !!e).reduce((e, t) => {
		let n = { ...e };
		return Object.entries(t).forEach(([e, t]) => {
			if (!n[e]) {
				n[e] = t;
				return;
			}
			if (e === "class") {
				let r = t ? String(t).split(" ") : [], i = n[e] ? n[e].split(" ") : [], a = r.filter((e) => !i.includes(e));
				n[e] = [...i, ...a].join(" ");
			} else if (e === "style") {
				let r = new Map([...yW(n[e]), ...yW(t)]);
				n[e] = Array.from(r.entries()).map(([e, t]) => `${e}: ${t}`).join("; ");
			} else n[e] = t;
		}), n;
	}, {});
}
function xW(e, t) {
	return t.filter((t) => t.type === e.type.name).filter((e) => e.attribute.rendered).map((t) => t.attribute.renderHTML ? t.attribute.renderHTML(e.attrs) || {} : { [t.name]: e.attrs[t.name] }).reduce((e, t) => bW(e, t), {});
}
function SW(e) {
	return typeof e == "string" ? e.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(e) : e === "true" || e !== "false" && e : e;
}
function CW(e, t) {
	return "style" in e ? e : {
		...e,
		getAttrs: (n) => {
			let r = e.getAttrs ? e.getAttrs(n) : e.attrs;
			if (r === !1) return !1;
			let i = t.reduce((e, t) => {
				let r = t.attribute.parseHTML ? t.attribute.parseHTML(n) : SW(n.getAttribute(t.name));
				return r == null ? e : {
					...e,
					[t.name]: r
				};
			}, {});
			return {
				...r,
				...i
			};
		}
	};
}
function wW(e) {
	return Object.fromEntries(Object.entries(e).filter(([e, t]) => e === "attrs" && hW(t) ? !1 : t != null));
}
function TW(e) {
	let t = {};
	return !e?.attribute?.isRequired && "default" in (e?.attribute || {}) && (t.default = e.attribute.default), e?.attribute?.validate !== void 0 && (t.validate = e.attribute.validate), [e.name, t];
}
function EW(e, t) {
	let n = _W(e), { nodeExtensions: r, markExtensions: i } = gW(e), a = r.find((e) => Q(e, "topNode"))?.name;
	return new nF({
		topNode: a,
		nodes: Object.fromEntries(r.map((r) => {
			let i = n.filter((e) => e.type === r.name), a = {
				name: r.name,
				options: r.options,
				storage: r.storage,
				editor: t
			}, o = wW({
				...e.reduce((e, t) => {
					let n = Q(t, "extendNodeSchema", a);
					return {
						...e,
						...n ? n(r) : {}
					};
				}, {}),
				content: mW(Q(r, "content", a)),
				marks: mW(Q(r, "marks", a)),
				group: mW(Q(r, "group", a)),
				inline: mW(Q(r, "inline", a)),
				atom: mW(Q(r, "atom", a)),
				selectable: mW(Q(r, "selectable", a)),
				draggable: mW(Q(r, "draggable", a)),
				code: mW(Q(r, "code", a)),
				whitespace: mW(Q(r, "whitespace", a)),
				linebreakReplacement: mW(Q(r, "linebreakReplacement", a)),
				defining: mW(Q(r, "defining", a)),
				isolating: mW(Q(r, "isolating", a)),
				attrs: Object.fromEntries(i.map(TW))
			}), s = mW(Q(r, "parseHTML", a));
			s && (o.parseDOM = s.map((e) => CW(e, i)));
			let c = Q(r, "renderHTML", a);
			c && (o.toDOM = (e) => c({
				node: e,
				HTMLAttributes: xW(e, i)
			}));
			let l = Q(r, "renderText", a);
			return l && (o.toText = l), [r.name, o];
		})),
		marks: Object.fromEntries(i.map((r) => {
			let i = n.filter((e) => e.type === r.name), a = {
				name: r.name,
				options: r.options,
				storage: r.storage,
				editor: t
			}, o = wW({
				...e.reduce((e, t) => {
					let n = Q(t, "extendMarkSchema", a);
					return {
						...e,
						...n ? n(r) : {}
					};
				}, {}),
				inclusive: mW(Q(r, "inclusive", a)),
				excludes: mW(Q(r, "excludes", a)),
				group: mW(Q(r, "group", a)),
				spanning: mW(Q(r, "spanning", a)),
				code: mW(Q(r, "code", a)),
				attrs: Object.fromEntries(i.map(TW))
			}), s = mW(Q(r, "parseHTML", a));
			s && (o.parseDOM = s.map((e) => CW(e, i)));
			let c = Q(r, "renderHTML", a);
			return c && (o.toDOM = (e) => c({
				mark: e,
				HTMLAttributes: xW(e, i)
			})), [r.name, o];
		}))
	});
}
function DW(e) {
	let t = e.filter((t, n) => e.indexOf(t) !== n);
	return Array.from(new Set(t));
}
function OW(e) {
	return e.sort((e, t) => {
		let n = Q(e, "priority") || 100, r = Q(t, "priority") || 100;
		return n > r ? -1 : +(n < r);
	});
}
function kW(e) {
	let t = OW(dW(e)), n = DW(t.map((e) => e.name));
	return n.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${n.map((e) => `'${e}'`).join(", ")}]. This can lead to issues.`), t;
}
function AW(e, t, n) {
	let { from: r, to: i } = t, { blockSeparator: a = "\n\n", textSerializers: o = {} } = n || {}, s = "";
	return e.nodesBetween(r, i, (e, n, c, l) => {
		e.isBlock && n > r && (s += a);
		let u = o?.[e.type.name];
		if (u) return c && (s += u({
			node: e,
			pos: n,
			parent: c,
			index: l,
			range: t
		})), !1;
		e.isText && (s += (e?.text)?.slice(Math.max(r, n) - n, i - n));
	}), s;
}
function jW(e, t) {
	return AW(e, {
		from: 0,
		to: e.content.size
	}, t);
}
function MW(e) {
	return Object.fromEntries(Object.entries(e.nodes).filter(([, e]) => e.spec.toText).map(([e, t]) => [e, t.spec.toText]));
}
function NW(e, t) {
	let n = $H(t, e.schema), { from: r, to: i } = e.selection, a = [];
	e.doc.nodesBetween(r, i, (e) => {
		a.push(e);
	});
	let o = a.reverse().find((e) => e.type.name === n.name);
	return o ? { ...o.attrs } : {};
}
function PW(e, t) {
	let n = qU(typeof t == "string" ? t : t.name, e.schema);
	return n === "node" ? NW(e, t) : n === "mark" ? aW(e, t) : {};
}
function FW(e, t = JSON.stringify) {
	let n = {};
	return e.filter((e) => {
		let r = t(e);
		return Object.prototype.hasOwnProperty.call(n, r) ? !1 : n[r] = !0;
	});
}
function IW(e) {
	let t = FW(e);
	return t.length === 1 ? t : t.filter((e, n) => !t.filter((e, t) => t !== n).some((t) => e.oldRange.from >= t.oldRange.from && e.oldRange.to <= t.oldRange.to && e.newRange.from >= t.newRange.from && e.newRange.to <= t.newRange.to));
}
function LW(e) {
	let { mapping: t, steps: n } = e, r = [];
	return t.maps.forEach((e, i) => {
		let a = [];
		if (e.ranges.length) e.forEach((e, t) => {
			a.push({
				from: e,
				to: t
			});
		});
		else {
			let { from: e, to: t } = n[i];
			if (e === void 0 || t === void 0) return;
			a.push({
				from: e,
				to: t
			});
		}
		a.forEach(({ from: e, to: n }) => {
			let a = t.slice(i).map(e, -1), o = t.slice(i).map(n), s = t.invert().map(a, -1), c = t.invert().map(o);
			r.push({
				oldRange: {
					from: s,
					to: c
				},
				newRange: {
					from: a,
					to: o
				}
			});
		});
	}), IW(r);
}
function RW(e, t, n) {
	let r = [];
	return e === t ? n.resolve(e).marks().forEach((t) => {
		let i = fU(n.resolve(e), t.type);
		i && r.push({
			mark: t,
			...i
		});
	}) : n.nodesBetween(e, t, (e, t) => {
		!e || e?.nodeSize === void 0 || r.push(...e.marks.map((n) => ({
			from: t,
			to: t + e.nodeSize,
			mark: n
		})));
	}), r;
}
var zW = (e, t, n, r = 20) => {
	let i = e.doc.resolve(n), a = r, o = null;
	for (; a > 0 && o === null;) {
		let e = i.node(a);
		e?.type.name === t ? o = e : --a;
	}
	return [o, a];
};
function BW(e, t) {
	return t.nodes[e] || t.marks[e] || null;
}
function VW(e, t, n) {
	return Object.fromEntries(Object.entries(n).filter(([n]) => {
		let r = e.find((e) => e.type === t && e.name === n);
		return r ? r.attribute.keepOnSplit : !1;
	}));
}
var HW = (e, t = 500) => {
	let n = "", r = e.parentOffset;
	return e.parent.nodesBetween(Math.max(0, r - t), r, (e, t, i, a) => {
		var o;
		let s = (o = e.type.spec).toText?.call(o, {
			node: e,
			pos: t,
			parent: i,
			index: a
		}) || e.textContent || "%leaf%";
		n += e.isAtom && !e.isText ? s : s.slice(0, Math.max(0, r - t));
	}), n;
};
function UW(e, t, n = {}) {
	let { empty: r, ranges: i } = e.selection, a = t ? pU(t, e.schema) : null;
	if (r) return !!(e.storedMarks || e.selection.$from.marks()).filter((e) => !a || a.name === e.type.name).find((e) => lU(e.attrs, n, { strict: !1 }));
	let o = 0, s = [];
	if (i.forEach(({ $from: t, $to: n }) => {
		let r = t.pos, i = n.pos;
		e.doc.nodesBetween(r, i, (e, t) => {
			if (a && e.inlineContent && !e.type.allowsMarkType(a)) return !1;
			if (!e.isText && !e.marks.length) return;
			let n = Math.max(r, t), c = Math.min(i, t + e.nodeSize), l = c - n;
			o += l, s.push(...e.marks.map((e) => ({
				mark: e,
				from: n,
				to: c
			})));
		});
	}), o === 0) return !1;
	let c = s.filter((e) => !a || a.name === e.mark.type.name).filter((e) => lU(e.mark.attrs, n, { strict: !1 })).reduce((e, t) => e + t.to - t.from, 0), l = s.filter((e) => !a || e.mark.type !== a && e.mark.type.excludes(a)).reduce((e, t) => e + t.to - t.from, 0);
	return (c > 0 ? c + l : c) >= o;
}
function WW(e, t, n = {}) {
	if (!t) return HU(e, null, n) || UW(e, null, n);
	let r = qU(t, e.schema);
	return r === "node" ? HU(e, t, n) : r === "mark" && UW(e, t, n);
}
var GW = (e, t) => {
	let { $from: n, $to: r, $anchor: i } = e.selection;
	if (t) {
		let n = uW((e) => e.type.name === t)(e.selection);
		if (!n) return !1;
		let r = e.doc.resolve(n.pos + 1);
		return i.pos + 1 === r.end();
	}
	return !(r.parentOffset < r.parent.nodeSize - 2 || n.pos !== r.pos);
}, KW = (e) => {
	let { $from: t, $to: n } = e.selection;
	return !(t.parentOffset > 0 || t.pos !== n.pos);
};
function qW(e, t) {
	return Array.isArray(t) ? t.some((t) => (typeof t == "string" ? t : t.name) === e.name) : t;
}
function JW(e, t) {
	let { nodeExtensions: n } = gW(t), r = n.find((t) => t.name === e);
	if (!r) return !1;
	let i = mW(Q(r, "group", {
		name: r.name,
		options: r.options,
		storage: r.storage
	}));
	return typeof i == "string" && i.split(" ").includes("list");
}
function YW(e, { checkChildren: t = !0, ignoreWhitespace: n = !1 } = {}) {
	if (n) {
		if (e.type.name === "hardBreak") return !0;
		if (e.isText) return !/\S/.test(e.text ?? "");
	}
	if (e.isText) return !e.text;
	if (e.isAtom || e.isLeaf) return !1;
	if (e.content.childCount === 0) return !0;
	if (t) {
		let r = !0;
		return e.content.forEach((e) => {
			r !== !1 && (YW(e, {
				ignoreWhitespace: n,
				checkChildren: t
			}) || (r = !1));
		}), r;
	}
	return !1;
}
function XW(e) {
	return e instanceof qI;
}
var ZW = class e {
	constructor(e) {
		this.position = e;
	}
	static fromJSON(t) {
		return new e(t.position);
	}
	toJSON() {
		return { position: this.position };
	}
};
function QW(e, t) {
	let n = t.mapping.mapResult(e.position);
	return {
		position: new ZW(n.pos),
		mapResult: n
	};
}
function $W(e) {
	return new ZW(e);
}
function eG(e, t, n) {
	let { selection: r } = t, i = null;
	if (gU(r) && (i = r.$cursor), i) {
		let t = e.storedMarks ?? i.marks();
		return i.parent.type.allowsMarkType(n) && (!!n.isInSet(t) || !t.some((e) => e.type.excludes(n)));
	}
	let { ranges: a } = r;
	return a.some(({ $from: t, $to: r }) => {
		let i = t.depth === 0 && e.doc.inlineContent && e.doc.type.allowsMarkType(n);
		return e.doc.nodesBetween(t.pos, r.pos, (e, t, r) => {
			if (i) return !1;
			if (e.isInline) {
				let t = !r || r.type.allowsMarkType(n), a = !!n.isInSet(e.marks) || !e.marks.some((e) => e.type.excludes(n));
				i = t && a;
			}
			return !i;
		}), i;
	});
}
var tG = (e, t = {}) => ({ tr: n, state: r, dispatch: i }) => {
	let { selection: a } = n, { empty: o, ranges: s } = a, c = pU(e, r.schema);
	if (i) {
		if (o) {
			let e = aW(r, c);
			n.addStoredMark(c.create({
				...e,
				...t
			}));
		} else s.forEach((e) => {
			let i = e.$from.pos, a = e.$to.pos;
			r.doc.nodesBetween(i, a, (e, r) => {
				let o = Math.max(r, i), s = Math.min(r + e.nodeSize, a);
				e.marks.find((e) => e.type === c) ? e.marks.forEach((e) => {
					c === e.type && n.addMark(o, s, c.create({
						...e.attrs,
						...t
					}));
				}) : n.addMark(o, s, c.create(t));
			});
		});
	}
	return eG(r, n, c);
}, nG = (e, t) => ({ tr: n }) => (n.setMeta(e, t), !0), rG = (e, t = {}) => ({ state: n, dispatch: r, chain: i }) => {
	let a = $H(e, n.schema), o;
	return n.selection.$anchor.sameParent(n.selection.$head) && (o = n.selection.$anchor.parent.attrs), a.isTextblock ? i().command(({ commands: e }) => WL(a, {
		...o,
		...t
	})(n) ? !0 : e.clearNodes()).command(({ state: e }) => WL(a, {
		...o,
		...t
	})(e, r)).run() : (console.warn("[tiptap warn]: Currently \"setNode()\" only supports text block nodes."), !1);
}, iG = (e) => ({ tr: t, dispatch: n }) => {
	if (n) {
		let { doc: n } = t, r = _U(e, 0, n.content.size), i = qI.create(n, r);
		t.setSelection(i);
	}
	return !0;
}, aG = (e, t) => ({ tr: n, state: r, dispatch: i }) => {
	let { selection: a } = r, o, s;
	return typeof t == "number" ? (o = t, s = t) : t && "from" in t && "to" in t ? (o = t.from, s = t.to) : (o = a.from, s = a.to), i && n.doc.nodesBetween(o, s, (t, r) => {
		t.isText || n.setNodeMarkup(r, void 0, {
			...t.attrs,
			dir: e
		});
	}), !0;
}, oG = (e) => ({ tr: t, dispatch: n }) => {
	if (n) {
		let { doc: n } = t, { from: r, to: i } = typeof e == "number" ? {
			from: e,
			to: e
		} : e, a = GI.atStart(n).from, o = GI.atEnd(n).to, s = _U(r, a, o), c = _U(i, a, o), l = GI.create(n, s, c);
		t.setSelection(l);
	}
	return !0;
}, sG = (e) => ({ state: t, dispatch: n }) => nR($H(e, t.schema))(t, n);
function cG(e, t) {
	let n = e.storedMarks || e.selection.$to.parentOffset && e.selection.$from.marks();
	if (n) {
		let r = n.filter((e) => t?.includes(e.type.name));
		e.tr.ensureMarks(r);
	}
}
var lG = ({ keepMarks: e = !0 } = {}) => ({ tr: t, state: n, dispatch: r, editor: i }) => {
	let { selection: a, doc: o } = t, { $from: s, $to: c } = a, l = i.extensionManager.attributes, u = VW(l, s.node().type.name, s.node().attrs);
	if (a instanceof qI && a.node.isBlock) return !s.parentOffset || !fI(o, s.pos) ? !1 : (r && (e && cG(n, i.extensionManager.splittableMarks), t.split(s.pos).scrollIntoView()), !0);
	if (!s.parent.isBlock) return !1;
	let d = c.parentOffset === c.parent.content.size, f = s.depth === 0 ? void 0 : sW(s.node(-1).contentMatchAt(s.indexAfter(-1))), p = d && f ? [{
		type: f,
		attrs: u
	}] : void 0, m = fI(t.doc, t.mapping.map(s.pos), 1, p);
	if (!p && !m && fI(t.doc, t.mapping.map(s.pos), 1, f ? [{ type: f }] : void 0) && (m = !0, p = f ? [{
		type: f,
		attrs: u
	}] : void 0), r) {
		if (m && (a instanceof GI && t.deleteSelection(), t.split(t.mapping.map(s.pos), 1, p), f && !d && !s.parentOffset && s.parent.type !== f)) {
			let e = t.mapping.map(s.before()), n = t.doc.resolve(e);
			s.node(-1).canReplaceWith(n.index(), n.index() + 1, f) && t.setNodeMarkup(t.mapping.map(s.before()), f);
		}
		e && cG(n, i.extensionManager.splittableMarks), t.scrollIntoView();
	}
	return m;
}, uG = (e, t = {}) => ({ tr: n, state: r, dispatch: i, editor: a }) => {
	let o = $H(e, r.schema), { $from: s, $to: c } = r.selection, l = r.selection.node;
	if (l && l.isBlock || s.depth < 2 || !s.sameParent(c)) return !1;
	let u = s.node(-1);
	if (u.type !== o) return !1;
	let d = a.extensionManager.attributes;
	if (s.parent.content.size === 0 && s.node(-1).childCount === s.indexAfter(-1)) {
		if (s.depth === 2 || s.node(-3).type !== o || s.index(-2) !== s.node(-2).childCount - 1) return !1;
		if (i) {
			let e = X.empty, r = s.index(-1) ? 1 : s.index(-2) ? 2 : 3;
			for (let t = s.depth - r; t >= s.depth - 3; --t) e = X.from(s.node(t).copy(e));
			let i = s.indexAfter(-1) < s.node(-2).childCount ? 1 : s.indexAfter(-2) < s.node(-3).childCount ? 2 : 3, a = {
				...VW(d, s.node().type.name, s.node().attrs),
				...t
			}, c = o.contentMatch.defaultType?.createAndFill(a) || void 0;
			e = e.append(X.from(o.createAndFill(null, c) || void 0));
			let l = s.before(s.depth - (r - 1));
			n.replace(l, s.after(-i), new Z(e, 4 - r, 0));
			let u = -1;
			n.doc.nodesBetween(l, n.doc.content.size, (e, t) => {
				if (u > -1) return !1;
				e.isTextblock && e.content.size === 0 && (u = t + 1);
			}), u > -1 && n.setSelection(GI.near(n.doc.resolve(u))), n.scrollIntoView();
		}
		return !0;
	}
	let f = c.pos === s.end() ? u.contentMatchAt(0).defaultType : null, p = {
		...VW(d, u.type.name, u.attrs),
		...t
	}, m = {
		...VW(d, s.node().type.name, s.node().attrs),
		...t
	};
	n.delete(s.pos, c.pos);
	let h = f ? [{
		type: o,
		attrs: p
	}, {
		type: f,
		attrs: m
	}] : [{
		type: o,
		attrs: p
	}];
	if (!fI(n.doc, s.pos, 2)) return !1;
	if (i) {
		let { selection: e, storedMarks: t } = r, { splittableMarks: o } = a.extensionManager, c = t || e.$to.parentOffset && e.$from.marks();
		if (n.split(s.pos, 2, h).scrollIntoView(), !c || !i) return !0;
		let l = c.filter((e) => o.includes(e.type.name));
		n.ensureMarks(l);
	}
	return !0;
};
function dG(e) {
	return !e || e === "1" ? null : e;
}
function fG(e, t) {
	return dG(e) === dG(t);
}
var pG = (e, t) => {
	let n = uW((e) => e.type === t)(e.selection);
	if (!n) return !0;
	let r = e.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
	if (r === void 0) return !0;
	let i = e.doc.nodeAt(r);
	return !(n.node.type === i?.type && mI(e.doc, n.pos)) || !fG(n.node.attrs.type, i?.attrs.type) || e.join(n.pos), !0;
}, mG = (e, t) => {
	let n = uW((e) => e.type === t)(e.selection);
	if (!n) return !0;
	let r = e.doc.resolve(n.start).after(n.depth);
	if (r === void 0) return !0;
	let i = e.doc.nodeAt(r);
	return !(n.node.type === i?.type && mI(e.doc, r)) || !fG(n.node.attrs.type, i?.attrs.type) || e.join(r), !0;
};
function hG(e) {
	let t = e.doc, n = t.firstChild;
	if (!n) return null;
	let r = t.resolve(1), i = t.resolve(n.nodeSize - 1);
	return GI.between(r, i);
}
var gG = (e, t, n, r = {}) => ({ editor: i, tr: a, state: o, dispatch: s, chain: c, commands: l, can: u }) => {
	let { extensions: d, splittableMarks: f } = i.extensionManager, p = $H(e, o.schema), m = $H(t, o.schema), { selection: h, storedMarks: g } = o, { $from: _, $to: v } = h, y = _.blockRange(v), b = g || h.$to.parentOffset && h.$from.marks();
	if (!y) return !1;
	let x = uW((e) => JW(e.type.name, d))(h), S = h.from === 0 && h.to === o.doc.content.size, C = o.doc.content.content, w = C.length === 1 ? C[0] : null, T = S && w && JW(w.type.name, d) ? {
		node: w,
		pos: 0,
		depth: 0
	} : null, E = x ?? T, D = !!x && y.depth >= 1 && y.depth - x.depth <= 1, O = !!T;
	if ((D || O) && E) {
		if (E.node.type === p) return S && O ? c().command(({ tr: e, dispatch: t }) => {
			let n = hG(e);
			return n ? (e.setSelection(n), t && t(e), !0) : !1;
		}).liftListItem(m).run() : l.liftListItem(m);
		if (JW(E.node.type.name, d) && p.validContent(E.node.content)) return c().command(() => (a.setNodeMarkup(E.pos, p), !0)).command(() => pG(a, p)).command(() => mG(a, p)).run();
	}
	return !n || !b || !s ? c().command(() => u().wrapInList(p, r) ? !0 : l.clearNodes()).wrapInList(p, r).command(() => pG(a, p)).command(() => mG(a, p)).run() : c().command(() => {
		let e = u().wrapInList(p, r), t = b.filter((e) => f.includes(e.type.name));
		return a.ensureMarks(t), e ? !0 : l.clearNodes();
	}).wrapInList(p, r).command(() => pG(a, p)).command(() => mG(a, p)).run();
}, _G = (e, t = {}, n = {}) => ({ state: r, commands: i }) => {
	let { extendEmptyMarkRange: a = !1 } = n, o = pU(e, r.schema);
	return UW(r, o, t) ? i.unsetMark(o, { extendEmptyMarkRange: a }) : i.setMark(o, t);
}, vG = (e, t, n = {}) => ({ state: r, commands: i }) => {
	let a = $H(e, r.schema), o = $H(t, r.schema), s = HU(r, a, n), c;
	return r.selection.$anchor.sameParent(r.selection.$head) && (c = r.selection.$anchor.parent.attrs), s ? i.setNode(o, c) : i.setNode(a, {
		...c,
		...n
	});
}, yG = (e, t = {}) => ({ state: n, commands: r }) => {
	let i = $H(e, n.schema);
	return HU(n, i, t) ? r.lift(i) : r.wrapIn(i, t);
}, bG = () => ({ state: e, dispatch: t }) => {
	let n = e.plugins;
	for (let r = 0; r < n.length; r += 1) {
		let i = n[r], a;
		if (i.spec.isInputRules && (a = i.getState(e))) {
			if (t) {
				let t = e.tr, n = a.transform;
				for (let e = n.steps.length - 1; e >= 0; --e) t.step(n.steps[e].invert(n.docs[e]));
				if (a.text) {
					let n = t.doc.resolve(a.from).marks();
					t.replaceWith(a.from, a.to, e.schema.text(a.text, n));
				} else t.delete(a.from, a.to);
			}
			return !0;
		}
	}
	return !1;
}, xG = (e = {}) => ({ tr: t, dispatch: n, editor: r }) => {
	let { ignoreClearable: i = !1 } = e, { selection: a } = t, { empty: o, ranges: s } = a;
	if (o) return !0;
	let { nonClearableMarks: c } = r.extensionManager;
	if (n) {
		let e = Object.values(r.schema.marks).filter((e) => i || !c.includes(e.name));
		s.forEach((n) => {
			for (let r of e) t.removeMark(n.$from.pos, n.$to.pos, r);
		});
	}
	return !0;
}, SG = (e, t = {}) => ({ tr: n, state: r, dispatch: i }) => {
	let { extendEmptyMarkRange: a = !1 } = t, { selection: o } = n, s = pU(e, r.schema), { $from: c, empty: l, ranges: u } = o;
	if (!i) return !0;
	if (l && a) {
		let { from: e, to: t } = o, r = fU(c, s, c.marks().find((e) => e.type === s)?.attrs);
		r && (e = r.from, t = r.to), n.removeMark(e, t, s);
	} else u.forEach((e) => {
		n.removeMark(e.$from.pos, e.$to.pos, s);
	});
	return n.removeStoredMark(s), !0;
}, CG = (e) => ({ tr: t, state: n, dispatch: r }) => {
	let { selection: i } = n, a, o;
	return typeof e == "number" ? (a = e, o = e) : e && "from" in e && "to" in e ? (a = e.from, o = e.to) : (a = i.from, o = i.to), r && t.doc.nodesBetween(a, o, (e, n) => {
		if (e.isText) return;
		let r = { ...e.attrs };
		delete r.dir, t.setNodeMarkup(n, void 0, r);
	}), !0;
}, wG = (e, t = {}) => ({ tr: n, state: r, dispatch: i }) => {
	let a = null, o = null, s = qU(typeof e == "string" ? e : e.name, r.schema);
	if (!s) return !1;
	s === "node" && (a = $H(e, r.schema)), s === "mark" && (o = pU(e, r.schema));
	let c = !1;
	return n.selection.ranges.forEach((e) => {
		let s = e.$from.pos, l = e.$to.pos, u, d, f, p;
		n.selection.empty ? r.doc.nodesBetween(s, l, (e, t) => {
			a && a === e.type && (c = !0, f = Math.max(t, s), p = Math.min(t + e.nodeSize, l), u = t, d = e);
		}) : r.doc.nodesBetween(s, l, (e, r) => {
			r < s && a && a === e.type && (c = !0, f = Math.max(r, s), p = Math.min(r + e.nodeSize, l), u = r, d = e), r >= s && r <= l && (a && a === e.type && (c = !0, i && n.setNodeMarkup(r, void 0, {
				...e.attrs,
				...t
			})), o && e.marks.length && e.marks.forEach((a) => {
				if (o === a.type && (c = !0, i)) {
					let i = Math.max(r, s), c = Math.min(r + e.nodeSize, l);
					n.addMark(i, c, o.create({
						...a.attrs,
						...t
					}));
				}
			}));
		}), d && (u !== void 0 && i && n.setNodeMarkup(u, void 0, {
			...d.attrs,
			...t
		}), o && d.marks.length && d.marks.forEach((e) => {
			o === e.type && i && n.addMark(f, p, o.create({
				...e.attrs,
				...t
			}));
		}));
	}), c;
}, TG = (e, t = {}) => ({ state: n, dispatch: r }) => UL($H(e, n.schema), t)(n, r), EG = (e, t = {}) => ({ state: n, dispatch: r }) => XL($H(e, n.schema), t)(n, r), DG = class {
	constructor() {
		this.callbacks = {};
	}
	on(e, t) {
		return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(t), this;
	}
	emit(e, ...t) {
		let n = this.callbacks[e];
		return n && n.forEach((e) => e.apply(this, t)), this;
	}
	off(e, t) {
		let n = this.callbacks[e];
		return n && (t ? this.callbacks[e] = n.filter((e) => e !== t) : delete this.callbacks[e]), this;
	}
	once(e, t) {
		let n = (...r) => {
			this.off(e, n), t.apply(this, r);
		};
		return this.on(e, n);
	}
	removeAllListeners() {
		this.callbacks = {};
	}
};
function OG(e, t, n) {
	let r = document.querySelector(`style[data-tiptap-style${n ? `-${n}` : ""}]`);
	if (r !== null) return r;
	let i = document.createElement("style");
	return t && i.setAttribute("nonce", t), i.setAttribute(`data-tiptap-style${n ? `-${n}` : ""}`, ""), i.innerHTML = e, document.getElementsByTagName("head")[0].appendChild(i), i;
}
function kG(e) {
	return typeof e == "number";
}
function AG(e) {
	return Object.prototype.toString.call(e).slice(8, -1);
}
function jG(e) {
	return AG(e) === "Object" && e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}
HH({}, {
	createAtomBlockMarkdownSpec: () => PG,
	createBlockMarkdownSpec: () => FG,
	createInlineMarkdownSpec: () => RG,
	parseAttributes: () => MG,
	parseIndentedBlocks: () => zG,
	renderNestedMarkdownContent: () => BG,
	serializeAttributes: () => NG
});
function MG(e) {
	if (!e?.trim()) return {};
	let t = {}, n = [], r = e.replace(/["']([^"']*)["']/g, (e) => (n.push(e), `__QUOTED_${n.length - 1}__`)), i = r.match(/(?:^|\s)\.([\w-]+)/g);
	i && (t.class = i.map((e) => e.trim().slice(1)).join(" "));
	let a = r.match(/(?:^|\s)#([\w-]+)/);
	a && (t.id = a[1]), Array.from(r.matchAll(/([a-zA-Z][\w-]*)\s*=\s*(__QUOTED_\d+__)/g)).forEach(([, e, r]) => {
		let i = parseInt(r.match(/__QUOTED_(\d+)__/)?.[1] || "0", 10), a = n[i];
		a && (t[e] = a.slice(1, -1));
	});
	let o = r.replace(/(?:^|\s)\.([\w-]+)/g, "").replace(/(?:^|\s)#([\w-]+)/g, "").replace(/([a-zA-Z][\w-]*)\s*=\s*__QUOTED_\d+__/g, "").trim();
	return o && o.split(/\s+/).filter(Boolean).forEach((e) => {
		e.match(/^[a-zA-Z][\w-]*$/) && (t[e] = !0);
	}), t;
}
function NG(e) {
	if (!e || Object.keys(e).length === 0) return "";
	let t = [];
	return e.class && String(e.class).split(/\s+/).filter(Boolean).forEach((e) => t.push(`.${e}`)), e.id && t.push(`#${e.id}`), Object.entries(e).forEach(([e, n]) => {
		e !== "class" && e !== "id" && (n === !0 ? t.push(e) : n !== !1 && n != null && t.push(`${e}="${String(n)}"`));
	}), t.join(" ");
}
function PG(e) {
	let { nodeName: t, name: n, parseAttributes: r = MG, serializeAttributes: i = NG, defaultAttributes: a = {}, requiredAttributes: o = [], allowedAttributes: s } = e, c = n || t, l = (e) => {
		if (!s) return e;
		let t = {};
		return s.forEach((n) => {
			n in e && (t[n] = e[n]);
		}), t;
	};
	return {
		parseMarkdown: (e, n) => {
			let r = {
				...a,
				...e.attributes
			};
			return n.createNode(t, r, []);
		},
		markdownTokenizer: {
			name: t,
			level: "block",
			start(e) {
				let t = RegExp(`^:::${c}(?:\\s|$)`, "m"), n = e.match(t)?.index;
				return n === void 0 ? -1 : n;
			},
			tokenize(e, n, i) {
				let a = RegExp(`^:::${c}(?:\\s+\\{([^}]*)\\})?\\s*:::(?:\\n|$)`), s = e.match(a);
				if (!s) return;
				let l = s[1] || "", u = r(l);
				if (!o.find((e) => !(e in u))) return {
					type: t,
					raw: s[0],
					attributes: u
				};
			}
		},
		renderMarkdown: (e) => {
			let t = l(e.attrs || {}), n = i(t), r = n ? ` {${n}}` : "";
			return `:::${c}${r} :::`;
		}
	};
}
function FG(e) {
	let { nodeName: t, name: n, getContent: r, parseAttributes: i = MG, serializeAttributes: a = NG, defaultAttributes: o = {}, content: s = "block", allowedAttributes: c } = e, l = n || t, u = (e) => {
		if (!c) return e;
		let t = {};
		return c.forEach((n) => {
			n in e && (t[n] = e[n]);
		}), t;
	};
	return {
		parseMarkdown: (e, n) => {
			let i;
			if (r) {
				let t = r(e);
				i = typeof t == "string" ? [{
					type: "text",
					text: t
				}] : t;
			} else i = s === "block" ? n.parseChildren(e.tokens || []) : n.parseInline(e.tokens || []);
			let a = {
				...o,
				...e.attributes
			};
			return n.createNode(t, a, i);
		},
		markdownTokenizer: {
			name: t,
			level: "block",
			start(e) {
				let t = RegExp(`^:::${l}`, "m"), n = e.match(t)?.index;
				return n === void 0 ? -1 : n;
			},
			tokenize(e, n, r) {
				let a = RegExp(`^:::${l}(?:\\s+\\{([^}]*)\\})?\\s*\\n`), o = e.match(a);
				if (!o) return;
				let [c, u = ""] = o, d = i(u), f = 1, p = c.length, m = "", h = /^:::([\w-]*)(\s.*)?/gm, g = e.slice(p);
				for (h.lastIndex = 0;;) {
					let n = h.exec(g);
					if (n === null) break;
					let i = n.index, a = n[1];
					if (!n[2]?.endsWith(":::")) {
						if (a) f += 1;
						else if (--f, f === 0) {
							let a = g.slice(0, i);
							m = a.trim();
							let o = e.slice(0, p + i + n[0].length), c = [];
							if (m) {
								if (s === "block") for (c = r.blockTokens(a), c.forEach((e) => {
									e.text && (!e.tokens || e.tokens.length === 0) && (e.tokens = r.inlineTokens(e.text));
								}); c.length > 0;) {
									let e = c[c.length - 1];
									if (e.type === "paragraph" && (!e.text || e.text.trim() === "")) c.pop();
									else break;
								}
								else c = r.inlineTokens(m);
							}
							return {
								type: t,
								raw: o,
								attributes: d,
								content: m,
								tokens: c
							};
						}
					}
				}
			}
		},
		renderMarkdown: (e, t) => {
			let n = u(e.attrs || {}), r = a(n), i = r ? ` {${r}}` : "", o = t.renderChildren(e.content || [], "\n\n");
			return `:::${l}${i}

${o}

:::`;
		}
	};
}
function IG(e) {
	if (!e.trim()) return {};
	let t = {}, n = /(\w+)=(?:"([^"]*)"|'([^']*)')/g, r = n.exec(e);
	for (; r !== null;) {
		let [, i, a, o] = r;
		t[i] = a || o, r = n.exec(e);
	}
	return t;
}
function LG(e) {
	return Object.entries(e).filter(([, e]) => e != null).map(([e, t]) => `${e}="${t}"`).join(" ");
}
function RG(e) {
	let { nodeName: t, name: n, getContent: r, parseAttributes: i = IG, serializeAttributes: a = LG, defaultAttributes: o = {}, selfClosing: s = !1, allowedAttributes: c } = e, l = n || t, u = (e) => {
		if (!c) return e;
		let t = {};
		return c.forEach((n) => {
			let r = typeof n == "string" ? n : n.name, i = typeof n == "string" ? void 0 : n.skipIfDefault;
			if (r in e) {
				let n = e[r];
				if (i !== void 0 && n === i) return;
				t[r] = n;
			}
		}), t;
	}, d = l.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	return {
		parseMarkdown: (e, n) => {
			let i = {
				...o,
				...e.attributes
			};
			if (s) return n.createNode(t, i);
			let a = r ? r(e) : e.content || "";
			return a ? n.createNode(t, i, [n.createTextNode(a)]) : n.createNode(t, i, []);
		},
		markdownTokenizer: {
			name: t,
			level: "inline",
			start(e) {
				let t = RegExp(s ? `\\[${d}\\s*[^\\]]*\\]` : `\\[${d}\\s*[^\\]]*\\][\\s\\S]*?\\[\\/${d}\\]`), n = e.match(t)?.index;
				return n === void 0 ? -1 : n;
			},
			tokenize(e, n, r) {
				let a = RegExp(s ? `^\\[${d}\\s*([^\\]]*)\\]` : `^\\[${d}\\s*([^\\]]*)\\]([\\s\\S]*?)\\[\\/${d}\\]`), o = e.match(a);
				if (!o) return;
				let c = "", l = "";
				if (s) {
					let [, e] = o;
					l = e;
				} else {
					let [, e, t] = o;
					l = e, c = t || "";
				}
				let u = i(l.trim());
				return {
					type: t,
					raw: o[0],
					content: c.trim(),
					attributes: u
				};
			}
		},
		renderMarkdown: (e) => {
			let t = "";
			r ? t = r(e) : e.content && e.content.length > 0 && (t = e.content.filter((e) => e.type === "text").map((e) => e.text).join(""));
			let n = u(e.attrs || {}), i = a(n), o = i ? ` ${i}` : "";
			return s ? `[${l}${o}]` : `[${l}${o}]${t}[/${l}]`;
		}
	};
}
function zG(e, t, n) {
	let r = e.split("\n"), i = [], a = "", o = 0, s = t.baseIndentSize || 2;
	for (; o < r.length;) {
		let e = r[o], c = e.match(t.itemPattern);
		if (!c) {
			if (i.length > 0) break;
			if (e.trim() === "") {
				o += 1, a = `${a}${e}
`;
				continue;
			}
			return;
		}
		let l = t.extractItemData(c), { indentLevel: u, mainContent: d } = l;
		a = `${a}${e}
`;
		let f = [d];
		for (o += 1; o < r.length;) {
			let e = r[o];
			if (e.trim() === "") {
				let t = r.slice(o + 1).findIndex((e) => e.trim() !== "");
				if (t === -1) break;
				if ((r[o + 1 + t].match(/^(\s*)/)?.[1]?.length || 0) > u) {
					f.push(e), a = `${a}${e}
`, o += 1;
					continue;
				}
				break;
			}
			if ((e.match(/^(\s*)/)?.[1]?.length || 0) > u) f.push(e), a = `${a}${e}
`, o += 1;
			else break;
		}
		let p, m = f.slice(1);
		if (m.length > 0) {
			let e = m.map((e) => e.slice(u + s)).join("\n");
			e.trim() && (p = t.customNestedParser ? t.customNestedParser(e) : n.blockTokens(e));
		}
		let h = t.createToken(l, p);
		i.push(h);
	}
	if (i.length !== 0) return {
		items: i,
		raw: a
	};
}
function BG(e, t, n, r) {
	if (!e || !Array.isArray(e.content)) return "";
	let i = typeof n == "function" ? n(r) : n, [a, ...o] = e.content, s = `${i}${t.renderChildren([a])}`;
	return o && o.length > 0 && o.forEach((e, n) => {
		let r = t.renderChild?.call(t, e, n + 1) ?? t.renderChildren([e]);
		if (r != null) {
			let n = r.split("\n").map((e) => e ? t.indent(e) : t.indent("")).join("\n");
			s += e.type === "paragraph" ? `

${n}` : `
${n}`;
		}
	}), s;
}
function VG(e, t) {
	let n = { ...e };
	return jG(e) && jG(t) && Object.keys(t).forEach((r) => {
		jG(t[r]) && jG(e[r]) ? n[r] = VG(e[r], t[r]) : n[r] = t[r];
	}), n;
}
function HG(e, t, n = {}) {
	let { state: r } = t, { doc: i, tr: a } = r, o = e;
	i.descendants((t, r) => {
		let i = a.mapping.map(r), s = a.mapping.map(r) + t.nodeSize, c = null;
		if (t.marks.forEach((e) => {
			if (e !== o) return !1;
			c = e;
		}), !c) return;
		let l = !1;
		if (Object.keys(n).forEach((e) => {
			n[e] !== c.attrs[e] && (l = !0);
		}), l) {
			let t = e.type.create({
				...e.attrs,
				...n
			});
			a.removeMark(i, s, e.type), a.addMark(i, s, t);
		}
	}), a.docChanged && t.view.dispatch(a);
}
var UG = class {
	constructor(e) {
		this.find = e.find, this.handler = e.handler, this.undoable = e.undoable ?? !0;
	}
}, WG = (e, t) => {
	if (cU(t)) return t.exec(e);
	let n = t(e);
	if (!n) return null;
	let r = [n.text];
	return r.index = n.index, r.input = e, r.data = n.data, n.replaceWith && (n.text.includes(n.replaceWith) || console.warn("[tiptap warn]: \"inputRuleMatch.replaceWith\" must be part of \"inputRuleMatch.text\"."), r.push(n.replaceWith)), r;
};
function GG(e) {
	let { editor: t, from: n, to: r, text: i, rules: a, plugin: o } = e, { view: s } = t;
	if (s.composing) return !1;
	let c = s.state.doc.resolve(n);
	if (c.parent.type.spec.code || (c.nodeBefore || c.nodeAfter)?.marks.find((e) => e.type.spec.code)) return !1;
	let l = !1, u = HW(c) + i;
	return a.forEach((e) => {
		if (l) return;
		let a = WG(u, e.find);
		if (!a) return;
		let c = s.state.tr, d = UH({
			state: s.state,
			transaction: c
		}), f = {
			from: n - (a[0].length - i.length),
			to: r
		}, { commands: p, chain: m, can: h } = new WH({
			editor: t,
			state: d
		});
		e.handler({
			state: d,
			range: f,
			match: a,
			commands: p,
			chain: m,
			can: h
		}) === null || !c.steps.length || (e.undoable && c.setMeta(o, {
			transform: c,
			from: n,
			to: r,
			text: i
		}), s.dispatch(c), l = !0);
	}), l;
}
function KG(e) {
	let { editor: t, rules: n } = e, r = new lL({
		state: {
			init() {
				return null;
			},
			apply(e, i, a) {
				let o = e.getMeta(r);
				if (o) return o;
				let s = e.getMeta("applyInputRules");
				return s && setTimeout(() => {
					let { text: e } = s;
					e = typeof e == "string" ? e : fW(X.from(e), a.schema);
					let { from: i } = s, o = i + e.length;
					GG({
						editor: t,
						from: i,
						to: o,
						text: e,
						rules: n,
						plugin: r
					});
				}), e.selectionSet || e.docChanged ? null : i;
			}
		},
		props: {
			handleTextInput(e, i, a, o) {
				return GG({
					editor: t,
					from: i,
					to: a,
					text: o,
					rules: n,
					plugin: r
				});
			},
			handleDOMEvents: { compositionend: (e) => (setTimeout(() => {
				let { $cursor: i } = e.state.selection;
				i && GG({
					editor: t,
					from: i.pos,
					to: i.pos,
					text: "",
					rules: n,
					plugin: r
				});
			}), !1) },
			handleKeyDown(e, i) {
				if (i.key !== "Enter") return !1;
				let { $cursor: a } = e.state.selection;
				return a ? GG({
					editor: t,
					from: a.pos,
					to: a.pos,
					text: "\n",
					rules: n,
					plugin: r
				}) : !1;
			}
		},
		isInputRules: !0
	});
	return r;
}
var qG = class {
	constructor(e = {}) {
		this.type = "extendable", this.parent = null, this.child = null, this.name = "", this.config = { name: this.name }, this.config = {
			...this.config,
			...e
		}, this.name = this.config.name;
	}
	get options() {
		return { ...mW(Q(this, "addOptions", { name: this.name })) };
	}
	get storage() {
		return { ...mW(Q(this, "addStorage", {
			name: this.name,
			options: this.options
		})) };
	}
	configure(e = {}) {
		let t = this.extend({
			...this.config,
			addOptions: () => VG(this.options, e)
		});
		return t.name = this.name, t.parent = this.parent, this.child = null, t;
	}
	extend(e = {}) {
		let t = new this.constructor({
			...this.config,
			...e
		});
		return t.parent = this, this.child = t, t.name = "name" in e ? e.name : t.parent.name, t;
	}
}, JG = class e extends qG {
	constructor() {
		super(...arguments), this.type = "mark";
	}
	static create(t = {}) {
		let n = typeof t == "function" ? t() : t;
		return new e(n);
	}
	static handleExit({ editor: e, mark: t }) {
		let { tr: n } = e.state, r = e.state.selection.$from;
		if (r.pos === r.end()) {
			let i = r.marks();
			if (!i.find((e) => e?.type.name === t.name)) return !1;
			let a = i.find((e) => e?.type.name === t.name);
			return a && n.removeStoredMark(a), n.insertText(" ", r.pos), e.view.dispatch(n), !0;
		}
		return !1;
	}
	configure(e) {
		return super.configure(e);
	}
	extend(e) {
		let t = typeof e == "function" ? e() : e;
		return super.extend(t);
	}
}, YG = class {
	constructor(e) {
		this.find = e.find, this.handler = e.handler;
	}
}, XG = (e, t, n) => {
	if (cU(t)) return [...e.matchAll(t)];
	let r = t(e, n);
	return r ? r.map((t) => {
		let n = [t.text];
		return n.index = t.index, n.input = e, n.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn("[tiptap warn]: \"pasteRuleMatch.replaceWith\" must be part of \"pasteRuleMatch.text\"."), n.push(t.replaceWith)), n;
	}) : [];
};
function ZG(e) {
	let { editor: t, state: n, from: r, to: i, rule: a, pasteEvent: o, dropEvent: s } = e, { commands: c, chain: l, can: u } = new WH({
		editor: t,
		state: n
	}), d = [];
	return n.doc.nodesBetween(r, i, (e, t) => {
		if (e.type?.spec?.code || !(e.isText || e.isTextblock || e.isInline)) return;
		let f = e.content?.size ?? e.nodeSize ?? 0, p = Math.max(r, t), m = Math.min(i, t + f);
		p >= m || XG(e.isText ? e.text || "" : e.textBetween(p - t, m - t, void 0, "￼"), a.find, o).forEach((e) => {
			if (e.index === void 0) return;
			let t = p + e.index + 1, r = t + e[0].length, i = {
				from: n.tr.mapping.map(t),
				to: n.tr.mapping.map(r)
			}, f = a.handler({
				state: n,
				range: i,
				match: e,
				commands: c,
				chain: l,
				can: u,
				pasteEvent: o,
				dropEvent: s
			});
			d.push(f);
		});
	}), d.every((e) => e !== null);
}
var QG = null, $G = (e) => {
	var t;
	let n = new ClipboardEvent("paste", { clipboardData: new DataTransfer() });
	return (t = n.clipboardData) == null || t.setData("text/html", e), n;
};
function eK(e) {
	let { editor: t, rules: n } = e, r = null, i = !1, a = !1, o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, s;
	try {
		s = typeof DragEvent < "u" ? new DragEvent("drop") : null;
	} catch {
		s = null;
	}
	let c = ({ state: e, from: n, to: r, rule: i, pasteEvt: a }) => {
		let c = e.tr, l = UH({
			state: e,
			transaction: c
		});
		if (!(!ZG({
			editor: t,
			state: l,
			from: Math.max(n - 1, 0),
			to: r.b - 1,
			rule: i,
			pasteEvent: a,
			dropEvent: s
		}) || !c.steps.length)) {
			try {
				s = typeof DragEvent < "u" ? new DragEvent("drop") : null;
			} catch {
				s = null;
			}
			return o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, c;
		}
	};
	return n.map((e) => new lL({
		view(e) {
			let n = (n) => {
				r = e.dom.parentElement?.contains(n.target) ? e.dom.parentElement : null, r && (QG = t);
			}, i = () => {
				QG &&= null;
			};
			return window.addEventListener("dragstart", n), window.addEventListener("dragend", i), { destroy() {
				window.removeEventListener("dragstart", n), window.removeEventListener("dragend", i);
			} };
		},
		props: { handleDOMEvents: {
			drop: (e, t) => {
				if (a = r === e.dom.parentElement, s = t, !a) {
					let e = QG;
					e?.isEditable && setTimeout(() => {
						let t = e.state.selection;
						t && e.commands.deleteRange({
							from: t.from,
							to: t.to
						});
					}, 10);
				}
				return !1;
			},
			paste: (e, t) => {
				let n = t.clipboardData?.getData("text/html");
				return o = t, i = !!n?.includes("data-pm-slice"), !1;
			}
		} },
		appendTransaction: (t, n, r) => {
			let s = t[0], l = s.getMeta("uiEvent") === "paste" && !i, u = s.getMeta("uiEvent") === "drop" && !a, d = s.getMeta("applyPasteRules"), f = !!d;
			if (!l && !u && !f) return;
			if (f) {
				let { text: t } = d;
				t = typeof t == "string" ? t : fW(X.from(t), r.schema);
				let { from: n } = d, i = n + t.length, a = $G(t);
				return c({
					rule: e,
					state: r,
					from: n,
					to: { b: i },
					pasteEvt: a
				});
			}
			let p = n.doc.content.findDiffStart(r.doc.content), m = n.doc.content.findDiffEnd(r.doc.content);
			if (!(!kG(p) || !m || p === m.b)) return c({
				rule: e,
				state: r,
				from: p,
				to: m,
				pasteEvt: o
			});
		}
	}));
}
var tK = class {
	constructor(e, t) {
		this.splittableMarks = [], this.nonClearableMarks = [], this.editor = t, this.baseExtensions = e, this.extensions = kW(e), this.schema = EW(this.extensions, t), this.setupExtensions();
	}
	get commands() {
		return this.extensions.reduce((e, t) => {
			let n = Q(t, "addCommands", {
				name: t.name,
				options: t.options,
				storage: this.editor.extensionStorage[t.name],
				editor: this.editor,
				type: BW(t.name, this.schema)
			});
			return n ? {
				...e,
				...n()
			} : e;
		}, {});
	}
	get plugins() {
		let { editor: e } = this;
		return OW([...this.extensions].reverse()).flatMap((t) => {
			let n = {
				name: t.name,
				options: t.options,
				storage: this.editor.extensionStorage[t.name],
				editor: e,
				type: BW(t.name, this.schema)
			}, r = [], i = Q(t, "addKeyboardShortcuts", n), a = {};
			if (t.type === "mark" && Q(t, "exitable", n) && (a.ArrowRight = () => JG.handleExit({
				editor: e,
				mark: t
			})), i) {
				let t = Object.fromEntries(Object.entries(i()).map(([t, n]) => [t, () => n({ editor: e })]));
				a = {
					...a,
					...t
				};
			}
			let o = zH(a);
			r.push(o);
			let s = Q(t, "addInputRules", n);
			if (qW(t, e.options.enableInputRules) && s) {
				let t = s();
				if (t && t.length) {
					let n = KG({
						editor: e,
						rules: t
					}), i = Array.isArray(n) ? n : [n];
					r.push(...i);
				}
			}
			let c = Q(t, "addPasteRules", n);
			if (qW(t, e.options.enablePasteRules) && c) {
				let t = c();
				if (t && t.length) {
					let n = eK({
						editor: e,
						rules: t
					});
					r.push(...n);
				}
			}
			let l = Q(t, "addProseMirrorPlugins", n);
			if (l) {
				let e = l();
				r.push(...e);
			}
			return r;
		});
	}
	get attributes() {
		return _W(this.extensions);
	}
	get nodeViews() {
		let { editor: e } = this, { nodeExtensions: t } = gW(this.extensions);
		return Object.fromEntries(t.filter((e) => !!Q(e, "addNodeView")).map((t) => {
			let n = this.attributes.filter((e) => e.type === t.name), r = Q(t, "addNodeView", {
				name: t.name,
				options: t.options,
				storage: this.editor.extensionStorage[t.name],
				editor: e,
				type: $H(t.name, this.schema)
			});
			if (!r) return [];
			let i = r();
			return i ? [t.name, (r, a, o, s, c) => {
				let l = xW(r, n);
				return i({
					node: r,
					view: a,
					getPos: o,
					decorations: s,
					innerDecorations: c,
					editor: e,
					extension: t,
					HTMLAttributes: l
				});
			}] : [];
		}));
	}
	dispatchTransaction(e) {
		let { editor: t } = this;
		return OW([...this.extensions].reverse()).reduceRight((e, n) => {
			let r = {
				name: n.name,
				options: n.options,
				storage: this.editor.extensionStorage[n.name],
				editor: t,
				type: BW(n.name, this.schema)
			}, i = Q(n, "dispatchTransaction", r);
			return i ? (t) => {
				i.call(r, {
					transaction: t,
					next: e
				});
			} : e;
		}, e);
	}
	transformPastedHTML(e) {
		let { editor: t } = this;
		return OW([...this.extensions]).reduce((e, n) => {
			let r = {
				name: n.name,
				options: n.options,
				storage: this.editor.extensionStorage[n.name],
				editor: t,
				type: BW(n.name, this.schema)
			}, i = Q(n, "transformPastedHTML", r);
			return i ? (t, n) => {
				let a = e(t, n);
				return i.call(r, a);
			} : e;
		}, e || ((e) => e));
	}
	get markViews() {
		let { editor: e } = this, { markExtensions: t } = gW(this.extensions);
		return Object.fromEntries(t.filter((e) => !!Q(e, "addMarkView")).map((t) => {
			let n = this.attributes.filter((e) => e.type === t.name), r = Q(t, "addMarkView", {
				name: t.name,
				options: t.options,
				storage: this.editor.extensionStorage[t.name],
				editor: e,
				type: pU(t.name, this.schema)
			});
			return r ? [t.name, (i, a, o) => {
				let s = xW(i, n);
				return r()({
					mark: i,
					view: a,
					inline: o,
					editor: e,
					extension: t,
					HTMLAttributes: s,
					updateAttributes: (t) => {
						HG(i, e, t);
					}
				});
			}] : [];
		}));
	}
	destroy() {
		this.extensions.forEach((e) => {
			let t = e;
			for (; t.parent;) {
				let e = t.parent;
				e.child === t && (e.child = null), t = e;
			}
		}), this.extensions = [], this.baseExtensions = [], this.schema = null, this.editor = null;
	}
	setupExtensions() {
		let e = this.extensions;
		this.editor.extensionStorage = Object.fromEntries(e.map((e) => [e.name, e.storage])), e.forEach((e) => {
			let t = {
				name: e.name,
				options: e.options,
				storage: this.editor.extensionStorage[e.name],
				editor: this.editor,
				type: BW(e.name, this.schema)
			};
			e.type === "mark" && ((mW(Q(e, "keepOnSplit", t)) ?? !0) && this.splittableMarks.push(e.name), (mW(Q(e, "clearable", t)) ?? !0) || this.nonClearableMarks.push(e.name));
			let n = Q(e, "onBeforeCreate", t), r = Q(e, "onCreate", t), i = Q(e, "onUpdate", t), a = Q(e, "onSelectionUpdate", t), o = Q(e, "onTransaction", t), s = Q(e, "onFocus", t), c = Q(e, "onBlur", t), l = Q(e, "onDestroy", t);
			n && this.editor.on("beforeCreate", n), r && this.editor.on("create", r), i && this.editor.on("update", i), a && this.editor.on("selectionUpdate", a), o && this.editor.on("transaction", o), s && this.editor.on("focus", s), c && this.editor.on("blur", c), l && this.editor.on("destroy", l);
		});
	}
};
tK.resolve = kW, tK.sort = OW, tK.flatten = dW, HH({}, {
	ClipboardTextSerializer: () => rK,
	Commands: () => iK,
	Delete: () => aK,
	Drop: () => oK,
	Editable: () => sK,
	FocusEvents: () => lK,
	Keymap: () => uK,
	Paste: () => dK,
	Tabindex: () => fK,
	TextDirection: () => pK,
	focusEventsPluginKey: () => cK
});
var nK = class e extends qG {
	constructor() {
		super(...arguments), this.type = "extension";
	}
	static create(t = {}) {
		let n = typeof t == "function" ? t() : t;
		return new e(n);
	}
	configure(e) {
		return super.configure(e);
	}
	extend(e) {
		let t = typeof e == "function" ? e() : e;
		return super.extend(t);
	}
}, rK = nK.create({
	name: "clipboardTextSerializer",
	addOptions() {
		return { blockSeparator: void 0 };
	},
	addProseMirrorPlugins() {
		return [new lL({
			key: new fL("clipboardTextSerializer"),
			props: { clipboardTextSerializer: () => {
				let { editor: e } = this, { state: t, schema: n } = e, { doc: r, selection: i } = t, a = MW(n), { blockSeparator: o } = this.options, s = {
					...o === void 0 ? {} : { blockSeparator: o },
					textSerializers: a
				};
				return [...i.ranges].sort((e, t) => e.$from.pos - t.$from.pos).map(({ $from: e, $to: t }) => AW(r, {
					from: e.pos,
					to: t.pos
				}, s)).join(o ?? "\n\n");
			} }
		})];
	}
}), iK = nK.create({
	name: "commands",
	addCommands() {
		return { ...GH };
	}
}), aK = nK.create({
	name: "delete",
	onUpdate({ transaction: e, appendedTransactions: t }) {
		let n = () => {
			var n;
			if (((n = this.editor.options.coreExtensionOptions?.delete)?.filterTransaction)?.call(n, e) ?? e.getMeta("y-sync$")) return;
			let r = oW(e.before, [e, ...t]);
			LW(r).forEach((t) => {
				r.mapping.mapResult(t.oldRange.from).deletedAfter && r.mapping.mapResult(t.oldRange.to).deletedBefore && r.before.nodesBetween(t.oldRange.from, t.oldRange.to, (n, i) => {
					let a = i + n.nodeSize - 2, o = t.oldRange.from <= i && a <= t.oldRange.to;
					this.editor.emit("delete", {
						type: "node",
						node: n,
						from: i,
						to: a,
						newFrom: r.mapping.map(i),
						newTo: r.mapping.map(a),
						deletedRange: t.oldRange,
						newRange: t.newRange,
						partial: !o,
						editor: this.editor,
						transaction: e,
						combinedTransform: r
					});
				});
			});
			let i = r.mapping;
			r.steps.forEach((t, n) => {
				if (t instanceof WF) {
					let a = i.slice(n).map(t.from, -1), o = i.slice(n).map(t.to), s = i.invert().map(a, -1), c = i.invert().map(o), l = a > 0 && r.doc.nodeAt(a - 1)?.marks.some((e) => e.eq(t.mark)), u = r.doc.nodeAt(o)?.marks.some((e) => e.eq(t.mark));
					this.editor.emit("delete", {
						type: "mark",
						mark: t.mark,
						from: t.from,
						to: t.to,
						deletedRange: {
							from: s,
							to: c
						},
						newRange: {
							from: a,
							to: o
						},
						partial: !!(u || l),
						editor: this.editor,
						transaction: e,
						combinedTransform: r
					});
				}
			});
		};
		this.editor.options.coreExtensionOptions?.delete?.async ?? !0 ? setTimeout(n, 0) : n();
	}
}), oK = nK.create({
	name: "drop",
	addProseMirrorPlugins() {
		return [new lL({
			key: new fL("tiptapDrop"),
			props: { handleDrop: (e, t, n, r) => {
				this.editor.emit("drop", {
					editor: this.editor,
					event: t,
					slice: n,
					moved: r
				});
			} }
		})];
	}
}), sK = nK.create({
	name: "editable",
	addProseMirrorPlugins() {
		return [new lL({
			key: new fL("editable"),
			props: { editable: () => this.editor.options.editable }
		})];
	}
}), cK = new fL("focusEvents"), lK = nK.create({
	name: "focusEvents",
	addProseMirrorPlugins() {
		let { editor: e } = this;
		return [new lL({
			key: cK,
			props: { handleDOMEvents: {
				focus: (t, n) => {
					e.isFocused = !0;
					let r = e.state.tr.setMeta("focus", { event: n }).setMeta("addToHistory", !1);
					return t.dispatch(r), !1;
				},
				blur: (t, n) => {
					e.isFocused = !1;
					let r = e.state.tr.setMeta("blur", { event: n }).setMeta("addToHistory", !1);
					return t.dispatch(r), !1;
				}
			} }
		})];
	}
}), uK = nK.create({
	name: "keymap",
	addKeyboardShortcuts() {
		let e = () => this.editor.commands.first(({ commands: e }) => [
			() => e.undoInputRule(),
			() => e.command(({ tr: t }) => {
				let { selection: n, doc: r } = t, { empty: i, $anchor: a } = n, { pos: o, parent: s } = a, c = a.parent.isTextblock && o > 0 ? t.doc.resolve(o - 1) : a, l = c.parent.type.spec.isolating, u = a.pos - a.parentOffset, d = l && c.parent.childCount === 1 ? u === a.pos : VI.atStart(r).from === o;
				return !i || !s.type.isTextblock || s.textContent.length || !d || d && a.parent.type.name === "paragraph" ? !1 : e.clearNodes();
			}),
			() => e.deleteSelection(),
			() => e.joinBackward(),
			() => e.selectNodeBackward()
		]), t = () => this.editor.commands.first(({ commands: e }) => [
			() => e.deleteSelection(),
			() => e.deleteCurrentNode(),
			() => e.joinForward(),
			() => e.selectNodeForward()
		]), n = {
			Enter: () => this.editor.commands.first(({ commands: e }) => [
				() => e.newlineInCode(),
				() => e.createParagraphNear(),
				() => e.liftEmptyBlock(),
				() => e.splitBlock()
			]),
			"Mod-Enter": () => this.editor.commands.exitCode(),
			Backspace: e,
			"Mod-Backspace": e,
			"Shift-Backspace": e,
			Delete: t,
			"Mod-Delete": t,
			"Mod-a": () => this.editor.commands.selectAll()
		}, r = { ...n }, i = {
			...n,
			"Ctrl-h": e,
			"Alt-Backspace": e,
			"Ctrl-d": t,
			"Ctrl-Alt-Backspace": t,
			"Alt-Delete": t,
			"Alt-d": t,
			"Ctrl-a": () => this.editor.commands.selectTextblockStart(),
			"Ctrl-e": () => this.editor.commands.selectTextblockEnd()
		};
		return bU() || zU() ? i : r;
	},
	addProseMirrorPlugins() {
		return [new lL({
			key: new fL("clearDocument"),
			appendTransaction: (e, t, n) => {
				if (e.some((e) => e.getMeta("composition"))) return;
				let r = e.some((e) => e.docChanged) && !t.doc.eq(n.doc), i = e.some((e) => e.getMeta("preventClearDocument"));
				if (!r || i) return;
				let { empty: a, from: o, to: s } = t.selection, c = VI.atStart(t.doc).from, l = VI.atEnd(t.doc).to;
				if (a || o !== c || s !== l || !YW(n.doc)) return;
				let u = n.tr, d = UH({
					state: n,
					transaction: u
				}), { commands: f } = new WH({
					editor: this.editor,
					state: d
				});
				if (f.clearNodes(), u.steps.length) return u;
			}
		})];
	}
}), dK = nK.create({
	name: "paste",
	addProseMirrorPlugins() {
		return [new lL({
			key: new fL("tiptapPaste"),
			props: { handlePaste: (e, t, n) => {
				this.editor.emit("paste", {
					editor: this.editor,
					event: t,
					slice: n
				});
			} }
		})];
	}
}), fK = nK.create({
	name: "tabindex",
	addOptions() {
		return { value: void 0 };
	},
	addProseMirrorPlugins() {
		return [new lL({
			key: new fL("tabindex"),
			props: { attributes: () => !this.editor.isEditable && this.options.value === void 0 ? {} : { tabindex: this.options.value ?? "0" } }
		})];
	}
}), pK = nK.create({
	name: "textDirection",
	addOptions() {
		return { direction: void 0 };
	},
	addGlobalAttributes() {
		if (!this.options.direction) return [];
		let { nodeExtensions: e } = gW(this.extensions);
		return [{
			types: e.filter((e) => e.name !== "text").map((e) => e.name),
			attributes: { dir: {
				default: this.options.direction,
				parseHTML: (e) => {
					let t = e.getAttribute("dir");
					return t && (t === "ltr" || t === "rtl" || t === "auto") ? t : this.options.direction;
				},
				renderHTML: (e) => e.dir ? { dir: e.dir } : {}
			} }
		}];
	},
	addProseMirrorPlugins() {
		return [new lL({
			key: new fL("textDirection"),
			props: { attributes: () => {
				let e = this.options.direction;
				return e ? { dir: e } : {};
			} }
		})];
	}
}), mK = class e {
	constructor(e, t, n = !1, r = null) {
		this.currentNode = null, this.actualDepth = null, this.isBlock = n, this.resolvedPos = e, this.editor = t, this.currentNode = r;
	}
	get name() {
		return this.node.type.name;
	}
	get node() {
		return this.currentNode || this.resolvedPos.node();
	}
	get element() {
		return this.editor.view.domAtPos(this.pos).node;
	}
	get depth() {
		return this.actualDepth ?? this.resolvedPos.depth;
	}
	get pos() {
		return this.resolvedPos.pos;
	}
	get content() {
		return this.node.content;
	}
	set content(e) {
		let t = this.from, n = this.to;
		if (this.isBlock) {
			if (this.content.size === 0) {
				console.error(`You can\u2019t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
				return;
			}
			t = this.from + 1, n = this.to - 1;
		}
		this.editor.commands.insertContentAt({
			from: t,
			to: n
		}, e);
	}
	get attributes() {
		return this.node.attrs;
	}
	get textContent() {
		return this.node.textContent;
	}
	get size() {
		return this.node.nodeSize;
	}
	get from() {
		return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
	}
	get range() {
		return {
			from: this.from,
			to: this.to
		};
	}
	get to() {
		return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + +!this.node.isText;
	}
	get parent() {
		if (this.depth === 0) return null;
		let t = this.resolvedPos.start(this.resolvedPos.depth - 1), n = this.resolvedPos.doc.resolve(t);
		return new e(n, this.editor);
	}
	get before() {
		let t = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
		return t.depth !== this.depth && (t = this.resolvedPos.doc.resolve(this.from - 3)), new e(t, this.editor);
	}
	get after() {
		let t = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
		return t.depth !== this.depth && (t = this.resolvedPos.doc.resolve(this.to + 3)), new e(t, this.editor);
	}
	get children() {
		let t = [];
		return this.node.content.forEach((n, r) => {
			let i = n.isBlock && !n.isTextblock, a = n.isAtom && !n.isText, o = n.isInline, s = this.pos + r + +!a;
			if (s < 0 || s > this.resolvedPos.doc.nodeSize - 2) return;
			let c = this.resolvedPos.doc.resolve(s);
			if (!i && !o && c.depth <= this.depth) return;
			let l = new e(c, this.editor, i, i || o ? n : null);
			i && (l.actualDepth = this.depth + 1), t.push(l);
		}), t;
	}
	get firstChild() {
		return this.children[0] || null;
	}
	get lastChild() {
		let e = this.children;
		return e[e.length - 1] || null;
	}
	closest(e, t = {}) {
		let n = null, r = this.parent;
		for (; r && !n;) {
			if (r.node.type.name === e) {
				if (Object.keys(t).length > 0) {
					let e = r.node.attrs, n = Object.keys(t);
					for (let r = 0; r < n.length; r += 1) {
						let i = n[r];
						if (e[i] !== t[i]) break;
					}
				} else n = r;
			}
			r = r.parent;
		}
		return n;
	}
	querySelector(e, t = {}) {
		return this.querySelectorAll(e, t, !0)[0] || null;
	}
	querySelectorAll(e, t = {}, n = !1) {
		let r = [];
		if (!this.children || this.children.length === 0) return r;
		let i = Object.keys(t);
		return this.children.forEach((a) => {
			n && r.length > 0 || (a.node.type.name === e && i.every((e) => t[e] === a.node.attrs[e]) && r.push(a), !(n && r.length > 0) && (r = r.concat(a.querySelectorAll(e, t, n))));
		}), r;
	}
	setAttribute(e) {
		let { tr: t } = this.editor.state;
		t.setNodeMarkup(this.from, void 0, {
			...this.node.attrs,
			...e
		}), this.editor.view.dispatch(t);
	}
}, hK = ".ProseMirror {\n  position: relative;\n}\n\n.ProseMirror {\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  white-space: break-spaces;\n  -webkit-font-variant-ligatures: none;\n  font-variant-ligatures: none;\n  font-feature-settings: \"liga\" 0; /* the above doesn't seem to work in Edge */\n}\n\n.ProseMirror [contenteditable=\"false\"] {\n  white-space: normal;\n}\n\n.ProseMirror [contenteditable=\"false\"] [contenteditable=\"true\"] {\n  white-space: pre-wrap;\n}\n\n.ProseMirror pre {\n  white-space: pre-wrap;\n}\n\nimg.ProseMirror-separator {\n  display: inline !important;\n  border: none !important;\n  margin: 0 !important;\n  width: 0 !important;\n  height: 0 !important;\n}\n\n.ProseMirror-gapcursor {\n  display: none;\n  pointer-events: none;\n  position: absolute;\n  margin: 0;\n}\n\n.ProseMirror-gapcursor:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: -2px;\n  width: 20px;\n  border-top: 1px solid black;\n  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;\n}\n\n@keyframes ProseMirror-cursor-blink {\n  to {\n    visibility: hidden;\n  }\n}\n\n.ProseMirror-hideselection *::selection {\n  background: transparent;\n}\n\n.ProseMirror-hideselection *::-moz-selection {\n  background: transparent;\n}\n\n.ProseMirror-hideselection * {\n  caret-color: transparent;\n}\n\n.ProseMirror-focused .ProseMirror-gapcursor {\n  display: block;\n}", gK = class extends DG {
	constructor(e = {}) {
		super(), this.css = null, this.className = "tiptap", this.editorView = null, this.isFocused = !1, this.destroyed = !1, this.isInitialized = !1, this.extensionStorage = {}, this.instanceId = Math.random().toString(36).slice(2, 9), this.options = {
			element: typeof document < "u" ? document.createElement("div") : null,
			content: "",
			injectCSS: !0,
			injectNonce: void 0,
			extensions: [],
			autofocus: !1,
			editable: !0,
			textDirection: void 0,
			editorProps: {},
			parseOptions: {},
			coreExtensionOptions: {},
			enableInputRules: !0,
			enablePasteRules: !0,
			enableCoreExtensions: !0,
			enableContentCheck: !1,
			emitContentError: !1,
			onBeforeCreate: () => null,
			onCreate: () => null,
			onMount: () => null,
			onUnmount: () => null,
			onUpdate: () => null,
			onSelectionUpdate: () => null,
			onTransaction: () => null,
			onFocus: () => null,
			onBlur: () => null,
			onDestroy: () => null,
			onContentError: ({ error: e }) => {
				throw e;
			},
			onPaste: () => null,
			onDrop: () => null,
			onDelete: () => null,
			enableExtensionDispatchTransaction: !0
		}, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.utils = {
			getUpdatedPosition: QW,
			createMappablePosition: $W
		}, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("mount", this.options.onMount), this.on("unmount", this.options.onUnmount), this.on("contentError", this.options.onContentError), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: e, slice: t, moved: n }) => this.options.onDrop(e, t, n)), this.on("paste", ({ event: e, slice: t }) => this.options.onPaste(e, t)), this.on("delete", this.options.onDelete);
		let t = this.createDoc(), n = vU(t, this.options.autofocus);
		this.editorState = sL.create({
			doc: t,
			schema: this.schema,
			selection: n || void 0
		}), this.options.element && this.mount(this.options.element);
	}
	mount(e) {
		if (typeof document > "u") throw Error("[tiptap error]: The editor cannot be mounted because there is no 'document' defined in this environment.");
		this.createView(e), this.emit("mount", { editor: this }), this.css && !document.head.contains(this.css) && document.head.appendChild(this.css), window.setTimeout(() => {
			this.isDestroyed || (this.options.autofocus !== !1 && this.options.autofocus !== null && this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
		}, 0);
	}
	unmount() {
		if (this.editorView) {
			let e = this.editorView.dom;
			e?.editor && delete e.editor, this.editorView.destroy();
		}
		if (this.editorView = null, this.isInitialized = !1, this.css && !document.querySelectorAll(`.${this.className}`).length) try {
			typeof this.css.remove == "function" ? this.css.remove() : this.css.parentNode && this.css.parentNode.removeChild(this.css);
		} catch (e) {
			console.warn("Failed to remove CSS element:", e);
		}
		this.css = null, this.emit("unmount", { editor: this });
	}
	get storage() {
		return this.extensionStorage;
	}
	get commands() {
		return this.commandManager.commands;
	}
	chain() {
		return this.commandManager.chain();
	}
	can() {
		return this.commandManager.can();
	}
	injectCSS() {
		this.options.injectCSS && typeof document < "u" && (this.css = OG(hK, this.options.injectNonce));
	}
	setOptions(e = {}) {
		this.options = {
			...this.options,
			...e
		}, !(!this.editorView || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
	}
	setEditable(e, t = !0) {
		this.setOptions({ editable: e }), t && this.emit("update", {
			editor: this,
			transaction: this.state.tr,
			appendedTransactions: []
		});
	}
	get isEditable() {
		return this.options.editable && this.view && this.view.editable;
	}
	get view() {
		return this.editorView ? this.editorView : new Proxy({
			state: this.editorState,
			updateState: (e) => {
				this.editorState = e;
			},
			dispatch: (e) => {
				this.dispatchTransaction(e);
			},
			composing: !1,
			dragging: null,
			editable: !0,
			isDestroyed: !1
		}, { get: (e, t) => {
			if (this.editorView) return this.editorView[t];
			if (t === "state") return this.editorState;
			if (t in e) return Reflect.get(e, t);
			throw Error(`[tiptap error]: The editor view is not available. Cannot access view['${t}']. The editor may not be mounted yet.`);
		} });
	}
	get state() {
		return this.editorView && (this.editorState = this.view.state), this.editorState;
	}
	registerPlugin(e, t) {
		let n = pW(t) ? t(e, [...this.state.plugins]) : [...this.state.plugins, e], r = this.state.reconfigure({ plugins: n });
		return this.view.updateState(r), r;
	}
	unregisterPlugin(e) {
		if (this.isDestroyed) return;
		let t = this.state.plugins, n = t;
		if ([].concat(e).forEach((e) => {
			let t = typeof e == "string" ? `${e}$` : e.key;
			n = n.filter((e) => !e.key.startsWith(t));
		}), t.length === n.length) return;
		let r = this.state.reconfigure({ plugins: n });
		return this.view.updateState(r), r;
	}
	createExtensionManager() {
		let e = [...this.options.enableCoreExtensions ? [
			sK,
			rK.configure({ blockSeparator: this.options.coreExtensionOptions?.clipboardTextSerializer?.blockSeparator }),
			iK,
			lK,
			uK,
			fK.configure({ value: this.options.coreExtensionOptions?.tabindex?.value }),
			oK,
			dK,
			aK,
			pK.configure({ direction: this.options.textDirection })
		].filter((e) => typeof this.options.enableCoreExtensions != "object" || this.options.enableCoreExtensions[e.name] !== !1) : [], ...this.options.extensions].filter((e) => [
			"extension",
			"node",
			"mark"
		].includes(e?.type));
		this.extensionManager = new tK(e, this);
	}
	createCommandManager() {
		this.commandManager = new WH({ editor: this });
	}
	createSchema() {
		this.schema = this.extensionManager.schema;
	}
	createDoc() {
		let e;
		try {
			e = rW(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
		} catch (t) {
			if (!(t instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(t.message)) throw t;
			this.emit("contentError", {
				editor: this,
				error: t,
				disableCollaboration: () => {
					"collaboration" in this.storage && typeof this.storage.collaboration == "object" && this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((e) => e.name !== "collaboration"), this.createExtensionManager();
				}
			}), e = rW(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: !1 });
		}
		return e;
	}
	createView(e) {
		let { editorProps: t, enableExtensionDispatchTransaction: n } = this.options, r = t.dispatchTransaction || this.dispatchTransaction.bind(this), i = n ? this.extensionManager.dispatchTransaction(r) : r, a = t.transformPastedHTML, o = this.extensionManager.transformPastedHTML(a);
		this.editorView = new yH(e, {
			...t,
			attributes: {
				role: "textbox",
				...t?.attributes
			},
			dispatchTransaction: i,
			transformPastedHTML: o,
			state: this.editorState,
			markViews: this.extensionManager.markViews,
			nodeViews: this.extensionManager.nodeViews
		});
		let s = this.state.reconfigure({ plugins: this.extensionManager.plugins });
		this.view.updateState(s), this.prependClass(), this.injectCSS();
		let c = this.view.dom;
		c.editor = this;
	}
	createNodeViews() {
		this.view.isDestroyed || this.view.setProps({
			markViews: this.extensionManager.markViews,
			nodeViews: this.extensionManager.nodeViews
		});
	}
	prependClass() {
		this.view.dom.className = `${this.className} ${this.view.dom.className}`;
	}
	captureTransaction(e) {
		this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
		let t = this.capturedTransaction;
		return this.capturedTransaction = null, t;
	}
	dispatchTransaction(e) {
		if (this.view.isDestroyed) return;
		if (this.isCapturingTransaction) {
			if (!this.capturedTransaction) {
				this.capturedTransaction = e;
				return;
			}
			e.steps.forEach((e) => this.capturedTransaction?.step(e));
			return;
		}
		let { state: t, transactions: n } = this.state.applyTransaction(e), r = !this.state.selection.eq(t.selection), i = n.includes(e), a = this.state;
		if (this.emit("beforeTransaction", {
			editor: this,
			transaction: e,
			nextState: t
		}), !i) return;
		this.view.updateState(t), this.emit("transaction", {
			editor: this,
			transaction: e,
			appendedTransactions: n.slice(1)
		}), r && this.emit("selectionUpdate", {
			editor: this,
			transaction: e
		});
		let o = n.findLast((e) => e.getMeta("focus") || e.getMeta("blur")), s = o?.getMeta("focus"), c = o?.getMeta("blur");
		s && this.emit("focus", {
			editor: this,
			event: s.event,
			transaction: o
		}), c && this.emit("blur", {
			editor: this,
			event: c.event,
			transaction: o
		}), !(e.getMeta("preventUpdate") || !n.some((e) => e.docChanged) || a.doc.eq(t.doc)) && this.emit("update", {
			editor: this,
			transaction: e,
			appendedTransactions: n.slice(1)
		});
	}
	getAttributes(e) {
		return PW(this.state, e);
	}
	isActive(e, t) {
		let n = typeof e == "string" ? e : null, r = typeof e == "string" ? t : e;
		return WW(this.state, n, r);
	}
	getJSON() {
		return this.state.doc.toJSON();
	}
	getHTML() {
		return fW(this.state.doc.content, this.schema);
	}
	getText(e) {
		let { blockSeparator: t = "\n\n", textSerializers: n = {} } = e || {};
		return jW(this.state.doc, {
			blockSeparator: t,
			textSerializers: {
				...MW(this.schema),
				...n
			}
		});
	}
	get isEmpty() {
		return YW(this.state.doc);
	}
	destroy() {
		this.destroyed || (this.destroyed = !0, this.emit("destroy"), this.unmount(), this.removeAllListeners(), this.extensionManager.destroy(), this.extensionManager = null, this.schema = null, this.commandManager = null, this.extensionStorage = {});
	}
	get isDestroyed() {
		return this.editorView?.isDestroyed ?? !0;
	}
	$node(e, t) {
		return this.$doc?.querySelector(e, t) || null;
	}
	$nodes(e, t) {
		return this.$doc?.querySelectorAll(e, t) || null;
	}
	$pos(e) {
		let t = this.state.doc.resolve(e), n = e > 0 && t.nodeAfter && !t.nodeAfter.isText ? t.nodeAfter : null;
		return new mK(t, this, !1, n);
	}
	get $doc() {
		return this.$pos(0);
	}
};
function _K(e) {
	return new UG({
		find: e.find,
		handler: ({ state: t, range: n, match: r }) => {
			let i = mW(e.getAttributes, void 0, r);
			if (i === !1 || i === null) return null;
			let { tr: a } = t, o = r[r.length - 1], s = r[0];
			if (o) {
				let r = s.search(/\S/), c = n.from + s.indexOf(o), l = c + o.length;
				if (RW(n.from, n.to, t.doc).filter((t) => t.mark.type.excluded.find((n) => n === e.type && n !== t.mark.type)).filter((e) => e.to > c).length) return null;
				l < n.to && a.delete(l, n.to), c > n.from && a.delete(n.from + r, c);
				let u = n.from + r + o.length;
				a.addMark(n.from + r, u, e.type.create(i || {})), a.removeStoredMark(e.type);
			}
		},
		undoable: e.undoable
	});
}
function vK(e) {
	return new UG({
		find: e.find,
		handler: ({ state: t, range: n, match: r }) => {
			let i = mW(e.getAttributes, void 0, r) || {}, { tr: a } = t, o = n.from, s = n.to, c = e.type.create(i);
			if (r[1]) {
				let e = o + r[0].lastIndexOf(r[1]);
				e > s ? e = s : s = e + r[1].length;
				let t = r[0][r[0].length - 1];
				a.insertText(t, o + r[0].length - 1), a.replaceWith(e, s, c);
			} else if (r[0]) {
				let t = e.type.isInline ? o : o - 1;
				a.insert(t, e.type.create(i)).delete(a.mapping.map(o), a.mapping.map(s));
			}
			a.scrollIntoView();
		},
		undoable: e.undoable
	});
}
function yK(e) {
	return new UG({
		find: e.find,
		handler: ({ state: t, range: n, match: r }) => {
			let i = t.doc.resolve(n.from), a = mW(e.getAttributes, void 0, r) || {};
			if (!i.node(-1).canReplaceWith(i.index(-1), i.indexAfter(-1), e.type)) return null;
			t.tr.delete(n.from, n.to).setBlockType(n.from, n.from, e.type, a);
		},
		undoable: e.undoable
	});
}
function bK(e) {
	return new UG({
		find: e.find,
		handler: ({ state: t, range: n, match: r, chain: i }) => {
			let a = mW(e.getAttributes, void 0, r) || {}, o = t.tr.delete(n.from, n.to), s = o.doc.resolve(n.from).blockRange(), c = s && nI(s, e.type, a);
			if (!c) return null;
			if (o.wrap(s, c), e.keepMarks && e.editor) {
				let { selection: n, storedMarks: r } = t, { splittableMarks: i } = e.editor.extensionManager, a = r || n.$to.parentOffset && n.$from.marks();
				if (a) {
					let e = a.filter((e) => i.includes(e.type.name));
					o.ensureMarks(e);
				}
			}
			if (e.keepAttributes) {
				let t = e.type.name === "bulletList" || e.type.name === "orderedList" ? "listItem" : "taskList";
				i().updateAttributes(t, a).run();
			}
			let l = o.doc.resolve(n.from - 1).nodeBefore;
			l && l.type === e.type && mI(o.doc, n.from - 1) && (!e.joinPredicate || e.joinPredicate(r, l)) && o.join(n.from - 1);
		},
		undoable: e.undoable
	});
}
var xK = (e) => "touches" in e, SK = class {
	constructor(e) {
		this.directions = [
			"bottom-left",
			"bottom-right",
			"top-left",
			"top-right"
		], this.minSize = {
			height: 8,
			width: 8
		}, this.preserveAspectRatio = !1, this.classNames = {
			container: "",
			wrapper: "",
			handle: "",
			resizing: ""
		}, this.initialWidth = 0, this.initialHeight = 0, this.aspectRatio = 1, this.isResizing = !1, this.activeHandle = null, this.startX = 0, this.startY = 0, this.startWidth = 0, this.startHeight = 0, this.isShiftKeyPressed = !1, this.lastEditableState = void 0, this.handleMap = /* @__PURE__ */ new Map(), this.handleMouseMove = (e) => {
			if (!this.isResizing || !this.activeHandle) return;
			let t = e.clientX - this.startX, n = e.clientY - this.startY;
			this.handleResize(t, n);
		}, this.handleTouchMove = (e) => {
			if (!this.isResizing || !this.activeHandle) return;
			let t = e.touches[0];
			if (!t) return;
			let n = t.clientX - this.startX, r = t.clientY - this.startY;
			this.handleResize(n, r);
		}, this.handleMouseUp = () => {
			if (!this.isResizing) return;
			let e = this.element.offsetWidth, t = this.element.offsetHeight;
			this.onCommit(e, t), this.isResizing = !1, this.activeHandle = null, this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp);
		}, this.handleKeyDown = (e) => {
			e.key === "Shift" && (this.isShiftKeyPressed = !0);
		}, this.handleKeyUp = (e) => {
			e.key === "Shift" && (this.isShiftKeyPressed = !1);
		}, this.node = e.node, this.editor = e.editor, this.element = e.element, this.element.draggable = !1, this.contentElement = e.contentElement, this.getPos = e.getPos, this.onResize = e.onResize, this.onCommit = e.onCommit, this.onUpdate = e.onUpdate, e.options?.min && (this.minSize = {
			...this.minSize,
			...e.options.min
		}), e.options?.max && (this.maxSize = e.options.max), e?.options?.directions && (this.directions = e.options.directions), e.options?.preserveAspectRatio && (this.preserveAspectRatio = e.options.preserveAspectRatio), e.options?.className && (this.classNames = {
			container: e.options.className.container || "",
			wrapper: e.options.className.wrapper || "",
			handle: e.options.className.handle || "",
			resizing: e.options.className.resizing || ""
		}), e.options?.createCustomHandle && (this.createCustomHandle = e.options.createCustomHandle), this.wrapper = this.createWrapper(), this.container = this.createContainer(), this.applyInitialSize(), this.attachHandles(), this.editor.on("update", this.handleEditorUpdate.bind(this));
	}
	get dom() {
		return this.container;
	}
	get contentDOM() {
		return this.contentElement ?? null;
	}
	handleEditorUpdate() {
		let e = this.editor.isEditable;
		e !== this.lastEditableState && (this.lastEditableState = e, e ? e && this.handleMap.size === 0 && this.attachHandles() : this.removeHandles());
	}
	update(e, t, n) {
		return e.type === this.node.type && (this.node = e, !this.onUpdate || this.onUpdate(e, t, n));
	}
	destroy() {
		this.isResizing && (this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp), this.isResizing = !1, this.activeHandle = null), this.editor.off("update", this.handleEditorUpdate.bind(this)), this.container.remove();
	}
	createContainer() {
		let e = document.createElement("div");
		return e.dataset.resizeContainer = "", e.dataset.node = this.node.type.name, e.style.display = this.node.type.isInline ? "inline-flex" : "flex", this.classNames.container && (e.className = this.classNames.container), e.appendChild(this.wrapper), e;
	}
	createWrapper() {
		let e = document.createElement("div");
		return e.style.position = "relative", e.style.display = "block", e.dataset.resizeWrapper = "", this.classNames.wrapper && (e.className = this.classNames.wrapper), e.appendChild(this.element), e;
	}
	createHandle(e) {
		let t = document.createElement("div");
		return t.dataset.resizeHandle = e, t.style.position = "absolute", this.classNames.handle && (t.className = this.classNames.handle), t;
	}
	positionHandle(e, t) {
		let n = t.includes("top"), r = t.includes("bottom"), i = t.includes("left"), a = t.includes("right");
		n && (e.style.top = "0"), r && (e.style.bottom = "0"), i && (e.style.left = "0"), a && (e.style.right = "0"), (t === "top" || t === "bottom") && (e.style.left = "0", e.style.right = "0"), (t === "left" || t === "right") && (e.style.top = "0", e.style.bottom = "0");
	}
	attachHandles() {
		this.directions.forEach((e) => {
			let t;
			t = this.createCustomHandle ? this.createCustomHandle(e) : this.createHandle(e), t instanceof HTMLElement || (console.warn(`[ResizableNodeView] createCustomHandle("${e}") did not return an HTMLElement. Falling back to default handle.`), t = this.createHandle(e)), this.createCustomHandle || this.positionHandle(t, e), t.addEventListener("mousedown", (t) => this.handleResizeStart(t, e)), t.addEventListener("touchstart", (t) => this.handleResizeStart(t, e)), this.handleMap.set(e, t), this.wrapper.appendChild(t);
		});
	}
	removeHandles() {
		this.handleMap.forEach((e) => e.remove()), this.handleMap.clear();
	}
	applyInitialSize() {
		let e = this.node.attrs.width, t = this.node.attrs.height;
		e ? (this.element.style.width = `${e}px`, this.initialWidth = e) : this.initialWidth = this.element.offsetWidth, t ? (this.element.style.height = `${t}px`, this.initialHeight = t) : this.initialHeight = this.element.offsetHeight, this.initialWidth > 0 && this.initialHeight > 0 && (this.aspectRatio = this.initialWidth / this.initialHeight);
	}
	handleResizeStart(e, t) {
		e.preventDefault(), e.stopPropagation(), this.isResizing = !0, this.activeHandle = t, xK(e) ? (this.startX = e.touches[0].clientX, this.startY = e.touches[0].clientY) : (this.startX = e.clientX, this.startY = e.clientY), this.startWidth = this.element.offsetWidth, this.startHeight = this.element.offsetHeight, this.startWidth > 0 && this.startHeight > 0 && (this.aspectRatio = this.startWidth / this.startHeight), this.getPos(), this.container.dataset.resizeState = "true", this.classNames.resizing && this.container.classList.add(this.classNames.resizing), document.addEventListener("mousemove", this.handleMouseMove), document.addEventListener("touchmove", this.handleTouchMove), document.addEventListener("mouseup", this.handleMouseUp), document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("keyup", this.handleKeyUp);
	}
	handleResize(e, t) {
		if (!this.activeHandle) return;
		let n = this.preserveAspectRatio || this.isShiftKeyPressed, { width: r, height: i } = this.calculateNewDimensions(this.activeHandle, e, t), a = this.applyConstraints(r, i, n);
		this.element.style.width = `${a.width}px`, this.element.style.height = `${a.height}px`, this.onResize && this.onResize(a.width, a.height);
	}
	calculateNewDimensions(e, t, n) {
		let r = this.startWidth, i = this.startHeight, a = e.includes("right"), o = e.includes("left"), s = e.includes("bottom"), c = e.includes("top");
		return a ? r = this.startWidth + t : o && (r = this.startWidth - t), s ? i = this.startHeight + n : c && (i = this.startHeight - n), (e === "right" || e === "left") && (r = this.startWidth + (a ? t : -t)), (e === "top" || e === "bottom") && (i = this.startHeight + (s ? n : -n)), this.preserveAspectRatio || this.isShiftKeyPressed ? this.applyAspectRatio(r, i, e) : {
			width: r,
			height: i
		};
	}
	applyConstraints(e, t, n) {
		if (!n) {
			let n = Math.max(this.minSize.width, e), r = Math.max(this.minSize.height, t);
			return this.maxSize?.width && (n = Math.min(this.maxSize.width, n)), this.maxSize?.height && (r = Math.min(this.maxSize.height, r)), {
				width: n,
				height: r
			};
		}
		let r = e, i = t;
		return r < this.minSize.width && (r = this.minSize.width, i = r / this.aspectRatio), i < this.minSize.height && (i = this.minSize.height, r = i * this.aspectRatio), this.maxSize?.width && r > this.maxSize.width && (r = this.maxSize.width, i = r / this.aspectRatio), this.maxSize?.height && i > this.maxSize.height && (i = this.maxSize.height, r = i * this.aspectRatio), {
			width: r,
			height: i
		};
	}
	applyAspectRatio(e, t, n) {
		return n === "left" || n === "right" ? {
			width: e,
			height: e / this.aspectRatio
		} : n === "top" || n === "bottom" ? {
			width: t * this.aspectRatio,
			height: t
		} : {
			width: e,
			height: e / this.aspectRatio
		};
	}
}, CK = class e extends qG {
	constructor() {
		super(...arguments), this.type = "node";
	}
	static create(t = {}) {
		let n = typeof t == "function" ? t() : t;
		return new e(n);
	}
	configure(e) {
		return super.configure(e);
	}
	extend(e) {
		let t = typeof e == "function" ? e() : e;
		return super.extend(t);
	}
};
function wK(e) {
	return new YG({
		find: e.find,
		handler: ({ state: t, range: n, match: r, pasteEvent: i }) => {
			let a = mW(e.getAttributes, void 0, r, i);
			if (a === !1 || a === null) return null;
			let { tr: o } = t, s = r[r.length - 1], c = r[0], l = n.to;
			if (s) {
				let i = c.search(/\S/), u = n.from + c.indexOf(s), d = u + s.length;
				if (RW(n.from, n.to, t.doc).filter((t) => t.mark.type.excluded.find((n) => n === e.type && n !== t.mark.type)).filter((e) => e.to > u).length) return null;
				d < n.to && o.delete(d, n.to), u > n.from && o.delete(n.from + i, u), l = n.from + i + s.length, o.addMark(n.from + i, l, e.type.create(a || {})), r.index !== void 0 && r.input !== void 0 && r.index + r[0].length >= r.input.length || o.removeStoredMark(e.type);
			}
		}
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@tiptap+vue-3@3.27.1_@floating-ui+dom@1.8.0_@tiptap+core@3.27.1_@tiptap+pm@3.27.1__@tip_2851c70091577cf96e7d90cdbed2cfa5/node_modules/@tiptap/vue-3/dist/index.js
function TK(e) {
	return d((t, n) => ({
		get() {
			return t(), e;
		},
		set(t) {
			e = t, requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					n();
				});
			});
		}
	}));
}
var EK = class extends gK {
	constructor(e = {}) {
		return super(e), this.contentComponent = null, this.appContext = null, this.reactiveState = TK(this.view.state), this.reactiveExtensionStorage = TK(this.extensionStorage), this.on("beforeTransaction", ({ nextState: e }) => {
			this.reactiveState.value = e, this.reactiveExtensionStorage.value = this.extensionStorage;
		}), y(this);
	}
	get state() {
		return this.reactiveState ? this.reactiveState.value : this.view.state;
	}
	get storage() {
		return this.reactiveExtensionStorage ? this.reactiveExtensionStorage.value : super.storage;
	}
	registerPlugin(e, t) {
		let n = super.registerPlugin(e, t);
		return this.reactiveState && (this.reactiveState.value = n), n;
	}
	unregisterPlugin(e) {
		let t = super.unregisterPlugin(e);
		return this.reactiveState && t && (this.reactiveState.value = t), t;
	}
}, DK = f({
	name: "EditorContent",
	props: { editor: {
		default: null,
		type: Object
	} },
	setup(e) {
		let t = M(), n = p();
		return ge(() => {
			let r = e.editor;
			r && r.options.element && t.value && S(() => {
				if (!t.value || !r.view.dom?.parentNode) return;
				let e = L(t.value);
				t.value.append(...r.view.dom.parentNode.childNodes), r.contentComponent = n.ctx._, n && (r.appContext = {
					...n.appContext,
					provides: n.provides
				}), r.setOptions({ element: e }), r.createNodeViews();
			});
		}), E(() => {
			let t = e.editor;
			t && (t.contentComponent = null, t.appContext = null);
		}), { rootEl: t };
	},
	render() {
		return g("div", { ref: (e) => {
			this.rootEl = e;
		} });
	}
});
f({
	name: "NodeViewContent",
	props: { as: {
		type: String,
		default: "div"
	} },
	inject: { nodeViewContentRef: { default: void 0 } },
	mounted() {
		let e = this.nodeViewContentRef;
		e && this.$el && e(this.$el);
	},
	beforeUnmount() {
		let e = this.nodeViewContentRef;
		e && e(null);
	},
	render() {
		return g(this.as, {
			style: { whiteSpace: "pre-wrap" },
			"data-node-view-content": ""
		});
	}
}), f({
	name: "NodeViewWrapper",
	props: { as: {
		type: String,
		default: "div"
	} },
	inject: ["onDragStart", "decorationClasses"],
	render() {
		var e;
		return g(this.as, {
			class: this.decorationClasses,
			style: { whiteSpace: "normal" },
			"data-node-view-wrapper": "",
			onDragstart: this.onDragStart
		}, (e = this.$slots).default?.call(e));
	}
});
var OK = (e = {}) => {
	let t = ie();
	return O(() => {
		t.value = new EK(e);
	}), E(() => {
		var e;
		(e = t.value) == null || e.destroy();
	}), t;
};
f({
	name: "MarkViewContent",
	props: { as: {
		type: String,
		default: "span"
	} },
	render() {
		return g(this.as, {
			style: { whiteSpace: "inherit" },
			"data-mark-view-content": ""
		});
	}
});
//#endregion
//#region src/components/Wysiwyg/Toolbar/components/ToolbarButton.vue
var kK = /* @__PURE__ */ f({
	__name: "ToolbarButton",
	props: { active: { type: Boolean } },
	setup(e) {
		return (t, n) => (A(), o("button", { class: C(["disabled:opacity-50", { "text-primary bg-primary-light rounded-lg": e.active }]) }, [F(t.$slots, "default")], 2));
	}
}), AK = { class: "flex flex-col h-full border-l" }, jK = { class: "flex gap-2 px-3 py-2.5 border-b items-center" }, MK = { class: "flex-1 min-h-0 overflow-y-auto hidden md:block" }, NK = { class: "px-3 py-2.5 bg-gray-200 flex min-h-full" }, PK = { class: "list-none m-0 p-0" }, FK = /* @__PURE__ */ f({
	__name: "TagsSidebar",
	props: {
		editor: {},
		tags: {}
	},
	setup(t) {
		let { t: n } = Re(), r = t, i = (e) => {
			r.editor.chain().focus().insertContent(e.key).run();
		};
		return (r, a) => (A(), o("div", AK, [s("div", jK, [u(yb, {
			class: "my-0.5",
			size: "small"
		}, {
			default: B(() => [l(I(L(n)("ui.wysiwyg.personalize")), 1)]),
			_: 1
		}), u(L(Gb), null, {
			default: B(() => [l(I(L(n)("ui.wysiwyg.personalizeNote")), 1)]),
			_: 1
		})]), s("div", MK, [s("div", NK, [s("ul", PK, [(A(!0), o(e, null, P(t.tags, (e) => (A(), o("li", {
			key: e.key,
			class: "flex before:content-['+'] before:mr-1"
		}, [u(kK, {
			class: "block text-left",
			title: L(n)("ui.wysiwyg.addTag"),
			onClick: () => i(e)
		}, {
			default: B(() => [l(I(e.label), 1)]),
			_: 2
		}, 1032, ["title", "onClick"])]))), 128))])])])]));
	}
}), IK = {
	Headings: "headings",
	Formatting: "formatting",
	Lists: "lists",
	Link: "link",
	Image: "image",
	TextAlignment: "textAlignment",
	Tags: "tags"
}, LK = (e) => ({
	toggleHeading: (t) => {
		if (e.isActive("heading", { level: t })) {
			e.chain().focus().setNode("paragraph").run();
			return;
		}
		if ((e.isActive("paragraph") || e.isActive("heading")) && !e.isActive("image")) {
			e.chain().focus().setNode("heading", { level: t }).run();
			return;
		}
		e.chain().focus().insertContentAt(e.state.selection.to, {
			type: "heading",
			attrs: { level: t }
		}).run();
	},
	toggleMark: (t) => {
		e.chain().focus().toggleMark(t).run();
	},
	setTextAlign: (t) => {
		e.chain().focus().toggleTextAlign(t).run();
	},
	toggleList: (t) => {
		if (e.isActive(t)) {
			e.chain().focus().setNode("paragraph").run();
			return;
		}
		e.chain().focus().toggleList(t, "paragraph", !0).run();
	}
}), RK = { class: "flex gap-3 border-r pr-2.5 py-2.5" }, zK = /* @__PURE__ */ f({
	__name: "AlignmentButtons",
	props: { editor: {} },
	setup(e) {
		let { setTextAlign: t } = LK(e.editor);
		return (n, r) => (A(), o("div", RK, [
			u(kK, {
				active: e.editor.isActive({ textAlign: "center" }),
				"aria-label": "Align center",
				onClick: r[0] ||= (e) => L(t)("center")
			}, {
				default: B(() => [u(L(Jp), {
					class: "block",
					size: L(Kp).Medium
				}, {
					default: B(() => [u(L(qm))]),
					_: 1
				}, 8, ["size"])]),
				_: 1
			}, 8, ["active"]),
			u(kK, {
				active: e.editor.isActive({ textAlign: "left" }),
				"aria-label": "Align left",
				onClick: r[1] ||= (e) => L(t)("left")
			}, {
				default: B(() => [u(L(Jp), {
					class: "block",
					size: L(Kp).Medium
				}, {
					default: B(() => [u(L(eh))]),
					_: 1
				}, 8, ["size"])]),
				_: 1
			}, 8, ["active"]),
			u(kK, {
				active: e.editor.isActive({ textAlign: "right" }),
				"aria-label": "Align right",
				onClick: r[2] ||= (e) => L(t)("right")
			}, {
				default: B(() => [u(L(Jp), {
					class: "block",
					size: L(Kp).Medium
				}, {
					default: B(() => [u(L(ch))]),
					_: 1
				}, 8, ["size"])]),
				_: 1
			}, 8, ["active"]),
			u(kK, {
				active: e.editor.isActive({ textAlign: "justify" }),
				"aria-label": "Align justify",
				onClick: r[3] ||= (e) => L(t)("justify")
			}, {
				default: B(() => [u(L(Jp), {
					class: "block",
					size: L(Kp).Medium
				}, {
					default: B(() => [u(L(Em))]),
					_: 1
				}, 8, ["size"])]),
				_: 1
			}, 8, ["active"])
		]));
	}
}), BK = { class: "flex gap-3 border-r pr-2.5 py-2.5" }, VK = /* @__PURE__ */ f({
	__name: "FormattingButtons",
	props: { editor: {} },
	setup(e) {
		let { toggleMark: t } = LK(e.editor);
		return (n, r) => (A(), o("div", BK, [
			u(kK, {
				active: e.editor.isActive("bold"),
				"aria-label": "Bold",
				disabled: !e.editor.can().toggleBold(),
				onClick: r[0] ||= (e) => L(t)("bold")
			}, {
				default: B(() => [u(L(Jp), {
					class: "block",
					size: L(Kp).Medium
				}, {
					default: B(() => [u(L(nm))]),
					_: 1
				}, 8, ["size"])]),
				_: 1
			}, 8, ["active", "disabled"]),
			u(kK, {
				active: e.editor.isActive("italic"),
				"aria-label": "Italic",
				disabled: !e.editor.can().toggleItalic(),
				onClick: r[1] ||= (e) => L(t)("italic")
			}, {
				default: B(() => [u(L(Jp), {
					class: "block",
					size: L(Kp).Medium
				}, {
					default: B(() => [u(L(zm))]),
					_: 1
				}, 8, ["size"])]),
				_: 1
			}, 8, ["active", "disabled"]),
			u(kK, {
				active: e.editor.isActive("underline"),
				"aria-label": "Underline",
				disabled: !e.editor.can().toggleUnderline(),
				onClick: r[2] ||= (e) => L(t)("underline")
			}, {
				default: B(() => [...r[3] ||= [s("u", { class: "decoration-2 block w-6 h-6 scale-115" }, "U", -1)]]),
				_: 1
			}, 8, ["active", "disabled"])
		]));
	}
}), HK = { class: "flex gap-3 border-r pr-2.5 py-2.5" }, UK = /* @__PURE__ */ f({
	__name: "HeadingButtons",
	props: { editor: {} },
	setup(e) {
		let { toggleHeading: t } = LK(e.editor);
		return (n, r) => (A(), o("div", HK, [
			u(kK, {
				active: e.editor.isActive("heading", { level: 1 }),
				"aria-label": "Heading 1",
				onClick: r[0] ||= (e) => L(t)(1)
			}, {
				default: B(() => [...r[3] ||= [s("p", { class: "bold w-6" }, "H1", -1)]]),
				_: 1
			}, 8, ["active"]),
			u(kK, {
				active: e.editor.isActive("heading", { level: 2 }),
				"aria-label": "Heading 2",
				onClick: r[1] ||= (e) => L(t)(2)
			}, {
				default: B(() => [...r[4] ||= [s("p", { class: "bold w-6" }, "H2", -1)]]),
				_: 1
			}, 8, ["active"]),
			u(kK, {
				active: e.editor.isActive("heading", { level: 3 }),
				"aria-label": "Heading 3",
				onClick: r[2] ||= (e) => L(t)(3)
			}, {
				default: B(() => [...r[5] ||= [s("p", { class: "bold w-6" }, "H3", -1)]]),
				_: 1
			}, 8, ["active"])
		]));
	}
}), WK = { class: "relative" }, GK = ["aria-label"], KK = {
	key: 0,
	class: "absolute w-[225px] top-6 -left-2.5 bg-white p-4 rounded-b-lg border mx-[-1px] mt-2.5 pt-1.5 z-30 shadow-lg",
	role: "dialog"
}, qK = /* @__PURE__ */ f({
	__name: "ToolbarDrawer",
	props: {
		ariaLabel: {},
		withChevron: { type: Boolean }
	},
	emits: ["onOpen"],
	setup(e, { expose: t, emit: n }) {
		let r = n, [c, l] = Fe(), u = () => {
			c.value || r("onOpen"), l(!c.value);
		};
		return t({ toggleIsOpen: l }), (t, n) => V((A(), o("div", WK, [s("button", {
			"aria-label": e.ariaLabel,
			class: "flex items-center",
			onClick: u
		}, [F(t.$slots, "trigger"), e.withChevron ? (A(), i(op, {
			key: 0,
			"is-open": L(c)
		}, null, 8, ["is-open"])) : a("", !0)], 8, GK), L(c) ? (A(), o("div", KK, [F(t.$slots, "content")])) : a("", !0)])), [[L(Ee), () => L(l)(!1)]]);
	}
}), JK = { class: "flex gap-3 border-r pr-2.5 py-2.5 relative" }, YK = { class: "flex flex-col gap-2 w-48" }, XK = /* @__PURE__ */ f({
	__name: "ImageButtonDrawer",
	props: { editor: {} },
	setup(e) {
		let t = e, n = M(null), r = M(""), i = M(""), a = M(""), c = () => {
			let { view: e, state: n } = t.editor, { from: r, to: i } = e?.state?.selection;
			return n.doc.textBetween(r, i, "") || "";
		}, d = () => {
			if (t.editor.isActive("image")) {
				let e = t.editor.getAttributes("image");
				r.value = e.src, i.value = e.title || "", a.value = e.alt || "";
			} else a.value = c(), r.value = "", i.value = "";
		}, f = () => {
			n.value?.toggleIsOpen(!1);
		}, p = (e, n, r) => {
			let i = r?.trim();
			t.editor.isActive("image") ? t.editor.chain().focus().setImage({
				src: e,
				alt: i || n,
				title: n
			}).run() : t.editor.chain().focus().insertContent({
				type: "image",
				attrs: {
					src: e,
					alt: i || n,
					title: n
				}
			}).run(), f();
		};
		return (t, c) => (A(), o("div", JK, [u(qK, {
			ref_key: "drawer",
			ref: n,
			"aria-label": "Insert image",
			onOnOpen: d
		}, {
			trigger: B(() => [...c[4] ||= [s("p", { class: "block w-6 h-6" }, "🖼️", -1)]]),
			content: B(() => [s("div", YK, [
				u(QO, {
					modelValue: r.value,
					"onUpdate:modelValue": c[0] ||= (e) => r.value = e,
					name: "image-url",
					placeholder: "Image URL"
				}, null, 8, ["modelValue"]),
				u(QO, {
					modelValue: i.value,
					"onUpdate:modelValue": c[1] ||= (e) => i.value = e,
					name: "image-title",
					placeholder: "Image Title"
				}, null, 8, ["modelValue"]),
				u(QO, {
					modelValue: a.value,
					"onUpdate:modelValue": c[2] ||= (e) => a.value = e,
					name: "image-alt-text",
					placeholder: "Image Alt Text"
				}, null, 8, ["modelValue"]),
				u(Dp, {
					"aria-label": "Submit image",
					disabled: r.value.trim() === "" || i.value.trim() === "" || !e.editor.can().setImage({ src: r.value }),
					onClick: c[3] ||= (e) => p(r.value, i.value, a.value)
				}, {
					default: B(() => [...c[5] ||= [l(" Submit ", -1)]]),
					_: 1
				}, 8, ["disabled"])
			])]),
			_: 1
		}, 512)]));
	}
}), ZK = { class: "flex gap-3 border-r pr-2.5 py-2.5 relative" }, QK = { class: "flex flex-col gap-2 w-48" }, $K = /* @__PURE__ */ f({
	__name: "LinkButtonDrawer",
	props: { editor: {} },
	setup(e) {
		let t = e, n = M(null), r = M(""), c = M(""), d = () => {
			let { view: e, state: n } = t.editor, { from: r, to: i } = e?.state?.selection;
			return n.doc.textBetween(r, i, "") || "";
		}, f = () => {
			if (r.value = d(), t.editor.isActive("link")) {
				let e = t.editor.getAttributes("link");
				c.value = e.href;
			} else c.value = "";
		}, p = () => {
			n.value?.toggleIsOpen(!1);
		}, m = (e, n) => {
			let r = t.editor, i = r.chain().focus();
			if (r.isActive("link")) {
				let t = fU(r.state.selection.$from, r.schema.marks.link) ?? fU(r.state.selection.$to, r.schema.marks.link);
				/* c8 ignore next - selection-edge fallback; getMarkRange may return undefined at mark boundaries */
				if (t && r.state.doc.nodeAt(t.from)?.type.name !== "image") {
					i.insertContentAt(t, {
						type: "text",
						text: e.trim(),
						marks: [{
							type: "link",
							attrs: { href: n }
						}]
					}).run();
					return;
				}
				i.extendMarkRange("link").setLink({ href: n }).run();
				return;
			}
			if (r.isActive("image")) {
				let { from: e, to: t } = r.state.selection, a = r.state.doc.nodeAt(e);
				/* c8 ignore next - selection-edge fallback; nodeAt may return null at node boundaries */
				if (a?.type.name === "image") {
					i.insertContentAt({
						from: e,
						to: t
					}, {
						type: "image",
						attrs: a.attrs,
						marks: [{
							type: "link",
							attrs: { href: n }
						}]
					}).run();
					return;
				}
			}
			let a = e.trim();
			i.insertContent({
				type: "text",
				text: a,
				marks: [{
					type: "link",
					attrs: { href: n }
				}]
			}).run();
		}, h = () => {
			t.editor.chain().focus().unsetLink().run();
		}, g = () => {
			m(r.value, c.value), p();
		}, _ = () => {
			h(), p();
		};
		return (t, d) => (A(), o("div", ZK, [u(qK, {
			ref_key: "drawer",
			ref: n,
			"aria-label": "Insert link",
			onOnOpen: f
		}, {
			trigger: B(() => [u(L(Jp), {
				class: "block",
				size: L(Kp).Medium
			}, {
				default: B(() => [u(L(Qp))]),
				_: 1
			}, 8, ["size"])]),
			content: B(() => [s("div", QK, [
				u(QO, {
					modelValue: c.value,
					"onUpdate:modelValue": d[0] ||= (e) => c.value = e,
					name: "link-url",
					placeholder: "URL"
				}, null, 8, ["modelValue"]),
				e.editor.isActive("image") ? a("", !0) : (A(), i(QO, {
					key: 0,
					modelValue: r.value,
					"onUpdate:modelValue": d[1] ||= (e) => r.value = e,
					name: "link-text",
					placeholder: "Selected text"
				}, null, 8, ["modelValue"])),
				e.editor.isActive("link") ? (A(), i(Dp, {
					key: 1,
					"aria-label": "Unlink",
					variant: "danger",
					onClick: _
				}, {
					default: B(() => [...d[2] ||= [l(" Unlink ", -1)]]),
					_: 1
				})) : a("", !0),
				u(Dp, {
					"aria-label": "Submit link",
					disabled: r.value.trim() === "" && !e.editor.isActive("image") || c.value.trim() === "" || !e.editor.isActive("image") && !e.editor.can().toggleLink(),
					onClick: g
				}, {
					default: B(() => [...d[3] ||= [l(" Submit ", -1)]]),
					_: 1
				}, 8, ["disabled"])
			])]),
			_: 1
		}, 512)]));
	}
}), eq = { class: "flex gap-3 border-r pr-2.5 py-2.5" }, tq = /* @__PURE__ */ f({
	__name: "ListButtons",
	props: { editor: {} },
	setup(e) {
		let { toggleList: t } = LK(e.editor);
		return (n, r) => (A(), o("div", eq, [u(kK, {
			active: e.editor.isActive("orderedList"),
			"aria-label": "Ordered list",
			onClick: r[0] ||= (e) => L(t)("orderedList")
		}, {
			default: B(() => [u(L(Jp), {
				class: "block",
				size: L(Kp).Medium
			}, {
				default: B(() => [u(L(mm))]),
				_: 1
			}, 8, ["size"])]),
			_: 1
		}, 8, ["active"]), u(kK, {
			active: e.editor.isActive("bulletList"),
			"aria-label": "Bullet list",
			onClick: r[1] ||= (e) => L(t)("bulletList")
		}, {
			default: B(() => [u(L(Jp), {
				class: "block",
				size: L(Kp).Medium
			}, {
				default: B(() => [u(L(Sm))]),
				_: 1
			}, 8, ["size"])]),
			_: 1
		}, 8, ["active"])]));
	}
}), nq = { class: "flex gap-3 py-2.5 relative" }, rq = { class: "flex" }, iq = { class: "mr-2" }, aq = { class: "list-none m-0 p-0" }, oq = /* @__PURE__ */ f({
	__name: "TagsButtonDrawer",
	props: {
		editor: {},
		tags: {}
	},
	setup(t) {
		let { t: n } = Re(), r = t, i = (e) => {
			r.editor.chain().focus().insertContent(e.key).run();
		};
		return (r, a) => (A(), o("div", nq, [u(qK, {
			"aria-label": L(n)("ui.wysiwyg.addTag"),
			"with-chevron": ""
		}, {
			trigger: B(() => [s("div", rq, [s("span", iq, I(L(n)("ui.wysiwyg.addTag")), 1), u(L(Jp), {
				class: "block",
				size: L(Kp).Medium
			}, {
				default: B(() => [u(L(Fm))]),
				_: 1
			}, 8, ["size"])])]),
			content: B(() => [s("ul", aq, [(A(!0), o(e, null, P(t.tags, (e) => (A(), o("li", {
				key: e.key,
				class: "flex before:content-['+'] before:mr-1"
			}, [u(kK, {
				class: "block text-left",
				title: L(n)("ui.wysiwyg.addTag"),
				onClick: () => i(e)
			}, {
				default: B(() => [l(I(e.label), 1)]),
				_: 2
			}, 1032, ["title", "onClick"])]))), 128))])]),
			_: 1
		}, 8, ["aria-label"])]));
	}
}), sq = { class: "flex gap-3 border-r pr-2.5 py-2.5" }, cq = /* @__PURE__ */ f({
	__name: "UndoRedoButtons",
	props: { editor: {} },
	setup(e) {
		let t = e, n = M(t.editor.can().undo()), r = M(t.editor.can().redo()), i = () => {
			n.value = t.editor.can().undo(), r.value = t.editor.can().redo();
		};
		return t.editor.on("transaction", i), E(() => {
			t.editor.off("transaction", i);
		}), (t, i) => (A(), o("div", sq, [u(kK, {
			"aria-label": "Undo",
			disabled: !n.value,
			onClick: i[0] ||= (t) => e.editor.chain().focus().undo().run()
		}, {
			default: B(() => [u(L(Jp), {
				class: "block",
				size: L(Kp).Medium
			}, {
				default: B(() => [u(L(Um))]),
				_: 1
			}, 8, ["size"])]),
			_: 1
		}, 8, ["disabled"]), u(kK, {
			"aria-label": "Redo",
			disabled: !r.value,
			onClick: i[1] ||= (t) => e.editor.chain().focus().redo().run()
		}, {
			default: B(() => [u(L(Jp), {
				class: "block",
				size: L(Kp).Medium
			}, {
				default: B(() => [u(L(ih))]),
				_: 1
			}, 8, ["size"])]),
			_: 1
		}, 8, ["disabled"])]));
	}
}), lq = { class: "flex gap-2.5 flex-1" }, uq = { "data-toolbar-item": "undoRedo" }, dq = ["data-toolbar-item"], fq = {
	key: 0,
	class: "relative flex items-center"
}, pq = ["aria-label", "title"], mq = {
	key: 1,
	class: "absolute right-0 top-full bg-white border rounded-bl-lg rounded-br-lg shadow-lg z-50 w-full",
	"data-test": "overflow-menu"
}, hq = { class: "flex flex-row flex-wrap" }, gq = /* @__PURE__ */ f({
	__name: "Toolbar",
	props: {
		editor: {},
		allowedExtensions: {},
		overflowExtensions: {},
		tags: {},
		tagEditorSidebar: { type: Boolean }
	},
	setup(t) {
		let n = [
			{
				key: IK.Headings,
				component: UK
			},
			{
				key: IK.Formatting,
				component: VK
			},
			{
				key: IK.TextAlignment,
				component: zK
			},
			{
				key: IK.Lists,
				component: tq
			},
			{
				key: IK.Link,
				component: $K
			},
			{
				key: IK.Image,
				component: XK
			},
			{
				key: IK.Tags,
				component: oq,
				class: "relative",
				extraProps: (e) => ({ tags: e.tags })
			}
		], c = t, { t: l } = Re(), d = M(), f = M(!1), p = r(() => n.filter((e) => e.key === IK.Tags && (c.tagEditorSidebar || c.tags.length === 0) ? !1 : c.allowedExtensions.includes(e.key))), m = r(() => p.value.filter((e) => c.overflowExtensions.includes(e.key))), h = r(() => m.value.length > 0), g = (e) => ({
			editor: c.editor,
			...e.extraProps?.(c)
		}), _ = () => {
			f.value = !f.value;
		}, v = (e) => {
			/* c8 ignore next - Defensive check, ref always exists when event fires */
			if (!d.value) return;
			let t = e.target;
			d.value.contains(t) || (f.value = !1);
		};
		return O(() => {
			document.addEventListener("click", v);
		}), ee(() => {
			document.removeEventListener("click", v);
		}), (n, r) => (A(), o("div", {
			ref_key: "toolbarRef",
			ref: d,
			"aria-label": "Editor toolbar",
			class: "flex gap-2.5 border-b px-3 relative"
		}, [
			s("div", lq, [s("div", uq, [u(cq, { editor: t.editor }, null, 8, ["editor"])]), (A(!0), o(e, null, P(p.value, (e) => V((A(), o("div", x({ key: e.key }, { ref_for: !0 }, e.class ? { class: e.class } : void 0, { "data-toolbar-item": e.key }), [(A(), i(re(e.component), x({ ref_for: !0 }, g(e)), null, 16))], 16, dq)), [[he, !t.overflowExtensions.includes(e.key)]])), 128))]),
			h.value ? (A(), o("div", fq, [s("button", {
				"aria-label": L(l)("ui.wysiwyg.moreOptions"),
				class: "px-2 py-1 hover:bg-gray-100 rounded",
				title: L(l)("ui.wysiwyg.moreOptions"),
				type: "button",
				onClick: U(_, ["stop"])
			}, [...r[0] ||= [s("svg", {
				class: "lucide lucide-ellipsis-vertical-icon lucide-ellipsis-vertical",
				fill: "none",
				height: "24",
				stroke: "currentColor",
				"stroke-linecap": "round",
				"stroke-linejoin": "round",
				"stroke-width": "2",
				viewBox: "0 0 24 24",
				width: "24",
				xmlns: "http://www.w3.org/2000/svg"
			}, [
				s("circle", {
					cx: "12",
					cy: "12",
					r: "1"
				}),
				s("circle", {
					cx: "12",
					cy: "5",
					r: "1"
				}),
				s("circle", {
					cx: "12",
					cy: "19",
					r: "1"
				})
			], -1)]], 8, pq)])) : a("", !0),
			f.value ? (A(), o("div", mq, [s("div", hq, [(A(!0), o(e, null, P(m.value, (e) => (A(), o("div", {
				key: e.key,
				class: "pl-2.5 border-b"
			}, [(A(), i(re(e.component), x({ ref_for: !0 }, g(e)), null, 16))]))), 128))])])) : a("", !0)
		], 512));
	}
}), _q = (e, t) => {
	if (e === "slot") return 0;
	if (e instanceof Function) return e(t);
	let { children: n, ...r } = t ?? {};
	if (e === "svg") throw Error("SVG elements are not supported in the JSX syntax, use the array syntax instead");
	return [
		e,
		r,
		n
	];
}, vq = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, yq = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, bq = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, xq = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, Sq = JG.create({
	name: "bold",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	parseHTML() {
		return [
			{ tag: "strong" },
			{
				tag: "b",
				getAttrs: (e) => e.style.fontWeight !== "normal" && null
			},
			{
				style: "font-weight=400",
				clearMark: (e) => e.type.name === this.name
			},
			{
				style: "font-weight",
				getAttrs: (e) => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null
			}
		];
	},
	renderHTML({ HTMLAttributes: e }) {
		return /* @__PURE__ */ _q("strong", {
			...bW(this.options.HTMLAttributes, e),
			children: /* @__PURE__ */ _q("slot", {})
		});
	},
	markdownTokenName: "strong",
	parseMarkdown: (e, t) => t.applyMark("bold", t.parseInline(e.tokens || [])),
	markdownOptions: { htmlReopen: {
		open: "<strong>",
		close: "</strong>"
	} },
	renderMarkdown: (e, t) => `**${t.renderChildren(e)}**`,
	addCommands() {
		return {
			setBold: () => ({ commands: e }) => e.setMark(this.name),
			toggleBold: () => ({ commands: e }) => e.toggleMark(this.name),
			unsetBold: () => ({ commands: e }) => e.unsetMark(this.name)
		};
	},
	addKeyboardShortcuts() {
		return {
			"Mod-b": () => this.editor.commands.toggleBold(),
			"Mod-B": () => this.editor.commands.toggleBold()
		};
	},
	addInputRules() {
		return [_K({
			find: vq,
			type: this.type
		}), _K({
			find: bq,
			type: this.type
		})];
	},
	addPasteRules() {
		return [wK({
			find: yq,
			type: this.type
		}), wK({
			find: xq,
			type: this.type
		})];
	}
}), Cq = Object.defineProperty, wq = (e, t) => {
	for (var n in t) Cq(e, n, {
		get: t[n],
		enumerable: !0
	});
}, Tq = "listItem", Eq = "textStyle", Dq = /^\s*([-+*])\s$/, Oq = CK.create({
	name: "bulletList",
	addOptions() {
		return {
			itemTypeName: "listItem",
			HTMLAttributes: {},
			keepMarks: !1,
			keepAttributes: !1
		};
	},
	group: "block list",
	content() {
		return `${this.options.itemTypeName}+`;
	},
	parseHTML() {
		return [{ tag: "ul" }];
	},
	renderHTML({ HTMLAttributes: e }) {
		return [
			"ul",
			bW(this.options.HTMLAttributes, e),
			0
		];
	},
	markdownTokenName: "list",
	parseMarkdown: (e, t) => e.type !== "list" || e.ordered ? [] : {
		type: "bulletList",
		content: e.items ? t.parseChildren(e.items) : []
	},
	renderMarkdown: (e, t) => e.content ? t.renderChildren(e.content, "\n") : "",
	markdownOptions: { indentsContent: !0 },
	addCommands() {
		return { toggleBulletList: () => ({ commands: e, chain: t }) => this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(Tq, this.editor.getAttributes(Eq)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks) };
	},
	addKeyboardShortcuts() {
		return { "Mod-Shift-8": () => this.editor.commands.toggleBulletList() };
	},
	addInputRules() {
		let e = bK({
			find: Dq,
			type: this.type
		});
		return (this.options.keepMarks || this.options.keepAttributes) && (e = bK({
			find: Dq,
			type: this.type,
			keepMarks: this.options.keepMarks,
			keepAttributes: this.options.keepAttributes,
			getAttributes: () => this.editor.getAttributes(Eq),
			editor: this.editor
		})), [e];
	}
}), kq = (e, t, n) => {
	let { selection: r } = e;
	if (!r.empty) return null;
	let { $from: i } = r;
	if (!i.parent.isTextblock || i.parentOffset !== i.parent.content.size) return null;
	let a = -1;
	for (let e = i.depth; e > 0; --e) if (i.node(e).type.name === t) {
		a = e;
		break;
	}
	if (a < 0) return null;
	let o = i.node(a), s = i.index(a);
	if (s + 1 >= o.childCount) return null;
	let c = o.child(s + 1);
	if (!n.includes(c.type.name)) return null;
	let l = e.schema.nodes[t], u = !1;
	if (c.forEach((e) => {
		e.type === l && e.childCount > 1 && (u = !0);
	}), !u) return null;
	let d = e.doc.resolve(i.after()).nodeAfter;
	if (!d || !n.includes(d.type.name)) return null;
	let f = [];
	return d.forEach((e) => {
		f.push(e);
	}), f.length === 0 ? null : {
		listItemDepth: a,
		nestedList: d,
		nestedListPos: i.after(),
		insertPos: i.after(a),
		items: f
	};
}, Aq = (e, t, n, r) => {
	let i = kq(e, n, r);
	if (!i) return !1;
	let { selection: a } = e, { nestedList: o, nestedListPos: s, insertPos: c, items: l } = i, u = e.tr;
	u.delete(s, s + o.nodeSize);
	let d = u.mapping.map(c);
	return u.insert(d, X.from(l)), u.setSelection(a.map(u.doc, u.mapping)), t && t(u), !0;
}, jq = (e, t, n) => Aq(e.state, e.view.dispatch, t, n), Mq = (e, t) => nK.create({
	name: `${e}BranchingDeleteKeymap`,
	priority: 101,
	addKeyboardShortcuts() {
		let n = () => jq(this.editor, e, t);
		return {
			Delete: n,
			"Mod-Delete": n
		};
	}
}), Nq = [
	[1e3, "m"],
	[900, "cm"],
	[500, "d"],
	[400, "cd"],
	[100, "c"],
	[90, "xc"],
	[50, "l"],
	[40, "xl"],
	[10, "x"],
	[9, "ix"],
	[5, "v"],
	[4, "iv"],
	[1, "i"]
], Pq = "abcdefghijklmnopqrstuvwxyz", Fq = String.raw`\d+|[ivxlcdmIVXLCDM]+|${"[a-zA-Z]{1,2}"}`;
function Iq(e) {
	let t = e, n = "";
	for (let [e, r] of Nq) for (; t >= e;) n += r, t -= e;
	return n;
}
function Lq(e) {
	return Iq(e).toUpperCase();
}
function Rq(e) {
	let t = e.toLowerCase(), n = 0, r = 0;
	for (; n < t.length;) {
		let e = !1;
		for (let [i, a] of Nq) if (t.startsWith(a, n)) {
			r += i, n += a.length, e = !0;
			break;
		}
		if (!e) return 0;
	}
	return r;
}
function zq(e) {
	if (!/^[ivxlcdmIVXLCDM]+$/.test(e)) return !1;
	let t = Rq(e);
	return t <= 0 ? !1 : (e === e.toLowerCase() ? Iq(t) : Lq(t)) === e;
}
function Bq(e) {
	let t = e.toLowerCase();
	if (t.length === 1) return t.charCodeAt(0) - 97 + 1;
	if (t.length === 2) {
		let e = t.charCodeAt(0) - 97, n = t.charCodeAt(1) - 97;
		return (e + 1) * 26 + n + 1;
	}
	return 0;
}
function Vq(e) {
	if (e <= 26) return Pq[e - 1];
	let t = Math.floor((e - 1) / 26) - 1, n = (e - 1) % 26;
	return t < 0 ? Pq[n] : Pq[t] + Pq[n];
}
function Hq(e) {
	if (!(!e || /^\d+$/.test(e))) {
		if (zq(e)) return e === e.toLowerCase() ? "i" : "I";
		if (/^[a-z]{1,2}$/.test(e)) return "a";
		if (/^[A-Z]{1,2}$/.test(e)) return "A";
	}
}
function Uq(e) {
	if (/^\d+$/.test(e)) return parseInt(e, 10);
	let t = Hq(e);
	if (t === "i" || t === "I") return Rq(e);
	if (t === "a" || t === "A") {
		let t = Bq(e);
		return t > 0 ? t : 1;
	}
	let n = parseInt(e, 10);
	return Number.isNaN(n) ? 1 : n;
}
function Wq(e, t) {
	if (e === "numeric") return String(t);
	switch (e) {
		case "a": return Vq(t);
		case "A": return Vq(t).toUpperCase();
		case "i": return Iq(t);
		case "I": return Lq(t);
		default: return String(t);
	}
}
function Gq(e) {
	if (e.length === 0) return !1;
	let t = Hq(e[0]) ?? "numeric", n = Uq(e[0]);
	if (n < 1) return !1;
	for (let r = 0; r < e.length; r++) {
		let i = Wq(t, n + r);
		if (e[r] !== i) return !1;
	}
	return !0;
}
function Kq(e) {
	return {
		type: Hq(e),
		start: Uq(e)
	};
}
function qq(e) {
	let { type: t, start: n } = Kq(e), r = {};
	return t && (r.type = t), n !== 1 && (r.start = n), r;
}
function Jq(e, t, n = ". ") {
	let r = t + 1;
	if (!e || e === "1") return `${r}${n}`;
	switch (e) {
		case "a": return `${Vq(r)}${n}`;
		case "A": return `${Vq(r).toUpperCase()}${n}`;
		case "i": return `${Iq(r)}${n}`;
		case "I": return `${Lq(r)}${n}`;
		default: return `${r}${n}`;
	}
}
function Yq(e) {
	let t = e.tokens?.[0];
	return !!(e.text && e.tokens?.length === 1 && t?.type === "list" && t.ordered && t.raw === e.text);
}
function Xq(e, t) {
	return t.tokenizeInline ? t.parseInline(t.tokenizeInline(e)) : t.parseInline([{
		type: "text",
		raw: e,
		text: e
	}]);
}
var Zq = CK.create({
	name: "listItem",
	addOptions() {
		return {
			HTMLAttributes: {},
			bulletListTypeName: "bulletList",
			orderedListTypeName: "orderedList"
		};
	},
	content: "paragraph block*",
	defining: !0,
	parseHTML() {
		return [{ tag: "li" }];
	},
	renderHTML({ HTMLAttributes: e }) {
		return [
			"li",
			bW(this.options.HTMLAttributes, e),
			0
		];
	},
	markdownTokenName: "list_item",
	parseMarkdown: (e, t) => {
		if (e.type !== "list_item") return [];
		let n = t.parseBlockChildren ?? t.parseChildren, r = [];
		if (e.tokens && e.tokens.length > 0) {
			if (Yq(e)) return {
				type: "listItem",
				content: [{
					type: "paragraph",
					content: Xq(e.text || "", t)
				}]
			};
			if (e.tokens.some((e) => e.type === "paragraph")) r = n(e.tokens);
			else {
				let i = e.tokens[0];
				if (i && i.type === "text" && i.tokens && i.tokens.length > 0) {
					if (r = [{
						type: "paragraph",
						content: t.parseInline(i.tokens)
					}], e.tokens.length > 1) {
						let t = n(e.tokens.slice(1));
						r.push(...t);
					}
				} else r = n(e.tokens);
			}
		}
		return r.length === 0 && (r = [{
			type: "paragraph",
			content: []
		}]), {
			type: "listItem",
			content: r
		};
	},
	renderMarkdown: (e, t, n) => BG(e, t, (e) => {
		if (e.parentType === "bulletList") return "- ";
		if (e.parentType === "orderedList") {
			let t = e.meta?.parentAttrs?.start || 1;
			return Jq(e.meta?.parentAttrs?.type, t - 1 + (e.index || 0), ". ");
		}
		return "- ";
	}, n),
	addExtensions() {
		return [Mq(this.name, [this.options.bulletListTypeName, this.options.orderedListTypeName])];
	},
	addKeyboardShortcuts() {
		return {
			Enter: () => this.editor.commands.splitListItem(this.name),
			Tab: () => this.editor.commands.sinkListItem(this.name),
			"Shift-Tab": () => this.editor.commands.liftListItem(this.name)
		};
	}
});
wq({}, {
	findListItemPos: () => Qq,
	getNextListDepth: () => $q,
	handleBackspace: () => tJ,
	handleDelete: () => iJ,
	hasListBefore: () => eJ,
	hasListItemAfter: () => aJ,
	hasListItemBefore: () => oJ,
	listItemHasSubList: () => sJ,
	nextListIsDeeper: () => nJ,
	nextListIsHigher: () => rJ
});
var Qq = (e, t) => {
	let { $from: n } = t.selection, r = $H(e, t.schema), i = null, a = n.depth, o = n.pos, s = null;
	for (; a > 0 && s === null;) i = n.node(a), i.type === r ? s = a : (--a, --o);
	return s === null ? null : {
		$pos: t.doc.resolve(o),
		depth: s
	};
}, $q = (e, t) => {
	let n = Qq(e, t);
	if (!n) return !1;
	let [, r] = zW(t, e, n.$pos.pos + 4);
	return r;
}, eJ = (e, t, n) => {
	let { $anchor: r } = e.selection, i = Math.max(0, r.pos - 2), a = e.doc.resolve(i).node();
	return !(!a || !n.includes(a.type.name));
}, tJ = (e, t, n) => {
	if (e.commands.undoInputRule()) return !0;
	if (e.state.selection.from !== e.state.selection.to) return !1;
	if (!HU(e.state, t) && eJ(e.state, t, n)) {
		let { $anchor: n } = e.state.selection, r = e.state.doc.resolve(n.before() - 1), i = [];
		r.node().descendants((e, n) => {
			e.type.name === t && i.push({
				node: e,
				pos: n
			});
		});
		let a = i.at(-1);
		if (!a) return !1;
		let o = e.state.doc.resolve(r.start() + a.pos + 1);
		return e.chain().cut({
			from: n.start() - 1,
			to: n.end() + 1
		}, o.end()).joinForward().run();
	}
	return !HU(e.state, t) || !KW(e.state) ? !1 : e.chain().liftListItem(t).run();
}, nJ = (e, t) => {
	let n = $q(e, t), r = Qq(e, t);
	return !r || !n ? !1 : n > r.depth;
}, rJ = (e, t) => {
	let n = $q(e, t), r = Qq(e, t);
	return !r || !n ? !1 : n < r.depth;
}, iJ = (e, t) => {
	if (!HU(e.state, t) || !GW(e.state, t)) return !1;
	let { selection: n } = e.state, { $from: r, $to: i } = n;
	return !n.empty && r.sameParent(i) ? !1 : nJ(t, e.state) ? e.chain().focus(e.state.selection.from + 4).lift(t).joinBackward().run() : rJ(t, e.state) ? e.chain().joinForward().joinBackward().run() : e.commands.joinItemForward();
}, aJ = (e, t) => {
	let { $anchor: n } = t.selection, r = t.doc.resolve(n.pos - n.parentOffset - 2);
	return r.index() !== r.parent.childCount - 1 && r.nodeAfter?.type.name === e;
}, oJ = (e, t) => {
	let { $anchor: n } = t.selection, r = t.doc.resolve(n.pos - 2);
	return r.index() !== 0 && r.nodeBefore?.type.name === e;
}, sJ = (e, t, n) => {
	if (!n) return !1;
	let r = $H(e, t.schema), i = !1;
	return n.descendants((e) => {
		e.type === r && (i = !0);
	}), i;
}, cJ = nK.create({
	name: "listKeymap",
	addOptions() {
		return { listTypes: [{
			itemName: "listItem",
			wrapperNames: ["bulletList", "orderedList"]
		}, {
			itemName: "taskItem",
			wrapperNames: ["taskList"]
		}] };
	},
	addKeyboardShortcuts() {
		return {
			Delete: ({ editor: e }) => {
				let t = !1;
				return this.options.listTypes.forEach(({ itemName: n }) => {
					e.state.schema.nodes[n] !== void 0 && iJ(e, n) && (t = !0);
				}), t;
			},
			"Mod-Delete": ({ editor: e }) => {
				let t = !1;
				return this.options.listTypes.forEach(({ itemName: n }) => {
					e.state.schema.nodes[n] !== void 0 && iJ(e, n) && (t = !0);
				}), t;
			},
			Backspace: ({ editor: e }) => {
				let t = !1;
				return this.options.listTypes.forEach(({ itemName: n, wrapperNames: r }) => {
					e.state.schema.nodes[n] !== void 0 && tJ(e, n, r) && (t = !0);
				}), t;
			},
			"Mod-Backspace": ({ editor: e }) => {
				let t = !1;
				return this.options.listTypes.forEach(({ itemName: n, wrapperNames: r }) => {
					e.state.schema.nodes[n] !== void 0 && tJ(e, n, r) && (t = !0);
				}), t;
			}
		};
	}
}), lJ = RegExp(`^(\\s*)(${Fq})([.)])\\s+(.*)$`), uJ = RegExp(`^(\\s*)(${Fq})([.)])\\s+`), dJ = /^\s/;
function fJ(e) {
	return lJ.test(e.trimStart());
}
function pJ(e) {
	let t = e.trimStart();
	return /^[-+*]\s+/.test(t) || fJ(t) || /^>\s?/.test(t) || /^```/.test(t) || /^~~~/.test(t);
}
function mJ(e) {
	let t = [], n = [], r = !1;
	return e.forEach((e) => {
		if (r) {
			n.push(e);
			return;
		}
		if (e.trim() === "") {
			r = !0, n.push(e);
			return;
		}
		if (t.length > 0 && pJ(e)) {
			r = !0, n.push(e);
			return;
		}
		t.push(e);
	}), {
		paragraphLines: t,
		blockLines: n
	};
}
function hJ(e) {
	let t = [], n = 0, r = 0;
	for (; n < e.length;) {
		let i = e[n], a = i.match(lJ);
		if (!a) break;
		let [, o, s, c, l] = a, u = o.length, d = parseInt(s, 10), f = isNaN(d) ? Hq(s) : void 0, p = isNaN(d) ? Uq(s) : d, m = [l], h = n + 1, g = [i], _ = !1;
		for (; h < e.length;) {
			let t = e[h];
			if (t.match(lJ)) break;
			if (t.trim() === "") g.push(t), m.push(""), _ = !0, h += 1;
			else if (t.match(dJ)) {
				let e = t.length - t.trimStart().length, n = u + s.length + 1;
				g.push(t), m.push(t.slice(Math.min(e, n))), h += 1;
			} else {
				if (_) break;
				g.push(t), m.push(t), h += 1;
			}
		}
		t.push({
			indent: u,
			number: p,
			type: f,
			content: m.join("\n").trim(),
			contentLines: m,
			raw: g.join("\n")
		}), r = h, n = h;
	}
	return [t, r];
}
var gJ = RegExp(`^(${Fq})([.)])\\s+(.+)$`);
function _J(e) {
	let t = e.split("\n").filter((e) => e.trim().length > 0);
	if (t.length === 0) return null;
	let n = [];
	for (let e of t) {
		let t = e.trim().match(gJ);
		if (!t) return null;
		n.push({
			marker: t[1],
			content: t[3]
		});
	}
	return Gq(n.map((e) => e.marker)) ? {
		type: "orderedList",
		attrs: qq(n[0].marker),
		content: n.map((e) => ({
			type: "listItem",
			content: [{
				type: "paragraph",
				content: [{
					type: "text",
					text: e.content
				}]
			}]
		}))
	} : null;
}
function vJ(e, t, n) {
	let r = [], i = 0;
	for (; i < e.length;) {
		let a = e[i];
		if (a.indent === t) {
			let { paragraphLines: o, blockLines: s } = mJ(a.contentLines), c = o.join("\n").trim(), l = [];
			c && l.push({
				type: "paragraph",
				raw: c,
				tokens: n.inlineTokens(c)
			});
			let u = s.join("\n").trim();
			if (u) {
				let e = n.blockTokens(u);
				l.push(...e);
			}
			let d = i + 1, f = [];
			for (; d < e.length && e[d].indent > t;) f.push(e[d]), d += 1;
			if (f.length > 0) {
				let e = vJ(f, Math.min(...f.map((e) => e.indent)), n);
				l.push({
					type: "list",
					ordered: !0,
					start: f[0].number,
					typeMarker: f[0].type,
					items: e,
					raw: f.map((e) => e.raw).join("\n")
				});
			}
			r.push({
				type: "list_item",
				raw: a.raw,
				tokens: l
			}), i = d;
		} else i += 1;
	}
	return r;
}
function yJ(e, t) {
	return e.map((e) => {
		if (e.type !== "list_item") return t.parseChildren([e])[0];
		let n = [];
		return e.tokens && e.tokens.length > 0 && e.tokens.forEach((e) => {
			if (e.type === "paragraph" || e.type === "list" || e.type === "blockquote" || e.type === "code") n.push(...t.parseChildren([e]));
			else if (e.type === "text" && e.tokens) {
				let r = t.parseChildren([e]);
				n.push({
					type: "paragraph",
					content: r
				});
			} else {
				let r = t.parseChildren([e]);
				r.length > 0 && n.push(...r);
			}
		}), {
			type: "listItem",
			content: n
		};
	});
}
var bJ = "listItem", xJ = "textStyle", SJ = /^(\d+)\.\s$/;
function CJ(e) {
	let t = e.match(/list-style-type\s*:\s*([^;]+)/i);
	if (!t) return null;
	switch (t[1].trim().toLowerCase()) {
		case "upper-roman": return "I";
		case "lower-roman": return "i";
		case "upper-alpha":
		case "upper-latin": return "A";
		case "lower-alpha":
		case "lower-latin": return "a";
		default: return null;
	}
}
var wJ = CK.create({
	name: "orderedList",
	addOptions() {
		return {
			itemTypeName: "listItem",
			HTMLAttributes: {},
			keepMarks: !1,
			keepAttributes: !1
		};
	},
	group: "block list",
	content() {
		return `${this.options.itemTypeName}+`;
	},
	addAttributes() {
		return {
			start: {
				default: 1,
				parseHTML: (e) => e.hasAttribute("start") ? parseInt(e.getAttribute("start") || "", 10) : 1
			},
			type: {
				default: null,
				parseHTML: (e) => {
					let t = e.getAttribute("type");
					if (t) return t;
					let n = e.getAttribute("style");
					if (n) {
						let e = CJ(n);
						if (e) return e;
					}
					let r = e.querySelector("li");
					if (r) {
						let e = r.getAttribute("style");
						if (e) {
							let t = CJ(e);
							if (t) return t;
						}
					}
					return null;
				}
			}
		};
	},
	parseHTML() {
		return [{ tag: "ol" }];
	},
	renderHTML({ HTMLAttributes: e }) {
		let { start: t, type: n, ...r } = e, i = bW(this.options.HTMLAttributes, r);
		return t !== 1 && (i.start = t), n && n !== "1" && (i.type = n), [
			"ol",
			i,
			0
		];
	},
	markdownTokenName: "list",
	parseMarkdown: (e, t) => {
		if (e.type !== "list" || !e.ordered) return [];
		let n = e.start || 1, r = e.typeMarker, i = e.items ? yJ(e.items, t) : [], a = {};
		return n !== 1 && (a.start = n), r && (a.type = r), Object.keys(a).length > 0 ? {
			type: "orderedList",
			attrs: a,
			content: i
		} : {
			type: "orderedList",
			content: i
		};
	},
	renderMarkdown: (e, t) => e.content ? t.renderChildren(e.content, "\n") : "",
	markdownTokenizer: {
		name: "orderedList",
		level: "block",
		start: (e) => {
			let t = e.match(uJ)?.index;
			return t === void 0 ? -1 : t;
		},
		tokenize: (e, t, n) => {
			let r = e.split("\n"), [i, a] = hJ(r);
			if (i.length === 0) return;
			let o = vJ(i, 0, n);
			if (o.length !== 0) return {
				type: "list",
				ordered: !0,
				start: i[0]?.number || 1,
				typeMarker: i[0]?.type,
				items: o,
				raw: r.slice(0, a).join("\n")
			};
		}
	},
	markdownOptions: { indentsContent: !0 },
	addCommands() {
		return { toggleOrderedList: () => ({ commands: e, chain: t }) => this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(bJ, this.editor.getAttributes(xJ)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks) };
	},
	addKeyboardShortcuts() {
		return { "Mod-Shift-7": () => this.editor.commands.toggleOrderedList() };
	},
	addProseMirrorPlugins() {
		return [new lL({ props: { handlePaste: (e, t) => {
			if ((t.clipboardData?.getData("text/html"))?.trim()) return !1;
			let n = t.clipboardData?.getData("text/plain");
			if (!n) return !1;
			let r = _J(n);
			if (!r) return !1;
			try {
				let t = e.state.schema.nodeFromJSON(r), n = e.state.tr.replaceSelectionWith(t);
				return e.dispatch(n), !0;
			} catch {
				return !1;
			}
		} } })];
	},
	addInputRules() {
		let e = (e, t) => (!t.attrs.type || t.attrs.type === "1") && t.childCount + t.attrs.start === +e[1], t = bK({
			find: SJ,
			type: this.type,
			getAttributes: (e) => ({ start: +e[1] }),
			joinPredicate: e
		});
		return (this.options.keepMarks || this.options.keepAttributes) && (t = bK({
			find: SJ,
			type: this.type,
			keepMarks: this.options.keepMarks,
			keepAttributes: this.options.keepAttributes,
			getAttributes: (e) => ({
				start: +e[1],
				...this.editor.getAttributes(xJ)
			}),
			joinPredicate: e,
			editor: this.editor
		})), [t];
	}
}), TJ = /^\s*(\[([( |x])?\])\s$/, EJ = CK.create({
	name: "taskItem",
	addOptions() {
		return {
			nested: !1,
			HTMLAttributes: {},
			taskListTypeName: "taskList",
			a11y: void 0
		};
	},
	content() {
		return this.options.nested ? "paragraph block*" : "paragraph+";
	},
	defining: !0,
	addAttributes() {
		return { checked: {
			default: !1,
			keepOnSplit: !1,
			parseHTML: (e) => {
				let t = e.getAttribute("data-checked");
				return t === "" || t === "true";
			},
			renderHTML: (e) => ({ "data-checked": e.checked })
		} };
	},
	parseHTML() {
		return [{
			tag: `li[data-type="${this.name}"]`,
			priority: 51
		}];
	},
	renderHTML({ node: e, HTMLAttributes: t }) {
		return [
			"li",
			bW(this.options.HTMLAttributes, t, { "data-type": this.name }),
			[
				"label",
				["input", {
					type: "checkbox",
					checked: e.attrs.checked ? "checked" : null
				}],
				["span"]
			],
			["div", 0]
		];
	},
	parseMarkdown: (e, t) => {
		let n = [];
		if (e.tokens && e.tokens.length > 0 ? n.push(t.createNode("paragraph", {}, t.parseInline(e.tokens))) : e.text ? n.push(t.createNode("paragraph", {}, [t.createNode("text", { text: e.text })])) : n.push(t.createNode("paragraph", {}, [])), e.nestedTokens && e.nestedTokens.length > 0) {
			let r = t.parseChildren(e.nestedTokens);
			n.push(...r);
		}
		return t.createNode("taskItem", { checked: e.checked || !1 }, n);
	},
	renderMarkdown: (e, t) => BG(e, t, `- [${e.attrs?.checked ? "x" : " "}] `),
	addExtensions() {
		return this.options.nested ? [Mq(this.name, [this.options.taskListTypeName])] : [];
	},
	addKeyboardShortcuts() {
		let e = {
			Enter: () => this.editor.commands.splitListItem(this.name),
			"Shift-Tab": () => this.editor.commands.liftListItem(this.name)
		};
		return this.options.nested ? {
			...e,
			Tab: () => this.editor.commands.sinkListItem(this.name)
		} : e;
	},
	addNodeView() {
		return ({ node: e, HTMLAttributes: t, getPos: n, editor: r }) => {
			let i = document.createElement("li"), a = document.createElement("label"), o = document.createElement("span"), s = document.createElement("input"), c = document.createElement("div"), l = (e) => {
				var t;
				s.ariaLabel = ((t = this.options.a11y)?.checkboxLabel)?.call(t, e, s.checked) || `Task item checkbox for ${e.textContent || "empty task item"}`;
			};
			l(e), a.contentEditable = "false", s.type = "checkbox", s.addEventListener("mousedown", (e) => e.preventDefault()), s.addEventListener("change", (t) => {
				if (!r.isEditable && !this.options.onReadOnlyChecked) {
					s.checked = !s.checked;
					return;
				}
				let { checked: i } = t.target;
				r.isEditable && typeof n == "function" && r.chain().focus(void 0, { scrollIntoView: !1 }).command(({ tr: e }) => {
					let t = n();
					if (typeof t != "number") return !1;
					let r = e.doc.nodeAt(t);
					return e.setNodeMarkup(t, void 0, {
						...r?.attrs,
						checked: i
					}), !0;
				}).run(), !r.isEditable && this.options.onReadOnlyChecked && (this.options.onReadOnlyChecked(e, i) || (s.checked = !s.checked));
			}), Object.entries(this.options.HTMLAttributes).forEach(([e, t]) => {
				i.setAttribute(e, t);
			}), i.dataset.checked = e.attrs.checked, s.checked = e.attrs.checked, a.append(s, o), i.append(a, c), Object.entries(t).forEach(([e, t]) => {
				i.setAttribute(e, t);
			});
			let u = new Set(Object.keys(t));
			return {
				dom: i,
				contentDOM: c,
				update: (e) => {
					if (e.type !== this.type) return !1;
					i.dataset.checked = e.attrs.checked, s.checked = e.attrs.checked, l(e);
					let t = r.extensionManager.attributes, n = xW(e, t), a = new Set(Object.keys(n)), o = this.options.HTMLAttributes;
					return u.forEach((e) => {
						a.has(e) || (e in o ? i.setAttribute(e, o[e]) : i.removeAttribute(e));
					}), Object.entries(n).forEach(([e, t]) => {
						t == null ? e in o ? i.setAttribute(e, o[e]) : i.removeAttribute(e) : i.setAttribute(e, t);
					}), u = a, !0;
				}
			};
		};
	},
	addInputRules() {
		return [bK({
			find: TJ,
			type: this.type,
			getAttributes: (e) => ({ checked: e[e.length - 1] === "x" })
		})];
	}
}), DJ = CK.create({
	name: "taskList",
	addOptions() {
		return {
			itemTypeName: "taskItem",
			HTMLAttributes: {}
		};
	},
	group: "block list",
	content() {
		return `${this.options.itemTypeName}+`;
	},
	parseHTML() {
		return [{
			tag: `ul[data-type="${this.name}"]`,
			priority: 51
		}];
	},
	renderHTML({ HTMLAttributes: e }) {
		return [
			"ul",
			bW(this.options.HTMLAttributes, e, { "data-type": this.name }),
			0
		];
	},
	parseMarkdown: (e, t) => t.createNode("taskList", {}, t.parseChildren(e.items || [])),
	renderMarkdown: (e, t) => e.content ? t.renderChildren(e.content, "\n") : "",
	markdownTokenizer: {
		name: "taskList",
		level: "block",
		start(e) {
			let t = e.match(/^\s*[-+*]\s+\[([ xX])\]\s+/)?.index;
			return t === void 0 ? -1 : t;
		},
		tokenize(e, t, n) {
			let r = (e) => {
				let t = zG(e, {
					itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
					extractItemData: (e) => ({
						indentLevel: e[1].length,
						mainContent: e[4],
						checked: e[3].toLowerCase() === "x"
					}),
					createToken: (e, t) => ({
						type: "taskItem",
						raw: "",
						mainContent: e.mainContent,
						indentLevel: e.indentLevel,
						checked: e.checked,
						text: e.mainContent,
						tokens: n.inlineTokens(e.mainContent),
						nestedTokens: t
					}),
					customNestedParser: r
				}, n);
				return t ? [{
					type: "taskList",
					raw: t.raw,
					items: t.items
				}] : n.blockTokens(e);
			}, i = zG(e, {
				itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
				extractItemData: (e) => ({
					indentLevel: e[1].length,
					mainContent: e[4],
					checked: e[3].toLowerCase() === "x"
				}),
				createToken: (e, t) => ({
					type: "taskItem",
					raw: "",
					mainContent: e.mainContent,
					indentLevel: e.indentLevel,
					checked: e.checked,
					text: e.mainContent,
					tokens: n.inlineTokens(e.mainContent),
					nestedTokens: t
				}),
				customNestedParser: r
			}, n);
			if (i) return {
				type: "taskList",
				raw: i.raw,
				items: i.items
			};
		}
	},
	markdownOptions: { indentsContent: !0 },
	addCommands() {
		return { toggleTaskList: () => ({ commands: e }) => e.toggleList(this.name, this.options.itemTypeName) };
	},
	addKeyboardShortcuts() {
		return { "Mod-Shift-9": () => this.editor.commands.toggleTaskList() };
	}
});
nK.create({
	name: "listKit",
	addExtensions() {
		let e = [];
		return this.options.bulletList !== !1 && e.push(Oq.configure(this.options.bulletList)), this.options.listItem !== !1 && e.push(Zq.configure(this.options.listItem)), this.options.listKeymap !== !1 && e.push(cJ.configure(this.options.listKeymap)), this.options.orderedList !== !1 && e.push(wJ.configure(this.options.orderedList)), this.options.taskItem !== !1 && e.push(EJ.configure(this.options.taskItem)), this.options.taskList !== !1 && e.push(DJ.configure(this.options.taskList)), e;
	}
});
//#endregion
//#region ../../node_modules/.pnpm/@tiptap+extension-bullet-list@3.27.1_@tiptap+extension-list@3.27.1_@tiptap+core@3.27.1__02134c3bdbcb00d5389ebe29c3402ae9/node_modules/@tiptap/extension-bullet-list/dist/index.js
var OJ = Oq, kJ = CK.create({
	name: "doc",
	topNode: !0,
	content: "block+",
	renderMarkdown: (e, t) => e.content ? t.renderChildren(e.content, "\n\n") : ""
});
//#endregion
//#region ../../node_modules/.pnpm/prosemirror-dropcursor@1.8.2/node_modules/prosemirror-dropcursor/dist/index.js
function AJ(e = {}) {
	return new lL({ view(t) {
		return new jJ(t, e);
	} });
}
var jJ = class {
	constructor(e, t) {
		this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = t.width ?? 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = [
			"dragover",
			"dragend",
			"drop",
			"dragleave"
		].map((t) => {
			let n = (e) => {
				this[t](e);
			};
			return e.dom.addEventListener(t, n), {
				name: t,
				handler: n
			};
		});
	}
	destroy() {
		this.handlers.forEach(({ name: e, handler: t }) => this.editorView.dom.removeEventListener(e, t));
	}
	update(e, t) {
		this.cursorPos != null && t.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
	}
	setCursor(e) {
		e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
	}
	updateOverlay() {
		let e = this.editorView.state.doc.resolve(this.cursorPos), t = !e.parent.inlineContent, n, r = this.editorView.dom, i = r.getBoundingClientRect(), a = i.width / r.offsetWidth, o = i.height / r.offsetHeight;
		if (t) {
			let t = e.nodeBefore, r = e.nodeAfter;
			if (t || r) {
				let e = this.editorView.nodeDOM(this.cursorPos - (t ? t.nodeSize : 0));
				if (e) {
					let i = e.getBoundingClientRect(), a = t ? i.bottom : i.top;
					t && r && (a = (a + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
					let s = this.width / 2 * o;
					n = {
						left: i.left,
						right: i.right,
						top: a - s,
						bottom: a + s
					};
				}
			}
		}
		if (!n) {
			let e = this.editorView.coordsAtPos(this.cursorPos), t = this.width / 2 * a;
			n = {
				left: e.left - t,
				right: e.left + t,
				top: e.top,
				bottom: e.bottom
			};
		}
		let s = this.editorView.dom.offsetParent;
		this.element || (this.element = s.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
		let c, l;
		if (!s || s == document.body && getComputedStyle(s).position == "static") c = -pageXOffset, l = -pageYOffset;
		else {
			let e = s.getBoundingClientRect(), t = e.width / s.offsetWidth, n = e.height / s.offsetHeight;
			c = e.left - s.scrollLeft * t, l = e.top - s.scrollTop * n;
		}
		this.element.style.left = (n.left - c) / a + "px", this.element.style.top = (n.top - l) / o + "px", this.element.style.width = (n.right - n.left) / a + "px", this.element.style.height = (n.bottom - n.top) / o + "px";
	}
	scheduleRemoval(e) {
		clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
	}
	dragover(e) {
		if (!this.editorView.editable) return;
		let t = this.editorView.posAtCoords({
			left: e.clientX,
			top: e.clientY
		}), n = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), r = n && n.type.spec.disableDropCursor, i = typeof r == "function" ? r(this.editorView, t, e) : r;
		if (t && !i) {
			let e = t.pos;
			if (this.editorView.dragging && this.editorView.dragging.slice) {
				let t = bI(this.editorView.state.doc, e, this.editorView.dragging.slice);
				t != null && (e = t);
			}
			this.setCursor(e), this.scheduleRemoval(5e3);
		}
	}
	dragend() {
		this.scheduleRemoval(20);
	}
	drop() {
		this.scheduleRemoval(20);
	}
	dragleave(e) {
		this.editorView.dom.contains(e.relatedTarget) || this.setCursor(null);
	}
}, MJ = class e extends VI {
	constructor(e) {
		super(e, e);
	}
	map(t, n) {
		let r = t.resolve(n.map(this.head));
		return e.valid(r) ? new e(r) : VI.near(r);
	}
	content() {
		return Z.empty;
	}
	eq(t) {
		return t instanceof e && t.head == this.head;
	}
	toJSON() {
		return {
			type: "gapcursor",
			pos: this.head
		};
	}
	static fromJSON(t, n) {
		if (typeof n.pos != "number") throw RangeError("Invalid input for GapCursor.fromJSON");
		return new e(t.resolve(n.pos));
	}
	getBookmark() {
		return new NJ(this.anchor);
	}
	static valid(e) {
		let t = e.parent;
		if (t.isTextblock || !FJ(e) || !IJ(e)) return !1;
		let n = t.type.spec.allowGapCursor;
		if (n != null) return n;
		let r = t.contentMatchAt(e.index()).defaultType;
		return r && r.isTextblock;
	}
	static findGapCursorFrom(t, n, r = !1) {
		search: for (;;) {
			if (!r && e.valid(t)) return t;
			let i = t.pos, a = null;
			for (let r = t.depth;; r--) {
				let o = t.node(r);
				if (n > 0 ? t.indexAfter(r) < o.childCount : t.index(r) > 0) {
					a = o.child(n > 0 ? t.indexAfter(r) : t.index(r) - 1);
					break;
				}
				if (r == 0) return null;
				i += n;
				let s = t.doc.resolve(i);
				if (e.valid(s)) return s;
			}
			for (;;) {
				let o = n > 0 ? a.firstChild : a.lastChild;
				if (!o) {
					if (a.isAtom && !a.isText && !qI.isSelectable(a)) {
						t = t.doc.resolve(i + a.nodeSize * n), r = !1;
						continue search;
					}
					break;
				}
				a = o, i += n;
				let s = t.doc.resolve(i);
				if (e.valid(s)) return s;
			}
			return null;
		}
	}
};
MJ.prototype.visible = !1, MJ.findFrom = MJ.findGapCursorFrom, VI.jsonID("gapcursor", MJ);
var NJ = class e {
	constructor(e) {
		this.pos = e;
	}
	map(t) {
		return new e(t.map(this.pos));
	}
	resolve(e) {
		let t = e.resolve(this.pos);
		return MJ.valid(t) ? new MJ(t) : VI.near(t);
	}
};
function PJ(e) {
	return e.isAtom || e.spec.isolating || e.spec.createGapCursor;
}
function FJ(e) {
	for (let t = e.depth; t >= 0; t--) {
		let n = e.index(t), r = e.node(t);
		if (n == 0) {
			if (r.type.spec.isolating) return !0;
			continue;
		}
		for (let e = r.child(n - 1);; e = e.lastChild) {
			if (e.childCount == 0 && !e.inlineContent || PJ(e.type)) return !0;
			if (e.inlineContent) return !1;
		}
	}
	return !0;
}
function IJ(e) {
	for (let t = e.depth; t >= 0; t--) {
		let n = e.indexAfter(t), r = e.node(t);
		if (n == r.childCount) {
			if (r.type.spec.isolating) return !0;
			continue;
		}
		for (let e = r.child(n);; e = e.firstChild) {
			if (e.childCount == 0 && !e.inlineContent || PJ(e.type)) return !0;
			if (e.inlineContent) return !1;
		}
	}
	return !0;
}
function LJ() {
	return new lL({ props: {
		decorations: HJ,
		createSelectionBetween(e, t, n) {
			return t.pos == n.pos && MJ.valid(n) ? new MJ(n) : null;
		},
		handleClick: BJ,
		handleKeyDown: RJ,
		handleDOMEvents: { beforeinput: VJ }
	} });
}
var RJ = BH({
	ArrowLeft: zJ("horiz", -1),
	ArrowRight: zJ("horiz", 1),
	ArrowUp: zJ("vert", -1),
	ArrowDown: zJ("vert", 1)
});
function zJ(e, t) {
	let n = e == "vert" ? t > 0 ? "down" : "up" : t > 0 ? "right" : "left";
	return function(e, r, i) {
		let a = e.selection, o = t > 0 ? a.$to : a.$from, s = a.empty;
		if (a instanceof GI) {
			if (!i.endOfTextblock(n) || o.depth == 0) return !1;
			s = !1, o = e.doc.resolve(t > 0 ? o.after() : o.before());
		}
		let c = MJ.findGapCursorFrom(o, t, s);
		return c ? (r && r(e.tr.setSelection(new MJ(c))), !0) : !1;
	};
}
function BJ(e, t, n) {
	if (!e || !e.editable) return !1;
	let r = e.state.doc.resolve(t);
	if (!MJ.valid(r)) return !1;
	let i = e.posAtCoords({
		left: n.clientX,
		top: n.clientY
	});
	return i && i.inside > -1 && qI.isSelectable(e.state.doc.nodeAt(i.inside)) ? !1 : (e.dispatch(e.state.tr.setSelection(new MJ(r))), !0);
}
function VJ(e, t) {
	if (t.inputType != "insertCompositionText" || !(e.state.selection instanceof MJ)) return !1;
	let { $from: n } = e.state.selection, r = n.parent.contentMatchAt(n.index()).findWrapping(e.state.schema.nodes.text);
	if (!r) return !1;
	let i = X.empty;
	for (let e = r.length - 1; e >= 0; e--) i = X.from(r[e].createAndFill(null, i));
	let a = e.state.tr.replace(n.pos, n.pos, new Z(i, 0, 0));
	return a.setSelection(GI.near(a.doc.resolve(n.pos + 1))), e.dispatch(a), !1;
}
function HJ(e) {
	if (!(e.selection instanceof MJ)) return null;
	let t = document.createElement("div");
	return t.className = "ProseMirror-gapcursor", BV.create(e.doc, [LV.widget(e.selection.head, t, { key: "gapcursor" })]);
}
//#endregion
//#region ../../node_modules/.pnpm/rope-sequence@1.3.4/node_modules/rope-sequence/dist/index.js
var UJ = 200, WJ = function() {};
WJ.prototype.append = function(e) {
	return e.length ? (e = WJ.from(e), !this.length && e || e.length < UJ && this.leafAppend(e) || this.length < UJ && e.leafPrepend(this) || this.appendInner(e)) : this;
}, WJ.prototype.prepend = function(e) {
	return e.length ? WJ.from(e).append(this) : this;
}, WJ.prototype.appendInner = function(e) {
	return new KJ(this, e);
}, WJ.prototype.slice = function(e, t) {
	return e === void 0 && (e = 0), t === void 0 && (t = this.length), e >= t ? WJ.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, t));
}, WJ.prototype.get = function(e) {
	if (!(e < 0 || e >= this.length)) return this.getInner(e);
}, WJ.prototype.forEach = function(e, t, n) {
	t === void 0 && (t = 0), n === void 0 && (n = this.length), t <= n ? this.forEachInner(e, t, n, 0) : this.forEachInvertedInner(e, t, n, 0);
}, WJ.prototype.map = function(e, t, n) {
	t === void 0 && (t = 0), n === void 0 && (n = this.length);
	var r = [];
	return this.forEach(function(t, n) {
		return r.push(e(t, n));
	}, t, n), r;
}, WJ.from = function(e) {
	return e instanceof WJ ? e : e && e.length ? new GJ(e) : WJ.empty;
};
var GJ = /* @__PURE__ */ function(e) {
	function t(t) {
		e.call(this), this.values = t;
	}
	e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t;
	var n = {
		length: { configurable: !0 },
		depth: { configurable: !0 }
	};
	return t.prototype.flatten = function() {
		return this.values;
	}, t.prototype.sliceInner = function(e, n) {
		return e == 0 && n == this.length ? this : new t(this.values.slice(e, n));
	}, t.prototype.getInner = function(e) {
		return this.values[e];
	}, t.prototype.forEachInner = function(e, t, n, r) {
		for (var i = t; i < n; i++) if (e(this.values[i], r + i) === !1) return !1;
	}, t.prototype.forEachInvertedInner = function(e, t, n, r) {
		for (var i = t - 1; i >= n; i--) if (e(this.values[i], r + i) === !1) return !1;
	}, t.prototype.leafAppend = function(e) {
		if (this.length + e.length <= UJ) return new t(this.values.concat(e.flatten()));
	}, t.prototype.leafPrepend = function(e) {
		if (this.length + e.length <= UJ) return new t(e.flatten().concat(this.values));
	}, n.length.get = function() {
		return this.values.length;
	}, n.depth.get = function() {
		return 0;
	}, Object.defineProperties(t.prototype, n), t;
}(WJ);
WJ.empty = new GJ([]);
var KJ = /* @__PURE__ */ function(e) {
	function t(t, n) {
		e.call(this), this.left = t, this.right = n, this.length = t.length + n.length, this.depth = Math.max(t.depth, n.depth) + 1;
	}
	return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.flatten = function() {
		return this.left.flatten().concat(this.right.flatten());
	}, t.prototype.getInner = function(e) {
		return e < this.left.length ? this.left.get(e) : this.right.get(e - this.left.length);
	}, t.prototype.forEachInner = function(e, t, n, r) {
		var i = this.left.length;
		if (t < i && this.left.forEachInner(e, t, Math.min(n, i), r) === !1 || n > i && this.right.forEachInner(e, Math.max(t - i, 0), Math.min(this.length, n) - i, r + i) === !1) return !1;
	}, t.prototype.forEachInvertedInner = function(e, t, n, r) {
		var i = this.left.length;
		if (t > i && this.right.forEachInvertedInner(e, t - i, Math.max(n, i) - i, r + i) === !1 || n < i && this.left.forEachInvertedInner(e, Math.min(t, i), n, r) === !1) return !1;
	}, t.prototype.sliceInner = function(e, t) {
		if (e == 0 && t == this.length) return this;
		var n = this.left.length;
		return t <= n ? this.left.slice(e, t) : e >= n ? this.right.slice(e - n, t - n) : this.left.slice(e, n).append(this.right.slice(0, t - n));
	}, t.prototype.leafAppend = function(e) {
		var n = this.right.leafAppend(e);
		if (n) return new t(this.left, n);
	}, t.prototype.leafPrepend = function(e) {
		var n = this.left.leafPrepend(e);
		if (n) return new t(n, this.right);
	}, t.prototype.appendInner = function(e) {
		return this.left.depth >= Math.max(this.right.depth, e.depth) + 1 ? new t(this.left, new t(this.right, e)) : new t(this, e);
	}, t;
}(WJ), qJ = 500, JJ = class e {
	constructor(e, t) {
		this.items = e, this.eventCount = t;
	}
	popEvent(t, n) {
		if (this.eventCount == 0) return null;
		let r = this.items.length;
		for (;; r--) if (this.items.get(r - 1).selection) {
			--r;
			break;
		}
		let i, a;
		n && (i = this.remapping(r, this.items.length), a = i.maps.length);
		let o = t.tr, s, c, l = [], u = [];
		return this.items.forEach((t, n) => {
			if (!t.step) {
				i || (i = this.remapping(r, n + 1), a = i.maps.length), a--, u.push(t);
				return;
			}
			if (i) {
				u.push(new XJ(t.map));
				let e = t.step.map(i.slice(a)), n;
				e && o.maybeStep(e).doc && (n = o.mapping.maps[o.mapping.maps.length - 1], l.push(new XJ(n, void 0, void 0, l.length + u.length))), a--, n && i.appendMap(n, a);
			} else o.maybeStep(t.step);
			if (t.selection) return s = i ? t.selection.map(i.slice(a)) : t.selection, c = new e(this.items.slice(0, r).append(u.reverse().concat(l)), this.eventCount - 1), !1;
		}, this.items.length, 0), {
			remaining: c,
			transform: o,
			selection: s
		};
	}
	addTransform(t, n, r, i) {
		let a = [], o = this.eventCount, s = this.items, c = !i && s.length ? s.get(s.length - 1) : null;
		for (let e = 0; e < t.steps.length; e++) {
			let r = t.steps[e].invert(t.docs[e]), l = new XJ(t.mapping.maps[e], r, n), u;
			(u = c && c.merge(l)) && (l = u, e ? a.pop() : s = s.slice(0, s.length - 1)), a.push(l), n &&= (o++, void 0), i || (c = l);
		}
		let l = o - r.depth;
		return l > QJ && (s = YJ(s, l), o -= l), new e(s.append(a), o);
	}
	remapping(e, t) {
		let n = new RF();
		return this.items.forEach((t, r) => {
			let i = t.mirrorOffset != null && r - t.mirrorOffset >= e ? n.maps.length - t.mirrorOffset : void 0;
			n.appendMap(t.map, i);
		}, e, t), n;
	}
	addMaps(t) {
		return this.eventCount == 0 ? this : new e(this.items.append(t.map((e) => new XJ(e))), this.eventCount);
	}
	rebased(t, n) {
		if (!this.eventCount) return this;
		let r = [], i = Math.max(0, this.items.length - n), a = t.mapping, o = t.steps.length, s = this.eventCount;
		this.items.forEach((e) => {
			e.selection && s--;
		}, i);
		let c = n;
		this.items.forEach((e) => {
			let n = a.getMirror(--c);
			if (n == null) return;
			o = Math.min(o, n);
			let i = a.maps[n];
			if (e.step) {
				let o = t.steps[n].invert(t.docs[n]), l = e.selection && e.selection.map(a.slice(c + 1, n));
				l && s++, r.push(new XJ(i, o, l));
			} else r.push(new XJ(i));
		}, i);
		let l = [];
		for (let e = n; e < o; e++) l.push(new XJ(a.maps[e]));
		let u = this.items.slice(0, i).append(l).append(r), d = new e(u, s);
		return d.emptyItemCount() > qJ && (d = d.compress(this.items.length - r.length)), d;
	}
	emptyItemCount() {
		let e = 0;
		return this.items.forEach((t) => {
			t.step || e++;
		}), e;
	}
	compress(t = this.items.length) {
		let n = this.remapping(0, t), r = n.maps.length, i = [], a = 0;
		return this.items.forEach((e, o) => {
			if (o >= t) i.push(e), e.selection && a++;
			else if (e.step) {
				let t = e.step.map(n.slice(r)), o = t && t.getMap();
				if (r--, o && n.appendMap(o, r), t) {
					let s = e.selection && e.selection.map(n.slice(r));
					s && a++;
					let c = new XJ(o.invert(), t, s), l, u = i.length - 1;
					(l = i.length && i[u].merge(c)) ? i[u] = l : i.push(c);
				}
			} else e.map && r--;
		}, this.items.length, 0), new e(WJ.from(i.reverse()), a);
	}
};
JJ.empty = new JJ(WJ.empty, 0);
function YJ(e, t) {
	let n;
	return e.forEach((e, r) => {
		if (e.selection && t-- == 0) return n = r, !1;
	}), e.slice(n);
}
var XJ = class e {
	constructor(e, t, n, r) {
		this.map = e, this.step = t, this.selection = n, this.mirrorOffset = r;
	}
	merge(t) {
		if (this.step && t.step && !t.selection) {
			let n = t.step.merge(this.step);
			if (n) return new e(n.getMap().invert(), n, this.selection);
		}
	}
}, ZJ = class {
	constructor(e, t, n, r, i) {
		this.done = e, this.undone = t, this.prevRanges = n, this.prevTime = r, this.prevComposition = i;
	}
}, QJ = 20;
function $J(e, t, n, r) {
	let i = n.getMeta(sY), a;
	if (i) return i.historyState;
	n.getMeta(cY) && (e = new ZJ(e.done, e.undone, null, 0, -1));
	let o = n.getMeta("appendedTransaction");
	if (n.steps.length == 0) return e;
	if (o && o.getMeta(sY)) return o.getMeta(sY).redo ? new ZJ(e.done.addTransform(n, void 0, r, oY(t)), e.undone, tY(n.mapping.maps), e.prevTime, e.prevComposition) : new ZJ(e.done, e.undone.addTransform(n, void 0, r, oY(t)), null, e.prevTime, e.prevComposition);
	if (n.getMeta("addToHistory") !== !1 && !(o && o.getMeta("addToHistory") === !1)) {
		let i = n.getMeta("composition"), a = e.prevTime == 0 || !o && e.prevComposition != i && (e.prevTime < (n.time || 0) - r.newGroupDelay || !eY(n, e.prevRanges)), s = o ? nY(e.prevRanges, n.mapping) : tY(n.mapping.maps);
		return new ZJ(e.done.addTransform(n, a ? t.selection.getBookmark() : void 0, r, oY(t)), JJ.empty, s, n.time, i ?? e.prevComposition);
	}
	return (a = n.getMeta("rebased")) ? new ZJ(e.done.rebased(n, a), e.undone.rebased(n, a), nY(e.prevRanges, n.mapping), e.prevTime, e.prevComposition) : new ZJ(e.done.addMaps(n.mapping.maps), e.undone.addMaps(n.mapping.maps), nY(e.prevRanges, n.mapping), e.prevTime, e.prevComposition);
}
function eY(e, t) {
	if (!t) return !1;
	if (!e.docChanged) return !0;
	let n = !1;
	return e.mapping.maps[0].forEach((e, r) => {
		for (let i = 0; i < t.length; i += 2) e <= t[i + 1] && r >= t[i] && (n = !0);
	}), n;
}
function tY(e) {
	let t = [];
	for (let n = e.length - 1; n >= 0 && t.length == 0; n--) e[n].forEach((e, n, r, i) => t.push(r, i));
	return t;
}
function nY(e, t) {
	if (!e) return null;
	let n = [];
	for (let r = 0; r < e.length; r += 2) {
		let i = t.map(e[r], 1), a = t.map(e[r + 1], -1);
		i <= a && n.push(i, a);
	}
	return n;
}
function rY(e, t, n) {
	let r = oY(t), i = sY.get(t).spec.config, a = (n ? e.undone : e.done).popEvent(t, r);
	if (!a) return null;
	let o = a.selection.resolve(a.transform.doc), s = (n ? e.done : e.undone).addTransform(a.transform, t.selection.getBookmark(), i, r), c = new ZJ(n ? s : a.remaining, n ? a.remaining : s, null, 0, -1);
	return a.transform.setSelection(o).setMeta(sY, {
		redo: n,
		historyState: c
	});
}
var iY = !1, aY = null;
function oY(e) {
	let t = e.plugins;
	if (aY != t) {
		iY = !1, aY = t;
		for (let e = 0; e < t.length; e++) if (t[e].spec.historyPreserveItems) {
			iY = !0;
			break;
		}
	}
	return iY;
}
var sY = new fL("history"), cY = new fL("closeHistory");
function lY(e = {}) {
	return e = {
		depth: e.depth || 100,
		newGroupDelay: e.newGroupDelay || 500
	}, new lL({
		key: sY,
		state: {
			init() {
				return new ZJ(JJ.empty, JJ.empty, null, 0, -1);
			},
			apply(t, n, r) {
				return $J(n, r, t, e);
			}
		},
		config: e,
		props: { handleDOMEvents: { beforeinput(e, t) {
			let n = t.inputType, r = n == "historyUndo" ? dY : n == "historyRedo" ? fY : null;
			return r ? (t.preventDefault(), r(e.state, e.dispatch)) : !1;
		} } }
	});
}
function uY(e, t) {
	return (n, r) => {
		let i = sY.getState(n);
		if (!i || (e ? i.undone : i.done).eventCount == 0) return !1;
		if (r) {
			let a = rY(i, n, e);
			a && r(t ? a.scrollIntoView() : a);
		}
		return !0;
	};
}
var dY = uY(!1, !0), fY = uY(!0, !0);
nK.create({
	name: "characterCount",
	addOptions() {
		return {
			limit: null,
			autoTrim: !0,
			mode: "textSize",
			textCounter: (e) => e.length,
			wordCounter: (e) => e.split(" ").filter((e) => e !== "").length
		};
	},
	addStorage() {
		return {
			characters: () => 0,
			words: () => 0
		};
	},
	onBeforeCreate() {
		this.storage.characters = (e) => {
			let t = e?.node || this.editor.state.doc;
			if ((e?.mode || this.options.mode) === "textSize") {
				let e = t.textBetween(0, t.content.size, void 0, " ");
				return this.options.textCounter(e);
			}
			return t.nodeSize;
		}, this.storage.words = (e) => {
			let t = e?.node || this.editor.state.doc, n = t.textBetween(0, t.content.size, " ", " ");
			return this.options.wordCounter(n);
		};
	},
	addProseMirrorPlugins() {
		let e = !1;
		return [new lL({
			key: new fL("characterCount"),
			appendTransaction: (t, n, r) => {
				if (e) return;
				let i = this.options.limit, a = this.options.autoTrim;
				if (i == null || i === 0 || a === !1) {
					e = !0;
					return;
				}
				let o = this.storage.characters({ node: r.doc });
				if (o > i) {
					let t = o - i;
					console.warn(`[CharacterCount] Initial content exceeded limit of ${i} characters. Content was automatically trimmed.`);
					let n = r.tr.deleteRange(0, t);
					return e = !0, n;
				}
				e = !0;
			},
			filterTransaction: (e, t) => {
				let n = this.options.limit;
				if (!e.docChanged || n === 0 || n == null) return !0;
				let r = this.storage.characters({ node: t.doc }), i = this.storage.characters({ node: e.doc });
				if (i <= n || r > n && i > n && i <= r) return !0;
				if (r > n && i > n && i > r || !e.getMeta("paste")) return !1;
				let a = e.selection.$head.pos, o = a - (i - n), s = a;
				return e.deleteRange(o, s), !(this.storage.characters({ node: e.doc }) > n);
			}
		})];
	}
});
var pY = nK.create({
	name: "dropCursor",
	addOptions() {
		return {
			color: "currentColor",
			width: 1,
			class: void 0
		};
	},
	addProseMirrorPlugins() {
		return [AJ(this.options)];
	}
});
nK.create({
	name: "focus",
	addOptions() {
		return {
			className: "has-focus",
			mode: "all"
		};
	},
	addProseMirrorPlugins() {
		return [new lL({
			key: new fL("focus"),
			props: { decorations: ({ doc: e, selection: t }) => {
				let { isEditable: n, isFocused: r } = this.editor, { anchor: i } = t, a = [];
				if (!n || !r) return BV.create(e, []);
				let o = 0;
				this.options.mode === "deepest" && e.descendants((e, t) => {
					if (!e.isText) {
						if (!(i >= t && i <= t + e.nodeSize - 1)) return !1;
						o += 1;
					}
				});
				let s = 0;
				return e.descendants((e, t) => {
					if (e.isText || !(i >= t && i <= t + e.nodeSize - 1)) return !1;
					if (s += 1, this.options.mode === "deepest" && o - s > 0 || this.options.mode === "shallowest" && s > 1) return this.options.mode === "deepest";
					a.push(LV.node(t, t + e.nodeSize, { class: this.options.className }));
				}), BV.create(e, a);
			} }
		})];
	}
});
var mY = nK.create({
	name: "gapCursor",
	addProseMirrorPlugins() {
		return [LJ()];
	},
	extendNodeSchema(e) {
		return { allowGapCursor: mW(Q(e, "allowGapCursor", {
			name: e.name,
			options: e.options,
			storage: e.storage
		})) ?? null };
	}
}), hY = "placeholder", gY = new fL("tiptap__placeholder"), _Y = 200;
function vY(e) {
	let { editor: t, placeholder: n, dataAttribute: r, pos: i, node: a, isEmptyDoc: o, hasAnchor: s, classes: { emptyNode: c, emptyEditor: l } } = e, u = [c];
	return o && u.push(l), LV.node(i, i + a.nodeSize, {
		class: u.join(" "),
		[r]: typeof n == "function" ? n({
			editor: t,
			node: a,
			pos: i,
			hasAnchor: s
		}) : n
	});
}
function yY(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function bY({ editor: e, options: t, dataAttribute: n, doc: r, selection: i }) {
	if (!(e.isEditable || !t.showOnlyWhenEditable)) return null;
	let { anchor: a } = i, o = [], s = e.isEmpty;
	if (t.showOnlyCurrent && !t.includeChildren) {
		let i = r.resolve(a), c = i.depth > 0 ? i.node(1) : i.nodeAfter, l = i.depth > 0 ? i.before(1) : a;
		if (c && c.type.isTextblock && YW(c)) {
			let r = a >= l && a <= l + c.nodeSize;
			o.push(vY({
				editor: e,
				isEmptyDoc: s,
				dataAttribute: n,
				hasAnchor: r,
				placeholder: t.placeholder,
				classes: {
					emptyEditor: t.emptyEditorClass,
					emptyNode: yY(t.emptyNodeClass, {
						editor: e,
						node: c,
						pos: l,
						hasAnchor: r
					})
				},
				node: c,
				pos: l
			}));
		}
	} else {
		let i = gY.getState(e.state), c = i?.topPos ?? 0, l = i?.bottomPos ?? r.content.size;
		r.nodesBetween(c, l, (r, i) => {
			let c = a >= i && a <= i + r.nodeSize, l = !r.isLeaf && YW(r);
			return r.type.isTextblock && (c || !t.showOnlyCurrent) && l && o.push(vY({
				editor: e,
				isEmptyDoc: s,
				dataAttribute: n,
				hasAnchor: c,
				placeholder: t.placeholder,
				classes: {
					emptyEditor: t.emptyEditorClass,
					emptyNode: yY(t.emptyNodeClass, {
						editor: e,
						node: r,
						pos: i,
						hasAnchor: c
					})
				},
				node: r,
				pos: i
			})), t.includeChildren;
		});
	}
	return BV.create(r, o);
}
function xY(e) {
	return e.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-]/g, "").replace(/^[0-9-]+/, "").replace(/^-+/, "").toLowerCase();
}
function SY(e) {
	let t = getComputedStyle(e), n = `${t.overflow} ${t.overflowY} ${t.overflowX}`;
	return /auto|scroll|overlay/.test(n);
}
function CY(e) {
	let t = e;
	for (; t;) {
		if (SY(t)) return t;
		let e = t.parentElement;
		if (!e) {
			let e = t.getRootNode();
			if (e instanceof ShadowRoot) {
				t = e.host;
				continue;
			}
			return window;
		}
		t = e;
	}
	return window;
}
function wY(e) {
	return e === window ? {
		top: 0,
		bottom: window.innerHeight
	} : e.getBoundingClientRect();
}
function TY({ view: e, scrollContainer: t }) {
	let n = e.dom.getBoundingClientRect();
	if (n.width <= 0 || n.height <= 0) return null;
	let r = t ? wY(t) : {
		top: 0,
		bottom: window.innerHeight
	}, i = Math.max(n.top, r.top) - _Y, a = Math.min(n.bottom, r.bottom) + _Y;
	if (i >= a) return null;
	let o = n.left + 1, s = n.right - 1;
	if (o > s) return null;
	let c = getComputedStyle(e.dom).direction === "rtl" ? n.right - 2 : n.left + 2, l = Math.min(Math.max(c, o), s), u = Math.max(i + 2, n.top + 1), d = Math.min(a - 2, n.bottom - 1);
	if (u > d) return null;
	let f = e.posAtCoords({
		left: l,
		top: u
	}), p = e.posAtCoords({
		left: l,
		top: d
	});
	return !f || !p ? null : {
		top: f.pos,
		bottom: p.pos
	};
}
var EY = {
	init() {
		return {
			topPos: null,
			bottomPos: null
		};
	},
	apply(e, t) {
		let n = e.getMeta(gY);
		return n?.positions ? {
			topPos: n.positions.top,
			bottomPos: n.positions.bottom
		} : e.docChanged ? {
			topPos: t.topPos === null ? null : e.mapping.map(t.topPos),
			bottomPos: t.bottomPos === null ? null : e.mapping.map(t.bottomPos)
		} : t;
	}
};
function DY(e) {
	let t = CY(e.dom), n = () => {
		let n = TY({
			view: e,
			scrollContainer: t
		});
		if (n === null) return;
		let r = gY.getState(e.state);
		if (r?.topPos === n.top && r?.bottomPos === n.bottom) return;
		let i = e.state.tr.setMeta(gY, { positions: n });
		e.dispatch(i);
	}, r = null, i = 0, a = () => {
		r === null && (r = requestAnimationFrame(() => {
			r = null;
			let e = performance.now();
			e - i >= 150 ? (i = e, n()) : a();
		}));
	};
	t.addEventListener("scroll", a, { passive: !0 });
	let o = typeof ResizeObserver < "u" ? new ResizeObserver(a) : null;
	o?.observe(e.dom);
	let s = typeof IntersectionObserver < "u" ? new IntersectionObserver(a) : null;
	return s?.observe(e.dom), e.dom.addEventListener("focus", a), n(), {
		update(t, n) {
			e.state.doc.content.size !== n.doc.content.size && a();
		},
		destroy: () => {
			r !== null && cancelAnimationFrame(r), t.removeEventListener("scroll", a), o?.disconnect(), s?.disconnect(), e.dom.removeEventListener("focus", a);
		}
	};
}
function OY({ editor: e, options: t }) {
	let n = t.dataAttribute ? `data-${xY(t.dataAttribute)}` : `data-${hY}`;
	return new lL({
		key: gY,
		state: EY,
		view: DY,
		props: { decorations: ({ doc: r, selection: i }) => bY({
			editor: e,
			options: t,
			dataAttribute: n,
			doc: r,
			selection: i
		}) }
	});
}
nK.create({
	name: "placeholder",
	addOptions() {
		return {
			emptyEditorClass: "is-editor-empty",
			emptyNodeClass: "is-empty",
			dataAttribute: hY,
			placeholder: "Write something …",
			showOnlyWhenEditable: !0,
			showOnlyCurrent: !0,
			includeChildren: !1
		};
	},
	addProseMirrorPlugins() {
		return [OY({
			editor: this.editor,
			options: this.options
		})];
	}
});
var kY = ".ProseMirror:not(.ProseMirror-focused) *::selection {\n  background: transparent;\n}\n\n.ProseMirror:not(.ProseMirror-focused) *::-moz-selection {\n  background: transparent;\n}";
nK.create({
	name: "selection",
	addOptions() {
		return { className: "selection" };
	},
	addProseMirrorPlugins() {
		let { editor: e, options: t } = this;
		return e.options.injectCSS && typeof document < "u" && OG(kY, e.options.injectNonce, "selection"), [new lL({
			key: new fL("selection"),
			props: { decorations(n) {
				return n.selection.empty || e.isFocused || !e.isEditable || XW(n.selection) || e.view.dragging ? null : BV.create(n.doc, [LV.inline(n.selection.from, n.selection.to, { class: t.className })]);
			} }
		})];
	}
});
function AY({ types: e, node: t }) {
	return t && Array.isArray(e) && e.includes(t.type) || t?.type === e;
}
nK.create({
	name: "trailingNode",
	addOptions() {
		return {
			node: void 0,
			notAfter: []
		};
	},
	addProseMirrorPlugins() {
		let e = new fL(this.name), t = this.options.node || this.editor.schema.topNodeType.contentMatch.defaultType?.name || "paragraph", n = Object.entries(this.editor.schema.nodes).map(([, e]) => e).filter((e) => (this.options.notAfter || []).concat(t).includes(e.name));
		return [new lL({
			key: e,
			appendTransaction: (n, r, i) => {
				let { doc: a, tr: o, schema: s } = i, c = e.getState(i), l = a.content.size, u = s.nodes[t];
				if (!n.some((e) => e.getMeta("skipTrailingNode")) && c) return o.insert(l, u.create());
			},
			state: {
				init: (e, t) => {
					let r = t.tr.doc.lastChild;
					return !AY({
						node: r,
						types: n
					});
				},
				apply: (e, t) => {
					if (!e.docChanged || e.getMeta("__uniqueIDTransaction")) return t;
					let r = e.doc.lastChild;
					return !AY({
						node: r,
						types: n
					});
				}
			}
		})];
	}
});
var jY = nK.create({
	name: "undoRedo",
	addOptions() {
		return {
			depth: 100,
			newGroupDelay: 500
		};
	},
	addCommands() {
		return {
			undo: () => ({ state: e, dispatch: t }) => dY(e, t),
			redo: () => ({ state: e, dispatch: t }) => fY(e, t)
		};
	},
	addProseMirrorPlugins() {
		return [lY(this.options)];
	},
	addKeyboardShortcuts() {
		return {
			"Mod-z": () => this.editor.commands.undo(),
			"Shift-Mod-z": () => this.editor.commands.redo(),
			"Mod-y": () => this.editor.commands.redo(),
			"Mod-я": () => this.editor.commands.undo(),
			"Shift-Mod-я": () => this.editor.commands.redo()
		};
	}
}), MY = pY, NY = mY, PY = CK.create({
	name: "hardBreak",
	markdownTokenName: "br",
	addOptions() {
		return {
			keepMarks: !0,
			HTMLAttributes: {}
		};
	},
	inline: !0,
	group: "inline",
	selectable: !1,
	linebreakReplacement: !0,
	parseHTML() {
		return [{ tag: "br" }];
	},
	renderHTML({ HTMLAttributes: e }) {
		return ["br", bW(this.options.HTMLAttributes, e)];
	},
	renderText() {
		return "\n";
	},
	renderMarkdown: () => "  \n",
	parseMarkdown: () => ({ type: "hardBreak" }),
	addCommands() {
		return { setHardBreak: () => ({ commands: e, chain: t, state: n, editor: r }) => e.first([() => e.exitCode(), () => e.command(() => {
			let { selection: e, storedMarks: i } = n;
			if (e.$from.parent.type.spec.isolating) return !1;
			let { keepMarks: a } = this.options, { splittableMarks: o } = r.extensionManager, s = i || e.$to.parentOffset && e.$from.marks();
			return t().insertContent({ type: this.name }).command(({ tr: e, dispatch: t }) => {
				if (t && s && a) {
					let t = s.filter((e) => o.includes(e.type.name));
					e.ensureMarks(t);
				}
				return !0;
			}).run();
		})]) };
	},
	addKeyboardShortcuts() {
		return {
			"Mod-Enter": () => this.editor.commands.setHardBreak(),
			"Shift-Enter": () => this.editor.commands.setHardBreak()
		};
	}
}), FY = CK.create({
	name: "heading",
	addOptions() {
		return {
			levels: [
				1,
				2,
				3,
				4,
				5,
				6
			],
			HTMLAttributes: {}
		};
	},
	content: "inline*",
	group: "block",
	defining: !0,
	addAttributes() {
		return { level: {
			default: 1,
			rendered: !1
		} };
	},
	parseHTML() {
		return this.options.levels.map((e) => ({
			tag: `h${e}`,
			attrs: { level: e }
		}));
	},
	renderHTML({ node: e, HTMLAttributes: t }) {
		return [
			`h${this.options.levels.includes(e.attrs.level) ? e.attrs.level : this.options.levels[0]}`,
			bW(this.options.HTMLAttributes, t),
			0
		];
	},
	parseMarkdown: (e, t) => t.createNode("heading", { level: e.depth || 1 }, t.parseInline(e.tokens || [])),
	renderMarkdown: (e, t) => {
		let n = e.attrs?.level ? parseInt(e.attrs.level, 10) : 1, r = "#".repeat(n);
		return e.content ? `${r} ${t.renderChildren(e.content)}` : "";
	},
	addCommands() {
		return {
			setHeading: (e) => ({ commands: t }) => this.options.levels.includes(e.level) ? t.setNode(this.name, e) : !1,
			toggleHeading: (e) => ({ commands: t }) => this.options.levels.includes(e.level) ? t.toggleNode(this.name, "paragraph", e) : !1
		};
	},
	addKeyboardShortcuts() {
		return this.options.levels.reduce((e, t) => ({
			...e,
			[`Mod-Alt-${t}`]: () => this.editor.commands.toggleHeading({ level: t })
		}), {});
	},
	addInputRules() {
		return this.options.levels.map((e) => yK({
			find: RegExp(`^(#{${Math.min(...this.options.levels)},${e}})\\s$`),
			type: this.type,
			getAttributes: { level: e }
		}));
	}
}), IY = jY, LY = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, RY = CK.create({
	name: "image",
	addOptions() {
		return {
			inline: !1,
			allowBase64: !1,
			HTMLAttributes: {},
			resize: !1
		};
	},
	inline() {
		return this.options.inline;
	},
	group() {
		return this.options.inline ? "inline" : "block";
	},
	draggable: !0,
	addAttributes() {
		return {
			src: { default: null },
			alt: { default: null },
			title: { default: null },
			width: { default: null },
			height: { default: null }
		};
	},
	parseHTML() {
		return [{ tag: this.options.allowBase64 ? "img[src]" : "img[src]:not([src^=\"data:\"])" }];
	},
	renderHTML({ HTMLAttributes: e }) {
		return ["img", bW(this.options.HTMLAttributes, e)];
	},
	parseMarkdown: (e, t) => t.createNode("image", {
		src: e.href,
		title: e.title,
		alt: e.text
	}),
	renderMarkdown: (e) => {
		let t = e.attrs?.src ?? "", n = e.attrs?.alt ?? "", r = e.attrs?.title ?? "";
		return r ? `![${n}](${t} "${r}")` : `![${n}](${t})`;
	},
	addNodeView() {
		if (!this.options.resize || !this.options.resize.enabled || typeof document > "u") return null;
		let { directions: e, minWidth: t, minHeight: n, alwaysPreserveAspectRatio: r } = this.options.resize;
		return ({ node: i, getPos: a, HTMLAttributes: o, editor: s }) => {
			let c = document.createElement("img");
			c.draggable = !1;
			let l = bW(this.options.HTMLAttributes, o);
			Object.entries(l).forEach(([e, t]) => {
				if (t != null) switch (e) {
					case "width":
					case "height": break;
					default: c.setAttribute(e, t);
				}
			}), l.src !== null && (c.src = l.src);
			let u = new SK({
				element: c,
				editor: s,
				node: i,
				getPos: a,
				onResize: (e, t) => {
					c.style.width = `${e}px`, c.style.height = `${t}px`;
				},
				onCommit: (e, t) => {
					let n = a();
					n !== void 0 && this.editor.chain().setNodeSelection(n).updateAttributes(this.name, {
						width: e,
						height: t
					}).run();
				},
				onUpdate: (e, t, n) => e.type === i.type,
				options: {
					directions: e,
					min: {
						width: t,
						height: n
					},
					preserveAspectRatio: r === !0
				}
			}), d = u.dom;
			return d.style.visibility = "hidden", d.style.pointerEvents = "none", c.onload = () => {
				d.style.visibility = "", d.style.pointerEvents = "";
			}, u;
		};
	},
	addCommands() {
		return { setImage: (e) => ({ commands: t }) => t.insertContent({
			type: this.name,
			attrs: e
		}) };
	},
	addInputRules() {
		return [vK({
			find: LY,
			type: this.type,
			getAttributes: (e) => {
				let [, , t, n, r] = e;
				return {
					src: n,
					alt: t,
					title: r
				};
			}
		})];
	}
}), zY = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, BY = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, VY = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, HY = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, UY = JG.create({
	name: "italic",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	parseHTML() {
		return [
			{ tag: "em" },
			{
				tag: "i",
				getAttrs: (e) => e.style.fontStyle !== "normal" && null
			},
			{
				style: "font-style=normal",
				clearMark: (e) => e.type.name === this.name
			},
			{ style: "font-style=italic" }
		];
	},
	renderHTML({ HTMLAttributes: e }) {
		return [
			"em",
			bW(this.options.HTMLAttributes, e),
			0
		];
	},
	addCommands() {
		return {
			setItalic: () => ({ commands: e }) => e.setMark(this.name),
			toggleItalic: () => ({ commands: e }) => e.toggleMark(this.name),
			unsetItalic: () => ({ commands: e }) => e.unsetMark(this.name)
		};
	},
	markdownTokenName: "em",
	parseMarkdown: (e, t) => t.applyMark("italic", t.parseInline(e.tokens || [])),
	markdownOptions: { htmlReopen: {
		open: "<em>",
		close: "</em>"
	} },
	renderMarkdown: (e, t) => `*${t.renderChildren(e)}*`,
	addKeyboardShortcuts() {
		return {
			"Mod-i": () => this.editor.commands.toggleItalic(),
			"Mod-I": () => this.editor.commands.toggleItalic()
		};
	},
	addInputRules() {
		return [_K({
			find: zY,
			type: this.type
		}), _K({
			find: VY,
			type: this.type
		})];
	},
	addPasteRules() {
		return [wK({
			find: BY,
			type: this.type
		}), wK({
			find: HY,
			type: this.type
		})];
	}
}), WY = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2odyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rck0msd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2oodside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", GY = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", KY = "numeric", qY = "ascii", JY = "alpha", YY = "asciinumeric", XY = "alphanumeric", ZY = "domain", QY = "emoji", $Y = "scheme", eX = "slashscheme", tX = "whitespace";
function nX(e, t) {
	return e in t || (t[e] = []), t[e];
}
function rX(e, t, n) {
	t[KY] && (t[YY] = !0, t[XY] = !0), t[qY] && (t[YY] = !0, t[JY] = !0), t[YY] && (t[XY] = !0), t[JY] && (t[XY] = !0), t[XY] && (t[ZY] = !0), t[QY] && (t[ZY] = !0);
	for (let r in t) {
		let t = nX(r, n);
		t.indexOf(e) < 0 && t.push(e);
	}
}
function iX(e, t) {
	let n = {};
	for (let r in t) t[r].indexOf(e) >= 0 && (n[r] = !0);
	return n;
}
function aX(e = null) {
	this.j = {}, this.jr = [], this.jd = null, this.t = e;
}
aX.groups = {}, aX.prototype = {
	accepts() {
		return !!this.t;
	},
	go(e) {
		let t = this, n = t.j[e];
		if (n) return n;
		for (let n = 0; n < t.jr.length; n++) {
			let r = t.jr[n][0], i = t.jr[n][1];
			if (i && r.test(e)) return i;
		}
		return t.jd;
	},
	has(e, t = !1) {
		return t ? e in this.j : !!this.go(e);
	},
	ta(e, t, n, r) {
		for (let i = 0; i < e.length; i++) this.tt(e[i], t, n, r);
	},
	tr(e, t, n, r) {
		r ||= aX.groups;
		let i;
		return t && t.j ? i = t : (i = new aX(t), n && r && rX(t, n, r)), this.jr.push([e, i]), i;
	},
	ts(e, t, n, r) {
		let i = this, a = e.length;
		if (!a) return i;
		for (let t = 0; t < a - 1; t++) i = i.tt(e[t]);
		return i.tt(e[a - 1], t, n, r);
	},
	tt(e, t, n, r) {
		r ||= aX.groups;
		let i = this;
		if (t && t.j) return i.j[e] = t, t;
		let a = t, o, s = i.go(e);
		return s ? (o = new aX(), Object.assign(o.j, s.j), o.jr.push.apply(o.jr, s.jr), o.jd = s.jd, o.t = s.t) : o = new aX(), a && (r && (o.t && typeof o.t == "string" ? rX(a, Object.assign(iX(o.t, r), n), r) : n && rX(a, n, r)), o.t = a), i.j[e] = o, o;
	}
};
var oX = (e, t, n, r, i) => e.ta(t, n, r, i), sX = (e, t, n, r, i) => e.tr(t, n, r, i), cX = (e, t, n, r, i) => e.ts(t, n, r, i), $ = (e, t, n, r, i) => e.tt(t, n, r, i), lX = "WORD", uX = "UWORD", dX = "ASCIINUMERICAL", fX = "ALPHANUMERICAL", pX = "LOCALHOST", mX = "TLD", hX = "UTLD", gX = "SCHEME", _X = "SLASH_SCHEME", vX = "NUM", yX = "WS", bX = "NL", xX = "OPENBRACE", SX = "CLOSEBRACE", CX = "OPENBRACKET", wX = "CLOSEBRACKET", TX = "OPENPAREN", EX = "CLOSEPAREN", DX = "OPENANGLEBRACKET", OX = "CLOSEANGLEBRACKET", kX = "FULLWIDTHLEFTPAREN", AX = "FULLWIDTHRIGHTPAREN", jX = "LEFTCORNERBRACKET", MX = "RIGHTCORNERBRACKET", NX = "LEFTWHITECORNERBRACKET", PX = "RIGHTWHITECORNERBRACKET", FX = "FULLWIDTHLESSTHAN", IX = "FULLWIDTHGREATERTHAN", LX = "AMPERSAND", RX = "APOSTROPHE", zX = "ASTERISK", BX = "AT", VX = "BACKSLASH", HX = "BACKTICK", UX = "CARET", WX = "COLON", GX = "COMMA", KX = "DOLLAR", qX = "DOT", JX = "EQUALS", YX = "EXCLAMATION", XX = "HYPHEN", ZX = "PERCENT", QX = "PIPE", $X = "PLUS", eZ = "POUND", tZ = "QUERY", nZ = "QUOTE", rZ = "FULLWIDTHMIDDLEDOT", iZ = "SEMI", aZ = "SLASH", oZ = "TILDE", sZ = "UNDERSCORE", cZ = "EMOJI", lZ = "SYM", uZ = /*#__PURE__*/ Object.freeze({
	__proto__: null,
	ALPHANUMERICAL: fX,
	AMPERSAND: LX,
	APOSTROPHE: RX,
	ASCIINUMERICAL: dX,
	ASTERISK: zX,
	AT: BX,
	BACKSLASH: VX,
	BACKTICK: HX,
	CARET: UX,
	CLOSEANGLEBRACKET: OX,
	CLOSEBRACE: SX,
	CLOSEBRACKET: wX,
	CLOSEPAREN: EX,
	COLON: WX,
	COMMA: GX,
	DOLLAR: KX,
	DOT: qX,
	EMOJI: cZ,
	EQUALS: JX,
	EXCLAMATION: YX,
	FULLWIDTHGREATERTHAN: IX,
	FULLWIDTHLEFTPAREN: kX,
	FULLWIDTHLESSTHAN: FX,
	FULLWIDTHMIDDLEDOT: rZ,
	FULLWIDTHRIGHTPAREN: AX,
	HYPHEN: XX,
	LEFTCORNERBRACKET: jX,
	LEFTWHITECORNERBRACKET: NX,
	LOCALHOST: pX,
	NL: bX,
	NUM: vX,
	OPENANGLEBRACKET: DX,
	OPENBRACE: xX,
	OPENBRACKET: CX,
	OPENPAREN: TX,
	PERCENT: ZX,
	PIPE: QX,
	PLUS: $X,
	POUND: eZ,
	QUERY: tZ,
	QUOTE: nZ,
	RIGHTCORNERBRACKET: MX,
	RIGHTWHITECORNERBRACKET: PX,
	SCHEME: gX,
	SEMI: iZ,
	SLASH: aZ,
	SLASH_SCHEME: _X,
	SYM: lZ,
	TILDE: oZ,
	TLD: mX,
	UNDERSCORE: sZ,
	UTLD: hX,
	UWORD: uX,
	WORD: lX,
	WS: yX
}), dZ = /[a-z]/, fZ = /\p{L}/u, pZ = /\p{Emoji}/u, mZ = /\d/, hZ = /\s/, gZ = "\r", _Z = "\n", vZ = "️", yZ = "‍", bZ = "￼", xZ = null, SZ = null;
function CZ(e = []) {
	let t = {};
	aX.groups = t;
	let n = new aX();
	xZ ??= DZ(WY), SZ ??= DZ(GY), $(n, "'", RX), $(n, "{", xX), $(n, "}", SX), $(n, "[", CX), $(n, "]", wX), $(n, "(", TX), $(n, ")", EX), $(n, "<", DX), $(n, ">", OX), $(n, "（", kX), $(n, "）", AX), $(n, "「", jX), $(n, "」", MX), $(n, "『", NX), $(n, "』", PX), $(n, "＜", FX), $(n, "＞", IX), $(n, "&", LX), $(n, "*", zX), $(n, "@", BX), $(n, "`", HX), $(n, "^", UX), $(n, ":", WX), $(n, ",", GX), $(n, "$", KX), $(n, ".", qX), $(n, "=", JX), $(n, "!", YX), $(n, "-", XX), $(n, "%", ZX), $(n, "|", QX), $(n, "+", $X), $(n, "#", eZ), $(n, "?", tZ), $(n, "\"", nZ), $(n, "/", aZ), $(n, ";", iZ), $(n, "~", oZ), $(n, "_", sZ), $(n, "\\", VX), $(n, "・", rZ);
	let r = sX(n, mZ, vX, { [KY]: !0 });
	sX(r, mZ, r);
	let i = sX(r, dZ, dX, { [YY]: !0 }), a = sX(r, fZ, fX, { [XY]: !0 }), o = sX(n, dZ, lX, { [qY]: !0 });
	sX(o, mZ, i), sX(o, dZ, o), sX(i, mZ, i), sX(i, dZ, i);
	let s = sX(n, fZ, uX, { [JY]: !0 });
	sX(s, dZ), sX(s, mZ, a), sX(s, fZ, s), sX(a, mZ, a), sX(a, dZ), sX(a, fZ, a);
	let c = $(n, _Z, bX, { [tX]: !0 }), l = $(n, gZ, yX, { [tX]: !0 }), u = sX(n, hZ, yX, { [tX]: !0 });
	$(n, bZ, u), $(l, _Z, c), $(l, bZ, u), sX(l, hZ, u), $(u, gZ), $(u, _Z), sX(u, hZ, u), $(u, bZ, u);
	let d = sX(n, pZ, cZ, { [QY]: !0 });
	$(d, "#"), sX(d, pZ, d), $(d, vZ, d);
	let f = $(d, yZ);
	$(f, "#"), sX(f, pZ, d);
	let p = [[dZ, o], [mZ, i]], m = [
		[dZ, null],
		[fZ, s],
		[mZ, a]
	];
	for (let e = 0; e < xZ.length; e++) EZ(n, xZ[e], mX, lX, p);
	for (let e = 0; e < SZ.length; e++) EZ(n, SZ[e], hX, uX, m);
	rX(mX, {
		tld: !0,
		ascii: !0
	}, t), rX(hX, {
		utld: !0,
		alpha: !0
	}, t), EZ(n, "file", gX, lX, p), EZ(n, "mailto", gX, lX, p), EZ(n, "http", _X, lX, p), EZ(n, "https", _X, lX, p), EZ(n, "ftp", _X, lX, p), EZ(n, "ftps", _X, lX, p), rX(gX, {
		scheme: !0,
		ascii: !0
	}, t), rX(_X, {
		slashscheme: !0,
		ascii: !0
	}, t), e = e.sort((e, t) => e[0] > t[0] ? 1 : -1);
	for (let t = 0; t < e.length; t++) {
		let r = e[t][0], i = e[t][1] ? { [$Y]: !0 } : { [eX]: !0 };
		r.indexOf("-") >= 0 ? i[ZY] = !0 : dZ.test(r) ? mZ.test(r) ? i[YY] = !0 : i[qY] = !0 : i[KY] = !0, cX(n, r, r, i);
	}
	return cX(n, "localhost", pX, { ascii: !0 }), n.jd = new aX(lZ), {
		start: n,
		tokens: Object.assign({ groups: t }, uZ)
	};
}
function wZ(e, t) {
	let n = TZ(t.replace(/[A-Z]/g, (e) => e.toLowerCase())), r = n.length, i = [], a = 0, o = 0;
	for (; o < r;) {
		let s = e, c = null, l = 0, u = null, d = -1, f = -1;
		for (; o < r && (c = s.go(n[o]));) s = c, s.accepts() ? (d = 0, f = 0, u = s) : d >= 0 && (d += n[o].length, f++), l += n[o].length, a += n[o].length, o++;
		a -= d, o -= f, l -= d, i.push({
			t: u.t,
			v: t.slice(a - l, a),
			s: a - l,
			e: a
		});
	}
	return i;
}
function TZ(e) {
	let t = [], n = e.length, r = 0;
	for (; r < n;) {
		let i = e.charCodeAt(r), a, o = i < 55296 || i > 56319 || r + 1 === n || (a = e.charCodeAt(r + 1)) < 56320 || a > 57343 ? e[r] : e.slice(r, r + 2);
		t.push(o), r += o.length;
	}
	return t;
}
function EZ(e, t, n, r, i) {
	let a, o = t.length;
	for (let n = 0; n < o - 1; n++) {
		let o = t[n];
		e.j[o] ? a = e.j[o] : (a = new aX(r), a.jr = i.slice(), e.j[o] = a), e = a;
	}
	return a = new aX(n), a.jr = i.slice(), e.j[t[o - 1]] = a, a;
}
function DZ(e) {
	let t = [], n = [], r = 0;
	for (; r < e.length;) {
		let i = 0;
		for (; "0123456789".indexOf(e[r + i]) >= 0;) i++;
		if (i > 0) {
			t.push(n.join(""));
			for (let t = parseInt(e.substring(r, r + i), 10); t > 0; t--) n.pop();
			r += i;
		} else n.push(e[r]), r++;
	}
	return t;
}
var OZ = {
	defaultProtocol: "http",
	events: null,
	format: AZ,
	formatHref: AZ,
	nl2br: !1,
	tagName: "a",
	target: null,
	rel: null,
	validate: !0,
	truncate: Infinity,
	className: null,
	attributes: null,
	ignoreTags: [],
	render: null
};
function kZ(e, t = null) {
	let n = Object.assign({}, OZ);
	e && (n = Object.assign(n, e instanceof kZ ? e.o : e));
	let r = n.ignoreTags, i = [];
	for (let e = 0; e < r.length; e++) i.push(r[e].toUpperCase());
	this.o = n, t && (this.defaultRender = t), this.ignoreTags = i;
}
kZ.prototype = {
	o: OZ,
	ignoreTags: [],
	defaultRender(e) {
		return e;
	},
	check(e) {
		return this.get("validate", e.toString(), e);
	},
	get(e, t, n) {
		let r = t != null, i = this.o[e];
		return i && (typeof i == "object" ? (i = n.t in i ? i[n.t] : OZ[e], typeof i == "function" && r && (i = i(t, n))) : typeof i == "function" && r && (i = i(t, n.t, n)), i);
	},
	getObj(e, t, n) {
		let r = this.o[e];
		return typeof r == "function" && t != null && (r = r(t, n.t, n)), r;
	},
	render(e) {
		let t = e.render(this);
		return (this.get("render", null, e) || this.defaultRender)(t, e.t, e);
	}
};
function AZ(e) {
	return e;
}
function jZ(e, t) {
	this.t = "token", this.v = e, this.tk = t;
}
jZ.prototype = {
	isLink: !1,
	toString() {
		return this.v;
	},
	toHref(e) {
		return this.toString();
	},
	toFormattedString(e) {
		let t = this.toString(), n = e.get("truncate", t, this), r = e.get("format", t, this);
		return n && r.length > n ? r.substring(0, n) + "…" : r;
	},
	toFormattedHref(e) {
		return e.get("formatHref", this.toHref(e.get("defaultProtocol")), this);
	},
	startIndex() {
		return this.tk[0].s;
	},
	endIndex() {
		return this.tk[this.tk.length - 1].e;
	},
	toObject(e = OZ.defaultProtocol) {
		return {
			type: this.t,
			value: this.toString(),
			isLink: this.isLink,
			href: this.toHref(e),
			start: this.startIndex(),
			end: this.endIndex()
		};
	},
	toFormattedObject(e) {
		return {
			type: this.t,
			value: this.toFormattedString(e),
			isLink: this.isLink,
			href: this.toFormattedHref(e),
			start: this.startIndex(),
			end: this.endIndex()
		};
	},
	validate(e) {
		return e.get("validate", this.toString(), this);
	},
	render(e) {
		let t = this, n = this.toHref(e.get("defaultProtocol")), r = e.get("formatHref", n, this), i = e.get("tagName", n, t), a = this.toFormattedString(e), o = {}, s = e.get("className", n, t), c = e.get("target", n, t), l = e.get("rel", n, t), u = e.getObj("attributes", n, t), d = e.getObj("events", n, t);
		return o.href = r, s && (o.class = s), c && (o.target = c), l && (o.rel = l), u && Object.assign(o, u), {
			tagName: i,
			attributes: o,
			content: a,
			eventListeners: d
		};
	}
};
function MZ(e, t) {
	class n extends jZ {
		constructor(t, n) {
			super(t, n), this.t = e;
		}
	}
	for (let e in t) n.prototype[e] = t[e];
	return n.t = e, n;
}
var NZ = MZ("email", {
	isLink: !0,
	toHref() {
		return "mailto:" + this.toString();
	}
}), PZ = MZ("text"), FZ = MZ("nl"), IZ = MZ("url", {
	isLink: !0,
	toHref(e = OZ.defaultProtocol) {
		return this.hasProtocol() ? this.v : `${e}://${this.v}`;
	},
	hasProtocol() {
		let e = this.tk;
		return e.length >= 2 && e[0].t !== pX && e[1].t === WX;
	}
}), LZ = (e) => new aX(e);
function RZ({ groups: e }) {
	let t = e.domain.concat([
		LX,
		zX,
		BX,
		VX,
		HX,
		UX,
		KX,
		JX,
		XX,
		vX,
		ZX,
		QX,
		$X,
		eZ,
		aZ,
		lZ,
		oZ,
		sZ
	]), n = [
		RX,
		WX,
		GX,
		qX,
		YX,
		ZX,
		tZ,
		nZ,
		iZ,
		DX,
		OX,
		xX,
		SX,
		wX,
		CX,
		TX,
		EX,
		kX,
		AX,
		jX,
		MX,
		NX,
		PX,
		FX,
		IX
	], r = [
		LX,
		RX,
		zX,
		VX,
		HX,
		UX,
		KX,
		JX,
		XX,
		xX,
		SX,
		ZX,
		QX,
		$X,
		eZ,
		tZ,
		aZ,
		lZ,
		oZ,
		sZ
	], i = LZ(), a = $(i, oZ);
	oX(a, r, a), oX(a, e.domain, a);
	let o = LZ(), s = LZ(), c = LZ();
	oX(i, e.domain, o), oX(i, e.scheme, s), oX(i, e.slashscheme, c), oX(o, r, a), oX(o, e.domain, o);
	let l = $(o, BX);
	$(a, BX, l), $(s, BX, l), $(c, BX, l);
	let u = $(a, qX);
	oX(u, r, a), oX(u, e.domain, a);
	let d = LZ();
	oX(l, e.domain, d), oX(d, e.domain, d);
	let f = $(d, qX);
	oX(f, e.domain, d);
	let p = LZ(NZ);
	oX(f, e.tld, p), oX(f, e.utld, p), $(l, pX, p);
	let m = $(d, XX);
	$(m, XX, m), oX(m, e.domain, d), oX(p, e.domain, d), $(p, qX, f), $(p, XX, m);
	let h = $(o, XX), g = $(o, qX);
	$(h, XX, h), oX(h, e.domain, o), oX(g, r, a), oX(g, e.domain, o);
	let _ = LZ(IZ);
	oX(g, e.tld, _), oX(g, e.utld, _), oX(_, e.domain, o), oX(_, r, a), $(_, qX, g), $(_, XX, h), $(_, BX, l);
	let v = $(_, WX), y = LZ(IZ);
	oX(v, e.numeric, y);
	let b = LZ(IZ), x = LZ();
	oX(b, t, b), oX(b, n, x), oX(x, t, b), oX(x, n, x), $(_, aZ, b), $(y, aZ, b);
	let S = $(s, WX), C = $($($(c, WX), aZ), aZ);
	oX(s, e.domain, o), $(s, qX, g), $(s, XX, h), oX(c, e.domain, o), $(c, qX, g), $(c, XX, h), oX(S, e.domain, b), $(S, aZ, b), $(S, tZ, b), oX(C, e.domain, b), oX(C, t, b), $(C, aZ, b);
	let w = [
		[xX, SX],
		[CX, wX],
		[TX, EX],
		[DX, OX],
		[kX, AX],
		[jX, MX],
		[NX, PX],
		[FX, IX]
	];
	for (let e = 0; e < w.length; e++) {
		let [r, i] = w[e], a = $(b, r);
		$(x, r, a);
		let o = LZ(IZ);
		oX(a, t, o);
		let s = LZ();
		oX(a, n, s), $(a, i, b), oX(o, t, o), oX(o, n, s), oX(s, t, o), oX(s, n, s), $(o, i, b), $(s, i, b);
	}
	return $(i, pX, _), $(i, bX, FZ), {
		start: i,
		tokens: uZ
	};
}
function zZ(e, t, n) {
	let r = n.length, i = 0, a = [], o = [];
	for (; i < r;) {
		let s = e, c = null, l = null, u = 0, d = null, f = -1;
		for (; i < r && !(c = s.go(n[i].t));) o.push(n[i++]);
		for (; i < r && (l = c || s.go(n[i].t));) c = null, s = l, s.accepts() ? (f = 0, d = s) : f >= 0 && f++, i++, u++;
		if (f < 0) i -= u, i < r && (o.push(n[i]), i++);
		else {
			o.length > 0 && (a.push(BZ(PZ, t, o)), o = []), i -= f, u -= f;
			let e = d.t, r = n.slice(i - u, i);
			a.push(BZ(e, t, r));
		}
	}
	return o.length > 0 && a.push(BZ(PZ, t, o)), a;
}
function BZ(e, t, n) {
	let r = n[0].s, i = n[n.length - 1].e;
	return new e(t.slice(r, i), n);
}
var VZ = typeof console < "u" && console && console.warn || (() => {}), HZ = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", UZ = {
	scanner: null,
	parser: null,
	tokenQueue: [],
	pluginQueue: [],
	customSchemes: [],
	initialized: !1
};
function WZ() {
	return aX.groups = {}, UZ.scanner = null, UZ.parser = null, UZ.tokenQueue = [], UZ.pluginQueue = [], UZ.customSchemes = [], UZ.initialized = !1, UZ;
}
function GZ(e, t = !1) {
	if (UZ.initialized && VZ(`linkifyjs: already initialized - will not register custom scheme "${e}" ${HZ}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(e)) throw Error("linkifyjs: incorrect scheme format.\n1. Must only contain digits, lowercase ASCII letters or \"-\"\n2. Cannot start or end with \"-\"\n3. \"-\" cannot repeat");
	UZ.customSchemes.push([e, t]);
}
function KZ() {
	UZ.scanner = CZ(UZ.customSchemes);
	for (let e = 0; e < UZ.tokenQueue.length; e++) UZ.tokenQueue[e][1]({ scanner: UZ.scanner });
	UZ.parser = RZ(UZ.scanner.tokens);
	for (let e = 0; e < UZ.pluginQueue.length; e++) UZ.pluginQueue[e][1]({
		scanner: UZ.scanner,
		parser: UZ.parser
	});
	return UZ.initialized = !0, UZ;
}
function qZ(e) {
	return UZ.initialized || KZ(), zZ(UZ.parser.start, e, wZ(UZ.scanner.start, e));
}
qZ.scan = wZ;
function JZ(e, t = null, n = null) {
	if (t && typeof t == "object") {
		if (n) throw Error(`linkifyjs: Invalid link type ${t}; must be a string`);
		n = t, t = null;
	}
	let r = new kZ(n), i = qZ(e), a = [];
	for (let e = 0; e < i.length; e++) {
		let n = i[e];
		n.isLink && (!t || n.t === t) && r.check(n) && a.push(n.toFormattedObject(r));
	}
	return a;
}
//#endregion
//#region ../../node_modules/.pnpm/@tiptap+extension-link@3.27.1_@tiptap+core@3.27.1_@tiptap+pm@3.27.1__@tiptap+pm@3.27.1/node_modules/@tiptap/extension-link/dist/index.js
var YZ = "[\0- \xA0 ᠎ -\u2029 　]", XZ = new RegExp(YZ), ZZ = RegExp(`${YZ}$`), QZ = new RegExp(YZ, "g");
function $Z(e) {
	return e.length === 1 ? e[0].isLink : e.length === 3 && e[1].isLink ? ["()", "[]"].includes(e[0].value + e[2].value) : !1;
}
function eQ(e) {
	return new lL({
		key: new fL("autolink"),
		appendTransaction: (t, n, r) => {
			let i = t.some((e) => e.docChanged) && !n.doc.eq(r.doc), a = t.some((e) => e.getMeta("preventAutolink"));
			if (!i || a) return;
			let { tr: o } = r;
			if (LW(oW(n.doc, [...t])).forEach(({ newRange: t }) => {
				let n = cW(r.doc, t, (e) => e.isTextblock), i, a;
				if (n.length > 1) i = n[0], a = r.doc.textBetween(i.pos, i.pos + i.node.nodeSize, void 0, " ");
				else if (n.length) {
					let e = r.doc.textBetween(t.from, t.to, " ", " ");
					if (!ZZ.test(e)) return;
					i = n[0], a = r.doc.textBetween(i.pos, t.to, void 0, " ");
				}
				if (i && a) {
					let t = a.split(XZ).filter(Boolean);
					if (t.length <= 0) return !1;
					let n = t[t.length - 1], s = i.pos + a.lastIndexOf(n);
					if (!n) return !1;
					let c = qZ(n).map((t) => t.toObject(e.defaultProtocol));
					if (!$Z(c)) return !1;
					c.filter((e) => e.isLink).map((e) => ({
						...e,
						from: s + e.start + 1,
						to: s + e.end + 1
					})).filter((e) => !r.schema.marks.code || !r.doc.rangeHasMark(e.from, e.to, r.schema.marks.code)).filter((t) => e.validate(t.value)).filter((t) => e.shouldAutoLink(t.value)).forEach((t) => {
						RW(t.from, t.to, r.doc).some((t) => t.mark.type === e.type) || o.addMark(t.from, t.to, e.type.create({ href: t.href }));
					});
				}
			}), o.steps.length) return o;
		}
	});
}
function tQ(e) {
	return new lL({
		key: new fL("handleClickLink"),
		props: { handleClick: (t, n, r) => {
			if (r.button !== 0 || !t.editable) return !1;
			let i = null;
			if (r.target instanceof HTMLAnchorElement) i = r.target;
			else {
				let t = r.target;
				if (!t) return !1;
				let n = e.editor.view.dom;
				i = t.closest("a"), i && !n.contains(i) && (i = null);
			}
			if (!i) return !1;
			let a = !1;
			if (e.enableClickSelection && (a = e.editor.commands.extendMarkRange(e.type.name)), e.openOnClick) {
				let n = PW(t.state, e.type.name), r = i.href ?? n.href, o = i.target ?? n.target;
				r && (window.open(r, o), a = !0);
			}
			return a;
		} }
	});
}
function nQ(e) {
	return new lL({
		key: new fL("handlePasteLink"),
		props: { handlePaste: (t, n, r) => {
			let { shouldAutoLink: i } = e, { state: a } = t, { selection: o } = a, { empty: s } = o;
			if (s) return !1;
			let c = "";
			r.content.forEach((e) => {
				c += e.textContent;
			});
			let l = JZ(c, { defaultProtocol: e.defaultProtocol }).find((e) => e.isLink && e.value === c);
			return !c || !l || i !== void 0 && !i(l.value) ? !1 : e.editor.commands.setMark(e.type, { href: l.href });
		} }
	});
}
function rQ(e, t) {
	let n = [
		"http",
		"https",
		"ftp",
		"ftps",
		"mailto",
		"tel",
		"callto",
		"sms",
		"cid",
		"xmpp"
	];
	return t && t.forEach((e) => {
		let t = typeof e == "string" ? e : e.scheme;
		t && n.push(t);
	}), !e || e.replace(QZ, "").match(RegExp(`^(?:(?:${n.map((e) => e.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&")).join("|")}):|[^a-z]|[a-z0-9+.\\-]+(?:[^a-z+.\\-:]|$))`, "i"));
}
var iQ = JG.create({
	name: "link",
	priority: 1e3,
	keepOnSplit: !1,
	exitable: !0,
	onCreate() {
		this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((e) => {
			if (typeof e == "string") {
				GZ(e);
				return;
			}
			GZ(e.scheme, e.optionalSlashes);
		});
	},
	onDestroy() {
		WZ();
	},
	inclusive() {
		return this.options.autolink;
	},
	addOptions() {
		return {
			openOnClick: !0,
			enableClickSelection: !1,
			linkOnPaste: !0,
			autolink: !0,
			protocols: [],
			defaultProtocol: "http",
			HTMLAttributes: {
				target: "_blank",
				rel: "noopener noreferrer nofollow",
				class: null
			},
			isAllowedUri: (e, t) => !!rQ(e, t.protocols),
			validate: (e) => !!e,
			shouldAutoLink: (e) => {
				let t = /^[a-z][a-z0-9+.-]*:\/\//i.test(e), n = /^[a-z][a-z0-9+.-]*:/i.test(e);
				if (t || n && !e.includes("@")) return !0;
				let r = (e.includes("@") ? e.split("@").pop() : e).split(/[/?#:]/)[0];
				return !(/^\d{1,3}(\.\d{1,3}){3}$/.test(r) || !/\./.test(r));
			}
		};
	},
	addAttributes() {
		return {
			href: {
				default: null,
				parseHTML(e) {
					return e.getAttribute("href");
				}
			},
			target: { default: this.options.HTMLAttributes.target },
			rel: { default: this.options.HTMLAttributes.rel },
			class: { default: this.options.HTMLAttributes.class },
			title: { default: null }
		};
	},
	parseHTML() {
		return [{
			tag: "a[href]",
			getAttrs: (e) => {
				let t = e.getAttribute("href");
				return !t || !this.options.isAllowedUri(t, {
					defaultValidate: (e) => !!rQ(e, this.options.protocols),
					protocols: this.options.protocols,
					defaultProtocol: this.options.defaultProtocol
				}) ? !1 : null;
			}
		}];
	},
	renderHTML({ HTMLAttributes: e }) {
		return this.options.isAllowedUri(e.href, {
			defaultValidate: (e) => !!rQ(e, this.options.protocols),
			protocols: this.options.protocols,
			defaultProtocol: this.options.defaultProtocol
		}) ? [
			"a",
			bW(this.options.HTMLAttributes, e),
			0
		] : [
			"a",
			bW(this.options.HTMLAttributes, {
				...e,
				href: ""
			}),
			0
		];
	},
	markdownTokenName: "link",
	parseMarkdown: (e, t) => t.applyMark("link", t.parseInline(e.tokens || []), {
		href: e.href,
		title: e.title || null
	}),
	renderMarkdown: (e, t) => {
		let n = e.attrs?.href ?? "", r = e.attrs?.title ?? "", i = t.renderChildren(e);
		return r ? `[${i}](${n} "${r}")` : `[${i}](${n})`;
	},
	addCommands() {
		return {
			setLink: (e) => ({ chain: t }) => {
				let { href: n } = e;
				return this.options.isAllowedUri(n, {
					defaultValidate: (e) => !!rQ(e, this.options.protocols),
					protocols: this.options.protocols,
					defaultProtocol: this.options.defaultProtocol
				}) ? t().setMark(this.name, e).setMeta("preventAutolink", !0).run() : !1;
			},
			toggleLink: (e) => ({ chain: t }) => {
				let { href: n } = e || {};
				return n && !this.options.isAllowedUri(n, {
					defaultValidate: (e) => !!rQ(e, this.options.protocols),
					protocols: this.options.protocols,
					defaultProtocol: this.options.defaultProtocol
				}) ? !1 : t().toggleMark(this.name, e, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run();
			},
			unsetLink: () => ({ chain: e }) => e().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
		};
	},
	addPasteRules() {
		return [wK({
			find: (e) => {
				let t = [];
				if (e) {
					let { protocols: n, defaultProtocol: r } = this.options, i = JZ(e).filter((e) => e.isLink && this.options.isAllowedUri(e.value, {
						defaultValidate: (e) => !!rQ(e, n),
						protocols: n,
						defaultProtocol: r
					}));
					i.length && i.forEach((e) => {
						this.options.shouldAutoLink(e.value) && t.push({
							text: e.value,
							data: { href: e.href },
							index: e.start
						});
					});
				}
				return t;
			},
			type: this.type,
			getAttributes: (e) => ({ href: e.data?.href })
		})];
	},
	addProseMirrorPlugins() {
		let e = [], { protocols: t, defaultProtocol: n } = this.options;
		return this.options.autolink && e.push(eQ({
			type: this.type,
			defaultProtocol: this.options.defaultProtocol,
			validate: (e) => this.options.isAllowedUri(e, {
				defaultValidate: (e) => !!rQ(e, t),
				protocols: t,
				defaultProtocol: n
			}),
			shouldAutoLink: this.options.shouldAutoLink
		})), e.push(tQ({
			type: this.type,
			editor: this.editor,
			openOnClick: this.options.openOnClick === "whenNotEditable" || this.options.openOnClick,
			enableClickSelection: this.options.enableClickSelection
		})), this.options.linkOnPaste && e.push(nQ({
			editor: this.editor,
			defaultProtocol: this.options.defaultProtocol,
			type: this.type,
			shouldAutoLink: this.options.shouldAutoLink
		})), e;
	}
}), aQ = Zq, oQ = cJ, sQ = wJ, cQ = "&nbsp;", lQ = "\xA0", uQ = CK.create({
	name: "paragraph",
	priority: 1e3,
	addOptions() {
		return { HTMLAttributes: {} };
	},
	group: "block",
	content: "inline*",
	parseHTML() {
		return [{ tag: "p" }];
	},
	renderHTML({ HTMLAttributes: e }) {
		return [
			"p",
			bW(this.options.HTMLAttributes, e),
			0
		];
	},
	parseMarkdown: (e, t) => {
		let n = e.tokens || [];
		if (n.length === 1 && n[0].type === "image") return t.parseChildren([n[0]]);
		let r = t.parseInline(n);
		return n.length === 1 && n[0].type === "text" && (n[0].raw === cQ || n[0].text === cQ || n[0].raw === lQ || n[0].text === lQ) && r.length === 1 && r[0].type === "text" && (r[0].text === cQ || r[0].text === lQ) ? t.createNode("paragraph", void 0, []) : t.createNode("paragraph", void 0, r);
	},
	renderMarkdown: (e, t, n) => {
		if (!e) return "";
		let r = Array.isArray(e.content) ? e.content : [];
		if (r.length === 0) {
			let e = Array.isArray(n?.previousNode?.content) ? n.previousNode.content : [];
			return n?.previousNode?.type === "paragraph" && e.length === 0 ? cQ : "";
		}
		return t.renderChildren(r);
	},
	addCommands() {
		return { setParagraph: () => ({ commands: e }) => e.setNode(this.name) };
	},
	addKeyboardShortcuts() {
		return { "Mod-Alt-0": () => this.editor.commands.setParagraph() };
	}
}), dQ = CK.create({
	name: "text",
	group: "inline",
	parseMarkdown: (e) => ({
		type: "text",
		text: e.text || ""
	}),
	renderMarkdown: (e) => e.text || ""
}), fQ = nK.create({
	name: "textAlign",
	addOptions() {
		return {
			types: [],
			alignments: [
				"left",
				"center",
				"right",
				"justify"
			],
			defaultAlignment: null
		};
	},
	addGlobalAttributes() {
		return [{
			types: this.options.types,
			attributes: { textAlign: {
				default: this.options.defaultAlignment,
				parseHTML: (e) => {
					let t = e.style.textAlign;
					return this.options.alignments.includes(t) ? t : this.options.defaultAlignment;
				},
				renderHTML: (e) => e.textAlign ? { style: `text-align: ${e.textAlign}` } : {}
			} }
		}];
	},
	addCommands() {
		return {
			setTextAlign: (e) => ({ commands: t }) => this.options.alignments.includes(e) ? this.options.types.map((n) => t.updateAttributes(n, { textAlign: e })).some((e) => e) : !1,
			unsetTextAlign: () => ({ commands: e }) => this.options.types.map((t) => e.resetAttributes(t, "textAlign")).some((e) => e),
			toggleTextAlign: (e) => ({ editor: t, commands: n }) => this.options.alignments.includes(e) ? t.isActive({ textAlign: e }) ? n.unsetTextAlign() : n.setTextAlign(e) : !1
		};
	},
	addKeyboardShortcuts() {
		return {
			"Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
			"Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
			"Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
			"Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
		};
	}
}), pQ = JG.create({
	name: "underline",
	addOptions() {
		return { HTMLAttributes: {} };
	},
	parseHTML() {
		return [{ tag: "u" }, {
			style: "text-decoration",
			consuming: !1,
			getAttrs: (e) => e.includes("underline") ? {} : !1
		}];
	},
	renderHTML({ HTMLAttributes: e }) {
		return [
			"u",
			bW(this.options.HTMLAttributes, e),
			0
		];
	},
	parseMarkdown(e, t) {
		return t.applyMark(this.name || "underline", t.parseInline(e.tokens || []));
	},
	renderMarkdown(e, t) {
		return `++${t.renderChildren(e)}++`;
	},
	markdownTokenizer: {
		name: "underline",
		level: "inline",
		start(e) {
			return e.indexOf("++");
		},
		tokenize(e, t, n) {
			let r = /^(\+\+)([\s\S]+?)(\+\+)/.exec(e);
			if (!r) return;
			let i = r[2].trim();
			return {
				type: "underline",
				raw: r[0],
				text: i,
				tokens: n.inlineTokens(i)
			};
		}
	},
	addCommands() {
		return {
			setUnderline: () => ({ commands: e }) => e.setMark(this.name),
			toggleUnderline: () => ({ commands: e }) => e.toggleMark(this.name),
			unsetUnderline: () => ({ commands: e }) => e.unsetMark(this.name)
		};
	},
	addKeyboardShortcuts() {
		return {
			"Mod-u": () => this.editor.commands.toggleUnderline(),
			"Mod-U": () => this.editor.commands.toggleUnderline()
		};
	}
}), mQ = nK.create({
	name: "emailTags",
	addProseMirrorPlugins() {
		return this.options.tags.length === 0 ? [] : [new lL({
			key: new fL("emailTags"),
			props: { decorations: (e) => {
				let t = [], { doc: n } = e;
				return n.descendants((e, n) => {
					if (!e.isText) return;
					let r = e.text;
					this.options.tags.forEach((e) => {
						let i = r.indexOf(e);
						for (; i !== -1;) t.push(LV.inline(n + i, n + i + e.length, { class: this.options.class })), i = r.indexOf(e, i + 1);
					});
				}), BV.create(n, t);
			} }
		})];
	}
}), hQ = {
	headings: FY.configure({ levels: [
		1,
		2,
		3
	] }),
	formatting: [
		Sq,
		UY,
		pQ
	],
	lists: [
		OJ,
		sQ,
		aQ,
		oQ
	],
	link: iQ.configure({
		openOnClick: !1,
		defaultProtocol: "https"
	}),
	image: RY.configure({ inline: !0 }),
	textAlignment: fQ.configure({
		types: [
			"heading",
			"paragraph",
			"image"
		],
		defaultAlignment: "left"
	}),
	tags: mQ.configure({
		tags: [],
		class: "bg-primary-light text-primary"
	})
}, gQ = (e, t, n) => {
	let r = n ? kJ.extend({ content: "text*" }) : kJ, i = n ? [] : [uQ, PY], a = e.flatMap((e) => e === "tags" ? mQ.configure({
		tags: t.map((e) => e.key),
		class: "bg-primary-light text-primary"
	}) : hQ[e]), o = [
		r,
		dQ,
		...i,
		...a
	], s = [
		MY,
		NY,
		IY
	];
	return [...o, ...s];
}, _Q = (e, t, n, r, i, a) => {
	let o = gQ(e, t, a);
	return OK({
		content: n,
		editorProps: { attributes: {
			class: "p-4 flex-1 max-w-full",
			"aria-label": i,
			role: "textbox"
		} },
		extensions: o,
		onUpdate: ({ editor: e }) => {
			r(a ? e.getText() : e.getHTML());
		}
	});
}, vQ = { class: "border rounded-lg svg:block w-full" }, yQ = { class: "grid grid-cols-4" }, bQ = { class: "relative" }, xQ = { class: "relative z-0 flex flex-1" }, SQ = ["aria-label"], CQ = /* @__PURE__ */ f({
	__name: "Wysiwyg",
	props: {
		allowedExtensions: { default: () => [] },
		overflowExtensions: { default: () => [] },
		tags: { default: () => [] },
		modelValue: {},
		tagEditorSidebar: {
			type: Boolean,
			default: !1
		},
		label: { default: "editor" },
		plainText: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { emit: t }) {
		let { t: n } = Re(), r = e, c = t, l = _Q(r.allowedExtensions, r.tags, r.modelValue, (e) => c("update:modelValue", e), r.label, r.plainText);
		return z(() => r.modelValue, (e) => {
			l.value && (r.plainText ? l.value.getText() : l.value.getHTML()) !== e && l.value.commands.setContent(e);
		}), (t, r) => (A(), o("div", vQ, [s("div", yQ, [s("div", { class: C(["flex flex-col", e.tagEditorSidebar ? "col-span-3" : "col-span-4"]) }, [s("div", bQ, [L(l) ? (A(), i(gq, {
			key: 0,
			"allowed-extensions": e.allowedExtensions,
			editor: L(l),
			"overflow-extensions": e.overflowExtensions,
			"tag-editor-sidebar": e.tagEditorSidebar,
			tags: e.tags
		}, null, 8, [
			"allowed-extensions",
			"editor",
			"overflow-extensions",
			"tag-editor-sidebar",
			"tags"
		])) : a("", !0)]), s("div", xQ, [u(L(DK), {
			class: "flex-1 flex",
			editor: L(l)
		}, null, 8, ["editor"])])], 2), e.tagEditorSidebar ? (A(), o("aside", {
			key: 0,
			"aria-label": L(n)("ui.wysiwyg.tagEditorSidebar"),
			class: "flex flex-col"
		}, [L(l) && e.allowedExtensions?.includes("tags") ? (A(), i(FK, {
			key: 0,
			editor: L(l),
			tags: e.tags
		}, null, 8, ["editor", "tags"])) : a("", !0)], 8, SQ)) : a("", !0)])]));
	}
});
//#endregion
export { it as AccordionGroup, lp as AccordionItem, Op as ActionButton, Mp as ActionButtonWithSpinner, Bp as ActionButtonWrapper, _s as AdminUser24, Il as Amazon, Kv as AreYouSureModal, Ko as ArrowDown, Ho as ArrowRight, Xo as ArrowUp, Ht as AssignToPerson, Xt as Attachment24, BA as Backdrop, Xv as Badge, ey as BadgeOverlay, Zv as BadgeSize, qv as BadgeVariant, er as Barcode, rn as Barcode24, Vn as Bars, ny as BaseImage, Mn as Basket, Ru as Bell, Hu as Bell24, Hp as BlockActionButton, Vp as BlockActionButtonLayout, xj as BottomSheet, Ei as Box, Ai as Box24, Si as BoxOpen, Oj as BulkActionBar, Dp as Button, xp as ButtonSizes, Cp as ButtonType, Sp as ButtonVariant, Wp as ButtonWithSpinner, gn as Cancel, oy as Card, uy as CardBody, my as CardRow, ry as CardVariant, ib as CarrierLogo, Qt as CarrierTruck, ur as CarrierTruck48, ut as Chat24, Fd as Check, Zd as Check24, Ud as Check48, zd as CheckRounded, qd as CheckRounded24, Bb as Checkbox, yn as CheckboxCheck, ex as CheckboxGroup, Vb as CheckboxGroupAlignment, Jr as ChevronDown, Qr as ChevronDown24, op as ChevronIcon, ni as ChevronLeft, Ir as ChevronRight, Br as ChevronRight24, Wr as ChevronUp, oi as ChevronUp24, Jn as Chrome, cn as Clear, ab as ClipboardText, ir as Close, At as Cog24, VA as CollapseMenuButton, ix as ColorInput, on as Comments48, ot as Compress, nr as Copy, ob as CountBadge, xn as Cross, xt as Crosshairs24, sx as CurrencyInput, hx as CurrencyRangeInput, Lt as Dashboard, vy as DashboardButton, yy as Date, NO as DatePicker, FO as DatePickerRange, ht as Desktop, Wa as DhlActive, Ma as DhlRounded, $u as DigitalStamp, Nn as Directdebitauthorization, Ln as Distributed88, WA as DividerMenuItem, Wn as Doublechatbubble, _a as DpdActive, pa as DpdRounded, db as Dropdown, Dt as Droppedoff88, hb as EXTERNAL_LINK_BASE_STYLE, gb as EXTERNAL_LINK_VARIANT_STYLES, fb as EcommercePlatformLogo, tl as Ecommerceplatformbol, sl as Ecommerceplatformbolmedium, zc as Ecommerceplatformcscart, Jc as Ecommerceplatformcscartmedium, kc as Ecommerceplatformdefault, Ic as Ecommerceplatformlightspeed, Qc as Ecommerceplatformlightspeedmedium, ul as Ecommerceplatformpresta, Hc as Ecommerceplatformprestamedium, il as Ecommerceplatformshopify, Gc as Ecommerceplatformshopifymedium, Mc as Ecommerceplatformwoocommerce, pl as Ecommerceplatformwoocommercemedium, fr as Edit, cr as Envelope24, zn as Error, Nl as Etsy, dd as EuroSign, sd as EuroSign24, Tl as Exact, zl as ExactDe, yt as Expand, Dd as ExternalLink, Cd as ExternalLink24, vb as ExternalLinkAnchor, mb as ExternalLinkVariant, YA as ExternalMenuItem, mi as EyeHide, vi as EyeShow, ui as EyeShow24, cu as Facebook, iu as FacebookSocial, eu as FacebookSolid, Qn as Feedback, oo as File, Co as FileAlt, wb as FileBar, ho as FileCsv, Po as FileDownload, no as FileDownload24, Ro as FileDownload48, Ao as FileMov, uo as FilePackingSlip, yo as FilePdf, Fn as FileSheet, jb as FileUpload, Eo as FileUpload48, Tb as FileUploadVariant, Ib as FilledFileCard, _n as Filter, kA as FilterBar, Hi as FlagBe, Zi as FlagDe, Gi as FlagEs, pt as FlagFinish24, Ii as FlagFr, Ni as FlagGb, Lb as FlagIcon, Ji as FlagIt, zi as FlagNl, ux as FormRow, vr as Fulfilment24, Jt as Fulfilment48, oc as Gift, hd as Hamburger, yd as Hamburger24, Nt as HandGivingPackage, Bv as Heading, Wt as Home, ap as IconBase, np as IconSize, rp as IconType, tp as IconViewBox, un as ImageEmpty, BO as ImageUpload, Tn as ImportExport, Mt as Info, NA as InfoCard, tf as Instagram, of as InstagramSocial, uf as InstagramSolid, jn as Insurance, QA as InternalMenuItem, px as Label, cx as LabelPosition, zA as LanguageToggle, nn as Laptop48, Hf as Linkedin, Rf as LinkedinSocial, Kf as LinkedinSolid, yM as LoadMore, jj as LoadMoreSection, hn as LocationPin, rd as MailboxParcel, Ot as MapMarkerAlt, Qj as MasterDetailPanel, Fj as MasterDetailView, Gs as Megaphone, Js as MegaphoneLoud, aM as MenuButton, $A as MenuItemType, aa as Minus, ta as Minus24, kn as MobilePhone, Wv as Modal, Qs as More16, nc as More24, Mk as MultiSelect, Lk as MultiSelectWithBadges, Uk as MultiSelectWithBadgesOutside, hu as MyParcel, vu as MyParcelBe, du as MyParcelPrimary, oM as MyParcelShopLogo, An as Myparcel24, Yb as NestedTranslation, _t as Note, fM as Notification, HO as NumberInput, XO as NumberInputStepper, Xu as PackageSmall, pM as PackageTypeIcon, mr as Packaging, Tt as Packaging24, Hn as PackingSlip, vM as Pagination, Ku as Pallet, Vj as PanelHeader, Xj as PanelItem, Xn as PaperPlane, yb as Paragraph, tj as ParentMenuItemCollapsed, lj as ParentMenuItemExpanded, tk as PasswordInput, Su as Phone24, Eu as Phone48, br as Picklist, ep as Plus, Xf as Plus24, Gb as PopOver, Ip as Popup, Ia as PostnlActive, Ba as PostnlBusinessActive, xa as PostnlBusinessRounded, Ta as PostnlRounded, SM as PrefetchWrapper, EM as ProgressBar, CM as ProgressBarVariant, vc as Question, uc as Question24, mc as QuestionCircle, Sc as QuestionCircle24, Ec as QuestionCircle48, ok as RadioGroup, is as Redo, es as Redo24, lr as Refresh, hr as RefreshPlus, ct as Reminder, Vt as Reply, qt as Search24, hk as SearchInput, Ck as SearchSuggestTextInput, pk as Select, Qk as SelectAutocomplete, ft as Settings, Dn as Settings24, Ft as Shipment, dn as ShipmentSorting, pn as ShipmentUnknown, zt as Shirt24, Kn as ShoppingCart, oj as SideMenuCollapsed, mj as SideMenuExpanded, Au as SideMenuHide, Pu as SideMenuShow, wj as SidePanel, _r as Signin, DM as Skeleton, kM as SkeletonField, AM as SkeletonRectangle, jM as SocialIcon, NM as SocialLinks, Qa as SortAsc, Ja as SortDesc, en as Sorted, Ap as Spinner, Xl as Star, Ul as Star24, ql as StarSolid, FM as StatusIndicator, PM as StatusIndicatorVariant, _l as Subscription, xl as Subscription48, Rt as Support, or as Support24, tA as Switch, up as TOP_LAYER_CHANGE_EVENT, hN as TabGroup, _N as TabLink, QM as Table, IM as TableBody, LM as TableCell, GM as TableColoredRow, BM as TableColumnHeader, RM as TableColumnHeaderSort, aN as TableEmptyBody, HM as TableHeader, WM as TableRow, rN as TableRowExpandable, uN as TableRowSkeleton, qM as TableRowToggle, XM as TableTab, JM as TableTabCount, nN as TableTabs, pb as Target, rA as TextArea, QO as TextInput, ek as TextInputWithButton, sA as TextInputWithInfo, Ct as ThSolid, jd as TiktokSocial, cA as TimeInput, ps as Times, ls as Times24, dM as Toast, WN as TrackAndTraceList, kN as TrackAndTraceTimeline, PN as TrackAndTraceTimelineSkeleton, Ls as Trash, Ns as Trash24, ks as TrashBig, Or as Twitter, Mr as TwitterSocial, wr as TwitterSolid, Gt as UnassignFromPerson, fn as Unstamped, Pf as Upload, Af as Upload24, la as UpsActive, ka as UpsRounded, xs as User, Ts as User24, fA as WeightRangeSelector, uA as WeightSelector, Ef as Whatsapp, mf as Whatsapp24, Sf as Whatsapp48, vf as WhatsappSolid, kl as Wix, nP as WizardFooter, eP as WizardStepper, CQ as Wysiwyg, IK as WysiwygExtension, Vs as YoutubeSocial, cN as createActionsColumn, sN as createNonSortableColumn, oN as createSortableColumn, bp as vTooltip };
